/**
 * Tokyo Angular Client */
/*! jQuery v2.1.1 | (c) 2005, 2014 jQuery Foundation, Inc. | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k={},l=a.document,m="2.1.1",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return n.each(this,a,b)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){return!n.isArray(a)&&a-parseFloat(a)>=0},isPlainObject:function(a){return"object"!==n.type(a)||a.nodeType||n.isWindow(a)?!1:a.constructor&&!j.call(a.constructor.prototype,"isPrototypeOf")?!1:!0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?h[i.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=l.createElement("script"),b.text=a,l.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=s(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:g.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=s(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(e=d.call(arguments,2),f=function(){return a.apply(b||this,e.concat(d.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:k}),n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){h["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+-new Date,v=a.document,w=0,x=0,y=gb(),z=gb(),A=gb(),B=function(a,b){return a===b&&(l=!0),0},C="undefined",D=1<<31,E={}.hasOwnProperty,F=[],G=F.pop,H=F.push,I=F.push,J=F.slice,K=F.indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(this[b]===a)return b;return-1},L="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",N="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",O=N.replace("w","w#"),P="\\["+M+"*("+N+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+O+"))|)"+M+"*\\]",Q=":("+N+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+P+")*)|.*)\\)|)",R=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),S=new RegExp("^"+M+"*,"+M+"*"),T=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp("="+M+"*([^\\]'\"]*?)"+M+"*\\]","g"),V=new RegExp(Q),W=new RegExp("^"+O+"$"),X={ID:new RegExp("^#("+N+")"),CLASS:new RegExp("^\\.("+N+")"),TAG:new RegExp("^("+N.replace("w","w*")+")"),ATTR:new RegExp("^"+P),PSEUDO:new RegExp("^"+Q),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+L+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/^(?:input|select|textarea|button)$/i,Z=/^h\d$/i,$=/^[^{]+\{\s*\[native \w/,_=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ab=/[+~]/,bb=/'|\\/g,cb=new RegExp("\\\\([\\da-f]{1,6}"+M+"?|("+M+")|.)","ig"),db=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)};try{I.apply(F=J.call(v.childNodes),v.childNodes),F[v.childNodes.length].nodeType}catch(eb){I={apply:F.length?function(a,b){H.apply(a,J.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fb(a,b,d,e){var f,h,j,k,l,o,r,s,w,x;if((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,d=d||[],!a||"string"!=typeof a)return d;if(1!==(k=b.nodeType)&&9!==k)return[];if(p&&!e){if(f=_.exec(a))if(j=f[1]){if(9===k){if(h=b.getElementById(j),!h||!h.parentNode)return d;if(h.id===j)return d.push(h),d}else if(b.ownerDocument&&(h=b.ownerDocument.getElementById(j))&&t(b,h)&&h.id===j)return d.push(h),d}else{if(f[2])return I.apply(d,b.getElementsByTagName(a)),d;if((j=f[3])&&c.getElementsByClassName&&b.getElementsByClassName)return I.apply(d,b.getElementsByClassName(j)),d}if(c.qsa&&(!q||!q.test(a))){if(s=r=u,w=b,x=9===k&&a,1===k&&"object"!==b.nodeName.toLowerCase()){o=g(a),(r=b.getAttribute("id"))?s=r.replace(bb,"\\$&"):b.setAttribute("id",s),s="[id='"+s+"'] ",l=o.length;while(l--)o[l]=s+qb(o[l]);w=ab.test(a)&&ob(b.parentNode)||b,x=o.join(",")}if(x)try{return I.apply(d,w.querySelectorAll(x)),d}catch(y){}finally{r||b.removeAttribute("id")}}}return i(a.replace(R,"$1"),b,d,e)}function gb(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function hb(a){return a[u]=!0,a}function ib(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function jb(a,b){var c=a.split("|"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function kb(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||D)-(~a.sourceIndex||D);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function lb(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function mb(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function nb(a){return hb(function(b){return b=+b,hb(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function ob(a){return a&&typeof a.getElementsByTagName!==C&&a}c=fb.support={},f=fb.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fb.setDocument=function(a){var b,e=a?a.ownerDocument||a:v,g=e.defaultView;return e!==n&&9===e.nodeType&&e.documentElement?(n=e,o=e.documentElement,p=!f(e),g&&g!==g.top&&(g.addEventListener?g.addEventListener("unload",function(){m()},!1):g.attachEvent&&g.attachEvent("onunload",function(){m()})),c.attributes=ib(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ib(function(a){return a.appendChild(e.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=$.test(e.getElementsByClassName)&&ib(function(a){return a.innerHTML="<div class='a'></div><div class='a i'></div>",a.firstChild.className="i",2===a.getElementsByClassName("i").length}),c.getById=ib(function(a){return o.appendChild(a).id=u,!e.getElementsByName||!e.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if(typeof b.getElementById!==C&&p){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(cb,db);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(cb,db);return function(a){var c=typeof a.getAttributeNode!==C&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return typeof b.getElementsByTagName!==C?b.getElementsByTagName(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return typeof b.getElementsByClassName!==C&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=$.test(e.querySelectorAll))&&(ib(function(a){a.innerHTML="<select msallowclip=''><option selected=''></option></select>",a.querySelectorAll("[msallowclip^='']").length&&q.push("[*^$]="+M+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+M+"*(?:value|"+L+")"),a.querySelectorAll(":checked").length||q.push(":checked")}),ib(function(a){var b=e.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+M+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=$.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ib(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",Q)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=$.test(o.compareDocumentPosition),t=b||$.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===e||a.ownerDocument===v&&t(v,a)?-1:b===e||b.ownerDocument===v&&t(v,b)?1:k?K.call(k,a)-K.call(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,f=a.parentNode,g=b.parentNode,h=[a],i=[b];if(!f||!g)return a===e?-1:b===e?1:f?-1:g?1:k?K.call(k,a)-K.call(k,b):0;if(f===g)return kb(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)i.unshift(c);while(h[d]===i[d])d++;return d?kb(h[d],i[d]):h[d]===v?-1:i[d]===v?1:0},e):n},fb.matches=function(a,b){return fb(a,null,null,b)},fb.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(U,"='$1']"),!(!c.matchesSelector||!p||r&&r.test(b)||q&&q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fb(b,n,null,[a]).length>0},fb.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fb.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&E.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fb.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fb.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fb.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fb.selectors={cacheLength:50,createPseudo:hb,match:X,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(cb,db),a[3]=(a[3]||a[4]||a[5]||"").replace(cb,db),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fb.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fb.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return X.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&V.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(cb,db).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+M+")"+a+"("+M+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||typeof a.getAttribute!==C&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fb.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){k=q[u]||(q[u]={}),j=k[a]||[],n=j[0]===w&&j[1],m=j[0]===w&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[w,n,m];break}}else if(s&&(j=(b[u]||(b[u]={}))[a])&&j[0]===w)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(s&&((l[u]||(l[u]={}))[a]=[w,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fb.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?hb(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=K.call(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:hb(function(a){var b=[],c=[],d=h(a.replace(R,"$1"));return d[u]?hb(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),!c.pop()}}),has:hb(function(a){return function(b){return fb(a,b).length>0}}),contains:hb(function(a){return function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:hb(function(a){return W.test(a||"")||fb.error("unsupported lang: "+a),a=a.replace(cb,db).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Z.test(a.nodeName)},input:function(a){return Y.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:nb(function(){return[0]}),last:nb(function(a,b){return[b-1]}),eq:nb(function(a,b,c){return[0>c?c+b:c]}),even:nb(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:nb(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:nb(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:nb(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=lb(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=mb(b);function pb(){}pb.prototype=d.filters=d.pseudos,d.setFilters=new pb,g=fb.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=S.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=T.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(R," ")}),h=h.slice(c.length));for(g in d.filter)!(e=X[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fb.error(a):z(a,i).slice(0)};function qb(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function rb(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[u]||(b[u]={}),(h=i[d])&&h[0]===w&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function sb(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function tb(a,b,c){for(var d=0,e=b.length;e>d;d++)fb(a,b[d],c);return c}function ub(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function vb(a,b,c,d,e,f){return d&&!d[u]&&(d=vb(d)),e&&!e[u]&&(e=vb(e,f)),hb(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||tb(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ub(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ub(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?K.call(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ub(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):I.apply(g,r)})}function wb(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=rb(function(a){return a===b},h,!0),l=rb(function(a){return K.call(b,a)>-1},h,!0),m=[function(a,c,d){return!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d))}];f>i;i++)if(c=d.relative[a[i].type])m=[rb(sb(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return vb(i>1&&sb(m),i>1&&qb(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(R,"$1"),c,e>i&&wb(a.slice(i,e)),f>e&&wb(a=a.slice(e)),f>e&&qb(a))}m.push(c)}return sb(m)}function xb(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,m,o,p=0,q="0",r=f&&[],s=[],t=j,u=f||e&&d.find.TAG("*",k),v=w+=null==t?1:Math.random()||.1,x=u.length;for(k&&(j=g!==n&&g);q!==x&&null!=(l=u[q]);q++){if(e&&l){m=0;while(o=a[m++])if(o(l,g,h)){i.push(l);break}k&&(w=v)}c&&((l=!o&&l)&&p--,f&&r.push(l))}if(p+=q,c&&q!==p){m=0;while(o=b[m++])o(r,s,g,h);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=G.call(i));s=ub(s)}I.apply(i,s),k&&!f&&s.length>0&&p+b.length>1&&fb.uniqueSort(i)}return k&&(w=v,j=t),r};return c?hb(f):f}return h=fb.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wb(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xb(e,d)),f.selector=a}return f},i=fb.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(cb,db),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=X.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(cb,db),ab.test(j[0].type)&&ob(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qb(j),!a)return I.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,ab.test(a)&&ob(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ib(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ib(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||jb("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ib(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||jb("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ib(function(a){return null==a.getAttribute("disabled")})||jb(L,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fb}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=n.expr.match.needsContext,v=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,w=/^.[^:#\[\.,]*$/;function x(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(w.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return g.call(b,a)>=0!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(x(this,a||[],!1))},not:function(a){return this.pushStack(x(this,a||[],!0))},is:function(a){return!!x(this,"string"==typeof a&&u.test(a)?n(a):a||[],!1).length}});var y,z=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,A=n.fn.init=function(a,b){var c,d;if(!a)return this;if("string"==typeof a){if(c="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:z.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||y).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:l,!0)),v.test(c[1])&&n.isPlainObject(b))for(c in b)n.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}return d=l.getElementById(c[2]),d&&d.parentNode&&(this.length=1,this[0]=d),this.context=l,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?"undefined"!=typeof y.ready?y.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};A.prototype=n.fn,y=n(l);var B=/^(?:parents|prev(?:Until|All))/,C={children:!0,contents:!0,next:!0,prev:!0};n.extend({dir:function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=u.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.unique(f):f)},index:function(a){return a?"string"==typeof a?g.call(n(a),this[0]):g.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.unique(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function D(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return n.dir(a,"parentNode")},parentsUntil:function(a,b,c){return n.dir(a,"parentNode",c)},next:function(a){return D(a,"nextSibling")},prev:function(a){return D(a,"previousSibling")},nextAll:function(a){return n.dir(a,"nextSibling")},prevAll:function(a){return n.dir(a,"previousSibling")},nextUntil:function(a,b,c){return n.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return n.dir(a,"previousSibling",c)},siblings:function(a){return n.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return n.sibling(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(C[a]||n.unique(e),B.test(a)&&e.reverse()),this.pushStack(e)}});var E=/\S+/g,F={};function G(a){var b=F[a]={};return n.each(a.match(E)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?F[a]||G(a):n.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(b=a.memory&&l,c=!0,g=e||0,e=0,f=h.length,d=!0;h&&f>g;g++)if(h[g].apply(l[0],l[1])===!1&&a.stopOnFalse){b=!1;break}d=!1,h&&(i?i.length&&j(i.shift()):b?h=[]:k.disable())},k={add:function(){if(h){var c=h.length;!function g(b){n.each(b,function(b,c){var d=n.type(c);"function"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&"string"!==d&&g(c)})}(arguments),d?f=h.length:b&&(e=c,j(b))}return this},remove:function(){return h&&n.each(arguments,function(a,b){var c;while((c=n.inArray(b,h,c))>-1)h.splice(c,1),d&&(f>=c&&f--,g>=c&&g--)}),this},has:function(a){return a?n.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],f=0,this},disable:function(){return h=i=b=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,b||k.disable(),this},locked:function(){return!i},fireWith:function(a,b){return!h||c&&!i||(b=b||[],b=[a,b.slice?b.slice():b],d?i.push(b):j(b)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!c}};return k},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&n.isFunction(a.promise)?e:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var H;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(H.resolveWith(l,[n]),n.fn.triggerHandler&&(n(l).triggerHandler("ready"),n(l).off("ready"))))}});function I(){l.removeEventListener("DOMContentLoaded",I,!1),a.removeEventListener("load",I,!1),n.ready()}n.ready.promise=function(b){return H||(H=n.Deferred(),"complete"===l.readyState?setTimeout(n.ready):(l.addEventListener("DOMContentLoaded",I,!1),a.addEventListener("load",I,!1))),H.promise(b)},n.ready.promise();var J=n.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)n.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f};n.acceptData=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function K(){Object.defineProperty(this.cache={},0,{get:function(){return{}}}),this.expando=n.expando+Math.random()}K.uid=1,K.accepts=n.acceptData,K.prototype={key:function(a){if(!K.accepts(a))return 0;var b={},c=a[this.expando];if(!c){c=K.uid++;try{b[this.expando]={value:c},Object.defineProperties(a,b)}catch(d){b[this.expando]=c,n.extend(a,b)}}return this.cache[c]||(this.cache[c]={}),c},set:function(a,b,c){var d,e=this.key(a),f=this.cache[e];if("string"==typeof b)f[b]=c;else if(n.isEmptyObject(f))n.extend(this.cache[e],b);else for(d in b)f[d]=b[d];return f},get:function(a,b){var c=this.cache[this.key(a)];return void 0===b?c:c[b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=this.key(a),g=this.cache[f];if(void 0===b)this.cache[f]={};else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in g?d=[b,e]:(d=e,d=d in g?[d]:d.match(E)||[])),c=d.length;while(c--)delete g[d[c]]}},hasData:function(a){return!n.isEmptyObject(this.cache[a[this.expando]]||{})},discard:function(a){a[this.expando]&&delete this.cache[a[this.expando]]}};var L=new K,M=new K,N=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,O=/([A-Z])/g;function P(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(O,"-$1").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:N.test(c)?n.parseJSON(c):c}catch(e){}M.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return M.hasData(a)||L.hasData(a)},data:function(a,b,c){return M.access(a,b,c)},removeData:function(a,b){M.remove(a,b)
},_data:function(a,b,c){return L.access(a,b,c)},_removeData:function(a,b){L.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=M.get(f),1===f.nodeType&&!L.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),P(f,d,e[d])));L.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){M.set(this,a)}):J(this,function(b){var c,d=n.camelCase(a);if(f&&void 0===b){if(c=M.get(f,a),void 0!==c)return c;if(c=M.get(f,d),void 0!==c)return c;if(c=P(f,d,void 0),void 0!==c)return c}else this.each(function(){var c=M.get(this,d);M.set(this,d,b),-1!==a.indexOf("-")&&void 0!==c&&M.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){M.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=L.get(a,b),c&&(!d||n.isArray(c)?d=L.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return L.get(a,c)||L.access(a,c,{empty:n.Callbacks("once memory").add(function(){L.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=L.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var Q=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,R=["Top","Right","Bottom","Left"],S=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)},T=/^(?:checkbox|radio)$/i;!function(){var a=l.createDocumentFragment(),b=a.appendChild(l.createElement("div")),c=l.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),k.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",k.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var U="undefined";k.focusinBubbles="onfocusin"in a;var V=/^key/,W=/^(?:mouse|pointer|contextmenu)|click/,X=/^(?:focusinfocus|focusoutblur)$/,Y=/^([^.]*)(?:\.(.+)|)$/;function Z(){return!0}function $(){return!1}function _(){try{return l.activeElement}catch(a){}}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return typeof n!==U&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(E)||[""],j=b.length;while(j--)h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g,!1)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.hasData(a)&&L.get(a);if(r&&(i=r.events)){b=(b||"").match(E)||[""],j=b.length;while(j--)if(h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&(delete r.handle,L.remove(a,"events"))}},trigger:function(b,c,d,e){var f,g,h,i,k,m,o,p=[d||l],q=j.call(b,"type")?b.type:b,r=j.call(b,"namespace")?b.namespace.split("."):[];if(g=h=d=d||l,3!==d.nodeType&&8!==d.nodeType&&!X.test(q+n.event.triggered)&&(q.indexOf(".")>=0&&(r=q.split("."),q=r.shift(),r.sort()),k=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=r.join("."),b.namespace_re=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},e||!o.trigger||o.trigger.apply(d,c)!==!1)){if(!e&&!o.noBubble&&!n.isWindow(d)){for(i=o.delegateType||q,X.test(i+q)||(g=g.parentNode);g;g=g.parentNode)p.push(g),h=g;h===(d.ownerDocument||l)&&p.push(h.defaultView||h.parentWindow||a)}f=0;while((g=p[f++])&&!b.isPropagationStopped())b.type=f>1?i:o.bindType||q,m=(L.get(g,"events")||{})[b.type]&&L.get(g,"handle"),m&&m.apply(g,c),m=k&&g[k],m&&m.apply&&n.acceptData(g)&&(b.result=m.apply(g,c),b.result===!1&&b.preventDefault());return b.type=q,e||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!n.acceptData(d)||k&&n.isFunction(d[q])&&!n.isWindow(d)&&(h=d[k],h&&(d[k]=null),n.event.triggered=q,d[q](),n.event.triggered=void 0,h&&(d[k]=h)),b.result}},dispatch:function(a){a=n.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(L.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(g.namespace))&&(a.handleObj=g,a.data=g.data,e=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(a.result=e)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||"click"!==a.type))for(;i!==this;i=i.parentNode||this)if(i.disabled!==!0||"click"!==a.type){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>=0:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,d,e,f=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||l,d=c.documentElement,e=c.body,a.pageX=b.clientX+(d&&d.scrollLeft||e&&e.scrollLeft||0)-(d&&d.clientLeft||e&&e.clientLeft||0),a.pageY=b.clientY+(d&&d.scrollTop||e&&e.scrollTop||0)-(d&&d.clientTop||e&&e.clientTop||0)),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=W.test(e)?this.mouseHooks:V.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new n.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=l),3===a.target.nodeType&&(a.target=a.target.parentNode),g.filter?g.filter(a,f):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==_()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===_()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=n.extend(new n.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?n.event.trigger(e,null,b):n.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?Z:$):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={isDefaultPrevented:$,isPropagationStopped:$,isImmediatePropagationStopped:$,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=Z,a&&a.preventDefault&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=Z,a&&a.stopPropagation&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=Z,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),k.focusinBubbles||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a),!0)};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=L.access(d,b);e||d.addEventListener(a,c,!0),L.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=L.access(d,b)-1;e?L.access(d,b,e):(d.removeEventListener(a,c,!0),L.remove(d,b))}}}),n.fn.extend({on:function(a,b,c,d,e){var f,g;if("object"==typeof a){"string"!=typeof b&&(c=c||b,b=void 0);for(g in a)this.on(g,b,c,a[g],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&("string"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=$;else if(!d)return this;return 1===e&&(f=d,d=function(a){return n().off(a),f.apply(this,arguments)},d.guid=f.guid||(f.guid=n.guid++)),this.each(function(){n.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=$),this.each(function(){n.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}});var ab=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,bb=/<([\w:]+)/,cb=/<|&#?\w+;/,db=/<(?:script|style|link)/i,eb=/checked\s*(?:[^=]|=\s*.checked.)/i,fb=/^$|\/(?:java|ecma)script/i,gb=/^true\/(.*)/,hb=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,ib={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ib.optgroup=ib.option,ib.tbody=ib.tfoot=ib.colgroup=ib.caption=ib.thead,ib.th=ib.td;function jb(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function kb(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function lb(a){var b=gb.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function mb(a,b){for(var c=0,d=a.length;d>c;c++)L.set(a[c],"globalEval",!b||L.get(b[c],"globalEval"))}function nb(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(L.hasData(a)&&(f=L.access(a),g=L.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}M.hasData(a)&&(h=M.access(a),i=n.extend({},h),M.set(b,i))}}function ob(a,b){var c=a.getElementsByTagName?a.getElementsByTagName(b||"*"):a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function pb(a,b){var c=b.nodeName.toLowerCase();"input"===c&&T.test(a.type)?b.checked=a.checked:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}n.extend({clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(k.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=ob(h),f=ob(a),d=0,e=f.length;e>d;d++)pb(f[d],g[d]);if(b)if(c)for(f=f||ob(a),g=g||ob(h),d=0,e=f.length;e>d;d++)nb(f[d],g[d]);else nb(a,h);return g=ob(h,"script"),g.length>0&&mb(g,!i&&ob(a,"script")),h},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,k=b.createDocumentFragment(),l=[],m=0,o=a.length;o>m;m++)if(e=a[m],e||0===e)if("object"===n.type(e))n.merge(l,e.nodeType?[e]:e);else if(cb.test(e)){f=f||k.appendChild(b.createElement("div")),g=(bb.exec(e)||["",""])[1].toLowerCase(),h=ib[g]||ib._default,f.innerHTML=h[1]+e.replace(ab,"<$1></$2>")+h[2],j=h[0];while(j--)f=f.lastChild;n.merge(l,f.childNodes),f=k.firstChild,f.textContent=""}else l.push(b.createTextNode(e));k.textContent="",m=0;while(e=l[m++])if((!d||-1===n.inArray(e,d))&&(i=n.contains(e.ownerDocument,e),f=ob(k.appendChild(e),"script"),i&&mb(f),c)){j=0;while(e=f[j++])fb.test(e.type||"")&&c.push(e)}return k},cleanData:function(a){for(var b,c,d,e,f=n.event.special,g=0;void 0!==(c=a[g]);g++){if(n.acceptData(c)&&(e=c[L.expando],e&&(b=L.cache[e]))){if(b.events)for(d in b.events)f[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);L.cache[e]&&delete L.cache[e]}delete M.cache[c[M.expando]]}}}),n.fn.extend({text:function(a){return J(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&(this.textContent=a)})},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=jb(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=jb(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?n.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||n.cleanData(ob(c)),c.parentNode&&(b&&n.contains(c.ownerDocument,c)&&mb(ob(c,"script")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(ob(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return J(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!db.test(a)&&!ib[(bb.exec(a)||["",""])[1].toLowerCase()]){a=a.replace(ab,"<$1></$2>");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(ob(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,n.cleanData(ob(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,l=this.length,m=this,o=l-1,p=a[0],q=n.isFunction(p);if(q||l>1&&"string"==typeof p&&!k.checkClone&&eb.test(p))return this.each(function(c){var d=m.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(l&&(c=n.buildFragment(a,this[0].ownerDocument,!1,this),d=c.firstChild,1===c.childNodes.length&&(c=d),d)){for(f=n.map(ob(c,"script"),kb),g=f.length;l>j;j++)h=c,j!==o&&(h=n.clone(h,!0,!0),g&&n.merge(f,ob(h,"script"))),b.call(this[j],h,j);if(g)for(i=f[f.length-1].ownerDocument,n.map(f,lb),j=0;g>j;j++)h=f[j],fb.test(h.type||"")&&!L.access(h,"globalEval")&&n.contains(i,h)&&(h.src?n._evalUrl&&n._evalUrl(h.src):n.globalEval(h.textContent.replace(hb,"")))}return this}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),g=e.length-1,h=0;g>=h;h++)c=h===g?this:this.clone(!0),n(e[h])[b](c),f.apply(d,c.get());return this.pushStack(d)}});var qb,rb={};function sb(b,c){var d,e=n(c.createElement(b)).appendTo(c.body),f=a.getDefaultComputedStyle&&(d=a.getDefaultComputedStyle(e[0]))?d.display:n.css(e[0],"display");return e.detach(),f}function tb(a){var b=l,c=rb[a];return c||(c=sb(a,b),"none"!==c&&c||(qb=(qb||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=qb[0].contentDocument,b.write(),b.close(),c=sb(a,b),qb.detach()),rb[a]=c),c}var ub=/^margin/,vb=new RegExp("^("+Q+")(?!px)[a-z%]+$","i"),wb=function(a){return a.ownerDocument.defaultView.getComputedStyle(a,null)};function xb(a,b,c){var d,e,f,g,h=a.style;return c=c||wb(a),c&&(g=c.getPropertyValue(b)||c[b]),c&&(""!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),vb.test(g)&&ub.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function yb(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d=l.documentElement,e=l.createElement("div"),f=l.createElement("div");if(f.style){f.style.backgroundClip="content-box",f.cloneNode(!0).style.backgroundClip="",k.clearCloneStyle="content-box"===f.style.backgroundClip,e.style.cssText="border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute",e.appendChild(f);function g(){f.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute",f.innerHTML="",d.appendChild(e);var g=a.getComputedStyle(f,null);b="1%"!==g.top,c="4px"===g.width,d.removeChild(e)}a.getComputedStyle&&n.extend(k,{pixelPosition:function(){return g(),b},boxSizingReliable:function(){return null==c&&g(),c},reliableMarginRight:function(){var b,c=f.appendChild(l.createElement("div"));return c.style.cssText=f.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",f.style.width="1px",d.appendChild(e),b=!parseFloat(a.getComputedStyle(c,null).marginRight),d.removeChild(e),b}})}}(),n.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var zb=/^(none|table(?!-c[ea]).+)/,Ab=new RegExp("^("+Q+")(.*)$","i"),Bb=new RegExp("^([+-])=("+Q+")","i"),Cb={position:"absolute",visibility:"hidden",display:"block"},Db={letterSpacing:"0",fontWeight:"400"},Eb=["Webkit","O","Moz","ms"];function Fb(a,b){if(b in a)return b;var c=b[0].toUpperCase()+b.slice(1),d=b,e=Eb.length;while(e--)if(b=Eb[e]+c,b in a)return b;return d}function Gb(a,b,c){var d=Ab.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function Hb(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+R[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+R[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+R[f]+"Width",!0,e))):(g+=n.css(a,"padding"+R[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+R[f]+"Width",!0,e)));return g}function Ib(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=wb(a),g="border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=xb(a,b,f),(0>e||null==e)&&(e=a.style[b]),vb.test(e))return e;d=g&&(k.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Hb(a,b,c||(g?"border":"content"),d,f)+"px"}function Jb(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=L.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&S(d)&&(f[g]=L.access(d,"olddisplay",tb(d.nodeName)))):(e=S(d),"none"===c&&e||L.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=xb(a,"opacity");return""===c?"1":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Fb(i,h)),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=Bb.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(n.css(a,b)),f="number"),null!=c&&c===c&&("number"!==f||n.cssNumber[h]||(c+="px"),k.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Fb(a.style,h)),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=xb(a,b,d)),"normal"===e&&b in Db&&(e=Db[b]),""===c||c?(f=parseFloat(e),c===!0||n.isNumeric(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?zb.test(n.css(a,"display"))&&0===a.offsetWidth?n.swap(a,Cb,function(){return Ib(a,b,d)}):Ib(a,b,d):void 0},set:function(a,c,d){var e=d&&wb(a);return Gb(a,c,d?Hb(a,b,d,"border-box"===n.css(a,"boxSizing",!1,e),e):0)}}}),n.cssHooks.marginRight=yb(k.reliableMarginRight,function(a,b){return b?n.swap(a,{display:"inline-block"},xb,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+R[d]+b]=f[d]||f[d-2]||f[0];return e}},ub.test(a)||(n.cssHooks[a+b].set=Gb)}),n.fn.extend({css:function(a,b){return J(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=wb(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Jb(this,!0)},hide:function(){return Jb(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){S(this)?n(this).show():n(this).hide()})}});function Kb(a,b,c,d,e){return new Kb.prototype.init(a,b,c,d,e)}n.Tween=Kb,Kb.prototype={constructor:Kb,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||"swing",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Kb.propHooks[this.prop];return a&&a.get?a.get(this):Kb.propHooks._default.get(this)},run:function(a){var b,c=Kb.propHooks[this.prop];return this.pos=b=this.options.duration?n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Kb.propHooks._default.set(this),this}},Kb.prototype.init.prototype=Kb.prototype,Kb.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0):a.elem[a.prop]},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[n.cssProps[a.prop]]||n.cssHooks[a.prop])?n.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},Kb.propHooks.scrollTop=Kb.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},n.fx=Kb.prototype.init,n.fx.step={};var Lb,Mb,Nb=/^(?:toggle|show|hide)$/,Ob=new RegExp("^(?:([+-])=|)("+Q+")([a-z%]*)$","i"),Pb=/queueHooks$/,Qb=[Vb],Rb={"*":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=Ob.exec(b),f=e&&e[3]||(n.cssNumber[a]?"":"px"),g=(n.cssNumber[a]||"px"!==f&&+d)&&Ob.exec(n.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||".5",g/=h,n.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function Sb(){return setTimeout(function(){Lb=void 0}),Lb=n.now()}function Tb(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=R[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ub(a,b,c){for(var d,e=(Rb[b]||[]).concat(Rb["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Vb(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&S(a),q=L.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?L.get(a,"olddisplay")||tb(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Nb.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?tb(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=L.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;L.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ub(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function Wb(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function Xb(a,b,c){var d,e,f=0,g=Qb.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Lb||Sb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:Lb||Sb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(Wb(k,j.opts.specialEasing);g>f;f++)if(d=Qb[f].call(j,a,k,j.opts))return d;return n.map(k,Ub,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(Xb,{tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.split(" ");for(var c,d=0,e=a.length;e>d;d++)c=a[d],Rb[c]=Rb[c]||[],Rb[c].unshift(b)},prefilter:function(a,b){b?Qb.unshift(a):Qb.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(S).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=Xb(this,n.extend({},a),f);(e||L.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=L.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Pb.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=L.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Tb(b,!0),a,d,e)}}),n.each({slideDown:Tb("show"),slideUp:Tb("hide"),slideToggle:Tb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Lb=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Lb=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Mb||(Mb=setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){clearInterval(Mb),Mb=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(a,b){return a=n.fx?n.fx.speeds[a]||a:a,b=b||"fx",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a=l.createElement("input"),b=l.createElement("select"),c=b.appendChild(l.createElement("option"));a.type="checkbox",k.checkOn=""!==a.value,k.optSelected=c.selected,b.disabled=!0,k.optDisabled=!c.disabled,a=l.createElement("input"),a.value="t",a.type="radio",k.radioValue="t"===a.value}();var Yb,Zb,$b=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return J(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===U?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),d=n.attrHooks[b]||(n.expr.match.bool.test(b)?Zb:Yb)),void 0===c?d&&"get"in d&&null!==(e=d.get(a,b))?e:(e=n.find.attr(a,b),null==e?void 0:e):null!==c?d&&"set"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+""),c):void n.removeAttr(a,b))
},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(E);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)},attrHooks:{type:{set:function(a,b){if(!k.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}}}),Zb={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=$b[b]||n.find.attr;$b[b]=function(a,b,d){var e,f;return d||(f=$b[b],$b[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,$b[b]=f),e}});var _b=/^(?:input|select|textarea|button)$/i;n.fn.extend({prop:function(a,b){return J(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({propFix:{"for":"htmlFor","class":"className"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!n.isXMLDoc(a),f&&(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){return a.hasAttribute("tabindex")||_b.test(a.nodeName)||a.href?a.tabIndex:-1}}}}),k.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var ac=/[\t\r\n\f]/g;n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h="string"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,this.className))});if(h)for(b=(a||"").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ac," "):" ")){f=0;while(e=b[f++])d.indexOf(" "+e+" ")<0&&(d+=e+" ");g=n.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0===arguments.length||"string"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,this.className))});if(h)for(b=(a||"").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ac," "):"")){f=0;while(e=b[f++])while(d.indexOf(" "+e+" ")>=0)d=d.replace(" "+e+" "," ");g=a?n.trim(d):"",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):this.each(n.isFunction(a)?function(c){n(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if("string"===c){var b,d=0,e=n(this),f=a.match(E)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===U||"boolean"===c)&&(this.className&&L.set(this,"__className__",this.className),this.className=this.className||a===!1?"":L.get(this,"__className__")||"")})},hasClass:function(a){for(var b=" "+a+" ",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(" "+this[c].className+" ").replace(ac," ").indexOf(b)>=0)return!0;return!1}});var bc=/\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(bc,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(k.optDisabled?c.disabled:null!==c.getAttribute("disabled"))||c.parentNode.disabled&&n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(d.value,f)>=0)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>=0:void 0}},k.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}});var cc=n.now(),dc=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(a){var b,c;if(!a||"string"!=typeof a)return null;try{c=new DOMParser,b=c.parseFromString(a,"text/xml")}catch(d){b=void 0}return(!b||b.getElementsByTagName("parsererror").length)&&n.error("Invalid XML: "+a),b};var ec,fc,gc=/#.*$/,hc=/([?&])_=[^&]*/,ic=/^(.*?):[ \t]*([^\r\n]*)$/gm,jc=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,kc=/^(?:GET|HEAD)$/,lc=/^\/\//,mc=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,nc={},oc={},pc="*/".concat("*");try{fc=location.href}catch(qc){fc=l.createElement("a"),fc.href="",fc=fc.href}ec=mc.exec(fc.toLowerCase())||[];function rc(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(E)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function sc(a,b,c,d){var e={},f=a===oc;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function tc(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function uc(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function vc(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:fc,type:"GET",isLocal:jc.test(ec[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":pc,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?tc(tc(a,n.ajaxSettings),b):tc(n.ajaxSettings,a)},ajaxPrefilter:rc(nc),ajaxTransport:rc(oc),ajax:function(a,b){"object"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=n.ajaxSetup({},b),l=k.context||k,m=k.context&&(l.nodeType||l.jquery)?n(l):n.event,o=n.Deferred(),p=n.Callbacks("once memory"),q=k.statusCode||{},r={},s={},t=0,u="canceled",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!f){f={};while(b=ic.exec(e))f[b[1].toLowerCase()]=b[2]}b=f[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?e:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return c&&c.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||fc)+"").replace(gc,"").replace(lc,ec[1]+"//"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=n.trim(k.dataType||"*").toLowerCase().match(E)||[""],null==k.crossDomain&&(h=mc.exec(k.url.toLowerCase()),k.crossDomain=!(!h||h[1]===ec[1]&&h[2]===ec[2]&&(h[3]||("http:"===h[1]?"80":"443"))===(ec[3]||("http:"===ec[1]?"80":"443")))),k.data&&k.processData&&"string"!=typeof k.data&&(k.data=n.param(k.data,k.traditional)),sc(nc,k,b,v),2===t)return v;i=k.global,i&&0===n.active++&&n.event.trigger("ajaxStart"),k.type=k.type.toUpperCase(),k.hasContent=!kc.test(k.type),d=k.url,k.hasContent||(k.data&&(d=k.url+=(dc.test(d)?"&":"?")+k.data,delete k.data),k.cache===!1&&(k.url=hc.test(d)?d.replace(hc,"$1_="+cc++):d+(dc.test(d)?"&":"?")+"_="+cc++)),k.ifModified&&(n.lastModified[d]&&v.setRequestHeader("If-Modified-Since",n.lastModified[d]),n.etag[d]&&v.setRequestHeader("If-None-Match",n.etag[d])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader("Content-Type",k.contentType),v.setRequestHeader("Accept",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+("*"!==k.dataTypes[0]?", "+pc+"; q=0.01":""):k.accepts["*"]);for(j in k.headers)v.setRequestHeader(j,k.headers[j]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u="abort";for(j in{success:1,error:1,complete:1})v[j](k[j]);if(c=sc(oc,k,b,v)){v.readyState=1,i&&m.trigger("ajaxSend",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort("timeout")},k.timeout));try{t=1,c.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,"No Transport");function x(a,b,f,h){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),c=void 0,e=h||"",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,f&&(u=uc(k,v,f)),u=vc(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader("Last-Modified"),w&&(n.lastModified[d]=w),w=v.getResponseHeader("etag"),w&&(n.etag[d]=w)),204===a||"HEAD"===k.type?x="nocontent":304===a?x="notmodified":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x="error",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+"",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,i&&m.trigger(j?"ajaxSuccess":"ajaxError",[v,k,j?r:s]),p.fireWith(l,[v,x]),i&&(m.trigger("ajaxComplete",[v,k]),--n.active||n.event.trigger("ajaxStop")))}return v},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return this.each(n.isFunction(a)?function(b){n(this).wrapInner(a.call(this,b))}:function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0},n.expr.filters.visible=function(a){return!n.expr.filters.hidden(a)};var wc=/%20/g,xc=/\[\]$/,yc=/\r?\n/g,zc=/^(?:submit|button|image|reset|file)$/i,Ac=/^(?:input|select|textarea|keygen)/i;function Bc(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||xc.test(a)?d(a,e):Bc(a+"["+("object"==typeof e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Bc(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Bc(c,a[c],b,e);return d.join("&").replace(wc,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Ac.test(this.nodeName)&&!zc.test(a)&&(this.checked||!T.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(yc,"\r\n")}}):{name:b.name,value:c.replace(yc,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new XMLHttpRequest}catch(a){}};var Cc=0,Dc={},Ec={0:200,1223:204},Fc=n.ajaxSettings.xhr();a.ActiveXObject&&n(a).on("unload",function(){for(var a in Dc)Dc[a]()}),k.cors=!!Fc&&"withCredentials"in Fc,k.ajax=Fc=!!Fc,n.ajaxTransport(function(a){var b;return k.cors||Fc&&!a.crossDomain?{send:function(c,d){var e,f=a.xhr(),g=++Cc;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c["X-Requested-With"]||(c["X-Requested-With"]="XMLHttpRequest");for(e in c)f.setRequestHeader(e,c[e]);b=function(a){return function(){b&&(delete Dc[g],b=f.onload=f.onerror=null,"abort"===a?f.abort():"error"===a?d(f.status,f.statusText):d(Ec[f.status]||f.status,f.statusText,"string"==typeof f.responseText?{text:f.responseText}:void 0,f.getAllResponseHeaders()))}},f.onload=b(),f.onerror=b("error"),b=Dc[g]=b("abort");try{f.send(a.hasContent&&a.data||null)}catch(h){if(b)throw h}},abort:function(){b&&b()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(d,e){b=n("<script>").prop({async:!0,charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&e("error"===a.type?404:200,a.type)}),l.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Gc=[],Hc=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Gc.pop()||n.expando+"_"+cc++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Hc.test(b.url)?"url":"string"==typeof b.data&&!(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Hc.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Hc,"$1"+e):b.jsonp!==!1&&(b.url+=(dc.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Gc.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||l;var d=v.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=n.buildFragment([a],b,e),e&&e.length&&n(e).remove(),n.merge([],d.childNodes))};var Ic=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Ic)return Ic.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>=0&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e,dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,f||[a.responseText,b,a])}),this},n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};var Jc=a.document.documentElement;function Kc(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(typeof d.getBoundingClientRect!==U&&(e=d.getBoundingClientRect()),c=Kc(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||Jc;while(a&&!n.nodeName(a,"html")&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Jc})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(b,c){var d="pageYOffset"===c;n.fn[b]=function(e){return J(this,function(b,e,f){var g=Kc(b);return void 0===f?g?g[c]:b[e]:void(g?g.scrollTo(d?a.pageXOffset:f,d?f:a.pageYOffset):b[e]=f)},b,e,arguments.length,null)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=yb(k.pixelPosition,function(a,c){return c?(c=xb(a,b),vb.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return J(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.size=function(){return this.length},n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Lc=a.jQuery,Mc=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Mc),b&&a.jQuery===n&&(a.jQuery=Lc),n},typeof b===U&&(a.jQuery=a.$=n),n});
//# sourceMappingURL=jquery.min.map
/**
 * @license AngularJS v1.3.0
 * (c) 2010-2014 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, document, undefined) {'use strict';

/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * Angular. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace') . Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;
  return function () {
    var code = arguments[0],
      prefix = '[' + (module ? module + ':' : '') + code + '] ',
      template = arguments[1],
      templateArgs = arguments,
      stringify = function (obj) {
        if (typeof obj === 'function') {
          return obj.toString().replace(/ \{[\s\S]*$/, '');
        } else if (typeof obj === 'undefined') {
          return 'undefined';
        } else if (typeof obj !== 'string') {
          return JSON.stringify(obj);
        }
        return obj;
      },
      message, i;

    message = prefix + template.replace(/\{\d+\}/g, function (match) {
      var index = +match.slice(1, -1), arg;

      if (index + 2 < templateArgs.length) {
        arg = templateArgs[index + 2];
        if (typeof arg === 'function') {
          return arg.toString().replace(/ ?\{[\s\S]*$/, '');
        } else if (typeof arg === 'undefined') {
          return 'undefined';
        } else if (typeof arg !== 'string') {
          return toJson(arg);
        }
        return arg;
      }
      return match;
    });

    message = message + '\nhttp://errors.angularjs.org/1.3.0/' +
      (module ? module + '/' : '') + code;
    for (i = 2; i < arguments.length; i++) {
      message = message + (i == 2 ? '?' : '&') + 'p' + (i-2) + '=' +
        encodeURIComponent(stringify(arguments[i]));
    }
    return new ErrorConstructor(message);
  };
}

/* We need to tell jshint what variables are being exported */
/* global angular: true,
  msie: true,
  jqLite: true,
  jQuery: true,
  slice: true,
  splice: true,
  push: true,
  toString: true,
  ngMinErr: true,
  angularModule: true,
  uid: true,
  REGEX_STRING_REGEXP: true,
  VALIDITY_STATE_PROPERTY: true,

  lowercase: true,
  uppercase: true,
  manualLowercase: true,
  manualUppercase: true,
  nodeName_: true,
  isArrayLike: true,
  forEach: true,
  sortedKeys: true,
  forEachSorted: true,
  reverseParams: true,
  nextUid: true,
  setHashKey: true,
  extend: true,
  int: true,
  inherit: true,
  noop: true,
  identity: true,
  valueFn: true,
  isUndefined: true,
  isDefined: true,
  isObject: true,
  isString: true,
  isNumber: true,
  isDate: true,
  isArray: true,
  isFunction: true,
  isRegExp: true,
  isWindow: true,
  isScope: true,
  isFile: true,
  isBlob: true,
  isBoolean: true,
  isPromiseLike: true,
  trim: true,
  isElement: true,
  makeMap: true,
  size: true,
  includes: true,
  arrayRemove: true,
  isLeafNode: true,
  copy: true,
  shallowCopy: true,
  equals: true,
  csp: true,
  concat: true,
  sliceArgs: true,
  bind: true,
  toJsonReplacer: true,
  toJson: true,
  fromJson: true,
  startingTag: true,
  tryDecodeURIComponent: true,
  parseKeyValue: true,
  toKeyValue: true,
  encodeUriSegment: true,
  encodeUriQuery: true,
  angularInit: true,
  bootstrap: true,
  getTestability: true,
  snake_case: true,
  bindJQuery: true,
  assertArg: true,
  assertArgFn: true,
  assertNotHasOwnProperty: true,
  getter: true,
  getBlockNodes: true,
  hasOwnProperty: true,
  createMap: true,

  NODE_TYPE_ELEMENT: true,
  NODE_TYPE_TEXT: true,
  NODE_TYPE_COMMENT: true,
  NODE_TYPE_DOCUMENT: true,
  NODE_TYPE_DOCUMENT_FRAGMENT: true,
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @description
 *
 * # ng (core module)
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 * <div doc-module-components="ng"></div>
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';

/**
 * @ngdoc function
 * @name angular.lowercase
 * @module ng
 * @kind function
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
var lowercase = function(string){return isString(string) ? string.toLowerCase() : string;};
var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * @ngdoc function
 * @name angular.uppercase
 * @module ng
 * @kind function
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
var uppercase = function(string){return isString(string) ? string.toUpperCase() : string;};


var manualLowercase = function(s) {
  /* jshint bitwise: false */
  return isString(s)
      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
      : s;
};
var manualUppercase = function(s) {
  /* jshint bitwise: false */
  return isString(s)
      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
      : s;
};


// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
// with correct but slower alternatives.
if ('i' !== 'I'.toLowerCase()) {
  lowercase = manualLowercase;
  uppercase = manualUppercase;
}


var /** holds major version number for IE or NaN for real browsers */
    msie,
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {
  if (obj == null || isWindow(obj)) {
    return false;
  }

  var length = obj.length;

  if (obj.nodeType === NODE_TYPE_ELEMENT && length) {
    return true;
  }

  return isString(obj) || isArray(obj) || length === 0 ||
         typeof length === 'number' && length > 0 && (length - 1) in obj;
}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        // Need to check if hasOwnProperty exists,
        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else {
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function sortedKeys(obj) {
  var keys = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      keys.push(key);
    }
  }
  return keys.sort();
}

function forEachSorted(obj, iterator, context) {
  var keys = sortedKeys(obj);
  for ( var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) { iteratorFn(key, value); };
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  }
  else {
    delete obj.$$hashKey;
  }
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  var h = dst.$$hashKey;

  for (var i = 1, ii = arguments.length; i < ii; i++) {
    var obj = arguments[i];
    if (obj) {
      var keys = Object.keys(obj);
      for (var j = 0, jj = keys.length; j < jj; j++) {
        var key = keys[j];
        dst[key] = obj[key];
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

function int(str) {
  return parseInt(str, 10);
}


function inherit(parent, extra) {
  return extend(new (extend(function() {}, {prototype:parent}))(), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
     function transformer(transformationFn, value) {
       return (transformationFn || angular.identity)(value);
     };
   ```
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function() {return value;};}

/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value){return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value){return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value){
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value){return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value){return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
var isArray = Array.isArray;

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value){return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // we are a direct element
    || (node.prop && node.attr && node.find)));  // we have an on and find method part of jQuery API
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(","), i;
  for ( i = 0; i < items.length; i++ )
    obj[ items[i] ] = true;
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || element[0].nodeName);
}


/**
 * @description
 * Determines the number of elements in an array, the number of properties an object has, or
 * the length of a string.
 *
 * Note: This function is used to augment the Object type in Angular expressions. See
 * {@link angular.Object} for more information about Angular arrays.
 *
 * @param {Object|Array|string} obj Object, array, or string to inspect.
 * @param {boolean} [ownPropsOnly=false] Count only "own" properties in an object
 * @returns {number} The size of `obj` or `0` if `obj` is neither an object nor an array.
 */
function size(obj, ownPropsOnly) {
  var count = 0, key;

  if (isArray(obj) || isString(obj)) {
    return obj.length;
  } else if (isObject(obj)) {
    for (key in obj)
      if (!ownPropsOnly || obj.hasOwnProperty(key))
        count++;
  }

  return count;
}


function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) != -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >=0)
    array.splice(index, 1);
  return value;
}

function isLeafNode (node) {
  if (node) {
    switch (nodeName_(node)) {
    case "option":
    case "pre":
    case "title":
      return true;
    }
  }
  return false;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array.
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for array) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to 'destination' an exception will be thrown.
 *
 * @param {*} source The source that will be used to make a copy.
 *                   Can be any type, including primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If
 *     provided, must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
 <example module="copyExample">
 <file name="index.html">
 <div ng-controller="ExampleController">
 <form novalidate class="simple-form">
 Name: <input type="text" ng-model="user.name" /><br />
 E-mail: <input type="email" ng-model="user.email" /><br />
 Gender: <input type="radio" ng-model="user.gender" value="male" />male
 <input type="radio" ng-model="user.gender" value="female" />female<br />
 <button ng-click="reset()">RESET</button>
 <button ng-click="update(user)">SAVE</button>
 </form>
 <pre>form = {{user | json}}</pre>
 <pre>master = {{master | json}}</pre>
 </div>

 <script>
  angular.module('copyExample', [])
    .controller('ExampleController', ['$scope', function($scope) {
      $scope.master= {};

      $scope.update = function(user) {
        // Example with 1 argument
        $scope.master= angular.copy(user);
      };

      $scope.reset = function() {
        // Example with 2 arguments
        angular.copy($scope.master, $scope.user);
      };

      $scope.reset();
    }]);
 </script>
 </file>
 </example>
 */
function copy(source, destination, stackSource, stackDest) {
  if (isWindow(source) || isScope(source)) {
    throw ngMinErr('cpws',
      "Can't copy! Making copies of Window or Scope instances is not supported.");
  }

  if (!destination) {
    destination = source;
    if (source) {
      if (isArray(source)) {
        destination = copy(source, [], stackSource, stackDest);
      } else if (isDate(source)) {
        destination = new Date(source.getTime());
      } else if (isRegExp(source)) {
        destination = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
        destination.lastIndex = source.lastIndex;
      } else if (isObject(source)) {
        var emptyObject = Object.create(Object.getPrototypeOf(source));
        destination = copy(source, emptyObject, stackSource, stackDest);
      }
    }
  } else {
    if (source === destination) throw ngMinErr('cpi',
      "Can't copy! Source and destination are identical.");

    stackSource = stackSource || [];
    stackDest = stackDest || [];

    if (isObject(source)) {
      var index = stackSource.indexOf(source);
      if (index !== -1) return stackDest[index];

      stackSource.push(source);
      stackDest.push(destination);
    }

    var result;
    if (isArray(source)) {
      destination.length = 0;
      for ( var i = 0; i < source.length; i++) {
        result = copy(source[i], null, stackSource, stackDest);
        if (isObject(source[i])) {
          stackSource.push(source[i]);
          stackDest.push(result);
        }
        destination.push(result);
      }
    } else {
      var h = destination.$$hashKey;
      if (isArray(destination)) {
        destination.length = 0;
      } else {
        forEach(destination, function(value, key) {
          delete destination[key];
        });
      }
      for ( var key in source) {
        if(source.hasOwnProperty(key)) {
          result = copy(source[key], null, stackSource, stackDest);
          if (isObject(source[key])) {
            stackSource.push(source[key]);
            stackDest.push(result);
          }
          destination[key] = result;
        }
      }
      setHashKey(destination,h);
    }

  }
  return destination;
}

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 == t2) {
    if (t1 == 'object') {
      if (isArray(o1)) {
        if (!isArray(o2)) return false;
        if ((length = o1.length) == o2.length) {
          for(key=0; key<length; key++) {
            if (!equals(o1[key], o2[key])) return false;
          }
          return true;
        }
      } else if (isDate(o1)) {
        if (!isDate(o2)) return false;
        return equals(o1.getTime(), o2.getTime());
      } else if (isRegExp(o1) && isRegExp(o2)) {
        return o1.toString() == o2.toString();
      } else {
        if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) || isArray(o2)) return false;
        keySet = {};
        for(key in o1) {
          if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
          if (!equals(o1[key], o2[key])) return false;
          keySet[key] = true;
        }
        for(key in o2) {
          if (!keySet.hasOwnProperty(key) &&
              key.charAt(0) !== '$' &&
              o2[key] !== undefined &&
              !isFunction(o2[key])) return false;
        }
        return true;
      }
    }
  }
  return false;
}

var csp = function() {
  if (isDefined(csp.isActive_)) return csp.isActive_;

  var active = !!(document.querySelector('[ng-csp]') ||
                  document.querySelector('[data-ng-csp]'));

  if (!active) {
    try {
      /* jshint -W031, -W054 */
      new Function('');
      /* jshint +W031, +W054 */
    } catch (e) {
      active = true;
    }
  }

  return (csp.isActive_ = active);
};



function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/* jshint -W101 */
/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
/* jshint +W101 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, curryArgs.concat(slice.call(arguments, 0)))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // in IE, native methods are not functions so they cannot be bound (note: they don't need to be)
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since angular uses this notation internally.
 *
 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
 * @param {boolean=} pretty If set to true, the JSON output will contain newlines and whitespace.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 */
function toJson(obj, pretty) {
  if (typeof obj === 'undefined') return undefined;
  return JSON.stringify(obj, toJsonReplacer, pretty ? '  ' : null);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized thingy.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone();
  try {
    // turns out IE does not let you set .html() on elements which
    // are not allowed to have children. So we just ignore it.
    element.empty();
  } catch(e) {}
  var elemHtml = jqLite('<div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w\-]+)/, function(match, nodeName) { return '<' + lowercase(nodeName); });
  } catch(e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch(e) {
    // Ignore any invalid uri component
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {}, key_value, key;
  forEach((keyValue || "").split('&'), function(keyValue) {
    if ( keyValue ) {
      key_value = keyValue.replace(/\+/g,'%20').split('=');
      key = tryDecodeURIComponent(key_value[0]);
      if ( isDefined(key) ) {
        var val = isDefined(key_value[1]) ? tryDecodeURIComponent(key_value[1]) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if(isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query       = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  element = jqLite(element);
  for (i=0; i<ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.attr(attr))) {
      return attr;
    }
  }
  return null;
}

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * Only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 * found in the document will be used to define the root element to auto-bootstrap as an
 * application. To run multiple applications in an HTML document you must manually bootstrap them using
 * {@link angular.bootstrap} instead. AngularJS applications cannot be nested within each other.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped and
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * `ngApp` is the easiest, and most common, way to bootstrap an application.
 *
 <example module="ngAppDemo">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = "World";
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up angular application.
 *
 * See: {@link guide/bootstrap Bootstrap}
 *
 * Note that Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 *
 * Angular will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of Angular try to work on the DOM.
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of angular application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a run block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 *     - `strictDi`: disable automatic function annotation for the application. This is meant to
 *       assist in finding bugs which break minified code.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === document) ? 'document' : startingTag(element);
      //Encode angle brackets to prevent input from being sanitized to empty string #8683
      throw ngMinErr(
          'btstrpd',
          "App Already Bootstrapped with this Element '{0}'",
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    doBootstrap();
  };
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of Angular on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of angular application.
 */
function getTestability(rootElement) {
  return angular.element(rootElement).injector().get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
var skipDestroyOnNextJQueryCleanData;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  jQuery = window.jQuery;
  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: JQLitePrototype.controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });

    // All nodes removed from the DOM via various jQuery APIs like .remove()
    // are passed through jQuery.cleanData. Monkey-patch this method to fire
    // the $destroy event on all removed nodes.
    originalCleanData = jQuery.cleanData;
    jQuery.cleanData = function(elems) {
      var events;
      if (!skipDestroyOnNextJQueryCleanData) {
        for (var i = 0, elem; (elem = elems[i]) != null; i++) {
          events = jQuery._data(elem, "events");
          if (events && events.$destroy) {
            jQuery(elem).triggerHandler('$destroy');
          }
        }
      } else {
        skipDestroyOnNextJQueryCleanData = false;
      }
      originalCleanData(elems);
    };
  } else {
    jqLite = JQLite;
  }

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {jqLite} jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
  //             collection, otherwise update the original collection.
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes = [node];

  do {
    node = node.nextSibling;
    if (!node) break;
    blockNodes.push(node);
  } while (node !== endNode);

  return jqLite(blockNodes);
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring angular {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving Angular
     * modules.
     * All modules (angular core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * When passed two or more arguments, a new module is created.  If passed only one argument, an
     * existing module (the name passed as the first argument to `module`) is retrieved.
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {
      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
             "the module name or forgot to load it. If registering a module ensure that you " +
             "specify the dependencies as the second argument.", name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLater('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLater('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLater('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constant are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link ngAnimate.$animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLater('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name.
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           */
          filter: invokeLater('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLater('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLater('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to register work which needs to be performed on module loading.
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return  moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global angularModule: true,
  version: true,

  $LocaleProvider,
  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  inputDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  styleDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCspDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DocumentProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $InterpolateProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpBackendProvider,
  $LocationProvider,
  $LogProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $$AsyncCallbackProvider,
  $WindowProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version. This object has the
 * following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  full: '1.3.0',    // all of these placeholder strings will be replaced by grunt's
  major: 1,    // package task
  minor: 3,
  dot: 0,
  codeName: 'superluminal-nudge'
};


function publishExternalAPI(angular){
  extend(angular, {
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'lowercase': lowercase,
    'uppercase': uppercase,
    'callbacks': {counter: 0},
    'getTestability': getTestability,
    '$$minErr': minErr,
    '$$csp': csp,
    'reloadWithDebugInfo': reloadWithDebugInfo
  });

  angularModule = setupModuleLoader(window);
  try {
    angularModule('ngLocale');
  } catch (e) {
    angularModule('ngLocale', []).provider('$locale', $LocaleProvider);
  }

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            style: styleDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $http: $HttpProvider,
        $httpBackend: $HttpBackendProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$asyncCallback : $$AsyncCallbackProvider
      });
    }
  ]);
}

/* global JQLitePrototype: true,
  addEventListenerFn: true,
  removeEventListenerFn: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true,
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or "jqLite."
 *
 * <div class="alert alert-success">jqLite is a tiny, API-compatible subset of jQuery that allows
 * Angular to manipulate the DOM in a cross-browser compatible way. **jqLite** implements only the most
 * commonly needed functionality with the goal of having a very small footprint.</div>
 *
 * To use jQuery, simply load it before `DOMContentLoaded` event fired.
 *
 * <div class="alert">**Note:** all element references in Angular are always wrapped with jQuery or
 * jqLite; they are never raw DOM references.</div>
 *
 * ## Angular's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/)
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/)
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyles()`
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces or selectors
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
 * - [`removeClass()`](http://api.jquery.com/removeClass/)
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/)
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers.
 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * ## jQuery/jqLite Extras
 * Angular also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1,
    addEventListenerFn = function(element, type, fn) {
      element.addEventListener(type, fn, false);
    },
    removeEventListenerFn = function(element, type, fn) {
      element.removeEventListener(type, fn, false);
    };

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var MOUSE_EVENT_MAP= { mouseleave : "mouseout", mouseenter : "mouseover"};
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts snake_case to camelCase.
 * Also there is special case for Moz prefix starting with upper case letter.
 * @param name Name to normalize
 */
function camelCase(name) {
  return name.
    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    }).
    replace(MOZ_HACK_REGEXP, 'Moz$1');
}

var SINGLE_TAG_REGEXP = /^<(\w+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi;

var wrapMap = {
  'option': [1, '<select multiple="multiple">', '</select>'],

  'thead': [1, '<table>', '</table>'],
  'col': [2, '<table><colgroup>', '</colgroup></table>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],
  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
  '_default': [0, "", ""]
};

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = tmp || fragment.appendChild(context.createElement("div"));
    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
    wrap = wrapMap[tag] || wrapMap._default;
    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];

    // Descend through wrappers to the right content
    i = wrap[0];
    while (i--) {
      tmp = tmp.lastChild;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = "";
  }

  // Remove wrapper from fragment
  fragment.textContent = "";
  fragment.innerHTML = ""; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) != '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants){
  if (!onlyDescendants) jqLiteRemoveData(element);

  if (element.querySelectorAll) {
    var descendants = element.querySelectorAll('*');
    for (var i = 0, l = descendants.length; i < l; i++) {
      jqLiteRemoveData(descendants[i]);
    }
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        removeEventListenerFn(element, type, handle);
      }
      delete events[type];
    }
  } else {
    forEach(type.split(' '), function(type) {
      if (isDefined(fn)) {
        var listenerFns = events[type];
        arrayRemove(listenerFns || [], fn);
        if (listenerFns && listenerFns.length > 0) {
          return;
        }
      }

      removeEventListenerFn(element, type, handle);
      delete events[type];
    });
  }
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
      return;
    }

    if (expandoStore.handle) {
      if (expandoStore.events.$destroy) {
        expandoStore.handle({}, '$destroy');
      }
      jqLiteOff(element);
    }
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[key] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[key];
        } else { // mass-setter: data({key1: val1, key2: val2})
          extend(data, key);
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
      indexOf( " " + selector + " " ) > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    forEach(cssClasses.split(' '), function(cssClass) {
      element.setAttribute('class', trim(
          (" " + (element.getAttribute('class') || '') + " ")
          .replace(/[\n\t]/g, " ")
          .replace(" " + trim(cssClass) + " ", " "))
      );
    });
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, " ");

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
        existingClasses += cssClass + ' ';
      }
    });

    element.setAttribute('class', trim(existingClasses));
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController' ) + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if(element.nodeType == NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if ((value = jqLite.data(element, names[i])) !== undefined) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behaviour
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: function(fn) {
    var fired = false;

    function trigger() {
      if (fired) return;
      fired = true;
      fn();
    }

    // check if document is already loaded
    if (document.readyState === 'complete'){
      setTimeout(trigger);
    } else {
      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
      // jshint -W064
      JQLite(window).on('load', trigger); // fallback to window.onload for others
      // jshint +W064
      this.on('DOMContentLoaded', trigger);
    }
  },
  toString: function() {
    var value = [];
    forEach(this, function(e){ value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength' : 'minlength',
  'ngMaxlength' : 'maxlength',
  'ngMin' : 'min',
  'ngMax' : 'max',
  'ngPattern' : 'pattern'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(element, name) {
  var nodeName = element.nodeName;
  return (nodeName === 'INPUT' || nodeName === 'TEXTAREA') && ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = camelCase(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value){
    var lowercasedName = lowercase(name);
    if (BOOLEAN_ATTR[lowercasedName]) {
      if (isDefined(value)) {
        if (!!value) {
          element[name] = true;
          element.setAttribute(name, lowercasedName);
        } else {
          element[name] = false;
          element.removeAttribute(lowercasedName);
        }
      } else {
        return (element[name] ||
                 (element.attributes.getNamedItem(name)|| noop).specified)
               ? lowercasedName
               : undefined;
      }
    } else if (isDefined(value)) {
      element.setAttribute(name, value);
    } else if (element.getAttribute) {
      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
      // some elements (e.g. Document) don't have get attribute, so return undefined
      var ret = element.getAttribute(name, 2);
      // normalize non-existing attributes to undefined (as jQuery)
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function (option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result.length === 0 ? null : result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name){
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2) === undefined)) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (value === undefined) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function (event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        eventFns[i].call(element, event);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported){
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    while (i--) {
      type = types[i];
      var eventFns = events[type];

      if (!eventFns) {
        events[type] = [];

        if (type === 'mouseenter' || type === 'mouseleave') {
          // Refer to jQuery's implementation of mouseenter & mouseleave
          // Read about mouseenter and mouseleave:
          // http://www.quirksmode.org/js/events_mouse.html#link8

          jqLiteOn(element, MOUSE_EVENT_MAP[type], function(event) {
            var target = this, related = event.relatedTarget;
            // For mousenter/leave call the handler if related is outside the target.
            // NB: No relatedTarget if the mouse left/entered the browser window
            if ( !related || (related !== target && !target.contains(related)) ){
              handle(event, type);
            }
          });

        } else {
          if (type !== '$destroy') {
            addEventListenerFn(element, type, handle);
          }
        }
        eventFns = events[type];
      }
      eventFns.push(fn);
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node){
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element){
      if (element.nodeType === NODE_TYPE_ELEMENT)
        children.push(element);
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child){
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    wrapNode = jqLite(wrapNode).eq(0).clone()[0];
    var parent = element.parentNode;
    if (parent) {
      parent.replaceChild(wrapNode, element);
    }
    wrapNode.appendChild(element);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;
    newElement = new JQLite(newElement);

    for (var i = 0, ii = newElement.length; i < ii; i++) {
      var node = newElement[i];
      parent.insertBefore(node, index.nextSibling);
      index = node;
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className){
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name){
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for(var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };

  // bind legacy bind/unbind to on/off
  JQLite.prototype.bind = JQLite.prototype.on;
  JQLite.prototype.unbind = JQLite.prototype.off;
});

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType == 'function' || (objType == 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

/**
 * HashMap which can use objects as keys
 */
function HashMap(array, isolatedUid) {
  if (isolatedUid) {
    var uid = 0;
    this.nextUid = function() {
      return ++uid;
    };
  }
  forEach(array, this.put, this);
}
HashMap.prototype = {
  /**
   * Store key value pair
   * @param key key to store can be any type
   * @param value value to store can be any type
   */
  put: function(key, value) {
    this[hashKey(key, this.nextUid)] = value;
  },

  /**
   * @param key
   * @returns {Object} the value for the key
   */
  get: function(key) {
    return this[hashKey(key, this.nextUid)];
  },

  /**
   * Remove the key/value pair
   * @param key
   */
  remove: function(key) {
    var value = this[key = hashKey(key, this.nextUid)];
    delete this[key];
    return value;
  }
};

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *

 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *        {@link angular.module}. The `ng` module must be explicitly added.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running Angular app
 * from outside Angular. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var FN_ARGS = /^function\s*[^\(]*\(\s*([^\)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var fnText = fn.toString().replace(STRIP_COMMENTS, ''),
      args = fnText.match(FN_ARGS);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      fnText,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        fnText = fn.toString().replace(STRIP_COMMENTS, '');
        argDecl = fnText.match(FN_ARGS);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * # Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ## Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. *NOTE:* This does not work with
 * minification, and obfuscation tools since these tools change the argument names.
 *
 * ## `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ## Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {!Function} fn The function to invoke. Function parameters are injected according to the
 *   {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * # Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * # The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * # The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */




/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An Angular **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(fn)} - registers a service **factory function**, `fn`,
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(class)} - registers a **constructor function**, `class`
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {function()} $getFn The $getFn for the instance creation. Internally this is a short hand
 *                            for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is the service
 * constructor function that will be used to instantiate the service instance.
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function} constructor A class (constructor function) that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function.  This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an Angular
 * {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service**, such as a string, a number, an array, an object or a function,
 * with the {@link auto.$injector $injector}. Unlike {@link auto.$provide#value value} it can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **service decorator** with the {@link auto.$injector $injector}. A service decorator
 * intercepts the creation of a service, allowing it to override or modify the behaviour of the
 * service. The object returned by the decorator may be the original service, or a new service
 * object which replaces or wraps and delegates to the original service.
 *
 * @param {string} name The name of the service to decorate.
 * @param {function()} decorator This function will be invoked when the service needs to be
 *    instantiated and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new HashMap([], true),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function() {
            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
          })),
      instanceCache = {},
      instanceInjector = (instanceCache.$injector =
          createInternalInjector(instanceCache, function(servicename) {
            var provider = providerInjector.get(servicename + providerSuffix);
            return instanceInjector.invoke(provider.$get, provider, undefined, servicename);
          }));


  forEach(loadModules(modulesToLoad), function(fn) { instanceInjector.invoke(fn || noop); });

  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
    }
    return providerCache[name + providerSuffix] = provider_;
  }

  function enforceReturnValue(name, factory) {
    return function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this, undefined, name);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad){
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.put(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for(i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          /* jshint -W022 */
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          return cache[serviceName] = factory(serviceName);
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = [],
          $inject = annotate(fn, strictDi, serviceName),
          length, i,
          key;

      for(i = 0, length = $inject.length; i < length; i++) {
        key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(
          locals && locals.hasOwnProperty(key)
          ? locals[key]
          : getService(key)
        );
      }
      if (isArray(fn)) {
        fn = fn[length];
      }

      // http://jsperf.com/angularjs-invoke-apply-vs-switch
      // #5388
      return fn.apply(self, args);
    }

    function instantiate(Type, locals, serviceName) {
      var Constructor = function() {},
          instance, returnedValue;

      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      Constructor.prototype = (isArray(Type) ? Type[Type.length - 1] : Type).prototype;
      instance = new Constructor();
      returnedValue = invoke(Type, instance, locals, serviceName);

      return isObject(returnedValue) || isFunction(returnedValue) ? returnedValue : instance;
    }

    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically will detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it checks the current value of {@link ng.$location#hash $location.hash()} and
   * scrolls to the related element, according to the rules specified in the
   * [Html5 spec](http://dev.w3.org/html5/spec/Overview.html#the-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function ($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function ($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;
    var scrollScheduled = false;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll() {
      var hash = $location.hash(), elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash == 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM
 * updates and calls done() callbacks.
 *
 * In order to enable animations the ngAnimate module has to be loaded.
 *
 * To see the functional implementation check out src/ngAnimate/animate.js
 */
var $AnimateProvider = ['$provide', function($provide) {


  this.$$selectors = {};


  /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(Element, doneFunction)` The element to animate, the `doneFunction`
   *   must be called once the element animation is complete. If a function is returned then the
   *   animation service will use this function to cancel the animation whenever a cancel event is
   *   triggered.
   *
   *
   * ```js
   *   return {
     *     eventFn : function(element, done) {
     *       //code to run the animation
     *       //once complete, then run done()
     *       return function cancellationFunction() {
     *         //code to cancel the animation
     *       }
     *     }
     *   }
   * ```
   *
   * @param {string} name The name of the animation.
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    var key = name + '-animation';
    if (name && name.charAt(0) != '.') throw $animateMinErr('notcsel',
        "Expecting class selector starting with '.' got '{0}'.", name);
    this.$$selectors[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element.
   * When setting the classNameFilter value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if(arguments.length === 1) {
      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
    }
    return this.$$classNameFilter;
  };

  this.$get = ['$$q', '$$asyncCallback', '$rootScope', function($$q, $$asyncCallback, $rootScope) {

    var currentDefer;

    function runAnimationPostDigest(fn) {
      var cancelFn, defer = $$q.defer();
      defer.promise.$$cancelFn = function ngAnimateMaybeCancel() {
        cancelFn && cancelFn();
      };

      $rootScope.$$postDigest(function ngAnimatePostDigest() {
        cancelFn = fn(function ngAnimateNotifyComplete() {
          defer.resolve();
        });
      });

      return defer.promise;
    }

    function resolveElementClasses(element, classes) {
      var toAdd = [], toRemove = [];

      var hasClasses = createMap();
      forEach((element.attr('class') || '').split(/\s+/), function(className) {
        hasClasses[className] = true;
      });

      forEach(classes, function(status, className) {
        var hasClass = hasClasses[className];

        // If the most recent class manipulation (via $animate) was to remove the class, and the
        // element currently has the class, the class is scheduled for removal. Otherwise, if
        // the most recent class manipulation (via $animate) was to add the class, and the
        // element does not currently have the class, the class is scheduled to be added.
        if (status === false && hasClass) {
          toRemove.push(className);
        } else if (status === true && !hasClass) {
          toAdd.push(className);
        }
      });

      return (toAdd.length + toRemove.length) > 0 &&
        [toAdd.length ? toAdd : null, toRemove.length ? toRemove : null];
    }

    function cachedClassManipulation(cache, classes, op) {
      for (var i=0, ii = classes.length; i < ii; ++i) {
        var className = classes[i];
        cache[className] = op;
      }
    }

    function asyncPromise() {
      // only serve one instance of a promise in order to save CPU cycles
      if (!currentDefer) {
        currentDefer = $$q.defer();
        $$asyncCallback(function() {
          currentDefer.resolve();
          currentDefer = null;
        });
      }
      return currentDefer.promise;
    }

    function applyStyles(element, options) {
      if (angular.isObject(options)) {
        var styles = extend(options.from || {}, options.to || {});
        element.css(styles);
      }
    }

    /**
     *
     * @ngdoc service
     * @name $animate
     * @description The $animate service provides rudimentary DOM manipulation functions to
     * insert, remove and move elements within the DOM, as well as adding and removing classes.
     * This service is the core service used by the ngAnimate $animator service which provides
     * high-level animation hooks for CSS and JavaScript.
     *
     * $animate is available in the AngularJS core, however, the ngAnimate module must be included
     * to enable full out animation support. Otherwise, $animate will only perform simple DOM
     * manipulation operations.
     *
     * To learn more about enabling animation support, click here to visit the {@link ngAnimate
     * ngAnimate module page} as well as the {@link ngAnimate.$animate ngAnimate $animate service
     * page}.
     */
    return {
      animate : function(element, from, to) {
        applyStyles(element, { from: from, to: to });
        return asyncPromise();
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element or
       * as the first child within the `parent` element. When the function is called a promise
       * is returned that will be resolved at a later time.
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (if the after element is not present)
       * @param {DOMElement} after the sibling element which will append the element
       *   after itself
       * @param {object=} options an optional collection of styles that will be applied to the element.
       * @return {Promise} the animation callback promise
       */
      enter : function(element, parent, after, options) {
        applyStyles(element, options);
        after ? after.after(element)
              : parent.prepend(element);
        return asyncPromise();
      },

      /**
       *
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Removes the element from the DOM. When the function is called a promise
       * is returned that will be resolved at a later time.
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options that will be applied to the element.
       * @return {Promise} the animation callback promise
       */
      leave : function(element, options) {
        element.remove();
        return asyncPromise();
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Moves the position of the provided element within the DOM to be placed
       * either after the `after` element or inside of the `parent` element. When the function
       * is called a promise is returned that will be resolved at a later time.
       *
       * @param {DOMElement} element the element which will be moved around within the
       *   DOM
       * @param {DOMElement} parent the parent element where the element will be
       *   inserted into (if the after element is not present)
       * @param {DOMElement} after the sibling element where the element will be
       *   positioned next to
       * @param {object=} options an optional collection of options that will be applied to the element.
       * @return {Promise} the animation callback promise
       */
      move : function(element, parent, after, options) {
        // Do not remove element before insert. Removing will cause data associated with the
        // element to be dropped. Insert will implicitly do the remove.
        return this.enter(element, parent, after, options);
      },

      /**
       *
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       * @description Adds the provided className CSS class value to the provided element.
       * When the function is called a promise is returned that will be resolved at a later time.
       * @param {DOMElement} element the element which will have the className value
       *   added to it
       * @param {string} className the CSS class which will be added to the element
       * @param {object=} options an optional collection of options that will be applied to the element.
       * @return {Promise} the animation callback promise
       */
      addClass : function(element, className, options) {
        return this.setClass(element, className, [], options);
      },

      $$addClassImmediately : function(element, className, options) {
        element = jqLite(element);
        className = !isString(className)
                        ? (isArray(className) ? className.join(' ') : '')
                        : className;
        forEach(element, function (element) {
          jqLiteAddClass(element, className);
        });
        applyStyles(element, options);
        return asyncPromise();
      },

      /**
       *
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       * @description Removes the provided className CSS class value from the provided element.
       * When the function is called a promise is returned that will be resolved at a later time.
       * @param {DOMElement} element the element which will have the className value
       *   removed from it
       * @param {string} className the CSS class which will be removed from the element
       * @param {object=} options an optional collection of options that will be applied to the element.
       * @return {Promise} the animation callback promise
       */
      removeClass : function(element, className, options) {
        return this.setClass(element, [], className, options);
      },

      $$removeClassImmediately : function(element, className, options) {
        element = jqLite(element);
        className = !isString(className)
                        ? (isArray(className) ? className.join(' ') : '')
                        : className;
        forEach(element, function (element) {
          jqLiteRemoveClass(element, className);
        });
        applyStyles(element, options);
        return asyncPromise();
      },

      /**
       *
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       * @description Adds and/or removes the given CSS classes to and from the element.
       * When the function is called a promise is returned that will be resolved at a later time.
       * @param {DOMElement} element the element which will have its CSS classes changed
       *   removed from it
       * @param {string} add the CSS classes which will be added to the element
       * @param {string} remove the CSS class which will be removed from the element
       * @param {object=} options an optional collection of options that will be applied to the element.
       * @return {Promise} the animation callback promise
       */
      setClass : function(element, add, remove, options) {
        var self = this;
        var STORAGE_KEY = '$$animateClasses';
        var createdCache = false;
        element = jqLite(element);

        var cache = element.data(STORAGE_KEY);
        if (!cache) {
          cache = {
            classes: {},
            options : options
          };
          createdCache = true;
        } else if (options && cache.options) {
          cache.options = angular.extend(cache.options || {}, options);
        }

        var classes = cache.classes;

        add = isArray(add) ? add : add.split(' ');
        remove = isArray(remove) ? remove : remove.split(' ');
        cachedClassManipulation(classes, add, true);
        cachedClassManipulation(classes, remove, false);

        if (createdCache) {
          cache.promise = runAnimationPostDigest(function(done) {
            var cache = element.data(STORAGE_KEY);
            element.removeData(STORAGE_KEY);

            // in the event that the element is removed before postDigest
            // is run then the cache will be undefined and there will be
            // no need anymore to add or remove and of the element classes
            if (cache) {
              var classes = resolveElementClasses(element, cache.classes);
              if (classes) {
                self.$$setClassImmediately(element, classes[0], classes[1], cache.options);
              }
            }

            done();
          });
          element.data(STORAGE_KEY, cache);
        }

        return cache.promise;
      },

      $$setClassImmediately : function(element, add, remove, options) {
        add && this.$$addClassImmediately(element, add);
        remove && this.$$removeClassImmediately(element, remove);
        applyStyles(element, options);
        return asyncPromise();
      },

      enabled : noop,
      cancel : noop
    };
  }];
}];

function $$AsyncCallbackProvider(){
  this.$get = ['$$rAF', '$timeout', function($$rAF, $timeout) {
    return $$rAF.supported
      ? function(fn) { return $$rAF(fn); }
      : function(fn) {
        return $timeout(fn, 0, false);
      };
  }];
}

/* global stripHash: true */

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {function()} XHR XMLHttpRequest constructor.
 * @param {object} $log console.log or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer) {
  var self = this,
      rawDocument = document[0],
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {};

  self.isMock = false;

  var outstandingRequestCount = 0;
  var outstandingRequestCallbacks = [];

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = completeOutstandingRequest;
  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };

  /**
   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
   */
  function completeOutstandingRequest(fn) {
    try {
      fn.apply(null, sliceArgs(arguments, 1));
    } finally {
      outstandingRequestCount--;
      if (outstandingRequestCount === 0) {
        while(outstandingRequestCallbacks.length) {
          try {
            outstandingRequestCallbacks.pop()();
          } catch (e) {
            $log.error(e);
          }
        }
      }
    }
  }

  /**
   * @private
   * Note: this method is used only by scenario runner
   * TODO(vojta): prefix this method with $$ ?
   * @param {function()} callback Function that will be called when no outstanding request
   */
  self.notifyWhenNoOutstandingRequests = function(callback) {
    // force browser to execute all pollFns - this is needed so that cookies and other pollers fire
    // at some deterministic time in respect to the test runner's actions. Leaving things up to the
    // regular poller would result in flaky tests.
    forEach(pollFns, function(pollFn){ pollFn(); });

    if (outstandingRequestCount === 0) {
      callback();
    } else {
      outstandingRequestCallbacks.push(callback);
    }
  };

  //////////////////////////////////////////////////////////////
  // Poll Watcher API
  //////////////////////////////////////////////////////////////
  var pollFns = [],
      pollTimeout;

  /**
   * @name $browser#addPollFn
   *
   * @param {function()} fn Poll function to add
   *
   * @description
   * Adds a function to the list of functions that poller periodically executes,
   * and starts polling if not started yet.
   *
   * @returns {function()} the added function
   */
  self.addPollFn = function(fn) {
    if (isUndefined(pollTimeout)) startPoller(100, setTimeout);
    pollFns.push(fn);
    return fn;
  };

  /**
   * @param {number} interval How often should browser call poll functions (ms)
   * @param {function()} setTimeout Reference to a real or fake `setTimeout` function.
   *
   * @description
   * Configures the poller to run in the specified intervals, using the specified
   * setTimeout fn and kicks it off.
   */
  function startPoller(interval, setTimeout) {
    (function check() {
      forEach(pollFns, function(pollFn){ pollFn(); });
      pollTimeout = setTimeout(check, interval);
    })();
  }

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      reloadLocation = null;

  cacheState();
  lastHistoryState = cachedState;

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of location.href.
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, pushState/replaceState is used, otherwise
   * location.href/location.replace is used.
   * Returns its own instance to allow chaining
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state object to use with pushState/replaceState
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
        // Do the assignment again so that those two variables are referentially identical.
        lastHistoryState = cachedState;
      } else {
        if (!sameBase) {
          reloadLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else {
          location.href = url;
        }
      }
      return self;
    // getter
    } else {
      // - reloadLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened.
      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
      return reloadLocation || location.href.replace(/%27/g,"'");
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    cacheState();
    fireUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = window.history.state;
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }
    lastCachedState = cachedState;
  }

  function fireUrlChange() {
    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of angular:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in angular apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
      // don't fire popstate when user change the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * Checks whether the url has changed outside of Angular.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
  };

  //////////////////////////////////////////////////////////////
  // Cookies API
  //////////////////////////////////////////////////////////////
  var lastCookies = {};
  var lastCookieString = '';
  var cookiePath = self.baseHref();

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  /**
   * @name $browser#cookies
   *
   * @param {string=} name Cookie name
   * @param {string=} value Cookie value
   *
   * @description
   * The cookies method provides a 'private' low level access to browser cookies.
   * It is not meant to be used directly, use the $cookie service instead.
   *
   * The return values vary depending on the arguments that the method was called with as follows:
   *
   * - cookies() -> hash of all cookies, this is NOT a copy of the internal state, so do not modify
   *   it
   * - cookies(name, value) -> set name to value, if value is undefined delete the cookie
   * - cookies(name) -> the same as (name, undefined) == DELETES (no one calls it right now that
   *   way)
   *
   * @returns {Object} Hash of all cookies (if called without any parameter)
   */
  self.cookies = function(name, value) {
    var cookieLength, cookieArray, cookie, i, index;

    if (name) {
      if (value === undefined) {
        rawDocument.cookie = encodeURIComponent(name) + "=;path=" + cookiePath +
                                ";expires=Thu, 01 Jan 1970 00:00:00 GMT";
      } else {
        if (isString(value)) {
          cookieLength = (rawDocument.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) +
                                ';path=' + cookiePath).length + 1;

          // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
          // - 300 cookies
          // - 20 cookies per unique domain
          // - 4096 bytes per cookie
          if (cookieLength > 4096) {
            $log.warn("Cookie '"+ name +
              "' possibly not set or overflowed because it was too large ("+
              cookieLength + " > 4096 bytes)!");
          }
        }
      }
    } else {
      if (rawDocument.cookie !== lastCookieString) {
        lastCookieString = rawDocument.cookie;
        cookieArray = lastCookieString.split("; ");
        lastCookies = {};

        for (i = 0; i < cookieArray.length; i++) {
          cookie = cookieArray[i];
          index = cookie.indexOf('=');
          if (index > 0) { //ignore nameless cookies
            name = safeDecodeURIComponent(cookie.substring(0, index));
            // the first value that is seen for a cookie is the most
            // specific one.  values for the same cookie name that
            // follow are for less specific paths.
            if (lastCookies[name] === undefined) {
              lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
            }
          }
        }
      }
      return lastCookies;
    }
  };


  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] of milliseconds to defer the function execution.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay) {
    var timeoutId;
    outstandingRequestCount++;
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      completeOutstandingRequest(fn);
    }, delay || 0);
    pendingDeferIds[timeoutId] = true;
    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds[deferId]) {
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      completeOutstandingRequest(noop);
      return true;
    }
    return false;
  };

}

function $BrowserProvider(){
  this.$get = ['$window', '$log', '$sniffer', '$document',
      function( $window,   $log,   $sniffer,   $document){
        return new Browser($window, $document, $log, $sniffer);
      }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if ($scope.cache.get(key) === undefined) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, value === undefined ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = {},
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = {},
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
       * templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (isUndefined(value)) return;
          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = {};
          size = 0;
          lruHash = {};
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      };


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry != freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd == entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry != prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 *
 * @description
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, or by consuming the
 * `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be below the `ng-app` definition.
 *
 * Adding via the $templateCache service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your HTML:
 * ```html
 * <div ng-include=" 'templateId.html' "></div>
 * ```
 *
 * or get it via Javascript:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 * See {@link ng.$cacheFactory $cacheFactory}.
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a "Directive Definition Object" (see below) that defines the directive properties,
 * or just the `postLink` function (all other properties will have the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       priority: 0,
 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       transclude: false,
 *       restrict: 'A',
 *       templateNamespace: 'html',
 *       scope: false,
 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       controllerAs: 'stringAlias',
 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       compile: function compile(tElement, tAttrs, transclude) {
 *         return {
 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // link: {
 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // link: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true, the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recomended that this feature be used on directives
 * which are not strictly behavioural (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * **If set to `true`,** then a new scope will be created for this directive. If multiple directives on the
 * same element request a new scope, only one new scope is created. The new scope rule does not
 * apply for the root of the template since the root of the template always gets a new scope.
 *
 * **If set to `{}` (object hash),** then a new "isolate" scope is created. The 'isolate' scope differs from
 * normal scope in that it does not prototypically inherit from the parent scope. This is useful
 * when creating reusable components, which should not accidentally read or modify data in the
 * parent scope.
 *
 * The 'isolate' scope takes an object hash which defines a set of local scope properties
 * derived from the parent scope. These local properties are useful for aliasing values for
 * templates. Locals definition is a hash of local scope property to its source:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified  then the
 *   attribute name is assumed to be the same as the local name.
 *   Given `<widget my-attr="hello {{name}}">` and widget definition
 *   of `scope: { localName:'@myAttr' }`, then widget scope property `localName` will reflect
 *   the interpolated value of `hello {{name}}`. As the `name` attribute changes so will the
 *   `localName` property on the widget scope. The `name` is read from the parent scope (not
 *   component scope).
 *
 * * `=` or `=attr` - set up bi-directional binding between a local scope property and the
 *   parent scope property of name defined via the value of the `attr` attribute. If no `attr`
 *   name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<widget my-attr="parentModel">` and widget definition of
 *   `scope: { localModel:'=myAttr' }`, then widget scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel` and any changes in `localModel` will reflect in `parentModel`. If the parent
 *   scope property doesn't exist, it will throw a NON_ASSIGNABLE_MODEL_EXPRESSION exception. You
 *   can avoid this behavior using `=?` or `=?attr` in order to flag the property as optional.
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name. Given `<widget my-attr="count = count + value">` and widget definition of
 *   `scope: { localFn:'&myAttr' }`, then isolate scope property `localFn` will point to
 *   a function wrapper for the `count = count + value` expression. Often it's desirable to
 *   pass data from the isolated scope via an expression to the parent scope, this can be
 *   done by passing a map of local variable names and values into the expression wrapper fn.
 *   For example, if the expression is `increment(amount)` then we can specify the amount value
 *   by calling the `localFn` as `localFn({amount: 22})`.
 *
 *
 * #### `bindToController`
 * When an isolate scope is used for a component (see above), and `controllerAs` is used, `bindToController` will
 * allow a component to have its properties bound to the controller, rather than to scope. When the controller
 * is instantiated, the initial values of the isolate scope bindings are already available.
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and it is shared with other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement)`.
 *    * `scope`: optional argument to override the scope.
 *    * `cloneLinkingFn`: optional argument to create clones of the original transcluded content.
 *    * `futureParentElement`:
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkinFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` takes a string name (or array of strings) of the directive(s) to pass in. If an array is used, the
 * injected argument will be an array in corresponding order. If no such directive can be
 * found, or if the directive does not have a controller, then an error is raised. The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Controller alias at the directive scope. An alias for the controller so it
 * can be referenced at the directive template. The directive needs to define a scope for this
 * configuration to be used. Useful in the case when directive is used as component.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
 * specify what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 * There are two kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element or the entire element:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and a
 * stack overflow errors.
 *
 * This can be avoided by manually using $compile in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-error">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - a controller instance - A controller instance if at least one directive on the
 *     element defines a controller. The controller is shared among all the directives, which allows
 *     the directives to use the controllers as a communication channel.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude`
 *     parameter of directive controllers, see there for details.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM element from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a translude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
 * ```
 * - $rootScope
 *   - isolate
 *     - transclusion
 * ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
 * ```
 * - $rootScope
 *   - transclusion
 * - isolate
 * ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * accessing *Normalized attribute names:*
 * Directives like 'ngBind' can be expressed in many ways: 'ng:bind', `data-ng-bind`, or 'x-ng-bind'.
 * the attributes object allows for normalized access to
 *   the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', function($compile) {
          // directive factory creates a link function
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                 // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'Angular';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br>
      <textarea ng-model="html"></textarea> <br>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello Angular'.
       expect(output.getText()).toBe('Hello Angular');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('Angular!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives.
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to $digest which typically is done by
 * Angular automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = $compile('<p>{{total}}</p>')(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone via the cloneAttachFn:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>'),
 *         scope = ....;
 *
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       //attach the clone to DOM document at the right place
 *     });
 *
 *     //now we have reference to the cloned DOM via `clonedElement`
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
 */

var $compileMinErr = minErr('$compile');

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\d\w_\-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\d\w_\-]+)(?:\:([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;

  function parseIsolateBindings(scope, directiveName) {
    var LOCAL_REGEXP = /^\s*([@=&])(\??)\s*(\w*)\s*$/;

    var bindings = {};

    forEach(scope, function(definition, scopeName) {
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            "Invalid isolate scope definition for directive '{0}'." +
            " Definition: {... {1}: '{2}' ...}",
            directiveName, scopeName, definition);
      }

      bindings[scopeName] = {
        attrName: match[3] || scopeName,
        mode: match[1],
        optional: match[2] === '?'
      };
    });

    return bindings;
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
   *    names and the values are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See
   *    {@link guide/directive} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
   this.directive = function registerDirective(name, directiveFactory) {
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = directive.require || (directive.controller && directive.name);
                directive.restrict = directive.restrict || 'EA';
                if (isObject(directive.scope)) {
                  directive.$$isolateBindings = parseIsolateBindings(directive.scope, directive.name);
                }
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
    }
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `$binding` data property containing an array of the binding expressions
   *
   * You may want to use this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if(isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$document', '$sce', '$animate', '$$sanitizeUri',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $document,   $sce,   $animate,   $$sanitizeUri) {

    var Attributes = function(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    };

    Attributes.prototype = {
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass : function(classVal) {
        if(classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass : function(classVal) {
        if(classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass : function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        //is set through this function since it may cause $updateClass to
        //become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(node, key),
            observer = key,
            normalizedVal,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if(aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        if ((nodeName === 'a' && key === 'href') ||
            (nodeName === 'img' && key === 'src')) {
          // sanitize a[href] and img[src] values
          this[key] = value = $$sanitizeUri(value, key === 'src');
        } else if (nodeName === 'img' && key === 'srcset') {
          // sanitize img[srcset] values
          var result = "";

          // first check if there are spaces because it's not the same pattern
          var trimmedSrcset = trim(value);
          //                (   999x   ,|   999w   ,|   ,|,   )
          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

          // split srcset into tuple of uri and descriptor except for the last item
          var rawUris = trimmedSrcset.split(pattern);

          // for each tuples
          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
          for (var i=0; i<nbrUrisWith2parts; i++) {
            var innerIdx = i*2;
            // sanitize the uri
            result += $$sanitizeUri(trim( rawUris[innerIdx]), true);
            // add the descriptor
            result += ( " " + trim(rawUris[innerIdx+1]));
          }

          // split the last item into uri and descriptor
          var lastTuple = trim(rawUris[i*2]).split(/\s/);

          // sanitize the last uri
          result += $$sanitizeUri(trim(lastTuple[0]), true);

          // and add the last descriptor if any
          if( lastTuple.length === 2) {
            result += (" " + trim(lastTuple[1]));
          }
          this[key] = value = result;
        }

        if (writeAttr !== false) {
          if (value === null || value === undefined) {
            this.$$element.removeAttr(attrName);
          } else {
            this.$$element.attr(attrName, value);
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        $$observers && forEach($$observers[observer], function(fn) {
          try {
            fn(value);
          } catch (e) {
            $exceptionHandler(e);
          }
        });
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/directive#text-and-attribute-bindings Directives} guide for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };


    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch(e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol == '{{' || endSymbol  == '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_ATTR_BINDING = /^ngAttr[A-Z]/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }
      // We can not compile top level text elements since text nodes can be merged and we will
      // not be able to attach scope data to them, so we will wrap them in <span>
      forEach($compileNodes, function(node, index){
        if (node.nodeType == NODE_TYPE_TEXT && node.nodeValue.match(/\S+/) /* non-empty */ ) {
          $compileNodes[index] = jqLite(node).wrap('<span></span>').parent()[0];
        }
      });
      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, transcludeControllers, parentBoundTranscludeFn, futureParentElement){
        assertArg(scope, 'scope');
        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && node.toString().match(/SVG/) ? 'svg': 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;

      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i+=3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for(i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if ( nodeLinkFn.transcludeOnThisElement ) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn,
                  nodeLinkFn.elementTranscludeOnThisElement);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn, elementTransclusion) {

      var boundTranscludeFn = function(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, controllers, previousBoundTranscludeFn, futureParentElement);
      };

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          className;

      switch(nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */
          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            attr = nAttrs[j];
            name = attr.name;
            value = trim(attr.value);

            // support ngAttr attribute binding
            ngAttrName = directiveNormalize(name);
            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
              name = snake_case(ngAttrName.substr(6), '-');
            }

            var directiveNName = ngAttrName.replace(/(Start|End)$/, '');
            if (directiveIsMultiElement(directiveNName)) {
              if (ngAttrName === directiveNName + 'Start') {
                attrStartName = name;
                attrEndName = name.substr(0, name.length - 5) + 'end';
                name = name.substr(0, name.length - 6);
              }
            }

            nName = directiveNormalize(name.toLowerCase());
            attrsMap[nName] = name;
            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
            }
            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                          attrEndName);
          }

          // use class as directive
          className = node.className;
          if (isString(className) && className !== '') {
            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          try {
            match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
            if (match) {
              nName = directiveNormalize(match[1]);
              if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[2]);
              }
            }
          } catch (e) {
            // turns out that under some circumstances IE9 throws errors when one attempts to read
            // comment's node value.
            // Just ignore it and continue. (Can't seem to reproduce in test case.)
          }
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    /**
     * Given a node with an directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        var startNode = node;
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
                      attrStart, attrEnd);
          }
          if (node.nodeType == NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          controllers,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          directiveValue;

      // executes all directives on the current element
      for(var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        if (directiveValue = directive.scope) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        if (!directive.templateUrl && directive.controller) {
          directiveValue = directive.controller;
          controllerDirectives = controllerDirectives || {};
          assertNoDuplicate("'" + directiveName + "' controller",
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        if (directiveValue = directive.transclude) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue == 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(document.createComment(' ' + directiveName + ': ' +
                                              templateAttrs[directiveName] + ' '));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            childTranscludeFn = compile($template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {
            $template = jqLite(jqLiteClone(compileNode)).contents();
            $compileNode.empty(); // clear contents
            childTranscludeFn = compile($template, transcludeFn);
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  "Template for directive '{0}' must have exactly one root element. {1}",
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective) {
              markDirectivesAsIsolate(templateDirectives);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            if (isFunction(linkFn)) {
              addLinkFns(null, linkFn, attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(linkFn.pre, linkFn.post, attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.elementTranscludeOnThisElement = hasElementTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }


      function getControllers(directiveName, require, $element, elementControllers) {
        var value, retrievalMethod = 'data', optional = false;
        var $searchElement = $element;
        var match;
        if (isString(require)) {
          match = require.match(REQUIRE_PREFIX_REGEXP);
          require = require.substring(match[0].length);

          if (match[3]) {
            if (match[1]) match[3] = null;
            else match[1] = match[3];
          }
          if (match[1] === '^') {
            retrievalMethod = 'inheritedData';
          } else if (match[1] === '^^') {
            retrievalMethod = 'inheritedData';
            $searchElement = $element.parent();
          }
          if (match[2] === '?') {
            optional = true;
          }

          value = null;

          if (elementControllers && retrievalMethod === 'data') {
            if (value = elementControllers[require]) {
              value = value.instance;
            }
          }
          value = value || $searchElement[retrievalMethod]('$' + require + 'Controller');

          if (!value && !optional) {
            throw $compileMinErr('ctreq',
                "Controller '{0}', required by directive '{1}', can't be found!",
                require, directiveName);
          }
          return value;
        } else if (isArray(require)) {
          value = [];
          forEach(require, function(require) {
            value.push(getControllers(directiveName, require, $element, elementControllers));
          });
        }
        return value;
      }


      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, controller, isolateScope, elementControllers, transcludeFn, $element,
            attrs;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        }

        transcludeFn = boundTranscludeFn && controllersBoundTransclude;
        if (controllerDirectives) {
          // TODO: merge `controllers` and `elementControllers` into single object.
          controllers = {};
          elementControllers = {};
          forEach(controllerDirectives, function(directive) {
            var locals = {
              $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
              $element: $element,
              $attrs: attrs,
              $transclude: transcludeFn
            }, controllerInstance;

            controller = directive.controller;
            if (controller == '@') {
              controller = attrs[directive.name];
            }

            controllerInstance = $controller(controller, locals, true, directive.controllerAs);

            // For directives with element transclusion the element is a comment,
            // but jQuery .data doesn't support attaching data to comment nodes as it's hard to
            // clean up (http://bugs.jquery.com/ticket/8335).
            // Instead, we save the controllers for the element in a local hash and attach to .data
            // later, once we have the actual element.
            elementControllers[directive.name] = controllerInstance;
            if (!hasElementTranscludeDirective) {
              $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
            }

            controllers[directive.name] = controllerInstance;
          });
        }

        if (newIsolateScopeDirective) {
          var LOCAL_REGEXP = /^\s*([@=&])(\??)\s*(\w*)\s*$/;

          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);

          var isolateScopeController = controllers && controllers[newIsolateScopeDirective.name];
          var isolateBindingContext = isolateScope;
          if (isolateScopeController && isolateScopeController.identifier &&
              newIsolateScopeDirective.bindToController === true) {
            isolateBindingContext = isolateScopeController.instance;
          }

          forEach(isolateScope.$$isolateBindings = newIsolateScopeDirective.$$isolateBindings, function(definition, scopeName) {
            var attrName = definition.attrName,
                optional = definition.optional,
                mode = definition.mode, // @, =, or &
                lastValue,
                parentGet, parentSet, compare;

            switch (mode) {

              case '@':
                attrs.$observe(attrName, function(value) {
                  isolateBindingContext[scopeName] = value;
                });
                attrs.$$observers[attrName].$$scope = scope;
                if( attrs[attrName] ) {
                  // If the attribute has been provided then we trigger an interpolation to ensure
                  // the value is there for use in the link fn
                  isolateBindingContext[scopeName] = $interpolate(attrs[attrName])(scope);
                }
                break;

              case '=':
                if (optional && !attrs[attrName]) {
                  return;
                }
                parentGet = $parse(attrs[attrName]);
                if (parentGet.literal) {
                  compare = equals;
                } else {
                  compare = function(a,b) { return a === b || (a !== a && b !== b); };
                }
                parentSet = parentGet.assign || function() {
                  // reset the change, or we will throw this exception on every $digest
                  lastValue = isolateBindingContext[scopeName] = parentGet(scope);
                  throw $compileMinErr('nonassign',
                      "Expression '{0}' used with directive '{1}' is non-assignable!",
                      attrs[attrName], newIsolateScopeDirective.name);
                };
                lastValue = isolateBindingContext[scopeName] = parentGet(scope);
                var parentValueWatch = function parentValueWatch(parentValue) {
                  if (!compare(parentValue, isolateBindingContext[scopeName])) {
                    // we are out of sync and need to copy
                    if (!compare(parentValue, lastValue)) {
                      // parent changed and it has precedence
                      isolateBindingContext[scopeName] = parentValue;
                    } else {
                      // if the parent can be assigned then do so
                      parentSet(scope, parentValue = isolateBindingContext[scopeName]);
                    }
                  }
                  return lastValue = parentValue;
                };
                parentValueWatch.$stateful = true;
                var unwatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
                isolateScope.$on('$destroy', unwatch);
                break;

              case '&':
                parentGet = $parse(attrs[attrName]);
                isolateBindingContext[scopeName] = function(locals) {
                  return parentGet(scope, locals);
                };
                break;
            }
          });
        }
        if (controllers) {
          forEach(controllers, function(controller) {
            controller();
          });
          controllers = null;
        }

        // PRELINKING
        for(i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);

        // POSTLINKING
        for(i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement) {
          var transcludeControllers;

          // No scope passed in:
          if (!isScope(scope)) {
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
        }
      }
    }

    function markDirectivesAsIsolate(directives) {
      // mark all directives as needing isolate scope.
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: true});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for(var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i<ii; i++) {
          try {
            directive = directives[i];
            if ( (maxPriority === undefined || maxPriority > directive.priority) &&
                 directive.restrict.indexOf(location) != -1) {
              if (startAttrName) {
                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
              }
              tDirectives.push(directive);
              match = directive;
            }
          } catch(e) { $exceptionHandler(e); }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for(var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i<ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr,
          $element = dst.$$element;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) != '$') {
          if (src[key] && src[key] !== value) {
            value += (key === 'style' ? ';' : ' ') + src[key];
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        if (key == 'class') {
          safeAddClass($element, value);
          dst['class'] = (dst['class'] ? dst['class'] + ' ' : '') + value;
        } else if (key == 'style') {
          $element.attr('style', $element.attr('style') + ';' + value);
          dst['style'] = (dst['style'] ? dst['style'] + ';' : '') + value;
          // `dst` will never contain hasOwnProperty as DOM parser won't let it.
          // You will get an "InvalidCharacterError: DOM Exception 5" error if you
          // have an attribute like "has-own-property" or "data-has-own-property", etc.
        } else if (key.charAt(0) != '$' && !dst.hasOwnProperty(key)) {
          dst[key] = value;
          dstAttr[key] = srcAttr[key];
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          // The fact that we have to copy and patch the directive seems wrong!
          derivedSyncDirective = extend({}, origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest($sce.getTrustedResourceUrl(templateUrl))
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  "Template for directive '{0}' must have exactly one root element. {1}",
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              markDirectivesAsIsolate(templateDirectives);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node == compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while(linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope);
          linkQueue.push(node);
          linkQueue.push(rootElement);
          linkQueue.push(childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }


    function assertNoDuplicate(what, previousDirective, directive, element) {
      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}, {1}] asking for {2} on: {3}',
            previousDirective.name, directive.name, what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch(type) {
      case 'svg':
      case 'math':
        var wrapper = document.createElement('div');
        wrapper.innerHTML = '<'+type+'>'+template+'</'+type+'>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedContext(node, attrNormalizedName) {
      if (attrNormalizedName == "srcdoc") {
        return $sce.HTML;
      }
      var tag = nodeName_(node);
      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
      if (attrNormalizedName == "xlinkHref" ||
          (tag == "form" && attrNormalizedName == "action") ||
          (tag != "img" && (attrNormalizedName == "src" ||
                            attrNormalizedName == "ngSrc"))) {
        return $sce.RESOURCE_URL;
      }
    }


    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
      var interpolateFn = $interpolate(value, true);

      // no interpolation found -> ignore
      if (!interpolateFn) return;


      if (name === "multiple" && nodeName_(node) === "select") {
        throw $compileMinErr("selmulti",
            "Binding to the 'multiple' attribute is not supported. Element: {0}",
            startingTag(node));
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = {}));

                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
                  throw $compileMinErr('nodomevents',
                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
                          "ng- versions (such as ng-click instead of onclick) instead.");
                }

                // If the attribute was removed, then we are done
                if (!attr[name]) {
                  return;
                }

                // we need to interpolate again, in case the attribute value has been updated
                // (e.g. by another directive's compile function)
                interpolateFn = $interpolate(attr[name], true, getTrustedContext(node, name),
                    ALL_OR_NOTHING_ATTRS[name] || allOrNothing);

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if(name === 'class' && newValue != oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for(i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] == firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // TODO(perf): what's this document fragment for? is it needed? can we at least reuse it?
      var fragment = document.createDocumentFragment();
      fragment.appendChild(firstElementToRemove);

      // Copy over user data (that includes Angular's $scope etc.). Don't copy private
      // data here because there's no public interface in jQuery to do that and copying over
      // event listeners (which is the main use of private data) wouldn't work anyway.
      jqLite(newNode).data(jqLite(firstElementToRemove).data());

      // Remove data of the replaced element. We cannot just call .remove()
      // on the element it since that would deallocate scope that is needed
      // for the new node. Instead, remove the data "manually".
      if (!jQuery) {
        delete jqLite.cache[firstElementToRemove[jqLite.expando]];
      } else {
        // jQuery 2.x doesn't expose the data storage. Use jQuery.cleanData to clean up after
        // the replaced element. The cleanData version monkey-patched by Angular would cause
        // the scope to be trashed and we do need the very same scope to work with the new
        // element. However, we cannot just cache the non-patched version and use it here as
        // that would break if another library patches the method after Angular does (one
        // example is jQuery UI). Instead, set a flag indicating scope destroying should be
        // skipped this one time.
        skipDestroyOnNextJQueryCleanData = true;
        jQuery.cleanData([firstElementToRemove]);
      }

      for (var k = 1, kk = elementsToRemove.length; k < kk; k++) {
        var element = elementsToRemove[k];
        jqLite(element).remove(); // must do this way to clean up expando
        fragment.appendChild(element);
        delete elementsToRemove[k];
      }

      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch(e) {
        $exceptionHandler(e, startingTag($element));
      }
    }
  }];
}

var PREFIX_REGEXP = /^(x[\:\-_]|data[\:\-_])/i;
/**
 * Converts all accepted directives format into proper directive name.
 * All of these will become 'myDirective':
 *   my:Directive
 *   my-directive
 *   x-my-directive
 *   data-my:directive
 *
 * Also there is special case for Moz prefix starting with upper case letter.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return camelCase(name.replace(PREFIX_REGEXP, ''));
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in Angular:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
){}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
){}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for(var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for(var j = 0; j < tokens2.length; j++) {
      if(token == tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT) {
      splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

/**
 * @ngdoc provider
 * @name $controllerProvider
 * @description
 * The {@link ng.$controller $controller service} is used by Angular to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {},
      globals = false,
      CNTRL_REG = /^(\S+)(\s+as\s+(\w+))?$/;


  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#allowGlobals
   * @description If called, allows `$controller` to find controller constructors on `window`
   */
  this.allowGlobals = function() {
    globals = true;
  };


  this.$get = ['$injector', '$window', function($injector, $window) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
     *      `window` object (not recommended)
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if(isString(expression)) {
        match = expression.match(CNTRL_REG),
        constructor = match[1],
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true) ||
                (globals ? getter($window, constructor, true) : undefined);

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        var Constructor = function() {};
        Constructor.prototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = new Constructor();

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return extend(function() {
          $injector.invoke(expression, instance, locals, constructor);
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider(){
  this.$get = ['$window', function(window){
    return jqLite(window.document);
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 *
 * @description
 * Any uncaught exception in angular expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * ```js
 *   angular.module('exceptionOverride', []).factory('$exceptionHandler', function () {
 *     return function (exception, cause) {
 *       exception.message += ' (caused by "' + cause + '")';
 *       throw exception;
 *     };
 *   });
 * ```
 *
 * This example will override the normal action of `$exceptionHandler`, to make angular
 * exceptions fail hard when they happen, instead of just logging to the console.
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = {}, key, val, i;

  if (!headers) return parsed;

  forEach(headers.split('\n'), function(line) {
    i = line.indexOf(':');
    key = lowercase(trim(line.substr(0, i)));
    val = trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with single an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj = isObject(headers) ? headers : undefined;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      return headersObj[lowercase(name)] || null;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers Http headers getter fn.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, fns) {
  if (isFunction(fns))
    return fns(data, headers);

  forEach(fns, function(fn) {
    data = fn(data, headers);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 * */
function $HttpProvider() {
  var JSON_START = /^\s*(\[|\{[^\{])/,
      JSON_END = /[\}\]]\s*$/,
      PROTECTION_PREFIX = /^\)\]\}',?\n/,
      APPLICATION_JSON = 'application/json',
      CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};

  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   **/
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [function defaultHttpResponseTransform(data, headers) {
      if (isString(data)) {
        // strip json vulnerability protection prefix
        data = data.replace(PROTECTION_PREFIX, '');
        var contentType = headers('Content-Type');
        if ((contentType && contentType.indexOf(APPLICATION_JSON) === 0) ||
            (JSON_START.test(data) && JSON_END.test(data))) {
          data = fromJson(data);
        }
      }
      return data;
    }],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specifed, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   **/
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  /**
   * Are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   */
  var interceptorFactories = this.interceptors = [];

  this.$get = ['$httpBackend', '$browser', '$cacheFactory', '$rootScope', '$q', '$injector',
      function($httpBackend, $browser, $cacheFactory, $rootScope, $q, $injector) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core Angular service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a configuration object —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}
     * with two $http specific methods: `success` and `error`.
     *
     * ```js
     *   // Simple GET request example :
     *   $http.get('/someUrl').
     *     success(function(data, status, headers, config) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }).
     *     error(function(data, status, headers, config) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     * ```js
     *   // Simple POST request example (passing data) :
     *   $http.post('/someUrl', {msg:'hello word!'}).
     *     success(function(data, status, headers, config) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }).
     *     error(function(data, status, headers, config) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * Since the returned value of calling the $http function is a `promise`, you can also use
     * the `then` method to register callbacks, and these callbacks will receive a single argument –
     * an object representing the response. See the API signature and type info below for more
     * details.
     *
     * A response status code between 200 and 299 is considered a success status and
     * will result in the success callback being called. Note that if the response is a redirect,
     * XMLHttpRequest will transparently follow it, meaning that the error callback will not be
     * called for such responses.
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests.
     *
     * ```js
     *   $http.get('/someUrl').success(successCallback);
     *   $http.post('/someUrl', data).success(successCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - `Accept: application/json, text/plain, * / *`
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w'
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`{function(data, headersGetter)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * Angular provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If JSON response is detected, deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * To enable caching, set the request configuration `cache` property to `true` (to use default
     * cache) or to a custom cache object (built with {@link ng.$cacheFactory `$cacheFactory`}).
     * When the cache is enabled, `$http` stores the response from the server in the specified
     * cache. The next time the same request is made, the response is served from the cache without
     * sending a request to the server.
     *
     * Note that even if the response is served from cache, delivery of the data is asynchronous in
     * the same way that real requests are.
     *
     * If there are multiple GET requests for the same URL that should be cached using the same
     * cache, but the cache is not populated yet, only one request to the server will be made and
     * the remaining requests will be fulfilled using the response from the first request.
     *
     * You can change the default cache to a new object (built with
     * {@link ng.$cacheFactory `$cacheFactory`}) by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property. All requests who set
     * their `cache` property to `true` will now use this cache object.
     *
     * If you set the default cache to `false` then only requests that specify their own custom
     * cache object will be cached.
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http `config` object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * Angular will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * Angular will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is a technique by which
     * an unauthorized site can gain your user's private data. Angular provides a mechanism
     * to counter XSRF. When performing XHR requests, the $http service reads a token from a cookie
     * (by default, `XSRF-TOKEN`) and sets it as an HTTP header (`X-XSRF-TOKEN`). Since only
     * JavaScript that runs on your domain could read the cookie, your server can be assured that
     * the XHR came from JavaScript running on your domain. The header will not be set for
     * cross-domain requests.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
     * that only JavaScript running on your domain could have sent the request. The token must be
     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
     * or the per-request config object.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be turned
     *      to `?key1=value1&key2=value2` after the url. If the value is not a string, it will be
     *      JSONified.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link #overriding-the-default-transformations-per-request Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body and headers and returns its transformed (typically deserialized) version.
     *      See {@link #overriding-the-default-transformations-per-request Overriding the Default Transformations}
     *    - **cache** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
     *      GET request, otherwise if a cache instance built with
     *      {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
     *      caching.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
     *
     * @returns {HttpPromise} Returns a {@link ng.$q promise} object with the
     *   standard `then` method and two http specific methods: `success` and `error`. The `then`
     *   method takes two arguments a success and an error callback which will be called with a
     *   response object. The `success` and `error` methods take a single argument - a function that
     *   will be called when the request succeeds or fails respectively. The arguments passed into
     *   these functions are destructured representation of the response object passed into the
     *   `then` method. The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with the transform
     *     functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80"/>
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            success(function(data, status) {
              $scope.status = status;
              $scope.data = data;
            }).
            error(function(data, status) {
              $scope.data = data || "Request failed";
              $scope.status = status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {
      var config = {
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse
      };
      var headers = mergeHeaders(requestConfig);

      extend(config, requestConfig);
      config.headers = headers;
      config.method = uppercase(config.method);

      var serverRequest = function(config) {
        headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
                delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData, headers).then(transformResponse, transformResponse);
      };

      var chain = [serverRequest, undefined];
      var promise = $q.when(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          chain.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          chain.push(interceptor.response, interceptor.responseError);
        }
      });

      while(chain.length) {
        var thenFn = chain.shift();
        var rejectFn = chain.shift();

        promise = promise.then(thenFn, rejectFn);
      }

      promise.success = function(fn) {
        promise.then(function(response) {
          fn(response.data, response.status, response.headers, config);
        });
        return promise;
      };

      promise.error = function(fn) {
        promise.then(null, function(response) {
          fn(response.data, response.status, response.headers, config);
        });
        return promise;
      };

      return promise;

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        if (!response.data) {
          resp.data = response.data;
        } else {
          resp.data = transformData(response.data, response.headers, config.transformResponse);
        }
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        execHeaders(reqHeaders);
        return reqHeaders;

        function execHeaders(headers) {
          var headerContent;

          forEach(headers, function(headerFn, header) {
            if (isFunction(headerFn)) {
              headerContent = headerFn();
              if (headerContent != null) {
                headers[header] = headerContent;
              } else {
                delete headers[header];
              }
            }
          });
        }
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request.
     *                     The name of the callback should be the string `JSON_CALLBACK`.
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object
      * @returns {HttpPromise} Future object
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend(config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend(config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData, reqHeaders) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          url = buildUrl(config.url, config.params);

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);


      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
              : isObject(defaults.cache) ? defaults.cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(removePendingReq, removePendingReq);
            return cachedResp;
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsSameOrigin(config.url)
            ? $browser.cookies()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType);
      }

      return promise;


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText) {
        // normalize internal statuses to 0
        status = Math.max(status, 0);

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText : statusText
        });
      }


      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, params) {
      if (!params) return url;
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value)) return;
        if (!isArray(value)) value = [value];

        forEach(value, function(v) {
          if (isObject(v)) {
            if (isDate(v)){
              v = v.toISOString();
            } else {
              v = toJson(v);
            }
          }
          parts.push(encodeUriQuery(key) + '=' +
                     encodeUriQuery(v));
        });
      });
      if(parts.length > 0) {
        url += ((url.indexOf('?') == -1) ? '?' : '&') + parts.join('&');
      }
      return url;
    }
  }];
}

function createXhr() {
    return new window.XMLHttpRequest();
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $window
 * @requires $document
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$window', '$document', function($browser, $window, $document) {
    return createHttpBackend($browser, createXhr, $browser.defer, $window.angular.callbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType) {
    $browser.$$incOutstandingRequestCount();
    url = url || $browser.url();

    if (lowercase(method) == 'jsonp') {
      var callbackId = '_' + (callbacks.counter++).toString(36);
      callbacks[callbackId] = function(data) {
        callbacks[callbackId].data = data;
        callbacks[callbackId].called = true;
      };

      var jsonpDone = jsonpReq(url.replace('JSON_CALLBACK', 'angular.callbacks.' + callbackId),
          callbackId, function(status, text) {
        completeRequest(callback, status, callbacks[callbackId].data, "", text);
        callbacks[callbackId] = noop;
      });
    } else {

      var xhr = createXhr();

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE8 & 9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText);
      };

      var requestError = function () {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '');
      };

      xhr.onerror = requestError;
      xhr.onabort = requestError;

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(post || null);
    }

    if (timeout > 0) {
      var timeoutId = $browserDefer(timeoutRequest, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(timeoutRequest);
    }


    function timeoutRequest() {
      jsonpDone && jsonpDone();
      xhr && xhr.abort();
    }

    function completeRequest(callback, status, response, headersString, statusText) {
      // cancel timeout and subsequent timeout promise resolution
      timeoutId && $browserDefer.cancel(timeoutId);
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText);
      $browser.$$completeOutstandingRequest(noop);
    }
  };

  function jsonpReq(url, callbackId, done) {
    // we can't use jQuery/jqLite here because jQuery does crazy shit with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = "text/javascript";
    script.src = url;
    script.async = true;

    callback = function(event) {
      removeEventListenerFn(script, "load", callback);
      removeEventListenerFn(script, "error", callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = "unknown";

      if (event) {
        if (event.type === "load" && !callbacks[callbackId].called) {
          event = { type: "error" };
        }
        text = event.type;
        status = event.type === "error" ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    addEventListenerFn(script, "load", callback);
    addEventListenerFn(script, "error", callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = minErr('$interpolate');

/**
 * @ngdoc provider
 * @name $interpolateProvider
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * @example
<example module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-app="App" ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value){
    if (value) {
      startSymbol = value;
      return this;
    } else {
      return startSymbol;
    }
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value){
    if (value) {
      endSymbol = value;
      return this;
    } else {
      return endSymbol;
    }
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'Angular'}).toEqual('Hello ANGULAR!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'Angular';
     *   expect(exp(context)).toEqual('Hello Angular!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * ####Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example>
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns = [],
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [];

      while(index < textLength) {
        if ( ((startIndex = text.indexOf(startSymbol, index)) != -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1) ) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          parseFns.push($parse(exp, parseStringifyInterceptor));
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push('');
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for iframe[src], object[src], etc., we ensure that the value
      // that's used is assigned or constructed by some JS code somewhere that is more testable or
      // make it obvious that you bound the value to some user controlled value.  This helps reduce
      // the load when auditing for XSS issues.
      if (trustedContext && concat.length > 1) {
          throw $interpolateMinErr('noconcat',
              "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
              "interpolations that concatenate multiple expressions when a trusted value is " +
              "required.  See http://docs.angularjs.org/api/ng.$sce", text);
      }

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for(var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }
          return concat.join('');
        };

        var getValue = function (value) {
          return trustedContext ?
            $sce.getTrusted(trustedContext, value) :
            $sce.valueOf(value);
        };

        var stringify = function (value) {
          if (value == null) { // null || undefined
            return '';
          }
          switch (typeof value) {
            case 'string':
              break;
            case 'number':
              value = '' + value;
              break;
            default:
              value = toJson(value);
          }

          return value;
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch(err) {
              var newErr = $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text,
                  err.toString());
              $exceptionHandler(newErr);
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function (scope, listener, objectEquality) {
            var lastValue;
            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              if (isFunction(listener)) {
                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              }
              lastValue = currValue;
            }, objectEquality);
          }
        });
      }

      function unescapeText(text) {
        return text.replace(escapedStartRegexp, startSymbol).
          replace(escapedEndRegexp, endSymbol);
      }

      function parseStringifyInterceptor(value) {
        try {
          return stringify(getValue(value));
        } catch(err) {
          var newErr = $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text,
            err.toString());
          $exceptionHandler(newErr);
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

function $IntervalProvider() {
  this.$get = ['$rootScope', '$window', '$q', '$$q',
       function($rootScope,   $window,   $q,   $$q) {
    var intervals = {};


     /**
      * @ngdoc service
      * @name $interval
      *
      * @description
      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
      * milliseconds.
      *
      * The return value of registering an interval function is a promise. This promise will be
      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
      * run indefinitely if `count` is not defined. The value of the notification will be the
      * number of iterations that have run.
      * To cancel an interval, call `$interval.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
      * time.
      *
      * <div class="alert alert-warning">
      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
      * with them.  In particular they are not automatically destroyed when a controller's scope or a
      * directive's element are destroyed.
      * You should take this into consideration and make sure to always cancel the interval at the
      * appropriate moment.  See the example below for more details on how and when to do this.
      * </div>
      *
      * @param {function()} fn A function that should be called repeatedly.
      * @param {number} delay Number of milliseconds between each function call.
      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
      *   indefinitely.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @returns {promise} A promise which will be notified on each iteration.
      *
      * @example
      * <example module="intervalExample">
      * <file name="index.html">
      *   <script>
      *     angular.module('intervalExample', [])
      *       .controller('ExampleController', ['$scope', '$interval',
      *         function($scope, $interval) {
      *           $scope.format = 'M/d/yy h:mm:ss a';
      *           $scope.blood_1 = 100;
      *           $scope.blood_2 = 120;
      *
      *           var stop;
      *           $scope.fight = function() {
      *             // Don't start a new fight if we are already fighting
      *             if ( angular.isDefined(stop) ) return;
      *
      *           stop = $interval(function() {
      *             if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
      *               $scope.blood_1 = $scope.blood_1 - 3;
      *               $scope.blood_2 = $scope.blood_2 - 4;
      *             } else {
      *               $scope.stopFight();
      *             }
      *           }, 100);
      *         };
      *
      *         $scope.stopFight = function() {
      *           if (angular.isDefined(stop)) {
      *             $interval.cancel(stop);
      *             stop = undefined;
      *           }
      *         };
      *
      *         $scope.resetFight = function() {
      *           $scope.blood_1 = 100;
      *           $scope.blood_2 = 120;
      *         };
      *
      *         $scope.$on('$destroy', function() {
      *           // Make sure that the interval is destroyed too
      *           $scope.stopFight();
      *         });
      *       }])
      *       // Register the 'myCurrentTime' directive factory method.
      *       // We inject $interval and dateFilter service since the factory method is DI.
      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
      *         function($interval, dateFilter) {
      *           // return the directive link function. (compile function not needed)
      *           return function(scope, element, attrs) {
      *             var format,  // date format
      *                 stopTime; // so that we can cancel the time updates
      *
      *             // used to update the UI
      *             function updateTime() {
      *               element.text(dateFilter(new Date(), format));
      *             }
      *
      *             // watch the expression, and update the UI on change.
      *             scope.$watch(attrs.myCurrentTime, function(value) {
      *               format = value;
      *               updateTime();
      *             });
      *
      *             stopTime = $interval(updateTime, 1000);
      *
      *             // listen on DOM destroy (removal) event, and cancel the next UI update
      *             // to prevent updating time after the DOM element was removed.
      *             element.on('$destroy', function() {
      *               $interval.cancel(stopTime);
      *             });
      *           }
      *         }]);
      *   </script>
      *
      *   <div>
      *     <div ng-controller="ExampleController">
      *       Date format: <input ng-model="format"> <hr/>
      *       Current time is: <span my-current-time="format"></span>
      *       <hr/>
      *       Blood 1 : <font color='red'>{{blood_1}}</font>
      *       Blood 2 : <font color='red'>{{blood_2}}</font>
      *       <button type="button" data-ng-click="fight()">Fight</button>
      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
      *     </div>
      *   </div>
      *
      * </file>
      * </example>
      */
    function interval(fn, delay, count, invokeApply) {
      var setInterval = $window.setInterval,
          clearInterval = $window.clearInterval,
          iteration = 0,
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise;

      count = isDefined(count) ? count : 0;

      promise.then(null, null, fn);

      promise.$$intervalId = setInterval(function tick() {
        deferred.notify(iteration++);

        if (count > 0 && iteration >= count) {
          deferred.resolve(iteration);
          clearInterval(promise.$$intervalId);
          delete intervals[promise.$$intervalId];
        }

        if (!skipApply) $rootScope.$apply();

      }, delay);

      intervals[promise.$$intervalId] = deferred;

      return promise;
    }


     /**
      * @ngdoc method
      * @name $interval#cancel
      *
      * @description
      * Cancels a task associated with the `promise`.
      *
      * @param {promise} promise returned by the `$interval` function.
      * @returns {boolean} Returns `true` if the task was successfully canceled.
      */
    interval.cancel = function(promise) {
      if (promise && promise.$$intervalId in intervals) {
        intervals[promise.$$intervalId].reject('canceled');
        $window.clearInterval(promise.$$intervalId);
        delete intervals[promise.$$intervalId];
        return true;
      }
      return false;
    };

    return interval;
  }];
}

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various Angular components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */
function $LocaleProvider(){
  this.$get = function() {
    return {
      id: 'en-us',

      NUMBER_FORMATS: {
        DECIMAL_SEP: '.',
        GROUP_SEP: ',',
        PATTERNS: [
          { // Decimal Pattern
            minInt: 1,
            minFrac: 0,
            maxFrac: 3,
            posPre: '',
            posSuf: '',
            negPre: '-',
            negSuf: '',
            gSize: 3,
            lgSize: 3
          },{ //Currency Pattern
            minInt: 1,
            minFrac: 2,
            maxFrac: 2,
            posPre: '\u00A4',
            posSuf: '',
            negPre: '(\u00A4',
            negSuf: ')',
            gSize: 3,
            lgSize: 3
          }
        ],
        CURRENCY_SYM: '$'
      },

      DATETIME_FORMATS: {
        MONTH:
            'January,February,March,April,May,June,July,August,September,October,November,December'
            .split(','),
        SHORTMONTH:  'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec'.split(','),
        DAY: 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday'.split(','),
        SHORTDAY: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat'.split(','),
        AMPMS: ['AM','PM'],
        medium: 'MMM d, y h:mm:ss a',
        short: 'M/d/yy h:mm a',
        fullDate: 'EEEE, MMMM d, y',
        longDate: 'MMMM d, y',
        mediumDate: 'MMM d, y',
        shortDate: 'M/d/yy',
        mediumTime: 'h:mm:ss a',
        shortTime: 'h:mm a'
      },

      pluralCat: function(num) {
        if (num === 1) {
          return 'one';
        }
        return 'other';
      }
    };
  };
}

var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = encodeUriSegment(segments[i]);
  }

  return segments.join('/');
}

function parseAbsoluteUrl(absoluteUrl, locationObj, appBase) {
  var parsedUrl = urlResolve(absoluteUrl, appBase);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = int(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}


function parseAppUrl(relativeUrl, locationObj, appBase) {
  var prefixed = (relativeUrl.charAt(0) !== '/');
  if (prefixed) {
    relativeUrl = '/' + relativeUrl;
  }
  var match = urlResolve(relativeUrl, appBase);
  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
      match.pathname.substring(1) : match.pathname);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}


/**
 *
 * @param {string} begin
 * @param {string} whole
 * @returns {string} returns text from whole after begin or undefined if it does not begin with
 *                   expected string.
 */
function beginsWith(begin, whole) {
  if (whole.indexOf(begin) === 0) {
    return whole.substr(begin.length);
  }
}


function stripHash(url) {
  var index = url.indexOf('#');
  return index == -1 ? url : url.substr(0, index);
}


function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents an url
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} basePrefix url path prefix
 */
function LocationHtml5Url(appBase, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  var appBaseNoFile = stripFile(appBase);
  parseAbsoluteUrl(appBase, this, appBase);


  /**
   * Parse given html5 (regular) url string into properties
   * @param {string} newAbsoluteUrl HTML5 url
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = beginsWith(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this, appBase);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  /**
   * Compose url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;

    if ( (appUrl = beginsWith(appBase, url)) !== undefined ) {
      prevAppUrl = appUrl;
      if ( (appUrl = beginsWith(basePrefix, appUrl)) !== undefined ) {
        rewrittenUrl = appBaseNoFile + (beginsWith('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if ( (appUrl = beginsWith(appBaseNoFile, url)) !== undefined ) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile == url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents url
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, hashPrefix) {
  var appBaseNoFile = stripFile(appBase);

  parseAbsoluteUrl(appBase, this, appBase);


  /**
   * Parse given hashbang url into properties
   * @param {string} url Hashbang url
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = beginsWith(appBase, url) || beginsWith(appBaseNoFile, url);
    var withoutHashUrl = withoutBaseUrl.charAt(0) == '#'
        ? beginsWith(hashPrefix, withoutBaseUrl)
        : (this.$$html5)
          ? withoutBaseUrl
          : '';

    if (!isString(withoutHashUrl)) {
      throw $locationMinErr('ihshprfx', 'Invalid url "{0}", missing hash prefix "{1}".', url,
          hashPrefix);
    }
    parseAppUrl(withoutHashUrl, this, appBase);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of Angular, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName (path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (url.indexOf(base) === 0) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  /**
   * Compose hashbang url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if(stripHash(appBase) == stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents url
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  var appBaseNoFile = stripFile(appBase);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if ( appBase == stripHash(url) ) {
      rewrittenUrl = url;
    } else if ( (appUrl = beginsWith(appBaseNoFile, url)) ) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if ( appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    // include hashPrefix in $$absUrl when $$url is empty so IE8 & 9 do not reload page because of removal of '#'
    this.$$absUrl = appBase + hashPrefix + this.$$url;
  };

}


var locationPrototype = {

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full url representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   * @return {string} full url
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url))
      return this.$$url;

    var match = PATH_MATCH.exec(url);
    if (match[1]) this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1]) this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current url.
   *
   * @return {string} protocol of current url
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current url.
   *
   * @return {string} host of current url.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current url.
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current url when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   * @param {(string|number)=} path New path
   * @return {string} path
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) == '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current url when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // => $location
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the url.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Return hash fragment when called without any parameter.
   *
   * Change hash fragment when called with parameter and return `$location`.
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during current `$digest` will be replacing current history
   * record, instead of adding new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function (Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length)
      return this.$$state;

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;

    return this;
  };
});


function locationGetter(property) {
  return function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return function(value) {
    if (isUndefined(value))
      return this[property];

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider(){
  var hashPrefix = '',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables url rewriting for relative links.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement',
      function( $rootScope,   $browser,   $sniffer,   $rootElement) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          "$location in HTML5 mode requires a <base> tag to be present!");
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    $location = new LocationMode(appBase, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.which == 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the angular application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() != $browser.url()) {
            $rootScope.$apply();
            // hack to work around FF6 bug 684208 when scenario runner clicks on links
            window.angular['ff-684208-preventDefault'] = true;
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if ($location.absUrl() != initialUrl) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {
      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;

        $location.$$parse(newUrl);
        $location.$$state = newState;
        if ($rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      var oldUrl = $browser.url();
      var oldState = $browser.state();
      var currentReplace = $location.$$replace;
      var urlOrStateChanged = oldUrl !== $location.absUrl() ||
        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

      if (initializing || urlOrStateChanged) {
        initializing = false;

        $rootScope.$evalAsync(function() {
          if ($rootScope.$broadcast('$locationChangeStart', $location.absUrl(), oldUrl,
              $location.$$state, oldState).defaultPrevented) {
            $location.$$parse(oldUrl);
            $location.$$state = oldState;
          } else {
            if (urlOrStateChanged) {
              setBrowserUrlWithFallback($location.absUrl(), currentReplace,
                                        oldState === $location.$$state ? null : $location.$$state);
            }
            afterLocationChange(oldUrl, oldState);
          }
        });
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         Message:
         <input type="text" ng-model="message"/>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider(){
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
    return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window){
    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function () {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      }())
    };

    function formatError(arg) {
      if (arg instanceof Error) {
        if (arg.stack) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop,
          hasApply = false;

      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
      // The reason behind this is that console.log has type "object" in IE8...
      try {
        hasApply = !!logFn.apply;
      } catch (e) {}

      if (hasApply) {
        return function() {
          var args = [];
          forEach(arguments, function(arg) {
            args.push(formatError(arg));
          });
          return logFn.apply(console, args);
        };
      }

      // we are IE which either doesn't have window.console => this is noop and we do nothing,
      // or we are IE where console.log doesn't have apply so we log at least first 2 args
      return function(arg1, arg2) {
        logFn(arg1, arg2 == null ? '' : arg2);
      };
    }
  }];
}

var $parseMinErr = minErr('$parse');

// Sandboxing Angular Expressions
// ------------------------------
// Angular expressions are generally considered safe because these expressions only have direct
// access to $scope and locals. However, one can obtain the ability to execute arbitrary JS code by
// obtaining a reference to native JS functions such as the Function constructor.
//
// As an example, consider the following Angular expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
// against the expression language, but not to prevent exploits that were enabled by exposing
// sensitive JavaScript or browser apis on Scope. Exposing such objects on a Scope is never a good
// practice and therefore we are not even trying to protect against interaction with an object
// explicitly exposed in this way.
//
// In general, it is not possible to access a Window object from an angular expression unless a
// window or some DOM object that has a reference to window is published onto a Scope.
// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
// native objects.


function ensureSafeMemberName(name, fullExpression) {
  if (name === "__defineGetter__" || name === "__defineSetter__"
      || name === "__lookupGetter__" || name === "__lookupSetter__"
      || name === "__proto__") {
    throw $parseMinErr('isecfld',
        'Attempting to access a disallowed field in Angular expressions! '
        +'Expression: {0}', fullExpression);
  }
  return name;
}

function ensureSafeObject(obj, fullExpression) {
  // nifty check if obj is Function that is fast and works across iframes and other contexts
  if (obj) {
    if (obj.constructor === obj) {
      throw $parseMinErr('isecfn',
          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// isWindow(obj)
        obj.window === obj) {
      throw $parseMinErr('isecwindow',
          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// isElement(obj)
        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
      throw $parseMinErr('isecdom',
          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// block Object so that we can't get hold of dangerous Object.* methods
        obj === Object) {
      throw $parseMinErr('isecobj',
          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    }
  }
  return obj;
}

var CALL = Function.prototype.call;
var APPLY = Function.prototype.apply;
var BIND = Function.prototype.bind;

function ensureSafeFunction(obj, fullExpression) {
  if (obj) {
    if (obj.constructor === obj) {
      throw $parseMinErr('isecfn',
        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
        fullExpression);
    } else if (obj === CALL || obj === APPLY || obj === BIND) {
      throw $parseMinErr('isecff',
        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
        fullExpression);
    }
  }
}

//Keyword constants
var CONSTANTS = createMap();
forEach({
  'null': function() { return null; },
  'true': function() { return true; },
  'false': function() { return false; },
  'undefined': function() {}
}, function(constantGetter, name) {
  constantGetter.constant = constantGetter.literal = constantGetter.sharedGetter = true;
  CONSTANTS[name] = constantGetter;
});

//Not quite a constant, but can be lex/parsed the same
CONSTANTS['this'] = function(self) { return self; };
CONSTANTS['this'].sharedGetter = true;


//Operators - will be wrapped by binaryFn/unaryFn/assignment/filter
var OPERATORS = extend(createMap(), {
    '+':function(self, locals, a,b){
      a=a(self, locals); b=b(self, locals);
      if (isDefined(a)) {
        if (isDefined(b)) {
          return a + b;
        }
        return a;
      }
      return isDefined(b)?b:undefined;},
    '-':function(self, locals, a,b){
          a=a(self, locals); b=b(self, locals);
          return (isDefined(a)?a:0)-(isDefined(b)?b:0);
        },
    '*':function(self, locals, a,b){return a(self, locals)*b(self, locals);},
    '/':function(self, locals, a,b){return a(self, locals)/b(self, locals);},
    '%':function(self, locals, a,b){return a(self, locals)%b(self, locals);},
    '===':function(self, locals, a, b){return a(self, locals)===b(self, locals);},
    '!==':function(self, locals, a, b){return a(self, locals)!==b(self, locals);},
    '==':function(self, locals, a,b){return a(self, locals)==b(self, locals);},
    '!=':function(self, locals, a,b){return a(self, locals)!=b(self, locals);},
    '<':function(self, locals, a,b){return a(self, locals)<b(self, locals);},
    '>':function(self, locals, a,b){return a(self, locals)>b(self, locals);},
    '<=':function(self, locals, a,b){return a(self, locals)<=b(self, locals);},
    '>=':function(self, locals, a,b){return a(self, locals)>=b(self, locals);},
    '&&':function(self, locals, a,b){return a(self, locals)&&b(self, locals);},
    '||':function(self, locals, a,b){return a(self, locals)||b(self, locals);},
    '!':function(self, locals, a){return !a(self, locals);},

    //Tokenized as operators but parsed as assignment/filters
    '=':true,
    '|':true
});
var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function (options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function (text) {
    this.text = text;
    this.index = 0;
    this.ch = undefined;
    this.tokens = [];

    while (this.index < this.text.length) {
      this.ch = this.text.charAt(this.index);
      if (this.is('"\'')) {
        this.readString(this.ch);
      } else if (this.isNumber(this.ch) || this.is('.') && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdent(this.ch)) {
        this.readIdent();
      } else if (this.is('(){}[].,;:?')) {
        this.tokens.push({
          index: this.index,
          text: this.ch
        });
        this.index++;
      } else if (this.isWhitespace(this.ch)) {
        this.index++;
      } else {
        var ch2 = this.ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var fn = OPERATORS[this.ch];
        var fn2 = OPERATORS[ch2];
        var fn3 = OPERATORS[ch3];
        if (fn3) {
          this.tokens.push({index: this.index, text: ch3, fn: fn3});
          this.index += 3;
        } else if (fn2) {
          this.tokens.push({index: this.index, text: ch2, fn: fn2});
          this.index += 2;
        } else if (fn) {
          this.tokens.push({
            index: this.index,
            text: this.ch,
            fn: fn
          });
          this.index += 1;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(chars) {
    return chars.indexOf(this.ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9');
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdent: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch == '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch == 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) == 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) == 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    number = 1 * number;
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      fn: function() { return number; }
    });
  },

  readIdent: function() {
    var expression = this.text;

    var ident = '';
    var start = this.index;

    var lastDot, peekIndex, methodName, ch;

    while (this.index < this.text.length) {
      ch = this.text.charAt(this.index);
      if (ch === '.' || this.isIdent(ch) || this.isNumber(ch)) {
        if (ch === '.') lastDot = this.index;
        ident += ch;
      } else {
        break;
      }
      this.index++;
    }

    //check if the identifier ends with . and if so move back one char
    if (lastDot && ident[ident.length - 1] === '.') {
      this.index--;
      ident = ident.slice(0, -1);
      lastDot = ident.lastIndexOf('.');
      if (lastDot === -1) {
        lastDot = undefined;
      }
    }

    //check if this is not a method invocation and if it is back out to last dot
    if (lastDot) {
      peekIndex = this.index;
      while (peekIndex < this.text.length) {
        ch = this.text.charAt(peekIndex);
        if (ch === '(') {
          methodName = ident.substr(lastDot - start + 1);
          ident = ident.substr(0, lastDot - start);
          this.index = peekIndex;
          break;
        }
        if (this.isWhitespace(ch)) {
          peekIndex++;
        } else {
          break;
        }
      }
    }

    this.tokens.push({
      index: start,
      text: ident,
      fn: CONSTANTS[ident] || getterFn(ident, this.options, expression)
    });

    if (methodName) {
      this.tokens.push({
        index: lastDot,
        text: '.'
      });
      this.tokens.push({
        index: lastDot + 1,
        text: methodName
      });
    }
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i))
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          string: string,
          constant: true,
          fn: function() { return string; }
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};


function isConstant(exp) {
  return exp.constant;
}

/**
 * @constructor
 */
var Parser = function (lexer, $filter, options) {
  this.lexer = lexer;
  this.$filter = $filter;
  this.options = options;
};

Parser.ZERO = extend(function () {
  return 0;
}, {
  sharedGetter: true,
  constant: true
});

Parser.prototype = {
  constructor: Parser,

  parse: function (text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.statements();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    value.literal = !!value.literal;
    value.constant = !!value.constant;

    return value;
  },

  primary: function () {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else {
      var token = this.expect();
      primary = token.fn;
      if (!primary) {
        this.throwError('not a primary expression', token);
      }
      if (token.constant) {
        primary.constant = true;
        primary.literal = true;
      }
    }

    var next, context;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = this.functionCall(primary, context);
        context = null;
      } else if (next.text === '[') {
        context = primary;
        primary = this.objectIndex(primary);
      } else if (next.text === '.') {
        context = primary;
        primary = this.fieldAccess(primary);
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  peekToken: function() {
    if (this.tokens.length === 0)
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    if (this.tokens.length > 0) {
      var token = this.tokens[0];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4){
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  consume: function(e1){
    if (!this.expect(e1)) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
  },

  unaryFn: function(fn, right) {
    return extend(function $parseUnaryFn(self, locals) {
      return fn(self, locals, right);
    }, {
      constant:right.constant,
      inputs: [right]
    });
  },

  binaryFn: function(left, fn, right, isBranching) {
    return extend(function $parseBinaryFn(self, locals) {
      return fn(self, locals, left, right);
    }, {
      constant: left.constant && right.constant,
      inputs: !isBranching && [left, right]
    });
  },

  statements: function() {
    var statements = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        statements.push(this.filterChain());
      if (!this.expect(';')) {
        // optimize for the common case where there is only one statement.
        // TODO(size): maybe we should not support multiple statements?
        return (statements.length === 1)
            ? statements[0]
            : function $parseStatements(self, locals) {
                var value;
                for (var i = 0, ii = statements.length; i < ii; i++) {
                  value = statements[i](self, locals);
                }
                return value;
              };
      }
    }
  },

  filterChain: function() {
    var left = this.expression();
    var token;
    while ((token = this.expect('|'))) {
      left = this.filter(left);
    }
    return left;
  },

  filter: function(inputFn) {
    var token = this.expect();
    var fn = this.$filter(token.text);
    var argsFn;
    var args;

    if (this.peek(':')) {
      argsFn = [];
      args = []; // we can safely reuse the array
      while (this.expect(':')) {
        argsFn.push(this.expression());
      }
    }

    var inputs = [inputFn].concat(argsFn || []);

    return extend(function $parseFilter(self, locals) {
      var input = inputFn(self, locals);
      if (args) {
        args[0] = input;

        var i = argsFn.length;
        while (i--) {
          args[i + 1] = argsFn[i](self, locals);
        }

        return fn.apply(undefined, args);
      }

      return fn(input);
    }, {
      constant: !fn.$stateful && inputs.every(isConstant),
      inputs: !fn.$stateful && inputs
    });
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var left = this.ternary();
    var right;
    var token;
    if ((token = this.expect('='))) {
      if (!left.assign) {
        this.throwError('implies assignment but [' +
            this.text.substring(0, token.index) + '] can not be assigned to', token);
      }
      right = this.ternary();
      return extend(function $parseAssignment(scope, locals) {
        return left.assign(scope, right(scope, locals), locals);
      }, {
        inputs: [left, right]
      });
    }
    return left;
  },

  ternary: function() {
    var left = this.logicalOR();
    var middle;
    var token;
    if ((token = this.expect('?'))) {
      middle = this.assignment();
      if ((token = this.expect(':'))) {
        var right = this.assignment();

        return extend(function $parseTernary(self, locals){
          return left(self, locals) ? middle(self, locals) : right(self, locals);
        }, {
          constant: left.constant && middle.constant && right.constant
        });

      } else {
        this.throwError('expected :', token);
      }
    }

    return left;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    var token;
    while ((token = this.expect('||'))) {
      left = this.binaryFn(left, token.fn, this.logicalAND(), true);
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    var token;
    if ((token = this.expect('&&'))) {
      left = this.binaryFn(left, token.fn, this.logicalAND(), true);
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    if ((token = this.expect('==','!=','===','!=='))) {
      left = this.binaryFn(left, token.fn, this.equality());
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    if ((token = this.expect('<', '>', '<=', '>='))) {
      left = this.binaryFn(left, token.fn, this.relational());
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = this.binaryFn(left, token.fn, this.multiplicative());
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = this.binaryFn(left, token.fn, this.unary());
    }
    return left;
  },

  unary: function() {
    var token;
    if (this.expect('+')) {
      return this.primary();
    } else if ((token = this.expect('-'))) {
      return this.binaryFn(Parser.ZERO, token.fn, this.unary());
    } else if ((token = this.expect('!'))) {
      return this.unaryFn(token.fn, this.unary());
    } else {
      return this.primary();
    }
  },

  fieldAccess: function(object) {
    var expression = this.text;
    var field = this.expect().text;
    var getter = getterFn(field, this.options, expression);

    return extend(function $parseFieldAccess(scope, locals, self) {
      return getter(self || object(scope, locals));
    }, {
      assign: function(scope, value, locals) {
        var o = object(scope, locals);
        if (!o) object.assign(scope, o = {});
        return setter(o, field, value, expression);
      }
    });
  },

  objectIndex: function(obj) {
    var expression = this.text;

    var indexFn = this.expression();
    this.consume(']');

    return extend(function $parseObjectIndex(self, locals) {
      var o = obj(self, locals),
          i = indexFn(self, locals),
          v;

      ensureSafeMemberName(i, expression);
      if (!o) return undefined;
      v = ensureSafeObject(o[i], expression);
      return v;
    }, {
      assign: function(self, value, locals) {
        var key = ensureSafeMemberName(indexFn(self, locals), expression);
        // prevent overwriting of Function.constructor which would break ensureSafeObject check
        var o = ensureSafeObject(obj(self, locals), expression);
        if (!o) obj.assign(self, o = {});
        return o[key] = value;
      }
    });
  },

  functionCall: function(fnGetter, contextGetter) {
    var argsFn = [];
    if (this.peekToken().text !== ')') {
      do {
        argsFn.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(')');

    var expressionText = this.text;
    // we can safely reuse the array across invocations
    var args = argsFn.length ? [] : null;

    return function $parseFunctionCall(scope, locals) {
      var context = contextGetter ? contextGetter(scope, locals) : scope;
      var fn = fnGetter(scope, locals, context) || noop;

      if (args) {
        var i = argsFn.length;
        while (i--) {
          args[i] = ensureSafeObject(argsFn[i](scope, locals), expressionText);
        }
      }

      ensureSafeObject(context, expressionText);
      ensureSafeFunction(fn, expressionText);

      // IE stupidity! (IE doesn't have apply for some native functions)
      var v = fn.apply
            ? fn.apply(context, args)
            : fn(args[0], args[1], args[2], args[3], args[4]);

      return ensureSafeObject(v, expressionText);
    };
  },

  // This is used with json array declaration
  arrayDeclaration: function () {
    var elementFns = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        var elementFn = this.expression();
        elementFns.push(elementFn);
      } while (this.expect(','));
    }
    this.consume(']');

    return extend(function $parseArrayLiteral(self, locals) {
      var array = [];
      for (var i = 0, ii = elementFns.length; i < ii; i++) {
        array.push(elementFns[i](self, locals));
      }
      return array;
    }, {
      literal: true,
      constant: elementFns.every(isConstant),
      inputs: elementFns
    });
  },

  object: function () {
    var keys = [], valueFns = [];
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        var token = this.expect();
        keys.push(token.string || token.text);
        this.consume(':');
        var value = this.expression();
        valueFns.push(value);
      } while (this.expect(','));
    }
    this.consume('}');

    return extend(function $parseObjectLiteral(self, locals) {
      var object = {};
      for (var i = 0, ii = valueFns.length; i < ii; i++) {
        object[keys[i]] = valueFns[i](self, locals);
      }
      return object;
    }, {
      literal: true,
      constant: valueFns.every(isConstant),
      inputs: valueFns
    });
  }
};


//////////////////////////////////////////////////
// Parser helper functions
//////////////////////////////////////////////////

function setter(obj, path, setValue, fullExp) {
  ensureSafeObject(obj, fullExp);

  var element = path.split('.'), key;
  for (var i = 0; element.length > 1; i++) {
    key = ensureSafeMemberName(element.shift(), fullExp);
    var propertyObj = ensureSafeObject(obj[key], fullExp);
    if (!propertyObj) {
      propertyObj = {};
      obj[key] = propertyObj;
    }
    obj = propertyObj;
  }
  key = ensureSafeMemberName(element.shift(), fullExp);
  ensureSafeObject(obj[key], fullExp);
  obj[key] = setValue;
  return setValue;
}

var getterFnCache = createMap();

/**
 * Implementation of the "Black Hole" variant from:
 * - http://jsperf.com/angularjs-parse-getter/4
 * - http://jsperf.com/path-evaluation-simplified/7
 */
function cspSafeGetterFn(key0, key1, key2, key3, key4, fullExp) {
  ensureSafeMemberName(key0, fullExp);
  ensureSafeMemberName(key1, fullExp);
  ensureSafeMemberName(key2, fullExp);
  ensureSafeMemberName(key3, fullExp);
  ensureSafeMemberName(key4, fullExp);

  return function cspSafeGetter(scope, locals) {
    var pathVal = (locals && locals.hasOwnProperty(key0)) ? locals : scope;

    if (pathVal == null) return pathVal;
    pathVal = pathVal[key0];

    if (!key1) return pathVal;
    if (pathVal == null) return undefined;
    pathVal = pathVal[key1];

    if (!key2) return pathVal;
    if (pathVal == null) return undefined;
    pathVal = pathVal[key2];

    if (!key3) return pathVal;
    if (pathVal == null) return undefined;
    pathVal = pathVal[key3];

    if (!key4) return pathVal;
    if (pathVal == null) return undefined;
    pathVal = pathVal[key4];

    return pathVal;
  };
}

function getterFn(path, options, fullExp) {
  var fn = getterFnCache[path];

  if (fn) return fn;

  var pathKeys = path.split('.'),
      pathKeysLength = pathKeys.length;

  // http://jsperf.com/angularjs-parse-getter/6
  if (options.csp) {
    if (pathKeysLength < 6) {
      fn = cspSafeGetterFn(pathKeys[0], pathKeys[1], pathKeys[2], pathKeys[3], pathKeys[4], fullExp);
    } else {
      fn = function cspSafeGetter(scope, locals) {
        var i = 0, val;
        do {
          val = cspSafeGetterFn(pathKeys[i++], pathKeys[i++], pathKeys[i++], pathKeys[i++],
                                pathKeys[i++], fullExp)(scope, locals);

          locals = undefined; // clear after first iteration
          scope = val;
        } while (i < pathKeysLength);
        return val;
      };
    }
  } else {
    var code = '';
    forEach(pathKeys, function(key, index) {
      ensureSafeMemberName(key, fullExp);
      code += 'if(s == null) return undefined;\n' +
              's='+ (index
                      // we simply dereference 's' on any .dot notation
                      ? 's'
                      // but if we are first then we check locals first, and if so read it first
                      : '((l&&l.hasOwnProperty("' + key + '"))?l:s)') + '.' + key + ';\n';
    });
    code += 'return s;';

    /* jshint -W054 */
    var evaledFnGetter = new Function('s', 'l', code); // s=scope, l=locals
    /* jshint +W054 */
    evaledFnGetter.toString = valueFn(code);

    fn = evaledFnGetter;
  }

  fn.sharedGetter = true;
  fn.assign = function(self, value) {
    return setter(self, path, value, path);
  };
  getterFnCache[path] = fn;
  return fn;
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts Angular {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'angular'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('angular');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cache = createMap();

  var $parseOptions = {
    csp: false
  };


  this.$get = ['$filter', '$sniffer', function($filter, $sniffer) {
    $parseOptions.csp = $sniffer.csp;

    function wrapSharedExpression(exp) {
      var wrapped = exp;

      if (exp.sharedGetter) {
        wrapped = function $parseWrapper(self, locals) {
          return exp(self, locals);
        };
        wrapped.literal = exp.literal;
        wrapped.constant = exp.constant;
        wrapped.assign = exp.assign;
      }

      return wrapped;
    }

    return function $parse(exp, interceptorFn) {
      var parsedExpression, oneTime, cacheKey;

      switch (typeof exp) {
        case 'string':
          cacheKey = exp = exp.trim();

          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
              oneTime = true;
              exp = exp.substring(2);
            }

            var lexer = new Lexer($parseOptions);
            var parser = new Parser(lexer, $filter, $parseOptions);
            parsedExpression = parser.parse(exp);

            if (parsedExpression.constant) {
              parsedExpression.$$watchDelegate = constantWatchDelegate;
            } else if (oneTime) {
              //oneTime is not part of the exp passed to the Parser so we may have to
              //wrap the parsedExpression before adding a $$watchDelegate
              parsedExpression = wrapSharedExpression(parsedExpression);
              parsedExpression.$$watchDelegate = parsedExpression.literal ?
                oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
            } else if (parsedExpression.inputs) {
              parsedExpression.$$watchDelegate = inputsWatchDelegate;
            }

            cache[cacheKey] = parsedExpression;
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    };

    function collectExpressionInputs(inputs, list) {
      for (var i = 0, ii = inputs.length; i < ii; i++) {
        var input = inputs[i];
        if (!input.constant) {
          if (input.inputs) {
            collectExpressionInputs(input.inputs, list);
          } else if (list.indexOf(input) === -1) { // TODO(perf) can we do better?
            list.push(input);
          }
        }
      }

      return list;
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = newValue.valueOf();

        if (typeof newValue === 'object') {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var inputExpressions = parsedExpression.$$inputs ||
                    (parsedExpression.$$inputs = collectExpressionInputs(parsedExpression.inputs, []));

      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValue = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValue)) {
            lastResult = parsedExpression(scope);
            oldInputValue = newInputValue && newInputValue.valueOf();
          }
          return lastResult;
        }, listener, objectEquality);
      }

      var oldInputValueOfValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
            oldInputValueOfValues[i] = newInputValue && newInputValue.valueOf();
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope);
        }

        return lastResult;
      }, listener, objectEquality);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      return unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener.apply(this, arguments);
        }
        if (isDefined(value)) {
          scope.$$postDigest(function () {
            if (isDefined(lastValue)) {
              unwatch();
            }
          });
        }
      }, objectEquality);
    }

    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      return unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener.call(this, value, old, scope);
        }
        if (isAllDefined(value)) {
          scope.$$postDigest(function () {
            if(isAllDefined(lastValue)) unwatch();
          });
        }
      }, objectEquality);

      function isAllDefined(value) {
        var allDefined = true;
        forEach(value, function (val) {
          if (!isDefined(val)) allDefined = false;
        });
        return allDefined;
      }
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch;
      return unwatch = scope.$watch(function constantWatch(scope) {
        return parsedExpression(scope);
      }, function constantListener(value, old, scope) {
        if (isFunction(listener)) {
          listener.apply(this, arguments);
        }
        unwatch();
      }, objectEquality);
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;

      var fn = function interceptedExpression(scope, locals) {
        var value = parsedExpression(scope, locals);
        var result = interceptorFn(value, scope, locals);
        // we only return the interceptor's result if the
        // initial value is defined (for bind-once)
        return isDefined(value) ? result : value;
      };

      // Propagate $$watchDelegates other then inputsWatchDelegate
      if (parsedExpression.$$watchDelegate &&
          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
      } else if (!interceptorFn.$stateful) {
        // If there is an interceptor, but no watchDelegate then treat the interceptor like
        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
        fn.$$watchDelegate = inputsWatchDelegate;
        fn.inputs = [parsedExpression];
      }

      return fn;
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A promise/deferred implementation inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 promises to some degree.
 *
 * # $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6 Harmony,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 Harmony promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * # The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * # The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, errorCallback, notifyCallback)` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback`. It also notifies via the return value of the
 *   `notifyCallback` method. The promise cannot be resolved or rejected from the notifyCallback
 *   method.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 *   Because `finally` is a reserved word in JavaScript and reserved keywords are not supported as
 *   property names by ES3, you'll need to invoke the method like `promise['finally'](callback)` to
 *   make your code IE8 and Android 2.x compatible.
 *
 * # Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * # Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in angular, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 *  # Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
function $QProvider() {

  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler);
  }];
}

function $$QProvider() {
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler);
  }];
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler) {
  var $qMinErr = minErr('$q', TypeError);
  function callOnce(self, resolveFn, rejectFn) {
    var called = false;
    function wrap(fn) {
      return function(value) {
        if (called) return;
        called = true;
        fn.call(self, value);
      };
    }

    return [wrap(resolveFn), wrap(rejectFn)];
  }

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  var defer = function() {
    return new Deferred();
  };

  function Promise() {
    this.$$state = { status: 0 };
  }

  Promise.prototype = {
    then: function(onFulfilled, onRejected, progressBack) {
      var result = new Deferred();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result.promise;
    },

    "catch": function(callback) {
      return this.then(null, callback);
    },

    "finally": function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, true, callback);
      }, function(error) {
        return handleCallback(error, false, callback);
      }, progressBack);
    }
  };

  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
  function simpleBind(context, fn) {
    return function(value) {
      fn.call(context, value);
    };
  }

  function processQueue(state) {
    var fn, promise, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    for (var i = 0, ii = pending.length; i < ii; ++i) {
      promise = pending[i][0];
      fn = pending[i][state.status];
      try {
        if (isFunction(fn)) {
          promise.resolve(fn(state.value));
        } else if (state.status === 1) {
          promise.resolve(state.value);
        } else {
          promise.reject(state.value);
        }
      } catch(e) {
        promise.reject(e);
        exceptionHandler(e);
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    nextTick(function() { processQueue(state); });
  }

  function Deferred() {
    this.promise = new Promise();
    //Necessary to support unbound execution :/
    this.resolve = simpleBind(this, this.resolve);
    this.reject = simpleBind(this, this.reject);
    this.notify = simpleBind(this, this.notify);
  }

  Deferred.prototype = {
    resolve: function(val) {
      if (this.promise.$$state.status) return;
      if (val === this.promise) {
        this.$$reject($qMinErr(
          'qcycle',
          "Expected promise to be resolved with value other than itself '{0}'",
          val));
      }
      else {
        this.$$resolve(val);
      }

    },

    $$resolve: function(val) {
      var then, fns;

      fns = callOnce(this, this.$$resolve, this.$$reject);
      try {
        if ((isObject(val) || isFunction(val))) then = val && val.then;
        if (isFunction(then)) {
          this.promise.$$state.status = -1;
          then.call(val, fns[0], fns[1], this.notify);
        } else {
          this.promise.$$state.value = val;
          this.promise.$$state.status = 1;
          scheduleProcessQueue(this.promise.$$state);
        }
      } catch(e) {
        fns[1](e);
        exceptionHandler(e);
      }
    },

    reject: function(reason) {
      if (this.promise.$$state.status) return;
      this.$$reject(reason);
    },

    $$reject: function(reason) {
      this.promise.$$state.value = reason;
      this.promise.$$state.status = 2;
      scheduleProcessQueue(this.promise.$$state);
    },

    notify: function(progress) {
      var callbacks = this.promise.$$state.pending;

      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
        nextTick(function() {
          var callback, result;
          for (var i = 0, ii = callbacks.length; i < ii; i++) {
            result = callbacks[i][0];
            callback = callbacks[i][3];
            try {
              result.notify(isFunction(callback) ? callback(progress) : progress);
            } catch(e) {
              exceptionHandler(e);
            }
          }
        });
      }
    }
  };

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  var reject = function(reason) {
    var result = new Deferred();
    result.reject(reason);
    return result.promise;
  };

  var makePromise = function makePromise(value, resolved) {
    var result = new Deferred();
    if (resolved) {
      result.resolve(value);
    } else {
      result.reject(value);
    }
    return result.promise;
  };

  var handleCallback = function handleCallback(value, isResolved, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch(e) {
      return makePromise(e, false);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return makePromise(value, isResolved);
      }, function(error) {
        return makePromise(error, false);
      });
    } else {
      return makePromise(value, isResolved);
    }
  };

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  var when = function(value, callback, errback, progressBack) {
    var result = new Deferred();
    result.resolve(value);
    return result.promise.then(callback, errback, progressBack);
  };

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var deferred = new Deferred(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        if (results.hasOwnProperty(key)) return;
        results[key] = value;
        if (!(--counter)) deferred.resolve(results);
      }, function(reason) {
        if (results.hasOwnProperty(key)) return;
        deferred.reject(reason);
      });
    });

    if (counter === 0) {
      deferred.resolve(results);
    }

    return deferred.promise;
  }

  var $Q = function Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
    }

    if (!(this instanceof Q)) {
      // More useful when $Q is the Promise itself.
      return new Q(resolver);
    }

    var deferred = new Deferred();

    function resolveFn(value) {
      deferred.resolve(value);
    }

    function rejectFn(reason) {
      deferred.reject(reason);
    }

    resolver(resolveFn, rejectFn);

    return deferred.promise;
  };

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.all = all;

  return $Q;
}

function $$RAFProvider(){ //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame ||
                                $window.mozRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.mozCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - this means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in middle are expensive so we use linked list
 *
 * There are few watches then a lot of observers. This is why you don't want the observer to be
 * implemented in the same way as watch. Watch requires return of initialization function which
 * are expensive to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide an event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider(){
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  this.$get = ['$injector', '$exceptionHandler', '$parse', '$browser',
      function( $injector,   $exceptionHandler,   $parse,   $browser) {

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.)
     *
     * Here is a simple scope snippet to show how you can interact with the scope.
     * ```html
     * <file src="./test/ng/rootScopeSpec.js" tag="docs1" />
     * ```
     *
     * # Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         child.name = "World";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = function ChildScope() {
              this.$$watchers = this.$$nextSibling =
                  this.$$childHead = this.$$childTail = null;
              this.$$listeners = {};
              this.$$listenerCount = {};
              this.$id = nextUid();
              this.$$ChildScope = null;
            };
            this.$$ChildScope.prototype = this;
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent != this) child.$on('$destroy', destroyChild);

        return child;

        function destroyChild() {
          child.$$destroyed = true;
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (Since
       *   {@link ng.$rootScope.Scope#$digest $digest()} reruns when it detects changes the
       *   `watchExpression` can execute multiple times per
       *   {@link ng.$rootScope.Scope#$digest $digest()} and should be idempotent.)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Since `watchExpression`
       * can execute multiple times per {@link ng.$rootScope.Scope#$digest $digest} cycle when a
       * change is detected, be prepared for multiple calls to your listener.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * # Example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} objectEquality Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality) {
        var get = $parse(watchExp);

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, listener, objectEquality, get);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: listener,
              last: initWatchVal,
              get: get,
              exp: watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!isFunction(listener)) {
          watcher.fn = noop;
        }

        if (!array) {
          array = scope.$$watchers = [];
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);

        return function deregisterWatch() {
          arrayRemove(array, watcher);
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
       *   call to $digest() to see if any items changes.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function () {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function (expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
            newValues[i] = value;
            oldValues[i] = oldValue;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          if (firstRun) {
            firstRun = false;
            listener(newValues, newValues, self);
          } else {
            listener(newValues, oldValues, self);
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * # Example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        $watchCollectionInterceptor.$stateful = true;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (newValue.hasOwnProperty(key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for(key in oldValue) {
                if (!newValue.hasOwnProperty(key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * # Example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last,
            watchers,
            length,
            dirty, ttl = TTL,
            next, current, target = this,
            watchLog = [],
            logIdx, logMsg, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          while(asyncQueue.length) {
            try {
              asyncTask = asyncQueue.shift();
              asyncTask.scope.$eval(asyncTask.expression);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = current.$$watchers)) {
              // process our watches
              length = watchers.length;
              while (length--) {
                try {
                  watch = watchers[length];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    if ((value = watch.get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (typeof value === 'number' && typeof last === 'number'
                               && isNaN(value) && isNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      watch.fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        logMsg = (isFunction(watch.exp))
                            ? 'fn: ' + (watch.exp.name || watch.exp.toString())
                            : watch.exp;
                        logMsg += '; newVal: ' + toJson(value) + '; oldVal: ' + toJson(last);
                        watchLog[logIdx].push(logMsg);
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            if (!(next = (current.$$childHead ||
                (current !== target && current.$$nextSibling)))) {
              while(current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, toJson(watchLog));
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        while(postDigestQueue.length) {
          try {
            postDigestQueue.shift()();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
      },


      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // we can't destroy the root scope or a scope that has been already destroyed
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;
        if (this === $rootScope) return;

        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
        if (parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // All of the code below is bogus code that works around V8's memory leak via optimized code
        // and inline caches.
        //
        // see:
        // - https://code.google.com/p/v8/issues/detail?id=2073#c26
        // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
        // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

        this.$parent = this.$$nextSibling = this.$$prevSibling = this.$$childHead =
            this.$$childTail = this.$root = this.$$watchers = null;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating Angular
       * expressions.
       *
       * # Example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       */
      $evalAsync: function(expr) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          });
        }

        asyncQueue.push({scope: this, expression: expr});
      },

      $$postDigest : function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in angular from outside of the angular
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the angular framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * ## Life cycle
       *
       * # Pseudo-Code of `$apply()`
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          return this.$eval(expr);
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          clearPhase();
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invokation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        expr && applyAsyncQueue.push($applyAsyncExpression);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          namedListeners[namedListeners.indexOf(listener)] = null;
          decrementListenerCount(self, 1, name);
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i=0, length=namedListeners.length; i<length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            event.currentScope = null;
            return event;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i=0, length = listeners.length; i<length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch(e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while(current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }


    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch(e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        });
      }
    }
  }];
}

/**
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {
  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationWhitelist = regexp;
      return this;
    }
    return aHrefSanitizationWhitelist;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationWhitelist = regexp;
      return this;
    }
    return imgSrcSanitizationWhitelist;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isImage) {
      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
      var normalizedVal;
      normalizedVal = urlResolve(uri).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:'+normalizedVal;
      }
      return uri;
    };
  };
}

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  HTML: 'html',
  CSS: 'css',
  URL: 'url',
  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
  // url.  (e.g. ng-include, script src, templateUrl)
  RESOURCE_URL: 'resourceUrl',
  JS: 'js'
};

// Helper functions follow.

// Copied from:
// http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962
// Prereq: s is a string.
function escapeForRegexp(s) {
  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
           replace(/\x08/g, '\\x08');
}


function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace('\\*\\*', '.*').
                  replace('\\*', '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 *
 * For the general details about this service in Angular, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var resourceUrlWhitelist = ['self'],
      resourceUrlBlacklist = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.
   *
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   *     Note: **an empty whitelist array will block all URLs**!
   *
   * @return {Array} the currently set whitelist array.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   */
  this.resourceUrlWhitelist = function (value) {
    if (arguments.length) {
      resourceUrlWhitelist = adjustMatchers(value);
    }
    return resourceUrlWhitelist;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.
   *
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   *     The typical usage for the blacklist is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *
   *     Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} the currently set blacklist array.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   */

  this.resourceUrlBlacklist = function (value) {
    if (arguments.length) {
      resourceUrlBlacklist = adjustMatchers(value);
    }
    return resourceUrlBlacklist;
  };

  this.$get = ['$injector', function($injector) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the whitelist allows this url.
      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns an object that is trusted by angular for use in specified strict
     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
     * attribute interpolation, any dom event binding attribute interpolation
     * such as for onclick,  etc.) that uses the provided value.
     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || trustedValue === undefined || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *      call or anything else.
     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
     * returns the originally supplied value if the queried context type is a supertype of the
     * created type.  If this condition isn't satisfied, throws an exception.
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call.
     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || maybeTrusted === undefined || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }
      // If we get here, then we may only take one of two actions.
      // 1. sanitize the value for the requested type, or
      // 2. throw an exception.
      if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        return htmlSanitizer(maybeTrusted);
      }
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/* jshint maxlen: false*/

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * # Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
 * contexts to result in a value that is marked as safe to use for that context.  One example of
 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
 * to these contexts as privileged or SCE contexts.
 *
 * As of version 1.2, Angular ships with SCE enabled by default.
 *
 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
 * to the top of your HTML document.
 *
 * SCE assists in writing code in way that (a) is secure by default and (b) makes auditing for
 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV.
 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
 * security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
 * determine that something explicitly says it's safe to use a value for binding in that
 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
 * for those values that you can easily tell are safe - because they were received from your server,
 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * obtain values that will be accepted by SCE / privileged contexts.
 *
 *
 * ## How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ## Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, Angular only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ## This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
 *
 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ## What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and ';'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      not appropriate to use in for a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage.).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      if they as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  e.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ## Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
 *           self.userComments = userComments;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */
/* jshint maxlen: 100 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE.
   * @return {boolean} true if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function (value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the a value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way.  In some future, we
   * may not use inheritance anymore.  That is OK because no code outside of
   * sce.js and sceSpecs.js would need to be aware of this detail.
   */

  this.$get = ['$document', '$parse', '$sceDelegate', function(
                $document,   $parse,   $sceDelegate) {
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && $document[0].documentMode < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function () {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The kind of SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function (value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
     * returns an object that is trusted by angular for use in specified strict contextual
     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
     * escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resource_url, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the return
     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
     * originally supplied value if the queried context type is a supertype of the created type.
     * If this condition isn't satisfied, throws an exception.
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
     *                         call.
     * @returns {*} The value the was originally provided to
     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
     *              Otherwise, throws an exception.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function (enumValue, name) {
      var lName = lowercase(name);
      sce[camelCase("parse_as_" + lName)] = function (expr) {
        return parse(enumValue, expr);
      };
      sce[camelCase("get_trusted_" + lName)] = function (value) {
        return getTrusted(enumValue, value);
      };
      sce[camelCase("trust_as_" + lName)] = function (value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        android =
          int((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        vendorPrefix,
        vendorRegex = /^(Moz|webkit|O|ms)(?=[A-Z])/,
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false,
        match;

    if (bodyStyle) {
      for(var prop in bodyStyle) {
        if(match = vendorRegex.exec(prop)) {
          vendorPrefix = match[0];
          vendorPrefix = vendorPrefix.substr(0, 1).toUpperCase() + vendorPrefix.substr(1);
          break;
        }
      }

      if(!vendorPrefix) {
        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
      }

      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));

      if (android && (!transitions||!animations)) {
        transitions = isString(document.body.style.webkitTransition);
        animations = isString(document.body.style.webkitAnimation);
      }
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      // jshint -W018
      history: !!($window.history && $window.history.pushState && !(android < 4) && !boxee),
      // jshint +W018
      hasEvent: function(event) {
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        if (event == 'input' && msie == 9) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      vendorPrefix: vendorPrefix,
      transitions : transitions,
      animations : animations,
      android: android
    };
  }];
}

var $compileMinErr = minErr('$compile');

/**
 * @ngdoc service
 * @name $templateRequest
 *
 * @description
 * The `$templateRequest` service downloads the provided template using `$http` and, upon success,
 * stores the contents inside of `$templateCache`. If the HTTP request fails or the response data
 * of the HTTP request is empty then a `$compile` error will be thrown (the exception can be thwarted
 * by setting the 2nd parameter of the function to true).
 *
 * @param {string} tpl The HTTP request template URL
 * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
 *
 * @return {Promise} the HTTP Promise for the given.
 *
 * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
 */
function $TemplateRequestProvider() {
  this.$get = ['$templateCache', '$http', '$q', function($templateCache, $http, $q) {
    function handleRequestFn(tpl, ignoreRequestError) {
      var self = handleRequestFn;
      self.totalPendingRequests++;

      return $http.get(tpl, { cache : $templateCache })
        .then(function(response) {
          var html = response.data;
          if(!html || html.length === 0) {
            return handleError();
          }

          self.totalPendingRequests--;
          $templateCache.put(tpl, html);
          return html;
        }, handleError);

      function handleError() {
        self.totalPendingRequests--;
        if (!ignoreRequestError) {
          throw $compileMinErr('tpload', 'Failed to load template: {0}', tpl);
        }
        return $q.reject();
      }
    }

    handleRequestFn.totalPendingRequests = 0;

    return handleRequestFn;
  }];
}

function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + expression + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) != -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when $timeout and $http requests are completed.
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
    var deferreds = {};


     /**
      * @ngdoc service
      * @name $timeout
      *
      * @description
      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
      * block and delegates any exceptions to
      * {@link ng.$exceptionHandler $exceptionHandler} service.
      *
      * The return value of registering a timeout function is a promise, which will be resolved when
      * the timeout is reached and the timeout function is executed.
      *
      * To cancel a timeout request, call `$timeout.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
      * synchronously flush the queue of deferred functions.
      *
      * @param {function()} fn A function, whose execution should be delayed.
      * @param {number=} [delay=0] Delay in milliseconds.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @returns {Promise} Promise that will be resolved when the timeout is reached. The value this
      *   promise will be resolved with is the return value of the `fn` function.
      *
      */
    function timeout(fn, delay, invokeApply) {
      var skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn());
        } catch(e) {
          deferred.reject(e);
          $exceptionHandler(e);
        }
        finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay);

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


     /**
      * @ngdoc method
      * @name $timeout#cancel
      *
      * @description
      * Cancels a task associated with the `promise`. As a result of this, the promise will be
      * resolved with a rejection.
      *
      * @param {Promise=} promise Promise returned by the `$timeout` function.
      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
      *   canceled.
      */
    timeout.cancel = function(promise) {
      if (promise && promise.$$timeoutId in deferreds) {
        deferreds[promise.$$timeoutId].reject('canceled');
        delete deferreds[promise.$$timeoutId];
        return $browser.defer.cancel(promise.$$timeoutId);
      }
      return false;
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = document.createElement("a");
var originUrl = urlResolve(window.location.href, true);


/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE >= 8 and <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * IE7 does not normalize the URL when assigned to an anchor node.  (Apparently, it does, if one
 * uses the inner HTML approach to assign the URL as part of an HTML snippet -
 * http://stackoverflow.com/a/472729)  However, setting img[src] does normalize the URL.
 * Unfortunately, setting img[src] to something like "javascript:foo" on IE throws an exception.
 * Since the primary usage for normalizing URLs is to sanitize such URLs, we can't use that
 * method and IE < 8 is unsupported.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string} url The URL to be parsed.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description    |
 *   |---------------|----------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol including the trailing colon                              |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol
 *   | hostname      | The hostname
 *   | port          | The port, without ":"
 *   | pathname      | The pathname, beginning with "/"
 *
 */
function urlResolve(url, base) {
  var href = url;

  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute("href", href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: urlParsingNode.hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
  return (parsed.protocol === originUrl.protocol &&
          parsed.host === originUrl.host);
}

/**
 * @ngdoc service
 * @name $window
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In angular we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function ($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider(){
  this.$get = valueFn(window);
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how angular filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the Angular Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * The general syntax in templates is as follows:
 *
 *         {{ expression [| filter_name[:parameter_value] ... ] }}
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if(isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false,
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is evaluated as an expression and the resulting value is used for substring match against
 *     the contents of the `array`. All strings or objects with string properties in `array` that contain this string
 *     will be returned. The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
 *     property of the object. That's equivalent to the simple substring match with a `string`
 *     as described above. The predicate can be negated by prefixing the string with `!`.
 *     For Example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *   - `function(value, index)`: A predicate function can be used to write arbitrary filters. The
 *     function is called for each element of `array`. The final result is an array of those
 *     elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
 *     determining if the expected value (from the filter expression) and actual value (from
 *     the object in the array) should be considered a match.
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if the item should be included in filtered result.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(expected, actual)}`.
 *     this is essentially strict comparison of expected and actual.
 *
 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
 *     insensitive way.
 *
 * @example
   <example>
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       Search: <input ng-model="searchText">
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       Any: <input ng-model="search.$"> <br>
       Name only <input ng-model="search.name"><br>
       Phone only <input ng-model="search.phone"><br>
       Equality <input type="checkbox" ng-model="strict"><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */
function filterFilter() {
  return function(array, expression, comparator) {
    if (!isArray(array)) return array;

    var comparatorType = typeof(comparator),
        predicates = [];

    predicates.check = function(value, index) {
      for (var j = 0; j < predicates.length; j++) {
        if(!predicates[j](value, index)) {
          return false;
        }
      }
      return true;
    };

    if (comparatorType !== 'function') {
      if (comparatorType === 'boolean' && comparator) {
        comparator = function(obj, text) {
          return angular.equals(obj, text);
        };
      } else {
        comparator = function(obj, text) {
          if (obj && text && typeof obj === 'object' && typeof text === 'object') {
            for (var objKey in obj) {
              if (objKey.charAt(0) !== '$' && hasOwnProperty.call(obj, objKey) &&
                  comparator(obj[objKey], text[objKey])) {
                return true;
              }
            }
            return false;
          }
          text = (''+text).toLowerCase();
          return (''+obj).toLowerCase().indexOf(text) > -1;
        };
      }
    }

    var search = function(obj, text){
      if (typeof text === 'string' && text.charAt(0) === '!') {
        return !search(obj, text.substr(1));
      }
      switch (typeof obj) {
        case 'boolean':
        case 'number':
        case 'string':
          return comparator(obj, text);
        case 'object':
          switch (typeof text) {
            case 'object':
              return comparator(obj, text);
            default:
              for ( var objKey in obj) {
                if (objKey.charAt(0) !== '$' && search(obj[objKey], text)) {
                  return true;
                }
              }
              break;
          }
          return false;
        case 'array':
          for ( var i = 0; i < obj.length; i++) {
            if (search(obj[i], text)) {
              return true;
            }
          }
          return false;
        default:
          return false;
      }
    };
    switch (typeof expression) {
      case 'boolean':
      case 'number':
      case 'string':
        // Set up expression object and fall through
        expression = {$:expression};
        // jshint -W086
      case 'object':
        // jshint +W086
        for (var key in expression) {
          (function(path) {
            if (typeof expression[path] === 'undefined') return;
            predicates.push(function(value) {
              return search(path == '$' ? value : (value && value[path]), expression[path]);
            });
          })(key);
        }
        break;
      case 'function':
        predicates.push(expression);
        break;
      default:
        return array;
    }
    var filtered = [];
    for ( var j = 0; j < array.length; j++) {
      var value = array[j];
      if (predicates.check(value, j)) {
        filtered.push(value);
      }
    }
    return filtered;
  };
}

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to.
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser == 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('($1,234.00)');
         expect(element(by.id('currency-custom')).getText()).toBe('(USD$1,234.00)');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('(USD$1,234)');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize){
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      // TODO: read the default value from the locale file
      fractionSize = 2;
    }

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(/\u00A4/g, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is not a number an empty string is returned.
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to decimalPlaces and places a “,” after each third digit.
 *
 * @example
   <example module="numberFilterExample">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         Enter number: <input ng-model='val'><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */


numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

var DECIMAL_SEP = '.';
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
  if (!isFinite(number) || isObject(number)) return '';

  var isNegative = number < 0;
  number = Math.abs(number);
  var numStr = number + '',
      formatedText = '',
      parts = [];

  var hasExponent = false;
  if (numStr.indexOf('e') !== -1) {
    var match = numStr.match(/([\d\.]+)e(-?)(\d+)/);
    if (match && match[2] == '-' && match[3] > fractionSize + 1) {
      numStr = '0';
      number = 0;
    } else {
      formatedText = numStr;
      hasExponent = true;
    }
  }

  if (!hasExponent) {
    var fractionLen = (numStr.split(DECIMAL_SEP)[1] || '').length;

    // determine fractionSize if it is not specified
    if (isUndefined(fractionSize)) {
      fractionSize = Math.min(Math.max(pattern.minFrac, fractionLen), pattern.maxFrac);
    }

    // safely round numbers in JS without hitting imprecisions of floating-point arithmetics
    // inspired by:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
    number = +(Math.round(+(number.toString() + 'e' + fractionSize)).toString() + 'e' + -fractionSize);

    if (number === 0) {
      isNegative = false;
    }

    var fraction = ('' + number).split(DECIMAL_SEP);
    var whole = fraction[0];
    fraction = fraction[1] || '';

    var i, pos = 0,
        lgroup = pattern.lgSize,
        group = pattern.gSize;

    if (whole.length >= (lgroup + group)) {
      pos = whole.length - lgroup;
      for (i = 0; i < pos; i++) {
        if ((pos - i)%group === 0 && i !== 0) {
          formatedText += groupSep;
        }
        formatedText += whole.charAt(i);
      }
    }

    for (i = pos; i < whole.length; i++) {
      if ((whole.length - i)%lgroup === 0 && i !== 0) {
        formatedText += groupSep;
      }
      formatedText += whole.charAt(i);
    }

    // format fraction part.
    while(fraction.length < fractionSize) {
      fraction += '0';
    }

    if (fractionSize && fractionSize !== "0") formatedText += decimalSep + fraction.substr(0, fractionSize);
  } else {

    if (fractionSize > 0 && number > -1 && number < 1) {
      formatedText = number.toFixed(fractionSize);
    }
  }

  parts.push(isNegative ? pattern.negPre : pattern.posPre);
  parts.push(formatedText);
  parts.push(isNegative ? pattern.negSuf : pattern.posSuf);
  return parts.join('');
}

function padNumber(num, digits, trim) {
  var neg = '';
  if (num < 0) {
    neg =  '-';
    num = -num;
  }
  num = '' + num;
  while(num.length < digits) num = '0' + num;
  if (trim)
    num = num.substr(num.length - digits);
  return neg + num;
}


function dateGetter(name, size, offset, trim) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset)
      value += offset;
    if (value === 0 && offset == -12 ) value = 12;
    return padNumber(value, size, trim);
  };
}

function dateStrGetter(name, shortForm) {
  return function(date, formats) {
    var value = date['get' + name]();
    var get = uppercase(shortForm ? ('SHORT' + name) : name);

    return formats[get][value];
  };
}

function timeZoneGetter(date) {
  var zone = -1 * date.getTimezoneOffset();
  var paddedZone = (zone >= 0) ? "+" : "";

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4),
    yy: dateGetter('FullYear', 2, 0, true),
     y: dateGetter('FullYear', 1),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1)
};

var DATE_FORMATS_SPLIT = /((?:[^yMdHhmsaZEw']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|w+))(.*)/,
    NUMBER_STRING = /^\-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'.sss' or ',sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: ISO-8601 week of year (00-53)
 *   * `'w'`: ISO-8601 week of year (0-53)
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. Right now, only `'UTC'` is supported.
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example>
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if (match = string.match(R_ISO8601_STR)) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = int(match[9] + match[10]);
        tzMin = int(match[9] + match[11]);
      }
      dateSetter.call(date, int(match[1]), int(match[2]) - 1, int(match[3]));
      var h = int(match[4]||0) - tzHour;
      var m = int(match[5]||0) - tzMin;
      var s = int(match[6]||0);
      var ms = Math.round(parseFloat('0.' + (match[7]||0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? int(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date)) {
      return date;
    }

    while(format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    if (timezone && timezone === 'UTC') {
      date = new Date(date.getTime());
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    }
    forEach(parts, function(value){
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS)
                 : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example>
     <file name="index.html">
       <pre>{{ {'name':'value'} | json }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.binding("{'name':'value'}")).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object) {
    return toJson(object, true);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @see angular.uppercase
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements
 * are taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. If a number is used as input, it is
 * converted to a string.
 *
 * @param {Array|string|number} input Source array, string or number to be limited.
 * @param {string|number} limit The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if input array
 *     had less than `limit` elements.
 *
 * @example
   <example module="limitToExample">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         Limit {{numbers}} to: <input type="number" step="1" ng-model="numLimit">
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         Limit {{letters}} to: <input type="number" step="1" ng-model="letterLimit">
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         Limit {{longNumber}} to: <input type="number" step="1" ng-model="longNumberLimit">
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter(){
  return function(input, limit) {
    if (isNumber(input)) input = input.toString();
    if (!isArray(input) && !isString(input)) return input;

    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = int(limit);
    }

    if (isString(input)) {
      //NaN check on limit
      if (limit) {
        return limit >= 0 ? input.slice(0, limit) : input.slice(limit, input.length);
      } else {
        return "";
      }
    }

    var out = [],
      i, n;

    // if abs(limit) exceeds maximum length, trim it
    if (limit > input.length)
      limit = input.length;
    else if (limit < -input.length)
      limit = -input.length;

    if (limit > 0) {
      i = 0;
      n = limit;
    } else {
      i = input.length + limit;
      n = input.length;
    }

    for (; i<n; i++) {
      out.push(input[i]);
    }

    return out;
  };
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Orders a specified `array` by the `expression` predicate. It is ordered alphabetically
 * for strings and numerically for numbers. Note: if you notice numbers are not being sorted
 * correctly, make sure they are actually being saved as numbers and not strings.
 *
 * @param {Array} array The array to sort.
 * @param {function(*)|string|Array.<(function(*)|string)>=} expression A predicate to be
 *    used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `function`: Getter function. The result of this function will be sorted using the
 *      `<`, `=`, `>` operator.
 *    - `string`: An Angular expression. The result of this expression is used to compare elements
 *      (for example `name` to sort by a property called `name` or `name.substr(0, 3)` to sort by
 *      3 first characters of a property called `name`). The result of a constant expression
 *      is interpreted as a property name to be used in comparisons (for example `"special name"`
 *      to sort object by the value of their `special name` property). An expression can be
 *      optionally prefixed with `+` or `-` to control ascending or descending sort order
 *      (for example, `+name` or `-name`). If no property is provided, (e.g. `'+'`) then the array
 *      element itself is used to compare where sorting.
 *    - `Array`: An array of function or string predicates. The first predicate in the array
 *      is used for sorting, but when two items are equivalent, the next predicate is used.
 *
 *    If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse Reverse the order of the array.
 * @returns {Array} Sorted copy of the source array.
 *
 * @example
   <example module="orderByExample">
     <file name="index.html">
       <script>
         angular.module('orderByExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.friends =
                 [{name:'John', phone:'555-1212', age:10},
                  {name:'Mary', phone:'555-9876', age:19},
                  {name:'Mike', phone:'555-4321', age:21},
                  {name:'Adam', phone:'555-5678', age:35},
                  {name:'Julie', phone:'555-8765', age:29}];
             $scope.predicate = '-age';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
         <hr/>
         [ <a href="" ng-click="predicate=''">unsorted</a> ]
         <table class="friend">
           <tr>
             <th><a href="" ng-click="predicate = 'name'; reverse=false">Name</a>
                 (<a href="" ng-click="predicate = '-name'; reverse=false">^</a>)</th>
             <th><a href="" ng-click="predicate = 'phone'; reverse=!reverse">Phone Number</a></th>
             <th><a href="" ng-click="predicate = 'age'; reverse=!reverse">Age</a></th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:predicate:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
   </example>
 *
 * It's also possible to call the orderBy filter manually, by injecting `$filter`, retrieving the
 * filter routine with `$filter('orderBy')`, and calling the returned filter routine with the
 * desired parameters.
 *
 * Example:
 *
 * @example
  <example module="orderByExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <table class="friend">
          <tr>
            <th><a href="" ng-click="reverse=false;order('name', false)">Name</a>
              (<a href="" ng-click="order('-name',false)">^</a>)</th>
            <th><a href="" ng-click="reverse=!reverse;order('phone', reverse)">Phone Number</a></th>
            <th><a href="" ng-click="reverse=!reverse;order('age',reverse)">Age</a></th>
          </tr>
          <tr ng-repeat="friend in friends">
            <td>{{friend.name}}</td>
            <td>{{friend.phone}}</td>
            <td>{{friend.age}}</td>
          </tr>
        </table>
      </div>
    </file>

    <file name="script.js">
      angular.module('orderByExample', [])
        .controller('ExampleController', ['$scope', '$filter', function($scope, $filter) {
          var orderBy = $filter('orderBy');
          $scope.friends = [
            { name: 'John',    phone: '555-1212',    age: 10 },
            { name: 'Mary',    phone: '555-9876',    age: 19 },
            { name: 'Mike',    phone: '555-4321',    age: 21 },
            { name: 'Adam',    phone: '555-5678',    age: 35 },
            { name: 'Julie',   phone: '555-8765',    age: 29 }
          ];
          $scope.order = function(predicate, reverse) {
            $scope.friends = orderBy($scope.friends, predicate, reverse);
          };
          $scope.order('-age',false);
        }]);
    </file>
</example>
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse){
  return function(array, sortPredicate, reverseOrder) {
    if (!(isArrayLike(array))) return array;
    sortPredicate = isArray(sortPredicate) ? sortPredicate: [sortPredicate];
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
    sortPredicate = sortPredicate.map(function(predicate){
      var descending = false, get = predicate || identity;
      if (isString(predicate)) {
        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
          descending = predicate.charAt(0) == '-';
          predicate = predicate.substring(1);
        }
        if ( predicate === '' ) {
          // Effectively no predicate was passed so we compare identity
          return reverseComparator(function(a,b) {
            return compare(a, b);
          }, descending);
        }
        get = $parse(predicate);
        if (get.constant) {
          var key = get();
          return reverseComparator(function(a,b) {
            return compare(a[key], b[key]);
          }, descending);
        }
      }
      return reverseComparator(function(a,b){
        return compare(get(a),get(b));
      }, descending);
    });
    var arrayCopy = [];
    for ( var i = 0; i < array.length; i++) { arrayCopy.push(array[i]); }
    return arrayCopy.sort(reverseComparator(comparator, reverseOrder));

    function comparator(o1, o2){
      for ( var i = 0; i < sortPredicate.length; i++) {
        var comp = sortPredicate[i](o1, o2);
        if (comp !== 0) return comp;
      }
      return 0;
    }
    function reverseComparator(comp, descending) {
      return descending
          ? function(a,b){return comp(b,a);}
          : comp;
    }
    function compare(v1, v2){
      var t1 = typeof v1;
      var t2 = typeof v2;
      if (t1 == t2) {
        if (isDate(v1) && isDate(v2)) {
          v1 = v1.valueOf();
          v2 = v2.valueOf();
        }
        if (t1 == "string") {
           v1 = v1.toLowerCase();
           v2 = v2.toLowerCase();
        }
        if (v1 === v2) return 0;
        return v1 < v2 ? -1 : 1;
      } else {
        return t1 < t2 ? -1 : 1;
      }
    }
  };
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html A tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * This change permits the easy creation of action links with the `ngClick` directive
 * without changing the location or causing page reloads, e.g.:
 * `<a href="" ng-click="list.addItem()">Add Item</a>`
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref && !attr.name) {
      return function(scope, element) {
        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event){
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * Angular has a chance to replace the `{{hash}}` markup with its
 * value. Until Angular replaces the markup the link will be broken
 * and will most likely return a 404 error.
 *
 * The `ngHref` directive solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example>
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        xit('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}"/>
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x"/>
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * We shouldn't do this, because it will make the button enabled on Chrome/Firefox but not on IE8 and older IEs:
 * ```html
 * <div ng-init="scope = { isDisabled: false }">
 *  <button disabled="{{scope.isDisabled}}">Disabled</button>
 * </div>
 * ```
 *
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as disabled. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngDisabled` directive solves this problem for the `disabled` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 *
 * @example
    <example>
      <file name="index.html">
        Click me to toggle: <input type="checkbox" ng-model="checked"><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then special attribute "disabled" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as checked. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngChecked` directive solves this problem for the `checked` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 * @example
    <example>
      <file name="index.html">
        Check me to check both: <input type="checkbox" ng-model="master"><br/>
        <input id="checkSlave" type="checkbox" ng-checked="master">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
          element(by.model('master')).click();
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then special attribute "checked" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as readonly. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngReadonly` directive solves this problem for the `readonly` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 * @example
    <example>
      <file name="index.html">
        Check me to make text readonly: <input type="checkbox" ng-model="checked"><br/>
        <input type="text" ng-readonly="checked" value="I'm Angular"/>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as selected. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngSelected` directive solves this problem for the `selected` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 *
 * @example
    <example>
      <file name="index.html">
        Check me to select: <input type="checkbox" ng-model="selected"><br/>
        <select>
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 * The HTML specification does not require browsers to preserve the values of boolean attributes
 * such as open. (Their presence means true and their absence means false.)
 * If we put an Angular interpolation expression into such an attribute then the
 * binding information would be lost when the browser removes the attribute.
 * The `ngOpen` directive solves this problem for the `open` attribute.
 * This complementary directive is not removed by the browser and so provides
 * a permanent reliable place to store the binding information.
 * @example
     <example>
       <file name="index.html">
         Check me check multiple: <input type="checkbox" ng-model="open"><br/>
         <details id="details" ng-open="open">
            <summary>Show/Hide me</summary>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};


// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName == "multiple") return;

  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: function(scope, element, attr) {
        scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
          attr.$set(attrName, !!value);
        });
      }
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set("ngPattern", new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = function() {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // we use attr[attrName] value since $set can sanitize the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  };
});

/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
 */
var nullFormCtrl = {
  $addControl: noop,
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop
},
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $error Is an object hash, containing references to controls or
 *  forms with failing validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for given error name.
 *
 *  Built-in validation tokens:
 *
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController(element, attrs, $scope, $animate, $interpolate) {
  var form = this,
      controls = [];

  var parentForm = form.$$parentForm = element.parent().controller('form') || nullFormCtrl;

  // init state
  form.$error = {};
  form.$$success = {};
  form.$pending = undefined;
  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
  form.$dirty = false;
  form.$pristine = true;
  form.$valid = true;
  form.$invalid = false;
  form.$submitted = false;

  parentForm.$addControl(form);

  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  form.$rollbackViewValue = function() {
    forEach(controls, function(control) {
      control.$rollbackViewValue();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  form.$commitViewValue = function() {
    forEach(controls, function(control) {
      control.$commitViewValue();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   *
   * @description
   * Register a control with the form.
   *
   * Input elements using ngModelController do this automatically when they are linked.
   */
  form.$addControl = function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    controls.push(control);

    if (control.$name) {
      form[control.$name] = control;
    }
  };

  // Private API: rename a form control
  form.$$renameControl = function(control, newName) {
    var oldName = control.$name;

    if (form[oldName] === control) {
      delete form[oldName];
    }
    form[newName] = control;
    control.$name = newName;
  };

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   */
  form.$removeControl = function(control) {
    if (control.$name && form[control.$name] === control) {
      delete form[control.$name];
    }
    forEach(form.$pending, function(value, name) {
      form.$setValidity(name, null, control);
    });
    forEach(form.$error, function(value, name) {
      form.$setValidity(name, null, control);
    });

    arrayRemove(controls, control);
  };


  /**
   * @ngdoc method
   * @name form.FormController#$setValidity
   *
   * @description
   * Sets the validity of a form control.
   *
   * This method will also propagate to parent forms.
   */
  addSetValidityMethod({
    ctrl: this,
    $element: element,
    set: function(object, property, control) {
      var list = object[property];
      if (!list) {
        object[property] = [control];
      } else {
        var index = list.indexOf(control);
        if (index === -1) {
          list.push(control);
        }
      }
    },
    unset: function(object, property, control) {
      var list = object[property];
      if (!list) {
        return;
      }
      arrayRemove(list, control);
      if (list.length === 0) {
        delete object[property];
      }
    },
    parentForm: parentForm,
    $animate: $animate
  });

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  form.$setDirty = function() {
    $animate.removeClass(element, PRISTINE_CLASS);
    $animate.addClass(element, DIRTY_CLASS);
    form.$dirty = true;
    form.$pristine = false;
    parentForm.$setDirty();
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
   * state (ng-pristine class). This method will also propagate to all the controls contained
   * in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  form.$setPristine = function () {
    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    form.$dirty = false;
    form.$pristine = true;
    form.$submitted = false;
    forEach(controls, function(control) {
      control.$setPristine();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  form.$setUntouched = function () {
    forEach(controls, function(control) {
      control.$setUntouched();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its submitted state.
   */
  form.$setSubmitted = function () {
    $animate.addClass(element, SUBMITTED_CLASS);
    form.$submitted = true;
    parentForm.$setSubmitted();
  };
}

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
 * sub-group of controls needs to be determined.
 *
 * Note: the purpose of `ngForm` is to group controls,
 * but not to be a replacement for the `<form>` tag with all of its capabilities
 * (e.g. posting to the server, ...).
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * # Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In Angular forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive which behaves identically to
 * `<form>` but can be nested.  This allows you to have nested forms, which is very useful when
 * using Angular validation directives in forms that are dynamically generated using the
 * {@link ng.directive:ngRepeat `ngRepeat`} directive. Since you cannot dynamically generate the `name`
 * attribute of input elements using interpolation, you have to wrap each set of repeated inputs in an
 * `ngForm` directive and nest these in an outer `form` element.
 *
 *
 * # CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * # Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side Angular applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, Angular prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ## Animation Hooks
 *
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          -webkit-transition:all linear 0.5s;
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <tt>userType = {{userType}}</tt><br>
         <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br>
         <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', function($timeout) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      controller: FormController,
      compile: function ngFormCompile(formElement) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, controller) {
            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault
                  ? event.preventDefault()
                  : event.returnValue = false; // IE
              };

              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = controller.$$parentForm,
                alias = controller.$name;

            if (alias) {
              setter(scope, alias, controller, alias);
              attr.$observe(attr.name ? 'name' : 'ngForm', function(newValue) {
                if (alias === newValue) return;
                setter(scope, alias, undefined, alias);
                alias = newValue;
                setter(scope, alias, controller, alias);
                parentFormCtrl.$$renameControl(controller, alias);
              });
            }
            formElement.on('$destroy', function() {
              parentFormCtrl.$removeControl(controller);
              if (alias) {
                setter(scope, alias, undefined, alias);
              }
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
*/

// Regex code is obtained from SO: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
var URL_REGEXP = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))\s*$/;
var DATE_REGEXP = /^(\d{4})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

var $ngModelMinErr = new minErr('ngModel');

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
   *
   * *NOTE* Not every feature offered is available for all input types.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength.
   * @param {string=} ngPattern Sets `pattern` validation error key if the value does not match the
   *    RegExp pattern expression. Expected value is `/regexp/` for inline patterns or `regexp` for
   *    patterns defined as scope expressions.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.text = 'guest';
               $scope.word = /^\s*\w*\s*$/;
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           Single word: <input type="text" name="input" ng-model="text"
                               ng-pattern="word" required ng-trim="false">
           <span class="error" ng-show="myForm.input.$error.required">
             Required!</span>
           <span class="error" ng-show="myForm.input.$error.pattern">
             Single word only!</span>

           <tt>text = {{text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label. The model must always be a Date object.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable angular expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     * valid ISO date string (yyyy-MM-dd).
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     * a valid ISO date string (yyyy-MM-dd).
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange Angular expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.value = new Date(2013, 9, 22);
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          Pick a date in 2013:
          <input type="date" id="exampleInput" name="input" ng-model="value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.date">
              Not a valid date!</span>
           <tt>value = {{value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));
        var input = element(by.model('value'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[dateTimeLocal]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`. The model must be a Date object.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
    * valid ISO datetime format (yyyy-MM-ddTHH:mm:ss).
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
    * a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss).
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.value = new Date(2010, 11, 28, 14, 57);
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        Pick a date between in 2013:
        <input type="datetime-local" id="exampleInput" name="input" ng-model="value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
        <span class="error" ng-show="myForm.input.$error.datetimelocal">
            Not a valid date!</span>
        <tt>value = {{value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
   * valid ISO time format (HH:mm:ss).
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be a
   * valid ISO time format (HH:mm:ss).
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.value = new Date(1970, 0, 1, 14, 57, 0);
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        Pick a between 8am and 5pm:
        <input type="time" id="exampleInput" name="input" ng-model="value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
        <span class="error" ng-show="myForm.input.$error.time">
            Not a valid date!</span>
        <tt>value = {{value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`. The model must always be a Date object.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
    * valid ISO week format (yyyy-W##).
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
    * a valid ISO week format (yyyy-W##).
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.value = new Date(2013, 0, 3);
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        Pick a date between in 2013:
        <input id="exampleInput" type="week" name="input" ng-model="value"
            placeholder="YYYY-W##" min="2012-W32" max="2013-W52" required />
        <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
        <span class="error" ng-show="myForm.input.$error.week">
            Not a valid date!</span>
        <tt>value = {{value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`. The model must always be a Date object. In the event the model is
   * not set to the first of the month, the first of that model's month is assumed.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be
   * a valid ISO month format (yyyy-MM).
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must
   * be a valid ISO month format (yyyy-MM).
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.value = new Date(2013, 9, 1);
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       Pick a month int 2013:
       <input id="exampleInput" type="month" name="input" ng-model="value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <span class="error" ng-show="myForm.input.$error.required">
          Required!</span>
       <span class="error" ng-show="myForm.input.$error.month">
          Not a valid month!</span>
       <tt>value = {{value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength.
   * @param {string=} ngPattern Sets `pattern` validation error key if the value does not match the
   *    RegExp pattern expression. Expected value is `/regexp/` for inline patterns or `regexp` for
   *    patterns defined as scope expressions.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.value = 12;
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           Number: <input type="number" name="input" ng-model="value"
                          min="0" max="99" required>
           <span class="error" ng-show="myForm.input.$error.required">
             Required!</span>
           <span class="error" ng-show="myForm.input.$error.number">
             Not valid number!</span>
           <tt>value = {{value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength.
   * @param {string=} ngPattern Sets `pattern` validation error key if the value does not match the
   *    RegExp pattern expression. Expected value is `/regexp/` for inline patterns or `regexp` for
   *    patterns defined as scope expressions.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.text = 'http://google.com';
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           URL: <input type="url" name="input" ng-model="text" required>
           <span class="error" ng-show="myForm.input.$error.required">
             Required!</span>
           <span class="error" ng-show="myForm.input.$error.url">
             Not valid url!</span>
           <tt>text = {{text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength.
   * @param {string=} ngPattern Sets `pattern` validation error key if the value does not match the
   *    RegExp pattern expression. Expected value is `/regexp/` for inline patterns or `regexp` for
   *    patterns defined as scope expressions.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.text = 'me@example.com';
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             Email: <input type="email" name="input" ng-model="text" required>
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.email">
               Not valid email!</span>
             <tt>text = {{text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string} value The value to which the expression should be set when selected.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue Angular expression which sets the value to which the expression should
   *    be set when selected.
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = 'blue';
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <input type="radio" ng-model="color" value="red">  Red <br/>
           <input type="radio" ng-model="color" ng-value="specialValue"> Green <br/>
           <input type="radio" ng-model="color" value="blue"> Blue <br/>
           <tt>color = {{color | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var color = element(by.binding('color'));

            expect(color.getText()).toContain('blue');

            element.all(by.model('color')).get(0).click();

            expect(color.getText()).toContain('red');
          });
        </file>
      </example>
   */
  'radio': radioInputType,


  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.value1 = true;
               $scope.value2 = 'YES'
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           Value1: <input type="checkbox" ng-model="value1"> <br/>
           Value2: <input type="checkbox" ng-model="value2"
                          ng-true-value="'YES'" ng-false-value="'NO'"> <br/>
           <tt>value1 = {{value1}}</tt><br/>
           <tt>value2 = {{value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('value1'));
            var value2 = element(by.binding('value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('value1')).click();
            element(by.model('value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function testFlags(validity, flags) {
  var i, flag;
  if (flags) {
    for (i=0; i<flags.length; ++i) {
      flag = flags[i];
      if (validity[flag]) {
        return true;
      }
    }
  }
  return false;
}

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var validity = element.prop(VALIDITY_STATE_PROPERTY);
  var placeholder = element[0].placeholder, noevent = {};
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputing intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function(data) {
      composing = true;
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var listener = function(ev) {
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // IE (11 and under) seem to emit an 'input' event if the placeholder value changes.
    // We don't want to dirty the value when this happens, so we abort here. Unfortunately,
    // IE also sends input events for other non-input-related things, (such as focusing on a
    // form control), so this change is not entirely enough to solve this.
    if (msie && (ev || noevent).type === 'input' && element[0].placeholder !== placeholder) {
      placeholder = element[0].placeholder;
      return;
    }

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var timeout;

    var deferListener = function(ev) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          listener(ev);
          timeout = null;
        });
      }
    };

    element.on('keydown', function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event);
    });

    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  ctrl.$render = function() {
    element.val(ctrl.$isEmpty(ctrl.$modelValue) ? '' : ctrl.$viewValue);
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, date) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) == '"' && iso.charAt(iso.length-1) == '"') {
        iso = iso.substring(1, iso.length-1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (date) {
          map = {
            yyyy: date.getFullYear(),
            MM: date.getMonth() + 1,
            dd: date.getDate(),
            HH: date.getHours(),
            mm: date.getMinutes(),
            ss: date.getSeconds(),
            sss: date.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });
        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
    badInputChecker(scope, element, attr, ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
    var previousDate;

    ctrl.$$parserName = type;
    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;
      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        var parsedDate = parseDate(value, previousDate);
        if (timezone === 'UTC') {
          parsedDate.setMinutes(parsedDate.getMinutes() - parsedDate.getTimezoneOffset());
        }
        return parsedDate;
      }
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (!ctrl.$isEmpty(value)) {
        if (!isDate(value)) {
          throw $ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
        }
        previousDate = value;
        if (previousDate && timezone === 'UTC') {
          var timezoneOffset = 60000 * previousDate.getTimezoneOffset();
          previousDate = new Date(previousDate.getTime() + timezoneOffset);
        }
        return $filter('date')(value, format, timezone);
      } else {
        previousDate = null;
      }
      return '';
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal;
      ctrl.$validators.min = function(value) {
        return ctrl.$isEmpty(value) || isUndefined(minVal) || parseDate(value) >= minVal;
      };
      attr.$observe('min', function(val) {
        minVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal;
      ctrl.$validators.max = function(value) {
        return ctrl.$isEmpty(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
      };
      attr.$observe('max', function(val) {
        maxVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }
    // Override the standard $isEmpty to detect invalid dates as well
    ctrl.$isEmpty = function(value) {
      // Invalid Date: getTime() returns NaN
      return !value || (value.getTime && value.getTime() !== value.getTime());
    };

    function parseObservedDateValue(val) {
      return isDefined(val) ? (isDate(val) ? val : parseDate(val)) : undefined;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      // Detect bug in FF35 for input[email] (https://bugzilla.mozilla.org/show_bug.cgi?id=1064430):
      // - also sets validity.badInput (should only be validity.typeMismatch).
      // - see http://www.whatwg.org/specs/web-apps/current-work/multipage/forms.html#e-mail-state-(type=email)
      // - can ignore this case as we can still read out the erroneous email...
      return validity.badInput && !validity.typeMismatch ? undefined : value;
    });
  }
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  ctrl.$$parserName = 'number';
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw $ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });

  if (attr.min || attr.ngMin) {
    var minVal;
    ctrl.$validators.min = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
    };

    attr.$observe('min', function(val) {
      if (isDefined(val) && !isNumber(val)) {
        val = parseFloat(val, 10);
      }
      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (attr.max || attr.ngMax) {
    var maxVal;
    ctrl.$validators.max = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
    };

    attr.$observe('max', function(val) {
      if (isDefined(val) && !isNumber(val)) {
        val = parseFloat(val, 10);
      }
      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'url';
  ctrl.$validators.url = function(value) {
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'email';
  ctrl.$validators.email = function(value) {
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    if (element[0].checked) {
      ctrl.$setViewValue(attr.value, ev && ev.type);
    }
  };

  element.on('click', listener);

  ctrl.$render = function() {
    var value = attr.value;
    element[0].checked = (value == ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw minErr('ngModel')('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('click', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because an empty checkbox is never equal to the trueValue
  ctrl.$isEmpty = function(value) {
    return value !== trueValue;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with angular data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength.
 * @param {string=} ngPattern Sets `pattern` validation error key if the value does not match the
 *    RegExp pattern expression. Expected value is `/regexp/` for inline patterns or `regexp` for
 *    patterns defined as scope expressions.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control with angular data-binding. Input control follows HTML5 input types
 * and polyfills the HTML5 validation behavior for older browsers.
 *
 * *NOTE* Not every feature offered is available for all input types.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength.
 * @param {string=} ngPattern Sets `pattern` validation error key if the value does not match the
 *    RegExp pattern expression. Expected value is `/regexp/` for inline patterns or `regexp` for
 *    patterns defined as scope expressions.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           User name: <input type="text" name="userName" ng-model="user.name" required>
           <span class="error" ng-show="myForm.userName.$error.required">
             Required!</span><br>
           Last name: <input type="text" name="lastName" ng-model="user.last"
             ng-minlength="3" ng-maxlength="10">
           <span class="error" ng-show="myForm.lastName.$error.minlength">
             Too short!</span>
           <span class="error" ng-show="myForm.lastName.$error.maxlength">
             Too long!</span><br>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];

var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    PENDING_CLASS = 'ng-pending';

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 *
 * @property {string} $viewValue Actual string value in the view.
 * @property {*} $modelValue The value in the model, that the control is bound to.
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
       the control reads value from the DOM.  Each function is called, in turn, passing the value
       through to the next. The last return value is used to populate the model.
       Used to sanitize / convert the value as well as validation. For validation,
       the parsers should update the validity state using
       {@link ngModel.NgModelController#$setValidity $setValidity()},
       and return `undefined` for invalid values.

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
       the model value changes. Each function is called, in turn, passing the value through to the
       next. Used to format / convert values for display in the control and validation.
 * ```js
 * function formatter(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(formatter);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. Also, keep in mind that all
 *      asynchronous validators will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @param {string} name The name of the validator.
 * @param {Function} validationFn The validation function that will be run.
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
 *     view value has changed. It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 *
 * @description
 *
 * `NgModelController` provides API for the `ng-model` directive. The controller contains
 * services for data-binding, validation, CSS updates, and value formatting and parsing. It
 * purposefully does not contain any logic which deals with DOM rendering or listening to
 * DOM events. Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding.
 *
 * ## Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * Note that `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.  This will not work on older browsers.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$apply(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if ( attrs.stripBr && html == '<br>' ) {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);


  var parsedNgModel = $parse($attr.ngModel),
      pendingDebounce = null,
      ctrl = this;

  var ngModelGet = function ngModelGet() {
    var modelValue = parsedNgModel($scope);
    if (ctrl.$options && ctrl.$options.getterSetter && isFunction(modelValue)) {
      modelValue = modelValue();
    }
    return modelValue;
  };

  var ngModelSet = function ngModelSet(newValue) {
    var getterSetter;
    if (ctrl.$options && ctrl.$options.getterSetter &&
        isFunction(getterSetter = parsedNgModel($scope))) {

      getterSetter(ctrl.$modelValue);
    } else {
      parsedNgModel.assign($scope, ctrl.$modelValue);
    }
  };

  this.$$setOptions = function(options) {
    ctrl.$options = options;

    if (!parsedNgModel.assign && (!options || !options.getterSetter)) {
      throw $ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
          $attr.ngModel, startingTag($element));
    }
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different to last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different to their previous value. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  this.$render = noop;

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of the input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different to the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value Model value to check.
   * @returns {boolean} True if `value` is empty.
   */
  this.$isEmpty = function(value) {
    return isUndefined(value) || value === '' || value === null || value !== value;
  };

  var parentForm = $element.inheritedData('$formController') || nullFormCtrl,
      currentValidationRunId = 0;

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setValidity
   *
   * @description
   * Change the validity state, and notifies the form.
   *
   * This method can be called within $parsers/$formatters. However, if possible, please use the
   *        `ngModel.$validators` pipeline which is designed to call this method automatically.
   *
   * @param {string} validationErrorKey Name of the validator. the `validationErrorKey` will assign
   *        to `$error[validationErrorKey]` and `$pending[validationErrorKey]`
   *        so that it is available for data-binding.
   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
   *                          or skipped (null).
   */
  addSetValidityMethod({
    ctrl: this,
    $element: $element,
    set: function(object, property) {
      object[property] = true;
    },
    unset: function(object, property) {
      delete object[property];
    },
    parentForm: parentForm,
    $animate: $animate
  });

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the 'ng-dirty' class and set the control to its pristine
   * state (ng-pristine class). A model is considered to be pristine when the model has not been changed
   * from when first compiled within then form.
   */
  this.$setPristine = function () {
    ctrl.$dirty = false;
    ctrl.$pristine = true;
    $animate.removeClass($element, DIRTY_CLASS);
    $animate.addClass($element, PRISTINE_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the control to its
   * untouched state (ng-untouched class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  this.$setUntouched = function() {
    ctrl.$touched = false;
    ctrl.$untouched = true;
    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the 'ng-untouched' class and set the control to its
   * touched state (ng-touched class). A model is considered to be touched when the user has
   * first interacted (focussed) on the model input element and then shifted focus away (blurred)
   * from the input element.
   */
  this.$setTouched = function() {
    ctrl.$touched = true;
    ctrl.$untouched = false;
    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for a some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced events or events such
   * as blur you can have a situation where there is a period when the `$viewValue`
   * is out of synch with the ngModel's `$modelValue`.
   *
   * In this case, you can run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because Angular's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.resetWithCancel = function (e) {
   *         if (e.keyCode == 27) {
   *           $scope.myForm.myInput1.$rollbackViewValue();
   *           $scope.myValue = '';
   *         }
   *       };
   *       $scope.resetWithoutCancel = function (e) {
   *         if (e.keyCode == 27) {
   *           $scope.myValue = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Try typing something in each input.  See that the model only updates when you
   *          blur off the input.
   *        </p>
   *        <p>Now see what happens if you start typing then press the Escape key</p>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <p>With $rollbackViewValue()</p>
   *         <input name="myInput1" ng-model="myValue" ng-keydown="resetWithCancel($event)"><br/>
   *         myValue: "{{ myValue }}"
   *
   *         <p>Without $rollbackViewValue()</p>
   *         <input name="myInput2" ng-model="myValue" ng-keydown="resetWithoutCancel($event)"><br/>
   *         myValue: "{{ myValue }}"
   *       </form>
   *     </div>
   *   </file>
   * </example>
   */
  this.$rollbackViewValue = function() {
    $timeout.cancel(pendingDebounce);
    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
    ctrl.$render();
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then asynchronous validators).
   */
  this.$validate = function() {
    // ignore $validate before model is initialized
    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
      return;
    }
    this.$$parseAndValidate();
  };

  this.$$runValidators = function(parseValid, modelValue, viewValue, doneCallback) {
    currentValidationRunId++;
    var localValidationRunId = currentValidationRunId;

    // check parser error
    if (!processParseErrors(parseValid)) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors(parseValid) {
      var errorKey = ctrl.$$parserName || 'parse';
      if (parseValid === undefined) {
        setValidity(errorKey, null);
      } else {
        setValidity(errorKey, parseValid);
        if (!parseValid) {
          forEach(ctrl.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(ctrl.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
          return false;
        }
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(ctrl.$validators, function(validator, name) {
        var result = validator(modelValue, viewValue);
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(ctrl.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(ctrl.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw $ngModelMinErr("$asyncValidators",
            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function(error) {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        $q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === currentValidationRunId) {
        ctrl.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  this.$commitViewValue = function() {
    var viewValue = ctrl.$viewValue;

    $timeout.cancel(pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
      return;
    }
    ctrl.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (ctrl.$pristine) {
      ctrl.$dirty = true;
      ctrl.$pristine = false;
      $animate.removeClass($element, PRISTINE_CLASS);
      $animate.addClass($element, DIRTY_CLASS);
      parentForm.$setDirty();
    }
    this.$$parseAndValidate();
  };

  this.$$parseAndValidate = function() {
    var viewValue = ctrl.$$lastCommittedViewValue;
    var modelValue = viewValue;
    var parserValid = isUndefined(modelValue) ? undefined : true;

    if (parserValid) {
      for(var i = 0; i < ctrl.$parsers.length; i++) {
        modelValue = ctrl.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          parserValid = false;
          break;
        }
      }
    }
    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
      // ctrl.$modelValue has not been touched yet...
      ctrl.$modelValue = ngModelGet();
    }
    var prevModelValue = ctrl.$modelValue;
    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
    if (allowInvalid) {
      ctrl.$modelValue = modelValue;
      writeToModelIfNeeded();
    }
    ctrl.$$runValidators(parserValid, modelValue, viewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check ctrl.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        ctrl.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (ctrl.$modelValue !== prevModelValue) {
        ctrl.$$writeModelToScope();
      }
    }
  };

  this.$$writeModelToScope = function() {
    ngModelSet(ctrl.$modelValue);
    forEach(ctrl.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch(e) {
        $exceptionHandler(e);
      }
    });
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when an input directive want to change the view value; typically,
   * this is done from within a DOM event handler.
   *
   * For example {@link ng.directive:input input} calls it when the value of the input changes and
   * {@link ng.directive:select select} calls it when an option is selected.
   *
   * If the new `value` is an object (rather than a string or a number), we should make a copy of the
   * object before passing it to `$setViewValue`.  This is because `ngModel` does not perform a deep
   * watch of objects, it only looks for a change of identity. If you only change the property of
   * the object then ngModel will not realise that the object has changed and will not invoke the
   * `$parsers` and `$validators` pipelines.
   *
   * For this reason, you should not change properties of the copy once it has been passed to
   * `$setViewValue`. Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * When this method is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value sent directly for processing, finally to be applied to `$modelValue` and then the
   * **expression** specified in the `ng-model` attribute.
   *
   * Lastly, all the registered change listeners, in the `$viewChangeListeners` list, are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   *
   * Note that calling this function does not trigger a `$digest`.
   *
   * @param {string} value Value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  this.$setViewValue = function(value, trigger) {
    ctrl.$viewValue = value;
    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
      ctrl.$$debounceViewValueCommit(trigger);
    }
  };

  this.$$debounceViewValueCommit = function(trigger) {
    var debounceDelay = 0,
        options = ctrl.$options,
        debounce;

    if (options && isDefined(options.debounce)) {
      debounce = options.debounce;
      if (isNumber(debounce)) {
        debounceDelay = debounce;
      } else if (isNumber(debounce[trigger])) {
        debounceDelay = debounce[trigger];
      } else if (isNumber(debounce['default'])) {
        debounceDelay = debounce['default'];
      }
    }

    $timeout.cancel(pendingDebounce);
    if (debounceDelay) {
      pendingDebounce = $timeout(function() {
        ctrl.$commitViewValue();
      }, debounceDelay);
    } else if ($rootScope.$$phase) {
      ctrl.$commitViewValue();
    } else {
      $scope.$apply(function() {
        ctrl.$commitViewValue();
      });
    }
  };

  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  $scope.$watch(function ngModelWatch() {
    var modelValue = ngModelGet();

    // if scope model value and ngModel value are out of sync
    // TODO(perf): why not move this to the action fn?
    if (modelValue !== ctrl.$modelValue) {
      ctrl.$modelValue = modelValue;

      var formatters = ctrl.$formatters,
          idx = formatters.length;

      var viewValue = modelValue;
      while(idx--) {
        viewValue = formatters[idx](viewValue);
      }
      if (ctrl.$viewValue !== viewValue) {
        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
        ctrl.$render();

        ctrl.$$runValidators(undefined, modelValue, viewValue, noop);
      }
    }

    return modelValue;
  });
}];


/**
 * @ngdoc directive
 * @name ngModel
 *
 * @element input
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`, `ng-untouched`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [https://github.com/angular/angular.js/wiki/Understanding-Scopes]
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[dateTimeLocal] dateTimeLocal}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * # CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid` is set if the model is valid.
 *  - `ng-invalid` is set if the model is invalid.
 *  - `ng-pristine` is set if the model is pristine.
 *  - `ng-dirty` is set if the model is dirty.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * ## Animation Hooks
 *
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes are: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           -webkit-transition:all linear 0.5s;
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       Update input to see transitions when valid/invalid.
       Integer is a valid value.
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input" />
       </form>
     </file>
 * </example>
 *
 * ## Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different than what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           Name:
           <input type="text" name="userName"
                  ng-model="user.name"
                  ng-model-options="{ getterSetter: true }" />
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function (newName) {
               if (angular.isDefined(newName)) {
                 _name = newName;
               }
               return _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = function() {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || nullFormCtrl;

          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              formCtrl.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            formCtrl.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
            element.on(modelCtrl.$options.updateOn, function(ev) {
              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
            });
          }

          element.on('blur', function(ev) {
            if (modelCtrl.$touched) return;

            scope.$apply(function() {
              modelCtrl.$setTouched();
            });
          });
        }
      };
    }
  };
};


/**
 * @ngdoc directive
 * @name ngChange
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element input
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});


var requiredDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      attr.required = true; // force truthy in case we are on non input element

      ctrl.$validators.required = function(value) {
        return !attr.required || !ctrl.$isEmpty(value);
      };

      attr.$observe('required', function() {
        ctrl.$validate();
      });
    }
  };
};


var patternDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var regexp, patternExp = attr.ngPattern || attr.pattern;
      attr.$observe('pattern', function(regex) {
        if (isString(regex) && regex.length > 0) {
          regex = new RegExp(regex);
        }

        if (regex && !regex.test) {
          throw minErr('ngPattern')('noregexp',
            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
            regex, startingTag(elm));
        }

        regexp = regex || undefined;
        ctrl.$validate();
      });

      ctrl.$validators.pattern = function(value) {
        return ctrl.$isEmpty(value) || isUndefined(regexp) || regexp.test(value);
      };
    }
  };
};


var maxlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = 0;
      attr.$observe('maxlength', function(value) {
        maxlength = int(value) || 0;
        ctrl.$validate();
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(modelValue) || viewValue.length <= maxlength;
      };
    }
  };
};

var minlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = 0;
      attr.$observe('minlength', function(value) {
        minlength = int(value) || 0;
        ctrl.$validate();
      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(modelValue) || viewValue.length >= minlength;
      };
    }
  };
};


/**
 * @ngdoc directive
 * @name ngList
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * ### Example with Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      List: <input name="namesInput" ng-model="names" ng-list required>
 *      <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * ### Example - splitting on whitespace
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 * @element input
 * @param {string=} ngList optional delimiter that should be used to split the value.
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      // We want to control whitespace trimming so we use this convoluted approach
      // to access the ngList attribute, which doesn't pre-trim the attribute
      var ngList = element.attr(attr.$attr.ngList) || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};


var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 *
 * @description
 * Binds the given expression to the value of `input[select]` or `input[radio]`, so
 * that when the element is selected, the `ngModel` of that element is set to the
 * bound value.
 *
 * `ngValue` is useful when dynamically generating lists of radio buttons using `ng-repeat`, as
 * shown below.
 *
 * @element input
 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
 *   of the `input` element
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          attr.$set('value', scope.$eval(attr.ngValue));
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            attr.$set('value', value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngModelOptions
 *
 * @description
 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
 * events that will trigger a model update and/or a debouncing delay so that the actual update only
 * takes place when a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different than the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
 *
 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
 *   - `updateOn`: string specifying which event should be the input bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging of the control.
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     `ng-model-options="{ updateOn: 'default blur', debounce: {'default': 500, 'blur': 0} }"`
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
       `ngModel` as getters/setters.
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date">`, `<input type="time">`, ... . Right now, the only supported value is `'UTC'`,
 *     otherwise the default timezone of the browser will be used.
 *
 * @example

  The following example shows how to override immediate updates. Changes on the inputs within the
  form will update the model only when the control loses focus (blur event). If `escape` key is
  pressed while the input field is focused, the value is reset to the value in the current model.

  <example name="ngModelOptions-directive-blur" module="optionsExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          Name:
          <input type="text" name="userName"
                 ng-model="user.name"
                 ng-model-options="{ updateOn: 'blur' }"
                 ng-keyup="cancel($event)" /><br />

          Other data:
          <input type="text" ng-model="user.data" /><br />
        </form>
        <pre>user.name = <span ng-bind="user.name"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.user = { name: 'say', data: '' };

          $scope.cancel = function (e) {
            if (e.keyCode == 27) {
              $scope.userForm.userName.$rollbackViewValue();
            }
          };
        }]);
    </file>
    <file name="protractor.js" type="protractor">
      var model = element(by.binding('user.name'));
      var input = element(by.model('user.name'));
      var other = element(by.model('user.data'));

      it('should allow custom events', function() {
        input.sendKeys(' hello');
        input.click();
        expect(model.getText()).toEqual('say');
        other.click();
        expect(model.getText()).toEqual('say hello');
      });

      it('should $rollbackViewValue when model changes', function() {
        input.sendKeys(' hello');
        expect(input.getAttribute('value')).toEqual('say hello');
        input.sendKeys(protractor.Key.ESCAPE);
        expect(input.getAttribute('value')).toEqual('say');
        other.click();
        expect(model.getText()).toEqual('say');
      });
    </file>
  </example>

  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.

  <example name="ngModelOptions-directive-debounce" module="optionsExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          Name:
          <input type="text" name="userName"
                 ng-model="user.name"
                 ng-model-options="{ debounce: 1000 }" />
          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
        </form>
        <pre>user.name = <span ng-bind="user.name"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.user = { name: 'say' };
        }]);
    </file>
  </example>

  This one shows how to bind to getter/setters:

  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          Name:
          <input type="text" name="userName"
                 ng-model="user.name"
                 ng-model-options="{ getterSetter: true }" />
        </form>
        <pre>user.name = <span ng-bind="user.name()"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('getterSetterExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          var _name = 'Brian';
          $scope.user = {
            name: function (newName) {
              return angular.isDefined(newName) ? (_name = newName) : _name;
            }
          };
        }]);
    </file>
  </example>
 */
var ngModelOptionsDirective = function() {
  return {
    restrict: 'A',
    controller: ['$scope', '$attrs', function($scope, $attrs) {
      var that = this;
      this.$options = $scope.$eval($attrs.ngModelOptions);
      // Allow adding/overriding bound events
      if (this.$options.updateOn !== undefined) {
        this.$options.updateOnDefault = false;
        // extract "default" pseudo-event from list of events that can trigger a model update
        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
          that.$options.updateOnDefault = true;
          return ' ';
        }));
      } else {
        this.$options.updateOnDefault = true;
      }
    }]
  };
};

// helper methods
function addSetValidityMethod(context) {
  var ctrl = context.ctrl,
      $element = context.$element,
      classCache = {},
      set = context.set,
      unset = context.unset,
      parentForm = context.parentForm,
      $animate = context.$animate;

  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));

  ctrl.$setValidity = setValidity;

  function setValidity(validationErrorKey, state, options) {
    if (state === undefined) {
      createAndSet('$pending', validationErrorKey, options);
    } else {
      unsetAndCleanup('$pending', validationErrorKey, options);
    }
    if (!isBoolean(state)) {
      unset(ctrl.$error, validationErrorKey, options);
      unset(ctrl.$$success, validationErrorKey, options);
    } else {
      if (state) {
        unset(ctrl.$error, validationErrorKey, options);
        set(ctrl.$$success, validationErrorKey, options);
      } else {
        set(ctrl.$error, validationErrorKey, options);
        unset(ctrl.$$success, validationErrorKey, options);
      }
    }
    if (ctrl.$pending) {
      cachedToggleClass(PENDING_CLASS, true);
      ctrl.$valid = ctrl.$invalid = undefined;
      toggleValidationCss('', null);
    } else {
      cachedToggleClass(PENDING_CLASS, false);
      ctrl.$valid = isObjectEmpty(ctrl.$error);
      ctrl.$invalid = !ctrl.$valid;
      toggleValidationCss('', ctrl.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in ctrl.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (ctrl.$error[validationErrorKey]) {
      combinedState = false;
    } else if (ctrl.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }
    toggleValidationCss(validationErrorKey, combinedState);
    parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
  }

  function createAndSet(name, value, options) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, options);
  }

  function unsetAndCleanup(name, value, options) {
    if (ctrl[name]) {
      unset(ctrl[name], value, options);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(className, switchValue) {
    if (switchValue && !classCache[className]) {
      $animate.addClass($element, className);
      classCache[className] = true;
    } else if (!switchValue && classCache[className]) {
      $animate.removeClass($element, className);
      classCache[className] = false;
    }
  }

  function toggleValidationCss(validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      return false;
    }
  }
  return true;
}

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         Enter name: <input type="text" ng-model="name"><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = value === undefined ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function ($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        Salutation: <input type="text" ng-model="salutation"><br>
        Name: <input type="text" ng-model="name"><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = value === undefined ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Creates a binding that will innerHTML the result of evaluating the `expression` into the current
 * element in a secure way.  By default, the innerHTML-ed content will be sanitized using the {@link
 * ngSanitize.$sanitize $sanitize} service.  To utilize this functionality, ensure that `$sanitize`
 * is available, for example, by including {@link ngSanitize} in your module's dependencies (not in
 * core Angular). In order to use {@link ngSanitize} in your module's dependencies, you need to
 * include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function getStringValue(value) {
        return (value || '').toString();
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // we re-evaluate the expr because we want a TrustedValueHolderType
          // for $sce, not a string
          element.html($sce.getTrustedHtml(ngBindHtmlGetter(scope)) || '');
        });
      };
    }
  };
}];

function classDirective(name, selector) {
  name = 'ngClass' + name;
  return ['$animate', function($animate) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var oldVal;

        scope.$watch(attr[name], ngClassWatchAction, true);

        attr.$observe('class', function(value) {
          ngClassWatchAction(scope.$eval(attr[name]));
        });


        if (name !== 'ngClass') {
          scope.$watch('$index', function($index, old$index) {
            // jshint bitwise: false
            var mod = $index & 1;
            if (mod !== (old$index & 1)) {
              var classes = arrayClasses(scope.$eval(attr[name]));
              mod === selector ?
                addClasses(classes) :
                removeClasses(classes);
            }
          });
        }

        function addClasses(classes) {
          var newClasses = digestClassCounts(classes, 1);
          attr.$addClass(newClasses);
        }

        function removeClasses(classes) {
          var newClasses = digestClassCounts(classes, -1);
          attr.$removeClass(newClasses);
        }

        function digestClassCounts (classes, count) {
          var classCounts = element.data('$classCounts') || {};
          var classesToUpdate = [];
          forEach(classes, function (className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });
          element.data('$classCounts', classCounts);
          return classesToUpdate.join(' ');
        }

        function updateClasses (oldClasses, newClasses) {
          var toAdd = arrayDifference(newClasses, oldClasses);
          var toRemove = arrayDifference(oldClasses, newClasses);
          toAdd = digestClassCounts(toAdd, 1);
          toRemove = digestClassCounts(toRemove, -1);
          if (toAdd && toAdd.length) {
            $animate.addClass(element, toAdd);
          }
          if (toRemove && toRemove.length) {
            $animate.removeClass(element, toRemove);
          }
        }

        function ngClassWatchAction(newVal) {
          if (selector === true || scope.$index % 2 === selector) {
            var newClasses = arrayClasses(newVal || []);
            if (!oldVal) {
              addClasses(newClasses);
            } else if (!equals(newVal,oldVal)) {
              var oldClasses = arrayClasses(oldVal);
              updateClasses(oldClasses, newClasses);
            }
          }
          oldVal = shallowCopy(newVal);
        }
      }
    };

    function arrayDifference(tokens1, tokens2) {
      var values = [];

      outer:
      for(var i = 0; i < tokens1.length; i++) {
        var token = tokens1[i];
        for(var j = 0; j < tokens2.length; j++) {
          if(token == tokens2[j]) continue outer;
        }
        values.push(token);
      }
      return values;
    }

    function arrayClasses (classVal) {
      if (isArray(classVal)) {
        return classVal;
      } else if (isString(classVal)) {
        return classVal.split(' ');
      } else if (isObject(classVal)) {
        var classes = [], i = 0;
        forEach(classVal, function(v, k) {
          if (v) {
            classes = classes.concat(k.split(' '));
          }
        });
        return classes;
      }
      return classVal;
    }
  }];
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an array, each element of the array should be a string that is
 * one or more space-delimited class names.
 *
 * 3. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then the
 * new classes are added.
 *
 * @animations
 * add - happens just before the class is applied to the element
 * remove - happens just before the class is removed from the element
 *
 * @element ANY
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example Example that demonstrates basic bindings via ngClass directive.
   <example>
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, red: error}">Map Syntax Example</p>
       <input type="checkbox" ng-model="deleted"> deleted (apply "strike" class)<br>
       <input type="checkbox" ng-model="important"> important (apply "bold" class)<br>
       <input type="checkbox" ng-model="error"> error (apply "red" class)
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style" placeholder="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1" placeholder="Type: bold, strike or red"><br>
       <input ng-model="style2" placeholder="Type: bold, strike or red"><br>
       <input ng-model="style3" placeholder="Type: bold, strike or red"><br>
     </file>
     <file name="style.css">
       .strike {
         text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/red/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/red/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.last().getAttribute('class')).toBe('bold strike red');
       });
     </file>
   </example>

   ## Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>


   ## ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link ng.$animate#addClass $animate.addClass} and
   {@link ng.$animate#removeClass $animate.removeClass}.
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example>
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example>
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * Legacy browsers, like IE7, do not provide attribute selector support (added in CSS 2.1) so they
 * cannot match the `[ng\:cloak]` selector. To work around this limitation, you must add the css
 * class `ng-cloak` in addition to the `ngCloak` directive as shown in the example below.
 *
 * @element ANY
 *
 * @example
   <example>
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" ng-cloak class="ng-cloak">{{ 'hello IE7' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * If the current `$controllerProvider` is configured to use globals (via
 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
 * also be the name of a globally accessible constructor function (not recommended).
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the angular markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the Angular community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      Name: <input type="text" ng-model="settings.name"/>
 *      [ <a href="" ng-click="settings.greet()">greet</a> ]<br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value"/>
 *          [ <a href="" ng-click="settings.clearContact(contact)">clear</a>
 *          | <a href="" ng-click="settings.removeContact(contact)">X</a> ]
 *        </li>
 *        <li>[ <a href="" ng-click="settings.addContact()">add</a> ]</li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = "John Smith";
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'} ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.linkText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.linkText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     Name: <input type="text" ng-model="name"/>
 *     [ <a href="" ng-click="greet()">greet</a> ]<br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value"/>
 *         [ <a href="" ng-click="clearContact(contact)">clear</a>
 *         | <a href="" ng-click="removeContact(contact)">X</a> ]
 *       </li>
 *       <li>[ <a href="" ng-click="addContact()">add</a> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = "John Smith";
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'} ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.linkText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.linkText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @element html
 * @description
 * Enables [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) support.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 * CSP forbids apps to use `eval` or `Function(string)` generated functions (among other things).
 * For Angular to be CSP compatible there are only two things that we need to do differently:
 *
 * - don't use `Function` constructor to generate optimized value getters
 * - don't inject custom stylesheet into the document
 *
 * AngularJS uses `Function(string)` generated functions as a speed optimization. Applying the `ngCsp`
 * directive will cause Angular to use CSP compatibility mode. When this mode is on AngularJS will
 * evaluate all expressions up to 30% slower than in non-CSP mode, but no security violations will
 * be raised.
 *
 * CSP forbids JavaScript to inline stylesheet rules. In non CSP mode Angular automatically
 * includes some CSS rules (e.g. {@link ng.directive:ngCloak ngCloak}).
 * To make those directives work in CSP mode, include the `angular-csp.css` manually.
 *
 * Angular tries to autodetect if CSP is active and automatically turn on the CSP-safe mode. This
 * autodetection however triggers a CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on the root element of the application or on the `angular.js` script tag, whichever
 * appears first in the html document.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * @example
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```
  * @example
      // Note: the suffix `.csp` in the example name triggers
      // csp mode in our http server!
      <example name="example.csp" module="cspExample" ng-csp="true">
        <file name="index.html">
          <div ng-controller="MainController as ctrl">
            <div>
              <button ng-click="ctrl.inc()" id="inc">Increment</button>
              <span id="counter">
                {{ctrl.counter}}
              </span>
            </div>

            <div>
              <button ng-click="ctrl.evil()" id="evil">Evil</button>
              <span id="evilError">
                {{ctrl.evilError}}
              </span>
            </div>
          </div>
        </file>
        <file name="script.js">
           angular.module('cspExample', [])
             .controller('MainController', function() {
                this.counter = 0;
                this.inc = function() {
                  this.counter++;
                };
                this.evil = function() {
                  // jshint evil:true
                  try {
                    eval('1+2');
                  } catch (e) {
                    this.evilError = e.message;
                  }
                };
              });
        </file>
        <file name="protractor.js" type="protractor">
          var util, webdriver;

          var incBtn = element(by.id('inc'));
          var counter = element(by.id('counter'));
          var evilBtn = element(by.id('evil'));
          var evilError = element(by.id('evilError'));

          function getAndClearSevereErrors() {
            return browser.manage().logs().get('browser').then(function(browserLog) {
              return browserLog.filter(function(logEntry) {
                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
              });
            });
          }

          function clearErrors() {
            getAndClearSevereErrors();
          }

          function expectNoErrors() {
            getAndClearSevereErrors().then(function(filteredLog) {
              expect(filteredLog.length).toEqual(0);
              if (filteredLog.length) {
                console.log('browser console errors: ' + util.inspect(filteredLog));
              }
            });
          }

          function expectError(regex) {
            getAndClearSevereErrors().then(function(filteredLog) {
              var found = false;
              filteredLog.forEach(function(log) {
                if (log.message.match(regex)) {
                  found = true;
                }
              });
              if (!found) {
                throw new Error('expected an error that matches ' + regex);
              }
            });
          }

          beforeEach(function() {
            util = require('util');
            webdriver = require('protractor/node_modules/selenium-webdriver');
          });

          // For now, we only test on Chrome,
          // as Safari does not load the page with Protractor's injected scripts,
          // and Firefox webdriver always disables content security policy (#6358)
          if (browser.params.browser !== 'chrome') {
            return;
          }

          it('should not report errors when the page is loaded', function() {
            // clear errors so we are not dependent on previous tests
            clearErrors();
            // Need to reload the page as the page is already loaded when
            // we come here
            browser.driver.getCurrentUrl().then(function(url) {
              browser.get(url);
            });
            expectNoErrors();
          });

          it('should evaluate expressions', function() {
            expect(counter.getText()).toEqual('0');
            incBtn.click();
            expect(counter.getText()).toEqual('1');
            expectNoErrors();
          });

          it('should throw and report an error when using "eval"', function() {
            evilBtn.click();
            expect(evilError.getText()).toMatch(/Content Security Policy/);
            expectError(/Content Security Policy/);
          });
        </file>
      </example>
  */

// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
// bootstrap the system (before $parse is instantiated), for this reason we just have
// the csp.isActive() fn that looks for ng-csp attribute anywhere in the current doc

/**
 * @ngdoc directive
 * @name ngClick
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A directive that allows creation of custom onclick handlers that are defined as angular
 * expressions and are compiled and executed within the current scope.
 *
 * Events that are handled via these handler are always configured not to propagate further.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
      return {
        restrict: 'A',
        compile: function($element, attr) {
          var fn = $parse(attr[directiveName]);
          return function ngEventHandler(scope, element) {
            element.on(eventName, function(event) {
              var callback = function() {
                fn(scope, {$event:event});
              };
              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                scope.$evalAsync(callback);
              } else {
                scope.$apply(callback);
              }
            });
          };
        }
      };
    }];
  }
);

/**
 * @ngdoc directive
 * @name ngDblclick
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @element ANY
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 *
 * @description
 * Enables binding angular expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @element form
 * @priority 0
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * enter - happens just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container
 * leave - happens just before the `ngIf` contents are removed from the DOM
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', function($animate) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function ($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function (clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = document.createComment(' end ngIf: ' + $attr.ngIf + ' ');
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).then(function() {
                previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * enter - animation is used to bring new content into the browser.
 * leave - animation is used to animate existing content away.
 *
 * The enter and leave animation occur concurrently.
 *
 * @scope
 * @priority 400
 *
 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <tt>{{template.url}}</tt>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [ { name: 'template1.html', url: 'template1.html'},
              { name: 'template2.html', url: 'template2.html'} ];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser == 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser == 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erronous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate', '$sce',
                  function($templateRequest,   $anchorScroll,   $animate,   $sce) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if(previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if(currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if(currentElement) {
            $animate.leave(currentElement).then(function() {
              previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch($sce.parseAsResourceUrl(srcExp), function ngIncludeWatchAction(src) {
          var afterAnimation = function() {
            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
              $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).then(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (/SVG/.test($element[0].toString())) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, undefined, undefined, $element);
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-error">
 * The only appropriate use of `ngInit` is for aliasing special properties of
 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below. Besides this case, you
 * should use {@link guide/controller controllers} rather than `ngInit`
 * to initialize values on a scope.
 * </div>
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with {@link ng.$filter `$filter`}, make
 * sure you have parenthesis for correct precedence:
 * <pre class="prettyprint">
 *   <div ng-init="test1 = (data | orderBy:'name')"></div>
 * </pre>
 * </div>
 *
 * @priority 450
 *
 * @element ANY
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @example
   <example module="initExample">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 *
 * @description
 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
 * DOM element. This is useful if the element contains what appears to be Angular directives and
 * bindings but which should be ignored by Angular. This could be the case if you have a site that
 * displays snippets of code, for instance.
 *
 * @element ANY
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
 * @example
    <example>
      <file name="index.html">
        <div>Normal: {{1 + 2}}</div>
        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
      </file>
      <file name="protractor.js" type="protractor">
       it('should check ng-non-bindable', function() {
         expect(element(by.binding('1 + 2')).getText()).toContain('3');
         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
       });
      </file>
    </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * # Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in Angular's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * # Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * Angular expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, Angular will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * # Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          Person 1:<input type="text" ng-model="person1" value="Igor" /><br/>
          Person 2:<input type="text" ng-model="person2" value="Misko" /><br/>
          Number of People:<input type="text" ng-model="personCount" value="1" /><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', function($locale, $interpolate) {
  var BRACE = /{}/g;
  return {
    restrict: 'EA',
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          isWhen = /^when(Minus)?(.+)$/;

      forEach(attr, function(expression, attributeName) {
        if (isWhen.test(attributeName)) {
          whens[lowercase(attributeName.replace('when', '').replace('Minus', '-'))] =
            element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] =
          $interpolate(expression.replace(BRACE, startSymbol + numberExp + '-' +
            offset + endSymbol));
      });

      scope.$watch(function ngPluralizeWatch() {
        var value = parseFloat(scope.$eval(numberExp));

        if (!isNaN(value)) {
          //if explicit number rule such as 1, 2, 3... is defined, just use it. Otherwise,
          //check it against pluralization rules in $locale service
          if (!(value in whens)) value = $locale.pluralCat(value - offset);
           return whensExpFns[value](scope);
        } else {
          return '';
        }
      }, function ngPluralizeWatchAction(newVal) {
        element.text(newVal);
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRepeat
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 * This may be useful when, for instance, nesting ngRepeats.
 *
 * # Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * **.enter** - when a new item is added to the list or when an item is revealed after a filter
 *
 * **.leave** - when an item is removed from the list or when an item is filtered out
 *
 * **.move** - when an adjacent item is filtered out causing a reorder or when the item contents are reordered
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking function
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking function
 *     is specified the ng-repeat associates elements by identity in the collection. It is an error to have
 *     more than one tracking function to resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)  Filters should be applied to the expression,
 *     before specifying a tracking expression.
 *
 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
 *     will be associated by item identity in the array.
 *
 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
 *     element in the same way in the DOM.
 *
 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
 *     property is same.
 *
 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
 *     to items in conjunction with a tracking expression.
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 * @example
 * This example initializes the scope to a list of names and
 * then uses `ngRepeat` to display every person:
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-init="friends = [
        {name:'John', age:25, gender:'boy'},
        {name:'Jessie', age:30, gender:'girl'},
        {name:'Johanna', age:28, gender:'girl'},
        {name:'Joy', age:15, gender:'girl'},
        {name:'Mary', age:28, gender:'girl'},
        {name:'Peter', age:95, gender:'boy'},
        {name:'Sebastian', age:50, gender:'boy'},
        {name:'Erika', age:27, gender:'girl'},
        {name:'Patrick', age:40, gender:'boy'},
        {name:'Samantha', age:60, gender:'girl'}
      ]">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length == 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:40px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        -webkit-transition:all linear 0.5s;
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:40px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', function($parse, $animate) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // jshint bitwise: false
    scope.$odd = !(scope.$even = (index&1) === 0);
    // jshint bitwise: true
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };


  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = document.createComment(' end ngRepeat: ' + expression + ' ');

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:([\$\w]+)|\(([\$\w]+)\s*,\s*([\$\w]+)\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
          aliasAs);
      }

      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
      var hashFnLocals = {$id: hashKey};

      if (trackByExp) {
        trackByExpGetter = $parse(trackByExp);
      } else {
        trackByIdArrayFn = function (key, value) {
          return hashKey(value);
        };
        trackByIdObjFn = function (key) {
          return key;
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        if (trackByExpGetter) {
          trackByIdExpFn = function(key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        }

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - element: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, sort them and use to determine order of iteration over obj props
            collectionKeys = [];
            for (var itemKey in collection) {
              if (collection.hasOwnProperty(itemKey) && itemKey.charAt(0) != '$') {
                collectionKeys.push(itemKey);
              }
            }
            collectionKeys.sort();
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn(key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function (block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
                  expression, trackById, toJson(value));
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) != nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, jqLite(previousNode));
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                // TODO(perf): support naked previousNode in `enter` to avoid creation of jqLite wrapper?
                $animate.enter(clone, null, jqLite(previousNode));
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression
 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
 * in AngularJS and sets the display style to none (using an !important flag).
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
 * from the element causing the element not to appear hidden.
 *
 * ## Why is !important used?
 *
 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
 * can be easily overridden by heavier selectors. For example, something as simple
 * as changing the display style on a HTML list item would make hidden elements appear visible.
 * This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display:none!important`. If you wish to change
 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
 * class in CSS:
 *
 * ```css
 * .ng-hide {
 *   /&#42; this is just another form of hiding an element &#42;/
 *   display:block!important;
 *   position:absolute;
 *   top:-9999px;
 *   left:-9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the display style.
 *
 * ## A note about animations with `ngShow`
 *
 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
 * is true and false. This system works like the animation system present with ngClass except that
 * you must also include the !important flag to override the display property
 * so that you can perform an animation when the element is hidden during the time of the animation.
 *
 * ```css
 * //
 * //a working example can be found at the bottom of this page
 * //
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   /&#42; this is required as of 1.3x to properly
 *      apply all styling in a show/hide animation &#42;/
 *   transition:0s linear all;
 * }
 *
 * .my-element.ng-hide-add-active,
 * .my-element.ng-hide-remove-active {
 *   /&#42; the transition is defined in the active class &#42;/
 *   transition:1s linear all;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
 *
 * @animations
 * addClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a truthy value and the just before contents are set to visible
 * removeClass: `.ng-hide` - happens after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
 *     then the element is shown or hidden respectively.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked"><br/>
      <div>
        Show:
        <div class="check-element animate-show" ng-show="checked">
          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
        </div>
      </div>
      <div>
        Hide:
        <div class="check-element animate-show" ng-hide="checked">
          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
        </div>
      </div>
    </file>
    <file name="glyphicons.css">
      @import url(//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css);
    </file>
    <file name="animations.css">
      .animate-show {
        line-height:20px;
        opacity:1;
        padding:10px;
        border:1px solid black;
        background:white;
      }

      .animate-show.ng-hide-add.ng-hide-add-active,
      .animate-show.ng-hide-remove.ng-hide-remove-active {
        -webkit-transition:all linear 0.5s;
        transition:all linear 0.5s;
      }

      .animate-show.ng-hide {
        line-height:0;
        opacity:0;
        padding:0 10px;
      }

      .check-element {
        padding:10px;
        border:1px solid black;
        background:white;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));

      it('should check ng-show / ng-hide', function() {
        expect(thumbsUp.isDisplayed()).toBeFalsy();
        expect(thumbsDown.isDisplayed()).toBeTruthy();

        element(by.model('checked')).click();

        expect(thumbsUp.isDisplayed()).toBeTruthy();
        expect(thumbsDown.isDisplayed()).toBeFalsy();
      });
    </file>
  </example>
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value){
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses : NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression
 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
 * in AngularJS and sets the display style to none (using an !important flag).
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
 * from the element causing the element not to appear hidden.
 *
 * ## Why is !important used?
 *
 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
 * can be easily overridden by heavier selectors. For example, something as simple
 * as changing the display style on a HTML list item would make hidden elements appear visible.
 * This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display:none!important`. If you wish to change
 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
 * class in CSS:
 *
 * ```css
 * .ng-hide {
 *   /&#42; this is just another form of hiding an element &#42;/
 *   display:block!important;
 *   position:absolute;
 *   top:-9999px;
 *   left:-9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the display style.
 *
 * ## A note about animations with `ngHide`
 *
 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
 * CSS class is added and removed for you instead of your own CSS class.
 *
 * ```css
 * //
 * //a working example can be found at the bottom of this page
 * //
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition:0.5s linear all;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3.0-beta.11, there is no need to change the display
 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
 *
 * @animations
 * removeClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden
 * addClass: `.ng-hide` - happens after the `ngHide` expression evaluates to a non truthy value and just before the contents are set to visible
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
 *     the element is shown or hidden respectively.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked"><br/>
      <div>
        Show:
        <div class="check-element animate-hide" ng-show="checked">
          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
        </div>
      </div>
      <div>
        Hide:
        <div class="check-element animate-hide" ng-hide="checked">
          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
        </div>
      </div>
    </file>
    <file name="glyphicons.css">
      @import url(//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css);
    </file>
    <file name="animations.css">
      .animate-hide {
        -webkit-transition:all linear 0.5s;
        transition:all linear 0.5s;
        line-height:20px;
        opacity:1;
        padding:10px;
        border:1px solid black;
        background:white;
      }

      .animate-hide.ng-hide {
        line-height:0;
        opacity:0;
        padding:0 10px;
      }

      .check-element {
        padding:10px;
        border:1px solid black;
        background:white;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));

      it('should check ng-show / ng-hide', function() {
        expect(thumbsUp.isDisplayed()).toBeFalsy();
        expect(thumbsDown.isDisplayed()).toBeTruthy();

        element(by.model('checked')).click();

        expect(thumbsUp.isDisplayed()).toBeTruthy();
        expect(thumbsDown.isDisplayed()).toBeFalsy();
      });
    </file>
  </example>
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value){
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses : NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example>
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, '');});
    }
    if (newStyles) element.css(newStyles);
  }, true);
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * enter - happens after the ngSwitch contents change and the matched child element is placed inside the container
 * leave - happens just after the ngSwitch contents change and just before the former contents are removed from the DOM
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <tt>ng-switch-when</tt>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <tt>selection={{selection}}</tt>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        -webkit-transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', function($animate) {
  return {
    restrict: 'EA',
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function ngSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function() { array.splice(index, 1); };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;
        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
          $animate.cancel(previousLeaveAnimations[i]);
        }
        previousLeaveAnimations.length = 0;

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
          promise.then(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = document.createComment(' end ngSwitchWhen: ');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {
    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * Any existing content of the element that this directive is placed on will be removed before the transcluded content is inserted.
 *
 * @element ANY
 *
 * @example
   <example module="transcludeExample">
     <file name="index.html">
       <script>
         angular.module('transcludeExample', [])
          .directive('pane', function(){
             return {
               restrict: 'E',
               transclude: true,
               scope: { title:'@' },
               template: '<div style="border: 1px solid black;">' +
                           '<div style="background-color: gray">{{title}}</div>' +
                           '<ng-transclude></ng-transclude>' +
                         '</div>'
             };
         })
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.title = 'Lorem Ipsum';
           $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
         }]);
       </script>
       <div ng-controller="ExampleController">
         <input ng-model="title"><br>
         <textarea ng-model="text"></textarea> <br/>
         <pane title="{{title}}">{{text}}</pane>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
        it('should have transcluded', function() {
          var titleElement = element(by.model('title'));
          titleElement.clear();
          titleElement.sendKeys('TITLE');
          var textElement = element(by.model('text'));
          textElement.clear();
          textElement.sendKeys('TEXT');
          expect(element(by.binding('title')).getText()).toEqual('TITLE');
          expect(element(by.binding('text')).getText()).toEqual('TEXT');
        });
     </file>
   </example>
 *
 */
var ngTranscludeDirective = ngDirective({
  restrict: 'EAC',
  link: function($scope, $element, $attrs, controller, $transclude) {
    if (!$transclude) {
      throw minErr('ngTransclude')('orphan',
       'Illegal use of ngTransclude directive in the template! ' +
       'No parent directive that requires a transclusion found. ' +
       'Element: {0}',
       startingTag($element));
    }

    $transclude(function(clone) {
      $element.empty();
      $element.append(clone);
    });
  }
});

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example>
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type == 'text/ng-template') {
        var templateUrl = attr.id,
            // IE is not consistent, in scripts we have to read .text but in other nodes we have to read .textContent
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

var ngOptionsMinErr = minErr('ngOptions');
/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `SELECT` element with angular data-binding.
 *
 * # `ngOptions`
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension_expression.
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * <div class="alert alert-warning">
 * **Note:** `ngModel` compares by reference, not value. This is important when binding to an
 * array of objects. See an example [in this jsfiddle](http://jsfiddle.net/qWzTb/).
 * </div>
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * <div class="alert alert-warning">
 * **Note:** `ngOptions` provides an iterator facility for the `<option>` element which should be used instead
 * of {@link ng.directive:ngRepeat ngRepeat} when you want the
 * `select` model to be bound to a non-string value. This is because an option element can only
 * be bound to string values at present.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** Using `select as` will bind the result of the `select as` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection.
 * </div>
 *
 * **Note:** Using `select as` together with `trackexpr` is not recommended.
 * Reasoning:
 * - Example: &lt;select ng-options="item.subItem as item.label for item in values track by item.id" ng-model="selected"&gt;
 *   values: [{id: 1, label: 'aLabel', subItem: {name: 'aSubItem'}}, {id: 2, label: 'bLabel', subItem: {name: 'bSubItem'}}],
 *   $scope.selected = {name: 'aSubItem'};
 * - track by is always applied to `value`, with the purpose of preserving the selection,
 *   (to `item` in this case)
 * - to calculate whether an item is selected we do the following:
 *   1. apply `track by` to the values in the array, e.g.
 *      In the example: [1,2]
 *   2. apply `track by` to the already selected value in `ngModel`:
 *      In the example: this is not possible, as `track by` refers to `item.id`, but the selected
 *      value from `ngModel` is `{name: aSubItem}`.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {comprehension_expression=} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label`  **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 *
 * @example
    <example module="selectExample">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light'},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark'},
              {name:'yellow', shade:'light'}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              Name: <input ng-model="color.name">
              [<a href ng-click="colors.splice($index, 1)">X</a>]
            </li>
            <li>
              [<a href ng-click="colors.push({})">add</a>]
            </li>
          </ul>
          <hr/>
          Color (null not allowed):
          <select ng-model="myColor" ng-options="color.name for color in colors"></select><br>

          Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span><br/>

          Color grouped by shade:
          <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
          </select><br/>


          Select <a href ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</a>.<br>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

var ngOptionsDirective = valueFn({
  restrict: 'A',
  terminal: true
});

// jshint maxlen: false
var selectDirective = ['$compile', '$parse', function($compile,   $parse) {
                         //000011111111110000000000022222222220000000000000000000003333333333000000000000004444444444444440000000005555555555555550000000666666666666666000000000000000777777777700000000000000000008888888888
  var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/,
      nullModelCtrl = {$setViewValue: noop};
// jshint maxlen: 100

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {
      var self = this,
          optionsMap = {},
          ngModelCtrl = nullModelCtrl,
          nullOption,
          unknownOption;


      self.databound = $attrs.ngModel;


      self.init = function(ngModelCtrl_, nullOption_, unknownOption_) {
        ngModelCtrl = ngModelCtrl_;
        nullOption = nullOption_;
        unknownOption = unknownOption_;
      };


      self.addOption = function(value, element) {
        assertNotHasOwnProperty(value, '"option value"');
        optionsMap[value] = true;

        if (ngModelCtrl.$viewValue == value) {
          $element.val(value);
          if (unknownOption.parent()) unknownOption.remove();
        }
        // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
        // Adding an <option selected="selected"> element to a <select required="required"> should
        // automatically select the new element
        if (element && element[0].hasAttribute('selected')) {
          element[0].selected = true;
        }
      };


      self.removeOption = function(value) {
        if (this.hasOption(value)) {
          delete optionsMap[value];
          if (ngModelCtrl.$viewValue == value) {
            this.renderUnknownOption(value);
          }
        }
      };


      self.renderUnknownOption = function(val) {
        var unknownVal = '? ' + hashKey(val) + ' ?';
        unknownOption.val(unknownVal);
        $element.prepend(unknownOption);
        $element.val(unknownVal);
        unknownOption.prop('selected', true); // needed for IE
      };


      self.hasOption = function(value) {
        return optionsMap.hasOwnProperty(value);
      };

      $scope.$on('$destroy', function() {
        // disable unknown option so that we don't do work when the whole select is being destroyed
        self.renderUnknownOption = noop;
      });
    }],

    link: function(scope, element, attr, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      if (!ctrls[1]) return;

      var selectCtrl = ctrls[0],
          ngModelCtrl = ctrls[1],
          multiple = attr.multiple,
          optionsExp = attr.ngOptions,
          nullOption = false, // if false, user will not be able to select it (used by ngOptions)
          emptyOption,
          renderScheduled = false,
          // we can't just jqLite('<option>') since jqLite is not smart enough
          // to create it in <select> and IE barfs otherwise.
          optionTemplate = jqLite(document.createElement('option')),
          optGroupTemplate =jqLite(document.createElement('optgroup')),
          unknownOption = optionTemplate.clone();

      // find "null" option
      for(var i = 0, children = element.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          emptyOption = nullOption = children.eq(i);
          break;
        }
      }

      selectCtrl.init(ngModelCtrl, nullOption, unknownOption);

      // required validator
      if (multiple) {
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };
      }

      if (optionsExp) setupAsOptions(scope, element, ngModelCtrl);
      else if (multiple) setupAsMultiple(scope, element, ngModelCtrl);
      else setupAsSingle(scope, element, ngModelCtrl, selectCtrl);


      ////////////////////////////



      function setupAsSingle(scope, selectElement, ngModelCtrl, selectCtrl) {
        ngModelCtrl.$render = function() {
          var viewValue = ngModelCtrl.$viewValue;

          if (selectCtrl.hasOption(viewValue)) {
            if (unknownOption.parent()) unknownOption.remove();
            selectElement.val(viewValue);
            if (viewValue === '') emptyOption.prop('selected', true); // to make IE9 happy
          } else {
            if (isUndefined(viewValue) && emptyOption) {
              selectElement.val('');
            } else {
              selectCtrl.renderUnknownOption(viewValue);
            }
          }
        };

        selectElement.on('change', function() {
          scope.$apply(function() {
            if (unknownOption.parent()) unknownOption.remove();
            ngModelCtrl.$setViewValue(selectElement.val());
          });
        });
      }

      function setupAsMultiple(scope, selectElement, ctrl) {
        var lastView;
        ctrl.$render = function() {
          var items = new HashMap(ctrl.$viewValue);
          forEach(selectElement.find('option'), function(option) {
            option.selected = isDefined(items.get(option.value));
          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        scope.$watch(function selectMultipleWatch() {
          if (!equals(lastView, ctrl.$viewValue)) {
            lastView = shallowCopy(ctrl.$viewValue);
            ctrl.$render();
          }
        });

        selectElement.on('change', function() {
          scope.$apply(function() {
            var array = [];
            forEach(selectElement.find('option'), function(option) {
              if (option.selected) {
                array.push(option.value);
              }
            });
            ctrl.$setViewValue(array);
          });
        });
      }

      function setupAsOptions(scope, selectElement, ctrl) {
        var match;

        if (!(match = optionsExp.match(NG_OPTIONS_REGEXP))) {
          throw ngOptionsMinErr('iexp',
            "Expected expression in form of " +
            "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
            " but got '{0}'. Element: {1}",
            optionsExp, startingTag(selectElement));
        }

        var displayFn = $parse(match[2] || match[1]),
            valueName = match[4] || match[6],
            selectAs = / as /.test(match[0]) && match[1],
            selectAsFn = selectAs ? $parse(selectAs) : null,
            keyName = match[5],
            groupByFn = $parse(match[3] || ''),
            valueFn = $parse(match[2] ? match[1] : valueName),
            valuesFn = $parse(match[7]),
            track = match[8],
            trackFn = track ? $parse(match[8]) : null,
            // This is an array of array of existing option groups in DOM.
            // We try to reuse these if possible
            // - optionGroupsCache[0] is the options with no option group
            // - optionGroupsCache[?][0] is the parent: either the SELECT or OPTGROUP element
            optionGroupsCache = [[{element: selectElement, label:''}]],
            //re-usable object to represent option's locals
            locals = {};

        if (nullOption) {
          // compile the element since there might be bindings in it
          $compile(nullOption)(scope);

          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          nullOption.removeClass('ng-scope');

          // we need to remove it before calling selectElement.empty() because otherwise IE will
          // remove the label from the element. wtf?
          nullOption.remove();
        }

        // clear contents, we'll add what's needed based on the model
        selectElement.empty();

        selectElement.on('change', selectionChanged);

        ctrl.$render = render;

        scope.$watchCollection(valuesFn, scheduleRendering);
        scope.$watchCollection(getLabels, scheduleRendering);

        if (multiple) {
          scope.$watchCollection(function() { return ctrl.$modelValue; }, scheduleRendering);
        }

        // ------------------------------------------------------------------ //

        function callExpression(exprFn, key, value) {
          locals[valueName] = value;
          if (keyName) locals[keyName] = key;
          return exprFn(scope, locals);
        }

        function selectionChanged() {
          scope.$apply(function() {
            var optionGroup,
                collection = valuesFn(scope) || [],
                key, value, optionElement, index, groupIndex, length, groupLength, trackIndex;
            var viewValue;
            if (multiple) {
              viewValue = [];
              forEach(selectElement.val(), function(selectedKey) {
                viewValue.push(getViewValue(selectedKey, collection[selectedKey]));
              });
            } else {
              var selectedKey = selectElement.val();
              viewValue = getViewValue(selectedKey, collection[selectedKey]);
            }
            ctrl.$setViewValue(viewValue);
            render();
          });
        }

        function getViewValue(key, value) {
          if (key === '?') {
            return undefined;
          } else if (key === '') {
            return null;
          } else {
            var viewValueFn = selectAsFn ? selectAsFn : valueFn;
            return callExpression(viewValueFn, key, value);
          }
        }

        function getLabels() {
          var values = valuesFn(scope);
          var toDisplay;
          if (values && isArray(values)) {
            toDisplay = new Array(values.length);
            for (var i = 0, ii = values.length; i < ii; i++) {
              toDisplay[i] = callExpression(displayFn, i, values[i]);
            }
            return toDisplay;
          } else if (values) {
            // TODO: Add a test for this case
            toDisplay = {};
            for (var prop in values) {
              if (values.hasOwnProperty(prop)) {
                toDisplay[prop] = callExpression(displayFn, prop, values[prop]);
              }
            }
          }
          return toDisplay;
        }

        function createIsSelectedFn(viewValue) {
          var selectedSet;
          if (multiple) {
            if (trackFn && isArray(viewValue)) {

              selectedSet = new HashMap([]);
              for (var trackIndex = 0; trackIndex < viewValue.length; trackIndex++) {
                // tracking by key
                selectedSet.put(callExpression(trackFn, null, viewValue[trackIndex]), true);
              }
            } else {
              selectedSet = new HashMap(viewValue);
            }
          } else if (trackFn) {
            viewValue = callExpression(trackFn, null, viewValue);
          }

          return function isSelected(key, value) {
            var compareValueFn;
            if (trackFn) {
              compareValueFn = trackFn;
            } else if (selectAsFn) {
              compareValueFn = selectAsFn;
            } else {
              compareValueFn = valueFn;
            }

            if (multiple) {
              return isDefined(selectedSet.remove(callExpression(compareValueFn, key, value)));
            } else {
              return viewValue == callExpression(compareValueFn, key, value);
            }
          };
        }

        function scheduleRendering() {
          if (!renderScheduled) {
            scope.$$postDigest(render);
            renderScheduled = true;
          }
        }

        /**
         * A new labelMap is created with each render.
         * This function is called for each existing option with added=false,
         * and each new option with added=true.
         * - Labels that are passed to this method twice,
         * (once with added=true and once with added=false) will end up with a value of 0, and
         * will cause no change to happen to the corresponding option.
         * - Labels that are passed to this method only once with added=false will end up with a
         * value of -1 and will eventually be passed to selectCtrl.removeOption()
         * - Labels that are passed to this method only once with added=true will end up with a
         * value of 1 and will eventually be passed to selectCtrl.addOption()
        */
        function updateLabelMap(labelMap, label, added) {
          labelMap[label] = labelMap[label] || 0;
          labelMap[label] += (added ? 1 : -1);
        }

        function render() {
          renderScheduled = false;

          // Temporary location for the option groups before we render them
          var optionGroups = {'':[]},
              optionGroupNames = [''],
              optionGroupName,
              optionGroup,
              option,
              existingParent, existingOptions, existingOption,
              viewValue = ctrl.$viewValue,
              values = valuesFn(scope) || [],
              keys = keyName ? sortedKeys(values) : values,
              key,
              value,
              groupLength, length,
              groupIndex, index,
              labelMap = {},
              selected,
              isSelected = createIsSelectedFn(viewValue),
              anySelected = false,
              lastElement,
              element,
              label;

          // We now build up the list of options we need (we merge later)
          for (index = 0; length = keys.length, index < length; index++) {
            key = index;
            if (keyName) {
              key = keys[index];
              if ( key.charAt(0) === '$' ) continue;
            }
            value = values[key];

            optionGroupName = callExpression(groupByFn, key, value) || '';
            if (!(optionGroup = optionGroups[optionGroupName])) {
              optionGroup = optionGroups[optionGroupName] = [];
              optionGroupNames.push(optionGroupName);
            }

            selected = isSelected(key, value);
            anySelected = anySelected || selected;

            label = callExpression(displayFn, key, value); // what will be seen by the user

            // doing displayFn(scope, locals) || '' overwrites zero values
            label = isDefined(label) ? label : '';
            optionGroup.push({
              // either the index into array or key from object
              id: (keyName ? keys[index] : index),
              label: label,
              selected: selected                   // determine if we should be selected
            });
          }
          if (!multiple) {
            if (nullOption || viewValue === null) {
              // insert null option if we have a placeholder, or the model is null
              optionGroups[''].unshift({id:'', label:'', selected:!anySelected});
            } else if (!anySelected) {
              // option could not be found, we have to insert the undefined item
              optionGroups[''].unshift({id:'?', label:'', selected:true});
            }
          }

          // Now we need to update the list of DOM nodes to match the optionGroups we computed above
          for (groupIndex = 0, groupLength = optionGroupNames.length;
               groupIndex < groupLength;
               groupIndex++) {
            // current option group name or '' if no group
            optionGroupName = optionGroupNames[groupIndex];

            // list of options for that group. (first item has the parent)
            optionGroup = optionGroups[optionGroupName];

            if (optionGroupsCache.length <= groupIndex) {
              // we need to grow the optionGroups
              existingParent = {
                element: optGroupTemplate.clone().attr('label', optionGroupName),
                label: optionGroup.label
              };
              existingOptions = [existingParent];
              optionGroupsCache.push(existingOptions);
              selectElement.append(existingParent.element);
            } else {
              existingOptions = optionGroupsCache[groupIndex];
              existingParent = existingOptions[0];  // either SELECT (no group) or OPTGROUP element

              // update the OPTGROUP label if not the same.
              if (existingParent.label != optionGroupName) {
                existingParent.element.attr('label', existingParent.label = optionGroupName);
              }
            }

            lastElement = null;  // start at the beginning
            for(index = 0, length = optionGroup.length; index < length; index++) {
              option = optionGroup[index];
              if ((existingOption = existingOptions[index+1])) {
                // reuse elements
                lastElement = existingOption.element;
                if (existingOption.label !== option.label) {
                  updateLabelMap(labelMap, existingOption.label, false);
                  updateLabelMap(labelMap, option.label, true);
                  lastElement.text(existingOption.label = option.label);
                }
                if (existingOption.id !== option.id) {
                  lastElement.val(existingOption.id = option.id);
                }
                // lastElement.prop('selected') provided by jQuery has side-effects
                if (lastElement[0].selected !== option.selected) {
                  lastElement.prop('selected', (existingOption.selected = option.selected));
                  if (msie) {
                    // See #7692
                    // The selected item wouldn't visually update on IE without this.
                    // Tested on Win7: IE9, IE10 and IE11. Future IEs should be tested as well
                    lastElement.prop('selected', existingOption.selected);
                  }
                }
              } else {
                // grow elements

                // if it's a null option
                if (option.id === '' && nullOption) {
                  // put back the pre-compiled element
                  element = nullOption;
                } else {
                  // jQuery(v1.4.2) Bug: We should be able to chain the method calls, but
                  // in this version of jQuery on some browser the .text() returns a string
                  // rather then the element.
                  (element = optionTemplate.clone())
                      .val(option.id)
                      .prop('selected', option.selected)
                      .attr('selected', option.selected)
                      .text(option.label);
                }

                existingOptions.push(existingOption = {
                    element: element,
                    label: option.label,
                    id: option.id,
                    selected: option.selected
                });
                updateLabelMap(labelMap, option.label, true);
                if (lastElement) {
                  lastElement.after(element);
                } else {
                  existingParent.element.append(element);
                }
                lastElement = element;
              }
            }
            // remove any excessive OPTIONs in a group
            index++; // increment since the existingOptions[0] is parent element not OPTION
            while(existingOptions.length > index) {
              option = existingOptions.pop();
              updateLabelMap(labelMap, option.label, false);
              option.element.remove();
            }
            forEach(labelMap, function (count, label) {
              if (count > 0) {
                selectCtrl.addOption(label);
              } else if (count < 0) {
                selectCtrl.removeOption(label);
              }
            });
          }
          // remove any excessive OPTGROUPs from select
          while(optionGroupsCache.length > groupIndex) {
            optionGroupsCache.pop()[0].element.remove();
          }
        }
      }
    }
  };
}];

var optionDirective = ['$interpolate', function($interpolate) {
  var nullSelectCtrl = {
    addOption: noop,
    removeOption: noop
  };

  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      if (isUndefined(attr.value)) {
        var interpolateFn = $interpolate(element.text(), true);
        if (!interpolateFn) {
          attr.$set('value', element.text());
        }
      }

      return function (scope, element, attr) {
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (!selectCtrl || !selectCtrl.databound) {
          selectCtrl = nullSelectCtrl;
        }

        if (interpolateFn) {
          scope.$watch(interpolateFn, function interpolateWatchAction(newVal, oldVal) {
            attr.$set('value', newVal);
            if (oldVal !== newVal) {
              selectCtrl.removeOption(oldVal);
            }
            selectCtrl.addOption(newVal, element);
          });
        } else {
          selectCtrl.addOption(attr.value, element);
        }

        element.on('$destroy', function() {
          selectCtrl.removeOption(attr.value);
        });
      };
    }
  };
}];

var styleDirective = valueFn({
  restrict: 'E',
  terminal: false
});

  if (window.angular.bootstrap) {
    //AngularJS is already loaded, so we can return here...
    console.log('WARNING: Tried to load angular more than once.');
    return;
  }

  //try to bind to jquery now so that one can write jqLite(document).ready()
  //but we will rebind on bootstrap again.
  bindJQuery();

  publishExternalAPI(angular);

  jqLite(document).ready(function() {
    angularInit(document, bootstrap);
  });

})(window, document);

!window.angular.$$csp() && window.angular.element(document).find('head').prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}</style>');
/*
 AngularJS v1.3.2
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(M,f,S){'use strict';f.module("ngAnimate",["ng"]).directive("ngAnimateChildren",function(){return function(T,B,k){k=k.ngAnimateChildren;f.isString(k)&&0===k.length?B.data("$$ngAnimateChildren",!0):T.$watch(k,function(f){B.data("$$ngAnimateChildren",!!f)})}}).factory("$$animateReflow",["$$rAF","$document",function(f,B){return function(k){return f(function(){k()})}}]).config(["$provide","$animateProvider",function(T,B){function k(f){for(var g=0;g<f.length;g++){var k=f[g];if(1==k.nodeType)return k}}
function N(f,g){return k(f)==k(g)}var s=f.noop,g=f.forEach,ba=B.$$selectors,$=f.isArray,ca=f.isString,da=f.isObject,t={running:!0};T.decorator("$animate",["$delegate","$$q","$injector","$sniffer","$rootElement","$$asyncCallback","$rootScope","$document","$templateRequest",function(O,M,I,U,x,C,P,S,V){function A(a,c){var b=a.data("$$ngAnimateState")||{};c&&(b.running=!0,b.structural=!0,a.data("$$ngAnimateState",b));return b.disabled||b.running&&b.structural}function z(a){var c,b=M.defer();b.promise.$$cancelFn=
function(){c&&c()};P.$$postDigest(function(){c=a(function(){b.resolve()})});return b.promise}function J(a){if(da(a))return a.tempClasses&&ca(a.tempClasses)&&(a.tempClasses=a.tempClasses.split(/\s+/)),a}function W(a,c,b){b=b||{};var e={};g(b,function(a,d){g(d.split(" "),function(d){e[d]=a})});var m=Object.create(null);g((a.attr("class")||"").split(/\s+/),function(a){m[a]=!0});var f=[],k=[];g(c&&c.classes||[],function(a,d){var b=m[d],c=e[d]||{};!1===a?(b||"addClass"==c.event)&&k.push(d):!0===a&&(b&&
"removeClass"!=c.event||f.push(d))});return 0<f.length+k.length&&[f.join(" "),k.join(" ")]}function Q(a){if(a){var c=[],b={};a=a.substr(1).split(".");(U.transitions||U.animations)&&c.push(I.get(ba[""]));for(var e=0;e<a.length;e++){var f=a[e],k=ba[f];k&&!b[f]&&(c.push(I.get(k)),b[f]=!0)}return c}}function R(a,c,b,e){function m(a,d){var b=a[d],c=a["before"+d.charAt(0).toUpperCase()+d.substr(1)];if(b||c)return"leave"==d&&(c=b,b=null),l.push({event:d,fn:b}),H.push({event:d,fn:c}),!0}function k(c,h,G){var w=
[];g(c,function(a){a.fn&&w.push(a)});var f=0;g(w,function(c,n){var u=function(){a:{if(h){(h[n]||s)();if(++f<w.length)break a;h=null}G()}};switch(c.event){case "setClass":h.push(c.fn(a,F,d,u,e));break;case "animate":h.push(c.fn(a,b,e.from,e.to,u));break;case "addClass":h.push(c.fn(a,F||b,u,e));break;case "removeClass":h.push(c.fn(a,d||b,u,e));break;default:h.push(c.fn(a,u,e))}});h&&0===h.length&&G()}var p=a[0];if(p){e&&(e.to=e.to||{},e.from=e.from||{});var F,d;$(b)&&(F=b[0],d=b[1],F?d?b=F+" "+d:(b=
F,c="addClass"):(b=d,c="removeClass"));var h="setClass"==c,G=h||"addClass"==c||"removeClass"==c||"animate"==c,w=a.attr("class")+" "+b;if(X(w)){var u=s,n=[],H=[],q=s,r=[],l=[],w=(" "+w).replace(/\s+/g,".");g(Q(w),function(a){!m(a,c)&&h&&(m(a,"addClass"),m(a,"removeClass"))});return{node:p,event:c,className:b,isClassBased:G,isSetClassOperation:h,applyStyles:function(){e&&a.css(f.extend(e.from||{},e.to||{}))},before:function(a){u=a;k(H,n,function(){u=s;a()})},after:function(a){q=a;k(l,r,function(){q=
s;a()})},cancel:function(){n&&(g(n,function(a){(a||s)(!0)}),u(!0));r&&(g(r,function(a){(a||s)(!0)}),q(!0))}}}}}function y(a,c,b,e,m,k,p,F){function d(d){var h="$animate:"+d;H&&H[h]&&0<H[h].length&&C(function(){b.triggerHandler(h,{event:a,className:c})})}function h(){d("before")}function G(){d("after")}function w(){w.hasBeenRun||(w.hasBeenRun=!0,k())}function u(){if(!u.hasBeenRun){n&&n.applyStyles();u.hasBeenRun=!0;p&&p.tempClasses&&g(p.tempClasses,function(a){b.removeClass(a)});var h=b.data("$$ngAnimateState");
h&&(n&&n.isClassBased?l(b,c):(C(function(){var d=b.data("$$ngAnimateState")||{};v==d.index&&l(b,c,a)}),b.data("$$ngAnimateState",h)));d("close");F()}}var n=R(b,a,c,p);if(!n)return w(),h(),G(),u(),s;a=n.event;c=n.className;var H=f.element._data(n.node),H=H&&H.events;e||(e=m?m.parent():b.parent());if(Y(b,e))return w(),h(),G(),u(),s;e=b.data("$$ngAnimateState")||{};var q=e.active||{},r=e.totalActive||0,t=e.last;m=!1;if(0<r){r=[];if(n.isClassBased)"setClass"==t.event?(r.push(t),l(b,c)):q[c]&&(aa=q[c],
aa.event==a?m=!0:(r.push(aa),l(b,c)));else if("leave"==a&&q["ng-leave"])m=!0;else{for(var aa in q)r.push(q[aa]);e={};l(b,!0)}0<r.length&&g(r,function(a){a.cancel()})}!n.isClassBased||n.isSetClassOperation||"animate"==a||m||(m="addClass"==a==b.hasClass(c));if(m)return w(),h(),G(),d("close"),F(),s;q=e.active||{};r=e.totalActive||0;if("leave"==a)b.one("$destroy",function(a){a=f.element(this);var d=a.data("$$ngAnimateState");d&&(d=d.active["ng-leave"])&&(d.cancel(),l(a,"ng-leave"))});b.addClass("ng-animate");
p&&p.tempClasses&&g(p.tempClasses,function(a){b.addClass(a)});var v=Z++;r++;q[c]=n;b.data("$$ngAnimateState",{last:n,active:q,index:v,totalActive:r});h();n.before(function(d){var h=b.data("$$ngAnimateState");d=d||!h||!h.active[c]||n.isClassBased&&h.active[c].event!=a;w();!0===d?u():(G(),n.after(u))});return n.cancel}function K(a){if(a=k(a))a=f.isFunction(a.getElementsByClassName)?a.getElementsByClassName("ng-animate"):a.querySelectorAll(".ng-animate"),g(a,function(a){a=f.element(a);(a=a.data("$$ngAnimateState"))&&
a.active&&g(a.active,function(a){a.cancel()})})}function l(a,c){if(N(a,x))t.disabled||(t.running=!1,t.structural=!1);else if(c){var b=a.data("$$ngAnimateState")||{},e=!0===c;!e&&b.active&&b.active[c]&&(b.totalActive--,delete b.active[c]);if(e||!b.totalActive)a.removeClass("ng-animate"),a.removeData("$$ngAnimateState")}}function Y(a,c){if(t.disabled)return!0;if(N(a,x))return t.running;var b,e,k;do{if(0===c.length)break;var g=N(c,x),p=g?t:c.data("$$ngAnimateState")||{};if(p.disabled)return!0;g&&(k=
!0);!1!==b&&(g=c.data("$$ngAnimateChildren"),f.isDefined(g)&&(b=g));e=e||p.running||p.last&&!p.last.isClassBased}while(c=c.parent());return!k||!b&&e}x.data("$$ngAnimateState",t);var L=P.$watch(function(){return V.totalPendingRequests},function(a,c){0===a&&(L(),P.$$postDigest(function(){P.$$postDigest(function(){t.running=!1})}))}),Z=0,E=B.classNameFilter(),X=E?function(a){return E.test(a)}:function(){return!0};return{animate:function(a,c,b,e,g){e=e||"ng-inline-animate";g=J(g)||{};g.from=b?c:null;
g.to=b?b:c;return z(function(b){return y("animate",e,f.element(k(a)),null,null,s,g,b)})},enter:function(a,c,b,e){e=J(e);a=f.element(a);c=c&&f.element(c);b=b&&f.element(b);A(a,!0);O.enter(a,c,b);return z(function(g){return y("enter","ng-enter",f.element(k(a)),c,b,s,e,g)})},leave:function(a,c){c=J(c);a=f.element(a);K(a);A(a,!0);return z(function(b){return y("leave","ng-leave",f.element(k(a)),null,null,function(){O.leave(a)},c,b)})},move:function(a,c,b,e){e=J(e);a=f.element(a);c=c&&f.element(c);b=b&&
f.element(b);K(a);A(a,!0);O.move(a,c,b);return z(function(g){return y("move","ng-move",f.element(k(a)),c,b,s,e,g)})},addClass:function(a,c,b){return this.setClass(a,c,[],b)},removeClass:function(a,c,b){return this.setClass(a,[],c,b)},setClass:function(a,c,b,e){e=J(e);a=f.element(a);a=f.element(k(a));if(A(a))return O.$$setClassImmediately(a,c,b,e);var m,l=a.data("$$animateClasses"),p=!!l;l||(l={classes:{}});m=l.classes;c=$(c)?c:c.split(" ");g(c,function(a){a&&a.length&&(m[a]=!0)});b=$(b)?b:b.split(" ");
g(b,function(a){a&&a.length&&(m[a]=!1)});if(p)return e&&l.options&&(l.options=f.extend(l.options||{},e)),l.promise;a.data("$$animateClasses",l={classes:m,options:e});return l.promise=z(function(b){var d=a.parent(),h=k(a),c=h.parentNode;if(!c||c.$$NG_REMOVED||h.$$NG_REMOVED)b();else{h=a.data("$$animateClasses");a.removeData("$$animateClasses");var c=a.data("$$ngAnimateState")||{},e=W(a,h,c.active);return e?y("setClass",e,a,d,null,function(){e[0]&&O.$$addClassImmediately(a,e[0]);e[1]&&O.$$removeClassImmediately(a,
e[1])},h.options,b):b()}})},cancel:function(a){a.$$cancelFn()},enabled:function(a,c){switch(arguments.length){case 2:if(a)l(c);else{var b=c.data("$$ngAnimateState")||{};b.disabled=!0;c.data("$$ngAnimateState",b)}break;case 1:t.disabled=!a;break;default:a=!t.disabled}return!!a}}}]);B.register("",["$window","$sniffer","$timeout","$$animateReflow",function(t,B,I,U){function x(){e||(e=U(function(){b=[];e=null;a={}}))}function C(c,d){e&&e();b.push(d);e=U(function(){g(b,function(a){a()});b=[];e=null;a=
{}})}function P(a,d){var h=k(a);a=f.element(h);p.push(a);h=Date.now()+d;h<=N||(I.cancel(m),N=h,m=I(function(){T(p);p=[]},d,!1))}function T(a){g(a,function(a){(a=a.data("$$ngAnimateCSS3Data"))&&g(a.closeAnimationFns,function(a){a()})})}function V(b,d){var h=d?a[d]:null;if(!h){var c=0,e=0,f=0,k=0;g(b,function(a){if(1==a.nodeType){a=t.getComputedStyle(a)||{};c=Math.max(A(a[L+"Duration"]),c);e=Math.max(A(a[L+"Delay"]),e);k=Math.max(A(a[E+"Delay"]),k);var d=A(a[E+"Duration"]);0<d&&(d*=parseInt(a[E+"IterationCount"],
10)||1);f=Math.max(d,f)}});h={total:0,transitionDelay:e,transitionDuration:c,animationDelay:k,animationDuration:f};d&&(a[d]=h)}return h}function A(a){var d=0;a=ca(a)?a.split(/\s*,\s*/):[];g(a,function(a){d=Math.max(parseFloat(a)||0,d)});return d}function z(b,d,h,e){b=0<=["ng-enter","ng-leave","ng-move"].indexOf(h);var f,g=d.parent(),n=g.data("$$ngAnimateKey");n||(g.data("$$ngAnimateKey",++c),n=c);f=n+"-"+k(d).getAttribute("class");var g=f+" "+h,n=a[g]?++a[g].total:0,l={};if(0<n){var q=h+"-stagger",
l=f+" "+q;(f=!a[l])&&d.addClass(q);l=V(d,l);f&&d.removeClass(q)}d.addClass(h);var q=d.data("$$ngAnimateCSS3Data")||{},r=V(d,g);f=r.transitionDuration;r=r.animationDuration;if(b&&0===f&&0===r)return d.removeClass(h),!1;h=e||b&&0<f;b=0<r&&0<l.animationDelay&&0===l.animationDuration;d.data("$$ngAnimateCSS3Data",{stagger:l,cacheKey:g,running:q.running||0,itemIndex:n,blockTransition:h,closeAnimationFns:q.closeAnimationFns||[]});g=k(d);h&&(W(g,!0),e&&d.css(e));b&&(g.style[E+"PlayState"]="paused");return!0}
function J(a,d,b,c,e){function f(){d.off(C,l);d.removeClass(q);d.removeClass(r);z&&I.cancel(z);K(d,b);var a=k(d),c;for(c in p)a.style.removeProperty(p[c])}function l(a){a.stopPropagation();var d=a.originalEvent||a;a=d.$manualTimeStamp||d.timeStamp||Date.now();d=parseFloat(d.elapsedTime.toFixed(3));Math.max(a-B,0)>=A&&d>=x&&c()}var m=k(d);a=d.data("$$ngAnimateCSS3Data");if(-1!=m.getAttribute("class").indexOf(b)&&a){var q="",r="";g(b.split(" "),function(a,d){var b=(0<d?" ":"")+a;q+=b+"-active";r+=b+
"-pending"});var p=[],t=a.itemIndex,v=a.stagger,s=0;if(0<t){s=0;0<v.transitionDelay&&0===v.transitionDuration&&(s=v.transitionDelay*t);var y=0;0<v.animationDelay&&0===v.animationDuration&&(y=v.animationDelay*t,p.push(Y+"animation-play-state"));s=Math.round(100*Math.max(s,y))/100}s||(d.addClass(q),a.blockTransition&&W(m,!1));var D=V(d,a.cacheKey+" "+q),x=Math.max(D.transitionDuration,D.animationDuration);if(0===x)d.removeClass(q),K(d,b),c();else{!s&&e&&(D.transitionDuration||(d.css("transition",D.animationDuration+
"s linear all"),p.push("transition")),d.css(e));var t=Math.max(D.transitionDelay,D.animationDelay),A=1E3*t;0<p.length&&(v=m.getAttribute("style")||"",";"!==v.charAt(v.length-1)&&(v+=";"),m.setAttribute("style",v+" "));var B=Date.now(),C=X+" "+Z,t=1E3*(s+1.5*(t+x)),z;0<s&&(d.addClass(r),z=I(function(){z=null;0<D.transitionDuration&&W(m,!1);0<D.animationDuration&&(m.style[E+"PlayState"]="");d.addClass(q);d.removeClass(r);e&&(0===D.transitionDuration&&d.css("transition",D.animationDuration+"s linear all"),
d.css(e),p.push("transition"))},1E3*s,!1));d.on(C,l);a.closeAnimationFns.push(function(){f();c()});a.running++;P(d,t);return f}}else c()}function W(a,d){a.style[L+"Property"]=d?"none":""}function Q(a,d,b,c){if(z(a,d,b,c))return function(a){a&&K(d,b)}}function R(a,d,b,c,e){if(d.data("$$ngAnimateCSS3Data"))return J(a,d,b,c,e);K(d,b);c()}function y(a,d,b,c,e){var f=Q(a,d,b,e.from);if(f){var g=f;C(d,function(){g=R(a,d,b,c,e.to)});return function(a){(g||s)(a)}}x();c()}function K(a,d){a.removeClass(d);
var b=a.data("$$ngAnimateCSS3Data");b&&(b.running&&b.running--,b.running&&0!==b.running||a.removeData("$$ngAnimateCSS3Data"))}function l(a,d){var b="";a=$(a)?a:a.split(/\s+/);g(a,function(a,c){a&&0<a.length&&(b+=(0<c?" ":"")+a+d)});return b}var Y="",L,Z,E,X;M.ontransitionend===S&&M.onwebkittransitionend!==S?(Y="-webkit-",L="WebkitTransition",Z="webkitTransitionEnd transitionend"):(L="transition",Z="transitionend");M.onanimationend===S&&M.onwebkitanimationend!==S?(Y="-webkit-",E="WebkitAnimation",
X="webkitAnimationEnd animationend"):(E="animation",X="animationend");var a={},c=0,b=[],e,m=null,N=0,p=[];return{animate:function(a,d,b,c,e,f){f=f||{};f.from=b;f.to=c;return y("animate",a,d,e,f)},enter:function(a,b,c){c=c||{};return y("enter",a,"ng-enter",b,c)},leave:function(a,b,c){c=c||{};return y("leave",a,"ng-leave",b,c)},move:function(a,b,c){c=c||{};return y("move",a,"ng-move",b,c)},beforeSetClass:function(a,b,c,e,f){f=f||{};b=l(c,"-remove")+" "+l(b,"-add");if(f=Q("setClass",a,b,f.from))return C(a,
e),f;x();e()},beforeAddClass:function(a,b,c,e){e=e||{};if(b=Q("addClass",a,l(b,"-add"),e.from))return C(a,c),b;x();c()},beforeRemoveClass:function(a,b,c,e){e=e||{};if(b=Q("removeClass",a,l(b,"-remove"),e.from))return C(a,c),b;x();c()},setClass:function(a,b,c,e,f){f=f||{};c=l(c,"-remove");b=l(b,"-add");return R("setClass",a,c+" "+b,e,f.to)},addClass:function(a,b,c,e){e=e||{};return R("addClass",a,l(b,"-add"),c,e.to)},removeClass:function(a,b,c,e){e=e||{};return R("removeClass",a,l(b,"-remove"),c,e.to)}}}])}])})(window,
window.angular);
//# sourceMappingURL=angular-animate.min.js.map

/**
* @author Jason Dobry <jason.dobry@gmail.com>
* @file angular-cache.min.js
* @version 3.1.1 - Homepage <https://github.com/jmdobry/angular-cache>
* @copyright (c) 2013-2014 Jason Dobry <http://www.pseudobry.com>
* @license MIT <https://github.com/jmdobry/angular-cache/blob/master/LICENSE>
*
* @overview angular-cache is a very useful replacement for Angular's $cacheFactory.
*/

!function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);throw new Error("Cannot find module '"+g+"'")}var j=c[g]={exports:{}};b[g][0].call(j.exports,function(a){var c=b[g][1][a];return e(c?c:a)},j,j.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b){function c(a,b,c){for(var d=a[c],e=b(d);c>0;){var f=Math.floor((c+1)/2)-1,g=a[f];if(e>=b(g))break;a[f]=d,a[c]=g,c=f}}function d(a,b,c){for(var d=a.length,e=a[c],f=b(e);;){var g=2*(c+1),h=g-1,i=null;if(d>h){var j=a[h],k=b(j);f>k&&(i=h)}if(d>g){var l=a[g],m=b(l);m<(null===i?f:b(a[h]))&&(i=g)}if(null===i)break;a[c]=a[i],a[i]=e,c=i}}function e(a){if(a&&!angular.isFunction(a))throw new Error("DSBinaryHeap(weightFunc): weightFunc: must be a function!");a=a||function(a){return a},this.weightFunc=a,this.heap=[]}function f(){this.$get=function(){return e}}e.prototype.push=function(a){this.heap.push(a),c(this.heap,this.weightFunc,this.heap.length-1)},e.prototype.peek=function(){return this.heap[0]},e.prototype.pop=function(){var a=this.heap[0],b=this.heap.pop();return this.heap.length>0&&(this.heap[0]=b,d(this.heap,this.weightFunc,0)),a},e.prototype.remove=function(a){for(var b=this.heap.length,e=0;b>e;e++)if(angular.equals(this.heap[e],a)){var f=this.heap[e],g=this.heap.pop();return e!==b-1&&(this.heap[e]=g,c(this.heap,this.weightFunc,e),d(this.heap,this.weightFunc,e)),f}return null},e.prototype.removeAll=function(){this.heap=[]},e.prototype.size=function(){return this.heap.length},b.exports={DSBinaryHeapProvider:f,DSBinaryHeap:e}},{}],2:[function(a,b){b.exports=function(){clearInterval(this.$$cacheFlushIntervalId),clearInterval(this.$$recycleFreqId),this.removeAll(),this.$$storage&&(this.$$storage.removeItem(this.$$prefix+".keys"),this.$$storage.removeItem(this.$$prefix)),this.$$storage=null,this.$$data=null,this.$$lruHeap=null,this.$$expiresHeap=null,this.$$prefix=null}},{}],3:[function(a,b){var c=a("../utils");b.exports=function(a,b){var d=this;if(angular.isArray(a)){var e=a,f=[];return angular.forEach(e,function(a){var c=d.get(a,b);null!==c&&void 0!==c&&f.push(c)}),f}if(a=c.stringifyNumber(a),!this.$$disabled){if(b=b||{},!angular.isString(a))throw angular.$$minErr("ng")("areq","Expected key to be a string! Found: {0}.",typeof a);if(b&&!angular.isObject(b))throw angular.$$minErr("ng")("areq","Expected options to be an object! Found: {0}.",typeof b);if(b.onExpire&&!angular.isFunction(b.onExpire))throw angular.$$minErr("ng")("areq","Expected options.onExpire to be a function! Found: {0}.",typeof b.onExpire);var g;if(this.$$storage){var h=this.$$storage.getItem(this.$$prefix+".data."+a);if(!h)return;g=angular.fromJson(h)}else{if(!(a in this.$$data))return;g=this.$$data[a]}var i=g.value,j=(new Date).getTime();return this.$$storage?(this.$$lruHeap.remove({key:a,accessed:g.accessed}),g.accessed=j,this.$$lruHeap.push({key:a,accessed:j})):(this.$$lruHeap.remove(g),g.accessed=j,this.$$lruHeap.push(g)),"passive"===this.$$deleteOnExpire&&"expires"in g&&g.expires<j?(this.remove(a),this.$$onExpire?this.$$onExpire(a,g.value,b.onExpire):b.onExpire&&b.onExpire(a,g.value),i=void 0):this.$$storage&&this.$$storage.setItem(this.$$prefix+".data."+a,angular.toJson(g)),i}}},{"../utils":21}],4:[function(a,b){function c(a,b){if(!angular.isString(a))throw angular.$$minErr("ng")("areq","Expected storageMode to be a string! Found: {0}.",typeof a);if("memory"!==a&&"localStorage"!==a&&"sessionStorage"!==a)throw angular.$$minErr("ng")("areq",'Expected storageMode to be "memory", "localStorage" or "sessionStorage"! Found: {0}.',a);if(this.$$storageMode=a,b){if(!angular.isObject(b))throw angular.$$minErr("ng")("areq","Expected storageImpl to be an object! Found: {0}.",typeof b);if(!("setItem"in b&&"function"==typeof b.setItem))throw angular.$$minErr("ng")("areq",'Expected storageImpl to implement "setItem(key, value)"! Found: {0}.',typeof b.setItem);if(!("getItem"in b&&"function"==typeof b.getItem))throw angular.$$minErr("ng")("areq",'Expected storageImpl to implement "getItem(key)"! Found: {0}.',typeof b.getItem);if(!("removeItem"in b)||"function"!=typeof b.removeItem)throw angular.$$minErr("ng")("areq",'Expected storageImpl to implement "removeItem(key)"! Found: {0}.',typeof b.removeItem);this.$$storage=b}else if("localStorage"===this.$$storageMode)try{localStorage.setItem("angular-cache","angular-cache"),localStorage.removeItem("angular-cache"),this.$$storage=localStorage}catch(c){delete this.$$storage,this.$$storageMode="memory"}else if("sessionStorage"===this.$$storageMode)try{sessionStorage.setItem("angular-cache","angular-cache"),sessionStorage.removeItem("angular-cache"),this.$$storage=sessionStorage}catch(c){delete this.$$storage,this.$$storageMode="memory"}}function d(a,b){if(a=a||{},b=!!b,!angular.isObject(a))throw angular.$$minErr("ng")("areq","Expected cacheOptions to be an object! Found: {0}.",typeof a);"disabled"in a?this.$$disabled=!!a.disabled:b&&delete this.$$disabled,"capacity"in a?this.setCapacity(a.capacity):b&&this.setCapacity(null),"deleteOnExpire"in a?this.setDeleteOnExpire(a.deleteOnExpire):b&&this.setDeleteOnExpire(null),"maxAge"in a?this.setMaxAge(a.maxAge):b&&this.setMaxAge(null),"recycleFreq"in a?this.setRecycleFreq(a.recycleFreq):b&&this.setRecycleFreq(null),"cacheFlushInterval"in a?this.setCacheFlushInterval(a.cacheFlushInterval):b&&this.setCacheFlushInterval(null),"onExpire"in a?this.setOnExpire(a.onExpire):b&&this.setOnExpire(null)}function e(a,b){this.$$data={},this.$$id=a,this.$$storage=null,this.$$expiresHeap=new g(function(a){return a.expires}),this.$$lruHeap=new g(function(a){return a.accessed}),b=b||{},"storageMode"in b&&c.apply(this,[b.storageMode,b.storageImpl]),"storagePrefix"in b&&(this.$$storagePrefix=b.storagePrefix),this.$$prefix=this.$$storagePrefix+a,d.apply(this,[b,!0])}var f=a("../defaults"),g=a("../DSBinaryHeap").DSBinaryHeap;for(var h in f.defaults)e.prototype["$$"+h]=f.defaults[h];e.prototype.setOptions=d,e.prototype.setCapacity=a("./setCapacity"),e.prototype.setDeleteOnExpire=a("./setDeleteOnExpire"),e.prototype.setMaxAge=a("./setMaxAge"),e.prototype.setRecycleFreq=a("./setRecycleFreq"),e.prototype.setCacheFlushInterval=a("./setCacheFlushInterval"),e.prototype.setOnExpire=a("./setOnExpire"),e.prototype.put=a("./put"),e.prototype.get=a("./get"),e.prototype.remove=a("./remove"),e.prototype.removeAll=a("./removeAll"),e.prototype.removeExpired=a("./removeExpired"),e.prototype.destroy=a("./destroy"),e.prototype.info=a("./info"),e.prototype.keySet=a("./keySet"),e.prototype.keys=a("./keys"),e.prototype.disable=function(){this.$$disabled=!0},e.prototype.enable=function(){delete this.$$disabled},e.prototype.touch=function(a){if(a){var b=this,c=this.get(a,{onExpire:function(a,c){b.put(a,c)}});c&&this.put(a,c)}else for(var d=this.keys(),e=0;e<d.length;e++)this.touch(d[e])},b.exports=e},{"../DSBinaryHeap":1,"../defaults":19,"./destroy":2,"./get":3,"./info":5,"./keySet":6,"./keys":7,"./put":8,"./remove":9,"./removeAll":10,"./removeExpired":11,"./setCacheFlushInterval":12,"./setCapacity":13,"./setDeleteOnExpire":14,"./setMaxAge":15,"./setOnExpire":16,"./setRecycleFreq":17}],5:[function(a,b){b.exports=function(a){if(a){var b;if(this.$$storage){var c=this.$$storage.getItem(this.$$prefix+".data."+a);return c?(b=angular.fromJson(c),{created:b.created,accessed:b.accessed,expires:b.expires,isExpired:(new Date).getTime()-b.created>this.$$maxAge}):void 0}return a in this.$$data?(b=this.$$data[a],{created:b.created,accessed:b.accessed,expires:b.expires,isExpired:(new Date).getTime()-b.created>this.$$maxAge}):void 0}return{id:this.$$id,capacity:this.$$capacity,maxAge:this.$$maxAge,deleteOnExpire:this.$$deleteOnExpire,onExpire:this.$$onExpire,cacheFlushInterval:this.$$cacheFlushInterval,recycleFreq:this.$$recycleFreq,storageMode:this.$$storageMode,storageImpl:this.$$storage,disabled:this.$$disabled,size:this.$$lruHeap&&this.$$lruHeap.size()||0}}},{}],6:[function(a,b){var c=a("../utils");b.exports=function(){if(this.$$storage){var a=this.$$storage.getItem(this.$$prefix+".keys"),b={};if(a)for(var d=angular.fromJson(a),e=0;e<d.length;e++)b[d[e]]=d[e];return b}return c.keySet(this.$$data)}},{"../utils":21}],7:[function(a,b){var c=a("../utils");b.exports=function(){if(this.$$storage){var a=this.$$storage.getItem(this.$$prefix+".keys");return a?angular.fromJson(a):[]}return c.keys(this.$$data)}},{"../utils":21}],8:[function(a,b){var c=a("../utils");b.exports=function(a,b){var d=this;if(!this.$$disabled&&null!==b&&void 0!==b){if(b&&b.then)return void b.then(function(b){angular.isObject(b)&&"status"in b&&"data"in b?d.put(a,[b.status,b.data,b.headers(),b.statusText]):d.put(a,b)});if(a=c.stringifyNumber(a),!angular.isString(a))throw angular.$$minErr("ng")("areq","Expected key to be a string! Found: {0}.",typeof a);var e=(new Date).getTime(),f={key:a,value:b,created:e,accessed:e};if(f.expires=f.created+this.$$maxAge,this.$$storage){var g=this.$$storage.getItem(this.$$prefix+".keys"),h=g?angular.fromJson(g):[],i=this.$$storage.getItem(this.$$prefix+".data."+a);i&&this.remove(a),this.$$expiresHeap.push({key:a,expires:f.expires}),this.$$lruHeap.push({key:a,accessed:f.accessed}),this.$$storage.setItem(this.$$prefix+".data."+a,angular.toJson(f));for(var j=!1,k=0;k<h.length;k++)if(h[k]===a){j=!0;break}j||h.push(a),this.$$storage.setItem(this.$$prefix+".keys",angular.toJson(h))}else this.$$data[a]&&this.remove(a),this.$$expiresHeap.push(f),this.$$lruHeap.push(f),this.$$data[a]=f;return this.$$lruHeap.size()>this.$$capacity&&this.remove(this.$$lruHeap.peek().key),b}}},{"../utils":21}],9:[function(a,b){b.exports=function(a){if(!this.$$storage){var b=this.$$data[a]?this.$$data[a].value:void 0;return this.$$lruHeap.remove(this.$$data[a]),this.$$expiresHeap.remove(this.$$data[a]),this.$$data[a]=null,delete this.$$data[a],b}var c=this.$$storage.getItem(this.$$prefix+".data."+a);if(c){var d=angular.fromJson(c);this.$$lruHeap.remove({key:a,accessed:d.accessed}),this.$$expiresHeap.remove({key:a,expires:d.expires}),this.$$storage.removeItem(this.$$prefix+".data."+a);var e=this.$$storage.getItem(this.$$prefix+".keys"),f=e?angular.fromJson(e):[],g=f.indexOf(a);return g>=0&&f.splice(g,1),this.$$storage.setItem(this.$$prefix+".keys",angular.toJson(f)),d.value}}},{}],10:[function(a,b){b.exports=function(){if(this.$$storage){this.$$lruHeap.removeAll(),this.$$expiresHeap.removeAll();var a=this.$$storage.getItem(this.$$prefix+".keys");if(a)for(var b=angular.fromJson(a),c=0;c<b.length;c++)this.remove(b[c]);this.$$storage.setItem(this.$$prefix+".keys",angular.toJson([]))}else{this.$$lruHeap.removeAll(),this.$$expiresHeap.removeAll();for(var d in this.$$data)this.$$data[d]=null;this.$$data={}}}},{}],11:[function(a,b){b.exports=function(){for(var a,b,c=(new Date).getTime(),d={};(b=this.$$expiresHeap.peek())&&b.expires<c;)d[b.key]=b.value?b.value:null,this.$$expiresHeap.pop();if(this.$$storage)for(a in d){var e=this.$$storage.getItem(this.$$prefix+".data."+a);e&&(d[a]=angular.fromJson(e).value,this.remove(a))}else for(a in d)this.remove(a);if(this.$$onExpire)for(a in d)this.$$onExpire(a,d[a]);return d}},{}],12:[function(a,b){b.exports=function(a){if(null===a)delete this.$$cacheFlushInterval;else{if(!angular.isNumber(a))throw angular.$$minErr("ng")("areq","Expected cacheFlushInterval to be a number! Found: {0}.",typeof a);if(0>a)throw angular.$$minErr("ng")("areq","Expected cacheFlushInterval to be greater than zero! Found: {0}.",a);a!==this.$$cacheFlushInterval&&(this.$$cacheFlushInterval=a,clearInterval(this.$$cacheFlushIntervalId),function(a){a.$$cacheFlushIntervalId=setInterval(function(){a.removeAll()},a.$$cacheFlushInterval)}(this))}}},{}],13:[function(a,b){b.exports=function(a){if(null===a)delete this.$$capacity;else{if(!angular.isNumber(a))throw angular.$$minErr("ng")("areq","Expected capacity to be a number! Found: {0}.",typeof a);if(0>a)throw angular.$$minErr("ng")("areq","Expected capacity to be greater than zero! Found: {0}.",a);this.$$capacity=a}for(var b={};this.$$lruHeap.size()>this.$$capacity;)b[this.$$lruHeap.peek().key]=this.remove(this.$$lruHeap.peek().key);return b}},{}],14:[function(a,b){b.exports=function(a){if(null===a)delete this.$$deleteOnExpire;else{if(!angular.isString(a))throw angular.$$minErr("ng")("areq","Expected deleteOnExpire to be a string! Found: {0}.",typeof a);if("none"!==a&&"passive"!==a&&"aggressive"!==a)throw angular.$$minErr("ng")("areq",'Expected deleteOnExpire to be "none", "passive" or "aggressive"! Found: {0}.',a);this.$$deleteOnExpire=a}this.setRecycleFreq(this.$$recycleFreq)}},{}],15:[function(a,b){var c=a("../utils");b.exports=function(a){if(null===a)delete this.$$maxAge;else{if(!angular.isNumber(a))throw angular.$$minErr("ng")("areq","Expected maxAge to be a number! Found: {0}.",typeof a);if(0>a)throw angular.$$minErr("ng")("areq","Expected maxAge to be greater than zero! Found: {0}.",a);this.$$maxAge=a}var b,d,e;if(this.$$expiresHeap.removeAll(),this.$$storage){var f=this.$$storage.getItem(this.$$prefix+".keys");for(d=f?angular.fromJson(f):[],b=0;b<d.length;b++){e=d[b];var g=this.$$storage.getItem(this.$$prefix+".data."+e);if(g){var h=angular.fromJson(g);h.expires=this.$$maxAge===Number.MAX_VALUE?Number.MAX_VALUE:h.created+this.$$maxAge,this.$$expiresHeap.push({key:e,expires:h.expires})}}}else for(d=c.keys(this.$$data),b=0;b<d.length;b++)e=d[b],this.$$data[e].expires=this.$$maxAge===Number.MAX_VALUE?Number.MAX_VALUE:this.$$data[e].created+this.$$maxAge,this.$$expiresHeap.push(this.$$data[e]);return"aggressive"===this.$$deleteOnExpire?this.removeExpired():{}}},{"../utils":21}],16:[function(a,b){b.exports=function(a){if(null===a)delete this.$$onExpire;else{if(!angular.isFunction(a))throw angular.$$minErr("ng")("areq","Expected onExpire to be a function! Found: {0}.",typeof a);this.$$onExpire=a}}},{}],17:[function(a,b){b.exports=function(a){if(null===a)delete this.$$recycleFreq;else{if(!angular.isNumber(a))throw angular.$$minErr("ng")("areq","Expected recycleFreq to be a number! Found: {0}.",typeof a);if(0>a)throw angular.$$minErr("ng")("areq","Expected recycleFreq to be greater than zero! Found: {0}.",a);this.$$recycleFreq=a}clearInterval(this.$$recycleFreqId),"aggressive"===this.$$deleteOnExpire?!function(a){a.$$recycleFreqId=setInterval(function(){a.removeExpired()},a.$$recycleFreq)}(this):delete this.$$recycleFreqId}},{}],18:[function(a,b){function c(){var a=new d.Config;this.version=f,this.setCacheDefaults=function(b){if(b=b||{},!angular.isObject(b))throw angular.$$minErr("ng")("areq","Expected options to be an object! Found: {0}.",typeof b);for(var c in d.defaults)c in b&&(a[c]=b[c]);"disabled"in b&&(a.$$disabled=!!b.disabled)},this.$get=function(){function b(a){var b,c=[];for(b in a)a.hasOwnProperty(b)&&c.push(b);return c}function c(b,c){if(b in h)throw angular.$$minErr("$cacheFactory")("iid","CacheId '{0}' is already taken!",b);if(!angular.isString(b))throw angular.$$minErr("ng")("areq","Expected cacheId to be a string! Found: {0}.",typeof b);return h[b]=new e(b,angular.extend({},a,c)),h[b].destroy=function(){this.constructor.prototype.destroy.call(this),delete h[this.$$id]},h[b]}function g(a,b){return c(a,b)}var h={};return g.createCache=c,g.version=f,g.info=function(){for(var c=b(h),e={size:c.length,caches:{}},f=0;f<c.length;f++){var g=c[f];e.caches[g]=h[g].info()}var i=e.cacheDefaults=angular.extend({},a);for(var j in d.defaults)j in i||(i[j]=a["$$"+j]);return e},g.get=function(a){if(!angular.isString(a))throw angular.$$minErr("ng")("areq","Expected cacheId to be a string! Found: {0}.",typeof a);return h[a]},g.keySet=function(){var a,b={};for(a in h)h.hasOwnProperty(a)&&(b[a]=a);return b},g.keys=function(){return b(h)},g.destroyAll=function(){for(var a in h)h[a].destroy();h={}},g.clearAll=function(){for(var a in h)h[a].removeAll()},g.enableAll=function(){for(var a in h)h[a].$$disabled=!1},g.disableAll=function(){for(var a in h)h[a].$$disabled=!0},g}}var d=a("../defaults"),e=a("../DSCache"),f="3.1.1";b.exports=c},{"../DSCache":4,"../defaults":19}],19:[function(a,b){function c(){}var d={capacity:Number.MAX_VALUE,maxAge:Number.MAX_VALUE,deleteOnExpire:"none",onExpire:null,cacheFlushInterval:null,recycleFreq:1e3,storageMode:"memory",storageImpl:null,disabled:!1,storagePrefix:"angular-cache.caches."};for(var e in d)c.prototype["$$"+e]=d[e];b.exports={Config:c,defaults:d}},{}],20:[function(a){!function(b,c){"use strict";c.$$minErr=c.$$minErr||function(a){return function(){var b,d,e=arguments[0],f="["+(a?a+":":"")+e+"] ",g=arguments[1],h=arguments,i=function(a){return"function"==typeof a?a.toString().replace(/ \{[\s\S]*$/,""):"undefined"==typeof a?"undefined":"string"!=typeof a?JSON.stringify(a):a};for(b=f+g.replace(/\{\d+\}/g,function(a){var b,d=+a.slice(1,-1);return d+2<h.length?(b=h[d+2],"function"==typeof b?b.toString().replace(/ ?\{[\s\S]*$/,""):"undefined"==typeof b?"undefined":"string"!=typeof b?c.toJson(b):b):a}),b=b+"\nhttp://errors.angularjs.org/"+c.version.full+"/"+(a?a+"/":"")+e,d=2;d<arguments.length;d++)b=b+(2==d?"?":"&")+"p"+(d-2)+"="+encodeURIComponent(i(arguments[d]));return new Error(b)}},c.module("angular-data.DSBinaryHeap",[]).provider("DSBinaryHeap",a("./DSBinaryHeap").DSBinaryHeapProvider),c.module("angular-data.DSCacheFactory",["ng","angular-data.DSBinaryHeap"]).provider("DSCacheFactory",a("./DSCacheFactory"))}(window,window.angular)},{"./DSBinaryHeap":1,"./DSCacheFactory":18}],21:[function(a,b){b.exports={stringifyNumber:function(a){return a&&angular.isNumber(a)?a.toString():a},keySet:function(a){var b,c={};for(b in a)a.hasOwnProperty(b)&&(c[b]=b);return c},keys:function(a){var b,c=[];for(b in a)a.hasOwnProperty(b)&&c.push(b);return c}}},{}]},{},[20]);
//# sourceMappingURL=angular-cache.min.map
/**
* @author Jason Dobry <jason.dobry@gmail.com>
* @file angular-data.js
* @version 1.0.1 - Homepage <http://angular-data.pseudobry.com/>
* @copyright (c) 2014 Jason Dobry <https://github.com/jmdobry/>
* @license MIT <https://github.com/jmdobry/angular-data/blob/master/LICENSE>
*
* @overview Data store for Angular.js.
*/
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
// Copyright 2012 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// Modifications
// Copyright 2014 Jason Dobry
//
// Summary of modifications:
// Removed all code related to:
// - ArrayObserver
// - ArraySplice
// - PathObserver
// - CompoundObserver
// - Path
// - ObserverTransform
(function(global) {
  'use strict';

  // Detect and do basic sanity checking on Object/Array.observe.
  function detectObjectObserve() {
    if (typeof Object.observe !== 'function' ||
        typeof Array.observe !== 'function') {
      return false;
    }

    var records = [];

    function callback(recs) {
      records = recs;
    }

    var test = {};
    var arr = [];
    Object.observe(test, callback);
    Array.observe(arr, callback);
    test.id = 1;
    test.id = 2;
    delete test.id;
    arr.push(1, 2);
    arr.length = 0;

    Object.deliverChangeRecords(callback);
    if (records.length !== 5)
      return false;

    if (records[0].type != 'add' ||
        records[1].type != 'update' ||
        records[2].type != 'delete' ||
        records[3].type != 'splice' ||
        records[4].type != 'splice') {
      return false;
    }

    Object.unobserve(test, callback);
    Array.unobserve(arr, callback);

    return true;
  }

  var hasObserve = detectObjectObserve();

  function detectEval() {
    // Don't test for eval if we're running in a Chrome App environment.
    // We check for APIs set that only exist in a Chrome App context.
    if (typeof chrome !== 'undefined' && chrome.app && chrome.app.runtime) {
      return false;
    }

    try {
      var f = new Function('', 'return true;');
      return f();
    } catch (ex) {
      return false;
    }
  }

  var hasEval = detectEval();

  var createObject = ('__proto__' in {}) ?
    function(obj) { return obj; } :
    function(obj) {
      var proto = obj.__proto__;
      if (!proto)
        return obj;
      var newObject = Object.create(proto);
      Object.getOwnPropertyNames(obj).forEach(function(name) {
        Object.defineProperty(newObject, name,
                             Object.getOwnPropertyDescriptor(obj, name));
      });
      return newObject;
    };

  var MAX_DIRTY_CHECK_CYCLES = 1000;

  function dirtyCheck(observer) {
    var cycles = 0;
    while (cycles < MAX_DIRTY_CHECK_CYCLES && observer.check_()) {
      cycles++;
    }
    if (global.testingExposeCycleCount)
      global.dirtyCheckCycleCount = cycles;

    return cycles > 0;
  }

  function objectIsEmpty(object) {
    for (var prop in object)
      return false;
    return true;
  }

  function diffIsEmpty(diff) {
    return objectIsEmpty(diff.added) &&
           objectIsEmpty(diff.removed) &&
           objectIsEmpty(diff.changed);
  }

  function diffObjectFromOldObject(object, oldObject) {
    var added = {};
    var removed = {};
    var changed = {};

    for (var prop in oldObject) {
      var newValue = object[prop];

      if (newValue !== undefined && newValue === oldObject[prop])
        continue;

      if (!(prop in object)) {
        removed[prop] = undefined;
        continue;
      }

      if (newValue !== oldObject[prop])
        changed[prop] = newValue;
    }

    for (var prop in object) {
      if (prop in oldObject)
        continue;

      added[prop] = object[prop];
    }

    if (Array.isArray(object) && object.length !== oldObject.length)
      changed.length = object.length;

    return {
      added: added,
      removed: removed,
      changed: changed
    };
  }

  var eomTasks = [];
  function runEOMTasks() {
    if (!eomTasks.length)
      return false;

    for (var i = 0; i < eomTasks.length; i++) {
      eomTasks[i]();
    }
    eomTasks.length = 0;
    return true;
  }

  var runEOM = hasObserve ? (function(){
    var eomObj = { pingPong: true };
    var eomRunScheduled = false;

    Object.observe(eomObj, function() {
      runEOMTasks();
      eomRunScheduled = false;
    });

    return function(fn) {
      eomTasks.push(fn);
      if (!eomRunScheduled) {
        eomRunScheduled = true;
        eomObj.pingPong = !eomObj.pingPong;
      }
    };
  })() :
  (function() {
    return function(fn) {
      eomTasks.push(fn);
    };
  })();

  var observedObjectCache = [];

  function newObservedObject() {
    var observer;
    var object;
    var discardRecords = false;
    var first = true;

    function callback(records) {
      if (observer && observer.state_ === OPENED && !discardRecords)
        observer.check_(records);
    }

    return {
      open: function(obs) {
        if (observer)
          throw Error('ObservedObject in use');

        if (!first)
          Object.deliverChangeRecords(callback);

        observer = obs;
        first = false;
      },
      observe: function(obj, arrayObserve) {
        object = obj;
        if (arrayObserve)
          Array.observe(object, callback);
        else
          Object.observe(object, callback);
      },
      deliver: function(discard) {
        discardRecords = discard;
        Object.deliverChangeRecords(callback);
        discardRecords = false;
      },
      close: function() {
        observer = undefined;
        Object.unobserve(object, callback);
        observedObjectCache.push(this);
      }
    };
  }

  /*
   * The observedSet abstraction is a perf optimization which reduces the total
   * number of Object.observe observations of a set of objects. The idea is that
   * groups of Observers will have some object dependencies in common and this
   * observed set ensures that each object in the transitive closure of
   * dependencies is only observed once. The observedSet acts as a write barrier
   * such that whenever any change comes through, all Observers are checked for
   * changed values.
   *
   * Note that this optimization is explicitly moving work from setup-time to
   * change-time.
   *
   * TODO(rafaelw): Implement "garbage collection". In order to move work off
   * the critical path, when Observers are closed, their observed objects are
   * not Object.unobserve(d). As a result, it's possible that if the observedSet
   * is kept open, but some Observers have been closed, it could cause "leaks"
   * (prevent otherwise collectable objects from being collected). At some
   * point, we should implement incremental "gc" which keeps a list of
   * observedSets which may need clean-up and does small amounts of cleanup on a
   * timeout until all is clean.
   */

  function getObservedObject(observer, object, arrayObserve) {
    var dir = observedObjectCache.pop() || newObservedObject();
    dir.open(observer);
    dir.observe(object, arrayObserve);
    return dir;
  }

  var UNOPENED = 0;
  var OPENED = 1;
  var CLOSED = 2;

  var nextObserverId = 1;

  function Observer() {
    this.state_ = UNOPENED;
    this.callback_ = undefined;
    this.target_ = undefined; // TODO(rafaelw): Should be WeakRef
    this.directObserver_ = undefined;
    this.value_ = undefined;
    this.id_ = nextObserverId++;
  }

  Observer.prototype = {
    open: function(callback, target) {
      if (this.state_ != UNOPENED)
        throw Error('Observer has already been opened.');

      addToAll(this);
      this.callback_ = callback;
      this.target_ = target;
      this.connect_();
      this.state_ = OPENED;
      return this.value_;
    },

    close: function() {
      if (this.state_ != OPENED)
        return;

      removeFromAll(this);
      this.disconnect_();
      this.value_ = undefined;
      this.callback_ = undefined;
      this.target_ = undefined;
      this.state_ = CLOSED;
    },

    deliver: function() {
      if (this.state_ != OPENED)
        return;

      dirtyCheck(this);
    },

    report_: function(changes) {
      try {
        this.callback_.apply(this.target_, changes);
      } catch (ex) {
        Observer._errorThrownDuringCallback = true;
        console.error('Exception caught during observer callback: ' +
                       (ex.stack || ex));
      }
    },

    discardChanges: function() {
      this.check_(undefined, true);
      return this.value_;
    }
  }

  var collectObservers = !hasObserve;
  var allObservers;
  Observer._allObserversCount = 0;

  if (collectObservers) {
    allObservers = [];
  }

  function addToAll(observer) {
    Observer._allObserversCount++;
    if (!collectObservers)
      return;

    allObservers.push(observer);
  }

  function removeFromAll(observer) {
    Observer._allObserversCount--;
  }

  var runningMicrotaskCheckpoint = false;

  var hasDebugForceFullDelivery = hasObserve && hasEval && (function() {
    try {
      eval('%RunMicrotasks()');
      return true;
    } catch (ex) {
      return false;
    }
  })();

  global.Platform = global.Platform || {};

  global.Platform.performMicrotaskCheckpoint = function() {
    if (runningMicrotaskCheckpoint)
      return;

    if (hasDebugForceFullDelivery) {
      eval('%RunMicrotasks()');
      return;
    }

    if (!collectObservers)
      return;

    runningMicrotaskCheckpoint = true;

    var cycles = 0;
    var anyChanged, toCheck;

    do {
      cycles++;
      toCheck = allObservers;
      allObservers = [];
      anyChanged = false;

      for (var i = 0; i < toCheck.length; i++) {
        var observer = toCheck[i];
        if (observer.state_ != OPENED)
          continue;

        if (observer.check_())
          anyChanged = true;

        allObservers.push(observer);
      }
      if (runEOMTasks())
        anyChanged = true;
    } while (cycles < MAX_DIRTY_CHECK_CYCLES && anyChanged);

    if (global.testingExposeCycleCount)
      global.dirtyCheckCycleCount = cycles;

    runningMicrotaskCheckpoint = false;
  };

  if (collectObservers) {
    global.Platform.clearObservers = function() {
      allObservers = [];
    };
  }

  function ObjectObserver(object) {
    Observer.call(this);
    this.value_ = object;
    this.oldObject_ = undefined;
  }

  ObjectObserver.prototype = createObject({
    __proto__: Observer.prototype,

    arrayObserve: false,

    connect_: function(callback, target) {
      if (hasObserve) {
        this.directObserver_ = getObservedObject(this, this.value_,
                                                 this.arrayObserve);
      } else {
        this.oldObject_ = this.copyObject(this.value_);
      }

    },

    copyObject: function(object) {
      var copy = Array.isArray(object) ? [] : {};
      for (var prop in object) {
        copy[prop] = object[prop];
      };
      if (Array.isArray(object))
        copy.length = object.length;
      return copy;
    },

    check_: function(changeRecords, skipChanges) {
      var diff;
      var oldValues;
      if (hasObserve) {
        if (!changeRecords)
          return false;

        oldValues = {};
        diff = diffObjectFromChangeRecords(this.value_, changeRecords,
                                           oldValues);
      } else {
        oldValues = this.oldObject_;
        diff = diffObjectFromOldObject(this.value_, this.oldObject_);
      }

      if (diffIsEmpty(diff))
        return false;

      if (!hasObserve)
        this.oldObject_ = this.copyObject(this.value_);

      this.report_([
        diff.added || {},
        diff.removed || {},
        diff.changed || {},
        function(property) {
          return oldValues[property];
        }
      ]);

      return true;
    },

    disconnect_: function() {
      if (hasObserve) {
        this.directObserver_.close();
        this.directObserver_ = undefined;
      } else {
        this.oldObject_ = undefined;
      }
    },

    deliver: function() {
      if (this.state_ != OPENED)
        return;

      if (hasObserve)
        this.directObserver_.deliver(false);
      else
        dirtyCheck(this);
    },

    discardChanges: function() {
      if (this.directObserver_)
        this.directObserver_.deliver(true);
      else
        this.oldObject_ = this.copyObject(this.value_);

      return this.value_;
    }
  });

  var observerSentinel = {};

  var expectedRecordTypes = {
    add: true,
    update: true,
    delete: true
  };

  function diffObjectFromChangeRecords(object, changeRecords, oldValues) {
    var added = {};
    var removed = {};

    for (var i = 0; i < changeRecords.length; i++) {
      var record = changeRecords[i];
      if (!expectedRecordTypes[record.type]) {
        console.error('Unknown changeRecord type: ' + record.type);
        console.error(record);
        continue;
      }

      if (!(record.name in oldValues))
        oldValues[record.name] = record.oldValue;

      if (record.type == 'update')
        continue;

      if (record.type == 'add') {
        if (record.name in removed)
          delete removed[record.name];
        else
          added[record.name] = true;

        continue;
      }

      // type = 'delete'
      if (record.name in added) {
        delete added[record.name];
        delete oldValues[record.name];
      } else {
        removed[record.name] = true;
      }
    }

    for (var prop in added)
      added[prop] = object[prop];

    for (var prop in removed)
      removed[prop] = undefined;

    var changed = {};
    for (var prop in oldValues) {
      if (prop in added || prop in removed)
        continue;

      var newValue = object[prop];
      if (oldValues[prop] !== newValue)
        changed[prop] = newValue;
    }

    return {
      added: added,
      removed: removed,
      changed: changed
    };
  }

  global.Observer = Observer;
  global.Observer.runEOM_ = runEOM;
  global.Observer.observerSentinel_ = observerSentinel; // for testing.
  global.Observer.hasObjectObserve = hasObserve;

  global.ObjectObserver = ObjectObserver;
})((exports.Number = { isNaN: window.isNaN }) ? exports : exports);

},{}],2:[function(require,module,exports){
var indexOf = require('./indexOf');

    /**
     * If array contains values.
     */
    function contains(arr, val) {
        return indexOf(arr, val) !== -1;
    }
    module.exports = contains;


},{"./indexOf":5}],3:[function(require,module,exports){
var makeIterator = require('../function/makeIterator_');

    /**
     * Array filter
     */
    function filter(arr, callback, thisObj) {
        callback = makeIterator(callback, thisObj);
        var results = [];
        if (arr == null) {
            return results;
        }

        var i = -1, len = arr.length, value;
        while (++i < len) {
            value = arr[i];
            if (callback(value, i, arr)) {
                results.push(value);
            }
        }

        return results;
    }

    module.exports = filter;



},{"../function/makeIterator_":12}],4:[function(require,module,exports){


    /**
     * Array forEach
     */
    function forEach(arr, callback, thisObj) {
        if (arr == null) {
            return;
        }
        var i = -1,
            len = arr.length;
        while (++i < len) {
            // we iterate over sparse items since there is no way to make it
            // work properly on IE 7-8. see #64
            if ( callback.call(thisObj, arr[i], i, arr) === false ) {
                break;
            }
        }
    }

    module.exports = forEach;



},{}],5:[function(require,module,exports){


    /**
     * Array.indexOf
     */
    function indexOf(arr, item, fromIndex) {
        fromIndex = fromIndex || 0;
        if (arr == null) {
            return -1;
        }

        var len = arr.length,
            i = fromIndex < 0 ? len + fromIndex : fromIndex;
        while (i < len) {
            // we iterate over sparse items since there is no way to make it
            // work properly on IE 7-8. see #64
            if (arr[i] === item) {
                return i;
            }

            i++;
        }

        return -1;
    }

    module.exports = indexOf;


},{}],6:[function(require,module,exports){
var filter = require('./filter');

    function isValidString(val) {
        return (val != null && val !== '');
    }

    /**
     * Joins strings with the specified separator inserted between each value.
     * Null values and empty strings will be excluded.
     */
    function join(items, separator) {
        separator = separator || '';
        return filter(items, isValidString).join(separator);
    }

    module.exports = join;


},{"./filter":3}],7:[function(require,module,exports){
var indexOf = require('./indexOf');

    /**
     * Remove a single item from the array.
     * (it won't remove duplicates, just a single item)
     */
    function remove(arr, item){
        var idx = indexOf(arr, item);
        if (idx !== -1) arr.splice(idx, 1);
    }

    module.exports = remove;


},{"./indexOf":5}],8:[function(require,module,exports){


    /**
     * Create slice of source array or array-like object
     */
    function slice(arr, start, end){
        var len = arr.length;

        if (start == null) {
            start = 0;
        } else if (start < 0) {
            start = Math.max(len + start, 0);
        } else {
            start = Math.min(start, len);
        }

        if (end == null) {
            end = len;
        } else if (end < 0) {
            end = Math.max(len + end, 0);
        } else {
            end = Math.min(end, len);
        }

        var result = [];
        while (start < end) {
            result.push(arr[start++]);
        }

        return result;
    }

    module.exports = slice;



},{}],9:[function(require,module,exports){


    /**
     * Merge sort (http://en.wikipedia.org/wiki/Merge_sort)
     */
    function mergeSort(arr, compareFn) {
        if (arr == null) {
            return [];
        } else if (arr.length < 2) {
            return arr;
        }

        if (compareFn == null) {
            compareFn = defaultCompare;
        }

        var mid, left, right;

        mid   = ~~(arr.length / 2);
        left  = mergeSort( arr.slice(0, mid), compareFn );
        right = mergeSort( arr.slice(mid, arr.length), compareFn );

        return merge(left, right, compareFn);
    }

    function defaultCompare(a, b) {
        return a < b ? -1 : (a > b? 1 : 0);
    }

    function merge(left, right, compareFn) {
        var result = [];

        while (left.length && right.length) {
            if (compareFn(left[0], right[0]) <= 0) {
                // if 0 it should preserve same order (stable)
                result.push(left.shift());
            } else {
                result.push(right.shift());
            }
        }

        if (left.length) {
            result.push.apply(result, left);
        }

        if (right.length) {
            result.push.apply(result, right);
        }

        return result;
    }

    module.exports = mergeSort;



},{}],10:[function(require,module,exports){
var isFunction = require('../lang/isFunction');

    /**
     * Creates an object that holds a lookup for the objects in the array.
     */
    function toLookup(arr, key) {
        var result = {};
        if (arr == null) {
            return result;
        }

        var i = -1, len = arr.length, value;
        if (isFunction(key)) {
            while (++i < len) {
                value = arr[i];
                result[key(value)] = value;
            }
        } else {
            while (++i < len) {
                value = arr[i];
                result[value[key]] = value;
            }
        }

        return result;
    }
    module.exports = toLookup;


},{"../lang/isFunction":19}],11:[function(require,module,exports){


    /**
     * Returns the first argument provided to it.
     */
    function identity(val){
        return val;
    }

    module.exports = identity;



},{}],12:[function(require,module,exports){
var identity = require('./identity');
var prop = require('./prop');
var deepMatches = require('../object/deepMatches');

    /**
     * Converts argument into a valid iterator.
     * Used internally on most array/object/collection methods that receives a
     * callback/iterator providing a shortcut syntax.
     */
    function makeIterator(src, thisObj){
        if (src == null) {
            return identity;
        }
        switch(typeof src) {
            case 'function':
                // function is the first to improve perf (most common case)
                // also avoid using `Function#call` if not needed, which boosts
                // perf a lot in some cases
                return (typeof thisObj !== 'undefined')? function(val, i, arr){
                    return src.call(thisObj, val, i, arr);
                } : src;
            case 'object':
                return function(val){
                    return deepMatches(val, src);
                };
            case 'string':
            case 'number':
                return prop(src);
        }
    }

    module.exports = makeIterator;



},{"../object/deepMatches":27,"./identity":11,"./prop":13}],13:[function(require,module,exports){


    /**
     * Returns a function that gets a property of the passed object
     */
    function prop(name){
        return function(obj){
            return obj[name];
        };
    }

    module.exports = prop;



},{}],14:[function(require,module,exports){
var kindOf = require('./kindOf');
var isPlainObject = require('./isPlainObject');
var mixIn = require('../object/mixIn');

    /**
     * Clone native types.
     */
    function clone(val){
        switch (kindOf(val)) {
            case 'Object':
                return cloneObject(val);
            case 'Array':
                return cloneArray(val);
            case 'RegExp':
                return cloneRegExp(val);
            case 'Date':
                return cloneDate(val);
            default:
                return val;
        }
    }

    function cloneObject(source) {
        if (isPlainObject(source)) {
            return mixIn({}, source);
        } else {
            return source;
        }
    }

    function cloneRegExp(r) {
        var flags = '';
        flags += r.multiline ? 'm' : '';
        flags += r.global ? 'g' : '';
        flags += r.ignorecase ? 'i' : '';
        return new RegExp(r.source, flags);
    }

    function cloneDate(date) {
        return new Date(+date);
    }

    function cloneArray(arr) {
        return arr.slice();
    }

    module.exports = clone;



},{"../object/mixIn":34,"./isPlainObject":22,"./kindOf":23}],15:[function(require,module,exports){
var clone = require('./clone');
var forOwn = require('../object/forOwn');
var kindOf = require('./kindOf');
var isPlainObject = require('./isPlainObject');

    /**
     * Recursively clone native types.
     */
    function deepClone(val, instanceClone) {
        switch ( kindOf(val) ) {
            case 'Object':
                return cloneObject(val, instanceClone);
            case 'Array':
                return cloneArray(val, instanceClone);
            default:
                return clone(val);
        }
    }

    function cloneObject(source, instanceClone) {
        if (isPlainObject(source)) {
            var out = {};
            forOwn(source, function(val, key) {
                this[key] = deepClone(val, instanceClone);
            }, out);
            return out;
        } else if (instanceClone) {
            return instanceClone(source);
        } else {
            return source;
        }
    }

    function cloneArray(arr, instanceClone) {
        var out = [],
            i = -1,
            n = arr.length,
            val;
        while (++i < n) {
            out[i] = deepClone(arr[i], instanceClone);
        }
        return out;
    }

    module.exports = deepClone;




},{"../object/forOwn":30,"./clone":14,"./isPlainObject":22,"./kindOf":23}],16:[function(require,module,exports){
var isKind = require('./isKind');
    /**
     */
    var isArray = Array.isArray || function (val) {
        return isKind(val, 'Array');
    };
    module.exports = isArray;


},{"./isKind":20}],17:[function(require,module,exports){
var isKind = require('./isKind');
    /**
     */
    function isBoolean(val) {
        return isKind(val, 'Boolean');
    }
    module.exports = isBoolean;


},{"./isKind":20}],18:[function(require,module,exports){
var forOwn = require('../object/forOwn');
var isArray = require('./isArray');

    function isEmpty(val){
        if (val == null) {
            // typeof null == 'object' so we check it first
            return true;
        } else if ( typeof val === 'string' || isArray(val) ) {
            return !val.length;
        } else if ( typeof val === 'object' ) {
            var result = true;
            forOwn(val, function(){
                result = false;
                return false; // break loop
            });
            return result;
        } else {
            return true;
        }
    }

    module.exports = isEmpty;



},{"../object/forOwn":30,"./isArray":16}],19:[function(require,module,exports){
var isKind = require('./isKind');
    /**
     */
    function isFunction(val) {
        return isKind(val, 'Function');
    }
    module.exports = isFunction;


},{"./isKind":20}],20:[function(require,module,exports){
var kindOf = require('./kindOf');
    /**
     * Check if value is from a specific "kind".
     */
    function isKind(val, kind){
        return kindOf(val) === kind;
    }
    module.exports = isKind;


},{"./kindOf":23}],21:[function(require,module,exports){
var isKind = require('./isKind');
    /**
     */
    function isObject(val) {
        return isKind(val, 'Object');
    }
    module.exports = isObject;


},{"./isKind":20}],22:[function(require,module,exports){


    /**
     * Checks if the value is created by the `Object` constructor.
     */
    function isPlainObject(value) {
        return (!!value && typeof value === 'object' &&
            value.constructor === Object);
    }

    module.exports = isPlainObject;



},{}],23:[function(require,module,exports){


    var _rKind = /^\[object (.*)\]$/,
        _toString = Object.prototype.toString,
        UNDEF;

    /**
     * Gets the "kind" of value. (e.g. "String", "Number", etc)
     */
    function kindOf(val) {
        if (val === null) {
            return 'Null';
        } else if (val === UNDEF) {
            return 'Undefined';
        } else {
            return _rKind.exec( _toString.call(val) )[1];
        }
    }
    module.exports = kindOf;


},{}],24:[function(require,module,exports){


    /**
     * Typecast a value to a String, using an empty string value for null or
     * undefined.
     */
    function toString(val){
        return val == null ? '' : val.toString();
    }

    module.exports = toString;



},{}],25:[function(require,module,exports){
/**
 * @constant Maximum 32-bit signed integer value. (2^31 - 1)
 */

    module.exports = 2147483647;


},{}],26:[function(require,module,exports){
/**
 * @constant Minimum 32-bit signed integer value (-2^31).
 */

    module.exports = -2147483648;


},{}],27:[function(require,module,exports){
var forOwn = require('./forOwn');
var isArray = require('../lang/isArray');

    function containsMatch(array, pattern) {
        var i = -1, length = array.length;
        while (++i < length) {
            if (deepMatches(array[i], pattern)) {
                return true;
            }
        }

        return false;
    }

    function matchArray(target, pattern) {
        var i = -1, patternLength = pattern.length;
        while (++i < patternLength) {
            if (!containsMatch(target, pattern[i])) {
                return false;
            }
        }

        return true;
    }

    function matchObject(target, pattern) {
        var result = true;
        forOwn(pattern, function(val, key) {
            if (!deepMatches(target[key], val)) {
                // Return false to break out of forOwn early
                return (result = false);
            }
        });

        return result;
    }

    /**
     * Recursively check if the objects match.
     */
    function deepMatches(target, pattern){
        if (target && typeof target === 'object') {
            if (isArray(target) && isArray(pattern)) {
                return matchArray(target, pattern);
            } else {
                return matchObject(target, pattern);
            }
        } else {
            return target === pattern;
        }
    }

    module.exports = deepMatches;



},{"../lang/isArray":16,"./forOwn":30}],28:[function(require,module,exports){
var forOwn = require('./forOwn');
var isPlainObject = require('../lang/isPlainObject');

    /**
     * Mixes objects into the target object, recursively mixing existing child
     * objects.
     */
    function deepMixIn(target, objects) {
        var i = 0,
            n = arguments.length,
            obj;

        while(++i < n){
            obj = arguments[i];
            if (obj) {
                forOwn(obj, copyProp, target);
            }
        }

        return target;
    }

    function copyProp(val, key) {
        var existing = this[key];
        if (isPlainObject(val) && isPlainObject(existing)) {
            deepMixIn(existing, val);
        } else {
            this[key] = val;
        }
    }

    module.exports = deepMixIn;



},{"../lang/isPlainObject":22,"./forOwn":30}],29:[function(require,module,exports){
var hasOwn = require('./hasOwn');

    var _hasDontEnumBug,
        _dontEnums;

    function checkDontEnum(){
        _dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ];

        _hasDontEnumBug = true;

        for (var key in {'toString': null}) {
            _hasDontEnumBug = false;
        }
    }

    /**
     * Similar to Array/forEach but works over object properties and fixes Don't
     * Enum bug on IE.
     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
     */
    function forIn(obj, fn, thisObj){
        var key, i = 0;
        // no need to check if argument is a real object that way we can use
        // it for arrays, functions, date, etc.

        //post-pone check till needed
        if (_hasDontEnumBug == null) checkDontEnum();

        for (key in obj) {
            if (exec(fn, obj, key, thisObj) === false) {
                break;
            }
        }


        if (_hasDontEnumBug) {
            var ctor = obj.constructor,
                isProto = !!ctor && obj === ctor.prototype;

            while (key = _dontEnums[i++]) {
                // For constructor, if it is a prototype object the constructor
                // is always non-enumerable unless defined otherwise (and
                // enumerated above).  For non-prototype objects, it will have
                // to be defined on this object, since it cannot be defined on
                // any prototype objects.
                //
                // For other [[DontEnum]] properties, check if the value is
                // different than Object prototype value.
                if (
                    (key !== 'constructor' ||
                        (!isProto && hasOwn(obj, key))) &&
                    obj[key] !== Object.prototype[key]
                ) {
                    if (exec(fn, obj, key, thisObj) === false) {
                        break;
                    }
                }
            }
        }
    }

    function exec(fn, obj, key, thisObj){
        return fn.call(thisObj, obj[key], key, obj);
    }

    module.exports = forIn;



},{"./hasOwn":31}],30:[function(require,module,exports){
var hasOwn = require('./hasOwn');
var forIn = require('./forIn');

    /**
     * Similar to Array/forEach but works over object properties and fixes Don't
     * Enum bug on IE.
     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
     */
    function forOwn(obj, fn, thisObj){
        forIn(obj, function(val, key){
            if (hasOwn(obj, key)) {
                return fn.call(thisObj, obj[key], key, obj);
            }
        });
    }

    module.exports = forOwn;



},{"./forIn":29,"./hasOwn":31}],31:[function(require,module,exports){


    /**
     * Safer Object.hasOwnProperty
     */
     function hasOwn(obj, prop){
         return Object.prototype.hasOwnProperty.call(obj, prop);
     }

     module.exports = hasOwn;



},{}],32:[function(require,module,exports){
var forOwn = require('./forOwn');

    /**
     * Get object keys
     */
     var keys = Object.keys || function (obj) {
            var keys = [];
            forOwn(obj, function(val, key){
                keys.push(key);
            });
            return keys;
        };

    module.exports = keys;



},{"./forOwn":30}],33:[function(require,module,exports){
var hasOwn = require('./hasOwn');
var deepClone = require('../lang/deepClone');
var isObject = require('../lang/isObject');

    /**
     * Deep merge objects.
     */
    function merge() {
        var i = 1,
            key, val, obj, target;

        // make sure we don't modify source element and it's properties
        // objects are passed by reference
        target = deepClone( arguments[0] );

        while (obj = arguments[i++]) {
            for (key in obj) {
                if ( ! hasOwn(obj, key) ) {
                    continue;
                }

                val = obj[key];

                if ( isObject(val) && isObject(target[key]) ){
                    // inception, deep merge objects
                    target[key] = merge(target[key], val);
                } else {
                    // make sure arrays, regexp, date, objects are cloned
                    target[key] = deepClone(val);
                }

            }
        }

        return target;
    }

    module.exports = merge;



},{"../lang/deepClone":15,"../lang/isObject":21,"./hasOwn":31}],34:[function(require,module,exports){
var forOwn = require('./forOwn');

    /**
    * Combine properties from all the objects into first one.
    * - This method affects target object in place, if you want to create a new Object pass an empty object as first param.
    * @param {object} target    Target Object
    * @param {...object} objects    Objects to be combined (0...n objects).
    * @return {object} Target Object.
    */
    function mixIn(target, objects){
        var i = 0,
            n = arguments.length,
            obj;
        while(++i < n){
            obj = arguments[i];
            if (obj != null) {
                forOwn(obj, copyProp, target);
            }
        }
        return target;
    }

    function copyProp(val, key){
        this[key] = val;
    }

    module.exports = mixIn;


},{"./forOwn":30}],35:[function(require,module,exports){
var forEach = require('../array/forEach');

    /**
     * Create nested object if non-existent
     */
    function namespace(obj, path){
        if (!path) return obj;
        forEach(path.split('.'), function(key){
            if (!obj[key]) {
                obj[key] = {};
            }
            obj = obj[key];
        });
        return obj;
    }

    module.exports = namespace;



},{"../array/forEach":4}],36:[function(require,module,exports){
var slice = require('../array/slice');

    /**
     * Return a copy of the object, filtered to only have values for the whitelisted keys.
     */
    function pick(obj, var_keys){
        var keys = typeof arguments[1] !== 'string'? arguments[1] : slice(arguments, 1),
            out = {},
            i = 0, key;
        while (key = keys[i++]) {
            out[key] = obj[key];
        }
        return out;
    }

    module.exports = pick;



},{"../array/slice":8}],37:[function(require,module,exports){
var namespace = require('./namespace');

    /**
     * set "nested" object property
     */
    function set(obj, prop, val){
        var parts = (/^(.+)\.(.+)$/).exec(prop);
        if (parts){
            namespace(obj, parts[1])[parts[2]] = val;
        } else {
            obj[prop] = val;
        }
    }

    module.exports = set;



},{"./namespace":35}],38:[function(require,module,exports){
var randInt = require('./randInt');
var isArray = require('../lang/isArray');

    /**
     * Returns a random element from the supplied arguments
     * or from the array (if single argument is an array).
     */
    function choice(items) {
        var target = (arguments.length === 1 && isArray(items))? items : arguments;
        return target[ randInt(0, target.length - 1) ];
    }

    module.exports = choice;



},{"../lang/isArray":16,"./randInt":42}],39:[function(require,module,exports){
var randHex = require('./randHex');
var choice = require('./choice');

  /**
   * Returns pseudo-random guid (UUID v4)
   * IMPORTANT: it's not totally "safe" since randHex/choice uses Math.random
   * by default and sequences can be predicted in some cases. See the
   * "random/random" documentation for more info about it and how to replace
   * the default PRNG.
   */
  function guid() {
    return (
        randHex(8)+'-'+
        randHex(4)+'-'+
        // v4 UUID always contain "4" at this position to specify it was
        // randomly generated
        '4' + randHex(3) +'-'+
        // v4 UUID always contain chars [a,b,8,9] at this position
        choice(8, 9, 'a', 'b') + randHex(3)+'-'+
        randHex(12)
    );
  }
  module.exports = guid;


},{"./choice":38,"./randHex":41}],40:[function(require,module,exports){
var random = require('./random');
var MIN_INT = require('../number/MIN_INT');
var MAX_INT = require('../number/MAX_INT');

    /**
     * Returns random number inside range
     */
    function rand(min, max){
        min = min == null? MIN_INT : min;
        max = max == null? MAX_INT : max;
        return min + (max - min) * random();
    }

    module.exports = rand;


},{"../number/MAX_INT":25,"../number/MIN_INT":26,"./random":43}],41:[function(require,module,exports){
var choice = require('./choice');

    var _chars = '0123456789abcdef'.split('');

    /**
     * Returns a random hexadecimal string
     */
    function randHex(size){
        size = size && size > 0? size : 6;
        var str = '';
        while (size--) {
            str += choice(_chars);
        }
        return str;
    }

    module.exports = randHex;



},{"./choice":38}],42:[function(require,module,exports){
var MIN_INT = require('../number/MIN_INT');
var MAX_INT = require('../number/MAX_INT');
var rand = require('./rand');

    /**
     * Gets random integer inside range or snap to min/max values.
     */
    function randInt(min, max){
        min = min == null? MIN_INT : ~~min;
        max = max == null? MAX_INT : ~~max;
        // can't be max + 0.5 otherwise it will round up if `rand`
        // returns `max` causing it to overflow range.
        // -0.5 and + 0.49 are required to avoid bias caused by rounding
        return Math.round( rand(min - 0.5, max + 0.499999999999) );
    }

    module.exports = randInt;


},{"../number/MAX_INT":25,"../number/MIN_INT":26,"./rand":40}],43:[function(require,module,exports){


    /**
     * Just a wrapper to Math.random. No methods inside mout/random should call
     * Math.random() directly so we can inject the pseudo-random number
     * generator if needed (ie. in case we need a seeded random or a better
     * algorithm than the native one)
     */
    function random(){
        return random.get();
    }

    // we expose the method so it can be swapped if needed
    random.get = Math.random;

    module.exports = random;



},{}],44:[function(require,module,exports){
var toString = require('../lang/toString');
var replaceAccents = require('./replaceAccents');
var removeNonWord = require('./removeNonWord');
var upperCase = require('./upperCase');
var lowerCase = require('./lowerCase');
    /**
    * Convert string to camelCase text.
    */
    function camelCase(str){
        str = toString(str);
        str = replaceAccents(str);
        str = removeNonWord(str)
            .replace(/[\-_]/g, ' ') //convert all hyphens and underscores to spaces
            .replace(/\s[a-z]/g, upperCase) //convert first char of each word to UPPERCASE
            .replace(/\s+/g, '') //remove spaces
            .replace(/^[A-Z]/g, lowerCase); //convert first char to lowercase
        return str;
    }
    module.exports = camelCase;


},{"../lang/toString":24,"./lowerCase":45,"./removeNonWord":48,"./replaceAccents":49,"./upperCase":50}],45:[function(require,module,exports){
var toString = require('../lang/toString');
    /**
     * "Safer" String.toLowerCase()
     */
    function lowerCase(str){
        str = toString(str);
        return str.toLowerCase();
    }

    module.exports = lowerCase;


},{"../lang/toString":24}],46:[function(require,module,exports){
var join = require('../array/join');
var slice = require('../array/slice');

    /**
     * Group arguments as path segments, if any of the args is `null` or an
     * empty string it will be ignored from resulting path.
     */
    function makePath(var_args){
        var result = join(slice(arguments), '/');
        // need to disconsider duplicate '/' after protocol (eg: 'http://')
        return result.replace(/([^:\/]|^)\/{2,}/g, '$1/');
    }

    module.exports = makePath;


},{"../array/join":6,"../array/slice":8}],47:[function(require,module,exports){
var toString = require('../lang/toString');
var camelCase = require('./camelCase');
var upperCase = require('./upperCase');
    /**
     * camelCase + UPPERCASE first char
     */
    function pascalCase(str){
        str = toString(str);
        return camelCase(str).replace(/^[a-z]/, upperCase);
    }

    module.exports = pascalCase;


},{"../lang/toString":24,"./camelCase":44,"./upperCase":50}],48:[function(require,module,exports){
var toString = require('../lang/toString');
    // This pattern is generated by the _build/pattern-removeNonWord.js script
    var PATTERN = /[^\x20\x2D0-9A-Z\x5Fa-z\xC0-\xD6\xD8-\xF6\xF8-\xFF]/g;

    /**
     * Remove non-word chars.
     */
    function removeNonWord(str){
        str = toString(str);
        return str.replace(PATTERN, '');
    }

    module.exports = removeNonWord;


},{"../lang/toString":24}],49:[function(require,module,exports){
var toString = require('../lang/toString');
    /**
    * Replaces all accented chars with regular ones
    */
    function replaceAccents(str){
        str = toString(str);

        // verifies if the String has accents and replace them
        if (str.search(/[\xC0-\xFF]/g) > -1) {
            str = str
                    .replace(/[\xC0-\xC5]/g, "A")
                    .replace(/[\xC6]/g, "AE")
                    .replace(/[\xC7]/g, "C")
                    .replace(/[\xC8-\xCB]/g, "E")
                    .replace(/[\xCC-\xCF]/g, "I")
                    .replace(/[\xD0]/g, "D")
                    .replace(/[\xD1]/g, "N")
                    .replace(/[\xD2-\xD6\xD8]/g, "O")
                    .replace(/[\xD9-\xDC]/g, "U")
                    .replace(/[\xDD]/g, "Y")
                    .replace(/[\xDE]/g, "P")
                    .replace(/[\xE0-\xE5]/g, "a")
                    .replace(/[\xE6]/g, "ae")
                    .replace(/[\xE7]/g, "c")
                    .replace(/[\xE8-\xEB]/g, "e")
                    .replace(/[\xEC-\xEF]/g, "i")
                    .replace(/[\xF1]/g, "n")
                    .replace(/[\xF2-\xF6\xF8]/g, "o")
                    .replace(/[\xF9-\xFC]/g, "u")
                    .replace(/[\xFE]/g, "p")
                    .replace(/[\xFD\xFF]/g, "y");
        }
        return str;
    }
    module.exports = replaceAccents;


},{"../lang/toString":24}],50:[function(require,module,exports){
var toString = require('../lang/toString');
    /**
     * "Safer" String.toUpperCase()
     */
    function upperCase(str){
        str = toString(str);
        return str.toUpperCase();
    }
    module.exports = upperCase;


},{"../lang/toString":24}],51:[function(require,module,exports){
/**
 * @doc function
 * @id DSHttpAdapterProvider
 * @name DSHttpAdapterProvider
 */
function DSHttpAdapterProvider() {

  /**
   * @doc property
   * @id DSHttpAdapterProvider.properties:defaults
   * @name defaults
   * @description
   * Default configuration for this adapter.
   *
   * Properties:
   *
   * - `{function}` - `queryTransform` - See [the guide](/documentation/guide/adapters/index). Default: No-op.
   */
  var defaults = this.defaults = {
    /**
     * @doc property
     * @id DSHttpAdapterProvider.properties:defaults.queryTransform
     * @name defaults.queryTransform
     * @description
     * Transform the angular-data query to something your server understands. You might just do this on the server instead.
     *
     * ## Example:
     * ```js
     * DSHttpAdapterProvider.defaults.queryTransform = function (resourceName, params) {
     *   if (params && params.userId) {
     *     params.user_id = params.userId;
     *     delete params.userId;
     *   }
     *   return params;
     * };
     * ```
     *
     * @param {string} resourceName The name of the resource.
     * @param {object} params Params that will be passed to `$http`.
     * @returns {*} By default just returns `params` as-is.
     */
    queryTransform: function (resourceName, params) {
      return params;
    },

    forceTrailingSlash: false,

    /**
     * @doc property
     * @id DSHttpAdapterProvider.properties:defaults.$httpConfig
     * @name defaults.$httpConfig
     * @description
     * Default `$http` configuration options used whenever `DSHttpAdapter` uses `$http`.
     *
     * ## Example:
     * ```js
     * angular.module('myApp').config(function (DSHttpAdapterProvider) {
     *   angular.extend(DSHttpAdapterProvider.defaults.$httpConfig, {
     *     headers: {
     *       Authorization: 'Basic YmVlcDpib29w'
     *     },
     *     timeout: 20000
     *   });
     * });
     * ```
     */
    $httpConfig: {}
  };

  this.$get = ['$http', '$log', 'DSUtils', function ($http, $log, DSUtils) {

    /**
     * @doc interface
     * @id DSHttpAdapter
     * @name DSHttpAdapter
     * @description
     * Default adapter used by angular-data. This adapter uses AJAX and JSON to send/retrieve data to/from a server.
     * Developers may provide custom adapters that implement the adapter interface.
     */
    return {
      /**
       * @doc property
       * @id DSHttpAdapter.properties:defaults
       * @name defaults
       * @description
       * Reference to [DSHttpAdapterProvider.defaults](/documentation/api/api/DSHttpAdapterProvider.properties:defaults).
       */
      defaults: defaults,

      /**
       * @doc method
       * @id DSHttpAdapter.methods:HTTP
       * @name HTTP
       * @description
       * A wrapper for `$http()`.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.HTTP(config)
       * ```
       *
       * @param {object} config Configuration object.
       * @returns {Promise} Promise.
       */
      HTTP: function (config) {
        var start = new Date().getTime();

        if (this.defaults.forceTrailingSlash && config.url[config.url.length] !== '/') {
          config.url += '/';
        }
        config = DSUtils.deepMixIn(config, defaults.$httpConfig);
        return $http(config).then(function (data) {
          $log.debug(data.config.method + ' request:' + data.config.url + ' Time taken: ' + (new Date().getTime() - start) + 'ms', arguments);
          return data;
        });
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:GET
       * @name GET
       * @description
       * A wrapper for `$http.get()`.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.GET(url[, config])
       * ```
       *
       * @param {string} url The url of the request.
       * @param {object=} config Optional configuration.
       * @returns {Promise} Promise.
       */
      GET: function (url, config) {
        config = config || {};
        if (!('method' in config)) {
          config.method = 'GET';
        }
        return this.HTTP(DSUtils.deepMixIn(config, {
          url: url
        }));
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:POST
       * @name POST
       * @description
       * A wrapper for `$http.post()`.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.POST(url[, attrs][, config])
       * ```
       *
       * @param {string} url The url of the request.
       * @param {object=} attrs Request payload.
       * @param {object=} config Optional configuration.
       * @returns {Promise} Promise.
       */
      POST: function (url, attrs, config) {
        config = config || {};
        if (!('method' in config)) {
          config.method = 'POST';
        }
        return this.HTTP(DSUtils.deepMixIn(config, {
          url: url,
          data: attrs
        }));
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:PUT
       * @name PUT
       * @description
       * A wrapper for `$http.put()`.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.PUT(url[, attrs][, config])
       * ```
       *
       * @param {string} url The url of the request.
       * @param {object=} attrs Request payload.
       * @param {object=} config Optional configuration.
       * @returns {Promise} Promise.
       */
      PUT: function (url, attrs, config) {
        config = config || {};
        if (!('method' in config)) {
          config.method = 'PUT';
        }
        return this.HTTP(DSUtils.deepMixIn(config, {
          url: url,
          data: attrs || {}
        }));
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:DEL
       * @name DEL
       * @description
       * A wrapper for `$http.delete()`.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.DEL(url[, config])
       * ```
       *
       * @param {string} url The url of the request.
       * @param {object=} config Optional configuration.
       * @returns {Promise} Promise.
       */
      DEL: function (url, config) {
        config = config || {};
        if (!('method' in config)) {
          config.method = 'DELETE';
        }
        return this.HTTP(DSUtils.deepMixIn(config, {
          url: url
        }));
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:find
       * @name find
       * @description
       * Retrieve a single entity from the server.
       *
       * Makes a `GET` request.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.find(resourceConfig, id[, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {string|number} id Primary key of the entity to update.
       * @param {object=} options Optional configuration. Also passed along to `$http([config])`. Properties:
       *
       * - `{string=}` - `baseUrl` - Override the default base url.
       * - `{string=}` - `endpoint` - Override the default endpoint.
       * - `{object=}` - `params` - Additional query string parameters to add to the url.
       *
       * @returns {Promise} Promise.
       */
      find: function (resourceConfig, id, options) {
        options = options || {};
        return this.GET(
          DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(id, options), id),
          options
        );
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:findAll
       * @name findAll
       * @description
       * Retrieve a collection of entities from the server.
       *
       * Makes a `GET` request.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.findAll(resourceConfig[, params][, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {object=} params Search query parameters. See the [query guide](/documentation/guide/queries/index).
       * @param {object=} options Optional configuration. Also passed along to `$http([config])`. Properties:
       *
       * - `{string=}` - `baseUrl` - Override the default base url.
       * - `{string=}` - `endpoint` - Override the default endpoint.
       * - `{object=}` - `params` - Additional query string parameters to add to the url.
       *
       * @returns {Promise} Promise.
       */
      findAll: function (resourceConfig, params, options) {
        options = options || {};
        options.params = options.params || {};
        if (params) {
          params = defaults.queryTransform(resourceConfig.name, params);
          DSUtils.deepMixIn(options.params, params);
        }
        return this.GET(
          DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(null, options)),
          options
        );
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:create
       * @name create
       * @description
       * Create a new entity on the server.
       *
       * Makes a `POST` request.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.create(resourceConfig, attrs[, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {object} attrs The attribute payload.
       * @param {object=} options Optional configuration. Also passed along to `$http([config])`. Properties:
       *
       * - `{string=}` - `baseUrl` - Override the default base url.
       * - `{string=}` - `endpoint` - Override the default endpoint.
       * - `{object=}` - `params` - Additional query string parameters to add to the url.
       *
       * @returns {Promise} Promise.
       */
      create: function (resourceConfig, attrs, options) {
        options = options || {};
        return this.POST(
          DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(attrs, options)),
          attrs,
          options
        );
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:update
       * @name update
       * @description
       * Update an entity on the server.
       *
       * Makes a `PUT` request.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.update(resourceConfig, id, attrs[, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {string|number} id Primary key of the entity to update.
       * @param {object} attrs The attribute payload.
       * @param {object=} options Optional configuration. Also passed along to `$http([config])`. Properties:
       *
       * - `{string=}` - `baseUrl` - Override the default base url.
       * - `{string=}` - `endpoint` - Override the default endpoint.
       * - `{object=}` - `params` - Additional query string parameters to add to the url.
       *
       * @returns {Promise} Promise.
       */
      update: function (resourceConfig, id, attrs, options) {
        options = options || {};
        return this.PUT(
          DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(id, options), id),
          attrs,
          options
        );
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:updateAll
       * @name updateAll
       * @description
       * Update a collection of entities on the server.
       *
       * Makes a `PUT` request.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.updateAll(resourceConfig, attrs[, params][, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {object} attrs The attribute payload.
       * @param {object=} params Search query parameters. See the [query guide](/documentation/guide/queries/index).
       * @param {object=} options Optional configuration. Also passed along to `$http([config])`. Properties:
       *
       * - `{string=}` - `baseUrl` - Override the default base url.
       * - `{string=}` - `endpoint` - Override the default endpoint.
       * - `{object=}` - `params` - Additional query string parameters to add to the url.
       *
       * @returns {Promise} Promise.
       */
      updateAll: function (resourceConfig, attrs, params, options) {
        options = options || {};
        options.params = options.params || {};
        if (params) {
          params = defaults.queryTransform(resourceConfig.name, params);
          DSUtils.deepMixIn(options.params, params);
        }
        return this.PUT(
          DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(null, options)),
          attrs,
          options
        );
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:destroy
       * @name destroy
       * @description
       * Delete an entity on the server.
       *
       * Makes a `DELETE` request.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.destroy(resourceConfig, id[, options)
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {string|number} id Primary key of the entity to update.
       * @param {object=} options Optional configuration. Also passed along to `$http([config])`. Properties:
       *
       * - `{string=}` - `baseUrl` - Override the default base url.
       * - `{string=}` - `endpoint` - Override the default endpoint.
       * - `{object=}` - `params` - Additional query string parameters to add to the url.
       *
       * @returns {Promise} Promise.
       */
      destroy: function (resourceConfig, id, options) {
        options = options || {};
        return this.DEL(
          DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(id, options), id),
          options
        );
      },

      /**
       * @doc method
       * @id DSHttpAdapter.methods:destroyAll
       * @name destroyAll
       * @description
       * Delete a collection of entities on the server.
       *
       * Makes `DELETE` request.
       *
       * ## Signature:
       * ```js
       * DSHttpAdapter.destroyAll(resourceConfig[, params][, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {object=} params Search query parameters. See the [query guide](/documentation/guide/queries/index).
       * @param {object=} options Optional configuration. Also passed along to `$http([config])`. Properties:
       *
       * - `{string=}` - `baseUrl` - Override the default base url.
       * - `{string=}` - `endpoint` - Override the default endpoint.
       * - `{object=}` - `params` - Additional query string parameters to add to the url.
       *
       * @returns {Promise} Promise.
       */
      destroyAll: function (resourceConfig, params, options) {
        options = options || {};
        options.params = options.params || {};
        if (params) {
          params = defaults.queryTransform(resourceConfig.name, params);
          DSUtils.deepMixIn(options.params, params);
        }
        return this.DEL(
          DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(null, options)),
          options
        );
      }
    };
  }];
}

module.exports = DSHttpAdapterProvider;

},{}],52:[function(require,module,exports){
/*!
 * @doc function
 * @id DSLocalStorageAdapterProvider
 * @name DSLocalStorageAdapterProvider
 */
function DSLocalStorageAdapterProvider() {

  this.$get = ['$q', 'DSUtils', 'DSErrors', function ($q, DSUtils) {

    /**
     * @doc interface
     * @id DSLocalStorageAdapter
     * @name DSLocalStorageAdapter
     * @description
     * Adapter that uses `localStorage` as its persistence layer. The localStorage adapter does not support operations
     * on collections because localStorage itself is a key-value store.
     */
    return {

      getIds: function (name, options) {
        var ids;
        var idsPath = DSUtils.makePath(options.baseUrl, 'DSKeys', name);
        var idsJson = localStorage.getItem(idsPath);
        if (idsJson) {
          ids = DSUtils.fromJson(idsJson);
        } else {
          localStorage.setItem(idsPath, DSUtils.toJson({}));
          ids = {};
        }
        return ids;
      },

      saveKeys: function (ids, name, options) {
        var keysPath = DSUtils.makePath(options.baseUrl, 'DSKeys', name);
        localStorage.setItem(keysPath, DSUtils.toJson(ids));
      },

      ensureId: function (id, name, options) {
        var ids = this.getIds(name, options);
        ids[id] = 1;
        this.saveKeys(ids, name, options);
      },

      removeId: function (id, name, options) {
        var ids = this.getIds(name, options);
        delete ids[id];
        this.saveKeys(ids, name, options);
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:GET
       * @name GET
       * @description
       * An asynchronous wrapper for `localStorage.getItem(key)`.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.GET(key)
       * ```
       *
       * @param {string} key The key path of the item to retrieve.
       * @returns {Promise} Promise.
       */
      GET: function (key) {
        var deferred = $q.defer();
        try {
          var item = localStorage.getItem(key);
          deferred.resolve(item ? angular.fromJson(item) : undefined);
        } catch (err) {
          deferred.reject(err);
        }
        return deferred.promise;
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:PUT
       * @name PUT
       * @description
       * An asynchronous wrapper for `localStorage.setItem(key, value)`.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.PUT(key, value)
       * ```
       *
       * @param {string} key The key to update.
       * @param {object} value Attributes to put.
       * @returns {Promise} Promise.
       */
      PUT: function (key, value) {
        var DSLocalStorageAdapter = this;
        return DSLocalStorageAdapter.GET(key).then(function (item) {
          if (item) {
            DSUtils.deepMixIn(item, value);
          }
          localStorage.setItem(key, angular.toJson(item || value));
          return DSLocalStorageAdapter.GET(key);
        });
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:DEL
       * @name DEL
       * @description
       * An asynchronous wrapper for `localStorage.removeItem(key)`.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.DEL(key)
       * ```
       *
       * @param {string} key The key to remove.
       * @returns {Promise} Promise.
       */
      DEL: function (key) {
        var deferred = $q.defer();
        try {
          localStorage.removeItem(key);
          deferred.resolve();
        } catch (err) {
          deferred.reject(err);
        }
        return deferred.promise;
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:find
       * @name find
       * @description
       * Retrieve a single entity from localStorage.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.find(resourceConfig, id[, options])
       * ```
       *
       * ## Example:
       * ```js
       * DS.find('user', 5, {
       *   adapter: 'DSLocalStorageAdapter'
       * }).then(function (user) {
       *   user; // { id: 5, ... }
       * });
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {string|number} id Primary key of the entity to retrieve.
       * @param {object=} options Optional configuration. Properties:
       *
       * - `{string=}` - `baseUrl` - Base path to use.
       *
       * @returns {Promise} Promise.
       */
      find: function find(resourceConfig, id, options) {
        options = options || {};
        return this.GET(DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.endpoint, id)).then(function (item) {
          if (!item) {
            return $q.reject(new Error('Not Found!'));
          } else {
            return item;
          }
        });
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:findAll
       * @name findAll
       * @description
       * Retrieve a collections of entities from localStorage.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.findAll(resourceConfig, params[, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {object=} params Query parameters.
       * @param {object=} options Optional configuration. Properties:
       *
       * - `{string=}` - `baseUrl` - Base path to use.
       *
       * @returns {Promise} Promise.
       */
      findAll: function (resourceConfig, params, options) {
        var _this = this;
        var deferred = $q.defer();
        options = options || {};
        if (!('allowSimpleWhere' in options)) {
          options.allowSimpleWhere = true;
        }
        var items = [];
        var ids = DSUtils.keys(_this.getIds(resourceConfig.name, options));
        DSUtils.forEach(ids, function (id) {
          var itemJson = localStorage.getItem(DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(id, options), id));
          if (itemJson) {
            items.push(DSUtils.fromJson(itemJson));
          }
        });
        deferred.resolve(_this.DS.defaults.defaultFilter.call(_this.DS, items, resourceConfig.name, params, options));
        return deferred.promise;
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:create
       * @name create
       * @description
       * Create an entity in `localStorage`. You must generate the primary key and include it in the `attrs` object.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.create(resourceConfig, attrs[, options])
       * ```
       *
       * ## Example:
       * ```js
       * DS.create('user', {
       *   id: 1,
       *   name: 'john'
       * }, {
       *   adapter: 'DSLocalStorageAdapter'
       * }).then(function (user) {
       *   user; // { id: 1, name: 'john' }
       * });
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {object} attrs Attributes to create in localStorage.
       * @param {object=} options Optional configuration. Properties:
       *
       * - `{string=}` - `baseUrl` - Base path to use.
       *
       * @returns {Promise} Promise.
       */
      create: function (resourceConfig, attrs, options) {
        var _this = this;
        attrs[resourceConfig.idAttribute] = attrs[resourceConfig.idAttribute] || DSUtils.guid();
        options = options || {};
        return this.PUT(
          DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(attrs, options), attrs[resourceConfig.idAttribute]),
          attrs
        ).then(function (item) {
            _this.ensureId(item[resourceConfig.idAttribute], resourceConfig.name, options);
            return item;
          });
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:update
       * @name update
       * @description
       * Update an entity in localStorage.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.update(resourceConfig, id, attrs[, options])
       * ```
       *
       * ## Example:
       * ```js
       * DS.update('user', 5, {
       *   name: 'john'
       * }, {
       *   adapter: 'DSLocalStorageAdapter'
       * }).then(function (user) {
       *   user; // { id: 5, ... }
       * });
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {string|number} id Primary key of the entity to retrieve.
       * @param {object} attrs Attributes with which to update the entity.
       * @param {object=} options Optional configuration. Properties:
       *
       * - `{string=}` - `baseUrl` - Base path to use.
       *
       * @returns {Promise} Promise.
       */
      update: function (resourceConfig, id, attrs, options) {
        options = options || {};
        return this.PUT(DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(id, options), id), attrs);
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:updateAll
       * @name updateAll
       * @description
       * Update a collections of entities in localStorage.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.updateAll(resourceConfig, attrs, params[, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {object} attrs Attributes with which to update the items.
       * @param {object=} params Query parameters.
       * @param {object=} options Optional configuration. Properties:
       *
       * - `{string=}` - `baseUrl` - Base path to use.
       *
       * @returns {Promise} Promise.
       */
      updateAll: function (resourceConfig, attrs, params, options) {
        var _this = this;
        return this.findAll(resourceConfig, params, options).then(function (items) {
          var tasks = [];
          DSUtils.forEach(items, function (item) {
            tasks.push(_this.update(resourceConfig, item[resourceConfig.idAttribute], attrs, options));
          });
          return $q.all(tasks);
        });
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:destroy
       * @name destroy
       * @description
       * Destroy an entity from localStorage.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.destroy(resourceConfig, id[, options])
       * ```
       *
       * ## Example:
       * ```js
       * DS.destroy('user', 5, {
       *   name: ''
       * }, {
       *   adapter: 'DSLocalStorageAdapter'
       * }).then(function (user) {
       *   user; // { id: 5, ... }
       * });
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {string|number} id Primary key of the entity to destroy.
       * @param {object=} options Optional configuration. Properties:
       *
       * - `{string=}` - `baseUrl` - Base path to use.
       *
       * @returns {Promise} Promise.
       */
      destroy: function (resourceConfig, id, options) {
        options = options || {};
        return this.DEL(DSUtils.makePath(options.baseUrl || resourceConfig.baseUrl, resourceConfig.getEndpoint(id, options), id));
      },

      /**
       * @doc method
       * @id DSLocalStorageAdapter.methods:destroyAll
       * @name destroyAll
       * @description
       * Destroy a collections of entities from localStorage.
       *
       * ## Signature:
       * ```js
       * DSLocalStorageAdapter.destroyAll(resourceConfig, params[, options])
       * ```
       *
       * @param {object} resourceConfig DS resource definition object:
       * @param {object=} params Query parameters.
       * @param {object=} options Optional configuration. Properties:
       *
       * - `{string=}` - `baseUrl` - Base path to use.
       *
       * @returns {Promise} Promise.
       */
      destroyAll: function (resourceConfig, params, options) {
        var _this = this;
        return this.findAll(resourceConfig, params, options).then(function (items) {
          var tasks = [];
          DSUtils.forEach(items, function (item) {
            tasks.push(_this.destroy(resourceConfig, item[resourceConfig.idAttribute], options));
          });
          return $q.all(tasks);
        });
      }
    };
  }];
}

module.exports = DSLocalStorageAdapterProvider;

},{}],53:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.create(' + resourceName + ', attrs[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:create
 * @name create
 * @description
 * The "C" in "CRUD". Delegate to the `create` method of whichever adapter is being used (http by default) and inject the
 * result into the data store.
 *
 * ## Signature:
 * ```js
 * DS.create(resourceName, attrs[, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.create('document', {
 *   author: 'John Anderson'
 * }).then(function (document) {
 *   document; // { id: 5, author: 'John Anderson' }
 *
 *   // The new document is already in the data store
 *   DS.get('document', document.id); // { id: 5, author: 'John Anderson' }
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object} attrs The attributes with which to create the item of the type specified by `resourceName`.
 * @param {object=} options Configuration options. Also passed along to the adapter's `create` method. Properties:
 *
 * - `{boolean=}` - `useClass` - Whether to wrap the injected item with the resource's instance constructor.
 * - `{boolean=}` - `cacheResponse` - Inject the data returned by the adapter into the data store. Default: `true`.
 * - `{boolean=}` - `upsert` - If `attrs` already contains a primary key, then attempt to call `DS.update` instead. Default: `true`.
 * - `{boolean=}` - `eagerInject` - Eagerly inject the attributes into the store without waiting for a successful response from the adapter. Default: `false`.
 * - `{function=}` - `beforeValidate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `validate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `afterValidate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `beforeCreate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `afterCreate` - Override the resource or global lifecycle hook.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Resolves with:
 *
 * - `{object}` - `item` - A reference to the newly created item.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 */
function create(resourceName, attrs, options) {
  var DS = this;
  var deferred = DS.$q.defer();

  try {
    var definition = DS.definitions[resourceName];
    var injected;

    options = options || {};

    if (!definition) {
      throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
    } else if (!DS.utils.isObject(attrs)) {
      throw new DS.errors.IA(errorPrefix(resourceName) + 'attrs: Must be an object!');
    }
    if (!('cacheResponse' in options)) {
      options.cacheResponse = true;
    }

    if (!('upsert' in options)) {
      options.upsert = true;
    }

    if (!('eagerInject' in options)) {
      options.eagerInject = definition.eagerInject;
    }

    if (!('notify' in options)) {
      options.notify = definition.notify;
    }

    deferred.resolve(attrs);

    if (options.upsert && attrs[definition.idAttribute]) {
      return DS.update(resourceName, attrs[definition.idAttribute], attrs, options);
    } else {
      return deferred.promise
        .then(function (attrs) {
          var func = options.beforeValidate ? DS.$q.promisify(options.beforeValidate) : definition.beforeValidate;
          return func.call(attrs, resourceName, attrs);
        })
        .then(function (attrs) {
          var func = options.validate ? DS.$q.promisify(options.validate) : definition.validate;
          return func.call(attrs, resourceName, attrs);
        })
        .then(function (attrs) {
          var func = options.afterValidate ? DS.$q.promisify(options.afterValidate) : definition.afterValidate;
          return func.call(attrs, resourceName, attrs);
        })
        .then(function (attrs) {
          var func = options.beforeCreate ? DS.$q.promisify(options.beforeCreate) : definition.beforeCreate;
          return func.call(attrs, resourceName, attrs);
        })
        .then(function (attrs) {
          if (options.notify) {
            DS.emit(definition, 'beforeCreate', DS.utils.merge({}, attrs));
          }
          if (options.eagerInject && options.cacheResponse) {
            attrs[definition.idAttribute] = attrs[definition.idAttribute] || DS.utils.guid();
            injected = DS.inject(resourceName, attrs);
          }
          return DS.adapters[options.adapter || definition.defaultAdapter].create(definition, options.serialize ? options.serialize(resourceName, attrs) : definition.serialize(resourceName, attrs), options);
        })
        .then(function (res) {
          var func = options.afterCreate ? DS.$q.promisify(options.afterCreate) : definition.afterCreate;
          var attrs = options.deserialize ? options.deserialize(resourceName, res) : definition.deserialize(resourceName, res);
          return func.call(attrs, resourceName, attrs);
        })
        .then(function (attrs) {
          if (options.notify) {
            DS.emit(definition, 'afterCreate', DS.utils.merge({}, attrs));
          }
          if (options.cacheResponse) {
            var resource = DS.store[resourceName];
            if (options.eagerInject) {
              var newId = attrs[definition.idAttribute];
              var prevId = injected[definition.idAttribute];
              var prev = DS.get(resourceName, prevId);
              resource.previousAttributes[newId] = resource.previousAttributes[prevId];
              resource.changeHistories[newId] = resource.changeHistories[prevId];
              resource.observers[newId] = resource.observers[prevId];
              resource.modified[newId] = resource.modified[prevId];
              resource.saved[newId] = resource.saved[prevId];
              resource.index.put(newId, prev);
              DS.eject(resourceName, prevId, { notify: false });
              prev[definition.idAttribute] = newId;
              resource.collection.push(prev);
            }
            var created = DS.inject(resourceName, attrs, options);
            var id = created[definition.idAttribute];
            resource.completedQueries[id] = new Date().getTime();
            resource.previousAttributes[id] = DS.utils.deepMixIn({}, created);
            resource.saved[id] = DS.utils.updateTimestamp(resource.saved[id]);
            return DS.get(resourceName, id);
          } else {
            return DS.createInstance(resourceName, attrs, options);
          }
        })
        .catch(function (err) {
          if (options.eagerInject && options.cacheResponse) {
            DS.eject(resourceName, injected[definition.idAttribute], { notify: false });
          }
          return DS.$q.reject(err);
        });
    }
  } catch (err) {
    deferred.reject(err);
    return deferred.promise;
  }
}

module.exports = create;

},{}],54:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.destroy(' + resourceName + ', ' + id + '[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:destroy
 * @name destroy
 * @description
 * The "D" in "CRUD". Delegate to the `destroy` method of whichever adapter is being used (http by default) and eject the
 * appropriate item from the data store.
 *
 * ## Signature:
 * ```js
 * DS.destroy(resourceName, id[, options]);
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.destroy('document', 5).then(function (id) {
 *   id; // 5
 *
 *   // The document is gone
 *   DS.get('document', 5); // undefined
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item to remove.
 * @param {object=} options Configuration options. Also passed along to the adapter's `destroy` method. Properties:
 *
 * - `{function=}` - `beforeDestroy` - Override the resource or global lifecycle hook.
 * - `{function=}` - `afterDestroy` - Override the resource or global lifecycle hook.
 * - `{boolean=}` - `eagerEject` - If `true` eagerly eject the item from the store without waiting for the adapter's response, the item will be re-injected if the adapter operation fails. Default: `false`.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Resolves with:
 *
 * - `{string|number}` - `id` - The primary key of the destroyed item.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{RuntimeError}`
 * - `{NonexistentResourceError}`
 */
function destroy(resourceName, id, options) {
  var DS = this;
  var deferred = DS.$q.defer();

  try {
    var definition = DS.definitions[resourceName];

    options = options || {};

    id = DS.utils.resolveId(definition, id);
    if (!definition) {
      throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
    } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
      throw new DS.errors.IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
    }

    var item = DS.get(resourceName, id);
    if (!item) {
      throw new DS.errors.R(errorPrefix(resourceName, id) + 'id: "' + id + '" not found!');
    }

    deferred.resolve(item);

    if (!('eagerEject' in options)) {
      options.eagerEject = definition.eagerEject;
    }

    if (!('notify' in options)) {
      options.notify = definition.notify;
    }

    return deferred.promise
      .then(function (attrs) {
        var func = options.beforeDestroy ? DS.$q.promisify(options.beforeDestroy) : definition.beforeDestroy;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        if (options.notify) {
          DS.emit(definition, 'beforeDestroy', DS.utils.merge({}, attrs));
        }
        if (options.eagerEject) {
          DS.eject(resourceName, id);
        }
        return DS.adapters[options.adapter || definition.defaultAdapter].destroy(definition, id, options);
      })
      .then(function () {
        var func = options.afterDestroy ? DS.$q.promisify(options.afterDestroy) : definition.afterDestroy;
        return func.call(item, resourceName, item);
      })
      .then(function () {
        if (options.notify) {
          DS.emit(definition, 'afterDestroy', DS.utils.merge({}, item));
        }
        DS.eject(resourceName, id);
        return id;
      }).catch(function (err) {
        if (options.eagerEject && item) {
          DS.inject(resourceName, item);
        }
        return DS.$q.reject(err);
      });
  } catch (err) {
    deferred.reject(err);
    return deferred.promise;
  }
}

module.exports = destroy;

},{}],55:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.destroyAll(' + resourceName + ', params[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:destroyAll
 * @name destroyAll
 * @description
 * The "D" in "CRUD". Delegate to the `destroyAll` method of whichever adapter is being used (http by default) and eject
 * the appropriate items from the data store.
 *
 * ## Signature:
 * ```js
 * DS.destroyAll(resourceName, params[, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * var params = {
 *   where: {
 *     author: {
 *       '==': 'John Anderson'
 *     }
 *   }
 * };
 *
 * DS.destroyAll('document', params).then(function (documents) {
 *   // The documents are gone from the data store
 *   DS.filter('document', params); // []
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object} params Parameter object that is serialized into the query string. Properties:
 *
 *  - `{object=}` - `where` - Where clause.
 *  - `{number=}` - `limit` - Limit clause.
 *  - `{number=}` - `skip` - Skip clause.
 *  - `{number=}` - `offset` - Same as skip.
 *  - `{string|array=}` - `orderBy` - OrderBy clause.
 *
 * @param {object=} options Optional configuration. Also passed along to the adapter's `destroyAll` method. Properties:
 *
 * - `{boolean=}` - `bypassCache` - Bypass the cache. Default: `false`.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 */
function destroyAll(resourceName, params, options) {
  var DS = this;
  var deferred = DS.$q.defer();

  try {
    var IA = DS.errors.IA;
    var definition = DS.definitions[resourceName];

    options = options || {};

    if (!definition) {
      throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
    } else if (!DS.utils.isObject(params)) {
      throw new IA(errorPrefix(resourceName) + 'params: Must be an object!');
    } else if (!DS.utils.isObject(options)) {
      throw new IA(errorPrefix(resourceName) + 'options: Must be an object!');
    }

    deferred.resolve();

    return deferred.promise
      .then(function () {
        return DS.adapters[options.adapter || definition.defaultAdapter].destroyAll(definition, params, options);
      })
      .then(function () {
        return DS.ejectAll(resourceName, params);
      });
  } catch (err) {
    deferred.reject(err);
    return deferred.promise;
  }
}

module.exports = destroyAll;

},{}],56:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.find(' + resourceName + ', ' + id + '[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:find
 * @name find
 * @description
 * The "R" in "CRUD". Delegate to the `find` method of whichever adapter is being used (http by default) and inject the
 * resulting item into the data store.
 *
 * ## Signature:
 * ```js
 * DS.find(resourceName, id[, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.get('document', 5); // undefined
 * DS.find('document', 5).then(function (document) {
 *   document; // { id: 5, author: 'John Anderson' }
 *
 *   // the document is now in the data store
 *   DS.get('document', 5); // { id: 5, author: 'John Anderson' }
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item to retrieve.
 * @param {object=} options Optional configuration. Also passed along to the adapter's `find` method. Properties:
 *
 * - `{boolean=}` - `useClass` - Whether to wrap the injected item with the resource's instance constructor.
 * - `{boolean=}` - `bypassCache` - Bypass the cache. Default: `false`.
 * - `{boolean=}` - `cacheResponse` - Inject the data returned by the adapter into the data store. Default: `true`.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Resolves with:
 *
 * - `{object}` - `item` - The item returned by the adapter.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 */
function find(resourceName, id, options) {
  var DS = this;
  var deferred = DS.$q.defer();
  var promise = deferred.promise;

  try {
    var IA = DS.errors.IA;
    var definition = DS.definitions[resourceName];

    options = options || {};

    if (!definition) {
      throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
    } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
      throw new IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
    } else if (!DS.utils.isObject(options)) {
      throw new IA(errorPrefix(resourceName, id) + 'options: Must be an object!');
    }

    if (!('cacheResponse' in options)) {
      options.cacheResponse = true;
    }
    var resource = DS.store[resourceName];

    if (options.bypassCache || !options.cacheResponse) {
      delete resource.completedQueries[id];
    }

    if (!(id in resource.completedQueries)) {
      if (!(id in resource.pendingQueries)) {
        promise = resource.pendingQueries[id] = DS.adapters[options.adapter || definition.defaultAdapter].find(definition, id, options)
          .then(function (res) {
            var data = options.deserialize ? options.deserialize(resourceName, res) : definition.deserialize(resourceName, res);
            // Query is no longer pending
            delete resource.pendingQueries[id];
            if (options.cacheResponse) {
              resource.completedQueries[id] = new Date().getTime();
              return DS.inject(resourceName, data, options);
            } else {
              return DS.createInstance(resourceName, data, options);
            }
          }, function (err) {
            delete resource.pendingQueries[id];
            return DS.$q.reject(err);
          });
      }

      return resource.pendingQueries[id];
    } else {
      deferred.resolve(DS.get(resourceName, id));
    }
  } catch (err) {
    deferred.reject(err);
  }

  return promise;
}

module.exports = find;

},{}],57:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.findAll(' + resourceName + ', params[, options]): ';
}

function processResults(data, resourceName, queryHash, options) {
  var DS = this;
  var resource = DS.store[resourceName];
  var idAttribute = DS.definitions[resourceName].idAttribute;
  var date = new Date().getTime();

  data = data || [];

  // Query is no longer pending
  delete resource.pendingQueries[queryHash];
  resource.completedQueries[queryHash] = date;

  // Update modified timestamp of collection
  resource.collectionModified = DS.utils.updateTimestamp(resource.collectionModified);

  // Merge the new values into the cache
  var injected = DS.inject(resourceName, data, options);

  // Make sure each object is added to completedQueries
  if (DS.utils.isArray(injected)) {
    angular.forEach(injected, function (item) {
      if (item && item[idAttribute]) {
        resource.completedQueries[item[idAttribute]] = date;
      }
    });
  } else {
    DS.$log.warn(errorPrefix(resourceName) + 'response is expected to be an array!');
    resource.completedQueries[injected[idAttribute]] = date;
  }

  return injected;
}

function _findAll(resourceName, params, options) {
  var DS = this;
  var definition = DS.definitions[resourceName];
  var resource = DS.store[resourceName];
  var queryHash = DS.utils.toJson(params);

  if (options.bypassCache || !options.cacheResponse) {
    delete resource.completedQueries[queryHash];
  }

  if (!(queryHash in resource.completedQueries)) {
    // This particular query has never been completed

    if (!(queryHash in resource.pendingQueries)) {

      // This particular query has never even been made
      resource.pendingQueries[queryHash] = DS.adapters[options.adapter || definition.defaultAdapter].findAll(definition, params, options)
        .then(function (res) {
          delete resource.pendingQueries[queryHash];
          var data = options.deserialize ? options.deserialize(resourceName, res) : definition.deserialize(resourceName, res);
          if (options.cacheResponse) {
            try {
              return processResults.call(DS, data, resourceName, queryHash, options);
            } catch (err) {
              return DS.$q.reject(err);
            }
          } else {
            DS.utils.forEach(data, function (item, i) {
              data[i] = DS.createInstance(resourceName, item, options);
            });
            return data;
          }
        }, function (err) {
          delete resource.pendingQueries[queryHash];
          return DS.$q.reject(err);
        });
    }

    return resource.pendingQueries[queryHash];
  } else {
    return DS.filter(resourceName, params, options);
  }
}

/**
 * @doc method
 * @id DS.async methods:findAll
 * @name findAll
 * @description
 * The "R" in "CRUD". Delegate to the `findAll` method of whichever adapter is being used (http by default) and inject
 * the resulting collection into the data store.
 *
 * ## Signature:
 * ```js
 * DS.findAll(resourceName, params[, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * var params = {
 *   where: {
 *     author: {
 *       '==': 'John Anderson'
 *     }
 *   }
 * };
 *
 * DS.filter('document', params); // []
 * DS.findAll('document', params).then(function (documents) {
 *   documents;  // [{ id: '1', author: 'John Anderson', title: 'How to cook' },
 *               //  { id: '2', author: 'John Anderson', title: 'How NOT to cook' }]
 *
 *   // The documents are now in the data store
 *   DS.filter('document', params); // [{ id: '1', author: 'John Anderson', title: 'How to cook' },
 *                                  //  { id: '2', author: 'John Anderson', title: 'How NOT to cook' }]
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object=} params Parameter object that is serialized into the query string. Default properties:
 *
 * - `{object=}` - `where` - Where clause.
 * - `{number=}` - `limit` - Limit clause.
 * - `{number=}` - `skip` - Skip clause.
 * - `{number=}` - `offset` - Same as skip.
 * - `{string|array=}` - `orderBy` - OrderBy clause.
 *
 * @param {object=} options Optional configuration. Also passed along to the adapter's `findAll` method. Properties:
 *
 * - `{boolean=}` - `useClass` - Whether to wrap the injected item with the resource's instance constructor.
 * - `{boolean=}` - `bypassCache` - Bypass the cache. Default: `false`.
 * - `{boolean=}` - `cacheResponse` - Inject the data returned by the adapter into the data store. Default: `true`.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Resolves with:
 *
 * - `{array}` - `items` - The collection of items returned by the adapter.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 */
function findAll(resourceName, params, options) {
  var DS = this;
  var deferred = DS.$q.defer();

  try {
    var IA = DS.errors.IA;

    options = options || {};
    params = params || {};

    if (!DS.definitions[resourceName]) {
      throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
    } else if (!DS.utils.isObject(params)) {
      throw new IA(errorPrefix(resourceName) + 'params: Must be an object!');
    } else if (!DS.utils.isObject(options)) {
      throw new IA(errorPrefix(resourceName) + 'options: Must be an object!');
    }

    if (!('cacheResponse' in options)) {
      options.cacheResponse = true;
    }

    deferred.resolve();

    return deferred.promise.then(function () {
      return _findAll.call(DS, resourceName, params, options);
    });
  } catch (err) {
    deferred.reject(err);
    return deferred.promise;
  }
}

module.exports = findAll;

},{}],58:[function(require,module,exports){
module.exports = {
  /**
   * @doc method
   * @id DS.async methods:create
   * @name create
   * @methodOf DS
   * @description
   * See [DS.create](/documentation/api/api/DS.async methods:create).
   */
  create: require('./create'),

  /**
   * @doc method
   * @id DS.async methods:destroy
   * @name destroy
   * @methodOf DS
   * @description
   * See [DS.destroy](/documentation/api/api/DS.async methods:destroy).
   */
  destroy: require('./destroy'),

  /**
   * @doc method
   * @id DS.async methods:destroyAll
   * @name destroyAll
   * @methodOf DS
   * @description
   * See [DS.destroyAll](/documentation/api/api/DS.async methods:destroyAll).
   */
  destroyAll: require('./destroyAll'),

  /**
   * @doc method
   * @id DS.async methods:find
   * @name find
   * @methodOf DS
   * @description
   * See [DS.find](/documentation/api/api/DS.async methods:find).
   */
  find: require('./find'),

  /**
   * @doc method
   * @id DS.async methods:findAll
   * @name findAll
   * @methodOf DS
   * @description
   * See [DS.findAll](/documentation/api/api/DS.async methods:findAll).
   */
  findAll: require('./findAll'),

  /**
   * @doc method
   * @id DS.async methods:loadRelations
   * @name loadRelations
   * @methodOf DS
   * @description
   * See [DS.loadRelations](/documentation/api/api/DS.async methods:loadRelations).
   */
  loadRelations: require('./loadRelations'),

  /**
   * @doc method
   * @id DS.async methods:refresh
   * @name refresh
   * @methodOf DS
   * @description
   * See [DS.refresh](/documentation/api/api/DS.async methods:refresh).
   */
  refresh: require('./refresh'),

  /**
   * @doc method
   * @id DS.async methods:save
   * @name save
   * @methodOf DS
   * @description
   * See [DS.save](/documentation/api/api/DS.async methods:save).
   */
  save: require('./save'),

  /**
   * @doc method
   * @id DS.async methods:update
   * @name update
   * @methodOf DS
   * @description
   * See [DS.update](/documentation/api/api/DS.async methods:update).
   */
  update: require('./update'),

  /**
   * @doc method
   * @id DS.async methods:updateAll
   * @name updateAll
   * @methodOf DS
   * @description
   * See [DS.updateAll](/documentation/api/api/DS.async methods:updateAll).
   */
  updateAll: require('./updateAll')
};

},{"./create":53,"./destroy":54,"./destroyAll":55,"./find":56,"./findAll":57,"./loadRelations":59,"./refresh":60,"./save":61,"./update":62,"./updateAll":63}],59:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.loadRelations(' + resourceName + ', instance(Id), relations[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:loadRelations
 * @name loadRelations
 * @description
 * Asynchronously load the indicated relations of the given instance.
 *
 * ## Signature:
 * ```js
 * DS.loadRelations(resourceName, instance|id, relations[, options])
 * ```
 *
 * ## Examples:
 *
 * ```js
 * DS.loadRelations('user', 10, ['profile']).then(function (user) {
 *   user.profile; // object
 *   assert.deepEqual(user.profile, DS.filter('profile', { userId: 10 })[0]);
 * });
 * ```
 *
 * ```js
 * var user = DS.get('user', 10);
 *
 * DS.loadRelations('user', user, ['profile']).then(function (user) {
 *   user.profile; // object
 *   assert.deepEqual(user.profile, DS.filter('profile', { userId: 10 })[0]);
 * });
 * ```
 *
 * ```js
 * DS.loadRelations('user', 10, ['profile'], { cacheResponse: false }).then(function (user) {
 *   user.profile; // object
 *   assert.equal(DS.filter('profile', { userId: 10 }).length, 0);
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number|object} instance The instance or the id of the instance for which relations are to be loaded.
 * @param {string|array=} relations The relation(s) to load.
 * @param {object=} options Optional configuration. Also passed along to the adapter's `find` or `findAll` methods.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Resolves with:
 *
 * - `{object}` - `item` - The instance with its loaded relations.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 */
function loadRelations(resourceName, instance, relations, options) {
  var DS = this;
  var deferred = DS.$q.defer();

  try {
    var IA = DS.errors.IA;
    var definition = DS.definitions[resourceName];

    options = options || {};

    if (angular.isString(instance) || angular.isNumber(instance)) {
      instance = DS.get(resourceName, instance);
    }

    if (angular.isString(relations)) {
      relations = [relations];
    }

    if (!definition) {
      throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
    } else if (!DS.utils.isObject(instance)) {
      throw new IA(errorPrefix(resourceName) + 'instance(Id): Must be a string, number or object!');
    } else if (!DS.utils.isArray(relations)) {
      throw new IA(errorPrefix(resourceName) + 'relations: Must be a string or an array!');
    } else if (!DS.utils.isObject(options)) {
      throw new IA(errorPrefix(resourceName) + 'options: Must be an object!');
    }

    if (!('findBelongsTo' in options)) {
      options.findBelongsTo = true;
    }

    if (!('findHasMany' in options)) {
      options.findHasMany = true;
    }

    var tasks = [];
    var fields = [];

    DS.utils.forEach(definition.relationList, function (def) {
      var relationName = def.relation;
      if (DS.utils.contains(relations, relationName)) {
        var task;
        var params = {};
        params[def.foreignKey] = instance[definition.idAttribute];

        if (def.type === 'hasMany' && params[def.foreignKey]) {
          task = DS.findAll(relationName, params, options);
        } else if (def.type === 'hasOne') {
          if (def.localKey && instance[def.localKey]) {
            task = DS.find(relationName, instance[def.localKey], options);
          } else if (def.foreignKey && params[def.foreignKey]) {
            task = DS.findAll(relationName, params, options).then(function (hasOnes) {
              return hasOnes.length ? hasOnes[0] : null;
            });
          }
        } else if (instance[def.localKey]) {
          task = DS.find(relationName, instance[def.localKey], options);
        }

        if (task) {
          tasks.push(task);
          fields.push(def.localField);
        }
      }
    });

    deferred.resolve();

    return deferred.promise
      .then(function () {
        return DS.$q.all(tasks);
      })
      .then(function (loadedRelations) {
        angular.forEach(fields, function (field, index) {
          instance[field] = loadedRelations[index];
        });
        return instance;
      });
  } catch (err) {
    deferred.reject(err);
    return deferred.promise;
  }
}

module.exports = loadRelations;

},{}],60:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.refresh(' + resourceName + ', ' + id + '[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:refresh
 * @name refresh
 * @description
 * Like `DS.find`, except the resource is only refreshed from the adapter if it already exists in the data store.
 *
 * ## Signature:
 * ```js
 * DS.refresh(resourceName, id[, options])
 * ```
 * ## Example:
 *
 * ```js
 * // Exists in the data store, but we want a fresh copy
 * DS.get('document', 5);
 *
 * DS.refresh('document', 5).then(function (document) {
 *   document; // The fresh copy
 * });
 *
 * // Does not exist in the data store
 * DS.get('document', 6); // undefined
 *
 * DS.refresh('document', 6).then(function (document) {
 *   document; // undefined
 * });
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item to refresh from the adapter.
 * @param {object=} options Optional configuration. Also passed along to the adapter's `find` method.
 * @returns {Promise} A Promise created by the $q service.
 *
 * ## Resolves with:
 *
 * - `{object|undefined}` - `item` - The item returned by the adapter or `undefined` if the item wasn't already in the
 * data store.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 */
function refresh(resourceName, id, options) {
  var DS = this;
  var IA = DS.errors.IA;

  options = options || {};

  id = DS.utils.resolveId(DS.definitions[resourceName], id);
  if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
  } else if (!DS.utils.isObject(options)) {
    throw new IA(errorPrefix(resourceName, id) + 'options: Must be an object!');
  } else {
    options.bypassCache = true;

    if (DS.get(resourceName, id)) {
      return DS.find(resourceName, id, options);
    } else {
      var deferred = DS.$q.defer();
      deferred.resolve();
      return deferred.promise;
    }
  }
}

module.exports = refresh;

},{}],61:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.save(' + resourceName + ', ' + id + '[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:save
 * @name save
 * @description
 * The "U" in "CRUD". Persist a single item already in the store and in it's current form to whichever adapter is being
 * used (http by default) and inject the resulting item into the data store.
 *
 * ## Signature:
 * ```js
 * DS.save(resourceName, id[, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * var document = DS.get('document', 5);
 *
 * document.title = 'How to cook in style';
 *
 * DS.save('document', 5).then(function (document) {
 *   document; // A reference to the document that's been persisted via an adapter
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item to save.
 * @param {object=} options Optional configuration. Also passed along to the adapter's `update` method. Properties:
 *
 * - `{boolean=}` - `cacheResponse` - Inject the data returned by the adapter into the data store. Default: `true`.
 * - `{boolean=}` - `changesOnly` - Only send changed and added values to the adapter. Default: `false`.
 * - `{function=}` - `beforeValidate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `validate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `afterValidate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `beforeUpdate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `afterUpdate` - Override the resource or global lifecycle hook.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Resolves with:
 *
 * - `{object}` - `item` - The item returned by the adapter.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{RuntimeError}`
 * - `{NonexistentResourceError}`
 */
function save(resourceName, id, options) {
  var DS = this;
  var deferred = DS.$q.defer();

  try {
    var IA = DS.errors.IA;
    var definition = DS.definitions[resourceName];

    options = options || {};

    id = DS.utils.resolveId(definition, id);
    if (!definition) {
      throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
    } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
      throw new IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
    } else if (!DS.utils.isObject(options)) {
      throw new IA(errorPrefix(resourceName, id) + 'options: Must be an object!');
    }

    var item = DS.get(resourceName, id);
    if (!item) {
      throw new DS.errors.R(errorPrefix(resourceName, id) + 'id: "' + id + '" not found!');
    }

    if (!('cacheResponse' in options)) {
      options.cacheResponse = true;
    }

    if (!('notify' in options)) {
      options.notify = definition.notify;
    }

    deferred.resolve(item);

    return deferred.promise
      .then(function (attrs) {
        var func = options.beforeValidate ? DS.$q.promisify(options.beforeValidate) : definition.beforeValidate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.validate ? DS.$q.promisify(options.validate) : definition.validate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.afterValidate ? DS.$q.promisify(options.afterValidate) : definition.afterValidate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.beforeUpdate ? DS.$q.promisify(options.beforeUpdate) : definition.beforeUpdate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        if (options.notify) {
          DS.emit(definition, 'beforeUpdate', DS.utils.merge({}, attrs));
        }
        if (options.changesOnly) {
          var resource = DS.store[resourceName];
          resource.observers[id].deliver();
          var toKeep = [],
            changes = DS.changes(resourceName, id);

          for (var key in changes.added) {
            toKeep.push(key);
          }
          for (key in changes.changed) {
            toKeep.push(key);
          }
          changes = DS.utils.pick(attrs, toKeep);
          if (DS.utils.isEmpty(changes)) {
            // no changes, return
            return attrs;
          } else {
            attrs = changes;
          }
        }
        return DS.adapters[options.adapter || definition.defaultAdapter].update(definition, id, options.serialize ? options.serialize(resourceName, attrs) : definition.serialize(resourceName, attrs), options);
      })
      .then(function (res) {
        var func = options.afterUpdate ? DS.$q.promisify(options.afterUpdate) : definition.afterUpdate;
        var attrs = options.deserialize ? options.deserialize(resourceName, res) : definition.deserialize(resourceName, res);
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        if (options.notify) {
          DS.emit(definition, 'afterUpdate', DS.utils.merge({}, attrs));
        }
        if (options.cacheResponse) {
          var resource = DS.store[resourceName];
          var saved = DS.inject(definition.name, attrs, options);
          resource.previousAttributes[id] = DS.utils.deepMixIn({}, saved);
          resource.saved[id] = DS.utils.updateTimestamp(resource.saved[id]);
          resource.observers[id].discardChanges();
          return DS.get(resourceName, id);
        } else {
          return attrs;
        }
      });
  } catch (err) {
    deferred.reject(err);
    return deferred.promise;
  }
}

module.exports = save;

},{}],62:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.update(' + resourceName + ', ' + id + ', attrs[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:update
 * @name update
 * @description
 * The "U" in "CRUD". Update the item of type `resourceName` and primary key `id` with `attrs`. This is useful when you
 * want to update an item that isn't already in the data store, or you don't want to update the item that's in the data
 * store until the adapter operation succeeds. This differs from `DS.save` which simply saves items in their current
 * form that already exist in the data store. The resulting item (by default) will be injected into the data store.
 *
 * ## Signature:
 * ```js
 * DS.update(resourceName, id, attrs[, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.get('document', 5); // undefined
 *
 * DS.update('document', 5, {
 *   title: 'How to cook in style'
 * }).then(function (document) {
 *   document; // A reference to the document that's been saved via an adapter
 *             // and now resides in the data store
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item to update.
 * @param {object} attrs The attributes with which to update the item.
 * @param {object=} options Optional configuration. Also passed along to the adapter's `update` method. Properties:
 *
 * - `{boolean=}` - `cacheResponse` - Inject the data returned by the adapter into the data store. Default: `true`.
 * - `{function=}` - `beforeValidate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `validate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `afterValidate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `beforeUpdate` - Override the resource or global lifecycle hook.
 * - `{function=}` - `afterUpdate` - Override the resource or global lifecycle hook.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Resolves with:
 *
 * - `{object}` - `item` - The item returned by the adapter.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 */
function update(resourceName, id, attrs, options) {
  var DS = this;
  var deferred = DS.$q.defer();

  try {
    var IA = DS.errors.IA;
    var definition = DS.definitions[resourceName];

    options = options || {};

    id = DS.utils.resolveId(definition, id);
    if (!definition) {
      throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
    } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
      throw new IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
    } else if (!DS.utils.isObject(attrs)) {
      throw new IA(errorPrefix(resourceName, id) + 'attrs: Must be an object!');
    } else if (!DS.utils.isObject(options)) {
      throw new IA(errorPrefix(resourceName, id) + 'options: Must be an object!');
    }

    if (!('cacheResponse' in options)) {
      options.cacheResponse = true;
    }

    if (!('notify' in options)) {
      options.notify = definition.notify;
    }

    deferred.resolve(attrs);

    return deferred.promise
      .then(function (attrs) {
        var func = options.beforeValidate ? DS.$q.promisify(options.beforeValidate) : definition.beforeValidate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.validate ? DS.$q.promisify(options.validate) : definition.validate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.afterValidate ? DS.$q.promisify(options.afterValidate) : definition.afterValidate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.beforeUpdate ? DS.$q.promisify(options.beforeUpdate) : definition.beforeUpdate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        if (options.notify) {
          DS.emit(definition, 'beforeUpdate', DS.utils.merge({}, attrs));
        }
        return DS.adapters[options.adapter || definition.defaultAdapter].update(definition, id, options.serialize ? options.serialize(resourceName, attrs) : definition.serialize(resourceName, attrs), options);
      })
      .then(function (res) {
        var func = options.afterUpdate ? DS.$q.promisify(options.afterUpdate) : definition.afterUpdate;
        var attrs = options.deserialize ? options.deserialize(resourceName, res) : definition.deserialize(resourceName, res);
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        if (options.notify) {
          DS.emit(definition, 'afterUpdate', DS.utils.merge({}, attrs));
        }
        if (options.cacheResponse) {
          var resource = DS.store[resourceName];
          var updated = DS.inject(definition.name, attrs, options);
          var id = updated[definition.idAttribute];
          resource.previousAttributes[id] = DS.utils.deepMixIn({}, updated);
          resource.saved[id] = DS.utils.updateTimestamp(resource.saved[id]);
          resource.observers[id].discardChanges();
          return DS.get(definition.name, id);
        } else {
          return attrs;
        }
      });
  } catch (err) {
    deferred.reject(err);
    return deferred.promise;
  }
}

module.exports = update;

},{}],63:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.updateAll(' + resourceName + ', attrs, params[, options]): ';
}

/**
 * @doc method
 * @id DS.async methods:updateAll
 * @name updateAll
 * @description
 * The "U" in "CRUD". Update items of type `resourceName` with `attrs` according to the criteria specified by `params`.
 * This is useful when you want to update multiple items with the same attributes or you don't want to update the items
 * in the data store until the adapter operation succeeds. The resulting items (by default) will be injected into the
 * data store.
 *
 * ## Signature:
 * ```js
 * DS.updateAll(resourceName, attrs, params[, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * var params = {
 *   where: {
 *     author: {
 *       '==': 'John Anderson'
 *     }
 *   }
 * };
 *
 * DS.filter('document', params); // []
 *
 * DS.updateAll('document', 5, {
 *   author: 'Sally'
 * }, params).then(function (documents) {
 *   documents; // The documents that were updated via an adapter
 *              // and now reside in the data store
 *
 *   documents[0].author; // "Sally"
 * });
 * ```
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object} attrs The attributes with which to update the items.
 * @param {object} params Parameter object that is serialized into the query string. Default properties:
 *
 *  - `{object=}` - `where` - Where clause.
 *  - `{number=}` - `limit` - Limit clause.
 *  - `{number=}` - `skip` - Skip clause.
 *  - `{number=}` - `offset` - Same as skip.
 *  - `{string|array=}` - `orderBy` - OrderBy clause.
 *
 * @param {object=} options Optional configuration. Also passed along to the adapter's `updateAll` method. Properties:
 *
 * - `{boolean=}` - `cacheResponse` - Inject the items returned by the adapter into the data store. Default: `true`.
 *
 * @returns {Promise} Promise produced by the `$q` service.
 *
 * ## Resolves with:
 *
 * - `{array}` - `items` - The items returned by the adapter.
 *
 * ## Rejects with:
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 */
function updateAll(resourceName, attrs, params, options) {
  var DS = this;
  var deferred = DS.$q.defer();

  try {
    var IA = DS.errors.IA;
    var definition = DS.definitions[resourceName];

    options = options || {};

    if (!definition) {
      throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
    } else if (!DS.utils.isObject(attrs)) {
      throw new IA(errorPrefix(resourceName) + 'attrs: Must be an object!');
    } else if (!DS.utils.isObject(params)) {
      throw new IA(errorPrefix(resourceName) + 'params: Must be an object!');
    } else if (!DS.utils.isObject(options)) {
      throw new IA(errorPrefix(resourceName) + 'options: Must be an object!');
    }

    if (!('cacheResponse' in options)) {
      options.cacheResponse = true;
    }

    if (!('notify' in options)) {
      options.notify = definition.notify;
    }

    deferred.resolve(attrs);

    return deferred.promise
      .then(function (attrs) {
        var func = options.beforeValidate ? DS.$q.promisify(options.beforeValidate) : definition.beforeValidate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.validate ? DS.$q.promisify(options.validate) : definition.validate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.afterValidate ? DS.$q.promisify(options.afterValidate) : definition.afterValidate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        var func = options.beforeUpdate ? DS.$q.promisify(options.beforeUpdate) : definition.beforeUpdate;
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        if (options.notify) {
          DS.emit(definition, 'beforeUpdate', DS.utils.merge({}, attrs));
        }
        return DS.adapters[options.adapter || definition.defaultAdapter].updateAll(definition, options.serialize ? options.serialize(resourceName, attrs) : definition.serialize(resourceName, attrs), params, options);
      })
      .then(function (res) {
        var func = options.afterUpdate ? DS.$q.promisify(options.afterUpdate) : definition.afterUpdate;
        var attrs = options.deserialize ? options.deserialize(resourceName, res) : definition.deserialize(resourceName, res);
        return func.call(attrs, resourceName, attrs);
      })
      .then(function (attrs) {
        if (options.notify) {
          DS.emit(definition, 'afterUpdate', DS.utils.merge({}, attrs));
        }
        if (options.cacheResponse) {
          return DS.inject(definition.name, attrs, options);
        } else {
          return attrs;
        }
      });
  } catch (err) {
    deferred.reject(err);
    return deferred.promise;
  }
}

module.exports = updateAll;

},{}],64:[function(require,module,exports){
var utils = require('../utils')[0]();

function lifecycleNoop(resourceName, attrs, cb) {
  cb(null, attrs);
}

function Defaults() {
}

Defaults.prototype.idAttribute = 'id';
Defaults.prototype.defaultAdapter = 'DSHttpAdapter';
Defaults.prototype.defaultFilter = function (collection, resourceName, params, options) {
  var _this = this;
  var filtered = collection;
  var where = null;
  var reserved = {
    skip: '',
    offset: '',
    where: '',
    limit: '',
    orderBy: '',
    sort: ''
  };

  if (this.utils.isObject(params.where)) {
    where = params.where;
  } else {
    where = {};
  }

  if (options.allowSimpleWhere) {
    this.utils.forEach(params, function (value, key) {
      if (!(key in reserved) && !(key in where)) {
        where[key] = {
          '==': value
        };
      }
    });
  }

  if (this.utils.isEmpty(where)) {
    where = null;
  }

  if (where) {
    filtered = this.utils.filter(filtered, function (attrs) {
      var first = true;
      var keep = true;
      _this.utils.forEach(where, function (clause, field) {
        if (_this.utils.isString(clause)) {
          clause = {
            '===': clause
          };
        } else if (_this.utils.isNumber(clause) || _this.utils.isBoolean(clause)) {
          clause = {
            '==': clause
          };
        }
        if (_this.utils.isObject(clause)) {
          _this.utils.forEach(clause, function (val, op) {
            if (op === '==') {
              keep = first ? (attrs[field] == val) : keep && (attrs[field] == val);
            } else if (op === '===') {
              keep = first ? (attrs[field] === val) : keep && (attrs[field] === val);
            } else if (op === '!=') {
              keep = first ? (attrs[field] != val) : keep && (attrs[field] != val);
            } else if (op === '!==') {
              keep = first ? (attrs[field] !== val) : keep && (attrs[field] !== val);
            } else if (op === '>') {
              keep = first ? (attrs[field] > val) : keep && (attrs[field] > val);
            } else if (op === '>=') {
              keep = first ? (attrs[field] >= val) : keep && (attrs[field] >= val);
            } else if (op === '<') {
              keep = first ? (attrs[field] < val) : keep && (attrs[field] < val);
            } else if (op === '<=') {
              keep = first ? (attrs[field] <= val) : keep && (attrs[field] <= val);
            } else if (op === 'in') {
              keep = first ? _this.utils.contains(val, attrs[field]) : keep && _this.utils.contains(val, attrs[field]);
            } else if (op === 'notIn') {
              keep = first ? !_this.utils.contains(val, attrs[field]) : keep && !_this.utils.contains(val, attrs[field]);
            } else if (op === '|==') {
              keep = first ? (attrs[field] == val) : keep || (attrs[field] == val);
            } else if (op === '|===') {
              keep = first ? (attrs[field] === val) : keep || (attrs[field] === val);
            } else if (op === '|!=') {
              keep = first ? (attrs[field] != val) : keep || (attrs[field] != val);
            } else if (op === '|!==') {
              keep = first ? (attrs[field] !== val) : keep || (attrs[field] !== val);
            } else if (op === '|>') {
              keep = first ? (attrs[field] > val) : keep || (attrs[field] > val);
            } else if (op === '|>=') {
              keep = first ? (attrs[field] >= val) : keep || (attrs[field] >= val);
            } else if (op === '|<') {
              keep = first ? (attrs[field] < val) : keep || (attrs[field] < val);
            } else if (op === '|<=') {
              keep = first ? (attrs[field] <= val) : keep || (attrs[field] <= val);
            } else if (op === '|in') {
              keep = first ? _this.utils.contains(val, attrs[field]) : keep || _this.utils.contains(val, attrs[field]);
            } else if (op === '|notIn') {
              keep = first ? !_this.utils.contains(val, attrs[field]) : keep || !_this.utils.contains(val, attrs[field]);
            }
            first = false;
          });
        }
      });
      return keep;
    });
  }

  var orderBy = null;

  if (this.utils.isString(params.orderBy)) {
    orderBy = [
      [params.orderBy, 'ASC']
    ];
  } else if (this.utils.isArray(params.orderBy)) {
    orderBy = params.orderBy;
  }

  if (!orderBy && this.utils.isString(params.sort)) {
    orderBy = [
      [params.sort, 'ASC']
    ];
  } else if (!orderBy && this.utils.isArray(params.sort)) {
    orderBy = params.sort;
  }

  // Apply 'orderBy'
  if (orderBy) {
    angular.forEach(orderBy, function (def) {
      if (_this.utils.isString(def)) {
        def = [def, 'ASC'];
      } else if (!_this.utils.isArray(def)) {
        throw new _this.errors.IllegalArgumentError('DS.filter(resourceName[, params][, options]): ' + angular.toJson(def) + ': Must be a string or an array!', { params: { 'orderBy[i]': { actual: typeof def, expected: 'string|array' } } });
      }
      filtered = _this.utils.sort(filtered, function (a, b) {
        var cA = a[def[0]], cB = b[def[0]];
        if (_this.utils.isString(cA)) {
          cA = _this.utils.upperCase(cA);
        }
        if (_this.utils.isString(cB)) {
          cB = _this.utils.upperCase(cB);
        }
        if (def[1] === 'DESC') {
          if (cB < cA) {
            return -1;
          } else if (cB > cA) {
            return 1;
          } else {
            return 0;
          }
        } else {
          if (cA < cB) {
            return -1;
          } else if (cA > cB) {
            return 1;
          } else {
            return 0;
          }
        }
      });
    });
  }

  var limit = angular.isNumber(params.limit) ? params.limit : null;
  var skip = null;

  if (angular.isNumber(params.skip)) {
    skip = params.skip;
  } else if (angular.isNumber(params.offset)) {
    skip = params.offset;
  }

  // Apply 'limit' and 'skip'
  if (limit && skip) {
    filtered = this.utils.slice(filtered, skip, Math.min(filtered.length, skip + limit));
  } else if (this.utils.isNumber(limit)) {
    filtered = this.utils.slice(filtered, 0, Math.min(filtered.length, limit));
  } else if (this.utils.isNumber(skip)) {
    if (skip < filtered.length) {
      filtered = this.utils.slice(filtered, skip);
    } else {
      filtered = [];
    }
  }

  return filtered;
};
Defaults.prototype.baseUrl = '';
Defaults.prototype.endpoint = '';
Defaults.prototype.useClass = true;
Defaults.prototype.keepChangeHistory = false;
Defaults.prototype.resetHistoryOnInject = true;
Defaults.prototype.eagerInject = false;
Defaults.prototype.eagerEject = false;
Defaults.prototype.notify = true;
/**
 * @doc property
 * @id DSProvider.properties:defaults.beforeValidate
 * @name defaults.beforeValidate
 * @description
 * Called before the `validate` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * beforeValidate(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.beforeValidate = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.beforeValidate = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.validate
 * @name defaults.validate
 * @description
 * Called before the `afterValidate` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * validate(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.validate = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.validate = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.afterValidate
 * @name defaults.afterValidate
 * @description
 * Called before the `beforeCreate` or `beforeUpdate` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * afterValidate(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.afterValidate = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.afterValidate = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.beforeCreate
 * @name defaults.beforeCreate
 * @description
 * Called before the `create` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * beforeCreate(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.beforeCreate = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.beforeCreate = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.afterCreate
 * @name defaults.afterCreate
 * @description
 * Called after the `create` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * afterCreate(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.afterCreate = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.afterCreate = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.beforeUpdate
 * @name defaults.beforeUpdate
 * @description
 * Called before the `update` or `save` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * beforeUpdate(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.beforeUpdate = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.beforeUpdate = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.afterUpdate
 * @name defaults.afterUpdate
 * @description
 * Called after the `update` or `save` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * afterUpdate(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.afterUpdate = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.afterUpdate = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.beforeDestroy
 * @name defaults.beforeDestroy
 * @description
 * Called before the `destroy` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * beforeDestroy(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.beforeDestroy = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.beforeDestroy = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.afterDestroy
 * @name defaults.afterDestroy
 * @description
 * Called after the `destroy` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * afterDestroy(resourceName, attrs, cb)
 * ```
 *
 * ## Callback signature:
 * ```js
 * cb(err, attrs)
 * ```
 * Remember to pass the attributes along to the next step. Passing a first argument to the callback will abort the
 * lifecycle and reject the promise.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.afterDestroy = function (resourceName, attrs, cb) {
 *      // do somthing/inspect attrs
 *      cb(null, attrs);
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.afterDestroy = lifecycleNoop;
/**
 * @doc property
 * @id DSProvider.properties:defaults.beforeInject
 * @name defaults.beforeInject
 * @description
 * Called before the `inject` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * beforeInject(resourceName, attrs)
 * ```
 *
 * Throwing an error inside this step will cancel the injection.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.beforeInject = function (resourceName, attrs) {
 *      // do somthing/inspect/modify attrs
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.beforeInject = function (resourceName, attrs) {
  return attrs;
};
/**
 * @doc property
 * @id DSProvider.properties:defaults.afterInject
 * @name defaults.afterInject
 * @description
 * Called after the `inject` lifecycle step. Can be overridden per resource as well.
 *
 * ## Signature:
 * ```js
 * afterInject(resourceName, attrs)
 * ```
 *
 * Throwing an error inside this step will cancel the injection.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.afterInject = function (resourceName, attrs) {
 *      // do somthing/inspect/modify attrs
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource moving through the lifecycle.
 * @param {object} attrs Attributes of the item moving through the lifecycle.
 */
Defaults.prototype.afterInject = function (resourceName, attrs) {
  return attrs;
};
/**
 * @doc property
 * @id DSProvider.properties:defaults.serialize
 * @name defaults.serialize
 * @description
 * Your server might expect a custom request object rather than the plain POJO payload. Use `serialize` to
 * create your custom request object.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.serialize = function (resourceName, data) {
 *      return {
 *          payload: data
 *      };
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource to serialize.
 * @param {object} data Data to be sent to the server.
 * @returns {*} By default returns `data` as-is.
 */
Defaults.prototype.serialize = function (resourceName, data) {
  return data;
};

/**
 * @doc property
 * @id DSProvider.properties:defaults.deserialize
 * @name DSProvider.properties:defaults.deserialize
 * @description
 * Your server might return a custom response object instead of the plain POJO payload. Use `deserialize` to
 * pull the payload out of your response object so angular-data can use it.
 *
 * ## Example:
 * ```js
 *  DSProvider.defaults.deserialize = function (resourceName, data) {
 *      return data ? data.payload : data;
 *  };
 * ```
 *
 * @param {string} resourceName The name of the resource to deserialize.
 * @param {object} data Response object from `$http()`.
 * @returns {*} By default returns `data.data`.
 */
Defaults.prototype.deserialize = function (resourceName, data) {
  return data ? (data.data ? data.data : data) : data;
};

/**
 * @doc property
 * @id DSProvider.properties:defaults.events
 * @name DSProvider.properties:defaults.events
 * @description
 * Whether to broadcast, emit, or disable DS events on the `$rootScope`.
 *
 * Possible values are: `"broadcast"`, `"emit"`, `"none"`.
 *
 * `"broadcast"` events will be [broadcasted](https://code.angularjs.org/1.2.22/docs/api/ng/type/$rootScope.Scope#$broadcast) on the `$rootScope`.
 *
 * `"emit"` events will be [emitted](https://code.angularjs.org/1.2.22/docs/api/ng/type/$rootScope.Scope#$emit) on the `$rootScope`.
 *
 * `"none"` events will be will neither be broadcasted nor emitted.
 *
 * Current events are `"DS.inject"` and `"DS.eject"`.
 *
 * Overridable per resource.
 */
Defaults.prototype.events = 'broadcast';

/**
 * @doc function
 * @id DSProvider
 * @name DSProvider
 */
function DSProvider() {

  /**
   * @doc property
   * @id DSProvider.properties:defaults
   * @name defaults
   * @description
   * See the [configuration guide](/documentation/guide/configure/global).
   *
   * Properties:
   *
   * - `{string}` - `baseUrl` - The url relative to which all AJAX requests will be made.
   * - `{string}` - `idAttribute` - Default: `"id"` - The attribute that specifies the primary key for resources.
   * - `{string}` - `defaultAdapter` - Default: `"DSHttpAdapter"`
   * - `{string}` - `events` - Default: `"broadcast"` [DSProvider.defaults.events](/documentation/api/angular-data/DSProvider.properties:defaults.events)
   * - `{function}` - `filter` - Default: See [angular-data query language](/documentation/guide/queries/custom).
   * - `{function}` - `beforeValidate` - See [DSProvider.defaults.beforeValidate](/documentation/api/angular-data/DSProvider.properties:defaults.beforeValidate). Default: No-op
   * - `{function}` - `validate` - See [DSProvider.defaults.validate](/documentation/api/angular-data/DSProvider.properties:defaults.validate). Default: No-op
   * - `{function}` - `afterValidate` - See [DSProvider.defaults.afterValidate](/documentation/api/angular-data/DSProvider.properties:defaults.afterValidate). Default: No-op
   * - `{function}` - `beforeCreate` - See [DSProvider.defaults.beforeCreate](/documentation/api/angular-data/DSProvider.properties:defaults.beforeCreate). Default: No-op
   * - `{function}` - `afterCreate` - See [DSProvider.defaults.afterCreate](/documentation/api/angular-data/DSProvider.properties:defaults.afterCreate). Default: No-op
   * - `{function}` - `beforeUpdate` - See [DSProvider.defaults.beforeUpdate](/documentation/api/angular-data/DSProvider.properties:defaults.beforeUpdate). Default: No-op
   * - `{function}` - `afterUpdate` - See [DSProvider.defaults.afterUpdate](/documentation/api/angular-data/DSProvider.properties:defaults.afterUpdate). Default: No-op
   * - `{function}` - `beforeDestroy` - See [DSProvider.defaults.beforeDestroy](/documentation/api/angular-data/DSProvider.properties:defaults.beforeDestroy). Default: No-op
   * - `{function}` - `afterDestroy` - See [DSProvider.defaults.afterDestroy](/documentation/api/angular-data/DSProvider.properties:defaults.afterDestroy). Default: No-op
   * - `{function}` - `afterInject` - See [DSProvider.defaults.afterInject](/documentation/api/angular-data/DSProvider.properties:defaults.afterInject). Default: No-op
   * - `{function}` - `beforeInject` - See [DSProvider.defaults.beforeInject](/documentation/api/angular-data/DSProvider.properties:defaults.beforeInject). Default: No-op
   * - `{function}` - `serialize` - See [DSProvider.defaults.serialize](/documentation/api/angular-data/DSProvider.properties:defaults.serialize). Default: No-op
   * - `{function}` - `deserialize` - See [DSProvider.defaults.deserialize](/documentation/api/angular-data/DSProvider.properties:defaults.deserialize). Default: No-op
   */
  var defaults = this.defaults = new Defaults();

  this.$get = [
    '$rootScope', '$log', '$q', 'DSHttpAdapter', 'DSLocalStorageAdapter', 'DSUtils', 'DSErrors',
    function ($rootScope, $log, $q, DSHttpAdapter, DSLocalStorageAdapter, DSUtils, DSErrors) {

      var syncMethods = require('./sync_methods'),
        asyncMethods = require('./async_methods'),
        cache;

      try {
        cache = angular.injector(['angular-data.DSCacheFactory']).get('DSCacheFactory');
      } catch (err) {
        $log.debug('DSCacheFactory is unavailable. Resorting to the lesser capabilities of $cacheFactory.');
        cache = angular.injector(['ng']).get('$cacheFactory');
      }

      /**
       * @doc interface
       * @id DS
       * @name DS
       * @description
       * Public data store interface. Consists of several properties and a number of methods. Injectable as `DS`.
       *
       * See the [guide](/documentation/guide/overview/index).
       */
      var DS = {
        emit: function (definition, event) {
          var args = Array.prototype.slice.call(arguments, 2);
          args.unshift(definition.name);
          args.unshift('DS.' + event);
          definition.emit.apply(definition, args);
          if (definition.events === 'broadcast') {
            $rootScope.$broadcast.apply($rootScope, args);
          } else if (definition.events === 'emit') {
            $rootScope.$emit.apply($rootScope, args);
          }
        },
        $rootScope: $rootScope,
        $log: $log,
        $q: $q,

        cacheFactory: cache,

        /**
         * @doc property
         * @id DS.properties:defaults
         * @name defaults
         * @description
         * Reference to [DSProvider.defaults](/documentation/api/api/DSProvider.properties:defaults).
         */
        defaults: defaults,

        /*!
         * @doc property
         * @id DS.properties:store
         * @name store
         * @description
         * Meta data for each registered resource.
         */
        store: {},

        /*!
         * @doc property
         * @id DS.properties:definitions
         * @name definitions
         * @description
         * Registered resource definitions available to the data store.
         */
        definitions: {},

        /**
         * @doc property
         * @id DS.properties:adapters
         * @name adapters
         * @description
         * Registered adapters available to the data store. Object consists of key-values pairs where the key is
         * the name of the adapter and the value is the adapter itself.
         */
        adapters: {
          DSHttpAdapter: DSHttpAdapter,
          DSLocalStorageAdapter: DSLocalStorageAdapter
        },

        /**
         * @doc property
         * @id DS.properties:errors
         * @name errors
         * @description
         * References to the various [error types](/documentation/api/api/errors) used by angular-data.
         */
        errors: DSErrors,

        /*!
         * @doc property
         * @id DS.properties:utils
         * @name utils
         * @description
         * Utility functions used internally by angular-data.
         */
        utils: DSUtils
      };

      DSUtils.deepFreeze(syncMethods);
      DSUtils.deepFreeze(asyncMethods);

      DSUtils.deepMixIn(DS, syncMethods);
      DSUtils.deepMixIn(DS, asyncMethods);

      DSUtils.deepFreeze(DS.errors);
      DSUtils.deepFreeze(DS.utils);

      DSHttpAdapter.DS = DS;
      DSLocalStorageAdapter.DS = DS;

      if (typeof Object.observe !== 'function' ||
        typeof Array.observe !== 'function') {
        $rootScope.$watch(function () {
          // Throttle angular-data's digest loop to tenths of a second
          return new Date().getTime() / 100 | 0;
        }, function () {
          DS.digest();
        });
      }

      return DS;
    }
  ];
}

module.exports = DSProvider;

},{"../utils":89,"./async_methods":58,"./sync_methods":78}],65:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.bindAll(scope, expr, ' + resourceName + ', params[, cb]): ';
}

/**
 * @doc method
 * @id DS.sync methods:bindAll
 * @name bindAll
 * @description
 * Bind a collection of items in the data store to `scope` under the property specified by `expr` filtered by `params`.
 *
 * ## Signature:
 * ```js
 * DS.bindAll(scope, expr, resourceName, params[, cb])
 * ```
 *
 * ## Example:
 *
 * ```js
 * // bind the documents with ownerId of 5 to the 'docs' property of the $scope
 * var deregisterFunc = DS.bindAll($scope, 'docs', 'document', {
 *   where: {
 *     ownerId: 5
 *   }
 * });
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {object} scope The scope to bind to.
 * @param {string} expr An expression used to bind to the scope. Can be used to set nested keys, i.e. `"user.comments"`.
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object} params Parameter object that is used in filtering the collection. Properties:
 *
 *  - `{object=}` - `where` - Where clause.
 *  - `{number=}` - `limit` - Limit clause.
 *  - `{number=}` - `skip` - Skip clause.
 *  - `{number=}` - `offset` - Same as skip.
 *  - `{string|array=}` - `orderBy` - OrderBy clause.
 *
 * @param {function=} cb Optional callback executed on change. Signature: `cb(err, items)`.
 *
 * @returns {function} Scope $watch deregistration function.
 */
function bindAll(scope, expr, resourceName, params, cb) {
  var DS = this;
  var IA = DS.errors.IA;

  params = params || {};

  if (!DS.utils.isObject(scope)) {
    throw new IA(errorPrefix(resourceName) + 'scope: Must be an object!');
  } else if (!DS.utils.isString(expr)) {
    throw new IA(errorPrefix(resourceName) + 'expr: Must be a string!');
  } else if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isObject(params)) {
    throw new IA(errorPrefix(resourceName) + 'params: Must be an object!');
  }

  try {
    return scope.$watch(function () {
      return DS.lastModified(resourceName);
    }, function () {
      var items = DS.filter(resourceName, params);
      DS.utils.set(scope, expr, items);
      if (cb) {
        cb(null, items);
      }
    });
  } catch (err) {
    if (cb) {
      cb(err);
    } else {
      throw err;
    }
  }
}

module.exports = bindAll;

},{}],66:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.bindOne(scope, expr, ' + resourceName + ', id[, cb]): ';
}

/**
 * @doc method
 * @id DS.sync methods:bindOne
 * @name bindOne
 * @description
 * Bind an item in the data store to `scope` under the property specified by `expr`.
 *
 * ## Signature:
 * ```js
 * DS.bindOne(scope, expr, resourceName, id[, cb])
 * ```
 *
 * ## Example:
 *
 * ```js
 * // bind the document with id 5 to the 'doc' property of the $scope
 * var deregisterFunc = DS.bindOne($scope, 'doc', 'document', 5);
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {object} scope The scope to bind to.
 * @param {string} expr An expression used to bind to the scope. Can be used to set nested keys, i.e. `"user.profile"`.
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item to bind.
 * @param {function=} cb Optional callback executed on change. Signature: `cb(err, item)`.
 * @returns {function} Scope $watch deregistration function.
 */
function bindOne(scope, expr, resourceName, id, cb) {
  var DS = this;
  var IA = DS.errors.IA;

  id = DS.utils.resolveId(DS.definitions[resourceName], id);
  if (!DS.utils.isObject(scope)) {
    throw new IA(errorPrefix(resourceName) + 'scope: Must be an object!');
  } else if (!DS.utils.isString(expr)) {
    throw new IA(errorPrefix(resourceName) + 'expr: Must be a string!');
  } else if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new IA(errorPrefix(resourceName) + 'id: Must be a string or a number!');
  }

  try {
    return scope.$watch(function () {
      return DS.lastModified(resourceName, id);
    }, function () {
      var item = DS.get(resourceName, id);
      DS.utils.set(scope, expr, item);
      if (cb) {
        cb(null, item);
      }
    });
  } catch (err) {
    if (cb) {
      cb(err);
    } else {
      throw err;
    }
  }
}

module.exports = bindOne;

},{}],67:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.changeHistory(' + resourceName + ', id): ';
}

/**
 * @doc method
 * @id DS.sync methods:changeHistory
 * @name changeHistory
 * @description
 * Synchronously return the changeHistory of the item of the type specified by `resourceName` that has the primary key
 * specified by `id`. This object represents the history of changes in the item since the item was last injected or
 * re-injected (on save, update, etc.) into the data store.
 *
 * ## Signature:
 * ```js
 * DS.changeHistory(resourceName, id)
 * ```
 *
 * ## Example:
 *
 * ```js
 * var d = DS.get('document', 5); // { author: 'John Anderson', id: 5 }
 *
 * d.author = 'Sally';
 *
 * // You might have to do $scope.$apply() first
 *
 * DS.changeHistory('document', 5); // [{...}] Array of changes
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number=} id The primary key of the item for which to retrieve the changeHistory.
 * @returns {object} The changeHistory of the item of the type specified by `resourceName` with the primary key specified by `id`.
 */
function changeHistory(resourceName, id) {
  var DS = this;
  var DSUtils = DS.utils;
  var definition = DS.definitions[resourceName];
  var resource = DS.store[resourceName];

  id = DS.utils.resolveId(definition, id);
  if (resourceName && !DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (id && !DSUtils.isString(id) && !DSUtils.isNumber(id)) {
    throw new DS.errors.IA(errorPrefix(resourceName) + 'id: Must be a string or a number!');
  }

  if (!definition.keepChangeHistory) {
    DS.$log.warn(errorPrefix(resourceName) + 'changeHistory is disabled for this resource!');
  } else {
    if (resourceName) {
      var item = DS.get(resourceName, id);
      if (item) {
        return resource.changeHistories[id];
      }
    } else {
      return resource.changeHistory;
    }
  }
}

module.exports = changeHistory;

},{}],68:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.changes(' + resourceName + ', id): ';
}

/**
 * @doc method
 * @id DS.sync methods:changes
 * @name changes
 * @description
 * Synchronously return the changes object of the item of the type specified by `resourceName` that has the primary key
 * specified by `id`. This object represents the diff between the item in its current state and the state of the item
 * the last time it was saved via an adapter.
 *
 * ## Signature:
 * ```js
 * DS.changes(resourceName, id)
 * ```
 *
 * ## Example:
 *
 * ```js
 * var d = DS.get('document', 5); // { author: 'John Anderson', id: 5 }
 *
 * d.author = 'Sally';
 *
 * // You might have to do $scope.$apply() first
 *
 * DS.changes('document', 5); // {...} Object describing changes
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item of the changes to retrieve.
 * @returns {object} The changes of the item of the type specified by `resourceName` with the primary key specified by `id`.
 */
function changes(resourceName, id) {
  var DS = this;

  id = DS.utils.resolveId(DS.definitions[resourceName], id);
  if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new DS.errors.IA(errorPrefix(resourceName) + 'id: Must be a string or a number!');
  }

  var item = DS.get(resourceName, id);
  if (item) {
    DS.store[resourceName].observers[id].deliver();
    var diff = DS.utils.diffObjectFromOldObject(item, DS.store[resourceName].previousAttributes[id]);
    DS.utils.forEach(diff, function (changeset, name) {
      var toKeep = [];
      DS.utils.forEach(changeset, function (value, field) {
        if (!angular.isFunction(value)) {
          toKeep.push(field);
        }
      });
      diff[name] = DS.utils.pick(diff[name], toKeep);
    });
    DS.utils.forEach(DS.definitions[resourceName].relationFields, function (field) {
      delete diff.added[field];
      delete diff.removed[field];
      delete diff.changed[field];
    });
    return diff;
  }
}

module.exports = changes;

},{}],69:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.compute(' + resourceName + ', instance): ';
}

function _compute(fn, field) {
  var _this = this;
  var args = [];
  angular.forEach(fn.deps, function (dep) {
    args.push(_this[dep]);
  });
  // compute property
  this[field] = fn[fn.length - 1].apply(this, args);
}

/**
 * @doc method
 * @id DS.sync methods:compute
 * @name compute
 * @description
 * Force the given instance or the item with the given primary key to recompute its computed properties.
 *
 * ## Signature:
 * ```js
 * DS.compute(resourceName, instance)
 * ```
 *
 * ## Example:
 *
 * ```js
 * var User = DS.defineResource({
 *   name: 'user',
 *   computed: {
 *     fullName: ['first', 'last', function (first, last) {
 *       return first + ' ' + last;
 *     }]
 *   }
 * });
 *
 * var user = User.createInstance({ first: 'John', last: 'Doe' });
 * user.fullName; // undefined
 *
 * User.compute(user);
 *
 * user.fullName; // "John Doe"
 *
 * var user2 = User.inject({ id: 2, first: 'Jane', last: 'Doe' });
 * user2.fullName; // undefined
 *
 * User.compute(1);
 *
 * user2.fullName; // "Jane Doe"
 *
 * // if you don't pass useClass: false then you can do:
 * var user3 = User.createInstance({ first: 'Sally', last: 'Doe' });
 * user3.fullName; // undefined
 * user3.DSCompute();
 * user3.fullName; // "Sally Doe"
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object|string|number} instance Instance or primary key of the instance (must be in the store) for which to recompute properties.
 * @returns {Object} The instance.
 */
function compute(resourceName, instance) {
  var DS = this;
  var IA = DS.errors.IA;
  var definition = DS.definitions[resourceName];

  instance = DS.utils.resolveItem(DS.store[resourceName], instance);
  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isObject(instance) && !DS.utils.isString(instance) && !DS.utils.isNumber(instance)) {
    throw new IA(errorPrefix(resourceName) + 'instance: Must be an object, string or number!');
  }

  if (DS.utils.isString(instance) || DS.utils.isNumber(instance)) {
    instance = DS.get(resourceName, instance);
  }

  DS.utils.forEach(definition.computed, function (fn, field) {
    _compute.call(instance, fn, field);
  });

  return instance;
}

module.exports = {
  compute: compute,
  _compute: _compute
};

},{}],70:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.createInstance(' + resourceName + '[, attrs][, options]): ';
}

/**
 * @doc method
 * @id DS.sync methods:createInstance
 * @name createInstance
 * @description
 * Return a new instance of the specified resource.
 *
 * ## Signature:
 * ```js
 * DS.createInstance(resourceName[, attrs][, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * var User = DS.defineResource({
 *   name: 'user',
 *   methods: {
 *     say: function () {
 *       return 'hi';
 *     }
 *   }
 * });
 *
 * var user = User.createInstance();
 * var user2 = DS.createInstance('user');
 *
 * user instanceof User[User.class]; // true
 * user2 instanceof User[User.class]; // true
 *
 * user.say(); // hi
 * user2.say(); // hi
 *
 * var user3 = User.createInstance({ name: 'John' }, { useClass: false });
 * var user4 = DS.createInstance('user', { name: 'John' }, { useClass: false });
 *
 * user3; // { name: 'John' }
 * user3 instanceof User[User.class]; // false
 *
 * user4; // { name: 'John' }
 * user4 instanceof User[User.class]; // false
 *
 * user3.say(); // TypeError: undefined is not a function
 * user4.say(); // TypeError: undefined is not a function
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object=} attrs Optional attributes to mix in to the new instance.
 * @param {object=} options Optional configuration. Properties:
 *
 * - `{boolean=}` - `useClass` - Whether to wrap the injected item with the resource's instance constructor.
 *
 * @returns {object} The new instance.
 */
function createInstance(resourceName, attrs, options) {
  var DS = this;
  var IA = DS.errors.IA;
  var definition = DS.definitions[resourceName];

  attrs = attrs || {};
  options = options || {};

  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (attrs && !DS.utils.isObject(attrs)) {
    throw new IA(errorPrefix(resourceName) + 'attrs: Must be an object!');
  } else if (!DS.utils.isObject(options)) {
    throw new IA(errorPrefix(resourceName) + 'options: Must be an object!');
  }

  if (!('useClass' in options)) {
    options.useClass = definition.useClass;
  }

  var item;

  if (options.useClass) {
    var Func = definition[definition.class];
    item = new Func();
  } else {
    item = {};
  }
  return DS.utils.deepMixIn(item, attrs);
}

module.exports = createInstance;

},{}],71:[function(require,module,exports){
/*jshint evil:true*/
var errorPrefix = 'DS.defineResource(definition): ';

function Resource(utils, options) {

  utils.deepMixIn(this, options);

  if ('endpoint' in options) {
    this.endpoint = options.endpoint;
  } else {
    this.endpoint = this.name;
  }
}

var methodsToProxy = [
  'bindAll',
  'bindOne',
  'changes',
  'changeHistory',
  'create',
  'createInstance',
  'destroy',
  'destroyAll',
  'eject',
  'ejectAll',
  'filter',
  'find',
  'findAll',
  'get',
  'hasChanges',
  'inject',
  'lastModified',
  'lastSaved',
  'link',
  'linkAll',
  'linkInverse',
  'loadRelations',
  'previous',
  'refresh',
  'save',
  'update',
  'updateAll'
];

/**
 * @doc method
 * @id DS.sync methods:defineResource
 * @name defineResource
 * @description
 * Define a resource and register it with the data store.
 *
 * ## Signature:
 * ```js
 * DS.defineResource(definition)
 * ```
 *
 * ## Example:
 *
 * ```js
 *  DS.defineResource({
 *      name: 'document',
 *      idAttribute: '_id',
 *      endpoint: '/documents
 *      baseUrl: 'http://myapp.com/api',
 *      beforeDestroy: function (resourceName attrs, cb) {
 *          console.log('looks good to me');
 *          cb(null, attrs);
 *      }
 *  });
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{RuntimeError}`
 *
 * @param {string|object} definition Name of resource or resource definition object: Properties:
 *
 * - `{string}` - `name` - The name by which this resource will be identified.
 * - `{string="id"}` - `idAttribute` - The attribute that specifies the primary key for this resource.
 * - `{string=}` - `endpoint` - The attribute that specifies the primary key for this resource. Default is the value of `name`.
 * - `{string=}` - `baseUrl` - The url relative to which all AJAX requests will be made.
 * - `{boolean=}` - `useClass` - Whether to use a wrapper class created from the ProperCase name of the resource. The wrapper will always be used for resources that have `methods` defined.
 * - `{boolean=}` - `keepChangeHistory` - Whether to keep a history of changes for items in the data store. Default: `false`.
 * - `{boolean=}` - `resetHistoryOnInject` - Whether to reset the history of changes for items when they are injected of re-injected into the data store. This will also reset an item's previous attributes. Default: `true`.
 * - `{function=}` - `defaultFilter` - Override the filtering used internally by `DS.filter` with you own function here.
 * - `{*=}` - `meta` - A property reserved for developer use. This will never be used by the API.
 * - `{object=}` - `methods` - If provided, items of this resource will be wrapped in a constructor function that is
 * empty save for the attributes in this option which will be mixed in to the constructor function prototype. Enabling
 * this feature for this resource will incur a slight performance penalty, but allows you to give custom behavior to what
 * are now "instances" of this resource.
 * - `{function=}` - `beforeValidate` - Lifecycle hook. Overrides global. Signature: `beforeValidate(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `validate` - Lifecycle hook. Overrides global. Signature: `validate(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `afterValidate` - Lifecycle hook. Overrides global. Signature: `afterValidate(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `beforeCreate` - Lifecycle hook. Overrides global. Signature: `beforeCreate(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `afterCreate` - Lifecycle hook. Overrides global. Signature: `afterCreate(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `beforeUpdate` - Lifecycle hook. Overrides global. Signature: `beforeUpdate(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `afterUpdate` - Lifecycle hook. Overrides global. Signature: `afterUpdate(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `beforeDestroy` - Lifecycle hook. Overrides global. Signature: `beforeDestroy(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `afterDestroy` - Lifecycle hook. Overrides global. Signature: `afterDestroy(resourceName, attrs, cb)`. Callback signature: `cb(err, attrs)`.
 * - `{function=}` - `beforeInject` - Lifecycle hook. Overrides global. Signature: `beforeInject(resourceName, attrs)`.
 * - `{function=}` - `afterInject` - Lifecycle hook. Overrides global. Signature: `afterInject(resourceName, attrs)`.
 * - `{function=}` - `serialize` - Serialization hook. Overrides global. Signature: `serialize(resourceName, attrs)`.
 * - `{function=}` - `deserialize` - Deserialization hook. Overrides global. Signature: `deserialize(resourceName, attrs)`.
 *
 * See [DSProvider.defaults](/documentation/api/angular-data/DSProvider.properties:defaults).
 */
function defineResource(definition) {
  var DS = this;
  var DSUtils = DS.utils;
  var definitions = DS.definitions;
  var IA = DS.errors.IA;

  if (DSUtils.isString(definition)) {
    definition = definition.replace(/\s/gi, '');
    definition = {
      name: definition
    };
  }
  if (!DSUtils.isObject(definition)) {
    throw new IA(errorPrefix + 'definition: Must be an object!');
  } else if (!DSUtils.isString(definition.name)) {
    throw new IA(errorPrefix + 'definition.name: Must be a string!');
  } else if (definition.idAttribute && !DSUtils.isString(definition.idAttribute)) {
    throw new IA(errorPrefix + 'definition.idAttribute: Must be a string!');
  } else if (definition.endpoint && !DSUtils.isString(definition.endpoint)) {
    throw new IA(errorPrefix + 'definition.endpoint: Must be a string!');
  } else if (DS.store[definition.name]) {
    throw new DS.errors.R(errorPrefix + definition.name + ' is already registered!');
  }

  try {
    // Inherit from global defaults
    Resource.prototype = DS.defaults;
    definitions[definition.name] = new Resource(DSUtils, definition);

    var def = definitions[definition.name];

    // Setup nested parent configuration
    if (def.relations) {
      def.relationList = [];
      def.relationFields = [];
      DSUtils.forEach(def.relations, function (relatedModels, type) {
        DSUtils.forEach(relatedModels, function (defs, relationName) {
          if (!DSUtils.isArray(defs)) {
            relatedModels[relationName] = [defs];
          }
          DSUtils.forEach(relatedModels[relationName], function (d) {
            d.type = type;
            d.relation = relationName;
            d.name = def.name;
            def.relationList.push(d);
            def.relationFields.push(d.localField);
          });
        });
      });
      if (def.relations.belongsTo) {
        DSUtils.forEach(def.relations.belongsTo, function (relatedModel, modelName) {
          DSUtils.forEach(relatedModel, function (relation) {
            if (relation.parent) {
              def.parent = modelName;
              def.parentKey = relation.localKey;
            }
          });
        });
      }
      DSUtils.deepFreeze(def.relations);
      DSUtils.deepFreeze(def.relationList);
    }

    def.getEndpoint = function (attrs, options) {
      var parent = this.parent;
      var parentKey = this.parentKey;
      var item;
      var endpoint;
      var thisEndpoint = options.endpoint || this.endpoint;
      delete options.endpoint;
      options = options || {};
      options.params = options.params || {};
      if (parent && parentKey && definitions[parent] && options.params[parentKey] !== false) {
        if (DSUtils.isNumber(attrs) || DSUtils.isString(attrs)) {
          item = DS.get(this.name, attrs);
        }
        if (DSUtils.isObject(attrs) && parentKey in attrs) {
          delete options.params[parentKey];
          endpoint = DSUtils.makePath(definitions[parent].getEndpoint(attrs, options), attrs[parentKey], thisEndpoint);
        } else if (item && parentKey in item) {
          delete options.params[parentKey];
          endpoint = DSUtils.makePath(definitions[parent].getEndpoint(attrs, options), item[parentKey], thisEndpoint);
        } else if (options && options.params[parentKey]) {
          endpoint = DSUtils.makePath(definitions[parent].getEndpoint(attrs, options), options.params[parentKey], thisEndpoint);
          delete options.params[parentKey];
        }
      }
      if (options.params[parentKey] === false) {
        delete options.params[parentKey];
      }
      return endpoint || thisEndpoint;
    };

    // Remove this in v0.11.0 and make a breaking change notice
    // the the `filter` option has been renamed to `defaultFilter`
    if (def.filter) {
      def.defaultFilter = def.filter;
      delete def.filter;
    }

    // Setup the cache
    var cache = DS.cacheFactory('DS.' + def.name, {
      maxAge: def.maxAge || null,
      recycleFreq: def.recycleFreq || 1000,
      cacheFlushInterval: def.cacheFlushInterval || null,
      deleteOnExpire: def.deleteOnExpire || 'none',
      onExpire: function (id) {
        var item = DS.eject(def.name, id);
        if (DSUtils.isFunction(def.onExpire)) {
          def.onExpire(id, item);
        }
      },
      capacity: Number.MAX_VALUE,
      storageMode: 'memory',
      storageImpl: null,
      disabled: false,
      storagePrefix: 'DS.' + def.name
    });

    // Create the wrapper class for the new resource
    def.class = DSUtils.pascalCase(definition.name);
    eval('function ' + def.class + '() {}');
    def[def.class] = eval(def.class);

    // Apply developer-defined methods
    if (def.methods) {
      DSUtils.deepMixIn(def[def.class].prototype, def.methods);
    }

    // Prepare for computed properties
    if (def.computed) {
      DSUtils.forEach(def.computed, function (fn, field) {
        if (angular.isFunction(fn)) {
          def.computed[field] = [fn];
          fn = def.computed[field];
        }
        if (def.methods && field in def.methods) {
          DS.$log.warn(errorPrefix + 'Computed property "' + field + '" conflicts with previously defined prototype method!');
        }
        var deps;
        if (fn.length === 1) {
          var match = fn[0].toString().match(/function.*?\(([\s\S]*?)\)/);
          deps = match[1].split(',');
          def.computed[field] = deps.concat(fn);
          fn = def.computed[field];
          if (deps.length) {
            DS.$log.warn(errorPrefix + 'Use the computed property array syntax for compatibility with minified code!');
          }
        }
        deps = fn.slice(0, fn.length - 1);
        angular.forEach(deps, function (val, index) {
          deps[index] = val.trim();
        });
        fn.deps = DSUtils.filter(deps, function (dep) {
          return !!dep;
        });
      });

      def[def.class].prototype.DSCompute = function () {
        return DS.compute(def.name, this);
      };
    }

    def[def.class].prototype.DSUpdate = function () {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(this[def.idAttribute]);
      args.unshift(def.name);
      return DS.update.apply(DS, args);
    };

    def[def.class].prototype.DSSave = function () {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(this[def.idAttribute]);
      args.unshift(def.name);
      return DS.save.apply(DS, args);
    };

    // Initialize store data for the new resource
    DS.store[def.name] = {
      collection: [],
      completedQueries: {},
      pendingQueries: {},
      index: cache,
      modified: {},
      saved: {},
      previousAttributes: {},
      observers: {},
      changeHistories: {},
      changeHistory: [],
      collectionModified: 0
    };

    // Proxy DS methods with shorthand ones
    angular.forEach(methodsToProxy, function (name) {
      if (name === 'bindOne' || name === 'bindAll') {
        def[name] = function () {
          var args = Array.prototype.slice.call(arguments);
          args.splice(2, 0, def.name);
          return DS[name].apply(DS, args);
        };
      } else {
        def[name] = function () {
          var args = Array.prototype.slice.call(arguments);
          args.unshift(def.name);
          return DS[name].apply(DS, args);
        };
      }
    });

    def.beforeValidate = DS.$q.promisify(def.beforeValidate);
    def.validate = DS.$q.promisify(def.validate);
    def.afterValidate = DS.$q.promisify(def.afterValidate);
    def.beforeCreate = DS.$q.promisify(def.beforeCreate);
    def.afterCreate = DS.$q.promisify(def.afterCreate);
    def.beforeUpdate = DS.$q.promisify(def.beforeUpdate);
    def.afterUpdate = DS.$q.promisify(def.afterUpdate);
    def.beforeDestroy = DS.$q.promisify(def.beforeDestroy);
    def.afterDestroy = DS.$q.promisify(def.afterDestroy);

    // Mix-in events
    DSUtils.Events(def);

    return def;
  } catch (err) {
    DS.$log.error(err);
    delete definitions[definition.name];
    delete DS.store[definition.name];
    throw err;
  }
}

module.exports = defineResource;

},{}],72:[function(require,module,exports){
var observe = require('../../../lib/observe-js/observe-js');

/**
 * @doc method
 * @id DS.sync methods:digest
 * @name digest
 * @description
 * Trigger a digest loop that checks for changes and updates the `lastModified` timestamp if an object has changed.
 * Anything $watching `DS.lastModified(...)` will detect the updated timestamp and execute the callback function. If
 * your browser supports `Object.observe` then this function has no effect.
 *
 * ## Signature:
 * ```js
 * DS.digest()
 * ```
 *
 * ## Example:
 *
 * ```js
 * Works like $scope.$apply()
 * ```
 *
 */
function digest() {
  if (!this.$rootScope.$$phase) {
    this.$rootScope.$apply(function () {
      observe.Platform.performMicrotaskCheckpoint();
    });
  } else {
    observe.Platform.performMicrotaskCheckpoint();
  }
}

module.exports = digest;

},{"../../../lib/observe-js/observe-js":1}],73:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.eject(' + resourceName + ', ' + id + '): ';
}

function _eject(definition, resource, id, options) {
  var item;
  var DS = this;
  var found = false;
  for (var i = 0; i < resource.collection.length; i++) {
    if (resource.collection[i][definition.idAttribute] == id) {
      item = resource.collection[i];
      found = true;
      break;
    }
  }
  if (found) {
    this.unlinkInverse(definition.name, id);
    resource.collection.splice(i, 1);
    resource.observers[id].close();
    delete resource.observers[id];

    resource.index.remove(id);
    delete resource.previousAttributes[id];
    delete resource.completedQueries[id];
    delete resource.pendingQueries[id];
    DS.utils.forEach(resource.changeHistories[id], function (changeRecord) {
      DS.utils.remove(resource.changeHistory, changeRecord);
    });
    delete resource.changeHistories[id];
    delete resource.modified[id];
    delete resource.saved[id];
    resource.collectionModified = this.utils.updateTimestamp(resource.collectionModified);

    if (options.notify) {
      this.emit(definition, 'eject', item);
    }

    return item;
  }
}

/**
 * @doc method
 * @id DS.sync methods:eject
 * @name eject
 * @description
 * Eject the item of the specified type that has the given primary key from the data store. Ejection only removes items
 * from the data store and does not attempt to destroy items via an adapter.
 *
 * ## Signature:
 * ```js
 * DS.eject(resourceName[, id])
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.get('document', 45); // { title: 'How to Cook', id: 45 }
 *
 * DS.eject('document', 45);
 *
 * DS.get('document', 45); // undefined
 * ```
 *
 * ```js
 * $rootScope.$on('DS.eject', function ($event, resourceName, ejected) {...});
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item to eject.
 * @param {object=} options Optional configuration.
 * @returns {object} A reference to the item that was ejected from the data store.
 */
function eject(resourceName, id, options) {
  var DS = this;
  var definition = DS.definitions[resourceName];
  options = options || {};

  id = DS.utils.resolveId(definition, id);
  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new DS.errors.IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
  }
  var resource = DS.store[resourceName];
  var ejected;

  if (!('notify' in options)) {
    options.notify = definition.notify;
  }

  if (!DS.$rootScope.$$phase) {
    DS.$rootScope.$apply(function () {
      ejected = _eject.call(DS, definition, resource, id, options);
    });
  } else {
    ejected = _eject.call(DS, definition, resource, id, options);
  }

  return ejected;
}

module.exports = eject;

},{}],74:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.ejectAll(' + resourceName + '[, params]): ';
}

function _ejectAll(definition, resource, params, options) {
  var DS = this;
  var queryHash = DS.utils.toJson(params);
  var items = DS.filter(definition.name, params);
  var ids = DS.utils.toLookup(items, definition.idAttribute);

  angular.forEach(ids, function (item, id) {
    DS.eject(definition.name, id);
  });

  delete resource.completedQueries[queryHash];
  resource.collectionModified = DS.utils.updateTimestamp(resource.collectionModified);

  if (options.notify) {
    DS.emit(definition, 'eject', items);
  }

  return items;
}

/**
 * @doc method
 * @id DS.sync methods:ejectAll
 * @name ejectAll
 * @description
 * Eject all matching items of the specified type from the data store. Ejection only removes items from the data store
 * and does not attempt to destroy items via an adapter.
 *
 * ## Signature:
 * ```js
 * DS.ejectAll(resourceName[, params])
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.get('document', 45); // { title: 'How to Cook', id: 45 }
 *
 * DS.eject('document', 45);
 *
 * DS.get('document', 45); // undefined
 * ```
 *
 * Eject all items of the specified type that match the criteria from the data store.
 *
 * ```js
 * DS.filter('document');   // [ { title: 'How to Cook', id: 45, author: 'John Anderson' },
 *                          //   { title: 'How to Eat', id: 46, author: 'Sally Jane' } ]
 *
 * DS.ejectAll('document', { where: { author: 'Sally Jane' } });
 *
 * DS.filter('document'); // [ { title: 'How to Cook', id: 45, author: 'John Anderson' } ]
 * ```
 *
 * Eject all items of the specified type from the data store.
 *
 * ```js
 * DS.filter('document');   // [ { title: 'How to Cook', id: 45, author: 'John Anderson' },
 *                          //   { title: 'How to Eat', id: 46, author: 'Sally Jane' } ]
 *
 * DS.ejectAll('document');
 *
 * DS.filter('document'); // [ ]
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object} params Parameter object that is used to filter items. Properties:
 *
 *  - `{object=}` - `where` - Where clause.
 *  - `{number=}` - `limit` - Limit clause.
 *  - `{number=}` - `skip` - Skip clause.
 *  - `{number=}` - `offset` - Same as skip.
 *  - `{string|array=}` - `orderBy` - OrderBy clause.
 *
 * @param {object=} options Optional configuration.
 *
 * @returns {array} The items that were ejected from the data store.
 */
function ejectAll(resourceName, params, options) {
  var DS = this;
  var definition = DS.definitions[resourceName];
  params = params || {};
  options = options || {};

  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isObject(params)) {
    throw new DS.errors.IA(errorPrefix(resourceName) + 'params: Must be an object!');
  }
  var resource = DS.store[resourceName];
  var ejected;

  if (DS.utils.isEmpty(params)) {
    resource.completedQueries = {};
  }

  if (!('notify' in options)) {
    options.notify = definition.notify;
  }

  if (!DS.$rootScope.$$phase) {
    DS.$rootScope.$apply(function () {
      ejected = _ejectAll.call(DS, definition, resource, params, options);
    });
  } else {
    ejected = _ejectAll.call(DS, definition, resource, params, options);
  }

  return ejected;
}

module.exports = ejectAll;

},{}],75:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.filter(' + resourceName + '[, params][, options]): ';
}

/**
 * @doc method
 * @id DS.sync methods:filter
 * @name filter
 * @description
 * Synchronously filter items in the data store of the type specified by `resourceName`.
 *
 * ## Signature:
 * ```js
 * DS.filter(resourceName[, params][, options])
 * ```
 *
 * ## Example:
 *
 * For many examples see the [tests for DS.filter](https://github.com/jmdobry/angular-data/blob/master/test/integration/datastore/sync methods/filter.test.js).
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object=} params Parameter object that is used to filter items. Properties:
 *
 *  - `{object=}` - `where` - Where clause.
 *  - `{number=}` - `limit` - Limit clause.
 *  - `{number=}` - `skip` - Skip clause.
 *  - `{number=}` - `offset` - Same as skip.
 *  - `{string|array=}` - `orderBy` - OrderBy clause.
 *
 * @param {object=} options Optional configuration. Properties:
 *
 * - `{boolean=}` - `loadFromServer` - Send the query to server if it has not been sent yet. Default: `false`.
 * - `{boolean=}` - `allowSimpleWhere` - Treat top-level fields on the `params` argument as simple "where" equality clauses. Default: `true`.
 *
 * @returns {array} The filtered collection of items of the type specified by `resourceName`.
 */
function filter(resourceName, params, options) {
  var DS = this;
  var IA = DS.errors.IA;
  var definition = DS.definitions[resourceName];

  options = options || {};

  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (params && !DS.utils.isObject(params)) {
    throw new IA(errorPrefix(resourceName) + 'params: Must be an object!');
  } else if (!DS.utils.isObject(options)) {
    throw new IA(errorPrefix(resourceName) + 'options: Must be an object!');
  }
  var resource = DS.store[resourceName];

  // Protect against null
  params = params || {};

  if ('allowSimpleWhere' in options) {
    options.allowSimpleWhere = !!options.allowSimpleWhere;
  } else {
    options.allowSimpleWhere = true;
  }

  var queryHash = DS.utils.toJson(params);

  if (!(queryHash in resource.completedQueries) && options.loadFromServer) {
    // This particular query has never been completed

    if (!resource.pendingQueries[queryHash]) {
      // This particular query has never even been started
      DS.findAll(resourceName, params, options);
    }
  }

  return definition.defaultFilter.call(DS, resource.collection, resourceName, params, options);
}

module.exports = filter;

},{}],76:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.get(' + resourceName + ', ' + id + '): ';
}

/**
 * @doc method
 * @id DS.sync methods:get
 * @name get
 * @description
 * Synchronously return the resource with the given id. The data store will forward the request to an adapter if
 * `loadFromServer` is `true` in the options hash.
 *
 * ## Signature:
 * ```js
 * DS.get(resourceName, id[, options])
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.get('document', 5'); // { author: 'John Anderson', id: 5 }
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item to retrieve.
 * @param {object=} options Optional configuration. Also passed along to `DS.find` if `loadFromServer` is `true`. Properties:
 *
 * - `{boolean=}` - `loadFromServer` - Send the query to server if it has not been sent yet. Default: `false`.
 *
 * @returns {object} The item of the type specified by `resourceName` with the primary key specified by `id`.
 */
function get(resourceName, id, options) {
  var DS = this;
  var IA = DS.errors.IA;

  options = options || {};

  if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
  } else if (!DS.utils.isObject(options)) {
    throw new IA(errorPrefix(resourceName, id) + 'options: Must be an object!');
  }
  // cache miss, request resource from server
  var item = DS.store[resourceName].index.get(id);
  if (!item && options.loadFromServer) {
    DS.find(resourceName, id, options).then(null, function (err) {
      return DS.$q.reject(err);
    });
  }

  // return resource from cache
  return item;
}

module.exports = get;

},{}],77:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.hasChanges(' + resourceName + ', ' + id + '): ';
}

function diffIsEmpty(utils, diff) {
  return !(utils.isEmpty(diff.added) &&
    utils.isEmpty(diff.removed) &&
    utils.isEmpty(diff.changed));
}

/**
 * @doc method
 * @id DS.sync methods:hasChanges
 * @name hasChanges
 * @description
 * Synchronously return whether object of the item of the type specified by `resourceName` that has the primary key
 * specified by `id` has changes.
 *
 * ## Signature:
 * ```js
 * DS.hasChanges(resourceName, id)
 * ```
 *
 * ## Example:
 *
 * ```js
 * var d = DS.get('document', 5); // { author: 'John Anderson', id: 5 }
 *
 * d.author = 'Sally';
 *
 * // You may have to do $scope.$apply() first
 *
 * DS.hasChanges('document', 5); // true
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item.
 * @returns {boolean} Whether the item of the type specified by `resourceName` with the primary key specified by `id` has changes.
 */
function hasChanges(resourceName, id) {
  var DS = this;

  id = DS.utils.resolveId(DS.definitions[resourceName], id);
  if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new DS.errors.IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
  }

  // return resource from cache
  if (DS.get(resourceName, id)) {
    return diffIsEmpty(DS.utils, DS.changes(resourceName, id));
  } else {
    return false;
  }
}

module.exports = hasChanges;

},{}],78:[function(require,module,exports){
module.exports = {

  /**
   * @doc method
   * @id DS.sync methods:bindOne
   * @name bindOne
   * @methodOf DS
   * @description
   * See [DS.bindOne](/documentation/api/api/DS.sync methods:bindOne).
   */
  bindOne: require('./bindOne'),

  /**
   * @doc method
   * @id DS.sync methods:bindAll
   * @name bindAll
   * @methodOf DS
   * @description
   * See [DS.bindAll](/documentation/api/api/DS.sync methods:bindAll).
   */
  bindAll: require('./bindAll'),

  /**
   * @doc method
   * @id DS.sync methods:changes
   * @name changes
   * @methodOf DS
   * @description
   * See [DS.changes](/documentation/api/api/DS.sync methods:changes).
   */
  changes: require('./changes'),

  /**
   * @doc method
   * @id DS.sync methods:changeHistory
   * @name changeHistory
   * @methodOf DS
   * @description
   * See [DS.changeHistory](/documentation/api/api/DS.sync methods:changeHistory).
   */
  changeHistory: require('./changeHistory'),

  /**
   * @doc method
   * @id DS.sync methods:compute
   * @name compute
   * @methodOf DS
   * @description
   * See [DS.compute](/documentation/api/api/DS.sync methods:compute).
   */
  compute: require('./compute').compute,

  /**
   * @doc method
   * @id DS.sync methods:createInstance
   * @name createInstance
   * @methodOf DS
   * @description
   * See [DS.createInstance](/documentation/api/api/DS.sync methods:createInstance).
   */
  createInstance: require('./createInstance'),

  /**
   * @doc method
   * @id DS.sync methods:defineResource
   * @name defineResource
   * @methodOf DS
   * @description
   * See [DS.defineResource](/documentation/api/api/DS.sync methods:defineResource).
   */
  defineResource: require('./defineResource'),

  /**
   * @doc method
   * @id DS.sync methods:digest
   * @name digest
   * @methodOf DS
   * @description
   * See [DS.digest](/documentation/api/api/DS.sync methods:digest).
   */
  digest: require('./digest'),

  /**
   * @doc method
   * @id DS.sync methods:eject
   * @name eject
   * @methodOf DS
   * @description
   * See [DS.eject](/documentation/api/api/DS.sync methods:eject).
   */
  eject: require('./eject'),

  /**
   * @doc method
   * @id DS.sync methods:ejectAll
   * @name ejectAll
   * @methodOf DS
   * @description
   * See [DS.ejectAll](/documentation/api/api/DS.sync methods:ejectAll).
   */
  ejectAll: require('./ejectAll'),

  /**
   * @doc method
   * @id DS.sync methods:filter
   * @name filter
   * @methodOf DS
   * @description
   * See [DS.filter](/documentation/api/api/DS.sync methods:filter).
   */
  filter: require('./filter'),

  /**
   * @doc method
   * @id DS.sync methods:get
   * @name get
   * @methodOf DS
   * @description
   * See [DS.get](/documentation/api/api/DS.sync methods:get).
   */
  get: require('./get'),

  /**
   * @doc method
   * @id DS.sync methods:hasChanges
   * @name hasChanges
   * @methodOf DS
   * @description
   * See [DS.hasChanges](/documentation/api/api/DS.sync methods:hasChanges).
   */
  hasChanges: require('./hasChanges'),

  /**
   * @doc method
   * @id DS.sync methods:inject
   * @name inject
   * @methodOf DS
   * @description
   * See [DS.inject](/documentation/api/api/DS.sync methods:inject).
   */
  inject: require('./inject'),

  /**
   * @doc method
   * @id DS.sync methods:lastModified
   * @name lastModified
   * @methodOf DS
   * @description
   * See [DS.lastModified](/documentation/api/api/DS.sync methods:lastModified).
   */
  lastModified: require('./lastModified'),

  /**
   * @doc method
   * @id DS.sync methods:lastSaved
   * @name lastSaved
   * @methodOf DS
   * @description
   * See [DS.lastSaved](/documentation/api/api/DS.sync methods:lastSaved).
   */
  lastSaved: require('./lastSaved'),

  /**
   * @doc method
   * @id DS.sync methods:link
   * @name link
   * @methodOf DS
   * @description
   * See [DS.link](/documentation/api/api/DS.sync methods:link).
   */
  link: require('./link'),

  /**
   * @doc method
   * @id DS.sync methods:linkAll
   * @name linkAll
   * @methodOf DS
   * @description
   * See [DS.linkAll](/documentation/api/api/DS.sync methods:linkAll).
   */
  linkAll: require('./linkAll'),

  /**
   * @doc method
   * @id DS.sync methods:linkInverse
   * @name linkInverse
   * @methodOf DS
   * @description
   * See [DS.linkInverse](/documentation/api/api/DS.sync methods:linkInverse).
   */
  linkInverse: require('./linkInverse'),

  /**
   * @doc method
   * @id DS.sync methods:previous
   * @name previous
   * @methodOf DS
   * @description
   * See [DS.previous](/documentation/api/api/DS.sync methods:previous).
   */
  previous: require('./previous'),

  /**
   * @doc method
   * @id DS.sync methods:unlinkInverse
   * @name unlinkInverse
   * @methodOf DS
   * @description
   * See [DS.unlinkInverse](/documentation/api/api/DS.sync methods:unlinkInverse).
   */
  unlinkInverse: require('./unlinkInverse')
};

},{"./bindAll":65,"./bindOne":66,"./changeHistory":67,"./changes":68,"./compute":69,"./createInstance":70,"./defineResource":71,"./digest":72,"./eject":73,"./ejectAll":74,"./filter":75,"./get":76,"./hasChanges":77,"./inject":79,"./lastModified":80,"./lastSaved":81,"./link":82,"./linkAll":83,"./linkInverse":84,"./previous":85,"./unlinkInverse":86}],79:[function(require,module,exports){
var observe = require('../../../lib/observe-js/observe-js');
var _compute = require('./compute')._compute;

function errorPrefix(resourceName) {
  return 'DS.inject(' + resourceName + ', attrs[, options]): ';
}

function _injectRelations(definition, injected, options) {
  var DS = this;

  DS.utils.forEach(definition.relationList, function (def) {
    var relationName = def.relation;
    var relationDef = DS.definitions[relationName];
    if (injected[def.localField]) {
      if (!relationDef) {
        throw new DS.errors.R(definition.name + 'relation is defined but the resource is not!');
      }
      try {
        injected[def.localField] = DS.inject(relationName, injected[def.localField], options);
      } catch (err) {
        DS.$log.error(errorPrefix(definition.name) + 'Failed to inject ' + def.type + ' relation: "' + relationName + '"!', err);
      }
    }
  });
}

function _inject(definition, resource, attrs, options) {
  var DS = this;
  var $log = DS.$log;

  function _react(added, removed, changed, oldValueFn, firstTime) {
    var target = this;
    var item;
    var innerId = (oldValueFn && oldValueFn(definition.idAttribute)) ? oldValueFn(definition.idAttribute) : target[definition.idAttribute];

    DS.utils.forEach(definition.relationFields, function (field) {
      delete added[field];
      delete removed[field];
      delete changed[field];
    });

    if (!DS.utils.isEmpty(added) || !DS.utils.isEmpty(removed) || !DS.utils.isEmpty(changed) || firstTime) {
      item = DS.get(definition.name, innerId);
      resource.modified[innerId] = DS.utils.updateTimestamp(resource.modified[innerId]);
      resource.collectionModified = DS.utils.updateTimestamp(resource.collectionModified);
      if (definition.keepChangeHistory) {
        var changeRecord = {
          resourceName: definition.name,
          target: item,
          added: added,
          removed: removed,
          changed: changed,
          timestamp: resource.modified[innerId]
        };
        resource.changeHistories[innerId].push(changeRecord);
        resource.changeHistory.push(changeRecord);
      }
    }

    if (definition.computed) {
      item = item || DS.get(definition.name, innerId);
      DS.utils.forEach(definition.computed, function (fn, field) {
        var compute = false;
        // check if required fields changed
        angular.forEach(fn.deps, function (dep) {
          if (dep in added || dep in removed || dep in changed || !(field in item)) {
            compute = true;
          }
        });
        compute = compute || !fn.deps.length;
        if (compute) {
          _compute.call(item, fn, field);
        }
      });
    }

    if (definition.relations) {
      item = item || DS.get(definition.name, innerId);
      DS.utils.forEach(definition.relationList, function (def) {
        if (item[def.localField] && (def.localKey in added || def.localKey in removed || def.localKey in changed)) {
          DS.link(definition.name, item[definition.idAttribute], [def.relation]);
        }
      });
    }

    if (definition.idAttribute in changed) {
      $log.error('Doh! You just changed the primary key of an object! ' +
        'I don\'t know how to handle this yet, so your data for the "' + definition.name +
        '" resource is now in an undefined (probably broken) state.');
    }
  }

  var injected;
  if (DS.utils.isArray(attrs)) {
    injected = [];
    for (var i = 0; i < attrs.length; i++) {
      injected.push(_inject.call(DS, definition, resource, attrs[i], options));
    }
  } else {
    // check if "idAttribute" is a computed property
    var c = definition.computed;
    var idA = definition.idAttribute;
    if (c && c[idA]) {
      var args = [];
      angular.forEach(c[idA].deps, function (dep) {
        args.push(attrs[dep]);
      });
      attrs[idA] = c[idA][c[idA].length - 1].apply(attrs, args);
    }
    if (!(idA in attrs)) {
      var error = new DS.errors.R(errorPrefix(definition.name) + 'attrs: Must contain the property specified by `idAttribute`!');
      $log.error(error);
      throw error;
    } else {
      try {
        definition.beforeInject(definition.name, attrs);
        var id = attrs[idA];
        var item = DS.get(definition.name, id);

        if (!item) {
          if (options.useClass) {
            if (attrs instanceof definition[definition.class]) {
              item = attrs;
            } else {
              item = new definition[definition.class]();
            }
          } else {
            item = {};
          }
          resource.previousAttributes[id] = {};

          DS.utils.deepMixIn(item, attrs);
          DS.utils.deepMixIn(resource.previousAttributes[id], attrs);

          resource.collection.push(item);

          resource.changeHistories[id] = [];
          resource.observers[id] = new observe.ObjectObserver(item);
          resource.observers[id].open(_react, item);
          resource.index.put(id, item);

          _react.call(item, {}, {}, {}, null, true);

          if (definition.relations) {
            _injectRelations.call(DS, definition, item, options);
          }
        } else {
          DS.utils.deepMixIn(item, attrs);
          if (definition.resetHistoryOnInject) {
            resource.previousAttributes[id] = {};
            DS.utils.deepMixIn(resource.previousAttributes[id], attrs);
            if (resource.changeHistories[id].length) {
              DS.utils.forEach(resource.changeHistories[id], function (changeRecord) {
                DS.utils.remove(resource.changeHistory, changeRecord);
              });
              resource.changeHistories[id].splice(0, resource.changeHistories[id].length);
            }
          }
          if (typeof resource.index.touch === 'function') {
            resource.index.touch(id);
          } else {
            resource.index.put(id, resource.index.get(id));
          }
          resource.observers[id].deliver();
        }
        resource.saved[id] = DS.utils.updateTimestamp(resource.saved[id]);
        definition.afterInject(definition.name, item);
        injected = item;
      } catch (err) {
        $log.error(err);
        $log.error('inject failed!', definition.name, attrs);
      }
    }
  }
  return injected;
}

function _link(definition, injected, options) {
  var DS = this;

  DS.utils.forEach(definition.relationList, function (def) {
    if (options.findBelongsTo && def.type === 'belongsTo' && injected[definition.idAttribute]) {
      DS.link(definition.name, injected[definition.idAttribute], [def.relation]);
    } else if ((options.findHasMany && def.type === 'hasMany') || (options.findHasOne && def.type === 'hasOne')) {
      DS.link(definition.name, injected[definition.idAttribute], [def.relation]);
    }
  });
}

/**
 * @doc method
 * @id DS.sync methods:inject
 * @name inject
 * @description
 * Inject the given item into the data store as the specified type. If `attrs` is an array, inject each item into the
 * data store. Injecting an item into the data store does not save it to the server. Emits a `"DS.inject"` event.
 *
 * ## Signature:
 * ```js
 * DS.inject(resourceName, attrs[, options])
 * ```
 *
 * ## Examples:
 *
 * ```js
 * DS.get('document', 45); // undefined
 *
 * DS.inject('document', { title: 'How to Cook', id: 45 });
 *
 * DS.get('document', 45); // { title: 'How to Cook', id: 45 }
 * ```
 *
 * Inject a collection into the data store:
 *
 * ```js
 * DS.filter('document'); // [ ]
 *
 * DS.inject('document', [ { title: 'How to Cook', id: 45 }, { title: 'How to Eat', id: 46 } ]);
 *
 * DS.filter('document'); // [ { title: 'How to Cook', id: 45 }, { title: 'How to Eat', id: 46 } ]
 * ```
 *
 * ```js
 * $rootScope.$on('DS.inject', function ($event, resourceName, injected) {...});
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{RuntimeError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object|array} attrs The item or collection of items to inject into the data store.
 * @param {object=} options The item or collection of items to inject into the data store. Properties:
 *
 * - `{boolean=}` - `useClass` - Whether to wrap the injected item with the resource's instance constructor.
 * - `{boolean=}` - `findBelongsTo` - Find and attach any existing "belongsTo" relationships to the newly injected item. Potentially expensive if enabled. Default: `false`.
 * - `{boolean=}` - `findHasMany` - Find and attach any existing "hasMany" relationships to the newly injected item. Potentially expensive if enabled. Default: `false`.
 * - `{boolean=}` - `findHasOne` - Find and attach any existing "hasOne" relationships to the newly injected item. Potentially expensive if enabled. Default: `false`.
 * - `{boolean=}` - `linkInverse` - Look in the data store for relations of the injected item(s) and update their links to the injected. Potentially expensive if enabled. Default: `false`.
 *
 * @returns {object|array} A reference to the item that was injected into the data store or an array of references to
 * the items that were injected into the data store.
 */
function inject(resourceName, attrs, options) {
  var DS = this;
  var IA = DS.errors.IA;
  var definition = DS.definitions[resourceName];

  options = options || {};

  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isObject(attrs) && !DS.utils.isArray(attrs)) {
    throw new IA(errorPrefix(resourceName) + 'attrs: Must be an object or an array!');
  } else if (!DS.utils.isObject(options)) {
    throw new IA(errorPrefix(resourceName) + 'options: Must be an object!');
  }
  var resource = DS.store[resourceName];
  var injected;

  if (!('useClass' in options)) {
    options.useClass = definition.useClass;
  }
  if (!('notify' in options)) {
    options.notify = definition.notify;
  }
  if (!DS.$rootScope.$$phase) {
    DS.$rootScope.$apply(function () {
      injected = _inject.call(DS, definition, resource, attrs, options);
    });
  } else {
    injected = _inject.call(DS, definition, resource, attrs, options);
  }

  if (options.linkInverse) {
    if (DS.utils.isArray(injected) && injected.length) {
      DS.linkInverse(definition.name, injected[0][definition.idAttribute]);
    } else {
      DS.linkInverse(definition.name, injected[definition.idAttribute]);
    }
  }

  if (DS.utils.isArray(injected)) {
    DS.utils.forEach(injected, function (injectedI) {
      _link.call(DS, definition, injectedI, options);
    });
  } else {
    _link.call(DS, definition, injected, options);
  }

  if (options.notify) {
    DS.emit(definition, 'inject', injected);
  }


  return injected;
}

module.exports = inject;

},{"../../../lib/observe-js/observe-js":1,"./compute":69}],80:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.lastModified(' + resourceName + '[, ' + id + ']): ';
}

/**
 * @doc method
 * @id DS.sync methods:lastModified
 * @name lastModified
 * @description
 * Return the timestamp of the last time either the collection for `resourceName` or the item of type `resourceName`
 * with the given primary key was modified.
 *
 * ## Signature:
 * ```js
 * DS.lastModified(resourceName[, id])
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.lastModified('document', 5); // undefined
 *
 * DS.find('document', 5).then(function (document) {
 *   DS.lastModified('document', 5); // 1234235825494
 * });
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number=} id The primary key of the item to remove.
 * @returns {number} The timestamp of the last time either the collection for `resourceName` or the item of type
 * `resourceName` with the given primary key was modified.
 */
function lastModified(resourceName, id) {
  var DS = this;
  var resource = DS.store[resourceName];

  id = DS.utils.resolveId(DS.definitions[resourceName], id);
  if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
  } else if (id && !DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new DS.errors.IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
  }
  if (id) {
    if (!(id in resource.modified)) {
      resource.modified[id] = 0;
    }
    return resource.modified[id];
  }
  return resource.collectionModified;
}

module.exports = lastModified;

},{}],81:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.lastSaved(' + resourceName + '[, ' + id + ']): ';
}

/**
 * @doc method
 * @id DS.sync methods:lastSaved
 * @name lastSaved
 * @description
 * Return the timestamp of the last time either the collection for `resourceName` or the item of type `resourceName`
 * with the given primary key was saved via an async adapter.
 *
 * ## Signature:
 * ```js
 * DS.lastSaved(resourceName[, id])
 * ```
 *
 * ## Example:
 *
 * ```js
 * DS.lastModified('document', 5); // undefined
 * DS.lastSaved('document', 5); // undefined
 *
 * DS.find('document', 5).then(function (document) {
 *   DS.lastModified('document', 5); // 1234235825494
 *   DS.lastSaved('document', 5); // 1234235825494
 *
 *   document.author = 'Sally';
 *
 *   // You may have to call $scope.$apply() first
 *
 *   DS.lastModified('document', 5); // 1234304985344 - something different
 *   DS.lastSaved('document', 5); // 1234235825494 - still the same
 * });
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item for which to retrieve the lastSaved timestamp.
 * @returns {number} The timestamp of the last time the item of type `resourceName` with the given primary key was saved.
 */
function lastSaved(resourceName, id) {
  var DS = this;
  var resource = DS.store[resourceName];

  id = DS.utils.resolveId(DS.definitions[resourceName], id);
  if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new DS.errors.IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
  }
  if (!(id in resource.saved)) {
    resource.saved[id] = 0;
  }
  return resource.saved[id];
}

module.exports = lastSaved;

},{}],82:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.link(' + resourceName + ', id[, relations]): ';
}

function _link(definition, linked, relations) {
  var DS = this;
  DS.utils.forEach(definition.relationList, function (def) {
    var relationName = def.relation;
    if (relations.length && !DS.utils.contains(relations, relationName)) {
      return;
    }
    var params = {};
    if (def.type === 'belongsTo') {
      var parent = linked[def.localKey] ? DS.get(relationName, linked[def.localKey]) : null;
      if (parent) {
        linked[def.localField] = parent;
      }
    } else if (def.type === 'hasMany') {
      params[def.foreignKey] = linked[definition.idAttribute];
      linked[def.localField] = DS.defaults.constructor.prototype.defaultFilter.call(DS, DS.store[relationName].collection, relationName, params, { allowSimpleWhere: true });
    } else if (def.type === 'hasOne') {
      params[def.foreignKey] = linked[definition.idAttribute];
      var children = DS.defaults.constructor.prototype.defaultFilter.call(DS, DS.store[relationName].collection, relationName, params, { allowSimpleWhere: true });
      if (children.length) {
        linked[def.localField] = children[0];
      }
    }
  });
}

/**
 * @doc method
 * @id DS.sync methods:link
 * @name link
 * @description
 * Find relations of the item with the given primary key that are already in the data store and link them to the item.
 *
 * ## Signature:
 * ```js
 * DS.link(resourceName, id[, relations])
 * ```
 *
 * ## Examples:
 *
 * Assume `user` has `hasMany` relationships to `post` and `comment`.
 * ```js
 * DS.get('user', 1); // { name: 'John', id: 1 }
 *
 * // link posts
 * DS.link('user', 1, ['post']);
 *
 * DS.get('user', 1); // { name: 'John', id: 1, posts: [...] }
 *
 * // link all relations
 * DS.link('user', 1);
 *
 * DS.get('user', 1); // { name: 'John', id: 1, posts: [...], comments: [...] }
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item for to link relations.
 * @param {array=} relations The relations to be linked. If not provided then all relations will be linked. Default: `[]`.
 * @returns {object|array} A reference to the item with its linked relations.
 */
function link(resourceName, id, relations) {
  var DS = this;
  var IA = DS.errors.IA;
  var definition = DS.definitions[resourceName];

  relations = relations || [];

  id = DS.utils.resolveId(definition, id);
  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new IA(errorPrefix(resourceName) + 'id: Must be a string or a number!');
  } else if (!DS.utils.isArray(relations)) {
    throw new IA(errorPrefix(resourceName) + 'relations: Must be an array!');
  }
  var linked = DS.get(resourceName, id);

  if (linked) {
    if (!DS.$rootScope.$$phase) {
      DS.$rootScope.$apply(function () {
        _link.call(DS, definition, linked, relations);
      });
    } else {
      _link.call(DS, definition, linked, relations);
    }
  }

  return linked;
}

module.exports = link;

},{}],83:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.linkAll(' + resourceName + '[, params][, relations]): ';
}

function _linkAll(definition, linked, relations) {
  var DS = this;
  DS.utils.forEach(definition.relationList, function (def) {
    var relationName = def.relation;
    if (relations.length && !DS.utils.contains(relations, relationName)) {
      return;
    }
    if (def.type === 'belongsTo') {
      DS.utils.forEach(linked, function (injectedItem) {
        var parent = injectedItem[def.localKey] ? DS.get(relationName, injectedItem[def.localKey]) : null;
        if (parent) {
          injectedItem[def.localField] = parent;
        }
      });
    } else if (def.type === 'hasMany') {
      DS.utils.forEach(linked, function (injectedItem) {
        var params = {};
        params[def.foreignKey] = injectedItem[definition.idAttribute];
        injectedItem[def.localField] = DS.defaults.constructor.prototype.defaultFilter.call(DS, DS.store[relationName].collection, relationName, params, { allowSimpleWhere: true });
      });
    } else if (def.type === 'hasOne') {
      DS.utils.forEach(linked, function (injectedItem) {
        var params = {};
        params[def.foreignKey] = injectedItem[definition.idAttribute];
        var children = DS.defaults.constructor.prototype.defaultFilter.call(DS, DS.store[relationName].collection, relationName, params, { allowSimpleWhere: true });
        if (children.length) {
          injectedItem[def.localField] = children[0];
        }
      });
    }
  });
}

/**
 * @doc method
 * @id DS.sync methods:linkAll
 * @name linkAll
 * @description
 * Find relations of a collection of items that are already in the data store and link them to the items.
 *
 * ## Signature:
 * ```js
 * DS.linkAll(resourceName[, params][, relations])
 * ```
 *
 * ## Examples:
 *
 * Assume `user` has `hasMany` relationships to `post` and `comment`.
 * ```js
 * DS.filter('user'); // [{ name: 'John', id: 1 }, { name: 'Sally', id: 2 }]
 *
 * // link posts
 * DS.linkAll('user', {
 *   name: : 'John'
 * }, ['post']);
 *
 * DS.filter('user'); // [{ name: 'John', id: 1, posts: [...] }, { name: 'Sally', id: 2 }]
 *
 * // link all relations
 * DS.linkAll('user', { name: : 'John' });
 *
 * DS.filter('user'); // [{ name: 'John', id: 1, posts: [...], comments: [...] }, { name: 'Sally', id: 2 }]
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {object=} params Parameter object that is used to filter items. Properties:
 *
 *  - `{object=}` - `where` - Where clause.
 *  - `{number=}` - `limit` - Limit clause.
 *  - `{number=}` - `skip` - Skip clause.
 *  - `{number=}` - `offset` - Same as skip.
 *  - `{string|array=}` - `orderBy` - OrderBy clause.
 *
 * @param {array=} relations The relations to be linked. If not provided then all relations will be linked. Default: `[]`.
 * @returns {object|array} A reference to the item with its linked relations.
 */
function linkAll(resourceName, params, relations) {
  var DS = this;
  var IA = DS.errors.IA;
  var definition = DS.definitions[resourceName];

  relations = relations || [];

  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (params && !DS.utils.isObject(params)) {
    throw new IA(errorPrefix(resourceName) + 'params: Must be an object!');
  } else if (!DS.utils.isArray(relations)) {
    throw new IA(errorPrefix(resourceName) + 'relations: Must be an array!');
  }
  var linked = DS.filter(resourceName, params);

  if (linked) {
    if (!DS.$rootScope.$$phase) {
      DS.$rootScope.$apply(function () {
        _linkAll.call(DS, definition, linked, relations);
      });
    } else {
      _linkAll.call(DS, definition, linked, relations);
    }
  }

  return linked;
}

module.exports = linkAll;

},{}],84:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.linkInverse(' + resourceName + ', id[, relations]): ';
}

function _linkInverse(definition, relations) {
  var DS = this;
  DS.utils.forEach(DS.definitions, function (d) {
    DS.utils.forEach(d.relations, function (relatedModels) {
      DS.utils.forEach(relatedModels, function (defs, relationName) {
        if (relations.length && !DS.utils.contains(relations, d.name)) {
          return;
        }
        if (definition.name === relationName) {
          DS.linkAll(d.name, {}, [definition.name]);
        }
      });
    });
  });
}

/**
 * @doc method
 * @id DS.sync methods:linkInverse
 * @name linkInverse
 * @description
 * Find relations of the item with the given primary key that are already in the data store and link this item to those
 * relations. This creates links in the opposite direction of `DS.link`.
 *
 * ## Signature:
 * ```js
 * DS.linkInverse(resourceName, id[, relations])
 * ```
 *
 * ## Examples:
 *
 * Assume `organization` has `hasMany` relationship to `user` and `post` has a `belongsTo` relationship to `user`.
 * ```js
 * DS.get('user', 1); // { organizationId: 5, id: 1 }
 * DS.get('organization', 5); // { id: 5 }
 * DS.filter('post', { userId: 1 }); // [ { id: 23, userId: 1 }, { id: 44, userId: 1 }]
 *
 * // link user to its relations
 * DS.linkInverse('user', 1, ['organization']);
 *
 * DS.get('organization', 5); // { id: 5, users: [{ organizationId: 5, id: 1 }] }
 *
 * // link user to all of its all relations
 * DS.linkInverse('user', 1);
 *
 * DS.get('user', 1); // { organizationId: 5, id: 1 }
 * DS.get('organization', 5); // { id: 5, users: [{ organizationId: 5, id: 1 }] }
 * DS.filter('post', { userId: 1 }); // [ { id: 23, userId: 1, user: {...} }, { id: 44, userId: 1, user: {...} }]
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item for to link relations.
 * @param {array=} relations The relations to be linked. If not provided then all relations will be linked. Default: `[]`.
 * @returns {object|array} A reference to the item with its linked relations.
 */
function linkInverse(resourceName, id, relations) {
  var DS = this;
  var IA = DS.errors.IA;
  var definition = DS.definitions[resourceName];

  relations = relations || [];


  id = DS.utils.resolveId(definition, id);
  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new IA(errorPrefix(resourceName) + 'id: Must be a string or a number!');
  } else if (!DS.utils.isArray(relations)) {
    throw new IA(errorPrefix(resourceName) + 'relations: Must be an array!');
  }
  var linked = DS.get(resourceName, id);

  if (linked) {
    if (!DS.$rootScope.$$phase) {
      DS.$rootScope.$apply(function () {
        _linkInverse.call(DS, definition, relations);
      });
    } else {
      _linkInverse.call(DS, definition, relations);
    }
  }

  return linked;
}

module.exports = linkInverse;

},{}],85:[function(require,module,exports){
function errorPrefix(resourceName, id) {
  return 'DS.previous(' + resourceName + '[, ' + id + ']): ';
}

/**
 * @doc method
 * @id DS.sync methods:previous
 * @name previous
 * @description
 * Synchronously return the previous attributes of the item of the type specified by `resourceName` that has the primary key
 * specified by `id`. This object represents the state of the item the last time it was saved via an async adapter.
 *
 * ## Signature:
 * ```js
 * DS.previous(resourceName, id)
 * ```
 *
 * ## Example:
 *
 * ```js
 * var d = DS.get('document', 5); // { author: 'John Anderson', id: 5 }
 *
 * d.author = 'Sally';
 *
 * d; // { author: 'Sally', id: 5 }
 *
 * // You may have to do $scope.$apply() first
 *
 * DS.previous('document', 5); // { author: 'John Anderson', id: 5 }
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item whose previous attributes are to be retrieved.
 * @returns {object} The previous attributes of the item of the type specified by `resourceName` with the primary key specified by `id`.
 */
function previous(resourceName, id) {
  var DS = this;

  id = DS.utils.resolveId(DS.definitions[resourceName], id);
  if (!DS.definitions[resourceName]) {
    throw new DS.errors.NER(errorPrefix(resourceName, id) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new DS.errors.IA(errorPrefix(resourceName, id) + 'id: Must be a string or a number!');
  }

  // return resource from cache
  return angular.copy(DS.store[resourceName].previousAttributes[id]);
}

module.exports = previous;

},{}],86:[function(require,module,exports){
function errorPrefix(resourceName) {
  return 'DS.unlinkInverse(' + resourceName + ', id[, relations]): ';
}

function _unlinkInverse(definition, linked) {
  var DS = this;
  DS.utils.forEach(DS.definitions, function (d) {
    DS.utils.forEach(d.relations, function (relatedModels) {
      DS.utils.forEach(relatedModels, function (defs, relationName) {
        if (definition.name === relationName) {
          DS.utils.forEach(defs, function (def) {
            DS.utils.forEach(DS.store[def.name].collection, function (item) {
              if (def.type === 'hasMany' && item[def.localField]) {
                var index;
                DS.utils.forEach(item[def.localField], function (subItem, i) {
                  if (subItem === linked) {
                    index = i;
                  }
                });
                if (index !== undefined) {
                  item[def.localField].splice(index, 1);
                }
              } else if (item[def.localField] === linked) {
                delete item[def.localField];
              }
            });
          });
        }
      });
    });
  });
}

/**
 * @doc method
 * @id DS.sync methods:unlinkInverse
 * @name unlinkInverse
 * @description
 * Find relations of the item with the given primary key that are already in the data store and _unlink_ this item from those
 * relations. This unlinks links that would be created by `DS.linkInverse`.
 *
 * ## Signature:
 * ```js
 * DS.unlinkInverse(resourceName, id[, relations])
 * ```
 *
 * ## Examples:
 *
 * Assume `organization` has `hasMany` relationship to `user` and `post` has a `belongsTo` relationship to `user`.
 * ```js
 * DS.get('organization', 5); // { id: 5, users: [{ organizationId: 5, id: 1 }] }
 *
 * // unlink user 1 from its relations
 * DS.unlinkInverse('user', 1, ['organization']);
 *
 * DS.get('organization', 5); // { id: 5, users: [] }
 * ```
 *
 * ## Throws
 *
 * - `{IllegalArgumentError}`
 * - `{NonexistentResourceError}`
 *
 * @param {string} resourceName The resource type, e.g. 'user', 'comment', etc.
 * @param {string|number} id The primary key of the item for which to unlink relations.
 * @param {array=} relations The relations to be unlinked. If not provided then all relations will be unlinked. Default: `[]`.
 * @returns {object|array} A reference to the item that has been unlinked.
 */
function unlinkInverse(resourceName, id, relations) {
  var DS = this;
  var IA = DS.errors.IA;
  var definition = DS.definitions[resourceName];

  relations = relations || [];

  id = DS.utils.resolveId(definition, id);
  if (!definition) {
    throw new DS.errors.NER(errorPrefix(resourceName) + resourceName);
  } else if (!DS.utils.isString(id) && !DS.utils.isNumber(id)) {
    throw new IA(errorPrefix(resourceName) + 'id: Must be a string or a number!');
  } else if (!DS.utils.isArray(relations)) {
    throw new IA(errorPrefix(resourceName) + 'relations: Must be an array!');
  }
  var linked = DS.get(resourceName, id);

  if (linked) {
    if (!DS.$rootScope.$$phase) {
      DS.$rootScope.$apply(function () {
        _unlinkInverse.call(DS, definition, linked, relations);
      });
    } else {
      _unlinkInverse.call(DS, definition, linked, relations);
    }
  }

  return linked;
}

module.exports = unlinkInverse;

},{}],87:[function(require,module,exports){
/**
 * @doc function
 * @id errors.types:IllegalArgumentError
 * @name IllegalArgumentError
 * @description Error that is thrown/returned when a caller does not honor the pre-conditions of a method/function.
 * @param {string=} message Error message. Default: `"Illegal Argument!"`.
 * @returns {IllegalArgumentError} A new instance of `IllegalArgumentError`.
 */
function IllegalArgumentError(message) {
  Error.call(this);
  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(this, this.constructor);
  }

  /**
   * @doc property
   * @id errors.types:IllegalArgumentError.type
   * @name type
   * @propertyOf errors.types:IllegalArgumentError
   * @description Name of error type. Default: `"IllegalArgumentError"`.
   */
  this.type = this.constructor.name;

  /**
   * @doc property
   * @id errors.types:IllegalArgumentError.message
   * @name message
   * @propertyOf errors.types:IllegalArgumentError
   * @description Error message. Default: `"Illegal Argument!"`.
   */
  this.message = message || 'Illegal Argument!';
}

IllegalArgumentError.prototype = Object.create(Error.prototype);
IllegalArgumentError.prototype.constructor = IllegalArgumentError;

/**
 * @doc function
 * @id errors.types:RuntimeError
 * @name RuntimeError
 * @description Error that is thrown/returned for invalid state during runtime.
 * @param {string=} message Error message. Default: `"Runtime Error!"`.
 * @returns {RuntimeError} A new instance of `RuntimeError`.
 */
function RuntimeError(message) {
  Error.call(this);
  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(this, this.constructor);
  }

  /**
   * @doc property
   * @id errors.types:RuntimeError.type
   * @name type
   * @propertyOf errors.types:RuntimeError
   * @description Name of error type. Default: `"RuntimeError"`.
   */
  this.type = this.constructor.name;

  /**
   * @doc property
   * @id errors.types:RuntimeError.message
   * @name message
   * @propertyOf errors.types:RuntimeError
   * @description Error message. Default: `"Runtime Error!"`.
   */
  this.message = message || 'RuntimeError Error!';
}

RuntimeError.prototype = Object.create(Error.prototype);
RuntimeError.prototype.constructor = RuntimeError;

/**
 * @doc function
 * @id errors.types:NonexistentResourceError
 * @name NonexistentResourceError
 * @description Error that is thrown/returned when trying to access a resource that does not exist.
 * @param {string=} resourceName Name of non-existent resource.
 * @returns {NonexistentResourceError} A new instance of `NonexistentResourceError`.
 */
function NonexistentResourceError(resourceName) {
  Error.call(this);
  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(this, this.constructor);
  }

  /**
   * @doc property
   * @id errors.types:NonexistentResourceError.type
   * @name type
   * @propertyOf errors.types:NonexistentResourceError
   * @description Name of error type. Default: `"NonexistentResourceError"`.
   */
  this.type = this.constructor.name;

  /**
   * @doc property
   * @id errors.types:NonexistentResourceError.message
   * @name message
   * @propertyOf errors.types:NonexistentResourceError
   * @description Error message. Default: `"Runtime Error!"`.
   */
  this.message = (resourceName || '') + ' is not a registered resource!';
}

NonexistentResourceError.prototype = Object.create(Error.prototype);
NonexistentResourceError.prototype.constructor = NonexistentResourceError;

/**
 * @doc interface
 * @id errors
 * @name angular-data error types
 * @description
 * Various error types that may be thrown by angular-data.
 *
 * - [IllegalArgumentError](/documentation/api/api/errors.types:IllegalArgumentError)
 * - [RuntimeError](/documentation/api/api/errors.types:RuntimeError)
 * - [NonexistentResourceError](/documentation/api/api/errors.types:NonexistentResourceError)
 *
 * References to the constructor functions of these errors can be found in `DS.errors`.
 */
module.exports = [function () {
  return {
    IllegalArgumentError: IllegalArgumentError,
    IA: IllegalArgumentError,
    RuntimeError: RuntimeError,
    R: RuntimeError,
    NonexistentResourceError: NonexistentResourceError,
    NER: NonexistentResourceError
  };
}];

},{}],88:[function(require,module,exports){
(function (window, angular, undefined) {
  'use strict';

  /**
   * @doc overview
   * @id angular-data
   * @name angular-data
   * @description
   * __Version:__ 1.0.1
   *
   * ## Install
   *
   * #### Bower
   * ```text
   * bower install angular-data
   * ```
   *
   * Load `dist/angular-data.js` or `dist/angular-data.min.js` onto your web page after Angular.js.
   *
   * #### Npm
   * ```text
   * npm install angular-data
   * ```
   *
   * Load `dist/angular-data.js` or `dist/angular-data.min.js` onto your web page after Angular.js.
   *
   * #### Manual download
   * Download angular-data from the [Releases](https://github.com/jmdobry/angular-data/releases)
   * section of the angular-data GitHub project.
   *
   * ## Load into Angular
   * Your Angular app must depend on the module `"angular-data.DS"` in order to use angular-data. Loading
   * angular-data into your app allows you to inject the following:
   *
   * - `DS`
   * - `DSHttpAdapter`
   * - `DSUtils`
   * - `DSErrors`
   *
   * [DS](/documentation/api/api/DS) is the Data Store itself, which you will inject often.
   * [DSHttpAdapter](/documentation/api/api/DSHttpAdapter) is useful as a wrapper for `$http` and is configurable.
   * [DSUtils](/documentation/api/api/DSUtils) has some useful utility methods.
   * [DSErrors](/documentation/api/api/DSErrors) provides references to the various errors thrown by the data store.
   */
  angular.module('angular-data.DS', ['ng'])
    .factory('DSUtils', require('./utils'))
    .factory('DSErrors', require('./errors'))
    .provider('DSHttpAdapter', require('./adapters/http'))
    .provider('DSLocalStorageAdapter', require('./adapters/localStorage'))
    .provider('DS', require('./datastore'))
    .config(['$provide', function ($provide) {
      $provide.decorator('$q', ['$delegate', function ($delegate) {
        // do whatever you you want
        $delegate.promisify = function (fn, target) {
          if (!fn) {
            return;
          } else if (typeof fn !== 'function') {
            throw new Error('Can only promisify functions!');
          }
          var $q = this;
          return function () {
            var deferred = $q.defer();
            var args = Array.prototype.slice.apply(arguments);

            args.push(function (err, result) {
              if (err) {
                deferred.reject(err);
              } else {
                deferred.resolve(result);
              }
            });

            try {
              var promise = fn.apply(target || this, args);
              if (promise && promise.then) {
                promise.then(deferred.resolve, deferred.reject);
              }
            } catch (err) {
              deferred.reject(err);
            }

            return deferred.promise;
          };
        };
        return $delegate;
      }]);
    }]);

})(window, window.angular);

},{"./adapters/http":51,"./adapters/localStorage":52,"./datastore":64,"./errors":87,"./utils":89}],89:[function(require,module,exports){
function Events(target) {
  var events = {};
  target = target || this;
  /**
   *  On: listen to events
   */
  target.on = function (type, func, ctx) {
    events[type] = events[type] || [];
    events[type].push({
      f: func,
      c: ctx
    });
  };

  /**
   *  Off: stop listening to event / specific callback
   */
  target.off = function (type, func) {
    var listeners = events[type];
    if (!listeners) {
      events = {};
    } else if (func) {
      for (var i = 0; i < listeners.length; i++) {
        if (listeners[i] === func) {
          listeners.splice(i, 1);
          break;
        }
      }
    } else {
      listeners.splice(0, listeners.length);
    }
  };

  target.emit = function () {
    var args = Array.prototype.slice.call(arguments);
    var listeners = events[args.shift()] || [];
    if (listeners) {
      for (var i = 0; i < listeners.length; i++) {
        listeners[i].f.apply(listeners[i].c, args);
      }
    }
  };
}

module.exports = [function () {
  return {
    isBoolean: require('mout/lang/isBoolean'),
    isString: angular.isString,
    isArray: angular.isArray,
    isObject: angular.isObject,
    isNumber: angular.isNumber,
    isFunction: angular.isFunction,
    isEmpty: require('mout/lang/isEmpty'),
    toJson: angular.toJson,
    fromJson: angular.fromJson,
    makePath: require('mout/string/makePath'),
    upperCase: require('mout/string/upperCase'),
    pascalCase: require('mout/string/pascalCase'),
    deepMixIn: require('mout/object/deepMixIn'),
    forEach: angular.forEach,
    pick: require('mout/object/pick'),
    set: require('mout/object/set'),
    merge: require('mout/object/merge'),
    contains: require('mout/array/contains'),
    filter: require('mout/array/filter'),
    toLookup: require('mout/array/toLookup'),
    remove: require('mout/array/remove'),
    slice: require('mout/array/slice'),
    sort: require('mout/array/sort'),
    guid: require('mout/random/guid'),
    keys: require('mout/object/keys'),
    resolveItem: function (resource, idOrInstance) {
      if (resource && (this.isString(idOrInstance) || this.isNumber(idOrInstance))) {
        return resource.index[idOrInstance] || idOrInstance;
      } else {
        return idOrInstance;
      }
    },
    resolveId: function (definition, idOrInstance) {
      if (this.isString(idOrInstance) || this.isNumber(idOrInstance)) {
        return idOrInstance;
      } else if (idOrInstance && definition) {
        return idOrInstance[definition.idAttribute] || idOrInstance;
      } else {
        return idOrInstance;
      }
    },
    updateTimestamp: function (timestamp) {
      var newTimestamp = typeof Date.now === 'function' ? Date.now() : new Date().getTime();
      if (timestamp && newTimestamp <= timestamp) {
        return timestamp + 1;
      } else {
        return newTimestamp;
      }
    },
    deepFreeze: function deepFreeze(o) {
      if (typeof Object.freeze === 'function') {
        var prop, propKey;
        Object.freeze(o); // First freeze the object.
        for (propKey in o) {
          prop = o[propKey];
          if (!o.hasOwnProperty(propKey) || typeof prop !== 'object' || Object.isFrozen(prop)) {
            // If the object is on the prototype, not an object, or is already frozen,
            // skip it. Note that this might leave an unfrozen reference somewhere in the
            // object if there is an already frozen object containing an unfrozen object.
            continue;
          }

          deepFreeze(prop); // Recursively call deepFreeze.
        }
      }
    },
    diffObjectFromOldObject: function (object, oldObject) {
      var added = {};
      var removed = {};
      var changed = {};

      for (var prop in oldObject) {
        var newValue = object[prop];

        if (newValue !== undefined && newValue === oldObject[prop])
          continue;

        if (!(prop in object)) {
          removed[prop] = undefined;
          continue;
        }

        if (newValue !== oldObject[prop])
          changed[prop] = newValue;
      }

      for (var prop2 in object) {
        if (prop2 in oldObject)
          continue;

        added[prop2] = object[prop2];
      }

      return {
        added: added,
        removed: removed,
        changed: changed
      };
    },
    Events: Events
  };
}];

},{"mout/array/contains":2,"mout/array/filter":3,"mout/array/remove":7,"mout/array/slice":8,"mout/array/sort":9,"mout/array/toLookup":10,"mout/lang/isBoolean":17,"mout/lang/isEmpty":18,"mout/object/deepMixIn":28,"mout/object/keys":32,"mout/object/merge":33,"mout/object/pick":36,"mout/object/set":37,"mout/random/guid":39,"mout/string/makePath":46,"mout/string/pascalCase":47,"mout/string/upperCase":50}]},{},[88]);

/**
 * @license AngularJS v1.3.0
 * (c) 2010-2014 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular, undefined) {'use strict';

/**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * # ngCookies
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 *
 * <div doc-module-components="ngCookies"></div>
 *
 * See {@link ngCookies.$cookies `$cookies`} and
 * {@link ngCookies.$cookieStore `$cookieStore`} for usage.
 */


angular.module('ngCookies', ['ng']).
  /**
   * @ngdoc service
   * @name $cookies
   *
   * @description
   * Provides read/write access to browser's cookies.
   *
   * Only a simple Object is exposed and by adding or removing properties to/from this object, new
   * cookies are created/deleted at the end of current $eval.
   * The object's properties can only be strings.
   *
   * Requires the {@link ngCookies `ngCookies`} module to be installed.
   *
   * @example
   *
   * ```js
   * angular.module('cookiesExample', ['ngCookies'])
   *   .controller('ExampleController', ['$cookies', function($cookies) {
   *     // Retrieving a cookie
   *     var favoriteCookie = $cookies.myFavorite;
   *     // Setting a cookie
   *     $cookies.myFavorite = 'oatmeal';
   *   }]);
   * ```
   */
   factory('$cookies', ['$rootScope', '$browser', function ($rootScope, $browser) {
      var cookies = {},
          lastCookies = {},
          lastBrowserCookies,
          runEval = false,
          copy = angular.copy,
          isUndefined = angular.isUndefined;

      //creates a poller fn that copies all cookies from the $browser to service & inits the service
      $browser.addPollFn(function() {
        var currentCookies = $browser.cookies();
        if (lastBrowserCookies != currentCookies) { //relies on browser.cookies() impl
          lastBrowserCookies = currentCookies;
          copy(currentCookies, lastCookies);
          copy(currentCookies, cookies);
          if (runEval) $rootScope.$apply();
        }
      })();

      runEval = true;

      //at the end of each eval, push cookies
      //TODO: this should happen before the "delayed" watches fire, because if some cookies are not
      //      strings or browser refuses to store some cookies, we update the model in the push fn.
      $rootScope.$watch(push);

      return cookies;


      /**
       * Pushes all the cookies from the service to the browser and verifies if all cookies were
       * stored.
       */
      function push() {
        var name,
            value,
            browserCookies,
            updated;

        //delete any cookies deleted in $cookies
        for (name in lastCookies) {
          if (isUndefined(cookies[name])) {
            $browser.cookies(name, undefined);
          }
        }

        //update all cookies updated in $cookies
        for(name in cookies) {
          value = cookies[name];
          if (!angular.isString(value)) {
            value = '' + value;
            cookies[name] = value;
          }
          if (value !== lastCookies[name]) {
            $browser.cookies(name, value);
            updated = true;
          }
        }

        //verify what was actually stored
        if (updated){
          updated = false;
          browserCookies = $browser.cookies();

          for (name in cookies) {
            if (cookies[name] !== browserCookies[name]) {
              //delete or reset all cookies that the browser dropped from $cookies
              if (isUndefined(browserCookies[name])) {
                delete cookies[name];
              } else {
                cookies[name] = browserCookies[name];
              }
              updated = true;
            }
          }
        }
      }
    }]).


  /**
   * @ngdoc service
   * @name $cookieStore
   * @requires $cookies
   *
   * @description
   * Provides a key-value (string-object) storage, that is backed by session cookies.
   * Objects put or retrieved from this storage are automatically serialized or
   * deserialized by angular's toJson/fromJson.
   *
   * Requires the {@link ngCookies `ngCookies`} module to be installed.
   *
   * @example
   *
   * ```js
   * angular.module('cookieStoreExample', ['ngCookies'])
   *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
   *     // Put cookie
   *     $cookieStore.put('myFavorite','oatmeal');
   *     // Get cookie
   *     var favoriteCookie = $cookieStore.get('myFavorite');
   *     // Removing a cookie
   *     $cookieStore.remove('myFavorite');
   *   }]);
   * ```
   */
   factory('$cookieStore', ['$cookies', function($cookies) {

      return {
        /**
         * @ngdoc method
         * @name $cookieStore#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        get: function(key) {
          var value = $cookies[key];
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookieStore#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         */
        put: function(key, value) {
          $cookies[key] = angular.toJson(value);
        },

        /**
         * @ngdoc method
         * @name $cookieStore#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         */
        remove: function(key) {
          delete $cookies[key];
        }
      };

    }]);


})(window, window.angular);

/*
 AngularJS v1.3.0
 (c) 2010-2014 Google, Inc. http://angularjs.org
 License: MIT
*/
(function(r,f,s){'use strict';f.module("ngMessages",[]).directive("ngMessages",["$compile","$animate","$templateRequest",function(q,k,l){return{restrict:"AE",controller:function(){this.$renderNgMessageClasses=f.noop;var b=[];this.registerMessage=function(d,a){for(var c=0;c<b.length;c++)if(b[c].type==a.type){if(d!=c){var g=b[d];b[d]=b[c];d<b.length?b[c]=g:b.splice(0,c)}return}b.splice(d,0,a)};this.renderMessages=function(d,a){d=d||{};var c;f.forEach(b,function(b){var e;if(e=!c||a)e=d[b.type],e=null!==
e&&!1!==e&&e;e?(b.attach(),c=!0):b.detach()});this.renderElementClasses(c)}},require:"ngMessages",link:function(b,d,a,c){c.renderElementClasses=function(b){b?k.setClass(d,"ng-active","ng-inactive"):k.setClass(d,"ng-inactive","ng-active")};var g=f.isString(a.ngMessagesMultiple)||f.isString(a.multiple),e;b.$watchCollection(a.ngMessages||a["for"],function(b){e=b;c.renderMessages(b,g)});(a=a.ngMessagesInclude||a.include)&&l(a).then(function(a){var h;a=f.element("<div/>").html(a);f.forEach(a.children(),
function(a){a=f.element(a);h?h.after(a):d.prepend(a);h=a;q(a)(b)});c.renderMessages(e,g)})}}}]).directive("ngMessage",["$animate",function(f){return{require:"^ngMessages",transclude:"element",terminal:!0,restrict:"AE",link:function(k,l,b,d,a){for(var c,g,e=l[0],n=e.parentNode,h=0,p=0;h<n.childNodes.length;h++){var m=n.childNodes[h];if(8==m.nodeType&&0<=m.nodeValue.indexOf("ngMessage")){if(m===e){c=p;break}p++}}d.registerMessage(c,{type:b.ngMessage||b.when,attach:function(){g||a(k,function(a){f.enter(a,
null,l);g=a})},detach:function(a){g&&(f.leave(g),g=null)}})}}}])})(window,window.angular);
//# sourceMappingURL=angular-messages.min.js.map

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.11.2 - 2014-09-26
 * License: MIT
 */
angular.module("ui.bootstrap",["ui.bootstrap.tpls","ui.bootstrap.transition","ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.bindHtml","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]),angular.module("ui.bootstrap.tpls",["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-unsafe-popup.html","template/tooltip/tooltip-popup.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]),angular.module("ui.bootstrap.transition",[]).factory("$transition",["$q","$timeout","$rootScope",function(a,b,c){function d(a){for(var b in a)if(void 0!==f.style[b])return a[b]}var e=function(d,f,g){g=g||{};var h=a.defer(),i=e[g.animation?"animationEndEventName":"transitionEndEventName"],j=function(){c.$apply(function(){d.unbind(i,j),h.resolve(d)})};return i&&d.bind(i,j),b(function(){angular.isString(f)?d.addClass(f):angular.isFunction(f)?f(d):angular.isObject(f)&&d.css(f),i||h.resolve(d)}),h.promise.cancel=function(){i&&d.unbind(i,j),h.reject("Transition cancelled")},h.promise},f=document.createElement("trans"),g={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"},h={WebkitTransition:"webkitAnimationEnd",MozTransition:"animationend",OTransition:"oAnimationEnd",transition:"animationend"};return e.transitionEndEventName=d(g),e.animationEndEventName=d(h),e}]),angular.module("ui.bootstrap.collapse",["ui.bootstrap.transition"]).directive("collapse",["$transition",function(a){return{link:function(b,c,d){function e(b){function d(){j===e&&(j=void 0)}var e=a(c,b);return j&&j.cancel(),j=e,e.then(d,d),e}function f(){k?(k=!1,g()):(c.removeClass("collapse").addClass("collapsing"),e({height:c[0].scrollHeight+"px"}).then(g))}function g(){c.removeClass("collapsing"),c.addClass("collapse in"),c.css({height:"auto"})}function h(){if(k)k=!1,i(),c.css({height:0});else{c.css({height:c[0].scrollHeight+"px"});{c[0].offsetWidth}c.removeClass("collapse in").addClass("collapsing"),e({height:0}).then(i)}}function i(){c.removeClass("collapsing"),c.addClass("collapse")}var j,k=!0;b.$watch(d.collapse,function(a){a?h():f()})}}}]),angular.module("ui.bootstrap.accordion",["ui.bootstrap.collapse"]).constant("accordionConfig",{closeOthers:!0}).controller("AccordionController",["$scope","$attrs","accordionConfig",function(a,b,c){this.groups=[],this.closeOthers=function(d){var e=angular.isDefined(b.closeOthers)?a.$eval(b.closeOthers):c.closeOthers;e&&angular.forEach(this.groups,function(a){a!==d&&(a.isOpen=!1)})},this.addGroup=function(a){var b=this;this.groups.push(a),a.$on("$destroy",function(){b.removeGroup(a)})},this.removeGroup=function(a){var b=this.groups.indexOf(a);-1!==b&&this.groups.splice(b,1)}}]).directive("accordion",function(){return{restrict:"EA",controller:"AccordionController",transclude:!0,replace:!1,templateUrl:"template/accordion/accordion.html"}}).directive("accordionGroup",function(){return{require:"^accordion",restrict:"EA",transclude:!0,replace:!0,templateUrl:"template/accordion/accordion-group.html",scope:{heading:"@",isOpen:"=?",isDisabled:"=?"},controller:function(){this.setHeading=function(a){this.heading=a}},link:function(a,b,c,d){d.addGroup(a),a.$watch("isOpen",function(b){b&&d.closeOthers(a)}),a.toggleOpen=function(){a.isDisabled||(a.isOpen=!a.isOpen)}}}}).directive("accordionHeading",function(){return{restrict:"EA",transclude:!0,template:"",replace:!0,require:"^accordionGroup",link:function(a,b,c,d,e){d.setHeading(e(a,function(){}))}}}).directive("accordionTransclude",function(){return{require:"^accordionGroup",link:function(a,b,c,d){a.$watch(function(){return d[c.accordionTransclude]},function(a){a&&(b.html(""),b.append(a))})}}}),angular.module("ui.bootstrap.alert",[]).controller("AlertController",["$scope","$attrs",function(a,b){a.closeable="close"in b}]).directive("alert",function(){return{restrict:"EA",controller:"AlertController",templateUrl:"template/alert/alert.html",transclude:!0,replace:!0,scope:{type:"@",close:"&"}}}),angular.module("ui.bootstrap.bindHtml",[]).directive("bindHtmlUnsafe",function(){return function(a,b,c){b.addClass("ng-binding").data("$binding",c.bindHtmlUnsafe),a.$watch(c.bindHtmlUnsafe,function(a){b.html(a||"")})}}),angular.module("ui.bootstrap.buttons",[]).constant("buttonConfig",{activeClass:"active",toggleEvent:"click"}).controller("ButtonsController",["buttonConfig",function(a){this.activeClass=a.activeClass||"active",this.toggleEvent=a.toggleEvent||"click"}]).directive("btnRadio",function(){return{require:["btnRadio","ngModel"],controller:"ButtonsController",link:function(a,b,c,d){var e=d[0],f=d[1];f.$render=function(){b.toggleClass(e.activeClass,angular.equals(f.$modelValue,a.$eval(c.btnRadio)))},b.bind(e.toggleEvent,function(){var d=b.hasClass(e.activeClass);(!d||angular.isDefined(c.uncheckable))&&a.$apply(function(){f.$setViewValue(d?null:a.$eval(c.btnRadio)),f.$render()})})}}}).directive("btnCheckbox",function(){return{require:["btnCheckbox","ngModel"],controller:"ButtonsController",link:function(a,b,c,d){function e(){return g(c.btnCheckboxTrue,!0)}function f(){return g(c.btnCheckboxFalse,!1)}function g(b,c){var d=a.$eval(b);return angular.isDefined(d)?d:c}var h=d[0],i=d[1];i.$render=function(){b.toggleClass(h.activeClass,angular.equals(i.$modelValue,e()))},b.bind(h.toggleEvent,function(){a.$apply(function(){i.$setViewValue(b.hasClass(h.activeClass)?f():e()),i.$render()})})}}}),angular.module("ui.bootstrap.carousel",["ui.bootstrap.transition"]).controller("CarouselController",["$scope","$timeout","$transition",function(a,b,c){function d(){e();var c=+a.interval;!isNaN(c)&&c>=0&&(g=b(f,c))}function e(){g&&(b.cancel(g),g=null)}function f(){h?(a.next(),d()):a.pause()}var g,h,i=this,j=i.slides=a.slides=[],k=-1;i.currentSlide=null;var l=!1;i.select=a.select=function(e,f){function g(){if(!l){if(i.currentSlide&&angular.isString(f)&&!a.noTransition&&e.$element){e.$element.addClass(f);{e.$element[0].offsetWidth}angular.forEach(j,function(a){angular.extend(a,{direction:"",entering:!1,leaving:!1,active:!1})}),angular.extend(e,{direction:f,active:!0,entering:!0}),angular.extend(i.currentSlide||{},{direction:f,leaving:!0}),a.$currentTransition=c(e.$element,{}),function(b,c){a.$currentTransition.then(function(){h(b,c)},function(){h(b,c)})}(e,i.currentSlide)}else h(e,i.currentSlide);i.currentSlide=e,k=m,d()}}function h(b,c){angular.extend(b,{direction:"",active:!0,leaving:!1,entering:!1}),angular.extend(c||{},{direction:"",active:!1,leaving:!1,entering:!1}),a.$currentTransition=null}var m=j.indexOf(e);void 0===f&&(f=m>k?"next":"prev"),e&&e!==i.currentSlide&&(a.$currentTransition?(a.$currentTransition.cancel(),b(g)):g())},a.$on("$destroy",function(){l=!0}),i.indexOfSlide=function(a){return j.indexOf(a)},a.next=function(){var b=(k+1)%j.length;return a.$currentTransition?void 0:i.select(j[b],"next")},a.prev=function(){var b=0>k-1?j.length-1:k-1;return a.$currentTransition?void 0:i.select(j[b],"prev")},a.isActive=function(a){return i.currentSlide===a},a.$watch("interval",d),a.$on("$destroy",e),a.play=function(){h||(h=!0,d())},a.pause=function(){a.noPause||(h=!1,e())},i.addSlide=function(b,c){b.$element=c,j.push(b),1===j.length||b.active?(i.select(j[j.length-1]),1==j.length&&a.play()):b.active=!1},i.removeSlide=function(a){var b=j.indexOf(a);j.splice(b,1),j.length>0&&a.active?i.select(b>=j.length?j[b-1]:j[b]):k>b&&k--}}]).directive("carousel",[function(){return{restrict:"EA",transclude:!0,replace:!0,controller:"CarouselController",require:"carousel",templateUrl:"template/carousel/carousel.html",scope:{interval:"=",noTransition:"=",noPause:"="}}}]).directive("slide",function(){return{require:"^carousel",restrict:"EA",transclude:!0,replace:!0,templateUrl:"template/carousel/slide.html",scope:{active:"=?"},link:function(a,b,c,d){d.addSlide(a,b),a.$on("$destroy",function(){d.removeSlide(a)}),a.$watch("active",function(b){b&&d.select(a)})}}}),angular.module("ui.bootstrap.dateparser",[]).service("dateParser",["$locale","orderByFilter",function(a,b){function c(a){var c=[],d=a.split("");return angular.forEach(e,function(b,e){var f=a.indexOf(e);if(f>-1){a=a.split(""),d[f]="("+b.regex+")",a[f]="$";for(var g=f+1,h=f+e.length;h>g;g++)d[g]="",a[g]="$";a=a.join(""),c.push({index:f,apply:b.apply})}}),{regex:new RegExp("^"+d.join("")+"$"),map:b(c,"index")}}function d(a,b,c){return 1===b&&c>28?29===c&&(a%4===0&&a%100!==0||a%400===0):3===b||5===b||8===b||10===b?31>c:!0}this.parsers={};var e={yyyy:{regex:"\\d{4}",apply:function(a){this.year=+a}},yy:{regex:"\\d{2}",apply:function(a){this.year=+a+2e3}},y:{regex:"\\d{1,4}",apply:function(a){this.year=+a}},MMMM:{regex:a.DATETIME_FORMATS.MONTH.join("|"),apply:function(b){this.month=a.DATETIME_FORMATS.MONTH.indexOf(b)}},MMM:{regex:a.DATETIME_FORMATS.SHORTMONTH.join("|"),apply:function(b){this.month=a.DATETIME_FORMATS.SHORTMONTH.indexOf(b)}},MM:{regex:"0[1-9]|1[0-2]",apply:function(a){this.month=a-1}},M:{regex:"[1-9]|1[0-2]",apply:function(a){this.month=a-1}},dd:{regex:"[0-2][0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a}},d:{regex:"[1-2]?[0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a}},EEEE:{regex:a.DATETIME_FORMATS.DAY.join("|")},EEE:{regex:a.DATETIME_FORMATS.SHORTDAY.join("|")}};this.parse=function(b,e){if(!angular.isString(b)||!e)return b;e=a.DATETIME_FORMATS[e]||e,this.parsers[e]||(this.parsers[e]=c(e));var f=this.parsers[e],g=f.regex,h=f.map,i=b.match(g);if(i&&i.length){for(var j,k={year:1900,month:0,date:1,hours:0},l=1,m=i.length;m>l;l++){var n=h[l-1];n.apply&&n.apply.call(k,i[l])}return d(k.year,k.month,k.date)&&(j=new Date(k.year,k.month,k.date,k.hours)),j}}}]),angular.module("ui.bootstrap.position",[]).factory("$position",["$document","$window",function(a,b){function c(a,c){return a.currentStyle?a.currentStyle[c]:b.getComputedStyle?b.getComputedStyle(a)[c]:a.style[c]}function d(a){return"static"===(c(a,"position")||"static")}var e=function(b){for(var c=a[0],e=b.offsetParent||c;e&&e!==c&&d(e);)e=e.offsetParent;return e||c};return{position:function(b){var c=this.offset(b),d={top:0,left:0},f=e(b[0]);f!=a[0]&&(d=this.offset(angular.element(f)),d.top+=f.clientTop-f.scrollTop,d.left+=f.clientLeft-f.scrollLeft);var g=b[0].getBoundingClientRect();return{width:g.width||b.prop("offsetWidth"),height:g.height||b.prop("offsetHeight"),top:c.top-d.top,left:c.left-d.left}},offset:function(c){var d=c[0].getBoundingClientRect();return{width:d.width||c.prop("offsetWidth"),height:d.height||c.prop("offsetHeight"),top:d.top+(b.pageYOffset||a[0].documentElement.scrollTop),left:d.left+(b.pageXOffset||a[0].documentElement.scrollLeft)}},positionElements:function(a,b,c,d){var e,f,g,h,i=c.split("-"),j=i[0],k=i[1]||"center";e=d?this.offset(a):this.position(a),f=b.prop("offsetWidth"),g=b.prop("offsetHeight");var l={center:function(){return e.left+e.width/2-f/2},left:function(){return e.left},right:function(){return e.left+e.width}},m={center:function(){return e.top+e.height/2-g/2},top:function(){return e.top},bottom:function(){return e.top+e.height}};switch(j){case"right":h={top:m[k](),left:l[j]()};break;case"left":h={top:m[k](),left:e.left-f};break;case"bottom":h={top:m[j](),left:l[k]()};break;default:h={top:e.top-g,left:l[k]()}}return h}}}]),angular.module("ui.bootstrap.datepicker",["ui.bootstrap.dateparser","ui.bootstrap.position"]).constant("datepickerConfig",{formatDay:"dd",formatMonth:"MMMM",formatYear:"yyyy",formatDayHeader:"EEE",formatDayTitle:"MMMM yyyy",formatMonthTitle:"yyyy",datepickerMode:"day",minMode:"day",maxMode:"year",showWeeks:!0,startingDay:0,yearRange:20,minDate:null,maxDate:null}).controller("DatepickerController",["$scope","$attrs","$parse","$interpolate","$timeout","$log","dateFilter","datepickerConfig",function(a,b,c,d,e,f,g,h){var i=this,j={$setViewValue:angular.noop};this.modes=["day","month","year"],angular.forEach(["formatDay","formatMonth","formatYear","formatDayHeader","formatDayTitle","formatMonthTitle","minMode","maxMode","showWeeks","startingDay","yearRange"],function(c,e){i[c]=angular.isDefined(b[c])?8>e?d(b[c])(a.$parent):a.$parent.$eval(b[c]):h[c]}),angular.forEach(["minDate","maxDate"],function(d){b[d]?a.$parent.$watch(c(b[d]),function(a){i[d]=a?new Date(a):null,i.refreshView()}):i[d]=h[d]?new Date(h[d]):null}),a.datepickerMode=a.datepickerMode||h.datepickerMode,a.uniqueId="datepicker-"+a.$id+"-"+Math.floor(1e4*Math.random()),this.activeDate=angular.isDefined(b.initDate)?a.$parent.$eval(b.initDate):new Date,a.isActive=function(b){return 0===i.compare(b.date,i.activeDate)?(a.activeDateId=b.uid,!0):!1},this.init=function(a){j=a,j.$render=function(){i.render()}},this.render=function(){if(j.$modelValue){var a=new Date(j.$modelValue),b=!isNaN(a);b?this.activeDate=a:f.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.'),j.$setValidity("date",b)}this.refreshView()},this.refreshView=function(){if(this.element){this._refreshView();var a=j.$modelValue?new Date(j.$modelValue):null;j.$setValidity("date-disabled",!a||this.element&&!this.isDisabled(a))}},this.createDateObject=function(a,b){var c=j.$modelValue?new Date(j.$modelValue):null;return{date:a,label:g(a,b),selected:c&&0===this.compare(a,c),disabled:this.isDisabled(a),current:0===this.compare(a,new Date)}},this.isDisabled=function(c){return this.minDate&&this.compare(c,this.minDate)<0||this.maxDate&&this.compare(c,this.maxDate)>0||b.dateDisabled&&a.dateDisabled({date:c,mode:a.datepickerMode})},this.split=function(a,b){for(var c=[];a.length>0;)c.push(a.splice(0,b));return c},a.select=function(b){if(a.datepickerMode===i.minMode){var c=j.$modelValue?new Date(j.$modelValue):new Date(0,0,0,0,0,0,0);c.setFullYear(b.getFullYear(),b.getMonth(),b.getDate()),j.$setViewValue(c),j.$render()}else i.activeDate=b,a.datepickerMode=i.modes[i.modes.indexOf(a.datepickerMode)-1]},a.move=function(a){var b=i.activeDate.getFullYear()+a*(i.step.years||0),c=i.activeDate.getMonth()+a*(i.step.months||0);i.activeDate.setFullYear(b,c,1),i.refreshView()},a.toggleMode=function(b){b=b||1,a.datepickerMode===i.maxMode&&1===b||a.datepickerMode===i.minMode&&-1===b||(a.datepickerMode=i.modes[i.modes.indexOf(a.datepickerMode)+b])},a.keys={13:"enter",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down"};var k=function(){e(function(){i.element[0].focus()},0,!1)};a.$on("datepicker.focus",k),a.keydown=function(b){var c=a.keys[b.which];if(c&&!b.shiftKey&&!b.altKey)if(b.preventDefault(),b.stopPropagation(),"enter"===c||"space"===c){if(i.isDisabled(i.activeDate))return;a.select(i.activeDate),k()}else!b.ctrlKey||"up"!==c&&"down"!==c?(i.handleKeyDown(c,b),i.refreshView()):(a.toggleMode("up"===c?1:-1),k())}}]).directive("datepicker",function(){return{restrict:"EA",replace:!0,templateUrl:"template/datepicker/datepicker.html",scope:{datepickerMode:"=?",dateDisabled:"&"},require:["datepicker","?^ngModel"],controller:"DatepickerController",link:function(a,b,c,d){var e=d[0],f=d[1];f&&e.init(f)}}}).directive("daypicker",["dateFilter",function(a){return{restrict:"EA",replace:!0,templateUrl:"template/datepicker/day.html",require:"^datepicker",link:function(b,c,d,e){function f(a,b){return 1!==b||a%4!==0||a%100===0&&a%400!==0?i[b]:29}function g(a,b){var c=new Array(b),d=new Date(a),e=0;for(d.setHours(12);b>e;)c[e++]=new Date(d),d.setDate(d.getDate()+1);return c}function h(a){var b=new Date(a);b.setDate(b.getDate()+4-(b.getDay()||7));var c=b.getTime();return b.setMonth(0),b.setDate(1),Math.floor(Math.round((c-b)/864e5)/7)+1}b.showWeeks=e.showWeeks,e.step={months:1},e.element=c;var i=[31,28,31,30,31,30,31,31,30,31,30,31];e._refreshView=function(){var c=e.activeDate.getFullYear(),d=e.activeDate.getMonth(),f=new Date(c,d,1),i=e.startingDay-f.getDay(),j=i>0?7-i:-i,k=new Date(f);j>0&&k.setDate(-j+1);for(var l=g(k,42),m=0;42>m;m++)l[m]=angular.extend(e.createDateObject(l[m],e.formatDay),{secondary:l[m].getMonth()!==d,uid:b.uniqueId+"-"+m});b.labels=new Array(7);for(var n=0;7>n;n++)b.labels[n]={abbr:a(l[n].date,e.formatDayHeader),full:a(l[n].date,"EEEE")};if(b.title=a(e.activeDate,e.formatDayTitle),b.rows=e.split(l,7),b.showWeeks){b.weekNumbers=[];for(var o=h(b.rows[0][0].date),p=b.rows.length;b.weekNumbers.push(o++)<p;);}},e.compare=function(a,b){return new Date(a.getFullYear(),a.getMonth(),a.getDate())-new Date(b.getFullYear(),b.getMonth(),b.getDate())},e.handleKeyDown=function(a){var b=e.activeDate.getDate();if("left"===a)b-=1;else if("up"===a)b-=7;else if("right"===a)b+=1;else if("down"===a)b+=7;else if("pageup"===a||"pagedown"===a){var c=e.activeDate.getMonth()+("pageup"===a?-1:1);e.activeDate.setMonth(c,1),b=Math.min(f(e.activeDate.getFullYear(),e.activeDate.getMonth()),b)}else"home"===a?b=1:"end"===a&&(b=f(e.activeDate.getFullYear(),e.activeDate.getMonth()));e.activeDate.setDate(b)},e.refreshView()}}}]).directive("monthpicker",["dateFilter",function(a){return{restrict:"EA",replace:!0,templateUrl:"template/datepicker/month.html",require:"^datepicker",link:function(b,c,d,e){e.step={years:1},e.element=c,e._refreshView=function(){for(var c=new Array(12),d=e.activeDate.getFullYear(),f=0;12>f;f++)c[f]=angular.extend(e.createDateObject(new Date(d,f,1),e.formatMonth),{uid:b.uniqueId+"-"+f});b.title=a(e.activeDate,e.formatMonthTitle),b.rows=e.split(c,3)},e.compare=function(a,b){return new Date(a.getFullYear(),a.getMonth())-new Date(b.getFullYear(),b.getMonth())},e.handleKeyDown=function(a){var b=e.activeDate.getMonth();if("left"===a)b-=1;else if("up"===a)b-=3;else if("right"===a)b+=1;else if("down"===a)b+=3;else if("pageup"===a||"pagedown"===a){var c=e.activeDate.getFullYear()+("pageup"===a?-1:1);e.activeDate.setFullYear(c)}else"home"===a?b=0:"end"===a&&(b=11);e.activeDate.setMonth(b)},e.refreshView()}}}]).directive("yearpicker",["dateFilter",function(){return{restrict:"EA",replace:!0,templateUrl:"template/datepicker/year.html",require:"^datepicker",link:function(a,b,c,d){function e(a){return parseInt((a-1)/f,10)*f+1}var f=d.yearRange;d.step={years:f},d.element=b,d._refreshView=function(){for(var b=new Array(f),c=0,g=e(d.activeDate.getFullYear());f>c;c++)b[c]=angular.extend(d.createDateObject(new Date(g+c,0,1),d.formatYear),{uid:a.uniqueId+"-"+c});a.title=[b[0].label,b[f-1].label].join(" - "),a.rows=d.split(b,5)},d.compare=function(a,b){return a.getFullYear()-b.getFullYear()},d.handleKeyDown=function(a){var b=d.activeDate.getFullYear();"left"===a?b-=1:"up"===a?b-=5:"right"===a?b+=1:"down"===a?b+=5:"pageup"===a||"pagedown"===a?b+=("pageup"===a?-1:1)*d.step.years:"home"===a?b=e(d.activeDate.getFullYear()):"end"===a&&(b=e(d.activeDate.getFullYear())+f-1),d.activeDate.setFullYear(b)},d.refreshView()}}}]).constant("datepickerPopupConfig",{datepickerPopup:"yyyy-MM-dd",currentText:"Today",clearText:"Clear",closeText:"Done",closeOnDateSelection:!0,appendToBody:!1,showButtonBar:!0}).directive("datepickerPopup",["$compile","$parse","$document","$position","dateFilter","dateParser","datepickerPopupConfig",function(a,b,c,d,e,f,g){return{restrict:"EA",require:"ngModel",scope:{isOpen:"=?",currentText:"@",clearText:"@",closeText:"@",dateDisabled:"&"},link:function(h,i,j,k){function l(a){return a.replace(/([A-Z])/g,function(a){return"-"+a.toLowerCase()})}function m(a){if(a){if(angular.isDate(a)&&!isNaN(a))return k.$setValidity("date",!0),a;if(angular.isString(a)){var b=f.parse(a,n)||new Date(a);return isNaN(b)?void k.$setValidity("date",!1):(k.$setValidity("date",!0),b)}return void k.$setValidity("date",!1)}return k.$setValidity("date",!0),null}var n,o=angular.isDefined(j.closeOnDateSelection)?h.$parent.$eval(j.closeOnDateSelection):g.closeOnDateSelection,p=angular.isDefined(j.datepickerAppendToBody)?h.$parent.$eval(j.datepickerAppendToBody):g.appendToBody;h.showButtonBar=angular.isDefined(j.showButtonBar)?h.$parent.$eval(j.showButtonBar):g.showButtonBar,h.getText=function(a){return h[a+"Text"]||g[a+"Text"]},j.$observe("datepickerPopup",function(a){n=a||g.datepickerPopup,k.$render()});var q=angular.element("<div datepicker-popup-wrap><div datepicker></div></div>");q.attr({"ng-model":"date","ng-change":"dateSelection()"});var r=angular.element(q.children()[0]);j.datepickerOptions&&angular.forEach(h.$parent.$eval(j.datepickerOptions),function(a,b){r.attr(l(b),a)}),h.watchData={},angular.forEach(["minDate","maxDate","datepickerMode"],function(a){if(j[a]){var c=b(j[a]);if(h.$parent.$watch(c,function(b){h.watchData[a]=b}),r.attr(l(a),"watchData."+a),"datepickerMode"===a){var d=c.assign;h.$watch("watchData."+a,function(a,b){a!==b&&d(h.$parent,a)})}}}),j.dateDisabled&&r.attr("date-disabled","dateDisabled({ date: date, mode: mode })"),k.$parsers.unshift(m),h.dateSelection=function(a){angular.isDefined(a)&&(h.date=a),k.$setViewValue(h.date),k.$render(),o&&(h.isOpen=!1,i[0].focus())},i.bind("input change keyup",function(){h.$apply(function(){h.date=k.$modelValue})}),k.$render=function(){var a=k.$viewValue?e(k.$viewValue,n):"";i.val(a),h.date=m(k.$modelValue)};var s=function(a){h.isOpen&&a.target!==i[0]&&h.$apply(function(){h.isOpen=!1})},t=function(a){h.keydown(a)};i.bind("keydown",t),h.keydown=function(a){27===a.which?(a.preventDefault(),a.stopPropagation(),h.close()):40!==a.which||h.isOpen||(h.isOpen=!0)},h.$watch("isOpen",function(a){a?(h.$broadcast("datepicker.focus"),h.position=p?d.offset(i):d.position(i),h.position.top=h.position.top+i.prop("offsetHeight"),c.bind("click",s)):c.unbind("click",s)}),h.select=function(a){if("today"===a){var b=new Date;angular.isDate(k.$modelValue)?(a=new Date(k.$modelValue),a.setFullYear(b.getFullYear(),b.getMonth(),b.getDate())):a=new Date(b.setHours(0,0,0,0))}h.dateSelection(a)},h.close=function(){h.isOpen=!1,i[0].focus()};var u=a(q)(h);q.remove(),p?c.find("body").append(u):i.after(u),h.$on("$destroy",function(){u.remove(),i.unbind("keydown",t),c.unbind("click",s)})}}}]).directive("datepickerPopupWrap",function(){return{restrict:"EA",replace:!0,transclude:!0,templateUrl:"template/datepicker/popup.html",link:function(a,b){b.bind("click",function(a){a.preventDefault(),a.stopPropagation()})}}}),angular.module("ui.bootstrap.dropdown",[]).constant("dropdownConfig",{openClass:"open"}).service("dropdownService",["$document",function(a){var b=null;this.open=function(e){b||(a.bind("click",c),a.bind("keydown",d)),b&&b!==e&&(b.isOpen=!1),b=e},this.close=function(e){b===e&&(b=null,a.unbind("click",c),a.unbind("keydown",d))};var c=function(a){var c=b.getToggleElement();a&&c&&c[0].contains(a.target)||b.$apply(function(){b.isOpen=!1})},d=function(a){27===a.which&&(b.focusToggleElement(),c())}}]).controller("DropdownController",["$scope","$attrs","$parse","dropdownConfig","dropdownService","$animate",function(a,b,c,d,e,f){var g,h=this,i=a.$new(),j=d.openClass,k=angular.noop,l=b.onToggle?c(b.onToggle):angular.noop;this.init=function(d){h.$element=d,b.isOpen&&(g=c(b.isOpen),k=g.assign,a.$watch(g,function(a){i.isOpen=!!a}))},this.toggle=function(a){return i.isOpen=arguments.length?!!a:!i.isOpen},this.isOpen=function(){return i.isOpen},i.getToggleElement=function(){return h.toggleElement},i.focusToggleElement=function(){h.toggleElement&&h.toggleElement[0].focus()},i.$watch("isOpen",function(b,c){f[b?"addClass":"removeClass"](h.$element,j),b?(i.focusToggleElement(),e.open(i)):e.close(i),k(a,b),angular.isDefined(b)&&b!==c&&l(a,{open:!!b})}),a.$on("$locationChangeSuccess",function(){i.isOpen=!1}),a.$on("$destroy",function(){i.$destroy()})}]).directive("dropdown",function(){return{restrict:"CA",controller:"DropdownController",link:function(a,b,c,d){d.init(b)}}}).directive("dropdownToggle",function(){return{restrict:"CA",require:"?^dropdown",link:function(a,b,c,d){if(d){d.toggleElement=b;var e=function(e){e.preventDefault(),b.hasClass("disabled")||c.disabled||a.$apply(function(){d.toggle()})};b.bind("click",e),b.attr({"aria-haspopup":!0,"aria-expanded":!1}),a.$watch(d.isOpen,function(a){b.attr("aria-expanded",!!a)}),a.$on("$destroy",function(){b.unbind("click",e)})}}}}),angular.module("ui.bootstrap.modal",["ui.bootstrap.transition"]).factory("$$stackedMap",function(){return{createNew:function(){var a=[];return{add:function(b,c){a.push({key:b,value:c})},get:function(b){for(var c=0;c<a.length;c++)if(b==a[c].key)return a[c]},keys:function(){for(var b=[],c=0;c<a.length;c++)b.push(a[c].key);return b},top:function(){return a[a.length-1]},remove:function(b){for(var c=-1,d=0;d<a.length;d++)if(b==a[d].key){c=d;break}return a.splice(c,1)[0]},removeTop:function(){return a.splice(a.length-1,1)[0]},length:function(){return a.length}}}}}).directive("modalBackdrop",["$timeout",function(a){return{restrict:"EA",replace:!0,templateUrl:"template/modal/backdrop.html",link:function(b,c,d){b.backdropClass=d.backdropClass||"",b.animate=!1,a(function(){b.animate=!0})}}}]).directive("modalWindow",["$modalStack","$timeout",function(a,b){return{restrict:"EA",scope:{index:"@",animate:"="},replace:!0,transclude:!0,templateUrl:function(a,b){return b.templateUrl||"template/modal/window.html"},link:function(c,d,e){d.addClass(e.windowClass||""),c.size=e.size,b(function(){c.animate=!0,d[0].querySelectorAll("[autofocus]").length||d[0].focus()}),c.close=function(b){var c=a.getTop();c&&c.value.backdrop&&"static"!=c.value.backdrop&&b.target===b.currentTarget&&(b.preventDefault(),b.stopPropagation(),a.dismiss(c.key,"backdrop click"))}}}}]).directive("modalTransclude",function(){return{link:function(a,b,c,d,e){e(a.$parent,function(a){b.empty(),b.append(a)})}}}).factory("$modalStack",["$transition","$timeout","$document","$compile","$rootScope","$$stackedMap",function(a,b,c,d,e,f){function g(){for(var a=-1,b=n.keys(),c=0;c<b.length;c++)n.get(b[c]).value.backdrop&&(a=c);return a}function h(a){var b=c.find("body").eq(0),d=n.get(a).value;n.remove(a),j(d.modalDomEl,d.modalScope,300,function(){d.modalScope.$destroy(),b.toggleClass(m,n.length()>0),i()})}function i(){if(k&&-1==g()){var a=l;j(k,l,150,function(){a.$destroy(),a=null}),k=void 0,l=void 0}}function j(c,d,e,f){function g(){g.done||(g.done=!0,c.remove(),f&&f())}d.animate=!1;var h=a.transitionEndEventName;if(h){var i=b(g,e);c.bind(h,function(){b.cancel(i),g(),d.$apply()})}else b(g)}var k,l,m="modal-open",n=f.createNew(),o={};return e.$watch(g,function(a){l&&(l.index=a)}),c.bind("keydown",function(a){var b;27===a.which&&(b=n.top(),b&&b.value.keyboard&&(a.preventDefault(),e.$apply(function(){o.dismiss(b.key,"escape key press")})))}),o.open=function(a,b){n.add(a,{deferred:b.deferred,modalScope:b.scope,backdrop:b.backdrop,keyboard:b.keyboard});var f=c.find("body").eq(0),h=g();if(h>=0&&!k){l=e.$new(!0),l.index=h;var i=angular.element("<div modal-backdrop></div>");i.attr("backdrop-class",b.backdropClass),k=d(i)(l),f.append(k)}var j=angular.element("<div modal-window></div>");j.attr({"template-url":b.windowTemplateUrl,"window-class":b.windowClass,size:b.size,index:n.length()-1,animate:"animate"}).html(b.content);var o=d(j)(b.scope);n.top().value.modalDomEl=o,f.append(o),f.addClass(m)},o.close=function(a,b){var c=n.get(a);c&&(c.value.deferred.resolve(b),h(a))},o.dismiss=function(a,b){var c=n.get(a);c&&(c.value.deferred.reject(b),h(a))},o.dismissAll=function(a){for(var b=this.getTop();b;)this.dismiss(b.key,a),b=this.getTop()},o.getTop=function(){return n.top()},o}]).provider("$modal",function(){var a={options:{backdrop:!0,keyboard:!0},$get:["$injector","$rootScope","$q","$http","$templateCache","$controller","$modalStack",function(b,c,d,e,f,g,h){function i(a){return a.template?d.when(a.template):e.get(angular.isFunction(a.templateUrl)?a.templateUrl():a.templateUrl,{cache:f}).then(function(a){return a.data})}function j(a){var c=[];return angular.forEach(a,function(a){(angular.isFunction(a)||angular.isArray(a))&&c.push(d.when(b.invoke(a)))}),c}var k={};return k.open=function(b){var e=d.defer(),f=d.defer(),k={result:e.promise,opened:f.promise,close:function(a){h.close(k,a)},dismiss:function(a){h.dismiss(k,a)}};if(b=angular.extend({},a.options,b),b.resolve=b.resolve||{},!b.template&&!b.templateUrl)throw new Error("One of template or templateUrl options is required.");var l=d.all([i(b)].concat(j(b.resolve)));return l.then(function(a){var d=(b.scope||c).$new();d.$close=k.close,d.$dismiss=k.dismiss;var f,i={},j=1;b.controller&&(i.$scope=d,i.$modalInstance=k,angular.forEach(b.resolve,function(b,c){i[c]=a[j++]}),f=g(b.controller,i),b.controllerAs&&(d[b.controllerAs]=f)),h.open(k,{scope:d,deferred:e,content:a[0],backdrop:b.backdrop,keyboard:b.keyboard,backdropClass:b.backdropClass,windowClass:b.windowClass,windowTemplateUrl:b.windowTemplateUrl,size:b.size})},function(a){e.reject(a)}),l.then(function(){f.resolve(!0)},function(){f.reject(!1)}),k},k}]};return a}),angular.module("ui.bootstrap.pagination",[]).controller("PaginationController",["$scope","$attrs","$parse",function(a,b,c){var d=this,e={$setViewValue:angular.noop},f=b.numPages?c(b.numPages).assign:angular.noop;this.init=function(f,g){e=f,this.config=g,e.$render=function(){d.render()},b.itemsPerPage?a.$parent.$watch(c(b.itemsPerPage),function(b){d.itemsPerPage=parseInt(b,10),a.totalPages=d.calculateTotalPages()}):this.itemsPerPage=g.itemsPerPage},this.calculateTotalPages=function(){var b=this.itemsPerPage<1?1:Math.ceil(a.totalItems/this.itemsPerPage);return Math.max(b||0,1)},this.render=function(){a.page=parseInt(e.$viewValue,10)||1},a.selectPage=function(b){a.page!==b&&b>0&&b<=a.totalPages&&(e.$setViewValue(b),e.$render())},a.getText=function(b){return a[b+"Text"]||d.config[b+"Text"]},a.noPrevious=function(){return 1===a.page},a.noNext=function(){return a.page===a.totalPages},a.$watch("totalItems",function(){a.totalPages=d.calculateTotalPages()}),a.$watch("totalPages",function(b){f(a.$parent,b),a.page>b?a.selectPage(b):e.$render()})}]).constant("paginationConfig",{itemsPerPage:10,boundaryLinks:!1,directionLinks:!0,firstText:"First",previousText:"Previous",nextText:"Next",lastText:"Last",rotate:!0}).directive("pagination",["$parse","paginationConfig",function(a,b){return{restrict:"EA",scope:{totalItems:"=",firstText:"@",previousText:"@",nextText:"@",lastText:"@"},require:["pagination","?ngModel"],controller:"PaginationController",templateUrl:"template/pagination/pagination.html",replace:!0,link:function(c,d,e,f){function g(a,b,c){return{number:a,text:b,active:c}}function h(a,b){var c=[],d=1,e=b,f=angular.isDefined(k)&&b>k;f&&(l?(d=Math.max(a-Math.floor(k/2),1),e=d+k-1,e>b&&(e=b,d=e-k+1)):(d=(Math.ceil(a/k)-1)*k+1,e=Math.min(d+k-1,b)));for(var h=d;e>=h;h++){var i=g(h,h,h===a);c.push(i)}if(f&&!l){if(d>1){var j=g(d-1,"...",!1);c.unshift(j)}if(b>e){var m=g(e+1,"...",!1);c.push(m)}}return c}var i=f[0],j=f[1];if(j){var k=angular.isDefined(e.maxSize)?c.$parent.$eval(e.maxSize):b.maxSize,l=angular.isDefined(e.rotate)?c.$parent.$eval(e.rotate):b.rotate;c.boundaryLinks=angular.isDefined(e.boundaryLinks)?c.$parent.$eval(e.boundaryLinks):b.boundaryLinks,c.directionLinks=angular.isDefined(e.directionLinks)?c.$parent.$eval(e.directionLinks):b.directionLinks,i.init(j,b),e.maxSize&&c.$parent.$watch(a(e.maxSize),function(a){k=parseInt(a,10),i.render()
});var m=i.render;i.render=function(){m(),c.page>0&&c.page<=c.totalPages&&(c.pages=h(c.page,c.totalPages))}}}}}]).constant("pagerConfig",{itemsPerPage:10,previousText:"« Previous",nextText:"Next »",align:!0}).directive("pager",["pagerConfig",function(a){return{restrict:"EA",scope:{totalItems:"=",previousText:"@",nextText:"@"},require:["pager","?ngModel"],controller:"PaginationController",templateUrl:"template/pagination/pager.html",replace:!0,link:function(b,c,d,e){var f=e[0],g=e[1];g&&(b.align=angular.isDefined(d.align)?b.$parent.$eval(d.align):a.align,f.init(g,a))}}}]),angular.module("ui.bootstrap.tooltip",["ui.bootstrap.position","ui.bootstrap.bindHtml"]).provider("$tooltip",function(){function a(a){var b=/[A-Z]/g,c="-";return a.replace(b,function(a,b){return(b?c:"")+a.toLowerCase()})}var b={placement:"top",animation:!0,popupDelay:0},c={mouseenter:"mouseleave",click:"click",focus:"blur"},d={};this.options=function(a){angular.extend(d,a)},this.setTriggers=function(a){angular.extend(c,a)},this.$get=["$window","$compile","$timeout","$parse","$document","$position","$interpolate",function(e,f,g,h,i,j,k){return function(e,l,m){function n(a){var b=a||o.trigger||m,d=c[b]||b;return{show:b,hide:d}}var o=angular.extend({},b,d),p=a(e),q=k.startSymbol(),r=k.endSymbol(),s="<div "+p+'-popup title="'+q+"tt_title"+r+'" content="'+q+"tt_content"+r+'" placement="'+q+"tt_placement"+r+'" animation="tt_animation" is-open="tt_isOpen"></div>';return{restrict:"EA",scope:!0,compile:function(){var a=f(s);return function(b,c,d){function f(){b.tt_isOpen?m():k()}function k(){(!y||b.$eval(d[l+"Enable"]))&&(b.tt_popupDelay?v||(v=g(p,b.tt_popupDelay,!1),v.then(function(a){a()})):p()())}function m(){b.$apply(function(){q()})}function p(){return v=null,u&&(g.cancel(u),u=null),b.tt_content?(r(),t.css({top:0,left:0,display:"block"}),w?i.find("body").append(t):c.after(t),z(),b.tt_isOpen=!0,b.$digest(),z):angular.noop}function q(){b.tt_isOpen=!1,g.cancel(v),v=null,b.tt_animation?u||(u=g(s,500)):s()}function r(){t&&s(),t=a(b,function(){}),b.$digest()}function s(){u=null,t&&(t.remove(),t=null)}var t,u,v,w=angular.isDefined(o.appendToBody)?o.appendToBody:!1,x=n(void 0),y=angular.isDefined(d[l+"Enable"]),z=function(){var a=j.positionElements(c,t,b.tt_placement,w);a.top+="px",a.left+="px",t.css(a)};b.tt_isOpen=!1,d.$observe(e,function(a){b.tt_content=a,!a&&b.tt_isOpen&&q()}),d.$observe(l+"Title",function(a){b.tt_title=a}),d.$observe(l+"Placement",function(a){b.tt_placement=angular.isDefined(a)?a:o.placement}),d.$observe(l+"PopupDelay",function(a){var c=parseInt(a,10);b.tt_popupDelay=isNaN(c)?o.popupDelay:c});var A=function(){c.unbind(x.show,k),c.unbind(x.hide,m)};d.$observe(l+"Trigger",function(a){A(),x=n(a),x.show===x.hide?c.bind(x.show,f):(c.bind(x.show,k),c.bind(x.hide,m))});var B=b.$eval(d[l+"Animation"]);b.tt_animation=angular.isDefined(B)?!!B:o.animation,d.$observe(l+"AppendToBody",function(a){w=angular.isDefined(a)?h(a)(b):w}),w&&b.$on("$locationChangeSuccess",function(){b.tt_isOpen&&q()}),b.$on("$destroy",function(){g.cancel(u),g.cancel(v),A(),s()})}}}}}]}).directive("tooltipPopup",function(){return{restrict:"EA",replace:!0,scope:{content:"@",placement:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-popup.html"}}).directive("tooltip",["$tooltip",function(a){return a("tooltip","tooltip","mouseenter")}]).directive("tooltipHtmlUnsafePopup",function(){return{restrict:"EA",replace:!0,scope:{content:"@",placement:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-html-unsafe-popup.html"}}).directive("tooltipHtmlUnsafe",["$tooltip",function(a){return a("tooltipHtmlUnsafe","tooltip","mouseenter")}]),angular.module("ui.bootstrap.popover",["ui.bootstrap.tooltip"]).directive("popoverPopup",function(){return{restrict:"EA",replace:!0,scope:{title:"@",content:"@",placement:"@",animation:"&",isOpen:"&"},templateUrl:"template/popover/popover.html"}}).directive("popover",["$tooltip",function(a){return a("popover","popover","click")}]),angular.module("ui.bootstrap.progressbar",[]).constant("progressConfig",{animate:!0,max:100}).controller("ProgressController",["$scope","$attrs","progressConfig",function(a,b,c){var d=this,e=angular.isDefined(b.animate)?a.$parent.$eval(b.animate):c.animate;this.bars=[],a.max=angular.isDefined(b.max)?a.$parent.$eval(b.max):c.max,this.addBar=function(b,c){e||c.css({transition:"none"}),this.bars.push(b),b.$watch("value",function(c){b.percent=+(100*c/a.max).toFixed(2)}),b.$on("$destroy",function(){c=null,d.removeBar(b)})},this.removeBar=function(a){this.bars.splice(this.bars.indexOf(a),1)}}]).directive("progress",function(){return{restrict:"EA",replace:!0,transclude:!0,controller:"ProgressController",require:"progress",scope:{},templateUrl:"template/progressbar/progress.html"}}).directive("bar",function(){return{restrict:"EA",replace:!0,transclude:!0,require:"^progress",scope:{value:"=",type:"@"},templateUrl:"template/progressbar/bar.html",link:function(a,b,c,d){d.addBar(a,b)}}}).directive("progressbar",function(){return{restrict:"EA",replace:!0,transclude:!0,controller:"ProgressController",scope:{value:"=",type:"@"},templateUrl:"template/progressbar/progressbar.html",link:function(a,b,c,d){d.addBar(a,angular.element(b.children()[0]))}}}),angular.module("ui.bootstrap.rating",[]).constant("ratingConfig",{max:5,stateOn:null,stateOff:null}).controller("RatingController",["$scope","$attrs","ratingConfig",function(a,b,c){var d={$setViewValue:angular.noop};this.init=function(e){d=e,d.$render=this.render,this.stateOn=angular.isDefined(b.stateOn)?a.$parent.$eval(b.stateOn):c.stateOn,this.stateOff=angular.isDefined(b.stateOff)?a.$parent.$eval(b.stateOff):c.stateOff;var f=angular.isDefined(b.ratingStates)?a.$parent.$eval(b.ratingStates):new Array(angular.isDefined(b.max)?a.$parent.$eval(b.max):c.max);a.range=this.buildTemplateObjects(f)},this.buildTemplateObjects=function(a){for(var b=0,c=a.length;c>b;b++)a[b]=angular.extend({index:b},{stateOn:this.stateOn,stateOff:this.stateOff},a[b]);return a},a.rate=function(b){!a.readonly&&b>=0&&b<=a.range.length&&(d.$setViewValue(b),d.$render())},a.enter=function(b){a.readonly||(a.value=b),a.onHover({value:b})},a.reset=function(){a.value=d.$viewValue,a.onLeave()},a.onKeydown=function(b){/(37|38|39|40)/.test(b.which)&&(b.preventDefault(),b.stopPropagation(),a.rate(a.value+(38===b.which||39===b.which?1:-1)))},this.render=function(){a.value=d.$viewValue}}]).directive("rating",function(){return{restrict:"EA",require:["rating","ngModel"],scope:{readonly:"=?",onHover:"&",onLeave:"&"},controller:"RatingController",templateUrl:"template/rating/rating.html",replace:!0,link:function(a,b,c,d){var e=d[0],f=d[1];f&&e.init(f)}}}),angular.module("ui.bootstrap.tabs",[]).controller("TabsetController",["$scope",function(a){var b=this,c=b.tabs=a.tabs=[];b.select=function(a){angular.forEach(c,function(b){b.active&&b!==a&&(b.active=!1,b.onDeselect())}),a.active=!0,a.onSelect()},b.addTab=function(a){c.push(a),1===c.length?a.active=!0:a.active&&b.select(a)},b.removeTab=function(a){var d=c.indexOf(a);if(a.active&&c.length>1){var e=d==c.length-1?d-1:d+1;b.select(c[e])}c.splice(d,1)}}]).directive("tabset",function(){return{restrict:"EA",transclude:!0,replace:!0,scope:{type:"@"},controller:"TabsetController",templateUrl:"template/tabs/tabset.html",link:function(a,b,c){a.vertical=angular.isDefined(c.vertical)?a.$parent.$eval(c.vertical):!1,a.justified=angular.isDefined(c.justified)?a.$parent.$eval(c.justified):!1}}}).directive("tab",["$parse",function(a){return{require:"^tabset",restrict:"EA",replace:!0,templateUrl:"template/tabs/tab.html",transclude:!0,scope:{active:"=?",heading:"@",onSelect:"&select",onDeselect:"&deselect"},controller:function(){},compile:function(b,c,d){return function(b,c,e,f){b.$watch("active",function(a){a&&f.select(b)}),b.disabled=!1,e.disabled&&b.$parent.$watch(a(e.disabled),function(a){b.disabled=!!a}),b.select=function(){b.disabled||(b.active=!0)},f.addTab(b),b.$on("$destroy",function(){f.removeTab(b)}),b.$transcludeFn=d}}}}]).directive("tabHeadingTransclude",[function(){return{restrict:"A",require:"^tab",link:function(a,b){a.$watch("headingElement",function(a){a&&(b.html(""),b.append(a))})}}}]).directive("tabContentTransclude",function(){function a(a){return a.tagName&&(a.hasAttribute("tab-heading")||a.hasAttribute("data-tab-heading")||"tab-heading"===a.tagName.toLowerCase()||"data-tab-heading"===a.tagName.toLowerCase())}return{restrict:"A",require:"^tabset",link:function(b,c,d){var e=b.$eval(d.tabContentTransclude);e.$transcludeFn(e.$parent,function(b){angular.forEach(b,function(b){a(b)?e.headingElement=b:c.append(b)})})}}}),angular.module("ui.bootstrap.timepicker",[]).constant("timepickerConfig",{hourStep:1,minuteStep:1,showMeridian:!0,meridians:null,readonlyInput:!1,mousewheel:!0}).controller("TimepickerController",["$scope","$attrs","$parse","$log","$locale","timepickerConfig",function(a,b,c,d,e,f){function g(){var b=parseInt(a.hours,10),c=a.showMeridian?b>0&&13>b:b>=0&&24>b;return c?(a.showMeridian&&(12===b&&(b=0),a.meridian===p[1]&&(b+=12)),b):void 0}function h(){var b=parseInt(a.minutes,10);return b>=0&&60>b?b:void 0}function i(a){return angular.isDefined(a)&&a.toString().length<2?"0"+a:a}function j(a){k(),o.$setViewValue(new Date(n)),l(a)}function k(){o.$setValidity("time",!0),a.invalidHours=!1,a.invalidMinutes=!1}function l(b){var c=n.getHours(),d=n.getMinutes();a.showMeridian&&(c=0===c||12===c?12:c%12),a.hours="h"===b?c:i(c),a.minutes="m"===b?d:i(d),a.meridian=n.getHours()<12?p[0]:p[1]}function m(a){var b=new Date(n.getTime()+6e4*a);n.setHours(b.getHours(),b.getMinutes()),j()}var n=new Date,o={$setViewValue:angular.noop},p=angular.isDefined(b.meridians)?a.$parent.$eval(b.meridians):f.meridians||e.DATETIME_FORMATS.AMPMS;this.init=function(c,d){o=c,o.$render=this.render;var e=d.eq(0),g=d.eq(1),h=angular.isDefined(b.mousewheel)?a.$parent.$eval(b.mousewheel):f.mousewheel;h&&this.setupMousewheelEvents(e,g),a.readonlyInput=angular.isDefined(b.readonlyInput)?a.$parent.$eval(b.readonlyInput):f.readonlyInput,this.setupInputEvents(e,g)};var q=f.hourStep;b.hourStep&&a.$parent.$watch(c(b.hourStep),function(a){q=parseInt(a,10)});var r=f.minuteStep;b.minuteStep&&a.$parent.$watch(c(b.minuteStep),function(a){r=parseInt(a,10)}),a.showMeridian=f.showMeridian,b.showMeridian&&a.$parent.$watch(c(b.showMeridian),function(b){if(a.showMeridian=!!b,o.$error.time){var c=g(),d=h();angular.isDefined(c)&&angular.isDefined(d)&&(n.setHours(c),j())}else l()}),this.setupMousewheelEvents=function(b,c){var d=function(a){a.originalEvent&&(a=a.originalEvent);var b=a.wheelDelta?a.wheelDelta:-a.deltaY;return a.detail||b>0};b.bind("mousewheel wheel",function(b){a.$apply(d(b)?a.incrementHours():a.decrementHours()),b.preventDefault()}),c.bind("mousewheel wheel",function(b){a.$apply(d(b)?a.incrementMinutes():a.decrementMinutes()),b.preventDefault()})},this.setupInputEvents=function(b,c){if(a.readonlyInput)return a.updateHours=angular.noop,void(a.updateMinutes=angular.noop);var d=function(b,c){o.$setViewValue(null),o.$setValidity("time",!1),angular.isDefined(b)&&(a.invalidHours=b),angular.isDefined(c)&&(a.invalidMinutes=c)};a.updateHours=function(){var a=g();angular.isDefined(a)?(n.setHours(a),j("h")):d(!0)},b.bind("blur",function(){!a.invalidHours&&a.hours<10&&a.$apply(function(){a.hours=i(a.hours)})}),a.updateMinutes=function(){var a=h();angular.isDefined(a)?(n.setMinutes(a),j("m")):d(void 0,!0)},c.bind("blur",function(){!a.invalidMinutes&&a.minutes<10&&a.$apply(function(){a.minutes=i(a.minutes)})})},this.render=function(){var a=o.$modelValue?new Date(o.$modelValue):null;isNaN(a)?(o.$setValidity("time",!1),d.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')):(a&&(n=a),k(),l())},a.incrementHours=function(){m(60*q)},a.decrementHours=function(){m(60*-q)},a.incrementMinutes=function(){m(r)},a.decrementMinutes=function(){m(-r)},a.toggleMeridian=function(){m(720*(n.getHours()<12?1:-1))}}]).directive("timepicker",function(){return{restrict:"EA",require:["timepicker","?^ngModel"],controller:"TimepickerController",replace:!0,scope:{},templateUrl:"template/timepicker/timepicker.html",link:function(a,b,c,d){var e=d[0],f=d[1];f&&e.init(f,b.find("input"))}}}),angular.module("ui.bootstrap.typeahead",["ui.bootstrap.position","ui.bootstrap.bindHtml"]).factory("typeaheadParser",["$parse",function(a){var b=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return{parse:function(c){var d=c.match(b);if(!d)throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "'+c+'".');return{itemName:d[3],source:a(d[4]),viewMapper:a(d[2]||d[1]),modelMapper:a(d[1])}}}}]).directive("typeahead",["$compile","$parse","$q","$timeout","$document","$position","typeaheadParser",function(a,b,c,d,e,f,g){var h=[9,13,27,38,40];return{require:"ngModel",link:function(i,j,k,l){var m,n=i.$eval(k.typeaheadMinLength)||1,o=i.$eval(k.typeaheadWaitMs)||0,p=i.$eval(k.typeaheadEditable)!==!1,q=b(k.typeaheadLoading).assign||angular.noop,r=b(k.typeaheadOnSelect),s=k.typeaheadInputFormatter?b(k.typeaheadInputFormatter):void 0,t=k.typeaheadAppendToBody?i.$eval(k.typeaheadAppendToBody):!1,u=b(k.ngModel).assign,v=g.parse(k.typeahead),w=i.$new();i.$on("$destroy",function(){w.$destroy()});var x="typeahead-"+w.$id+"-"+Math.floor(1e4*Math.random());j.attr({"aria-autocomplete":"list","aria-expanded":!1,"aria-owns":x});var y=angular.element("<div typeahead-popup></div>");y.attr({id:x,matches:"matches",active:"activeIdx",select:"select(activeIdx)",query:"query",position:"position"}),angular.isDefined(k.typeaheadTemplateUrl)&&y.attr("template-url",k.typeaheadTemplateUrl);var z=function(){w.matches=[],w.activeIdx=-1,j.attr("aria-expanded",!1)},A=function(a){return x+"-option-"+a};w.$watch("activeIdx",function(a){0>a?j.removeAttr("aria-activedescendant"):j.attr("aria-activedescendant",A(a))});var B=function(a){var b={$viewValue:a};q(i,!0),c.when(v.source(i,b)).then(function(c){var d=a===l.$viewValue;if(d&&m)if(c.length>0){w.activeIdx=0,w.matches.length=0;for(var e=0;e<c.length;e++)b[v.itemName]=c[e],w.matches.push({id:A(e),label:v.viewMapper(w,b),model:c[e]});w.query=a,w.position=t?f.offset(j):f.position(j),w.position.top=w.position.top+j.prop("offsetHeight"),j.attr("aria-expanded",!0)}else z();d&&q(i,!1)},function(){z(),q(i,!1)})};z(),w.query=void 0;var C,D=function(a){C=d(function(){B(a)},o)},E=function(){C&&d.cancel(C)};l.$parsers.unshift(function(a){return m=!0,a&&a.length>=n?o>0?(E(),D(a)):B(a):(q(i,!1),E(),z()),p?a:a?void l.$setValidity("editable",!1):(l.$setValidity("editable",!0),a)}),l.$formatters.push(function(a){var b,c,d={};return s?(d.$model=a,s(i,d)):(d[v.itemName]=a,b=v.viewMapper(i,d),d[v.itemName]=void 0,c=v.viewMapper(i,d),b!==c?b:a)}),w.select=function(a){var b,c,e={};e[v.itemName]=c=w.matches[a].model,b=v.modelMapper(i,e),u(i,b),l.$setValidity("editable",!0),r(i,{$item:c,$model:b,$label:v.viewMapper(i,e)}),z(),d(function(){j[0].focus()},0,!1)},j.bind("keydown",function(a){0!==w.matches.length&&-1!==h.indexOf(a.which)&&(a.preventDefault(),40===a.which?(w.activeIdx=(w.activeIdx+1)%w.matches.length,w.$digest()):38===a.which?(w.activeIdx=(w.activeIdx?w.activeIdx:w.matches.length)-1,w.$digest()):13===a.which||9===a.which?w.$apply(function(){w.select(w.activeIdx)}):27===a.which&&(a.stopPropagation(),z(),w.$digest()))}),j.bind("blur",function(){m=!1});var F=function(a){j[0]!==a.target&&(z(),w.$digest())};e.bind("click",F),i.$on("$destroy",function(){e.unbind("click",F)});var G=a(y)(w);t?e.find("body").append(G):j.after(G)}}}]).directive("typeaheadPopup",function(){return{restrict:"EA",scope:{matches:"=",query:"=",active:"=",position:"=",select:"&"},replace:!0,templateUrl:"template/typeahead/typeahead-popup.html",link:function(a,b,c){a.templateUrl=c.templateUrl,a.isOpen=function(){return a.matches.length>0},a.isActive=function(b){return a.active==b},a.selectActive=function(b){a.active=b},a.selectMatch=function(b){a.select({activeIdx:b})}}}}).directive("typeaheadMatch",["$http","$templateCache","$compile","$parse",function(a,b,c,d){return{restrict:"EA",scope:{index:"=",match:"=",query:"="},link:function(e,f,g){var h=d(g.templateUrl)(e.$parent)||"template/typeahead/typeahead-match.html";a.get(h,{cache:b}).success(function(a){f.replaceWith(c(a.trim())(e))})}}}]).filter("typeaheadHighlight",function(){function a(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}return function(b,c){return c?(""+b).replace(new RegExp(a(c),"gi"),"<strong>$&</strong>"):b}}),angular.module("template/accordion/accordion-group.html",[]).run(["$templateCache",function(a){a.put("template/accordion/accordion-group.html",'<div class="panel panel-default">\n  <div class="panel-heading">\n    <h4 class="panel-title">\n      <a class="accordion-toggle" ng-click="toggleOpen()" accordion-transclude="heading"><span ng-class="{\'text-muted\': isDisabled}">{{heading}}</span></a>\n    </h4>\n  </div>\n  <div class="panel-collapse" collapse="!isOpen">\n	  <div class="panel-body" ng-transclude></div>\n  </div>\n</div>')}]),angular.module("template/accordion/accordion.html",[]).run(["$templateCache",function(a){a.put("template/accordion/accordion.html",'<div class="panel-group" ng-transclude></div>')}]),angular.module("template/alert/alert.html",[]).run(["$templateCache",function(a){a.put("template/alert/alert.html",'<div class="alert" ng-class="[\'alert-\' + (type || \'warning\'), closeable ? \'alert-dismissable\' : null]" role="alert">\n    <button ng-show="closeable" type="button" class="close" ng-click="close()">\n        <span aria-hidden="true">&times;</span>\n        <span class="sr-only">Close</span>\n    </button>\n    <div ng-transclude></div>\n</div>\n')}]),angular.module("template/carousel/carousel.html",[]).run(["$templateCache",function(a){a.put("template/carousel/carousel.html",'<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n    <ol class="carousel-indicators" ng-show="slides.length > 1">\n        <li ng-repeat="slide in slides track by $index" ng-class="{active: isActive(slide)}" ng-click="select(slide)"></li>\n    </ol>\n    <div class="carousel-inner" ng-transclude></div>\n    <a class="left carousel-control" ng-click="prev()" ng-show="slides.length > 1"><span class="glyphicon glyphicon-chevron-left"></span></a>\n    <a class="right carousel-control" ng-click="next()" ng-show="slides.length > 1"><span class="glyphicon glyphicon-chevron-right"></span></a>\n</div>\n')}]),angular.module("template/carousel/slide.html",[]).run(["$templateCache",function(a){a.put("template/carousel/slide.html","<div ng-class=\"{\n    'active': leaving || (active && !entering),\n    'prev': (next || active) && direction=='prev',\n    'next': (next || active) && direction=='next',\n    'right': direction=='prev',\n    'left': direction=='next'\n  }\" class=\"item text-center\" ng-transclude></div>\n")}]),angular.module("template/datepicker/datepicker.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/datepicker.html",'<div ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)">\n  <daypicker ng-switch-when="day" tabindex="0"></daypicker>\n  <monthpicker ng-switch-when="month" tabindex="0"></monthpicker>\n  <yearpicker ng-switch-when="year" tabindex="0"></yearpicker>\n</div>')}]),angular.module("template/datepicker/day.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/day.html",'<table role="grid" aria-labelledby="{{uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{5 + showWeeks}}"><button id="{{uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-show="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in labels track by $index" class="text-center"><small aria-label="{{label.full}}">{{label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-show="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{dt.uid}}" aria-disabled="{{!!dt.disabled}}">\n        <button type="button" style="width:100%;" class="btn btn-default btn-sm" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/datepicker/month.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/month.html",'<table role="grid" aria-labelledby="{{uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th><button id="{{uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{dt.uid}}" aria-disabled="{{!!dt.disabled}}">\n        <button type="button" style="width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="{\'text-info\': dt.current}">{{dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/datepicker/popup.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/popup.html",'<ul class="dropdown-menu" ng-style="{display: (isOpen && \'block\') || \'none\', top: position.top+\'px\', left: position.left+\'px\'}" ng-keydown="keydown($event)">\n	<li ng-transclude></li>\n	<li ng-if="showButtonBar" style="padding:10px 9px 2px">\n		<span class="btn-group">\n			<button type="button" class="btn btn-sm btn-info" ng-click="select(\'today\')">{{ getText(\'current\') }}</button>\n			<button type="button" class="btn btn-sm btn-danger" ng-click="select(null)">{{ getText(\'clear\') }}</button>\n		</span>\n		<button type="button" class="btn btn-sm btn-success pull-right" ng-click="close()">{{ getText(\'close\') }}</button>\n	</li>\n</ul>\n')}]),angular.module("template/datepicker/year.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/year.html",'<table role="grid" aria-labelledby="{{uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="3"><button id="{{uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{dt.uid}}" aria-disabled="{{!!dt.disabled}}">\n        <button type="button" style="width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="{\'text-info\': dt.current}">{{dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/modal/backdrop.html",[]).run(["$templateCache",function(a){a.put("template/modal/backdrop.html",'<div class="modal-backdrop fade {{ backdropClass }}"\n     ng-class="{in: animate}"\n     ng-style="{\'z-index\': 1040 + (index && 1 || 0) + index*10}"\n></div>\n')}]),angular.module("template/modal/window.html",[]).run(["$templateCache",function(a){a.put("template/modal/window.html",'<div tabindex="-1" role="dialog" class="modal fade" ng-class="{in: animate}" ng-style="{\'z-index\': 1050 + index*10, display: \'block\'}" ng-click="close($event)">\n    <div class="modal-dialog" ng-class="{\'modal-sm\': size == \'sm\', \'modal-lg\': size == \'lg\'}"><div class="modal-content" modal-transclude></div></div>\n</div>')}]),angular.module("template/pagination/pager.html",[]).run(["$templateCache",function(a){a.put("template/pagination/pager.html",'<ul class="pager">\n  <li ng-class="{disabled: noPrevious(), previous: align}"><a href ng-click="selectPage(page - 1)">{{getText(\'previous\')}}</a></li>\n  <li ng-class="{disabled: noNext(), next: align}"><a href ng-click="selectPage(page + 1)">{{getText(\'next\')}}</a></li>\n</ul>')}]),angular.module("template/pagination/pagination.html",[]).run(["$templateCache",function(a){a.put("template/pagination/pagination.html",'<ul class="pagination">\n  <li ng-if="boundaryLinks" ng-class="{disabled: noPrevious()}"><a href ng-click="selectPage(1)">{{getText(\'first\')}}</a></li>\n  <li ng-if="directionLinks" ng-class="{disabled: noPrevious()}"><a href ng-click="selectPage(page - 1)">{{getText(\'previous\')}}</a></li>\n  <li ng-repeat="page in pages track by $index" ng-class="{active: page.active}"><a href ng-click="selectPage(page.number)">{{page.text}}</a></li>\n  <li ng-if="directionLinks" ng-class="{disabled: noNext()}"><a href ng-click="selectPage(page + 1)">{{getText(\'next\')}}</a></li>\n  <li ng-if="boundaryLinks" ng-class="{disabled: noNext()}"><a href ng-click="selectPage(totalPages)">{{getText(\'last\')}}</a></li>\n</ul>')}]),angular.module("template/tooltip/tooltip-html-unsafe-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-html-unsafe-popup.html",'<div class="tooltip {{placement}}" ng-class="{ in: isOpen(), fade: animation() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" bind-html-unsafe="content"></div>\n</div>\n')}]),angular.module("template/tooltip/tooltip-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-popup.html",'<div class="tooltip {{placement}}" ng-class="{ in: isOpen(), fade: animation() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind="content"></div>\n</div>\n')}]),angular.module("template/popover/popover.html",[]).run(["$templateCache",function(a){a.put("template/popover/popover.html",'<div class="popover {{placement}}" ng-class="{ in: isOpen(), fade: animation() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-show="title"></h3>\n      <div class="popover-content" ng-bind="content"></div>\n  </div>\n</div>\n')}]),angular.module("template/progressbar/bar.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/bar.html",'<div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: percent + \'%\'}" aria-valuetext="{{percent | number:0}}%" ng-transclude></div>')}]),angular.module("template/progressbar/progress.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/progress.html",'<div class="progress" ng-transclude></div>')}]),angular.module("template/progressbar/progressbar.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/progressbar.html",'<div class="progress">\n  <div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: percent + \'%\'}" aria-valuetext="{{percent | number:0}}%" ng-transclude></div>\n</div>')}]),angular.module("template/rating/rating.html",[]).run(["$templateCache",function(a){a.put("template/rating/rating.html",'<span ng-mouseleave="reset()" ng-keydown="onKeydown($event)" tabindex="0" role="slider" aria-valuemin="0" aria-valuemax="{{range.length}}" aria-valuenow="{{value}}">\n    <i ng-repeat="r in range track by $index" ng-mouseenter="enter($index + 1)" ng-click="rate($index + 1)" class="glyphicon" ng-class="$index < value && (r.stateOn || \'glyphicon-star\') || (r.stateOff || \'glyphicon-star-empty\')">\n        <span class="sr-only">({{ $index < value ? \'*\' : \' \' }})</span>\n    </i>\n</span>')}]),angular.module("template/tabs/tab.html",[]).run(["$templateCache",function(a){a.put("template/tabs/tab.html",'<li ng-class="{active: active, disabled: disabled}">\n  <a ng-click="select()" tab-heading-transclude>{{heading}}</a>\n</li>\n')}]),angular.module("template/tabs/tabset.html",[]).run(["$templateCache",function(a){a.put("template/tabs/tabset.html",'<div>\n  <ul class="nav nav-{{type || \'tabs\'}}" ng-class="{\'nav-stacked\': vertical, \'nav-justified\': justified}" ng-transclude></ul>\n  <div class="tab-content">\n    <div class="tab-pane" \n         ng-repeat="tab in tabs" \n         ng-class="{active: tab.active}"\n         tab-content-transclude="tab">\n    </div>\n  </div>\n</div>\n')}]),angular.module("template/timepicker/timepicker.html",[]).run(["$templateCache",function(a){a.put("template/timepicker/timepicker.html",'<table>\n	<tbody>\n		<tr class="text-center">\n			<td><a ng-click="incrementHours()" class="btn btn-link"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n			<td>&nbsp;</td>\n			<td><a ng-click="incrementMinutes()" class="btn btn-link"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n			<td ng-show="showMeridian"></td>\n		</tr>\n		<tr>\n			<td style="width:50px;" class="form-group" ng-class="{\'has-error\': invalidHours}">\n				<input type="text" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-mousewheel="incrementHours()" ng-readonly="readonlyInput" maxlength="2">\n			</td>\n			<td>:</td>\n			<td style="width:50px;" class="form-group" ng-class="{\'has-error\': invalidMinutes}">\n				<input type="text" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="readonlyInput" maxlength="2">\n			</td>\n			<td ng-show="showMeridian"><button type="button" class="btn btn-default text-center" ng-click="toggleMeridian()">{{meridian}}</button></td>\n		</tr>\n		<tr class="text-center">\n			<td><a ng-click="decrementHours()" class="btn btn-link"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n			<td>&nbsp;</td>\n			<td><a ng-click="decrementMinutes()" class="btn btn-link"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n			<td ng-show="showMeridian"></td>\n		</tr>\n	</tbody>\n</table>\n')}]),angular.module("template/typeahead/typeahead-match.html",[]).run(["$templateCache",function(a){a.put("template/typeahead/typeahead-match.html",'<a tabindex="-1" bind-html-unsafe="match.label | typeaheadHighlight:query"></a>')
}]),angular.module("template/typeahead/typeahead-popup.html",[]).run(["$templateCache",function(a){a.put("template/typeahead/typeahead-popup.html",'<ul class="dropdown-menu" ng-show="isOpen()" ng-style="{top: position.top+\'px\', left: position.left+\'px\'}" style="display: block;" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option" id="{{match.id}}">\n        <div typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n')}]);
/**
 * State-based routing for AngularJS
 * @version v0.2.18
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'ui.router';
}

(function (window, angular, undefined) {
/*jshint globalstrict:true*/
/*global angular:false*/
'use strict';

var isDefined = angular.isDefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    toJson = angular.toJson;

function inherit(parent, extra) {
  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
}

function merge(dst) {
  forEach(arguments, function(obj) {
    if (obj !== dst) {
      forEach(obj, function(value, key) {
        if (!dst.hasOwnProperty(key)) dst[key] = value;
      });
    }
  });
  return dst;
}

/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

/**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  forEach(object, function(val, key) {
    result.push(key);
  });
  return result;
}

/**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */
function indexOf(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

/**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i] || !parents[i].params) continue;
    parentParams = objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

/**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */
function equalForKeys(a, b, keys) {
  if (!keys) {
    keys = [];
    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (var i=0; i<keys.length; i++) {
    var k = keys[i];
    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
}

/**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */
function filterByKeys(keys, values) {
  var filtered = {};

  forEach(keys, function (name) {
    filtered[name] = values[name];
  });
  return filtered;
}

// like _.indexBy
// when you know that your index values will be unique, or you want last-one-in to win
function indexBy(array, propName) {
  var result = {};
  forEach(array, function(item) {
    result[item[propName]] = item;
  });
  return result;
}

// extracted from underscore.js
// Return a copy of the object only containing the whitelisted properties.
function pick(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  forEach(keys, function(key) {
    if (key in obj) copy[key] = obj[key];
  });
  return copy;
}

// extracted from underscore.js
// Return a copy of the object omitting the blacklisted properties.
function omit(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  for (var key in obj) {
    if (indexOf(keys, key) == -1) copy[key] = obj[key];
  }
  return copy;
}

function pluck(collection, key) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = isFunction(key) ? key(val) : val[key];
  });
  return result;
}

function filter(collection, callback) {
  var array = isArray(collection);
  var result = array ? [] : {};
  forEach(collection, function(val, i) {
    if (callback(val, i)) {
      result[array ? result.length : i] = val;
    }
  });
  return result;
}

function map(collection, callback) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = callback(val, i);
  });
  return result;
}

/**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */
angular.module('ui.router.util', ['ng']);

/**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */
angular.module('ui.router.router', ['ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */
angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */
angular.module('ui.router', ['ui.router.state']);

angular.module('ui.router.compat', ['ui.router']);

/**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */
$Resolve.$inject = ['$q', '$injector'];
function $Resolve(  $q,    $injector) {
  
  var VISIT_IN_PROGRESS = 1,
      VISIT_DONE = 2,
      NOTHING = {},
      NO_DEPENDENCIES = [],
      NO_LOCALS = NOTHING,
      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
  

  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */
  this.study = function (invocables) {
    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
    var invocableKeys = objectKeys(invocables || {});
    
    // Perform a topological sort of invocables to build an ordered plan
    var plan = [], cycle = [], visited = {};
    function visit(value, key) {
      if (visited[key] === VISIT_DONE) return;
      
      cycle.push(key);
      if (visited[key] === VISIT_IN_PROGRESS) {
        cycle.splice(0, indexOf(cycle, key));
        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
      }
      visited[key] = VISIT_IN_PROGRESS;
      
      if (isString(value)) {
        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
      } else {
        var params = $injector.annotate(value);
        forEach(params, function (param) {
          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
        });
        plan.push(key, value, params);
      }
      
      cycle.pop();
      visited[key] = VISIT_DONE;
    }
    forEach(invocables, visit);
    invocables = cycle = visited = null; // plan is all that's required
    
    function isResolve(value) {
      return isObject(value) && value.then && value.$$promises;
    }
    
    return function (locals, parent, self) {
      if (isResolve(locals) && self === undefined) {
        self = parent; parent = locals; locals = null;
      }
      if (!locals) locals = NO_LOCALS;
      else if (!isObject(locals)) {
        throw new Error("'locals' must be an object");
      }       
      if (!parent) parent = NO_PARENT;
      else if (!isResolve(parent)) {
        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
      }
      
      // To complete the overall resolution, we have to wait for the parent
      // promise and for the promise for each invokable in our plan.
      var resolution = $q.defer(),
          result = resolution.promise,
          promises = result.$$promises = {},
          values = extend({}, locals),
          wait = 1 + plan.length/3,
          merged = false;
          
      function done() {
        // Merge parent values we haven't got yet and publish our own $$values
        if (!--wait) {
          if (!merged) merge(values, parent.$$values); 
          result.$$values = values;
          result.$$promises = result.$$promises || true; // keep for isResolve()
          delete result.$$inheritedValues;
          resolution.resolve(values);
        }
      }
      
      function fail(reason) {
        result.$$failure = reason;
        resolution.reject(reason);
      }

      // Short-circuit if parent has already failed
      if (isDefined(parent.$$failure)) {
        fail(parent.$$failure);
        return result;
      }
      
      if (parent.$$inheritedValues) {
        merge(values, omit(parent.$$inheritedValues, invocableKeys));
      }

      // Merge parent values if the parent has already resolved, or merge
      // parent promises and wait if the parent resolve is still in progress.
      extend(promises, parent.$$promises);
      if (parent.$$values) {
        merged = merge(values, omit(parent.$$values, invocableKeys));
        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
        done();
      } else {
        if (parent.$$inheritedValues) {
          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
        }        
        parent.then(done, fail);
      }
      
      // Process each invocable in the plan, but ignore any where a local of the same name exists.
      for (var i=0, ii=plan.length; i<ii; i+=3) {
        if (locals.hasOwnProperty(plan[i])) done();
        else invoke(plan[i], plan[i+1], plan[i+2]);
      }
      
      function invoke(key, invocable, params) {
        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
        var invocation = $q.defer(), waitParams = 0;
        function onfailure(reason) {
          invocation.reject(reason);
          fail(reason);
        }
        // Wait for any parameter that we have a promise for (either from parent or from this
        // resolve; in that case study() will have made sure it's ordered before us in the plan).
        forEach(params, function (dep) {
          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
            waitParams++;
            promises[dep].then(function (result) {
              values[dep] = result;
              if (!(--waitParams)) proceed();
            }, onfailure);
          }
        });
        if (!waitParams) proceed();
        function proceed() {
          if (isDefined(result.$$failure)) return;
          try {
            invocation.resolve($injector.invoke(invocable, self, values));
            invocation.promise.then(function (result) {
              values[key] = result;
              done();
            }, onfailure);
          } catch (e) {
            onfailure(e);
          }
        }
        // Publish promise synchronously; invocations further down in the plan may depend on it.
        promises[key] = invocation.promise;
      }
      
      return result;
    };
  };
  
  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */
  this.resolve = function (invocables, locals, parent, self) {
    return this.study(invocables)(locals, parent, self);
  };
}

angular.module('ui.router.util').service('$resolve', $Resolve);


/**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */
$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
function $TemplateFactory(  $http,   $templateCache,   $injector) {

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */
  this.fromConfig = function (config, params, locals) {
    return (
      isDefined(config.template) ? this.fromString(config.template, params) :
      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
      null
    );
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */
  this.fromString = function (template, params) {
    return isFunction(template) ? template(params) : template;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromUrl = function (url, params) {
    if (isFunction(url)) url = url(params);
    if (url == null) return null;
    else return $http
        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
        .then(function(response) { return response.data; });
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromProvider = function (provider, params, locals) {
    return $injector.invoke(provider, null, locals || { params: params });
  };
}

angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);

var $$UMFP; // reference to $UrlMatcherFactoryProvider

/**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */
function UrlMatcher(pattern, config, parentMatcher) {
  config = extend({ params: {} }, isObject(config) ? config : {});

  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
  //   '*' name
  //   ':' name
  //   '{' name '}'
  //   '{' name ':' regexp '}'
  // The regular expression is somewhat complicated due to the need to allow curly braces
  // inside the regular expression. The placeholder regexp breaks down as follows:
  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
  //    [^{}\\]+                       - anything other than curly braces or backslash
  //    \\.                            - a backslash escape
  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      compiled = '^', last = 0, m,
      segments = this.segments = [],
      parentParams = parentMatcher ? parentMatcher.params : {},
      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
      paramNames = [];

  function addParameter(id, type, config, location) {
    paramNames.push(id);
    if (parentParams[id]) return parentParams[id];
    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
    params[id] = new $$UMFP.Param(id, type, config, location);
    return params[id];
  }

  function quoteRegExp(string, pattern, squash, optional) {
    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!pattern) return result;
    switch(squash) {
      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:\/(', ')|\/)?'];
      break;
      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
    }
    return result + surroundPattern[0] + pattern + surroundPattern[1];
  }

  this.source = pattern;

  // Split into static segments separated by path parameter placeholders.
  // The number of segments is always 1 more than the number of parameters.
  function matchDetails(m, isSearch) {
    var id, regexp, segment, type, cfg, arrayMode;
    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
    cfg         = config.params[id];
    segment     = pattern.substring(last, m.index);
    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);

    if (regexp) {
      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
    }

    return {
      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
    };
  }

  var p, param, segment;
  while ((m = placeholder.exec(pattern))) {
    p = matchDetails(m, false);
    if (p.segment.indexOf('?') >= 0) break; // we're into the search part

    param = addParameter(p.id, p.type, p.cfg, "path");
    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
    segments.push(p.segment);
    last = placeholder.lastIndex;
  }
  segment = pattern.substring(last);

  // Find any search parameter names and remove them from the last segment
  var i = segment.indexOf('?');

  if (i >= 0) {
    var search = this.sourceSearch = segment.substring(i);
    segment = segment.substring(0, i);
    this.sourcePath = pattern.substring(0, last + i);

    if (search.length > 0) {
      last = 0;
      while ((m = searchPlaceholder.exec(search))) {
        p = matchDetails(m, true);
        param = addParameter(p.id, p.type, p.cfg, "search");
        last = placeholder.lastIndex;
        // check if ?&
      }
    }
  } else {
    this.sourcePath = pattern;
    this.sourceSearch = '';
  }

  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
  segments.push(segment);

  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
  this.prefix = segments[0];
  this.$$paramNames = paramNames;
}

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */
UrlMatcher.prototype.concat = function (pattern, config) {
  // Because order of search parameters is irrelevant, we can add our own search
  // parameters to the end of the new pattern. Parse the new pattern by itself
  // and then join the bits together, but it's much easier to do this on a string level.
  var defaultConfig = {
    caseInsensitive: $$UMFP.caseInsensitive(),
    strict: $$UMFP.strictMode(),
    squash: $$UMFP.defaultSquashPolicy()
  };
  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
};

UrlMatcher.prototype.toString = function () {
  return this.source;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */
UrlMatcher.prototype.exec = function (path, searchParams) {
  var m = this.regexp.exec(path);
  if (!m) return null;
  searchParams = searchParams || {};

  var paramNames = this.parameters(), nTotal = paramNames.length,
    nPath = this.segments.length - 1,
    values = {}, i, j, cfg, paramName;

  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");

  function decodePathArray(string) {
    function reverseString(str) { return str.split("").reverse().join(""); }
    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }

    var split = reverseString(string).split(/-(?!\\)/);
    var allReversed = map(split, reverseString);
    return map(allReversed, unquoteDashes).reverse();
  }

  var param, paramVal;
  for (i = 0; i < nPath; i++) {
    paramName = paramNames[i];
    param = this.params[paramName];
    paramVal = m[i+1];
    // if the param value matches a pre-replace pair, replace the value before decoding.
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }
  for (/**/; i < nTotal; i++) {
    paramName = paramNames[i];
    values[paramName] = this.params[paramName].value(searchParams[paramName]);
    param = this.params[paramName];
    paramVal = searchParams[paramName];
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }

  return values;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */
UrlMatcher.prototype.parameters = function (param) {
  if (!isDefined(param)) return this.$$paramNames;
  return this.params[param] || null;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */
UrlMatcher.prototype.validates = function (params) {
  return this.params.$$validates(params);
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */
UrlMatcher.prototype.format = function (values) {
  values = values || {};
  var segments = this.segments, params = this.parameters(), paramset = this.params;
  if (!this.validates(values)) return null;

  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];

  function encodeDashes(str) { // Replace dashes with encoded "\-"
    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
  }

  for (i = 0; i < nTotal; i++) {
    var isPathParam = i < nPath;
    var name = params[i], param = paramset[name], value = param.value(values[name]);
    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
    var squash = isDefaultValue ? param.squash : false;
    var encoded = param.type.encode(value);

    if (isPathParam) {
      var nextSegment = segments[i + 1];
      var isFinalPathParam = i + 1 === nPath;

      if (squash === false) {
        if (encoded != null) {
          if (isArray(encoded)) {
            result += map(encoded, encodeDashes).join("-");
          } else {
            result += encodeURIComponent(encoded);
          }
        }
        result += nextSegment;
      } else if (squash === true) {
        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
        result += nextSegment.match(capture)[1];
      } else if (isString(squash)) {
        result += squash + nextSegment;
      }

      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
    } else {
      if (encoded == null || (isDefaultValue && squash !== false)) continue;
      if (!isArray(encoded)) encoded = [ encoded ];
      if (encoded.length === 0) continue;
      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
      result += (search ? '&' : '?') + (name + '=' + encoded);
      search = true;
    }
  }

  return result;
};

/**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */
function Type(config) {
  extend(this, config);
}

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */
Type.prototype.is = function(val, key) {
  return true;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */
Type.prototype.encode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */
Type.prototype.decode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */
Type.prototype.equals = function(a, b) {
  return a == b;
};

Type.prototype.$subPattern = function() {
  var sub = this.pattern.toString();
  return sub.substr(1, sub.length - 2);
};

Type.prototype.pattern = /.*/;

Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };

/** Given an encoded string, or a decoded object, returns a decoded object */
Type.prototype.$normalize = function(val) {
  return this.is(val) ? val : this.decode(val);
};

/*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */
Type.prototype.$asArray = function(mode, isSearch) {
  if (!mode) return this;
  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");

  function ArrayType(type, mode) {
    function bindTo(type, callbackName) {
      return function() {
        return type[callbackName].apply(type, arguments);
      };
    }

    // Wrap non-array value as array
    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch(val.length) {
        case 0: return undefined;
        case 1: return mode === "auto" ? val[0] : val;
        default: return val;
      }
    }
    function falsey(val) { return !val; }

    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        val = arrayWrap(val);
        var result = map(val, callback);
        if (allTruthyMode === true)
          return filter(result, falsey).length === 0;
        return arrayUnwrap(result);
      };
    }

    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1), right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }

    this.encode = arrayHandler(bindTo(type, 'encode'));
    this.decode = arrayHandler(bindTo(type, 'decode'));
    this.is     = arrayHandler(bindTo(type, 'is'), true);
    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
    this.pattern = type.pattern;
    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
    this.name = type.name;
    this.$arrayMode = mode;
  }

  return new ArrayType(this, mode);
};



/**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */
function $UrlMatcherFactory() {
  $$UMFP = this;

  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;

  // Use tildes to pre-encode slashes.
  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
  // and bidirectional encoding/decoding fails.
  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }

  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
    "string": {
      encode: valToString,
      decode: valFromString,
      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
      // In 0.2.x, string params are optional by default for backwards compat
      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
      pattern: /[^/]*/
    },
    "int": {
      encode: valToString,
      decode: function(val) { return parseInt(val, 10); },
      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
      pattern: /\d+/
    },
    "bool": {
      encode: function(val) { return val ? 1 : 0; },
      decode: function(val) { return parseInt(val, 10) !== 0; },
      is: function(val) { return val === true || val === false; },
      pattern: /0|1/
    },
    "date": {
      encode: function (val) {
        if (!this.is(val))
          return undefined;
        return [ val.getFullYear(),
          ('0' + (val.getMonth() + 1)).slice(-2),
          ('0' + val.getDate()).slice(-2)
        ].join("-");
      },
      decode: function (val) {
        if (this.is(val)) return val;
        var match = this.capture.exec(val);
        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
      },
      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
    },
    "json": {
      encode: angular.toJson,
      decode: angular.fromJson,
      is: angular.isObject,
      equals: angular.equals,
      pattern: /[^/]*/
    },
    "any": { // does not encode/decode
      encode: angular.identity,
      decode: angular.identity,
      equals: angular.equals,
      pattern: /.*/
    }
  };

  function getDefaultConfig() {
    return {
      strict: isStrictMode,
      caseInsensitive: isCaseInsensitive
    };
  }

  function isInjectable(value) {
    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
  }

  /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */
  $UrlMatcherFactory.$$getDefaultValue = function(config) {
    if (!isInjectable(config.value)) return config.value;
    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
    return injector.invoke(config.value);
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */
  this.caseInsensitive = function(value) {
    if (isDefined(value))
      isCaseInsensitive = value;
    return isCaseInsensitive;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */
  this.strictMode = function(value) {
    if (isDefined(value))
      isStrictMode = value;
    return isStrictMode;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */
  this.defaultSquashPolicy = function(value) {
    if (!isDefined(value)) return defaultSquashPolicy;
    if (value !== true && value !== false && !isString(value))
      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
    defaultSquashPolicy = value;
    return value;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */
  this.compile = function (pattern, config) {
    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */
  this.isMatcher = function (o) {
    if (!isObject(o)) return false;
    var result = true;

    forEach(UrlMatcher.prototype, function(val, name) {
      if (isFunction(val)) {
        result = result && (isDefined(o[name]) && isFunction(o[name]));
      }
    });
    return result;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */
  this.type = function (name, definition, definitionFn) {
    if (!isDefined(definition)) return $types[name];
    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");

    $types[name] = new Type(extend({ name: name }, definition));
    if (definitionFn) {
      typeQueue.push({ name: name, def: definitionFn });
      if (!enqueue) flushTypeQueue();
    }
    return this;
  };

  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
  function flushTypeQueue() {
    while(typeQueue.length) {
      var type = typeQueue.shift();
      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
      angular.extend($types[type.name], injector.invoke(type.def));
    }
  }

  // Register default types. Store them in the prototype of $types.
  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
  $types = inherit($types, {});

  /* No need to document $get, since it returns this */
  this.$get = ['$injector', function ($injector) {
    injector = $injector;
    enqueue = false;
    flushTypeQueue();

    forEach(defaultTypes, function(type, name) {
      if (!$types[name]) $types[name] = new Type(type);
    });
    return this;
  }];

  this.Param = function Param(id, type, config, location) {
    var self = this;
    config = unwrapShorthand(config);
    type = getType(config, type, location);
    var arrayMode = getArrayMode();
    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
    var isOptional = config.value !== undefined;
    var squash = getSquashPolicy(config, isOptional);
    var replace = getReplace(config, arrayMode, isOptional, squash);

    function unwrapShorthand(config) {
      var keys = isObject(config) ? objectKeys(config) : [];
      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
      if (isShorthand) config = { value: config };
      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
      return config;
    }

    function getType(config, urlType, location) {
      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
      if (urlType) return urlType;
      if (!config.type) return (location === "config" ? $types.any : $types.string);

      if (angular.isString(config.type))
        return $types[config.type];
      if (config.type instanceof Type)
        return config.type;
      return new Type(config.type);
    }

    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
    function getArrayMode() {
      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
      return extend(arrayDefaults, arrayParamNomenclature, config).array;
    }

    /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */
    function getSquashPolicy(config, isOptional) {
      var squash = config.squash;
      if (!isOptional || squash === false) return false;
      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
      if (squash === true || isString(squash)) return squash;
      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }

    function getReplace(config, arrayMode, isOptional, squash) {
      var replace, configuredKeys, defaultPolicy = [
        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
      ];
      replace = isArray(config.replace) ? config.replace : [];
      if (isString(squash))
        replace.push({ from: squash, to: undefined });
      configuredKeys = map(replace, function(item) { return item.from; } );
      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
    }

    /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */
    function $$getDefaultValue() {
      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
      var defaultValue = injector.invoke(config.$$fn);
      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
      return defaultValue;
    }

    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    function $value(value) {
      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
      function $replace(value) {
        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
        return replacement.length ? replacement[0] : value;
      }
      value = $replace(value);
      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
    }

    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }

    extend(this, {
      id: id,
      type: type,
      location: location,
      array: arrayMode,
      squash: squash,
      replace: replace,
      isOptional: isOptional,
      value: $value,
      dynamic: undefined,
      config: config,
      toString: toString
    });
  };

  function ParamSet(params) {
    extend(this, params || {});
  }

  ParamSet.prototype = {
    $$new: function() {
      return inherit(this, extend(new ParamSet(), { $$parent: this}));
    },
    $$keys: function () {
      var keys = [], chain = [], parent = this,
        ignore = objectKeys(ParamSet.prototype);
      while (parent) { chain.push(parent); parent = parent.$$parent; }
      chain.reverse();
      forEach(chain, function(paramset) {
        forEach(objectKeys(paramset), function(key) {
            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
        });
      });
      return keys;
    },
    $$values: function(paramValues) {
      var values = {}, self = this;
      forEach(self.$$keys(), function(key) {
        values[key] = self[key].value(paramValues && paramValues[key]);
      });
      return values;
    },
    $$equals: function(paramValues1, paramValues2) {
      var equal = true, self = this;
      forEach(self.$$keys(), function(key) {
        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
        if (!self[key].type.equals(left, right)) equal = false;
      });
      return equal;
    },
    $$validates: function $$validate(paramValues) {
      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
      for (i = 0; i < keys.length; i++) {
        param = this[keys[i]];
        rawVal = paramValues[keys[i]];
        if ((rawVal === undefined || rawVal === null) && param.isOptional)
          break; // There was no parameter value, but the param is optional
        normalized = param.type.$normalize(rawVal);
        if (!param.type.is(normalized))
          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
        encoded = param.type.encode(normalized);
        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
      }
      return true;
    },
    $$parent: undefined
  };

  this.ParamSet = ParamSet;
}

// Register as a provider so it's available to other providers
angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);

/**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */
$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
  var rules = [], otherwise = null, interceptDeferred = false, listener;

  // Returns a string that is a prefix of all strings matching the RegExp
  function regExpPrefix(re) {
    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
  }

  // Interpolates matched values into a String.replace()-style pattern
  function interpolate(pattern, match) {
    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
      return match[what === '$' ? 0 : Number(what)];
    });
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.rule = function (rule) {
    if (!isFunction(rule)) throw new Error("'rule' must be a function");
    rules.push(rule);
    return this;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.otherwise = function (rule) {
    if (isString(rule)) {
      var redirect = rule;
      rule = function () { return redirect; };
    }
    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
    otherwise = rule;
    return this;
  };


  function handleIfMatch($injector, handler, match) {
    if (!match) return false;
    var result = $injector.invoke(handler, handler, { $match: match });
    return isDefined(result) ? result : true;
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */
  this.when = function (what, handler) {
    var redirect, handlerIsString = isString(handler);
    if (isString(what)) what = $urlMatcherFactory.compile(what);

    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
      throw new Error("invalid 'handler' in when()");

    var strategies = {
      matcher: function (what, handler) {
        if (handlerIsString) {
          redirect = $urlMatcherFactory.compile(handler);
          handler = ['$match', function ($match) { return redirect.format($match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
        }, {
          prefix: isString(what.prefix) ? what.prefix : ''
        });
      },
      regex: function (what, handler) {
        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");

        if (handlerIsString) {
          redirect = handler;
          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path()));
        }, {
          prefix: regExpPrefix(what)
        });
      }
    };

    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };

    for (var n in check) {
      if (check[n]) return this.rule(strategies[n](what, handler));
    }

    throw new Error("invalid 'what' in when()");
  };

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */
  this.deferIntercept = function (defer) {
    if (defer === undefined) defer = true;
    interceptDeferred = defer;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */
  this.$get = $get;
  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {

    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;

    function appendBasePath(url, isHtml5, absolute) {
      if (baseHref === '/') return url;
      if (isHtml5) return baseHref.slice(0, -1) + url;
      if (absolute) return baseHref.slice(1) + url;
      return url;
    }

    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
    function update(evt) {
      if (evt && evt.defaultPrevented) return;
      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
      lastPushedUrl = undefined;
      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
      //if (ignoreUpdate) return true;

      function check(rule) {
        var handled = rule($injector, $location);

        if (!handled) return false;
        if (isString(handled)) $location.replace().url(handled);
        return true;
      }
      var n = rules.length, i;

      for (i = 0; i < n; i++) {
        if (check(rules[i])) return;
      }
      // always check otherwise last to allow dynamic updates to the set of rules
      if (otherwise) check(otherwise);
    }

    function listen() {
      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
      return listener;
    }

    if (!interceptDeferred) listen();

    return {
      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */
      sync: function() {
        update();
      },

      listen: function() {
        return listen();
      },

      update: function(read) {
        if (read) {
          location = $location.url();
          return;
        }
        if ($location.url() === location) return;

        $location.url(location);
        $location.replace();
      },

      push: function(urlMatcher, params, options) {
         var url = urlMatcher.format(params || {});

        // Handle the special hash param, if needed
        if (url !== null && params && params['#']) {
            url += '#' + params['#'];
        }

        $location.url(url);
        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
        if (options && options.replace) $location.replace();
      },

      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */
      href: function(urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;

        var isHtml5 = $locationProvider.html5Mode();
        if (angular.isObject(isHtml5)) {
          isHtml5 = isHtml5.enabled;
        }

        isHtml5 = isHtml5 && $sniffer.history;
        
        var url = urlMatcher.format(params);
        options = options || {};

        if (!isHtml5 && url !== null) {
          url = "#" + $locationProvider.hashPrefix() + url;
        }

        // Handle special hash param, if needed
        if (url !== null && params && params['#']) {
          url += '#' + params['#'];
        }

        url = appendBasePath(url, isHtml5, options.absolute);

        if (!options.absolute || !url) {
          return url;
        }

        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);

        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
      }
    };
  }
}

angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {

  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';

  // Builds state properties from definition passed to registerState()
  var stateBuilder = {

    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
    // state.children = [];
    // if (parent) parent.children.push(state);
    parent: function(state) {
      if (isDefined(state.parent) && state.parent) return findState(state.parent);
      // regex matches any valid composite state name
      // would match "contact.list" but not "contacts"
      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
      return compositeName ? findState(compositeName[1]) : root;
    },

    // inherit 'data' from parent and override by own values (if any)
    data: function(state) {
      if (state.parent && state.parent.data) {
        state.data = state.self.data = inherit(state.parent.data, state.data);
      }
      return state.data;
    },

    // Build a URLMatcher if necessary, either via a relative or absolute URL
    url: function(state) {
      var url = state.url, config = { params: state.params || {} };

      if (isString(url)) {
        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
        return (state.parent.navigable || root).url.concat(url, config);
      }

      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
    },

    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
    navigable: function(state) {
      return state.url ? state : (state.parent ? state.parent.navigable : null);
    },

    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
    ownParams: function(state) {
      var params = state.url && state.url.params || new $$UMFP.ParamSet();
      forEach(state.params || {}, function(config, id) {
        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
      });
      return params;
    },

    // Derive parameters for this state and ensure they're a super-set of parent's parameters
    params: function(state) {
      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
    },

    // If there is no explicit multi-view configuration, make one up so we don't have
    // to handle both cases in the view directive later. Note that having an explicit
    // 'views' property will mean the default unnamed view properties are ignored. This
    // is also a good time to resolve view names to absolute names, so everything is a
    // straight lookup at link time.
    views: function(state) {
      var views = {};

      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
        views[name] = view;
      });
      return views;
    },

    // Keep a full path from the root down to this state as this is needed for state activation.
    path: function(state) {
      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
    },

    // Speed up $state.contains() as it's used a lot
    includes: function(state) {
      var includes = state.parent ? extend({}, state.parent.includes) : {};
      includes[state.name] = true;
      return includes;
    },

    $delegates: {}
  };

  function isRelative(stateName) {
    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
  }

  function findState(stateOrName, base) {
    if (!stateOrName) return undefined;

    var isStr = isString(stateOrName),
        name  = isStr ? stateOrName : stateOrName.name,
        path  = isRelative(name);

    if (path) {
      if (!base) throw new Error("No reference point given for path '"  + name + "'");
      base = findState(base);
      
      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;

      for (; i < pathLength; i++) {
        if (rel[i] === "" && i === 0) {
          current = base;
          continue;
        }
        if (rel[i] === "^") {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      rel = rel.slice(i).join(".");
      name = current.name + (current.name && rel ? "." : "") + rel;
    }
    var state = states[name];

    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
      return state;
    }
    return undefined;
  }

  function queueState(parentName, state) {
    if (!queue[parentName]) {
      queue[parentName] = [];
    }
    queue[parentName].push(state);
  }

  function flushQueuedChildren(parentName) {
    var queued = queue[parentName] || [];
    while(queued.length) {
      registerState(queued.shift());
    }
  }

  function registerState(state) {
    // Wrap a new object around the state so we can store our private details easily.
    state = inherit(state, {
      self: state,
      resolve: state.resolve || {},
      toString: function() { return this.name; }
    });

    var name = state.name;
    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");

    // Get parent name
    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
        : (isString(state.parent)) ? state.parent
        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
        : '';

    // If parent is not registered yet, add state to queue and register later
    if (parentName && !states[parentName]) {
      return queueState(parentName, state.self);
    }

    for (var key in stateBuilder) {
      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
    }
    states[name] = state;

    // Register the state in the global state list and with $urlRouter if necessary.
    if (!state[abstractKey] && state.url) {
      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
          $state.transitionTo(state, $match, { inherit: true, location: false });
        }
      }]);
    }

    // Register any queued children
    flushQueuedChildren(name);

    return state;
  }

  // Checks text to see if it looks like a glob.
  function isGlob (text) {
    return text.indexOf('*') > -1;
  }

  // Returns true if glob matches current $state name.
  function doesStateMatchGlob (glob) {
    var globSegments = glob.split('.'),
        segments = $state.$current.name.split('.');

    //match single stars
    for (var i = 0, l = globSegments.length; i < l; i++) {
      if (globSegments[i] === '*') {
        segments[i] = '*';
      }
    }

    //match greedy starts
    if (globSegments[0] === '**') {
       segments = segments.slice(indexOf(segments, globSegments[1]));
       segments.unshift('**');
    }
    //match greedy ends
    if (globSegments[globSegments.length - 1] === '**') {
       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
       segments.push('**');
    }

    if (globSegments.length != segments.length) {
      return false;
    }

    return segments.join('') === globSegments.join('');
  }


  // Implicit root state that is always active
  root = registerState({
    name: '',
    url: '^',
    views: null,
    'abstract': true
  });
  root.navigable = null;


  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */
  this.decorator = decorator;
  function decorator(name, func) {
    /*jshint validthis: true */
    if (isString(name) && !isDefined(func)) {
      return stateBuilder[name];
    }
    if (!isFunction(func) || !isString(name)) {
      return this;
    }
    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
      stateBuilder.$delegates[name] = stateBuilder[name];
    }
    stateBuilder[name] = func;
    return this;
  }

  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */
  this.state = state;
  function state(name, definition) {
    /*jshint validthis: true */
    if (isObject(name)) definition = name;
    else definition.name = name;
    registerState(definition);
    return this;
  }

  /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */
  this.$get = $get;
  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {

    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
    var TransitionPrevented = $q.reject(new Error('transition prevented'));
    var TransitionAborted = $q.reject(new Error('transition aborted'));
    var TransitionFailed = $q.reject(new Error('transition failed'));

    // Handles the case where a state which is the target of a transition is not found, and the user
    // can optionally retry or defer the transition
    function handleRedirect(redirect, state, params, options) {
      /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */
      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);

      if (evt.defaultPrevented) {
        $urlRouter.update();
        return TransitionAborted;
      }

      if (!evt.retry) {
        return null;
      }

      // Allow the handler to return a promise to defer state lookup retry
      if (options.$retry) {
        $urlRouter.update();
        return TransitionFailed;
      }
      var retryTransition = $state.transition = $q.when(evt.retry);

      retryTransition.then(function() {
        if (retryTransition !== $state.transition) return TransitionSuperseded;
        redirect.options.$retry = true;
        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
      }, function() {
        return TransitionAborted;
      });
      $urlRouter.update();

      return retryTransition;
    }

    root.locals = { resolve: null, globals: { $stateParams: {} } };

    $state = {
      params: {},
      current: root.self,
      $current: root,
      transition: null
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.reload = function reload(state) {
      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) return TransitionSuperseded;

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) return TransitionSuperseded;

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }, function (error) {
        if ($state.transition !== transition) return TransitionSuperseded;

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
            $urlRouter.update();
        }

        return $q.reject(error);
      });

      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }
      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */
    $state.href = function href(stateOrName, params, options) {
      options = extend({
        lossy:    true,
        inherit:  true,
        absolute: false,
        relative: $state.$current
      }, options || {});

      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) return null;
      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
      
      var nav = (state && options.lossy) ? state.navigable : state;

      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
        absolute: options.absolute
      });
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */
    $state.get = function (stateOrName, context) {
      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
      var state = findState(stateOrName, context || $state.$current);
      return (state && state.self) ? state.self : null;
    };

    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
      // Make a restricted $stateParams with only the parameters that apply to this state if
      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
      // we also need $stateParams to be available for any $injector calls we make during the
      // dependency resolution process.
      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
      var locals = { $stateParams: $stateParams };

      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
      // We're also including $stateParams in this; that way the parameters are restricted
      // to the set that should be visible to the state, and are independent of when we update
      // the global $state and $stateParams values.
      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
      var promises = [dst.resolve.then(function (globals) {
        dst.globals = globals;
      })];
      if (inherited) promises.push(inherited);

      function resolveViews() {
        var viewsPromises = [];

        // Resolve template and dependencies for all views.
        forEach(state.views, function (view, name) {
          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
          injectables.$template = [ function () {
            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
          }];

          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
            // References to the controller (only instantiated at link time)
            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
              var injectLocals = angular.extend({}, injectables, dst.globals);
              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
            } else {
              result.$$controller = view.controller;
            }
            // Provide access to the state itself for internal use
            result.$$state = state;
            result.$$controllerAs = view.controllerAs;
            dst[name] = result;
          }));
        });

        return $q.all(viewsPromises).then(function(){
          return dst.globals;
        });
      }

      // Wait for all the promises and then return the activation object
      return $q.all(promises).then(resolveViews).then(function (values) {
        return dst;
      });
    }

    return $state;
  }

  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
    // Return true if there are no differences in non-search (path/object) params, false if there are differences
    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
      function notSearchParam(key) {
        return fromAndToState.params[key].location != "search";
      }
      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
      return nonQueryParamSet.$$equals(fromParams, toParams);
    }

    // If reload was not explicitly requested
    // and we're transitioning to the same state we're already in
    // and    the locals didn't change
    //     or they changed in a way that doesn't merit reloading
    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
    // Then return true.
    if (!options.reload && to === from &&
      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
      return true;
    }
  }
}

angular.module('ui.router.state')
  .factory('$stateParams', function () { return {}; })
  .provider('$state', $StateProvider);


$ViewProvider.$inject = [];
function $ViewProvider() {

  this.$get = $get;
  /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */
  $get.$inject = ['$rootScope', '$templateFactory'];
  function $get(   $rootScope,   $templateFactory) {
    return {
      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
      /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */
      load: function load(name, options) {
        var result, defaults = {
          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
        };
        options = extend(defaults, options);

        if (options.view) {
          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
        }
        return result;
      }
    };
  }
}

angular.module('ui.router.state').provider('$view', $ViewProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */
function $ViewScrollProvider() {

  var useAnchorScroll = false;

  /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */
  this.useAnchorScroll = function () {
    useAnchorScroll = true;
  };

  /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */
  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
    if (useAnchorScroll) {
      return $anchorScroll;
    }

    return function ($element) {
      return $timeout(function () {
        $element[0].scrollIntoView();
      }, 0, false);
    };
  }];
}

angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

var ngMajorVer = angular.version.major;
var ngMinorVer = angular.version.minor;
/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
 * will be applied to the ui-view)
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 * 
 * @example
 * A view can be unnamed or named. 
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div> 
 * 
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a 
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div> 
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 * 
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 * 
 * But typically you'll only use the views property if you name your view or have more than one view 
 * in the same template. There's not really a compelling reason to name a view if its the only one, 
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre> 
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 * 
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div> 
 * <div ui-view="data"></div> 
 * </pre>
 * 
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 */
$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {

  function getService() {
    return ($injector.has) ? function(service) {
      return $injector.has(service) ? $injector.get(service) : null;
    } : function(service) {
      try {
        return $injector.get(service);
      } catch (e) {
        return null;
      }
    };
  }

  var service = getService(),
      $animator = service('$animator'),
      $animate = service('$animate');

  // Returns a set of DOM manipulation functions based on which Angular version
  // it should use
  function getRenderer(attrs, scope) {
    var statics = {
      enter: function (element, target, cb) { target.after(element); cb(); },
      leave: function (element, cb) { element.remove(); cb(); }
    };

    if (!!attrs.noanimation) return statics;

    function animEnabled(element) {
      if (ngMajorVer === 1 && ngMinorVer >= 4) return !!$animate.enabled(element);
      if (ngMajorVer === 1 && ngMinorVer >= 2) return !!$animate.enabled();
      return (!!$animator);
    }

    // ng 1.2+
    if ($animate) {
      return {
        enter: function(element, target, cb) {
          if (!animEnabled(element)) {
            statics.enter(element, target, cb);
          } else if (angular.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function(element, cb) {
          if (!animEnabled(element)) {
            statics.leave(element, cb);
          } else if (angular.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }

    // ng 1.1.5
    if ($animator) {
      var animate = $animator && $animator(scope, attrs);

      return {
        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
        leave: function(element, cb) { animate.leave(element); cb(); }
      };
    }

    return statics;
  }

  var directive = {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    compile: function (tElement, tAttrs, $transclude) {
      return function (scope, $element, attrs) {
        var previousEl, currentEl, currentScope, latestLocals,
            onloadExp     = attrs.onload || '',
            autoScrollExp = attrs.autoscroll,
            renderer      = getRenderer(attrs, scope);

        scope.$on('$stateChangeSuccess', function() {
          updateView(false);
        });

        updateView(true);

        function cleanupLastView() {
          var _previousEl = previousEl;
          var _currentScope = currentScope;

          if (_currentScope) {
            _currentScope._willBeDestroyed = true;
          }

          function cleanOld() {
            if (_previousEl) {
              _previousEl.remove();
            }

            if (_currentScope) {
              _currentScope.$destroy();
            }
          }

          if (currentEl) {
            renderer.leave(currentEl, function() {
              cleanOld();
              previousEl = null;
            });

            previousEl = currentEl;
          } else {
            cleanOld();
            previousEl = null;
          }

          currentEl = null;
          currentScope = null;
        }

        function updateView(firstTime) {
          var newScope,
              name            = getUiViewName(scope, attrs, $element, $interpolate),
              previousLocals  = name && $state.$current && $state.$current.locals[name];

          if (!firstTime && previousLocals === latestLocals || scope._willBeDestroyed) return; // nothing to do
          newScope = scope.$new();
          latestLocals = $state.$current.locals[name];

          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          newScope.$emit('$viewContentLoading', name);

          var clone = $transclude(newScope, function(clone) {
            renderer.enter(clone, $element, function onUiViewEnter() {
              if(currentScope) {
                currentScope.$emit('$viewContentAnimationEnded');
              }

              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                $uiViewScroll(clone);
              }
            });
            cleanupLastView();
          });

          currentEl = clone;
          currentScope = newScope;
          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          currentScope.$emit('$viewContentLoaded', name);
          currentScope.$eval(onloadExp);
        }
      };
    }
  };

  return directive;
}

$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
  return {
    restrict: 'ECA',
    priority: -400,
    compile: function (tElement) {
      var initial = tElement.html();
      return function (scope, $element, attrs) {
        var current = $state.$current,
            name = getUiViewName(scope, attrs, $element, $interpolate),
            locals  = current && current.locals[name];

        if (! locals) {
          return;
        }

        $element.data('$uiView', { name: name, state: locals.$$state });
        $element.html(locals.$template ? locals.$template : initial);

        var link = $compile($element.contents());

        if (locals.$$controller) {
          locals.$scope = scope;
          locals.$element = $element;
          var controller = $controller(locals.$$controller, locals);
          if (locals.$$controllerAs) {
            scope[locals.$$controllerAs] = controller;
          }
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }

        link(scope);
      };
    }
  };
}

/**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */
function getUiViewName(scope, attrs, element, $interpolate) {
  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
  var inherited = element.inheritedData('$uiView');
  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
}

angular.module('ui.router.state').directive('uiView', $ViewDirective);
angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

function parseStateRef(ref, current) {
  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
  if (preparsed) ref = current + '(' + preparsed[1] + ')';
  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
  return { state: parsed[1], paramExpr: parsed[3] || null };
}

function stateContext(el) {
  var stateData = el.parent().inheritedData('$uiView');

  if (stateData && stateData.state && stateData.state.name) {
    return stateData.state;
  }
}

function getTypeInfo(el) {
  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
  var isForm = el[0].nodeName === "FORM";

  return {
    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
    isAnchor: el.prop("tagName").toUpperCase() === "A",
    clickable: !isForm
  };
}

function clickHook(el, $state, $timeout, type, current) {
  return function(e) {
    var button = e.which || e.button, target = current();

    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
      var transition = $timeout(function() {
        $state.go(target.state, target.params, target.options);
      });
      e.preventDefault();

      // if the state has no URL, ignore one preventDefault from the <a> directive.
      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;

      e.preventDefault = function() {
        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
      };
    }
  };
}

function defaultOpts(el, $state) {
  return { relative: stateContext(el) || $state.$current, inherit: true };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
 */
$StateRefDirective.$inject = ['$state', '$timeout'];
function $StateRefDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
      var def    = { state: ref.state, href: null, params: null };
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];

      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});

      var update = function(val) {
        if (val) def.params = angular.copy(val);
        def.href = $state.href(ref.state, def.params, def.options);

        if (active) active.$$addStateInfo(ref.state, def.params);
        if (def.href !== null) attrs.$set(type.attr, def.href);
      };

      if (ref.paramExpr) {
        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
        def.params = angular.copy(scope.$eval(ref.paramExpr));
      }
      update();

      if (!type.clickable) return;
      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
    }
  };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
 */
$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
function $StateRefDynamicDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
      var def    = { state: null, params: null, options: null, href: null };

      function runStateRefLink (group) {
        def.state = group[0]; def.params = group[1]; def.options = group[2];
        def.href = $state.href(def.state, def.params, def.options);

        if (active) active.$$addStateInfo(def.state, def.params);
        if (def.href) attrs.$set(type.attr, def.href);
      }

      scope.$watch(watch, runStateRefLink, true);
      runStateRefLink(scope.$eval(watch));

      if (!type.clickable) return;
      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
    }
  };
}


/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */
$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
function $StateRefActiveDirective($state, $stateParams, $interpolate) {
  return  {
    restrict: "A",
    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;

      // There probably isn't much point in $observing this
      // uiSrefActive and uiSrefActiveEq share the same directive object with some
      // slight difference in logic routing
      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);

      try {
        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
      } catch (e) {
        // Do nothing. uiSrefActive is not a valid expression.
        // Fall back to using $interpolate below
      }
      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
      if (isObject(uiSrefActive)) {
        forEach(uiSrefActive, function(stateOrName, activeClass) {
          if (isString(stateOrName)) {
            var ref = parseStateRef(stateOrName, $state.current.name);
            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
          }
        });
      }

      // Allow uiSref to communicate with uiSrefActive[Equals]
      this.$$addStateInfo = function (newState, newParams) {
        // we already got an explicit state provided by ui-sref-active, so we
        // shadow the one that comes from ui-sref
        if (isObject(uiSrefActive) && states.length > 0) {
          return;
        }
        addState(newState, newParams, uiSrefActive);
        update();
      };

      $scope.$on('$stateChangeSuccess', update);

      function addState(stateName, stateParams, activeClass) {
        var state = $state.get(stateName, stateContext($element));
        var stateHash = createStateHash(stateName, stateParams);

        states.push({
          state: state || { name: stateName },
          params: stateParams,
          hash: stateHash
        });

        activeClasses[stateHash] = activeClass;
      }

      /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */
      function createStateHash(state, params) {
        if (!isString(state)) {
          throw new Error('state should be a string');
        }
        if (isObject(params)) {
          return state + toJson(params);
        }
        params = $scope.$eval(params);
        if (isObject(params)) {
          return state + toJson(params);
        }
        return state;
      }

      // Update route state
      function update() {
        for (var i = 0; i < states.length; i++) {
          if (anyMatch(states[i].state, states[i].params)) {
            addClass($element, activeClasses[states[i].hash]);
          } else {
            removeClass($element, activeClasses[states[i].hash]);
          }

          if (exactMatch(states[i].state, states[i].params)) {
            addClass($element, activeEqClass);
          } else {
            removeClass($element, activeEqClass);
          }
        }
      }

      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
      function removeClass(el, className) { el.removeClass(className); }
      function anyMatch(state, params) { return $state.includes(state.name, params); }
      function exactMatch(state, params) { return $state.is(state.name, params); }

      update();
    }]
  };
}

angular.module('ui.router.state')
  .directive('uiSref', $StateRefDirective)
  .directive('uiSrefActive', $StateRefActiveDirective)
  .directive('uiSrefActiveEq', $StateRefActiveDirective)
  .directive('uiState', $StateRefDynamicDirective);

/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
  var isFilter = function (state, params) {
    return $state.is(state, params);
  };
  isFilter.$stateful = true;
  return isFilter;
}

/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
  var includesFilter = function (state, params, options) {
    return $state.includes(state, params, options);
  };
  includesFilter.$stateful = true;
  return  includesFilter;
}

angular.module('ui.router.state')
  .filter('isState', $IsStateFilter)
  .filter('includedByState', $IncludedByStateFilter);
})(window, window.angular);
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

'use strict';

angular.module('autofill-directive', [])
	.directive('autofill', function() {
		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				scope.$on('autofill-submit', function(e) {
					ngModel.$setViewValue(element.val());
				});
			}
		}
	})
	
	.directive('autofillSubmit', ['$parse', function($parse) {
		return {
			link: function (scope, element) {
				var fn = $parse(element.attr('autofill-submit'));
				element.on('submit', function(event) {
					scope.$broadcast('autofill-submit');
					scope.$apply(function() {
						fn(scope, {$event:event});
					});
				});
			}
		}
	}]);
/*! ngTable v0.4.3 by Vitalii Savchuk(esvit666@gmail.com) - https://github.com/esvit/ng-table - New BSD License */

!function(a,b){"use strict";return"function"==typeof define&&define.amd?void define(["angular"],function(a){return b(a)}):b(a)}(angular||null,function(a){"use strict";var b=a.module("ngTable",[]);b.value("ngTableDefaults",{params:{},settings:{}}),b.factory("ngTableParams",["$q","$log","ngTableDefaults",function(b,c,d){var e=function(a){return!isNaN(parseFloat(a))&&isFinite(a)},f=function(f,g){var h=this,i=function(){k.debugMode&&c.debug&&c.debug.apply(this,arguments)};this.data=[],this.parameters=function(b,c){if(c=c||!1,a.isDefined(b)){for(var d in b){var f=b[d];if(c&&d.indexOf("[")>=0){for(var g=d.split(/\[(.*)\]/).reverse(),h="",k=0,l=g.length;l>k;k++){var m=g[k];if(""!==m){var n=f;f={},f[h=m]=e(n)?parseFloat(n):n}}"sorting"===h&&(j[h]={}),j[h]=a.extend(j[h]||{},f[h])}else j[d]=e(b[d])?parseFloat(b[d]):b[d]}return i("ngTable: set parameters",j),this}return j},this.settings=function(b){return a.isDefined(b)?(a.isArray(b.data)&&(b.total=b.data.length),k=a.extend(k,b),i("ngTable: set settings",k),this):k},this.page=function(b){return a.isDefined(b)?this.parameters({page:b}):j.page},this.total=function(b){return a.isDefined(b)?this.settings({total:b}):k.total},this.count=function(b){return a.isDefined(b)?this.parameters({count:b,page:1}):j.count},this.filter=function(b){return a.isDefined(b)?this.parameters({filter:b,page:1}):j.filter},this.sorting=function(b){if(2==arguments.length){var c={};return c[b]=arguments[1],this.parameters({sorting:c}),this}return a.isDefined(b)?this.parameters({sorting:b}):j.sorting},this.isSortBy=function(b,c){return a.isDefined(j.sorting[b])&&a.equals(j.sorting[b],c)},this.orderBy=function(){var a=[];for(var b in j.sorting)a.push(("asc"===j.sorting[b]?"+":"-")+b);return a},this.getData=function(b,c){return b.resolve(a.isArray(this.data)&&a.isObject(c)?this.data.slice((c.page()-1)*c.count(),c.page()*c.count()):[]),b.promise},this.getGroups=function(c,d){var e=b.defer();return e.promise.then(function(b){var e={};a.forEach(b,function(b){var c=a.isFunction(d)?d(b):b[d];e[c]=e[c]||{data:[]},e[c].value=c,e[c].data.push(b)});var f=[];for(var g in e)f.push(e[g]);i("ngTable: refresh groups",f),c.resolve(f)}),this.getData(e,h)},this.generatePagesArray=function(a,b,c){var d,e,f,g,h,i;if(d=11,i=[],h=Math.ceil(b/c),h>1){i.push({type:"prev",number:Math.max(1,a-1),active:a>1}),i.push({type:"first",number:1,active:a>1,current:1===a}),f=Math.round((d-5)/2),g=Math.max(2,a-f),e=Math.min(h-1,a+2*f-(a-g)),g=Math.max(2,g-(2*f-(e-g)));for(var j=g;e>=j;)i.push(j===g&&2!==j||j===e&&j!==h-1?{type:"more",active:!1}:{type:"page",number:j,active:a!==j,current:a===j}),j++;i.push({type:"last",number:h,active:a!==h,current:a===h}),i.push({type:"next",number:Math.min(h,a+1),active:h>a})}return i},this.url=function(b){b=b||!1;var c=b?[]:{};for(var d in j)if(j.hasOwnProperty(d)){var e=j[d],f=encodeURIComponent(d);if("object"==typeof e){for(var g in e)if(!a.isUndefined(e[g])&&""!==e[g]){var h=f+"["+encodeURIComponent(g)+"]";b?c.push(h+"="+e[g]):c[h]=e[g]}}else a.isFunction(e)||a.isUndefined(e)||""===e||(b?c.push(f+"="+encodeURIComponent(e)):c[f]=encodeURIComponent(e))}return c},this.reload=function(){var a=b.defer(),c=this,d=null;if(k.$scope)return k.$loading=!0,d=k.groupBy?k.getGroups(a,k.groupBy,this):k.getData(a,this),i("ngTable: reload data"),d||(d=a.promise),d.then(function(a){return k.$loading=!1,i("ngTable: current scope",k.$scope),k.groupBy?(c.data=a,k.$scope&&(k.$scope.$groups=a)):(c.data=a,k.$scope&&(k.$scope.$data=a)),k.$scope&&(k.$scope.pages=c.generatePagesArray(c.page(),c.total(),c.count())),k.$scope.$emit("ngTableAfterReloadData"),a})},this.reloadPages=function(){var a=this;k.$scope.pages=a.generatePagesArray(a.page(),a.total(),a.count())};var j=this.$params={page:1,count:1,filter:{},sorting:{},group:{},groupBy:null};a.extend(j,d.params);var k={$scope:null,$loading:!1,data:null,total:0,defaultSort:"desc",filterDelay:750,counts:[10,25,50,100],getGroups:this.getGroups,getData:this.getData};return a.extend(k,d.settings),this.settings(g),this.parameters(f,!0),this};return f}]);var c=["$scope","ngTableParams","$timeout",function(b,c,d){function e(){b.params.$params.page=1}var f=!0;b.$loading=!1,b.hasOwnProperty("params")||(b.params=new c,b.params.isNullInstance=!0),b.params.settings().$scope=b;var g=function(){var a=0;return function(b,c){d.cancel(a),a=d(b,c)}}();b.$watch("params.$params",function(c,d){if(c!==d){if(b.params.settings().$scope=b,a.equals(c.filter,d.filter))b.params.reload();else{var h=f?a.noop:e;g(function(){h(),b.params.reload()},b.params.settings().filterDelay)}b.params.isNullInstance||(f=!1)}},!0),b.sortBy=function(a,c){var d=b.parse(a.sortable);if(d){var e=b.params.settings().defaultSort,f="asc"===e?"desc":"asc",g=b.params.sorting()&&b.params.sorting()[d]&&b.params.sorting()[d]===e,h=c.ctrlKey||c.metaKey?b.params.sorting():{};h[d]=g?f:e,b.params.parameters({sorting:h})}}}];return b.directive("ngTable",["$compile","$q","$parse",function(b,d,e){return{restrict:"A",priority:1001,scope:!0,controller:c,compile:function(c){var d=[],f=0,g=null,h=c.find("thead");return a.forEach(a.element(c.find("tr")),function(b){b=a.element(b),b.hasClass("ng-table-group")||g||(g=b)}),g?(a.forEach(g.find("td"),function(b){var c=a.element(b);if(!c.attr("ignore-cell")||"true"!==c.attr("ignore-cell")){var g=function(a,b){return function(f){return e(c.attr("x-data-"+a)||c.attr("data-"+a)||c.attr(a))(f,{$columns:d})||b}},h=g("title"," "),i=g("header",!1),j=g("filter",!1)(),k=!1,l=!1;j&&j.$$name&&(l=j.$$name,delete j.$$name),j&&j.templateURL&&(k=j.templateURL,delete j.templateURL),c.attr("data-title-text",h()),d.push({id:f++,title:h,sortable:g("sortable",!1),"class":c.attr("x-data-header-class")||c.attr("data-header-class")||c.attr("header-class"),filter:j,filterTemplateURL:k,filterName:l,headerTemplateURL:i,filterData:c.attr("filter-data")?c.attr("filter-data"):null,show:c.attr("ng-show")?function(a){return e(c.attr("ng-show"))(a)}:function(){return!0}})}}),function(c,f,g){if(c.$loading=!1,c.$columns=d,c.$filterRow={},c.$watch(g.ngTable,function(b){a.isUndefined(b)||(c.paramsModel=e(g.ngTable),c.params=b)},!0),c.parse=function(b){return a.isDefined(b)?b(c):""},g.showFilter&&c.$parent.$watch(g.showFilter,function(a){c.show_filter=a}),g.disableFilter&&c.$parent.$watch(g.disableFilter,function(a){c.$filterRow.disabled=a}),a.forEach(d,function(b){var d;if(b.filterData)return d=e(b.filterData)(c,{$column:b}),a.isObject(d)&&a.isObject(d.promise)?(delete b.filterData,d.promise.then(function(c){a.isArray(c)||a.isFunction(c)||a.isObject(c)?a.isArray(c)&&c.unshift({title:"-",id:""}):c=[],b.data=c})):b.data=d}),!f.hasClass("ng-table")){c.templates={header:g.templateHeader?g.templateHeader:"ng-table/header.html",pagination:g.templatePagination?g.templatePagination:"ng-table/pager.html"};var i=h.length>0?h:a.element(document.createElement("thead")).attr("ng-include","templates.header"),j=a.element(document.createElement("div")).attr({"ng-table-pagination":"params","template-url":"templates.pagination"});f.find("thead").remove(),f.addClass("ng-table").prepend(i).after(j),b(i)(c),b(j)(c)}}):void 0}}}]),b.directive("ngTablePagination",["$compile",function(b){return{restrict:"A",scope:{params:"=ngTablePagination",templateUrl:"="},replace:!1,link:function(c,d){c.params.settings().$scope.$on("ngTableAfterReloadData",function(){c.pages=c.params.generatePagesArray(c.params.page(),c.params.total(),c.params.count())},!0),c.$watch("templateUrl",function(e){if(!a.isUndefined(e)){var f=a.element(document.createElement("div"));f.attr({"ng-include":"templateUrl"}),d.append(f),b(f)(c)}})}}}]),a.module("ngTable").run(["$templateCache",function(a){a.put("ng-table/filters/select-multiple.html",'<select ng-options="data.id as data.title for data in column.data" ng-disabled="$filterRow.disabled" multiple ng-multiple="true" ng-model="params.filter()[name]" ng-show="filter==\'select-multiple\'" class="filter filter-select-multiple form-control" name="{{column.filterName}}"> </select>'),a.put("ng-table/filters/select.html",'<select ng-options="data.id as data.title for data in column.data" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" ng-show="filter==\'select\'" class="filter filter-select form-control" name="{{column.filterName}}"> </select>'),a.put("ng-table/filters/text.html",'<input type="text" name="{{column.filterName}}" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" ng-if="filter==\'text\'" class="input-filter form-control"/>'),a.put("ng-table/header.html",'<tr> <th ng-repeat="column in $columns" ng-class="{ \'sortable\': parse(column.sortable), \'sort-asc\': params.sorting()[parse(column.sortable)]==\'asc\', \'sort-desc\': params.sorting()[parse(column.sortable)]==\'desc\' }" ng-click="sortBy(column, $event)" ng-show="column.show(this)" ng-init="template=column.headerTemplateURL(this)" class="header {{column.class}}"> <div ng-if="!template" ng-show="!template" ng-bind="parse(column.title)"></div> <div ng-if="template" ng-show="template" ng-include="template"></div> </th> </tr> <tr ng-show="show_filter" class="ng-table-filters"> <th ng-repeat="column in $columns" ng-show="column.show(this)" class="filter"> <div ng-repeat="(name, filter) in column.filter"> <div ng-if="column.filterTemplateURL" ng-show="column.filterTemplateURL"> <div ng-include="column.filterTemplateURL"></div> </div> <div ng-if="!column.filterTemplateURL" ng-show="!column.filterTemplateURL"> <div ng-include="\'ng-table/filters/\' + filter + \'.html\'"></div> </div> </div> </th> </tr> '),a.put("ng-table/pager.html",'<div class="ng-cloak ng-table-pager"> <div ng-if="params.settings().counts.length" class="ng-table-counts btn-group pull-right"> <button ng-repeat="count in params.settings().counts" type="button" ng-class="{\'active\':params.count()==count}" ng-click="params.count(count)" class="btn btn-default"> <span ng-bind="count"></span> </button> </div> <ul class="pagination ng-table-pagination"> <li ng-class="{\'disabled\': !page.active && !page.current, \'active\': page.current}" ng-repeat="page in pages" ng-switch="page.type"> <a ng-switch-when="prev" ng-click="params.page(page.number)" href="">&laquo;</a> <a ng-switch-when="first" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="page" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="more" ng-click="params.page(page.number)" href="">&#8230;</a> <a ng-switch-when="last" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="next" ng-click="params.page(page.number)" href="">&raquo;</a> </li> </ul> </div> ')}]),b});
//# sourceMappingURL=./dist/ng-table.min.js.map
/**
 * Copyright (c) 2011-2014 Felix Gnass
 * Licensed under the MIT license
 */
(function(root, factory) {

  /* CommonJS */
  if (typeof exports == 'object')  module.exports = factory()

  /* AMD module */
  else if (typeof define == 'function' && define.amd) define(factory)

  /* Browser global */
  else root.Spinner = factory()
}
(this, function() {
  "use strict";

  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
    , animations = {} /* Animation rules keyed by their name */
    , useCssAnimations /* Whether to use CSS animations or setTimeout */

  /**
   * Utility function to create elements. If no tag name is given,
   * a DIV is created. Optionally properties can be passed.
   */
  function createEl(tag, prop) {
    var el = document.createElement(tag || 'div')
      , n

    for(n in prop) el[n] = prop[n]
    return el
  }

  /**
   * Appends children and returns the parent.
   */
  function ins(parent /* child1, child2, ...*/) {
    for (var i=1, n=arguments.length; i<n; i++)
      parent.appendChild(arguments[i])

    return parent
  }

  /**
   * Insert a new stylesheet to hold the @keyframe or VML rules.
   */
  var sheet = (function() {
    var el = createEl('style', {type : 'text/css'})
    ins(document.getElementsByTagName('head')[0], el)
    return el.sheet || el.styleSheet
  }())

  /**
   * Creates an opacity keyframe animation rule and returns its name.
   * Since most mobile Webkits have timing issues with animation-delay,
   * we create separate rules for each line/segment.
   */
  function addAnimation(alpha, trail, i, lines) {
    var name = ['opacity', trail, ~~(alpha*100), i, lines].join('-')
      , start = 0.01 + i/lines * 100
      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
      , pre = prefix && '-' + prefix + '-' || ''

    if (!animations[name]) {
      sheet.insertRule(
        '@' + pre + 'keyframes ' + name + '{' +
        '0%{opacity:' + z + '}' +
        start + '%{opacity:' + alpha + '}' +
        (start+0.01) + '%{opacity:1}' +
        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
        '100%{opacity:' + z + '}' +
        '}', sheet.cssRules.length)

      animations[name] = 1
    }

    return name
  }

  /**
   * Tries various vendor prefixes and returns the first supported property.
   */
  function vendor(el, prop) {
    var s = el.style
      , pp
      , i

    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
    for(i=0; i<prefixes.length; i++) {
      pp = prefixes[i]+prop
      if(s[pp] !== undefined) return pp
    }
    if(s[prop] !== undefined) return prop
  }

  /**
   * Sets multiple style properties at once.
   */
  function css(el, prop) {
    for (var n in prop)
      el.style[vendor(el, n)||n] = prop[n]

    return el
  }

  /**
   * Fills in default values.
   */
  function merge(obj) {
    for (var i=1; i < arguments.length; i++) {
      var def = arguments[i]
      for (var n in def)
        if (obj[n] === undefined) obj[n] = def[n]
    }
    return obj
  }

  /**
   * Returns the line color from the given string or array.
   */
  function getColor(color, idx) {
    return typeof color == 'string' ? color : color[idx % color.length]
  }

  // Built-in defaults

  var defaults = {
    lines: 12,            // The number of lines to draw
    length: 7,            // The length of each line
    width: 5,             // The line thickness
    radius: 10,           // The radius of the inner circle
    rotate: 0,            // Rotation offset
    corners: 1,           // Roundness (0..1)
    color: '#000',        // #rgb or #rrggbb
    direction: 1,         // 1: clockwise, -1: counterclockwise
    speed: 1,             // Rounds per second
    trail: 100,           // Afterglow percentage
    opacity: 1/4,         // Opacity of the lines
    fps: 20,              // Frames per second when using setTimeout()
    zIndex: 2e9,          // Use a high z-index by default
    className: 'spinner', // CSS class to assign to the element
    top: '50%',           // center vertically
    left: '50%',          // center horizontally
    position: 'absolute'  // element position
  }

  /** The constructor */
  function Spinner(o) {
    this.opts = merge(o || {}, Spinner.defaults, defaults)
  }

  // Global defaults that override the built-ins:
  Spinner.defaults = {}

  merge(Spinner.prototype, {

    /**
     * Adds the spinner to the given target element. If this instance is already
     * spinning, it is automatically removed from its previous target b calling
     * stop() internally.
     */
    spin: function(target) {
      this.stop()

      var self = this
        , o = self.opts
        , el = self.el = css(createEl(0, {className: o.className}), {position: o.position, width: 0, zIndex: o.zIndex})

      css(el, {
        left: o.left,
        top: o.top
      })
        
      if (target) {
        target.insertBefore(el, target.firstChild||null)
      }

      el.setAttribute('role', 'progressbar')
      self.lines(el, self.opts)

      if (!useCssAnimations) {
        // No CSS animation support, use setTimeout() instead
        var i = 0
          , start = (o.lines - 1) * (1 - o.direction) / 2
          , alpha
          , fps = o.fps
          , f = fps/o.speed
          , ostep = (1-o.opacity) / (f*o.trail / 100)
          , astep = f/o.lines

        ;(function anim() {
          i++;
          for (var j = 0; j < o.lines; j++) {
            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)

            self.opacity(el, j * o.direction + start, alpha, o)
          }
          self.timeout = self.el && setTimeout(anim, ~~(1000/fps))
        })()
      }
      return self
    },

    /**
     * Stops and removes the Spinner.
     */
    stop: function() {
      var el = this.el
      if (el) {
        clearTimeout(this.timeout)
        if (el.parentNode) el.parentNode.removeChild(el)
        this.el = undefined
      }
      return this
    },

    /**
     * Internal method that draws the individual lines. Will be overwritten
     * in VML fallback mode below.
     */
    lines: function(el, o) {
      var i = 0
        , start = (o.lines - 1) * (1 - o.direction) / 2
        , seg

      function fill(color, shadow) {
        return css(createEl(), {
          position: 'absolute',
          width: (o.length+o.width) + 'px',
          height: o.width + 'px',
          background: color,
          boxShadow: shadow,
          transformOrigin: 'left',
          transform: 'rotate(' + ~~(360/o.lines*i+o.rotate) + 'deg) translate(' + o.radius+'px' +',0)',
          borderRadius: (o.corners * o.width>>1) + 'px'
        })
      }

      for (; i < o.lines; i++) {
        seg = css(createEl(), {
          position: 'absolute',
          top: 1+~(o.width/2) + 'px',
          transform: o.hwaccel ? 'translate3d(0,0,0)' : '',
          opacity: o.opacity,
          animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1/o.speed + 's linear infinite'
        })

        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px ' + '#000'), {top: 2+'px'}))
        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
      }
      return el
    },

    /**
     * Internal method that adjusts the opacity of a single line.
     * Will be overwritten in VML fallback mode below.
     */
    opacity: function(el, i, val) {
      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
    }

  })


  function initVML() {

    /* Utility function to create a VML tag */
    function vml(tag, attr) {
      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
    }

    // No CSS transforms but VML support, add a CSS rule for VML elements:
    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')

    Spinner.prototype.lines = function(el, o) {
      var r = o.length+o.width
        , s = 2*r

      function grp() {
        return css(
          vml('group', {
            coordsize: s + ' ' + s,
            coordorigin: -r + ' ' + -r
          }),
          { width: s, height: s }
        )
      }

      var margin = -(o.width+o.length)*2 + 'px'
        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
        , i

      function seg(i, dx, filter) {
        ins(g,
          ins(css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx}),
            ins(css(vml('roundrect', {arcsize: o.corners}), {
                width: r,
                height: o.width,
                left: o.radius,
                top: -o.width>>1,
                filter: filter
              }),
              vml('fill', {color: getColor(o.color, i), opacity: o.opacity}),
              vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
            )
          )
        )
      }

      if (o.shadow)
        for (i = 1; i <= o.lines; i++)
          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')

      for (i = 1; i <= o.lines; i++) seg(i)
      return ins(el, g)
    }

    Spinner.prototype.opacity = function(el, i, val, o) {
      var c = el.firstChild
      o = o.shadow && o.lines || 0
      if (c && i+o < c.childNodes.length) {
        c = c.childNodes[i+o]; c = c && c.firstChild; c = c && c.firstChild
        if (c) c.opacity = val
      }
    }
  }

  var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})

  if (!vendor(probe, 'transform') && probe.adj) initVML()
  else useCssAnimations = vendor(probe, 'animation')

  return Spinner

}));

!function(a){"use strict";function b(a,b){a.module("angularSpinner",[]).factory("usSpinnerService",["$rootScope",function(a){var b={};return b.spin=function(b){a.$broadcast("us-spinner:spin",b)},b.stop=function(b){a.$broadcast("us-spinner:stop",b)},b}]).directive("usSpinner",["$window",function(c){return{scope:!0,link:function(d,e,f){function g(){d.spinner&&d.spinner.stop()}var h=b||c.Spinner;d.spinner=null,d.key=a.isDefined(f.spinnerKey)?f.spinnerKey:!1,d.startActive=a.isDefined(f.spinnerStartActive)?f.spinnerStartActive:d.key?!1:!0,d.spin=function(){d.spinner&&d.spinner.spin(e[0])},d.stop=function(){d.startActive=!1,g()},d.$watch(f.usSpinner,function(a){g(),d.spinner=new h(a),(!d.key||d.startActive)&&d.spinner.spin(e[0])},!0),d.$on("us-spinner:spin",function(a,b){b===d.key&&d.spin()}),d.$on("us-spinner:stop",function(a,b){b===d.key&&d.stop()}),d.$on("$destroy",function(){d.stop(),d.spinner=null})}}}])}"function"==typeof define&&define.amd?define(["angular","spin"],b):b(a.angular)}(window);
//# sourceMappingURL=angular-spinner.min.js.map
/*!
 * Ladda
 * http://lab.hakim.se/ladda
 * MIT licensed
 *
 * Copyright (C) 2015 Hakim El Hattab, http://hakim.se
 */
/* jshint node:true, browser:true */
(function( root, factory ) {

	// CommonJS
	if( typeof exports === 'object' )  {
		module.exports = factory(require('spin.js'));
	}
	// AMD module
	else if( typeof define === 'function' && define.amd ) {
		define( [ 'spin' ], factory );
	}
	// Browser global
	else {
		root.Ladda = factory( root.Spinner );
	}

}
(this, function( Spinner ) {
	'use strict';

	// All currently instantiated instances of Ladda
	var ALL_INSTANCES = [];

	/**
	 * Creates a new instance of Ladda which wraps the
	 * target button element.
	 *
	 * @return An API object that can be used to control
	 * the loading animation state.
	 */
	function create( button ) {

		if( typeof button === 'undefined' ) {
			console.warn( "Ladda button target must be defined." );
			return;
		}

		// The text contents must be wrapped in a ladda-label
		// element, create one if it doesn't already exist
		if( !button.querySelector( '.ladda-label' ) ) {
			button.innerHTML = '<span class="ladda-label">'+ button.innerHTML +'</span>';
		}

		// The spinner component
		var spinner,
			spinnerWrapper = button.querySelector( '.ladda-spinner' );

		// Wrapper element for the spinner
		if( !spinnerWrapper ) {
			spinnerWrapper = document.createElement( 'span' );
			spinnerWrapper.className = 'ladda-spinner';
		}

		button.appendChild( spinnerWrapper );

		// Timer used to delay starting/stopping
		var timer;

		var instance = {

			/**
			 * Enter the loading state.
			 */
			start: function() {

				// Create the spinner if it doesn't already exist
				if( !spinner ) spinner = createSpinner( button );

				button.setAttribute( 'disabled', '' );
				button.setAttribute( 'data-loading', '' );

				clearTimeout( timer );
				spinner.spin( spinnerWrapper );

				this.setProgress( 0 );

				return this; // chain

			},

			/**
			 * Enter the loading state, after a delay.
			 */
			startAfter: function( delay ) {

				clearTimeout( timer );
				timer = setTimeout( function() { instance.start(); }, delay );

				return this; // chain

			},

			/**
			 * Exit the loading state.
			 */
			stop: function() {

				button.removeAttribute( 'disabled' );
				button.removeAttribute( 'data-loading' );

				// Kill the animation after a delay to make sure it
				// runs for the duration of the button transition
				clearTimeout( timer );

				if( spinner ) {
					timer = setTimeout( function() { spinner.stop(); }, 1000 );
				}

				return this; // chain

			},

			/**
			 * Toggle the loading state on/off.
			 */
			toggle: function() {

				if( this.isLoading() ) {
					this.stop();
				}
				else {
					this.start();
				}

				return this; // chain

			},

			/**
			 * Sets the width of the visual progress bar inside of
			 * this Ladda button
			 *
			 * @param {Number} progress in the range of 0-1
			 */
			setProgress: function( progress ) {

				// Cap it
				progress = Math.max( Math.min( progress, 1 ), 0 );

				var progressElement = button.querySelector( '.ladda-progress' );

				// Remove the progress bar if we're at 0 progress
				if( progress === 0 && progressElement && progressElement.parentNode ) {
					progressElement.parentNode.removeChild( progressElement );
				}
				else {
					if( !progressElement ) {
						progressElement = document.createElement( 'div' );
						progressElement.className = 'ladda-progress';
						button.appendChild( progressElement );
					}

					progressElement.style.width = ( ( progress || 0 ) * button.offsetWidth ) + 'px';
				}

			},

			enable: function() {

				this.stop();

				return this; // chain

			},

			disable: function () {

				this.stop();
				button.setAttribute( 'disabled', '' );

				return this; // chain

			},

			isLoading: function() {

				return button.hasAttribute( 'data-loading' );

			},

			remove: function() {

				clearTimeout( timer );

				button.removeAttribute( 'disabled', '' );
				button.removeAttribute( 'data-loading', '' );

				if( spinner ) {
					spinner.stop();
					spinner = null;
				}

				for( var i = 0, len = ALL_INSTANCES.length; i < len; i++ ) {
					if( instance === ALL_INSTANCES[i] ) {
						ALL_INSTANCES.splice( i, 1 );
						break;
					}
				}

			}

		};

		ALL_INSTANCES.push( instance );

		return instance;

	}

	/**
	* Get the first ancestor node from an element, having a
	* certain type.
	*
	* @param elem An HTML element
	* @param type an HTML tag type (uppercased)
	*
	* @return An HTML element
	*/
	function getAncestorOfTagType( elem, type ) {

		while ( elem.parentNode && elem.tagName !== type ) {
			elem = elem.parentNode;
		}

		return ( type === elem.tagName ) ? elem : undefined;

	}

	/**
	 * Returns a list of all inputs in the given form that
	 * have their `required` attribute set.
	 *
	 * @param form The from HTML element to look in
	 *
	 * @return A list of elements
	 */
	function getRequiredFields( form ) {

		var requirables = [ 'input', 'textarea', 'select' ];
		var inputs = [];

		for( var i = 0; i < requirables.length; i++ ) {
			var candidates = form.getElementsByTagName( requirables[i] );
			for( var j = 0; j < candidates.length; j++ ) {
				if ( candidates[j].hasAttribute( 'required' ) ) {
					inputs.push( candidates[j] );
				}
			}
		}

		return inputs;

	}


	/**
	 * Binds the target buttons to automatically enter the
	 * loading state when clicked.
	 *
	 * @param target Either an HTML element or a CSS selector.
	 * @param options
	 *          - timeout Number of milliseconds to wait before
	 *            automatically cancelling the animation.
	 */
	function bind( target, options ) {

		options = options || {};

		var targets = [];

		if( typeof target === 'string' ) {
			targets = toArray( document.querySelectorAll( target ) );
		}
		else if( typeof target === 'object' && typeof target.nodeName === 'string' ) {
			targets = [ target ];
		}

		for( var i = 0, len = targets.length; i < len; i++ ) {

			(function() {
				var element = targets[i];

				// Make sure we're working with a DOM element
				if( typeof element.addEventListener === 'function' ) {
					var instance = create( element );
					var timeout = -1;

					element.addEventListener( 'click', function( event ) {

						// If the button belongs to a form, make sure all the
						// fields in that form are filled out
						var valid = true;
						var form = getAncestorOfTagType( element, 'FORM' );

						if( typeof form !== 'undefined' ) {
							var requireds = getRequiredFields( form );
							for( var i = 0; i < requireds.length; i++ ) {

								// Alternatively to this trim() check,
								// we could have use .checkValidity() or .validity.valid
								if( requireds[i].value.replace( /^\s+|\s+$/g, '' ) === '' ) {
									valid = false;
								}

								// Radiobuttons and Checkboxes need to be checked for the "checked" attribute
								if( (requireds[i].type === 'checkbox' || requireds[i].type === 'radio' ) && !requireds[i].checked ) {
									valid = false;
								}

								// Email field validation, otherwise button starts spinning although field is not complete
								if( requireds[i].type === 'email' ) {
									valid = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test( requireds[i].value );
								}

							}
						}

						if( valid ) {
							// This is asynchronous to avoid an issue where setting
							// the disabled attribute on the button prevents forms
							// from submitting
							instance.startAfter( 1 );

							// Set a loading timeout if one is specified
							if( typeof options.timeout === 'number' ) {
								clearTimeout( timeout );
								timeout = setTimeout( instance.stop, options.timeout );
							}

							// Invoke callbacks
							if( typeof options.callback === 'function' ) {
								options.callback.apply( null, [ instance ] );
							}
						}

					}, false );
				}
			})();

		}

	}

	/**
	 * Stops ALL current loading animations.
	 */
	function stopAll() {

		for( var i = 0, len = ALL_INSTANCES.length; i < len; i++ ) {
			ALL_INSTANCES[i].stop();
		}

	}

	function createSpinner( button ) {

		var height = button.offsetHeight,
			spinnerColor;

		if( height === 0 ) {
			// We may have an element that is not visible so
			// we attempt to get the height in a different way
			height = parseFloat( window.getComputedStyle( button ).height );
		}

		// If the button is tall we can afford some padding
		if( height > 32 ) {
			height *= 0.8;
		}

		// Prefer an explicit height if one is defined
		if( button.hasAttribute( 'data-spinner-size' ) ) {
			height = parseInt( button.getAttribute( 'data-spinner-size' ), 10 );
		}

		// Allow buttons to specify the color of the spinner element
		if( button.hasAttribute( 'data-spinner-color' ) ) {
			spinnerColor = button.getAttribute( 'data-spinner-color' );
		}

		var lines = 12,
			radius = height * 0.2,
			length = radius * 0.6,
			width = radius < 7 ? 2 : 3;

		return new Spinner( {
			color: spinnerColor || '#fff',
			lines: lines,
			radius: radius,
			length: length,
			width: width,
			zIndex: 'auto',
			top: 'auto',
			left: 'auto',
			className: ''
		} );

	}

	function toArray( nodes ) {

		var a = [];

		for ( var i = 0; i < nodes.length; i++ ) {
			a.push( nodes[ i ] );
		}

		return a;

	}

	// Public API
	return {

		bind: bind,
		create: create,
		stopAll: stopAll

	};

}));

/*! angular-ladda 0.1.8 */
!function(){"use strict";angular.module("angular-ladda",[]).directive("ladda",["$compile","$timeout",function(a,b){return{restrict:"A",link:function(c,d,e){b(function(){d.addClass("ladda-button"),angular.isUndefined(d.attr("data-style"))&&d.attr("data-style","zoom-in");var b=Ladda.create(d[0]);a(angular.element(d.children()[0]).contents())(c),c.$watch(e.ladda,function(a){a||angular.isNumber(a)?(b.isLoading()||b.start(),angular.isNumber(a)&&b.setProgress(a)):(b.stop(),e.ngDisabled&&d.attr("disabled",c.$eval(e.ngDisabled)))})},0)}}}])}();
/*! Raygun4js - v2.7.1 - 2017-07-21
* https://github.com/MindscapeHQ/raygun4js
* Copyright (c) 2017 MindscapeHQ; Licensed MIT */

!function(a,b){function c(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function d(a){return"undefined"==typeof a}var e,f={},g=a.TraceKit,h=[].slice,i="?";f.setRaygun=function(a){e||(e=a)},f.noConflict=function(){return a.TraceKit=g,f},f.wrap=function(a){function b(){try{return a.apply(this,arguments)}catch(b){throw f.report(b),b}}return b},f.report=function(){function b(a){j(),n.push(a)}function d(a){for(var b=n.length-1;b>=0;--b)n[b]===a&&n.splice(b,1)}function g(a,b){var d=null;if(!b||f.collectWindowErrors){for(var e in n)if(c(n,e))try{n[e].apply(null,[a].concat(h.call(arguments,2)))}catch(g){d=g}if(d)throw d}}function i(a,b,c,d,e){var h=null;if(e)h=f.computeStackTrace(e);else if(p)f.computeStackTrace.augmentStackTraceWithInitialElement(p,b,c,a),h=p,p=null,o=null;else{var i={url:b,line:c,column:d};i.func=f.computeStackTrace.guessFunctionName(i.url,i.line),i.context=f.computeStackTrace.gatherContext(i.url,i.line),h={mode:"onerror",message:a,url:document.location.href,stack:[i],useragent:navigator.userAgent}}return g(h,"from window.onerror"),!!l&&l.apply(this,arguments)}function j(){m!==!0&&(l=a.onerror,a.onerror=i,m=!0)}function k(b){var c;if("undefined"!=typeof document&&(c=h.call(arguments,1)),p){if(o===b)return;var d=p;p=null,o=null,g.apply(null,[d,null].concat(c))}var i=f.computeStackTrace(b);if(p=i,o=b,a.setTimeout(function(){o===b&&(p=null,o=null,g.apply(null,[i,null].concat(c)))},i.incomplete?2e3:0),!e.Utilities.isReactNative())throw b}var l,m,n=[],o=null,p=null;return k.subscribe=b,k.unsubscribe=d,k}(),f.computeStackTrace=function(){function b(a){return"string"!=typeof a?[]:""}function g(d){if(!c(x,d)){var e="";d=d||"";var f;f="undefined"!=typeof document?document.domain:a.location.hostname,d.indexOf&&d.indexOf(f)!==-1&&(e=b(d)),x[d]=e?e.split("\n"):[]}return x[d]}function h(a,b){var c,e=/function ([^(]*)\(([^)]*)\)/,f=/['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,h="",j=10,k=g(a);if(!k.length)return i;for(var l=0;l<j;++l)if(h=k[b-l]+h,!d(h)){if(c=f.exec(h))return c[1];if(c=e.exec(h))return c[1]}return i}function j(a,b){var c=g(a);if(!c.length)return null;var e=[],h=Math.floor(f.linesOfContext/2),i=h+f.linesOfContext%2,j=Math.max(0,b-h-1),k=Math.min(c.length,b+i-1);b-=1;for(var l=j;l<k;++l)d(c[l])||e.push(c[l]);return e.length>0?e:null}function k(a){return a.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g,"\\$&")}function l(a){return k(a).replace("<","(?:<|&lt;)").replace(">","(?:>|&gt;)").replace("&","(?:&|&amp;)").replace('"','(?:"|&quot;)').replace(/\s+/g,"\\s+")}function m(a,b){for(var c,d,e=0,f=b.length;e<f;++e)if((c=g(b[e])).length&&(c=c.join("\n"),d=a.exec(c)))return{url:b[e],line:c.substring(0,d.index).split("\n").length,column:d.index-c.lastIndexOf("\n",d.index)-1};return null}function n(a,b,c){var d,e=g(b),f=new RegExp("\\b"+k(a)+"\\b");return c-=1,e&&e.length>c&&(d=f.exec(e[c]))?d.index:null}function o(b){for(var c,d,e,f,g=[a.location.href],h=document.getElementsByTagName("script"),i=""+b,j=/^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,n=/^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,o=0;o<h.length;++o){var p=h[o];p.src&&g.push(p.src)}if(e=j.exec(i)){var q=e[1]?"\\s+"+e[1]:"",r=e[2].split(",").join("\\s*,\\s*");c=k(e[3]).replace(/;$/,";?"),d=new RegExp("function"+q+"\\s*\\(\\s*"+r+"\\s*\\)\\s*{\\s*"+c+"\\s*}")}else d=new RegExp(k(i).replace(/\s+/g,"\\s+"));if(f=m(d,g))return f;if(e=n.exec(i)){var s=e[1];if(c=l(e[2]),d=new RegExp("on"+s+"=[\\'\"]\\s*"+c+"\\s*[\\'\"]","i"),f=m(d,g[0]))return f;if(d=new RegExp(c),f=m(d,g))return f}return null}function p(a){if(!a.stack)return{tracekitResult:"nostack"};var b,c,d=/^\s*at (.*?) ?\(((?:file|https?|\s*|blob|chrome-extension|native|webpack|eval|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,f=/^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i,g=/^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,k=a.stack.split("\n"),l=[],m=/^(.*) is undefined$/.exec(a.message);if(e.Utilities.isReactNative())for(var o=/^(.*@)?.*\/[^\.]+(\.app|CodePush)\/?(.*)/,p="file://reactnative.local/",q=0;q<k.length;q++)if(b=o.exec(k[q]),null!==b){var r=b[1]?b[1]:"anonymous@",s=b[3];k[q]=r+p+s}for(var q=0,t=k.length;q<t;++q){if(b=f.exec(k[q]))c={url:b[3],func:b[1]||i,args:b[2]?b[2].split(","):"",line:+b[4],column:b[5]?+b[5]:null};else if(b=d.exec(k[q]))c={url:b[2],func:b[1]||i,line:+b[3],column:b[4]?+b[4]:null};else{if(!(b=g.exec(k[q])))continue;c={url:b[2],func:b[1]||i,line:+b[3],column:b[4]?+b[4]:null}}!c.func&&c.line&&(c.func=h(c.url,c.line)),"undefined"!=typeof document&&c.line&&(c.context=j(c.url,c.line)),l.push(c)}if(l[0]&&l[0].line&&!l[0].column&&m?l[0].column=n(m[1],l[0].url,l[0].line):l[0].column||"undefined"==typeof a.columnNumber||(l[0].column=a.columnNumber+1),!l.length)return null;var u={mode:"stack",name:a?a.name:"",message:a?a.message:"",url:"undefined"!=typeof document?document.location.href:"",stack:l,useragent:navigator?navigator.userAgent:"",stackstring:a&&a.stack?a.stack.toString():""};return u}function q(a){for(var b,c=a.stacktrace,d=/ line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,e=c?c.split("\n"):[],f=[],g=0,i=e.length;g<i;g+=2)if(b=d.exec(e[g])){var k={line:+b[1],column:+b[2],func:b[3]||b[4],args:b[5]?b[5].split(","):[],url:b[6]};if(!k.func&&k.line&&(k.func=h(k.url,k.line)),k.line)try{k.context=j(k.url,k.line)}catch(l){}k.context||(k.context=[e[g+1]]),f.push(k)}return f.length?{mode:"stacktrace",name:a.name,message:a.message,url:document.location.href,stack:f,useragent:navigator.userAgent,stackstring:c}:null}function r(b){var d=b.message.split("\n");if(d.length<4)return null;var e,f,i,k,n=/^\s*Line (\d+) of linked script ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,o=/^\s*Line (\d+) of inline#(\d+) script in ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,p=/^\s*Line (\d+) of function script\s*$/i,q=[],r=document.getElementsByTagName("script"),s=[];for(f in r)c(r,f)&&!r[f].src&&s.push(r[f]);for(f=2,i=d.length;f<i;f+=2){var t=null;if(e=n.exec(d[f]))t={url:e[2],func:e[3],line:+e[1]};else if(e=o.exec(d[f])){t={url:e[3],func:e[4]};var u=+e[1],v=s[e[2]-1];if(v&&(k=g(t.url))){k=k.join("\n");var w=k.indexOf(v.innerText);w>=0&&(t.line=u+k.substring(0,w).split("\n").length)}}else if(e=p.exec(d[f])){var x=a.location.href.replace(/#.*$/,""),y=e[1],z=new RegExp(l(d[f+1]));k=m(z,[x]),t={url:x,line:k?k.line:y,func:""}}if(t){t.func||(t.func=h(t.url,t.line));var A=j(t.url,t.line),B=A?A[Math.floor(A.length/2)]:null;A&&B.replace(/^\s*/,"")===d[f+1].replace(/^\s*/,"")?t.context=A:t.context=[d[f+1]],q.push(t)}}return q.length?{mode:"multiline",name:b.name,message:d[0],url:document.location.href,stack:q,useragent:navigator.userAgent}:null}function s(a,b,c,d){var e={url:b,line:c};if(e.url&&e.line){a.incomplete=!1,e.func||(e.func=h(e.url,e.line)),e.context||(e.context=j(e.url,e.line));var f=/ '([^']+)' /.exec(d);if(f&&(e.column=n(f[1],e.url,e.line)),a.stack.length>0&&a.stack[0].url===e.url){if(a.stack[0].line===e.line)return!1;if(!a.stack[0].line&&a.stack[0].func===e.func)return a.stack[0].line=e.line,a.stack[0].context=e.context,!1}return a.stack.unshift(e),a.partial=!0,!0}return a.incomplete=!0,!1}function t(a,b){for(var c,d,e,g=/function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,j=[],k={},l=!1,m=t.caller;m&&!l;m=m.caller)if(m!==u&&m!==f.report){if(d={url:null,func:i,line:null,column:null},m.name?d.func=m.name:(c=g.exec(m.toString()))&&(d.func=c[1]),"undefined"==typeof d.func)try{d.func=c.input.substring(0,c.input.indexOf("{"))}catch(p){}if(e=o(m)){d.url=e.url,d.line=e.line,d.func===i&&(d.func=h(d.url,d.line));var q=/ '([^']+)' /.exec(a.message||a.description);q&&(d.column=n(q[1],e.url,e.line))}k[""+m]?l=!0:k[""+m]=!0,j.push(d)}b&&j.splice(0,b);var r={mode:"callers",name:a.name,message:a.message,url:document.location.href,stack:j,useragent:navigator.userAgent};return s(r,a.sourceURL||a.fileName,a.line||a.lineNumber,a.message||a.description),r}function u(a,b){var c=null;b=null==b?0:+b;try{if(c=q(a))return c}catch(d){if(w)throw d}try{if(c=p(a))return c}catch(d){if(w)throw d}try{if(c=r(a))return c}catch(d){if(w)throw d}try{if(c=t(a,b+1))return c}catch(d){if(w)throw d}return{tracekitResult:"failedToComputeAnyStackTrace"}}function v(a){a=(null==a?0:+a)+1;try{throw new Error}catch(b){return u(b,a+1)}}var w=!1,x={};return u.augmentStackTraceWithInitialElement=s,u.guessFunctionName=h,u.gatherContext=j,u.ofCaller=v,u}(),f.extendToAsynchronousCallbacks=function(){var b=function(b){var c=a[b];a[b]=function(){var a=h.call(arguments),b=a[0];return"function"==typeof b&&(a[0]=f.wrap(b)),c.apply?c.apply(this,a):c(a[0],a[1])}};b("setTimeout"),b("setInterval")},f.remoteFetching||(f.remoteFetching=!0),f.collectWindowErrors||(f.collectWindowErrors=!0),(!f.linesOfContext||f.linesOfContext<1)&&(f.linesOfContext=11),a.TraceKit=f}(window),function(a,b){"use strict";if(a&&a.event&&a.event.add){var c=a.event.add;a.event.add=function(d,e,f,g,h){if("function"!=typeof f&&"function"!=typeof f.handler)return c.call(this,d,e,f,g,h);var i;return f.handler?(i=f.handler,f.handler=b.wrap(f.handler)):(i=f,f=b.wrap(f)),i.guid?f.guid=i.guid:f.guid=i.guid=a.guid++,c.call(this,d,e,f,g,h)};var d=a.fn.ready;a.fn.ready=function(a){return d.call(this,b.wrap(a))};var e=a.ajax;a.ajax=function(c,d){"object"==typeof c&&(d=c,c=void 0),d=d||{};for(var f,g=["complete","error","success"];f=g.pop();)a.isFunction(d[f])&&(d[f]=b.wrap(d[f]));try{return c?e.call(this,c,d):e.call(this,d)}catch(h){throw b.report(h),h}}}}(window.jQuery,window.TraceKit),Date.prototype.toISOString||!function(){function a(a){var b=String(a);return 1===b.length&&(b="0"+b),b}Date.prototype.toISOString=function(){return this.getUTCFullYear()+"-"+a(this.getUTCMonth()+1)+"-"+a(this.getUTCDate())+"T"+a(this.getUTCHours())+":"+a(this.getUTCMinutes())+":"+a(this.getUTCSeconds())+"."+String((this.getUTCMilliseconds()/1e3).toFixed(3)).slice(2,5)+"Z"}}(),Array.prototype.indexOf||(Array.prototype.indexOf=function(a,b){var c;if(null==this)throw new TypeError('"this" is null or not defined');var d=Object(this),e=d.length>>>0;if(0===e)return-1;var f=0|b;if(f>=e)return-1;for(c=Math.max(f>=0?f:e-Math.abs(f),0);c<e;){if(c in d&&d[c]===a)return c;c++}return-1}),Array.prototype.map||(Array.prototype.map=function(a){var b,c,d;if(null==this)throw new TypeError("this is null or not defined");var e=Object(this),f=e.length>>>0;if("function"!=typeof a)throw new TypeError(a+" is not a function");for(arguments.length>1&&(b=arguments[1]),c=new Array(f),d=0;d<f;){var g,h;d in e&&(g=e[d],h=a.call(b,g,d,e),c[d]=h),d++}return c}),Array.prototype.forEach||(Array.prototype.forEach=function(a){var b,c;if(null==this)throw new TypeError("this is null or not defined");var d=Object(this),e=d.length>>>0;if("function"!=typeof a)throw new TypeError(a+" is not a function");for(arguments.length>1&&(b=arguments[1]),c=0;c<e;){var f;c in d&&(f=d[c],a.call(b,f,c,d)),c++}}),Function.prototype.bind||(Function.prototype.bind=function(a){if("function"!=typeof this)throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");var b=Array.prototype.slice.call(arguments,1),c=this,d=function(){},e=function(){return c.apply(this instanceof d&&a?this:a,b.concat(Array.prototype.slice.call(arguments)))};return d.prototype=this.prototype,e.prototype=new d,e}),window.raygunUtilityFactory=function(a,b){var c,d={getUuid:function(){function a(a){var b=(Math.random().toString(16)+"000000000").substr(2,8);return a?"-"+b.substr(0,4)+"-"+b.substr(4,4):b}return a()+a(!0)+a(!0)+a()},createCookie:function(a,b,c){if(!this.isReactNative()){var d;if(c){var e=new Date;e.setTime(e.getTime()+60*c*60*1e3),d="; expires="+e.toGMTString()}else d="";document.cookie=a+"="+b+d+"; path=/"}},readCookie:function(a,b){if(this.isReactNative())return void b(null,"none");for(var c=a+"=",d=document.cookie.split(";"),e=0;e<d.length;e++){for(var f=d[e];" "===f.charAt(0);)f=f.substring(1,f.length);if(0===f.indexOf(c)){var g=f.substring(c.length,f.length);return void b(null,g)}}b(null,null)},clearCookie:function(a){this.isReactNative()||this.createCookie(a,"",-1)},log:function(c,d){a.console&&a.console.log&&b.Options._debugMode&&(a.console.log(c),d&&a.console.log(d))},isApiKeyConfigured:function(){return!(!b.Options._raygunApiKey||""===b.Options._raygunApiKey)||(b.Utilities.log("Raygun API key has not been configured, make sure you call Raygun.init(yourApiKey)"),!1)},isReactNative:function(){return"undefined"==typeof document&&"undefined"!=typeof __DEV__},defaultReactNativeGlobalHandler:function(a,b){"function"==typeof c&&c(a,b)},localStorageAvailable:function(){try{return"localStorage"in a&&null!==a.localStorage}catch(b){return!1}},truncateURL:function(a){var b=a,c=a.split("//")[1];if(c){var d=c.indexOf("?"),e=c.toString().substring(0,d),f=e.split("/").slice(0,4).join("/"),g=e.substring(0,48);b=f.length<g.length?f:g,b!==e&&(b+="..")}return b},merge:function(a,b){var c,d={};for(c in a)d[c]=a[c];for(c in b)d[c]=b[c];return d},mergeMutate:function(a,b){var c;for(c in b)a[c]=b[c];return a},mergeArray:function(a,b){return null!=b?a.concat(b):a},forEach:function(a,b){for(var c=0;c<a.length;c++)b.call(null,c,a[c])},isEmpty:function(a){for(var b in a)if(a.hasOwnProperty(b))return!1;return!0},contains:function(a,b){for(var c=a.length;c--;)if(a[c]===b)return!0;return!1},getRandomInt:function(){return Math.floor(9007199254740992*Math.random())},getViewPort:function(){if(this.isReactNative())return{width:"Not available",height:"Not available"};var b=document.documentElement,c=document.getElementsByTagName("body")[0],d=a.innerWidth||b.clientWidth||c.clientWidth,e=a.innerHeight||b.clientHeight||c.clientHeight;return{width:d,height:e}},parseUrl:function(b,c){function d(a){return!isNaN(parseFloat(a))&&isFinite(a)}return function(b,c){if("undefined"==typeof document)return"";var e=c||a.location.toString();if(!b)return e;b=b.toString(),"//"===e.substring(0,2)?e="http:"+e:1===e.split("://").length&&(e="http://"+e),c=e.split("/");var f={auth:""},g=c[2].split("@");1===g.length?g=g[0].split(":"):(f.auth=g[0],g=g[1].split(":")),f.protocol=c[0],f.hostname=g[0],f.port=g[1]||("https"===f.protocol.split(":")[0].toLowerCase()?"443":"80"),f.pathname=(c.length>3?"/":"")+c.slice(3,c.length).join("/").split("?")[0].split("#")[0];var h=f.pathname;"/"===h.charAt(h.length-1)&&(h=h.substring(0,h.length-1));var i=f.hostname,j=i.split("."),k=h.split("/");if("hostname"===b)return i;if("domain"===b)return/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(i)?i:j.slice(-2).join(".");if("sub"===b)return j.slice(0,j.length-2).join(".");if("port"===b)return f.port;if("protocol"===b)return f.protocol.split(":")[0];if("auth"===b)return f.auth;if("user"===b)return f.auth.split(":")[0];if("pass"===b)return f.auth.split(":")[1]||"";if("path"===b)return f.pathname;if("."===b.charAt(0)){if(b=b.substring(1),d(b))return b=parseInt(b,10),j[b<0?j.length+b:b-1]||""}else{if(d(b))return b=parseInt(b,10),k[b<0?k.length+b:b]||"";if("file"===b)return k.slice(-1)[0];if("filename"===b)return k.slice(-1)[0].split(".")[0];if("fileext"===b)return k.slice(-1)[0].split(".")[1]||"";if("?"===b.charAt(0)||"#"===b.charAt(0)){var l=e,m=null;if("?"===b.charAt(0)?l=(l.split("?")[1]||"").split("#")[0]:"#"===b.charAt(0)&&(l=l.split("#")[1]||""),!b.charAt(1))return l;b=b.substring(1),l=l.split("&");for(var n=0,o=l.length;n<o;n++)if(m=l[n].split("="),m[0]===b)return m[1]||"";return null}}return""}(b,c)},enhance:function(a,b,c){var d=a[b];return a[b]=function(){c.apply(this,arguments),"function"==typeof d&&d.apply(this,arguments)},function(){a[b]=d}},addEventHandler:function(a,b,c,d){var e=d||!1;return a.addEventListener?a.addEventListener(b,c,e):a.attachEvent?a.attachEvent("on"+b,c):a["on"+b]=c,function(){a.removeEventListener?a.removeEventListener(b,c,e):a.detachEvent?a.detachEvent("on"+b,c):a["on"+b]=function(){}}},nodeText:function(a){var b=a.textContent||a.innerText||"";return["submit","button"].indexOf(a.type)!==-1&&(b=a.value),b=b.replace(/^\s+|\s+$/g,"")},nodeSelector:function(a){var b=[a.tagName];return a.id&&b.push("#"+a.id),a.className&&a.className.length&&b.push("."+a.className.split(" ").join(".")),b.join("")},truncate:function(a,b){var c="(...)";return a.length>b?a.slice(0,b-c.length)+c:a}};return d.isReactNative()&&__DEV__!==!0&&a.ErrorUtils&&a.ErrorUtils.getGlobalHandler&&(c=a.ErrorUtils.getGlobalHandler()),d},window.raygunBreadcrumbsFactory=function(a,b){function c(a,b){for(var c=0;c<b.length;c++){var d=b[c];if("string"==typeof d&&a&&a.indexOf(d)>-1)return!0;if("object"==typeof d&&d.exec(a))return!0}return!1}var d=function(){this.MAX_BREADCRUMBS=32,this.MAX_MESSAGE_SIZE=1024,this.BREADCRUMB_LEVELS=["debug","info","warning","error"],this.DEFAULT_BREADCRUMB_LEVEL="info",this.DEFAULT_XHR_IGNORED_HOSTS=["raygun"],this.breadcrumbLevel="info",this.logXhrContents=!1,this.xhrIgnoredHosts=[].concat(this.DEFAULT_XHR_IGNORED_HOSTS),this.breadcrumbs=[],this.raygunInstance={send:function(){}};var a=this;this.wrapWithHandler=function(b){return function(){try{return b.apply(this,arguments)}catch(c){a.raygunInstance.send(c)}}},this.disableConsoleFunctions=[],this.disableNavigationFunctions=[],this.disableXHRLogging=function(){},this.disableClicksTracking=function(){},this.enableAutoBreadcrumbs()};return d.prototype.recordBreadcrumb=function(a,c){var d={level:this.DEFAULT_BREADCRUMB_LEVEL,timestamp:(new Date).getTime(),type:"manual"};switch(typeof a){case"object":d=b.Utilities.merge(d,a);break;case"string":d=b.Utilities.merge(b.Utilities.merge(d,{message:a,metadata:c}));break;default:return void b.Utilities.log("expected first argument to recordBreadcrumb to be a 'string' or 'object', got "+typeof a)}this.BREADCRUMB_LEVELS.indexOf(d.level)===-1&&(b.Utilities.log("unknown breadcrumb level "+d.level+" setting to default of '"+this.DEFAULT_BREADCRUMB_LEVEL+"'"),d.level=this.DEFAULT_BREADCRUMB_LEVEL),this.shouldRecord(d)&&(d.message=b.Utilities.truncate(d.message,this.MAX_MESSAGE_SIZE),this.breadcrumbs.push(d),this.breadcrumbs=this.breadcrumbs.slice(-this.MAX_BREADCRUMBS))},d.prototype.shouldRecord=function(a){var b=this.BREADCRUMB_LEVELS.indexOf(a.level),c=this.BREADCRUMB_LEVELS.indexOf(this.breadcrumbLevel);return b>=c},d.prototype.setBreadcrumbLevel=function(a){return this.BREADCRUMB_LEVELS.indexOf(a)===-1?void b.Utilities.log("Breadcrumb level of '"+a+"' is invalid, setting to default of '"+this.DEFAULT_BREADCRUMB_LEVEL+"'"):void(this.breadcrumbLevel=a)},d.prototype.setOption=function(a,b){if("breadcrumbsLevel"===a)this.setBreadcrumbLevel(b);else if("xhrIgnoredHosts"===a){this.xhrIgnoredHosts=b.concat(this.DEFAULT_XHR_IGNORED_HOSTS);var d=this;this.removeBreadcrumbsWithPredicate(function(a){return"request"===a.type&&c(a.metadata.requestURL||a.metadata.responseURL,d.xhrIgnoredHosts)})}else"logXhrContents"===a&&(this.logXhrContents=b)},d.prototype.any=function(){return this.breadcrumbs.length>0},d.prototype.all=function(){return this.breadcrumbs},d.prototype.enableAutoBreadcrumbs=function(){this.enableAutoBreadcrumbsXHR(),this.enableAutoBreadcrumbsClicks(),this.enableAutoBreadcrumbsConsole(),this.enableAutoBreadcrumbsNavigation()},d.prototype.disableAutoBreadcrumbs=function(){this.disableAutoBreadcrumbsXHR(),this.disableAutoBreadcrumbsClicks(),this.disableAutoBreadcrumbsConsole(),this.disableAutoBreadcrumbsNavigation()},d.prototype.removeBreadcrumbsWithPredicate=function(a){for(var b=this.breadcrumbs,c=[],d=0;d<b.length;d++){var e=b[d];a(e)||c.push(e)}this.breadcrumbs=c},d.prototype.removeCrumbsOfType=function(a){this.removeBreadcrumbsWithPredicate(function(b){return b.type===a})},d.prototype.enableAutoBreadcrumbsConsole=function(){if("undefined"!=typeof a.console){var c=function(a,b){for(var c=[],d=0;d<b.length;d++){var e=b[d];null!==e&&void 0!==e&&c.push(e.toString())}this.recordBreadcrumb({type:"console",level:a,message:Array.prototype.slice.call(c).join(", ")})}.bind(this),d=["log","warn","error"],e=this;this.disableConsoleFunctions=d.map(function(a){return b.Utilities.enhance(console,a,e.wrapWithHandler(function(){var b="log"===a?"info":"warn"===a?"warning":"error";c(b,arguments)}))})}},d.prototype.disableAutoBreadcrumbsConsole=function(){this.disableConsoleFunctions.forEach(function(a){a()}),this.removeCrumbsOfType("console")},d.prototype.enableAutoBreadcrumbsNavigation=function(){if(a.addEventListener&&a.history&&a.history.pushState){var c=function(b,c,d,e){var f=location.pathname+location.search+location.hash,g=null;return a.history.state&&(g=history.state),{message:"History "+b,type:"navigation",level:"info",metadata:{from:f,to:e||f,prevState:JSON.stringify(g)||"unsupported",nextState:JSON.stringify(c)}}}.bind(this),d=function(a){return a.split("#")[1]||""},e=["pushState","replaceState"];this.disableNavigationFunctions=this.disableNavigationFunctions.concat(e.map(function(a){return b.Utilities.enhance(history,a,this.wrapWithHandler(function(b,d,e){this.recordBreadcrumb(c(a,b,d,e))}.bind(this)))}.bind(this)));var f=function(a){var b,c=a.oldURL,e=a.newURL;return b=c&&e?{from:d(c),to:d(e)}:{to:location.hash},{type:"navigation",message:"Hash change",metadata:b}},g=function(a){return this.wrapWithHandler(function(){this.recordBreadcrumb(a.apply(null,arguments))}.bind(this))}.bind(this),h=[{element:a,event:"hashchange",handler:f},{element:a,event:"load",handler:function(){return{type:"navigation",message:"Page loaded"}}},{element:a,event:"popstate",handler:function(){return{type:"navigation",message:"Navigated back"}}},{element:a,event:"pagehide",handler:function(){return{type:"navigation",message:"Page hidden"}}},{element:a,event:"pageshow",handler:function(){return{type:"navigation",message:"Page shown"}}},{element:document,event:"DOMContentLoaded",handler:function(){return{type:"navigation",message:"DOMContentLoaded"}}}];this.disableNavigationFunctions=this.disableNavigationFunctions.concat(h.map(function(a){return b.Utilities.addEventHandler(a.element,a.event,g(a.handler))}.bind(this)))}},d.prototype.disableAutoBreadcrumbsNavigation=function(){this.disableNavigationFunctions.forEach(function(a){a()}),this.disableNavigationFunctions=[],this.removeCrumbsOfType("navigation")},d.prototype.enableAutoBreadcrumbsClicks=function(){this.disableClicksTracking=b.Utilities.addEventHandler(a,"click",this.wrapWithHandler(function(a){var c,d;try{c=b.Utilities.truncate(b.Utilities.nodeText(a.target),150),d=b.Utilities.nodeSelector(a.target)}catch(e){c="[unknown]",d="[unknown]",b.Utilities.log("Error retrieving node text/selector. Most likely due to a cross domain error")}this.recordBreadcrumb({type:"click-event",message:"UI Click",level:"info",metadata:{text:c,selector:d}})}.bind(this),!0))},d.prototype.disableAutoBreadcrumbsClicks=function(){this.disableClicksTracking(),this.removeCrumbsOfType("click-event")},d.prototype.enableAutoBreadcrumbsXHR=function(){var d=this;return a.XMLHttpRequest.prototype.addEventListener?void(this.disableXHRLogging=b.Utilities.enhance(a.XMLHttpRequest.prototype,"open",d.wrapWithHandler(function(){var a=(new Date).getTime(),e=arguments[1]||"Unknown",f=arguments[0];c(e,d.xhrIgnoredHosts)||(b.Utilities.enhance(this,"send",d.wrapWithHandler(function(){var a={method:f,requestURL:e};arguments[0]&&"string"==typeof arguments[0]&&d.logXhrContents&&(a.requestText=b.Utilities.truncate(arguments[0],500)),d.recordBreadcrumb({type:"request",message:"Opening request to "+e,level:"info",metadata:a})})),this.addEventListener("load",d.wrapWithHandler(function(){var c="N/A for non text responses";""!==this.responseType&&"text"!==this.responseType||!d.logXhrContents||(c=b.Utilities.truncate(this.responseText,500)),d.recordBreadcrumb({type:"request",message:"Finished request to "+e,level:"info",metadata:{status:this.status,requestURL:e,responseURL:this.responseURL,responseText:d.logXhrContents?c:"Disabled",duration:(new Date).getTime()-a+"ms"}})})),this.addEventListener("error",d.wrapWithHandler(function(){d.recordBreadcrumb({type:"request",message:"Failed request to "+e,level:"info",metadata:{status:this.status,requestURL:e,responseURL:this.responseURL,duration:(new Date).getTime()-a+"ms"}})})),this.addEventListener("abort",d.wrapWithHandler(function(){d.recordBreadcrumb({type:"request",message:"Request to "+e+"aborted",level:"info",metadata:{requestURL:e,duration:(new Date).getTime()-a+"ms"}})})))}))):void(this.disableXHRLogging=function(){})},d.prototype.disableAutoBreadcrumbsXHR=function(){this.disableXHRLogging(),this.removeCrumbsOfType("request")},d.prototype.setCrashReportingInstance=function(a){a.init("D8pC4YA3glwX5g4N/krb6Q=="),this.raygunInstance=a;var b,c;for(b in d.prototype)c=d.prototype[b],"function"==typeof c&&(d.prototype[b]=this.wrapWithHandler(c))},d};var raygunFactory=function(a,b,c,d){function e(a){"function"==typeof z&&z(a)}function f(){t||M?h():s.Utilities.readCookie(D,g)}function g(a,b){var c;a&&(c="Unknown"),b?c=b:(c=s.Utilities.getUuid(),s.Utilities.createCookie(D,c,744)),s.setUser(c,!0,null,null,null,c),h()}function h(){if(_!==C.READY){if(_=C.READY,s.RealUserMonitoring!==d&&!O){var b=function(){X=new s.RealUserMonitoring(s.Options._raygunApiKey,T,r,t,u,R,U,V,G,Z,$,ca),X.attach()};"onLoad"===A?b():a.addEventListener?a.addEventListener("load",b):a.attachEvent("onload",b)}i(),k()}}function i(){var a;for(a=0;a<aa.length;a++)o(aa[a].stackTrace,aa[a].options,aa[a].userTriggered);for(aa=[],a=0;a<ba.length;a++)ea.trackEvent(ba[a].type,ba[a].options);ba=[]}function j(a,b){var c=(new Date).toJSON();try{var d="raygunjs+"+s.Options._raygunApiKey+"="+c+"="+s.Utilities.getRandomInt();"undefined"==typeof localStorage[d]&&(localStorage[d]=JSON.stringify({url:a,data:b}))}catch(e){s.Utilities.log("Raygun4JS: LocalStorage full, cannot save exception")}}function k(){if(s.Utilities.localStorageAvailable())for(var a in localStorage)if("raygunjs="===a.substring(0,9)||a.substring(0,33)==="raygunjs+"+s.Options._raygunApiKey){try{var b=JSON.parse(localStorage[a]);r(b.url,b.data)}catch(c){s.Utilities.log("Raygun4JS: Invalid JSON object in LocalStorage")}try{localStorage.removeItem(a)}catch(c){s.Utilities.log("Raygun4JS: Unable to remove error")}}}function l(a,b){if(v)for(var c=0;c<v.length;c++)if("object"==typeof v[c]&&"function"==typeof v[c].exec){if(null!==v[c].exec(a))return"[removed by filter]"}else if(v[c]===a)return"[removed by filter]";return b}function m(a,b){if(null==a)return a;if("[object Object]"!==Object.prototype.toString.call(a))return a;var c={};for(var d in a){var e=a[d];"[object Object]"===Object.prototype.toString.call(e)?"Details"!==b||"Client"!==d?c[d]=m(l(d,e),d):c[d]=e:"[object Function]"!==Object.prototype.toString.call(e)&&("undefined"!=typeof b?c[d]=l(d,e):"OccurredOn"===d&&(c[d]=e))}return c}function n(a,b,c,e){var f="AJAX Error: "+(b.statusText||"unknown")+" "+(c.type||"unknown")+" "+(s.Utilities.truncateURL(c.url)||"unknown");(!I||0!==b.status&&b.getAllResponseHeaders())&&s.send(e||a.type,{status:b.status,statusText:b.statusText,type:c.type,url:c.url,ajaxErrorMessage:f,contentType:c.contentType,requestData:c.data&&c.data.slice?c.data.slice(0,10240):d,responseData:b.responseText&&b.responseText.slice?b.responseText.slice(0,10240):d,activeTarget:a.target&&a.target.activeElement&&a.target.activeElement.outerHTML&&a.target.activeElement.outerHTML.slice?a.target.activeElement.outerHTML.slice(0,10240):d})}function o(b,c,e){if(_!==C.READY)return void aa.push({stackTrace:b,options:c,userTriggered:e});var f="Script error",g=[],h={};if(L){if(!b.stack||!b.stack.length)return void s.Utilities.log("Raygun4JS: Cancelling send due to null stacktrace");var i=s.Utilities.parseUrl("domain"),j=f;if(b.message?j=b.message:c&&c.status&&(j=c.status),"undefined"==typeof j&&(j=f),!s.Utilities.isReactNative()&&j.substring(0,f.length)===f&&null!==b.stack[0].url&&b.stack[0].url.indexOf(i)===-1&&(0===b.stack[0].line||"?"===b.stack[0].func))return void s.Utilities.log("Raygun4JS: cancelling send due to third-party script error with no stacktrace and message");if(null!==b.stack[0].url&&b.stack[0].url.indexOf(i)===-1){var k=!1;for(var n in S)b.stack[0].url.indexOf(S[n])>-1&&(k=!0);if(!k)return void s.Utilities.log("Raygun4JS: cancelling send due to error on non-origin, non-whitelisted domain")}}if(U instanceof Array)for(var o in U)if(U.hasOwnProperty(o)&&a.location.hostname&&a.location.hostname.match(U[o]))return void s.Utilities.log("Raygun4JS: cancelling send as error originates from an excluded hostname");if(V instanceof Array&&!s.Utilities.isReactNative())for(var q in V)if(V.hasOwnProperty(q)&&navigator.userAgent.match(V[q]))return void s.Utilities.log("Raygun4JS: cancelling send as error originates from an excluded user agent");if(s.Utilities.isReactNative()||!navigator.userAgent.match("RaygunPulseInsightsCrawler")){b.stack&&b.stack.length&&s.Utilities.forEach(b.stack,function(a,b){g.push({LineNumber:b.line,ColumnNumber:b.column,ClassName:"line "+b.line+", column "+b.column,FileName:b.url,MethodName:b.func||"[anonymous]"})});var r=s.Utilities.parseUrl("?");r.length>0&&s.Utilities.forEach(r.split("&"),function(a,b){var c=b.split("=");if(c&&2===c.length){var d=decodeURIComponent(c[0]),e=l(d,c[1]);h[d]=e}}),c===d&&(c={}),s.Utilities.isEmpty(c.customData)&&("function"==typeof Q?c.customData=Q():c.customData=Q),s.Utilities.isEmpty(c.tags)&&("function"==typeof R?c.tags=R():c.tags=R),e||(c.tags||(c.tags=[]),s.Utilities.contains(c.tags,"UnhandledException")||c.tags.push("UnhandledException")),s.Utilities.isReactNative()&&!s.Utilities.contains(c.tags,"React Native")&&c.tags.push("React Native");var v,y=a.screen||{width:s.Utilities.getViewPort().width,height:s.Utilities.getViewPort().height,colorDepth:8},z=c.customData&&c.customData.ajaxErrorMessage;v="customData"===W?m(c.customData,"UserCustomData"):c.customData;try{JSON.stringify(v)}catch(A){var B="Cannot add custom data; may contain circular reference";v={error:B},s.Utilities.log("Raygun4JS: "+B)}var D=f;z?D=z:b.message?D=b.message:c&&c.status&&(D=c.status),"undefined"==typeof D&&(D=f),D&&"string"==typeof D&&(D=D.substring(0,512));var E;E=s.Utilities.isReactNative()?"/":[location.protocol,"//",location.host,location.pathname,location.hash].join("");var F={OccurredOn:new Date,Details:{Error:{ClassName:b.name,Message:D,StackTrace:g,StackString:b.stackstring},Environment:{UtcOffset:(new Date).getTimezoneOffset()/-60,"User-Language":navigator.userLanguage,"Document-Mode":s.Utilities.isReactNative()?"Not available":document.documentMode,"Browser-Width":s.Utilities.getViewPort().width,"Browser-Height":s.Utilities.getViewPort().height,"Screen-Width":y.width,"Screen-Height":y.height,"Color-Depth":y.colorDepth,Browser:navigator.appCodeName,"Browser-Name":navigator.appName,"Browser-Version":navigator.appVersion,Platform:navigator.platform},Client:{Name:"raygun-js",Version:"2.7.1"},UserCustomData:v,Tags:c.tags,Request:{Url:E,QueryString:h,Headers:{"User-Agent":navigator.userAgent,Referer:s.Utilities.isReactNative()?"Not available":document.referrer,Host:s.Utilities.isReactNative()?"Not available":document.domain}},Version:u||"Not supplied"}};if(F.Details.User=t,Y.any()){F.Details.Breadcrumbs=[];var G=Y.all();G.forEach(function(a){a.metadata&&(a.CustomData=a.metadata,delete a.metadata),F.Details.Breadcrumbs.push(a)})}if("all"===W&&(F=m(F)),"function"==typeof x&&(s.Utilities.log("Raygun4JS: calling custom grouping key"),F.Details.GroupingKey=x(F,b,c)),"function"==typeof w){var H=w(F);H&&p(H)}else p(F)}}function p(a){if(s.Utilities.isApiKeyConfigured()){s.Utilities.log("Sending exception data to Raygun:",a);var b=T+"/entries?apikey="+encodeURIComponent(s.Options._raygunApiKey);r(b,JSON.stringify(a))}}function q(b,c){var d;return d=new a.XMLHttpRequest,"withCredentials"in d||s.Utilities.isReactNative()?d.open(b,c,!0):a.XDomainRequest&&(H&&(c=c.slice(6)),d=new a.XDomainRequest,d.open(b,c)),d.timeout=1e4,d}function r(b,c){
var d=q("POST",b,c);return"function"==typeof y&&y(d),s.Utilities.log("Is offline enabled? "+K),"withCredentials"in d||s.Utilities.isReactNative()?(d.onreadystatechange=function(){4===d.readyState&&(202===d.status?k():K&&403!==d.status&&400!==d.status&&429!==d.status&&j(b,c))},d.onload=function(){s.Utilities.log("posted to Raygun"),e(this)}):a.XDomainRequest&&(d.ontimeout=function(){K&&(s.Utilities.log("Raygun: saved locally"),j(b,c))},d.onload=function(){s.Utilities.log("posted to Raygun"),k(),e(this)}),d.onerror=function(){s.Utilities.log("failed to post to Raygun"),e(this)},d?(s.Utilities.isReactNative()&&d.setRequestHeader("Content-type","application/json;charset=UTF-8"),void d.send(c)):void s.Utilities.log("CORS not supported")}var s={};s.Utilities=raygunUtilityFactory(a,s),s.Breadcrumbs=raygunBreadcrumbsFactory(a,s);var t,u,v,w,x,y,z,A,B,C={LOADING:0,READY:1},D="raygun4js-userid",E=TraceKit,F=a.Raygun,G=!1,H=!1,I=!1,J=!1,K=!1,L=!1,M=!1,N=!1,O=!0,P=!1,Q={},R=[],S=[],T="https://api.raygun.io",U=null,V=null,W="customData",X=null,Y=new s.Breadcrumbs,Z=null,$=!0,_=C.LOADING,aa=[],ba=[],ca=null,da=Math.random(),ea={Rand:da,Options:{},noConflict:function(){return F&&(a.Raygun=F),s},constructNewRaygun:function(b){var c=raygunFactory(a,a.jQuery,b);return c},init:function(a,e,g){return E.remoteFetching=!1,this.Options._raygunApiKey=a,g&&(Q=g),b&&(B=b(document)),e&&(H=e.allowInsecureSubmissions||!1,I=e.ignoreAjaxAbort||!1,J=e.ignoreAjaxError||!1,M=e.disableAnonymousUserTracking||!1,N=e.disableErrorTracking||!1,O=e.disablePulse===d||e.disablePulse,U=e.excludedHostnames||!1,V=e.excludedUserAgents||!1,Z=e.pulseMaxVirtualPageDuration||null,$=e.pulseIgnoreUrlCasing||!1,ca=e.pulseCustomLoadTimeEnabled||!1,e.apiUrl&&(T=e.apiUrl),"undefined"!=typeof e.wrapAsynchronousCallbacks&&(P=e.wrapAsynchronousCallbacks),e.debugMode&&(G=e.debugMode),this.Options._debugMode=G,e.ignore3rdPartyErrors&&(L=!0),e.apiEndpoint&&(T=e.apiEndpoint),e.from&&(A=e.from)),c||Y.setCrashReportingInstance(this.constructNewRaygun(!0)),f(),s},withCustomData:function(a){return Q=a,s},withTags:function(a){return R=a,X!==d&&null!==X&&X.withTags(a),s},attach:function(){return!s.Utilities.isApiKeyConfigured()||N?s:(a.RaygunObject&&a[a.RaygunObject]&&a[a.RaygunObject].q&&(a.onerror=null),s.Utilities.isReactNative()&&__DEV__!==!0&&a.ErrorUtils&&a.ErrorUtils.setGlobalHandler&&a.ErrorUtils.setGlobalHandler(function(a,b){var c=z;z=function(){"function"==typeof c&&c(),s.Utilities.defaultReactNativeGlobalHandler(a,b),z=c},TraceKit.report(a)}),E.report.subscribe(o),P&&E.extendToAsynchronousCallbacks(),B&&B.ajaxError&&!J&&B.ajaxError(n),s)},detach:function(){return E.report.unsubscribe(o),B&&B.unbind("ajaxError",n),s},send:function(a,b,c){if(N)return s.Utilities.log("Error not sent due to disabled error tracking"),s;try{o(E.computeStackTrace(a),{customData:"function"==typeof Q?s.Utilities.merge(Q(),b):s.Utilities.merge(Q,b),tags:"function"==typeof R?s.Utilities.mergeArray(R(),c):s.Utilities.mergeArray(R,c)},!0)}catch(d){if(a!==d)throw d}return s},setUser:function(a,b,c,e,f,g){return t={Identifier:a},"boolean"==typeof b&&(t.IsAnonymous=b),c&&(t.Email=c),e&&(t.FullName=e),f&&(t.FirstName=f),g&&(t.UUID=g),X!==d&&null!==X&&X.setUser(t),s},resetAnonymousUser:function(){s.Utilities.clearCookie("raygun4js-userid")},setVersion:function(a){return u=a,s},saveIfOffline:function(a){return"undefined"!=typeof a&&"boolean"==typeof a&&(K=a),s},filterSensitiveData:function(a){return v=a,s},setFilterScope:function(a){return"customData"!==a&&"all"!==a||(W=a),s},whitelistCrossOriginDomains:function(a){return S=a,s},onBeforeSend:function(a){return w=a,s},groupingKey:function(a){return x=a,s},onBeforeXHR:function(a){return y=a,s},onAfterSend:function(a){return z=a,s},endSession:function(){s.RealUserMonitoring!==d&&X&&X.endSession()},trackEvent:function(a,b){return _!==C.READY?void ba.push({type:a,options:b}):void(s.RealUserMonitoring!==d&&X&&("pageView"===a&&b.path?X.virtualPageLoaded(b.path):"customTimings"===a&&b.timings&&X.sendCustomTimings(b.timings)))},recordBreadcrumb:function(){Y.recordBreadcrumb.apply(Y,arguments)},enableAutoBreadcrumbs:function(a){a?Y["enableAutoBreadcrumbs"+a]():Y.enableAutoBreadcrumbs()},disableAutoBreadcrumbs:function(a){a?Y["disableAutoBreadcrumbs"+a]():Y.disableAutoBreadcrumbs()},setBreadcrumbOption:function(a,b){Y.setOption(a,b)},setBreadcrumbs:function(a){Y=a}};return s=s.Utilities.mergeMutate(s,ea),a.__raygunNoConflict||c||(a.Raygun=s),TraceKit.setRaygun(s),s};window.__instantiatedRaygun=raygunFactory(window,window.jQuery);var raygunRumFactory=function(a,b,c){c.RealUserMonitoring=function(b,c,d,e,f,g,h,i,j,k,l,m){function n(a){var b=encodeURIComponent(a).match(/%[89ABab]/g);return a.length+(b?b.length:0)}function o(a){var b=r(F.cookieName),c=null===b,d="string"==typeof exisitingCookie&&b.length>0&&b.indexOf("timestamp")===-1,e=null;if(!c&&!d){var f=new Date(q(b,"timestamp")),g=new Date(new Date-18e5);e=f<g}if(c||d||e)F.sessionId=D(32),p(F.cookieName,F.sessionId),a(!0);else{var h=r(F.cookieName),i=q(h,"id");"undefined"===i||"null"===i?(F.sessionId=D(32),p(F.cookieName,F.sessionId),a(!0)):(F.sessionId=i,a(!1))}}function p(a,b,c){var d,e;if(c){var f=new Date;f.setTime(f.getTime()+60*c*60*1e3),d="; expires="+f.toGMTString()}else d="";e=(new Date).toISOString(),document.cookie=a+"=id|"+b+"&timestamp|"+e+d+"; path=/"}function q(a,b){var c=a.split(/[|&]/);return"id"===b?c[1]:"timestamp"===b?c[3]:void 0}function r(a){for(var b=a+"=",c=document.cookie.split(";"),d=0;d<c.length;d++){for(var e=c[d];" "===e.charAt(0);)e=e.substring(1,e.length);if(0===e.indexOf(b))return e.substring(b.length,e.length)}return null}function s(){var a,b=r(F.cookieName);if(b){var c=new Date(q(b,"timestamp")),d=new Date(new Date-18e5);a=c<d}else a=!0;a&&(F.sessionId=D(32)),p(F.cookieName,F.sessionId),a&&F.pageLoaded(!0)}function t(a){return Math.min(a,3e5)}function u(a){for(var b in a)isNaN(a[b])&&"string"!=typeof a[b]&&(a[b]=0);return a}function v(b,c){var d;return d="object"==typeof a.performance&&"function"==typeof a.performance.now?a.performance.now():0,{t:"v",du:Math.min(F.maxVirtualPageDuration,d-(b||c)),o:Math.min(F.maxVirtualPageDuration,d-c)}}function w(a,b){var c={du:a.duration,t:"p"};return c.a=b+a.fetchStart,a.domainLookupStart&&a.domainLookupStart>0&&(c.b=b+a.domainLookupStart-c.a),a.domainLookupEnd&&a.domainLookupEnd>0&&(c.c=b+a.domainLookupEnd-c.a),a.connectStart&&a.connectStart>0&&(c.d=b+a.connectStart-c.a),a.connectEnd&&a.connectEnd>0&&(c.e=b+a.connectEnd-c.a),a.responseStart&&a.responseStart>0&&(c.f=b+a.responseStart-c.a),a.responseEnd&&a.responseEnd>0&&(c.g=b+a.responseEnd-c.a),a.domLoading&&a.domLoading>0&&(c.h=b+a.domLoading-c.a),a.domInteractive&&a.domInteractive>0&&(c.i=b+a.domInteractive-c.a),a.domContentLoadedEventEnd&&a.domContentLoadedEventEnd>0&&(c.j=b+a.domContentLoadedEventEnd-c.a),a.domComplete&&a.domComplete>0&&(c.k=t(b+a.domComplete-c.a)),a.loadEventStart&&a.loadEventStart>0&&(c.l=b+a.loadEventStart-c.a),a.loadEventEnd&&a.loadEventEnd>0&&(c.m=b+a.loadEventEnd-c.a),a.secureConnectionStart&&a.secureConnectionStart>0&&(c.n=b+(a.secureConnectionStart-a.connectStart)-c.a),c=u(c)}function x(a,b){var c={du:t(a.duration).toFixed(2),t:"xmlhttprequest"===a.initiatorType?"x":0===a.duration?"e":"c",a:(b+a.fetchStart).toFixed(2)};return a.domainLookupStart&&a.domainLookupStart>0&&(c.b=b+a.domainLookupStart-c.a),a.domainLookupEnd&&a.domainLookupEnd>0&&(c.c=b+a.domainLookupEnd-c.a),a.connectStart&&a.connectStart>0&&(c.d=b+a.connectStart-c.a),a.connectEnd&&a.connectEnd>0&&(c.e=b+a.connectEnd-c.a),a.responseStart&&a.responseStart>0&&(c.f=b+a.responseStart-c.a),a.responseEnd&&a.responseEnd>0&&(c.g=b+a.responseEnd-c.a),a.secureConnectionStart&&a.secureConnectionStart>0&&(c.n=b+(a.secureConnectionStart-a.connectStart)-c.a),c=u(c)}function y(){var b=a.location.pathname;F.ignoreUrlCasing&&(b=b.toLowerCase());var c=a.location.protocol+"//"+a.location.host+b;return c.length>800&&(c=c.substring(0,800)),{url:c,userAgent:navigator.userAgent,timing:w(a.performance.timing,0),size:0}}function z(b,c,d){F.ignoreUrlCasing&&(b=b.toLowerCase());var e=a.location.protocol+"//"+a.location.host+b;return e.length>800&&(e=e.substring(0,800)),{url:e,userAgent:navigator.userAgent,timing:v(c,d),size:0}}function A(b,c){var d=b.name.split("?")[0];return F.ignoreUrlCasing&&(d=d.toLowerCase()),d.length>800&&(d=d.substring(0,800)),{url:d,timing:x(b,c?0:a.performance.timing.navigationStart),size:b.decodedBodySize||0}}function B(b,c){if(void 0!==a.performance&&a.performance.getEntries)try{for(var d=a.performance.getEntries(),e=F.offset;e<d.length;e++){var f=d[e].name.split("?")[0];0!==f.indexOf(F.apiUrl)&&(f.indexOf("favicon.ico")>0||0!==f.indexOf("about:blank")&&("j"===f[0]&&1===f.indexOf("avascript:")||0!==f.indexOf("chrome-extension://")&&0!==f.indexOf("res://")&&0!==f.indexOf("file://")&&b.push(A(d[e],c))))}F.offset=d.length}catch(g){}}function C(b,c,d){if(void 0===a.performance||void 0===a.performance.timing||void 0===a.performance.timing.fetchStart||isNaN(a.performance.timing.fetchStart))return null;var e=[];if(c&&(d&&e.push(y()),B(e)),b){F.pendingVirtualPage&&(e.push(F.pendingVirtualPage),B(e,!0));var f=null==F.pendingVirtualPage;if(F.pendingVirtualPage=z(b,F.previousVirtualPageLoadTimestamp,F.initalStaticPageLoadTimestamp),!f&&e.length>0)return e}return e}function D(a){return Math.round(Math.pow(36,a+1)-Math.random()*Math.pow(36,a)).toString(36).slice(1)}function E(b,c){a.console&&a.console.log&&F.debugMode&&(a.console.log(b),c&&a.console.log(c))}var F=this,G={};this.cookieName="raygun4js-sid",this.apiKey=b,this.apiUrl=c,this.debugMode=j,this.excludedHostNames=h,this.excludedUserAgents=i,this.maxVirtualPageDuration=k||18e5,this.ignoreUrlCasing=l,this.customTimingsEnabled=m,this.pendingPerformancePayload=null,this.makePostCorsRequest=function(b,c){if(F.excludedUserAgents instanceof Array)for(var e in F.excludedUserAgents)if(F.excludedUserAgents.hasOwnProperty(e)&&navigator.userAgent.match(F.excludedUserAgents[e]))return void(F.debugMode&&E("Raygun4JS: cancelling send as error originates from an excluded user agent"));if(F.excludedHostNames instanceof Array)for(var f in F.excludedHostNames)if(F.excludedHostNames.hasOwnProperty(f)&&a.location.hostname&&a.location.hostname.match(F.excludedHostNames[f]))return void E("Raygun4JS: cancelling send as error originates from an excluded hostname");navigator.userAgent.match("RaygunPulseInsightsCrawler")||d(b,c)},this.sessionId=null,this.virtualPage=null,this.user=e,this.version=f,this.tags=g,this.heartBeatInterval=null,this.offset=0,this.attach=function(){o(function(a){F.pageLoaded(a)});var b=function(){this.updateCookieTimestamp()}.bind(G),c=function(){var a=[];if(B(a),F.pendingVirtualPage&&(a.push(F.pendingVirtualPage),B(a,!0)),a.length>0){var b={eventData:[{sessionId:F.sessionId,timestamp:(new Date).toISOString(),type:"web_request_timing",user:F.user,version:F.version||"Not supplied",device:navigator.userAgent,tags:F.tags,data:JSON.stringify(a)}]};F.makePostCorsRequest(F.apiUrl+"/events?apikey="+encodeURIComponent(F.apiKey),JSON.stringify(b))}},d=function(){"visible"===document.visibilityState&&this.updateCookieTimestamp()}.bind(G);a.addEventListener?(a.addEventListener("click",b),document.addEventListener("visibilitychange",d),a.addEventListener("beforeunload",c)):a.attachEvent&&document.attachEvent("onclick",b)},this.pageLoaded=function(b){if(b){var c={eventData:[{sessionId:F.sessionId,timestamp:(new Date).toISOString(),type:"session_start",user:F.user,version:F.version||"Not supplied",tags:F.tags,device:navigator.userAgent}]};F.makePostCorsRequest(F.apiUrl+"/events?apikey="+encodeURIComponent(F.apiKey),JSON.stringify(c))}F.sendPerformance(!0,!0),F.heartBeat(),"object"==typeof a.performance&&"function"==typeof a.performance.now?F.initalStaticPageLoadTimestamp=a.performance.now():F.initalStaticPageLoadTimestamp=0},this.sendCustomTimings=function(a){if("object"==typeof a&&("number"==typeof a.custom1||"number"==typeof a.custom2||"number"==typeof a.custom3||"number"==typeof a.custom4||"number"==typeof a.custom5||"number"==typeof a.custom6||"number"==typeof a.custom7||"number"==typeof a.custom8||"number"==typeof a.custom9||"number"==typeof a.custom10)&&F.pendingPerformancePayload){var b=JSON.parse(F.pendingPerformancePayload),c=JSON.parse(b.eventData[0].data);c[0].customTiming=a,b.eventData[0].data=JSON.stringify(c),F.makePostCorsRequest(F.apiUrl+"/events?apikey="+encodeURIComponent(F.apiKey),JSON.stringify(b)),F.pendingPerformancePayload=null}},this.setUser=function(a){F.user=a},this.withTags=function(a){F.tags=a},this.endSession=function(){var a={eventData:[{sessionId:F.sessionId,timestamp:(new Date).toISOString(),type:"session_end"}]};F.makePostCorsRequest(F.apiUrl+"/events?apikey="+encodeURIComponent(F.apiKey),JSON.stringify(a))},this.heartBeat=function(){F.heartBeatInterval=setInterval(function(){var a,b=[];if(B(b,F.virtualPage),b.length>0){var c=JSON.stringify(b);n(c)<128e3&&(a={eventData:[{sessionId:F.sessionId,timestamp:(new Date).toISOString(),type:"web_request_timing",user:F.user,version:F.version||"Not supplied",device:navigator.userAgent,tags:F.tags,data:c}]})}void 0!==a&&F.makePostCorsRequest(F.apiUrl+"/events?apikey="+encodeURIComponent(F.apiKey),JSON.stringify(a))},3e4)},this.virtualPageLoaded=function(b){var c=null==this.virtualPage;"string"==typeof b&&(b.length>0&&"/"!==b[0]&&(b+="/"),b.length>800&&(b=b.substring(0,800)),this.virtualPage=b),c?this.sendPerformance(!0,!1):this.sendPerformance(!1,!1),"string"==typeof b&&("object"==typeof a.performance&&"function"==typeof a.performance.now?this.previousVirtualPageLoadTimestamp=a.performance.now():this.previousVirtualPageLoadTimestamp=0)},this.sendPerformance=function(a,b){var c=C(this.virtualPage,a,b);if(null!==c){var d={eventData:[{sessionId:F.sessionId,timestamp:(new Date).toISOString(),type:"web_request_timing",user:F.user,version:F.version||"Not supplied",device:navigator.userAgent,tags:F.tags,data:JSON.stringify(c)}]};F.customTimingsEnabled?F.pendingPerformancePayload=JSON.stringify(d):F.makePostCorsRequest(F.apiUrl+"/events?apikey="+encodeURIComponent(F.apiKey),JSON.stringify(d))}},G.updateCookieTimestamp=s}};raygunRumFactory(window,window.jQuery,window.__instantiatedRaygun),function(a,b){if(a.RaygunObject&&a[a.RaygunObject]){var c,d,e,f,g,h,i=a[a.RaygunObject].o,j=!1,k=!1,l=[],m=["function (b,c,d,f,g){","||(g=new Error(b)),a[e].q=a[e].q||[]"];c=a[a.RaygunObject].q;var n=b,o=["trackEvent","send","recordBreadcrumb"],p=function(){i=a[a.RaygunObject].o;for(var b in i){var c=i[b];c&&(o.indexOf(c[0])===-1?q(c):l.push(c))}},q=function(a){var b=a[0],c=a[1];if(b)switch(b){case"boot":s();break;case"noConflict":h=c;break;case"apiKey":d=c,j=!0;break;case"options":e=c;break;case"attach":case"enableCrashReporting":f=c,j=!0;break;case"enablePulse":g=c,j=!0;break;case"detach":n.detach();break;case"getRaygunInstance":return n;case"setUser":n.setUser(c.identifier,c.isAnonymous,c.email,c.fullName,c.firstName,c.uuid);break;case"onBeforeSend":n.onBeforeSend(c);break;case"onBeforeXHR":n.onBeforeXHR(c);break;case"onAfterSend":n.onAfterSend(c);break;case"withCustomData":n.withCustomData(c);break;case"withTags":n.withTags(c);break;case"setVersion":n.setVersion(c);break;case"filterSensitiveData":n.filterSensitiveData(c);break;case"setFilterScope":n.setFilterScope(c);break;case"whitelistCrossOriginDomains":n.whitelistCrossOriginDomains(c);break;case"saveIfOffline":"boolean"==typeof c&&n.saveIfOffline(c);break;case"groupingKey":n.groupingKey(c);break;case"send":var i,k,l;c.error?(i=c.error,c.tags&&(k=c.tags),c.customData&&(l=c.customData)):i=c,n.send(i,l,k);break;case"trackEvent":c.type&&c.path?n.trackEvent(c.type,{path:c.path}):c.type&&c.timings&&n.trackEvent(c.type,{timings:c.timings});break;case"recordBreadcrumb":n.recordBreadcrumb(a[1],a[2]);break;case"enableAutoBreadcrumbs":n.enableAutoBreadcrumbs();break;case"disableAutoBreadcrumbs":n.disableAutoBreadcrumbs();break;case"enableAutoBreadcrumbsConsole":n.enableAutoBreadcrumbs("Console");break;case"disableAutoBreadcrumbsConsole":n.disableAutoBreadcrumbs("Console");break;case"enableAutoBreadcrumbsNavigation":n.enableAutoBreadcrumbs("Navigation");break;case"disableAutoBreadcrumbsNavigation":n.disableAutoBreadcrumbs("Navigation");break;case"enableAutoBreadcrumbsClicks":n.enableAutoBreadcrumbs("Clicks");break;case"disableAutoBreadcrumbsClicks":n.disableAutoBreadcrumbs("Clicks");break;case"enableAutoBreadcrumbsXHR":n.enableAutoBreadcrumbs("XHR");break;case"disableAutoBreadcrumbsXHR":n.disableAutoBreadcrumbs("XHR");break;case"setBreadcrumbLevel":n.setBreadcrumbOption("breadcrumbsLevel",a[1]);break;case"setAutoBreadcrumbsXHRIgnoredHosts":n.setBreadcrumbOption("xhrIgnoredHosts",a[1]);break;case"logContentsOfXhrCalls":n.setBreadcrumbOption("logXhrContents",a[1])}},r=function(){a[a.RaygunObject]=function(){return q(arguments)},k=!0},s=function(){if(p(),h&&(n=b.noConflict()),d&&(e||(e={}),g&&(e.disablePulse=!1),e.from="onLoad",n.init(d,e,null)),f){n.attach(),c=a[a.RaygunObject].q;for(var i in c)n.send(c[i].e,{handler:"From Raygun4JS snippet global error handler"})}else if("function"==typeof a.onerror){var j=a.onerror.toString();j.indexOf(m[0])!==-1&&j.indexOf(m[1])!==-1&&(a.onerror=null)}for(var o in l)q(l[o]);l=[],k||r(),a[a.RaygunObject].q=c};b.Utilities.isReactNative()?r():"complete"===document.readyState?s():a.addEventListener?a.addEventListener("load",s):a.attachEvent("onload",s)}}(window,window.__instantiatedRaygun);try{delete window.__instantiatedRaygun}catch(e){window.__instantiatedRaygun=void 0}
//# sourceMappingURL=raygun.min.js.map
/*!
 * angular-translate - v2.15.1 - 2017-03-04
 * 
 * Copyright (c) 2017 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(a,b){"function"==typeof define&&define.amd?define([],function(){return b()}):"object"==typeof exports?module.exports=b():b()}(this,function(){function a(a){"use strict";var b=a.storageKey(),c=a.storage(),d=function(){var d=a.preferredLanguage();angular.isString(d)?a.use(d):c.put(b,a.use())};d.displayName="fallbackFromIncorrectStorageValue",c?c.get(b)?a.use(c.get(b)).catch(d):d():angular.isString(a.preferredLanguage())&&a.use(a.preferredLanguage())}function b(){"use strict";var a,b,c,d=null,e=!1,f=!1;c={sanitize:function(a,b){return"text"===b&&(a=h(a)),a},escape:function(a,b){return"text"===b&&(a=g(a)),a},sanitizeParameters:function(a,b){return"params"===b&&(a=j(a,h)),a},escapeParameters:function(a,b){return"params"===b&&(a=j(a,g)),a},sce:function(a,b,c){return"text"===b?a=i(a):"params"===b&&"filter"!==c&&(a=j(a,g)),a},sceParameters:function(a,b){return"params"===b&&(a=j(a,i)),a}},c.escaped=c.escapeParameters,this.addStrategy=function(a,b){return c[a]=b,this},this.removeStrategy=function(a){return delete c[a],this},this.useStrategy=function(a){return e=!0,d=a,this},this.$get=["$injector","$log",function(g,h){var i={},j=function(a,b,d,e){return angular.forEach(e,function(e){if(angular.isFunction(e))a=e(a,b,d);else if(angular.isFunction(c[e]))a=c[e](a,b,d);else{if(!angular.isString(c[e]))throw new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+e+"'");if(!i[c[e]])try{i[c[e]]=g.get(c[e])}catch(a){throw i[c[e]]=function(){},new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+e+"'")}a=i[c[e]](a,b,d)}}),a},k=function(){e||f||(h.warn("pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details."),f=!0)};return g.has("$sanitize")&&(a=g.get("$sanitize")),g.has("$sce")&&(b=g.get("$sce")),{useStrategy:function(a){return function(b){a.useStrategy(b)}}(this),sanitize:function(a,b,c,e){if(d||k(),c||null===c||(c=d),!c)return a;e||(e="service");var f=angular.isArray(c)?c:[c];return j(a,b,e,f)}}}];var g=function(a){var b=angular.element("<div></div>");return b.text(a),b.html()},h=function(b){if(!a)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as 'escape'.");return a(b)},i=function(a){if(!b)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sce service.");return b.trustAsHtml(a)},j=function(a,b,c){if(angular.isDate(a))return a;if(angular.isObject(a)){var d=angular.isArray(a)?[]:{};if(c){if(c.indexOf(a)>-1)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object")}else c=[];return c.push(a),angular.forEach(a,function(a,e){angular.isFunction(a)||(d[e]=j(a,b,c))}),c.splice(-1,1),d}return angular.isNumber(a)?a:angular.isUndefined(a)||null===a?a:b(a)}}function c(a,b,c,d){"use strict";var e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u={},v=[],w=a,x=[],y="translate-cloak",z=!1,A=!1,B=".",C=!1,D=!1,E=0,F=!0,G="default",H={default:function(a){return(a||"").split("-").join("_")},java:function(a){var b=(a||"").split("-").join("_"),c=b.split("_");return c.length>1?c[0].toLowerCase()+"_"+c[1].toUpperCase():b},bcp47:function(a){var b=(a||"").split("_").join("-"),c=b.split("-");return c.length>1?c[0].toLowerCase()+"-"+c[1].toUpperCase():b},"iso639-1":function(a){var b=(a||"").split("_").join("-"),c=b.split("-");return c[0].toLowerCase()}},I="2.15.1",J=function(){if(angular.isFunction(d.getLocale))return d.getLocale();var a,c,e=b.$get().navigator,f=["language","browserLanguage","systemLanguage","userLanguage"];if(angular.isArray(e.languages))for(a=0;a<e.languages.length;a++)if(c=e.languages[a],c&&c.length)return c;for(a=0;a<f.length;a++)if(c=e[f[a]],c&&c.length)return c;return null};J.displayName="angular-translate/service: getFirstBrowserLanguage";var K=function(){var a=J()||"";return H[G]&&(a=H[G](a)),a};K.displayName="angular-translate/service: getLocale";var L=function(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1},M=function(){return this.toString().replace(/^\s+|\s+$/g,"")},N=function(a){if(a){for(var b=[],c=angular.lowercase(a),d=0,e=v.length;d<e;d++)b.push(angular.lowercase(v[d]));if(L(b,c)>-1)return a;if(f){var g;for(var h in f)if(f.hasOwnProperty(h)){var i=!1,j=Object.prototype.hasOwnProperty.call(f,h)&&angular.lowercase(h)===angular.lowercase(a);if("*"===h.slice(-1)&&(i=h.slice(0,-1)===a.slice(0,h.length-1)),(j||i)&&(g=f[h],L(b,angular.lowercase(g))>-1))return g}}var k=a.split("_");return k.length>1&&L(b,angular.lowercase(k[0]))>-1?k[0]:void 0}},O=function(a,b){if(!a&&!b)return u;if(a&&!b){if(angular.isString(a))return u[a]}else angular.isObject(u[a])||(u[a]={}),angular.extend(u[a],P(b));return this};this.translations=O,this.cloakClassName=function(a){return a?(y=a,this):y},this.nestedObjectDelimeter=function(a){return a?(B=a,this):B};var P=function(a,b,c,d){var e,f,g,h;b||(b=[]),c||(c={});for(e in a)Object.prototype.hasOwnProperty.call(a,e)&&(h=a[e],angular.isObject(h)?P(h,b.concat(e),c,e):(f=b.length?""+b.join(B)+B+e:e,b.length&&e===d&&(g=""+b.join(B),c[g]="@:"+f),c[f]=h));return c};P.displayName="flatObject",this.addInterpolation=function(a){return x.push(a),this},this.useMessageFormatInterpolation=function(){return this.useInterpolation("$translateMessageFormatInterpolation")},this.useInterpolation=function(a){return n=a,this},this.useSanitizeValueStrategy=function(a){return c.useStrategy(a),this},this.preferredLanguage=function(a){return a?(Q(a),this):e};var Q=function(a){return a&&(e=a),e};this.translationNotFoundIndicator=function(a){return this.translationNotFoundIndicatorLeft(a),this.translationNotFoundIndicatorRight(a),this},this.translationNotFoundIndicatorLeft=function(a){return a?(q=a,this):q},this.translationNotFoundIndicatorRight=function(a){return a?(r=a,this):r},this.fallbackLanguage=function(a){return R(a),this};var R=function(a){return a?(angular.isString(a)?(h=!0,g=[a]):angular.isArray(a)&&(h=!1,g=a),angular.isString(e)&&L(g,e)<0&&g.push(e),this):h?g[0]:g};this.use=function(a){if(a){if(!u[a]&&!o)throw new Error("$translateProvider couldn't find translationTable for langKey: '"+a+"'");return i=a,this}return i},this.resolveClientLocale=function(){return K()};var S=function(a){return a?(w=a,this):l?l+w:w};this.storageKey=S,this.useUrlLoader=function(a,b){return this.useLoader("$translateUrlLoader",angular.extend({url:a},b))},this.useStaticFilesLoader=function(a){return this.useLoader("$translateStaticFilesLoader",a)},this.useLoader=function(a,b){return o=a,p=b||{},this},this.useLocalStorage=function(){return this.useStorage("$translateLocalStorage")},this.useCookieStorage=function(){return this.useStorage("$translateCookieStorage")},this.useStorage=function(a){return k=a,this},this.storagePrefix=function(a){return a?(l=a,this):a},this.useMissingTranslationHandlerLog=function(){return this.useMissingTranslationHandler("$translateMissingTranslationHandlerLog")},this.useMissingTranslationHandler=function(a){return m=a,this},this.usePostCompiling=function(a){return z=!!a,this},this.forceAsyncReload=function(a){return A=!!a,this},this.uniformLanguageTag=function(a){return a?angular.isString(a)&&(a={standard:a}):a={},G=a.standard,this},this.determinePreferredLanguage=function(a){var b=a&&angular.isFunction(a)?a():K();return e=v.length?N(b)||b:b,this},this.registerAvailableLanguageKeys=function(a,b){return a?(v=a,b&&(f=b),this):v},this.useLoaderCache=function(a){return a===!1?s=void 0:a===!0?s=!0:"undefined"==typeof a?s="$translationCache":a&&(s=a),this},this.directivePriority=function(a){return void 0===a?E:(E=a,this)},this.statefulFilter=function(a){return void 0===a?F:(F=a,this)},this.postProcess=function(a){return t=a?a:void 0,this},this.keepContent=function(a){return D=!!a,this},this.$get=["$log","$injector","$rootScope","$q",function(a,b,c,d){var f,l,G,H=b.get(n||"$translateDefaultInterpolation"),J=!1,T={},U={},V=function(a,b,c,h,j){!i&&e&&(i=e);var m=j&&j!==i?N(j)||j:i;if(j&&ka(j),angular.isArray(a)){var n=function(a){for(var e={},f=[],g=function(a){var f=d.defer(),g=function(b){e[a]=b,f.resolve([a,b])};return V(a,b,c,h,j).then(g,g),f.promise},i=0,k=a.length;i<k;i++)f.push(g(a[i]));return d.all(f).then(function(){return e})};return n(a)}var o=d.defer();a&&(a=M.apply(a));var p=function(){var a=e?U[e]:U[m];if(l=0,k&&!a){var b=f.get(w);if(a=U[b],g&&g.length){var c=L(g,b);l=0===c?1:0,L(g,e)<0&&g.push(e)}}return a}();if(p){var q=function(){j||(m=i),ga(a,b,c,h,m).then(o.resolve,o.reject)};q.displayName="promiseResolved",p.finally(q).catch(angular.noop)}else ga(a,b,c,h,m).then(o.resolve,o.reject);return o.promise},W=function(a){return q&&(a=[q,a].join(" ")),r&&(a=[a,r].join(" ")),a},X=function(a){i=a,k&&f.put(V.storageKey(),i),c.$emit("$translateChangeSuccess",{language:a}),H.setLocale(i);var b=function(a,b){T[b].setLocale(i)};b.displayName="eachInterpolatorLocaleSetter",angular.forEach(T,b),c.$emit("$translateChangeEnd",{language:a})},Y=function(a){if(!a)throw"No language key specified for loading.";var e=d.defer();c.$emit("$translateLoadingStart",{language:a}),J=!0;var f=s;"string"==typeof f&&(f=b.get(f));var g=angular.extend({},p,{key:a,$http:angular.extend({},{cache:f},p.$http)}),h=function(b){var d={};c.$emit("$translateLoadingSuccess",{language:a}),angular.isArray(b)?angular.forEach(b,function(a){angular.extend(d,P(a))}):angular.extend(d,P(b)),J=!1,e.resolve({key:a,table:d}),c.$emit("$translateLoadingEnd",{language:a})};h.displayName="onLoaderSuccess";var i=function(a){c.$emit("$translateLoadingError",{language:a}),e.reject(a),c.$emit("$translateLoadingEnd",{language:a})};return i.displayName="onLoaderError",b.get(o)(g).then(h,i),e.promise};if(k&&(f=b.get(k),!f.get||!f.put))throw new Error("Couldn't use storage '"+k+"', missing get() or put() method!");if(x.length){var Z=function(a){var c=b.get(a);c.setLocale(e||i),T[c.getInterpolationIdentifier()]=c};Z.displayName="interpolationFactoryAdder",angular.forEach(x,Z)}var $=function(a){var b=d.defer();if(Object.prototype.hasOwnProperty.call(u,a))b.resolve(u[a]);else if(U[a]){var c=function(a){O(a.key,a.table),b.resolve(a.table)};c.displayName="translationTableResolver",U[a].then(c,b.reject)}else b.reject();return b.promise},_=function(a,b,c,e,f){var g=d.defer(),h=function(d){if(Object.prototype.hasOwnProperty.call(d,b)&&null!==d[b]){e.setLocale(a);var h=d[b];if("@:"===h.substr(0,2))_(a,h.substr(2),c,e,f).then(g.resolve,g.reject);else{var j=e.interpolate(d[b],c,"service",f,b);j=ja(b,d[b],j,c,a),g.resolve(j)}e.setLocale(i)}else g.reject()};return h.displayName="fallbackTranslationResolver",$(a).then(h,g.reject),g.promise},aa=function(a,b,c,d,e){var f,g=u[a];if(g&&Object.prototype.hasOwnProperty.call(g,b)&&null!==g[b]){if(d.setLocale(a),f=d.interpolate(g[b],c,"filter",e,b),f=ja(b,g[b],f,c,a,e),!angular.isString(f)&&angular.isFunction(f.$$unwrapTrustedValue)){var h=f.$$unwrapTrustedValue();if("@:"===h.substr(0,2))return aa(a,h.substr(2),c,d,e)}else if("@:"===f.substr(0,2))return aa(a,f.substr(2),c,d,e);d.setLocale(i)}return f},ba=function(a,c,d,e){return m?b.get(m)(a,i,c,d,e):a},ca=function(a,b,c,e,f,h){var i=d.defer();if(a<g.length){var j=g[a];_(j,b,c,e,h).then(function(a){i.resolve(a)},function(){return ca(a+1,b,c,e,f,h).then(i.resolve,i.reject)})}else if(f)i.resolve(f);else{var k=ba(b,c,f);m&&k?i.resolve(k):i.reject(W(b))}return i.promise},da=function(a,b,c,d,e){var f;if(a<g.length){var h=g[a];f=aa(h,b,c,d,e),f||""===f||(f=da(a+1,b,c,d))}return f},ea=function(a,b,c,d,e){return ca(G>0?G:l,a,b,c,d,e)},fa=function(a,b,c,d){return da(G>0?G:l,a,b,c,d)},ga=function(a,b,c,e,f,h){var i=d.defer(),j=f?u[f]:u,k=c?T[c]:H;if(j&&Object.prototype.hasOwnProperty.call(j,a)&&null!==j[a]){var l=j[a];if("@:"===l.substr(0,2))V(l.substr(2),b,c,e,f).then(i.resolve,i.reject);else{var n=k.interpolate(l,b,"service",h,a);n=ja(a,l,n,b,f),i.resolve(n)}}else{var o;m&&!J&&(o=ba(a,b,e)),f&&g&&g.length?ea(a,b,k,e,h).then(function(a){i.resolve(a)},function(a){i.reject(W(a))}):m&&!J&&o?e?i.resolve(e):i.resolve(o):e?i.resolve(e):i.reject(W(a))}return i.promise},ha=function(a,b,c,d,e){var f,h=d?u[d]:u,i=H;if(T&&Object.prototype.hasOwnProperty.call(T,c)&&(i=T[c]),h&&Object.prototype.hasOwnProperty.call(h,a)&&null!==h[a]){var j=h[a];"@:"===j.substr(0,2)?f=ha(j.substr(2),b,c,d,e):(f=i.interpolate(j,b,"filter",e,a),f=ja(a,j,f,b,d,e))}else{var k;m&&!J&&(k=ba(a,b,e)),d&&g&&g.length?(l=0,f=fa(a,b,i,e)):f=m&&!J&&k?k:W(a)}return f},ia=function(a){j===a&&(j=void 0),U[a]=void 0},ja=function(a,c,d,e,f,g){var h=t;return h&&("string"==typeof h&&(h=b.get(h)),h)?h(a,c,d,e,f,g):d},ka=function(a){u[a]||!o||U[a]||(U[a]=Y(a).then(function(a){return O(a.key,a.table),a}))};V.preferredLanguage=function(a){return a&&Q(a),e},V.cloakClassName=function(){return y},V.nestedObjectDelimeter=function(){return B},V.fallbackLanguage=function(a){if(void 0!==a&&null!==a){if(R(a),o&&g&&g.length)for(var b=0,c=g.length;b<c;b++)U[g[b]]||(U[g[b]]=Y(g[b]));V.use(V.use())}return h?g[0]:g},V.useFallbackLanguage=function(a){if(void 0!==a&&null!==a)if(a){var b=L(g,a);b>-1&&(G=b)}else G=0},V.proposedLanguage=function(){return j},V.storage=function(){return f},V.negotiateLocale=N,V.use=function(a){if(!a)return i;var b=d.defer();b.promise.then(null,angular.noop),c.$emit("$translateChangeStart",{language:a});var e=N(a);return v.length>0&&!e?d.reject(a):(e&&(a=e),j=a,!A&&u[a]||!o||U[a]?U[a]?U[a].then(function(a){return j===a.key&&X(a.key),b.resolve(a.key),a},function(a){return!i&&g&&g.length>0&&g[0]!==a?V.use(g[0]).then(b.resolve,b.reject):b.reject(a)}):(b.resolve(a),X(a)):(U[a]=Y(a).then(function(c){return O(c.key,c.table),b.resolve(c.key),j===a&&X(c.key),c},function(a){return c.$emit("$translateChangeError",{language:a}),b.reject(a),c.$emit("$translateChangeEnd",{language:a}),d.reject(a)}),U[a].finally(function(){ia(a)}).catch(angular.noop)),b.promise)},V.resolveClientLocale=function(){return K()},V.storageKey=function(){return S()},V.isPostCompilingEnabled=function(){return z},V.isForceAsyncReloadEnabled=function(){return A},V.isKeepContent=function(){return D},V.refresh=function(a){function b(a){var b=Y(a);return U[a]=b,b.then(function(b){u[a]={},O(a,b.table),f[a]=!0},angular.noop),b}if(!o)throw new Error("Couldn't refresh translation table, no loader registered!");c.$emit("$translateRefreshStart",{language:a});var e=d.defer(),f={};if(e.promise.then(function(){for(var a in u)u.hasOwnProperty(a)&&(a in f||delete u[a]);i&&X(i)},angular.noop).finally(function(){c.$emit("$translateRefreshEnd",{language:a})}),a)u[a]?b(a).then(e.resolve,e.reject):e.reject();else{var h=g&&g.slice()||[];i&&h.indexOf(i)===-1&&h.push(i),d.all(h.map(b)).then(e.resolve,e.reject)}return e.promise},V.instant=function(a,b,c,d,f){var h=d&&d!==i?N(d)||d:i;if(null===a||angular.isUndefined(a))return a;if(d&&ka(d),angular.isArray(a)){for(var j={},k=0,l=a.length;k<l;k++)j[a[k]]=V.instant(a[k],b,c,d,f);return j}if(angular.isString(a)&&a.length<1)return a;a&&(a=M.apply(a));var n,o=[];e&&o.push(e),h&&o.push(h),g&&g.length&&(o=o.concat(g));for(var p=0,s=o.length;p<s;p++){var t=o[p];if(u[t]&&"undefined"!=typeof u[t][a]&&(n=ha(a,b,c,h,f)),"undefined"!=typeof n)break}if(!n&&""!==n)if(q||r)n=W(a);else{n=H.interpolate(a,b,"filter",f);var v;m&&!J&&(v=ba(a,b,f)),m&&!J&&v&&(n=v)}return n},V.versionInfo=function(){return I},V.loaderCache=function(){return s},V.directivePriority=function(){return E},V.statefulFilter=function(){return F},V.isReady=function(){return C};var la=d.defer();la.promise.then(function(){C=!0}),V.onReady=function(a){var b=d.defer();return angular.isFunction(a)&&b.promise.then(a),C?b.resolve():la.promise.then(b.resolve),b.promise},V.getAvailableLanguageKeys=function(){return v.length>0?v:null},V.getTranslationTable=function(a){return a=a||V.use(),a&&u[a]?angular.copy(u[a]):null};var ma=c.$on("$translateReady",function(){la.resolve(),ma(),ma=null}),na=c.$on("$translateChangeEnd",function(){la.resolve(),na(),na=null});if(o){if(angular.equals(u,{})&&V.use()&&V.use(V.use()),g&&g.length)for(var oa=function(a){return O(a.key,a.table),c.$emit("$translateChangeEnd",{language:a.key}),a},pa=0,qa=g.length;pa<qa;pa++){var ra=g[pa];!A&&u[ra]||(U[ra]=Y(ra).then(oa))}}else c.$emit("$translateReady",{language:V.use()});return V}]}function d(a,b){"use strict";var c,d={},e="default";return d.setLocale=function(a){c=a},d.getInterpolationIdentifier=function(){return e},d.useSanitizeValueStrategy=function(a){return b.useStrategy(a),this},d.interpolate=function(c,d,e,f,g){d=d||{},d=b.sanitize(d,"params",f,e);var h;return angular.isNumber(c)?h=""+c:angular.isString(c)?(h=a(c)(d),h=b.sanitize(h,"text",f,e)):h="",h},d}function e(a,b,c,d,e){"use strict";var g=function(){return this.toString().replace(/^\s+|\s+$/g,"")};return{restrict:"AE",scope:!0,priority:a.directivePriority(),compile:function(h,i){var j=i.translateValues?i.translateValues:void 0,k=i.translateInterpolation?i.translateInterpolation:void 0,l=h[0].outerHTML.match(/translate-value-+/i),m="^(.*)("+b.startSymbol()+".*"+b.endSymbol()+")(.*)",n="^(.*)"+b.startSymbol()+"(.*)"+b.endSymbol()+"(.*)";return function(h,o,p){h.interpolateParams={},h.preText="",h.postText="",h.translateNamespace=f(h);var q={},r=function(a,b,c){if(b.translateValues&&angular.extend(a,d(b.translateValues)(h.$parent)),l)for(var e in c)if(Object.prototype.hasOwnProperty.call(b,e)&&"translateValue"===e.substr(0,14)&&"translateValues"!==e){var f=angular.lowercase(e.substr(14,1))+e.substr(15);a[f]=c[e]}},s=function(a){if(angular.isFunction(s._unwatchOld)&&(s._unwatchOld(),s._unwatchOld=void 0),angular.equals(a,"")||!angular.isDefined(a)){var c=g.apply(o.text()),d=c.match(m);if(angular.isArray(d)){h.preText=d[1],h.postText=d[3],q.translate=b(d[2])(h.$parent);var e=c.match(n);angular.isArray(e)&&e[2]&&e[2].length&&(s._unwatchOld=h.$watch(e[2],function(a){q.translate=a,y()}))}else q.translate=c?c:void 0}else q.translate=a;y()},t=function(a){p.$observe(a,function(b){q[a]=b,y()})};r(h.interpolateParams,p,i);var u=!0;p.$observe("translate",function(a){"undefined"==typeof a?s(""):""===a&&u||(q.translate=a,y()),u=!1});for(var v in p)p.hasOwnProperty(v)&&"translateAttr"===v.substr(0,13)&&v.length>13&&t(v);if(p.$observe("translateDefault",function(a){h.defaultText=a,y()}),j&&p.$observe("translateValues",function(a){a&&h.$parent.$watch(function(){angular.extend(h.interpolateParams,d(a)(h.$parent))})}),l){var w=function(a){p.$observe(a,function(b){var c=angular.lowercase(a.substr(14,1))+a.substr(15);h.interpolateParams[c]=b})};for(var x in p)Object.prototype.hasOwnProperty.call(p,x)&&"translateValue"===x.substr(0,14)&&"translateValues"!==x&&w(x)}var y=function(){for(var a in q)q.hasOwnProperty(a)&&void 0!==q[a]&&z(a,q[a],h,h.interpolateParams,h.defaultText,h.translateNamespace)},z=function(b,c,d,e,f,g){c?(g&&"."===c.charAt(0)&&(c=g+c),a(c,e,k,f,d.translateLanguage).then(function(a){A(a,d,!0,b)},function(a){A(a,d,!1,b)})):A(c,d,!1,b)},A=function(b,d,e,f){if(e||"undefined"!=typeof d.defaultText&&(b=d.defaultText),"translate"===f){(e||!e&&!a.isKeepContent()&&"undefined"==typeof p.translateKeepContent)&&o.empty().append(d.preText+b+d.postText);var g=a.isPostCompilingEnabled(),h="undefined"!=typeof i.translateCompile,j=h&&"false"!==i.translateCompile;(g&&!h||j)&&c(o.contents())(d)}else{var k=p.$attr[f];"data-"===k.substr(0,5)&&(k=k.substr(5)),k=k.substr(15),o.attr(k,b)}};(j||l||p.translateDefault)&&h.$watch("interpolateParams",y,!0),h.$on("translateLanguageChanged",y);var B=e.$on("$translateChangeSuccess",y);o.text().length?s(p.translate?p.translate:""):p.translate&&s(p.translate),y(),h.$on("$destroy",B)}}}}function f(a){"use strict";return a.translateNamespace?a.translateNamespace:a.$parent?f(a.$parent):void 0}function g(a,b){"use strict";return{restrict:"A",priority:a.directivePriority(),link:function(c,d,e){var f,g,i={},j=function(){angular.forEach(f,function(b,f){b&&(i[f]=!0,c.translateNamespace&&"."===b.charAt(0)&&(b=c.translateNamespace+b),a(b,g,e.translateInterpolation,void 0,c.translateLanguage).then(function(a){d.attr(f,a)},function(a){d.attr(f,a)}))}),angular.forEach(i,function(a,b){f[b]||(d.removeAttr(b),delete i[b])})};h(c,e.translateAttr,function(a){f=a},j),h(c,e.translateValues,function(a){g=a},j),e.translateValues&&c.$watch(e.translateValues,j,!0),c.$on("translateLanguageChanged",j);var k=b.$on("$translateChangeSuccess",j);j(),c.$on("$destroy",k)}}}function h(a,b,c,d){"use strict";b&&("::"===b.substr(0,2)?b=b.substr(2):a.$watch(b,function(a){c(a),d()},!0),c(a.$eval(b)))}function i(a,b){"use strict";return{compile:function(c){var d=function(b){b.addClass(a.cloakClassName())},e=function(b){b.removeClass(a.cloakClassName())};return d(c),function(c,f,g){var h=e.bind(this,f),i=d.bind(this,f);g.translateCloak&&g.translateCloak.length?(g.$observe("translateCloak",function(b){a(b).then(h,i)}),b.$on("$translateChangeSuccess",function(){a(g.translateCloak).then(h,i)})):a.onReady(h)}}}}function j(){"use strict";return{restrict:"A",scope:!0,compile:function(){return{pre:function(a,b,c){a.translateNamespace=f(a),a.translateNamespace&&"."===c.translateNamespace.charAt(0)?a.translateNamespace+=c.translateNamespace:a.translateNamespace=c.translateNamespace}}}}}function f(a){"use strict";return a.translateNamespace?a.translateNamespace:a.$parent?f(a.$parent):void 0}function k(){"use strict";return{restrict:"A",scope:!0,compile:function(){return function(a,b,c){c.$observe("translateLanguage",function(b){a.translateLanguage=b}),a.$watch("translateLanguage",function(){a.$broadcast("translateLanguageChanged")})}}}}function l(a,b){"use strict";var c=function(c,d,e,f){if(!angular.isObject(d)){var g=this||{__SCOPE_IS_NOT_AVAILABLE:"More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f"};d=a(d)(g)}return b.instant(c,d,e,f)};return b.statefulFilter()&&(c.$stateful=!0),c}function m(a){"use strict";return a("translations")}return a.$inject=["$translate"],c.$inject=["$STORAGE_KEY","$windowProvider","$translateSanitizationProvider","pascalprechtTranslateOverrider"],d.$inject=["$interpolate","$translateSanitization"],e.$inject=["$translate","$interpolate","$compile","$parse","$rootScope"],g.$inject=["$translate","$rootScope"],i.$inject=["$translate","$rootScope"],l.$inject=["$parse","$translate"],m.$inject=["$cacheFactory"],angular.module("pascalprecht.translate",["ng"]).run(a),a.displayName="runTranslate",angular.module("pascalprecht.translate").provider("$translateSanitization",b),angular.module("pascalprecht.translate").constant("pascalprechtTranslateOverrider",{}).provider("$translate",c),c.displayName="displayName",angular.module("pascalprecht.translate").factory("$translateDefaultInterpolation",d),d.displayName="$translateDefaultInterpolation",angular.module("pascalprecht.translate").constant("$STORAGE_KEY","NG_TRANSLATE_LANG_KEY"),angular.module("pascalprecht.translate").directive("translate",e),e.displayName="translateDirective",angular.module("pascalprecht.translate").directive("translateAttr",g),g.displayName="translateAttrDirective",angular.module("pascalprecht.translate").directive("translateCloak",i),i.displayName="translateCloakDirective",angular.module("pascalprecht.translate").directive("translateNamespace",j),j.displayName="translateNamespaceDirective",angular.module("pascalprecht.translate").directive("translateLanguage",k),k.displayName="translateLanguageDirective",angular.module("pascalprecht.translate").filter("translate",l),l.displayName="translateFilterFactory",angular.module("pascalprecht.translate").factory("$translationCache",m),m.displayName="$translationCache","pascalprecht.translate"});
/*!
 * angular-translate - v2.15.1 - 2017-03-04
 * 
 * Copyright (c) 2017 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(a,b){"function"==typeof define&&define.amd?define([],function(){return b()}):"object"==typeof exports?module.exports=b():b()}(this,function(){function a(a,b){"use strict";return function(c){if(!(c&&(angular.isArray(c.files)||angular.isString(c.prefix)&&angular.isString(c.suffix))))throw new Error("Couldn't load static files, no files and prefix or suffix specified!");c.files||(c.files=[{prefix:c.prefix,suffix:c.suffix}]);for(var d=function(d){if(!d||!angular.isString(d.prefix)||!angular.isString(d.suffix))throw new Error("Couldn't load static file, no prefix or suffix specified!");var e=[d.prefix,c.key,d.suffix].join("");return angular.isObject(c.fileMap)&&c.fileMap[e]&&(e=c.fileMap[e]),b(angular.extend({url:e,method:"GET"},c.$http)).then(function(a){return a.data},function(){return a.reject(c.key)})},e=[],f=c.files.length,g=0;g<f;g++)e.push(d({prefix:c.files[g].prefix,key:c.key,suffix:c.files[g].suffix}));return a.all(e).then(function(a){for(var b=a.length,c={},d=0;d<b;d++)for(var e in a[d])c[e]=a[d][e];return c})}}return a.$inject=["$q","$http"],angular.module("pascalprecht.translate").factory("$translateStaticFilesLoader",a),a.displayName="$translateStaticFilesLoader","pascalprecht.translate"});
/*!
 * ui-select
 * http://github.com/angular-ui/ui-select
 * Version: 0.11.1 - 2015-03-09T14:30:26.109Z
 * License: MIT
 */
!function(){"use strict";var e={TAB:9,ENTER:13,ESC:27,SPACE:32,LEFT:37,UP:38,RIGHT:39,DOWN:40,SHIFT:16,CTRL:17,ALT:18,PAGE_UP:33,PAGE_DOWN:34,HOME:36,END:35,BACKSPACE:8,DELETE:46,COMMAND:91,MAP:{91:"COMMAND",8:"BACKSPACE",9:"TAB",13:"ENTER",16:"SHIFT",17:"CTRL",18:"ALT",19:"PAUSEBREAK",20:"CAPSLOCK",27:"ESC",32:"SPACE",33:"PAGE_UP",34:"PAGE_DOWN",35:"END",36:"HOME",37:"LEFT",38:"UP",39:"RIGHT",40:"DOWN",43:"+",44:"PRINTSCREEN",45:"INSERT",46:"DELETE",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",59:";",61:"=",65:"A",66:"B",67:"C",68:"D",69:"E",70:"F",71:"G",72:"H",73:"I",74:"J",75:"K",76:"L",77:"M",78:"N",79:"O",80:"P",81:"Q",82:"R",83:"S",84:"T",85:"U",86:"V",87:"W",88:"X",89:"Y",90:"Z",96:"0",97:"1",98:"2",99:"3",100:"4",101:"5",102:"6",103:"7",104:"8",105:"9",106:"*",107:"+",109:"-",110:".",111:"/",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NUMLOCK",145:"SCROLLLOCK",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'"},isControl:function(t){var c=t.which;switch(c){case e.COMMAND:case e.SHIFT:case e.CTRL:case e.ALT:return!0}return t.metaKey?!0:!1},isFunctionKey:function(e){return e=e.which?e.which:e,e>=112&&123>=e},isVerticalMovement:function(t){return~[e.UP,e.DOWN].indexOf(t)},isHorizontalMovement:function(t){return~[e.LEFT,e.RIGHT,e.BACKSPACE,e.DELETE].indexOf(t)}};void 0===angular.element.prototype.querySelectorAll&&(angular.element.prototype.querySelectorAll=function(e){return angular.element(this[0].querySelectorAll(e))}),void 0===angular.element.prototype.closest&&(angular.element.prototype.closest=function(e){for(var t=this[0],c=t.matches||t.webkitMatchesSelector||t.mozMatchesSelector||t.msMatchesSelector;t;){if(c.bind(t)(e))return t;t=t.parentElement}return!1});var t=0,c=angular.module("ui.select",[]).constant("uiSelectConfig",{theme:"bootstrap",searchEnabled:!0,sortable:!1,placeholder:"",refreshDelay:1e3,closeOnSelect:!0,generateId:function(){return t++}}).service("uiSelectMinErr",function(){var e=angular.$$minErr("ui.select");return function(){var t=e.apply(this,arguments),c=t.message.replace(new RegExp("\nhttp://errors.angularjs.org/.*"),"");return new Error(c)}}).directive("uisTranscludeAppend",function(){return{link:function(e,t,c,i,l){l(e,function(e){t.append(e)})}}}).filter("highlight",function(){function e(e){return e.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}return function(t,c){return c&&t?t.replace(new RegExp(e(c),"gi"),'<span class="ui-select-highlight">$&</span>'):t}});c.service("RepeatParser",["uiSelectMinErr","$parse",function(e,t){var c=this;c.parse=function(c){var i=c.match(/^\s*(?:([\s\S]+?)\s+as\s+)?([\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);if(!i)throw e("iexp","Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",c);return{itemName:i[2],source:t(i[3]),trackByExp:i[4],modelMapper:t(i[1]||i[2])}},c.getGroupNgRepeatExpression=function(){return"$group in $select.groups"},c.getNgRepeatExpression=function(e,t,c,i){var l=e+" in "+(i?"$group.items":t);return c&&(l+=" track by "+c),l}}]),c.directive("uiSelectChoices",["uiSelectConfig","RepeatParser","uiSelectMinErr","$compile",function(e,t,c,i){return{restrict:"EA",require:"^uiSelect",replace:!0,transclude:!0,templateUrl:function(t){var c=t.parent().attr("theme")||e.theme;return c+"/choices.tpl.html"},compile:function(l,s){if(!s.repeat)throw c("repeat","Expected 'repeat' expression.");return function(l,s,a,n,r){var o=a.groupBy;if(n.parseRepeatAttr(a.repeat,o),n.disableChoiceExpression=a.uiDisableChoice,n.onHighlightCallback=a.onHighlight,o){var u=s.querySelectorAll(".ui-select-choices-group");if(1!==u.length)throw c("rows","Expected 1 .ui-select-choices-group but got '{0}'.",u.length);u.attr("ng-repeat",t.getGroupNgRepeatExpression())}var d=s.querySelectorAll(".ui-select-choices-row");if(1!==d.length)throw c("rows","Expected 1 .ui-select-choices-row but got '{0}'.",d.length);d.attr("ng-repeat",t.getNgRepeatExpression(n.parserResult.itemName,"$select.items",n.parserResult.trackByExp,o)).attr("ng-if","$select.open").attr("ng-mouseenter","$select.setActiveItem("+n.parserResult.itemName+")").attr("ng-click","$select.select("+n.parserResult.itemName+",false,$event)");var p=s.querySelectorAll(".ui-select-choices-row-inner");if(1!==p.length)throw c("rows","Expected 1 .ui-select-choices-row-inner but got '{0}'.",p.length);p.attr("uis-transclude-append",""),i(s,r)(l),l.$watch("$select.search",function(e){e&&!n.open&&n.multiple&&n.activate(!1,!0),n.activeIndex=n.tagging.isActivated?-1:0,n.refresh(a.refresh)}),a.$observe("refreshDelay",function(){var t=l.$eval(a.refreshDelay);n.refreshDelay=void 0!==t?t:e.refreshDelay})}}}}]),c.controller("uiSelectCtrl",["$scope","$element","$timeout","$filter","RepeatParser","uiSelectMinErr","uiSelectConfig",function(t,c,i,l,s,a,n){function r(){(f.resetSearchInput||void 0===f.resetSearchInput&&n.resetSearchInput)&&(f.search=v,f.selected&&f.items.length&&!f.multiple&&(f.activeIndex=f.items.indexOf(f.selected)))}function o(t){var c=!0;switch(t){case e.DOWN:!f.open&&f.multiple?f.activate(!1,!0):f.activeIndex<f.items.length-1&&f.activeIndex++;break;case e.UP:!f.open&&f.multiple?f.activate(!1,!0):(f.activeIndex>0||0===f.search.length&&f.tagging.isActivated&&f.activeIndex>-1)&&f.activeIndex--;break;case e.TAB:(!f.multiple||f.open)&&f.select(f.items[f.activeIndex],!0);break;case e.ENTER:f.open&&f.activeIndex>=0?f.select(f.items[f.activeIndex]):f.activate(!1,!0);break;case e.ESC:f.close();break;default:c=!1}return c}function u(t){function c(){switch(t){case e.LEFT:return~f.activeMatchIndex?o:a;case e.RIGHT:return~f.activeMatchIndex&&n!==a?r:(f.activate(),!1);case e.BACKSPACE:return~f.activeMatchIndex?(f.removeChoice(n),o):a;case e.DELETE:return~f.activeMatchIndex?(f.removeChoice(f.activeMatchIndex),n):!1}}var i=g(m[0]),l=f.selected.length,s=0,a=l-1,n=f.activeMatchIndex,r=f.activeMatchIndex+1,o=f.activeMatchIndex-1,u=n;return i>0||f.search.length&&t==e.RIGHT?!1:(f.close(),u=c(),f.activeMatchIndex=f.selected.length&&u!==!1?Math.min(a,Math.max(s,u)):-1,!0)}function d(e){if(void 0===e||void 0===f.search)return!1;var t=e.filter(function(e){return void 0===f.search.toUpperCase()||void 0===e?!1:e.toUpperCase()===f.search.toUpperCase()}).length>0;return t}function p(e,t){var c=-1;if(angular.isArray(e))for(var i=angular.copy(e),l=0;l<i.length;l++)if(void 0===f.tagging.fct)i[l]+" "+f.taggingLabel===t&&(c=l);else{var s=i[l];s.isTag=!0,angular.equals(s,t)&&(c=l)}return c}function g(e){return angular.isNumber(e.selectionStart)?e.selectionStart:e.value.length}function h(){var e=c.querySelectorAll(".ui-select-choices-content"),t=e.querySelectorAll(".ui-select-choices-row");if(t.length<1)throw a("choices","Expected multiple .ui-select-choices-row but got '{0}'.",t.length);if(!(f.activeIndex<0)){var i=t[f.activeIndex],l=i.offsetTop+i.clientHeight-e[0].scrollTop,s=e[0].offsetHeight;l>s?e[0].scrollTop+=l-s:l<i.clientHeight&&(f.isGrouped&&0===f.activeIndex?e[0].scrollTop=0:e[0].scrollTop-=i.clientHeight-l)}}var f=this,v="";f.placeholder=n.placeholder,f.search=v,f.activeIndex=0,f.activeMatchIndex=-1,f.items=[],f.selected=void 0,f.open=!1,f.focus=!1,f.focusser=void 0,f.disabled=!1,f.searchEnabled=n.searchEnabled,f.sortable=n.sortable,f.resetSearchInput=!0,f.multiple=void 0,f.refreshDelay=n.refreshDelay,f.disableChoiceExpression=void 0,f.tagging={isActivated:!1,fct:void 0},f.taggingTokens={isActivated:!1,tokens:void 0},f.lockChoiceExpression=void 0,f.closeOnSelect=!0,f.clickTriggeredSelect=!1,f.$filter=l,f.isEmpty=function(){return angular.isUndefined(f.selected)||null===f.selected||""===f.selected};var m=c.querySelectorAll("input.ui-select-search");if(1!==m.length)throw a("searchInput","Expected 1 input.ui-select-search but got '{0}'.",m.length);f.activate=function(e,t){f.disabled||f.open||(t||r(),f.focusser.prop("disabled",!0),f.open=!0,f.activeMatchIndex=-1,f.activeIndex=f.activeIndex>=f.items.length?0:f.activeIndex,-1===f.activeIndex&&f.taggingLabel!==!1&&(f.activeIndex=0),i(function(){f.search=e||f.search,m[0].focus()}))},f.findGroupByName=function(e){return f.groups&&f.groups.filter(function(t){return t.name===e})[0]},f.parseRepeatAttr=function(e,c){function i(e){f.groups=[],angular.forEach(e,function(e){var i=t.$eval(c),l=angular.isFunction(i)?i(e):e[i],s=f.findGroupByName(l);s?s.items.push(e):f.groups.push({name:l,items:[e]})}),f.items=[],f.groups.forEach(function(e){f.items=f.items.concat(e.items)})}function l(e){f.items=e}var n=c?i:l;f.parserResult=s.parse(e),f.isGrouped=!!c,f.itemProperty=f.parserResult.itemName,t.$watchCollection(f.parserResult.source,function(e){if(void 0===e||null===e)f.items=[];else{if(!angular.isArray(e))throw a("items","Expected an array but got '{0}'.",e);if(f.multiple){var t=e.filter(function(e){return f.selected.indexOf(e)<0});n(t)}else n(e);f.ngModel.$modelValue=null}}),f.multiple&&t.$watchCollection("$select.selected",function(e){var c=f.parserResult.source(t);if(e.length){if(void 0!==c){var i=c.filter(function(t){return e.indexOf(t)<0});n(i)}}else n(c);f.sizeSearchInput()})};var $;f.refresh=function(e){void 0!==e&&($&&i.cancel($),$=i(function(){t.$eval(e)},f.refreshDelay))},f.setActiveItem=function(e){f.activeIndex=f.items.indexOf(e)},f.isActive=function(e){if(!f.open)return!1;var t=f.items.indexOf(e[f.itemProperty]),c=t===f.activeIndex;return!c||0>t&&f.taggingLabel!==!1||0>t&&f.taggingLabel===!1?!1:(c&&!angular.isUndefined(f.onHighlightCallback)&&e.$eval(f.onHighlightCallback),c)},f.isDisabled=function(e){if(f.open){var t,c=f.items.indexOf(e[f.itemProperty]),i=!1;return c>=0&&!angular.isUndefined(f.disableChoiceExpression)&&(t=f.items[c],i=!!e.$eval(f.disableChoiceExpression),t._uiSelectChoiceDisabled=i),i}},f.select=function(e,c,l){if(void 0===e||!e._uiSelectChoiceDisabled){if(!f.items&&!f.search)return;if(!e||!e._uiSelectChoiceDisabled){if(f.tagging.isActivated){if(f.taggingLabel===!1)if(f.activeIndex<0){if(e=void 0!==f.tagging.fct?f.tagging.fct(f.search):f.search,!e||angular.equals(f.items[0],e))return}else e=f.items[f.activeIndex];else if(0===f.activeIndex){if(void 0===e)return;if(void 0!==f.tagging.fct&&"string"==typeof e){if(e=f.tagging.fct(f.search),!e)return}else"string"==typeof e&&(e=e.replace(f.taggingLabel,"").trim())}if(f.selected&&angular.isArray(f.selected)&&f.selected.filter(function(t){return angular.equals(t,e)}).length>0)return f.close(c),void 0}var s={};s[f.parserResult.itemName]=e,f.multiple?(f.selected.push(e),f.sizeSearchInput()):f.selected=e,i(function(){f.onSelectCallback(t,{$item:e,$model:f.parserResult.modelMapper(t,s)})}),(!f.multiple||f.closeOnSelect)&&f.close(c),l&&"click"===l.type&&(f.clickTriggeredSelect=!0)}}},f.close=function(e){f.open&&(f.ngModel&&f.ngModel.$setTouched&&f.ngModel.$setTouched(),r(),f.open=!1,f.multiple||i(function(){f.focusser.prop("disabled",!1),e||f.focusser[0].focus()},0,!1))},f.setFocus=function(){f.focus||f.multiple||f.focusser[0].focus(),!f.focus&&f.multiple&&m[0].focus()},f.clear=function(e){f.select(void 0),e.stopPropagation(),f.focusser[0].focus()},f.toggle=function(e){f.open?(f.close(),e.preventDefault(),e.stopPropagation()):f.activate()},f.isLocked=function(e,t){var c,i=f.selected[t];return i&&!angular.isUndefined(f.lockChoiceExpression)&&(c=!!e.$eval(f.lockChoiceExpression),i._uiSelectChoiceLocked=c),c},f.removeChoice=function(e){var c=f.selected[e];if(!c._uiSelectChoiceLocked){var l={};l[f.parserResult.itemName]=c,f.selected.splice(e,1),f.activeMatchIndex=-1,f.sizeSearchInput(),i(function(){f.onRemoveCallback(t,{$item:c,$model:f.parserResult.modelMapper(t,l)})})}},f.getPlaceholder=function(){return f.multiple&&f.selected.length?void 0:f.placeholder};var b=null;f.sizeSearchInput=function(){var e=m[0],c=m.parent().parent()[0],l=function(){return c.clientWidth*!!e.offsetParent},s=function(t){if(0===t)return!1;var c=t-e.offsetLeft-10;return 50>c&&(c=t),m.css("width",c+"px"),!0};m.css("width","10px"),i(function(){null!==b||s(l())||(b=t.$watch(l,function(e){s(e)&&(b(),b=null)}))})},m.on("keydown",function(c){var l=c.which;t.$apply(function(){var t=!1,s=!1;if(f.multiple&&e.isHorizontalMovement(l)&&(t=u(l)),!t&&(f.items.length>0||f.tagging.isActivated)&&(t=o(l),f.taggingTokens.isActivated)){for(var a=0;a<f.taggingTokens.tokens.length;a++)f.taggingTokens.tokens[a]===e.MAP[c.keyCode]&&f.search.length>0&&(s=!0);s&&i(function(){m.triggerHandler("tagged");var t=f.search.replace(e.MAP[c.keyCode],"").trim();f.tagging.fct&&(t=f.tagging.fct(t)),t&&f.select(t,!0)})}t&&l!=e.TAB&&(c.preventDefault(),c.stopPropagation())}),e.isVerticalMovement(l)&&f.items.length>0&&h()}),m.on("paste",function(e){var t=e.originalEvent.clipboardData.getData("text/plain");if(t&&t.length>0&&f.taggingTokens.isActivated&&f.tagging.fct){var c=t.split(f.taggingTokens.tokens[0]);c&&c.length>0&&(angular.forEach(c,function(e){var t=f.tagging.fct(e);t&&f.select(t,!0)}),e.preventDefault(),e.stopPropagation())}}),m.on("keyup",function(c){if(e.isVerticalMovement(c.which)||t.$evalAsync(function(){f.activeIndex=f.taggingLabel===!1?-1:0}),f.tagging.isActivated&&f.search.length>0){if(c.which===e.TAB||e.isControl(c)||e.isFunctionKey(c)||c.which===e.ESC||e.isVerticalMovement(c.which))return;if(f.activeIndex=f.taggingLabel===!1?-1:0,f.taggingLabel===!1)return;var i,l,s,a,n=angular.copy(f.items),r=angular.copy(f.items),o=!1,u=-1;if(void 0!==f.tagging.fct){if(s=f.$filter("filter")(n,{isTag:!0}),s.length>0&&(a=s[0]),n.length>0&&a&&(o=!0,n=n.slice(1,n.length),r=r.slice(1,r.length)),i=f.tagging.fct(f.search),i.isTag=!0,r.filter(function(e){return angular.equals(e,f.tagging.fct(f.search))}).length>0)return;i.isTag=!0}else{if(s=f.$filter("filter")(n,function(e){return e.match(f.taggingLabel)}),s.length>0&&(a=s[0]),l=n[0],void 0!==l&&n.length>0&&a&&(o=!0,n=n.slice(1,n.length),r=r.slice(1,r.length)),i=f.search+" "+f.taggingLabel,p(f.selected,f.search)>-1)return;if(d(r.concat(f.selected)))return o&&(n=r,t.$evalAsync(function(){f.activeIndex=0,f.items=n})),void 0;if(d(r))return o&&(f.items=r.slice(1,r.length)),void 0}o&&(u=p(f.selected,i)),u>-1?n=n.slice(u+1,n.length-1):(n=[],n.push(i),n=n.concat(r)),t.$evalAsync(function(){f.activeIndex=0,f.items=n})}}),m.on("tagged",function(){i(function(){r()})}),m.on("blur",function(){i(function(){f.activeMatchIndex=-1})}),t.$on("$destroy",function(){m.off("keyup keydown tagged blur paste")})}]),c.directive("uiSelect",["$document","uiSelectConfig","uiSelectMinErr","$compile","$parse","$timeout",function(t,c,i,l,s,a){return{restrict:"EA",templateUrl:function(e,t){var i=t.theme||c.theme;return i+(angular.isDefined(t.multiple)?"/select-multiple.tpl.html":"/select.tpl.html")},replace:!0,transclude:!0,require:["uiSelect","^ngModel"],scope:!0,controller:"uiSelectCtrl",controllerAs:"$select",link:function(n,r,o,u,d){function p(e){if(g.open){var t=!1;if(t=window.jQuery?window.jQuery.contains(r[0],e.target):r[0].contains(e.target),!t&&!g.clickTriggeredSelect){var c=["input","button","textarea"],i=angular.element(e.target).scope(),l=i&&i.$select&&i.$select!==g;l||(l=~c.indexOf(e.target.tagName.toLowerCase())),g.close(l),n.$digest()}g.clickTriggeredSelect=!1}}var g=u[0],h=u[1],f=r.querySelectorAll("input.ui-select-search");g.generatedId=c.generateId(),g.baseTitle=o.title||"Select box",g.focusserTitle=g.baseTitle+" focus",g.focusserId="focusser-"+g.generatedId,g.multiple=angular.isDefined(o.multiple)&&(""===o.multiple||"multiple"===o.multiple.toLowerCase()||"true"===o.multiple.toLowerCase()),g.closeOnSelect=function(){return angular.isDefined(o.closeOnSelect)?s(o.closeOnSelect)():c.closeOnSelect}(),g.onSelectCallback=s(o.onSelect),g.onRemoveCallback=s(o.onRemove),h.$parsers.unshift(function(e){var t,c={};if(g.multiple){for(var i=[],l=g.selected.length-1;l>=0;l--)c={},c[g.parserResult.itemName]=g.selected[l],t=g.parserResult.modelMapper(n,c),i.unshift(t);return i}return c={},c[g.parserResult.itemName]=e,t=g.parserResult.modelMapper(n,c)}),h.$formatters.unshift(function(e){var t,c=g.parserResult.source(n,{$select:{search:""}}),i={};if(c){if(g.multiple){var l=[],s=function(e,c){if(!e||!e.length)return l.unshift(c),!0;for(var s=e.length-1;s>=0;s--){if(i[g.parserResult.itemName]=e[s],t=g.parserResult.modelMapper(n,i),g.parserResult.trackByExp){var a=/\.(.+)/.exec(g.parserResult.trackByExp);if(a.length>0&&t[a[1]]==c[a[1]])return l.unshift(e[s]),!0}if(t==c)return l.unshift(e[s]),!0}return!1};if(!e)return l;for(var a=e.length-1;a>=0;a--)s(g.selected,e[a])||s(c,e[a]);return l}var r=function(c){return i[g.parserResult.itemName]=c,t=g.parserResult.modelMapper(n,i),t==e};if(g.selected&&r(g.selected))return g.selected;for(var o=c.length-1;o>=0;o--)if(r(c[o]))return c[o]}return e}),g.ngModel=h,g.choiceGrouped=function(e){return g.isGrouped&&e&&e.name};var v=angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");o.tabindex&&o.$observe("tabindex",function(e){g.multiple?f.attr("tabindex",e):v.attr("tabindex",e),r.removeAttr("tabindex")}),l(v)(n),g.focusser=v,g.multiple||(r.append(v),v.bind("focus",function(){n.$evalAsync(function(){g.focus=!0})}),v.bind("blur",function(){n.$evalAsync(function(){g.focus=!1})}),v.bind("keydown",function(t){return t.which===e.BACKSPACE?(t.preventDefault(),t.stopPropagation(),g.select(void 0),n.$apply(),void 0):(t.which===e.TAB||e.isControl(t)||e.isFunctionKey(t)||t.which===e.ESC||((t.which==e.DOWN||t.which==e.UP||t.which==e.ENTER||t.which==e.SPACE)&&(t.preventDefault(),t.stopPropagation(),g.activate()),n.$digest()),void 0)}),v.bind("keyup input",function(t){t.which===e.TAB||e.isControl(t)||e.isFunctionKey(t)||t.which===e.ESC||t.which==e.ENTER||t.which===e.BACKSPACE||(g.activate(v.val()),v.val(""),n.$digest())})),n.$watch("searchEnabled",function(){var e=n.$eval(o.searchEnabled);g.searchEnabled=void 0!==e?e:c.searchEnabled}),n.$watch("sortable",function(){var e=n.$eval(o.sortable);g.sortable=void 0!==e?e:c.sortable}),o.$observe("disabled",function(){g.disabled=void 0!==o.disabled?o.disabled:!1,g.multiple&&g.sizeSearchInput()}),o.$observe("resetSearchInput",function(){var e=n.$eval(o.resetSearchInput);g.resetSearchInput=void 0!==e?e:!0}),o.$observe("tagging",function(){if(void 0!==o.tagging){var e=n.$eval(o.tagging);g.tagging={isActivated:!0,fct:e!==!0?e:void 0}}else g.tagging={isActivated:!1,fct:void 0}}),o.$observe("taggingLabel",function(){void 0!==o.tagging&&(g.taggingLabel="false"===o.taggingLabel?!1:void 0!==o.taggingLabel?o.taggingLabel:"(new)")}),o.$observe("taggingTokens",function(){if(void 0!==o.tagging){var e=void 0!==o.taggingTokens?o.taggingTokens.split("|"):[",","ENTER"];g.taggingTokens={isActivated:!0,tokens:e}}}),angular.isDefined(o.autofocus)&&a(function(){g.setFocus()}),angular.isDefined(o.focusOn)&&n.$on(o.focusOn,function(){a(function(){g.setFocus()})}),g.multiple?(n.$watchCollection(function(){return h.$modelValue},function(e,t){t!=e&&(h.$modelValue=null)}),g.firstPass=!0,n.$watchCollection("$select.selected",function(){g.firstPass?g.firstPass=!1:h.$setViewValue(Date.now())}),v.prop("disabled",!0)):n.$watch("$select.selected",function(e){h.$viewValue!==e&&h.$setViewValue(e)}),h.$render=function(){if(g.multiple&&!angular.isArray(h.$viewValue)){if(!angular.isUndefined(h.$viewValue)&&null!==h.$viewValue)throw i("multiarr","Expected model value to be array but got '{0}'",h.$viewValue);g.selected=[]}g.selected=h.$viewValue},t.on("click",p),n.$on("$destroy",function(){t.off("click",p)}),d(n,function(e){var t=angular.element("<div>").append(e),c=t.querySelectorAll(".ui-select-match");if(c.removeAttr("ui-select-match"),c.removeAttr("data-ui-select-match"),1!==c.length)throw i("transcluded","Expected 1 .ui-select-match but got '{0}'.",c.length);r.querySelectorAll(".ui-select-match").replaceWith(c);var l=t.querySelectorAll(".ui-select-choices");if(l.removeAttr("ui-select-choices"),l.removeAttr("data-ui-select-choices"),1!==l.length)throw i("transcluded","Expected 1 .ui-select-choices but got '{0}'.",l.length);r.querySelectorAll(".ui-select-choices").replaceWith(l)})}}}]),c.directive("uiSelectMatch",["uiSelectConfig",function(e){return{restrict:"EA",require:"^uiSelect",replace:!0,transclude:!0,templateUrl:function(t){var c=t.parent().attr("theme")||e.theme,i=t.parent().attr("multiple");return c+(i?"/match-multiple.tpl.html":"/match.tpl.html")},link:function(t,c,i,l){l.lockChoiceExpression=i.uiLockChoice,i.$observe("placeholder",function(t){l.placeholder=void 0!==t?t:e.placeholder}),l.allowClear=angular.isDefined(i.allowClear)?""===i.allowClear?!0:"true"===i.allowClear.toLowerCase():!1,l.multiple&&l.sizeSearchInput()}}}]),c.directive("uiSelectSort",["$timeout","uiSelectConfig","uiSelectMinErr",function(e,t,c){return{require:"^uiSelect",link:function(t,i,l,s){if(null===t[l.uiSelectSort])throw c("sort","Expected a list to sort");var a=angular.extend({axis:"horizontal"},t.$eval(l.uiSelectSortOptions)),n=a.axis,r="dragging",o="dropping",u="dropping-before",d="dropping-after";t.$watch(function(){return s.sortable},function(e){e?i.attr("draggable",!0):i.removeAttr("draggable")}),i.on("dragstart",function(e){i.addClass(r),(e.dataTransfer||e.originalEvent.dataTransfer).setData("text/plain",t.$index)}),i.on("dragend",function(){i.removeClass(r)});var p,g=function(e,t){this.splice(t,0,this.splice(e,1)[0])},h=function(e){e.preventDefault();var t="vertical"===n?e.offsetY||e.layerY||(e.originalEvent?e.originalEvent.offsetY:0):e.offsetX||e.layerX||(e.originalEvent?e.originalEvent.offsetX:0);t<this["vertical"===n?"offsetHeight":"offsetWidth"]/2?(i.removeClass(d),i.addClass(u)):(i.removeClass(u),i.addClass(d))},f=function(t){t.preventDefault();var c=parseInt((t.dataTransfer||t.originalEvent.dataTransfer).getData("text/plain"),10);e.cancel(p),p=e(function(){v(c)},20)},v=function(e){var c=t.$eval(l.uiSelectSort),s=c[e],a=null;a=i.hasClass(u)?e<t.$index?t.$index-1:t.$index:e<t.$index?t.$index:t.$index+1,g.apply(c,[e,a]),t.$apply(function(){t.$emit("uiSelectSort:change",{array:c,item:s,from:e,to:a})}),i.removeClass(o),i.removeClass(u),i.removeClass(d),i.off("drop",f)};i.on("dragenter",function(){i.hasClass(r)||(i.addClass(o),i.on("dragover",h),i.on("drop",f))}),i.on("dragleave",function(){i.removeClass(o),i.removeClass(u),i.removeClass(d),i.off("dragover",h),i.off("drop",f)})}}}])}(),angular.module("ui.select").run(["$templateCache",function(e){e.put("bootstrap/choices.tpl.html",'<ul class="ui-select-choices ui-select-choices-content dropdown-menu" role="listbox" ng-show="$select.items.length > 0"><li class="ui-select-choices-group" id="ui-select-choices-{{ $select.generatedId }}"><div class="divider" ng-show="$select.isGrouped && $index > 0"></div><div ng-show="$select.isGrouped" class="ui-select-choices-group-label dropdown-header" ng-bind="$group.name"></div><div id="ui-select-choices-row-{{ $select.generatedId }}-{{$index}}" class="ui-select-choices-row" ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}" role="option"><a href="javascript:void(0)" class="ui-select-choices-row-inner"></a></div></li></ul>'),e.put("bootstrap/match-multiple.tpl.html",'<span class="ui-select-match"><span ng-repeat="$item in $select.selected"><span class="ui-select-match-item btn btn-default btn-xs" tabindex="-1" type="button" ng-disabled="$select.disabled" ng-click="$select.activeMatchIndex = $index;" ng-class="{\'btn-primary\':$select.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected"><span class="close ui-select-match-close" ng-hide="$select.disabled" ng-click="$select.removeChoice($index)">&nbsp;&times;</span> <span uis-transclude-append=""></span></span></span></span>'),e.put("bootstrap/match.tpl.html",'<div class="ui-select-match" ng-hide="$select.open" ng-disabled="$select.disabled" ng-class="{\'btn-default-focus\':$select.focus}"><span tabindex="-1" class="btn btn-default form-control ui-select-toggle" aria-label="{{ $select.baseTitle }} activate" ng-disabled="$select.disabled" ng-click="$select.activate()" style="outline: 0;"><span ng-show="$select.isEmpty()" class="ui-select-placeholder text-muted">{{$select.placeholder}}</span> <span ng-hide="$select.isEmpty()" class="ui-select-match-text pull-left" ng-class="{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}" ng-transclude=""></span> <i class="caret pull-right" ng-click="$select.toggle($event)"></i> <a ng-show="$select.allowClear && !$select.isEmpty()" aria-label="{{ $select.baseTitle }} clear" style="margin-right: 10px" ng-click="$select.clear($event)" class="btn btn-xs btn-link pull-right"><i class="glyphicon glyphicon-remove" aria-hidden="true"></i></a></span></div>'),e.put("bootstrap/select-multiple.tpl.html",'<div class="ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control" ng-class="{open: $select.open}"><div><div class="ui-select-match"></div><input type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="ui-select-search input-xs" placeholder="{{$select.getPlaceholder()}}" ng-disabled="$select.disabled" ng-hide="$select.disabled" ng-click="$select.activate()" ng-model="$select.search" role="combobox" aria-label="{{ $select.baseTitle }}" ondrop="return false;"></div><div class="ui-select-choices"></div></div>'),e.put("bootstrap/select.tpl.html",'<div class="ui-select-container ui-select-bootstrap dropdown" ng-class="{open: $select.open}"><div class="ui-select-match"></div><input type="text" autocomplete="off" tabindex="-1" aria-expanded="true" aria-label="{{ $select.baseTitle }}" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}" class="form-control ui-select-search" placeholder="{{$select.placeholder}}" ng-model="$select.search" ng-show="$select.searchEnabled && $select.open"><div class="ui-select-choices"></div></div>'),e.put("select2/choices.tpl.html",'<ul class="ui-select-choices ui-select-choices-content select2-results"><li class="ui-select-choices-group" ng-class="{\'select2-result-with-children\': $select.choiceGrouped($group) }"><div ng-show="$select.choiceGrouped($group)" class="ui-select-choices-group-label select2-result-label" ng-bind="$group.name"></div><ul role="listbox" id="ui-select-choices-{{ $select.generatedId }}" ng-class="{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }"><li role="option" id="ui-select-choices-row-{{ $select.generatedId }}-{{$index}}" class="ui-select-choices-row" ng-class="{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}"><div class="select2-result-label ui-select-choices-row-inner"></div></li></ul></li></ul>'),e.put("select2/match-multiple.tpl.html",'<span class="ui-select-match"><li class="ui-select-match-item select2-search-choice" ng-repeat="$item in $select.selected" ng-class="{\'select2-search-choice-focus\':$select.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected"><span uis-transclude-append=""></span> <a href="javascript:;" class="ui-select-match-close select2-search-choice-close" ng-click="$select.removeChoice($index)" tabindex="-1"></a></li></span>'),e.put("select2/match.tpl.html",'<a class="select2-choice ui-select-match" ng-class="{\'select2-default\': $select.isEmpty()}" ng-click="$select.activate()" aria-label="{{ $select.baseTitle }} select"><span ng-show="$select.isEmpty()" class="select2-chosen">{{$select.placeholder}}</span> <span ng-hide="$select.isEmpty()" class="select2-chosen" ng-transclude=""></span> <abbr ng-if="$select.allowClear && !$select.isEmpty()" class="select2-search-choice-close" ng-click="$select.clear($event)"></abbr> <span class="select2-arrow ui-select-toggle" ng-click="$select.toggle($event)"><b></b></span></a>'),e.put("select2/select-multiple.tpl.html",'<div class="ui-select-container ui-select-multiple select2 select2-container select2-container-multi" ng-class="{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}"><ul class="select2-choices"><span class="ui-select-match"></span><li class="select2-search-field"><input type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="combobox" aria-expanded="true" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-label="{{ $select.baseTitle }}" aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}" class="select2-input ui-select-search" placeholder="{{$select.getPlaceholder()}}" ng-disabled="$select.disabled" ng-hide="$select.disabled" ng-model="$select.search" ng-click="$select.activate()" style="width: 34px;" ondrop="return false;"></li></ul><div class="select2-drop select2-with-searchbox select2-drop-active" ng-class="{\'select2-display-none\': !$select.open}"><div class="ui-select-choices"></div></div></div>'),e.put("select2/select.tpl.html",'<div class="ui-select-container select2 select2-container" ng-class="{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}"><div class="ui-select-match"></div><div class="select2-drop select2-with-searchbox select2-drop-active" ng-class="{\'select2-display-none\': !$select.open}"><div class="select2-search" ng-show="$select.searchEnabled"><input type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="combobox" aria-expanded="true" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-label="{{ $select.baseTitle }}" aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}" class="ui-select-search select2-input" ng-model="$select.search"></div><div class="ui-select-choices"></div></div></div>'),e.put("selectize/choices.tpl.html",'<div ng-show="$select.open" class="ui-select-choices selectize-dropdown single"><div class="ui-select-choices-content selectize-dropdown-content"><div class="ui-select-choices-group optgroup" role="listbox"><div ng-show="$select.isGrouped" class="ui-select-choices-group-label optgroup-header" ng-bind="$group.name"></div><div role="option" class="ui-select-choices-row" ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}"><div class="option ui-select-choices-row-inner" data-selectable=""></div></div></div></div></div>'),e.put("selectize/match.tpl.html",'<div ng-hide="($select.open || $select.isEmpty())" class="ui-select-match" ng-transclude=""></div>'),e.put("selectize/select.tpl.html",'<div class="ui-select-container selectize-control single" ng-class="{\'open\': $select.open}"><div class="selectize-input" ng-class="{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}" ng-click="$select.activate()"><div class="ui-select-match"></div><input type="text" autocomplete="off" tabindex="-1" class="ui-select-search ui-select-toggle" ng-click="$select.toggle($event)" placeholder="{{$select.placeholder}}" ng-model="$select.search" ng-hide="!$select.searchEnabled || ($select.selected && !$select.open)" ng-disabled="$select.disabled" aria-label="{{ $select.baseTitle }}"></div><div class="ui-select-choices"></div></div>')}]);
!function(){"use strict";function t(t,e,n,s,o,i,a){function l(t){if(t)m(t.toastId);else for(var e=0;e<w.length;e++)m(w[e].toastId)}function r(t,e,n){var s=f().iconClasses.error;return p(s,t,e,n)}function c(t,e,n){var s=f().iconClasses.info;return p(s,t,e,n)}function u(t,e,n){var s=f().iconClasses.success;return p(s,t,e,n)}function d(t,e,n){var s=f().iconClasses.warning;return p(s,t,e,n)}function m(e,n){function s(t){for(var e=0;e<w.length;e++)if(w[e].toastId===t)return w[e]}function o(){return!w.length}var l=s(e);l&&!l.deleting&&(l.deleting=!0,t.leave(l.el).then(function(){l.scope.options.onHidden&&l.scope.options.onHidden(n),l.scope.$destroy();var t=w.indexOf(l);w.splice(t,1);var e=i.maxOpened;e&&w.length>=e&&w[e-1].open.resolve(),o()&&(C.remove(),C=null,O=a.defer())}))}function p(t,e,n,s){return"object"==typeof n&&(s=n,n=null),v({iconClass:t,message:e,optionsOverride:s,title:n})}function f(){return angular.extend({},i)}function g(e){if(C)return O.promise;C=angular.element("<div></div>"),C.attr("id",e.containerId),C.addClass(e.positionClass),C.css({"pointer-events":"auto"});var n=angular.element(document.querySelector(e.target));if(!n||!n.length)throw"Target for toasts doesn't exist";return t.enter(C,n).then(function(){O.resolve()}),O.promise}function v(n){function i(t,e,n){n.allowHtml?(t.scope.allowHtml=!0,t.scope.title=o.trustAsHtml(e.title),t.scope.message=o.trustAsHtml(e.message)):(t.scope.title=e.title,t.scope.message=e.message),t.scope.toastType=t.iconClass,t.scope.toastId=t.toastId,t.scope.options={extendedTimeOut:n.extendedTimeOut,messageClass:n.messageClass,onHidden:n.onHidden,onShown:n.onShown,tapToDismiss:n.tapToDismiss,timeOut:n.timeOut,titleClass:n.titleClass,toastClass:n.toastClass},n.closeButton&&(t.scope.options.closeHtml=n.closeHtml)}function l(){var t={toastId:h++,scope:s.$new(),open:a.defer()};return t.iconClass=n.iconClass,n.optionsOverride&&(u=angular.extend(u,n.optionsOverride),t.iconClass=n.optionsOverride.iconClass||t.iconClass),i(t,n,u),t.el=r(t.scope),t}function r(t){var n=angular.element("<div toast></div>"),s=e.get("$compile");return s(n)(t)}function c(){return u.maxOpened&&w.length<=u.maxOpened||!u.maxOpened}var u=f(),d=l();return w.push(d),c()&&d.open.resolve(),d.open.promise.then(function(){g(u).then(function(){u.newestOnTop?t.enter(d.el,C).then(function(){d.scope.init()}):t.enter(d.el,C,C[0].lastChild).then(function(){d.scope.init()})})}),d}var C,h=0,w=[],O=a.defer(),H={clear:l,error:r,info:c,remove:m,success:u,warning:d};return H}angular.module("toastr",[]).factory("toastr",t),t.$inject=["$animate","$injector","$document","$rootScope","$sce","toastrConfig","$q"]}(),function(){"use strict";angular.module("toastr").constant("toastrConfig",{allowHtml:!1,closeButton:!1,closeHtml:"<button>&times;</button>",containerId:"toast-container",extendedTimeOut:1e3,iconClasses:{error:"toast-error",info:"toast-info",success:"toast-success",warning:"toast-warning"},maxOpened:0,messageClass:"toast-message",newestOnTop:!0,onHidden:null,onShown:null,positionClass:"toast-top-right",tapToDismiss:!0,target:"body",timeOut:5e3,titleClass:"toast-title",toastClass:"toast"})}(),function(){"use strict";function t(t,e,n){function s(s,o){function i(t){return e(function(){n.remove(s.toastId)},t,1)}function a(){return s.options.closeHtml}var l;if(s.toastClass=s.options.toastClass,s.titleClass=s.options.titleClass,s.messageClass=s.options.messageClass,a()){var r=angular.element(s.options.closeHtml),c=t.get("$compile");r.addClass("toast-close-button"),r.attr("ng-click","close()"),c(r)(s),o.prepend(r)}s.init=function(){s.options.timeOut&&(l=i(s.options.timeOut)),s.options.onShown&&s.options.onShown()},o.on("mouseenter",function(){l&&e.cancel(l)}),s.tapToast=function(){s.options.tapToDismiss&&s.close(!0)},s.close=function(t){n.remove(s.toastId,t)},o.on("mouseleave",function(){(0!==s.options.timeOut||0!==s.options.extendedTimeOut)&&(l=i(s.options.extendedTimeOut))})}return{replace:!0,templateUrl:"templates/toastr/toastr.html",link:s}}angular.module("toastr").directive("toast",t),t.$inject=["$injector","$interval","toastr"]}(),angular.module("toastr").run(["$templateCache",function(t){t.put("templates/toastr/toastr.html",'<div class="{{toastClass}} {{toastType}}" ng-click="tapToast()">\n  <div ng-switch on="allowHtml">\n    <div ng-switch-default ng-if="title" class="{{titleClass}}">{{title}}</div>\n    <div ng-switch-default class="{{messageClass}}">{{message}}</div>\n    <div ng-switch-when="true" ng-if="title" class="{{titleClass}}" ng-bind-html="title"></div>\n    <div ng-switch-when="true" class="{{messageClass}}" ng-bind-html="message"></div>\n  </div>\n</div>')}]);
/*! 3.2.4 */
!function(){function a(a,b){window.XMLHttpRequest.prototype[a]=b(window.XMLHttpRequest.prototype[a])}function b(a,b,c,d,g,h){function j(){return"input"===b[0].tagName.toLowerCase()&&b.attr("type")&&"file"===b.attr("type").toLowerCase()}function k(b){if(!p){p=!0;try{var j=b.__files_||b.target&&b.target.files,k=[],l=[],m=g(c.ngAccept);for(i=0;i<j.length;i++){var n=j.item(i);f(a,m,n,b)?k.push(n):l.push(n)}e(g,h,a,d,c,c.ngFileChange||c.ngFileSelect,k,l,b),0==k.length&&(b.target.value=k),b.target&&b.target.getAttribute("__ngf_gen__")&&angular.element(b.target).remove()}finally{p=!1}}}function l(b){c.ngMultiple&&b.attr("multiple",g(c.ngMultiple)(a)),c.accept&&b.attr("accept",c.accept),c.ngCapture&&b.attr("capture",g(c.ngCapture)(a)),c.ngDisabled&&b.attr("disabled",g(c.ngDisabled)(a)),b.bind("change",k)}function m(){if(!b.attr("disabled")){for(var a=angular.element('<input type="file">'),c=0;c<b[0].attributes.length;c++){var d=b[0].attributes[c];a.attr(d.name,d.value)}return j()?(b.replaceWith(a),b=a):(a.css("width","0px").css("height","0px").css("position","absolute").css("padding",0).css("margin",0).css("overflow","hidden").attr("tabindex","-1").css("opacity",0).attr("__ngf_gen__",!0),b.__ngf_ref_elem__&&b.__ngf_ref_elem__.remove(),b.__ngf_ref_elem__=a,b.parent()[0].insertBefore(a[0],b[0]),b.css("overflow","hidden")),l(a),a}}function n(b){e(g,h,a,d,c,c.ngFileChange||c.ngFileSelect,[],[],b,!0)}function o(a){var c=m(a);c&&(n(a),c[0].click()),j()&&(b.bind("click",o),a.preventDefault())}var p=!1;window.FileAPI&&window.FileAPI.ngfFixIE?window.FileAPI.ngfFixIE(b,m,k,n):b.bind("click",o)}function c(a,b,c,g,h,j,k){function l(a,b,c){var d=!0,e=c.dataTransfer.items;if(null!=e)for(i=0;i<e.length&&d;i++)d=d&&("file"==e[i].kind||""==e[i].kind)&&f(a,s,e[i],c);var g=h(b.dragOverClass)(a,{$event:c});return g&&(g.delay&&(r=g.delay),g.accept&&(g=d?g.accept:g.reject)),g||b.dragOverClass||"dragover"}function m(b,c,d,e){function g(c){f(a,s,c,b)?l.push(c):m.push(c)}function h(a,b,c){if(null!=b)if(b.isDirectory){var d=(c||"")+b.name;g({name:b.name,type:"directory",path:d});var e=b.createReader(),f=[];o++;var j=function(){e.readEntries(function(d){try{if(d.length)f=f.concat(Array.prototype.slice.call(d||[],0)),j();else{for(i=0;i<f.length;i++)h(a,f[i],(c?c:"")+b.name+"/");o--}}catch(e){o--,console.error(e)}},function(){o--})};j()}else o++,b.file(function(a){try{o--,a.path=(c?c:"")+a.name,g(a)}catch(b){o--,console.error(b)}},function(){o--})}var l=[],m=[],n=b.dataTransfer.items,o=0;if(n&&n.length>0&&"file"!=k.protocol())for(i=0;i<n.length;i++){if(n[i].webkitGetAsEntry&&n[i].webkitGetAsEntry()&&n[i].webkitGetAsEntry().isDirectory){var p=n[i].webkitGetAsEntry();if(p.isDirectory&&!d)continue;null!=p&&h(l,p)}else{var q=n[i].getAsFile();null!=q&&g(q)}if(!e&&l.length>0)break}else{var r=b.dataTransfer.files;if(null!=r)for(i=0;i<r.length&&(g(r.item(i)),e||!(l.length>0));i++);}var t=0;!function u(a){j(function(){if(o)10*t++<2e4&&u(10);else{if(!e&&l.length>1){for(i=0;"directory"==l[i].type;)i++;l=[l[i]]}c(l,m)}},a||0)}()}var n=d();if(c.dropAvailable&&j(function(){a.dropAvailable?a.dropAvailable.value=n:a.dropAvailable=n}),!n)return 1==h(c.hideOnDropNotAvailable)(a)&&b.css("display","none"),void 0;var o,p=null,q=h(c.stopPropagation),r=1,s=h(c.ngAccept),t=h(c.ngDisabled);b[0].addEventListener("dragover",function(d){if(!t(a)){if(d.preventDefault(),q(a)&&d.stopPropagation(),navigator.userAgent.indexOf("Chrome")>-1){var e=d.dataTransfer.effectAllowed;d.dataTransfer.dropEffect="move"===e||"linkMove"===e?"move":"copy"}j.cancel(p),a.actualDragOverClass||(o=l(a,c,d)),b.addClass(o)}},!1),b[0].addEventListener("dragenter",function(b){t(a)||(b.preventDefault(),q(a)&&b.stopPropagation())},!1),b[0].addEventListener("dragleave",function(){t(a)||(p=j(function(){b.removeClass(o),o=null},r||1))},!1),b[0].addEventListener("drop",function(d){t(a)||(d.preventDefault(),q(a)&&d.stopPropagation(),b.removeClass(o),o=null,m(d,function(b,f){e(h,j,a,g,c,c.ngFileChange||c.ngFileDrop,b,f,d)},0!=h(c.allowDir)(a),c.multiple||h(c.ngMultiple)(a)))},!1)}function d(){var a=document.createElement("div");return"draggable"in a&&"ondrop"in a}function e(a,b,c,d,e,f,g,h,i,j){function k(){d&&(a(e.ngModel).assign(c,g),b(function(){d&&d.$setViewValue(null!=g&&0==g.length?null:g)})),e.ngModelRejected&&a(e.ngModelRejected).assign(c,h),f&&a(f)(c,{$files:g,$rejectedFiles:h,$event:i})}j?k():b(function(){k()})}function f(a,b,c,d){var e=b(a,{$file:c,$event:d});if(null==e)return!0;if(angular.isString(e)){var f=new RegExp(g(e),"gi");e=null!=c.type&&c.type.match(f)||null!=c.name&&c.name.match(f)}return e}function g(a){if(a.length>2&&"/"===a[0]&&"/"===a[a.length-1])return a.substring(1,a.length-1);var b=a.split(","),c="";if(b.length>1)for(i=0;i<b.length;i++)c+="("+g(b[i])+")",i<b.length-1&&(c+="|");else 0==a.indexOf(".")&&(a="*"+a),c="^"+a.replace(new RegExp("[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]","g"),"\\$&")+"$",c=c.replace(/\\\*/g,".*").replace(/\\\?/g,".");return c}var h,i;window.XMLHttpRequest&&!window.XMLHttpRequest.__isFileAPIShim&&a("setRequestHeader",function(a){return function(b,c){if("__setXHR_"===b){var d=c(this);d instanceof Function&&d(this)}else a.apply(this,arguments)}});var j=angular.module("angularFileUpload",[]);j.version="3.2.4",j.service("$upload",["$http","$q","$timeout",function(a,b,c){function d(d){d.method=d.method||"POST",d.headers=d.headers||{},d.transformRequest=d.transformRequest||function(b,c){return window.ArrayBuffer&&b instanceof window.ArrayBuffer?b:a.defaults.transformRequest[0](b,c)};var e=b.defer(),f=e.promise;return d.headers.__setXHR_=function(){return function(a){a&&(d.__XHR=a,d.xhrFn&&d.xhrFn(a),a.upload.addEventListener("progress",function(a){a.config=d,e.notify?e.notify(a):f.progress_fn&&c(function(){f.progress_fn(a)})},!1),a.upload.addEventListener("load",function(a){a.lengthComputable&&(a.config=d,e.notify?e.notify(a):f.progress_fn&&c(function(){f.progress_fn(a)}))},!1))}},a(d).then(function(a){e.resolve(a)},function(a){e.reject(a)},function(a){e.notify(a)}),f.success=function(a){return f.then(function(b){a(b.data,b.status,b.headers,d)}),f},f.error=function(a){return f.then(null,function(b){a(b.data,b.status,b.headers,d)}),f},f.progress=function(a){return f.progress_fn=a,f.then(null,null,function(b){a(b)}),f},f.abort=function(){return d.__XHR&&c(function(){d.__XHR.abort()}),f},f.xhr=function(a){return d.xhrFn=function(b){return function(){b&&b.apply(f,arguments),a.apply(f,arguments)}}(d.xhrFn),f},f}this.upload=function(a){return a.headers=a.headers||{},a.headers["Content-Type"]=void 0,a.transformRequest=a.transformRequest?"[object Array]"===Object.prototype.toString.call(a.transformRequest)?a.transformRequest:[a.transformRequest]:[],a.transformRequest.push(function(b){var c=new FormData,d={};for(h in a.fields)a.fields.hasOwnProperty(h)&&(d[h]=a.fields[h]);if(b&&(d.data=b),a.formDataAppender)for(h in d)d.hasOwnProperty(h)&&a.formDataAppender(c,h,d[h]);else for(h in d)if(d.hasOwnProperty(h)){var e=d[h];void 0!==e&&("[object String]"===Object.prototype.toString.call(e)?c.append(h,e):a.sendObjectsAsJsonBlob&&"object"==typeof e?c.append(h,new Blob([e],{type:"application/json"})):c.append(h,JSON.stringify(e)))}if(null!=a.file){var f=a.fileFormDataName||"file";if("[object Array]"===Object.prototype.toString.call(a.file)){var g="[object String]"===Object.prototype.toString.call(f);for(i=0;i<a.file.length;i++)c.append(g?f:f[i],a.file[i],a.fileName&&a.fileName[i]||a.file[i].name)}else c.append(f,a.file,a.fileName||a.file.name)}return c}),d(a)},this.http=function(a){return d(a)}}]),j.directive("ngFileSelect",["$parse","$timeout","$compile",function(a,c,d){return{restrict:"AEC",require:"?ngModel",link:function(e,f,g,h){b(e,f,g,h,a,c,d)}}}]),j.directive("ngFileDrop",["$parse","$timeout","$location",function(a,b,d){return{restrict:"AEC",require:"?ngModel",link:function(e,f,g,h){c(e,f,g,h,a,b,d)}}}]),j.directive("ngNoFileDrop",function(){return function(a,b){d()&&b.css("display","none")}}),j.directive("ngFileDropAvailable",["$parse","$timeout",function(a,b){return function(c,e,f){if(d()){var g=a(f.ngFileDropAvailable);b(function(){g(c)})}}}]);var k=angular.module("ngFileUpload",[]);for(h in j)j.hasOwnProperty(h)&&(k[h]=j[h])}();
/*! 3.2.4 */
!function(){function a(a,b){window.XMLHttpRequest.prototype[a]=b(window.XMLHttpRequest.prototype[a])}function b(a,b,c){try{Object.defineProperty(a,b,{get:c})}catch(d){}}function c(a){return"input"===a[0].tagName.toLowerCase()&&a.attr("type")&&"file"===a.attr("type").toLowerCase()}var d=function(){try{var a=new ActiveXObject("ShockwaveFlash.ShockwaveFlash");if(a)return!0}catch(b){if(void 0!=navigator.mimeTypes["application/x-shockwave-flash"])return!0}return!1};if(window.XMLHttpRequest&&!window.FormData||window.FileAPI&&FileAPI.forceLoad){var e=function(a){if(!a.__listeners){a.upload||(a.upload={}),a.__listeners=[];var b=a.upload.addEventListener;a.upload.addEventListener=function(c,d){a.__listeners[c]=d,b&&b.apply(this,arguments)}}};a("open",function(a){return function(b,c,d){e(this),this.__url=c;try{a.apply(this,[b,c,d])}catch(f){f.message.indexOf("Access is denied")>-1&&(this.__origError=f,a.apply(this,[b,"_fix_for_ie_crossdomain__",d]))}}}),a("getResponseHeader",function(a){return function(b){return this.__fileApiXHR&&this.__fileApiXHR.getResponseHeader?this.__fileApiXHR.getResponseHeader(b):null==a?null:a.apply(this,[b])}}),a("getAllResponseHeaders",function(a){return function(){return this.__fileApiXHR&&this.__fileApiXHR.getAllResponseHeaders?this.__fileApiXHR.getAllResponseHeaders():null==a?null:a.apply(this)}}),a("abort",function(a){return function(){return this.__fileApiXHR&&this.__fileApiXHR.abort?this.__fileApiXHR.abort():null==a?null:a.apply(this)}}),a("setRequestHeader",function(a){return function(b,c){if("__setXHR_"===b){e(this);var d=c(this);d instanceof Function&&d(this)}else this.__requestHeaders=this.__requestHeaders||{},this.__requestHeaders[b]=c,a.apply(this,arguments)}}),a("send",function(a){return function(){var c=this;if(arguments[0]&&arguments[0].__isFileAPIShim){var e=arguments[0],f={url:c.__url,jsonp:!1,cache:!0,complete:function(a,d){c.__completed=!0,!a&&c.__listeners.load&&c.__listeners.load({type:"load",loaded:c.__loaded,total:c.__total,target:c,lengthComputable:!0}),!a&&c.__listeners.loadend&&c.__listeners.loadend({type:"loadend",loaded:c.__loaded,total:c.__total,target:c,lengthComputable:!0}),"abort"===a&&c.__listeners.abort&&c.__listeners.abort({type:"abort",loaded:c.__loaded,total:c.__total,target:c,lengthComputable:!0}),void 0!==d.status&&b(c,"status",function(){return 0==d.status&&a&&"abort"!==a?500:d.status}),void 0!==d.statusText&&b(c,"statusText",function(){return d.statusText}),b(c,"readyState",function(){return 4}),void 0!==d.response&&b(c,"response",function(){return d.response});var e=d.responseText||(a&&0==d.status&&"abort"!==a?a:void 0);b(c,"responseText",function(){return e}),b(c,"response",function(){return e}),a&&b(c,"err",function(){return a}),c.__fileApiXHR=d,c.onreadystatechange&&c.onreadystatechange(),c.onload&&c.onload()},fileprogress:function(a){if(a.target=c,c.__listeners.progress&&c.__listeners.progress(a),c.__total=a.total,c.__loaded=a.loaded,a.total===a.loaded){var b=this;setTimeout(function(){c.__completed||(c.getAllResponseHeaders=function(){},b.complete(null,{status:204,statusText:"No Content"}))},FileAPI.noContentTimeout||1e4)}},headers:c.__requestHeaders};f.data={},f.files={};for(var g=0;g<e.data.length;g++){var h=e.data[g];null!=h.val&&null!=h.val.name&&null!=h.val.size&&null!=h.val.type?f.files[h.key]=h.val:f.data[h.key]=h.val}setTimeout(function(){if(!d())throw'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';c.__fileApiXHR=FileAPI.upload(f)},1)}else{if(this.__origError)throw this.__origError;a.apply(c,arguments)}}}),window.XMLHttpRequest.__isFileAPIShim=!0,FileAPI.ngfFixIE=function(a,b,e){if(!d())throw'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';var f=function(){if(a.attr("disabled"))a.__ngf_elem__.removeClass("js-fileapi-wrapper");else{var d=a.__ngf_elem__=b();d.addClass("js-fileapi-wrapper"),c(a)||((""===d.parent().css("position")||"static"===d.parent().css("position"))&&d.parent().css("position","relative"),d.css("position","absolute").css("top",a[0].offsetTop+"px").css("left",a[0].offsetLeft+"px").css("width",a[0].offsetWidth+"px").css("height",a[0].offsetHeight+"px").css("padding",a.css("padding")).css("margin",a.css("margin")).css("filter","alpha(opacity=0)"),d.css("z-index","1000")),setTimeout(function(){d.bind("mouseenter",f)},10),d.unbind("change"),d.bind("change",function(a){g.apply(this,[a]),e.apply(this,[a])})}};a.bind("mouseenter",f);var g=function(a){for(var b=FileAPI.getFiles(a),c=0;c<b.length;c++)void 0===b[c].size&&(b[c].size=0),void 0===b[c].name&&(b[c].name="file"),void 0===b[c].type&&(b[c].type="undefined");a.target||(a.target={}),a.target.files=b,a.target.files!=b&&(a.__files_=b),(a.__files_||a.target.files).item=function(b){return(a.__files_||a.target.files)[b]||null}}},window.FormData=FormData=function(){return{append:function(a,b,c){b.__isFileAPIBlobShim&&(b=b.data[0]),this.data.push({key:a,val:b,name:c})},data:[],__isFileAPIShim:!0}},window.Blob=Blob=function(a){return{data:a,__isFileAPIBlobShim:!0}},function(){if(window.FileAPI||(window.FileAPI={}),FileAPI.forceLoad&&(FileAPI.html5=!1),!FileAPI.upload){var a,b,c,e,f,g=document.createElement("script"),h=document.getElementsByTagName("script");if(window.FileAPI.jsUrl)a=window.FileAPI.jsUrl;else if(window.FileAPI.jsPath)b=window.FileAPI.jsPath;else for(c=0;c<h.length;c++)if(f=h[c].src,e=f.search(/\/angular\-file\-upload[\-a-zA-z0-9\.]*\.js/),e>-1){b=f.substring(0,e+1);break}null==FileAPI.staticPath&&(FileAPI.staticPath=b),g.setAttribute("src",a||b+"FileAPI.min.js"),document.getElementsByTagName("head")[0].appendChild(g),FileAPI.hasFlash=d()}}(),FileAPI.disableFileInput=function(a,b){b?a.removeClass("js-fileapi-wrapper"):a.addClass("js-fileapi-wrapper")}}window.FileReader||(window.FileReader=function(){var a=this,b=!1;this.listeners={},this.addEventListener=function(b,c){a.listeners[b]=a.listeners[b]||[],a.listeners[b].push(c)},this.removeEventListener=function(b,c){a.listeners[b]&&a.listeners[b].splice(a.listeners[b].indexOf(c),1)},this.dispatchEvent=function(b){var c=a.listeners[b.type];if(c)for(var d=0;d<c.length;d++)c[d].call(a,b)},this.onabort=this.onerror=this.onload=this.onloadstart=this.onloadend=this.onprogress=null;var c=function(b,c){var d={type:b,target:a,loaded:c.loaded,total:c.total,error:c.error};return null!=c.result&&(d.target.result=c.result),d},d=function(d){if(b||(b=!0,a.onloadstart&&a.onloadstart(c("loadstart",d))),"load"===d.type){a.onloadend&&a.onloadend(c("loadend",d));var e=c("load",d);a.onload&&a.onload(e),a.dispatchEvent(e)}else if("progress"===d.type){var e=c("progress",d);a.onprogress&&a.onprogress(e),a.dispatchEvent(e)}else{var e=c("error",d);a.onerror&&a.onerror(e),a.dispatchEvent(e)}};this.readAsArrayBuffer=function(a){FileAPI.readAsBinaryString(a,d)},this.readAsBinaryString=function(a){FileAPI.readAsBinaryString(a,d)},this.readAsDataURL=function(a){FileAPI.readAsDataURL(a,d)},this.readAsText=function(a){FileAPI.readAsText(a,d)}})}();
/**
 * Bunch of useful filters for angularJS(with no external dependencies!)
 * @version v0.5.4 - 2015-02-20 * @link https://github.com/a8m/angular-filter
 * @author Ariel Mashraki <ariel@mashraki.co.il>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */!function(a,b,c){"use strict";function d(a){return D(a)?a:Object.keys(a).map(function(b){return a[b]})}function e(a){return null===a}function f(a,b){var d=Object.keys(a);return-1==d.map(function(d){return b[d]!==c&&b[d]==a[d]}).indexOf(!1)}function g(a,b){if(""===b)return a;var c=a.indexOf(b.charAt(0));return-1===c?!1:g(a.substr(c+1),b.substr(1))}function h(a,b,c){var d=0;return a.filter(function(a){var e=x(c)?b>d&&c(a):b>d;return d=e?d+1:d,e})}function i(a,b,c){return c.round(a*c.pow(10,b))/c.pow(10,b)}function j(a,b,c){b=b||[];var d=Object.keys(a);return d.forEach(function(d){if(C(a[d])&&!D(a[d])){var e=c?c+"."+d:c;j(a[d],b,e||d)}else{var f=c?c+"."+d:d;b.push(f)}}),b}function k(a){return a&&a.$evalAsync&&a.$watch}function l(){return function(a,b){return a>b}}function m(){return function(a,b){return a>=b}}function n(){return function(a,b){return b>a}}function o(){return function(a,b){return b>=a}}function p(){return function(a,b){return a==b}}function q(){return function(a,b){return a!=b}}function r(){return function(a,b){return a===b}}function s(){return function(a,b){return a!==b}}function t(a){return function(b,c){return b=C(b)?d(b):b,!D(b)||y(c)?!1:b.some(function(b){return C(b)||z(c)?a(c)(b):b===c})}}function u(a,b){return b=b||0,b>=a.length?a:D(a[b])?u(a.slice(0,b).concat(a[b],a.slice(b+1)),b):u(a,b+1)}function v(a){return function(b,c){function e(a,b){return y(b)?!1:a.some(function(a){return H(a,b)})}if(b=C(b)?d(b):b,!D(b))return b;var f=[],g=a(c);return b.filter(y(c)?function(a,b,c){return c.indexOf(a)===b}:function(a){var b=g(a);return e(f,b)?!1:(f.push(b),!0)})}}function w(a,b,c){return b?a+c+w(a,--b,c):a}var x=b.isDefined,y=b.isUndefined,z=b.isFunction,A=b.isString,B=b.isNumber,C=b.isObject,D=b.isArray,E=b.forEach,F=b.extend,G=b.copy,H=b.equals;String.prototype.contains||(String.prototype.contains=function(){return-1!==String.prototype.indexOf.apply(this,arguments)}),b.module("a8m.angular",[]).filter("isUndefined",function(){return function(a){return b.isUndefined(a)}}).filter("isDefined",function(){return function(a){return b.isDefined(a)}}).filter("isFunction",function(){return function(a){return b.isFunction(a)}}).filter("isString",function(){return function(a){return b.isString(a)}}).filter("isNumber",function(){return function(a){return b.isNumber(a)}}).filter("isArray",function(){return function(a){return b.isArray(a)}}).filter("isObject",function(){return function(a){return b.isObject(a)}}).filter("isEqual",function(){return function(a,c){return b.equals(a,c)}}),b.module("a8m.conditions",[]).filter({isGreaterThan:l,">":l,isGreaterThanOrEqualTo:m,">=":m,isLessThan:n,"<":n,isLessThanOrEqualTo:o,"<=":o,isEqualTo:p,"==":p,isNotEqualTo:q,"!=":q,isIdenticalTo:r,"===":r,isNotIdenticalTo:s,"!==":s}),b.module("a8m.is-null",[]).filter("isNull",function(){return function(a){return e(a)}}),b.module("a8m.after-where",[]).filter("afterWhere",function(){return function(a,b){if(a=C(a)?d(a):a,!D(a)||y(b))return a;var c=a.map(function(a){return f(b,a)}).indexOf(!0);return a.slice(-1===c?0:c)}}),b.module("a8m.after",[]).filter("after",function(){return function(a,b){return a=C(a)?d(a):a,D(a)?a.slice(b):a}}),b.module("a8m.before-where",[]).filter("beforeWhere",function(){return function(a,b){if(a=C(a)?d(a):a,!D(a)||y(b))return a;var c=a.map(function(a){return f(b,a)}).indexOf(!0);return a.slice(0,-1===c?a.length:++c)}}),b.module("a8m.before",[]).filter("before",function(){return function(a,b){return a=C(a)?d(a):a,D(a)?a.slice(0,b?--b:b):a}}),b.module("a8m.concat",[]).filter("concat",[function(){return function(a,b){if(y(b))return a;if(D(a))return a.concat(C(b)?d(b):b);if(C(a)){var c=d(a);return c.concat(C(b)?d(b):b)}return a}}]),b.module("a8m.contains",[]).filter({contains:["$parse",t],some:["$parse",t]}),b.module("a8m.count-by",[]).filter("countBy",["$parse",function(a){return function(b,c){var e,f={},g=a(c);return b=C(b)?d(b):b,!D(b)||y(c)?b:(b.forEach(function(a){e=g(a),f[e]||(f[e]=0),f[e]++}),f)}}]),b.module("a8m.defaults",[]).filter("defaults",["$parse",function(a){return function(b,c){if(b=C(b)?d(b):b,!D(b)||!C(c))return b;var e=j(c);return b.forEach(function(b){e.forEach(function(d){var e=a(d),f=e.assign;y(e(b))&&f(b,e(c))})}),b}}]),b.module("a8m.every",[]).filter("every",["$parse",function(a){return function(b,c){return b=C(b)?d(b):b,!D(b)||y(c)?!0:b.every(function(b){return C(b)||z(c)?a(c)(b):b===c})}}]),b.module("a8m.filter-by",[]).filter("filterBy",["$parse",function(a){return function(b,e,f){var g;return f=A(f)||B(f)?String(f).toLowerCase():c,b=C(b)?d(b):b,!D(b)||y(f)?b:b.filter(function(b){return e.some(function(c){if(~c.indexOf("+")){var d=c.replace(new RegExp("\\s","g"),"").split("+");g=d.reduce(function(c,d,e){return 1===e?a(c)(b)+" "+a(d)(b):c+" "+a(d)(b)})}else g=a(c)(b);return A(g)||B(g)?String(g).toLowerCase().contains(f):!1})})}}]),b.module("a8m.first",[]).filter("first",["$parse",function(a){return function(b){var e,f,g;return b=C(b)?d(b):b,D(b)?(g=Array.prototype.slice.call(arguments,1),e=B(g[0])?g[0]:1,f=B(g[0])?B(g[1])?c:g[1]:g[0],g.length?h(b,e,f?a(f):f):b[0]):b}}]),b.module("a8m.flatten",[]).filter("flatten",function(){return function(a,b){return b=b||!1,a=C(a)?d(a):a,D(a)?b?[].concat.apply([],a):u(a,0):a}}),b.module("a8m.fuzzy-by",[]).filter("fuzzyBy",["$parse",function(a){return function(b,c,e,f){var h,i,j=f||!1;return b=C(b)?d(b):b,!D(b)||y(c)||y(e)?b:(i=a(c),b.filter(function(a){return h=i(a),A(h)?(h=j?h:h.toLowerCase(),e=j?e:e.toLowerCase(),g(h,e)!==!1):!1}))}}]),b.module("a8m.fuzzy",[]).filter("fuzzy",function(){return function(a,b,c){function e(a,b){var c,d,e=Object.keys(a);return 0<e.filter(function(e){return c=a[e],d?!0:A(c)?(c=f?c:c.toLowerCase(),d=g(c,b)!==!1):!1}).length}var f=c||!1;return a=C(a)?d(a):a,!D(a)||y(b)?a:(b=f?b:b.toLowerCase(),a.filter(function(a){return A(a)?(a=f?a:a.toLowerCase(),g(a,b)!==!1):C(a)?e(a,b):!1}))}}),b.module("a8m.group-by",["a8m.filter-watcher"]).filter("groupBy",["$parse","filterWatcher",function(a,b){return function(c,d){function e(a,b){var c,d={};return E(a,function(a){c=b(a),d[c]||(d[c]=[]),d[c].push(a)}),d}if(!C(c)||y(d))return c;var f=a(d);return b.isMemoized("groupBy",arguments)||b.memoize("groupBy",arguments,this,e(c,f))}}]),b.module("a8m.is-empty",[]).filter("isEmpty",function(){return function(a){return C(a)?!d(a).length:!a.length}}),b.module("a8m.join",[]).filter("join",function(){return function(a,b){return y(a)||!D(a)?a:(y(b)&&(b=" "),a.join(b))}}),b.module("a8m.last",[]).filter("last",["$parse",function(a){return function(b){var e,f,g,i=G(b);return i=C(i)?d(i):i,D(i)?(g=Array.prototype.slice.call(arguments,1),e=B(g[0])?g[0]:1,f=B(g[0])?B(g[1])?c:g[1]:g[0],g.length?h(i.reverse(),e,f?a(f):f).reverse():i[i.length-1]):i}}]),b.module("a8m.map",[]).filter("map",["$parse",function(a){return function(b,c){return b=C(b)?d(b):b,!D(b)||y(c)?b:b.map(function(b){return a(c)(b)})}}]),b.module("a8m.omit",[]).filter("omit",["$parse",function(a){return function(b,c){return b=C(b)?d(b):b,!D(b)||y(c)?b:b.filter(function(b){return!a(c)(b)})}}]),b.module("a8m.pick",[]).filter("pick",["$parse",function(a){return function(b,c){return b=C(b)?d(b):b,!D(b)||y(c)?b:b.filter(function(b){return a(c)(b)})}}]),b.module("a8m.remove-with",[]).filter("removeWith",function(){return function(a,b){return y(b)?a:(a=C(a)?d(a):a,a.filter(function(a){return!f(b,a)}))}}),b.module("a8m.remove",[]).filter("remove",function(){return function(a){a=C(a)?d(a):a;var b=Array.prototype.slice.call(arguments,1);return D(a)?a.filter(function(a){return!b.some(function(b){return H(b,a)})}):a}}),b.module("a8m.reverse",[]).filter("reverse",[function(){return function(a){return a=C(a)?d(a):a,A(a)?a.split("").reverse().join(""):D(a)?a.slice().reverse():a}}]),b.module("a8m.search-field",[]).filter("searchField",["$parse",function(a){return function(b){var c,e;b=C(b)?d(b):b;var f=Array.prototype.slice.call(arguments,1);return D(b)&&f.length?b.map(function(b){return e=f.map(function(d){return(c=a(d))(b)}).join(" "),F(b,{searchField:e})}):b}}]),b.module("a8m.to-array",[]).filter("toArray",function(){return function(a,b){return C(a)?b?Object.keys(a).map(function(b){return F(a[b],{$key:b})}):d(a):a}}),b.module("a8m.unique",[]).filter({unique:["$parse",v],uniq:["$parse",v]}),b.module("a8m.where",[]).filter("where",function(){return function(a,b){return y(b)?a:(a=C(a)?d(a):a,a.filter(function(a){return f(b,a)}))}}),b.module("a8m.xor",[]).filter("xor",["$parse",function(a){return function(b,c,e){function f(b,c){var d=a(e);return c.some(function(a){return e?H(d(a),d(b)):H(a,b)})}return e=e||!1,b=C(b)?d(b):b,c=C(c)?d(c):c,D(b)&&D(c)?b.concat(c).filter(function(a){return!(f(a,b)&&f(a,c))}):b}}]),b.module("a8m.math.byteFmt",["a8m.math"]).filter("byteFmt",["$math",function(a){return function(b,c){return B(c)&&isFinite(c)&&c%1===0&&c>=0&&B(b)&&isFinite(b)?1024>b?i(b,c,a)+" B":1048576>b?i(b/1024,c,a)+" KB":1073741824>b?i(b/1048576,c,a)+" MB":i(b/1073741824,c,a)+" GB":"NaN"}}]),b.module("a8m.math.degrees",["a8m.math"]).filter("degrees",["$math",function(a){return function(b,c){if(B(c)&&isFinite(c)&&c%1===0&&c>=0&&B(b)&&isFinite(b)){var d=180*b/a.PI;return a.round(d*a.pow(10,c))/a.pow(10,c)}return"NaN"}}]),b.module("a8m.math.kbFmt",["a8m.math"]).filter("kbFmt",["$math",function(a){return function(b,c){return B(c)&&isFinite(c)&&c%1===0&&c>=0&&B(b)&&isFinite(b)?1024>b?i(b,c,a)+" KB":1048576>b?i(b/1024,c,a)+" MB":i(b/1048576,c,a)+" GB":"NaN"}}]),b.module("a8m.math",[]).factory("$math",["$window",function(a){return a.Math}]),b.module("a8m.math.max",["a8m.math"]).filter("max",["$math","$parse",function(a,b){function c(c,d){var e=c.map(function(a){return b(d)(a)});return e.indexOf(a.max.apply(a,e))}return function(b,d){return D(b)?y(d)?a.max.apply(a,b):b[c(b,d)]:b}}]),b.module("a8m.math.min",["a8m.math"]).filter("min",["$math","$parse",function(a,b){function c(c,d){var e=c.map(function(a){return b(d)(a)});return e.indexOf(a.min.apply(a,e))}return function(b,d){return D(b)?y(d)?a.min.apply(a,b):b[c(b,d)]:b}}]),b.module("a8m.math.percent",["a8m.math"]).filter("percent",["$math","$window",function(a,b){return function(c,d,e){var f=A(c)?b.Number(c):c;return d=d||100,e=e||!1,!B(f)||b.isNaN(f)?c:e?a.round(f/d*100):f/d*100}}]),b.module("a8m.math.radians",["a8m.math"]).filter("radians",["$math",function(a){return function(b,c){if(B(c)&&isFinite(c)&&c%1===0&&c>=0&&B(b)&&isFinite(b)){var d=3.14159265359*b/180;return a.round(d*a.pow(10,c))/a.pow(10,c)}return"NaN"}}]),b.module("a8m.math.radix",[]).filter("radix",function(){return function(a,b){var c=/^[2-9]$|^[1-2]\d$|^3[0-6]$/;return B(a)&&c.test(b)?a.toString(b).toUpperCase():a}}),b.module("a8m.math.shortFmt",["a8m.math"]).filter("shortFmt",["$math",function(a){return function(b,c){return B(c)&&isFinite(c)&&c%1===0&&c>=0&&B(b)&&isFinite(b)?1e3>b?b:1e6>b?i(b/1e3,c,a)+" K":1e9>b?i(b/1e6,c,a)+" M":i(b/1e9,c,a)+" B":"NaN"}}]),b.module("a8m.math.sum",[]).filter("sum",function(){return function(a,b){return D(a)?a.reduce(function(a,b){return a+b},b||0):a}}),b.module("a8m.ends-with",[]).filter("endsWith",function(){return function(a,b,c){var d,e=c||!1;return!A(a)||y(b)?a:(a=e?a:a.toLowerCase(),d=a.length-b.length,-1!==a.indexOf(e?b:b.toLowerCase(),d))}}),b.module("a8m.latinize",[]).filter("latinize",[function(){function a(a){return a.replace(/[^\u0000-\u007E]/g,function(a){return c[a]||a})}for(var b=[{base:"A",letters:"AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"},{base:"AA",letters:"Ꜳ"},{base:"AE",letters:"ÆǼǢ"},{base:"AO",letters:"Ꜵ"},{base:"AU",letters:"Ꜷ"},{base:"AV",letters:"ꜸꜺ"},{base:"AY",letters:"Ꜽ"},{base:"B",letters:"BⒷＢḂḄḆɃƂƁ"},{base:"C",letters:"CⒸＣĆĈĊČÇḈƇȻꜾ"},{base:"D",letters:"DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"},{base:"DZ",letters:"ǱǄ"},{base:"Dz",letters:"ǲǅ"},{base:"E",letters:"EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"},{base:"F",letters:"FⒻＦḞƑꝻ"},{base:"G",letters:"GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"},{base:"H",letters:"HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"},{base:"I",letters:"IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"},{base:"J",letters:"JⒿＪĴɈ"},{base:"K",letters:"KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"},{base:"L",letters:"LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"},{base:"LJ",letters:"Ǉ"},{base:"Lj",letters:"ǈ"},{base:"M",letters:"MⓂＭḾṀṂⱮƜ"},{base:"N",letters:"NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"},{base:"NJ",letters:"Ǌ"},{base:"Nj",letters:"ǋ"},{base:"O",letters:"OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"},{base:"OI",letters:"Ƣ"},{base:"OO",letters:"Ꝏ"},{base:"OU",letters:"Ȣ"},{base:"OE",letters:"Œ"},{base:"oe",letters:"œ"},{base:"P",letters:"PⓅＰṔṖƤⱣꝐꝒꝔ"},{base:"Q",letters:"QⓆＱꝖꝘɊ"},{base:"R",letters:"RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"},{base:"S",letters:"SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"},{base:"T",letters:"TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"},{base:"TZ",letters:"Ꜩ"},{base:"U",letters:"UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"},{base:"V",letters:"VⓋＶṼṾƲꝞɅ"},{base:"VY",letters:"Ꝡ"},{base:"W",letters:"WⓌＷẀẂŴẆẄẈⱲ"},{base:"X",letters:"XⓍＸẊẌ"},{base:"Y",letters:"YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"},{base:"Z",letters:"ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"},{base:"a",letters:"aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"},{base:"aa",letters:"ꜳ"},{base:"ae",letters:"æǽǣ"},{base:"ao",letters:"ꜵ"},{base:"au",letters:"ꜷ"},{base:"av",letters:"ꜹꜻ"},{base:"ay",letters:"ꜽ"},{base:"b",letters:"bⓑｂḃḅḇƀƃɓ"},{base:"c",letters:"cⓒｃćĉċčçḉƈȼꜿↄ"},{base:"d",letters:"dⓓｄḋďḍḑḓḏđƌɖɗꝺ"},{base:"dz",letters:"ǳǆ"},{base:"e",letters:"eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"},{base:"f",letters:"fⓕｆḟƒꝼ"},{base:"g",letters:"gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"},{base:"h",letters:"hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"},{base:"hv",letters:"ƕ"},{base:"i",letters:"iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"},{base:"j",letters:"jⓙｊĵǰɉ"},{base:"k",letters:"kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"},{base:"l",letters:"lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"},{base:"lj",letters:"ǉ"},{base:"m",letters:"mⓜｍḿṁṃɱɯ"},{base:"n",letters:"nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"},{base:"nj",letters:"ǌ"},{base:"o",letters:"oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"},{base:"oi",letters:"ƣ"},{base:"ou",letters:"ȣ"},{base:"oo",letters:"ꝏ"},{base:"p",letters:"pⓟｐṕṗƥᵽꝑꝓꝕ"},{base:"q",letters:"qⓠｑɋꝗꝙ"},{base:"r",letters:"rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"},{base:"s",letters:"sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"},{base:"t",letters:"tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"},{base:"tz",letters:"ꜩ"},{base:"u",letters:"uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"},{base:"v",letters:"vⓥｖṽṿʋꝟʌ"},{base:"vy",letters:"ꝡ"},{base:"w",letters:"wⓦｗẁẃŵẇẅẘẉⱳ"},{base:"x",letters:"xⓧｘẋẍ"},{base:"y",letters:"yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"},{base:"z",letters:"zⓩｚźẑżžẓẕƶȥɀⱬꝣ"}],c={},d=0;d<b.length;d++)for(var e=b[d].letters.split(""),f=0;f<e.length;f++)c[e[f]]=b[d].base;return function(b){return A(b)?a(b):b}}]),b.module("a8m.ltrim",[]).filter("ltrim",function(){return function(a,b){var c=b||"\\s";return A(a)?a.replace(new RegExp("^"+c+"+"),""):a}}),b.module("a8m.match",[]).filter("match",function(){return function(a,b,c){var d=new RegExp(b,c);return A(a)?a.match(d):null}}),b.module("a8m.repeat",[]).filter("repeat",[function(){return function(a,b,c){var d=~~b;return A(a)&&d?w(a,--b,c||""):a}}]),b.module("a8m.rtrim",[]).filter("rtrim",function(){return function(a,b){var c=b||"\\s";return A(a)?a.replace(new RegExp(c+"+$"),""):a}}),b.module("a8m.slugify",[]).filter("slugify",[function(){return function(a,b){var c=y(b)?"-":b;return A(a)?a.toLowerCase().replace(/\s+/g,c):a}}]),b.module("a8m.starts-with",[]).filter("startsWith",function(){return function(a,b,c){var d=c||!1;return!A(a)||y(b)?a:(a=d?a:a.toLowerCase(),!a.indexOf(d?b:b.toLowerCase()))}}),b.module("a8m.stringular",[]).filter("stringular",function(){return function(a){var b=Array.prototype.slice.call(arguments,1);return a.replace(/{(\d+)}/g,function(a,c){return y(b[c])?a:b[c]})}}),b.module("a8m.strip-tags",[]).filter("stripTags",function(){return function(a){return A(a)?a.replace(/<\S[^><]*>/g,""):a}}),b.module("a8m.test",[]).filter("test",function(){return function(a,b,c){var d=new RegExp(b,c);return A(a)?d.test(a):a}}),b.module("a8m.trim",[]).filter("trim",function(){return function(a,b){var c=b||"\\s";return A(a)?a.replace(new RegExp("^"+c+"+|"+c+"+$","g"),""):a}}),b.module("a8m.truncate",[]).filter("truncate",function(){return function(a,b,c,d){return b=y(b)?a.length:b,d=d||!1,c=c||"",!A(a)||a.length<=b?a:a.substring(0,d?-1===a.indexOf(" ",b)?a.length:a.indexOf(" ",b):b)+c}}),b.module("a8m.ucfirst",[]).filter("ucfirst",[function(){return function(a){return A(a)?a.split(" ").map(function(a){return a.charAt(0).toUpperCase()+a.substring(1)}).join(" "):a}}]),b.module("a8m.uri-component-encode",[]).filter("uriComponentEncode",["$window",function(a){return function(b){return A(b)?a.encodeURIComponent(b):b}}]),b.module("a8m.uri-encode",[]).filter("uriEncode",["$window",function(a){return function(b){return A(b)?a.encodeURI(b):b}}]),b.module("a8m.wrap",[]).filter("wrap",function(){return function(a,b,c){return A(a)&&x(b)?[b,a,c||b].join(""):a}}),b.module("a8m.filter-watcher",[]).provider("filterWatcher",function(){this.$get=["$window","$rootScope",function(a,c){function d(a,c){return[a,b.toJson(c)].join("#").replace(/"/g,"")}function e(a){var b=a.targetScope.$id;E(l[b],function(a){delete j[a]}),delete l[b]}function f(){m(function(){c.$$phase||(j={})})}function g(a,b){var c=a.$id;return y(l[c])&&(a.$on("$destroy",e),l[c]=[]),l[c].push(b)}function h(a,b){var c=d(a,b);return j[c]}function i(a,b,c,e){var h=d(a,b);return j[h]=e,k(c)?g(c,h):f(),e}var j={},l={},m=a.setTimeout;return{isMemoized:h,memoize:i}}]}),b.module("angular.filter",["a8m.ucfirst","a8m.uri-encode","a8m.uri-component-encode","a8m.slugify","a8m.latinize","a8m.strip-tags","a8m.stringular","a8m.truncate","a8m.starts-with","a8m.ends-with","a8m.wrap","a8m.trim","a8m.ltrim","a8m.rtrim","a8m.repeat","a8m.test","a8m.match","a8m.to-array","a8m.concat","a8m.contains","a8m.unique","a8m.is-empty","a8m.after","a8m.after-where","a8m.before","a8m.before-where","a8m.defaults","a8m.where","a8m.reverse","a8m.remove","a8m.remove-with","a8m.group-by","a8m.count-by","a8m.search-field","a8m.fuzzy-by","a8m.fuzzy","a8m.omit","a8m.pick","a8m.every","a8m.filter-by","a8m.xor","a8m.map","a8m.first","a8m.last","a8m.flatten","a8m.join","a8m.math","a8m.math.max","a8m.math.min","a8m.math.percent","a8m.math.radix","a8m.math.sum","a8m.math.degrees","a8m.math.radians","a8m.math.byteFmt","a8m.math.kbFmt","a8m.math.shortFmt","a8m.angular","a8m.conditions","a8m.is-null","a8m.filter-watcher"])}(window,window.angular);
/*
angular-tablesort v1.4.1
(c) 2013-2016 Mattias Holmlund, http://mattiash.github.io/angular-tablesort
License: MIT
*/

var tableSortModule = angular.module( 'tableSort', [] );

tableSortModule.provider( 'tableSortConfig', function () {
    this.filterTemplate = '';                          //No filtering by default unless a template is provided
    this.filterFunction = undefined;                   //Empty by default - use the built in filter function when left blank
    this.paginationTemplate = '';                      //No pagination by default unless a template is provided

    //The below options can all be overridden on a per-table basis
    this.perPageOptions = [10, 25, 50, 100];           //Default pagination options
    this.perPageDefault = this.perPageOptions[0];      //Select the first option by default
    this.itemNameSingular = 'item';                    //Default name
    this.itemNamePlural = this.itemNameSingular + 's'; //Default way to make an item plural for English
    this.noDataText = 'No ' + this.itemNamePlural;     //Default text to show that there are no items
    this.wrappingElementClass = "";                    //Empty by default

    if( !isNaN(this.perPageDefault) && this.perPageOptions.indexOf(this.perPageDefault) === -1 ) {
        //If a default per-page option was added that isn't in the array, add it at the end
        this.perPageOptions.push(this.perPageDefault);
    }

    //Sort the per-page options array
    this.perPageOptions.sort(function (a,b) {return a - b;});

    this.$get = function () {
        return this;
    };

});

tableSortModule.directive( 'tsWrapper', ['$parse', '$compile', function( $parse, $compile ) {
    'use strict';

    function replaceTemplateTokens($scope, templateString) {
        //Replace some strings with the proper expressions to be compiled
        return templateString
            .replace(/FILTER_STRING/g, 'filtering.filterString')
            .replace(/CURRENT_PAGE_RANGE/g, 'pagination.getPageRangeString(TOTAL_COUNT)')
            .replace(/TOTAL_COUNT/g, $scope.itemsArrayExpression + '.length')
            .replace(/PER_PAGE_OPTIONS/g, 'pagination.perPageOptions')
            .replace(/ITEMS_PER_PAGE/g, 'pagination.perPage')
            .replace(/ITEM_NAME_SINGULAR/g, 'itemNameSingular')
            .replace(/ITEM_NAME_PLURAL/g, 'itemNamePlural')
            .replace(/FILTERED_COUNT/g, 'filtering.filteredCount')
            .replace(/CURRENT_PAGE_NUMBER/g, 'pagination.currentPage');
    }

    function createDefaultComparer() {

        function _defaultComparer(a, b) {
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
        };

        var stringComparer = _defaultComparer;
        var numericComparer = _defaultComparer;

        if(typeof Intl === 'object') {
            stringComparer = new Intl.Collator(undefined, {sensitivity: 'case'}).compare;
        }
        else if(typeof String.prototype.localeCompare === 'function') {
            stringComparer = function(a, b) {
                return (a + '').localeCompare(b, undefined, {sensitivity: 'case'});
            };
        }

        var comparerFn = function (a, b) {
            if (typeof a === 'number' && typeof b === 'number')
                return numericComparer(a, b);

            if (a instanceof Date && b instanceof Date)
                return numericComparer(a.getTime(), b.getTime());

            return stringComparer(a, b);
        };

        return comparerFn;
    }

    var defaultComparer = createDefaultComparer();

    return {
        scope: true,
        controller: ['$scope', 'tableSortConfig', function($scope, tableSortConfig ) {
            //local scope vars for this directive
            $scope.pagination = {
                template: tableSortConfig.paginationTemplate,
                perPageOptions: tableSortConfig.perPageOptions.concat(), //copy the array, not a reference
                perPage: tableSortConfig.perPageDefault,
                currentPage: 1,
                getPageRangeString: function(total) {
                    //TODO: Format these numbers, perhaps optionally
                    var maxOnPage = total !== $scope.filtering.filteredCount ? $scope.filtering.filteredCount : total;
                    //This keeps the first page labeled as 1, not 0
                    var startPage = Math.max(($scope.pagination.currentPage - 1) * $scope.pagination.perPage + 1, 1);
                    var endPage = Math.min($scope.pagination.currentPage * $scope.pagination.perPage, maxOnPage);
                    //This prevents the range from showing when the total number of items can be shown on a single page
                    return $scope.filtering.filteredCount === 0 ? '' : (endPage === maxOnPage && startPage === 1 ? '' : startPage + '-') + endPage;
                }
            };

            $scope.filtering = {
                template: tableSortConfig.filterTemplate,
                filterString: '',
                filterFunction: tableSortConfig.filterFunction,
                filteredCount: 0,
                filterFields: []
            };

            $scope.itemsArrayExpression = ''; //this will contain the string expression for the array of items in the table
            $scope.itemNameSingular = tableSortConfig.itemNameSingular;
            $scope.itemNamePlural = tableSortConfig.itemNamePlural;
            $scope.noDataText = tableSortConfig.noDataText;
            $scope.wrappingElementClass = tableSortConfig.wrappingElementClass;
            $scope.sortExpression = [];
            $scope.headings = [];

            var parse_sortexpr = function( expr, name ) {
                return [$parse( expr ), null, false, name ? name : expr];
            };

            this.setSortField = function( sortexpr, element, name, sortBy ) {
                var i;
                var expr = parse_sortexpr( sortexpr, name );
                expr.push(sortBy);
                if( $scope.sortExpression.length === 1 && $scope.sortExpression[0][0] === expr[0] ) {
                    if( $scope.sortExpression[0][2] ) {
                        element.removeClass( 'tablesort-desc' );
                        element.addClass( 'tablesort-asc' );
                        $scope.sortExpression[0][2] = false;
                    } else {
                        element.removeClass( 'tablesort-asc' );
                        element.addClass( 'tablesort-desc' );
                        $scope.sortExpression[0][2] = true;
                    }
                    $scope.$emit( 'tablesort:sortOrder', [{
                      name: $scope.sortExpression[0][3],
                      order: $scope.sortExpression[0][2]
                    }]);
                } else {
                    for( i=0; i<$scope.headings.length; i=i+1 ) {
                        $scope.headings[i]
                            .removeClass( 'tablesort-desc' )
                            .removeClass( 'tablesort-asc' );
                    }
                    element.addClass( 'tablesort-asc' );
                    $scope.sortExpression = [expr];
                    $scope.$emit( 'tablesort:sortOrder', [{
                      name: expr[3],
                      order: expr[2]
                    }]);
                }
            };

            this.addSortField = function( sortexpr, element, name, sortBy ) {
                var i;
                var toggle_order = false;
                var expr = parse_sortexpr( sortexpr, name );
                expr.push(sortBy);
                for( i=0; i<$scope.sortExpression.length; i=i+1 ) {
                    if( $scope.sortExpression[i][0] === expr[0] ) {
                        if( $scope.sortExpression[i][2] ) {
                            element.removeClass( 'tablesort-desc' );
                            element.addClass( 'tablesort-asc' );
                            $scope.sortExpression[i][2] = false;
                        } else {
                            element.removeClass( 'tablesort-asc' );
                            element.addClass( 'tablesort-desc' );
                            $scope.sortExpression[i][2] = true;
                        }
                        toggle_order = true;
                    }
                }
                if( !toggle_order ) {
                    element.addClass( 'tablesort-asc' );
                    $scope.sortExpression.push( expr );
                }

                $scope.$emit( 'tablesort:sortOrder', $scope.sortExpression.map(function (a) {
                  return {
                    name: a[3],
                    order: a[2]
                  };
                }));

            };

            this.setTrackBy = function( trackBy ) {
                $scope.trackBy = trackBy;
            };

            this.registerHeading = function( headingelement ) {
                $scope.headings.push( headingelement );
            };

            this.addFilterField = function( sortexpr, element ) {
                var expr = parse_sortexpr( sortexpr );
                $scope.filtering.filterFields.push( expr );
            };

            this.setArrayExpr = function( dataArrayExp ) {
                $scope.itemsArrayExpression = dataArrayExp;
            };
        }],
        link: function($scope, $element, $attrs, tsWrapperCtrl) {

            if( $attrs.tsItemName ) {
                var originalNoDataText = 'No ' + $scope.itemNamePlural;

                //if the table attributes has an item name on it, this takes priority
                $scope.itemNameSingular = $attrs.tsItemName;

                if( $attrs.tsItemNamePlural ) {
                    //if a plural name was specified, use that
                    $scope.itemNamePlural = $attrs.tsItemNamePlural;
                } else {
                    //otherwise just add 's' to the singular name
                    $scope.itemNamePlural = $attrs.tsItemName + 's';
                }

                if( !$attrs.tsNoDataText && $scope.noDataText === originalNoDataText ) {
                    //If the noDataText was NOT specified AND it's in the same 'No ITEMS' format as the default , update it to contain the new item name
                    $scope.noDataText = 'No ' + $scope.itemNamePlural;
                }
            }

            if( $attrs.tsNoDataText ) {
                //If the noDataText was specified, update it
                $scope.noDataText = $attrs.tsNoDataText;
            }

            if( $attrs.tsWrappingElementClass ) {
                //If the wrappingElementClass was specified, update it
                $scope.wrappingElementClass = $attrs.tsWrappingElementClass;
            }

            //local attribute usages of the pagination/filtering options will override the global config
            if( $attrs.tsPerPageOptions ) {
                $scope.pagination.perPageOptions = $scope.$eval($attrs.tsPerPageOptions);
            }

            if( $attrs.tsPerPageDefault ) {
                var defaultPerPage = $scope.$eval($attrs.tsPerPageDefault);
                if( !isNaN(defaultPerPage) ) {
                    $scope.pagination.perPage = defaultPerPage;
                    if( $scope.pagination.perPageOptions.indexOf($scope.pagination.perPage) === -1 ) {
                        //If a default per-page option was added that isn't in the array, add it and sort the array
                        $scope.pagination.perPageOptions.push($scope.pagination.perPage);
                        $scope.pagination.perPageOptions.sort(function (a,b) {return a - b;});
                    }
                }
            }

            if( $attrs.tsFilterFields ) {
                var filterFields = $attrs.tsFilterFields.split(',')
                    .filter(function(item) {
                        return item && item.trim() !== '';
                    });
                for( var i=0; i<filterFields.length; i=i+1 ) {
                    tsWrapperCtrl.addFilterField(filterFields[i]);
                }
            }

            var $filterHtml;
            if( $attrs.tsDisplayFiltering !== 'false' && $scope.filtering.template !== '' && $scope.filtering.filterFields.length>0 ) {
                var filterString = replaceTemplateTokens($scope, $scope.filtering.template);
                $filterHtml = $compile(filterString)($scope);
                //Add filtering HTML BEFORE the table
                $element.parent()[0].insertBefore($filterHtml[0], $element[0]);
            }

            if( $attrs.tsFilterFunction ) {
                //if the table attributes has a filter function on it, this takes priority
                $scope.filtering.filterFunction = $scope.$eval($attrs.tsFilterFunction);
            }

            if( !angular.isFunction($scope.filtering.filterFunction) ) {
                //No custom filter was provided...
                if( $scope.filtering.filterFields.length===0 ) {
                    //There are no filter fields, so always return everything
                    $scope.filtering.filterFunction = function(item) {
                        return true;
                    };
                } else {
                    //This is the default filter function. It does a lowercase string match
                    $scope.filtering.filterFunction = function(item) {
                        var shouldInclude = false;
                        for( var i=0; i<$scope.filtering.filterFields.length; i=i+1 ) {
                            if( !shouldInclude ) {
                                var str = ($scope.filtering.filterFields[i][0](item) || '').toString().toLowerCase(); //parse the item's property using the `ts-criteria` value & filter
                                shouldInclude = str.indexOf($scope.filtering.filterString.toLowerCase()) > -1;
                            }
                        }
                        return shouldInclude;
                    };
                }
            }

            $scope.filterLimitFun = function(array) {
                if( !$attrs.tsFilterFunction && $scope.filtering.filterString === '' ) {
                    //Return unfiltered when NOT using a custom filter function and when nothing is being searched
                    $scope.filtering.filteredCount = array.length;
                    return array;
                }
                var filteredArr = array.filter($scope.filtering.filterFunction);
                $scope.filtering.filteredCount = filteredArr.length;
                return filteredArr;
            };

            $scope.sortFun = function( a, b ) {
                var i, aval, bval, descending, filterFun, compResult;
                for( i=0; i<$scope.sortExpression.length; i=i+1 ) {
                    aval = $scope.sortExpression[i][0](a);
                    bval = $scope.sortExpression[i][0](b);
                    filterFun = b[$scope.sortExpression[i][1]];
                    if( filterFun ) {
                        aval = filterFun( aval );
                        bval = filterFun( bval );
                    }
                    if( aval === undefined || aval === null ) {
                        aval = '';
                    }
                    if( bval === undefined || bval === null ) {
                    bval = '';
                    }
                    descending = $scope.sortExpression[i][2];
                    compResult = ($scope.sortExpression[i][4] || defaultComparer)(aval, bval);
                    if( compResult === 1 ) {
                        return descending ? -1 : 1;
                    } else if( compResult === -1 ) {
                        return descending ? 1 : -1;
                    }
                }

                // All the sort fields were equal. If there is a 'track by'' expression,
                // use that as a tiebreaker to make the sort result stable.
                if( $scope.trackBy ) {
                    aval = a[$scope.trackBy];
                    bval = b[$scope.trackBy];
                    if( aval === undefined || aval === null ) {
                        aval = '';
                    }
                    if( bval === undefined || bval === null ) {
                        bval = '';
                    }
                    compResult = defaultComparer(aval, bval);
                    if( compResult === 1 ) {
                        return descending ? -1 : 1;
                    } else if( compResult === -1 ) {
                        return descending ? 1 : -1;
                    }
                }
                return 0;
            };

            $scope.pageLimitFun = function(array) {
                if( $attrs.tsDisplayPagination === 'false' || $scope.pagination.template === '') {
                    //pagination is disabled on this table or there is no template, so return everything
                    return array;
                }
                //Only return the items that are in the correct index range for the currently selected page
                var begin = ($scope.pagination.currentPage - 1) * $scope.pagination.perPage;
                var end = $scope.pagination.currentPage * $scope.pagination.perPage;
                var final=[];
                for( var i=0; i < array.length; i++ ) {
                    if( i >= begin && i < end ) {
                        final.push(array[i]);
                    }
                }
                return final;
            };

            var $paginationHtml;
            if( $attrs.tsDisplayPagination !== 'false' && $scope.pagination.template !== '' ) {
                var pagerString = replaceTemplateTokens($scope, $scope.pagination.template);
                $paginationHtml = $compile(pagerString)($scope);
                //Add pagination HTML AFTER the table
                $element.after($paginationHtml);
            }

             var $wrappingElement;
            if( $scope.wrappingElementClass && $scope.wrappingElementClass !== "" ) {
                //This should happen AFTER the filtering and pagination HTML are set
                $wrappingElement = $element.wrap("<div class='"+ $scope.wrappingElementClass +"' />");
            }

            if( $attrs.tsGetTableDataFunction ) {
                var getter = $parse($attrs.tsGetTableDataFunction);
                var setter = getter.assign;

                //If this attribute has a value, then we want to turn it into a function on the parent scope
                //so that it can be passed into other functions and run on the parent controllers as needed
                var fn  = function( shouldApplySorting, shouldApplyFiltering, limitToCurrentPageOnly ) {
                    var arr = $parse($scope.itemsArrayExpression)($scope);

                    if( shouldApplySorting ) {
                        arr = arr.sort($scope.sortFun);
                    }

                    if( shouldApplyFiltering ) {
                        arr = $scope.filterLimitFun(arr);
                    }

                    if( limitToCurrentPageOnly ) {
                        arr = $scope.pageLimitFun(arr);
                    }

                    return arr;
                };

                setter($scope.$parent, fn);
            }

            $scope.$on( '$destroy', function() {
                //When the directive is destroyed, also remove the filter & pagination HTML
                if( $filterHtml ) {
                    $filterHtml.remove();
                }
                if( $paginationHtml ) {
                    $paginationHtml.remove();
                }
                if( $wrappingElement ) {
                    //un-wrap the table from this element
                    $wrappingElement.replaceWith($element);
                }
            });
        }
    };
}]);

tableSortModule.directive( 'tsCriteria', function() {
    return {
        require: "^tsWrapper",
        scope: {
          tsOrderBy: '='
        },
        link: function(scope, element, attrs, tsWrapperCtrl) {
            var clickingCallback = function(event) {
                scope.$apply( function() {
                    if( event.shiftKey ) {
                        tsWrapperCtrl.addSortField(attrs.tsCriteria, element, attrs.tsName, scope.tsOrderBy);
                    } else {
                        tsWrapperCtrl.setSortField(attrs.tsCriteria, element, attrs.tsName, scope.tsOrderBy);
                    }
                } );
            };
            element[element.on ? 'on' : 'bind']('click', clickingCallback );
            element.addClass( 'tablesort-sortable' );
            if( 'tsDefault' in attrs && attrs.tsDefault !== '0' ) {
                tsWrapperCtrl.addSortField( attrs.tsCriteria, element, attrs.tsName, scope.tsOrderBy );
                if( attrs.tsDefault === 'descending' ) {
                    tsWrapperCtrl.addSortField( attrs.tsCriteria, element, attrs.tsName, scope.tsOrderBy );
                }
            }
            if( 'tsFilter' in attrs) {
                tsWrapperCtrl.addFilterField( attrs.tsCriteria, element );
            }
            tsWrapperCtrl.registerHeading( element );
        }
    };
});

tableSortModule.directive( 'tsRepeat', ['$compile', '$interpolate', function($compile, $interpolate) {
    return {
        terminal: true,
        multiElement: true,
        require: '^tsWrapper',
        priority: 1000000,
        link: function(scope, element, attrs, tsWrapperCtrl) {
            var repeatAttrs = ['ng-repeat', 'data-ng-repeat', 'ng-repeat-start', 'data-ng-repeat-start'];
            var ngRepeatDirective = repeatAttrs[0];
            var tsRepeatDirective = 'ts-repeat';
            for (var i = 0; i < repeatAttrs.length; i++) {
                if (angular.isDefined(element.attr(repeatAttrs[i]))) {
                    ngRepeatDirective = repeatAttrs[i];
                    tsRepeatDirective = ngRepeatDirective.replace(/^(data-)?ng/, '$1ts');
                    break;
                }
            }

            var tsExpr = 'tablesortOrderBy:sortFun | tablesortLimit:filterLimitFun | tablesortLimit:pageLimitFun';
            var repeatExpr = element.attr(ngRepeatDirective);
            var repeatExprRegex = /^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(\s+track\s+by\s+[\s\S]+?)?\s*$/;
            var trackByMatch = repeatExpr.match(/\s+track\s+by\s+\S+?\.(\S+)/);
            var repeatInMatch = repeatExpr.match(repeatExprRegex);
            if (trackByMatch) {
                tsWrapperCtrl.setTrackBy(trackByMatch[1]);
            }

            //Limit Sort the results, then limit them to only include what matches the filter, then only what's on the current page
            if (repeatExpr.search(/tablesort/) !== -1) {
                repeatExpr = repeatExpr.replace(/tablesort/, tsExpr);
                if (trackByMatch) {
                    //Move the 'track by'' statement to the end
                    repeatExpr = repeatExpr.replace(trackByMatch[0], '') + trackByMatch[0];
                }
            } else {
                repeatExpr = repeatExpr.replace(repeatExprRegex, '$1 in $2 | ' + tsExpr + '$3');
            }

            if (angular.isUndefined(attrs.tsHideNoData)) {
                var startSym = $interpolate.startSymbol();
                var endSym = $interpolate.endSymbol();

                var noDataRow = angular.element(element[0]).clone();
                noDataRow.removeAttr(ngRepeatDirective);
                noDataRow.removeAttr(tsRepeatDirective);
                noDataRow.addClass( 'showIfLast' );
                noDataRow.children().remove();
                noDataRow.append( '<td colspan="' + element[0].childElementCount + '">' + startSym + 'noDataText' + endSym + '</td>' );
                noDataRow = $compile(noDataRow)(scope);
                element.parent().prepend(noDataRow);
            }

            //pass the `itemsList` from `item in itemsList` to the master directive as a string so it can be used in expressions
            tsWrapperCtrl.setArrayExpr(repeatInMatch[2]);

            angular.element(element[0]).attr(ngRepeatDirective, repeatExpr);
            $compile(element, null, 1000000)(scope);
        }
    };
}]);

tableSortModule.filter( 'tablesortLimit', function() {
    return function(array, limitFun) {
    if(!array) return;
    return limitFun(array);
    };
} );

tableSortModule.filter( 'tablesortOrderBy', function() {
    return function(array, sortfun ) {
        if(!array) return;
        var arrayCopy = array.concat();
        return arrayCopy.sort( sortfun );
    };
} );

tableSortModule.filter( 'parseInt', function() {
    return function(input) {
        return parseInt( input ) || null;
    };
} );

tableSortModule.filter( 'parseFloat', function() {
    return function(input) {
        return parseFloat( input ) || null;
    };
} );

tableSortModule.filter( 'parseDate', function () {
    return function (input) {
        var timestamp = Date.parse(input);
        return isNaN(timestamp) ? null : timestamp;
    };
} );

/**
 * @license AngularJS v1.3.0
 * (c) 2010-2014 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular, undefined) {'use strict';

/**
 * @ngdoc module
 * @name ngTouch
 * @description
 *
 * # ngTouch
 *
 * The `ngTouch` module provides touch events and other helpers for touch-enabled devices.
 * The implementation is based on jQuery Mobile touch event handling
 * ([jquerymobile.com](http://jquerymobile.com/)).
 *
 *
 * See {@link ngTouch.$swipe `$swipe`} for usage.
 *
 * <div doc-module-components="ngTouch"></div>
 *
 */

// define ngTouch module
/* global -ngTouch */
var ngTouch = angular.module('ngTouch', []);

/* global ngTouch: false */

    /**
     * @ngdoc service
     * @name $swipe
     *
     * @description
     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
     * behavior, to make implementing swipe-related directives more convenient.
     *
     * Requires the {@link ngTouch `ngTouch`} module to be installed.
     *
     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`, and by
     * `ngCarousel` in a separate component.
     *
     * # Usage
     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
     * which is to be watched for swipes, and an object with four handler functions. See the
     * documentation for `bind` below.
     */

ngTouch.factory('$swipe', [function() {
  // The total distance in any direction before we make the call on swipe vs. scroll.
  var MOVE_BUFFER_RADIUS = 10;

  var POINTER_EVENTS = {
    'mouse': {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    'touch': {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend',
      cancel: 'touchcancel'
    }
  };

  function getCoordinates(event) {
    var touches = event.touches && event.touches.length ? event.touches : [event];
    var e = (event.changedTouches && event.changedTouches[0]) ||
        (event.originalEvent && event.originalEvent.changedTouches &&
            event.originalEvent.changedTouches[0]) ||
        touches[0].originalEvent || touches[0];

    return {
      x: e.clientX,
      y: e.clientY
    };
  }

  function getEvents(pointerTypes, eventType) {
    var res = [];
    angular.forEach(pointerTypes, function(pointerType) {
      var eventName = POINTER_EVENTS[pointerType][eventType];
      if (eventName) {
        res.push(eventName);
      }
    });
    return res.join(' ');
  }

  return {
    /**
     * @ngdoc method
     * @name $swipe#bind
     *
     * @description
     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
     * object containing event handlers.
     * The pointer types that should be used can be specified via the optional
     * third argument, which is an array of strings `'mouse'` and `'touch'`. By default,
     * `$swipe` will listen for `mouse` and `touch` events.
     *
     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }`.
     *
     * `start` is called on either `mousedown` or `touchstart`. After this event, `$swipe` is
     * watching for `touchmove` or `mousemove` events. These events are ignored until the total
     * distance moved in either dimension exceeds a small threshold.
     *
     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
     *   A `cancel` event is sent.
     *
     * `move` is called on `mousemove` and `touchmove` after the above logic has determined that
     * a swipe is in progress.
     *
     * `end` is called when a swipe is successfully completed with a `touchend` or `mouseup`.
     *
     * `cancel` is called either on a `touchcancel` from the browser, or when we begin scrolling
     * as described above.
     *
     */
    bind: function(element, eventHandlers, pointerTypes) {
      // Absolute total movement, used to control swipe vs. scroll.
      var totalX, totalY;
      // Coordinates of the start position.
      var startCoords;
      // Last event's position.
      var lastPos;
      // Whether a swipe is active.
      var active = false;

      pointerTypes = pointerTypes || ['mouse', 'touch'];
      element.on(getEvents(pointerTypes, 'start'), function(event) {
        startCoords = getCoordinates(event);
        active = true;
        totalX = 0;
        totalY = 0;
        lastPos = startCoords;
        eventHandlers['start'] && eventHandlers['start'](startCoords, event);
      });
      var events = getEvents(pointerTypes, 'cancel');
      if (events) {
        element.on(events, function(event) {
          active = false;
          eventHandlers['cancel'] && eventHandlers['cancel'](event);
        });
      }

      element.on(getEvents(pointerTypes, 'move'), function(event) {
        if (!active) return;

        // Android will send a touchcancel if it thinks we're starting to scroll.
        // So when the total distance (+ or - or both) exceeds 10px in either direction,
        // we either:
        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
        // - On totalY > totalX, we let the browser handle it as a scroll.

        if (!startCoords) return;
        var coords = getCoordinates(event);

        totalX += Math.abs(coords.x - lastPos.x);
        totalY += Math.abs(coords.y - lastPos.y);

        lastPos = coords;

        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
          return;
        }

        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
        if (totalY > totalX) {
          // Allow native scrolling to take over.
          active = false;
          eventHandlers['cancel'] && eventHandlers['cancel'](event);
          return;
        } else {
          // Prevent the browser from scrolling.
          event.preventDefault();
          eventHandlers['move'] && eventHandlers['move'](coords, event);
        }
      });

      element.on(getEvents(pointerTypes, 'end'), function(event) {
        if (!active) return;
        active = false;
        eventHandlers['end'] && eventHandlers['end'](getCoordinates(event), event);
      });
    }
  };
}]);

/* global ngTouch: false */

/**
 * @ngdoc directive
 * @name ngClick
 *
 * @description
 * A more powerful replacement for the default ngClick designed to be used on touchscreen
 * devices. Most mobile browsers wait about 300ms after a tap-and-release before sending
 * the click event. This version handles them immediately, and then prevents the
 * following click event from propagating.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * This directive can fall back to using an ordinary click event, and so works on desktop
 * browsers as well as mobile.
 *
 * This directive also sets the CSS class `ng-click-active` while the element is being held
 * down (by a mouse click or touch) so you can restyle the depressed element if you wish.
 *
 * @element ANY
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate
 * upon tap. (Event object is available as `$event`)
 *
 * @example
    <example module="ngClickExample" deps="angular-touch.js">
      <file name="index.html">
        <button ng-click="count = count + 1" ng-init="count=0">
          Increment
        </button>
        count: {{ count }}
      </file>
      <file name="script.js">
        angular.module('ngClickExample', ['ngTouch']);
      </file>
    </example>
 */

ngTouch.config(['$provide', function($provide) {
  $provide.decorator('ngClickDirective', ['$delegate', function($delegate) {
    // drop the default ngClick directive
    $delegate.shift();
    return $delegate;
  }]);
}]);

ngTouch.directive('ngClick', ['$parse', '$timeout', '$rootElement',
    function($parse, $timeout, $rootElement) {
  var TAP_DURATION = 750; // Shorter than 750ms is a tap, longer is a taphold or drag.
  var MOVE_TOLERANCE = 12; // 12px seems to work in most mobile browsers.
  var PREVENT_DURATION = 2500; // 2.5 seconds maximum from preventGhostClick call to click
  var CLICKBUSTER_THRESHOLD = 25; // 25 pixels in any dimension is the limit for busting clicks.

  var ACTIVE_CLASS_NAME = 'ng-click-active';
  var lastPreventedTime;
  var touchCoordinates;
  var lastLabelClickCoordinates;


  // TAP EVENTS AND GHOST CLICKS
  //
  // Why tap events?
  // Mobile browsers detect a tap, then wait a moment (usually ~300ms) to see if you're
  // double-tapping, and then fire a click event.
  //
  // This delay sucks and makes mobile apps feel unresponsive.
  // So we detect touchstart, touchmove, touchcancel and touchend ourselves and determine when
  // the user has tapped on something.
  //
  // What happens when the browser then generates a click event?
  // The browser, of course, also detects the tap and fires a click after a delay. This results in
  // tapping/clicking twice. We do "clickbusting" to prevent it.
  //
  // How does it work?
  // We attach global touchstart and click handlers, that run during the capture (early) phase.
  // So the sequence for a tap is:
  // - global touchstart: Sets an "allowable region" at the point touched.
  // - element's touchstart: Starts a touch
  // (- touchmove or touchcancel ends the touch, no click follows)
  // - element's touchend: Determines if the tap is valid (didn't move too far away, didn't hold
  //   too long) and fires the user's tap handler. The touchend also calls preventGhostClick().
  // - preventGhostClick() removes the allowable region the global touchstart created.
  // - The browser generates a click event.
  // - The global click handler catches the click, and checks whether it was in an allowable region.
  //     - If preventGhostClick was called, the region will have been removed, the click is busted.
  //     - If the region is still there, the click proceeds normally. Therefore clicks on links and
  //       other elements without ngTap on them work normally.
  //
  // This is an ugly, terrible hack!
  // Yeah, tell me about it. The alternatives are using the slow click events, or making our users
  // deal with the ghost clicks, so I consider this the least of evils. Fortunately Angular
  // encapsulates this ugly logic away from the user.
  //
  // Why not just put click handlers on the element?
  // We do that too, just to be sure. If the tap event caused the DOM to change,
  // it is possible another element is now in that position. To take account for these possibly
  // distinct elements, the handlers are global and care only about coordinates.

  // Checks if the coordinates are close enough to be within the region.
  function hit(x1, y1, x2, y2) {
    return Math.abs(x1 - x2) < CLICKBUSTER_THRESHOLD && Math.abs(y1 - y2) < CLICKBUSTER_THRESHOLD;
  }

  // Checks a list of allowable regions against a click location.
  // Returns true if the click should be allowed.
  // Splices out the allowable region from the list after it has been used.
  function checkAllowableRegions(touchCoordinates, x, y) {
    for (var i = 0; i < touchCoordinates.length; i += 2) {
      if (hit(touchCoordinates[i], touchCoordinates[i+1], x, y)) {
        touchCoordinates.splice(i, i + 2);
        return true; // allowable region
      }
    }
    return false; // No allowable region; bust it.
  }

  // Global click handler that prevents the click if it's in a bustable zone and preventGhostClick
  // was called recently.
  function onClick(event) {
    if (Date.now() - lastPreventedTime > PREVENT_DURATION) {
      return; // Too old.
    }

    var touches = event.touches && event.touches.length ? event.touches : [event];
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    // Work around desktop Webkit quirk where clicking a label will fire two clicks (on the label
    // and on the input element). Depending on the exact browser, this second click we don't want
    // to bust has either (0,0), negative coordinates, or coordinates equal to triggering label
    // click event
    if (x < 1 && y < 1) {
      return; // offscreen
    }
    if (lastLabelClickCoordinates &&
        lastLabelClickCoordinates[0] === x && lastLabelClickCoordinates[1] === y) {
      return; // input click triggered by label click
    }
    // reset label click coordinates on first subsequent click
    if (lastLabelClickCoordinates) {
      lastLabelClickCoordinates = null;
    }
    // remember label click coordinates to prevent click busting of trigger click event on input
    if (event.target.tagName.toLowerCase() === 'label') {
      lastLabelClickCoordinates = [x, y];
    }

    // Look for an allowable region containing this click.
    // If we find one, that means it was created by touchstart and not removed by
    // preventGhostClick, so we don't bust it.
    if (checkAllowableRegions(touchCoordinates, x, y)) {
      return;
    }

    // If we didn't find an allowable region, bust the click.
    event.stopPropagation();
    event.preventDefault();

    // Blur focused form elements
    event.target && event.target.blur();
  }


  // Global touchstart handler that creates an allowable region for a click event.
  // This allowable region can be removed by preventGhostClick if we want to bust it.
  function onTouchStart(event) {
    var touches = event.touches && event.touches.length ? event.touches : [event];
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    touchCoordinates.push(x, y);

    $timeout(function() {
      // Remove the allowable region.
      for (var i = 0; i < touchCoordinates.length; i += 2) {
        if (touchCoordinates[i] == x && touchCoordinates[i+1] == y) {
          touchCoordinates.splice(i, i + 2);
          return;
        }
      }
    }, PREVENT_DURATION, false);
  }

  // On the first call, attaches some event handlers. Then whenever it gets called, it creates a
  // zone around the touchstart where clicks will get busted.
  function preventGhostClick(x, y) {
    if (!touchCoordinates) {
      $rootElement[0].addEventListener('click', onClick, true);
      $rootElement[0].addEventListener('touchstart', onTouchStart, true);
      touchCoordinates = [];
    }

    lastPreventedTime = Date.now();

    checkAllowableRegions(touchCoordinates, x, y);
  }

  // Actual linking function.
  return function(scope, element, attr) {
    var clickHandler = $parse(attr.ngClick),
        tapping = false,
        tapElement,  // Used to blur the element after a tap.
        startTime,   // Used to check if the tap was held too long.
        touchStartX,
        touchStartY;

    function resetState() {
      tapping = false;
      element.removeClass(ACTIVE_CLASS_NAME);
    }

    element.on('touchstart', function(event) {
      tapping = true;
      tapElement = event.target ? event.target : event.srcElement; // IE uses srcElement.
      // Hack for Safari, which can target text nodes instead of containers.
      if(tapElement.nodeType == 3) {
        tapElement = tapElement.parentNode;
      }

      element.addClass(ACTIVE_CLASS_NAME);

      startTime = Date.now();

      var touches = event.touches && event.touches.length ? event.touches : [event];
      var e = touches[0].originalEvent || touches[0];
      touchStartX = e.clientX;
      touchStartY = e.clientY;
    });

    element.on('touchmove', function(event) {
      resetState();
    });

    element.on('touchcancel', function(event) {
      resetState();
    });

    element.on('touchend', function(event) {
      var diff = Date.now() - startTime;

      var touches = (event.changedTouches && event.changedTouches.length) ? event.changedTouches :
          ((event.touches && event.touches.length) ? event.touches : [event]);
      var e = touches[0].originalEvent || touches[0];
      var x = e.clientX;
      var y = e.clientY;
      var dist = Math.sqrt( Math.pow(x - touchStartX, 2) + Math.pow(y - touchStartY, 2) );

      if (tapping && diff < TAP_DURATION && dist < MOVE_TOLERANCE) {
        // Call preventGhostClick so the clickbuster will catch the corresponding click.
        preventGhostClick(x, y);

        // Blur the focused element (the button, probably) before firing the callback.
        // This doesn't work perfectly on Android Chrome, but seems to work elsewhere.
        // I couldn't get anything to work reliably on Android Chrome.
        if (tapElement) {
          tapElement.blur();
        }

        if (!angular.isDefined(attr.disabled) || attr.disabled === false) {
          element.triggerHandler('click', [event]);
        }
      }

      resetState();
    });

    // Hack for iOS Safari's benefit. It goes searching for onclick handlers and is liable to click
    // something else nearby.
    element.onclick = function(event) { };

    // Actual click handler.
    // There are three different kinds of clicks, only two of which reach this point.
    // - On desktop browsers without touch events, their clicks will always come here.
    // - On mobile browsers, the simulated "fast" click will call this.
    // - But the browser's follow-up slow click will be "busted" before it reaches this handler.
    // Therefore it's safe to use this directive on both mobile and desktop.
    element.on('click', function(event, touchend) {
      scope.$apply(function() {
        clickHandler(scope, {$event: (touchend || event)});
      });
    });

    element.on('mousedown', function(event) {
      element.addClass(ACTIVE_CLASS_NAME);
    });

    element.on('mousemove mouseup', function(event) {
      element.removeClass(ACTIVE_CLASS_NAME);
    });

  };
}]);

/* global ngTouch: false */

/**
 * @ngdoc directive
 * @name ngSwipeLeft
 *
 * @description
 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
 * A leftward swipe is a quick, right-to-left slide of the finger.
 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
 * upon left swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeLeftExample" deps="angular-touch.js">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeLeftExample', ['ngTouch']);
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSwipeRight
 *
 * @description
 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
 * A rightward swipe is a quick, left-to-right slide of the finger.
 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
 * upon right swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeRightExample" deps="angular-touch.js">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeRightExample', ['ngTouch']);
      </file>
    </example>
 */

function makeSwipeDirective(directiveName, direction, eventName) {
  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
    // The maximum vertical delta for a swipe should be less than 75px.
    var MAX_VERTICAL_DISTANCE = 75;
    // Vertical distance should not be more than a fraction of the horizontal distance.
    var MAX_VERTICAL_RATIO = 0.3;
    // At least a 30px lateral motion is necessary for a swipe.
    var MIN_HORIZONTAL_DISTANCE = 30;

    return function(scope, element, attr) {
      var swipeHandler = $parse(attr[directiveName]);

      var startCoords, valid;

      function validSwipe(coords) {
        // Check that it's within the coordinates.
        // Absolute vertical distance must be within tolerances.
        // Horizontal distance, we take the current X - the starting X.
        // This is negative for leftward swipes and positive for rightward swipes.
        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
        // (ie. same direction as the directive wants) will have a positive delta and
        // illegal ones a negative delta.
        // Therefore this delta must be positive, and larger than the minimum.
        if (!startCoords) return false;
        var deltaY = Math.abs(coords.y - startCoords.y);
        var deltaX = (coords.x - startCoords.x) * direction;
        return valid && // Short circuit for already-invalidated swipes.
            deltaY < MAX_VERTICAL_DISTANCE &&
            deltaX > 0 &&
            deltaX > MIN_HORIZONTAL_DISTANCE &&
            deltaY / deltaX < MAX_VERTICAL_RATIO;
      }

      var pointerTypes = ['touch'];
      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
        pointerTypes.push('mouse');
      }
      $swipe.bind(element, {
        'start': function(coords, event) {
          startCoords = coords;
          valid = true;
        },
        'cancel': function(event) {
          valid = false;
        },
        'end': function(coords, event) {
          if (validSwipe(coords)) {
            scope.$apply(function() {
              element.triggerHandler(eventName);
              swipeHandler(scope, {$event: event});
            });
          }
        }
      }, pointerTypes);
    };
  }]);
}

// Left is negative X-coordinate, right is positive.
makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
makeSwipeDirective('ngSwipeRight', 1, 'swiperight');



})(window, window.angular);

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.jsPDF=e()}(this,function(){"use strict";var t,y,e,I,i,o,a,h,C,T,d,p,F,n,r,s,c,P,E,q,g,m,w,l,v,b,x,S,u,k,_,f,A,O,B,R,j,D,M,U,N,z,L,H,W,G,V,Y,X,J,K,Q,Z,vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},$=function(pt){var gt="1.3",mt={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};function wt(o){var a={};this.subscribe=function(t,e,n){if("function"!=typeof e)return!1;a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){pt.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}}}function yt(t,e,n,r){var i={};"object"===(void 0===t?"undefined":vt(t))&&(t=(i=t).orientation,e=i.unit||e,n=i.format||n,r=i.compress||i.compressPdf||r),e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();(""+n).toLowerCase();var K,w,y,o,u,v,a,s,h,c,l,f=!!r&&"function"==typeof Uint8Array,Q=i.textColor||"0 g",d=i.drawColor||"0 G",Z=i.fontSize||16,$=i.charSpace||0,tt=i.R2L||!1,et=i.lineHeight||1.15,p=i.lineWidth||.200025,g="00000000000000000000000000000000",m=2,b=!1,x=[],nt={},S={},k=0,_=[],A=[],I=[],C=[],T=[],F=0,P=0,E=0,q={title:"",subject:"",author:"",keywords:"",creator:""},O={},rt=new wt(O),B=i.hotfixes||[],R=function(t){var e,n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);s.ok&&(n=s.toHex())}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var h=parseInt(n.substr(1),16);n=h>>16&255,r=h>>8&255,i=255&h}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=N(n/255)+" "+a[0];break;case 3:default:e=z(n/255)+" "+a[0]}else if(void 0===o||"object"===(void 0===o?"undefined":vt(o))){if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[N(n/255),N(r/255),N(i/255),a[1]].join(" ");break;default:case 3:e=[z(n/255),z(r/255),z(i/255),a[1]].join(" ")}o&&0===o.a&&(e=["255","255","255",a[1]].join(" "))}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[N(n),N(r),N(i),N(o),a[2]].join(" ");break;case 3:default:e=[z(n),z(r),z(i),z(o),a[2]].join(" ")}return e},j=function(t){var e=function(t){return("0"+parseInt(t)).slice(-2)},n=t.getTimezoneOffset(),r=n<0?"+":"-",i=Math.floor(Math.abs(n/60)),o=Math.abs(n%60),a=[r,e(i),"'",e(o),"'"].join("");return["D:",t.getFullYear(),e(t.getMonth()+1),e(t.getDate()),e(t.getHours()),e(t.getMinutes()),e(t.getSeconds()),a].join("")},D=function(t){var e;return void 0===(void 0===t?"undefined":vt(t))&&(t=new Date),e="object"===(void 0===t?"undefined":vt(t))&&"[object Date]"===Object.prototype.toString.call(t)?j(t):/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t)?t:j(new Date),c=e},M=function(t){var e=c;return"jsDate"===t&&(e=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)}(c)),e},U=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),g=t},N=function(t){return t.toFixed(2)},z=function(t){return t.toFixed(3)},it=function(t){t="string"==typeof t?t:t.toString(),b?_[o].push(t):(E+=t.length+1,C.push(t))},L=function(){return x[++m]=E,it(m+" 0 obj"),m},H=function(t){it("stream"),it(t),it("endstream")},W=function(){for(var t in it("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),it("/Font <<"),nt)nt.hasOwnProperty(t)&&it("/"+t+" "+nt[t].objectNumber+" 0 R");it(">>"),it("/XObject <<"),rt.publish("putXobjectDict"),it(">>")},G=function(){!function(){for(var t in nt)nt.hasOwnProperty(t)&&(e=nt[t],rt.publish("putFont",{font:e,out:it,newObject:L}),!0!==e.isAlreadyPutted&&(e.objectNumber=L(),it("<<"),it("/Type /Font"),it("/BaseFont /"+e.postScriptName),it("/Subtype /Type1"),"string"==typeof e.encoding&&it("/Encoding /"+e.encoding),it("/FirstChar 32"),it("/LastChar 255"),it(">>"),it("endobj")));var e}(),rt.publish("putResources"),x[2]=E,it("2 0 obj"),it("<<"),W(),it(">>"),it("endobj"),rt.publish("postPutResources")},V=function(t,e,n){S.hasOwnProperty(e)||(S[e]={}),S[e][n]=t},Y=function(t,e,n,r){var i="F"+(Object.keys(nt).length+1).toString(10),o=nt[i]={id:i,postScriptName:t,fontName:e,fontStyle:n,encoding:r,metadata:{}};return V(i,e,n),rt.publish("addFont",o),i},ot=function(t,e){return function(t,e){var n,r,i,o,a,s,h,c,l;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&nt[K].metadata&&nt[K].metadata[i]&&nt[K].metadata[i].encoding&&(o=nt[K].metadata[i].encoding,!a&&nt[K].encoding&&(a=nt[K].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(h=!1,s=[],n=0,r=t.length;n<r;n++)(c=a[t.charCodeAt(n)])?s.push(String.fromCharCode(c)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(h=!0);t=s.join("")}for(n=t.length;void 0===h&&0!==n;)t.charCodeAt(n-1)>>8&&(h=!0),n--;if(!h)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((l=(c=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(l),s.push(c-(l<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},X=function(){(function(t,e){var n="string"==typeof e&&e.toLowerCase();if("string"==typeof t){var r=t.toLowerCase();mt.hasOwnProperty(r)&&(t=mt[r][0]/w,e=mt[r][1]/w)}if(Array.isArray(t)&&(e=t[1],t=t[0]),n){switch(n.substr(0,1)){case"l":t<e&&(n="s");break;case"p":e<t&&(n="s")}"s"===n&&(y=t,t=e,e=y)}b=!0,_[++k]=[],I[k]={width:Number(t)||u,height:Number(e)||v},A[k]={},J(k)}).apply(this,arguments),it(N(p*w)+" w"),it(d),0!==F&&it(F+" J"),0!==P&&it(P+" j"),rt.publish("addPage",{pageNumber:k})},J=function(t){0<t&&t<=k&&(u=I[o=t].width,v=I[t].height)},at=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:nt[K].fontName,e=void 0!==e?e:nt[K].fontStyle,r=t.toLowerCase(),void 0!==S[r]&&void 0!==S[r][e]?i=S[r][e]:void 0!==S[t]&&void 0!==S[t][e]?i=S[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=S.times[e])&&(i=S.times.normal),i},st=function(){b=!1,m=2,E=0,C=[],x=[],T=[],rt.publish("buildDocument"),it("%PDF-"+gt),it("%ºß¬à"),function(){var t,e,n,r,i,o,a,s,h,c=[];for(a=pt.adler32cs||yt.API.adler32cs,f&&void 0===a&&(f=!1),t=1;t<=k;t++){if(c.push(L()),s=(u=I[t].width)*w,h=(v=I[t].height)*w,it("<</Type /Page"),it("/Parent 1 0 R"),it("/Resources 2 0 R"),it("/MediaBox [0 0 "+N(s)+" "+N(h)+"]"),rt.publish("putPage",{pageNumber:t,page:_[t]}),it("/Contents "+(m+1)+" 0 R"),it(">>"),it("endobj"),e=_[t].join("\n"),L(),f){for(n=[],r=e.length;r--;)n[r]=e.charCodeAt(r);o=a.from(e),(i=new Deflater(6)).append(new Uint8Array(n)),e=i.flush(),(n=new Uint8Array(e.length+6)).set(new Uint8Array([120,156])),n.set(e,2),n.set(new Uint8Array([255&o,o>>8&255,o>>16&255,o>>24&255]),e.length+2),e=String.fromCharCode.apply(null,n),it("<</Length "+e.length+" /Filter [/FlateDecode]>>")}else it("<</Length "+e.length+">>");H(e),it("endobj")}x[1]=E,it("1 0 obj"),it("<</Type /Pages");var l="/Kids [";for(r=0;r<k;r++)l+=c[r]+" 0 R ";it(l+"]"),it("/Count "+k),it(">>"),it("endobj"),rt.publish("postPutPages")}(),function(){rt.publish("putAdditionalObjects");for(var t=0;t<T.length;t++){var e=T[t];x[e.objId]=E,it(e.objId+" 0 obj"),it(e.content),it("endobj")}m+=T.length,rt.publish("postPutAdditionalObjects")}(),G(),L(),it("<<"),function(){for(var t in it("/Producer (jsPDF "+yt.version+")"),q)q.hasOwnProperty(t)&&q[t]&&it("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+ot(q[t])+")");it("/CreationDate ("+c+")")}(),it(">>"),it("endobj"),L(),it("<<"),function(){switch(it("/Type /Catalog"),it("/Pages 1 0 R"),s||(s="fullwidth"),s){case"fullwidth":it("/OpenAction [3 0 R /FitH null]");break;case"fullheight":it("/OpenAction [3 0 R /FitV null]");break;case"fullpage":it("/OpenAction [3 0 R /Fit]");break;case"original":it("/OpenAction [3 0 R /XYZ null null 1]");break;default:var t=""+s;"%"===t.substr(t.length-1)&&(s=parseInt(s)/100),"number"==typeof s&&it("/OpenAction [3 0 R /XYZ null null "+N(s)+"]")}switch(h||(h="continuous"),h){case"continuous":it("/PageLayout /OneColumn");break;case"single":it("/PageLayout /SinglePage");break;case"two":case"twoleft":it("/PageLayout /TwoColumnLeft");break;case"tworight":it("/PageLayout /TwoColumnRight")}a&&it("/PageMode /"+a),rt.publish("putCatalog")}(),it(">>"),it("endobj");var t,e=E,n="0000000000";for(it("xref"),it("0 "+(m+1)),it(n+" 65535 f "),t=1;t<=m;t++){var r=x[t];it("function"==typeof r?(n+x[t]()).slice(-10)+" 00000 n ":(n+x[t]).slice(-10)+" 00000 n ")}return it("trailer"),it("<<"),it("/Size "+(m+1)),it("/Root "+m+" 0 R"),it("/Info "+(m-1)+" 0 R"),it("/ID [ <"+g+"> <"+g+"> ]"),it(">>"),it("startxref"),it(""+e),it("%%EOF"),b=!0,C.join("\n")},ht=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e},ct=function(){for(var t=st(),e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},lt=function(){return new Blob([ct()],{type:"application/pdf"})},ut=((l=function(t,e){var n="dataur"===(""+t).substr(0,6)?"data:application/pdf;base64,"+btoa(st()):0;switch(t){case void 0:return st();case"save":if("object"===("undefined"==typeof navigator?"undefined":vt(navigator))&&navigator.getUserMedia&&(void 0===pt.URL||void 0===pt.URL.createObjectURL))return O.output("dataurlnewwindow");bt(lt(),e),"function"==typeof bt.unload&&pt.setTimeout&&setTimeout(bt.unload,911);break;case"arraybuffer":return ct();case"blob":return lt();case"bloburi":case"bloburl":return pt.URL&&pt.URL.createObjectURL(lt())||void 0;case"datauristring":case"dataurlstring":return n;case"dataurlnewwindow":var r=pt.open(n);if(r||"undefined"==typeof safari)return r;case"datauri":case"dataurl":return pt.document.location.href=n;default:throw new Error('Output type "'+t+'" is not supported.')}}).foo=function(){try{return l.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!pt.console)throw new Error(n);pt.console.error(n,t),pt.alert&&alert(n)}},(l.foo.bar=l).foo),ft=function(t){return!0===Array.isArray(B)&&-1<B.indexOf(t)};switch(e){case"pt":w=1;break;case"mm":w=72/25.4;break;case"cm":w=72/2.54;break;case"in":w=72;break;case"px":w=1==ft("px_scaling")?.75:96/72;break;case"pc":case"em":w=12;break;case"ex":w=6;break;default:throw"Invalid unit: "+e}for(var dt in D(),U(),O.internal={pdfEscape:ot,getStyle:ht,getFont:function(){return nt[at.apply(O,arguments)]},getFontSize:function(){return Z},getCharSpace:function(){return $},getTextColor:function(){var t=Q.split(" ");if(2===t.length&&"g"===t[1]){var e=parseFloat(t[0]);t=[e,e,e,"r"]}for(var n="#",r=0;r<3;r++)n+=("0"+Math.floor(255*parseFloat(t[r])).toString(16)).slice(-2);return n},getLineHeight:function(){return Z*et},write:function(t){it(1===arguments.length?t:Array.prototype.join.call(arguments," "))},getCoordinateString:function(t){return N(t*w)},getVerticalCoordinateString:function(t){return N((v-t)*w)},collections:{},newObject:L,newAdditionalObject:function(){var t=2*_.length+1,e={objId:t+=T.length,content:""};return T.push(e),e},newObjectDeferred:function(){return x[++m]=function(){return E},m},newObjectDeferredBegin:function(t){x[t]=E},putStream:H,events:rt,scaleFactor:w,pageSize:{getWidth:function(){return u},getHeight:function(){return v}},output:function(t,e){return ut(t,e)},getNumberOfPages:function(){return _.length-1},pages:_,out:it,f2:N,getPageInfo:function(t){return{objId:2*(t-1)+3,pageNumber:t,pageContext:A[t]}},getCurrentPageInfo:function(){return{objId:2*(o-1)+3,pageNumber:o,pageContext:A[o]}},getPDFVersion:function(){return gt},hasHotfix:ft},O.addPage=function(){return X.apply(this,arguments),this},O.setPage=function(){return J.apply(this,arguments),this},O.insertPage=function(t){return this.addPage(),this.movePage(o,t),this},O.movePage=function(t,e){if(e<t){for(var n=_[t],r=I[t],i=A[t],o=t;e<o;o--)_[o]=_[o-1],I[o]=I[o-1],A[o]=A[o-1];_[e]=n,I[e]=r,A[e]=i,this.setPage(e)}else if(t<e){for(n=_[t],r=I[t],i=A[t],o=t;o<e;o++)_[o]=_[o+1],I[o]=I[o+1],A[o]=A[o+1];_[e]=n,I[e]=r,A[e]=i,this.setPage(e)}return this},O.deletePage=function(){return function(t){0<t&&t<=k&&(_.splice(t,1),I.splice(t,1),--k<o&&(o=k),this.setPage(o))}.apply(this,arguments),this},O.setCreationDate=function(t){return D(t),this},O.getCreationDate=function(t){return M(t)},O.setFileId=function(t){return U(t),this},O.getFileId=function(){return g},O.setDisplayMode=function(t,e,n){if(s=t,h=e,-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(a=n))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+n+'" is not recognized.');return this},O.text=function(t,e,n,i){var r,o,a="",s=et,h=this;function c(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):"[object Array]"===Object.prototype.toString.call(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function l(t,e){var n;if("string"==typeof t)n=e(t)[0];else if("[object Array]"===Object.prototype.toString.call(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):"[object Array]"===Object.prototype.toString.call(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}"number"==typeof t&&(o=n,n=e,e=t,t=o);var u=i,f=arguments[4],d=arguments[5];"object"===(void 0===u?"undefined":vt(u))&&null!==u||("string"==typeof f&&(d=f,f=null),"string"==typeof u&&(d=u,u=null),"number"==typeof u&&(f=u,u=null),i={flags:u,angle:f,align:d});var p=!1,g=!0;if("string"==typeof t)p=!0;else if("[object Array]"===Object.prototype.toString.call(t)){for(var m,w=t.concat(),y=[],v=w.length;v--;)("string"!=typeof(m=w.shift())||"[object Array]"===Object.prototype.toString.call(m)&&"string"!=typeof m[0])&&(g=!1);p=g}if(!1===p)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=nt[K].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=l(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),ot(r,u)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]),0<(j=i.maxWidth||0)&&("string"==typeof t?t=h.splitTextToSize(t,j):"[object Array]"===Object.prototype.toString.call(t)&&(t=h.splitTextToSize(t.join(" "),j)));var x={text:t,x:e,y:n,options:i,mutex:{pdfEscape:ot,activeFontKey:K,fonts:nt,activeFontSize:Z}};rt.publish("preProcessText",x),t=x.text;f=(i=x.options).angle;var S=h.internal.scaleFactor,k=(h.internal.pageSize.getHeight(),[]);if(f){f*=Math.PI/180;var _=Math.cos(f),A=Math.sin(f),I=function(t){return t.toFixed(2)};k=[I(_),I(A),I(-1*A),I(_)]}void 0!==(R=i.charSpace)&&(a+=R+" Tc\n");i.lang;var C=-1,T=i.renderingMode||i.stroke,F=h.internal.getCurrentPageInfo().pageContext;switch(T){case 0:case!1:case"fill":C=0;break;case 1:case!0:case"stroke":C=1;break;case 2:case"fillThenStroke":C=2;break;case 3:case"invisible":C=3;break;case 4:case"fillAndAddForClipping":C=4;break;case 5:case"strokeAndAddPathForClipping":C=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":C=6;break;case 7:case"addToPathForClipping":C=7}var P=F.usedRenderingMode||-1;-1!==C?a+=C+" Tr\n":-1!==P&&(a+="0 Tr\n"),-1!==C&&(F.usedRenderingMode=C);d=i.align||"left";var E=Z*s,q=h.internal.pageSize.getHeight(),O=h.internal.pageSize.getWidth(),B=(S=h.internal.scaleFactor,nt[K]),R=i.charSpace||$,j=i.maxWidth||0,D=(u={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var M,U;y=c(t);"left"!==d&&(U=y.map(function(t){return h.getStringUnitWidth(t,{font:B,charSpace:R,fontSize:Z})*Z/S}));var N,z=Math.max.apply(Math,U),L=0;if("right"===d){e-=U[0],t=[];var H=0;for(v=y.length;H<v;H++)z-U[H],0===H?(N=e*S,M=(q-n)*S):(N=(L-U[H])*S,M=-E),t.push([y[H],N,M]),L=U[H]}else if("center"===d){e-=U[0]/2,t=[];for(H=0,v=y.length;H<v;H++)(z-U[H])/2,0===H?(N=e*S,M=(q-n)*S):(N=(L-U[H])/2*S,M=-E),t.push([y[H],N,M]),L=U[H]}else if("left"===d){t=[];for(H=0,v=y.length;H<v;H++)M=0===H?(q-n)*S:-E,N=0===H?e*S:0,t.push(y[H])}else{if("justify"!==d)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(j=0!==j?j:O,H=0,v=y.length;H<v;H++)M=0===H?(q-n)*S:-E,N=0===H?e*S:0,H<v-1&&D.push(((j-U[H])/(y[H].split(" ").length-1)*S).toFixed(2)),t.push([y[H],N,M])}}!0===("boolean"==typeof i.R2L?i.R2L:tt)&&(t=l(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));x={text:t,x:e,y:n,options:i,mutex:{pdfEscape:ot,activeFontKey:K,fonts:nt,activeFontSize:Z}};rt.publish("postProcessText",x),t=x.text,r=x.mutex.isHex;y=c(t);t=[];var W,G,V,Y=0,X=(v=y.length,"");for(H=0;H<v;H++)X="","[object Array]"!==Object.prototype.toString.call(y[H])?(W=parseFloat(e*S).toFixed(2),G=parseFloat((q-n)*S).toFixed(2),V=(r?"<":"(")+y[H]+(r?">":")")):"[object Array]"===Object.prototype.toString.call(y[H])&&(W=parseFloat(y[H][1]).toFixed(2),G=parseFloat(y[H][2]).toFixed(2),V=(r?"<":"(")+y[H][0]+(r?">":")"),Y=1),void 0!==D&&void 0!==D[H]&&(X=D[H]+" Tw\n"),0!==k.length&&0===H?t.push(X+k.join(" ")+" "+W+" "+G+" Tm\n"+V):1===Y||0===Y&&0===H?t.push(X+W+" "+G+" Td\n"+V):t.push(X+V);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var J="BT\n/"+K+" "+Z+" Tf\n"+(Z*s).toFixed(2)+" TL\n"+Q+"\n";return J+=a,J+=t,it(J+="ET"),h},O.lstext=function(t,e,n,r){console.warn("jsPDF.lstext is deprecated");for(var i=0,o=t.length;i<o;i++,e+=r)this.text(t[i],e,n);return this},O.line=function(t,e,n,r){return this.lines([[n-t,r-e]],t,e)},O.clip=function(){it("W"),it("S")},O.clip_fixed=function(t){it("evenodd"===t?"W*":"W"),it("n")},O.lines=function(t,e,n,r,i,o){var a,s,h,c,l,u,f,d,p,g,m;for("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],it(z(e*w)+" "+z((v-n)*w)+" m "),a=r[0],s=r[1],c=t.length,g=e,m=n,h=0;h<c;h++)2===(l=t[h]).length?(g=l[0]*a+g,m=l[1]*s+m,it(z(g*w)+" "+z((v-m)*w)+" l")):(u=l[0]*a+g,f=l[1]*s+m,d=l[2]*a+g,p=l[3]*s+m,g=l[4]*a+g,m=l[5]*s+m,it(z(u*w)+" "+z((v-f)*w)+" "+z(d*w)+" "+z((v-p)*w)+" "+z(g*w)+" "+z((v-m)*w)+" c"));return o&&it(" h"),null!==i&&it(ht(i)),this},O.rect=function(t,e,n,r,i){ht(i);return it([N(t*w),N((v-e)*w),N(n*w),N(-r*w),"re"].join(" ")),null!==i&&it(ht(i)),this},O.triangle=function(t,e,n,r,i,o,a){return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},O.roundedRect=function(t,e,n,r,i,o,a){var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},O.ellipse=function(t,e,n,r,i){var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return it([N((t+n)*w),N((v-e)*w),"m",N((t+n)*w),N((v-(e-a))*w),N((t+o)*w),N((v-(e-r))*w),N(t*w),N((v-(e-r))*w),"c"].join(" ")),it([N((t-o)*w),N((v-(e-r))*w),N((t-n)*w),N((v-(e-a))*w),N((t-n)*w),N((v-e)*w),"c"].join(" ")),it([N((t-n)*w),N((v-(e+a))*w),N((t-o)*w),N((v-(e+r))*w),N(t*w),N((v-(e+r))*w),"c"].join(" ")),it([N((t+o)*w),N((v-(e+r))*w),N((t+n)*w),N((v-(e+a))*w),N((t+n)*w),N((v-e)*w),"c"].join(" ")),null!==i&&it(ht(i)),this},O.circle=function(t,e,n,r){return this.ellipse(t,e,n,n,r)},O.setProperties=function(t){for(var e in q)q.hasOwnProperty(e)&&t[e]&&(q[e]=t[e]);return this},O.setFontSize=function(t){return Z=t,this},O.setFont=function(t,e){return K=at(t,e),this},O.setFontStyle=O.setFontType=function(t){return K=at(void 0,t),this},O.getFontList=function(){var t,e,n,r={};for(t in S)if(S.hasOwnProperty(t))for(e in r[t]=n=[],S[t])S[t].hasOwnProperty(e)&&n.push(e);return r},O.addFont=function(t,e,n,r){Y(t,e,n,r=r||"Identity-H")},O.setLineWidth=function(t){return it((t*w).toFixed(2)+" w"),this},O.setDrawColor=function(t,e,n,r){return it(R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2})),this},O.setFillColor=function(t,e,n,r){return it(R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2})),this},O.setTextColor=function(t,e,n,r){return Q=R({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},O.setCharSpace=function(t){return $=t,this},O.setR2L=function(t){return tt=t,this},O.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},O.setLineCap=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return it((F=e)+" J"),this},O.setLineJoin=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return it((P=e)+" j"),this},O.output=ut,O.save=function(t){O.output("save",t)},yt.API)yt.API.hasOwnProperty(dt)&&("events"===dt&&yt.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(rt,yt.API.events):O[dt]=yt.API[dt]);return function(){for(var t="helvetica",e="times",n="courier",r="normal",i="bold",o="italic",a="bolditalic",s=[["Helvetica",t,r,"WinAnsiEncoding"],["Helvetica-Bold",t,i,"WinAnsiEncoding"],["Helvetica-Oblique",t,o,"WinAnsiEncoding"],["Helvetica-BoldOblique",t,a,"WinAnsiEncoding"],["Courier",n,r,"WinAnsiEncoding"],["Courier-Bold",n,i,"WinAnsiEncoding"],["Courier-Oblique",n,o,"WinAnsiEncoding"],["Courier-BoldOblique",n,a,"WinAnsiEncoding"],["Times-Roman",e,r,"WinAnsiEncoding"],["Times-Bold",e,i,"WinAnsiEncoding"],["Times-Italic",e,o,"WinAnsiEncoding"],["Times-BoldItalic",e,a,"WinAnsiEncoding"],["ZapfDingbats","zapfdingbats",r,null],["Symbol","symbol",r,null]],h=0,c=s.length;h<c;h++){var l=Y(s[h][0],s[h][1],s[h][2],s[h][3]),u=s[h][0].split("-");V(l,u[0],u[1]||"")}rt.publish("addFonts",{fonts:nt,dictionary:S})}(),K="F1",X(n,t),rt.publish("initialized"),O}return yt.API={events:[]},yt.version="0.0.0","function"==typeof define&&define.amd?define("jsPDF",function(){return yt}):"undefined"!=typeof module&&module.exports?(module.exports=yt,module.exports.jsPDF=yt):pt.jsPDF=yt,yt}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
/** @preserve
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.4.1 Built on 2018-06-06T07:49:34.040Z
   *                           CommitID 3233f44044
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */
/**
   * jsPDF AcroForm Plugin Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
!function(n,t){var l,a,e=1,r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},s=function(t){return t*(e/1)},h=function(t){var e=new I,n=N.internal.getHeight(t)||0,r=N.internal.getWidth(t)||0;return e.BBox=[0,0,r.toFixed(2),n.toFixed(2)],e},i=function(t,e,n){t=t||0;var r=1;if(r<<=e-1,1==(n=n||1))t=t|r;else t=t&~r;return t},o=function(t,e,n){n=n||1.3,t=t||0;return 1==e.readOnly&&(t=i(t,1)),1==e.required&&(t=i(t,2)),1==e.noExport&&(t=i(t,3)),1==e.multiline&&(t=i(t,13)),e.password&&(t=i(t,14)),e.noToggleToOff&&(t=i(t,15)),e.radio&&(t=i(t,16)),e.pushbutton&&(t=i(t,17)),e.combo&&(t=i(t,18)),e.edit&&(t=i(t,19)),e.sort&&(t=i(t,20)),e.fileSelect&&1.4<=n&&(t=i(t,21)),e.multiSelect&&1.4<=n&&(t=i(t,22)),e.doNotSpellCheck&&1.4<=n&&(t=i(t,23)),1==e.doNotScroll&&1.4<=n&&(t=i(t,24)),e.richText&&1.4<=n&&(t=i(t,25)),t},u=function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o={};return Array.isArray(e)?(e[0]=s(e[0]),e[1]=s(e[1]),e[2]=s(e[2]),e[3]=s(e[3])):(e=s(e),n=s(n),r=s(r),i=s(i)),o.lowerLeft_X=e||0,o.lowerLeft_Y=s(a)-n-i||0,o.upperRight_X=e+r||0,o.upperRight_Y=s(a)-n||0,[o.lowerLeft_X.toFixed(2),o.lowerLeft_Y.toFixed(2),o.upperRight_X.toFixed(2),o.upperRight_Y.toFixed(2)]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=c(t,n);e.push("/Tx BMC"),e.push("q"),e.push("/F1 "+r.fontSize.toFixed(2)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push("BT"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var i=new h(t);return i.stream=e.join("\n"),i}},c=function(t,e,i,n){n=n||12,i=i||"helvetica";var r={text:"",fontSize:""},o=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" "),a=n,s=N.internal.getHeight(t)||0;s=s<0?-s:s;var h=N.internal.getWidth(t)||0;h=h<0?-h:h;var c=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return A(r,n+"px",i).width<=h-4}return!1};a++;t:for(;;){e="";var l=A("3",--a+"px",i).height,u=t.multiline?s-a:(s-l)/2,f=-2,d=u+=2,p=0,g=0,m=0;if(a<=0){a=12,e="(...) Tj\n",e+="% Width of Text: "+A(e,"1px").width+", FieldWidth:"+h+"\n";break}m=A(o[0]+" ",a+"px",i).width;var w="",y=0;for(var v in o){w=" "==(w+=o[v]+" ").substr(w.length-1)?w.substr(0,w.length-1):w;var b=parseInt(v);m=A(w+" ",a+"px",i).width;var x=c(b,w,a),S=v>=o.length-1;if(!x||S){if(x||S){if(S)g=b;else if(t.multiline&&s<(l+2)*(y+2)+2)continue t}else{if(!t.multiline)continue t;if(s<(l+2)*(y+2)+2)continue t;g=b}for(var k="",_=p;_<=g;_++)k+=o[_]+" ";switch(k=" "==k.substr(k.length-1)?k.substr(0,k.length-1):k,m=A(k,a+"px",i).width,t.Q){case 2:f=h-m-2;break;case 1:f=(h-m)/2;break;case 0:default:f=2}e+=f.toFixed(2)+" "+d.toFixed(2)+" Td\n",e+="("+k+") Tj\n",e+=-f.toFixed(2)+" 0 Td\n",d=-(a+2),m=0,p=g+1,y++,w=""}else w+=" "}break}return r.text=e,r.fontSize=a,r},A=function(t,e,n){n=n||"helvetica";var r=l.internal.getFont(n),i=l.getStringUnitWidth(t,{font:r,fontSize:parseFloat(e),charSpace:0})*parseFloat(e);return{height:l.getStringUnitWidth("3",{font:r,fontSize:parseFloat(e),charSpace:0})*parseFloat(e)*1.5,width:i}},d={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){for(var t in l.internal.acroformPlugin.acroFormDictionaryRoot.Fields){var e=l.internal.acroformPlugin.acroFormDictionaryRoot.Fields[t];e.hasAnnotation&&m.call(l,e)}},g=function(t){l.internal.acroformPlugin.printedOut&&(l.internal.acroformPlugin.printedOut=!1,l.internal.acroformPlugin.acroFormDictionaryRoot=null),l.internal.acroformPlugin.acroFormDictionaryRoot||x.call(l),l.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)},m=function(t){var e={type:"reference",object:t};l.annotationPlugin.annotations[l.internal.getPageInfo(t.page).pageNumber].push(e)},w=function(){void 0!==l.internal.acroformPlugin.acroFormDictionaryRoot?l.internal.write("/AcroForm "+l.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R"):console.log("Root missing...")},y=function(){l.internal.events.unsubscribe(l.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete l.internal.acroformPlugin.acroFormDictionaryRoot._eventID,l.internal.acroformPlugin.printedOut=!0},v=function(t){var e=!t;t||(l.internal.newObjectDeferredBegin(l.internal.acroformPlugin.acroFormDictionaryRoot.objId),l.internal.out(l.internal.acroformPlugin.acroFormDictionaryRoot.getString()));t=t||l.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t){var r=t[n],i=r.Rect;r.Rect&&(r.Rect=u.call(this,r.Rect)),l.internal.newObjectDeferredBegin(r.objId);var o=r.objId+" 0 obj\n<<\n";if("object"===(void 0===r?"undefined":vt(r))&&"function"==typeof r.getContent&&(o+=r.getContent()),r.Rect=i,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);o+="/AP << /N "+a+" >>\n",l.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){for(var s in o+="/AP << ",r.appearanceStreamContent){var h=r.appearanceStreamContent[s];if(o+="/"+s+" ",o+="<< ",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var c;"function"==typeof(c=h[n])&&(c=c.call(this,r)),o+="/"+n+" "+c+" ",0<=l.internal.acroformPlugin.xForms.indexOf(c)||l.internal.acroformPlugin.xForms.push(c)}else"function"==typeof(c=h)&&(c=c.call(this,r)),o+="/"+n+" "+c+" \n",0<=l.internal.acroformPlugin.xForms.indexOf(c)||l.internal.acroformPlugin.xForms.push(c);o+=" >>\n"}o+=">>\n"}o+=">>\nendobj\n",l.internal.out(o)}e&&b.call(this,l.internal.acroformPlugin.xForms)},b=function(t){for(var e in t){var n=e,r=t[e];l.internal.newObjectDeferredBegin(r&&r.objId);var i="";"object"===(void 0===r?"undefined":vt(r))&&"function"==typeof r.getString&&(i=r.getString()),l.internal.out(i),delete t[n]}},x=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(l=this,T.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(d)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");e=l.internal.scaleFactor,a=l.internal.pageSize.getHeight(),l.internal.acroformPlugin.acroFormDictionaryRoot=new C,l.internal.acroformPlugin.acroFormDictionaryRoot._eventID=l.internal.events.subscribe("postPutResources",y),l.internal.events.subscribe("buildDocument",p),l.internal.events.subscribe("putCatalog",w),l.internal.events.subscribe("postPutPages",v),l.internal.acroformPlugin.isInitialized=!0}},S=function(t){if(Array.isArray(t)){var e=" [";for(var n in t){e+=t[n].toString(),e+=n<t.length-1?" ":""}return e+="]"}},k=function(t){return 0!==(t=t||"").indexOf("(")&&(t="("+t),")"!=t.substring(t.length-1)&&(t+=")"),t},_=function(){var t;Object.defineProperty(this,"objId",{get:function(){return t||(t=l.internal.newObjectDeferred()),t||console.log("Couldn't create Object ID"),t},configurable:!1})};_.prototype.toString=function(){return this.objId+" 0 R"},_.prototype.getString=function(){var t=this.objId+" 0 obj\n<<";return t+=this.getContent()+">>\n",this.stream&&(t+="stream\n",t+=this.stream,t+="\nendstream\n"),t+="endobj\n"},_.prototype.getContent=function(){var t="";return t+=function(t){var e="",n=Object.keys(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n){var i=n[r],o=t[i];o&&(Array.isArray(o)?e+="/"+i+" "+S(o)+"\n":e+=o instanceof _?"/"+i+" "+o.objId+" 0 R\n":"/"+i+" "+o+"\n")}return e}(this)};var I=function(){var e;_.call(this),this.Type="/XObject",this.Subtype="/Form",this.FormType=1,this.BBox,this.Matrix,this.Resources="2 0 R",this.PieceInfo,Object.defineProperty(this,"Length",{enumerable:!0,get:function(){return void 0!==e?e.length:0}}),Object.defineProperty(this,"stream",{enumerable:!1,set:function(t){e=t.trim()},get:function(){return e||null}})};r(I,_);var C=function(){_.call(this);var t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!0,configurable:!0,get:function(){return t}}),this.DA};r(C,_);var T=function t(){var e;_.call(this),Object.defineProperty(this,"Rect",{enumerable:!0,configurable:!1,get:function(){if(e)return e},set:function(t){e=t}});var n,r,i,o,a="";Object.defineProperty(this,"FT",{enumerable:!0,set:function(t){a=t},get:function(){return a}}),Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,set:function(t){n=t},get:function(){if(!n||n.length<1){if(this instanceof j)return;return"(FieldObject"+t.FieldNum+++")"}return"("==n.substring(0,1)&&n.substring(n.length-1)?n:"("+n+")"}}),Object.defineProperty(this,"DA",{enumerable:!0,get:function(){if(r)return"("+r+")"},set:function(t){r=t}}),Object.defineProperty(this,"DV",{enumerable:!0,configurable:!0,get:function(){if(i)return i},set:function(t){i=t}}),Object.defineProperty(this,"V",{enumerable:!0,configurable:!0,get:function(){if(o)return o},set:function(t){o=t}}),Object.defineProperty(this,"Type",{enumerable:!0,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,get:function(){return this.hasAnnotation?"/Widget":null}}),this.BG,Object.defineProperty(this,"hasAnnotation",{enumerable:!1,get:function(){return!!(this.Rect||this.BC||this.BG)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,configurable:!0,writable:!0}),Object.defineProperty(this,"page",{enumerable:!1,configurable:!0,writable:!0})};r(T,_);var F=function(){T.call(this),this.FT="/Ch",this.Opt=[],this.V="()",this.TI=0;var e=!1;Object.defineProperty(this,"combo",{enumerable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"edit",{enumerable:!0,set:function(t){1==t?(this._edit=!0,this.combo=!0):this._edit=!1},get:function(){return!!this._edit&&this._edit},configurable:!1}),this.hasAppearanceStream=!0};r(F,T);var P=function(){F.call(this),this.combo=!1};r(P,F);var E=function(){P.call(this),this.combo=!0};r(E,P);var q=function(){E.call(this),this.edit=!0};r(q,E);var O=function(){T.call(this),this.FT="/Btn"};r(O,T);var B=function(){O.call(this);var e=!0;Object.defineProperty(this,"pushbutton",{enumerable:!1,get:function(){return e},set:function(t){e=t}})};r(B,O);var R=function(){O.call(this);var e=!0;Object.defineProperty(this,"radio",{enumerable:!1,get:function(){return e},set:function(t){e=t}});var n,t=[];Object.defineProperty(this,"Kids",{enumerable:!0,get:function(){if(0<t.length)return t}}),Object.defineProperty(this,"__Kids",{get:function(){return t}}),Object.defineProperty(this,"noToggleToOff",{enumerable:!1,get:function(){return n},set:function(t){n=t}})};r(R,O);var j=function(t,e){T.call(this),this.Parent=t,this._AppearanceType=N.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(e),this.F=i(this.F,3,1),this.MK=this._AppearanceType.createMK(),this.AS="/Off",this._Name=e};r(j,T),R.prototype.setAppearance=function(t){if("createAppearanceStream"in t&&"createMK"in t)for(var e in this.__Kids){var n=this.__Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n._Name),n.MK=t.createMK()}else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!")},R.prototype.createOption=function(t){this.__Kids.length;var e=new j(this,t);return this.__Kids.push(e),n.addField(e),e};var D=function(){O.call(this),this.appearanceStreamContent=N.CheckBox.createAppearanceStream(),this.MK=N.CheckBox.createMK(),this.AS="/On",this.V="/On"};r(D,O);var M=function(){var e,n;T.call(this),this.DA=N.createDefaultAppearanceStream(),this.F=4,Object.defineProperty(this,"V",{get:function(){return e?k(e):e},enumerable:!0,set:function(t){e=t}}),Object.defineProperty(this,"DV",{get:function(){return n?k(n):n},enumerable:!0,set:function(t){n=t}});var r=!1;Object.defineProperty(this,"multiline",{enumerable:!1,get:function(){return r},set:function(t){r=t}});var i=!1;Object.defineProperty(this,"fileSelect",{enumerable:!1,get:function(){return i},set:function(t){i=t}});var o=!1;Object.defineProperty(this,"doNotSpellCheck",{enumerable:!1,get:function(){return o},set:function(t){o=t}});var a=!1;Object.defineProperty(this,"doNotScroll",{enumerable:!1,get:function(){return a},set:function(t){a=t}});var s=!1;Object.defineProperty(this,"MaxLen",{enumerable:!0,get:function(){return s},set:function(t){s=t}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,get:function(){return this.V||this.DV}})};r(M,T);var U=function(){M.call(this);var e=!0;Object.defineProperty(this,"password",{enumerable:!1,get:function(){return e},set:function(t){e=t}})};r(U,M);var N={CheckBox:{createAppearanceStream:function(){return{N:{On:N.CheckBox.YesNormal},D:{On:N.CheckBox.YesPushDown,Off:N.CheckBox.OffPushDown}}},createMK:function(){return"<< /CA (3)>>"},YesPushDown:function(t){var e=h(t),n=[],r=l.internal.getFont("zapfdingbats","normal").id;t.Q=1;var i=c(t,"3","ZapfDingbats",50);return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+i.fontSize.toFixed(2)+" Tf 0 g"),n.push("BT"),n.push(i.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=h(t),n=l.internal.getFont("zapfdingbats","normal").id,r=[];t.Q=1;var i=N.internal.getHeight(t),o=N.internal.getWidth(t),a=c(t,"3","ZapfDingbats",.9*i);return r.push("1 g"),r.push("0 0 "+o.toFixed(2)+" "+i.toFixed(2)+" re"),r.push("f"),r.push("q"),r.push("0 0 1 rg"),r.push("0 0 "+(o-1).toFixed(2)+" "+(i-1).toFixed(2)+" re"),r.push("W"),r.push("n"),r.push("0 g"),r.push("BT"),r.push("/"+n+" "+a.fontSize.toFixed(2)+" Tf 0 g"),r.push(a.text),r.push("ET"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:N.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=N.RadioButton.Circle.YesNormal,e.D[t]=N.RadioButton.Circle.YesPushDown,e},createMK:function(){return"<< /CA (l)>>"},YesNormal:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4;r*=.9;var i=N.internal.Bezier_C;return n.push("q"),n.push("1 0 0 1 "+N.internal.getWidth(t)/2+" "+N.internal.getHeight(t)/2+" cm"),n.push(r+" 0 m"),n.push(r+" "+r*i+" "+r*i+" "+r+" 0 "+r+" c"),n.push("-"+r*i+" "+r+" -"+r+" "+r*i+" -"+r+" 0 c"),n.push("-"+r+" -"+r*i+" -"+r*i+" -"+r+" 0 -"+r+" c"),n.push(r*i+" -"+r+" "+r+" -"+r*i+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4,i=2*(r*=.9),o=i*N.internal.Bezier_C,a=r*N.internal.Bezier_C;return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[],r=N.internal.getWidth(t)<=N.internal.getHeight(t)?N.internal.getWidth(t)/4:N.internal.getHeight(t)/4,i=2*(r*=.9),o=i*N.internal.Bezier_C;return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+(N.internal.getWidth(t)/2).toFixed(2)+" "+(N.internal.getHeight(t)/2).toFixed(2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:N.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=N.RadioButton.Cross.YesNormal,e.D[t]=N.RadioButton.Cross.YesPushDown,e},createMK:function(){return"<< /CA (8)>>"},YesNormal:function(t){var e=h(t),n=[],r=N.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+(N.internal.getWidth(t)-2).toFixed(2)+" "+(N.internal.getHeight(t)-2).toFixed(2)+" re"),n.push("W"),n.push("n"),n.push(r.x1.x.toFixed(2)+" "+r.x1.y.toFixed(2)+" m"),n.push(r.x2.x.toFixed(2)+" "+r.x2.y.toFixed(2)+" l"),n.push(r.x4.x.toFixed(2)+" "+r.x4.y.toFixed(2)+" m"),n.push(r.x3.x.toFixed(2)+" "+r.x3.y.toFixed(2)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=h(t),n=N.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),r.push("f"),r.push("q"),r.push("1 1 "+(N.internal.getWidth(t)-2).toFixed(2)+" "+(N.internal.getHeight(t)-2).toFixed(2)+" re"),r.push("W"),r.push("n"),r.push(n.x1.x.toFixed(2)+" "+n.x1.y.toFixed(2)+" m"),r.push(n.x2.x.toFixed(2)+" "+n.x2.y.toFixed(2)+" l"),r.push(n.x4.x.toFixed(2)+" "+n.x4.y.toFixed(2)+" m"),r.push(n.x3.x.toFixed(2)+" "+n.x3.y.toFixed(2)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=h(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+N.internal.getWidth(t).toFixed(2)+" "+N.internal.getHeight(t).toFixed(2)+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){return"/F1 0 Tf 0 g"}};N.internal={Bezier_C:.551915024494,calculateCross:function(t){var e,n,r=N.internal.getWidth(t),i=N.internal.getHeight(t),o=(n=i)<(e=r)?n:e;return{x1:{x:(r-o)/2,y:(i-o)/2+o},x2:{x:(r-o)/2+o,y:(i-o)/2},x3:{x:(r-o)/2,y:(i-o)/2},x4:{x:(r-o)/2+o,y:(i-o)/2+o}}}},N.internal.getWidth=function(t){var e=0;return"object"===(void 0===t?"undefined":vt(t))&&(e=s(t.Rect[2])),e},N.internal.getHeight=function(t){var e=0;return"object"===(void 0===t?"undefined":vt(t))&&(e=s(t.Rect[3])),e},n.addField=function(t){return x.call(this),t instanceof M?this.addTextField.call(this,t):t instanceof F?this.addChoiceField.call(this,t):t instanceof O?this.addButton.call(this,t):t instanceof j?g.call(this,t):t&&g.call(this,t),t.page=l.internal.getCurrentPageInfo().pageNumber,this},n.addButton=function(t){x.call(this);var e=t||new T;e.FT="/Btn",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},n.addTextField=function(t){x.call(this);var e=t||new T;e.FT="/Tx",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},n.addChoiceField=function(t){x.call(this);var e=t||new T;e.FT="/Ch",e.Ff=o(e.Ff,t,l.internal.getPDFVersion()),g.call(this,e)},"object"==(void 0===t?"undefined":vt(t))&&(t.ChoiceField=F,t.ListBox=P,t.ComboBox=E,t.EditBox=q,t.Button=O,t.PushButton=B,t.RadioButton=R,t.CheckBox=D,t.TextField=M,t.PasswordField=U,t.AcroForm={Appearance:N}),n.AcroFormChoiceField=F,n.AcroFormListBox=P,n.AcroFormComboBox=E,n.AcroFormEditBox=q,n.AcroFormButton=O,n.AcroFormPushButton=B,n.AcroFormRadioButton=R,n.AcroFormCheckBox=D,n.AcroFormTextField=M,n.AcroFormPasswordField=U,n.AcroForm={ChoiceField:F,ListBox:P,ComboBox:E,EditBox:q,Button:O,PushButton:B,RadioButton:R,CheckBox:D,TextField:M,PasswordField:U}}($.API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),$.API.addHTML=function(t,p,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof p&&(s=p,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,w=e.scaleFactor,y=e.pageSize.getWidth(),v=e.pageSize.getHeight();if((s=s||{}).onrendered=function(h){p=parseInt(p)||0,g=parseInt(g)||0;var t=s.dim||{},c=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(v,h.height/w),l=t.w||Math.min(y,h.width/w)-p,u=s.format||"JPEG",f=s.imageCompression||"SLOW";if(h.height>v-c.top-c.bottom&&s.pagesplit){var d=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?c.top:g,i.left=0!==n?c.left:p,o=(y-c.left-c.right)*w<h.width,"content"===c.useFor?0===n?(t=Math.min((y-c.left)*w,h.width),e=Math.min((v-c.top)*w,h.height-n)):(t=Math.min(y*w,h.width),e=Math.min(v*w,h.height-n),i.top=0):(t=Math.min((y-c.left-c.right)*w,h.width),e=Math.min((v-c.bottom-c.top)*w,h.height-n)),o)for(;;){"content"===c.useFor&&(0===r?t=Math.min((y-c.left)*w,h.width):(t=Math.min(y*w,h.width-r),i.left=0));var s=[a=d(h,r,n,t,e),i.left,i.top,a.width/w,a.height/w,u,null,f];if(this.addImage.apply(this,s),(r+=t)>=h.width)break;this.addPage()}else s=[a=d(h,0,n,t,e),i.left,i.top,a.width/w,a.height/w,u,null,f],this.addImage.apply(this,s);if((n+=e)>=h.height)break;this.addPage()}m(l,n,null,s)}.bind(this);if("CANVAS"===h.nodeName){var r=new Image;r.onload=n,r.src=h.toDataURL("image/png"),h=r}else n()}else{var i=Math.random().toString(35),o=[h,p,g,l,e,u,i,f];this.addImage.apply(this,o),m(l,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"!=typeof rasterizeHTML){var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||y*w,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})}return null},
/** @preserve
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(b){var x="addImage_",h={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]};b.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in h)for(i=h[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s};var n=function t(e){var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream;if(e.n=n,r("<</Type /XObject"),r("/Subtype /Image"),r("/Width "+e.w),r("/Height "+e.h),e.cs===this.color_spaces.INDEXED?r("/ColorSpace [/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"):(r("/ColorSpace /"+e.cs),e.cs===this.color_spaces.DEVICE_CMYK&&r("/Decode [1 0 1 0 1 0 1 0]")),r("/BitsPerComponent "+e.bpc),"f"in e&&r("/Filter /"+e.f),"dp"in e&&r("/DecodeParms <<"+e.dp+">>"),"trns"in e&&e.trns.constructor==Array){for(var o="",a=0,s=e.trns.length;a<s;a++)o+=e.trns[a]+" "+e.trns[a]+" ";r("/Mask ["+o+"]")}if("smask"in e&&r("/SMask "+(n+1)+" 0 R"),r("/Length "+e.data.length+">>"),i(e.data),r("endobj"),"smask"in e){var h="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,c={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:h,data:e.smask};"f"in e&&(c.f=e.f),t.call(this,c)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),r("<< /Length "+e.pal.length+">>"),i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))),r("endobj"))},S=function(){var t=this.internal.collections[x+"images"];for(var e in t)n.call(this,t[e])},k=function(){var t,e=this.internal.collections[x+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},_=function(t){return"function"==typeof b["process"+t.toUpperCase()]},A=function(t){return"object"===(void 0===t?"undefined":vt(t))&&1===t.nodeType},I=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return n;!e&&/\.png(?:[?#].*)?$/i.test(n)&&(e="png")}if("CANVAS"===t.nodeName)var r=t;else{(r=document.createElement("canvas")).width=t.clientWidth||t.width,r.height=t.clientHeight||t.height;var i=r.getContext("2d");if(!i)throw"addImage requires canvas to be supported by browser.";i.drawImage(t,0,0,r.width,r.height)}return r.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},C=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};b.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},b.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},b.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},b.sHashCode=function(t){return t=t||"",Array.prototype.reduce&&t.split("").reduce(function(t,e){return(t=(t<<5)-t+e.charCodeAt(0))&t},0)},b.isString=function(t){return"string"==typeof t},b.validateStringAsBase64=function(t){var e=!0;return(t=t||"").length%4!=0&&(e=!1),!1===/[A-Za-z0-9\/]+/.test(t.substr(0,t.length-2))&&(e=!1),!1===/[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==/.test(t.substr(-2))&&(e=!1),e},b.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));base64,(.+)$/g.exec(t)},b.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},b.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},b.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},b.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},b.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t));if("function"==typeof TextDecoder){var e=new TextDecoder("ascii");if("ascii"===e.encoding)return e.decode(t)}for(var n=this.isArrayBuffer(t)?t:new Uint8Array(t),r=20480,i="",o=Math.ceil(n.byteLength/r),a=0;a<o;a++)i+=String.fromCharCode.apply(null,n.slice(a*r,a*r+r));return i},b.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,h=0;h<s;h+=3)n+=r[(16515072&(e=i[h]<<16|i[h+1]<<8|i[h+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},b.createImageInfo=function(t,e,n,r,i,o,a,s,h,c,l,u,f){var d={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(d.f=o),h&&(d.dp=h),c&&(d.trns=c),l&&(d.pal=l),u&&(d.smask=u),f&&(d.p=f),d},b.addImage=function(t,e,n,r,i,o,a,s,h){var c="";if("string"!=typeof e){var l=o;o=i,i=r,r=n,n=e,e=l}if("object"===(void 0===t?"undefined":vt(t))&&!A(t)&&"imageData"in t){var u=t;t=u.imageData,e=u.format||e,n=u.x||n||0,r=u.y||r||0,i=u.w||i,o=u.h||o,a=u.alias||a,s=u.compression||s,h=u.rotation||u.angle||h}if(isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var f,d,p,g,m,w,y,v=function(){var t=this.internal.collections[x+"images"];return t||(this.internal.collections[x+"images"]=t={},this.internal.events.subscribe("putResources",S),this.internal.events.subscribe("putXobjectDict",k)),t}.call(this);if(!(f=C(t,v))&&(A(t)&&(t=I(t,e)),(null==(y=a)||0===y.length)&&(a="string"==typeof(w=t)&&b.sHashCode(w)),!(f=C(a,v)))){if(this.isString(t)&&(""!==(c=this.convertStringToImageData(t))?t=c:void 0!==(c=this.loadImageFile(t))&&(t=c)),e=this.getImageFileTypeByImageData(t,e),!_(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(f=this["process"+e.toUpperCase()](t,(m=0,(g=v)&&(m=Object.keys?Object.keys(g).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(g)),m),a,((p=s)&&"string"==typeof p&&(p=p.toUpperCase()),p in b.image_compression?p:b.image_compression.NONE),d)))throw new Error("An unkwown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var h=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),c=this.internal.getCoordinateString,l=this.internal.getVerticalCoordinateString;if(n=h[0],r=h[1],a[o]=i,s){s*=Math.PI/180;var u=Math.cos(s),f=Math.sin(s),d=function(t){return t.toFixed(4)},p=[d(u),d(f),d(-1*f),d(u),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,c(t),l(e+r),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([c(n),"0","0",c(r),"0","0","cm"].join(" "))):this.internal.write([c(n),"0","0",c(r),c(t),l(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,f,f.i,v,h),this},b.convertStringToImageData=function(t){var e,n="";this.isString(t)&&(null!==(e=this.extractInfoFromBase64DataURI(t))?b.validateStringAsBase64(e[3])&&(n=atob(e[3])):b.validateStringAsBase64(t)&&(n=atob(t)));return n};var c=function(t,e){return t.subarray(e,e+5)};b.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if(255===!t.charCodeAt(0)||216===!t.charCodeAt(1)||255===!t.charCodeAt(2)||224===!t.charCodeAt(3)||!t.charCodeAt(6)==="J".charCodeAt(0)||!t.charCodeAt(7)==="F".charCodeAt(0)||!t.charCodeAt(8)==="I".charCodeAt(0)||!t.charCodeAt(9)==="F".charCodeAt(0)||0===!t.charCodeAt(10))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=c(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=c(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},b.processJPG=function(){return this.processJPEG.apply(this,arguments)},b.loadImageFile=function(t,e,n){e=e||!0,n=n||function(){};Object.prototype.toString.call("undefined"!=typeof process?process:0);if(void 0!==("undefined"==typeof window?"undefined":vt(window))&&"object"===("undefined"==typeof location?"undefined":vt(location))&&"http"===location.protocol.substr(0,4))return function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)},b.getImageProperties=function(t){var e,n,r="";if(A(t)&&(t=I(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=this.loadImageFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!_(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unkwown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}($.API),
/**
   * jsPDF Annotations PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=$.API,y={annotations:[],f2:function(t){return t.toFixed(2)},notEmpty:function(t){if(void 0!==t&&""!=t)return!0}},$.API.annotationPlugin=y,$.API.events.push(["addPage",function(t){this.annotationPlugin.annotations[t.pageNumber]=[]}]),t.events.push(["putPage",function(t){for(var e=this.annotationPlugin.annotations[t.pageNumber],n=!1,r=0;r<e.length&&!n;r++)switch((h=e[r]).type){case"link":if(y.notEmpty(h.options.url)||y.notEmpty(h.options.pageNumber)){n=!0;break}case"reference":case"text":case"freetext":n=!0}if(0!=n){this.internal.write("/Annots [");var i=this.annotationPlugin.f2,o=this.internal.scaleFactor,a=this.internal.pageSize.getHeight(),s=this.internal.getPageInfo(t.pageNumber);for(r=0;r<e.length;r++){var h;switch((h=e[r]).type){case"reference":this.internal.write(" "+h.object.objId+" 0 R ");break;case"text":var c=this.internal.newAdditionalObject(),l=this.internal.newAdditionalObject(),u=h.title||"Note";m="<</Type /Annot /Subtype /Text "+(d="/Rect ["+i(h.bounds.x*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+" "+i((h.bounds.x+h.bounds.w)*o)+" "+i((a-h.bounds.y)*o)+"] ")+"/Contents ("+h.contents+")",m+=" /Popup "+l.objId+" 0 R",m+=" /P "+s.objId+" 0 R",m+=" /T ("+u+") >>",c.content=m;var f=c.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(d="/Rect ["+i((h.bounds.x+30)*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+" "+i((h.bounds.x+h.bounds.w+30)*o)+" "+i((a-h.bounds.y)*o)+"] ")+" /Parent "+f,h.open&&(m+=" /Open true"),m+=" >>",l.content=m,this.internal.write(c.objId,"0 R",l.objId,"0 R");break;case"freetext":var d="/Rect ["+i(h.bounds.x*o)+" "+i((a-h.bounds.y)*o)+" "+i(h.bounds.x+h.bounds.w*o)+" "+i(a-(h.bounds.y+h.bounds.h)*o)+"] ",p=h.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+d+"/Contents ("+h.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+p+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(h.options.name){var g=this.annotations._nameMap[h.options.name];h.options.pageNumber=g.page,h.options.top=g.y}else h.options.top||(h.options.top=0);d="/Rect ["+i(h.x*o)+" "+i((a-h.y)*o)+" "+i((h.x+h.w)*o)+" "+i((a-(h.y+h.h))*o)+"] ";var m="";if(h.options.url)m="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /A <</S /URI /URI ("+h.options.url+") >>";else if(h.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+d+"/Border [0 0 0] /Dest ["+(t=this.internal.getPageInfo(h.options.pageNumber)).objId+" 0 R",h.options.magFactor=h.options.magFactor||"XYZ",h.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+h.options.top+"]";break;case"FitV":h.options.left=h.options.left||0,m+=" /FitV "+h.options.left+"]";break;case"XYZ":default:var w=i((a-h.options.top)*o);h.options.left=h.options.left||0,void 0===h.options.zoom&&(h.options.zoom=0),m+=" /XYZ "+h.options.left+" "+w+" "+h.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t)}},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},t.getLineHeight=function(){return this.internal.getLineHeight()},function(t){var a=Object.keys({ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",fa:"Persian","fa-IR":"Persian/Iran",ur:"Urdu"}),u={1569:[65152],1570:[65153,65154,65153,65154],1571:[65155,65156,65155,65156],1572:[65157,65158],1573:[65159,65160,65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166,65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194,65193],1584:[65195,65196,65195],1585:[65197,65198,65197],1586:[65199,65200,65199],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262,65261],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395,64394],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},f={1570:[65269,65270,65269,65270],1571:[65271,65272,65271,65272],1573:[65273,65274,65273,65274],1575:[65275,65276,65275,65276]},d={1570:[65153,65154,65153,65154],1571:[65155,65156,65155,65156],1573:[65159,65160,65159,65160],1575:[65165,65166,65165,65166]},p={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},e=[1570,1571,1573,1575],n=[1569,1570,1571,1572,1573,1575,1577,1583,1584,1585,1586,1608,1688],o=0,s=1,h=2,c=3;function g(t){return void 0!==t&&void 0!==u[t.charCodeAt(0)]}function l(t){return void 0!==t&&0<=n.indexOf(t.charCodeAt(0))}function m(t){return void 0!==t&&0<=e.indexOf(t.charCodeAt(0))}function w(t){return g(t)&&2<=u[t.charCodeAt(0)].length}function y(t,e,n,r){return g(t)?(r=r||{},u=Object.assign(u,r),!w(t)||!g(e)&&!g(n)||!g(n)&&l(e)||l(t)&&!g(e)||l(t)&&m(e)||l(t)&&l(e)?(u=Object.assign(u,d),o):g(i=t)&&4==u[i.charCodeAt(0)].length&&g(e)&&!l(e)&&g(n)&&w(n)?(u=Object.assign(u,d),c):l(t)||!g(n)?(u=Object.assign(u,d),s):(u=Object.assign(u,d),h)):-1;var i}var v=t.processArabic=function(t,e){t=t||"",e=e||!1;var n,r,i,o="",a=0,s=0,h="",c="",l="";for(a=0;a<t.length;a+=1)h=t[a],c=t[a-1],l=t[a+1],g(h)?void 0!==c&&1604===c.charCodeAt(0)&&m(h)?(s=y(h,t[a-2],t[a+1],f),n=String.fromCharCode(f[h.charCodeAt(0)][s]),o=o.substr(0,o.length-1)+n):void 0!==c&&1617===c.charCodeAt(0)&&(void 0!==(r=h)&&void 0!==p[r.charCodeAt(0)])?(s=y(h,t[a-2],t[a+1],d),n=String.fromCharCode(p[h.charCodeAt(0)][s]),o=o.substr(0,o.length-1)+n):(s=y(h,c,l,d),o+=String.fromCharCode(u[h.charCodeAt(0)][s])):o+=e?{"(":")",")":"("}[i=h]||i:h;return e?o.split("").reverse().join(""):o};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang),i=[];if(0<=a.indexOf(r)){if("[object Array]"===Object.prototype.toString.call(e)){var o=0;for(i=[],o=0;o<e.length;o+=1)"[object Array]"===Object.prototype.toString.call(e[o])?i.push([v(e[o][0],!0),e[o][1],e[o][2]]):i.push([v(e[o],!0)]);t.text=i}else t.text=v(e,!0);void 0===n.charSpace&&(t.options.charSpace=0),!0===n.R2L&&(t.options.R2L=!1)}}])}($.API),$.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},(
/**
   * jsPDF Canvas PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=$.API).events.push(["initialized",function(){this.canvas.pdf=this}]),e.canvas={getContext:function(t){return(this.pdf.context2d._canvas=this).pdf.context2d},childNodes:[]},Object.defineProperty(e.canvas,"width",{get:function(){return this._width},set:function(t){this._width=t,this.getContext("2d").pageWrapX=t+1}}),Object.defineProperty(e.canvas,"height",{get:function(){return this._height},set:function(t){this._height=t,this.getContext("2d").pageWrapY=t+1}}),
/** ====================================================================
   * jsPDF Cell plugin
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
I=$.API,C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1,d=function(t,e,n,r,i){C={x:t,y:e,w:n,h:r,ln:i}},p=function(){return C},F={left:0,top:0,bottom:0},I.setHeaderFunction=function(t){h=t},I.getTextDimensions=function(e){i=this.internal.getFont().fontName,o=this.table_font_size||this.internal.getFontSize(),a=this.internal.getFont().fontStyle;var t,n,r=19.049976/25.4;(n=document.createElement("font")).id="jsPDFCell";try{n.style.fontStyle=a}catch(t){n.style.fontWeight=a}n.style.fontSize=o+"pt",n.style.fontFamily=i;try{n.textContent=e}catch(t){n.innerText=e}return document.body.appendChild(n),t={w:(n.offsetWidth+1)*r,h:(n.offsetHeight+1)*r},document.body.removeChild(n),t},I.cellAddPage=function(){var t=this.margins||F;this.addPage(),d(t.left,t.top,void 0,void 0),T+=1},I.cellInitialize=function(){C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1},I.cell=function(t,e,n,r,i,o,a){var s=p(),h=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var c=this.margins||F;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-c.bottom&&(this.cellAddPage(),h=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=p().y+p().h,h&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var l=0;l<i.length;l++){var u=i[l],f=this.getStringUnitWidth(u)*this.internal.getFontSize();this.text(u,t+n-f-3,e+this.internal.getLineHeight()*(l+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return d(t,e,n,r,o),this},I.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},I.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,h,c,l,u,f,d,p,g=[],m=[],w={},y={},v=[],b=[],x=!1,S=!0,k=12,_=F;if(_.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(S=!1),i.fontSize&&(k=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(k=16*i.css["font-size"]),i.margins&&(_=i.margins)),this.lnMod=0,C={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},T=1,this.printHeaders=S,this.margins=_,this.setFontSize(k),this.table_font_size=k,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),y[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(p=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(w[o=g[a]]=n.map(p),v.push(this.getTextDimensions(m[a]||o).w),u=0,h=(l=w[o]).length;u<h;u+=1)c=l[u],v.push(this.getTextDimensions(c).w);y[o]=I.arrayMax(v),v=[]}if(S){var A=this.calculateLineHeight(g,y,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,y[o],A,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],A=this.calculateLineHeight(g,y,f),u=0,d=g.length;u<d;u+=1)o=g[u],this.cell(t,e,y[o],A,f[o],a+2,o.align);return this.lastCellPos=C,this.table_x=t,this.table_y=e,this},I.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},I.setTableHeaderRow=function(t){this.tableHeaderRow=t},I.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==h){var a=h(this,T);d(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t){t.events.push(["initialized",function(){((this.context2d.pdf=this).context2d.internal.pdf=this).context2d.ctx=new e,this.context2d.ctxStack=[],this.context2d.path=[]}]),t.context2d={pageWrapXEnabled:!1,pageWrapYEnabled:!1,pageWrapX:9999999,pageWrapY:9999999,ctx:new e,f2:function(t){return t.toFixed(2)},fillRect:function(t,e,n,r){if(!this._isFillTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"f")}},strokeRect:function(t,e,n,r){if(!this._isStrokeTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"s")}},clearRect:function(t,e,n,r){if(!this.ctx.ignoreClearRect){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.save(),this.setFillStyle("#ffffff"),this.pdf.rect(i.x,i.y,i.w,i.h,"f"),this.restore()}},save:function(){this.ctx._fontSize=this.pdf.internal.getFontSize();var t=new e;t.copy(this.ctx),this.ctxStack.push(this.ctx),this.ctx=t},restore:function(){this.ctx=this.ctxStack.pop(),this.setFillStyle(this.ctx.fillStyle),this.setStrokeStyle(this.ctx.strokeStyle),this.setFont(this.ctx.font),this.pdf.setFontSize(this.ctx._fontSize),this.setLineCap(this.ctx.lineCap),this.setLineWidth(this.ctx.lineWidth),this.setLineJoin(this.ctx.lineJoin)},rect:function(t,e,n,r){this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.closePath()},beginPath:function(){this.path=[]},closePath:function(){this.path.push({type:"close"})},_getRGBA:function(t){var e,n,r,i,o=new RGBColor(t);if(!t)return{r:0,g:0,b:0,a:0,style:t};if(this.internal.rxTransparent.test(t))i=r=n=e=0;else{var a=this.internal.rxRgb.exec(t);null!=a?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=1):null!=(a=this.internal.rxRgba.exec(t))?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=parseFloat(a[4])):(i=1,"#"!=t.charAt(0)&&(t=o.ok?o.toHex():"#000000"),4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16))}return{r:e,g:n,b:r,a:i,style:t}},setFillStyle:function(t){var e=this._getRGBA(t);this.ctx.fillStyle=t,this.ctx._isFillTransparent=0===e.a,this.ctx._fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})},setStrokeStyle:function(t){var e=this._getRGBA(t);this.ctx.strokeStyle=e.style,this.ctx._isStrokeTransparent=0===e.a,this.ctx._strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))},fillText:function(t,e,n,r){if(!this._isFillTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(0<this.ctx._clip_path.length){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var h=1;try{h=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(h<.01)this.pdf.text(t,e,this._getBaseline(n),null,o);else{var c=this.pdf.internal.getFontSize();this.pdf.setFontSize(c*h),this.pdf.text(t,e,this._getBaseline(n),null,o),this.pdf.setFontSize(c)}0<this.ctx._clip_path.length&&a.push("Q")}},strokeText:function(t,e,n,r){if(!this._isStrokeTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(0<this.ctx._clip_path.length){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var h=1;try{h=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(1===h)this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o);else{var c=this.pdf.internal.getFontSize();this.pdf.setFontSize(c*h),this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o),this.pdf.setFontSize(c)}0<this.ctx._clip_path.length&&a.push("Q")}},setFont:function(t){if(this.ctx.font=t,null!=(c=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/.exec(t))){var e=c[1],n=(c[2],c[3]),r=c[4],i=c[5],o=c[6];r="px"===i?Math.floor(parseFloat(r)):"em"===i?Math.floor(parseFloat(r)*this.pdf.getFontSize()):Math.floor(parseFloat(r)),this.pdf.setFontSize(r),"bold"===n||"700"===n?this.pdf.setFontStyle("bold"):"italic"===e?this.pdf.setFontStyle("italic"):this.pdf.setFontStyle("normal"),l="bold"===n||"700"===n?"italic"===e?"bolditalic":"bold":"italic"===e?"italic":"normal";for(var a=o.toLowerCase().split(/\s*,\s*/),s="Times",h=0;h<a.length;h++){if(void 0!==this.pdf.internal.getFont(a[h],l,{noFallback:!0,disableWarning:!0})){s=a[h];break}if("bolditalic"===l&&void 0!==this.pdf.internal.getFont(a[h],"bold",{noFallback:!0,disableWarning:!0}))s=a[h],l="bold";else if(void 0!==this.pdf.internal.getFont(a[h],"normal",{noFallback:!0,disableWarning:!0})){s=a[h],l="normal";break}}this.pdf.setFont(s,l)}else{var c=/\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/.exec(t);if(null!=c){var l,u=c[1],f=(c[2],c[3]);(l=c[4])||(l="normal"),u="em"===i?Math.floor(parseFloat(r)*this.pdf.getFontSize()):Math.floor(parseFloat(u)),this.pdf.setFontSize(u),this.pdf.setFont(f,l)}}},setTextBaseline:function(t){this.ctx.textBaseline=t},getTextBaseline:function(){return this.ctx.textBaseline},setTextAlign:function(t){this.ctx.textAlign=t},getTextAlign:function(){return this.ctx.textAlign},setLineWidth:function(t){this.ctx.lineWidth=t,this.pdf.setLineWidth(t)},setLineCap:function(t){this.ctx.lineCap=t,this.pdf.setLineCap(t)},setLineJoin:function(t){this.ctx.lineJoin=t,this.pdf.setLineJoin(t)},moveTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"mt",x:t=n[0],y:e=n[1]};this.path.push(r)},_wrapX:function(t){return this.pageWrapXEnabled?t%this.pageWrapX:t},_wrapY:function(t){return this.pageWrapYEnabled?(this._gotoPage(this._page(t)),(t-this.lastBreak)%this.pageWrapY):t},transform:function(t,e,n,r,i,o){this.ctx._transform=this._matrix_multiply(this.ctx._transform,[t,e,n,r,i,o])},setTransform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},_getTransform:function(){return this.ctx._transform},lastBreak:0,pageBreaks:[],_page:function(t){if(this.pageWrapYEnabled){for(var e=this.lastBreak=0,n=0,r=0;r<this.pageBreaks.length;r++)if(t>=this.pageBreaks[r]){e++,0===this.lastBreak&&n++;var i=this.pageBreaks[r]-this.lastBreak;this.lastBreak=this.pageBreaks[r],n+=Math.floor(i/this.pageWrapY)}if(0===this.lastBreak)n+=Math.floor(t/this.pageWrapY)+1;return n+e}return this.pdf.internal.getCurrentPageInfo().pageNumber},_gotoPage:function(t){},lineTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"lt",x:t=n[0],y:e=n[1]};this.path.push(r)},bezierCurveTo:function(t,e,n,r,i,o){var a;t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),i=this._wrapX(i),o=this._wrapY(o),i=(a=this._matrix_map_point(this.ctx._transform,[i,o]))[0],o=a[1];var s={type:"bct",x1:t=(a=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=a[1],x2:n=(a=this._matrix_map_point(this.ctx._transform,[n,r]))[0],y2:r=a[1],x:i,y:o};this.path.push(s)},quadraticCurveTo:function(t,e,n,r){var i;t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),n=(i=this._matrix_map_point(this.ctx._transform,[n,r]))[0],r=i[1];var o={type:"qct",x1:t=(i=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=i[1],x:n,y:r};this.path.push(o)},arc:function(t,e,n,r,i,o){if(t=this._wrapX(t),e=this._wrapY(e),!this._matrix_is_identity(this.ctx._transform)){var a=this._matrix_map_point(this.ctx._transform,[t,e]);t=a[0],e=a[1];var s=this._matrix_map_point(this.ctx._transform,[0,0]),h=this._matrix_map_point(this.ctx._transform,[0,n]);n=Math.sqrt(Math.pow(h[0]-s[0],2)+Math.pow(h[1]-s[1],2))}var c={type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,anticlockwise:o};this.path.push(c)},drawImage:function(t,e,n,r,i,o,a,s,h){void 0!==o&&(e=o,n=a,r=s,i=h),e=this._wrapX(e),n=this._wrapY(n);var c,l=this._matrix_map_rect(this.ctx._transform,{x:e,y:n,w:r,h:i}),u=(this._matrix_map_rect(this.ctx._transform,{x:o,y:a,w:s,h:h}),/data:image\/(\w+).*/i.exec(t));c=null!=u?u[1]:"png",this.pdf.addImage(t,c,l.x,l.y,l.w,l.h)},_matrix_multiply:function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],a=e[4],s=e[5],h=n*t[0]+r*t[2],c=i*t[0]+o*t[2],l=a*t[0]+s*t[2]+t[4];return r=n*t[1]+r*t[3],o=i*t[1]+o*t[3],s=a*t[1]+s*t[3]+t[5],[n=h,r,i=c,o,a=l,s]},_matrix_rotation:function(t){return Math.atan2(t[2],t[0])},_matrix_decompose:function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o=Math.sqrt(e*e+n*n),a=(e/=o)*r+(n/=o)*i;r-=e*a,i-=n*a;var s=Math.sqrt(r*r+i*i);return a/=s,e*(i/=s)<n*(r/=s)&&(e=-e,n=-n,a=-a,o=-o),{scale:[o,0,0,s,0,0],translate:[1,0,0,1,t[4],t[5]],rotate:[e,n,-n,e,0,0],skew:[1,0,a,1,0,0]}},_matrix_map_point:function(t,e){var n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],h=e[0],c=e[1];return[h*n+c*i+a,h*r+c*o+s]},_matrix_map_point_obj:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]);return{x:n[0],y:n[1]}},_matrix_map_rect:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]),r=this._matrix_map_point(t,[e.x+e.w,e.y+e.h]);return{x:n[0],y:n[1],w:r[0]-n[0],h:r[1]-n[1]}},_matrix_is_identity:function(t){return 1==t[0]&&(0==t[1]&&(0==t[2]&&(1==t[3]&&(0==t[4]&&0==t[5]))))},rotate:function(t){var e=[Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,e)},scale:function(t,e){var n=[t,0,0,e,0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},translate:function(t,e){var n=[1,0,0,1,t,e];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},stroke:function(){if(0<this.ctx._clip_path.length){var t;(t=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var e=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._stroke(!0),this.ctx._clip_path=this.path,this.path=e,this._stroke(!1),t.push("Q")}else this._stroke(!1)},_stroke:function(t){if(t||!this._isStrokeTransparent()){for(var e=[],n=this.path,r=0;r<n.length;r++){var i=n[r];switch(i.type){case"mt":e.push({start:i,deltas:[],abs:[]});break;case"lt":var o=[i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(o),e[e.length-1].abs.push(i);break;case"bct":o=[i.x1-n[r-1].x,i.y1-n[r-1].y,i.x2-n[r-1].x,i.y2-n[r-1].y,i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(o);break;case"qct":var a=n[r-1].x+2/3*(i.x1-n[r-1].x),s=n[r-1].y+2/3*(i.y1-n[r-1].y),h=i.x+2/3*(i.x1-i.x),c=i.y+2/3*(i.y1-i.y),l=i.x,u=i.y;o=[a-n[r-1].x,s-n[r-1].y,h-n[r-1].x,c-n[r-1].y,l-n[r-1].x,u-n[r-1].y];e[e.length-1].deltas.push(o);break;case"arc":0==e.length&&e.push({start:{x:0,y:0},deltas:[],abs:[]}),e[e.length-1].arc=!0,Array.isArray(e[e.length-1].abs)&&e[e.length-1].abs.push(i)}}for(r=0;r<e.length;r++){var f;if(f=r==e.length-1?"s":null,e[r].arc)for(var d=e[r].abs,p=0;p<d.length;p++){var g=d[p],m=360*g.startAngle/(2*Math.PI),w=360*g.endAngle/(2*Math.PI),y=g.x,v=g.y;this.internal.arc2(this,y,v,g.radius,m,w,g.anticlockwise,f,t)}else{y=e[r].start.x,v=e[r].start.y;t?(this.pdf.lines(e[r].deltas,y,v,null,null),this.pdf.clip_fixed()):this.pdf.lines(e[r].deltas,y,v,null,f)}}}},_isFillTransparent:function(){return this.ctx._isFillTransparent||0==this.globalAlpha},_isStrokeTransparent:function(){return this.ctx._isStrokeTransparent||0==this.globalAlpha},fill:function(t){if(0<this.ctx._clip_path.length){var e;(e=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var n=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(t,!0),this.ctx._clip_path=this.path,this.path=n,this._fill(t,!1),e.push("Q")}else this._fill(t,!1)},_fill:function(t,e){if(!this._isFillTransparent()){var n,r="function"==typeof this.pdf.internal.newObject2;n=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage();var i=[],o=window.outIntercept;if(r)switch(this.ctx.globalCompositeOperation){case"normal":case"source-over":break;case"destination-in":case"destination-out":var a=this.pdf.internal.newStreamObject(),s=this.pdf.internal.newObject2();s.push("<</Type /ExtGState"),s.push("/SMask <</S /Alpha /G "+a.objId+" 0 R>>"),s.push(">>");var h="MASK"+s.objId;this.pdf.internal.addGraphicsState(h,s.objId);var c="/"+h+" gs";n.splice(0,0,"q"),n.splice(1,0,c),n.push("Q"),window.outIntercept=a;break;default:var l="/"+this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];l&&this.pdf.internal.out(l+" gs")}var u=this.ctx.globalAlpha;if(this.ctx._fillOpacity<1&&(u=this.ctx._fillOpacity),r){var f=this.pdf.internal.newObject2();f.push("<</Type /ExtGState"),f.push("/CA "+u),f.push("/ca "+u),f.push(">>");h="GS_O_"+f.objId;this.pdf.internal.addGraphicsState(h,f.objId),this.pdf.internal.out("/"+h+" gs")}for(var d=this.path,p=0;p<d.length;p++){var g=d[p];switch(g.type){case"mt":i.push({start:g,deltas:[],abs:[]});break;case"lt":var m=[g.x-d[p-1].x,g.y-d[p-1].y];i[i.length-1].deltas.push(m),i[i.length-1].abs.push(g);break;case"bct":m=[g.x1-d[p-1].x,g.y1-d[p-1].y,g.x2-d[p-1].x,g.y2-d[p-1].y,g.x-d[p-1].x,g.y-d[p-1].y];i[i.length-1].deltas.push(m);break;case"qct":var w=d[p-1].x+2/3*(g.x1-d[p-1].x),y=d[p-1].y+2/3*(g.y1-d[p-1].y),v=g.x+2/3*(g.x1-g.x),b=g.y+2/3*(g.y1-g.y),x=g.x,S=g.y;m=[w-d[p-1].x,y-d[p-1].y,v-d[p-1].x,b-d[p-1].y,x-d[p-1].x,S-d[p-1].y];i[i.length-1].deltas.push(m);break;case"arc":0===i.length&&i.push({deltas:[],abs:[]}),i[i.length-1].arc=!0,Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(g);break;case"close":i.push({close:!0})}}for(p=0;p<i.length;p++){var k;if(p==i.length-1?(k="f","evenodd"===t&&(k+="*")):k=null,i[p].close)this.pdf.internal.out("h"),k&&this.pdf.internal.out(k);else if(i[p].arc){i[p].start&&this.internal.move2(this,i[p].start.x,i[p].start.y);for(var _=i[p].abs,A=0;A<_.length;A++){var I=_[A];if(void 0!==I.startAngle){var C=360*I.startAngle/(2*Math.PI),T=360*I.endAngle/(2*Math.PI),F=I.x,P=I.y;if(0===A&&this.internal.move2(this,F,P),this.internal.arc2(this,F,P,I.radius,C,T,I.anticlockwise,null,e),A===_.length-1&&i[p].start){F=i[p].start.x,P=i[p].start.y;this.internal.line2(E,F,P)}}else this.internal.line2(E,I.x,I.y)}}else{F=i[p].start.x,P=i[p].start.y;e?(this.pdf.lines(i[p].deltas,F,P,null,null),this.pdf.clip_fixed()):this.pdf.lines(i[p].deltas,F,P,null,k)}}window.outIntercept=o}},pushMask:function(){if("function"==typeof this.pdf.internal.newObject2){var t=this.pdf.internal.newStreamObject(),e=this.pdf.internal.newObject2();e.push("<</Type /ExtGState"),e.push("/SMask <</S /Alpha /G "+t.objId+" 0 R>>"),e.push(">>");var n="MASK"+e.objId;this.pdf.internal.addGraphicsState(n,e.objId);var r="/"+n+" gs";this.pdf.internal.out(r)}else console.log("jsPDF v2 not enabled")},clip:function(){if(0<this.ctx._clip_path.length)for(var t=0;t<this.path.length;t++)this.ctx._clip_path.push(this.path[t]);else this.ctx._clip_path=this.path;this.path=[]},measureText:function(n){var r=this.pdf;return{getWidth:function(){var t=r.internal.getFontSize(),e=r.getStringUnitWidth(n)*t/r.internal.scaleFactor;return e*=1.3333},get width(){return this.getWidth(n)}}},_getBaseline:function(t){var e=parseInt(this.pdf.internal.getFontSize()),n=.25*e;switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e;case"hanging":return t+e-n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}}};var E=t.context2d;function e(){this._isStrokeTransparent=!1,this._strokeOpacity=1,this.strokeStyle="#000000",this.fillStyle="#000000",this._isFillTransparent=!1,this._fillOpacity=1,this.font="12pt times",this.textBaseline="alphabetic",this.textAlign="start",this.lineWidth=1,this.lineJoin="miter",this.lineCap="butt",this._transform=[1,0,0,1,0,0],this.globalCompositeOperation="normal",this.globalAlpha=1,this._clip_path=[],this.ignoreClearRect=!1,this.copy=function(t){this._isStrokeTransparent=t._isStrokeTransparent,this._strokeOpacity=t._strokeOpacity,this.strokeStyle=t.strokeStyle,this._isFillTransparent=t._isFillTransparent,this._fillOpacity=t._fillOpacity,this.fillStyle=t.fillStyle,this.font=t.font,this.lineWidth=t.lineWidth,this.lineJoin=t.lineJoin,this.lineCap=t.lineCap,this.textBaseline=t.textBaseline,this.textAlign=t.textAlign,this._fontSize=t._fontSize,this._transform=t._transform.slice(0),this.globalCompositeOperation=t.globalCompositeOperation,this.globalAlpha=t.globalAlpha,this._clip_path=t._clip_path.slice(0),this.ignoreClearRect=t.ignoreClearRect}}Object.defineProperty(E,"fillStyle",{set:function(t){this.setFillStyle(t)},get:function(){return this.ctx.fillStyle}}),Object.defineProperty(E,"strokeStyle",{set:function(t){this.setStrokeStyle(t)},get:function(){return this.ctx.strokeStyle}}),Object.defineProperty(E,"lineWidth",{set:function(t){this.setLineWidth(t)},get:function(){return this.ctx.lineWidth}}),Object.defineProperty(E,"lineCap",{set:function(t){this.setLineCap(t)},get:function(){return this.ctx.lineCap}}),Object.defineProperty(E,"lineJoin",{set:function(t){this.setLineJoin(t)},get:function(){return this.ctx.lineJoin}}),Object.defineProperty(E,"miterLimit",{set:function(t){this.ctx.miterLimit=t},get:function(){return this.ctx.miterLimit}}),Object.defineProperty(E,"textBaseline",{set:function(t){this.setTextBaseline(t)},get:function(){return this.getTextBaseline()}}),Object.defineProperty(E,"textAlign",{set:function(t){this.setTextAlign(t)},get:function(){return this.getTextAlign()}}),Object.defineProperty(E,"font",{set:function(t){this.setFont(t)},get:function(){return this.ctx.font}}),Object.defineProperty(E,"globalCompositeOperation",{set:function(t){this.ctx.globalCompositeOperation=t},get:function(){return this.ctx.globalCompositeOperation}}),Object.defineProperty(E,"globalAlpha",{set:function(t){this.ctx.globalAlpha=t},get:function(){return this.ctx.globalAlpha}}),Object.defineProperty(E,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(E,"ignoreClearRect",{set:function(t){this.ctx.ignoreClearRect=t},get:function(){return this.ctx.ignoreClearRect}}),E.internal={},E.internal.rxRgb=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,E.internal.rxRgba=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/,E.internal.rxTransparent=/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/,E.internal.arc=function(t,e,n,r,i,o,a,s){for(var h=this.pdf.internal.scaleFactor,c=this.pdf.internal.pageSize.getHeight(),l=this.pdf.internal.f2,u=i*(Math.PI/180),f=o*(Math.PI/180),d=this.createArc(r,u,f,a),p=0;p<d.length;p++){var g=d[p];0===p?this.pdf.internal.out([l((g.x1+e)*h),l((c-(g.y1+n))*h),"m",l((g.x2+e)*h),l((c-(g.y2+n))*h),l((g.x3+e)*h),l((c-(g.y3+n))*h),l((g.x4+e)*h),l((c-(g.y4+n))*h),"c"].join(" ")):this.pdf.internal.out([l((g.x2+e)*h),l((c-(g.y2+n))*h),l((g.x3+e)*h),l((c-(g.y3+n))*h),l((g.x4+e)*h),l((c-(g.y4+n))*h),"c"].join(" ")),t._lastPoint={x:e,y:n}}null!==s&&this.pdf.internal.out(this.pdf.internal.getStyle(s))},E.internal.arc2=function(t,e,n,r,i,o,a,s,h){var c=e,l=n;h?(this.arc(t,c,l,r,i,o,a,null),this.pdf.clip_fixed()):this.arc(t,c,l,r,i,o,a,s)},E.internal.move2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.getHeight(),o=this.pdf.internal.f2;this.pdf.internal.out([o(e*r),o((i-n)*r),"m"].join(" ")),t._lastPoint={x:e,y:n}},E.internal.line2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.getHeight(),o=this.pdf.internal.f2,a={x:e,y:n};this.pdf.internal.out([o(a.x*r),o((i-a.y)*r),"l"].join(" ")),t._lastPoint=a},E.internal.createArc=function(t,e,n,r){var i=2*Math.PI,o=Math.PI/2,a=e;for((a<i||i<a)&&(a%=i),a<0&&(a=i+a);n<e;)e-=i;var s=Math.abs(n-e);s<i&&r&&(s=i-s);for(var h=[],c=r?-1:1,l=a;1e-5<s;){var u=l+c*Math.min(s,o);h.push(this.createSmallArc(t,l,u)),s-=Math.abs(u-l),l=u}return h},E.internal.getCurrentPage=function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber]},E.internal.createSmallArc=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,h=a*a+s*s,c=h+a*i+s*o,l=4/3*(Math.sqrt(2*h*c)-c)/(a*o-s*i),u=a-l*s,f=s+l*a,d=u,p=-f,g=r+e,m=Math.cos(g),w=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:u*m-f*w,y2:u*w+f*m,x3:d*m-p*w,y3:d*w+p*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}}}($.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/** @preserve
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * 
   * ====================================================================
   */
function(t){var T,F,i,a,s,h,c,l,P,v,f,u,d,n,E,q,p,g,m,O;T=function(){return function(t){return e.prototype=t,new e};function e(){}}(),v=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},u=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},d=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},P=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=u((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=h[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=d(r("font-size"))||1,e["line-height"]=d(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&d(r("margin-top"))||0,e["margin-bottom"]=n&&d(r("margin-bottom"))||0,e["padding-top"]=n&&d(r("padding-top"))||0,e["padding-bottom"]=n&&d(r("padding-bottom"))||0,e["margin-left"]=n&&d(r("margin-left"))||0,e["margin-right"]=n&&d(r("margin-right"))||0,e["padding-left"]=n&&d(r("padding-left"))||0,e["padding-right"]=n&&d(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=c[r("cssFloat")]||"none",e.clear=l[r("clear")]||"none",e.color=r("color"),e},E=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},O=function(t,e){var n,r,i,o,a,s,h,c,l;for(n=[],r=[],i=0,l=t.rows[0].cells.length,h=t.clientWidth;i<l;)c=t.rows[0].cells[i],r[i]={name:c.textContent.toLowerCase().replace(/\s+/g,""),prompt:c.textContent.replace(/\r?\n/g,""),width:c.clientWidth/h*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var B={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},R=1;F=function(t,i,e){var n,r,o,a,s,h,c,l;for(r=t.childNodes,n=void 0,(s="block"===(o=P(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,h=r.length;a<h;){if("object"===(void 0===(n=r[a])?"undefined":vt(n))){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var u=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,F(u,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||B[n.nodeName])if(3===n.nodeType){var d=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)d=R+++". "+d;else{var p=o["font-size"],g=(3-.75*p)*i.pdf.internal.scaleFactor,m=.75*p*i.pdf.internal.scaleFactor,w=1.74*p/i.pdf.internal.scaleFactor;l=function(t,e){this.pdf.circle(t+g,e+m,w,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(d,o)}else"string"==typeof n&&i.addText(n,o);else{var y;if("IMG"===n.nodeName){var v=n.getAttribute("src");y=q[i.pdf.sHashCode(v)||v]}if(y){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=P(n),x=i.x,S=12/i.pdf.internal.scaleFactor,k=(b["margin-left"]+b["padding-left"])*S,_=(b["margin-right"]+b["padding-right"])*S,A=(b["margin-top"]+b["padding-top"])*S,I=(b["margin-bottom"]+b["padding-bottom"])*S;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-_:x+=k,i.pdf.addImage(y,x,i.y+A,n.width,n.height),y=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!B[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-k-_:0,i.y+n.height+A+I,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===P(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+k+_,"left"===b.float&&(i.x+=n.width+k+_)):i.y+=n.height+A+I}else if("TABLE"===n.nodeName)c=O(n,i),i.y+=10,i.pdf.table(i.x,i.y,c.rows,c.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:P(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)R=1,E(n,i,e)||F(n,i,e),i.y+=10;else if("LI"===n.nodeName){var C=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,E(n,i,e)||F(n,i,e),i.x=C}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",T(o))):E(n,i,e)||F(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(l)},q={},p=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function h(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function c(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;q[t]=q[t]||i}--s||h()},i.src=e}}for(;i--;)c(r[i].getAttribute("src"),r[i].width,r[i].height);return s||h()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},F(s,o,a);var h=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=h;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=h;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");F(s,o,a),o.pdf.margins_doc.bottom+=h,o.y=n},i=s.getElementsByTagName("span"),c=0;c<i.length;++c)-1<(" "+i[c].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),B.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,h,c;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),c="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(h=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",h.innerHTML='<iframe style="height:1px;width:1px" name="'+c+'" />',document.body.appendChild(h),(s=window.frames[c]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var l,u=new f(t,n,r,i);return p.call(this,e,u,i.elementHandlers,function(t){g(e,u,i.elementHandlers),F(e,u,i.elementHandlers),u.pdf.internal.events.publish("htmlRenderingFinished"),l=u.dispose(),"function"==typeof o?o(l):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),l||{x:u.x,y:u.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,h,c,l,u,f,d,p,g;for(12,u=this.pdf.internal.scaleFactor,o={},s=h=c=g=a=i=l=r=void 0,d=[f=[]],n=0,p=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(l=g["font-style"])])||(i=this.pdf.internal.getFont(r,l).metadata.Unicode,o[r+l]=i),c={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},h=this.pdf.getStringUnitWidth(a,c)*c.fontSize/u,"\u2028"==a)f=[],d.push(f);else if(p<n+h){for(s=this.pdf.splitTextToSize(a,p,c),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],d.push(f);n=this.pdf.getStringUnitWidth(f[0][0],c)*c.fontSize/u}else f.push([a,g]),n+=h;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<d.length;++m){var w=this.pdf.getStringUnitWidth(d[m][0][0],c)*c.fontSize/u;0<m&&(d[m][0][1]=T(d[m][0][1]));var y=p-w;if("right"===g["text-align"])d[m][0][1]["margin-left"]=y;else if("center"===g["text-align"])d[m][0][1]["margin-left"]=y/2;else if("justify"===g["text-align"]){var v=d[m][0][0].split(" ").length-1;d[m][0][1]["word-spacing"]=y/v,m===d.length-1&&(d[m][0][1]["word-spacing"]=0)}}return d},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=new RGBColor(t),o=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=o?(e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3])):("#"!=t.charAt(0)&&(t=i.ok?i.toHex():"#000000"),e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)),"string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d;if(r=v(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),h=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,u=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,l=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,u=((e["margin-top"]||0)+(e["padding-top"]||0))*n),c=this.pdf.internal.write,o=i=void 0,this.y+=u,c("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var p=0;s.length;){for(i=h=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(h=Math.max(h,a[i][1]["line-height"],a[i][1]["font-size"]),d=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-p,p=m),c(g+Math.max(e["margin-left"]||0,0)*n,(-12*h).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=h*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var w=[],y=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(w.push(t[e][0]+" "),y.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(v(w),y),c("ET","Q"),c("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-d/2),c("ET","Q"),this.y+=l}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},h={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},c={none:"none",right:"right",left:"left"},l={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}($.API),$.API.addJS=function(t){return s=t,this.internal.events.subscribe("postPutResources",function(t){n=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(n+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),r=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+s+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==n&&void 0!==r&&this.internal.out("/Names <</JavaScript "+n+" 0 R>>")}),this},(
/**
   * jsPDF Outline PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
c=$.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,h=[];for(r=0;r<s;r++){var c=t.internal.newObject();h.push(c);var l=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+l.objId+" 0 R /XYZ null null null]>> endobj")}var u=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<h.length;r++)t.internal.write("(page_"+(r+1)+")"+h[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+u+" 0 R"),t.internal.write(">>","endobj")}}]),c.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),c.events.push(["initialized",function(){var o=this;o.outline={createNamedDestinations:!1,root:{children:[]}},o.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},o.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=o,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},o.outline.genIds_r=function(t){t.id=o.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},o.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},o.outline.renderItems=function(t){for(var e=0;e<t.children.length;e++){var n=t.children[e];this.objStart(n),this.line("/Title "+this.makeString(n.title)),this.line("/Parent "+this.makeRef(t)),0<e&&this.line("/Prev "+this.makeRef(t.children[e-1])),e<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[e+1])),0<n.children.length&&(this.line("/First "+this.makeRef(n.children[0])),this.line("/Last "+this.makeRef(n.children[n.children.length-1])));var r=this.count=this.count_r({count:0},n);if(0<r&&this.line("/Count "+r),n.options&&n.options.pageNumber){var i=o.internal.getPageInfo(n.options.pageNumber);this.line("/Dest ["+i.objId+" 0 R /XYZ 0 "+this.ctx.pdf.internal.pageSize.getHeight()*this.ctx.pdf.internal.scaleFactor+" 0]")}this.objEnd()}for(e=0;e<t.children.length;e++)n=t.children[e],this.renderItems(n)},o.outline.line=function(t){this.ctx.val+=t+"\r\n"},o.outline.makeRef=function(t){return t.id+" 0 R"},o.outline.makeString=function(t){return"("+o.internal.pdfEscape(t)+")"},o.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},o.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},o.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**@preserve
   *  ====================================================================
   * jsPDF PNG PlugIn
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
P=$.API,E=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},q=function(t,e,n,r){var i=5,o=b;switch(r){case P.image_compression.FAST:i=3,o=v;break;case P.image_compression.MEDIUM:i=6,o=x;break;case P.image_compression.SLOW:i=9,o=S}t=w(t,e,n,o);var a=new Uint8Array(g(i)),s=m(t),h=new Deflater(i),c=h.append(t),l=h.flush(),u=a.length+c.length+l.length,f=new Uint8Array(u+4);return f.set(a),f.set(c,a.length),f.set(l,a.length+c.length),f[u++]=s>>>24&255,f[u++]=s>>>16&255,f[u++]=s>>>8&255,f[u++]=255&s,P.arrayBufferToBinaryString(f)},g=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},m=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},w=function(t,e,n,r){for(var i,o,a,s=t.length/e,h=new Uint8Array(t.length+s),c=k(),l=0;l<s;l++){if(a=l*e,i=t.subarray(a,a+e),r)h.set(r(i,n,o),a+l);else{for(var u=0,f=c.length,d=[];u<f;u++)d[u]=c[u](i,n,o);var p=_(d.concat());h.set(d[p],a+l)}o=i}return h},l=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},v=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},b=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},x=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},S=function(t,e,n){var r,i,o,a,s=[],h=0,c=t.length;for(s[0]=4;h<c;h++)r=t[h-e]||0,i=n&&n[h]||0,o=n&&n[h-e]||0,a=u(r,i,o),s[h+1]=t[h]-a+256&255;return s},u=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},k=function(){return[l,v,b,x,S]},_=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=f(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},f=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},P.processPNG=function(t,e,n,r,i){var o,a,s,h,c,l,u=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,d=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,d=o.bits,u=o.colorSpace,h=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var p,g=(I=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),w=new Uint8Array(g),y=o.pixelBitlength-o.bits,v=0,b=0;v<g;v++){for(x=I[v],p=0;p<y;)m[b++]=x>>>p&255,p+=o.bits;w[v]=x>>>p&255}if(16===o.bits){g=(I=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),w=new Uint8Array(g*(32/o.pixelBitlength));for(var x,S=1<o.colors,k=b=v=0;v<g;)x=I[v++],m[b++]=x>>>0&255,S&&(m[b++]=x>>>16&255,x=I[v++],m[b++]=x>>>0&255),w[k++]=x>>>16&255;d=8}r!==P.image_compression.NONE&&E()?(t=q(m,o.width*o.colors,o.colors,r),l=q(w,o.width,1,r)):(t=m,l=w,f=null)}if(3===o.colorType&&(u=this.color_spaces.INDEXED,c=o.palette,o.transparency.indexed)){var _=o.transparency.indexed,A=0;for(v=0,g=_.length;v<g;++v)A+=_[v];if((A/=255)==g-1&&-1!==_.indexOf(0))s=[_.indexOf(0)];else if(A!==g){var I=o.decodePixels();for(w=new Uint8Array(I.length),v=0,g=I.length;v<g;v++)w[v]=_[I[v]];l=q(w,o.width,1)}}var C=function(t){var e;switch(t){case P.image_compression.FAST:e=11;break;case P.image_compression.MEDIUM:e=13;break;case P.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+C+" /Colors "+h+" /BitsPerComponent "+d+" /Columns "+o.width:"/Colors "+h+" /BitsPerComponent "+d+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(l&&this.isArrayBuffer(l)||this.isArrayBufferView(l))&&(l=this.arrayBufferToBinaryString(l)),this.createImageInfo(t,o.width,o.height,u,d,f,e,n,a,s,c,l,C)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
/**
   * jsPDF gif Support PlugIn
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
A=$.API).processGIF89A=function(t,e,n,r,i){var o=new mt(t),a=o.width,s=o.height,h=[];o.decodeAndBlitFrameRGBA(0,h);var c={data:h,width:a,height:s},l=new yt(100).encode(c,100);return A.processJPEG.call(this,l,e,n,r)},A.processGIF87A=A.processGIF89A,(
/**
   * jsPDF bmp Support PlugIn
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
O=$.API).processBMP=function(t,e,n,r,i){var o=new xt(t,!1),a=o.width,s=o.height,h={data:o.getData(),width:a,height:s},c=new yt(100).encode(h,100);return O.processJPEG.call(this,c,e,n,r)},$.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @preserve
   * jsPDF split_text_to_size plugin - MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   */
B=$.API,R=B.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),h=e.widths?e.widths:o.metadata.Unicode.widths,c=h.fof?h.fof:1,l=e.kerning?e.kerning:o.metadata.Unicode.kerning,u=l.fof?l.fof:1,f=0,d=h[0]||c,p=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?p.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):p.push((h[i]||d)/c+(l[i]&&l[i][f]||0)/u),f=i;return p},j=B.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},D=B.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:j(R.apply(this,arguments))},M=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var h=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(h,o)),s=0,h=o),s+=e[o],o++;return h!==o&&i.push(t.slice(h,o)),i},U=function(t,e,n){n||(n={});var r,i,o,a,s,h,c=[],l=[c],u=n.textIndent||0,f=0,d=0,p=t.split(" "),g=R.apply(this,[" ",n])[0];if(h=-1===n.lineIndent?p[0].length+2:n.lineIndent||0){var m=Array(h).join(" "),w=[];p.map(function(t){1<(t=t.split(/\s*\n/)).length?w=w.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):w.push(t[0])}),p=w,h=D.apply(this,[m,n])}for(o=0,a=p.length;o<a;o++){var y=0;if(r=p[o],h&&"\n"==r[0]&&(r=r.substr(1),y=1),i=R.apply(this,[r,n]),e<u+f+(d=j(i))||y){if(e<d){for(s=M.apply(this,[r,i,e-(u+f),e]),c.push(s.shift()),c=[s.pop()];s.length;)l.push([s.shift()]);d=j(i.slice(r.length-(c[0]?c[0].length:0)))}else c=[r];l.push(c),u=d+h,f=g}else c.push(r),u+=f+d,f=g}if(h)var v=function(t,e){return(e?m:"")+t.join(" ")};else v=function(t){return t.join(" ")};return l.map(v)},B.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,h,c=[];for(s=0,h=r.length;s<h;s++)c=c.concat(U.apply(this,[r[s],a,o]));return c},
/** @preserve 
  jsPDF standard_fonts_metrics plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  MIT license.
  */
N=$.API,L={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(z=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,h,c={},l=1,u=c,f=[],d="",p="",g=t.length-1;for(r=1;r!=g;)h=t[r],r+=1,"'"==h?o?(s=o.join(""),o=i):o=[]:o?o.push(h):"{"==h?(f.push([u,s]),u={},s=i):"}"==h?((a=f.pop())[0][a[1]]=u,s=i,u=a[0]):"-"==h?l=-1:s===i?n.hasOwnProperty(h)?(d+=n[h],s=parseInt(d,16)*l,l=1,d=""):d+=h:n.hasOwnProperty(h)?(p+=n[h],u[s]=parseInt(p,16)*l,l=1,s=i,p=""):p+=h;return c})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},H={Unicode:{Courier:L,"Courier-Bold":L,"Courier-BoldOblique":L,"Courier-Oblique":L,Helvetica:L,"Helvetica-Bold":L,"Helvetica-BoldOblique":L,"Helvetica-Oblique":L,"Times-Roman":L,"Times-Bold":L,"Times-BoldItalic":L,"Times-Italic":L}
/** 
    Resources:
    Font metrics data is reprocessed derivative of contents of
    "Font Metrics for PDF Core 14 Fonts" package, which exhibits the following copyright and license:
    
    Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated. All Rights Reserved.
    
    This file and the 14 PostScript(R) AFM files it accompanies may be used,
    copied, and distributed for any purpose and without charge, with or without
    modification, provided that all copyright notices are retained; that the AFM
    files are not distributed without this file; that all modifications to this
    file or any of the AFM files are prominently noted in the modified file(s);
    and that this paragraph is not modified. Adobe Systems has no responsibility
    or obligation to support the use of the AFM files.
    
    */},W={Unicode:{"Courier-Oblique":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":z("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":z("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:z("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:z("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":z("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":z("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},N.events.push(["addFont",function(t){var e,n,r,i="Unicode";(e=W[i][t.postScriptName])&&((n=t.metadata[i]?t.metadata[i]:t.metadata[i]={}).widths=e.widths,n.kerning=e.kerning),(r=H[i][t.postScriptName])&&((n=t.metadata[i]?t.metadata[i]:t.metadata[i]={}).encoding=r).codePages&&r.codePages.length&&(t.encoding=r.codePages[0])}]),G=$,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),G.API.events.push(["addFont",function(t){G.API.existsFileInVFS(t.postScriptName)?(t.metadata=G.API.TTFFont.open(t.postScriptName,t.fontName,G.API.getFileFromVFS(t.postScriptName),t.encoding),t.metadata.Unicode=t.metadata.Unicode||{encoding:{},kerning:{},widths:[]}):14<t.id.slice(1)&&console.error("Font does not exist in FileInVFS, import fonts or remove declaration doc.addFont('"+t.postScriptName+"').")}]),(
/** @preserve
  jsPDF SVG plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  */
V=$.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,h,c,l,u,f,d,p=(c=document,d=c.createElement("iframe"),l=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(u=c).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=l:f.appendChild(u.createTextNode(l)),u.getElementsByTagName("head")[0].appendChild(f),d.name="childframe",d.setAttribute("width",0),d.setAttribute("height",0),d.setAttribute("frameborder","0"),d.setAttribute("scrolling","no"),d.setAttribute("seamless","seamless"),d.setAttribute("class","jsPDF_sillysvg_iframe"),c.body.appendChild(d),d),g=(a=t,(h=((s=p).contentWindow||s.contentDocument).document).write(a),h.close(),h.getElementsByTagName("svg")[0]),m=[1,1],w=parseFloat(g.getAttribute("width")),y=parseFloat(g.getAttribute("height"));w&&y&&(r&&i?m=[r/w,i/y]:r?m=[r/w,r/w]:i&&(m=[i/y,i/y]));var v,b,x,S,k=g.childNodes;for(v=0,b=k.length;v<b;v++)(x=k[v]).tagName&&"PATH"===x.tagName.toUpperCase()&&((S=o(x.getAttribute("d").split(" ")))[0]=S[0]*m[0]+e,S[1]=S[1]*m[1]+n,this.lines.call(this,S[2],S[0],S[1],m));return this},V.addSVG=V.addSvg,V.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var h=document.createElement("canvas");h.width=r,h.height=i;var c=h.getContext("2d");return c.fillStyle="#fff",c.fillRect(0,0,h.width,h.height),canvg(h,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(h.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},$.API.putTotalPages=function(t){for(var e=new RegExp(t,"g"),n=1;n<=this.internal.getNumberOfPages();n++)for(var r=0;r<this.internal.pages[n].length;r++)this.internal.pages[n][r]=this.internal.pages[n][r].replace(e,this.internal.getNumberOfPages());return this},$.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],h=0,c=0,l=0,u=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var d=a.length;for(l=0;l<d;l+=1)n[a[l]].value=n[a[l]].defaultValue,n[a[l]].explicitSet=!1}if("object"===(void 0===t?"undefined":vt(t)))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(h=0;h<i.length;h+=1)if(u=!0,1===i[h].length&&"number"==typeof i[h][0])s.push(String(i[h]));else if(1<i[h].length){for(c=0;c<i[h].length;c+=1)"number"!=typeof i[h][c]&&(u=!1);!0===u&&s.push(String(i[h].join("-")))}n[r].value=String(s)}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */
Y=$.API,K=J=X="",Y.addMetadata=function(t,e){return J=e||"http://jspdf.default.namespaceuri/",X=t,this.internal.events.subscribe("postPutResources",function(){if(X){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+J+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(X)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;K=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else K=""}),this.internal.events.subscribe("putCatalog",function(){K&&this.internal.write("/Metadata "+K+" 0 R")}),this},function(l,t){var e=l.API,m=[0];e.events.push(["putFont",function(t){!function(t,e,n){if(t.metadata instanceof l.API.TTFFont&&"Identity-H"===t.encoding){for(var r=t.metadata.Unicode.widths,i=t.metadata.subset.encode(m),o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();e("<<"),e("/Length "+o.length),e("/Length1 "+o.length),e(">>"),e("stream"),e(o),e("endstream"),e("endobj");var h=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+s+" 0 R"),e("/FontBBox "+l.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+h+" 0 R"),e("/W "+l.API.PDFObject.convert(r)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject)}]);e.events.push(["putFont",function(t){!function(t,e,n){if(t.metadata instanceof l.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var r=t.metadata.rawData,i="",o=0;o<r.length;o++)i+=String.fromCharCode(r[o]);var a=n();e("<<"),e("/Length "+i.length),e("/Length1 "+i.length),e(">>"),e("stream"),e(i),e("endstream"),e("endobj");var s=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+a+" 0 R"),e("/Flags 96"),e("/FontBBox "+l.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),o=0;o<t.metadata.hmtx.widths.length;o++)t.metadata.hmtx.widths[o]=parseInt(t.metadata.hmtx.widths[o]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/BaseFont/"+t.fontName+"/FontDescriptor "+s+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+l.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject)}]);var c=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},h=s.pdfEscape,c=s.activeFontKey,l=s.fonts,u=(s.activeFontSize,""),f=0,d="",p=l[n=c].encoding;if("Identity-H"!==l[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(d=r,n=c,"[object Array]"===Object.prototype.toString.call(r)&&(d=r[0]),f=0;f<d.length;f+=1)l[n].metadata.hasOwnProperty("cmap")&&(e=l[n].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]),e?u+=d[f]:d[f].charCodeAt(0)<256&&l[n].metadata.hasOwnProperty("Unicode")?u+=d[f]:u+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===p?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(h(u,n)):"Identity-H"===p&&(g=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),m.push(n),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")}(u,l[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var h=0;for(h=0;h<e.length;h+=1)"[object Array]"===Object.prototype.toString.call(e[h])&&3===e[h].length?a.push([c(Object.assign({},s,{text:e[h][0]})).text,e[h][1],e[h][2]]):a.push(c(Object.assign({},s,{text:e[h]})).text);t.text=a}else t.text=c(Object.assign({},s,{text:e})).text}])}($,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),Q=$.API,Z={},Q.existsFileInVFS=function(t){return Z.hasOwnProperty(t)},Q.addFileToVFS=function(t,e){return Z[t]=e,this},Q.getFileFromVFS=function(t){return Z.hasOwnProperty(t)?Z[t]:null},function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return new Blob}catch(t){}var s=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var s=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},e=function(){this.data=[]},h=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},n=e.prototype,r=h.prototype,c=t.FileReaderSync,l=function(t){this.code=this[this.name=t]},i="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),o=i.length,a=t.URL||t.webkitURL||t,u=a.createObjectURL,f=a.revokeObjectURL,d=a,p=t.btoa,g=t.atob,m=t.ArrayBuffer,w=t.Uint8Array,y=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(h.fake=r.fake=!0;o--;)l.prototype[i[o]]=o+1;return a.createObjectURL||(d=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(y),n.origin=e&&e[1])),n}),d.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof h?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):p?e+";base64,"+p(t.data):e+","+encodeURIComponent(t.data)):u?u.call(a,t):void 0},d.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(a,t)},n.append=function(t){var e=this.data;if(w&&(t instanceof m||t instanceof w)){for(var n="",r=new w(t),i=0,o=r.length;i<o;i++)n+=String.fromCharCode(r[i]);e.push(n)}else if("Blob"===s(t)||"File"===s(t)){if(!c)throw new l("NOT_READABLE_ERR");var a=new c;e.push(a.readAsBinaryString(t))}else t instanceof h?"base64"===t.encoding&&g?e.push(g(t.data)):"URI"===t.encoding?e.push(decodeURIComponent(t.data)):"raw"===t.encoding&&e.push(t.data):("string"!=typeof t&&(t+=""),e.push(unescape(encodeURIComponent(t))))},n.getBlob=function(t){return arguments.length||(t=null),new h(this.data.join(""),t,"raw")},n.toString=function(){return"[object BlobBuilder]"},r.slice=function(t,e,n){var r=arguments.length;return r<3&&(n=null),new h(this.data.slice(t,1<r?e:this.data.length),n,this.encoding)},r.toString=function(){return"[object Blob]"},r.close=function(){this.size=0,delete this.data},e}(t);t.Blob=function(t,e){var n=e&&e.type||"",r=new s;if(t)for(var i=0,o=t.length;i<o;i++)Uint8Array&&t[i]instanceof Uint8Array?r.append(t[i].buffer):r.append(t[i]);var a=r.getBlob(n);return!a.slice&&a.webkitSlice&&(a.slice=a.webkitSlice),a};var e=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=e(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||window.content||window);var tt,et,nt,rt,it,ot,at,st,ht,ct,lt,ut,ft,dt,pt,gt,bt=bt||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,h=function(){return s.URL||s.webkitURL||s},c=t.createElementNS("http://www.w3.org/1999/xhtml","a"),l="download"in c,u=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),d=function(t){(s.setImmediate||s.setTimeout)(function(){throw t},0)},p=function(t){setTimeout(function(){"string"==typeof t?h().revokeObjectURL(t):t.remove()},4e4)},g=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=g(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,l)return r=h().createObjectURL(t),void setTimeout(function(){var t,e;c.href=r,c.download=n,t=c,e=new MouseEvent("click"),t.dispatchEvent(e),a(),p(r),i.readyState=i.DONE});!function(){if((f||o&&u)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=h().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),p(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=g(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||window.content);function mt(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var S=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],h=0,c=null,l=0,u=null;for(this.width=S,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,u=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(_=x[t++]))break;t+=_}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];h=x[t++]|x[t++]<<8,c=x[t++],0==(1&f)&&(c=null),l=f>>2&7,t++;break;case 254:for(;;){if(0===(_=x[t++]))break;t+=_}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var d=x[t++]|x[t++]<<8,p=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,w=x[t++],y=w>>6&1,v=o,b=!1;if(w>>7){b=!0;v=t,t+=3*(1<<(7&w)+1)}var k=t;for(t++;;){var _;if(0===(_=x[t++]))break;t+=_}s.push({x:d,y:p,width:g,height:m,has_local_palette:b,palette_offset:v,data_offset:k,data_length:t-k,transparent_index:c,interlaced:!!y,delay:h,disposal:l});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return u},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);wt(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,h=S-s,c=s,l=4*(n.y*S+n.x),u=4*((n.y+n.height)*S+n.x),f=l,d=4*h;!0===n.interlaced&&(d+=4*(s+h)*7);for(var p=8,g=0,m=i.length;g<m;++g){var w=i[g];if(0===c&&(c=s,u<=(f+=d)&&(d=h+4*(s+h)*(p-1),f=l+(s+h)*(p<<1),p>>=1)),w===a)f+=4;else{var y=x[o+3*w],v=x[o+3*w+1],b=x[o+3*w+2];e[f++]=b,e[f++]=v,e[f++]=y,e[f++]=255}--c}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);wt(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,h=S-s,c=s,l=4*(n.y*S+n.x),u=4*((n.y+n.height)*S+n.x),f=l,d=4*h;!0===n.interlaced&&(d+=4*(s+h)*7);for(var p=8,g=0,m=i.length;g<m;++g){var w=i[g];if(0===c&&(c=s,u<=(f+=d)&&(d=h+4*(s+h)*(p-1),f=l+(s+h)*(p<<1),p>>=1)),w===a)f+=4;else{var y=x[o+3*w],v=x[o+3*w+1],b=x[o+3*w+2];e[f++]=y,e[f++]=v,e[f++]=b,e[f++]=255}--c}}}function wt(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,h=i+1,c=(1<<h)-1,l=0,u=0,f=0,d=t[e++],p=new Int32Array(4096),g=null;;){for(;l<16&&0!==d;)u|=t[e++]<<l,l+=8,1===d?d=t[e++]:--d;if(l<h)break;var m=u&c;if(u>>=h,l-=h,m!==o){if(m===a)break;for(var w=m<s?m:g,y=0,v=w;o<v;)v=p[v]>>8,++y;var b=v;if(r<f+y+(w!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=y;for(w!==m&&(n[f++]=b),v=w;y--;)v=p[v],n[--x]=255&v,v>>=8;null!==g&&s<4096&&(p[s++]=g<<8|b,c+1<=s&&h<12&&(++h,c=c<<1|1)),g=m}else s=a+1,c=(1<<(h=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}"undefined"!=typeof module&&module.exports?module.exports.saveAs=bt:"undefined"!=typeof define&&null!==define&&null!==define.amd&&define("FileSaver.js",function(){return bt})
/*
   * Copyright (c) 2012 chick307 <chick307@gmail.com>
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */,$.API.adler32cs=(ot="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,at=null,st=function(){if(!ot)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(at=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==at&&t instanceof at}}(),ht=null!==at?function(t){return new at(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},ct=65521,lt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%ct,r=(r+n)%ct;return(r<<16|n)>>>0},ut=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%ct,r=(r+n)%ct;return(r<<16|n)>>>0},dt=(ft={}).Adler32=(((it=(rt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=rt).from=((tt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=lt(1,t.toString())}).prototype=it,tt),rt.fromUtf8=((et=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());this.checksum=lt(1,e)}).prototype=it,et),ot&&(rt.fromBuffer=((nt=function(t){if(!(this instanceof rt))throw new TypeError("Constructor cannot called be as a function.");if(!st(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=ut(1,e)}).prototype=it,nt)),it.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=lt(this.checksum,t)},it.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());return this.checksum=lt(this.checksum,e)},ot&&(it.updateBuffer=function(t){if(!st(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=ut(this.checksum,e)}),it.clone=function(){return new dt(this.checksum)},rt),ft.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return lt(1,t.toString())},ft.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=ht(t.toString());return lt(1,e)},ot&&(ft.fromBuffer=function(t){if(!st(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return ut(1,e)}),ft);try{exports.GifWriter=function(w,t,e,n){var y=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,v=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}w[y++]=71,w[y++]=73,w[y++]=70,w[y++]=56,w[y++]=57,w[y++]=97;var i=0,o=0;if(null!==v){for(var a=b(v);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(w[y++]=255&t,w[y++]=t>>8&255,w[y++]=255&e,w[y++]=e>>8&255,w[y++]=(null!==v?128:0)|i,w[y++]=o,w[y++]=0,null!==v)for(var s=0,h=v.length;s<h;++s){var c=v[s];w[y++]=c>>16&255,w[y++]=c>>8&255,w[y++]=255&c}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";w[y++]=33,w[y++]=255,w[y++]=11,w[y++]=78,w[y++]=69,w[y++]=84,w[y++]=83,w[y++]=67,w[y++]=65,w[y++]=80,w[y++]=69,w[y++]=50,w[y++]=46,w[y++]=48,w[y++]=3,w[y++]=1,w[y++]=255&r,w[y++]=r>>8&255,w[y++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--y,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=v),null==s)throw"Must supply either a local or global palette.";for(var h=b(s),c=0;h>>=1;)++c;h=1<<c;var l=void 0===o.delay?0:o.delay,u=void 0===o.disposal?0:o.disposal;if(u<0||3<u)throw"Disposal out of range.";var f=!1,d=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(d=o.transparent)<0||h<=d))throw"Transparent color index.";if((0!==u||f||0!==l)&&(w[y++]=33,w[y++]=249,w[y++]=4,w[y++]=u<<2|(!0===f?1:0),w[y++]=255&l,w[y++]=l>>8&255,w[y++]=d,w[y++]=0),w[y++]=44,w[y++]=255&t,w[y++]=t>>8&255,w[y++]=255&e,w[y++]=e>>8&255,w[y++]=255&n,w[y++]=n>>8&255,w[y++]=255&r,w[y++]=r>>8&255,w[y++]=!0===a?128|c-1:0,!0===a)for(var p=0,g=s.length;p<g;++p){var m=s[p];w[y++]=m>>16&255,w[y++]=m>>8&255,w[y++]=255&m}y=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,h=s+1,c=t+1,l=0,u=0;function f(t){for(;t<=l;)e[n++]=255&u,u>>=8,l-=8,n===i+256&&(e[i]=255,i=n++)}function d(t){u|=t<<l,l+=c,f(8)}var p=r[0]&a,g={};d(o);for(var m=1,w=r.length;m<w;++m){var y=r[m]&a,v=p<<8|y,b=g[v];if(void 0===b){for(u|=p<<l,l+=c;8<=l;)e[n++]=255&u,u>>=8,l-=8,n===i+256&&(e[i]=255,i=n++);4096===h?(d(o),h=s+1,c=t+1,g={}):(1<<c<=h&&++c,g[v]=h++),p=y}else p=b}return d(p),d(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(w,y,c<2?2:c,i)},this.end=function(){return!1===x&&(w[y++]=59,x=!0),y}},exports.GifReader=mt}catch(t){}
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */function yt(t){var S,k,_,A,e,u=Math.floor,I=new Array(64),C=new Array(64),T=new Array(64),F=new Array(64),w=new Array(65535),y=new Array(65535),Q=new Array(64),v=new Array(64),P=[],E=0,q=7,O=new Array(64),B=new Array(64),R=new Array(64),n=new Array(256),j=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],D=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],M=[0,1,2,3,4,5,6,7,8,9,10,11],U=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],N=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],z=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],L=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function G(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(E|=1<<q),n--,--q<0&&(255==E?(V(255),V(0)):V(E),q=7,E=0)}function V(t){P.push(t)}function Y(t){V(t>>8&255),V(255&t)}function X(t,e,n,r,i){for(var o,a=i[0],s=i[240],h=function(t,e){var n,r,i,o,a,s,h,c,l,u,f=0;for(l=0;l<8;++l){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],h=t[f+6];var d=n+(c=t[f+7]),p=n-c,g=r+h,m=r-h,w=i+s,y=i-s,v=o+a,b=o-a,x=d+v,S=d-v,k=g+w,_=g-w;t[f]=x+k,t[f+4]=x-k;var A=.707106781*(_+S);t[f+2]=S+A,t[f+6]=S-A;var I=.382683433*((x=b+y)-(_=m+p)),C=.5411961*x+I,T=1.306562965*_+I,F=.707106781*(k=y+m),P=p+F,E=p-F;t[f+5]=E+C,t[f+3]=E-C,t[f+1]=P+T,t[f+7]=P-T,f+=8}for(l=f=0;l<8;++l){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],h=t[f+48];var q=n+(c=t[f+56]),O=n-c,B=r+h,R=r-h,j=i+s,D=i-s,M=o+a,U=o-a,N=q+M,z=q-M,L=B+j,H=B-j;t[f]=N+L,t[f+32]=N-L;var W=.707106781*(H+z);t[f+16]=z+W,t[f+48]=z-W;var G=.382683433*((N=U+D)-(H=R+O)),V=.5411961*N+G,Y=1.306562965*H+G,X=.707106781*(L=D+R),J=O+X,K=O-X;t[f+40]=K+V,t[f+24]=K-V,t[f+8]=J+Y,t[f+56]=J-Y,f++}for(l=0;l<64;++l)u=t[l]*e[l],Q[l]=0<u?u+.5|0:u-.5|0;return Q}(t,e),c=0;c<64;++c)v[b[c]]=h[c];var l=v[0]-n;n=v[0],0==l?G(r[0]):(G(r[y[o=32767+l]]),G(w[o]));for(var u=63;0<u&&0==v[u];u--);if(0==u)return G(a),n;for(var f,d=1;d<=u;){for(var p=d;0==v[d]&&d<=u;++d);var g=d-p;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)G(s);g&=15}o=32767+v[d],G(i[(g<<4)+y[o]]),G(w[o]),d++}return 63!=u&&G(a),n}function J(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=u((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),I[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=u((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),C[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],h=0,c=0;c<8;c++)for(var l=0;l<8;l++)T[h]=1/(I[b[h]]*s[c]*s[l]*8),F[h]=1/(C[b[h]]*s[c]*s[l]*8),h++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&J(e),P=new Array,E=0,q=7,Y(65496),Y(65504),Y(16),V(74),V(70),V(73),V(70),V(0),V(1),V(1),V(0),Y(1),Y(1),V(0),V(0),function(){Y(65499),Y(132),V(0);for(var t=0;t<64;t++)V(I[t]);V(1);for(var e=0;e<64;e++)V(C[e])}(),n=t.width,r=t.height,Y(65472),Y(17),V(8),Y(r),Y(n),V(3),V(1),V(17),V(0),V(2),V(17),V(1),V(3),V(17),V(1),function(){Y(65476),Y(418),V(0);for(var t=0;t<16;t++)V(D[t+1]);for(var e=0;e<=11;e++)V(M[e]);V(16);for(var n=0;n<16;n++)V(U[n+1]);for(var r=0;r<=161;r++)V(N[r]);V(1);for(var i=0;i<16;i++)V(z[i+1]);for(var o=0;o<=11;o++)V(L[o]);V(17);for(var a=0;a<16;a++)V(H[a+1]);for(var s=0;s<=161;s++)V(W[s])}(),Y(65498),Y(12),V(3),V(1),V(0),V(2),V(17),V(3),V(17),V(0),V(63),V(0);var i=0,o=0,a=0;E=0,q=7,this.encode.displayName="_encode_";for(var s,h,c,l,u,f,d,p,g,m=t.data,w=t.width,y=t.height,v=4*w,b=0;b<y;){for(s=0;s<v;){for(f=u=v*b+s,d=-1,g=p=0;g<64;g++)f=u+(p=g>>3)*v+(d=4*(7&g)),y<=b+p&&(f-=v*(b+1+p-y)),v<=s+d&&(f-=s+d-v+4),h=m[f++],c=m[f++],l=m[f++],O[g]=(j[h]+j[c+256>>0]+j[l+512>>0]>>16)-128,B[g]=(j[h+768>>0]+j[c+1024>>0]+j[l+1280>>0]>>16)-128,R[g]=(j[h+1280>>0]+j[c+1536>>0]+j[l+1792>>0]>>16)-128;i=X(O,T,i,S,_),o=X(B,F,o,k,A),a=X(R,F,a,k,A),s+=32}b+=8}if(0<=q){var x=[];x[1]=q+1,x[0]=(1<<q+1)-1,G(x)}return Y(65497),new Uint8Array(P)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),S=r(D,M),k=r(z,L),_=r(U,N),A=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)y[32767+r]=n,w[32767+r]=[],w[32767+r][1]=n,w[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)y[32767+i]=n,w[32767+i]=[],w[32767+i][1]=n,w[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)j[t]=19595*t,j[t+256>>0]=38470*t,j[t+512>>0]=7471*t+32768,j[t+768>>0]=-11059*t,j[t+1024>>0]=-21709*t,j[t+1280>>0]=32768*t+8421375,j[t+1536>>0]=-27439*t,j[t+1792>>0]=-5329*t}(),J(t),(new Date).getTime()}()}try{module.exports=yt}catch(t){}function xt(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}xt.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},xt.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},xt.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var h=this.palette[o>>7-s&1];this.data[a+4*s]=h.blue,this.data[a+4*s+1]=h.green,this.data[a+4*s+2]=h.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},xt.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,h=15&o,c=this.palette[s];if(this.data[a]=c.blue,this.data[a+1]=c.green,this.data[a+2]=c.red,this.data[a+3]=255,2*i+1>=this.width)break;c=this.palette[h],this.data[a+4]=c.blue,this.data[a+4+1]=c.green,this.data[a+4+2]=c.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},xt.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},xt.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,h=(o>>10&e)/e*255|0,c=o>>15?255:0,l=r*this.width*4+4*i;this.data[l]=h,this.data[l+1]=s,this.data[l+2]=a,this.data[l+3]=c}this.pos+=t}},xt.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,h=(a>>5&n)/n*255|0,c=(a>>11)/e*255|0,l=i*this.width*4+4*o;this.data[l]=c,this.data[l+1]=h,this.data[l+2]=s,this.data[l+3]=255}this.pos+=t}},xt.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},xt.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},xt.prototype.getData=function(){return this.data};try{module.exports=function(t){var e=new xt(t);return{data:e.getData(),width:e.width,height:e.height}}}catch(t){}
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
!function(t){var p=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ut(){var d=this;function h(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}d.build_tree=function(t){var e,n,r,i=d.dyn_tree,o=d.stat_desc.static_tree,a=d.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(d.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=d.dyn_tree,h=d.stat_desc.static_tree,c=d.stat_desc.extra_bits,l=d.stat_desc.extra_base,u=d.stat_desc.max_length,f=0;for(i=0;i<=p;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)u<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=u,f++),s[2*n+1]=i,n>d.max_code||(t.bl_count[i]++,o=0,l<=n&&(o=c[n-l]),a=s[2*n],t.opt_len+=a*(i+o),h&&(t.static_len+=a*(h[2*n+1]+o)));if(0!==f){do{for(i=u-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[u]--,f-=2}while(0<f);for(i=u;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>d.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=p;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=h(a[o]++,o))}(i,d.max_code,t.bl_count)}}function ft(t,e,n,r,i){var o=this;o.static_tree=t,o.extra_bits=e,o.extra_base=n,o.elems=r,o.max_length=i}ut._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ut.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ut.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ut.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ut.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ut.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ut.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ut.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ut.extra_lbits,257,286,p),ft.static_d_desc=new ft(ft.static_dtree,ut.extra_dbits,0,30,p),ft.static_bl_desc=new ft(null,ut.extra_blbits,0,19,7);function n(t,e,n,r,i){var o=this;o.good_length=t,o.max_lazy=e,o.nice_length=n,o.max_chain=r,o.func=i}var dt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],pt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],gt=262;function mt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var h,c,l,u,f,d,p,g,i,m,w,y,v,a,b,x,S,k,_,A,I,C,T,F,P,E,q,O,B,R,s,j,D,M,U,N,z,o,L,H,W,G=this,V=new ut,Y=new ut,X=new ut;function J(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)j[2*t]=0;for(t=0;t<19;t++)D[2*t]=0;s[512]=1,G.opt_len=G.static_len=0,N=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,h=4;for(0===o&&(s=138,h=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<h?D[2*r]+=a:0!==r?(r!=i&&D[2*r]++,D[32]++):a<=10?D[34]++:D[36]++,i=r,(a=0)===o?(s=138,h=3):r==o?(s=6,h=3):(s=7,h=4))}function Q(t){G.pending_buf[G.pending++]=t}function Z(t){Q(255&t),Q(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Z(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,h=4;for(0===o&&(s=138,h=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<h)for(;tt(r,D),0!=--a;);else 0!==r?(r!=i&&(tt(r,D),a--),tt(16,D),$(a-3,2)):a<=10?(tt(17,D),$(a-3,3)):(tt(18,D),$(a-11,7));i=r,(a=0)===o?(s=138,h=3):r==o?(s=6,h=3):(s=7,h=4)}}function nt(){16==W?(Z(H),W=H=0):8<=W&&(Q(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(G.pending_buf[z+2*N]=t>>>8&255,G.pending_buf[z+2*N+1]=255&t,G.pending_buf[M+N]=255&e,N++,0===t?s[2*e]++:(o++,t--,s[2*(ut._length_code[e]+256+1)]++,j[2*ut.d_code(t)]++),0==(8191&N)&&2<q){for(n=8*N,r=I-S,i=0;i<30;i++)n+=j[2*i]*(5+ut.extra_dbits[i]);if(n>>>=3,o<Math.floor(N/2)&&n<Math.floor(r/2))return!0}return N==U-1}function it(t,e){var n,r,i,o,a=0;if(0!==N)for(;n=G.pending_buf[z+2*a]<<8&65280|255&G.pending_buf[z+2*a+1],r=255&G.pending_buf[M+a],a++,0===n?tt(r,t):(tt((i=ut._length_code[r])+256+1,t),0!==(o=ut.extra_lbits[i])&&$(r-=ut.base_length[i],o),tt(i=ut.d_code(--n),e),0!==(o=ut.extra_dbits[i])&&$(n-=ut.base_dist[i],o)),a<N;);tt(256,t),L=t[513]}function ot(){8<W?Z(H):0<W&&Q(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),L=8,o&&(Z(i),Z(~i)),G.pending_buf.set(g.subarray(r,r+i),G.pending),G.pending+=i}function e(t,e,n){var r,i,o=0;0<q?(V.build_tree(G),Y.build_tree(G),o=function(){var t;for(K(s,V.max_code),K(j,Y.max_code),X.build_tree(G),t=18;3<=t&&0===D[2*ut.bl_order[t]+1];t--);return G.opt_len+=3*(t+1)+5+5+4,t}(),r=G.opt_len+3+7>>>3,(i=G.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(D[2*ut.bl_order[r]+1],3);et(s,t-1),et(j,e-1)}(V.max_code+1,Y.max_code+1,o+1),it(s,j)),J(),n&&ot()}function st(t){e(0<=S?S:-1,I-S,t),S=I,h.flush_pending()}function ht(){var t,e,n,r;do{if(0===(r=i-T-I)&&0===I&&0===T)r=f;else if(-1==r)r--;else if(f+f-gt<=I){for(g.set(g.subarray(f,f+f),0),C-=f,I-=f,S-=f,n=t=v;e=65535&w[--n],w[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===h.avail_in)return;t=h.read_buf(g,I+T,r),3<=(T+=t)&&(y=((y=255&g[I])<<x^255&g[I+1])&b)}while(T<gt&&0!==h.avail_in)}function ct(t){var e,n,r=P,i=I,o=F,a=f-gt<I?I-(f-gt):0,s=R,h=p,c=I+258,l=g[i+o-1],u=g[i+o];B<=F&&(r>>=2),T<s&&(s=T);do{if(g[(e=t)+o]==u&&g[e+o-1]==l&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<c);if(n=258-(c-i),i=c-258,o<n){if(C=t,s<=(o=n))break;l=g[i+o-1],u=g[i+o]}}}while((t=65535&m[t&h])>a&&0!=--r);return o<=T?o:T}function lt(t){return t.total_in=t.total_out=0,t.msg=null,G.pending=0,G.pending_out=0,c=113,u=0,V.dyn_tree=s,V.stat_desc=ft.static_l_desc,Y.dyn_tree=j,Y.stat_desc=ft.static_d_desc,X.dyn_tree=D,X.stat_desc=ft.static_bl_desc,W=H=0,L=8,J(),function(){var t;for(i=2*f,t=w[v-1]=0;t<v-1;t++)w[t]=0;E=dt[q].max_lazy,B=dt[q].good_length,R=dt[q].nice_length,P=dt[q].max_chain,k=F=2,y=A=T=S=I=0}(),0}G.depth=[],G.bl_count=[],G.heap=[],s=[],j=[],D=[],G.pqdownheap=function(t,e){for(var n=G.heap,r=n[e],i=e<<1;i<=G.heap_len&&(i<G.heap_len&&mt(t,n[i+1],n[i],G.depth)&&i++,!mt(t,r,n[i],G.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},G.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=G,p=(f=1<<(d=n))-1,b=(v=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],w=[],U=1<<i+6,G.pending_buf=new Uint8Array(4*U),l=4*U,z=Math.floor(U/2),M=3*U,q=e,O=o,lt(t))},G.deflateEnd=function(){return 42!=c&&113!=c&&666!=c?-2:(G.pending_buf=null,g=m=w=null,G.dstate=null,113==c?-3:0)},G.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(dt[q].func!=dt[e].func&&0!==t.total_in&&(r=t.deflate(1)),q!=e&&(E=dt[q=e].max_lazy,B=dt[q].good_length,R=dt[q].nice_length,P=dt[q].max_chain),O=n,r)},G.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=c)return-2;if(i<3)return 0;for(f-gt<i&&(o=n-(i=f-gt)),g.set(e.subarray(o,o+i),0),S=I=i,y=((y=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)y=(y<<x^255&g[r+2])&b,m[r&p]=w[y],w[y]=r;return 0},G.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==c&&4!=e)return t.msg=pt[4],-2;if(0===t.avail_out)return t.msg=pt[7],-5;if(h=t,o=u,u=e,42==c&&(r=8+(d-8<<4)<<8,3<(i=(q-1&255)>>1)&&(i=3),r|=i<<6,0!==I&&(r|=32),c=113,Q((s=r+=31-r%31)>>8&255),Q(255&s)),0!==G.pending){if(h.flush_pending(),0===h.avail_out)return u=-1,0}else if(0===h.avail_in&&e<=o&&4!=e)return h.msg=pt[7],-5;if(666==c&&0!==h.avail_in)return t.msg=pt[7],-5;if(0!==h.avail_in||0!==T||0!=e&&666!=c){switch(a=-1,dt[q].func){case 0:a=function(t){var e,n=65535;for(l-5<n&&(n=l-5);;){if(T<=1){if(ht(),0===T&&0==t)return 0;if(0===T)break}if(I+=T,e=S+n,((T=0)===I||e<=I)&&(T=I-e,I=e,st(!1),0===h.avail_out))return 0;if(f-gt<=I-S&&(st(!1),0===h.avail_out))return 0}return st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(T<gt){if(ht(),T<gt&&0==t)return 0;if(0===T)break}if(3<=T&&(y=(y<<x^255&g[I+2])&b,n=65535&w[y],m[I&p]=w[y],w[y]=I),0!==n&&(I-n&65535)<=f-gt&&2!=O&&(k=ct(n)),3<=k)if(e=rt(I-C,k-3),T-=k,k<=E&&3<=T){for(k--;y=(y<<x^255&g[++I+2])&b,n=65535&w[y],m[I&p]=w[y],w[y]=I,0!=--k;);I++}else I+=k,k=0,y=((y=255&g[I])<<x^255&g[I+1])&b;else e=rt(0,255&g[I]),T--,I++;if(e&&(st(!1),0===h.avail_out))return 0}return st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(T<gt){if(ht(),T<gt&&0==t)return 0;if(0===T)break}if(3<=T&&(y=(y<<x^255&g[I+2])&b,r=65535&w[y],m[I&p]=w[y],w[y]=I),F=k,_=C,k=2,0!==r&&F<E&&(I-r&65535)<=f-gt&&(2!=O&&(k=ct(r)),k<=5&&(1==O||3==k&&4096<I-C)&&(k=2)),3<=F&&k<=F){for(n=I+T-3,e=rt(I-1-_,F-3),T-=F-1,F-=2;++I<=n&&(y=(y<<x^255&g[I+2])&b,r=65535&w[y],m[I&p]=w[y],w[y]=I),0!=--F;);if(A=0,k=2,I++,e&&(st(!1),0===h.avail_out))return 0}else if(0!==A){if((e=rt(0,255&g[I-1]))&&st(!1),I++,T--,0===h.avail_out)return 0}else A=1,I++,T--}return 0!==A&&(e=rt(0,255&g[I-1]),A=0),st(4==t),0===h.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(c=666),0==a||2==a)return 0===h.avail_out&&(u=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+L+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),L=7;else if(at(0,0,!1),3==e)for(n=0;n<v;n++)w[n]=0;if(h.flush_pending(),0===h.avail_out)return u=-1,0}}return 4!=e?0:1}}function i(){var t=this;t.next_in_index=0,t.next_out_index=0,t.avail_in=0,t.total_in=0,t.avail_out=0,t.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=p),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this,i=r.avail_in;return n<i&&(i=n),0===i?0:(r.avail_in-=i,t.set(r.next_in.subarray(r.next_in_index,r.next_in_index+i),e),r.next_in_index+=i,r.total_in+=i,i)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,h=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=h,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(h)):r.push(new Uint8Array(h.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(h.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/**
   * A class to parse color values
   * @author Stoyan Stefanov <sstoo@gmail.com>
   * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
   * @license Use it if you like it
   */
function(t){function f(t){var e;this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var l={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var n in l)t==n&&(t=l[n]);for(var u=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],r=0;r<u.length;r++){var i=u[r].re,o=u[r].process,a=i.exec(t);a&&(e=o(a),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n},this.getHelpXML=function(){for(var t=new Array,e=0;e<u.length;e++)for(var n=u[e].example,r=0;r<n.length;r++)t[t.length]=n[r];for(var i in l)t[t.length]=i;var o=document.createElement("ul");o.setAttribute("id","rgbcolor-examples");for(e=0;e<t.length;e++)try{var a=document.createElement("li"),s=new f(t[e]),h=document.createElement("div");h.style.cssText="margin: 3px; border: 1px solid black; background:"+s.toHex()+"; color:"+s.toHex(),h.appendChild(document.createTextNode("test"));var c=document.createTextNode(" "+t[e]+" -> "+s.toRGB()+" -> "+s.toHex());a.appendChild(h),a.appendChild(c),o.appendChild(a)}catch(t){}return o}}"undefined"!=typeof define&&define.amd?define("RGBColor",function(){return f}):"undefined"!=typeof module&&module.exports&&(module.exports=f),t.RGBColor=f}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.html2canvas=t()}}(function(){return function o(a,s,h){function c(n,t){if(!s[n]){if(!a[n]){var e="function"==typeof require&&require;if(!t&&e)return e(n,!0);if(l)return l(n,!0);var r=new Error("Cannot find module '"+n+"'");throw r.code="MODULE_NOT_FOUND",r}var i=s[n]={exports:{}};a[n][0].call(i.exports,function(t){var e=a[n][1][t];return c(e||t)},i,i.exports,o,a,s,h)}return s[n].exports}for(var l="function"==typeof require&&require,t=0;t<h.length;t++)c(h[t]);return c}({1:[function(t,q,O){(function(E){!function(t){var e="object"==typeof O&&O,n="object"==typeof q&&q&&q.exports==e&&q,r="object"==typeof E&&E;r.global!==r&&r.window!==r||(t=r);var i,o,w=2147483647,y=36,v=1,b=26,a=38,s=700,x=72,S=128,k="-",h=/^xn--/,c=/[^ -~]/,l=/\x2E|\u3002|\uFF0E|\uFF61/g,u={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},f=y-v,_=Math.floor,A=String.fromCharCode;function I(t){throw RangeError(u[t])}function d(t,e){for(var n=t.length;n--;)t[n]=e(t[n]);return t}function p(t,e){return d(t.split(l),e).join(".")}function C(t){for(var e,n,r=[],i=0,o=t.length;i<o;)55296<=(e=t.charCodeAt(i++))&&e<=56319&&i<o?56320==(64512&(n=t.charCodeAt(i++)))?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--):r.push(e);return r}function T(t){return d(t,function(t){var e="";return 65535<t&&(e+=A((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=A(t)}).join("")}function F(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function P(t,e,n){var r=0;for(t=n?_(t/s):t>>1,t+=_(t/e);f*b>>1<t;r+=y)t=_(t/f);return _(r+(f+1)*t/(t+a))}function g(t){var e,n,r,i,o,a,s,h,c,l,u,f=[],d=t.length,p=0,g=S,m=x;for((n=t.lastIndexOf(k))<0&&(n=0),r=0;r<n;++r)128<=t.charCodeAt(r)&&I("not-basic"),f.push(t.charCodeAt(r));for(i=0<n?n+1:0;i<d;){for(o=p,a=1,s=y;d<=i&&I("invalid-input"),u=t.charCodeAt(i++),(y<=(h=u-48<10?u-22:u-65<26?u-65:u-97<26?u-97:y)||h>_((w-p)/a))&&I("overflow"),p+=h*a,!(h<(c=s<=m?v:m+b<=s?b:s-m));s+=y)a>_(w/(l=y-c))&&I("overflow"),a*=l;m=P(p-o,e=f.length+1,0==o),_(p/e)>w-g&&I("overflow"),g+=_(p/e),p%=e,f.splice(p++,0,g)}return T(f)}function m(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p,g,m=[];for(f=(t=C(t)).length,e=S,o=x,a=n=0;a<f;++a)(u=t[a])<128&&m.push(A(u));for(r=i=m.length,i&&m.push(k);r<f;){for(s=w,a=0;a<f;++a)e<=(u=t[a])&&u<s&&(s=u);for(s-e>_((w-n)/(d=r+1))&&I("overflow"),n+=(s-e)*d,e=s,a=0;a<f;++a)if((u=t[a])<e&&++n>w&&I("overflow"),u==e){for(h=n,c=y;!(h<(l=c<=o?v:o+b<=c?b:c-o));c+=y)g=h-l,p=y-l,m.push(A(F(l+g%p,0))),h=_(g/p);m.push(A(F(h,0))),o=P(n,d,r==i),n=0,++r}++n,++e}return m.join("")}if(i={version:"1.2.4",ucs2:{decode:C,encode:T},decode:g,encode:m,toASCII:function(t){return p(t,function(t){return c.test(t)?"xn--"+m(t):t})},toUnicode:function(t){return p(t,function(t){return h.test(t)?g(t.slice(4).toLowerCase()):t})}},e&&!e.nodeType)if(n)n.exports=i;else for(o in i)i.hasOwnProperty(o)&&(e[o]=i[o]);else t.punycode=i}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){var i=t("./log");function u(t,e){for(var n=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),r=t.firstChild;r;)!0!==e&&1===r.nodeType&&"SCRIPT"===r.nodeName||n.appendChild(u(r,e)),r=r.nextSibling;return 1===t.nodeType&&(n._scrollTop=t.scrollTop,n._scrollLeft=t.scrollLeft,"CANVAS"===t.nodeName?function(e,t){try{t&&(t.width=e.width,t.height=e.height,t.getContext("2d").putImageData(e.getContext("2d").getImageData(0,0,e.width,e.height),0,0))}catch(t){i("Unable to copy canvas content from",e,t)}}(t,n):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(n.value=t.value)),n}e.exports=function(o,t,e,n,a,s,h){var c=u(o.documentElement,a.javascriptEnabled),l=t.createElement("iframe");return l.className="html2canvas-container",l.style.visibility="hidden",l.style.position="fixed",l.style.left="-10000px",l.style.top="0px",l.style.border="0",l.width=e,l.height=n,l.scrolling="no",t.body.appendChild(l),new Promise(function(e){var t,n,r,i=l.contentWindow.document;l.contentWindow.onload=l.onload=function(){var t=setInterval(function(){0<i.body.childNodes.length&&(!function t(e){if(1===e.nodeType){e.scrollTop=e._scrollTop,e.scrollLeft=e._scrollLeft;for(var n=e.firstChild;n;)t(n),n=n.nextSibling}}(i.documentElement),clearInterval(t),"view"===a.type&&(l.contentWindow.scrollTo(s,h),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||l.contentWindow.scrollY===h&&l.contentWindow.scrollX===s||(i.documentElement.style.top=-h+"px",i.documentElement.style.left=-s+"px",i.documentElement.style.position="absolute")),e(l))},50)},i.open(),i.write("<!DOCTYPE html><html></html>"),n=s,r=h,!(t=o).defaultView||n===t.defaultView.pageXOffset&&r===t.defaultView.pageYOffset||t.defaultView.scrollTo(n,r),i.replaceChild(i.adoptNode(c),i.documentElement),i.close()})}},{"./log":13}],3:[function(t,e,n){function r(t){this.r=0,this.g=0,this.b=0,this.a=null;this.fromArray(t)||this.namedColor(t)||this.rgb(t)||this.rgba(t)||this.hex6(t)||this.hex3(t)}r.prototype.darken=function(t){var e=1-t;return new r([Math.round(this.r*e),Math.round(this.g*e),Math.round(this.b*e),this.a])},r.prototype.isTransparent=function(){return 0===this.a},r.prototype.isBlack=function(){return 0===this.r&&0===this.g&&0===this.b},r.prototype.fromArray=function(t){return Array.isArray(t)&&(this.r=Math.min(t[0],255),this.g=Math.min(t[1],255),this.b=Math.min(t[2],255),3<t.length&&(this.a=t[3])),Array.isArray(t)};var i=/^#([a-f0-9]{3})$/i;r.prototype.hex3=function(t){var e;return null!==(e=t.match(i))&&(this.r=parseInt(e[1][0]+e[1][0],16),this.g=parseInt(e[1][1]+e[1][1],16),this.b=parseInt(e[1][2]+e[1][2],16)),null!==e};var o=/^#([a-f0-9]{6})$/i;r.prototype.hex6=function(t){var e=null;return null!==(e=t.match(o))&&(this.r=parseInt(e[1].substring(0,2),16),this.g=parseInt(e[1].substring(2,4),16),this.b=parseInt(e[1].substring(4,6),16)),null!==e};var a=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;r.prototype.rgb=function(t){var e;return null!==(e=t.match(a))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3])),null!==e};var s=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;r.prototype.rgba=function(t){var e;return null!==(e=t.match(s))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3]),this.a=Number(e[4])),null!==e},r.prototype.toString=function(){return null!==this.a&&1!==this.a?"rgba("+[this.r,this.g,this.b,this.a].join(",")+")":"rgb("+[this.r,this.g,this.b].join(",")+")"},r.prototype.namedColor=function(t){t=t.toLowerCase();var e=h[t];if(e)this.r=e[0],this.g=e[1],this.b=e[2];else if("transparent"===t)return this.r=this.g=this.b=this.a=0,!0;return!!e},r.prototype.isColor=!0;var h={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]};e.exports=r},{}],4:[function(t,e,n){var p=t("./support"),d=t("./renderers/canvas"),g=t("./imageloader"),m=t("./nodeparser"),r=t("./nodecontainer"),w=t("./log"),i=t("./utils"),y=t("./clone"),v=t("./proxy").loadUrlDocument,b=i.getBounds,x="data-html2canvas-node",S=0;function o(t,e){var n,r,i=S++;if((e=e||{}).logging&&(w.options.logging=!0,w.options.start=Date.now()),e.async=void 0===e.async||e.async,e.allowTaint=void 0!==e.allowTaint&&e.allowTaint,e.removeContainer=void 0===e.removeContainer||e.removeContainer,e.javascriptEnabled=void 0!==e.javascriptEnabled&&e.javascriptEnabled,e.imageTimeout=void 0===e.imageTimeout?1e4:e.imageTimeout,e.renderer="function"==typeof e.renderer?e.renderer:d,e.strict=!!e.strict,"string"==typeof t){if("string"!=typeof e.proxy)return Promise.reject("Proxy must be used when rendering url");var o=null!=e.width?e.width:window.innerWidth,a=null!=e.height?e.height:window.innerHeight;return v((n=t,r=document.createElement("a"),r.href=n,r.href=r.href,r),e.proxy,document,o,a,e).then(function(t){return k(t.contentWindow.document.documentElement,t,e,o,a)})}var s,h,c,l,u,f=(void 0===t?[document.documentElement]:t.length?t:[t])[0];return f.setAttribute(x+i,i),(s=f.ownerDocument,h=e,c=f.ownerDocument.defaultView.innerWidth,l=f.ownerDocument.defaultView.innerHeight,u=i,y(s,s,c,l,h,s.defaultView.pageXOffset,s.defaultView.pageYOffset).then(function(t){w("Document cloned");var e=x+u,n="["+e+"='"+u+"']";s.querySelector(n).removeAttribute(e);var r=t.contentWindow,i=r.document.querySelector(n),o="function"==typeof h.onclone?Promise.resolve(h.onclone(r.document)):Promise.resolve(!0);return o.then(function(){return k(i,t,h,c,l)})})).then(function(t){return"function"==typeof e.onrendered&&(w("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"),e.onrendered(t)),t})}o.CanvasRenderer=d,o.NodeContainer=r,o.log=w,o.utils=i;var a="undefined"==typeof document||"function"!=typeof Object.create||"function"!=typeof document.createElement("canvas").getContext?function(){return Promise.reject("No canvas support")}:o;function k(n,r,i,t,e){var o,a,s=r.contentWindow,h=new p(s.document),c=new g(i,h),l=b(n),u="view"===i.type?t:(o=s.document,Math.max(Math.max(o.body.scrollWidth,o.documentElement.scrollWidth),Math.max(o.body.offsetWidth,o.documentElement.offsetWidth),Math.max(o.body.clientWidth,o.documentElement.clientWidth))),f="view"===i.type?e:(a=s.document,Math.max(Math.max(a.body.scrollHeight,a.documentElement.scrollHeight),Math.max(a.body.offsetHeight,a.documentElement.offsetHeight),Math.max(a.body.clientHeight,a.documentElement.clientHeight))),d=new i.renderer(u,f,c,i,document);return new m(n,d,h,c,i).ready.then(function(){var t,e;return w("Finished rendering"),t="view"===i.type?_(d.canvas,{width:d.canvas.width,height:d.canvas.height,top:0,left:0,x:0,y:0}):n===s.document.body||n===s.document.documentElement||null!=i.canvas?d.canvas:_(d.canvas,{width:null!=i.width?i.width:l.width,height:null!=i.height?i.height:l.height,top:l.top,left:l.left,x:0,y:0}),e=r,i.removeContainer&&(e.parentNode.removeChild(e),w("Cleaned up container")),t})}function _(t,e){var n=document.createElement("canvas"),r=Math.min(t.width-1,Math.max(0,e.left)),i=Math.min(t.width,Math.max(1,e.left+e.width)),o=Math.min(t.height-1,Math.max(0,e.top)),a=Math.min(t.height,Math.max(1,e.top+e.height));n.width=e.width,n.height=e.height;var s=i-r,h=a-o;return w("Cropping canvas at:","left:",e.left,"top:",e.top,"width:",s,"height:",h),w("Resulting crop with width",e.width,"and height",e.height,"with x",r,"and y",o),n.getContext("2d").drawImage(t,r,o,s,h,e.x,e.y,s,h),n}e.exports=a},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(t,e,n){var r=t("./log"),i=t("./utils").smallImage;e.exports=function t(e){if(this.src=e,r("DummyImageContainer for",e),!this.promise||!this.image){r("Initiating DummyImageContainer"),t.prototype.image=new Image;var n=this.image;t.prototype.promise=new Promise(function(t,e){n.onload=t,n.onerror=e,n.src=i(),!0===n.complete&&t(n)})}}},{"./log":13,"./utils":26}],6:[function(t,e,n){var h=t("./utils").smallImage;e.exports=function(t,e){var n,r,i=document.createElement("div"),o=document.createElement("img"),a=document.createElement("span"),s="Hidden Text";i.style.visibility="hidden",i.style.fontFamily=t,i.style.fontSize=e,i.style.margin=0,i.style.padding=0,document.body.appendChild(i),o.src=h(),o.width=1,o.height=1,o.style.margin=0,o.style.padding=0,o.style.verticalAlign="baseline",a.style.fontFamily=t,a.style.fontSize=e,a.style.margin=0,a.style.padding=0,a.appendChild(document.createTextNode(s)),i.appendChild(a),i.appendChild(o),n=o.offsetTop-a.offsetTop+1,i.removeChild(a),i.appendChild(document.createTextNode(s)),i.style.lineHeight="normal",o.style.verticalAlign="super",r=o.offsetTop-i.offsetTop+1,document.body.removeChild(i),this.baseline=n,this.lineWidth=1,this.middle=r}},{"./utils":26}],7:[function(t,e,n){var r=t("./font");function i(){this.data={}}i.prototype.getMetrics=function(t,e){return void 0===this.data[t+"-"+e]&&(this.data[t+"-"+e]=new r(t,e)),this.data[t+"-"+e]},e.exports=i},{"./font":6}],8:[function(o,t,e){var a=o("./utils").getBounds,i=o("./proxy").loadUrlDocument;function n(e,t,n){this.image=null,this.src=e;var r=this,i=a(e);this.promise=(t?new Promise(function(t){"about:blank"===e.contentWindow.document.URL||null==e.contentWindow.document.documentElement?e.contentWindow.onload=e.onload=function(){t(e)}:t(e)}):this.proxyLoad(n.proxy,i,n)).then(function(t){return o("./core")(t.contentWindow.document.documentElement,{type:"view",width:t.width,height:t.height,proxy:n.proxy,javascriptEnabled:n.javascriptEnabled,removeContainer:n.removeContainer,allowTaint:n.allowTaint,imageTimeout:n.imageTimeout/2})}).then(function(t){return r.image=t})}n.prototype.proxyLoad=function(t,e,n){var r=this.src;return i(r.src,t,r.ownerDocument,e.width,e.height,n)},t.exports=n},{"./core":4,"./proxy":16,"./utils":26}],9:[function(t,e,n){function r(t){this.src=t.value,this.colorStops=[],this.type=null,this.x0=.5,this.y0=.5,this.x1=.5,this.y1=.5,this.promise=Promise.resolve(!0)}r.TYPES={LINEAR:1,RADIAL:2},r.REGEXP_COLORSTOP=/^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i,e.exports=r},{}],10:[function(t,e,n){e.exports=function(n,r){this.src=n,this.image=new Image;var i=this;this.tainted=null,this.promise=new Promise(function(t,e){i.image.onload=t,i.image.onerror=e,r&&(i.image.crossOrigin="anonymous"),i.image.src=n,!0===i.image.complete&&t(i.image)})}},{}],11:[function(t,e,n){var o=t("./log"),r=t("./imagecontainer"),i=t("./dummyimagecontainer"),a=t("./proxyimagecontainer"),s=t("./framecontainer"),h=t("./svgcontainer"),c=t("./svgnodecontainer"),l=t("./lineargradientcontainer"),u=t("./webkitgradientcontainer"),f=t("./utils").bind;function d(t,e){this.link=null,this.options=t,this.support=e,this.origin=this.getOrigin(window.location.href)}d.prototype.findImages=function(t){var e=[];return t.reduce(function(t,e){switch(e.node.nodeName){case"IMG":return t.concat([{args:[e.node.src],method:"url"}]);case"svg":case"IFRAME":return t.concat([{args:[e.node],method:e.node.nodeName}])}return t},[]).forEach(this.addImage(e,this.loadImage),this),e},d.prototype.findBackgroundImage=function(t,e){return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t,this.loadImage),this),t},d.prototype.addImage=function(n,r){return function(e){e.args.forEach(function(t){this.imageExists(n,t)||(n.splice(0,0,r.call(this,e)),o("Added image #"+n.length,"string"==typeof t?t.substring(0,100):t))},this)}},d.prototype.hasImageBackground=function(t){return"none"!==t.method},d.prototype.loadImage=function(t){if("url"===t.method){var e=t.args[0];return!this.isSVG(e)||this.support.svg||this.options.allowTaint?e.match(/data:image\/.*;base64,/i)?new r(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi,""),!1):this.isSameOrigin(e)||!0===this.options.allowTaint||this.isSVG(e)?new r(e,!1):this.support.cors&&!this.options.allowTaint&&this.options.useCORS?new r(e,!0):this.options.proxy?new a(e,this.options.proxy):new i(e):new h(e)}return"linear-gradient"===t.method?new l(t):"gradient"===t.method?new u(t):"svg"===t.method?new c(t.args[0],this.support.svg):"IFRAME"===t.method?new s(t.args[0],this.isSameOrigin(t.args[0].src),this.options):new i(t)},d.prototype.isSVG=function(t){return"svg"===t.substring(t.length-3).toLowerCase()||h.prototype.isInline(t)},d.prototype.imageExists=function(t,e){return t.some(function(t){return t.src===e})},d.prototype.isSameOrigin=function(t){return this.getOrigin(t)===this.origin},d.prototype.getOrigin=function(t){var e=this.link||(this.link=document.createElement("a"));return e.href=t,e.href=e.href,e.protocol+e.hostname+e.port},d.prototype.getPromise=function(e){return this.timeout(e,this.options.imageTimeout).catch(function(){return new i(e.src).promise.then(function(t){e.image=t})})},d.prototype.get=function(e){var n=null;return this.images.some(function(t){return(n=t).src===e})?n:null},d.prototype.fetch=function(t){return this.images=t.reduce(f(this.findBackgroundImage,this),this.findImages(t)),this.images.forEach(function(e,n){e.promise.then(function(){o("Succesfully loaded image #"+(n+1),e)},function(t){o("Failed loading image #"+(n+1),e,t)})}),this.ready=Promise.all(this.images.map(this.getPromise,this)),o("Finished searching images"),this},d.prototype.timeout=function(n,r){var i,t=Promise.race([n.promise,new Promise(function(t,e){i=setTimeout(function(){o("Timed out loading image",n),e(n)},r)})]).then(function(t){return clearTimeout(i),t});return t.catch(function(){clearTimeout(i)}),t},e.exports=d},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(t,e,n){var i=t("./gradientcontainer"),o=t("./color");function r(t){i.apply(this,arguments),this.type=i.TYPES.LINEAR;var e=r.REGEXP_DIRECTION.test(t.args[0])||!i.REGEXP_COLORSTOP.test(t.args[0]);e?t.args[0].split(/\s+/).reverse().forEach(function(t,e){switch(t){case"left":this.x0=0,this.x1=1;break;case"top":this.y0=0,this.y1=1;break;case"right":this.x0=1,this.x1=0;break;case"bottom":this.y0=1,this.y1=0;break;case"to":var n=this.y0,r=this.x0;this.y0=this.y1,this.x0=this.x1,this.x1=r,this.y1=n;break;case"center":break;default:var i=.01*parseFloat(t,10);if(isNaN(i))break;0===e?(this.y0=i,this.y1=1-this.y0):(this.x0=i,this.x1=1-this.x0)}},this):(this.y0=0,this.y1=1),this.colorStops=t.args.slice(e?1:0).map(function(t){var e=t.match(i.REGEXP_COLORSTOP),n=+e[2],r=0===n?"%":e[3];return{color:new o(e[1]),stop:"%"===r?n/100:null}}),null===this.colorStops[0].stop&&(this.colorStops[0].stop=0),null===this.colorStops[this.colorStops.length-1].stop&&(this.colorStops[this.colorStops.length-1].stop=1),this.colorStops.forEach(function(n,r){null===n.stop&&this.colorStops.slice(r).some(function(t,e){return null!==t.stop&&(n.stop=(t.stop-this.colorStops[r-1].stop)/(e+1)+this.colorStops[r-1].stop,!0)},this)},this)}r.prototype=Object.create(i.prototype),r.REGEXP_DIRECTION=/^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i,e.exports=r},{"./color":3,"./gradientcontainer":9}],13:[function(t,e,n){var r=function(){r.options.logging&&window.console&&window.console.log&&Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-r.options.start+"ms","html2canvas:"].concat([].slice.call(arguments,0)))};r.options={logging:!1},e.exports=r},{}],14:[function(t,e,n){var o=t("./color"),r=t("./utils"),i=r.getBounds,a=r.parseBackgrounds,s=r.offsetBounds;function h(t,e){this.node=t,this.parent=e,this.stack=null,this.bounds=null,this.borders=null,this.clip=[],this.backgroundClip=[],this.offsetBounds=null,this.visible=null,this.computedStyles=null,this.colors={},this.styles={},this.backgroundImages=null,this.transformData=null,this.transformMatrix=null,this.isPseudoElement=!1,this.opacity=null}function c(t){return-1!==t.toString().indexOf("%")}function l(t){return t.replace("px","")}function u(t){return parseFloat(t)}h.prototype.cloneTo=function(t){t.visible=this.visible,t.borders=this.borders,t.bounds=this.bounds,t.clip=this.clip,t.backgroundClip=this.backgroundClip,t.computedStyles=this.computedStyles,t.styles=this.styles,t.backgroundImages=this.backgroundImages,t.opacity=this.opacity},h.prototype.getOpacity=function(){return null===this.opacity?this.opacity=this.cssFloat("opacity"):this.opacity},h.prototype.assignStack=function(t){(this.stack=t).children.push(this)},h.prototype.isElementVisible=function(){return this.node.nodeType===Node.TEXT_NODE?this.parent.visible:"none"!==this.css("display")&&"hidden"!==this.css("visibility")&&!this.node.hasAttribute("data-html2canvas-ignore")&&("INPUT"!==this.node.nodeName||"hidden"!==this.node.getAttribute("type"))},h.prototype.css=function(t){return this.computedStyles||(this.computedStyles=this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null)),this.styles[t]||(this.styles[t]=this.computedStyles[t])},h.prototype.prefixedCss=function(e){var n=this.css(e);return void 0===n&&["webkit","moz","ms","o"].some(function(t){return void 0!==(n=this.css(t+e.substr(0,1).toUpperCase()+e.substr(1)))},this),void 0===n?null:n},h.prototype.computedStyle=function(t){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,t)},h.prototype.cssInt=function(t){var e=parseInt(this.css(t),10);return isNaN(e)?0:e},h.prototype.color=function(t){return this.colors[t]||(this.colors[t]=new o(this.css(t)))},h.prototype.cssFloat=function(t){var e=parseFloat(this.css(t));return isNaN(e)?0:e},h.prototype.fontWeight=function(){var t=this.css("fontWeight");switch(parseInt(t,10)){case 401:t="bold";break;case 400:t="normal"}return t},h.prototype.parseClip=function(){var t=this.css("clip").match(this.CLIP);return t?{top:parseInt(t[1],10),right:parseInt(t[2],10),bottom:parseInt(t[3],10),left:parseInt(t[4],10)}:null},h.prototype.parseBackgroundImages=function(){return this.backgroundImages||(this.backgroundImages=a(this.css("backgroundImage")))},h.prototype.cssList=function(t,e){var n=(this.css(t)||"").split(",");return 1===(n=(n=n[e||0]||n[0]||"auto").trim().split(" ")).length&&(n=[n[0],c(n[0])?"auto":n[0]]),n},h.prototype.parseBackgroundSize=function(t,e,n){var r,i,o=this.cssList("backgroundSize",n);if(c(o[0]))r=t.width*parseFloat(o[0])/100;else{if(/contain|cover/.test(o[0])){var a=t.width/t.height,s=e.width/e.height;return a<s^"contain"===o[0]?{width:t.height*s,height:t.height}:{width:t.width,height:t.width/s}}r=parseInt(o[0],10)}return i="auto"===o[0]&&"auto"===o[1]?e.height:"auto"===o[1]?r/e.width*e.height:c(o[1])?t.height*parseFloat(o[1])/100:parseInt(o[1],10),"auto"===o[0]&&(r=i/e.height*e.width),{width:r,height:i}},h.prototype.parseBackgroundPosition=function(t,e,n,r){var i,o,a=this.cssList("backgroundPosition",n);return i=c(a[0])?(t.width-(r||e).width)*(parseFloat(a[0])/100):parseInt(a[0],10),o="auto"===a[1]?i/e.width*e.height:c(a[1])?(t.height-(r||e).height)*parseFloat(a[1])/100:parseInt(a[1],10),"auto"===a[0]&&(i=o/e.height*e.width),{left:i,top:o}},h.prototype.parseBackgroundRepeat=function(t){return this.cssList("backgroundRepeat",t)[0]},h.prototype.parseTextShadows=function(){var t=this.css("textShadow"),e=[];if(t&&"none"!==t)for(var n=t.match(this.TEXT_SHADOW_PROPERTY),r=0;n&&r<n.length;r++){var i=n[r].match(this.TEXT_SHADOW_VALUES);e.push({color:new o(i[0]),offsetX:i[1]?parseFloat(i[1].replace("px","")):0,offsetY:i[2]?parseFloat(i[2].replace("px","")):0,blur:i[3]?i[3].replace("px",""):0})}return e},h.prototype.parseTransform=function(){if(!this.transformData)if(this.hasTransform()){var t=this.parseBounds(),e=this.prefixedCss("transformOrigin").split(" ").map(l).map(u);e[0]+=t.left,e[1]+=t.top,this.transformData={origin:e,matrix:this.parseTransformMatrix()}}else this.transformData={origin:[0,0],matrix:[1,0,0,1,0,0]};return this.transformData},h.prototype.parseTransformMatrix=function(){if(!this.transformMatrix){var t=this.prefixedCss("transform"),e=t?function(t){{if(t&&"matrix"===t[1])return t[2].split(",").map(function(t){return parseFloat(t.trim())});if(t&&"matrix3d"===t[1]){var e=t[2].split(",").map(function(t){return parseFloat(t.trim())});return[e[0],e[1],e[4],e[5],e[12],e[13]]}}}(t.match(this.MATRIX_PROPERTY)):null;this.transformMatrix=e||[1,0,0,1,0,0]}return this.transformMatrix},h.prototype.parseBounds=function(){return this.bounds||(this.bounds=this.hasTransform()?s(this.node):i(this.node))},h.prototype.hasTransform=function(){return"1,0,0,1,0,0"!==this.parseTransformMatrix().join(",")||this.parent&&this.parent.hasTransform()},h.prototype.getValue=function(){var t,e,n=this.node.value||"";return"SELECT"===this.node.tagName?(t=this.node,n=(e=t.options[t.selectedIndex||0])&&e.text||""):"password"===this.node.type&&(n=Array(n.length+1).join("•")),0===n.length?this.node.placeholder||"":n},h.prototype.MATRIX_PROPERTY=/(matrix|matrix3d)\((.+)\)/,h.prototype.TEXT_SHADOW_PROPERTY=/((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g,h.prototype.TEXT_SHADOW_VALUES=/(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g,h.prototype.CLIP=/^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/,e.exports=h},{"./color":3,"./utils":26}],15:[function(t,e,n){var s=t("./log"),h=t("punycode"),c=t("./nodecontainer"),f=t("./textcontainer"),d=t("./pseudoelementcontainer"),l=t("./fontmetrics"),u=t("./color"),p=t("./stackingcontext"),r=t("./utils"),g=r.bind,a=r.getBounds,m=r.parseBackgrounds,w=r.offsetBounds;function i(t,e,n,r,i){s("Starting NodeParser"),this.renderer=e,this.options=i,this.range=null,this.support=n,this.renderQueue=[],this.stack=new p(!0,1,t.ownerDocument,null);var o=new c(t,null);if(i.background&&e.rectangle(0,0,e.width,e.height,new u(i.background)),t===t.ownerDocument.documentElement){var a=new c(o.color("backgroundColor").isTransparent()?t.ownerDocument.body:t.ownerDocument.documentElement,null);e.rectangle(0,0,e.width,e.height,a.color("backgroundColor"))}o.visibile=o.isElementVisible(),this.createPseudoHideStyles(t.ownerDocument),this.disableAnimations(t.ownerDocument),this.nodes=L([o].concat(this.getChildren(o)).filter(function(t){return t.visible=t.isElementVisible()}).map(this.getPseudoElements,this)),this.fontMetrics=new l,s("Fetched nodes, total:",this.nodes.length),s("Calculate overflow clips"),this.calculateOverflowClips(),s("Start fetching images"),this.images=r.fetch(this.nodes.filter(j)),this.ready=this.images.ready.then(g(function(){return s("Images loaded, starting parsing"),s("Creating stacking contexts"),this.createStackingContexts(),s("Sorting stacking contexts"),this.sortStackingContexts(this.stack),this.parse(this.stack),s("Render queue created with "+this.renderQueue.length+" items"),new Promise(g(function(t){i.async?"function"==typeof i.async?i.async.call(this,this.renderQueue,t):0<this.renderQueue.length?(this.renderIndex=0,this.asyncRenderer(this.renderQueue,t)):t():(this.renderQueue.forEach(this.paint,this),t())},this))},this))}function o(t){return t.parent&&t.parent.clip.length}function y(){}i.prototype.calculateOverflowClips=function(){this.nodes.forEach(function(t){if(j(t)){D(t)&&t.appendToDOM(),t.borders=this.parseBorders(t);var e="hidden"===t.css("overflow")?[t.borders.clip]:[],n=t.parseClip();n&&-1!==["absolute","fixed"].indexOf(t.css("position"))&&e.push([["rect",t.bounds.left+n.left,t.bounds.top+n.top,n.right-n.left,n.bottom-n.top]]),t.clip=o(t)?t.parent.clip.concat(e):e,t.backgroundClip="hidden"!==t.css("overflow")?t.clip.concat([t.borders.clip]):t.clip,D(t)&&t.cleanDOM()}else M(t)&&(t.clip=o(t)?t.parent.clip:[]);D(t)||(t.bounds=null)},this)},i.prototype.asyncRenderer=function(t,e,n){n=n||Date.now(),this.paint(t[this.renderIndex++]),t.length===this.renderIndex?e():n+20>Date.now()?this.asyncRenderer(t,e,n):setTimeout(g(function(){this.asyncRenderer(t,e)},this),0)},i.prototype.createPseudoHideStyles=function(t){this.createStyles(t,"."+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+':before { content: "" !important; display: none !important; }.'+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER+':after { content: "" !important; display: none !important; }')},i.prototype.disableAnimations=function(t){this.createStyles(t,"* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}")},i.prototype.createStyles=function(t,e){var n=t.createElement("style");n.innerHTML=e,t.body.appendChild(n)},i.prototype.getPseudoElements=function(t){var e=[[t]];if(t.node.nodeType===Node.ELEMENT_NODE){var n=this.getPseudoElement(t,":before"),r=this.getPseudoElement(t,":after");n&&e.push(n),r&&e.push(r)}return L(e)},i.prototype.getPseudoElement=function(t,e){var n=t.computedStyle(e);if(!n||!n.content||"none"===n.content||"-moz-alt-content"===n.content||"none"===n.display)return null;for(var r,i,o=(r=n.content,(i=r.substr(0,1))===r.substr(r.length-1)&&i.match(/'|"/)?r.substr(1,r.length-2):r),a="url"===o.substr(0,3),s=document.createElement(a?"img":"html2canvaspseudoelement"),h=new d(s,t,e),c=n.length-1;0<=c;c--){var l=n.item(c).replace(/(\-[a-z])/g,function(t){return t.toUpperCase().replace("-","")});s.style[l]=n[l]}if(s.className=d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+" "+d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER,a)return s.src=m(o)[0].args[0],[h];var u=document.createTextNode(o);return s.appendChild(u),[h,new f(u,h)]},i.prototype.getChildren=function(n){return L([].filter.call(n.node.childNodes,q).map(function(t){var e=[t.nodeType===Node.TEXT_NODE?new f(t,n):new c(t,n)].filter(z);return t.nodeType===Node.ELEMENT_NODE&&e.length&&"TEXTAREA"!==t.tagName?e[0].isElementVisible()?e.concat(this.getChildren(e[0])):[]:e},this))},i.prototype.newStackingContext=function(t,e){var n=new p(e,t.getOpacity(),t.node,t.parent);t.cloneTo(n),(e?n.getParentStack(this):n.parent.stack).contexts.push(n),t.stack=n},i.prototype.createStackingContexts=function(){this.nodes.forEach(function(t){var e,n;j(t)&&(this.isRootElement(t)||t.getOpacity()<1||(n=(e=t).css("position"),"auto"!==(-1!==["absolute","relative","fixed"].indexOf(n)?e.css("zIndex"):"auto"))||this.isBodyWithTransparentRoot(t)||t.hasTransform())?this.newStackingContext(t,!0):j(t)&&(O(t)&&T(t)||-1!==["inline-block","inline-table"].indexOf(t.css("display"))||B(t))?this.newStackingContext(t,!1):t.assignStack(t.parent.stack)},this)},i.prototype.isBodyWithTransparentRoot=function(t){return"BODY"===t.node.nodeName&&t.parent.color("backgroundColor").isTransparent()},i.prototype.isRootElement=function(t){return null===t.parent},i.prototype.sortStackingContexts=function(t){var n;t.contexts.sort((n=t.contexts.slice(0),function(t,e){return t.cssInt("zIndex")+n.indexOf(t)/n.length-(e.cssInt("zIndex")+n.indexOf(e)/n.length)})),t.contexts.forEach(this.sortStackingContexts,this)},i.prototype.parseTextBounds=function(a){return function(t,e,n){if("none"!==a.parent.css("textDecoration").substr(0,4)||0!==t.trim().length){if(this.support.rangeBounds&&!a.parent.hasTransform()){var r=n.slice(0,e).join("").length;return this.getRangeBounds(a.node,r,t.length)}if(a.node&&"string"==typeof a.node.data){var i=a.node.splitText(t.length),o=this.getWrapperBounds(a.node,a.parent.hasTransform());return a.node=i,o}}else this.support.rangeBounds&&!a.parent.hasTransform()||(a.node=a.node.splitText(t.length));return{}}},i.prototype.getWrapperBounds=function(t,e){var n=t.ownerDocument.createElement("html2canvaswrapper"),r=t.parentNode,i=t.cloneNode(!0);n.appendChild(t.cloneNode(!0)),r.replaceChild(n,t);var o=e?w(n):a(n);return r.replaceChild(i,n),o},i.prototype.getRangeBounds=function(t,e,n){var r=this.range||(this.range=t.ownerDocument.createRange());return r.setStart(t,e),r.setEnd(t,e+n),r.getBoundingClientRect()},i.prototype.parse=function(t){var e=t.contexts.filter(I),n=t.children.filter(j),r=n.filter(R(B)),i=r.filter(R(O)).filter(R(F)),o=n.filter(R(O)).filter(B),a=r.filter(R(O)).filter(F),s=t.contexts.concat(r.filter(O)).filter(T),h=t.children.filter(M).filter(E),c=t.contexts.filter(C);e.concat(i).concat(o).concat(a).concat(s).concat(h).concat(c).forEach(function(t){this.renderQueue.push(t),P(t)&&(this.parse(t),this.renderQueue.push(new y))},this)},i.prototype.paint=function(t){try{t instanceof y?this.renderer.ctx.restore():M(t)?(D(t.parent)&&t.parent.appendToDOM(),this.paintText(t),D(t.parent)&&t.parent.cleanDOM()):this.paintNode(t)}catch(t){if(s(t),this.options.strict)throw t}},i.prototype.paintNode=function(t){P(t)&&(this.renderer.setOpacity(t.opacity),this.renderer.ctx.save(),t.hasTransform()&&this.renderer.setTransform(t.parseTransform())),"INPUT"===t.node.nodeName&&"checkbox"===t.node.type?this.paintCheckbox(t):"INPUT"===t.node.nodeName&&"radio"===t.node.type?this.paintRadio(t):this.paintElement(t)},i.prototype.paintElement=function(n){var r=n.parseBounds();this.renderer.clip(n.backgroundClip,function(){this.renderer.renderBackground(n,r,n.borders.borders.map(N))},this),this.renderer.clip(n.clip,function(){this.renderer.renderBorders(n.borders.borders)},this),this.renderer.clip(n.backgroundClip,function(){switch(n.node.nodeName){case"svg":case"IFRAME":var t=this.images.get(n.node);t?this.renderer.renderImage(n,r,n.borders,t):s("Error loading <"+n.node.nodeName+">",n.node);break;case"IMG":var e=this.images.get(n.node.src);e?this.renderer.renderImage(n,r,n.borders,e):s("Error loading <img>",n.node.src);break;case"CANVAS":this.renderer.renderImage(n,r,n.borders,{image:n.node});break;case"SELECT":case"INPUT":case"TEXTAREA":this.paintFormValue(n)}},this)},i.prototype.paintCheckbox=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height),r={width:n-1,height:n-1,top:e.top,left:e.left},i=[3,3],o=[i,i,i,i],a=[1,1,1,1].map(function(t){return{color:new u("#A5A5A5"),width:t}}),s=S(r,o,a);this.renderer.clip(t.backgroundClip,function(){this.renderer.rectangle(r.left+1,r.top+1,r.width-2,r.height-2,new u("#DEDEDE")),this.renderer.renderBorders(b(a,r,s,o)),t.node.checked&&(this.renderer.font(new u("#424242"),"normal","normal","bold",n-3+"px","arial"),this.renderer.text("✔",r.left+n/6,r.top+n-1))},this)},i.prototype.paintRadio=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height)-2;this.renderer.clip(t.backgroundClip,function(){this.renderer.circleStroke(e.left+1,e.top+1,n,new u("#DEDEDE"),1,new u("#A5A5A5")),t.node.checked&&this.renderer.circle(Math.ceil(e.left+n/4)+1,Math.ceil(e.top+n/4)+1,Math.floor(n/2),new u("#424242"))},this)},i.prototype.paintFormValue=function(e){var t=e.getValue();if(0<t.length){var n=e.node.ownerDocument,r=n.createElement("html2canvaswrapper");["lineHeight","textAlign","fontFamily","fontWeight","fontSize","color","paddingLeft","paddingTop","paddingRight","paddingBottom","width","height","borderLeftStyle","borderTopStyle","borderLeftWidth","borderTopWidth","boxSizing","whiteSpace","wordWrap"].forEach(function(t){try{r.style[t]=e.css(t)}catch(t){s("html2canvas: Parse: Exception caught in renderFormValue: "+t.message)}});var i=e.parseBounds();r.style.position="fixed",r.style.left=i.left+"px",r.style.top=i.top+"px",r.textContent=t,n.body.appendChild(r),this.paintText(new f(r.firstChild,e)),n.body.removeChild(r)}},i.prototype.paintText=function(n){n.applyTextTransform();var t,e=h.ucs2.decode(n.node.data),r=this.options.letterRendering&&!/^(normal|none|0px)$/.test(n.parent.css("letterSpacing"))||(t=n.node.data,/[^\u0000-\u00ff]/.test(t))?e.map(function(t){return h.ucs2.encode([t])}):function(t){var e,n=[],r=0,i=!1;for(;t.length;)o=t[r],-1!==[32,13,10,9,45].indexOf(o)===i?((e=t.splice(0,r)).length&&n.push(h.ucs2.encode(e)),i=!i,r=0):r++,r>=t.length&&(e=t.splice(0,r)).length&&n.push(h.ucs2.encode(e));var o;return n}(e),i=n.parent.fontWeight(),o=n.parent.css("fontSize"),a=n.parent.css("fontFamily"),s=n.parent.parseTextShadows();this.renderer.font(n.parent.color("color"),n.parent.css("fontStyle"),n.parent.css("fontVariant"),i,o,a),s.length?this.renderer.fontShadow(s[0].color,s[0].offsetX,s[0].offsetY,s[0].blur):this.renderer.clearShadow(),this.renderer.clip(n.parent.clip,function(){r.map(this.parseTextBounds(n),this).forEach(function(t,e){t&&!1===/^\s*$/.test(r[e])&&(this.renderer.text(r[e],t.left,t.bottom),this.renderTextDecoration(n.parent,t,this.fontMetrics.getMetrics(a,o)))},this)},this)},i.prototype.renderTextDecoration=function(t,e,n){switch(t.css("textDecoration").split(" ")[0]){case"underline":this.renderer.rectangle(e.left,Math.round(e.top+n.baseline+n.lineWidth),e.width,1,t.color("color"));break;case"overline":this.renderer.rectangle(e.left,Math.round(e.top),e.width,1,t.color("color"));break;case"line-through":this.renderer.rectangle(e.left,Math.ceil(e.top+n.middle+n.lineWidth),e.width,1,t.color("color"))}};var v={inset:[["darken",.6],["darken",.1],["darken",.1],["darken",.6]]};function b(a,s,h,c){return a.map(function(t,e){if(0<t.width){var n=s.left,r=s.top,i=s.width,o=s.height-a[2].width;switch(e){case 0:o=a[0].width,t.args=_({c1:[n,r],c2:[n+i,r],c3:[n+i-a[1].width,r+o],c4:[n+a[3].width,r+o]},c[0],c[1],h.topLeftOuter,h.topLeftInner,h.topRightOuter,h.topRightInner);break;case 1:n=s.left+s.width-a[1].width,i=a[1].width,t.args=_({c1:[n+i,r],c2:[n+i,r+o+a[2].width],c3:[n,r+o],c4:[n,r+a[0].width]},c[1],c[2],h.topRightOuter,h.topRightInner,h.bottomRightOuter,h.bottomRightInner);break;case 2:r=r+s.height-a[2].width,o=a[2].width,t.args=_({c1:[n+i,r+o],c2:[n,r+o],c3:[n+a[3].width,r],c4:[n+i-a[3].width,r]},c[2],c[3],h.bottomRightOuter,h.bottomRightInner,h.bottomLeftOuter,h.bottomLeftInner);break;case 3:i=a[3].width,t.args=_({c1:[n,r+o+a[2].width],c2:[n,r],c3:[n+i,r+a[0].width],c4:[n+i,r+o]},c[3],c[0],h.bottomLeftOuter,h.bottomLeftInner,h.topLeftOuter,h.topLeftInner)}}return t})}function x(t,e,n,r){var i=(Math.sqrt(2)-1)/3*4,o=n*i,a=r*i,s=t+n,h=e+r;return{topLeft:k({x:t,y:h},{x:t,y:h-a},{x:s-o,y:e},{x:s,y:e}),topRight:k({x:t,y:e},{x:t+o,y:e},{x:s,y:h-a},{x:s,y:h}),bottomRight:k({x:s,y:e},{x:s,y:e+a},{x:t+o,y:h},{x:t,y:h}),bottomLeft:k({x:s,y:h},{x:s-o,y:h},{x:t,y:e+a},{x:t,y:e})}}function S(t,e,n){var r=t.left,i=t.top,o=t.width,a=t.height,s=e[0][0]<o/2?e[0][0]:o/2,h=e[0][1]<a/2?e[0][1]:a/2,c=e[1][0]<o/2?e[1][0]:o/2,l=e[1][1]<a/2?e[1][1]:a/2,u=e[2][0]<o/2?e[2][0]:o/2,f=e[2][1]<a/2?e[2][1]:a/2,d=e[3][0]<o/2?e[3][0]:o/2,p=e[3][1]<a/2?e[3][1]:a/2,g=o-c,m=a-f,w=o-u,y=a-p;return{topLeftOuter:x(r,i,s,h).topLeft.subdivide(.5),topLeftInner:x(r+n[3].width,i+n[0].width,Math.max(0,s-n[3].width),Math.max(0,h-n[0].width)).topLeft.subdivide(.5),topRightOuter:x(r+g,i,c,l).topRight.subdivide(.5),topRightInner:x(r+Math.min(g,o+n[3].width),i+n[0].width,g>o+n[3].width?0:c-n[3].width,l-n[0].width).topRight.subdivide(.5),bottomRightOuter:x(r+w,i+m,u,f).bottomRight.subdivide(.5),bottomRightInner:x(r+Math.min(w,o-n[3].width),i+Math.min(m,a+n[0].width),Math.max(0,u-n[1].width),f-n[2].width).bottomRight.subdivide(.5),bottomLeftOuter:x(r,i+y,d,p).bottomLeft.subdivide(.5),bottomLeftInner:x(r+n[3].width,i+y,Math.max(0,d-n[3].width),p-n[2].width).bottomLeft.subdivide(.5)}}function k(s,h,c,l){var u=function(t,e,n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}};return{start:s,startControl:h,endControl:c,end:l,subdivide:function(t){var e=u(s,h,t),n=u(h,c,t),r=u(c,l,t),i=u(e,n,t),o=u(n,r,t),a=u(i,o,t);return[k(s,e,i,a),k(a,o,r,l)]},curveTo:function(t){t.push(["bezierCurve",h.x,h.y,c.x,c.y,l.x,l.y])},curveToReversed:function(t){t.push(["bezierCurve",c.x,c.y,h.x,h.y,s.x,s.y])}}}function _(t,e,n,r,i,o,a){var s=[];return 0<e[0]||0<e[1]?(s.push(["line",r[1].start.x,r[1].start.y]),r[1].curveTo(s)):s.push(["line",t.c1[0],t.c1[1]]),0<n[0]||0<n[1]?(s.push(["line",o[0].start.x,o[0].start.y]),o[0].curveTo(s),s.push(["line",a[0].end.x,a[0].end.y]),a[0].curveToReversed(s)):(s.push(["line",t.c2[0],t.c2[1]]),s.push(["line",t.c3[0],t.c3[1]])),0<e[0]||0<e[1]?(s.push(["line",i[1].end.x,i[1].end.y]),i[1].curveToReversed(s)):s.push(["line",t.c4[0],t.c4[1]]),s}function A(t,e,n,r,i,o,a){0<e[0]||0<e[1]?(t.push(["line",r[0].start.x,r[0].start.y]),r[0].curveTo(t),r[1].curveTo(t)):t.push(["line",o,a]),(0<n[0]||0<n[1])&&t.push(["line",i[0].start.x,i[0].start.y])}function I(t){return t.cssInt("zIndex")<0}function C(t){return 0<t.cssInt("zIndex")}function T(t){return 0===t.cssInt("zIndex")}function F(t){return-1!==["inline","inline-block","inline-table"].indexOf(t.css("display"))}function P(t){return t instanceof p}function E(t){return 0<t.node.data.trim().length}function q(t){return t.nodeType===Node.TEXT_NODE||t.nodeType===Node.ELEMENT_NODE}function O(t){return"static"!==t.css("position")}function B(t){return"none"!==t.css("float")}function R(t){var e=this;return function(){return!t.apply(e,arguments)}}function j(t){return t.node.nodeType===Node.ELEMENT_NODE}function D(t){return!0===t.isPseudoElement}function M(t){return t.node.nodeType===Node.TEXT_NODE}function U(t){return parseInt(t,10)}function N(t){return t.width}function z(t){return t.node.nodeType!==Node.ELEMENT_NODE||-1===["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(t.node.nodeName)}function L(t){return[].concat.apply([],t)}i.prototype.parseBorders=function(o){var r,t=o.parseBounds(),e=(r=o,["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(t){var e=r.css("border"+t+"Radius"),n=e.split(" ");return n.length<=1&&(n[1]=n[0]),n.map(U)})),n=["Top","Right","Bottom","Left"].map(function(t,e){var n=o.css("border"+t+"Style"),r=o.color("border"+t+"Color");"inset"===n&&r.isBlack()&&(r=new u([255,255,255,r.a]));var i=v[n]?v[n][e]:null;return{width:o.cssInt("border"+t+"Width"),color:i?r[i[0]](i[1]):r,args:null}}),i=S(t,e,n);return{clip:this.parseBackgroundClip(o,i,n,e,t),borders:b(n,t,i,e)}},i.prototype.parseBackgroundClip=function(t,e,n,r,i){var o=[];switch(t.css("backgroundClip")){case"content-box":case"padding-box":A(o,r[0],r[1],e.topLeftInner,e.topRightInner,i.left+n[3].width,i.top+n[0].width),A(o,r[1],r[2],e.topRightInner,e.bottomRightInner,i.left+i.width-n[1].width,i.top+n[0].width),A(o,r[2],r[3],e.bottomRightInner,e.bottomLeftInner,i.left+i.width-n[1].width,i.top+i.height-n[2].width),A(o,r[3],r[0],e.bottomLeftInner,e.topLeftInner,i.left+n[3].width,i.top+i.height-n[2].width);break;default:A(o,r[0],r[1],e.topLeftOuter,e.topRightOuter,i.left,i.top),A(o,r[1],r[2],e.topRightOuter,e.bottomRightOuter,i.left+i.width,i.top),A(o,r[2],r[3],e.bottomRightOuter,e.bottomLeftOuter,i.left+i.width,i.top+i.height),A(o,r[3],r[0],e.bottomLeftOuter,e.topLeftOuter,i.left,i.top+i.height)}return o},e.exports=i},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,punycode:1}],16:[function(t,e,n){var a=t("./xhr"),r=t("./utils"),s=t("./log"),h=t("./clone"),c=r.decode64;function l(t,e,n){var r="withCredentials"in new XMLHttpRequest;if(!e)return Promise.reject("No proxy configured");var i=f(r),o=d(e,t,i);return r?a(o):u(n,o,i).then(function(t){return c(t.content)})}var i=0;function u(i,o,a){return new Promise(function(e,n){var t=i.createElement("script"),r=function(){delete window.html2canvas.proxy[a],i.body.removeChild(t)};window.html2canvas.proxy[a]=function(t){r(),e(t)},t.src=o,t.onerror=function(t){r(),n(t)},i.body.appendChild(t)})}function f(t){return t?"":"html2canvas_"+Date.now()+"_"+ ++i+"_"+Math.round(1e5*Math.random())}function d(t,e,n){return t+"?url="+encodeURIComponent(e)+(n.length?"&callback=html2canvas.proxy."+n:"")}n.Proxy=l,n.ProxyURL=function(t,e,n){var r="crossOrigin"in new Image,i=f(r),o=d(e,t,i);return r?Promise.resolve(o):u(n,o,i).then(function(t){return"data:"+t.type+";base64,"+t.content})},n.loadUrlDocument=function(t,e,n,r,i,o){return new l(t,e,window.document).then((a=t,function(e){var n,t=new DOMParser;try{n=t.parseFromString(e,"text/html")}catch(t){s("DOMParser not supported, falling back to createHTMLDocument"),n=document.implementation.createHTMLDocument("");try{n.open(),n.write(e),n.close()}catch(t){s("createHTMLDocument write not supported, falling back to document.body.innerHTML"),n.body.innerHTML=e}}var r=n.querySelector("base");if(!r||!r.href.host){var i=n.createElement("base");i.href=a,n.head.insertBefore(i,n.head.firstChild)}return n})).then(function(t){return h(t,n,r,i,o,0,0)});var a}},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(t,e,n){var o=t("./proxy").ProxyURL;e.exports=function(n,r){var t=document.createElement("a");t.href=n,n=t.href,this.src=n,this.image=new Image;var i=this;this.promise=new Promise(function(t,e){i.image.crossOrigin="Anonymous",i.image.onload=t,i.image.onerror=e,new o(n,r,document).then(function(t){i.image.src=t}).catch(e)})}},{"./proxy":16}],18:[function(t,e,n){var r=t("./nodecontainer");function i(t,e,n){r.call(this,t,e),this.isPseudoElement=!0,this.before=":before"===n}i.prototype.cloneTo=function(t){i.prototype.cloneTo.call(this,t),t.isPseudoElement=!0,t.before=this.before},(i.prototype=Object.create(r.prototype)).appendToDOM=function(){this.before?this.parent.node.insertBefore(this.node,this.parent.node.firstChild):this.parent.node.appendChild(this.node),this.parent.node.className+=" "+this.getHideClass()},i.prototype.cleanDOM=function(){this.node.parentNode.removeChild(this.node),this.parent.node.className=this.parent.node.className.replace(this.getHideClass(),"")},i.prototype.getHideClass=function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_"+(this.before?"BEFORE":"AFTER")]},i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE="___html2canvas___pseudoelement_before",i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER="___html2canvas___pseudoelement_after",e.exports=i},{"./nodecontainer":14}],19:[function(t,e,n){var h=t("./log");function r(t,e,n,r,i){this.width=t,this.height=e,this.images=n,this.options=r,this.document=i}r.prototype.renderImage=function(t,e,n,r){var i=t.cssInt("paddingLeft"),o=t.cssInt("paddingTop"),a=t.cssInt("paddingRight"),s=t.cssInt("paddingBottom"),h=n.borders,c=e.width-(h[1].width+h[3].width+i+a),l=e.height-(h[0].width+h[2].width+o+s);this.drawImage(r,0,0,r.image.width||c,r.image.height||l,e.left+i+h[3].width,e.top+o+h[0].width,c,l)},r.prototype.renderBackground=function(t,e,n){0<e.height&&0<e.width&&(this.renderBackgroundColor(t,e),this.renderBackgroundImage(t,e,n))},r.prototype.renderBackgroundColor=function(t,e){var n=t.color("backgroundColor");n.isTransparent()||this.rectangle(e.left,e.top,e.width,e.height,n)},r.prototype.renderBorders=function(t){t.forEach(this.renderBorder,this)},r.prototype.renderBorder=function(t){t.color.isTransparent()||null===t.args||this.drawShape(t.args,t.color)},r.prototype.renderBackgroundImage=function(o,a,s){o.parseBackgroundImages().reverse().forEach(function(t,e,n){switch(t.method){case"url":var r=this.images.get(t.args[0]);r?this.renderBackgroundRepeating(o,a,r,n.length-(e+1),s):h("Error loading background-image",t.args[0]);break;case"linear-gradient":case"gradient":var i=this.images.get(t.value);i?this.renderBackgroundGradient(i,a,s):h("Error loading background-image",t.args[0]);break;case"none":break;default:h("Unknown background-image type",t.args[0])}},this)},r.prototype.renderBackgroundRepeating=function(t,e,n,r,i){var o=t.parseBackgroundSize(e,n.image,r),a=t.parseBackgroundPosition(e,n.image,r,o);switch(t.parseBackgroundRepeat(r)){case"repeat-x":case"repeat no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+i[3],e.top+a.top+i[0],99999,o.height,i);break;case"repeat-y":case"no-repeat repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+i[0],o.width,99999,i);break;case"no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+a.top+i[0],o.width,o.height,i);break;default:this.renderBackgroundRepeat(n,a,o,{top:e.top,left:e.left},i[3],i[0])}},e.exports=r},{"./log":13}],20:[function(t,e,n){var r=t("../renderer"),i=t("../lineargradientcontainer"),o=t("../log");function a(t,e){r.apply(this,arguments),this.canvas=this.options.canvas||this.document.createElement("canvas"),this.options.canvas||(this.canvas.width=t,this.canvas.height=e),this.ctx=this.canvas.getContext("2d"),this.taintCtx=this.document.createElement("canvas").getContext("2d"),this.ctx.textBaseline="bottom",this.variables={},o("Initialized CanvasRenderer with size",t,"x",e)}function s(t){return 0<t.length}(a.prototype=Object.create(r.prototype)).setFillStyle=function(t){return this.ctx.fillStyle="object"==typeof t&&t.isColor?t.toString():t,this.ctx},a.prototype.rectangle=function(t,e,n,r,i){this.setFillStyle(i).fillRect(t,e,n,r)},a.prototype.circle=function(t,e,n,r){this.setFillStyle(r),this.ctx.beginPath(),this.ctx.arc(t+n/2,e+n/2,n/2,0,2*Math.PI,!0),this.ctx.closePath(),this.ctx.fill()},a.prototype.circleStroke=function(t,e,n,r,i,o){this.circle(t,e,n,r),this.ctx.strokeStyle=o.toString(),this.ctx.stroke()},a.prototype.drawShape=function(t,e){this.shape(t),this.setFillStyle(e).fill()},a.prototype.taints=function(e){if(null===e.tainted){this.taintCtx.drawImage(e.image,0,0);try{this.taintCtx.getImageData(0,0,1,1),e.tainted=!1}catch(t){this.taintCtx=document.createElement("canvas").getContext("2d"),e.tainted=!0}}return e.tainted},a.prototype.drawImage=function(t,e,n,r,i,o,a,s,h){this.taints(t)&&!this.options.allowTaint||this.ctx.drawImage(t.image,e,n,r,i,o,a,s,h)},a.prototype.clip=function(t,e,n){this.ctx.save(),t.filter(s).forEach(function(t){this.shape(t).clip()},this),e.call(n),this.ctx.restore()},a.prototype.shape=function(t){return this.ctx.beginPath(),t.forEach(function(t,e){"rect"===t[0]?this.ctx.rect.apply(this.ctx,t.slice(1)):this.ctx[0===e?"moveTo":t[0]+"To"].apply(this.ctx,t.slice(1))},this),this.ctx.closePath(),this.ctx},a.prototype.font=function(t,e,n,r,i,o){this.setFillStyle(t).font=[e,n,r,i,o].join(" ").split(",")[0]},a.prototype.fontShadow=function(t,e,n,r){this.setVariable("shadowColor",t.toString()).setVariable("shadowOffsetY",e).setVariable("shadowOffsetX",n).setVariable("shadowBlur",r)},a.prototype.clearShadow=function(){this.setVariable("shadowColor","rgba(0,0,0,0)")},a.prototype.setOpacity=function(t){this.ctx.globalAlpha=t},a.prototype.setTransform=function(t){this.ctx.translate(t.origin[0],t.origin[1]),this.ctx.transform.apply(this.ctx,t.matrix),this.ctx.translate(-t.origin[0],-t.origin[1])},a.prototype.setVariable=function(t,e){return this.variables[t]!==e&&(this.variables[t]=this.ctx[t]=e),this},a.prototype.text=function(t,e,n){this.ctx.fillText(t,e,n)},a.prototype.backgroundRepeatShape=function(t,e,n,r,i,o,a,s,h){var c=[["line",Math.round(i),Math.round(o)],["line",Math.round(i+a),Math.round(o)],["line",Math.round(i+a),Math.round(s+o)],["line",Math.round(i),Math.round(s+o)]];this.clip([c],function(){this.renderBackgroundRepeat(t,e,n,r,h[3],h[0])},this)},a.prototype.renderBackgroundRepeat=function(t,e,n,r,i,o){var a=Math.round(r.left+e.left+i),s=Math.round(r.top+e.top+o);this.setFillStyle(this.ctx.createPattern(this.resizeImage(t,n),"repeat")),this.ctx.translate(a,s),this.ctx.fill(),this.ctx.translate(-a,-s)},a.prototype.renderBackgroundGradient=function(t,e){if(t instanceof i){var n=this.ctx.createLinearGradient(e.left+e.width*t.x0,e.top+e.height*t.y0,e.left+e.width*t.x1,e.top+e.height*t.y1);t.colorStops.forEach(function(t){n.addColorStop(t.stop,t.color.toString())}),this.rectangle(e.left,e.top,e.width,e.height,n)}},a.prototype.resizeImage=function(t,e){var n=t.image;if(n.width===e.width&&n.height===e.height)return n;var r=document.createElement("canvas");return r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(n,0,0,n.width,n.height,0,0,e.width,e.height),r},e.exports=a},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(t,e,n){var i=t("./nodecontainer");function r(t,e,n,r){i.call(this,n,r),this.ownStacking=t,this.contexts=[],this.children=[],this.opacity=(this.parent?this.parent.stack.opacity:1)*e}(r.prototype=Object.create(i.prototype)).getParentStack=function(t){var e=this.parent?this.parent.stack:null;return e?e.ownStacking?e:e.getParentStack(t):t.stack},e.exports=r},{"./nodecontainer":14}],22:[function(t,e,n){function r(t){this.rangeBounds=this.testRangeBounds(t),this.cors=this.testCORS(),this.svg=this.testSVG()}r.prototype.testRangeBounds=function(t){var e,n,r=!1;return t.createRange&&(e=t.createRange()).getBoundingClientRect&&((n=t.createElement("boundtest")).style.height="123px",n.style.display="block",t.body.appendChild(n),e.selectNode(n),123===e.getBoundingClientRect().height&&(r=!0),t.body.removeChild(n)),r},r.prototype.testCORS=function(){return void 0!==(new Image).crossOrigin},r.prototype.testSVG=function(){var t=new Image,e=document.createElement("canvas"),n=e.getContext("2d");t.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{n.drawImage(t,0,0),e.toDataURL()}catch(t){return!1}return!0},e.exports=r},{}],23:[function(t,e,n){var r=t("./xhr"),i=t("./utils").decode64;function o(t){this.src=t,this.image=null;var n=this;this.promise=this.hasFabric().then(function(){return n.isInline(t)?Promise.resolve(n.inlineFormatting(t)):r(t)}).then(function(e){return new Promise(function(t){window.html2canvas.svg.fabric.loadSVGFromString(e,n.createCanvas.call(n,t))})})}o.prototype.hasFabric=function(){return window.html2canvas.svg&&window.html2canvas.svg.fabric?Promise.resolve():Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"))},o.prototype.inlineFormatting=function(t){return/^data:image\/svg\+xml;base64,/.test(t)?this.decode64(this.removeContentType(t)):this.removeContentType(t)},o.prototype.removeContentType=function(t){return t.replace(/^data:image\/svg\+xml(;base64)?,/,"")},o.prototype.isInline=function(t){return/^data:image\/svg\+xml/i.test(t)},o.prototype.createCanvas=function(r){var i=this;return function(t,e){var n=new window.html2canvas.svg.fabric.StaticCanvas("c");i.image=n.lowerCanvasEl,n.setWidth(e.width).setHeight(e.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(t,e)).renderAll(),r(n.lowerCanvasEl)}},o.prototype.decode64=function(t){return"function"==typeof window.atob?window.atob(t):i(t)},e.exports=o},{"./utils":26,"./xhr":28}],24:[function(t,e,n){var r=t("./svgcontainer");function i(n,t){this.src=n,this.image=null;var r=this;this.promise=t?new Promise(function(t,e){r.image=new Image,r.image.onload=t,r.image.onerror=e,r.image.src="data:image/svg+xml,"+(new XMLSerializer).serializeToString(n),!0===r.image.complete&&t(r.image)}):this.hasFabric().then(function(){return new Promise(function(t){window.html2canvas.svg.fabric.parseSVGDocument(n,r.createCanvas.call(r,t))})})}i.prototype=Object.create(r.prototype),e.exports=i},{"./svgcontainer":23}],25:[function(t,e,n){var r=t("./nodecontainer");function i(t,e){r.call(this,t,e)}function o(t,e,n){if(0<t.length)return e+n.toUpperCase()}(i.prototype=Object.create(r.prototype)).applyTextTransform=function(){this.node.data=this.transform(this.parent.css("textTransform"))},i.prototype.transform=function(t){var e=this.node.data;switch(t){case"lowercase":return e.toLowerCase();case"capitalize":return e.replace(/(^|\s|:|-|\(|\))([a-z])/g,o);case"uppercase":return e.toUpperCase();default:return e}},e.exports=i},{"./nodecontainer":14}],26:[function(t,e,n){n.smallImage=function(){return"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},n.bind=function(t,e){return function(){return t.apply(e,arguments)}},
/*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */
n.decode64=function(t){var e,n,r,i,o,a,s,h="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",c=t.length,l="";for(e=0;e<c;e+=4)o=h.indexOf(t[e])<<2|(n=h.indexOf(t[e+1]))>>4,a=(15&n)<<4|(r=h.indexOf(t[e+2]))>>2,s=(3&r)<<6|(i=h.indexOf(t[e+3])),l+=64===r?String.fromCharCode(o):64===i||-1===i?String.fromCharCode(o,a):String.fromCharCode(o,a,s);return l},n.getBounds=function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=null==t.offsetWidth?e.width:t.offsetWidth;return{top:e.top,bottom:e.bottom||e.top+e.height,right:e.left+n,left:e.left,width:n,height:null==t.offsetHeight?e.height:t.offsetHeight}}return{}},n.offsetBounds=function(t){var e=t.offsetParent?n.offsetBounds(t.offsetParent):{top:0,left:0};return{top:t.offsetTop+e.top,bottom:t.offsetTop+t.offsetHeight+e.top,right:t.offsetLeft+e.left+t.offsetWidth,left:t.offsetLeft+e.left,width:t.offsetWidth,height:t.offsetHeight}},n.parseBackgrounds=function(t){var e,n,r,i,o,a,s,h=[],c=0,l=0,u=function(){e&&('"'===n.substr(0,1)&&(n=n.substr(1,n.length-2)),n&&s.push(n),"-"===e.substr(0,1)&&0<(i=e.indexOf("-",1)+1)&&(r=e.substr(0,i),e=e.substr(i)),h.push({prefix:r,method:e.toLowerCase(),value:o,args:s,image:null})),s=[],e=r=n=o=""};return s=[],e=r=n=o="",t.split("").forEach(function(t){if(!(0===c&&-1<" \r\n\t".indexOf(t))){switch(t){case'"':a?a===t&&(a=null):a=t;break;case"(":if(a)break;if(0===c)return c=1,void(o+=t);l++;break;case")":if(a)break;if(1===c){if(0===l)return c=0,o+=t,void u();l--}break;case",":if(a)break;if(0===c)return void u();if(1===c&&0===l&&!e.match(/^url$/i))return s.push(n),n="",void(o+=t)}o+=t,0===c?e+=t:n+=t}}),u(),h}},{}],27:[function(t,e,n){var r=t("./gradientcontainer");function i(t){r.apply(this,arguments),this.type="linear"===t.args[0]?r.TYPES.LINEAR:r.TYPES.RADIAL}i.prototype=Object.create(r.prototype),e.exports=i},{"./gradientcontainer":9}],28:[function(t,e,n){e.exports=function(r){return new Promise(function(t,e){var n=new XMLHttpRequest;n.open("GET",r),n.onload=function(){200===n.status?t(n.responseText):e(new Error(n.statusText))},n.onerror=function(){e(new Error("Network Error"))},n.send()})}},{}]},{},[4])(4)}),function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),h="_".charCodeAt(0),l=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===h?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new X(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new T(this),this.registerTTF()}return i.open=function(t,e,n,r){return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var h=0;function c(t){a[h++]=t}for(n=e=0;e<r;e+=4,n+=3)c((16711680&(i=l(t.charAt(e))<<18|l(t.charAt(e+1))<<12|l(t.charAt(e+2))<<6|l(t.charAt(e+3))))>>16),c((65280&i)>>8),c(255&i);return 2===o?c(255&(i=l(t.charAt(e))<<2|l(t.charAt(e+1))>>4)):1===o&&(c((i=l(t.charAt(e))<<10|l(t.charAt(e+1))<<4|l(t.charAt(e+2))>>2)>>8&255),c(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new d(this),this.name=new b(this),this.cmap=new m(this),this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new S(this),this.post=new y(this),this.os2=new w(this),this.loca=new C(this),this.glyf=new _(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var c,X=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var p;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d;for(d in u=Object.keys(t).length,a=Math.log(2),c=16*Math.floor(Math.log(u)/a),i=Math.floor(c/a),h=16*u-c,(n=new X).writeInt(this.scalarType),n.writeShort(u),n.writeShort(c),n.writeShort(i),n.writeShort(h),r=16*u,s=n.pos+r,o=null,f=[],t)for(l=t[d],n.writeString(d),n.writeInt(p(l)),n.writeInt(s),n.writeInt(l.length),f=f.concat(l),"head"===d&&(o=s),s+=l.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-p(n.data),n.pos=o+8,n.writeUInt32(e),n.data},p=function(t){var e,n,r,i;for(t=k.call(t);t.length%4;)t.push(0);for(n=new X(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),u={}.hasOwnProperty,f=function(t,e){for(var n in e)u.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};c=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var d=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e}(),p=function(){function t(n,t){var e,r,i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),l=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),u=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,p=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),c=function(){var t,e;for(e=[],s=t=0;0<=u?t<u:u<t;s=0<=u?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=w=0,v=i.length;w<v;s=++w)for(g=i[s],e=y=d=p[s];d<=g?y<=g:g<=y;e=d<=g?++y:--y)0===c[s]?o=e+h[s]:0!==(o=a[c[s]/2+(e-d)-(u-s)]||0)&&(o+=h[s]),this.codeMap[e]=65535&o}n.pos=l}return t.encode=function(t,e){var n,r,i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v,b,x,S,k,_,A,I,C,T,F,P,E,q,O,B,R,j,D,M,U,N,z,L,H,W,G,V,Y;switch(F=new X,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(p=0,g=function(){var t,e;for(e=[],d=t=0;t<256;d=++t)e.push(0);return e}(),w={0:0},i={},P=0,B=o.length;P<B;P++)null==w[W=t[r=o[P]]]&&(w[W]=++p),i[r]={old:t[r],new:w[t[r]]},g[r]=w[t[r]];return F.writeUInt16(1),F.writeUInt16(0),F.writeUInt32(12),F.writeUInt16(0),F.writeUInt16(262),F.writeUInt16(0),F.write(g),{charMap:i,subtable:F.data,maxGlyphID:p+1};case"unicode":for(C=[],l=[],w={},n={},m=h=null,E=y=0,R=o.length;E<R;E++)null==w[b=t[r=o[E]]]&&(w[b]=++y),n[r]={old:b,new:w[b]},a=w[b]-r,null!=m&&a===h||(m&&l.push(m),C.push(r),h=a),m=r;for(m&&l.push(m),l.push(65535),C.push(65535),A=2*(_=C.length),k=2*Math.pow(Math.log(_)/Math.LN2,2),u=Math.log(k/2)/Math.LN2,S=2*_-k,s=[],x=[],f=[],d=q=0,j=C.length;q<j;d=++q){if(I=C[d],c=l[d],65535===I){s.push(0),x.push(0);break}if(32768<=I-(T=n[I].new))for(s.push(0),x.push(2*(f.length+_-d)),r=O=I;I<=c?O<=c:c<=O;r=I<=c?++O:--O)f.push(n[r].new);else s.push(T-I),x.push(0)}for(F.writeUInt16(3),F.writeUInt16(1),F.writeUInt32(12),F.writeUInt16(4),F.writeUInt16(16+8*_+2*f.length),F.writeUInt16(0),F.writeUInt16(A),F.writeUInt16(k),F.writeUInt16(u),F.writeUInt16(S),L=0,D=l.length;L<D;L++)r=l[L],F.writeUInt16(r);for(F.writeUInt16(0),H=0,M=C.length;H<M;H++)r=C[H],F.writeUInt16(r);for(G=0,U=s.length;G<U;G++)a=s[G],F.writeUInt16(a);for(V=0,N=x.length;V<N;V++)v=x[V],F.writeUInt16(v);for(Y=0,z=f.length;Y<z;Y++)p=f[Y],F.writeUInt16(p);return{charMap:n,subtable:F.data,maxGlyphID:y+1}}},t}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new p(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=p.encode(t,e),(r=new X).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),w=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),v=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,h,c,l,u,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=c=0;0<=e?c<e:e<c;i=0<=e?++c:--c)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=l=0,u=n.length;l<u;i=++l)r=n[i],t.pos=r.offset,h=t.readString(r.length),o=new v(h,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);return this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5],this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,""),this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),S=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),k=[].slice,_=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,h,c,l;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new X(e.read(r))).readShort(),h=a.readShort(),l=a.readShort(),s=a.readShort(),c=a.readShort(),this.cache[t]=-1===o?new I(a,h,l,s,c):new A(a,o,h,l,s,c),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),A=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),I=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new X(k.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),C=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,c),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var h=new Array(4*n.length),c=0;c<n.length;++c)h[4*c+3]=255&n[c],h[4*c+2]=(65280&n[c])>>8,h[4*c+1]=(16711680&n[c])>>16,h[4*c]=(4278190080&n[c])>>24;return h},e}(),T=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p,g;for(n in e=m.encode(this.generateCmap(),"unicode"),i=this.glyphsFor(t),u={0:0},g=e.charMap)u[(a=g[n]).old]=a.new;for(f in l=e.maxGlyphID,i)f in u||(u[f]=l++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(u),c=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=c.length;t<e;t++)o=c[t],n.push(h[o]);return n}(),r=this.font.glyf.encode(i,d,u),s=this.font.loca.encode(r.offsets,d),p={cmap:this.font.cmap.raw(),glyf:r.table,loca:s,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.raw()},this.font.os2.exists&&(p["OS/2"]=this.font.os2.raw()),this.font.directory.encode(p)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")}return""+r},a}()}($),
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
pt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),gt=function(){var c,n,r;function i(t){var e,n,r,i,o,a,s,h,c,l,u,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),c=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===c&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(l=r-this.transparency.indexed.length))for(d=0;0<=l?d<l:l<d;0<=l?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(u=this.read(e)).indexOf(0),h=String.fromCharCode.apply(String,u.slice(0,s)),this.text[h]=String.fromCharCode.apply(String,u.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(E){var q=this.pixelBitlength/8,O=new Uint8Array(this.width*this.height*q),B=0,R=this;if(null==E&&(E=this.imgData),0===E.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,h,c,l,u,f,d,p,g,m,w,y,v,b,x,S,k,_,A=Math.ceil((R.width-t)/n),I=Math.ceil((R.height-e)/r),C=R.width==A&&R.height==I;for(w=q*A,g=C?O:new Uint8Array(w*I),c=E.length,o=m=0;m<I&&B<c;){switch(E[B++]){case 0:for(s=b=0;b<w;s=b+=1)g[o++]=E[B++];break;case 1:for(s=x=0;x<w;s=x+=1)i=E[B++],h=s<q?0:g[o-q],g[o++]=(i+h)%256;break;case 2:for(s=S=0;S<w;s=S+=1)i=E[B++],a=(s-s%q)/q,y=m&&g[(m-1)*w+a*q+s%q],g[o++]=(y+i)%256;break;case 3:for(s=k=0;k<w;s=k+=1)i=E[B++],a=(s-s%q)/q,h=s<q?0:g[o-q],y=m&&g[(m-1)*w+a*q+s%q],g[o++]=(i+Math.floor((h+y)/2))%256;break;case 4:for(s=_=0;_<w;s=_+=1)i=E[B++],a=(s-s%q)/q,h=s<q?0:g[o-q],0===m?y=v=0:(y=g[(m-1)*w+a*q+s%q],v=a&&g[(m-1)*w+(a-1)*q+s%q]),l=h+y-v,u=Math.abs(l-h),d=Math.abs(l-y),p=Math.abs(l-v),f=u<=d&&u<=p?h:d<=p?y:v,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+E[B-1])}if(!C){var T=((e+m*r)*R.width+t)*q,F=m*w;for(s=0;s<A;s+=1){for(var P=0;P<q;P+=1)O[T++]=g[F++];T+=(n-1)*q}}m++}}return E=(E=new kt(E)).getBytes(),1==R.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),O},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,h;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(h=o[t++])?h:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,h,c,l,u,f;if(r=this.colors,l=null,n=this.hasAlphaChannel,this.palette.length&&(l=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),c=(i=t.data||t).length,a=l||e,o=s=0,1===r)for(;o<c;)h=l?4*e[o/4]:s,u=a[h++],i[o++]=u,i[o++]=u,i[o++]=u,i[o++]=n?a[h++]:255,s=h;else for(;o<c;)h=l?4*e[o/4]:s,i[o++]=a[h++],i[o++]=a[h++],i[o++]=a[h++],i[o++]=n?a[h++]:255,s=h},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=pt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return c=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,h;if(this.animation){for(h=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,h.push(e.image=c(r));return h}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,h=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],h.renderFrame(n,t),1<a&&i/a<s)return h.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),pt.PNG=gt;
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var St=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var F=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),P=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),E=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),q=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],O=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(St.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&B("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&B("Bad encoding in flate stream"),i|=s<<r,r+=8}var h=e[i&(1<<n)-1],c=h>>16,l=65535&h;return(0==r||r<c||0==c)&&B("Bad encoding in flate stream"),this.codeBuf=i>>c,this.codeSize=r-c,this.bytesPos=a,l},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,h=2;a<=n;++a,s<<=1,h<<=1)for(var c=0;c<e;++c)if(t[c]==a){var l=0,u=s;for(r=0;r<a;++r)l=l<<1|1&u,u>>=1;for(r=l;r<i;r+=h)o[r]=a<<16|c;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[h++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=q,r=O;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(F.length),h=0;h<a;)s[F[h++]]=this.getBits(3);for(var c=this.generateHuffmanTable(s),l=0,u=(h=0,i+o),f=new Array(u);h<u;){var d=this.getCode(c);16==d?t(this,f,2,3,l):17==d?t(this,f,3,3,l=0):18==d?t(this,f,7,11,l=0):f[h++]=l=d}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,u))}else B("Unknown block type in flate stream");for(var p=(I=this.buffer)?I.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)p<=g+1&&(p=(I=this.ensureBuffer(g+1)).length),I[g++]=m;else{if(256==m)return void(this.bufferLength=g);var w=(m=P[m-=257])>>16;0<w&&(w=this.getBits(w));l=(65535&m)+w;m=this.getCode(r),0<(w=(m=E[m])>>16)&&(w=this.getBits(w));var y=(65535&m)+w;p<=g+l&&(p=(I=this.ensureBuffer(g+l)).length);for(var v=0;v<l;++v,++g)I[g]=I[g-y]}}}else{var b,x=this.bytes,S=this.bytesPos;void 0===(b=x[S++])&&B("Bad block header in flate stream");var k=b;void 0===(b=x[S++])&&B("Bad block header in flate stream"),k|=b<<8,void 0===(b=x[S++])&&B("Bad block header in flate stream");var _=b;void 0===(b=x[S++])&&B("Bad block header in flate stream"),(_|=b<<8)!=(65535&~k)&&B("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var A=this.bufferLength,I=this.ensureBuffer(A+k),C=A+k;this.bufferLength=C;for(var T=A;T<C;++T){if(void 0===(b=x[S++])){this.eof=!0;break}I[T]=b}this.bytesPos=S}},t}function B(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||B("Invalid header in flate stream"),8!=(15&n)&&B("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&B("Bad FCHECK in flate stream"),32&r&&B("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,St.call(this)}}();return function(t){if("object"!=typeof t.console){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,h,c,l,u="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,h="",c=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,c[s++]=u.charAt(e)+u.charAt(n)+u.charAt(r)+u.charAt(i),a<t.length;);h=c.join("");var l=t.length%3;return(l?h.slice(0,l-3):h)+"===".slice(l||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,h=0,c=[];if(!t)return t;for(t+="";e=(a=u.indexOf(t.charAt(s++))<<18|u.indexOf(t.charAt(s++))<<12|(i=u.indexOf(t.charAt(s++)))<<6|(o=u.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,c[h++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return c.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,h=!{toString:null}.propertyIsEnumerable("toString"),l=(c=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!=typeof t&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(h)for(n=0;n<l;n++)s.call(t,c[n])&&r.push(c[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")})}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),$});
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var i;i="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,i.DeltaE=t()}}(function(){return function t(i,e,s){function h(a,n){if(!e[a]){if(!i[a]){var o="function"==typeof require&&require;if(!n&&o)return o(a,!0);if(r)return r(a,!0);var u=new Error("Cannot find module '"+a+"'");throw u.code="MODULE_NOT_FOUND",u}var m=e[a]={exports:{}};i[a][0].call(m.exports,function(t){var e=i[a][1][t];return h(e?e:t)},m,m.exports,t,i,e,s)}return e[a].exports}for(var r="function"==typeof require&&require,a=0;a<s.length;a++)h(s[a]);return h}({1:[function(t,i){"use strict";function e(){}var s=t("./dE76"),h=t("./dE94"),r=t("./dE00");e.prototype.getDeltaE76=function(t,i){var e=new s(t,i);return e.getDeltaE()},e.prototype.getDeltaE94=function(t,i){var e=new h(t,i);return e.getDeltaE()},e.prototype.getDeltaE00=function(t,i){var e=new r(t,i);return e.getDeltaE()},i.exports=new e},{"./dE00":2,"./dE76":3,"./dE94":4}],2:[function(t,i){"use strict";function e(t,i,e){var s=Math.sqrt,h=Math.pow;this.x1=t,this.x2=i,this.weights=e||{},this.ksubL=this.weights.lightness||1,this.ksubC=this.weights.chroma||1,this.ksubH=this.weights.hue||1,this.deltaLPrime=i.L-t.L,this.LBar=(t.L+i.L)/2,this.C1=s(h(t.A,2)+h(t.B,2)),this.C2=s(h(i.A,2)+h(i.B,2)),this.CBar=(this.C1+this.C2)/2,this.aPrime1=t.A+t.A/2*(1-s(h(this.CBar,7)/(h(this.CBar,7)+h(25,7)))),this.aPrime2=i.A+i.A/2*(1-s(h(this.CBar,7)/(h(this.CBar,7)+h(25,7)))),this.CPrime1=s(h(this.aPrime1,2)+h(t.B,2)),this.CPrime2=s(h(this.aPrime2,2)+h(i.B,2)),this.CBarPrime=(this.CPrime1+this.CPrime2)/2,this.deltaCPrime=this.CPrime2-this.CPrime1,this.SsubL=1+.015*h(this.LBar-50,2)/s(20+h(this.LBar-50,2)),this.SsubC=1+.045*this.CBarPrime,this.hPrime1=0,this.hPrime2=0,this.deltahPrime=0,this.deltaHPrime=0,this.HBarPrime=0,this.T=0,this.SsubH=0,this.RsubT=0}e.prototype.getDeltaE=function(){var t=Math.sqrt,i=Math.sin,e=Math.pow;this.hPrime1=this.gethPrime1(),this.hPrime2=this.gethPrime2(),this.deltahPrime=this.getDeltahPrime(),this.deltaHPrime=2*t(this.CPrime1*this.CPrime2)*i(this.degreesToRadians(this.deltahPrime)/2),this.HBarPrime=this.getHBarPrime(),this.T=this.getT(),this.SsubH=1+.015*this.CBarPrime*this.T,this.RsubT=this.getRsubT();var s=this.deltaLPrime/(this.ksubL*this.SsubL),h=this.deltaCPrime/(this.ksubC*this.SsubC),r=this.deltaHPrime/(this.ksubH*this.SsubH);return t(e(s,2)+e(h,2)+e(r,2)+this.RsubT*h*r)},e.prototype.getRsubT=function(){var t=Math.sin,i=Math.sqrt,e=Math.pow,s=Math.exp;return-2*i(e(this.CBarPrime,7)/(e(this.CBarPrime,7)+e(25,7)))*t(this.degreesToRadians(60*s(-e((this.HBarPrime-275)/25,2))))},e.prototype.getT=function(){var t=Math.cos;return 1-.17*t(this.degreesToRadians(this.HBarPrime-30))+.24*t(this.degreesToRadians(2*this.HBarPrime))+.32*t(this.degreesToRadians(3*this.HBarPrime+6))-.2*t(this.degreesToRadians(4*this.HBarPrime-63))},e.prototype.getHBarPrime=function(){var t=Math.abs;return t(this.hPrime1-this.hPrime2)>180?(this.hPrime1+this.hPrime2+360)/2:(this.hPrime1+this.hPrime2)/2},e.prototype.getDeltahPrime=function(){var t=Math.abs;return 0===this.C1||0===this.C2?0:t(this.hPrime1-this.hPrime2)<=180?this.hPrime2-this.hPrime1:this.hPrime2<=this.hPrime1?this.hPrime2-this.hPrime1+360:this.hPrime2-this.hPrime1-360},e.prototype.gethPrime1=function(){return this._gethPrimeFn(this.x1.B,this.aPrime1)},e.prototype.gethPrime2=function(){return this._gethPrimeFn(this.x2.B,this.aPrime2)},e.prototype._gethPrimeFn=function(t,i){var e;return 0===t&&0===i?0:(e=this.radiansToDegrees(Math.atan2(t,i)),e>=0?e:e+360)},e.prototype.radiansToDegrees=function(t){return t*(180/Math.PI)},e.prototype.degreesToRadians=function(t){return t*(Math.PI/180)},i.exports=e},{}],3:[function(t,i){"use strict";function e(t,i){this.x1=t,this.x2=i}e.prototype.getDeltaE=function(){var t=this.x1,i=this.x2;return Math.sqrt(Math.pow(i.L-t.L,2)+Math.pow(i.A-t.A,2)+Math.pow(i.B-t.B,2))},i.exports=e},{}],4:[function(t,i){"use strict";function e(t,i,e){this.x1=t,this.x2=i,this.weights=e||{},this.weights.lightness=this.weights.lightness||1,this.weights.chroma=this.weights.chroma||1,this.weights.hue=this.weights.hue||1,1===this.weights.lightness?(this.weights.K1=.045,this.weights.K2=.015):(this.weights.K1=.048,this.weights.K2=.014)}e.prototype.getDeltaE=function(){var t=this.x1,i=this.x2,e=Math.sqrt,s=Math.pow;return e(s(this.calculateL(t,i),2)+s(this.calculateA(t,i),2)+s(this.calculateB(t,i),2))},e.prototype.calculateL=function(t,i){return(t.L-i.L)/this.weights.lightness},e.prototype.calculateA=function(t,i){var e=Math.sqrt,s=Math.pow,h=e(s(t.A,2)+s(t.B,2)),r=e(s(i.A,2)+s(i.B,2)),a=h-r,n=1+this.weights.K1*h;return a/(this.weights.chroma*n)},e.prototype.calculateB=function(t,i){var e=Math.sqrt,s=Math.pow,h=e(s(t.A,2)+s(t.B,2)),r=e(s(i.A,2)+s(i.B,2)),a=h-r,n=t.A-i.A,o=t.B-i.B,u=e(s(n,2)+s(o,2)-s(a,2)),h=e(s(t.A,2)+s(t.B,2)),m=1+this.weights.K2*h;return u/m},i.exports=e},{}]},{},[1])(1)});
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.DOMPurify=t()}(this,function(){"use strict";function e(e,t){y&&y(e,null);for(var n=t.length;n--;){var r=t[n];if("string"==typeof r){var o=r.toLowerCase();o!==r&&(Object.isFrozen(t)||(t[n]=o),r=o)}e[r]=!0}return e}function t(e){var t={},n=void 0;for(n in e)g(h,e,[n])&&(t[n]=e[n]);return t}function n(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function r(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_(),u=function(e){return r(e)};if(u.version="1.0.11",u.removed=[],!o||!o.document||9!==o.document.nodeType)return u.isSupported=!1,u;var h=o.document,y=!1,g=!1,v=o.document,D=o.DocumentFragment,R=o.HTMLTemplateElement,C=o.Node,H=o.NodeFilter,F=o.NamedNodeMap,z=void 0===F?o.NamedNodeMap||o.MozNamedAttrMap:F,I=o.Text,j=o.Comment,P=o.DOMParser,U=o.TrustedTypes;if("function"==typeof R){var W=v.createElement("template");W.content&&W.content.ownerDocument&&(v=W.content.ownerDocument)}var B=N(U,h),G=B?B.createHTML(""):"",q=v,V=q.implementation,Y=q.createNodeIterator,K=q.getElementsByTagName,X=q.createDocumentFragment,$=h.importNode,J={};u.isSupported=V&&void 0!==V.createHTMLDocument&&9!==v.documentMode;var Q=b,Z=T,ee=A,te=x,ne=S,re=M,oe=L,ie=null,ae=e({},[].concat(n(i),n(a),n(l),n(c),n(s))),le=null,ce=e({},[].concat(n(d),n(f),n(p),n(m))),se=null,ue=null,de=!0,fe=!0,pe=!1,me=!1,he=!1,ye=!1,ge=!1,ve=!1,be=!1,Te=!1,Ae=!1,xe=!0,Le=!0,Se=!1,Me={},ke=e({},["audio","head","math","script","style","template","svg","video"]),we=e({},["audio","video","img","source","image"]),Ee=null,Oe=e({},["alt","class","for","id","label","name","pattern","placeholder","summary","title","value","style","xmlns"]),_e=null,Ne=v.createElement("form"),De=function(r){_e&&_e===r||(r&&"object"===(void 0===r?"undefined":k(r))||(r={}),ie="ALLOWED_TAGS"in r?e({},r.ALLOWED_TAGS):ae,le="ALLOWED_ATTR"in r?e({},r.ALLOWED_ATTR):ce,Ee="ADD_URI_SAFE_ATTR"in r?e({},r.ADD_URI_SAFE_ATTR):Oe,se="FORBID_TAGS"in r?e({},r.FORBID_TAGS):{},ue="FORBID_ATTR"in r?e({},r.FORBID_ATTR):{},Me="USE_PROFILES"in r&&r.USE_PROFILES,de=!1!==r.ALLOW_ARIA_ATTR,fe=!1!==r.ALLOW_DATA_ATTR,pe=r.ALLOW_UNKNOWN_PROTOCOLS||!1,me=r.SAFE_FOR_JQUERY||!1,he=r.SAFE_FOR_TEMPLATES||!1,ye=r.WHOLE_DOCUMENT||!1,be=r.RETURN_DOM||!1,Te=r.RETURN_DOM_FRAGMENT||!1,Ae=r.RETURN_DOM_IMPORT||!1,ve=r.FORCE_BODY||!1,xe=!1!==r.SANITIZE_DOM,Le=!1!==r.KEEP_CONTENT,Se=r.IN_PLACE||!1,oe=r.ALLOWED_URI_REGEXP||oe,he&&(fe=!1),Te&&(be=!0),Me&&(ie=e({},[].concat(n(s))),le=[],!0===Me.html&&(e(ie,i),e(le,d)),!0===Me.svg&&(e(ie,a),e(le,f),e(le,m)),!0===Me.svgFilters&&(e(ie,l),e(le,f),e(le,m)),!0===Me.mathMl&&(e(ie,c),e(le,p),e(le,m))),r.ADD_TAGS&&(ie===ae&&(ie=t(ie)),e(ie,r.ADD_TAGS)),r.ADD_ATTR&&(le===ce&&(le=t(le)),e(le,r.ADD_ATTR)),r.ADD_URI_SAFE_ATTR&&e(Ee,r.ADD_URI_SAFE_ATTR),Le&&(ie["#text"]=!0),ye&&e(ie,["html","head","body"]),ie.table&&e(ie,["tbody"]),O&&O(r),_e=r)},Re=function(e){u.removed.push({element:e});try{e.parentNode.removeChild(e)}catch(t){e.outerHTML=G}},Ce=function(e,t){try{u.removed.push({attribute:t.getAttributeNode(e),from:t})}catch(e){u.removed.push({attribute:null,from:t})}t.removeAttribute(e)},He=function(t){var n=void 0,r=void 0;if(ve)t="<remove></remove>"+t;else{var o=t.match(/^[\s]+/);(r=o&&o[0])&&(t=t.slice(r.length))}if(y)try{n=(new P).parseFromString(t,"text/html")}catch(e){}if(g&&e(se,["title"]),!n||!n.documentElement){var i=(n=V.createHTMLDocument("")).body;i.parentNode.removeChild(i.parentNode.firstElementChild),i.outerHTML=B?B.createHTML(t):t}return r&&n.body.insertBefore(v.createTextNode(r),n.body.childNodes[0]||null),K.call(n,ye?"html":"body")[0]};u.isSupported&&(function(){try{He('<svg><p><style><img src="</style><img src=x onerror=1//">').querySelector("svg img")&&(y=!0)}catch(e){}}(),function(){try{He("<x/><title>&lt;/title&gt;&lt;img&gt;").querySelector("title").innerHTML.match(/<\/title/)&&(g=!0)}catch(e){}}());var Fe=function(e){return Y.call(e.ownerDocument||e,e,H.SHOW_ELEMENT|H.SHOW_COMMENT|H.SHOW_TEXT,function(){return H.FILTER_ACCEPT},!1)},ze=function(e){return!(e instanceof I||e instanceof j)&&!("string"==typeof e.nodeName&&"string"==typeof e.textContent&&"function"==typeof e.removeChild&&e.attributes instanceof z&&"function"==typeof e.removeAttribute&&"function"==typeof e.setAttribute)},Ie=function(e){return"object"===(void 0===C?"undefined":k(C))?e instanceof C:e&&"object"===(void 0===e?"undefined":k(e))&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName},je=function(e,t,n){J[e]&&J[e].forEach(function(e){e.call(u,t,n,_e)})},Pe=function(e){var t=void 0;if(je("beforeSanitizeElements",e,null),ze(e))return Re(e),!0;var n=e.nodeName.toLowerCase();if(je("uponSanitizeElement",e,{tagName:n,allowedTags:ie}),!ie[n]||se[n]){if(Le&&!ke[n]&&"function"==typeof e.insertAdjacentHTML)try{var r=e.innerHTML;e.insertAdjacentHTML("AfterEnd",B?B.createHTML(r):r)}catch(e){}return Re(e),!0}return"noscript"===n&&e.innerHTML.match(/<\/noscript/i)?(Re(e),!0):"noembed"===n&&e.innerHTML.match(/<\/noembed/i)?(Re(e),!0):(!me||e.firstElementChild||e.content&&e.content.firstElementChild||!/</g.test(e.textContent)||(u.removed.push({element:e.cloneNode()}),e.innerHTML?e.innerHTML=e.innerHTML.replace(/</g,"&lt;"):e.innerHTML=e.textContent.replace(/</g,"&lt;")),he&&3===e.nodeType&&(t=(t=(t=e.textContent).replace(Q," ")).replace(Z," "),e.textContent!==t&&(u.removed.push({element:e.cloneNode()}),e.textContent=t)),je("afterSanitizeElements",e,null),!1)},Ue=function(e,t,n){if(xe&&("id"===t||"name"===t)&&(n in v||n in Ne))return!1;if(fe&&ee.test(t));else if(de&&te.test(t));else{if(!le[t]||ue[t])return!1;if(Ee[t]);else if(oe.test(n.replace(re,"")));else if("src"!==t&&"xlink:href"!==t||"script"===e||0!==n.indexOf("data:")||!we[e]){if(pe&&!ne.test(n.replace(re,"")));else if(n)return!1}else;}return!0},We=function(e){var t=void 0,n=void 0,r=void 0,o=void 0,i=void 0;je("beforeSanitizeAttributes",e,null);var a=e.attributes;if(a){var l={attrName:"",attrValue:"",keepAttr:!0,allowedAttributes:le};for(i=a.length;i--;){var c=t=a[i],s=c.name,d=c.namespaceURI;if(n=t.value.trim(),r=s.toLowerCase(),l.attrName=r,l.attrValue=n,l.keepAttr=!0,je("uponSanitizeAttribute",e,l),n=l.attrValue,"name"===r&&"IMG"===e.nodeName&&a.id)o=a.id,a=w(E,a,[]),Ce("id",e),Ce(s,e),a.indexOf(o)>i&&e.setAttribute("id",o.value);else{if("INPUT"===e.nodeName&&"type"===r&&"file"===n&&l.keepAttr&&(le[r]||!ue[r]))continue;"id"===s&&e.setAttribute(s,""),Ce(s,e)}if(l.keepAttr){he&&(n=(n=n.replace(Q," ")).replace(Z," "));var f=e.nodeName.toLowerCase();if(Ue(f,r,n))try{d?e.setAttributeNS(d,s,n):e.setAttribute(s,n),u.removed.pop()}catch(e){}}}je("afterSanitizeAttributes",e,null)}},Be=function e(t){var n=void 0,r=Fe(t);for(je("beforeSanitizeShadowDOM",t,null);n=r.nextNode();)je("uponSanitizeShadowNode",n,null),Pe(n)||(n.content instanceof D&&e(n.content),We(n));je("afterSanitizeShadowDOM",t,null)};return u.sanitize=function(e,t){var n=void 0,r=void 0,i=void 0,a=void 0,l=void 0;if(e||(e="\x3c!--\x3e"),"string"!=typeof e&&!Ie(e)){if("function"!=typeof e.toString)throw new TypeError("toString is not a function");if("string"!=typeof(e=e.toString()))throw new TypeError("dirty is not a string, aborting")}if(!u.isSupported){if("object"===k(o.toStaticHTML)||"function"==typeof o.toStaticHTML){if("string"==typeof e)return o.toStaticHTML(e);if(Ie(e))return o.toStaticHTML(e.outerHTML)}return e}if(ge||De(t),u.removed=[],Se);else if(e instanceof C)1===(r=(n=He("\x3c!--\x3e")).ownerDocument.importNode(e,!0)).nodeType&&"BODY"===r.nodeName?n=r:"HTML"===r.nodeName?n=r:n.appendChild(r);else{if(!be&&!he&&!ye&&-1===e.indexOf("<"))return B?B.createHTML(e):e;if(!(n=He(e)))return be?null:G}n&&ve&&Re(n.firstChild);for(var c=Fe(Se?e:n);i=c.nextNode();)3===i.nodeType&&i===a||Pe(i)||(i.content instanceof D&&Be(i.content),We(i),a=i);if(a=null,Se)return e;if(be){if(Te)for(l=X.call(n.ownerDocument);n.firstChild;)l.appendChild(n.firstChild);else l=n;return Ae&&(l=$.call(h,l,!0)),l}var s=ye?n.outerHTML:n.innerHTML;return he&&(s=(s=s.replace(Q," ")).replace(Z," ")),B?B.createHTML(s):s},u.setConfig=function(e){De(e),ge=!0},u.clearConfig=function(){_e=null,ge=!1},u.isValidAttribute=function(e,t,n){_e||De({});var r=e.toLowerCase(),o=t.toLowerCase();return Ue(r,o,n)},u.addHook=function(e,t){"function"==typeof t&&(J[e]=J[e]||[],J[e].push(t))},u.removeHook=function(e){J[e]&&J[e].pop()},u.removeHooks=function(e){J[e]&&(J[e]=[])},u.removeAllHooks=function(){J={}},u}var o=Object.freeze||function(e){return e},i=o(["a","abbr","acronym","address","area","article","aside","audio","b","bdi","bdo","big","blink","blockquote","body","br","button","canvas","caption","center","cite","code","col","colgroup","content","data","datalist","dd","decorator","del","details","dfn","dir","div","dl","dt","element","em","fieldset","figcaption","figure","font","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","img","input","ins","kbd","label","legend","li","main","map","mark","marquee","menu","menuitem","meter","nav","nobr","ol","optgroup","option","output","p","pre","progress","q","rp","rt","ruby","s","samp","section","select","shadow","small","source","spacer","span","strike","strong","style","sub","summary","sup","table","tbody","td","template","textarea","tfoot","th","thead","time","tr","track","tt","u","ul","var","video","wbr"]),a=o(["svg","a","altglyph","altglyphdef","altglyphitem","animatecolor","animatemotion","animatetransform","audio","canvas","circle","clippath","defs","desc","ellipse","filter","font","g","glyph","glyphref","hkern","image","line","lineargradient","marker","mask","metadata","mpath","path","pattern","polygon","polyline","radialgradient","rect","stop","style","switch","symbol","text","textpath","title","tref","tspan","video","view","vkern"]),l=o(["feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence"]),c=o(["math","menclose","merror","mfenced","mfrac","mglyph","mi","mlabeledtr","mmultiscripts","mn","mo","mover","mpadded","mphantom","mroot","mrow","ms","mspace","msqrt","mstyle","msub","msup","msubsup","mtable","mtd","mtext","mtr","munder","munderover"]),s=o(["#text"]),u=Object.freeze||function(e){return e},d=u(["accept","action","align","alt","autocomplete","background","bgcolor","border","cellpadding","cellspacing","checked","cite","class","clear","color","cols","colspan","controls","coords","crossorigin","datetime","default","dir","disabled","download","enctype","face","for","headers","height","hidden","high","href","hreflang","id","integrity","ismap","label","lang","list","loop","low","max","maxlength","media","method","min","multiple","name","noshade","novalidate","nowrap","open","optimum","pattern","placeholder","poster","preload","pubdate","radiogroup","readonly","rel","required","rev","reversed","role","rows","rowspan","spellcheck","scope","selected","shape","size","sizes","span","srclang","start","src","srcset","step","style","summary","tabindex","title","type","usemap","valign","value","width","xmlns"]),f=u(["accent-height","accumulate","additive","alignment-baseline","ascent","attributename","attributetype","azimuth","basefrequency","baseline-shift","begin","bias","by","class","clip","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","cx","cy","d","dx","dy","diffuseconstant","direction","display","divisor","dur","edgemode","elevation","end","fill","fill-opacity","fill-rule","filter","filterunits","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","fx","fy","g1","g2","glyph-name","glyphref","gradientunits","gradienttransform","height","href","id","image-rendering","in","in2","k","k1","k2","k3","k4","kerning","keypoints","keysplines","keytimes","lang","lengthadjust","letter-spacing","kernelmatrix","kernelunitlength","lighting-color","local","marker-end","marker-mid","marker-start","markerheight","markerunits","markerwidth","maskcontentunits","maskunits","max","mask","media","method","mode","min","name","numoctaves","offset","operator","opacity","order","orient","orientation","origin","overflow","paint-order","path","pathlength","patterncontentunits","patterntransform","patternunits","points","preservealpha","preserveaspectratio","primitiveunits","r","rx","ry","radius","refx","refy","repeatcount","repeatdur","restart","result","rotate","scale","seed","shape-rendering","specularconstant","specularexponent","spreadmethod","stddeviation","stitchtiles","stop-color","stop-opacity","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke","stroke-width","style","surfacescale","tabindex","targetx","targety","transform","text-anchor","text-decoration","text-rendering","textlength","type","u1","u2","unicode","values","viewbox","visibility","version","vert-adv-y","vert-origin-x","vert-origin-y","width","word-spacing","wrap","writing-mode","xchannelselector","ychannelselector","x","x1","x2","xmlns","y","y1","y2","z","zoomandpan"]),p=u(["accent","accentunder","align","bevelled","close","columnsalign","columnlines","columnspan","denomalign","depth","dir","display","displaystyle","fence","frame","height","href","id","largeop","length","linethickness","lspace","lquote","mathbackground","mathcolor","mathsize","mathvariant","maxsize","minsize","movablelimits","notation","numalign","open","rowalign","rowlines","rowspacing","rowspan","rspace","rquote","scriptlevel","scriptminsize","scriptsizemultiplier","selection","separator","separators","stretchy","subscriptshift","supscriptshift","symmetric","voffset","width","xmlns"]),m=u(["xlink:href","xml:id","xlink:title","xml:space","xmlns:xlink"]),h=Object.hasOwnProperty,y=Object.setPrototypeOf,g=("undefined"!=typeof Reflect&&Reflect).apply;g||(g=function(e,t,n){return e.apply(t,n)});var v=Object.seal||function(e){return e},b=v(/\{\{[\s\S]*|[\s\S]*\}\}/gm),T=v(/<%[\s\S]*|[\s\S]*%>/gm),A=v(/^data-[\-\w.\u00B7-\uFFFF]/),x=v(/^aria-[\-\w]+$/),L=v(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),S=v(/^(?:\w+script|data):/i),M=v(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g),k="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},w=("undefined"!=typeof Reflect&&Reflect).apply,E=Array.prototype.slice,O=Object.freeze,_=function(){return"undefined"==typeof window?null:window};w||(w=function(e,t,n){return e.apply(t,n)});var N=function(e,t){if("object"!==(void 0===e?"undefined":k(e))||"function"!=typeof e.createPolicy)return null;var n=null;t.currentScript&&t.currentScript.hasAttribute("data-tt-policy-suffix")&&(n=t.currentScript.getAttribute("data-tt-policy-suffix"));var r="dompurify"+(n?"#"+n:"");try{return e.createPolicy(r,{createHTML:function(e){return e}})}catch(e){return console.warn("TrustedTypes policy "+r+" could not be created."),null}};return r()});
//# sourceMappingURL=purify.min.js.map

(function() {

    'use strict';

    angular
        .module('app.admin', [
            'admin.controlPanel',
            'admin.draftOrders',
            'admin.discounts',
            'admin.customerDetails',
            'admin.pendingOrders',
            'admin.productTypes',
            'admin.templateCopy']);
})();
(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    tasksResolve.$inject = ["TasksApiService"];
    userResolve.$inject = ["AuthService"];
    ControlPanelController.$inject = ["TasksApiService", "$modal", "tasks", "user", "$interval", "$scope"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.controlpanel', {
            url: '/controlpanel',
            views: {
                "main-content": {
                    templateUrl: 'admin/controlPanel/controlPanel.tpl.html',
                    controller: 'ControlPanelController as vm'
                }
            },
            resolve: {
                tasks: tasksResolve,
                user: userResolve
            }
        });
    }

    // @ngInject
    function tasksResolve(TasksApiService) {
        return TasksApiService.getTasks();
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function ControlPanelController(TasksApiService, $modal, tasks, user, $interval, $scope) {
        /* jshint validthis: true */
        var vm = this;
        vm.tasks = tasks;
        vm.user = user;
        vm.onClickTask = onClickTask;
        vm.onClickSystemStatus = onClickSystemStatus;

        function onClickTask(task, action) {
            tasks = TasksApiService.changeTaskStatus(task.jobName, action).then(function(tasks) {
               vm.tasks = tasks;
            });
        }

        var interval = $interval(function() {
            TasksApiService.getTasks().then(function(tasks) {
                vm.tasks = tasks;
            });
        }, 5000);

        $scope.$on("$destroy", function() {
            $interval.cancel(interval);
        });

        function onClickSystemStatus() {
            var systemStatusDialog = {
                backdrop: 'static',
                controller: "SystemStatusDialogController as vm",
                templateUrl: "admin/controlPanel/systemStatusDialog/systemStatusDialog.tpl.html"
            };
            $modal.open(systemStatusDialog);
        }
    }

    angular
        .module('admin.controlPanel', ['systemStatusDialog'])
        .controller('ControlPanelController', ControlPanelController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    // @ngInject
    SystemStatusDialogController.$inject = ["$modalInstance", "loadSpinnerService", "TasksApiService"];
    function SystemStatusDialogController($modalInstance, loadSpinnerService, TasksApiService) {
        /* jshint validthis: true */
        var vm = this;
        vm.close = close;
        vm.isSystemNormal = isSystemNormal;

        initialise();

        function initialise() {
            loadSpinnerService.start();
            TasksApiService.getSystemStatus().then(function(systemStatus) {
                vm.systemStatus = systemStatus;
                loadSpinnerService.stop();
            });
        }

        function close() {
            $modalInstance.dismiss('cancel');
        }

        function isSystemNormal() {
            var result = true;
            angular.forEach(vm.systemStatus, function(moduleStatus) {
                result = result && 'OK' === moduleStatus;
            });
            return result;
        }
    }

    angular
        .module('systemStatusDialog', [])
        .controller('SystemStatusDialogController', SystemStatusDialogController);
})();

(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    customerDetailsResolve.$inject = ["AuthService", "CustomerDetailsApiService"];
    customerSettingsResolve.$inject = ["AuthService", "CustomerSettingsApiService"];
    CustomerDetailsController.$inject = ["$scope", "$q", "$state", "user", "AuthService", "CustomerSettingsApiService", "CustomerDetailsApiService", "customerDetails", "customerSettings"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.customer', {
            url: '/customer',
            views: {
                "main-content": {
                    templateUrl: 'admin/customerDetails/customerDetails.tpl.html',
                    controller: 'CustomerDetailsController as vm'
                }
            },
            resolve: {
                user: userResolve,
                customerDetails: customerDetailsResolve,
                customerSettings: customerSettingsResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function customerDetailsResolve(AuthService, CustomerDetailsApiService) {
        return AuthService.getUser()
            .then(function (user) {
                var customerId = user.orderRecipient ? user.orderRecipient.customerId : user.customerId;
                return CustomerDetailsApiService.getCustomerDetails(customerId);
            });
    }

    // @ngInject
    function customerSettingsResolve(AuthService, CustomerSettingsApiService) {
        return AuthService.getUser()
            .then(function (user) {
                var customerId = user.orderRecipient ? user.orderRecipient.customerId : user.customerId;
                return CustomerSettingsApiService.getCustomerSettings(customerId);
            });
    }

    // @ngInject
    function CustomerDetailsController(
        $scope,
        $q,
        $state,
        user, 
        AuthService, 
        CustomerSettingsApiService, 
        CustomerDetailsApiService, 
        customerDetails,
        customerSettings
    ) {
        var vm = this;
        vm.user = user;
        vm.customerDetails = customerDetails;
        vm.customerSettings = customerSettings;
        vm.listFields = ['texts', 'codes', 'numericFields'];
        vm.lists = [];
        vm.fieldGroups = [
            {
                title: 'contact',
                fields: ['address1', 'address2', 'postcodeCity', 'postcodeShipping', 'countryCode', 'telephone', 'fax']
            },
            {
                title: 'other',
                fields: ['reference', 'organisationId', 'invoiceCustomerName', 'categoryCode', 'salesDistrictCode', 'typeCode']
            },
            {
                title: 'terms',
                fields: ['discountCode', 'priceList', 'currencyCode', 'paymentTerms', 'deliveryTerms', 'deliveryMethod', 'vatCode']
            },
            {title: 'credit', fields: ['lastActivityDate', 'openBalance', 'creditLimit', 'warningCode']}
        ];
        vm.onClickToggle = onClickToggleNoApproval;
        vm.onClickToggleAutoReject = onClickToggleAutoReject;

        initialise();

        function onClickToggleNoApproval() {
            vm.customerSettings.noApproval = !vm.customerSettings.noApproval;

            if (vm.customerSettings.noApproval) {
                vm.customerSettings.autoReject = false;
            }

            CustomerSettingsApiService.updateCustomerSettings(vm.customerSettings);
        }

        function onClickToggleAutoReject() {
            CustomerSettingsApiService.updateCustomerSettings(vm.customerSettings);
        }

        $scope.$on('$orderRecipientChange', function () {
            AuthService.getUser()
            .then(function (user) {
              var details = CustomerDetailsApiService.getCustomerDetails(
                user.orderRecipient.customerId
              ).then(function (customerDetails) {
                vm.customerDetails = customerDetails;
                vm.lists = [];
                initialise();
              });
              var settings = CustomerSettingsApiService.getCustomerSettings(
                user.orderRecipient.customerId
              ).then(function (customerSettings) {
                vm.customerSettings = customerSettings;
              });
              $q.all([details, settings]);
            })
            .then($state.reload());
        });

        function initialise() {
            for (var listFieldIndex in vm.listFields) {
                var listField = vm.listFields[listFieldIndex];
                var items = [];
                for (var arrayIndex in vm.customerDetails[listField]) {
                    items.push({
                        value: vm.customerDetails[listField][arrayIndex],
                        index: items.length + 1
                    });
                }
                vm.lists.push({
                    field: listField,
                    values: items
                });
            }
        }
    }

    angular
        .module('admin.customerDetails', ['ngAnimate', 'ui.bootstrap'])
        .controller('CustomerDetailsController', CustomerDetailsController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    discountsResolve.$inject = ["DiscountsApiService"];
    DiscountsController.$inject = ["$scope", "user", "discounts", "DiscountsApiService"];
    function stateConfig($stateProvider) {
        $stateProvider.state( 'app.shop.discounts', {
            url: '/discounts',
            views: {
                "main-content": {
                    templateUrl: 'admin/discounts/discounts.tpl.html',
                    controller: 'DiscountsController as vm'
                }
            },
            resolve: {
                user: userResolve,
                discounts: discountsResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function discountsResolve(DiscountsApiService) {
        return DiscountsApiService.getDiscounts();
    }

    // @ngInject
    function DiscountsController($scope, user, discounts, DiscountsApiService) {
        var vm = this;
        var listener = null;

        vm.user = user;
        vm.hasDiscount = hasDiscount;
        vm.removeDiscount = removeDiscount;
        vm.discounts = angular.copy(discounts);
        vm.pristineDiscounts = angular.copy(discounts);
        vm.changedDiscount = changedDiscount;
        vm.checkDiscount = checkDiscount;
        vm.updateDiscounts = updateDiscounts;
        vm.isDirty = false;
        vm.isValid = true;

        watchForDirtyFields();

        function removeDiscount(discount) {
            discount.discount = '';
        }

        function hasDiscount(discount) {
            return discount.discount && discount.discount !== '';
        }

        function updateDiscounts() {
            DiscountsApiService.updateDiscounts(getUpdatedDiscounts());
            vm.pristineDiscounts = angular.copy(vm.discounts);
            vm.isDirty = false;
        }

        function changedDiscount(discount) {
            if (discount.discount && discount.discount.length > 0) {
                var input = parseInt(discount.discount);
                discount.discount = isNaN(input) ? '' : input + '';
            }
        }

        function checkDiscount(discount) {
            var valid = true;
            if (discount.discount && discount.discount.length > 0) {
                valid = parseInt(discount.discount) <= 100;
            }
            return valid;
        }

        function watchForDirtyFields() {
            if(listener !== null) {
                listener();
            }
            listener = $scope.$watch(function () {
                return vm.discounts;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    vm.isDirty = !_.isEmpty(getUpdatedDiscounts());
                    checkDiscounts();
                }
            }, true);
        }

        function checkDiscounts() {
            var valid = true;
            angular.forEach(vm.discounts, function(discount) {
                valid = valid && checkDiscount(discount);
            });
            vm.isValid = valid;
        }

        function getUpdatedDiscounts() {
            var updatedFields = [];
            angular.forEach(vm.discounts, function(discount) {
                var pristineDiscount = _.find(vm.pristineDiscounts, { 'articleGroupId': discount.articleGroupId });
                if (pristineDiscount.discount !== discount.discount) {
                    updatedFields.push(discount);
                }
            });
            return updatedFields;
        }
    }

    angular
        .module('admin.discounts', [])
        .controller('DiscountsController', DiscountsController)
        .config(stateConfig);
})();
(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    DraftOrdersController.$inject = ["$location", "$rootScope", "user", "CartApiService", "UsersApiService"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.draftorders', {
            url: '/draftorders',
            views: {
                "main-content": {
                    templateUrl: 'admin/draftOrders/draftOrders.tpl.html',
                    controller: 'DraftOrdersController as vm'
                }
            },
            resolve: {
                user: userResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function DraftOrdersController($location, $rootScope, user, CartApiService, UsersApiService) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.hasAdminCarts = hasAdminCarts;
        vm.selectAdminCart = selectAdminCart;

        function hasAdminCarts() {
            return vm.user.adminCarts && vm.user.adminCarts.length > 0;
        }

        function selectAdminCart(adminCart) {
            vm.user.orderRecipient = {
                customerId: adminCart.customerId,
                customerName: adminCart.customerName,
                userId: adminCart.userId,
                userName: adminCart.userName
            };
            UsersApiService.updateSelf(vm.user).then(function() {
                CartApiService.getCartRows();
                $rootScope.$broadcast('$orderRecipientChange');
                $location.path('/cart');
            });
        }
    }

    angular
        .module('admin.draftOrders', [])
        .controller('DraftOrdersController', DraftOrdersController)
        .config(stateConfig);
})();

(function () {

    "use strict";

    // @ngInject
    LogoDialogController.$inject = ["$modalInstance", "DS", "LogoImageApiService", "logo"];
    function LogoDialogController($modalInstance, DS, LogoImageApiService, logo) {
        var vm = this;
        vm.logo = logo;
        vm.attachmentUrl = "";
        vm.originalAttachmenUrl = "";

        vm.close = close;

        initialize();

        function initialize() {
            if (vm.logo) {
                if (vm.logo.logoImage) {
                    vm.attachmentUrl = DS.defaults.baseUrl + 'logoImages/image/' + vm.logo.logoImage;
    
                    // Try fetching original file
                    LogoImageApiService.get(vm.logo.logoImage)
                        .then(function (logoImage) {
                            if (logoImage && logoImage.originalId) {
                                vm.originalAttachmenUrl = DS.defaults.baseUrl + 'logoImages/original/' + logoImage.originalId;
                            }
                        });
                }
                vm.attachmentUrl = DS.defaults.baseUrl + 'attachments/' + vm.logo.logoId;
            }
        }

        function close() {
            $modalInstance.close(vm.selectedColors);
        }
    }

    angular
        .module("logoDialog", [])
        .controller("LogoDialogController", LogoDialogController);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    pendingOrdersResolve.$inject = ["PendingOrdersApiService"];
    pendingOrderResolve.$inject = ["PendingOrdersApiService", "$stateParams"];
    PendingOrderListController.$inject = ["$location", "user", "pendingOrders"];
    PendingOrderViewController.$inject = ["$rootScope", "$modal", "$location", "$translate", "LogosApiService", "PendingOrdersApiService", "user", "pendingOrder", "ConfirmDialogService", "TextAreaDialogService"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.pendingOrderList', {
            url: '/pendingorders',
            views: {
                "main-content": {
                    templateUrl: 'admin/pendingOrders/pendingOrderList.tpl.html',
                    controller: 'PendingOrderListController as vm'
                }
            },
            resolve: {
                user: userResolve,
                pendingOrders: pendingOrdersResolve
            }
        });
        $stateProvider.state('app.shop.pendingOrderView', {
            url: '/pendingorders/{id}',
            views: {
                "main-content": {
                    templateUrl: 'admin/pendingOrders/pendingOrderView.tpl.html',
                    controller: 'PendingOrderViewController as vm'
                }
            },
            resolve: {
                user: userResolve,
                pendingOrder: pendingOrderResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function pendingOrdersResolve(PendingOrdersApiService) {
        return PendingOrdersApiService.getOrders();
    }

    // @ngInject
    function pendingOrderResolve(PendingOrdersApiService, $stateParams) {
        return PendingOrdersApiService.getOrder($stateParams.id);
    }

    // @ngInject
    function PendingOrderListController($location, user, pendingOrders) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.pendingOrders = pendingOrders;
        vm.selectOrder = selectOrder;
        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'NAVIGATION.PENDINGORDERS',
                state: null
            }
        ];

        function selectOrder(order) {
            $location.path('pendingorders/' + order.id);
        }
    }

    // @ngInject
    function PendingOrderViewController(
        $rootScope,
        $modal,
        $location,
        $translate,
        LogosApiService,
        PendingOrdersApiService,
        user,
        pendingOrder,
        ConfirmDialogService,
        TextAreaDialogService
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.pendingOrder = pendingOrder;
        vm.approveOrder = approveOrder;
        vm.rejectOrder = rejectOrder;
        vm.openLogoDialog = openLogoDialog;
        vm.isOrderPending = isOrderPending;
        vm.showInstructions = showInstructions;

        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'NAVIGATION.PENDINGORDERS',
                state: {
                    to: 'app.shop.pendingOrderList'
                }
            },
            {
                displayName: 'NAVIGATION.PENDING_ORDER',
                state: null
            }
        ];

        function approveOrder() {
            PendingOrdersApiService.approveOrder(pendingOrder.orderId).then(function() {
                $rootScope.$broadcast('$updateNotifications');
                $location.path('pendingorders');
            });
        }

        function rejectOrder() {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default'}, { name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('PENDINGORDERS.REJECTDIALOGTITLE', 'PENDINGORDERS.REJECTDIALOGQUESTION', buttons).then(function(button) {
                if (button.name === 'BUTTON.YES') {
                    PendingOrdersApiService.rejectOrder(pendingOrder.orderId).then(function() {
                        $rootScope.$broadcast('$updateNotifications');
                        $location.path('pendingorders');
                    });
                }
            });
        }

        function isOrderPending() {
            return vm.pendingOrder.status === "PENDING";
        }

        function openLogoDialog(id) {

            var logoDialog = {
                backdrop: "static",
                controller: "LogoDialogController as vm",
                templateUrl: "admin/pendingOrders/logoDialog/logoDialog.tpl.html",
                resolve: {
                    logo: function() {
                        return LogosApiService.getLogo(id);
                    }
                }
            };
            $modal.open(logoDialog);
        }

        function showInstructions(text) {
            TextAreaDialogService.showDialog($translate('PENDINGORDERS.INSTRUCTION'), text);
        }
    }

    angular
        .module('admin.pendingOrders', ['logoDialog'])
        .controller('PendingOrderListController', PendingOrderListController)
        .controller('PendingOrderViewController', PendingOrderViewController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    productTypesResolve.$inject = ["ArticlesApiService"];
    ProductTypesController.$inject = ["user", "productTypes"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.producttypes', {
            url: '/producttypes',
            views: {
                "main-content": {
                    templateUrl: 'admin/productTypes/productTypes.tpl.html',
                    controller: 'ProductTypesController as vm'
                }
            },
            resolve: {
                user: userResolve,
                productTypes: productTypesResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function productTypesResolve(ArticlesApiService) {
        return ArticlesApiService.getProductTypes('');
    }

    // @ngInject
    function ProductTypesController(user, productTypes) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.productTypes = productTypes;
        vm.productType = null;
        vm.onClickProductType = onClickProductType;
        vm.getExampleImage = getExampleImage;

        function onClickProductType(productType) {
            vm.productType = productType;
        }

        function getExampleImage() {
            var base = "productTypeImages/";
            if(vm.productType && vm.productType.exampleImage) {
                return base + vm.productType.name + ".png";
            }
        }
    }

    angular
        .module('admin.productTypes', [])
        .controller('ProductTypesController', ProductTypesController)
        .config(stateConfig);
})();
(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    TemplateCopyController.$inject = ["toastr", "$translate", "user", "stores", "ClubsApiService", "loadSpinnerService"];
    userResolve.$inject = ["AuthService"];
    storesResolve.$inject = ["StadiumStoresApiService"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.templateCopy', {
            url: '/templatecopy',
            views: {
                'main-content': {
                    templateUrl: 'admin/templateCopy/templateCopy.tpl.html',
                    controller: 'TemplateCopyController as vm'
                }
            },
            resolve: {
                user: userResolve,
                stores: storesResolve
            }
        });
    }

    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    function storesResolve(StadiumStoresApiService) {
        return StadiumStoresApiService.getStores();
    }

    // @ngInject
    function TemplateCopyController(toastr, $translate, user, stores, ClubsApiService, loadSpinnerService) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.stores = stores;
        vm.selectedSource = null;
        vm.clubs = null;
        vm.selectedClub = null;
        vm.selectedDestination = null;
        vm.onSelectSource = onSelectSource;
        vm.copy = copy;

        function onSelectSource() {
            vm.clubs = null;
            vm.selectedClub = null;

            ClubsApiService.getAllClubsForStore(vm.selectedSource.storeId).then(function(clubs) {
                vm.clubs = clubs;
            });
        }

        function copy() {
            if(!vm.selectedSource || !vm.selectedDestination) {
                $translate('ADMIN.COPYTEMPLATE.SELECTERROR').then(function (translation) {
                    toastr.error(translation);
                });
                return;
            }
            
            var data = {
                sourceStoreId: vm.selectedSource.storeId,
                destinationStoreId: vm.selectedDestination.storeId,
                clubId: vm.selectedClub != null ? vm.selectedClub.clubId : ''
            };

            loadSpinnerService.start();
            ClubsApiService.copy(data).then(function() {
                $translate('ADMIN.COPYTEMPLATE.SUCCESS').then(function (translation) {
                    toastr.success(translation);
                });
            }, function() {                
                var message = '';
                if(!vm.selectedClub) {
                    message = 'ADMIN.COPYTEMPLATE.STOREERROR';
                } else {
                    message = 'ADMIN.COPYTEMPLATE.CLUBERROR';
                }

                $translate(message).then(function (translation) {
                    toastr.error(translation);
                });                
            }).finally(loadSpinnerService.stop);
        }
    }

    angular
        .module('admin.templateCopy', [])
        .controller('TemplateCopyController', TemplateCopyController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$compileProvider"];
    function stateConfig( $stateProvider, $urlRouterProvider, $compileProvider) {
        $compileProvider.debugInfoEnabled(false);
        $urlRouterProvider.when('', '/');
        $stateProvider.state( 'app', {
            abstract: true,
            url: '',
            data: { pageTitle: 'BAMATEX'}
        });
    }

    angular
        .module( 'app', [
            'app.core',
            'app.admin',
            'app.shop',
            'app.productionPlanning',
            'app.stadium',
            'login'
        ])
        .config(stateConfig);
})();
(function() {

    'use strict';

    // @ngInject
    translationConfig.$inject = ["$translateProvider", "ENV"];
    angularDataConfig.$inject = ["DSProvider", "ENV"];
    errorLogServiceConfig.$inject = ["$provide"];
    exceptionHandler.$inject = ["$delegate", "ErrorLogService"];
    httpProviderConfig.$inject = ["$httpProvider"];
    httpInterceptor.$inject = ["$injector", "$q", "ErrorLogService"];
    tooltipConfig.$inject = ["$tooltipProvider"];
    function translationConfig($translateProvider, ENV) {
        $translateProvider
            .useStaticFilesLoader({
                prefix: ENV.apiEndpoint + 'translations/',
                suffix: ''
            })
            .useSanitizeValueStrategy(null)
            .preferredLanguage('en');
    }

    // @ngInject
    function angularDataConfig(DSProvider,ENV) {
        DSProvider.defaults.baseUrl = ENV.apiEndpoint;
        DSProvider.defaults.imageUrlPrefix = ENV.imageUrlPrefix;
        DSProvider.defaults.oldImageUrlPrefix = ENV.oldImageUrlPrefix;
    }

    // @ngInject
    function errorLogServiceConfig($provide) {
        $provide.decorator("$exceptionHandler",exceptionHandler);
    }

    // @ngInject
    function exceptionHandler($delegate,ErrorLogService)
    {
        return function (exception, cause) {
            ErrorLogService.logException(exception,cause);
            $delegate(exception, cause);
        };
    }

    // @ngInject
    function httpProviderConfig($httpProvider){
        $httpProvider.interceptors.push('httpInterceptor');
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.common = {};
        }
        $httpProvider.defaults.headers.common["Cache-Control"] = "no-cache";
        $httpProvider.defaults.headers.common.Pragma = "no-cache";
    }

    // @ngInject
    function httpInterceptor($injector, $q, ErrorLogService) {
        return {
            responseError: function (rejection) {
                var AuthService = $injector.get('AuthService');
                if(rejection.status === 401 && !rejection.config.ignore401) {
                    AuthService.logOut();
                }

                if(rejection.status !== 401 && rejection.status !== 400)
                {
                    ErrorLogService.logException(new Error('HTTP '+rejection.status+ ' response error'), {
                            config: rejection.config,
                            status: rejection.status
                    });
                }

                return $q.reject(rejection);
            }
        };
    }

    // @ngInject
    function tooltipConfig($tooltipProvider){
        $tooltipProvider.options({
            animation: false,
            popupDelay: 750
        });
        $tooltipProvider.setTriggers({
            'openTrigger': 'closeTrigger'
        });
    }

    angular
        .module('core.config', [])
        .factory('httpInterceptor',httpInterceptor)
        .config(translationConfig)
        .config(angularDataConfig)
        .config(errorLogServiceConfig)
        .config(tooltipConfig)
        .config(httpProviderConfig);
})();

"use strict";

 angular.module('constant', [])

.constant('ENV', {name:'staging',apiEndpoint:'/api/',oldImageUrlPrefix:'',imageUrlPrefix:'',raygunApiKey:'dMEgV3td6HLqkr14YZN15g',version:'1.157.0',stadiumProducts:true})

;
(function() {

    'use strict';

    angular
        .module('app.core', [
            'templates-app',
            'templates-common',
            'errorLog',
            'ui.router',
            'ui.bootstrap',
            'ui.select',
            'toastr',
            'ngCookies',
            'pascalprecht.translate',
            'angular-data.DS',
            'ngTable',
            'angular-ladda',
            'angularSpinner',
            'angularFileUpload',
            'ngMessages',
            'modules',
            'security',
            'services.cookieConsentService',
            'services.confirmDialog',
            'services.colorPickerDialog',
            'services.customerPickerDialog',
            'services.emailDialog',
            'services.savedCartDialog',
            'services.manufacturingDialog',
            'services.backsidePickerDialog',
            'services.templateDialog',
            'services.templatePriceDialog',
            'services.templateCartDialog',
            'services.templatePickerDialog',
            'services.templateErrorDialog',
            'services.logoImageDialog',
            'services.playerGroupDialog',
            'services.textAreaDialog',
            'services.stadiumStockDialog',
            'services.garmentPicker',
            'services.stadiumProductTemplatePickerDialog',
            'printingInformationDialog',
            'uiSelectExtension',
            'constant',
            'validators',
            'validationManager',
            'filters',
            'loadSpinner',
            'manualtooltip',
            'adminInput',
            'updateCartButton',
            'confirmOrderButton',
            'addToCartButton',
            'addToTemplateButton',
            'counter',
            'singleClick',
            'onImageLoad',
            'helper',
            'table',
            'core.init',
            'core.config',
            'angular.filter',
            'focus',
            'color.tools'
        ]);
})();

(function() {

    'use strict';

    // @ngInject
    ResourceInit.$inject = ["DS"];
    function ResourceInit (DS) {
        DS.defineResource({
            name: 'article',
            idAttribute: 'id',
            endpoint: 'articles'
        });

        DS.defineResource({
            name: 'digit',
            idAttribute: 'id',
            endpoint: 'digits'
        });

        DS.defineResource({
            name: 'discount',
            idAttribute: 'articleGroupId',
            endpoint: 'discounts'
        });

        DS.defineResource({
            name: 'customer',
            idAttribute: 'id',
            endpoint: 'customers',
            computed: {
                search: ['id', 'name', function (id, name) {
                    return id + ' ' + name;
                }]
            }
        });
        
        DS.defineResource({
            name: 'cartRow',
            idAttribute: 'id',
            endpoint: 'cart'
        });

        DS.defineResource({
            name: 'user',
            idAttribute: 'userId',
            endpoint: 'users'
        });
    }

    angular
        .module('init.angularData', [])
        .run(ResourceInit);
})();
(function () {

    'use strict';

    // @ngInject
    initializeErrorLogging.$inject = ["ENV", "ErrorLogService"];
    setRootScopeVariables.$inject = ["$rootScope", "$state", "$stateParams", "$location"];
    eventSubscribers.$inject = ["$rootScope", "$state", "loadSpinnerService", "AuthService", "CookieConsentService"];
    function initializeErrorLogging(ENV, ErrorLogService) {
        if (ENV.name !== 'development') {
            ErrorLogService.init({apiKey: ENV.raygunApiKey, version: ENV.version});
        }
    }

    // @ngInject
    function setRootScopeVariables($rootScope, $state, $stateParams, $location) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.go = function (path) {
            $location.path(path);
        };
    }

    function eventSubscribers($rootScope, $state, loadSpinnerService, AuthService, CookieConsentService) {
        $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams, options) {
            e.preventDefault();
            loadSpinnerService.start();
            $rootScope.toState = toState;
            $rootScope.toParams = toParams;

            if (AuthService.isPublicState(toState.name)) {
                next();
                return;
            }

            AuthService.ensureUser().then(function() {
                next();
            }).catch(function () {
                $rootScope.$broadcast('$stateChangeError', toState, toParams, fromState, fromParams);
            });

            function next() {
                $state.go(toState.name, toParams, {notify: false, reload: options.reload}).then(function () {
                    $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                });
            }
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            loadSpinnerService.stop();

            if (angular.isDefined(toState.data.pageTitle)) {
                $rootScope.pageTitle = toState.data.pageTitle;
            }

            if(!AuthService.isPublicState(toState.name)){
                CookieConsentService.tryShowDialog();
            }
        });

        $rootScope.$on('$stateChangeError', function () {
            loadSpinnerService.stop();
        });
    }

    angular
        .module('core.init', ['cookieConsentDialog','init.angularData'])
        .run(initializeErrorLogging)
        .run(setRootScopeVariables)
        .run(eventSubscribers);
})();

(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    LoginController.$inject = ["$state", "AuthService"];
    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            url: '/login',
            controller: 'LoginController',
            data: {pageTitle: 'Login'}
        });
    }

    // @ngInject
    function LoginController($state, AuthService) {
        AuthService.showLogin();
    }

    angular
        .module('login', [])
        .config(stateConfig)
        .controller('LoginController', LoginController);
})();
(function() {

    "use strict";

    // @ngInject
    ErrandProofsDialogController.$inject = ["$modalInstance", "toastr", "$translate", "loadSpinnerService", "ProofsApiService", "errand"];
    function ErrandProofsDialogController($modalInstance, toastr, $translate, loadSpinnerService, ProofsApiService, errand) {
        /* jshint validthis: true */
        var vm = this;
        vm.files = [];
        vm.information = "";
        vm.close = close;
        vm.save = save;
        vm.onFileSelect = onFileSelect;
        vm.isValid = isValid;
        vm.getFileButtonRange = getFileButtonRange;
        vm.removeFile = removeFile;

        function isValid() {
            var result = vm.files && vm.files.length > 0;
            return result;
        }

        function save() {
            var proof = {
                information: vm.information,
                files: vm.files
            };

            loadSpinnerService.start();
            ProofsApiService.createErrandProof(errand.id, proof).then(function() {
                $modalInstance.close();
            }, function(error) {
                $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                    if (error && error.message) {
                        toastr.error(error.message, translation);
                    } else {
                        toastr.error(translation);
                    }
                });
            }).finally(function() {loadSpinnerService.stop();});
        }

        function close() {
            $modalInstance.dismiss();
        }

        function getFileButtonRange() {
            return _.range(vm.files.length + 1);
        }

        function onFileSelect(file) {
            if (validateFile(file)) {
                vm.files.push(file);
            }
        }

        function removeFile(index) {
            vm.files = _.without(vm.files, vm.files[index]);
        }

        function validateFile(file) {
            var result = true;
            if (file.size > 104857600) {
                toastr.error('File size is too large (limit: 100 MB)');
                result = false;
            }
            return result;
        }
    }

    angular
        .module("errandProofsDialog", [])
        .controller("ErrandProofsDialogController", ErrandProofsDialogController);
})();
(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    errandStatusTypesResolve.$inject = ["ProductionTypesApiService"];
    errandTypesResolve.$inject = ["ProductionTypesApiService"];
    resourcesResolve.$inject = ["ResourcesApiService"];
    ErrandsListController.$inject = ["ngTableParams", "$location", "$filter", "$modal", "$scope", "$timeout", "loadSpinnerService", "TableService", "EmailDialogService", "ErrandsApiService", "errandStatusTypes", "errandTypes", "user", "resources"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.errandsList', {
            url: '/errands',
            views: {
                "main-content": {
                    templateUrl: 'productionPlanning/errands/errandsList.tpl.html',
                    controller: 'ErrandsListController as vm'
                }
            },
            resolve: {
                user: userResolve,
                errandStatusTypes: errandStatusTypesResolve,
                errandTypes: errandTypesResolve,
                resources: resourcesResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    //@ngInject
    function errandStatusTypesResolve(ProductionTypesApiService){
        return ProductionTypesApiService.getStatusErrand();
    }

    //@ngInject
    function errandTypesResolve(ProductionTypesApiService){
        return ProductionTypesApiService.getErrandTypes();
    }

    // @ngInject
    function resourcesResolve(ResourcesApiService) {
        return ResourcesApiService.getResources('errand');
    }

    // @ngInject
    function ErrandsListController(
        ngTableParams,
        $location,
        $filter,
        $modal,
        $scope,
        $timeout,
        loadSpinnerService,
        TableService,
        EmailDialogService,
        ErrandsApiService,
        errandStatusTypes,
        errandTypes,
        user,
        resources
    ) {
        /* jshint validthis: true */
        var vm = this;
        var sortBy = {};

        vm.filter = ErrandsApiService.getSavedSearch();
        sortBy = vm.filter.sorting || {};
        vm.errandStatusTypes = errandStatusTypes;
        vm.errandTypes = errandTypes;
        vm.resources = resources;
        selectResource();

        vm.user = user;
        vm.tableParams = {};
        vm.initialized = false;
        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'NAVIGATION.ERRANDS',
                state: null
            }
        ];
        vm.selectErrand = selectErrand;
        vm.openErrandDialog = openErrandDialog;
        vm.onClickClear = onClickClear;
        vm.getStatusClass = getStatusClass;
        vm.getIconClass = getIconClass;
        vm.getIconTitle = getIconTitle;
        vm.toggleTodo = toggleTodo;
        vm.isSelected = isSelected;
        vm.getResourceName = getResourceName;
        vm.onResourceSelect = onResourceSelect;
        vm.getCustomerTitle = getCustomerTitle;
        vm.getRemindUsersClass = getRemindUsersClass;

        activate();

        function activate(){
            /* jshint ignore:start */
            vm.tableParams = new ngTableParams({
                page: vm.filter.page,
                count: 20,
                sorting: vm.filter.sorting
            }, {
                counts: [],
                total: 0, // length of data
                getData: updateTable
            });
            /* jshint ignore:end */
        }

        function getCustomerTitle(errand) {
            return errand.customerId + ' - ' +  errand.customerName;
        }

        function onResourceSelect(item) {
            vm.selectedResource = item;
            vm.filter.resourceId = item.resourceId;
        }

        function selectResource() {
            angular.forEach(vm.resources, function(resource) {
                if (resource.resourceId === vm.filter.resourceId) {
                    vm.selectedResource = resource;
                    return;
                }
            });
        }


        function getResourceName(id) {
            var result = "";
            angular.forEach(resources, function(resource) {
                if (resource.resourceId === id) {
                    result = resource.resourceName;
                }
            });
            return result;
        }

        function getStatusClass(item) {
            var result = 'status';
            if (item.status !== null) {
                var status = item.status.toLowerCase();
                result += ' ' + 'status' + '-' + status;
            }
            return result;
        }

        function getRemindUsersClass(errand) {
            if(_.includes(errand.remindUsers, vm.user.userId)) {
                return 'selected';
            }
        }

        function updateTable($defer, params) {
            loadSpinnerService.start();
            params.generatePagesArray = TableService.generatePagesArray;

            if(!_.isEqual(sortBy, params.sorting())){
                sortBy = params.sorting();
                if(params.page() !== 1){
                    params.page(1);
                }
            }

            ErrandsApiService.getErrands(params.sorting(), params.page(), vm.filter)
            .then(function(response) {
                params.total(response.meta.totalPages * response.meta.pageSize);
                if (!vm.initialized) {
                    vm.initialized = true;
                }
                $defer.resolve(response.errands);
            })
            .finally(function(){ loadSpinnerService.stop();});
        }

        function onClickClear() {
            vm.filter = {};
            vm.filter.errandTypes = [];
            vm.selectedResource = null;
        }

        function selectErrand(errand) {
            $location.path('errands/' + errand.id);
        }

        function openErrandDialog() {
            var errandsDialog = {
                backdrop: "static",
                controller: "ErrandsDialogController as vm",
                templateUrl: "productionPlanning/errands/errandsDialog/errandsDialog.tpl.html",
                resolve: {
                    errand: function() {
                        return {};
                    }
                }
            };
            $modal.open(errandsDialog).result.then(function(errand) {
                EmailDialogService.showErrandEmailDialog({
                    errandId: errand.id,
                    templateName: 'ERRAND',
                    recipient: errand.userId,
                    errandStatus: errand.status
                });
                $timeout(function(){
                    vm.tableParams.reload();
                }, 1000);
            });
        }

        function getIconClass(errand, type) {
            var result = '';
            if (_.includes(errand.errandTypes, type)) {
                if (type === 'PRICE') {
                    result = errand.sentPrice ? "action-done" : "action-todo";
                } else if (type === 'PROOF') {
                    result = "action-todo";
                    angular.forEach(errand.proofs, function(proof) {
                        result = proof.approvalType === 'APPROVED' ? 'action-done' : result;
                    });
                } else {
                    result = errand.status === 'CLOSED' ? "action-done" : "action-todo";
                }
            }
            return result;
        }

        function getIconTitle(errand, type) {
            var iconClass = getIconClass(errand, type).replace('action-', '').toUpperCase();
            var result = $filter('translate')('PRODUCTIONPLANNING.ERRANDTYPE.' + type);
            result = result + ': ' + $filter('translate')('PRODUCTIONPLANNING.ACTION.' + iconClass);
            return result;
        }

        function toggleTodo(item) {
            if (isSelected(item)) {
                vm.filter.errandTypes = _.without(vm.filter.errandTypes, item);
            } else {
                vm.filter.errandTypes.push(item);
            }
        }

        function isSelected(item) {
            return _.includes(vm.filter.errandTypes, item);
        }

        $scope.$watch(function () {
            return angular.toJson(vm.filter);
        }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (vm.tableParams.page() !== 1) {
                    vm.tableParams.page(1);
                }
                if (vm.tableParams.count() !== vm.filter.pageSize) {
                    vm.tableParams.count(vm.filter.pageSize);
                }
                vm.tableParams.reload();
            }
        }, true);
    }

    angular
        .module('productionPlanning.errands', ['errandsDialog', 'tableSort'])
        .controller('ErrandsListController', ErrandsListController)
        .config(stateConfig);
})();

(function() {

    "use strict";

    // @ngInject
    ErrandsDialogController.$inject = ["$modalInstance", "toastr", "$translate", "CustomersApiService", "loadSpinnerService", "$timeout", "ErrandsApiService", "errand", "ResourcesApiService", "ProductionTypesApiService"];
    function ErrandsDialogController($modalInstance, toastr, $translate, CustomersApiService, loadSpinnerService, $timeout, ErrandsApiService, errand, ResourcesApiService, ProductionTypesApiService) {
        /* jshint validthis: true */
        var vm = this;
        vm.isEditing = errand.id;
        vm.selectedCustomer = null;
        vm.selectedEmployee = {};
        vm.selectedResource = null;
        vm.information = "";
        vm.customers = [];
        vm.employees = [];
        vm.selectedErrandTypes = [];
        vm.errandTypes = [];
        vm.files = [];
        vm.tags = [];
        vm.resources = [];
        vm.errand = errand;
        vm.express = false;
        vm.errorMessage = "";
        vm.removeFile = removeFile;
        vm.onCustomerSelect = onCustomerSelect;
        vm.onEmployeeSelect = onEmployeeSelect;
        vm.onFileSelect = onFileSelect;
        vm.onClickClear = onClickClear;
        vm.newTag = newTag;
        vm.close = close;
        vm.save = save;
        vm.getFileButtonRange = getFileButtonRange;
        vm.isValid = isValid;
        vm.toggleErrandTypes = toggleErrandTypes;
        vm.isSelected = isSelected;
        vm.isSelectedEmployeeBlocked = isSelectedEmployeeBlocked;

        activate();

        function activate() {
            ProductionTypesApiService.getErrandTypes().then(function(errandTypes) {
                vm.errandTypes = errandTypes;
            });

            ResourcesApiService.getResources('ERRAND').then(function(resources) {
                vm.resources = resources;
                angular.forEach(vm.resources, function(resource) {
                    if (resource.resourceId === vm.errand.resourceId) {
                        vm.selectedResource = resource;
                    }
                });
            });
            if (vm.isEditing) {
                vm.information = errand.information;
                vm.tags = errand.tags;
                vm.selectedErrandTypes = errand.errandTypes;
                vm.express = errand.express;
            }
            loadSpinnerService.start();
            CustomersApiService.getAll().then(function(customers) {
                vm.customers = customers;

                if(vm.isEditing) {
                    vm.selectedCustomer = _.find(vm.customers, { 'id': vm.errand.customerId });
                    onCustomerSelect(vm.selectedCustomer);
                }

                loadSpinnerService.stop();
                focusSelect('.select-customer');
            });
        }

        function isValid() {
            var result = vm.information;
                result = result && vm.selectedCustomer || result && vm.errand.customerId;
                result = result && vm.selectedEmployee || result && vm.errand.userId;
                result = result && vm.selectedErrandTypes.length > 0;
            return result;
        }

        function save() {
            applyErrandData();
            loadSpinnerService.start();
            var action = vm.isEditing ? ErrandsApiService.updateErrand : ErrandsApiService.createErrand;
            action(vm.errand).then(function(errand) {
                $modalInstance.close(errand);
            }, function(error) {
                if(error && error.statusCode === 409) {
                    $translate(error.message).then(function (translation) {
                        vm.errorMessage = translation;
                    });
                }
                else {
                    $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                        if (error && error.message) {
                            toastr.error(error.message, translation);
                        } else {
                            toastr.error(translation);
                        }
                    });
                }
            }).finally(function() {loadSpinnerService.stop();});
        }

        function applyErrandData() {
            if (!errand.customerId || !errand.userId) {
                vm.errand.customerId = vm.selectedCustomer.id;
                vm.errand.userId = vm.selectedEmployee.id;
            }
            vm.errand.information = vm.information;
            vm.errand.tags = vm.tags;
            vm.errand.files = vm.files;
            vm.errand.resourceId = vm.selectedResource ? vm.selectedResource.resourceId : null;
            vm.errand.errandTypes = vm.selectedErrandTypes;
            vm.errand.express = vm.express;
        }

        function close() {
            if(!vm.isEditing) {
                $modalInstance.dismiss();
            } else {
                $modalInstance.close();
            }
        }

        function onFileSelect(file) {
            if (validateFile(file)) {
                vm.files.push(file);
            }
        }

        function newTag(tag){
            if(tag.length > 20){
                $translate('MESSAGE.MAXTAGLENGTH').then(function (translation) {
                    toastr.error(translation);
                });
                return false;
            }else{
                return tag.replace(',', '');
            }
        }

        function validateFile(file) {
            var result = true;
            if (file.size > 104857600) {
                toastr.error('File size is too large (limit: 100 MB)');
                result = false;
            }
            return result;
        }

        function onCustomerSelect(customer) {
            vm.selectedCustomer = customer;
            loadSpinnerService.start();
            return CustomersApiService.getById(customer.id).then(function(employees) {
                vm.employees = employees || [];
                vm.selectedEmployee = vm.employees.length === 0 ? null : vm.employees[0];
                loadSpinnerService.stop();
                focusSelect('.select-employee');
            });
        }

        function onEmployeeSelect(employee) {
            vm.selectedEmployee = employee;
            $timeout(function() {document.querySelector('.select-information').focus();});
        }

        function isSelectedEmployeeBlocked() {
            return vm.selectedEmployee.blocked;
        }

        function focusSelect(selectClass) {
            var node = document.querySelector(selectClass);
            if (node) {
                var uiSelect = angular.element(node).controller('uiSelect');
                uiSelect.focusser[0].focus();
                uiSelect.activate();
            } else {
                $timeout(function() {focusSelect(selectClass);});
            }
        }

        function getFileButtonRange() {
            return _.range(vm.files.length + 1);
        }

        function toggleErrandTypes(errandType) {
            if (isSelected(errandType)) {
                vm.selectedErrandTypes = _.without(vm.selectedErrandTypes, errandType);
            } else {
                vm.selectedErrandTypes.push(errandType);
            }
        }

        function isSelected(errandType) {
            return _.includes(vm.selectedErrandTypes, errandType);
        }

        function onClickClear() {
            vm.selectedResource = null;
        }

        function removeFile(index) {
            vm.files = _.without(vm.files, vm.files[index]);
        }
    }

    angular
        .module("errandsDialog", [])
        .controller("ErrandsDialogController", ErrandsDialogController);
})();

(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    errandResolve.$inject = ["ErrandsApiService", "$stateParams"];
    resourcesResolve.$inject = ["ResourcesApiService"];
    ErrandsViewController.$inject = ["$state", "$rootScope", "toastr", "user", "errand", "loadSpinnerService", "$modal", "$location", "$timeout", "$window", "CustomersApiService", "ErrandsApiService", "EmailApiService", "ProofsApiService", "DS", "resources", "UsersApiService", "CartApiService", "EmailDialogService", "ConfirmDialogService"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.errandView', {
            url: '/errands/{id}',
            views: {
                "main-content": {
                    templateUrl: 'productionPlanning/errands/errandsView.tpl.html',
                    controller: 'ErrandsViewController as vm'
                }
            },
            resolve: {
                user: userResolve,
                errand: errandResolve,
                resources: resourcesResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function errandResolve(ErrandsApiService, $stateParams) {
        return ErrandsApiService.getErrand($stateParams.id);
    }

    // @ngInject
    function resourcesResolve(ResourcesApiService) {
        return ResourcesApiService.getResources('errand');
    }

    // @ngInject
    function ErrandsViewController(
        $state,
        $rootScope,
        toastr,
        user,
        errand,
        loadSpinnerService,
        $modal,
        $location,
        $timeout,
        $window,
        CustomersApiService,
        ErrandsApiService,
        EmailApiService,
        ProofsApiService,
        DS,
        resources,
        UsersApiService,
        CartApiService,
        EmailDialogService,
        ConfirmDialogService
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.errand = errand;
        vm.resources = resources;
        vm.alerts = [];
        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'NAVIGATION.ERRANDS',
                state: {
                    to: 'app.shop.errandsList'
                }
            },
            {
                displayName: 'NAVIGATION.ERRAND',
                state: null
            }
        ];
        vm.isCustomerBlocked = false;
        vm.files = [];
        vm.addProof = addProof;
        vm.approveProof = approveProof;
        vm.canAddProof = canAddProof;
        vm.canChangeProofStatus = canChangeProofStatus;
        vm.canUndo = canUndo;
        vm.closeErrand = closeErrand;
        vm.deleteDraft = deleteDraft;
        vm.deleteErrand = deleteErrand;
        vm.editErrand = editErrand;
        vm.getAttachmentLink = getAttachmentLink;
        vm.getProofLink = getProofLink;
        vm.getResourceName = getResourceName;
        vm.getStatusClass = getStatusClass;
        vm.hasErrandType = hasErrandType;
        vm.hasEmails = hasEmails;
        vm.hasFiles = hasFiles;
        vm.hasProofWithStatus = hasProofWithStatus;
        vm.isErrandActive = isErrandActive;
        vm.isErrandClosed = isErrandClosed;
        vm.markRead = markRead;
        vm.openEmailDialog = openEmailDialog;
        vm.rejectProof = rejectProof;
        vm.removeFile = removeFile;
        vm.save = save;
        vm.showPriceAlert = showPriceAlert;
        vm.undoProof = undoProof;
        vm.viewEmail = viewEmail;
        vm.viewProof = viewProof;
        vm.remindUser = remindUser;
        vm.getRemindUsersClass = getRemindUsersClass;
        vm.goToPendingOrder = goToPendingOrder;

        activate();

        function goToPendingOrder() {
            var url = $state.href('app.shop.pendingOrderView', { id: vm.errand.pendingOrder });
            $window.open(url, '_blank');
        }

        function activate() {
            vm.alerts = [];
            if (vm.hasProofWithStatus('APPROVED')) {
                vm.alerts = [
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.APPROVEDPROOF1',
                    setActiveCustomer,
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.APPROVEDPROOF2',
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.APPROVEDPROOF3'
                ];
            }
            if (vm.showPriceAlert()) {
                vm.alerts = [
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.PRICEMUSTBESENT1',
                    function () { vm.openEmailDialog('PRICE'); },
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.PRICEMUSTBESENT2',
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.PRICEMUSTBESENT3',
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.PRICEMUSTBESENT4',
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.PRICEMUSTBESENT5',
                    markPriceSent,
                    'PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.PRICEMUSTBESENT6'
                ];
            }
            if (vm.hasProofWithStatus('PENDING')) {
                vm.alerts = ['PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.REJECTEDPROOF'];
            }
            if (!vm.errand.resourceId) {
                vm.alerts = ['PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.NOTASSIGNED'];
            }

            validateCustomer();

            if (vm.isErrandClosed()) {
                vm.alerts = ['PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.CLOSED'];
            }

            setFiles();
        }

        function setFiles() {
            vm.files = [];
            angular.forEach(vm.errand.files, function(file) {
                var fileName = file.filename + "." + file.fileExtension;
                var email = _.find(vm.errand.emails, function (email) {
                    if (email.attachments) {
                        return _.some(Object.keys(email.attachments), function(attachment) {
                            return attachment.name === fileName;
                        });
                    }
                });
                var data = {
                    "name": fileName,
                    "id": file.id
                };
                data.date = file.lastModifiedDate;
                vm.files.push(data);
            });
            vm.files = _.orderBy(vm.files, ['date'],['desc']);
        }

        function validateCustomer() {
            CustomersApiService.getEmployee(vm.errand.customerId, vm.errand.userId).then(function (employee) {
                if (!employee) {
                    vm.alerts = ['PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.INVALIDCONTACT'];
                    vm.errand.userId = "";
                } else {
                    vm.isCustomerBlocked = employee.blocked;
                }
            });
        }

        function markPriceSent() {
            ErrandsApiService.markPriceSent(vm.errand.id).then(function () {
                repopulateView();
            });
        }

        function removeFile(file) {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-success' }];
            ConfirmDialogService.showDialog('PRODUCTIONPLANNING.ERRAND.DELETE1', 'PRODUCTIONPLANNING.ERRAND.DELETE2', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    ErrandsApiService.deleteErrandAttachment(vm.errand.id, file.id).then(function () {
                        repopulateView();
                    }).finally(stopLoading);
                }
            });
        }

        function stopLoading() {
            loadSpinnerService.stop();
        }

        function getResourceName(id) {
            var result = id;
            angular.forEach(vm.resources, function (resource) {
                if (resource.resourceId === id) {
                    result = resource.resourceName;
                }
            });
            return result;
        }

        function getStatusClass(status) {
            var result = 'status';
            if (status) {
                result += ' ' + 'status' + '-' + status.toLowerCase();
            }
            return result;
        }

        function repopulateView() {
            return ErrandsApiService.getErrand(vm.errand.id).then(function (data) {
                vm.errand = data;
                activate();
            });
        }

        function editErrand() {
            var errandsDialog = {
                backdrop: "static",
                controller: "ErrandsDialogController as vm",
                templateUrl: "productionPlanning/errands/errandsDialog/errandsDialog.tpl.html",
                resolve: {
                    errand: function () {
                        return vm.errand;
                    }
                }
            };
            $modal.open(errandsDialog).result
                .finally(function () {
                    repopulateView();
                });
        }

        function closeErrand() {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-success' }];
            ConfirmDialogService.showDialog('PRODUCTIONPLANNING.CLOSEERRAND', 'PRODUCTIONPLANNING.CLOSEERRANDWARNING', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    ErrandsApiService.closeErrand(vm.errand.id).then(function () {
                        $location.path('errands');
                    }).finally(stopLoading);
                }
            });
        }

        function deleteErrand() {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-success' }];
            ConfirmDialogService.showDialog('PRODUCTIONPLANNING.DELETEERRAND', 'PRODUCTIONPLANNING.DELETEERRANDWARNING', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    ErrandsApiService.deleteErrand(vm.errand.id).then(function () {
                        $timeout(function () {
                            $location.path('errands');
                            loadSpinnerService.stop();
                        }, 1000);
                    });
                }
            });
        }

        function viewEmail(email) {
            EmailDialogService.showErrandEmailDialog({
                errandId: vm.errand.id,
                email: email,
                errandStatus: vm.errand.status
            }).then(function () {
                repopulateView();
            });
        }

        function openEmailDialog(templateName) {
            EmailDialogService.showErrandEmailDialog({
                errandId: vm.errand.id,
                templateName: templateName || 'BLANK',
                recipient: vm.errand.userId,
                errandStatus: vm.errand.status
            }).then(function () {
                repopulateView();
            });
        }

        function addProof() {
            var errandsDialog = {
                backdrop: "static",
                controller: "ErrandProofsDialogController as vm",
                templateUrl: "productionPlanning/errands/errandProofsDialog/errandProofsDialog.tpl.html",
                resolve: {
                    errand: function () {
                        return vm.errand;
                    }
                }
            };
            $modal.open(errandsDialog).result.then(function () {
                repopulateView();
                EmailDialogService.showErrandEmailDialog({
                    errandId: vm.errand.id,
                    templateName: 'PROOF',
                    recipient: vm.errand.userId,
                    errandStatus: vm.errand.status
                }).then(function () {
                    repopulateView();
                });
            });
        }

        function viewProof(proof) {
            var viewProofsDialog = {
                backdrop: "static",
                controller: "ViewErrandProofsDialogController as vm",
                templateUrl: "productionPlanning/errands/viewErrandProofsDialog/viewErrandProofsDialog.tpl.html",
                resolve: {
                    proof: function () {
                        return proof;
                    },
                    errand: function () {
                        return vm.errand;
                    }
                }
            };
            $modal.open(viewProofsDialog).result.then(function () {
                repopulateView();
            });
        }

        function getProofLink(proofId) {
            return DS.defaults.baseUrl + 'productionerrands/' + vm.errand.id + '/proofs/' + proofId;
        }

        function approveProof(id) {
            actionProof(ProofsApiService.approveErrandProof, id);
        }

        function rejectProof(id) {
            actionProof(ProofsApiService.rejectErrandProof, id);
        }

        function undoProof(id) {
            actionProof(ProofsApiService.undoErrandProof, id);
        }

        function actionProof(action, id) {
            loadSpinnerService.start();
            action(vm.errand.id, id)
                .then(repopulateView)
                .catch(function (error) {
                    if (error && error.data && error.data.message) {
                        toastr.error(error.data.message);
                    }
                })
                .finally(function () {
                    loadSpinnerService.stop(); 
                });
        }


        function hasFiles() {
            return vm.errand.files && !_.isEmpty(vm.errand.files);
        }

        function getAttachmentLink(fileId) {
            return DS.defaults.baseUrl + 'productionerrands/' + vm.errand.id + '/attachments/' + fileId;
        }

        function isErrandClosed() {
            return vm.errand.status === 'CLOSED';
        }

        function isErrandActive() {
            return vm.errand.status === 'IN_PROGRESS' || vm.errand.status === 'NOT_SENT' || vm.errand.status === 'READY';
        }

        function hasProofWithStatus(status) {
            var result = false;
            angular.forEach(vm.errand.proofs, function (proof) {
                result = result || proof.approvalType === status;
            });
            return result;
        }

        function canAddProof() {
            return isErrandActive() && !hasProofWithStatus('PENDING') && !hasProofWithStatus('APPROVED');
        }


        function canChangeProofStatus(proof) {
            return !isErrandClosed() && !hasProofWithStatus('APPROVED') && proof.approvalType === 'PENDING';
        }

        function canUndo(proof) {
            var result = !isErrandClosed() && proof.approvalType !== 'PENDING';
            if (proof.approvalType !== 'APPROVED') {
                result = result && !hasProofWithStatus('APPROVED') && !hasProofWithStatus('PENDING');
            }
            return result;
        }

        function hasEmails() {
            var emails = vm.errand.emails || [];
            emails = _.filter(emails, function (email) {
                return !email.archived;
            });
            return emails.length > 0;
        }

        function hasErrandType(type) {
            return _.includes(vm.errand.errandTypes, type);
        }

        function showPriceAlert() {
            return vm.errand.resourceId && vm.hasErrandType('PRICE') && !vm.errand.sentPrice;
        }

        function save() {
            vm.errand.files = [];
            ErrandsApiService.updateErrand(vm.errand).then(function () {
                repopulateView();
            });
        }

        function setActiveCustomer() {
            if (!vm.errand.userId || !vm.errand.userName) {
                vm.alerts = ['PRODUCTIONPLANNING.ERRANDSTATUSMESSAGE.INVALIDCONTACT'];
                vm.errand.userId = "";
                return;
            }

            vm.user.orderRecipient = {
                customerId: vm.errand.customerId,
                customerName: vm.errand.customerName,
                userId: vm.errand.userId,
                userName: vm.errand.userName
            };
            UsersApiService.updateSelf(vm.user).then(function (user) {
                CartApiService.getCartRows();
                vm.user = user;
                $state.go('app.shop.customer');
                $rootScope.$broadcast('$orderRecipientChange');
            });
        }

        function markRead(email) {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-success' }];
            ConfirmDialogService.showDialog('PRODUCTIONPLANNING.WARNING.MARKREADTITLE', 'PRODUCTIONPLANNING.WARNING.MARKREADBODY', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    EmailApiService.updateErrandEmail(vm.errand.id, email.id, { read: true }).then(function () {
                        repopulateView();
                    });
                }
            });
        }

        function deleteDraft(email) {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-success' }];
            ConfirmDialogService.showDialog('PRODUCTIONPLANNING.WARNING.DELETETITLE', 'PRODUCTIONPLANNING.WARNING.DELETEBODY', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    EmailApiService.deleteErrandEmail(vm.errand.id, email.id).then(function () {
                        repopulateView();
                    });
                }
            });
        }

        function remindUser() {
            ErrandsApiService.remindErrand(vm.errand.id).then(function () {
                repopulateView();
            });
        }

        function getRemindUsersClass() {
            var result = 'btn';
            if (_.includes(vm.errand.remindUsers, vm.user.userId)) {
                result += ' ' + 'btn-danger';
            } else {
                result += ' ' + 'btn-default';
            }
            return result;
        }
    }



    angular.module('productionPlanning.errandView', ['errandsDialog', 'errandProofsDialog', 'viewErrandProofsDialog', 'tableSort'])
        .controller('ErrandsViewController', ErrandsViewController)
        .config(stateConfig);
})();
(function() {

    "use strict";

    // @ngInject
    ViewErrandProofsDialogController.$inject = ["$modalInstance", "$translate", "DS", "toastr", "errand", "proof", "loadSpinnerService", "ProofsApiService"];
    function ViewErrandProofsDialogController($modalInstance, $translate, DS, toastr, errand, proof, loadSpinnerService, ProofsApiService) {
        /* jshint validthis: true */
        var vm = this;
        vm.files = [];
        vm.errand = errand;
        vm.proof = proof;
        vm.information = proof.information;
        vm.close = close;
        vm.getProofLink = getProofLink;
        vm.save = save;

        function save() {
            var query = {
                information: vm.information
            };

            loadSpinnerService.start();
            ProofsApiService.editErrandProof(vm.errand.errandId, vm.proof.id, query).then(function(proof) {
                var data = {
                    information: proof.information
                };
                $modalInstance.close(data);
            }, function(error) {
                $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                    if (error && error.message) {
                        toastr.error(error.message, translation);
                    } else {
                        toastr.error(translation);
                    }
                });
            }).finally(function() {loadSpinnerService.stop();});
        }

        function getProofLink(proofId, fileId) {
            return DS.defaults.baseUrl + 'productionerrands/' + vm.errand.id + '/proofs/' + proofId + '/' + fileId;
        }

        function close() {
            $modalInstance.close();
        }
    }

    angular
        .module("viewErrandProofsDialog", [])
        .controller("ViewErrandProofsDialogController", ViewErrandProofsDialogController);
})();
(function() {

    'use strict';

    angular
        .module('app.productionPlanning', [
            'productionPlanning.errands',
            'productionPlanning.errandView'
        ]);
})();
(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    articleResolve.$inject = ["ArticlesApiService", "$stateParams"];
    templateResolve.$inject = ["AuthService", "PlacementsApiService"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.articlesList', {
            url: '/articles',
            views: {
                'main-content': {
                    templateUrl: 'shop/articles/articlesList.tpl.html',
                    controller: 'ArticlesListController as vm'
                }
            },
            resolve: {
                user: userResolve,
                template: templateResolve
            }
        });

        $stateProvider.state('app.shop.articleView', {
            url: '/articles/{id}',
            views: {
                'main-content': {
                    templateUrl: 'shop/articles/articleView.tpl.html',
                    controller: 'ArticleViewController as vm'
                }
            },
            resolve: {
                user: userResolve,
                article: articleResolve,
                template: templateResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function articleResolve(ArticlesApiService, $stateParams) {
        return ArticlesApiService.getById($stateParams.id);
    }

    // @ngInject
    function templateResolve(AuthService, PlacementsApiService) {
        return AuthService.getUser()
          .then(function (user) {
              if (user && user.templateId) {
                  return PlacementsApiService.getPlacement(user.templateId);
              }

              return null;
          });
    }

    angular
        .module('shop.articles', [])
        .config(stateConfig);
})();

(function () {

    'use strict';

    // @ngInject
    ArticlesListController.$inject = ["$scope", "$state", "ngTableParams", "loadSpinnerService", "ArticlesApiService", "TableService", "ManufacturingDialogService", "PlacementsApiService", "user", "template"];
    function ArticlesListController(
        $scope,
        $state,
        ngTableParams,
        loadSpinnerService,
        ArticlesApiService,
        TableService,
        ManufacturingDialogService,
        PlacementsApiService,
        user,
        template
    ) {
        /* jshint validthis: true */
        var vm = this;
        var savedSearch = ArticlesApiService.getSavedSearch();
        var initialPage = savedSearch.page;
        var sortBy = savedSearch.sorting || {};

        vm.tableParams = {};
        vm.searchStatus = {};
        vm.initialized = false;
        vm.user = user;
        vm.template = template;
        vm.globalSearch = savedSearch.globalSearch;
        vm.stadiumSearch = savedSearch.stadiumSearch;
        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'NAVIGATION.ARTICLES',
                state: null
            }
        ];
        vm.selectArticle = selectArticle;
        vm.resetSearch = resetSearch;
        vm.updateTableData = updateTableData;
        vm.openManufacturingDialog = openManufacturingDialog;
        vm.isTemplateMode = isTemplateMode;
        vm.isOrderButtonVisible = isOrderButtonVisible;

        activate();

        function activate() {
            vm.searchStatus = {
                page: '1',
                pages: '1',
                active: false
            };
            /* jshint ignore:start */
            vm.tableParams = new ngTableParams({
                page: initialPage,
                globalSearch: savedSearch.globalSearch,
                stadiumSearch: savedSearch.stadiumSearch,
                count: savedSearch.count,
                sorting: savedSearch.sorting
            }, {
                counts: [],
                total: 0, // length of data
                getData: updateTable
            });
            /* jshint ignore:end */
        }

        function updateSearchStatus(meta) {
            var search = ArticlesApiService.getSavedSearch().searchField || '';
            vm.searchStatus.active = search.length > 0;
            vm.searchStatus.page = !meta.page || '0' === meta.page ? '1' : meta.page;
            vm.searchStatus.pages = !meta.totalPages || '0' === meta.totalPages ? '1' : meta.totalPages;
            vm.searchStatus.query = search;
        }

        function resetSearch() {
            ArticlesApiService.getSavedSearch().searchField = '';
            $state.reload();
        }

        function selectArticle(article) {
            $state.go('app.shop.articleView', {id: article.id});
        }

        function updateTableData(params) {
            var stadiumSearch = vm.user.stadium ? params.$params.stadiumSearch : null;

            return ArticlesApiService.getAll(
                params.page(),
                params.sorting(),
                params.$params.globalSearch,
                stadiumSearch
            );
        }

        function updateTable($defer, params) {
            loadSpinnerService.start();
            params.generatePagesArray = TableService.generatePagesArray;

            if (!_.isEqual(sortBy, params.sorting())) {
                sortBy = params.sorting();
                if (params.page() !== 1) {
                    params.page(1);
                    loadSpinnerService.stop();
                    return;
                }
            }

            var stadiumSearch = vm.user.stadium ? params.$params.stadiumSearch : null;
            ArticlesApiService.getAll(
                params.page(),
                params.sorting(),
                params.$params.globalSearch,
                stadiumSearch
            ).then(function (response) {
                params.total(response.meta.totalPages * response.meta.pageSize);
                updateSearchStatus(response.meta);

                // Set starting quantity
                angular.forEach(response.articles, function (article) {
                    article.quantity = article.minimumQuantity;
                });

                if (!vm.initialized) {
                    vm.initialized = true;
                }

                $defer.resolve(response.articles);
            }).then(function () {
                if (vm.user.templateId) {
                    PlacementsApiService.getPlacement(vm.user.templateId)
                      .then(function (template) {
                            vm.template = template;
                      });
                }
            }).finally(function () {
                loadSpinnerService.stop();
            });
        }

        function openManufacturingDialog(article) {
            ManufacturingDialogService.showDialog(article.id).then(function () {
            });
        }

        function isOrderButtonVisible() {
            if (!vm.user || isTemplateMode()) {
                return false;
            }

            if (vm.user.admin) {
                return vm.user.orderRecipient;
            }

            if (vm.user.stadium) {
                return vm.user.orderReference && !isTemplateMode();
            }

            return !vm.user.admin && !vm.user.stadium;
        }

        function isTemplateMode() {
            return vm.user.templateId;
        }

        $scope.$watch(function () {
            return vm.stadiumSearch + ',' + vm.globalSearch + ',' + ArticlesApiService.getSavedSearch().searchField;
        }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.tableParams.$params.globalSearch = vm.globalSearch;
                vm.tableParams.$params.stadiumSearch = vm.stadiumSearch;
                if (vm.tableParams.page() !== 1) {
                    vm.tableParams.page(1);
                }
                if (newValue.split(',')[2] !== oldValue.split(',')[2]) {
                    vm.tableParams.reload();
                }
            }
        });
    }

    angular
        .module('shop.articles')
        .controller('ArticlesListController', ArticlesListController);
})();

(function () {

    'use strict';

    // @ngInject
    ArticleViewController.$inject = ["$modal", "$scope", "$translate", "$state", "loadSpinnerService", "toastr", "ArticlesApiService", "ManufacturingApiService", "ManufacturingDialogService", "StadiumStockApiService", "StadiumStockDialogService", "ConfirmDialogService", "user", "article", "template"];
    function ArticleViewController(
        $modal,
        $scope,
        $translate,
        $state,
        loadSpinnerService,
        toastr,
        ArticlesApiService,
        ManufacturingApiService,
        ManufacturingDialogService,
        StadiumStockApiService,
        StadiumStockDialogService,
        ConfirmDialogService,
        user,
        article,
        template
    ) {
        var vm = this;
        vm.user = user;
        vm.isAdmin = user.admin;
        vm.article = article;
        vm.template = template;
        vm.tags = vm.article.tags;
        vm.article.quantity = vm.article.minimumQuantity;
        vm.stadiumStock = null;
        vm.manufacturingOrders = null;
        vm.imageUrl = ArticlesApiService.getArticleImageUrl(article.id);
        vm.attachmentUrl = ArticlesApiService.getArticleAttachmentUrl(article.id);

        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'NAVIGATION.ARTICLES',
                state: {
                    to: 'app.shop.articlesList'
                }
            },
            {
                displayName: article.id,
                state: null
            }
        ];
        vm.newTag = newTag;
        vm.getPanelSize = getPanelSize;
        vm.getStatusClass = getStatusClass;
        vm.openStadiumStockDialog = openStadiumStockDialog;
        vm.onStockUpdate = onStockUpdate;
        vm.getStatusName = getStatusName;
        vm.isTemplateMode = isTemplateMode;
        vm.isOrderButtonVisible = isOrderButtonVisible;
        vm.isShareButtonVisible = isShareButtonVisible;
        vm.openManufacturingDialog = openManufacturingDialog;
        vm.freezeArticle = freezeArticle;
        vm.shareArticle = shareArticle;
        vm.navigateToTemplate = navigateToTemplate;
        vm.setStocked = setStocked;

        activate();

        function activate() {
            if (vm.user && vm.user.stadium) {
                getStadiumData();
            }
        }

        function getStadiumData() {
            StadiumStockApiService.getStadiumStock(vm.article.id).then(function (stadiumStock) {
                vm.stadiumStock = stadiumStock;
            });
            ManufacturingApiService.getManufacturingOrders(vm.article.id).then(function (manufacturingOrders) {
                vm.manufacturingOrders = manufacturingOrders;
            });
        }

        function onStockUpdate() {
            StadiumStockApiService.getStadiumStock(vm.article.id, true).then(function (stadiumStock) {
                vm.stadiumStock = stadiumStock;
            });
        }

        function newTag(tag) {
            if (tag.length > 20) {
                $translate('MESSAGE.MAXTAGLENGTH').then(function (translation) {
                    toastr.error(translation);
                });
                return false;
            } else {
                if (!_.some(vm.tags, function (existing) {
                        return existing.toLowerCase() === tag.toLowerCase();
                    })) {
                    return tag.replace(',', '');
                } else {
                    return false;
                }
            }
        }

        function getPanelSize() {
            var panels = 1;
            var classes = {};
            var sizes = {
                sm: {
                    1: 'col-sm-12',
                    2: 'col-sm-6',
                    3: 'col-sm-4'
                }
            };

            if (vm.isAdmin) {
                panels++;
            }
            if (vm.article.orderIds && vm.article.orderIds.length > 0) {
                panels++;
            }

            classes[sizes.sm[panels]] = true;
            return classes;
        }

        function getStatusClass(status) {
            return 'status status-' + status;
        }

        function getStatusName(status) {
            return status ? 'STADIUM.SHARED' : 'STADIUM.NOTSHARED';
        }

        function isTemplateMode() {
            return vm.user.templateId;
        }

        function isOrderButtonVisible() {
            if (!vm.user || isTemplateMode()) {
                return false;
            }

            if (vm.user.admin) {
                return vm.user.orderRecipient;
            }

            if (vm.user.stadium) {
                return vm.user.orderReference && !isTemplateMode();
            }

            if (vm.user) {
                return !vm.user.admin && !vm.user.stadium;
            }
        }

        function freezeArticle() {
            var buttons = [{name: 'BUTTON.NO', class: 'btn-default'}, {name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('ARTICLE.DELETE', 'ARTICLE.DELETEDESCRIPTION', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    ArticlesApiService.freezeArticle(article.id).then(function () {
                        vm.article.frozen = true;
                    }, function () {
                        vm.tags = vm.article.tags;
                        $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                            toastr.error(translation);
                        });
                    }).finally(loadSpinnerService.stop);
                }
            });
        }

        function setStocked() {
            StadiumStockApiService.setStocked(article.id).then(function () {
                $state.reload();
            });
        }

        function shareArticle() {
            loadSpinnerService.start();

            var data = {
                articleId: vm.article.id,
                shared: !vm.article.shared
            };
            ArticlesApiService.shareArticle(data).then(function (article) {
                vm.article = article;
                activate();
            }, function (errors) {
                _.each(errors, function (error) {
                    toastr.error($translate.instant('ERROR.' + error.code));
                });
            }).finally(loadSpinnerService.stop);
        }

        function isShareButtonVisible() {
            if (vm.article && vm.article.owner !== null) {
                if (vm.user.stadiumMaster || (vm.user.customerId && vm.user.customerId === vm.article.owner.customerId)) {
                    return true;
                }
            }

            return false;
        }

        function openStadiumStockDialog() {
            StadiumStockDialogService.showDialog(vm.stadiumStock, vm.article.id).then(function () {
                getStadiumData();
            });
        }

        function openManufacturingDialog() {
            ManufacturingDialogService.showDialog(vm.article.id).then(function () {
                getStadiumData();
            });
        }

        function navigateToTemplate() {
            $state.go('app.shop.advancedMounting', {id: vm.user.templateId}, 'AdvancedMountingController');
        }

        $scope.$watch(function () {
            return vm.tags;
        }, function (newVal, oldVal) {
            if (newVal !== oldVal) {
                ArticlesApiService.updateArticle(vm.article.id, {tags: vm.tags}).then(function () {
                    $translate('MESSAGE.SAVESUCCESS').then(function (translation) {
                        toastr.success(translation);
                    });
                }, function () {
                    vm.tags = vm.article.tags;
                    $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                        toastr.error(translation);
                    });
                });
            }
        });
    }

    angular
        .module('shop.articles')
        .controller('ArticleViewController', ArticleViewController);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService", "$state", "loadSpinnerService"];
    CalculatorController.$inject = ["$location", "$translate", "ArticlesApiService", "CalculatorApiService", "user"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.calculator', {
            url: '/',
            views: {
                "main-content": {
                    templateUrl: 'shop/calculator/calculator.tpl.html',
                    controller: 'CalculatorController as vm'
                }
            },
            resolve: {
                user: userResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService, $state, loadSpinnerService) {
        return AuthService.getUser().then(function (user) {
            if (user && user.stadium && !user.admin) {
                loadSpinnerService.stop();
                $state.go('app.shop.stadiumStart');
            }

            return user;
        });
    }

    // @ngInject
    function CalculatorController($location, $translate, ArticlesApiService, CalculatorApiService, user) {
        var vm = this;
        vm.groupTypes = [
            {name: "TRANSFER"},
            {name: "PROFILE"},
            {name: "CONCEPT"}
        ];
        vm.groupType = null;
        vm.productTypes = [];
        vm.productType = null;
        vm.productSubtype = null;
        vm.prices = null;
        vm.costs = null;
        vm.height = "";
        vm.width = "";
        vm.stitchCount = "";
        vm.process = null;
        vm.express = null;
        vm.numberOfColours = "";
        vm.numberOfSpecialColours = "";
        vm.numbersDropdown = [];
        vm.specialNumbersDropdown = [];
        vm.user = user;
        vm.startCost = null;
        vm.colourCost = null;
        vm.expressCost = null;
        vm.errorMessage = "";
        vm.isLocked = isLocked;
        vm.isAdmin = isAdmin;
        vm.onProductGroupSelect = onProductGroupSelect;
        vm.onProductTypeSelect = onProductTypeSelect;
        vm.onProductSubtypeSelect = onProductSubtypeSelect;
        vm.onTotalColoursSelect = onTotalColoursSelect;
        vm.calculatePrice = calculatePrice;
        vm.isNumberOfColoursVisible = isNumberOfColoursVisible;
        vm.isNumberOfSpecialColoursVisible = isNumberOfSpecialColoursVisible;
        vm.isStitches = isStitches;
        vm.hasProcess = hasProcess;
        vm.clearColors = clearColors;
        vm.onExpress = onExpress;
        vm.isCostsVisible = isCostsVisible;
        vm.getExampleImage = getExampleImage;

        function hasProcess() {
            return vm.productSubtype && vm.productSubtype.processPrefix && vm.productSubtype.processPrefix.length > 0;
        }

        function clearColors() {
            vm.numberOfColours = "";
        }

        function isAdmin() {
            return vm.user && vm.user.admin;
        }

        function isLocked() {
            if(vm.user === null){
                return true;
            }
            return isAdmin() && !vm.user.orderRecipient;
        }

        function onProductGroupSelect(selectedGroup) {
            vm.groupType = selectedGroup;
            vm.productType = null;
            vm.productSubtype = null;
            vm.numberOfSpecialColours = "";
            ArticlesApiService.getProductTypes(selectedGroup.name).then(function(data) {
               vm.productTypes = data;
            });
            calculatePrice();
        }

        function onProductTypeSelect(selectedType) {
            vm.prices = null;
            vm.startCost = null;
            vm.colourCost = null;
            vm.process = false;
            vm.numberOfSpecialColours = "";
            vm.productType = selectedType;
            vm.productSubtype = vm.productType.productSubtypes.length === 1 ? vm.productType.productSubtypes[0] : null;

            if(isStitches()) {
                vm.width = "";
                vm.height = "";
            } else {
                vm.stitchCount = "";
            }
            setNumberOfColours();
            fillColourDropdown();
            calculatePrice();
        }

        function onProductSubtypeSelect(selectedSubtype) {
            vm.productSubtype = selectedSubtype;
            setNumberOfColours();
            fillColourDropdown();
            calculatePrice();
        }

        function onTotalColoursSelect() {
            if(vm.numberOfSpecialColours !== "") {
                vm.numberOfSpecialColours = "";
            }
            fillSpecialColourDropdown();
            calculatePrice();
        }

        function setNumberOfColours() {
            vm.numberOfColours = isNumberOfColoursVisible() ? "" : "0";
            if(vm.productSubtype && vm.productSubtype.exactColourCount) {
                vm.numberOfColours = vm.productSubtype.exactColourCount;
            }
        }

        function isNumberOfColoursVisible() {
            var result = vm.productType && vm.productType.maxColourCount > 0;
            result = result && vm.productSubtype && !vm.productSubtype.exactColourCount;
            result = result && !vm.productType.countStitches && !vm.productType.mounting;
            return result;
        }

        function isNumberOfSpecialColoursVisible() {
            return vm.productType && vm.productType.debitSpecialColours;
        }

        function isStitches() {
            return vm.productType && vm.productType.countStitches;
        }

        function isPresent(value) {
            return (typeof value !== 'undefined') && value !== null && value.length > 0 && value !== "" && value !== "0";
        }

        function onExpress() {
            vm.expressCost = "";
            calculatePrice();
        }

        function calculatePrice() {
            var query = {
                productGroup: vm.groupType ? vm.groupType.name : null,
                productType: vm.productType ? vm.productType.name : null,
                productSubtype: vm.productSubtype ? vm.productSubtype.name : null,
                width: vm.width ? vm.width : "",
                height: vm.height ? vm.height : "",
                numberOfColours: vm.numberOfColours ? vm.numberOfColours : "0",
                numberOfSpecialColours: vm.numberOfSpecialColours ? vm.numberOfSpecialColours : "0",
                stitchCount: vm.stitchCount ? vm.stitchCount : "",
                process: vm.process,
                express: vm.express ? vm.express : null
            };

            if (isQueryFilled(query)) {
                vm.errorMessage = "";

                CalculatorApiService.calculatePrice(query).then(function(data) {
                    if(!data.valid) {
                        vm.prices = null;
                        vm.expressCost = null;
                        vm.colourCost = null;
                        vm.startCost = null;
                        if(data.size && data.maxSize && !query.stitchCount) {
                            $translate('CALCULATOR.ERROR.SIZE').then(function(translation) {
                                vm.errorMessage = translation.replace('%s', data.size).replace('%s', data.maxSize);
                            });
                        }
                        else if(data.size && data.maxSize && query.stitchCount) {
                            $translate('CALCULATOR.ERROR.STITCHES').then(function(translation) {
                                vm.errorMessage = translation.replace('%s', data.size).replace('%s', data.maxSize);
                            });
                        }
                        else {
                            $translate('CALCULATOR.ERROR').then(function(translation) {
                                vm.errorMessage = translation;
                            });
                        }
                    } else {
                        vm.prices = data.prices;
                        vm.expressCost = data.expressCost;
                        vm.colourCost = data.colourCost;
                        vm.startCost = data.startCost;
                    }
                });
            } else {
                vm.prices = null;
                vm.errorMessage = "";
            }
        }

        function isQueryFilled(query) {
            var queryFilled = query.productGroup !== null && query.productType !== null && query.productSubtype !== null;
            if (isNumberOfColoursVisible() && !vm.process) {
                queryFilled = queryFilled && isPresent(query.numberOfColours);
            }
            if (isStitches()) {
                queryFilled = queryFilled && isPresent(query.stitchCount);
            } else {
                queryFilled = queryFilled && isPresent(query.width) && isPresent(query.height);
            }
            return queryFilled;
        }

        function fillColourDropdown() {
            vm.numbersDropdown = [];
            for (var i = vm.productType.minColourCount; i <= vm.productType.maxColourCount; i++) {
                vm.numbersDropdown.push(i + '');
            }
        }

        function fillSpecialColourDropdown() {
            vm.specialNumbersDropdown = [];
            for (var i = 0; i <= vm.numberOfColours; i++) {
                vm.specialNumbersDropdown.push(i + '');
            }
        }

        function isCostsVisible() {
            var result = vm.prices;
            result = result && (vm.colourCost || vm.startCost || vm.expressCost);
            return result;
        }

        function getExampleImage() {
            var base = "productTypeImages/";
            if(vm.productType && vm.productType.exampleImage) {
                return base + vm.productType.name + ".png";
            }
        }
    }

    angular
        .module('shop.calculator', [])
        .controller('CalculatorController', CalculatorController)
        .config(stateConfig);
})();
(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    cartRowsResolve.$inject = ["CartApiService"];
    userResolve.$inject = ["AuthService"];
    warningsResolve.$inject = ["PlacementOrderApiService"];
    CartController.$inject = ["$scope", "$modal", "$filter", "$state", "$translate", "DS", "loadSpinnerService", "HelperService", "CartApiService", "PlacementsApiService", "ConfirmDialogService", "PlacementOrderApiService", "ManufacturingDialogService", "BacksidePickerDialogService", "PlayerDialogService", "ValidationManager", "rows", "user", "warnings"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.cart', {
            url: '/cart',
            views: {
                'main-content': {
                    templateUrl: 'shop/cart/cart.tpl.html',
                    controller: 'CartController as vm'
                }
            },
            resolve: {
                rows: cartRowsResolve,
                user: userResolve,
                warnings: warningsResolve
            }
        });
    }

    // @ngInject
    function cartRowsResolve(CartApiService) {
        return CartApiService.getCartRows();
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function warningsResolve(PlacementOrderApiService) {
        return PlacementOrderApiService.getWarnings();
    }

    // @ngInject
    function CartController(
        $scope,
        $modal,
        $filter,
        $state,
        $translate,
        DS,
        loadSpinnerService,
        HelperService,
        CartApiService,
        PlacementsApiService,
        ConfirmDialogService,
        PlacementOrderApiService,
        ManufacturingDialogService,
        BacksidePickerDialogService,
        PlayerDialogService,
        ValidationManager,
        rows,
        user,
        warnings
    ) {
        /* jshint validthis: true */
        var vm = this;
        var listener = null;
        vm.user = user;
        vm.isAdmin = user.admin;
        vm.isStadium = user.stadium;
        vm.activeRowId = null;
        vm.isDirty = false;
        vm.isValid = false;
        vm.frozenArticles = [];
        vm.backsideArticles = [];
        vm.getSortedCartRows = getSortedCartRows;
        vm.canDeleteRow = canDeleteRow;
        vm.deleteRow = deleteRow;
        vm.updateCart = updateCart;
        vm.formatCurrency = formatCurrency;
        vm.openRowText = openRowText;
        vm.openCartWarningsModal = openCartWarningsModal;
        vm.hasRowText = hasRowText;
        vm.showCost = showCost;
        vm.confirm = confirm;
        vm.editMounting = editMounting;
        vm.editNewLogo = editNewLogo;
        vm.setActiveRow = setActiveRow;
        vm.selectArticle = selectArticle;
        vm.needsAttention = needsAttention;
        vm.isProblem = isProblem;
        vm.isShortage = isShortage;
        vm.isManufacturingAvailable = isManufacturingAvailable;
        vm.openPlayerListDialog = openPlayerListDialog;
        vm.openManufacturingDialog = openManufacturingDialog;
        vm.openBacksidePickerDialog = openBacksidePickerDialog;
        vm.isArticleFrozen = isArticleFrozen;
        vm.viewPlayerList = viewPlayerList;
        vm.isOrderManufacturingDisabled = isOrderManufacturingDisabled;
        vm.isArticleWithBackside = isArticleWithBackside;
        vm.getArticles = getArticles;
        vm.openBacksidePickerDialogWithArticleId = openBacksidePickerDialogWithArticleId;

        activate();

        function activate() {
            setWarnings(warnings);
            watchForDirtyFields();
            vm.cart = getCart();

            CartApiService.getCartInfo().then(function (info) {
                vm.cart.info = info;
            });
        }

        function getWarnings() {
            PlacementOrderApiService.getWarnings().then(function (warnings) {
                setWarnings(warnings);
            });
        }

        function setWarnings(warnings) {
            vm.warnings = warnings.mountingShortages;
            vm.frozenArticles = warnings.frozenArticles;
            vm.backsideArticles = warnings.backsideArticles;
            vm.shortages = warnings.stockShortages;
            vm.minimumShortages = warnings.minimumStockShortages;
            vm.nameProblems = warnings.nameShortages;
            vm.hasWarnings = vm.warnings.length > 0;
            vm.hasShortages = vm.shortages.length > 0;
            vm.hasMinimumShortages = vm.minimumShortages.length > 0;
            vm.hasNameProblems = vm.nameProblems.length > 0;

        }

        function getCart() {
            return {
                rows: angular.copy(rows),
                costs: angular.copy(CartApiService.getCartCosts()),
                meta: CartApiService.getCartMeta()
            };
        }

        function getSortedCartRows() {
            _.forEach(vm.cart.rows, function(row) {
                if (isArticleWithBackside(row.article.id)) {
                }
            });
            if (vm.isStadium) {
                return _.sortBy(vm.cart.rows, ['article.id']);
            }
            return vm.cart.rows;
        }

        function removeDeletedRows() {
            var result = false;
            // Get any deletions diffs between the current list and data store
            var diffs = HelperService.createArrayDiffs(vm.cart.rows, DS.filter('cartRow'), 'id');
            // Remove any rows that are marked as deleted
            _.forEach(diffs, function (diff) {
                if (diff.changeType() === 1) {
                    vm.cart.rows.splice(diff.position, 1);
                    result = true;
                }
            });
            return result;
        }

        function watchForDirtyFields() {
            // Destroy current listener
            if (listener !== null) {
                listener();
            }

            // Watch the quantity for any changes
            listener = $scope.$watch(function () {
                return vm.cart;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    // Check if any quantity fields are dirty
                    vm.isDirty = !_.isEmpty(getUpdatedFields()) || !_.isEmpty(getUpdatedCosts());
                    validate();
                }
            }, true);
        }

        function updateCart() {
            var cartUpdate = getCartUpdate();
            loadSpinnerService.start();
            CartApiService.updateCart(cartUpdate)
                .then(function (updatedRows) {
                    rows = updatedRows;
                    vm.cart = getCart();
                    getWarnings();
                }).then(function () {
                return CartApiService.getCartInfo()
                    .then(function (info) {
                        vm.cart.info = info;
                    });
            }).catch(function (error) {
                if (error) {
                    ValidationManager.handleResponseError(error);
                    throw error;
                }
            }).finally(stopLoading);
        }

        function deleteRow(row) {
            if (!canDeleteRow(row)) {
                return;
            }

            var buttons = [{name: 'BUTTON.NO', class: 'btn-default'}, {name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('CART.DELETE1', 'CART.DELETE2', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    CartApiService.deleteCartRow(row.id)
                        .then(function () {
                            updateCart();
                            getWarnings();
                        })
                        .catch(function (error) {
                            if (error) {
                                ValidationManager.handleResponseError(error);
                                throw error;
                            }
                        })
                        .finally(stopLoading);
                }
            });
        }

        function confirm() {
            if (!checkMinimumShortages()) {
                return;
            }

            checkout();
        }

        function checkMinimumShortages() {
            if (vm.minimumShortages.length) {
                var buttons = [{name: 'BUTTON.NO', class: 'btn-default'}, {name: 'BUTTON.YES', class: 'btn-success'}];
                ConfirmDialogService.showDialog('CART.MINIMUMSTOCK1', 'CART.MINIMUMSTOCK2', buttons).then(function (button) {
                    if (button.name === 'BUTTON.YES') {
                        checkout();
                    }
                });

                return false;
            }

            return true;
        }

        function checkout() {
            if (!vm.isValid || vm.isDirty || needsAttention()) {
                return;
            }

            var checkoutDialog = {
                backdrop: 'static',
                controller: 'CheckoutDialogController as vm',
                templateUrl: 'shop/cart/checkoutDialog/checkoutDialog.tpl.html',
                resolve: {
                    deliveryAddresses: function () {
                        return CartApiService.getDeliveryAddresses();
                    },
                    standardAddress: function () {
                        return CartApiService.getStandardAddress();
                    },
                    stadiumAddress: function () {
                        if (vm.user.stadium) {
                            return CartApiService.getStadiumAddress();
                        }
                        return null;
                    },
                    cart: function () {
                        return vm.cart;
                    },
                    nonWorkingDays: function () {
                        return CartApiService.getNonWorkingDays();
                    }
                }
            };
            $modal.open(checkoutDialog);
        }

        function stopLoading() {
            loadSpinnerService.stop();
        }

        function validate() {
            vm.isValid = vm.cart.rows.every(function (row) {
                // Skip mounting rows since they don't use quantity.
                if (row.mounting !== null) {
                    return true;
                }

                return parseInt(row.quantity) >= parseInt(row.article.minimumQuantity) ||
                    parseInt(row.manufacturingQuantity) >= parseInt(row.article.minimumQuantity);
            });
        }

        function getCartUpdate() {
            var data = {
                rows: getUpdatedFields(),
                costs: getUpdatedCosts()
            };
            return data;
        }

        function getUpdatedCosts() {
            var updatedCosts = [];
            var originalCosts = getCart().costs;
            angular.forEach(vm.cart.costs, function (cost) {
                var dirtyField = angular.copy(cost);
                var pureField = _.find(originalCosts, {'type': dirtyField.type});
                var changedData = HelperService.getChangedData(pureField, dirtyField, ['adminPrice', 'adminDiscount']);
                if (!_.isEmpty(changedData)) {
                    changedData.type = cost.type;
                    updatedCosts.push(changedData);
                }
            });
            return updatedCosts;
        }

        function getUpdatedFields() {
            var updatedFields = [];
            var originalRows = getCart().rows;
            // Add any updated field to array
            angular.forEach(vm.cart.rows, function (row) {
                var dirtyField = angular.copy(row);
                dirtyField = getComparisonRow(dirtyField);
                var pureField = _.find(originalRows, {'id': dirtyField.id});
                if (pureField) {
                    var changedData = HelperService.getChangedData(
                        getComparisonRow(pureField),
                        dirtyField,
                        ['quantity', 'manufacturingQuantity', 'express', 'adminPrice', 'adminDiscount', 'instruction']
                    );
                    if (!_.isEmpty(changedData)) {
                        changedData.id = row.id;
                        updatedFields.push(changedData);
                    }
                }
            });
            return updatedFields;
        }

        function getComparisonRow(row) {
            row.quantity = row.quantity.toString();
            row.adminPrice = row.adminPrice || '';
            row.adminDiscount = row.adminDiscount || '';
            row.instruction = row.instruction || '';
            row.express = !!row.express;
            return row;
        }

        function formatCurrency(amount) {
            var result = $filter('currency')(amount, '');
            result = result.replace(',', ' ');
            result = result.replace('.', ',');
            return vm.cart.meta.currencyPrefix + result + vm.cart.meta.currencySuffix;
        }

        function openRowText(row) {
            var cartRowTextDialog = {
                backdrop: 'static',
                controller: 'CartRowTextDialogController as vm',
                templateUrl: 'shop/cart/cartRowTextDialog/cartRowTextDialog.tpl.html',
                resolve: {
                    row: function () {
                        return row || {};
                    }
                }
            };

            $modal.open(cartRowTextDialog).result.then(function (isDirty) {
                if (isDirty) {
                    updateCart();
                }
            });
        }

        function openCartWarningsModal() {
            var cartWarningsDialog = {
                backdrop: 'static',
                controller: 'CartWarningsDialogController as vm',
                templateUrl: 'shop/cart/cartWarningsDialog/cartWarningsDialog.tpl.html',
                size: 'lg',
                windowClass: 'cart-warnings-dialog',
                resolve: {
                    warnings: function () {
                        return vm.warnings;
                    }
                }
            };

            $modal
                .open(cartWarningsDialog)
                .result
                .then(function () {
                    updateCart();
                });
        }

        function setActiveRow(id) {
            vm.activeRowId = id === vm.activeRowId ? null : id;
        }

        function hasRowText(row) {
            return row.instruction && row.instruction.trim().length > 0;
        }

        function showCost(cost) {
            return vm.isAdmin || cost.includeIfZero || cost.rowPrice !== '0.00';
        }

        function canDeleteRow(deleteRow) {
            var result = true;
            angular.forEach(vm.cart.rows, function (loopRow) {
                result = result && (!loopRow.mounting || loopRow.mounting.mountingArticleId !== deleteRow.id);
            });
            return result;
        }

        function editMounting(placementId) {
            loadSpinnerService.start();
            PlacementsApiService.openTemplate(placementId)
                .then(function () {
                    return $state.go('app.shop.advancedMounting', {id: placementId});
                })
                .finally(function () {
                    loadSpinnerService.stop();
                });
        }

        function editNewLogo(row) {
            $state.go('app.shop.edit', {
                articleGroup: row.article.productGroup,
                logoId: row.id
            });
        }

        function selectArticle(id) {
            $state.go('app.shop.articleView', {id: id});
        }

        function needsAttention() {
            return vm.hasWarnings || vm.hasShortages || vm.frozenArticles.length > 0 || vm.backsideArticles.length > 0;
        }

        function isProblem(articleId) {
            var some = _.some(vm.shortages, {'id': articleId});
            var minimum = _.some(vm.minimumShortages, {'id': articleId});
            var includes = _.includes(vm.nameProblems, articleId);
            var frozen = isArticleFrozen(articleId);
            var backside = isArticleWithBackside(articleId);

            return some || minimum || includes || frozen || backside;
        }

        function isShortage(articleId) {
            var shortages = _.some(vm.shortages, {'id': articleId});
            var minimum = _.some(vm.minimumShortages, {'id': articleId});

            return shortages || minimum;
        }

        function openPlayerListDialog(mounting) {
            PlayerDialogService.showDialog(mounting.playerListId)
                .then(function (playerList) {
                    return PlacementsApiService.setPlayerListOnTemplate(mounting.placementId, playerList.playerListId);
                })
                .then(function () {
                    var placementOrder = {
                        placementId: mounting.placementId,
                        quantity: null
                    };

                    return PlacementOrderApiService.updatePlacementInCart(placementOrder);
                })
                .then(function () {
                    $state.reload();
                })
                .catch(function (error) {
                    if (error) {
                        ValidationManager.handleResponseError(error);
                        throw error;
                    }
                });
        }

        function viewPlayerList(playerListId) {
            return PlayerDialogService.showDialog(playerListId, true);
        }

        function openManufacturingDialog(cartRow) {
            ManufacturingDialogService.showCartDialog(cartRow.article.id, cartRow.quantity)
                .then(function (result) {
                    if (result) {
                        cartRow.manufacturingQuantity = result.quantity;
                        cartRow.quantity = result.quantity;
                    }

                    updateCart();
                });
        }

        function openBacksidePickerDialog(cartRow) {
            BacksidePickerDialogService.showDialog(cartRow.article.id, cartRow.quantity, cartRow.manufacturingQuantity)
                .then(function (response) {
                    vm.selectedBacksides = response.selectedBacksides;
                    addBacksidesToCart(response.article);
                });
        }

        function openBacksidePickerDialogWithArticleId(articleId) {
            var row = findFirstRowWithArticle(articleId);
            
            if (!!row) {
                openBacksidePickerDialog(row);
            }
        }

        function addBacksidesToCart(article) {
            loadSpinnerService.start();

            var backsides = [];
            var instructions = " " + $translate.instant('CREATEARTICLE.BACKSIDES').toLowerCase() + " "  + $translate.instant('GENERAL.FOR') + " " + article.id;
            _.each(vm.selectedBacksides, function (backside) {
                if (backside.id !== 0) {
                    backsides.push({ id: backside.id, quantity: backside.quantity, instructions: backside.quantity += instructions });
                }
            });
            
            var data = {
                backsides: JSON.stringify(backsides),
                express: false
            };
            CartApiService.addBacksides(data)
                .then(function (updatedRows) {
                    rows = updatedRows;
                    vm.cart = getCart();
                    getWarnings();
                }).then(function () {
                return CartApiService.getCartInfo()
                    .then(function (info) {
                        vm.cart.info = info;
                    });
            }).catch(function (error) {
                if (error) {
                    ValidationManager.handleResponseError(error);
                    throw error;
                }
            }).finally(stopLoading);
        }

        function isManufacturingAvailable(cartRow) {
            if (vm.isShortage(cartRow.article.id)) {
                return true;
            }
            if (cartRow.article.stocked && cartRow.article.canAdjust) {
                return true;
            }
            if (cartRow.manufacturingQuantity > 0 && cartRow.article.id !== '') {
                return true;
            }

            return false;
        }

        function isOrderManufacturingDisabled(cartRow) {
            if (isArticleFrozen(cartRow.id)) {
                return true;
            }

            if (!cartRow.article.canOrderManufacturing){
                return true;
            }

            if (cartRow.article.canAdjust || cartRow.article.canOrderManufacturing) {
                return false;
            }

            return true;
        }

        function isArticleFrozen(articleId) {
            return _.includes(vm.frozenArticles, articleId);
        }

        function isArticleWithBackside(articleId) {
            return _.includes(vm.backsideArticles, articleId);
        }

        function findFirstRowWithArticle(articleId) {
            return _.find(vm.cart.rows, function(row) {
                if (!!row.article) {
                    if (row.article.id === articleId && articleId.length > 0) {
                        return row;
                    }
                }
            });
        }

        function getArticles() {
            return _.map(vm.cart.rows, 'article.id');
        }


        // Watch the data store for any edits to cart rows
        $scope.$watch(function () {
            return DS.lastModified('cartRow');
        }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                var removedRows = removeDeletedRows();
                if (!removedRows) {
                    vm.cart.rows = angular.copy(DS.filter('cartRow'));
                    vm.isDirty = false;
                    watchForDirtyFields();
                }
            }
        });
    }

    angular
        .module('shop.cart', [
            'checkoutDialog',
            'cartRowTextDialog',
            'cartWarningsDialog'
        ])
        .controller('CartController', CartController)
        .config(stateConfig);
})();

(function() {
    'use strict';

    // @ngInject
    CartRowTextDialogController.$inject = ["$modalInstance", "row"];
    function CartRowTextDialogController ($modalInstance, row) {
        var vm = this;
        vm.row = row;
        vm.instruction = row.instruction || '';
        vm.clear = clear;
        vm.cancel = cancel;
        vm.save = save;

        function clear() {
            vm.instruction = '';
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function save() {
            var isDirty = vm.row.instruction !== vm.instruction;
            vm.row.instruction = vm.instruction.trim();
            $modalInstance.close(isDirty);
        }
    }

    angular
        .module('cartRowTextDialog', [])
        .controller('CartRowTextDialogController', CartRowTextDialogController);
})();

(function() {
    'use strict';

    // @ngInject
    CartWarningsDialogController.$inject = ["$modalInstance", "warnings"];
    function CartWarningsDialogController ($modalInstance, warnings) {
        var vm = this;
        vm.warnings = warnings;
        vm.quantity = "";
        vm.close = close;
        vm.getArticle = getArticle;

        getArticle();

        function close() {
            $modalInstance.close();
        }

        function getArticle() {
            _.forEach(warnings, function(warning) {
                warning.quantity = warning.requiredQuantity - warning.currentQuantity;
                warning.minimumQuantity = warning.quantity;
                warning.setManufacturingQuantity = warning.manufacturingQuantity;
            });
        }
    }

    angular
        .module('cartWarningsDialog', [])
        .controller('CartWarningsDialogController', CartWarningsDialogController);
})();

(function () {

    "use strict";

    // @ngInject
    CheckoutDialogController.$inject = ["$modalInstance", "$state", "$filter", "$rootScope", "$translate", "toastr", "CartApiService", "AuthService", "CountriesApiService", "PlacementsApiService", "loadSpinnerService", "deliveryAddresses", "standardAddress", "stadiumAddress", "cart", "nonWorkingDays"];
    function CheckoutDialogController(
        $modalInstance,
        $state,
        $filter,
        $rootScope,
        $translate,
        toastr,
        CartApiService,
        AuthService,
        CountriesApiService,
        PlacementsApiService,
        loadSpinnerService,
        deliveryAddresses,
        standardAddress,
        stadiumAddress,
        cart,
        nonWorkingDays
    ) {
        /* jshint validthis: true */
        var vm = this;

        vm.files = [];
        vm.confirmError = "";
        vm.showErrors = false;
        vm.sendCustomerConfirmation = true;
        vm.cart = cart;
        vm.nonWorkingDays = nonWorkingDays;
        vm.order = {};
        vm.params = {};
        vm.deliveryDate = {};
        vm.contentTemplate = "shop/cart/checkoutDialog/checkoutDialogConfirmation.tpl.html";
        vm.currentPhase = 0;
        vm.lastPhase = 3;
        vm.radioAddress = "radioAddressStandard";
        vm.savedAddresses = deliveryAddresses || [];
        vm.standardAddress = standardAddress;
        vm.stadiumAddress = stadiumAddress;
        vm.stadiumInvoice = "radioStadiumInvoiceStore";
        vm.stadiumPayment = "radioStadiumPaymentStore";
        vm.onCountrySelect = onCountrySelect;
        vm.confirm = confirm;
        vm.cancel = cancel;
        vm.continueButton = continueButton;
        vm.isNoAddressSelected = isNoAddressSelected;
        vm.resetErrors = resetErrors;
        vm.resetForm = resetForm;
        vm.changePhase = changePhase;
        vm.isFirstPhase = isFirstPhase;
        vm.isLastPhase = isLastPhase;
        vm.isDateDisabled = isDateDisabled;
        vm.isAdmin = isAdmin;
        vm.onFileSelect = onFileSelect;
        vm.removeFile = removeFile;
        vm.getFileButtonRange = getFileButtonRange;
        vm.validateFile = validateFile;
        vm.onSelectSavedAddress = onSelectSavedAddress;
        vm.removeAddress = onRemoveAddress;
        vm.isSelectedAddressChanged = isSelectedAddressChanged;


        initialise();

        function initialise() {
            setDeliveryDate();
        }

        AuthService.getUser().then(function (user) {
            vm.user = user;
            vm.changePhase(0);
            vm.params = {
                reference: "",
                instructions: "",
                deliveryDate: "",
                recipient: "",
                line1: user.stadium ? "" : "Att: ",
                line2: "",
                postCode: "",
                city: "",
                countryCode: "",
                ignoreCustomerNotification: false
            };

            for (var iterator in vm.savedAddresses) {
                vm.savedAddresses[iterator].displayName = vm.savedAddresses[iterator].recipient + ", " + (vm.user.stadium ? vm.savedAddresses[iterator].line1 : vm.savedAddresses[iterator].line2);
            }

            if (vm.user.stadium) {
                vm.radioAddress = "radioAddressStadium";
            }

            if (vm.user.stadiumMaster) {
                vm.stadiumInvoice = "radioStadiumInvoiceSolutions";
                vm.stadiumPayment = "radioStadiumPaymentTeamSales";
            }

        });

        CountriesApiService.getCountries().then(function (countries) {
            vm.countries = countries;
            for (var country in countries) {
                if (countries[country].code === '') {
                    vm.selectedCountry = countries[country];
                }

                if (vm.standardAddress.countryCode === countries[country].code) {
                    vm.standardAddress.countryName = countries[country].name;
                }

                if (vm.user.stadium && vm.stadiumAddress.countryCode === countries[country].code) {
                    vm.stadiumAddress.countryName = countries[country].name;
                }
            }
        });

        function onRemoveAddress(address) {
            CartApiService.deleteAddress(address).then(function () {
                vm.savedAddresses = _.without(vm.savedAddresses, address);
                resetForm();
            });
        }

        function isSelectedAddressChanged() {
            return vm.selectedAddress.recipient !== vm.params.recipient ||
                vm.selectedAddress.line1 !== vm.params.line1 ||
                vm.selectedAddress.line2 !== vm.params.line2 ||
                vm.selectedAddress.postCode !== vm.params.postCode ||
                vm.selectedAddress.city !== vm.params.city ||
                vm.selectedAddress.countryCode !== vm.params.countryCode;
        }

        function setDeliveryDate() {
            vm.deliveryDate.chosenDate = new Date(parseInt(cart.meta.deliveryDate));
            vm.deliveryDate.minDate = new Date();
        }

        function onCountrySelect() {
            vm.params.countryCode = vm.selectedCountry.code;
        }

        function setAddress(address) {
            vm.params.recipient = address.recipient || "";
            vm.params.line1 = address.line1 || "";
            vm.params.line2 = address.line2 || "";
            vm.params.postCode = address.postCode || "";
            vm.params.city = address.city || "";
            vm.params.countryCode = address.countryCode || "";
        }

        function applyParams() {
            if (vm.user.admin) {
                var chosenDate = $filter("date")(vm.deliveryDate.chosenDate, "yyMMdd");
                var originalDate = $filter("date")(vm.cart.meta.deliveryDate, "yyMMdd");
                vm.params.deliveryDate = (chosenDate !== originalDate) ? chosenDate : "";
                vm.params.ignoreCustomerNotification = !vm.sendCustomerConfirmation;
            }

            if (vm.user.stadium) {
                vm.params.stadiumInvoice = vm.stadiumInvoice == "radioStadiumInvoiceStore" ? "store" : "solutions";
                vm.params.stadiumPayment = vm.stadiumPayment == "radioStadiumPaymentStore" ? "store" : "team_sales";
            }


            if (vm.radioAddress === "radioAddressSaved") {
                vm.params.addressType = "saved";
            } else if (vm.radioAddress === "radioAddressStadium") {
                vm.params.addressType = "stadium";
                setAddress(vm.stadiumAddress);
            } else if (vm.radioAddress === "radioAddressStandard") {
                vm.params.addressType = "standard";
                // Bamatex users may add an attention on line1
                if (!vm.user.stadium && vm.params.line1 != vm.standardAddress.line1 && vm.params.line1.trim() !== "Att:") {
                    vm.standardAddress.line1 = vm.params.line1;
                    setAddress(vm.standardAddress);
                } else {
                    vm.params.recipient = null;
                    vm.params.line1 = null;
                    vm.params.line2 = null;
                    vm.params.postCode = null;
                    vm.params.city = null;
                    vm.params.countryCode = null;
                }
            } else if (vm.radioAddress === "radioAddressNew") {
                vm.params.addressType = "new";
                if (vm.params.line1.trim() === "Att:") {
                    vm.params.line1 = "";
                }
            }
            vm.params.files = vm.files;
        }

        function isManufacturingRow(cartRow) {
            return cartRow.manufacturingQuantity > 0;
        }

        function isNewLogo(cartRow) {
            return cartRow.newLogo;
        }

        function isMounting(cartRow) {
            return cartRow.mounting;
        }

        function confirm() {
            loadSpinnerService.start();
            vm.confirmError = "";
            applyParams();
            CartApiService.newOrder(vm.params)
                .then(confirmSuccess, confirmError)
                .finally(function () {
                    loadSpinnerService.stop();
                });
        }

        function cancel() {
            $modalInstance.dismiss("cancel");
        }

        function changePhase(increment) {
            var firstPhase = vm.user.admin ? 1 : 2;
            vm.showErrors = (vm.form && vm.form.$invalid) || isNoAddressSelected();
            if (!vm.showErrors) {
                vm.currentPhase += increment;
                vm.currentPhase = Math.max(firstPhase, vm.currentPhase);
                vm.currentPhase = Math.min(vm.lastPhase, vm.currentPhase);
            }
        }

        function isFirstPhase() {
            var firstPhase = vm.user.admin ? 1 : 2;
            return firstPhase === vm.currentPhase;
        }

        function isLastPhase() {
            return vm.currentPhase === vm.lastPhase;
        }

        function isNoAddressSelected() {
            return vm.radioAddress === "radioAddressSaved" && vm.selectedAddress === undefined;
        }

        function onSelectSavedAddress(address) {
            setAddress(vm.selectedAddress);
            vm.selectedCountry = address.countryCode ? _.find(vm.countries, { 'code': address.countryCode }) : _.find(vm.countries, { 'code': 'SE' });

            vm.resetErrors();
        }

        function resetForm() {
            vm.resetErrors();
            vm.selectedAddress = undefined;
            vm.selectedCountry = undefined;
            vm.params.recipient = "";
            vm.params.line1 = vm.user.stadium ? "" : "Att: ";
            vm.params.line2 = "";
            vm.params.postCode = "";
            vm.params.city = "";
            vm.params.countryCode = "";
        }

        function resetErrors() {
            vm.showErrors = false;
        }

        function continueButton() {
            $modalInstance.close();
            $state.go("app.shop.calculator");
        }

        function confirmSuccess() {
            vm.isConfirmed = true;
            vm.user.orderRecipient = null;
            vm.user.orderReference = null;
            vm.user.orderProject = null;
            vm.contentTemplate = "shop/cart/checkoutDialog/checkoutDialogSuccess.tpl.html";

            if (vm.user.stadium) {
                PlacementsApiService.closeTemplate().then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                });
            }
        }

        function confirmError(response) {
            if (response.status && response.status == 400) {
                handleValidationErrors(response.data);
            } else {
                vm.confirmError = response.data.message ? response.data.message : 'Unknown error occurred';
            }
        }

        function handleValidationErrors(errors) {
            _.forEach(errors, function (error) {
                if (error.code === 'CART_CONTAINS_FROZEN_ARTICLES') {
                    $modalInstance.close();

                    $translate('CHECKOUT.FROZENARTICLES', { articleIds: error.data.join(', ') })
                        .then(function (translation) {
                            toastr.error(translation);
                        })
                        .catch(function () {
                            toastr.error(error.message);
                        });
                }
                if (error.code === 'STADIUM_ORDER_NOT_ACTIVE') {
                    $modalInstance.close();
                    $rootScope.$broadcast("$updateNotifications");

                    $translate('ERROR.STADIUM_ORDER_NOT_ACTIVE')
                        .then(function (translation) {
                            toastr.error(translation);
                        })
                        .catch(function () {
                            toastr.error(error.message);
                        });
                }
                else if (error.code === 'ORDER_CUSTOMER_USER_MISSING') {
                    $modalInstance.close();
                    $rootScope.$broadcast('$updateNotificationsClearOrderRecipient');
                    $state.go('app.shop.calculator');

                    $translate('CHECKOUT.USERMISSING').then(function (translation) {
                        toastr.error(translation);
                    });
                }
                else {
                    toastr.error(error.message);
                }
            });
        }

        function isDateDisabled(date) {
            return vm.nonWorkingDays.includes(formatDate(date));
        }

        function formatDate(date) {
            var month = '' + (date.getMonth() + 1);
            var day = '' + date.getDate();
            var year = date.getFullYear();

            if (month.length < 2) {
                month = '0' + month;
            }

            if (day.length < 2) {
                day = '0' + day;
            }

            return [year, month, day].join('-');
        }

        function isAdmin() {
            return vm.user && vm.user.admin;
        }

        function onFileSelect(file) {
            if (validateFile(file)) {
                vm.files.push(file);
            }
        }

        function validateFile(file) {
            var result = true;
            if (file.size > 104857600) {
                toastr.error('File size is too large (limit: 100 MB)');
                result = false;
            }
            return result;
        }

        function removeFile(index) {
            vm.files = _.without(vm.files, vm.files[index]);
        }

        function getFileButtonRange() {
            return _.range(vm.files.length + 1);
        }
    }

    angular
        .module("checkoutDialog", [])
        .controller("CheckoutDialogController", CheckoutDialogController);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    productTypesResolve.$inject = ["ArticlesApiService", "$stateParams"];
    orderProofsResolve.$inject = ["OrderProofsApiService"];
    articleGroupResolve.$inject = ["$stateParams"];
    logoResolve.$inject = ["LogosApiService", "$stateParams"];
    userResolve.$inject = ["AuthService"];
    customerSettingsResolve.$inject = ["AuthService", "CustomerSettingsApiService"];
    CreateController.$inject = ["$q", "$window", "$state", "$translate", "$anchorScroll", "$scope", "toastr", "loadSpinnerService", "DS", "ArticlesApiService", "LogosApiService", "ColorPickerDialogService", "ProofDialogService", "CalculatorApiService", "ConfirmDialogService", "LogoImageDialogService", "LogoImageApiService", "TemplateDialogService", "productTypes", "originalLogo", "orderProofs", "articleGroup", "editState", "user", "customerSettings"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.create', {
            url: '/create/{articleGroup}',
            views: {
                'main-content': {
                    templateUrl: 'shop/create/create.tpl.html',
                    controller: 'CreateController as vm'
                }
            },
            resolve: {
                productTypes: productTypesResolve,
                originalLogo: function() {
                    return null;
                },
                orderProofs: orderProofsResolve,
                articleGroup: articleGroupResolve,
                editState: function () {
                    return false;
                },
                user: userResolve,
                customerSettings: customerSettingsResolve
            }
        });

        $stateProvider.state('app.shop.edit', {
            url: '/edit/{articleGroup}/{logoId}',
            views: {
                'main-content': {
                    templateUrl: 'shop/create/create.tpl.html',
                    controller: 'CreateController as vm'
                }
            },
            resolve: {
                productTypes: productTypesResolve,
                originalLogo: logoResolve,
                orderProofs: orderProofsResolve,
                articleGroup: articleGroupResolve,
                editState: function () {
                    return true;
                },
                user: userResolve,
                customerSettings: customerSettingsResolve
            }
        });
    }

    // @ngInject
    function productTypesResolve(ArticlesApiService, $stateParams) {
        return ArticlesApiService.getProductTypes($stateParams.articleGroup);
    }

    // @ngInject
    function orderProofsResolve(OrderProofsApiService) {
        return OrderProofsApiService.getOrderProofs();
    }

    //@ngInject
    function articleGroupResolve($stateParams) {
        return $stateParams.articleGroup;
    }

    // @ngInject
    function logoResolve(LogosApiService, $stateParams) {
        return LogosApiService.getEditableLogo($stateParams.logoId);
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function customerSettingsResolve(AuthService, CustomerSettingsApiService) {
        return AuthService.getUser()
            .then(function (user) {
                var customerId = user.orderRecipient ? user.orderRecipient.customerId : user.customerId;
                return CustomerSettingsApiService.getCustomerSettings(customerId);
            });
    }

    // @ngInject
    function CreateController(
        $q,
        $window,
        $state,
        $translate,
        $anchorScroll,
        $scope,
        toastr,
        loadSpinnerService,
        DS,
        ArticlesApiService,
        LogosApiService,
        ColorPickerDialogService,
        ProofDialogService,
        CalculatorApiService,
        ConfirmDialogService,
        LogoImageDialogService,
        LogoImageApiService,
        TemplateDialogService,
        productTypes,
        originalLogo,
        orderProofs,
        articleGroup,
        editState,
        user,
        customerSettings
    ) {
        var vm = this;
        vm.user = user;
        vm.customerSettings = customerSettings;
        vm.isAdmin = vm.user.admin;
        vm.isEditState = editState;
        vm.article = {};
        vm.orderProofs = orderProofs;
        vm.originalLogo = originalLogo;
        vm.articleGroup = articleGroup;
        vm.productTypes = productTypes;
        vm.productType = null;
        vm.productSubtype = null;
        vm.minQuantity = 0;
        vm.colours = [];
        vm.selectedColours = [];
        vm.validationErrors = [];
        vm.files = [];
        vm.isAttachmentSet = false;
        vm.backsides = [];
        vm.selectedBackside = null;
        vm.selectedBacksides = [];
        vm.minQuantityOfBacksides = 1;
        vm.totalPrice = '';
        vm.prices = null;
        vm.showPrices = false;

        vm.onProductTypeSelect = onProductTypeSelect;
        vm.onFileSelect = onFileSelect;
        vm.onProcessSelect = onProcessSelect;
        vm.openProofDialog = openProofDialog;
        vm.validateFiles = validateFilesAttached;
        vm.selectLogoImage = selectLogoImage;
        vm.editLogoImage = editLogoImage;
        vm.openColourPicker = openColourPicker;
        vm.isFirst = isFirst;
        vm.isLast = isLast;
        vm.moveColour = moveColour;
        vm.maxColourCount = maxColourCount;
        vm.minColourCount = minColourCount;
        vm.addTag = addTag;
        vm.addColour = addColour;
        vm.addBackside = addBackside;
        vm.removeBackside = removeBackside;
        vm.showBacksidePicker = showBacksidePicker;
        vm.availableBacksides = availableBacksides;
        vm.showLogoImage = showLogoImage;
        vm.showProof = showProof;
        vm.showFile = showFile;
        vm.showColourPicker = showColourPicker;
        vm.showProcess = showProcess;
        vm.showSubProducts = showSubProducts;
        vm.getFile = getFile;
        vm.getProofFile = getProofFile;
        vm.getLogoImageUrl = getLogoImageUrl;
        vm.getExampleImageUrl = getExampleImageUrl;
        vm.clearFile = clearFile;
        vm.clearProof = clearProof;
        vm.clearLogoImage = clearLogoImage;
        vm.submit = submit;
        vm.submitAndPlace = submitAndPlace;
        vm.cancel = cancel;
        vm.isTemplateMode = isTemplateMode;
        vm.togglePrices = togglePrices;
        vm.isLeatheretteBrand = isLeatheretteBrand;
        vm.onLogoLoad = onLogoLoad;

        function initialise() {
            if (vm.isEditState) {
                if (vm.originalLogo) {
                    loadEdit(vm.originalLogo);
                } else {
                    toastr.error('Could not load logo');
                }
            } else {
                loadCreate();
            }

            applyCustomerSettings();
        }

        initialise();

        $scope.$watchGroup([
            'vm.articleGroup',
            'vm.productType',
            'vm.article.width',
            'vm.article.height',
            'vm.productSubtype',
            'vm.article.stitches',
            'vm.article.process',
            'vm.article.quantity',
            'vm.selectedColours',
            'vm.showPrices'
        ], _.debounce(tryShowCurrentPrice, 300));

        $scope.$watchGroup([
            'vm.article.width',
            'vm.article.height',
            'vm.article.logoImage.logoHeight',
            'vm.article.logoImage.logoWidth',
            'vm.article.fixedAspect'
        ], fixedAspectRatioHeight);

        function isTemplateMode() {
            return !!vm.user.templateId;
        }

        function loadCreate() {
            vm.article = {
                name: '',
                fixedAspect: false,
                height: '',
                width: '',
                colours: [],
                tags: [],
                information: '',
                process: false,
                contact: false,
                quantity: '0',
                logoImage: null,
                errand: null
            };
        }

        function loadEdit(article) {
            vm.article = {
                name: article.logoName,
                fixedAspect: article.logoFixedAspect === true,
                height: parseInt(article.logoHeight),
                width: parseInt(article.logoWidth),
                tags: article.tags,
                information: article.logoInformation,
                edgeType: article.edgeType,
                warpType: article.warpType,
                foldType: article.foldType,
                contact: article.contact,
                process: article.process,
                stitches: article.stitchCount ? parseInt(article.stitchCount) : null,
                attachmentExtension: article.attachmentExtension,
                quantity: article.quantity,
                logoImage: article.logoImage,
                backside: article.backside
            };

            setProductType(article.productType, article.productSubtype);
            setSelectedColours(vm.productType, article.colours, article.process);
            setAttachmentInformation(article);
        }

        function setProductType(productType, productSubtype) {
            vm.productType = _.find(vm.productTypes, { 'name': productType });

            if (vm.productType.productSubtypes) {
                vm.productSubtype = _.find(vm.productType.productSubtypes, { 'name': productSubtype });
            }

            vm.minQuantity = vm.productType.quantitySettings.minOrderQuantity;

            // Handle backsides
            if (vm.showBacksidePicker()) {
                loadBacksides()
                    .then(function() {
                        if (vm.article.backside) {
                            var selected = vm.backsides.find(function (backside) {
                                return backside.id === vm.article.backside;
                            });

                            vm.selectedBackside = selected || vm.backsides[0];
                        } else {
                            vm.selectedBackside = vm.backsides[0];
                        }
                    });
                addBackside();
            }
        }

        function setSelectedColours(productType, colours, process) {
            ArticlesApiService.getColors(productType.colourType.toLowerCase()).then(function (productColours) {
                vm.colours = productColours;
                vm.selectedColours = [];

                if (!process) {
                    _.each(colours, function (colour) {
                        vm.selectedColours.push(colour);
                    });
                }
            });
        }

        function setAttachmentInformation(article) {
            vm.isAttachmentSet = false;
            if (article.attachmentExtension) {
                vm.files[0] = {
                    name: $translate.instant('CREATEARTICLE.ATTACHMENTS.VIEWFILE')
                };
                vm.isAttachmentSet = true;
            }
            else if (article.logoImage) {
                LogoImageApiService.get(article.logoImage).then(function (logoImage) {
                    vm.article.logoImage = logoImage;
                    vm.isAttachmentSet = true;
                });
            }
            else if (article.errandId) {
                vm.article.errand = {
                    errandId: article.errandId,
                    fileId: article.proofFileId,
                    fileName: $translate.instant('CREATEARTICLE.ATTACHMENTS.VIEWPROOF')
                };
                vm.isAttachmentSet = true;
            }
        }

        function showLogoImage() {
            if (vm.isAttachmentSet) {
                return vm.article.logoImage;
            }

            return vm.productType && vm.productType.allowLogoUpload && !vm.article.process;
        }

        function showProof() {
            if (vm.isAttachmentSet) {
                return vm.article.errand;
            }

            return vm.orderProofs && vm.orderProofs.length > 0;
        }

        function showFile() {
            if (vm.isAttachmentSet) {
                return vm.files && vm.files.length > 0;
            }

            return true;
        }

        function showColourPicker() {
            return !vm.article.process && countCustomColours() < vm.maxColourCount();
        }

        function showProcess() {
            return vm.productSubtype && vm.productSubtype.processPrefix;
        }

        function showSubProducts() {
            if (!vm.productType) {
                return false;
            }

            var subTypes = vm.productType.productSubtypes;

            if (!subTypes || subTypes.length === 0) {
                return false;
            }

            if (subTypes.length === 1) {
                return _.head(subTypes).name !== "";
            }

            return true;
        }

        function getFile() {
            var url = '';
            if (vm.files.length > 0 && !vm.files[0].size && vm.originalLogo.logoId) {
                url = DS.defaults.baseUrl + 'attachments/' + vm.originalLogo.logoId;
            }

            if (url) {
                $window.open(url, '_blank');
            }
        }

        function getProofFile() {
            var url = '';
            if (vm.article.errand && vm.article.errand.proofId) {
                url = DS.defaults.baseUrl + 'productionerrands/' + vm.article.errand.errandId +
                    '/proofs/' + vm.article.errand.proofId +
                    '/' + vm.article.errand.fileId;
            }
            else if (vm.originalLogo.logoId){
                url = DS.defaults.baseUrl + 'attachments/' + vm.originalLogo.logoId;
            }

            if (url) {
                $window.open(url, '_blank');
            }
        }

        function getLogoImageUrl() {
            if (vm.article.logoImage && vm.article.logoImage.logoImageId) {
                return LogoImageApiService.getImageUrl(vm.article.logoImage.logoImageId);
            }
        }

        function getExampleImageUrl() {
            var base = 'productTypeImages/';
            if (vm.productType && vm.productType.exampleImage) {
                return base + vm.productType.name + '.png';
            }
        }

        function clearFile() {
            vm.files = [];
            clearAttachment();
        }

        function clearProof() {
            vm.article.errand = null;
            clearAttachment();
        }

        function clearLogoImage() {
            vm.article.logoImage = null;
            clearAttachment();
        }

        function fixedAspectRatioHeight() {
            var logo = vm.article.logoImage;
            if(logo == null ||
                vm.article.fixedAspect !== true ||
                vm.article.logoImage.logoHeight == null ||
                vm.article.logoImage.logoWidth == null) {
                return;
            }

            if(isNaN(vm.article.width)) {
                vm.article.height = '';
            }

            var ratio = vm.article.logoImage.logoHeight / vm.article.logoImage.logoWidth;
            vm.article.height = Math.round(ratio * vm.article.width);
        }

        function clearAttachment() {
            vm.isAttachmentSet = false;
            if (vm.isEditState) {
                vm.article.logoImage = null;
                vm.article.errand = null;
                vm.article.attachmentExtension = '';
            }
        }

        function addTag(tag) {
            if (tag && tag.trim()) {
                if (tag.trim().length > 20) {
                    $translate('MESSAGE.MAXTAGLENGTH').then(function (translation) {
                        toastr.error(translation);
                    });
                } else {
                    if (!_.some(vm.article.tags, function (existing) { return existing.toUpperCase() === tag.trim().toUpperCase(); })) {
                        return tag.replace(',', '').trim().toUpperCase();
                    }
                }
            }
        }

        function addColour(colour) {
            if (colour && colour.trim()) {
                var customColour = colour.trim().toUpperCase();
                if (!_.find(vm.selectedColours, { 'name': customColour })) {
                    return { name: customColour };
                }
            }
        }

        function addWarning(field, message) {
            vm.validationErrors.push({ field: field, message: message });
        }

        function removeWarning(field) {
            _.remove(vm.validationErrors, { 'field': field });
        }

        function submitAndPlace() {
            vm.form.$setSubmitted();
            return submit(true);
        }

        function submit(place) {
            if (vm.form.$invalid) {
                $anchorScroll();
                return;
            }

            $q.all([validation(), validateSize()])
                .then(function () {
                    if (place) {
                        return TemplateDialogService.showStandardDialog();
                    }
                })
                .then(function (template) {
                    loadSpinnerService.start();

                    if (template) {
                        vm.user.templateId = template.placementId;
                    }

                    applyArticleData();

                    if (!vm.isEditState) {
                        vm.form.$submitted = true;
                        return LogosApiService.newLogo(vm.article);
                    } else {
                        return LogosApiService.updateLogo(vm.article, vm.originalLogo.logoId);
                    }
                })
                .then(function () {
                    if (isTemplateMode()) {
                        $state.go('app.shop.advancedMounting', {id: vm.user.templateId});
                    } else {
                        $state.go('app.shop.cart');
                    }
                })
                .catch(function (error) {
                    $anchorScroll();
                    if (error) {
                        handleValidationErrors(error, vm.isEditState);
                    }
                })
                .finally(function () {
                    loadSpinnerService.stop();
                });
        }

        function validation() {
            vm.validationErrors = [];
            var q = $q.defer();

            // Validate
            validateProductType();
            validateColours();
            validateQuantities();
            validateAttachment();
            validateBacksides();

            if (vm.validationErrors.length > 0 || vm.form.$invalid) {
                q.reject();
            } else {
                q.resolve();
            }

            return q.promise;
        }

        function validateProductType() {
            if (vm.productType) {
                // Validate meta types
                var types = ['edge', 'fold', 'warp'];
                _.each(types, function (metaType) {
                    var validProductType = (vm.productType[metaType + 'Types'].length === 0) === (vm.article[metaType + 'Type'] === null);
                    if (!validProductType) {
                        addWarning(metaType, $translate.instant('CREATEARTICLE.VALIDATION.METATYPE')
                            .replace('%s', $translate.instant('PRODUCT.TYPE.META.' + metaType.toUpperCase()).toLowerCase()));
                    }
                });

                // Validate sub type
                if (!vm.productSubtype) {
                    addWarning('productSubtype', $translate.instant('CREATEARTICLE.VALIDATION.PRODUCTSUBTYPE'));
                }
            }
        }

        function validateColours() {
            var minColourCount = vm.minColourCount();
            if (!vm.article.process && vm.selectedColours.length < minColourCount) {
                addWarning('colours', $translate.instant('CREATEARTICLE.VALIDATION.COLORS', { colorCount: minColourCount }));
            }
        }

        function validateQuantities() {
            if (isTemplateMode()) {
                return;
            }

            if (vm.productType) {
                var minimumQuantity = vm.productType.quantitySettings.minOrderQuantity;
                if (vm.article.quantity < minimumQuantity) {
                    addWarning('quantity', $translate.instant('CREATEARTICLE.VALIDATION.MINQUANTITY', { minimumQuantity: minimumQuantity }));
                }
            }
        }

        function validateAttachment() {
            if (!(validateErrand() ||
                validateAttachmentExtension() ||
                validateFilesAttached() ||
                validateLogoImage())) {
                addWarning('file', $translate.instant('CREATEARTICLE.VALIDATION.FILE'));
            }
        }

        function validateErrand() {
            return !!vm.article.errand;
        }

        function validateAttachmentExtension() {
            return vm.article && vm.article.attachmentExtension;
        }

        function validateFilesAttached() {
            return vm.files && vm.files.length > 0;
        }

        function validateLogoImage() {
            return vm.article.logoImage;
        }

        function validateBacksides() {
            if (!showBacksidePicker()) {
                return;
            }
            if (isTemplateMode()) {
                if (!vm.selectedBackside) {
                    addWarning('backsides', $translate.instant('CREATEARTICLE.VALIDATION.BACKSIDES'));
                }

                return;
            }

            if (!vm.selectedBacksides || vm.selectedBacksides.length === 0) {
                addWarning('backsides', $translate.instant('CREATEARTICLE.VALIDATION.BACKSIDES'));
            }
            else {
                var totalQuantity = 0;
                _.each(vm.selectedBacksides, function (backside) {
                    totalQuantity += backside.quantity;
                });

                if (totalQuantity < vm.article.quantity) {
                    addWarning('backsides', $translate.instant('CREATEARTICLE.VALIDATION.BACKSIDES.QUANTITY'));
                }
            }
        }

        function validateSize() {
            var q = $q.defer();
            var standardColourCount = 0;
            var specialColourCount = 0;

            if (!vm.article.process && vm.selectedColours && vm.selectedColours.length > 0) {
                standardColourCount = vm.selectedColours.length;
                specialColourCount = countCustomColours();
            }

            var query = {
                productGroup: vm.articleGroup ? vm.articleGroup : null,
                productType: vm.productType ? vm.productType.name : null,
                productSubtype: vm.productSubtype ? vm.productSubtype.name : null,
                width: vm.article.width ? vm.article.width : '',
                height: vm.article.height ? vm.article.height : '',
                numberOfColours: standardColourCount.toString(),
                numberOfSpecialColours: specialColourCount.toString(),
                stitchCount: vm.article.stitches ? vm.article.stitches : '',
                process: vm.article.process ? vm.article.process : false,
                express: false
            };

            CalculatorApiService.calculateSize(query).then(function (data) {
                if (!data.valid) {
                    showSizeWarning(data, query);
                    q.reject();
                } else {
                    q.resolve();
                }
            }, function () {
                q.reject();
            });

            return q.promise;
        }

        function togglePrices() {
            vm.showPrices = !vm.showPrices;
        }

        function tryShowCurrentPrice() {
            if (!vm.showPrices) {
                return;
            }

            var query = buildCalculatorQuery();
            var valid = isQueryFilled(query);

            if(!valid) {
                clearPrices();
                return;
            }

            CalculatorApiService.calculatePrice(query)
                .then(function (data) {
                    if (!data.valid) {
                        clearPrices();
                        showSizeWarning(data, query);
                    } else {
                        removeWarning('size');
                        vm.prices = data.prices;
                        vm.expressCost = data.expressCost;
                        vm.colourCost = data.colourCost;
                        vm.startCost = data.startCost;
                        vm.totalPrice = data.totalPrice;
                    }
                })
                .catch(function (error) {
                    clearPrices();
                    throw error;
                });
        }

        function showSizeWarning(data, query) {
            removeWarning('size');
            if (data.size && data.maxSize && !query.stitchCount) {
                $translate('CALCULATOR.ERROR.SIZE').then(function (message) {
                    addWarning('size', message.replace('%s', data.size).replace('%s', data.maxSize));
                });
            }
            else if (data.size && data.maxSize && query.stitchCount) {
                $translate('CALCULATOR.ERROR.STITCHES').then(function (message) {
                    addWarning('size', message.replace('%s', data.size).replace('%s', data.maxSize));
                });
            }
            else {
                $translate('CALCULATOR.ERROR').then(function (message) {
                    addWarning('size', message);
                });
            }
        }

        function clearPrices() {
            vm.totalPrice = null;
            vm.prices = null;
            vm.expressCost = null;
            vm.colourCost = null;
            vm.startCost = null;
        }

        function applyArticleData() {
            if (vm.files[0]) {
                vm.article.file = null;
                // Check if there is a new file
                if (vm.files[0].size) {
                    vm.article.file = vm.files[0];
                }
            }

            vm.article.colors = _.map(vm.selectedColours, 'name');
            vm.article.productType = vm.productType.name;
            if (vm.productSubtype) {
                vm.article.productSubtype = vm.productSubtype.name;
            }
            if (vm.showBacksidePicker()) {
                vm.article.backsides = [];
                _.each(vm.selectedBacksides, function (backside) {
                    if (backside.id !== 0) {
                        vm.article.backsides.push({ id: backside.id, quantity: backside.quantity });
                    }
                });
            }
            if (isTemplateMode()) {
                vm.article.templateId = vm.user.templateId;
                if (vm.selectedBackside && vm.selectedBackside.id !== 0) {
                    vm.article.backside = vm.selectedBackside.id;
                }
            }
        }

        function handleValidationErrors(errors, update) {
            // Check for default error
            if (errors.statusCode && (errors.statusCode < 400 || errors.statusCode >= 500)) {
                var message = update ? 'MESSAGE.UPDATEFAIL' : 'MESSAGE.SAVEFAIL';
                $translate(message).then(function (translation) {
                    toastr.error(translation);
                });
            } else {
                _.forEach(errors, function (error) {
                    if (error.code === 'LOGO_IMAGE_FOR_PRODUCT_NOT_ALLOWED') {
                        $translate('ERROR.LOGO_IMAGE_FOR_PRODUCT_NOT_ALLOWED', {value: $translate.instant(error.data.value)})
                            .then(function (translation) {
                                toastr.error(translation);
                            })
                            .catch(function () {
                                toastr.error(error.message);
                            });
                    }
                    else {
                        $translate('ERROR.' + error.code, error.data).then(function (translation) {
                            toastr.error(translation);
                        }).catch(function () {
                            toastr.error(error.message);
                        });
                    }
                });
            }
        }

        function showBacksidePicker() {
            return vm.productType && vm.productType.backsides && vm.productType.backsides.length > 0;
        }

        function loadBacksides() {
            vm.backsides = [];
            return ArticlesApiService.getProductBacksides(vm.productType.name).then(function(response) {
                response.forEach(function (backside) {
                    vm.backsides.push(backside);
                });
            });
        }

        function availableBacksides() {
            if (!vm.selectedBacksides || vm.selectedBacksides && vm.selectedBacksides.length === 0) {
                return vm.backsides;
            }

            return _.filter(vm.backsides, function (backside) {
                return !vm.selectedBacksides.find(function (x) { return backside.id === x.id; });
            });
        }

        function addBackside() {
            if (!vm.selectedBackside) {
                return;
            }
            if (isTemplateMode()) {
                return;
            }

            vm.selectedBackside.quantity = _.max([vm.article.quantity, vm.selectedBackside.minimumQuantity]);
            vm.selectedBacksides.push(vm.selectedBackside);
            vm.selectedBackside = null;
        }

        function removeBackside(backsideToRemove) {
            if (!vm.selectedBacksides) {
                return;
            }
            if (vm.selectedBacksides.length === 1) {
                vm.selectedBacksides = [];
            } else {
                _.remove(vm.selectedBacksides, function (backside) {
                    return backside.id === backsideToRemove.id;
                });
            }
        }

        function loadColours(colorType) {
            ArticlesApiService.getColors(colorType.toLowerCase()).then(function(response) {
                vm.selectedColours = [];
                vm.colours = response;
            });
        }

        function maxColourCount() {
            return getColourCount('maxColourCount');
        }

        function minColourCount() {
            return getColourCount('minColourCount');
        }

        function getColourCount(field) {
            var result = vm.productType ? vm.productType[field] : 0;
            if (vm.productSubtype && vm.productSubtype.exactColourCount) {
                var exactCount = parseInt(vm.productSubtype.exactColourCount);
                if (!isNaN(exactCount)) {
                    result = exactCount;
                }
            }
            return result;
        }

        function countCustomColours() {
            return vm.selectedColours.filter(function(colour) {
                return !colour.code;
            }).length;
        }

        function isFirst(colour) {
            return isColourMatch(_.first(vm.selectedColours), colour);
        }

        function isLast(colour) {
            return isColourMatch(_.last(vm.selectedColours), colour);
        }

        function moveColour(colour, delta) {
            var index = -1;
            for (var loop in vm.selectedColours) {
                index = isColourMatch(vm.selectedColours[loop], colour) ? loop : index;
            }
            vm.selectedColours = _.without(vm.selectedColours, colour);
            index = parseInt(index) + delta;
            vm.selectedColours.splice(index, 0, colour);
        }

        function isColourMatch(colour1, colour2) {
            if(!colour1 || !colour1.name || !colour2 || !colour2.name) {
                return false;
            }
            return colour1.name.toUpperCase().trim() === colour2.name.toUpperCase().trim();
        }

        function onProcessSelect() {
            vm.selectedColours = [];

            if (vm.article.logoImage) {
                clearLogoImage();
            }
        }

        function openColourPicker() {
            var data = {
                colors: vm.colours.slice(),
                selectedColors: vm.selectedColours.slice(),
                maxColors: vm.maxColourCount(),
                customColors: countCustomColours()
            };

            ColorPickerDialogService.showDialog(data).then(function (selectedColours){
                vm.selectedColours = selectedColours;
            });
        }

        function onProductTypeSelect(selectedType)  {
            loadColours(selectedType.colourType);
            vm.validationErrors = [];
            vm.productSubtype = selectedType.productSubtypes ? selectedType.productSubtypes[0] || null : null;
            vm.article.edgeType = null;
            vm.article.warpType = null;
            vm.article.foldType = null;
            vm.article.process = false;
            vm.article.contact = false;
            vm.minQuantity = selectedType.quantitySettings.minOrderQuantity;
            vm.article.quantity = Math.max(parseInt(vm.article.quantity), parseInt(selectedType.quantitySettings.minOrderQuantity));

            if (selectedType.backsides && selectedType.backsides.length > 0) {
                loadBacksides()
                    .then(function () {
                        // Clear selection
                        vm.selectedBackside = null;

                        // Remove backsides not available to product type
                        if (vm.selectedBacksides.length > 0) {
                            vm.selectedBacksides = _.filter(vm.selectedBacksides, function (backside) {
                                return vm.backsides.find(function(x) { return backside.id === x.id; });
                            });
                        }
                    });
            } else {
                vm.article.backsides = [];
                vm.selectedBacksides = [];
                vm.selectedBackside = null;
            }

            if (!selectedType.allowLogoUpload) {
                clearLogoImage();
            }

            applyCustomerSettings();
        }

        function openProofDialog() {
            ProofDialogService.showDialog().then(function (orderProof) {
                if (orderProof) {
                    vm.article.errand = orderProof;
                    removeWarning('file');
                    vm.isAttachmentSet = true;
                }
            });
        }

        function onFileSelect(file) {
            var validSize = file.size < 104857600;

            if (!validSize) {
                toastr.error('File size is too large (limit: 100 MB)');
            } else {
                vm.files = [];
                vm.files.push(file);
                removeWarning('file');
                vm.isAttachmentSet = true;
            }

            return validSize;
        }

        function loadLogo(logoImage) {
            vm.article.logoImage = logoImage;
            vm.isAttachmentSet = true;
            removeWarning();

            vm.article.process = false;
            setLogoImageColours(logoImage);
        }

        function onLogoLoad(element, success) {
            if(!success) {
                return;
            }

            vm.article.logoImage.logoHeight = element.height;
            vm.article.logoImage.logoWidth = element.width;
        }

        function selectLogoImage() {
            var colourHolder = _.clone(vm.selectedColours);
            vm.selectedColours = [];

            LogoImageDialogService.showDialog(vm.productType.colourType).then(function (logoImage) {
                if (logoImage !== null) {
                    loadLogo(logoImage);
                }
            }, function (error) {
                if (!error) {
                    // If aborted - restore colours
                    vm.selectedColours = colourHolder;
                    return;
                }

                throw error;
            });
        }

        function editLogoImage() {
            var colourHolder = _.clone(vm.selectedColours);
            vm.selectedColours = [];

            LogoImageDialogService.showEditDialog(vm.article.logoImage, vm.productType.colourType).then(function (logoImage) {
                if (logoImage !== null) {
                    loadLogo(logoImage);
                }
            }, function (error) {
                if (!error) {
                    // If aborted - restore colours
                    vm.selectedColours = colourHolder;
                    return;
                }

                throw error;
            });
        }

        function setLogoImageColours(logoImage) {
            var newColours = [];
            _.each(logoImage.logoImageColours, function (colour) {
                if (colour.customColour === true) {
                    newColours.push({ name: colour.colourName });
                }
                else {
                    var logoColour = _.find(vm.colours, { 'name': colour.colourName });
                    if (logoColour) {
                        newColours.push(angular.copy(logoColour));
                    }
                }
            });

            vm.selectedColours = _.uniqBy(newColours, 'name');
        }

        function cancel() {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-success' }];
            ConfirmDialogService.showDialog('ARTICLE.CANCEL.TITLE', 'ARTICLE.CANCEL.DESCRIPTION', buttons)
                .then(function (button) {
                    if (button.name !== 'BUTTON.YES') {
                        return;
                    }
                    if (isTemplateMode()) {
                        return $state.go('app.shop.advancedMounting', { id: vm.user.templateId });
                    }

                    return $state.go('app.shop.cart');
                });
        }

        function isNumberOfColoursVisible() {
            var result = vm.productType && vm.productType.maxColourCount > 0;
            result = result && vm.productSubtype && !vm.productSubtype.exactColourCount;
            result = result && !vm.productType.countStitches && !vm.productType.mounting;
            return result;
        }

        function isPresent(value) {
            return (typeof value === 'string' && value.length > 0 && value !== '' && value !== '0') || (typeof value === 'number' && value !== 0);
        }

        function isStitches() {
            return vm.productType && vm.productType.countStitches;
        }

        function isQueryFilled(query) {
            var queryFilled = query.productGroup !== null && query.productType !== null && query.productSubtype !== null;
            if (isNumberOfColoursVisible() && !query.process) {
                queryFilled = queryFilled && isPresent(query.numberOfColours);
            }
            if (isStitches()) {
                queryFilled = queryFilled && isPresent(query.stitchCount);
            } else {
                queryFilled = queryFilled && isPresent(query.width) && isPresent(query.height);
            }
            return queryFilled;
        }

        function buildCalculatorQuery() {
            var standardColourCount = 0;
            var specialColourCount = 0;

            if (!vm.article.process && vm.selectedColours && vm.selectedColours.length > 0) {
                standardColourCount = vm.selectedColours.length;
                specialColourCount = countCustomColours();
            }

            return {
                productGroup: vm.articleGroup ? vm.articleGroup : null,
                productType: vm.productType ? vm.productType.name : null,
                productSubtype: vm.productSubtype ? vm.productSubtype.name : null,
                width: vm.article.width ? vm.article.width : '',
                height: vm.article.height ? vm.article.height : '',
                numberOfColours: standardColourCount.toString(),
                numberOfSpecialColours: specialColourCount.toString(),
                stitchCount: vm.article.stitches ? vm.article.stitches : '',
                process: vm.article.process ? vm.article.process : false,
                express: false,
                quantity: vm.article.quantity
            };
        }

        function applyCustomerSettings() {
            if (!vm.customerSettings.noApproval && vm.customerSettings.autoReject) {
                vm.article.contact = true;
            }
        }

        function isLeatheretteBrand() {
            return vm.productType.name === 'LEATHERETTE_BRAND' ||
            vm.productType.name === 'LEATHERETTE_BRAND_BASIC' ||
            vm.productType.name === 'ZIPPER_LEATHERETTE';
        }
    }

    angular
        .module('shop.create', ['services.proofDialog'])
        .controller('CreateController', CreateController)
        .config(stateConfig);
})();

(function () {

  'use strict';

  // @ngInject
  stateConfig.$inject = ["$stateProvider"];
  digitResolve.$inject = ["DigitsApiService", "$stateParams"];
  digitsResolve.$inject = ["DigitsApiService"];
  smallDigitsResolve.$inject = ["DigitsApiService"];
  smallDigitResolve.$inject = ["DigitsApiService", "$stateParams"];
  largeDigitsResolve.$inject = ["DigitsApiService"];
  largeDigitResolve.$inject = ["DigitsApiService", "$stateParams"];
  userResolve.$inject = ["AuthService"];
  templateResolve.$inject = ["AuthService", "PlacementsApiService"];
  function stateConfig($stateProvider) {
    $stateProvider
      .state('app.shop.digits', {
        url: '/digits',
        abstract: true,
        views: {
          'main-content': {
            template: '<ui-view></ui-view>',
          },
        },
      })
      .state('app.shop.digits.list', {
        url: '/list',
        templateUrl: 'shop/digits/digitsList.tpl.html',
        controller: 'DigitsListController as vm',
        resolve: {
          digits: digitsResolve,
        },
      })
      .state('app.shop.digits.view', {
        url: '/:id',
        templateUrl: 'shop/digits/digitView.tpl.html',
        controller: 'DigitViewController as vm',
        resolve: {
          digit: digitResolve,
          user: userResolve,
          template: templateResolve,
        },
      });

    $stateProvider
      .state('app.shop.small-digits', {
        url: '/small-digits',
        abstract: true,
        views: {
          'main-content': {
            template: '<ui-view></ui-view>',
          },
        },
      })
      .state('app.shop.small-digits.list', {
        url: '/list',
        templateUrl: 'shop/digits/digitsList.tpl.html',
        controller: 'DigitsListController as vm',
        resolve: {
          digits: smallDigitsResolve,
        },
      })
      .state('app.shop.small-digits.view', {
        url: '/:id',
        templateUrl: 'shop/digits/digitView.tpl.html',
        controller: 'DigitViewController as vm',
        resolve: {
          digit: smallDigitResolve,
          user: userResolve,
          template: templateResolve,
        },
      });
    $stateProvider
        .state('app.shop.large-digits', {
          url: '/large-digits',
          abstract: true,
          views: {
            'main-content': {
              template: '<ui-view></ui-view>',
            },
          },
        })
        .state('app.shop.large-digits.list', {
          url: '/list',
          templateUrl: 'shop/digits/digitsList.tpl.html',
          controller: 'DigitsListController as vm',
          resolve: {
            digits: largeDigitsResolve,
          },
        })
        .state('app.shop.large-digits.view', {
          url: '/:id',
          templateUrl: 'shop/digits/digitView.tpl.html',
          controller: 'DigitViewController as vm',
          resolve: {
            digit: largeDigitResolve,
            user: userResolve,
            template: templateResolve,
          },
        });
  }

  // @ngInject
  function digitResolve(DigitsApiService, $stateParams) {
    return DigitsApiService.getById($stateParams.id);
  }

  // @ngInject
  function digitsResolve(DigitsApiService) {
    return DigitsApiService.getAll();
  }

  // @ngInject
  function smallDigitsResolve(DigitsApiService) {
    return DigitsApiService.getAllSmall();
  }

  // @ngInject
  function smallDigitResolve(DigitsApiService, $stateParams) {
    return DigitsApiService.getSmallById($stateParams.id);
  }

  // @ngInject
  function largeDigitsResolve(DigitsApiService) {
    return DigitsApiService.getAllLarge();
  }

  // @ngInject
  function largeDigitResolve(DigitsApiService, $stateParams) {
    return DigitsApiService.getLargeById($stateParams.id);
  }

  // @ngInject
  function userResolve(AuthService) {
    return AuthService.getUser();
  }

  // @ngInject
  function templateResolve(AuthService, PlacementsApiService) {
    return AuthService.getUser()
      .then(function (user) {
        if (user && user.templateId) {
          return PlacementsApiService.getPlacement(user.templateId);
        }

        return null;
      });
  }

  angular
    .module('shop.digits', [])
    .config(stateConfig);
})();

(function () {

  'use strict';

  // @ngInject
  DigitsListController.$inject = ["$state", "DigitsApiService", "digits"];
  function DigitsListController($state, DigitsApiService, digits) {
    var vm = this;

    vm.digits = digits;
    vm.imageUrl = DigitsApiService.getImageUrl;
    vm.links = [
      {
        displayName: 'NAVIGATION.HOME',
        state: {
          to: 'app.shop.calculator',
        },
      },
      {
        displayName: 'NAVIGATION.DIGITS',
        state: null,
      },
    ];
    vm.selectDigit = selectDigit;

    function selectDigit(digit) {
      $state.go('^.view', { id: digit.id });
    }
  }

  angular
    .module('shop.digits')
    .controller('DigitsListController', DigitsListController);
})();

(function () {

  'use strict';

  // @ngInject
  DigitViewController.$inject = ["$scope", "$state", "PlayerDialogService", "DigitsApiService", "CartApiService", "ManufacturingDialogService", "StadiumStockApiService", "ValidationManager", "user", "digit", "template"];
  function DigitViewController(
    $scope,
    $state,
    PlayerDialogService,
    DigitsApiService,
    CartApiService,
    ManufacturingDialogService,
    StadiumStockApiService,
    ValidationManager,
    user,
    digit,
    template
  ) {
    var vm = this;
    vm.digit = digit;
    vm.user = user;
    vm.template = template;
    vm.selectedPlayerList = null;
    vm.numbers = null;
    vm.imageUrl = DigitsApiService.getImageUrl;
    vm.selectedSize = {};
    vm.currentSize = {};
    vm.numberSeriesMinimumQuantity = 1;
    vm.numberSeriesFrom = 1;
    vm.numberSeriesTo = 1;
    vm.isNumberSeries = false;
    vm.freeTextNumbers = [];
    vm.prices = [];
    vm.links = [
      {
        displayName: 'NAVIGATION.HOME',
        state: {
          to: 'app.shop.calculator',
        },
      },
      {
        displayName: 'NAVIGATION.DIGITS',
        state: {
          to: '^.list',
        },
      },
      {
        displayName: digit.id,
        state: null,
      },
    ];
    vm.addAllIsLoading = false;
    vm.setCurrentSize = setCurrentSize;
    vm.onClickClearPlayerList = onClickClearPlayerList;
    vm.setInitialQuantity = setInitialQuantity;
    vm.applyPlayerListQuantities = applyPlayerListQuantities;
    vm.isVisible = isVisible;
    vm.isNoneVisible = isNoneVisible;
    vm.isAnyStock = isAnyStock;
    vm.resetNumberSeries = resetNumberSeries;
    vm.applyNumberSeries = applyNumberSeries;
    vm.openPlayerDialog = openPlayerDialog;
    vm.resetFreeTextNumbers = resetFreeTextNumbers;
    vm.applyFreeTextNumbers = applyFreeTextNumbers;
    vm.addAllToCart = addAllToCart;
    vm.isTemplateMode = isTemplateMode;
    vm.isOrderButtonVisible = isOrderButtonVisible;
    vm.navigateToTemplate = navigateToTemplate;
    vm.isStadium = isStadium;
    vm.openManufacturingDialog = openManufacturingDialog;

    activate();

    function activate() {
      resetSelectedPlayerList();
      if (digit.sizes.length > 0) {
        vm.selectedSize = digit.sizes[0];
        setCurrentSize(vm.selectedSize);
      }
    }

    function resetSelectedPlayerList(playerListId, playerListName, players) {
      vm.selectedPlayerList = {
        playerListId: playerListId,
        playerListName: playerListName,
        players: players,
      };
    }

    function openManufacturingDialog(id) {
      ManufacturingDialogService.showDialog(id, true);
    }

    function setCurrentSize(size) {
      vm.currentSize = size;
      vm.prices = size.prices;
      setInitialQuantity();
      if (vm.isNumberSeries) {
        applyNumberSeries();
      }
      if (vm.selectedPlayerList.playerListId) {
        applyPlayerListQuantities();
      }
    }

    function setInitialQuantity() {
      _.forEach(vm.currentSize.articles, function (article) {
        article.quantity = article.minimumQuantity;
      });
      vm.numbers = null;
    }

    function onClickClearPlayerList() {
      resetSelectedPlayerList();
      vm.numbers = null;
      setInitialQuantity();
    }

    function applyPlayerListQuantities() {
      deActivateNumberSeries();
      summarizeNumbers();
      distributeQuantities();
    }

    function summarizeNumbers() {
      vm.numbers = {};
      vm.selectedPlayerList.players.forEach(function (player) {
        player.number.split('').forEach(function (n) {
          vm.numbers[n] = parseInt(vm.numbers[n] || 0) + parseInt(player.quantity || 0);
        });
      });
    }

    function distributeQuantities() {
      var keys = Object.keys(vm.numbers);
      var numbers = keys.map(function (key) {
        return vm.numbers[key];
      });
      keys.forEach(function (key, i) {
        vm.currentSize.articles[key].quantity = numbers[i];
      });
    }

    function isVisible(article) {
      var result = true;
      if (vm.numbers) {
        var number = article.id[article.id.length - 1];
        result = !!vm.numbers[number];
      }
      return result;
    }

    function isNoneVisible() {
      return !_.some(vm.currentSize.articles, isVisible);
    }

    function isStock(article) {
      return article.stock;
    }

    function isAnyStock() {
      return _.some(vm.currentSize.articles, isStock);
    }

    function deActivateNumberSeries() {
      vm.numberSeriesFrom = 1;
      vm.numberSeriesTo = 1;
      vm.isNumberSeries = false;
      vm.numbers = null;
    }

    function resetNumberSeries() {
      deActivateNumberSeries();
      setInitialQuantity();
    }

    function applyNumberSeries() {
      summarizeNumberSeries();
      distributeQuantities();
    }

    function summarizeNumberSeries() {
      var summary = {};
      for (var indexPlayer = vm.numberSeriesFrom; indexPlayer < vm.numberSeriesTo + 1; indexPlayer++) {
        var number = indexPlayer.toString();
        for (var indexDigit = 0; indexDigit < number.length; indexDigit++) {
          summary[number[indexDigit]] = (summary[number[indexDigit]] || 0) + 1;
        }
      }
      vm.numbers = summary;
    }

    function resetFreeTextNumbers() {
      setInitialQuantity();
      vm.freeTextNumbers = null;
    }

    function applyFreeTextNumbers() {
      if (vm.freeTextNumbers.length > 0) {
        var summary = {};
        vm.freeTextNumbers.trim(',').split(',').forEach(function (number) {
          number.split('').forEach(function (digit) {
            summary[digit] = parseInt(summary[digit] || 0) + 1;
          });
        });
        vm.numbers = summary;
        distributeQuantities();
      }
    }

    function addAllToCart() {
      var cartRows = [];
      vm.addAllIsLoading = true;
      vm.currentSize.articles.forEach(function (article) {
        if (isVisible(article)) {
          cartRows.push({ id: article.id, quantity: article.quantity.toString() });
        }
      });
      CartApiService.newCartRows(cartRows).catch(function (error) {
        if (error) {
          ValidationManager.handleResponseError(error);
          throw error;
        }
      });
      vm.addAllIsLoading = false;
    }

    function isOrderButtonVisible() {
      if (!vm.user || isTemplateMode()) {
        return false;
      }

      if (vm.user.admin) {
        return vm.user.orderRecipient;
      }

      if (vm.user.stadium) {
        return vm.user.orderReference && !isTemplateMode();
      }

      return !vm.user.admin && !vm.user.stadium;
    }

    function isTemplateMode() {
      return vm.user.templateId;
    }

    function openPlayerDialog() {
      var playerListId = vm.selectedPlayerList ? vm.selectedPlayerList.playerListId : null;
      PlayerDialogService.showDialog(playerListId).then(function (data) {
        resetSelectedPlayerList(data.playerListId, data.playerListName, data.players);
        applyPlayerListQuantities();
      });
    }

    function navigateToTemplate() {
      $state.go('app.shop.advancedMounting', { id: vm.user.templateId }, 'AdvancedMountingController');
    }

    function isStadium() {
      return vm.user.stadium;
    }

    $scope.$watch('[vm.numberSeriesTo, vm.numberSeriesFrom]', function () {
      resetSelectedPlayerList();
      if (vm.numberSeriesTo === 1 && vm.numberSeriesFrom === 1) {
        resetNumberSeries();
      } else {
        vm.isNumberSeries = true;
        applyNumberSeries();
      }
    });
  }

  angular
    .module('shop.digits')
    .controller('DigitViewController', DigitViewController);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    historyResolve.$inject = ["HistoryApiService", "$stateParams", "$state", "loadSpinnerService", "ConfirmDialogService"];
    HistoryListController.$inject = ["ngTableParams", "$location", "$filter", "loadSpinnerService", "AuthService", "HistoryApiService", "TableService"];
    HistoryViewController.$inject = ["AuthService", "history", "$sce"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.historyList', {
            url: '/history',
            views: {
                'main-content': {
                    templateUrl: 'shop/history/historyList.tpl.html',
                    controller: 'HistoryListController as vm'
                }
            }
        });
        $stateProvider.state('app.shop.historyView', {
            url: '/history/{id}',
            views: {
                'main-content': {
                    templateUrl: 'shop/history/historyView.tpl.html',
                    controller: 'HistoryViewController as vm'
                }
            },
            resolve:{
                history: historyResolve
            }
        });
    }

    // @ngInject
    function historyResolve(HistoryApiService, $stateParams, $state, loadSpinnerService, ConfirmDialogService){
        return HistoryApiService.getById($stateParams.id).then(function (history) {
            return history;
        }, function (error) {
            loadSpinnerService.stop();

            if(error && error.status !== 401) {
                var buttons = [{name: 'BUTTON.CLOSE', class: 'btn-default'}];
                ConfirmDialogService.showDialog('HISTORYDETAILS.NOTFOUND.TITLE', 'HISTORYDETAILS.NOTFOUND.TEXT', buttons).then(function() {
                    $state.go('app.shop.historyList', {}, {reload: true});
                });
            }
        });
    }

    // @ngInject
    function HistoryListController(
        ngTableParams,
        $location,
        $filter,
        loadSpinnerService,
        AuthService,
        HistoryApiService,
        TableService
    ){
        /* jshint validthis: true */
        var vm = this;
        var savedSearch = HistoryApiService.getSavedSearch();
        var sortBy = savedSearch.sorting || {};

        vm.tableParams = {};
        vm.searchStatus = {};
        vm.initialized = false;
        vm.selectOrder = selectOrder;
        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'NAVIGATION.ORDERHISTORY',
                state: null
            }
        ];

        activate();

        AuthService.getUser().then(function(user) {
            vm.user = user;
        });

        function activate(){
            vm.searchStatus = {
                page: '1',
                pages: '1',
                active: false
            };
            /* jshint ignore:start */
            vm.tableParams = new ngTableParams({
                page: savedSearch.page,
                count: 20,
                sorting: savedSearch.sorting
            }, {
                counts: [],
                total: 0, // length of data
                getData: updateTable
            });
            /* jshint ignore:end */
        }

        function selectOrder(order){
            $location.path('history/' + order.id);
        }

        function updateSearchStatus(meta) {
            vm.searchStatus.page = !meta.page || '0' === meta.page ? '1' : meta.page;
            vm.searchStatus.pages = !meta.totalPages || '0' === meta.totalPages ? '1' : meta.totalPages;
        }

        function formatOrder(order) {
            order.orderType = translate(order.orderType, 'HISTORYFLAG.ORDERTYPE.');
            order.deliveryStatus = translate(order.deliveryStatus, 'HISTORYFLAG.DELIVERYSTATUS.');
        }
        
        function translate(suffix, prefix) {
            var result = $filter('translate')(prefix + (suffix || ''));
            return result.indexOf(prefix) !== -1 ? suffix : result;
        }

        function updateTable($defer, params) {
            loadSpinnerService.start();
            params.generatePagesArray = TableService.generatePagesArray;

            if(!_.isEqual(sortBy, params.sorting())){
                sortBy = params.sorting();
                if(params.page() !== 1){
                    params.page(1);
                }
            }

            HistoryApiService.getAll(params.page(), params.sorting()).then(function(response) {
                params.total(response.meta.totalPages * response.meta.pageSize);
                updateSearchStatus(response.meta);
                angular.forEach(response.orders, formatOrder);
                if(!vm.initialized) {
                    vm.initialized = true;
                }
                $defer.resolve(response.orders);
            }).finally(function(){ loadSpinnerService.stop();});
        }
    }

    // @ngInject
    function HistoryViewController(AuthService, history, $sce){
        var vm = this;
        vm.history = history;

        activate();

        function activate() {
            AuthService.getUser().then(function(user) {
                vm.user = user;
            });

            if(history) {
                if (vm.history.flowUrl) {
                    vm.history.safeFlowUrl = $sce.trustAsResourceUrl(vm.history.flowUrl);
                }

                vm.links = [
                    {
                        displayName: 'NAVIGATION.HOME',
                        state: {
                            to: 'app.shop.calculator'
                        }
                    },
                    {
                        displayName: 'NAVIGATION.ORDERHISTORY',
                        state: {
                            to: 'app.shop.historyList'
                        }
                    },
                    {
                        displayName: history.id,
                        state: null
                    }
                ];
            }
        }
    }

    angular
        .module('shop.history', [])
        .controller('HistoryListController', HistoryListController)
        .controller('HistoryViewController', HistoryViewController)
        .config(stateConfig);
})();
(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["UsersApiService"];
    cartRowsResolve.$inject = ["CartApiService"];
    placementResolve.$inject = ["PlacementsApiService", "$stateParams"];
    coloursResolve.$inject = ["PlacementsApiService"];
    placementItemsResolve.$inject = ["PlacementsApiService", "$stateParams"];
    playerListResolve.$inject = ["PlayerListApiService", "placement"];
    AdvancedMountingController.$inject = ["$rootScope", "$modal", "$scope", "$state", "$translate", "$q", "loadSpinnerService", "DS", "toastr", "ClubsApiService", "PlacementsApiService", "PlacementImagesApiService", "PlacementOrderApiService", "PlayerDialogService", "ConfirmDialogService", "GarmentsApiService", "TemplateDialogService", "GarmentPickerService", "ValidationManager", "PlayerListApiService", "TemplatePriceDialogService", "TemplateCartDialogService", "StadiumProductTemplatePickerDialogService", "user", "cartRows", "placement", "colours", "placementItems", "playerList"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.advancedMounting', {
            url: '/mounting/{id}',
            views: {
                'main-content': {
                    templateUrl: 'shop/mounting/advancedMounting.tpl.html',
                    controller: 'AdvancedMountingController as vm'
                }
            },
            resolve: {
                user: userResolve,
                cartRows: cartRowsResolve,
                placement: placementResolve,
                colours: coloursResolve,
                placementItems: placementItemsResolve,
                playerList: playerListResolve,
            }
        });
    }

    // @ngInject
    function userResolve(UsersApiService) {
        return UsersApiService.getSelf();
    }

    // @ngInject
    function cartRowsResolve(CartApiService) {
        return CartApiService.getCartRows();
    }

    // @ngInject
    function placementResolve(PlacementsApiService, $stateParams) {
        if ($stateParams.id) {
            return PlacementsApiService.getPlacement($stateParams.id);
        }

        return null;
    }

    // @ngInject
    function coloursResolve(PlacementsApiService) {
        return PlacementsApiService.getColours();
    }

    // @ngInject
    function placementItemsResolve(PlacementsApiService, $stateParams) {
        if ($stateParams.id) {
            return PlacementsApiService.getPlacementItems($stateParams.id);
        }

        return null;
    }

    // @ngInject
    function playerListResolve(PlayerListApiService, placement) {
        if (placement.playerListId) {
            return PlayerListApiService.getPlayerList(placement.playerListId);
        }

        return null;
    }

    // @ngInject
    function AdvancedMountingController(
        $rootScope,
        $modal,
        $scope,
        $state,
        $translate,
        $q,
        loadSpinnerService,
        DS,
        toastr,
        ClubsApiService,
        PlacementsApiService,
        PlacementImagesApiService,
        PlacementOrderApiService,
        PlayerDialogService,
        ConfirmDialogService,
        GarmentsApiService,
        TemplateDialogService,
        GarmentPickerService,
        ValidationManager,
        PlayerListApiService,
        TemplatePriceDialogService,
        TemplateCartDialogService,
        StadiumProductTemplatePickerDialogService,
        user,
        cartRows,
        placement,
        colours,
        placementItems,
        playerList
    ) {
        var vm = this;
        vm.user = user;
        vm.colours = colours;
        vm.placement = placement;
        vm.placementItems = placementItems;
        vm.cartRows = cartRows;
        vm.playerList = playerList;
        vm.placerController = null;
        vm.designPlacerConfig = {};
        vm.printTemplate = {};
        vm.product = {};
        vm.quantity = getQuantity(playerList);
        vm.minQuantity = '1';
        vm.buttonLocked = false;
        vm.placedItemCount = 0;
        vm.errors = [];
        vm.printingPrice = placement.printingPrice;
        vm.printingWork = printingWork;
        vm.printingWorkDifficulties = ["EASY", "HARD"];
        vm.redirectOnClose = '';
        vm.updatingPlacements = false;

        vm.init = init;
        vm.resetActiveViewpoint = resetActiveViewpoint;
        vm.openPlayerDialog = openPlayerDialog;
        vm.openEditMountingDialog = openEditMountingDialog;
        vm.openUploadBackground = openUploadBackground;
        vm.openUploadLogo = openUploadLogo;
        vm.openGarmentPicker = openGarmentPicker;
        vm.clickedAddCart = clickedAddCart;
        vm.clickedUpdateCart = clickedUpdateCart;
        vm.closeTemplateMode = closeTemplateMode;
        vm.isEdit = isEdit;
        vm.isStadium = isStadium;
        vm.isQuickTemplateMode = isQuickTemplateMode;
        vm.isPlacementEmpty = isPlacementEmpty;
        vm.specialDigitsOnTemplate = specialDigitsOnTemplate;
        vm.digitsOnTemplate = digitsOnTemplate;
        vm.isItemPlaced = isItemPlaced;
        vm.onClickTemplateItem = onClickTemplateItem;
        vm.onClickEditPlacementItem = onClickEditPlacementItem;
        vm.onClickRemovePlacementItem = onClickRemovePlacementItem;
        vm.onClickCreateTemplate = onClickCreateTemplate;
        vm.onClickDownloadPdf = onClickDownloadPdf;
        vm.setHandledLegacyTemplate = setHandledLegacyTemplate;
        vm.countPlacements = countPlacements;
        vm.getImageUrl = getImageUrl;
        vm.getPlacementItemType = getPlacementItemType;
        vm.getPlacementItemArtNr = getPlacementItemArtNr;
        vm.isArticleId = isArticleId;
        vm.selectArticle = selectArticle;
        vm.getPlacementItemDescription = getPlacementItemDescription;
        vm.showPlacementItemEdit = showPlacementItemEdit;
        vm.placementItemFilter = placementItemFilter;
        vm.showPrices = showPrices;
        vm.addProductFromCart = addProductFromCart;
        vm.showAddFromCart = showAddFromCart;
        vm.getItemDisplaySize = getItemDisplaySize;
        vm.clearPrintingPrice = clearPrintingPrice;
        vm.updatePrintingPrice = updatePrintingPrice;
        vm.openTemplateAuditLogsDialog = openTemplateAuditLogsDialog;
        vm.openPrintingInformationDialog = openPrintingInformationDialog;
        vm.addToTemplate = addToTemplate;
        vm.copyFromTemplate = copyFromTemplate;

        initialize();

        function initialize() {

            vm.designPlacerConfig = {
                editorSize: {
                    width: 600,
                    height: 600
                },
                editable: vm.placement.draft
            };

            vm.product = {
                id: 1,
                name: vm.placement.garment,
                viewpoints: []
            };

            vm.placement.perspectives.forEach(function (perspective) {
                vm.product.viewpoints.push({
                    name: perspective.name,
                    image: parseImageUrl(perspective.imageUrl) || getDefaultImageUrl(vm.placement.garment, perspective.name),
                    width: 600,
                    height: 600
                });
            });

            vm.placedItemCount = countPlacedItems(vm.placement.perspectives);

            vm.printTemplate = {
                id: vm.placement.placementId,
                viewpoints: getViewpointArray(vm.placement)
            };

            if (!isStadium() && vm.placement.colour) {
                var colour = _.find(vm.colours, function (colour) {
                    return colour.name.toUpperCase() === vm.placement.colour.toUpperCase();
                });

                vm.designPlacerConfig.colour = (colour && colour.code) ? colour.code : '';
            }

            // Set default placeholder item
            if (isStadium()) {
                var newItemName = 'STORE';
                var placeholderItem = _.find(vm.placementItems, { id: '0' });
                if (placeholderItem) {
                    placeholderItem.name = newItemName;
                }
            } else {
                _.remove(vm.placementItems, { id: '0' });
            }
            var cartRow = findMountingCartRow();
            if (cartRow && !vm.placement.playerListId) {
                vm.quantity = cartRow.mounting.placementQuantity;
            }

            checkForInvalidItems();
        }

        function getViewpointArray(placement) {
            var result = [];
            angular.forEach(placement.perspectives, function (perspective) {
                result.push({
                    name: perspective.name,
                    customImage: parseImageUrl(perspective.imageUrl),
                    designs: getDesignArray(perspective)
                });
            });
            return result;
        }

        function getDesignArray(perspective) {
            var result = [];
            angular.forEach(perspective.placementItems, function (placementItem) {
                result.push({
                    id: placementItem.id,
                    image: parseImageUrl(placementItem.imageUrl),
                    x: parseFloat(placementItem.xCoordinate),
                    y: parseFloat(placementItem.yCoordinate),
                    rotation: parseFloat(placementItem.degreeOfRotation),
                    instruction: placementItem.instruction,
                    reference: placementItem.reference,
                    height: parseFloat(placementItem.height),
                    width: parseFloat(placementItem.width),
                    resizable: isResizable(_.find(vm.placementItems, { id: placementItem.reference })),
                    type: placementItem.type
                });
            });
            return result;
        }

        function parseImageUrl(originalImageUrl) {
            if (originalImageUrl == null) {
                return originalImageUrl;
            }

            if (DS.defaults.imageUrlPrefix === '') {
                return originalImageUrl;
            }

            if (originalImageUrl.contains(DS.defaults.imageUrlPrefix)) {
                return originalImageUrl;
            }

            if (originalImageUrl.contains(DS.defaults.oldImageUrlPrefix)) {
                return originalImageUrl.replace(DS.defaults.oldImageUrlPrefix, DS.defaults.imageUrlPrefix);
            }

            return DS.defaults.imageUrlPrefix + originalImageUrl;
        }

        function initViewpoint(viewpoint) {
            var promises = [];
            var viewPointData = vm.printTemplate.viewpoints.filter(function (data) {
                return data.name === viewpoint.name;
            });
            viewPointData = viewPointData.length ? viewPointData[0] : null;
            vm.placerController.addViewpoint(viewpoint);
            if (viewPointData) {
                var setDesignsPromise = vm.placerController.setDesigns(viewpoint.name, viewPointData.designs);
                promises.push(setDesignsPromise);
            }

            var background = viewPointData && viewPointData.customImage ? viewPointData.customImage : viewpoint.image;
            var setBackgroundPromise = vm.placerController.setBackground(viewpoint.name, background);
            promises.push(setBackgroundPromise);

            return $q.all(promises);
        }

        function initViewpoints() {
            loadSpinnerService.start();
            var viewpointPromises = vm.product.viewpoints.map(initViewpoint);

            return $q.all(viewpointPromises)
                .then(function () {
                    updateResizable();
                    loadSpinnerService.stop();
                }, function () {
                    updateResizable();
                    loadSpinnerService.stop();
                });
        }

        function init(controller) {
            vm.placerController = controller;
            initViewpoints();

            var updatePlacementDebounced = _.debounce(function () {
                return updatePlacement().then(function () {
                    vm.updatingPlacements = false;
                });
            }, 700);
            var updatePlacementListener = function () {
                vm.updatingPlacements = true;
                updatePlacementDebounced();
            };
            controller.events.on('update', updatePlacementListener);
            // Ideally we would listen to add & remove to save performance, but those don't exist yet.
            controller.events.on('update', updateResizable);
            controller.events.on('instruction', openInstructionDialog);
            controller.events.on('selectviewpoint', onSelectViewpoint);
            controller.selectViewpoint(vm.product.viewpoints[0].name);
        }

        function checkForInvalidItems() {
            return PlacementsApiService.validateTemplate(vm.placement.placementId).then(function (errors) {

                vm.errors = errors;
            });
        }

        function placementItemFilter(placementItem) {
            if (placementItem.id !== '0' && placementItem.id !== '') {
                return placementItem;
            }
        }

        function updatePlacement() {
            vm.placement.perspectives = getPerspectives();

            var data = {
                templateName: vm.placement.templateName,
                description: vm.placement.description,
                perspectives: vm.placement.perspectives,
                garment: vm.placement.garment,
                colour: vm.placement.colour,
                playerListId: vm.placement.playerListId,
                tags: vm.placement.tags,
                club: vm.placement.club,
                category: vm.placement.category,
                stadiumTemplate: vm.placement.stadiumTemplate,
                articleList: vm.placement.articleList,
                digitList: vm.placement.digitList,
                logoList: vm.placement.logoList,
                stadiumLegacyNotHandled: vm.placement.stadiumLegacyNotHandled
            };
            vm.placedItemCount = countPlacedItems(vm.placement.perspectives);
            return PlacementsApiService.updatePlacement(data, placement.placementId)
                .then(updatePlacementItems);
        }

        function updatePlacementItems(newItems) {
            newItems.forEach(function (newItem) {
                var toUpdate = _.find(vm.placementItems, { id: newItem.id });
                if (!toUpdate) {
                    return;
                }

                toUpdate.height = newItem.height;
                toUpdate.width = newItem.width;
            });
        }

        function getPerspectives() {
            if (isStadium()) {
                return _.map(vm.placerController.viewpoints, function (viewpoint) {
                    return {
                        name: viewpoint.name,
                        imageUrl: parseImageUrl(viewpoint.image),
                        placementItems: getRawPlacementItems(viewpoint)
                    };
                });
            }

            var rawPerspectives = _.map(vm.placerController.viewpoints, function (viewpoint) {
                return {
                    viewpoint: viewpoint,
                    placementItems: getRawPlacementItems(viewpoint)
                };
            });

            var rawItems = _.flatMap(rawPerspectives, function (perspective) {
                return perspective.placementItems;
            });

            var groupedRawItems = _.groupBy(rawItems, function (item) {
                return item.reference;
            });

            var fixedSizes = _.mapValues(groupedRawItems, function (itemGroup, key) {
                if (itemGroup.length <= 1) {
                    return false;
                }

                var baseItem = _.find(vm.placementItems, { id: key });
                return scaleToTemplateSize(baseItem.width, baseItem.height);
            });

            return _.map(rawPerspectives, function (perspective) {
                return {
                    name: perspective.viewpoint.name,
                    imageUrl: parseImageUrl(perspective.viewpoint.image),
                    placementItems: _.map(perspective.placementItems, function (placementItem) {
                        var fixedSize = fixedSizes[placementItem.reference];
                        return fixedSize ?
                            _.assign({}, placementItem, { width: fixedSize.width, height: fixedSize.height })
                            : placementItem;
                    })
                };
            });
        }

        function getRawPlacementItems(viewpoint) {
            var designsPublic = vm.placerController.getDesigns(viewpoint.name);
            return designsPublic.map(function (design) {
                return {
                    id: design.id,
                    type: design.data.type,
                    xCoordinate: design.x,
                    yCoordinate: design.y,
                    width: design.width,
                    height: design.height,
                    imageUrl: parseImageUrl(design.imageUrl),
                    instruction: design.instruction,
                    reference: design.reference,
                    degreeOfRotation: design.rotation
                };
            });
        }

        function countPlacedItems(perspectives) {
            return perspectives.reduce(function (acc, perspective) {
                return acc + perspective.placementItems.length;
            }, 0);
        }

        function resetActiveViewpoint() {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-danger' }];
            ConfirmDialogService.showDialog('Clear current view', 'Are you sure you want to reset the current view? All logos and any custom background will be cleared.', buttons)
                .then(function (button) {
                    if (button.name === 'BUTTON.YES') {
                        vm.placerController.setDesigns(vm.currentViewpoint, []);
                        vm.placerController.setBackground(vm.currentViewpoint, getDefaultImageUrl(vm.product.name, vm.currentViewpoint));
                        updatePlacement();
                    }
                });
        }

        function getDefaultImageUrl(garment, perspective) {
            return './assets/products/' + garment + '-' + perspective + '.png';
        }

        function addDesign(imageUrl, id, size, resizable, type) {
            loadSpinnerService.start();
            vm.placerController.addDesign(vm.currentViewpoint, {
                id: 1,
                type: type,
                reference: id,
                image: imageUrl,
                width: size ? size.width : undefined,
                height: size ? size.height : undefined,
                resizable: resizable
            }).then(function () {
                updateResizable();
                loadSpinnerService.stop();
            });
        }

        function getSizeFromImageUrl(url) {
            var deferred = $q.defer();
            var image = new Image();
            image.onerror = function () {
                deferred.resolve(null);
            };
            image.onload = function () {
                deferred.resolve({ width: this.width, height: this.height });
            };
            image.src = url;
            return deferred.promise;
        }

        function getScaledSizeFromImageUrl(url) {
            var deferred = $q.defer();
            var scale = getTemplateScale();
            getSizeFromImageUrl(url).then(function (size) {
                var maxWidthHeight = 80;
                var width = size.width > size.height ? maxWidthHeight : (size.width / size.height) * maxWidthHeight;
                var height = size.width > size.height ? (maxWidthHeight / size.width) * size.height : maxWidthHeight;
                deferred.resolve({ width: Math.round(width * scale), height: Math.round(height * scale) });
            });
            return deferred.promise;
        }

        function getTemplateScale() {
            return vm.placement.scale;
        }

        function onSelectViewpoint(evt) {
            vm.currentViewpoint = evt.viewpointName;
        }

        function getImageUrl(placementItem) {
            if (placementItem.logoImage) {
                return DS.defaults.baseUrl + 'logoImages/image/' + escapeReference(placementItem.imageId);
            }

            var itemReference;
            if (placementItem.id === '0' || placementItem.id === '') {
                itemReference = isStadium() ? encodeURIComponent('STORE') : encodeURIComponent('NEW ITEM');
            } else {
                itemReference = escapeReference(placementItem.imageId);
            }

            return DS.defaults.baseUrl + 'images/' + itemReference + '?logoId=' + placementItem.id + '&noRedirect=true';
        }

        function escapeReference(item) {
            var itemReference = item.replace(/\.+$/, '');

            // Remove reserved IIS characters
            var reserved = ['<', '>', '*', ':', '%', '&'];

            _.forEach(reserved, function (char) {
                itemReference = itemReference.replace(char, '');
            });

            return encodeURIComponent(itemReference);
        }

        function addPlacementItem(placementItem) {
            if (vm.updatingPlacements) {
                loadSpinnerService.start();
                updatePlacement().then(function () {
                    loadSpinnerService.stop();
                    var updatedPlacement = _.find(vm.placementItems, { id: placementItem.id });
                    addPlacementItemInternal(updatedPlacement);
                });
            } else {
                addPlacementItemInternal(placementItem);
            }
        }

        function addPlacementItemInternal(placement) {
            var imageUrl = getImageUrl(placement);
            var size = getSize(placement);
            if (!size) {
                getScaledSizeFromImageUrl(imageUrl).then(function (imageSize) {
                    addDesign(imageUrl, placement.id, imageSize, isResizable(placement), placement.type);
                });
            } else {
                addDesign(imageUrl, placement.id, size, isResizable(placement), placement.type);
            }
        }

        function onClickTemplateItem(placementItem) {
            addPlacementItem(placementItem);
        }

        function getSize(item) {
            if (isStadium()) {
                return null;
            }

            return scaleToTemplateSize(item.width, item.height);
        }

        function isResizable(item) {
            if (isStadium()) {
                return true;
            }

            if (!item) {
                return true;
            }

            return item.type === "LOGO" || !item.type;
        }

        function updateResizable() {
            var designs = vm.placerController.viewpoints.flatMap(function (viewpoint) {
                return vm.placerController.getDesigns(viewpoint.name);
            });

            var groupedDesigns = _.groupBy(designs, function (placement) {
                return placement.reference;
            });

            var resizableDesigns = _.mapValues(groupedDesigns, function (group, reference) {
                return group.length <= 1 && isResizable(_.find(vm.placementItems, { id: reference })) || isStadium();
            });


            var incorrectGrouped = _.mergeWith(_.clone(groupedDesigns), resizableDesigns, function (group, resizable) {
                return group.filter(function (placement) {
                    return placement.resizable !== resizable;
                }).map(function (placement) {
                    return _.assign({}, placement, { resizable: resizable });
                });
            });

            var incorrectPlacements = _.flatMap(incorrectGrouped);

            incorrectPlacements.forEach(function (placement) {
                placement.setResizable(placement.resizable);
            });
        }

        function scaleToTemplateSize(width, height) {
            return {
                width: width ? Math.max(1, parseInt(width) * getTemplateScale()) : undefined,
                height: height ? Math.max(1, parseInt(height) * getTemplateScale()) : undefined
            };
        }

        function isItemPlaced(reference) {
            if (reference.id === '0' || reference.id === '') {
                return true;
            }

            return vm.placement.perspectives.some(function (perspective) {
                return perspective.placementItems.some(function (placementItem) {
                    return placementItem.reference === reference.id && (!placementItem.type || placementItem.type === reference.type);
                });
            });
        }

        function digitsOnTemplate() {
            var digit = _.find(vm.placementItems, { type: 'DIGIT' });
            return digit;
        }

        function specialDigitsOnTemplate() {
            var digit = _.find(vm.placementItems, { productSubType: 'DIGIT' });
            return digit;
        }

        function countPlacements(reference) {
            var count = 0;
            _.each(vm.placement.perspectives, function (perspective) {
                _.each(perspective.placementItems, function (item) {
                    if (item.reference === reference.id && (!item.type || item.type === reference.type)) {
                        count++;
                    }
                });
            });

            return count === 0 ? 1 : count;
        }

        function openPlayerDialog() {
            var playerListId = vm.placement.playerListId;
            PlayerDialogService.showDialog(playerListId)
                .then(function (data) {
                    vm.placement.playerListId = data.playerListId;
                    return updatePlacement();
                })
                .then(function () {
                    return PlayerListApiService.getPlayerList(vm.placement.playerListId);
                })
                .then(function (playerList) {
                    vm.playerList = playerList;
                    vm.quantity = getQuantity(playerList);
                });
        }

        function openInstructionDialog(design) {
            var instructionDialog = {
                backdrop: 'static',
                controller: 'InstructionDialogController as vm',
                templateUrl: 'shop/mounting/instructionDialog/instructionDialog.tpl.html',
                resolve: {
                    instruction: function () {
                        return design.getInstruction();
                    }
                }
            };
            $modal.open(instructionDialog).result.then(function (instruction) {
                design.setInstruction(instruction);
                updatePlacement();
            });
        }

        function openUploadBackground() {
            var uploadsDialog = {
                backdrop: 'static',
                controller: 'UploadsDialogController as vm',
                templateUrl: 'shop/mounting/uploadsDialog/uploadsDialog.tpl.html',
                resolve: {
                    placementImages: function () {
                        return PlacementImagesApiService.getPlacementBackgrounds(vm.currentViewpoint);
                    },
                    garment: function () {
                        return vm.placement.garment;
                    },
                    perspective: function () {
                        return vm.currentViewpoint;
                    }
                }
            };
            $modal.open(uploadsDialog).result.then(function (data) {
                var imageUrl = DS.defaults.baseUrl + 'placementimages/' + encodeURIComponent(data.imageId);
                vm.placerController.setBackground(vm.currentViewpoint, imageUrl);
                updatePlacement()
                    .then(function () {
                        $state.reload();
                    });
            });
        }

        function openUploadLogo() {
            var uploadsDialog = {
                backdrop: 'static',
                controller: 'UploadsDialogController as vm',
                templateUrl: 'shop/mounting/uploadsDialog/uploadsDialog.tpl.html',
                resolve: {
                    placementImages: function () {
                        return PlacementImagesApiService.getPlacementLogos();
                    },
                    garment: function () {
                        return null;
                    },
                    perspective: function () {
                        return null;
                    }
                }
            };
            $modal.open(uploadsDialog).result.then(function (data) {
                var imageUrl = DS.defaults.baseUrl + 'placementimages/' + encodeURIComponent(data.imageId);
                addDesign(imageUrl);
            });
        }

        function openEditMountingDialog() {
            var editMountingDialog = {
                backdrop: 'static',
                controller: 'EditMountingDialogController as vm',
                templateUrl: 'shop/mounting/editMountingDialog/editMountingDialog.tpl.html',
                resolve: {
                    placement: function () {
                        return PlacementsApiService.getPlacement(vm.placement.placementId);
                    },
                    colours: function () {
                        return vm.colours;
                    },
                    placements: function () {
                        return PlacementsApiService.getStadiumTemplates(null, null, false);
                    },
                    garments: GarmentsApiService.getGarments,
                    clubs: function () {
                        return isStadium() ? ClubsApiService.getClubs() : null;
                    }
                }
            };
            $modal.open(editMountingDialog).result.then(function () {
                $state.reload();
            });
        }

        function openTemplateAuditLogsDialog() {
            var templateAuditDialog = {
                backdrop: 'static',
                controller: 'TemplateAuditLogsDialogController as vm',
                templateUrl: 'shop/mounting/templateAuditLogsDialog/templateAuditLogsDialog.tpl.html',
                resolve: {
                    templateAuditLogs: function () {
                        return PlacementsApiService.getTemplateAuditLogs(vm.placement.placementId);
                    },
                }
            };
            $modal.open(templateAuditDialog).result.then(function () {
                $state.reload();
            });
        }

        function openPrintingInformationDialog() {
            var printingInformationDialog = {
                backdrop: 'static',
                size: 'sm',
                controller: 'PrintingInformationDialogController as vm',
                templateUrl: 'shop/mounting/printingInformationDialog/printingInformationDialog.tpl.html',
                resolve: {
                    printingWork: function () {
                        return vm.printingWork;
                    },
                    placementId: function () {
                        return vm.placement.placementId;
                    },
                }
            };

            $modal.open(printingInformationDialog).result.then(function () {
                $state.reload();
            });
        }


        function openGarmentPicker() {
            GarmentPickerService.showDialog().then(function (garment) {
                vm.placement.garment = garment;

                // Reset perspective imageUrls
                _.each(vm.placement.perspectives, function (perspective) {
                    perspective.imageUrl = '';
                });

                PlacementsApiService.updatePlacement(vm.placement, vm.placement.placementId)
                    .then(function () {
                        $state.reload();
                    }, function (error) {
                        $translate('MESSAGE.UPDATEFAIL').then(function (translation) {
                            if (error && error.message) {
                                toastr.error(error.message, translation);
                            } else {
                                toastr.error(translation);
                            }
                        });
                    });
            });
        }

        function setHandledLegacyTemplate() {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-success' }];
            ConfirmDialogService.showDialog('TOOLTIP.SETHANDLEDLEGACYTEMPLATE', ' ', buttons)
                .then(function (button) {
                    if (button.name === 'BUTTON.YES') {
                        vm.placement.stadiumLegacyNotHandled = false;
                        updatePlacement();
                    }
                });
        }

        function clickedAddCart() {
            if (!vm.placement.playerListId && vm.quantity === 0) {
                return;
            }

            var placementOrder = {
                placementId: placement.placementId,
                quantity: placement.playerListId ? null : vm.quantity
            };

            PlacementOrderApiService.addPlacementToCart(placementOrder)
                .catch(function (error) {
                    ValidationManager.handleResponseError(error);
                    throw error;
                })
                .then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                    return $state.go('app.shop.cart');
                });
        }

        function clickedUpdateCart() {
            if (!vm.placement.playerListId && vm.quantity === 0) {
                return;
            }

            var placementOrder = {
                placementId: placement.placementId,
                quantity: placement.playerListId ? null : vm.quantity
            };
            PlacementOrderApiService.updatePlacementInCart(placementOrder)
                .catch(function (error) {
                    ValidationManager.handleResponseError(error);
                    throw error;
                })
                .then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                    $state.go('app.shop.cart');
                });
        }

        function isEdit() {
            return !!findMountingCartRow();
        }

        function findMountingCartRow() {
            return _.find(vm.cartRows, function (row) {
                return row.mounting && row.mounting.placementId === vm.placement.placementId;
            });
        }

        function isStadium() {
            return vm.user && vm.user.stadium;
        }

        function isQuickTemplateMode() {
            return isStadium() && vm.user.orderReference !== null;
        }

        function isPlacementEmpty() {
            if (vm.placerController) {
                var result = true;
                angular.forEach(vm.placerController.viewpoints, function (viewpoint) {
                    result = result && (viewpoint.editor.placingLayer.designs.length === 0);
                });
                return result;
            }
        }

        function onClickRemovePlacementItem(placementItem) {
            if (placementItem.id === '0' || placementItem.id === null) {
                return;
            }

            var data = {
                articleList: [],
                digitList: [],
                logoList: []
            };

            if (placementItem.type === 'ARTICLE') {
                data.articleList = [placementItem.id];

                _.remove(vm.placement.articleList, function (articleId) {
                    return articleId === placementItem.id;
                });
            }
            if (placementItem.type === 'LOGO' || placementItem.type === 'NAME') {
                data.logoList = [placementItem.id];

                _.remove(vm.placement.logoList, function (logoId) {
                    return logoId === placementItem.id;
                });
            }
            if (placementItem.type === 'DIGIT') {
                data.digitList = [placementItem.id];

                _.remove(vm.placement.digitList, function (digitId) {
                    return digitId === placementItem.id;
                });
            }

            _.remove(vm.placementItems, function (item) {
                return item.id === placementItem.id && item.type === placementItem.type;
            });

            // Remove item from template in backend
            PlacementsApiService.removeItemsFromTemplate(vm.placement.placementId, data)
                .then(checkForInvalidItems);
        }

        function onClickCreateTemplate() {
            TemplateDialogService.showTemplateDialog(null, null, vm.placement.club, vm.placement.category, false, true)
                .then(function (template) {
                    PlacementsApiService.openTemplate(template.placementId)
                        .then(function () {
                            $rootScope.$broadcast('$updateNotifications');
                        }).finally(function () {
                            $state.go('app.shop.advancedMounting', { id: template.placementId });
                        });
                });
        }

        function onClickDownloadPdf() {
            vm.buttonLocked = true;

            var maxSize = {
                width: 1200,
                height: 1200
            };

            /* jshint ignore:start */
            // Igorned due to issue with library not having a uppercase name for class
            var doc = new jsPDF('p', 'mm', 'a4'); // 210 x 297 in mm
            /* jshint ignore:end */
            var firstPage = true;

            var perspectiveImages = [];
            _.each(vm.product.viewpoints, function (viewPoint) {
                perspectiveImages.push(processImages(viewPoint, maxSize));
            });

            $q.all(perspectiveImages).then(function (images) {
                _.each(images, function (image) {
                    if (!firstPage) {
                        doc.addPage();
                    }

                    // header
                    doc.addImage("./assets/images/Tokyo_PDF.png", 'png', 84, 10, 42, 14, '', 'slow');  // 84mm x 28mm

                    // template name
                    doc.setFont("helvetica");
                    doc.setFontType("normal");
                    doc.setFontSize(14);
                    doc.text(vm.placement.templateName, 105, 60, { align: 'center' });

                    // image & watermark
                    doc.setFillColor(0, 0, 0);
                    doc.roundedRect(20, 62.5, 170, 170, 2, 2);
                    doc.addImage(image.image, 'png', 25, 67.5, 160, 160, '', 'slow');

                    // perspective name
                    doc.setFont("helvetica");
                    doc.setFontType("normal");
                    doc.setFontSize(12);
                    doc.text(image.name, 105, 238, { align: 'center' });

                    // footer
                    doc.text("Copyright © Bamatex AB", 105, 295, { align: 'center' });

                    firstPage = false;
                });
            }).then(function () {
                doc.setProperties({
                    title: vm.placement.templateName,
                    subject: 'Placement template',
                    keywords: 'placement, template, Tokyo, Bamatex AB',
                    creator: 'Tokyo - Bamatex AB',
                    created: new Date()
                });
                doc.save(vm.placement.templateName + '.pdf');
            }).finally(function () {
                vm.buttonLocked = false;
            });
        }

        function processImages(viewPoint, maxSize) {
            return $q(function (resolve, reject) {
                var editor = vm.placerController.getEditor(viewPoint.name);
                var perspectiveImage = editor.getImageData(maxSize);

                loadPlaceHolderImage(perspectiveImage).then(function (image) {
                    resolve({ name: viewPoint.name, image: image });
                }).catch(function (reason) {
                    reject(reason);
                });
            });
        }

        function loadPlaceHolderImage(imageUrl) {
            return $q(function (resolve, reject) {
                var placeholderImage = new Image();
                placeholderImage.onload = function () {
                    var h = placeholderImage.height, w = placeholderImage.width;
                    var canvas = Object.assign(document.createElement('canvas'), { width: w, height: h });
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(placeholderImage, 0, 0);

                    try {
                        var image = canvas.toDataURL('image/png');
                        resolve(image);
                    } catch (e) {
                        reject('Failed to load placeholderImage!');
                    }
                };
                placeholderImage.src = imageUrl;
            });
        }

        function getPlacementItemType(placementItem) {
            switch (placementItem.type) {
                case 'ARTICLE':
                    return 'MOUNTING.ARTICLE';
                case 'DIGIT':
                    return 'PRODUCT.TYPE.DIGIT';
                case 'NAME':
                    return 'NAME.PLAYERLISTTYPE.' + placementItem.productSubType;
                default:
                    return '';
            }
        }

        function getPlacementItemArtNr(placementItem) {
            switch (placementItem.type) {
                case 'ARTICLE':
                case 'DIGIT':
                    return placementItem.id;
                case 'LOGO':
                case 'NAME':
                    return 'PRODUCT.TYPE.' + placementItem.productType;
                default:
                    return '';
            }
        }

        function isArticleId(placementItem) {
            return placementItem.type === "ARTICLE";
        }

        function selectArticle(id) {
            $state.go('app.shop.articleView', { id: id });
        }

        function getItemDisplaySize(item) {
            if (item.width && item.height) {
                return item.width + " mm x " + item.height + " mm";
            }
            return "";
        }

        function getPlacementItemDescription(placementItem) {
            switch (placementItem.type) {
                case 'ARTICLE':
                    return 'ARTICLE';
                case 'DIGIT':
                    return 'PRODUCT.TYPE.DIGIT';
                case 'LOGO':
                    return 'PRODUCT.TYPE.' + placementItem.productType;
                case 'NAME':
                    return 'NAME.PLAYERLISTTYPE.' + placementItem.productSubType;
                default:
                    return '';
            }
        }

        function showPlacementItemEdit(placementItem) {
            switch (placementItem.type) {
                case 'LOGO':
                case 'NAME':
                    return true;
                default:
                    return false;
            }
        }

        function onClickEditPlacementItem(placementItem) {
            switch (placementItem.type) {
                case 'LOGO':
                    if (isStadium()) {
                        $state.go('app.shop.stadiumLogoEdit', { logoId: placementItem.id });
                    } else {
                        $state.go('app.shop.edit', {
                            articleGroup: placementItem.groupType,
                            logoId: placementItem.id
                        });
                    }
                    break;
                case 'NAME':
                    if (!isStadium()) {
                        $state.go('app.shop.editName', { id: placementItem.id });
                        break;
                    }

                    if (placementItem.productSubType === 'NAME') {
                        $state.go('app.shop.editName', { id: placementItem.id });
                    } else if (placementItem.productSubType === 'INITIAL') {
                        $state.go('app.shop.editInitial', { id: placementItem.id });
                    } else if (placementItem.productSubType === 'DIGIT') {
                        $state.go('app.shop.editDigit', { id: placementItem.id });
                    }
                    break;
                default:
                    return;
            }
        }


        function addToTemplate() {
            PlacementsApiService.addItemsToTemplate(vm.placement.placementId, { addDefaultProducts: true })
                .then(function () {
                    $state.reload();
                });
        }

        function copyFromTemplate() {
            StadiumProductTemplatePickerDialogService.showDialog(true)
                .then(function (productTemplate) {
                    PlacementsApiService.copyItemsToTemplate(vm.placement.placementId, productTemplate)
                        .then(function () {
                            $state.reload();
                        });
                });
        }

        function getQuantity(playerList) {
            if (playerList) {
                return playerList.players.reduce(function (previous, current) {
                    return previous + parseInt(current.quantity);
                }, 0);
            }
            return 0;
        }

        function showPrices() {
            TemplatePriceDialogService.showDialog(vm.placement.placementId, vm.quantity);
        }

        function showAddFromCart() {
            return isStadium() && isQuickTemplateMode();
        }

        function addProductFromCart() {
            TemplateCartDialogService.show(vm.placement.placementId)
                .finally(function () {
                    $state.reload();
                });
        }

        function updatePrintingPrice() {
            loadSpinnerService.start();
            var data = {};
            data.price = vm.printingPrice;
            PlacementsApiService.updatePrintingPrice(
                vm.placement.placementId,
                data
            ).then(function () {
                loadSpinnerService.stop();
            }).catch(function (error) {
                ValidationManager.handleResponseError(error);
            });
        }

        function clearPrintingPrice() {
            PlacementsApiService.clearPrintingPrice(
                vm.placement.placementId
            )
                .then(function () {
                    vm.printingPrice = null;
                })
                .catch(function (error) {
                    ValidationManager.handleResponseError(error);
                });
        }

        function isDirty() {
            var dirty = false;
            dirty = dirty || vm.printingPrice !== vm.placement.printingPrice;

            return dirty;
        }

        function closeTemplateMode() {
            if (isDirty()) {
                updatePrintingPrice();
            }
            PlacementsApiService.closeTemplate()
                .then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                })
                .then(function () {
                    if (vm.placement.type === 'STADIUM_PRODUCT_TEMPLATE') {
                        if (vm.placement.stadiumProductId) {
                            $state.go('app.shop.stadiumproduct', { id: vm.placement.stadiumProductId });
                        } else {
                            $state.go('app.shop.stadiumproducts');
                        }
                    } else {
                        $state.go('app.shop.stadiumStart');
                    }
                });
        }

        function printingWork() {
            var printingWork = PlacementsApiService.getPrintingWork(vm.placement.placementId);
            if (printingWork.difficulty == undefined || printingWork.difficulty == undefined) {
                printingWork = null;
            }
            return printingWork;
        }


        $scope.$on('$stateChangeStart', function (event, newUrl, current) {
            if (!isDirty()) {
                return;
            }
        });
    }

    angular
        .module('shop.mounting.advancedMounting', ['designPlacer', 'services.playerDialog', 'editMountingDialog', 'uploadsDialog', 'instructionDialog', 'templateAuditLogsDialog', 'printingInformationDialog'])
        .controller('AdvancedMountingController', AdvancedMountingController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    // @ngInject
    EditMountingDialogController.$inject = ["$filter", "$modalInstance", "$translate", "toastr", "loadSpinnerService", "AuthService", "ClubsApiService", "PlacementsApiService", "placements", "garments", "colours", "clubs", "placement"];
    function EditMountingDialogController(
        $filter,
        $modalInstance,
        $translate,
        toastr,
        loadSpinnerService,
        AuthService,
        ClubsApiService,
        PlacementsApiService,
        placements,
        garments,
        colours,
        clubs,
        placement
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.placements = placements;
        vm.clubs = clubs;
        vm.categories = null;
        vm.garments = [];
        vm.colours = colours;
        vm.tags = placement.tags;
        vm.selectedClub = null;
        vm.selectedCategory = null;
        vm.selectedColours = [];
        vm.templateName = placement.templateName;
        vm.description = placement.description;
        vm.placementId = placement.placementId;
        vm.nameIsUnique = true;
        vm.clubRequired = false;
        vm.categoryRequired = false;
        vm.isTemplateMode = false;
        vm.isQuickTemplateMode = false;
        vm.close = close;
        vm.save = save;
        vm.isValid = isValid;
        vm.checkNameIsUnique = checkNameIsUnique;
        vm.resetImageUrls = resetImageUrls;
        vm.newTag = newTag;
        vm.onSelectClub = onSelectClub;
        vm.onNewCustomColour = onNewCustomColour;

        init();

        function init() {
            initUser();
            initGarments();
            initActiveGarment();
            initActiveColour();
            initActiveClubAndCategory();
        }

        function initUser() {
            AuthService.getUser().then(function(user) {
                vm.user = user;
                vm.isTemplateMode = vm.user.templateId;
                vm.isQuickTemplateMode = vm.isTemplateMode && vm.user.orderReference !== null;
            });
        }

        function initGarments() {
            angular.forEach(garments, function(value, key) {
                vm.garments.push({
                    key: key,
                    value: $filter('translate')('GARMENT.TYPE.' + key)
                });
            });
        }

        function initActiveGarment() {
            var garmentIndex = _.findIndex(vm.garments, function(garment) {
                return garment.key === placement.garment;
            });
            if (garmentIndex !== -1) {
                vm.garment = vm.garments[garmentIndex];
            }
        }

        function initActiveColour() {
            var placementColour = placement.colour ? placement.colour.toUpperCase() : '';
            var colourIndex = _.findIndex(vm.colours, function(colour) {
                return colour.name.toUpperCase() === placementColour;
            });
            if (colourIndex !== -1) {
                vm.selectedColours[0] = vm.colours[colourIndex];
            }
            else if(colourIndex === -1 && placement.colour) {
                vm.selectedColours[0] = {name: placement.colour};
            }
        }

        function initActiveClubAndCategory() {
            if (!vm.clubs) {
                return;
            }

            vm.selectedClub = _.find(vm.clubs, function (club) {
                return club.clubId === placement.club;
            });

            if (vm.selectedClub) {
                ClubsApiService.getCategories(vm.selectedClub.clubId).then(function (categories) {
                    vm.categories = categories;
                    vm.selectedCategory = _.find(vm.categories, { categoryId: placement.category });
                });
            }
        }

        function close() {
            $modalInstance.dismiss();
        }

        function save() {
            if (vm.user.stadium && vm.isTemplateMode && !vm.isQuickTemplateMode) {
                if (checkClubAndCategoryAreSelected()) {
                    return;
                }
            }

            placement.templateName = vm.templateName;
            placement.description = vm.description;
            placement.garment = vm.garment.key;
            placement.colour = vm.selectedColours[0] ? vm.selectedColours[0].name : '';
            placement.tags = vm.tags;
            placement.club = vm.selectedClub ? vm.selectedClub.clubId : '';
            placement.category = vm.selectedCategory ? vm.selectedCategory.categoryId : '';
            loadSpinnerService.start();
            PlacementsApiService.updatePlacement(placement, placement.placementId).then(function() {
                $modalInstance.close();
            }, function(error) {
                $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                    if (error && error.message) {
                        toastr.error(error.message, translation);
                    } else {
                        toastr.error(translation);
                    }
                });
            }).finally(loadSpinnerService.stop);
        }

        function isValid() {
            return vm.templateName && vm.nameIsUnique;
        }

        function checkNameIsUnique() {
            vm.nameIsUnique = !_.some(vm.placements, function(placement) {
                // Since the active placement of the dialog is present in vm.placements, we need to compare ids as well.
                return placement.templateName === vm.templateName && placement.placementId !== vm.placementId;
            });
        }

        function checkClubAndCategoryAreSelected() {
            vm.clubRequired = !vm.selectedClub;
            vm.categoryRequired = !vm.selectedCategory;

            return vm.clubRequired || vm.categoryRequired;
        }

        function resetImageUrls() {
            angular.forEach(placement.perspectives, function(perspective) {
                perspective.imageUrl = '';
            });
        }

        function newTag(tag){
            if(tag.length > 20) {
                $translate('MESSAGE.MAXTAGLENGTH').then(function (translation) {
                    toastr.error(translation);
                });
                return false;
            } else {
                return tag.replace(',', '');
            }
        }

        function onSelectClub() {
            vm.selectedCategory = null;
            ClubsApiService.getCategories(vm.selectedClub.clubId).then(function(categories) {
                vm.categories = categories;
            });
        }

        function onNewCustomColour(colour) {
            return { name: colour };
        }
    }

    angular
        .module('editMountingDialog', [])
        .controller('EditMountingDialogController', EditMountingDialogController);
})();

(function() {

    "use strict";

    // @ngInject
    InstructionDialogController.$inject = ["$modalInstance", "instruction"];
    function InstructionDialogController($modalInstance, instruction) {
        /* jshint validthis: true */
        var vm = this;
        vm.instruction = instruction;
        vm.clear = clear;
        vm.close = close;
        vm.save = save;

        function save() {
            $modalInstance.close(vm.instruction);
        }

        function close() {
            $modalInstance.dismiss();
        }

        function clear() {
            vm.instruction = "";
        }
    }

    angular
        .module("instructionDialog", [])
        .controller("InstructionDialogController", InstructionDialogController);
})();
(function () {

    'use strict';

    // @ngInject
    PrintingInformationDialogController.$inject = ["$modalInstance", "loadSpinnerService", "PlacementsApiService", "printingWork", "placementId"];
    function PrintingInformationDialogController(
        $modalInstance,
        loadSpinnerService,
        PlacementsApiService,
        printingWork,
        placementId
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.close = close;
        vm.save = save;
        vm.missingValues = missingValues;
        vm.printingWork = printingWork;
        vm.printingWorkDifficulties = ["EASY", "HARD"];
        vm.clearPrintingInformation = clearPrintingInformation;
        vm.placementId = placementId;
        init();

        function close() {
            $modalInstance.dismiss();
        }

        function save() {
            updatePrintingInformation();
            $modalInstance.dismiss();
        }

        function missingValues() {
            return vm.printingWork.printCount === null || vm.printingWork.printCount === 0 || vm.printingWork.difficulty === null;
        }

        function clearPrintingInformation() {
            if(vm.printingWork.printCount != null && vm.printingWork.difficulty != null) {
            PlacementsApiService.clearPrintingInformation(
                vm.placementId
            )
                .then(function () {
                    vm.printingWork.printCount = null;
                    vm.printingWork.difficulty = null;
                })
                .catch(function (error) {
                    ValidationManager.handleResponseError(error);
                });
            }
        }

        function updatePrintingInformation() {
            loadSpinnerService.start();
            var data = {};
            data.printCount = vm.printingWork ? vm.printingWork.printCount : "";
            data.difficulty = vm.printingWork ? vm.printingWork.difficulty : "";
            PlacementsApiService.updatePrintingInformation(
                vm.placementId,
                data
            ).then(function () {
                loadSpinnerService.stop();
            }).catch(function (error) {
                ValidationManager.handleResponseError(error);
            });
        }

        function init() {
            if (printingWork.difficulty == undefined || printingWork.difficulty == undefined) {
                vm.printingWork.difficulty = null;
                vm.printingWork.printCount = 0;
            }
            vm.printingWork = angular.copy(printingWork);
        }
    }

    angular
        .module('printingInformationDialog', [])
        .controller('PrintingInformationDialogController', PrintingInformationDialogController);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    productTypesResolve.$inject = ["ArticlesApiService"];
    mountingItemsResolve.$inject = ["MountingItemsApiService"];
    customerSettingsResolve.$inject = ["AuthService", "CustomerSettingsApiService"];
    SimpleMountingController.$inject = ["$anchorScroll", "$location", "$translate", "loadSpinnerService", "LogosApiService", "toastr", "productTypes", "user", "mountingItems", "customerSettings"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.mounting', {
            url: '/mounting',
            views: {
                "main-content": {
                    templateUrl: 'shop/mounting/simpleMounting.tpl.html',
                    controller: 'SimpleMountingController as vm'
                }
            },
            resolve: {
                user: userResolve,
                productTypes: productTypesResolve,
                mountingItems: mountingItemsResolve,
                customerSettings: customerSettingsResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function productTypesResolve(ArticlesApiService) {
        return ArticlesApiService.getProductTypes("mounting");
    }

    // @ngInject
    function mountingItemsResolve(MountingItemsApiService) {
        return MountingItemsApiService.getMountingItems();
    }

    // @ngInject
    function customerSettingsResolve(AuthService, CustomerSettingsApiService) {
        return AuthService.getUser()
            .then(function (user) {
                var customerId = user.orderRecipient ? user.orderRecipient.customerId : user.customerId;
                return CustomerSettingsApiService.getCustomerSettings(customerId);
            });
    }

    // @ngInject
    function SimpleMountingController(
        $anchorScroll,
        $location,
        $translate,
        loadSpinnerService,
        LogosApiService,
        toastr,
        productTypes,
        user,
        mountingItems,
        customerSettings
    ) {
        var vm = this;
        vm.customerSettings = customerSettings;
        vm.productType = productTypes[0];
        vm.mountingItems = mountingItems;
        vm.isAdmin = user.admin;
        vm.isStadium = user.stadium;
        vm.productSybtype = null;
        vm.mountingArticle = null;
        vm.externalItem = false;
        vm.minQuantity = 1;
        vm.article = {};
        vm.files = [];
        vm.tags = [];

        vm.onClickToggle = onClickToggle;
        vm.save = save;
        vm.isValid = isValid;
        vm.clearMountingArticle = clearMountingArticle;
        vm.onClickClearErrand = onClickClearErrand;

        activate();

        function activate() {
            vm.article = {
                height: "",
                width: "",
                colours: [],
                tags: [],
                information: "",
                mountingArticle: null,
                process: false,
                contact: false,
                quantity: "0",
                errand: null,
                garment: "",
                placement: ""
            };
            vm.minQuantity = vm.productType.quantitySettings.minOrderQuantity;
            vm.article.quantity = vm.minQuantity;

            if (!vm.customerSettings.noApproval && vm.customerSettings.autoReject) {
                vm.article.contact = true;
            }
        }

        function clearMountingArticle() {
            if (vm.externalItem) {
                vm.mountingArticle = null;
            }
        }

        function isValid() {
            var result = true;
            result = result && vm.productSubtype;
            result =  result && vm.mountingArticle || vm.externalItem;
            return result;
        }

        function save() {
            if(!validForm()){
                $anchorScroll();
                return;
            }
            applyArticleData();
            loadSpinnerService.start();
            LogosApiService.newLogo(vm.article).then(function() {
                $location.path("/cart");
            },function(error){
                $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                    if(error && error.message){
                        toastr.error(error.message,translation);
                    }else{
                        toastr.error(translation);
                    }
                });
            }).finally(function(){loadSpinnerService.stop();});
        }

        function applyArticleData() {
            if (vm.files) {
                vm.article.file = vm.files[0];
            }
            if (vm.mountingArticle) {
                vm.article.mountingArticle = vm.mountingArticle.id;
            }
            vm.article.productType = vm.productType.name;
            vm.article.productSubtype = vm.productSubtype.name;
        }

        function validForm() {
            var isValid = true;

            if (vm.productType && (parseInt(vm.article.quantity) < vm.productType.quantitySettings.minOrderQuantity)) {
                isValid = false;
            }
            if (vm.form.$error && (vm.form.$error.required || vm.form.$error.integer)){
                isValid = false;
            }
            return isValid;
        }

        function onClickToggle() {
            vm.toggleView = !vm.toggleView;
        }

        function onClickClearErrand() {
            vm.article.errand = null;
        }
    }

    angular
        .module('shop.mounting.simpleMounting', [])
        .controller('SimpleMountingController', SimpleMountingController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    // @ngInject
    TemplateAuditLogsDialogController.$inject = ["$modalInstance", "templateAuditLogs"];
    function TemplateAuditLogsDialogController(
        $modalInstance,
        templateAuditLogs
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.close = close;
        vm.templateAuditLogs = templateAuditLogs;


        function close() {
            $modalInstance.dismiss();
        }
    }

    angular
        .module('templateAuditLogsDialog', [])
        .controller('TemplateAuditLogsDialogController', TemplateAuditLogsDialogController);
})();

(function() {

    "use strict";

    // @ngInject
    UploadsDialogController.$inject = ["DS", "$modalInstance", "PlacementImagesApiService", "ConfirmDialogService", "loadSpinnerService", "placementImages", "perspective"];
    function UploadsDialogController(DS, $modalInstance, PlacementImagesApiService, ConfirmDialogService, loadSpinnerService, placementImages, perspective) {
        /* jshint validthis: true */
        var vm = this;
        vm.files = [];
        vm.name = '';
        vm.radioChoice = 'radioNew';
        vm.perspective = perspective;
        vm.originalPlacementImages = placementImages;
        vm.placementImages = placementImages;
        vm.selectedImage = null;
        vm.hidden = false;
        vm.isValidFile = true;
        vm.search = '';
        vm.close = close;
        vm.upload = upload;
        vm.use = use;
        vm.imageUrl = imageUrl;
        vm.deletePlacementImage = deletePlacementImage;
        vm.onClickImage = onClickImage;
        vm.removeFile = removeFile;
        vm.onFileSelect = onFileSelect;
        vm.filter = filter;

        function onFileSelect(file) {
            var extension = file.name.split('.')[1].toLowerCase();
            if(extension === 'png') {
                vm.isValidFile = true;
            } else {
                vm.isValidFile = false;
            }
        }

        function filter() {
            if (vm.search === '') {
                vm.placementImages = vm.originalPlacementImages;
                return;
            }

            vm.placementImages = vm.originalPlacementImages.filter(function (placement) {
                return placement.name.toLowerCase().startsWith(vm.search.toLowerCase());
            });
        }

        function imageUrl(placementImage) {
            return DS.defaults.baseUrl + 'placementimages/' + encodeURIComponent(placementImage.imageId);
        }

        function deletePlacementImage(placementImage) {
            vm.hidden = true;
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default'}, { name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('UPLOADPOPUP.DELETE1', 'UPLOADPOPUP.DELETE2', buttons).then(function(button) {
                vm.hidden = false;
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    PlacementImagesApiService.deletePlacementImage(placementImage.imageId).then(function() {
                        if (vm.perspective) {
                            PlacementImagesApiService.getPlacementBackgrounds(perspective).then(function(data) {
                                vm.placementImages = data;
                                vm.originalPlacementImages = data;
                            });
                        }
                        else {
                            PlacementImagesApiService.getPlacementLogos().then(function(data) {
                                vm.placementImages = data;
                                vm.originalPlacementImages = data;
                            });
                        }
                    }).finally(function() {
                        loadSpinnerService.stop();
                    });
                }
            });
        }

        function onClickImage(placementImage) {
            vm.selectedImage = placementImage;
        }

        function upload() {
            var data = {
                name: vm.name,
                perspective: perspective,
                file: vm.files[0]
            };
            PlacementImagesApiService.uploadPlacementImage(data).then(function(result) {
                $modalInstance.close({
                    imageId: result.imageId
                });
            });
        }

        function removeFile() {
            vm.files = [];
        }

        function use() {
            $modalInstance.close({
                imageId: vm.selectedImage.imageId
            });
        }

        function close() {
            $modalInstance.dismiss();
        }
    }

    angular
        .module("uploadsDialog", [])
        .controller("UploadsDialogController", UploadsDialogController);
})();
(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    metaDataResolve.$inject = ["NamesApiService"];
    logoResolve.$inject = ["LogosApiService", "$stateParams"];
    nameResolve.$inject = ["NamesApiService", "$stateParams"];
    NameController.$inject = ["$q", "$state", "$translate", "$window", "$anchorScroll", "DS", "loadSpinnerService", "toastr", "PlayerDialogService", "NamesApiService", "ColorPickerDialogService", "PlayerListApiService", "PlacementsApiService", "ValidationManager", "user", "metaData", "logo", "name"];
    function stateConfig($stateProvider) {
        $stateProvider
            .state('app.shop.name', {
                url: '/name',
                views: {
                    'main-content': {
                        templateUrl: 'shop/name/name.tpl.html',
                        controller: 'NameController as vm'
                    }
                },
                resolve: {
                    metaData: metaDataResolve,
                    user: userResolve,
                    logo: logoResolve,
                    name: nameResolve
                }
            })
            .state('app.shop.editName', {
                url: '/name/{id}',
                views: {
                    'main-content': {
                        templateUrl: 'shop/name/name.tpl.html',
                        controller: 'NameController as vm'
                    }
                },
                resolve: {
                    metaData: metaDataResolve,
                    user: userResolve,
                    logo: logoResolve,
                    name: nameResolve
                }
            });
        $stateProvider
            .state('app.shop.initial', {
                url: '/initial',
                views: {
                    'main-content': {
                        templateUrl: 'shop/name/name.tpl.html',
                        controller: 'NameController as vm'
                    }
                },
                resolve: {
                    metaData: metaDataResolve,
                    user: userResolve,
                    logo: logoResolve,
                    name: nameResolve
                }
            })
            .state('app.shop.editInitial', {
                url: '/initial/{id}',
                views: {
                    'main-content': {
                        templateUrl: 'shop/name/name.tpl.html',
                        controller: 'NameController as vm'
                    }
                },
                resolve: {
                    metaData: metaDataResolve,
                    user: userResolve,
                    logo: logoResolve,
                    name: nameResolve
                }
            });
        $stateProvider
            .state('app.shop.digit', {
                url: '/digit',
                views: {
                    'main-content': {
                        templateUrl: 'shop/name/name.tpl.html',
                        controller: 'NameController as vm'
                    }
                },
                resolve: {
                    metaData: metaDataResolve,
                    user: userResolve,
                    logo: logoResolve,
                    name: nameResolve
                }
            })
            .state('app.shop.editDigit', {
                url: '/digit/{id}',
                views: {
                    'main-content': {
                        templateUrl: 'shop/name/name.tpl.html',
                        controller: 'NameController as vm'
                    }
                },
                resolve: {
                    metaData: metaDataResolve,
                    user: userResolve,
                    logo: logoResolve,
                    name: nameResolve
                }
            });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function metaDataResolve(NamesApiService) {
        return NamesApiService.getMetaData();
    }

    // @ngInject
    function logoResolve(LogosApiService, $stateParams) {
        if ($stateParams.id) {
            return LogosApiService.getLogo($stateParams.id);
        }

        return null;
    }

    // @ngInject
    function nameResolve(NamesApiService, $stateParams) {
        if ($stateParams.id) {
            return NamesApiService.getName($stateParams.id);
        }

        return null;
    }

    // @ngInject
    function NameController(
        $q,
        $state,
        $translate,
        $window,
        $anchorScroll,
        DS,
        loadSpinnerService,
        toastr,
        PlayerDialogService,
        NamesApiService,
        ColorPickerDialogService,
        PlayerListApiService,
        PlacementsApiService,
        ValidationManager,
        user,
        metaData,
        logo,
        name
    ) {
        var vm = this;
        vm.user = user;
        vm.originalLogo = logo;
        vm.originalName = name;
        vm.metaData = metaData;
        vm.playerListTypes = [];
        vm.names = '';
        vm.minQuantity = 1;
        vm.freeTextQuantity = 1;
        vm.players = [];
        vm.playerListName = '';
        vm.selectedPlayerList = null;
        vm.colours = [];
        vm.selectedFont = [];
        vm.maxColourCount = 1;
        vm.selectedColours = {
            text: [],
            background: []
        };
        vm.files = [];
        vm.attachmentUrl = null;
        vm.isAttachmentSet = false;
        vm.validationErrors = {};
        vm.hasErrors = false;

        vm.openPlayerListDialog = openPlayerListDialog;
        vm.clearPlayerLists = clearPlayerLists;
        vm.showNamePreview = showNamePreview;
        vm.setNamePreviewPlayers = setNamePreviewPlayers;
        vm.newCustomColour = newCustomColour;
        vm.openColourPicker = openColourPicker;
        vm.onHeightTypeChange = onHeightTypeChange;
        vm.getFile = getFile;
        vm.onFileSelect = onFileSelect;
        vm.submit = submit;
        vm.getTitle = getTitle;
        vm.getBreadText = getBreadText;
        vm.getSelectedFontName = getSelectedFontName;
        vm.isStadium = isStadium;
        vm.isEditMode = isEditMode;
        vm.isTemplateMode = isTemplateMode;
        vm.isDigit = isDigit;
        vm.getNoMatchingPlayersError = getNoMatchingPlayersError;

        initialise();

        function initialise() {
            NamesApiService.getCustomerFontList()
                .then(function (fontTypes) {
                    vm.metaData.fontTypes = fontTypes;

                    if (!isEditMode() && isStadium()) {
                        setPreselected();
                    }
                });

            vm.name = {
                description: '',
                fontType: '',
                formType: '',
                caseType: '',
                backgroundColour: '',
                textColour: '',
                tags: [],
                file: null,
                information: '',
                playerListId: '',
                playerListTypes: [],
                height: '',
                width: '',
                heightRelative: false
            };

            initialisePlayerListTypes();
            if (isEditMode()) {
                initialiseEdit();
            } else {
                initialiseColours();
            }
        }

        function initialiseEdit() {
            vm.name = vm.originalName;

            // Font
            if (vm.name.fontType) {
                vm.selectedFont.push(vm.name.fontType);
            } else if (vm.name.ownFont) {
                vm.selectedFont.push(vm.name.ownFont);
            }

            // Information
            vm.name.information = vm.originalLogo.logoInformation;
            vm.name.description = vm.originalLogo.logoName;
            vm.name.height = vm.originalLogo.logoHeight;
            vm.name.width = vm.originalLogo.logoWidth;
            vm.name.tags = vm.originalLogo.tags;

            // Player list types
            activatePlayerListType(vm.name.playerListScopeType);

            // Colours
            var found = _.find(vm.playerListTypes, {
                'name': vm.name.playerListScopeType ? vm.name.playerListScopeType : isName() ? 'NAME' : 'INITIAL'
            });
            NamesApiService.getColours(found.colourType)
                .then(function (colours) {
                    vm.colours = colours;
                    var textColour = _.find(vm.colours, {'name': vm.name.textColour});
                    var backgroundColour = _.find(vm.colours, {'name': vm.name.backgroundColour});
                    vm.selectedColours.text.push(textColour ? textColour : newCustomColour(vm.name.textColour));
                    vm.selectedColours.background.push(backgroundColour ? backgroundColour : newCustomColour(vm.name.backgroundColour));
                });

            // Init HeightRelative property
            if (vm.name.heightRelative) {
                vm.name.height = '';
            }

            // Attachment info
            if (vm.originalLogo.attachmentExtension) {
                vm.files[0] = {
                    name: 'CREATEARTICLE.ATTACHMENTS.VIEWFILE'
                };
                vm.isAttachmentSet = true;
            }
        }

        function initialiseColours() {
            var found = _.find(vm.playerListTypes, {'name': isInitial() ? 'INITIAL' : 'NAME'});
            NamesApiService.getColours(found.colourType)
                .then(function (colours) {
                    vm.colours = colours;
                });
        }

        function initialisePlayerListTypes() {
            vm.playerListTypes = [];

            vm.metaData.playerListTypes.forEach(function (type) {
                var playerListType = {
                    name: type.playerListScopeType,
                    active: false,
                    enabled: false,
                    colourType: type.colourType
                };

                if (isStadium()) {
                    initialiseStadiumPlayerListType(playerListType);
                } else {
                    initialiseBamatexPlayerListType(playerListType);
                }

                vm.playerListTypes.push(playerListType);
            });
        }

        function initialiseStadiumPlayerListType(playerListType) {
            if (isName() && playerListType.name === 'NAME') {
                playerListType.active = true;
                playerListType.enabled = true;
            }

            if (isInitial() && playerListType.name === 'INITIAL') {
                playerListType.active = true;
                playerListType.enabled = true;
            }

            if (isDigit() && playerListType.name === 'DIGIT') {
                playerListType.active = true;
                playerListType.enabled = true;
            }
        }

        function initialiseBamatexPlayerListType(playerListType) {
            if (!isEditMode() && !isTemplateMode() && playerListType.name === 'NAME') {
                playerListType.active = true;
                playerListType.enabled = true;
            }

            if (isEditMode() && vm.originalName.playerListScopeType === playerListType.name) {
                playerListType.active = true;
                playerListType.enabled = true;
            }

            if (isTemplateMode() && !isEditMode()) {
                playerListType.active = true;
                playerListType.enabled = true;
            }
        }

        function activatePlayerListType(type) {
            var index = _.findIndex(vm.playerListTypes, {'name': type});

            if (index !== -1) {
                vm.playerListTypes[index].active = true;
                vm.playerListTypes[index].enabled = true;
            }
        }

        function openPlayerListDialog() {
            PlayerDialogService.showDialog(vm.name.playerListId)
                .then(function (playerList) {
                    vm.selectedPlayerList = playerList;
                    vm.name.playerListId = playerList.playerListId;
                    vm.playerListName = playerList.playerListName;
                    vm.players = playerList.players;

                    initialisePlayerListTypes();

                    if (isStadium()) {
                        if (isName()) {
                            activatePlayerListType('NAME');
                        }
                        if (isInitial()) {
                            activatePlayerListType('INITIAL');
                        }
                        if (isDigit()) {
                            activatePlayerListType('DIGIT');
                        }
                    } else {
                        vm.players.forEach(function (player) {
                            if (player.name !== null && player.name !== '') {
                                activatePlayerListType('NAME');
                            }
                            if (player.initials !== null && player.initials !== '') {
                                activatePlayerListType('INITIAL');
                            }
                            if (player.number !== null && player.number !== '') {
                                activatePlayerListType('DIGIT');
                            }
                        });
                    }
                });
        }

        function clearPlayerLists() {
            vm.players = [];
            vm.playerListName = '';
            vm.name.playerListId = '';
            vm.selectedPlayerList = null;
            _.each(vm.playerListTypes, function (type) {
                type.active = false;
                type.enabled = false;
            });
        }

        function showNamePreview() {
            if (isTemplateMode()) {
                return false;
            }

            // PlayerList
            if ((!vm.names && !vm.name.playerListId) || !isAnyPlayerListTypeActive()) {
                return false;
            }

            // Font
            if (!vm.selectedFont || !vm.selectedFont.length) {
                return false;
            }

            // Colours
            if (!vm.selectedColours) {
                return false;
            }

            var colours = vm.selectedColours;
            if (!colours.text || !colours.text.length) {
                return false;
            }

            if (!colours.background || !colours.background.length) {
                return false;
            }

            return true;
        }

        function setNamePreviewPlayers() {
            var names = vm.names.split(/\r?\n/);

            initialisePlayerListTypes();

            vm.players = names.reduce(function (result, name) {
    
                if(isDigit()) {
                    result.push({
                        'name': '',
                        'initials': '',
                        'number': name.trim(), 
                        'smallNumber': name.trim(), 
                    });
                }
                else {
                    result.push({
                        'name': isName() ? name.trim() : '',
                        'initials': isName() ? '' : name.trim(),
                        'number': '',
                        'smallNumber': '',
                    });
                }
            
                return result;
            }, []);
        }

        function isAnyPlayerListTypeActive() {
            return _.some(vm.playerListTypes, function (type) {
                return type.active;
            });
        }

        function newCustomColour(colour) { 
            if (colour && colour.trim()) {
                return {name: colour};
            }
        }

        function openColourPicker(type) {
            var data = {
                colors: vm.colours.slice(),
                selectedColors: vm.selectedColours[type].slice(),
                maxColors: vm.maxColourCount
            };

            ColorPickerDialogService.showDialog(data)
                .then(function (selectedColours) {
                    vm.selectedColours[type] = selectedColours;
                });
        }

        function isNonNegativeInteger(num) {
            if (!num.match(/^\d+$/)) {
                return false;
            }
            var int = parseInt(num, 10);
            return int !== null && int >= 0;
        }

        function isPositiveInteger(num) {
            if (!num.match(/^\d+$/)) {
                return false;
            }
            var int = parseInt(num, 10);
            return int !== null && int > 0;
        }

        function onHeightTypeChange() {
            if (vm.name.heightRelative) {
                vm.name.height = '';
            }
        }

        function onFileSelect(file) {
            var validSize = file.size < 104857600;

            if (!validSize) {
                toastr.error('File size is too large (limit: 100 MB)');
            } else {
                vm.files = [];
                vm.files.push(file);
                vm.validationErrors.file = false;
                vm.isAttachmentSet = true;
            }

            return validSize;
        }

        function getFile() {
            var url = '';
            if (vm.files.length > 0 && !vm.files[0].size && vm.originalLogo.logoId) {
                url = DS.defaults.baseUrl + 'attachments/' + vm.originalLogo.logoId;
            }

            if (url) {
                $window.open(url, '_blank');
            }
        }

        function submit(action) {
            loadSpinnerService.start();
            validate()
                .then(function () {
                    if (isTemplateMode()) {
                        submitTemplateName(action);
                    } else {
                        submitQuickPlayerList()
                            .then(function (playerList) {
                                submitName(playerList, action);
                            })
                            .catch(function () {
                                $anchorScroll('#warnings');
                            });
                    }
                })
                .catch(function () {
                    $anchorScroll('#warnings');
                })
                .finally(function () {
                    loadSpinnerService.stop();
                });
        }

        function submitName(playerList, action) {
            if (playerList !== null) {
                vm.name.playerListId = playerList.playerListId;
            }

            prepareNameData();

            NamesApiService.postName(vm.name)
                .then(function () {
                    if (action === 'new') {
                        $state.reload();
                        $anchorScroll('#warnings');
                        toastr.success($translate.instant('MESSAGE.SAVESUCCESS'));
                    } else {
                        $state.go('app.shop.cart', {}, {reload: true});
                    }
                })
                .catch(function (error) {
                    $anchorScroll('#warnings');
                    $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                        if (error && error.message) {
                            toastr.error(error.message, translation);
                        } else {
                            toastr.error(translation);
                        }
                    });
                });
        }

        function submitTemplateName(action) {
            prepareTemplateNameData();

            NamesApiService.postName(vm.name)
                .then(function () {
                    if (action === 'new') {
                        $state.reload();
                        $anchorScroll('#warnings');
                        toastr.success($translate.instant('MESSAGE.SAVESUCCESS'));
                    } else {
                        $state.go('app.shop.advancedMounting', {id: vm.user.templateId});
                    }
                })
                .catch(function (error) {
                    $anchorScroll('#warnings');
                    var reason = error && error.message ? error.message : '';
                    var errorMessage = $translate.instant('MESSAGE.SAVEFAIL');
                    if (reason) {
                        toastr.error(reason, errorMessage);
                    } else {
                        toastr.error(errorMessage);
                    }
                });
        }

        function submitQuickPlayerList() {
            var deferred = $q.defer();

            if (!vm.names || isEditMode()) {
                deferred.resolve(null);
                return deferred.promise;
            }

            var players = [];
            _.each(vm.names.split(/\r?\n/), function (parsedPlayer) {
                var player = parsedPlayer.trim();
                if (!player) {
                    return;
                }

                var name = '';
                var initial = '';
                var number = '';
                var smallNumber = '';

                if (isName()) {
                    name = player;
                } else if (isInitial()) {
                    initial = player;
                } else if (isDigit()) {
                    number = player;
                    smallNumber = player;
                }
         

                players.push({
                    name: name,
                    articleId: '',
                    initials: initial,
                    number: number,
                    smallNumber: smallNumber,
                    size: '',
                    comment: '',
                    quantity: '' + vm.freeTextQuantity,
                    colour: ''
                });
                
            });

            PlayerListApiService.createQuickPlayerList(players)
                .then(function (playerListId) {
                    deferred.resolve(playerListId);
                })
                .catch(function (error) {
                    $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                        if (error && error.message) {
                            toastr.error(error.message, translation);
                        } else {
                            toastr.error(translation);
                        }
                    });

                    deferred.reject();
                });

            return deferred.promise;
        }

        function prepareNameData() {
            vm.name.fontType = vm.selectedFont[0];
            vm.name.textColour = vm.selectedColours.text[0] ? vm.selectedColours.text[0].name : '';
            vm.name.backgroundColour = vm.selectedColours.background[0] ? vm.selectedColours.background[0].name : '';

            vm.name.playerListTypes = vm.playerListTypes.filter(function (type) {
                return type.active;
            }).map(function (type) {
                return type.name;
            });

            // Attachment
            if (vm.files && vm.files.length > 0 && !vm.files[0].size) {
                vm.name.file = vm.files[0];
            } else {
                vm.name.file = null;
            }
        }

        function prepareTemplateNameData() {
            vm.name.fontType = vm.selectedFont[0];
            vm.name.textColour = vm.selectedColours.text[0] ? vm.selectedColours.text[0].name : '';
            vm.name.backgroundColour = vm.selectedColours.background[0] ? vm.selectedColours.background[0].name : '';

            vm.name.playerListTypes = vm.playerListTypes.filter(function (type) {
                return type.active;
            }).map(function (type) {
                return type.name;
            });

            // Attachment
            if (vm.files && vm.files.length > 0 && vm.files[0].size) {
                vm.name.file = vm.files[0];
            } else {
                vm.name.file = null;
            }
        }

        function validate() {
            vm.hasErrors = false;
            vm.validationErrors = [];

            return $q.all(validationTests.map(runValidation));
        }

        function runValidation(validationTest) {
            return $q(function (resolve, reject) {
                if (validationTest.run()) {
                    return resolve();
                }

                // Show specific error message in the view.
                vm.validationErrors[validationTest.field] = true;
                vm.hasErrors = true;

                return reject();
            });
        }

        var validationTests = [
            {
                field: 'fontType',
                run: function () {
                    return vm.selectedFont.length === 1;
                }
            },
            {
                field: 'formType',
                run: function () {
                    return vm.name.formType;
                }
            },
            {
                field: 'caseType',
                run: function () {
                    return vm.name.caseType;
                }
            },
            {
                field: 'textColour',
                run: function () {
                    return vm.selectedColours.text.length === 1;
                }
            },
            {
                field: 'backgroundColour',
                run: function () {
                    return vm.selectedColours.background.length === 1;
                }
            },
            {
                field: 'description',
                run: function () {
                    return vm.name.description;
                }
            },
            {
                field: 'playerListId',
                run: function () {
                    if (!isTemplateMode()) {
                        return vm.name.playerListId || vm.names;
                    }
                    return true;
                }
            },
            {
                field: 'height',
                run: function () {
                    return !vm.name.heightRelative ? isPositiveInteger(vm.name.height) : true;
                }
            },
            {
                field: 'width',
                run: function () {
                    if (isStadium() && isInitial()) {
                        return true;
                    }
                    return isPositiveInteger(vm.name.width);
                }
            },
            {
                field: 'stadiumInitialWidth',
                run: function () {
                    if (isStadium() && isInitial()) {
                        return isNonNegativeInteger(vm.name.width);
                    }
                    return true;
                }
            },
            {
                field: 'playerListTypes',
                run: function () {
                    return _.some(vm.playerListTypes, function (type) {
                        // At least one should be selected.
                        return type.active;
                    }) || vm.names;
                }
            },
            {
                field: 'quantity',
                run: function () {
                    if (vm.names && vm.names.length > 0) {
                        return vm.minQuantity <= vm.freeTextQuantity;
                    }

                    return true;
                }
            },
            {
                field: 'stadiumPlayerListNoMatchingPlayers',
                run: function () {
                    if (isStadium() && !isTemplateMode() && vm.selectedPlayerList !== null) {
                        if (isName()) {
                            return _.some(vm.selectedPlayerList.players, function (value) {
                                return value.name && value.name !== '';
                            });
                        } else if (isInitial()) {
                            return _.some(vm.selectedPlayerList.players, function (value) {
                                return value.initials && value.initials !== '';
                            });
                        } else if (isDigit()) {
                            return _.some(vm.selectedPlayerList.players, function (value) {
                                return value.number && value.number !== '' || value.smallNumber && value.smallNumber !== '';
                            });
                        }
                    }

                    return true;
                }
            }
        ];

        function isStadium() {
            return vm.user && vm.user.stadium;
        }

        function isName() {
            return $state.is('app.shop.name') || $state.is('app.shop.editName') || $state.is('app.shop.name.template');
        }

        function isInitial() {
            return $state.is('app.shop.initial') || $state.is('app.shop.editInitial');
        }

        function isDigit() {
            return $state.is('app.shop.digit') || $state.is('app.shop.editDigit');
        }

        function isEditMode() {
            return vm.originalName && vm.originalLogo;
        }

        function isTemplateMode() {
            return vm.user.templateId;
        }

        function getTitle() {
            var titles = {
                standard: 'NAME.HEADER.TITLE',
                standard_edit: 'NAME.HEADER.TITLE.EDIT',
                name: 'STADIUM.TEMPLATE.NAME.TITLE',
                name_edit: 'STADIUM.TEMPLATE.NAME.TITLE.EDIT',
                initial: 'STADIUM.TEMPLATE.INITIAL.TITLE',
                initial_edit: 'STADIUM.TEMPLATE.INITIAL.TITLE.EDIT',
                digit: 'STADIUM.TEMPLATE.DIGIT.TITLE',
                digit_edit: 'STADIUM.TEMPLATE.DIGIT.TITLE.EDIT'
            };

            if (isName()) {
                return isEditMode() ? titles.name_edit : titles.name;
            } else if (isInitial()) {
                return isEditMode() ? titles.initial_edit : titles.initial;
            } else if (isDigit()) {
                return isEditMode() ? titles.digit_edit : titles.digit;
            } else {
                return isEditMode() ? titles.standard_edit : titles.standard;
            }
        }

        function getBreadText() {
            var breadTexts = {
                standard: 'NAME.HEADER.BREADTEXT',
                name: 'STADIUM.TEMPLATE.NAME.DESCRIPTION',
                initial: 'STADIUM.TEMPLATE.INITIAL.DESCRIPTION',
                digit: 'STADIUM.TEMPLATE.DIGIT.DESCRIPTION'
            };

            if (isName()) {
                return breadTexts.name;
            } else if (isInitial()) {
                return breadTexts.initial;
            } else if (isDigit()) {
                return breadTexts.digit;
            } else {
                return breadTexts.standard;
            }
        }

        function setPreselected() {
            var fontType = 'STADIUM_SANS_BOLD';
            var caseType = 'AS_WRITTEN';
            var formType = 'HORIZONTAL';

            if (vm.metaData.fontTypes.includes(fontType)) {
                vm.selectedFont.push(fontType);
            }
            if (vm.metaData.caseTypes.includes(caseType)) {
                vm.name.caseType = caseType;
            }
            if (vm.metaData.formTypes.includes(formType)) {
                vm.name.formType = formType;
            }

            if (isTemplateMode()) {
                PlacementsApiService.getTemplateType(vm.user.templateId)
                    .then(function (type) {
                        if (type === 'STADIUM_PRODUCT_TEMPLATE') {
                            vm.selectedFont = ['STADIUM_B2C'];
                        }
                    })
                    .catch(function (error) {
                        ValidationManager.handleResponseError(error);
                    });
            }
        }

        function getSelectedFontName(selectedFont) {
            if (_.includes(vm.metaData.fontTypes, selectedFont)) {
                return 'NAME.FONTTYPE.' + selectedFont;
            }

            // This usually means the user entered a custom font name.
            return selectedFont;
        }

        function getNoMatchingPlayersError() {
            var baseError = 'NAME.VALIDATION.PLAYER_LIST.NO_MATCHING_PLAYERS';
            var typeError = '';
            if(isName()) {
                typeError = 'NAME.PLAYERLISTTYPE.NAME';
            }
            else if(isInitial()) {
                typeError = 'NAME.PLAYERLISTTYPE.INITIAL';
            }
            else
            {
                typeError = 'NAME.PLAYERLISTTYPE.DIGIT';
            }
            return $translate.instant(baseError, {type: $translate.instant(typeError)});
        }
    }

    angular
        .module('shop.name', ['namePreview'])
        .controller('NameController', NameController)
        .config(stateConfig);
}());

(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    cartResolve.$inject = ["CartApiService"];
    userResolve.$inject = ["AuthService"];
    ShopController.$inject = ["$scope", "$state", "$timeout", "$window", "CartApiService", "ArticlesApiService", "ConfirmDialogService", "TemplateDialogService", "ENV", "user"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop', {
            url: '',
            abstract: true,
            views: {
                '@': {
                    templateUrl: 'shop/shop.tpl.html',
                    controller: 'ShopController as vm'
                }
            },
            resolve: {
                cart: cartResolve,
                user: userResolve
            },
            data: {claims: ['user']}
        });
    }

    // @ngInject
    function cartResolve(CartApiService) {
        return CartApiService.getCartRows();
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function ShopController(
        $scope,
        $state,
        $timeout,
        $window,
        CartApiService,
        ArticlesApiService,
        ConfirmDialogService,
        TemplateDialogService,
        ENV,
        user
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.loading = true;
        vm.cartMeta = {};
        vm.isMenuOpen = $window.innerWidth >= 768;
        vm.searchField = ArticlesApiService.getSavedSearch().searchField;
        vm.showStadiumProducts = ENV.stadiumProducts;
        vm.isStagingOrDevelopment = ENV.name != 'production';
        vm.user = user;

        vm.onClickSearch = onClickSearch;
        vm.isLocked = isLocked;
        vm.isCurrentUserBlocked = isCurrentUserBlocked;
        vm.isSelectedUserBlocked = isSelectedUserBlocked;
        vm.getNewItemClasses = getNewItemClasses;
        vm.delayedFocus = delayedFocus;
        vm.toggleMenu = toggleMenu;
        vm.openPrivacyPolicy = openPrivacyPolicy;
        vm.isStadiumUser = isStadiumUser;
        vm.isTemplateMode = isTemplateMode;
        vm.navigateToName = navigateToName;
        vm.navigateToInitial = navigateToInitial;
        vm.navigateToMounting = navigateToMounting;
        vm.navigateToDigit = navigateToDigit;

        function onClickSearch(event) {
            if (!event || event.charCode === 13) {
                ArticlesApiService.getSavedSearch().searchField = vm.searchField;
                $state.go('app.shop.articlesList', {}, {reload: true});
            }
        }

        function isLocked(action) {
            switch (action) {
                case 'articles':
                case 'digits':
                case 'search':
                case 'create':
                    return isStadiumUser() ? false : locked();
                default:
                    return locked();
            }
        }

        function locked() {
            var result = false;
            if (isAdmin()) {
                result = !vm.user.orderRecipient;
            }
            if (isStadiumUser()) {
                result = !isStadiumOrderMode() && !isTemplateMode();
            }
            return result;
        }

        function isCurrentUserBlocked() {
            return vm.user && !vm.user.admin && vm.user.blocked;
        }

        function isSelectedUserBlocked() {
            return vm.user && vm.user.admin && vm.user.orderRecipient && vm.user.orderRecipient.blocked;
        }

        function isAdmin() {
            return vm.user && vm.user.admin;
        }

        function isStadiumUser() {
            return vm.user && vm.user.stadium;
        }

        function isTemplateMode() {
            return vm.user && vm.user.templateId && vm.user.templateName;
        }

        function isStadiumOrderMode() {
            return vm.user && vm.user.orderReference && vm.user.orderProject;
        }

        function navigateToName() {
            $state.go('app.shop.name');
        }

        function navigateToInitial() {
            $state.go('app.shop.initial');
        }

        function navigateToDigit() {
            $state.go('app.shop.digit');
        }

        function navigateToMounting() {
            if (vm.user.templateId) {
                $state.go('app.shop.advancedMounting', {id: vm.user.templateId}, 'AdvancedMountingController');
            }
            else if (vm.user.stadium) {
                TemplateDialogService.showStadiumDialog()
                    .then(handleTemplateDialogResponse);
            }
            else {
                TemplateDialogService.showStandardDialog()
                    .then(handleTemplateDialogResponse);
            }
        }

        function handleTemplateDialogResponse(template) {
            if (!template) {
                return $state.go('app.shop.cart', {}, {reload: true});
            } else {
                return $state.go('app.shop.advancedMounting', {id: template.placementId}, 'AdvancedMountingController');
            }
        }

        function getNewItemClasses(articleGroup) {
            var isMatchingArticleGroup = _.includes(['transfer', 'profile', 'concept'], articleGroup);
            var isActive = $state.includes('app.shop.create') && isMatchingArticleGroup;

            return {
                active: isActive,
                locked: vm.isLocked()
            };
        }

        function toggleMenu() {
            vm.isMenuOpen = !vm.isMenuOpen;
        }

        function openPrivacyPolicy() {
            var buttons = [{name: 'BUTTON.CLOSE', class: 'btn-default'}];
            ConfirmDialogService.showDialog('PRIVACY.TITLE', 'PRIVACY.TEXT', buttons).then(function (button) {
            });
        }

        function delayedFocus(selector) {
            $timeout(function () {
                $(selector).focus();
            }, 380);
        }

        $timeout(function () {
            vm.loading = false;
            vm.cartMeta = CartApiService.getCartMeta();
        }, 500);

        // Use $timeout to attach event handlers once the view is rendered.
        $timeout(function () {
            var navbar = $('.navbar-nav:has(.main-menu-toggle)');

            function updateMenuState() {
                if ($window.innerWidth < 768) {
                    $scope.$apply(function () {
                        vm.toggleMenu();
                    });
                }
            }

            // Selecting a menu item should close the menu to save screen space for the new view.
            $('> li:not(.main-menu-toggle, .dropdown)', navbar).on('click', updateMenuState);
            $('> li.dropdown li', navbar).on('click', updateMenuState);

            $(document).click(function (event) {
                // Clicking outside of the menu should close it.
                // Unfortunately, this event handler is triggered for every click on the page.
                if (vm.isMenuOpen && $window.innerWidth < 768) {
                    if (!$(event.target).closest('.navbar-nav:has(.main-menu-toggle)').length) {
                        $scope.$apply(function () {
                            vm.toggleMenu();
                        });
                    }
                }
            });
        });

        $(window).resize(_.debounce(function () {
            // Show or hide the main menu depending on the updated viewport size.
            $scope.$apply(function () {
                vm.isMenuOpen = $window.innerWidth >= 768;
            });
        }, 250));

        // Prevent the search input from closing on smaller screens.
        $(document).on('click', '.search .dropdown', function (event) {
            event.stopPropagation();
        });

        $scope.$watch(function () {
            return ArticlesApiService.getSavedSearch().searchField;
        }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.searchField = ArticlesApiService.getSavedSearch().searchField;
            }
        });
    }

    angular
        .module('app.shop', [
            'shop.calculator',
            'shop.articles',
            'shop.cart',
            'shop.create',
            'shop.digits',
            'shop.history',
            'shop.name',
            'shop.mounting.simpleMounting',
            'shop.mounting.advancedMounting',
            'userbox',
            'breadcrumbs',
            'modalWindow'])
        .controller('ShopController', ShopController)
        .config(stateConfig);
})();

(function() {
  'use strict';

  // @ngInject
  stateConfig.$inject = ["$stateProvider"];
  groupsResolve.$inject = ["StadiumOrderApiService", "$stateParams"];
  userResolve.$inject = ["AuthService"];
  orderTypeResolve.$inject = ["$stateParams"];
  IncomingOrdersController.$inject = ["$modal", "$rootScope", "$state", "toastr", "StadiumOrderApiService", "PlacementsApiService", "SavedCartDialogService", "AuthService", "loadSpinnerService", "ValidationManager", "CartApiService", "groups", "user", "orderType"];
  function stateConfig($stateProvider) {
    $stateProvider
      .state('app.shop.incomingOrdersWithType', {
        url: '/incomingorders/{orderType}',
        views: {
          'main-content': {
            templateUrl: 'stadium/incomingOrders/incomingOrders.tpl.html',
            controller: 'IncomingOrdersController as vm'
          }
        },
        resolve: {
          groups: groupsResolve,
          user: userResolve,
          orderType: orderTypeResolve
        }
      })
      .state('app.shop.incomingOrders', {
        url: '/incomingorders',
        views: {
          'main-content': {
            templateUrl: 'stadium/incomingOrders/incomingOrders.tpl.html',
            controller: 'IncomingOrdersController as vm'
          }
        },
        resolve: {
          groups: groupsResolve,
          user: userResolve,
          orderType: orderTypeResolve
        }
      });
  }

  // @ngInject
  function groupsResolve(StadiumOrderApiService, $stateParams) {
    if ($stateParams.orderType) {
      return StadiumOrderApiService.getOrderGroups(true);
    } else {
      return StadiumOrderApiService.getOrderGroups(false);
    }
  }

  // @ngInject
  function userResolve(AuthService) {
    return AuthService.getUser();
  }

  // @ngInject
  function orderTypeResolve($stateParams) {
    if ($stateParams.orderType) {
      return 'B2C';
    } else {
      return 'B2B';
    }
  }

  // @ngInject
  function IncomingOrdersController(
    $modal,
    $rootScope,
    $state,
    toastr,
    StadiumOrderApiService,
    PlacementsApiService,
    SavedCartDialogService,
    AuthService,
    loadSpinnerService,
    ValidationManager,
    CartApiService,
    groups,
    user,
    orderType
  ) {
    /* jshint validthis: true */
    var vm = this;
    vm.stadiumOrders = null;
    vm.links = [
      {
        displayName: 'NAVIGATION.HOME',
        state: {
          to: 'app.shop.calculator'
        }
      },
      {
        displayName: 'NAVIGATION.INCOMINGORDERS',
        state: null
      }
    ];
    vm.openIncomingOrdersDialog = openIncomingOrdersDialog;
    vm.consumeOrders = consumeOrders;
    vm.isOrderActive = isOrderActive;
    vm.changeOrderType = changeOrderType;
    vm.groups = groups;
    vm.user = user;
    vm.orderType = orderType;
    vm.createOrder = createOrder;

    function isOrderActive() {
      return vm.user.orderReference && vm.user.orderProject;
    }

    function changeOrderType() {
      loadSpinnerService.start();
      StadiumOrderApiService.getOrderGroups(isB2C())
        .then(function(data) {
          vm.groups = data;
        })
        .catch(function(error) {
          if (error && error.data) {
            toastr.error(error.data.message);
          }
        })
        .finally(loadSpinnerService.stop);
    }

    function consumeOrders(group) {
      loadSpinnerService.start();
      StadiumOrderApiService.consumeOrders(
        group.reference,
        group.user,
        group.weborder,
        vm.orderType
      )
        .then(function() {
          PlacementsApiService.closeTemplate()
            .then(function() {
                $rootScope.$broadcast('$updateNotifications');
                $state.go('app.shop.cart');
            });
        })
        .catch(function(error) {
          ValidationManager.handleResponseError(error);
        })
        .finally(loadSpinnerService.stop);
    }

    function isB2C() {
      return vm.orderType === 'B2C';
    }

    function createOrder(group) {
        SavedCartDialogService.showDialog(group.weborder, group.club)
            .then(function() {
                $rootScope.$broadcast('$updateNotifications');
            })
            .catch(function(error) {
                ValidationManager.handleResponseError(error);
                throw error;
            });
    }

    function openIncomingOrdersDialog(group) {
      StadiumOrderApiService.getOrders(
        group.reference,
        group.user,
        group.weborder,
        vm.orderType
      )
        .then(function(orders) {
          var incomingOrdersDialog = {
            backdrop: 'static',
            controller: 'IncomingOrdersDialogController as vm',
            templateUrl: 'stadium/incomingOrders/incomingOrdersDialog/incomingOrdersDialog.tpl.html',
            size: 'lg',
            resolve: {
              group: function() {
                return group;
              },
              orders: function() {
                return orders;
              },
              user: AuthService.getUser
            }
          };

          $modal.open(incomingOrdersDialog).result
            .then(function() {
                StadiumOrderApiService.getOrderGroups(isB2C())
                    .then(function(data) {
                        vm.groups = data;
                    })
                    .then(function() {
                      // Reload cart meta
                      CartApiService.getCartRows();
                    });
            });
        })
        .catch(function(error) {
          if (error && error.data) {
            toastr.error(error.data.message);
          }
        });
    }
  }

  angular
    .module('stadium.incomingOrders', ['incomingOrdersDialog'])
    .controller('IncomingOrdersController', IncomingOrdersController)
    .config(stateConfig);
})();

(function() {
  'use strict';

  // @ngInject
  IncomingOrdersDialogController.$inject = ["$modalInstance", "$rootScope", "$state", "group", "orders", "user", "loadSpinnerService", "ConfirmDialogService", "StadiumOrderApiService", "TemplateErrorDialogService", "TemplatePickerDialogService", "TemplateDialogService", "PlacementsApiService", "StadiumPlacementsApiService", "StadiumProductTemplatePickerDialogService", "toastr", "$translate"];
  function IncomingOrdersDialogController(
    $modalInstance,
    $rootScope,
    $state,
    group,
    orders,
    user,
    loadSpinnerService,
    ConfirmDialogService,
    StadiumOrderApiService,
    TemplateErrorDialogService,
    TemplatePickerDialogService,
    TemplateDialogService,
    PlacementsApiService,
    StadiumPlacementsApiService,
    StadiumProductTemplatePickerDialogService,
    toastr,
    $translate
  ) {
    /* jshint validthis: true */
    var vm = this;
    vm.user = user;
    vm.group = group;
    vm.orders = orders;
    vm.close = close;
    vm.processing = false;
    vm.isCartActive = isCartActive;
    vm.deleteOrder = deleteOrder;
    vm.consumeOrder = consumeOrder;
    vm.openTemplate = openTemplate;
    vm.onClickCreateQuickTemplate = onClickCreateQuickTemplate;
    vm.onClickEditQuickTemplate = onClickEditQuickTemplate;
    vm.onClickSetTemplate = onClickSetTemplate;
    vm.onClickEditStandardTemplate = onClickEditStandardTemplate;
    vm.onClickRemoveTemplate = onClickRemoveTemplate;
    vm.onClickSetProductTemplate = onClickSetProductTemplate;
    vm.validStadiumCustomer = validStadiumCustomer;

    function onClickEditStandardTemplate(order) {
      PlacementsApiService.createQuickTemplateFromTemplate(order.template).then(
        function(template) {
          setTemplateOnOrder(order, template, true, false);

          StadiumOrderApiService.updateTemplate(
            order.orderId,
            order.template
          ).then(function() {
            PlacementsApiService.openTemplate(template.placementId)
              .then(function() {
                $rootScope.$broadcast("$updateNotifications");
                $modalInstance.close();
              })
              .then(function() {
                $state.go("app.shop.advancedMounting", {
                  id: template.placementId
                });
              });
          });
        }
      );
    }

    function onClickCreateQuickTemplate(order) {
      TemplateDialogService.showTemplateDialog(
        order.colour,
        order.garment,
        order.club,
        null,
        true,
        false
      ).then(function(template) {
        setTemplateOnOrder(order, template, true, false);

        StadiumOrderApiService.updateTemplate(
          order.orderId,
          order.template
        ).then(function() {
          PlacementsApiService.openTemplate(template.placementId)
            .then(function() {
              $rootScope.$broadcast("$updateNotifications");
              $modalInstance.close();
            })
            .then(function() {
              $state.go("app.shop.advancedMounting", {
                id: template.placementId
              });
            });
        });
      });
    }

    function onClickEditQuickTemplate(order) {
      PlacementsApiService.openTemplate(order.template)
        .then(function() {
          $rootScope.$broadcast("$updateNotifications");
        })
        .then(function() {
          $modalInstance.close();
          $state.go("app.shop.advancedMounting", { id: order.template });
        });
    }

    function onClickSetTemplate(order) {
      var filterData = {
        garmentName: order.garment || "",
        garmentColour: order.colour || ""
      };

      TemplatePickerDialogService.showSetTemplateDialog(
        order.club,
        filterData
      ).then(function(result) {
        setTemplateOnOrder(order, result.template, false, false);
        StadiumOrderApiService.updateTemplate(order.orderId, order.template);
      });
    }

    function onClickSetProductTemplate(order) {
      StadiumProductTemplatePickerDialogService.showDialog()
        .then(function (productTemplate) {
          StadiumPlacementsApiService.getPlacement(productTemplate)
            .then(function (template) {
              setTemplateOnOrder(order, template, false, true);
              StadiumOrderApiService.updateTemplate(order.orderId, order.template);
            });
      });
    }

    function openTemplate(templateId) {
      var buttons = [
        { name: "BUTTON.NO", class: "btn-default" },
        { name: "BUTTON.YES", class: "btn-success" }
      ];

      ConfirmDialogService.showDialog(
        "INCOMINGORDERS.GOTOTEMPLATE1",
        "INCOMINGORDERS.GOTOTEMPLATE2",
        buttons
      ).then(function(button) {
        if (button.name === "BUTTON.YES") {
          $modalInstance.close();
          PlacementsApiService.openTemplate(templateId)
            .then(function() {
              $modalInstance.close();
              $rootScope.$broadcast("$updateNotifications");
            })
            .finally(function() {
              $state.go("app.shop.advancedMounting", { id: templateId });
            });
        }
      });
    }

    function onClickRemoveTemplate(order) {
      if (vm.user.templateId === order.template) {
        PlacementsApiService.closeTemplate().then(function() {
          $rootScope.$broadcast("$updateNotifications");
        });
      }

      var index = vm.orders.indexOf(order);
      order.template = null;
      order.templateName = null;
      order.legacyTemplateNotHandled = false;
      order.valid = false;
      order.quickTemplate = false;
      vm.orders[index] = order;

      StadiumOrderApiService.removeTemplate(order.orderId);
    }

    function isCartActive() {
      return vm.user.orderReference && vm.user.orderProject;
    }

    function consumeOrder(order) {
      vm.processing = true;
      var removedOrders = _.remove(vm.orders, function (o) {
        return _.isEqual(order.orderId, o.orderId);
      });

      StadiumOrderApiService.consumeOrder(order.orderId)
        .catch(function(error) {
          if (
            error.data[0] &&
            error.data[0].code &&
            (error.data[0].code === "INVALID_CART_STATE_FOR_B2C_ORDER" ||
              error.data[0].code === "INVALID_CART_STATE_FOR_B2B_ORDER" ||
                error.data[0].code === "STADIUM_ORDER_NOT_ACTIVE")
          ) {
            toastr.error($translate.instant("ERROR." + error.data[0].code));
          } else {
            TemplateErrorDialogService.showDialog(order.template);
          }

          // Restore order to list if fail to consume
          if (removedOrders.length > 0) {
            vm.orders.push(removedOrders[0]);
          }
        })
        .finally(function() {
          vm.processing = false;
          PlacementsApiService.closeTemplate()
            .then(function() {
              $rootScope.$broadcast("$updateNotifications");
            });
        });
    }

    function deleteOrder(order) {
      var buttons = [
        { name: "BUTTON.NO", class: "btn-default" },
        { name: "BUTTON.YES", class: "btn-success" }
      ];

      ConfirmDialogService.showDialog(
        "INCOMINGORDERS.DELETESTADIUMORDER1",
        "INCOMINGORDERS.DELETESTADIUMORDER2",
        buttons
      ).then(function(button) {
        if (button.name === "BUTTON.YES") {
          loadSpinnerService.start();
          StadiumOrderApiService.deleteOrder(order.orderId)
            .then(function() {
              PlacementsApiService.closeTemplate().then(function() {
                $rootScope.$broadcast("$updateNotifications");
                $modalInstance.close();
              });
            })
            .finally(loadSpinnerService.stop);
        }
      });
    }

    function setTemplateOnOrder(order, template, quickTemplate, productTemplate) {
      var index = vm.orders.indexOf(order);

      order.template = template.placementId;
      order.templateName = template.templateName;
      order.legacyTemplateNotHandled = template.legacyTemplateNotHandled;
      order.valid = true;
      order.quickTemplate = quickTemplate;
      order.productTemplate = productTemplate;

      vm.orders[index] = order;
    }

    function close() {
      $modalInstance.close();
    }

    function validStadiumCustomer() {
      return vm.user.customerId === "02101";
    }
  }

  angular
    .module("incomingOrdersDialog", [])
    .controller(
      "IncomingOrdersDialogController",
      IncomingOrdersDialogController
    );
})();

(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    productTypesResolve.$inject = ["ArticlesApiService"];
    userResolve.$inject = ["AuthService"];
    logoResolve.$inject = ["LogosApiService", "$stateParams"];
    StadiumLogoController.$inject = ["$q", "$location", "$window", "$scope", "$state", "$translate", "$anchorScroll", "DS", "toastr", "loadSpinnerService", "ArticlesApiService", "LogosApiService", "ColorPickerDialogService", "CalculatorApiService", "LogoImageDialogService", "LogoImageApiService", "productTypes", "user", "logo"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.stadiumLogo', {
            url: '/stadiumlogo',
            views: {
                'main-content': {
                    templateUrl: 'stadium/logo/stadiumLogo.tpl.html',
                    controller: 'StadiumLogoController as vm'
                }
            },
            resolve: {
                productTypes: productTypesResolve,
                user: userResolve,
                logo: function () {
                    return null;
                }
            }
        });
        $stateProvider.state('app.shop.stadiumLogoEdit', {
            url: '/stadiumlogo/edit/{logoId}',
            views: {
                'main-content': {
                    templateUrl: 'stadium/logo/stadiumLogo.tpl.html',
                    controller: 'StadiumLogoController as vm'
                }
            },
            resolve: {
                productTypes: productTypesResolve,
                user: userResolve,
                logo: logoResolve
            }
        });
    }

    // @ngInject
    function productTypesResolve(ArticlesApiService) {
        return ArticlesApiService.getProductTypes('stadium');
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    //@ngInject
    function logoResolve(LogosApiService, $stateParams) {
        return LogosApiService.getEditableLogo($stateParams.logoId);
    }

    // @ngInject
    function StadiumLogoController(
        $q,
        $location,
        $window,
        $scope,
        $state,
        $translate,
        $anchorScroll,
        DS,
        toastr,
        loadSpinnerService,
        ArticlesApiService,
        LogosApiService,
        ColorPickerDialogService,
        CalculatorApiService,
        LogoImageDialogService,
        LogoImageApiService,
        productTypes,
        user,
        logo
    ) {
        var vm = this;
        vm.user = user;
        vm.productTypes = productTypes;
        vm.logo = logo;
        vm.logoImage = null;
        vm.validationErrors = [];
        vm.files = [];
        vm.tags = [];
        vm.colours = [];
        vm.selectedColours = [];
        vm.productType = null;
        vm.process = false;
        vm.share = false;
        vm.inventory = false;
        vm.name = '';
        vm.width = '';
        vm.height = '';
        vm.information = '';

        vm.quantity = 0;
        vm.minQuantity = 0;
        vm.manufacturingQuantity = 0;
        vm.minimumStock = 0;
        vm.refillQuantity = 0;
        vm.minRefillQuantity = 0;

        vm.onProductTypeSelect = onProductTypeSelect;
        vm.isAllowOnlyRegistration = isAllowOnlyRegistration;
        vm.isTemplateMode = isTemplateMode;
        vm.isEditMode = isEditMode;
        vm.onSelectInventory = onSelectInventory;
        vm.newTag = newTag;
        vm.save = save;
        vm.saveAndAddNew = saveAndAddNew;
        vm.onFileSelect = onFileSelect;
        vm.getFile = getFile;
        vm.openColourPicker = openColourPicker;
        vm.isFirst = isFirst;
        vm.isLast = isLast;
        vm.moveColour = moveColour;
        vm.clearSelectedColours = clearSelectedColours;
        vm.maxColourCount = maxColourCount;
        vm.minColourCount = minColourCount;
        vm.addColour = addColour;
        vm.showColourPicker = showColourPicker;
        vm.showProcess = showProcess;
        vm.addBackside = addBackside;
        vm.removeBackside = removeBackside;
        vm.showBacksidePicker = showBacksidePicker;
        vm.availableBacksides = availableBacksides;
        vm.isOrderActive = isOrderActive;
        vm.showLogoImage = showLogoImage;
        vm.getLogoImageUrl = getLogoImageUrl;
        vm.selectLogoImage = selectLogoImage;
        vm.editLogoImage = editLogoImage;
        vm.clearAttachments = clearAttachments;
        vm.isAttachmentAvailable = isAttachmentAvailable;
        vm.isLeatheretteBrand = isLeatheretteBrand;

        init();

        function init() {
            if (isTemplateMode() && !isQuickTemplateMode()) {
                vm.productTypes = vm.productTypes.filter(function (productType) {
                    return productType.productSubtypes.some(function (subType) {
                        return subType.prefix[0] === 'x';
                    });
                }).map(function (productType) {
                    return productType;
                });
            }

            if (vm.logo) {
                loadEdit();
            }

            if (!isOrderActive() && !isTemplateMode()) {
                vm.register = true;
                vm.productTypes = vm.productTypes.filter(isAllowOnlyRegistration);
            } else {
                vm.register = false;
            }
        }

        function loadEdit() {
            vm.productType = _.find(vm.productTypes, {'name': vm.logo.productType});
            vm.productSubtype = _.head(vm.productType.productSubtypes) || null;
            vm.name = vm.logo.logoName;
            vm.width = parseInt(vm.logo.logoWidth);
            vm.height = parseInt(vm.logo.logoHeight);
            vm.process = vm.logo.process;
            vm.tags = vm.logo.tags;
            vm.information = vm.logo.logoInformation;
            vm.share = vm.logo.share;

            // Colours
            setSelectedColours(vm.productType, vm.logo.colours, vm.process);

            // Attachments
            if (vm.logo.attachmentExtension) {
                vm.files[0] = {
                    name: 'CREATEARTICLE.ATTACHMENTS.VIEWFILE'
                };
                vm.isAttachmentSet = true;
            } else if (vm.logo.logoImage) {
                LogoImageApiService.get(article.logoImage)
                    .then(function (logoImage) {
                        vm.logoImage = logoImage;
                        vm.isAttachmentSet = true;
                    });
            }

            // Inventory & Quantity is set to default
            vm.inventory = false;
            setQuantities(vm.productType.quantitySettings);

            // Handle backsides
            if (showBacksidePicker()) {
                loadBacksides()
                    .then(function() {
                        if (vm.article.backside) {
                            var selected = vm.backsides.find(function (backside) {
                                return backside.id === vm.article.backside;
                            });

                            vm.selectedBackside = selected || vm.backsides[0];
                        } else {
                            vm.selectedBackside = vm.backsides[0];
                        }
                    });
                addBackside();
            }
        }

        function setSelectedColours(productType, colours, process) {
            ArticlesApiService.getColors(productType.colourType.toLowerCase()).then(function (productColours) {
                vm.colours = productColours;
                vm.selectedColours = [];

                if (!process) {
                    _.each(colours, function (colour) {
                        var standardColour = _.find(vm.colours, function (c) {
                            return c.name.toLowerCase() === colour.name.toLowerCase();
                        });

                        if (standardColour) {
                            vm.selectedColours.push(standardColour);
                        } else {
                            vm.selectedColours.push(colour);
                        }
                    });
                }
            });
        }

        function loadColours(colorType) {
            ArticlesApiService.getColors(colorType.toLowerCase()).then(function (colours) {
                vm.selectedColours = [];
                vm.colours = colours;
            });
        }

        function onFileSelect(file) {
            var validSize = file.size < 104857600;

            if (!validSize) {
                toastr.error('File size is too large (limit: 100 MB)');
            } else {
                vm.files = [];
                vm.files.push(file);
                _.remove(vm.validationErrors, {field: 'file'});
                vm.isAttachmentSet = true;
            }

            return validSize;
        }

        function getFile() {
            var url = '';
            if (vm.files.length > 0 && !vm.files[0].size && vm.logo.logoId) {
                url = DS.defaults.baseUrl + 'attachments/' + vm.logo.logoId;
            }

            if (url) {
                $window.open(url, '_blank');
            }
        }

        function save() {
            saveProductAndTakeAction('cart');
        }

        function saveAndAddNew() {
            saveProductAndTakeAction('addNew');
        }

        function saveProductAndTakeAction(action) {
            if (!validForm()) {
                $anchorScroll();
                return;
            }

            loadSpinnerService.start();
            saveProduct()
                .then(function () {
                    takeAction(action);
                }, function (reason) {
                    if (Array.isArray(reason)) {
                        reason.forEach(function (error) {
                            toastr.error($translate.instant('ERROR.' + error.code, error.data));
                        });
                    }
                    else if (reason && reason.message) {
                        toastr.error(reason.message, $translate.instant('MESSAGE.SAVEFAIL'));
                    } else {
                        toastr.error($translate.instant('MESSAGE.SAVEFAIL'));
                    }
                })
                .finally(function () {
                    loadSpinnerService.stop();
                });
        }

        function isOrderActive() {
            return vm.user.orderReference && vm.user.orderProject;
        }

        function takeAction(action) {
            switch (action) {
                case 'cart':
                    if (isTemplateMode()) {
                        $state.go('app.shop.advancedMounting', {id: vm.user.templateId}, 'AdvancedMountingController');
                    } else if (!isOrderActive()) {
                        $state.go('app.shop.stadiumStart');
                    } else {
                        $location.path('/cart');
                    }
                    break;
                case 'addNew':
                    $state.reload();
                    toastr.success($translate.instant('MESSAGE.SAVESUCCESS'));
                    break;
                default:
                    break;
            }
        }

        function saveProduct() {
            var q = $q.defer();

            validateSize()
                .then(function () {
                    var data = getData();

                    if (isTemplateMode()) {
                        data.templateId = vm.user.templateId;
                    }

                    if (isEditMode()) {
                        LogosApiService.updateLogo(data, data.logoId)
                            .then(function () {
                                q.resolve();
                            }, function (reason) {
                                q.reject(reason);
                            });
                    } else {
                        data.register = vm.register;
                        LogosApiService.newLogo(data)
                            .then(function () {
                                q.resolve();
                            }, function (reason) {
                                q.reject(reason);
                            });
                    }
                }, function (reason) {
                    q.reject(reason);
                });

            return q.promise;
        }

        function getData() {
            var data = {
                file: null,
                colors: _.map(vm.selectedColours, 'name'),
                productType: vm.productType.name,
                productSubtype: vm.productSubtype ? vm.productSubtype.name : null,
                name: vm.name,
                width: vm.width.toString(),
                height: vm.height.toString(),
                process: vm.process,
                tags: vm.tags,
                information: vm.information,
                share: vm.share,
                quantity: vm.quantity,
                logoImage: vm.logoImage
            };

            if (vm.inventory) {
                data.minimumStock = vm.minimumStock;
                data.refillQuantity = vm.refillQuantity;
                data.manufacturingQuantity = vm.manufacturingQuantity;
            }

            if (Array.isArray(vm.files) && vm.files.length > 0 && vm.files[0].size) {
                data.file = vm.files[0];
            }

            if (showBacksidePicker()) {
                data.backsides = [];
                _.each(vm.selectedBacksides, function (backside) {
                    if (backside.id !== 0) {
                        data.backsides.push({ id: backside.id, quantity: backside.quantity });
                    }
                });
            }

            if (isTemplateMode()) {
                if (vm.selectedBackside && vm.selectedBackside.id !== 0) {
                    data.backside = vm.selectedBackside.id;
                    data.backsides = null;
                }
            }

            if (isEditMode() && isTemplateMode()) {
                data.logoId = vm.logo.logoId;
            }

            return data;
        }

        function newTag(tag) {
            if (tag.length > 20) {
                $translate('MESSAGE.MAXTAGLENGTH').then(function (translation) {
                    toastr.error(translation);
                });
                return false;
            } else {
                if (!_.some(vm.tags, function (existing) {
                    return existing.toLowerCase() === tag.toLowerCase();
                })) {
                    return tag.replace(',', '').toUpperCase();
                } else {
                    return false;
                }
            }
        }

        function onProductTypeSelect(selectedType) {
            vm.validationErrors = [];
            vm.tags = [];
            vm.process = false;
            vm.share = false;
            vm.inventory = false;
            vm.productSubtype = _.head(selectedType.productSubtypes) || null;
            vm.register = vm.register && isAllowOnlyRegistration(selectedType);

            loadColours(selectedType.colourType);
            setQuantities(selectedType.quantitySettings);

            // Handle backsides
            if (selectedType.backsides && selectedType.backsides.length > 0) {
                loadBacksides()
                    .then(function () {
                        // Clear selection
                        vm.selectedBackside = null;

                        // Remove backsides not available to product type
                        if (vm.selectedBacksides.length > 0) {
                            vm.selectedBacksides = _.filter(vm.selectedBacksides, function (backside) {
                                return vm.backsides.find(function(x) { return backside.id === x.id; });
                            });
                        }
                    });
            } else {
                vm.backsides = [];
                vm.selectedBacksides = [];
                vm.selectedBackside = null;
            }
        }

        function setQuantities(quantitySettings) {
            vm.quantity = quantitySettings.minOrderQuantity;
            vm.minQuantity = quantitySettings.minOrderQuantity;
            vm.minManufacturingQuantity = quantitySettings.minProductionQuantity;

            vm.manufacturingQuantity = 0;
            vm.minimumStock = 0;
            vm.refillQuantity = quantitySettings.minRefillQuantity;
            vm.minRefillQuantity = quantitySettings.minRefillQuantity;
        }

        function validForm() {
            vm.validationErrors = [];
            var isValid = true;

            validateBacksides();

            if (!vm.files || vm.files.length === 0 && vm.logoImage === null) {
                if (!vm.logo || !vm.logo.attachmentExtension && vm.logoImage == null) {
                    vm.validationErrors.push({field: 'file', message: 'CREATEARTICLE.VALIDATION.FILE'});
                }
            }
            if (!vm.process && vm.selectedColours.length < vm.minColourCount()) {
                vm.validationErrors.push({field: 'colors', message: 'CREATEARTICLE.COLOR.REQUIRED'});
            }
            if (vm.productType && !vm.inventory && (vm.quantity < vm.minQuantity)) {
                isValid = false;
            }
            if (vm.form.$invalid) {
                isValid = false;
            }
            if (vm.validationErrors.length > 0) {
                isValid = false;
            }

            return isValid;
        }

        function validateSize() {
            var q = $q.defer();

            var standardColourCount = 0;
            var specialColourCount = 0;

            if (!vm.process && vm.selectedColours && vm.selectedColours.length > 0) {
                standardColourCount = vm.selectedColours.length;
                specialColourCount = countCustomColours();
            }

            var query = {
                productGroup: 'STADIUM',
                productType: vm.productType ? vm.productType.name : null,
                productSubtype: vm.productSubtype ? vm.productSubtype.name : null,
                width: parseInt(vm.width),
                height: parseInt(vm.height),
                numberOfColours: standardColourCount.toString(),
                numberOfSpecialColours: specialColourCount.toString(),
                stitchCount: '',
                process: vm.process ? vm.process : false,
                express: false
            };

            CalculatorApiService.calculateSize(query).then(function (data) {
                if (!data.valid) {
                    if (data.size && data.maxSize) {
                        var errorMessage = $translate.instant('CALCULATOR.ERROR.SIZE').replace('%s', data.size).replace('%s', data.maxSize);
                        vm.validationErrors.push({field: 'size', message: errorMessage});
                    } else {
                        vm.validationErrors.push({field: 'size', message: $translate.instant('CALCULATOR.ERROR')});
                    }
                    q.reject();
                } else {
                    q.resolve();
                }
            }, function () {
                vm.validationErrors.push({field: 'size', message: $translate.instant('CALCULATOR.ERROR.INTEGER')});
                q.reject();
            });

            return q.promise;
        }

        function isAllowOnlyRegistration(productType) {
            return productType.allowOnlyRegistration === true;
        }

        function isTemplateMode() {
            return vm.user.templateId;
        }

        function isQuickTemplateMode() {
            return vm.user.templateId && vm.user.orderReference;
        }

        function isEditMode() {
            return !!vm.logo;
        }

        function onSelectInventory() {
            if (vm.inventory === true) {
                vm.quantity = 0;
                vm.manufacturingQuantity = vm.productType.quantitySettings.minProductionQuantity;
                vm.refillQuantity = vm.productType.quantitySettings.minRefillQuantity;
            } else {
                vm.quantity = vm.productType.quantitySettings.minOrderQuantity;
                vm.manufacturingQuantity = 0;
                vm.refillQuantity = 0;
            }
        }

        function showColourPicker() {
            return !vm.process && countCustomColours() < vm.maxColourCount();
        }

        function showProcess() {
            return vm.productSubtype && vm.productSubtype.processPrefix;
        }

        function addColour(colour) {
            if (colour && colour.trim()) {
                var customColour = colour.trim().toUpperCase();
                if (!_.find(vm.selectedColours, {'name': customColour})) {
                    return {name: customColour};
                }
            }
        }

        function maxColourCount() {
            return getColourCount('maxColourCount');
        }

        function minColourCount() {
            return getColourCount('minColourCount');
        }

        function getColourCount(field) {
            var result = vm.productType ? vm.productType[field] : null;
            if (vm.productSubtype && vm.productSubtype.exactColourCount) {
                result = vm.productSubtype.exactColourCount;
            }
            return result ? parseInt(result) : 0;
        }

        function countCustomColours() {
            return _.filter(vm.selectedColours, function (colour) {
                return !colour.code;
            }).length;
        }

        function isFirst(colour) {
            return isColourMatch(_.first(vm.selectedColours), colour);
        }

        function isLast(colour) {
            return isColourMatch(_.last(vm.selectedColours), colour);
        }

        function moveColour(colour, delta) {
            var index = -1;
            for (var loop in vm.selectedColours) {
                index = isColourMatch(vm.selectedColours[loop], colour) ? loop : index;
            }
            vm.selectedColours = _.without(vm.selectedColours, colour);
            index = parseInt(index) + delta;
            vm.selectedColours.splice(index, 0, colour);
        }

        function isColourMatch(colour1, colour2) {
            if (!colour1 || !colour1.name || !colour2 || !colour2.name) {
                return false;
            }
            return colour1.name.toUpperCase().trim() === colour2.name.toUpperCase().trim();
        }

        function clearSelectedColours() {
            vm.selectedColours = [];
        }

        function openColourPicker() {
            var data = {
                colors: vm.colours.slice(),
                selectedColors: vm.selectedColours.slice(),
                maxColors: vm.maxColourCount(),
                customColors: countCustomColours()
            };

            ColorPickerDialogService.showDialog(data).then(function (selectedColours) {
                vm.selectedColours = selectedColours;
            });
        }

        function showBacksidePicker() {
            return vm.productType && vm.productType.backsides && vm.productType.backsides.length > 0;
        }

        function loadBacksides() {
            vm.selectedBacksides = [];
            var defaultQuantity = vm.productType.quantitySettings.minOrderQuantity;
            vm.backsides = [{
                id: 0,
                name: $translate.instant('ARTICLE.BACKSIDE.0'),
                quantity: defaultQuantity
            }];

            return ArticlesApiService.getProductBacksides(vm.productType.name).then(function(response) {
                response.forEach(function (backside) {
                    vm.backsides.push(backside);
                });
            });
        }

        function availableBacksides() {
            if (!vm.selectedBacksides || vm.selectedBacksides && vm.selectedBacksides.length === 0) {
                return vm.backsides;
            }
            
            return _.filter(vm.backsides, function (backside) {
                return !vm.selectedBacksides.find(function (x) { return backside.id === x.id; });
            });
        }

        function addBackside() {
            if (!vm.selectedBackside) {
                return;
            }
            if (isTemplateMode()) {
                return;
            }

            vm.selectedBackside.quantity = _.max([vm.quantity, vm.selectedBackside.minimumQuantity]);
            vm.selectedBacksides.push(vm.selectedBackside);
            vm.selectedBackside = null;
        }

        function removeBackside(backsideToRemove) {
            if (!vm.selectedBacksides) {
                return;
            }
            if (vm.selectedBacksides.length === 1) {
                vm.selectedBacksides = [];
            } else {
                _.remove(vm.selectedBacksides, function (backside) {
                    return backside.id === backsideToRemove.id;
                });
            }
        }

        function validateBacksides() {
            if (!showBacksidePicker()) {
                return;
            }

            if (isTemplateMode()) {
                if (!vm.selectedBackside) {
                    vm.validationErrors.push({field: 'backsides' , message: 'CREATEARTICLE.VALIDATION.BACKSIDES'});
                }

                return;
            }

            if (!vm.selectedBacksides || vm.selectedBacksides.length === 0) {
                vm.validationErrors.push({field: 'backsides', message: 'CREATEARTICLE.VALIDATION.BACKSIDES'});
            }
            else {
                var totalQuantity = 0;
                _.each(vm.selectedBacksides, function (backside) {
                    totalQuantity += backside.quantity;
                });

                if (totalQuantity < vm.quantity) {
                    vm.validationErrors.push({field: 'backsides', message: 'CREATEARTICLE.VALIDATION.BACKSIDES.QUANTITY'});
                }
            }
        }

        function isAttachmentAvailable(type) {
            if (type === 'file') {
                return vm.logoImage === null;
            }

            if (type == 'logoImage') {
                return vm.file && vm.files.length === 0 && !vm.process;
            }

            return false;
        }

        function clearAttachments() {
            vm.isAttachmentSet = false;
            vm.files = null;
            vm.logoImage = null;

            if (isEditMode()) {
                vm.attachmentExtension = '';
            }
        }

        function showLogoImage() {
            return vm.productType && vm.productType.allowLogoUpload && !vm.process;
        }

        function getLogoImageUrl() {
            if (vm.logoImage && vm.logoImage.logoImageId) {
                return LogoImageApiService.getImageUrl(vm.logoImage.logoImageId);
            }
        }

        function selectLogoImage() {
            var colourHolder = _.clone(vm.selectedColours);
            vm.selectedColours = [];

            LogoImageDialogService.showDialog(vm.productType.colourType)
                .then(function (logoImage) {
                    if (logoImage !== null) {
                        vm.logoImage = logoImage;
                        vm.isAttachmentSet = true;
                        _.remove(vm.validationErrors, {field: 'file'});

                        // Set colours
                        vm.process = false;
                        setLogoImageColours(logoImage);
                    }
                }).catch(function (error) {
                    if (!error) {
                        // If aborted - restore colours
                        vm.selectedColours = colourHolder;
                        return;
                    }

                    throw error;
                });
        }

        function editLogoImage() {
            var colourHolder = _.clone(vm.selectedColours);
            vm.selectedColours = [];

            LogoImageDialogService.showEditDialog(vm.logoImage, vm.productType.colourType)
                .then(function (logoImage) {
                    if (logoImage !== null) {
                        vm.logoImage = logoImage;
                        vm.isAttachmentSet = true;
                        _.remove(vm.validationErrors, {field: 'file'});

                        // Set colours
                        vm.process = false;
                        setLogoImageColours(logoImage);
                    }
                }).catch(function (error) {
                    if (!error) {
                        // If aborted - restore colours
                        vm.selectedColours = colourHolder;
                        return;
                    }

                    throw error;
                });
        }

        function setLogoImageColours(logoImage) {
            var newColours = [];
            _.each(logoImage.logoImageColours, function (colour) {
                if (colour.customColour === true) {
                    newColours.push({ name: colour.colourName });
                }
                else {
                    var logoColour = _.find(vm.colours, { 'name': colour.colourName });
                    if (logoColour) {
                        newColours.push(angular.copy(logoColour));
                    }
                }
            });

            vm.selectedColours = _.uniqBy(newColours, 'name');
        }

        function isLeatheretteBrand() {
            return vm.productType.name === 'STADIUM_LEATHERETTE_BRAND';
        }

        $scope.$watch(function () {
            return vm.selectedColours;
        }, function () {
            // Reset colors validation error
            _.remove(vm.validationErrors, {field: 'colors'});
        });
    }

    angular
        .module('stadium.logo', [])
        .controller('StadiumLogoController', StadiumLogoController)
        .config(stateConfig);
})();

(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    placementResolve.$inject = ["StadiumPlacementsApiService", "$stateParams"];
    PlacementController.$inject = ["$stateParams", "placement", "DS"];
    function stateConfig($stateProvider) {
        $stateProvider.state('placement', {
            url: '/placement/{placementId}/{perspective}/:dimensions?',
            views: {
                '@': {
                    template: '<div class="stadium-placement stadium-placement-{{vm.roundHundred(vm.width)}}"><design-placer config="vm.designPlacerConfig" init="vm.initialiseDesignPlacer(controller)"></design-placer></div>',
                    controller: 'PlacementController as vm'
                }
            },
            data: {pageTitle: 'Placement'},
            resolve: {
                placement: placementResolve
            }
        });
    }

    // @ngInject
    function placementResolve(StadiumPlacementsApiService, $stateParams) {
        return StadiumPlacementsApiService.getPlacement($stateParams.placementId);
    }

    // @ngInject
    function PlacementController($stateParams, placement, DS) {
        var vm = this;
        vm.width = !$stateParams.dimensions ? 600 : $stateParams.dimensions.split('x')[0];

        vm.placement = placement;
        vm.roundHundred = roundHundred;
        vm.initialiseDesignPlacer = initialiseDesignPlacer;

        activate();

        function activate() {
            vm.designPlacerConfig = {
                editorSize: {
                    width: 600,
                    height: 600
                },
                editable: false
            };
            vm.product = {
                id: 1,
                name: vm.placement.garment,
                viewpoints: []
            };
            angular.forEach(vm.placement.perspectives, function (perspective) {
                var imageUrl = './assets/products/' + vm.placement.garment + '-' + perspective.name + '.png';
                vm.product.viewpoints.push({
                    name: perspective.name,
                    image: parseImageUrl(perspective.imageUrl) || imageUrl,
                    width: 600,
                    height: 600
                });
            });
            vm.printTemplate = {
                id: vm.placement.placementId,
                viewpoints: getViewpointArray()
            };
        }

        function roundHundred(value){
            return Math.round(value/100)*100;
        }

        function getViewpointArray() {
            var result = [];
            angular.forEach(vm.placement.perspectives, function (perspective) {
                result.push({
                    name: perspective.name,
                    customImage: parseImageUrl(perspective.imageUrl),
                    designs: getDesignArray(perspective)
                });
            });
            return result;
        }

        function getDesignArray(perspective) {
            var result = [];
            angular.forEach(perspective.placementItems, function (placementItem) {
                result.push({
                    id: placementItem.id,
                    image: parseImageUrl(placementItem.imageUrl),
                    x: parseFloat(placementItem.xCoordinate),
                    y: parseFloat(placementItem.yCoordinate),
                    rotation: parseFloat(placementItem.degreeOfRotation),
                    instruction: placementItem.instruction,
                    height: parseFloat(placementItem.height),
                    width: parseFloat(placementItem.width)
                });
            });
            return result;
        }

        function parseImageUrl(originalImageUrl) {
            if (originalImageUrl == null) {
                return originalImageUrl;
            }

            if (DS.defaults.imageUrlPrefix === '') {
                return originalImageUrl;
            }

            if (originalImageUrl.contains(DS.defaults.imageUrlPrefix)) {
                return originalImageUrl;
            }

            if (originalImageUrl.contains(DS.defaults.oldImageUrlPrefix)) {
                return originalImageUrl.replace(DS.defaults.oldImageUrlPrefix, DS.defaults.imageUrlPrefix);
            }

            return DS.defaults.imageUrlPrefix + originalImageUrl;
        }

        function initialiseDesignPlacer(controller) {
            vm.placerController = controller;
            vm.product.viewpoints.forEach(function (v) {
                var viewPointData = vm.printTemplate.viewpoints.filter(function (data) {
                    return data.name === v.name;
                });
                viewPointData = viewPointData.length ? viewPointData[0] : null;
                controller.addViewpoint(v);
                if (viewPointData) {
                    controller.setDesigns(v.name, viewPointData.designs);
                }
                if (viewPointData && viewPointData.customImage) {
                    controller.setBackground(v.name, viewPointData.customImage);
                } else {
                    controller.setBackground(v.name, v.image);
                }
            });
            controller.selectViewpoint($stateParams.perspective);
        }
    }

    angular
        .module('stadium.placement', [])
        .controller('PlacementController', PlacementController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    ShortagesController.$inject = ["$scope", "$location", "$window", "$rootScope", "loadSpinnerService", "ngTableParams", "ManufacturingDialogService", "ShortagesApiService", "TableService", "user"];
    userResolve.$inject = ["AuthService"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.shortages', {
            url: '/shortages',
            views: {
                "main-content": {
                    templateUrl: 'stadium/shortages/shortages.tpl.html',
                    controller: 'ShortagesController as vm'
                }
            },
            resolve: {
                user: userResolve
            }
        });
    }

    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function ShortagesController(
        $scope,
        $location,
        $window,
        $rootScope,
        loadSpinnerService,
        ngTableParams,
        ManufacturingDialogService,
        ShortagesApiService,
        TableService,
        user
    ) {
        /* jshint validthis: true */
        var vm = this;
        var sortBy = {};
        vm.user = user;
        vm.openManufacturingDialog = openManufacturingDialog;
        vm.selectArticle = selectArticle;
        vm.tableParams = {};
        vm.searchStatus = {};
        vm.stadiumSearch = 'own';

        vm.initialized = false;
        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'NAVIGATION.SHORTAGES',
                state: null
            }
        ];

        activate();

        function activate() {
            vm.searchStatus = {
                page: '1',
                pages: '1',
                active: false
            };

            /* jshint ignore:start */
            vm.tableParams = new ngTableParams({
                stadiumSearch: vm.stadiumSearch,
                page: 1,
                count: 20,
                sorting: {
                    articleId: 'asc'
                }
            }, {
                counts: [],
                total: 0, // length of data
                getData: updateTable
            });
            /* jshint ignore:end */
        }

        function updateTable($defer, params) {
            loadSpinnerService.start();
            params.generatePagesArray = TableService.generatePagesArray;

            if(!_.isEqual(sortBy, params.sorting())){
                sortBy = params.sorting();
                if(params.page() !== 1){
                    params.page(1);
                }
            }

            ShortagesApiService.getShortages(params.page(), params.sorting(), params.$params.stadiumSearch).then(function(response) {
                params.total(response.meta.totalPages * response.meta.pageSize);
                updateSearchStatus(response.meta);

                if(!vm.initialized){
                    vm.initialized = true;
                }

                $defer.resolve(response.shortages);
            }).finally(function(){ loadSpinnerService.stop();});
        }

        function updateSearchStatus(meta) {
            vm.searchStatus.page = !meta.page || '0' === meta.page ? '1' : meta.page;
            vm.searchStatus.pages = !meta.totalPages || '0' === meta.totalPages ? '1' : meta.totalPages;
        }

        function selectArticle(id) {
            $location.path('articles/' + id);
        }

        function openManufacturingDialog(shortage) {
            ManufacturingDialogService.showDialog(shortage.articleId).then(function() {
                $rootScope.$broadcast('$updateNotifications');
                $window.location.reload();
            });
        }

        $scope.$watch(function(){
            return vm.stadiumSearch;
        }, function(newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.tableParams.$params.stadiumSearch = vm.stadiumSearch;
                if (vm.tableParams.page() !== 1) {
                    vm.tableParams.page(1);
                }
                if (newValue.split(',')[2] !== oldValue.split(',')[2]) {
                    vm.tableParams.reload();
                }
            }
        });
    }

    angular
        .module('stadium.shortages', [])
        .controller('ShortagesController', ShortagesController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    angular
        .module('app.stadium', [
            'stadium.logo',
            'stadium.product',
            'stadium.products',
            'stadium.shortages',
            'stadium.incomingOrders',
            'stadium.placement',
            'stadium.start',
            'stadium.templateManagement']);
})();
(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    productResolve.$inject = ["StadiumProductService", "$stateParams"];
    StadiumProductController.$inject = ["DS", "$state", "$translate", "$modal", "StadiumProductService", "PlacementsApiService", "ValidationManager", "ConfirmDialogService", "user", "product"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.stadiumproduct', {
            url: '/stadiumproducts/{id}',
            views: {
                'main-content': {
                    templateUrl: 'stadium/stadiumProduct/stadiumProduct.tpl.html',
                    controller: 'StadiumProductController as vm'
                }
            },
            resolve: {
                user: userResolve,
                product: productResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function productResolve(StadiumProductService, $stateParams) {
        return StadiumProductService.getProduct($stateParams.id);
    }

    // @ngInject
    function StadiumProductController(
        DS,
        $state,
        $translate,
        $modal,
        StadiumProductService,
        PlacementsApiService,
        ValidationManager,
        ConfirmDialogService,
        user,
        product
    ) {
        var vm = this;
        vm.user = user;
        vm.product = product;
        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'STADIUM.PRODUCTS',
                state: {
                    to: 'app.shop.stadiumproducts'
                }
            },
            {
                displayName: vm.product.articleId,
                state: null
            }
        ];

        vm.getImageUrl = getImageUrl;
        vm.getTemplateStatus = getTemplateStatus;
        vm.createMainTemplate = createMainTemplate;
        vm.editMainTemplate = editMainTemplate;
        vm.createTeamTemplate = createTeamTemplate;
        vm.editTeamTemplate = editTeamTemplate;
        vm.deleteTeamTemplate = deleteTeamTemplate;
        vm.deleteMainTemplate = deleteMainTemplate;
        vm.submitTemplate = submitTemplate;
        vm.revertTemplateStatus = revertTemplateStatus;
        vm.updateProduct = updateProduct;
        vm.getMainTemplateClass = getMainTemplateClass;
        vm.getTemplateClass = getTemplateClass;
        vm.getMainTemplateStatus = getMainTemplateStatus;
        vm.deleteProduct = deleteProduct;
        vm.openTemplateAuditLogsDialog = openTemplateAuditLogsDialog;
        vm.openPrintingInformationDialog = openPrintingInformationDialog;
        vm.isB2bOnly = isB2bOnly;

        function getImageUrl(fileName) {
            return DS.defaults.baseUrl + 'stadiumproducts/image/' + fileName + '?size=large';
        }

        function getTemplateStatus(template) {
            if (!template) {
                return $translate.instant('STADIUM.PRODUCT_STATUS_NOT_SET');
            }

            if (template.status === 'READY') {
                return $translate.instant('STADIUM.PRODUCT_STATUS_READY');
            } else {
                return $translate.instant('STADIUM.PRODUCT_STATUS_IN_PROGRESS');
            }
        }

        function createMainTemplate() {
            StadiumProductService.createMainTemplate(product.id)
                .catch(handleError)
                .then(function (template) {
                    return editTemplate(template.templateId);
                });
        }

        function editMainTemplate() {
            return editTemplate(vm.product.mainTemplate.templateId);
        }

        function createTeamTemplate(team) {
            StadiumProductService.createTeamTemplate(vm.product.id, team)
                .catch(handleError)
                .then(reloadProduct);
        }

        function reloadProduct() {
            return $state.reload();
        }

        function editTeamTemplate(templateId) {
            return editTemplate(templateId);
        }

        function deleteTeamTemplate(templateId) {
            StadiumProductService.deleteTeamTemplate(vm.product.id, templateId)
                .catch(handleError)
                .then(reloadProduct);
        }

        function deleteMainTemplate() {
            StadiumProductService.deleteMainTemplate(vm.product.id)
                .catch(handleError)
                .then(reloadProduct);
        }

        function submitTemplate(templateId) {
            StadiumProductService.submitTemplate(vm.product.id, templateId)
                .catch(handleError)
                .then(reloadProduct);
        }

        function revertTemplateStatus(templateId) {
            StadiumProductService.revertTemplateStatus(vm.product.id, templateId)
                .catch(handleError)
                .then(reloadProduct);
        }

        function updateProduct() {
            StadiumProductService.updateStadiumProduct(
                vm.product.id,
                vm.product.sponsoring
            ).catch(handleError);
        }

        function handleError(error) {
            ValidationManager.handleResponseError(error);
            throw error;
        }

        function editTemplate(templateId) {
            PlacementsApiService.openTemplate(templateId)
                .then(function () {
                    $state.go('app.shop.advancedMounting', {id: templateId});
                });
        }

        function openTemplateAuditLogsDialog() {
            var templateAuditDialog = {
                backdrop: 'static',
                controller: 'TemplateAuditLogsDialogController as vm',
                templateUrl: 'shop/mounting/templateAuditLogsDialog/templateAuditLogsDialog.tpl.html',
                resolve: {
                    templateAuditLogs: function () {
                        return PlacementsApiService.getTemplateAuditLogsStadiumProduct(vm.product.id);
                    },
                }
            };
            $modal.open(templateAuditDialog).result.then(function () {
                $state.reload();
            });
        }

        function openPrintingInformationDialog() {
            var printingInformationDialog = {
                backdrop: 'static',
                controller: 'PrintingInformationDialogController as vm',
                templateUrl: 'shop/mounting/printingInformationDialog/printingInformationDialog.tpl.html',
                resolve: {
                    printingInformation: function () {
                        return null;
                    },
                }
            };
            $modal.open(printingInformationDialog).result.then(function () {
                $state.reload();
            });
        }


        function getMainTemplateClass() {
            return getTemplateClass(vm.product.mainTemplate);
        }

        function getMainTemplateStatus() {
            return getTemplateStatus(vm.product.mainTemplate);
        }

        function getTemplateClass(template) {
            if (!template) {
                return {
                    'fa-circle': true,
                    'not-set': true
                };
            }
            if (template.status === 'IN_PROGRESS') {
                return {
                    'fa-circle': true,
                    'in-progress': true
                };
            }
            if (template.status === 'READY') {
                return {
                    'fa-check-circle': true,
                    'ready': true
                };
            }
        }

        function deleteProduct() {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default' }, { name: 'BUTTON.YES', class: 'btn-danger' }];
            return ConfirmDialogService.showDialog('STADIUM.PRODUCT_DELETE', ' ', buttons)
                .then(function(resp) {
                    if (resp.name === 'BUTTON.YES') {
                        return StadiumProductService.deleteProduct(vm.product.id)
                            .then(function() {
                                return $state.go('app.shop.stadiumproducts', {}, {reload: true});
                            });
                    }
                    return resp;
                });
        }

        function isB2bOnly() {
            if(vm.product.onlyB2BSharing) {
                return 'BOOLEAN.TRUE';
            }
            else {
                return 'BOOLEAN.FALSE';
            }
        }
    }

    angular.module('stadium.product', ['templateAuditLogsDialog', 'printingInformationDialog'])
        .controller('StadiumProductController', StadiumProductController)
        .config(stateConfig);
})();

(function () {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    clubsResolve.$inject = ["StadiumProductService"];
    StadiumProductsController.$inject = ["$state", "$translate", "StadiumProductService", "loadSpinnerService", "DS", "user", "clubs"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.stadiumproducts', {
            url: '/stadiumproducts',
            views: {
                'main-content': {
                    templateUrl: 'stadium/stadiumProduct/stadiumProducts.tpl.html',
                    controller: 'StadiumProductsController as vm'
                }
            },
            resolve: {
                user: userResolve,
                clubs: clubsResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function clubsResolve(StadiumProductService) {
        return StadiumProductService.getClubs();
    }

    // @ngInject
    function StadiumProductsController(
        $state,
        $translate,
        StadiumProductService,
        loadSpinnerService,
        DS,
        user,
        clubs
    ) {
        var vm = this;
        vm.user = user;
        vm.clubs = clubs;
        vm.links = [
            {
                displayName: 'NAVIGATION.HOME',
                state: {
                    to: 'app.shop.calculator'
                }
            },
            {
                displayName: 'STADIUM.PRODUCTS',
                state: null
            }
        ];

        vm.savedSearch = StadiumProductService.getSavedSearch();
        vm.searchText = vm.savedSearch.searchText;
        vm.pageSize = vm.savedSearch.pageSize;
        vm.page = vm.savedSearch.page;
        vm.selectedClubs = vm.savedSearch.selectedClubs;
        vm.pageSizeSelect = [24, 48, 72];

        vm.getImageUrl = getImageUrl;
        vm.search = search;
        vm.selectProduct = selectProduct;
        vm.getTemplateStatusClass = getTemplateStatusClass;
        vm.getTemplateStatus = getTemplateStatus;
        vm.pageChanged = pageChanged;
        vm.clubChanged = clubChanged;
        vm.isAnyFilterActive = isAnyFilterActive;
        vm.pageSizeChanged = pageSizeChanged;

        fetchProducts();

        function selectProduct(product) {
            $state.go('app.shop.stadiumproduct', {'id': product.id});
        }

        function getImageUrl(fileName) {
            return DS.defaults.baseUrl + 'stadiumproducts/image/' + fileName + '?size=small';
        }

        function search(event) {
            vm.searchText = event.target.value;
            vm.page = 1;
            fetchProducts();
        }

        function clubChanged() {
            vm.page = 1;
            fetchProducts();
        }

        function isAnyFilterActive() {
            return vm.selectedClubs && vm.selectedClubs.length > 0;
        }

        function clearProducts() {
            vm.products = null;
            vm.totalItems = null;
        }

        function fetchProducts() {
            if (!isAnyFilterActive()) {
                clearProducts();
                return;
            }

            loadSpinnerService.start();
            StadiumProductService.searchProducts(vm.searchText, vm.selectedClubs, vm.page, vm.pageSize)
                .then(function (result) {
                    vm.products = result.searchResults;
                    vm.totalItems = result.searchHitCount;
                    vm.savedSearch = StadiumProductService.getSavedSearch();
                })
                .finally(function () {
                    loadSpinnerService.stop();
                });
        }

        function pageChanged() {
            fetchProducts();
        }

        function getTemplateStatusClass(product) {
            if (!product.mainTemplateStatus) {
                return {
                    'not-set': true,
                    'fa-circle': true
                };
            }
            if (product.mainTemplateStatus === 'IN_PROGRESS') {
                return {
                    'in-progress': true,
                    'fa-circle': true
                };
            }
            if (product.mainTemplateStatus === 'READY') {
                return {
                    'ready': true,
                    'fa-check-circle': true
                };
            }
        }

        function getTemplateStatus(product) {
            if (!product.mainTemplateStatus) {
                return $translate.instant('STADIUM.PRODUCT_STATUS_NOT_SET');
            }

            if (product.mainTemplateStatus === 'READY') {
                return $translate.instant('STADIUM.PRODUCT_STATUS_READY');
            } else {
                return $translate.instant('STADIUM.PRODUCT_STATUS_IN_PROGRESS');
            }
        }

        function pageSizeChanged(newPageSize) {
            vm.pageSize = newPageSize;
            vm.page = 1;
            fetchProducts();
        }
    }

    angular
        .module('stadium.products', [])
        .controller('StadiumProductsController', StadiumProductsController)
        .config(stateConfig);
})();

(function() {

    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    savedCartsServiceResolve.$inject = ["SavedCartsApiService"];
    userResolve.$inject = ["AuthService"];
    StadiumStartController.$inject = ["$rootScope", "$state", "StadiumHistoryApiService", "SavedCartsApiService", "StadiumParserApiService", "CartApiService", "ClubsApiService", "PlacementsApiService", "StadiumPlacementsApiService", "ConfirmDialogService", "TemplatePickerDialogService", "loadSpinnerService", "PlayerDialogService", "PlacementOrderApiService", "TemplateErrorDialogService", "TemplateDialogService", "PlayerGroupDialogService", "ValidationManager", "StadiumProductTemplatePickerDialogService", "savedCarts", "user"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.stadiumStart', {
            url: '/stadium',
            views: {
                'main-content': {
                    templateUrl: 'stadium/start/start.tpl.html',
                    controller: 'StadiumStartController as vm'
                }
            },
            resolve: {
                savedCarts: savedCartsServiceResolve,
                user: userResolve
            }
        });
    }

    // @ngInject
    function savedCartsServiceResolve(SavedCartsApiService) {
        return SavedCartsApiService.getSavedCarts();
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function StadiumStartController(
        $rootScope,
        $state,
        StadiumHistoryApiService,
        SavedCartsApiService,
        StadiumParserApiService,
        CartApiService,
        ClubsApiService,
        PlacementsApiService,
        StadiumPlacementsApiService,
        ConfirmDialogService,
        TemplatePickerDialogService,
        loadSpinnerService,
        PlayerDialogService,
        PlacementOrderApiService,
        TemplateErrorDialogService,
        TemplateDialogService,
        PlayerGroupDialogService,
        ValidationManager,
        StadiumProductTemplatePickerDialogService,
        savedCarts,
        user
    ) {
        var vm = this;
        vm.user = user;
        vm.orders = [];
        vm.savedCarts = savedCarts;
        vm.stadiumTemplate = null;
        vm.reference = null;
        vm.project = null;
        vm.savedCart = null;
        vm.order = null;
        vm.locked = false;
        vm.isLoading = false;
        vm.excelImport = '';
        vm.playerGroups = null;
        vm.importErrors = [];

        vm.onClickNewOrder = onClickNewOrder;
        vm.onClickViewOrder = onClickViewOrder;
        vm.importExcel = importExcel;
        vm.addPlayerGroup = addPlayerGroup;
        vm.onClickRemovePlayerGroup = onClickRemovePlayerGroup;
        vm.onClickSetTemplate = onClickSetTemplate;
        vm.onClickSetProductTemplate = onClickSetProductTemplate;
        vm.onClickEditStandardTemplate = onClickEditStandardTemplate;
        vm.onClickCreateQuickTemplate = onClickCreateQuickTemplate;
        vm.onClickEditQuickTemplate = onClickEditQuickTemplate;
        vm.onClickRemoveQuickTemplate = onClickRemoveQuickTemplate;
        vm.onClickCreateTemplate = onClickCreateTemplate;
        vm.onClickEditTemplate = onClickEditTemplate;
        vm.onClickActivateSavedCart = onClickActivateSavedCart;
        vm.getSavedCarts = getSavedCarts;
        vm.removeSavedCart = removeSavedCart;
        vm.isReferenceProjectUnique = isReferenceProjectUnique;
        vm.openPlayerDialog = openPlayerDialog;
        vm.orderExcelImport = orderExcelImport;
        vm.isOrderAvailable = isOrderAvailable;
        vm.isPlayerGroupReady = isPlayerGroupReady;
        vm.showOrderTable = showOrderTable;

        activate();

        function activate() {
            vm.locked = !user.orderReference || !user.orderProject;
            StadiumHistoryApiService.getOrders().then(function(orders) {
                angular.forEach(orders, function(order) {
                    vm.orders.push({
                        id: order.id,
                        description: order.description,
                        articles: order.description + ' ' + order.articles
                    });
                });
            });

            if(!vm.locked) {
                ClubsApiService.getClubs().then(function (clubs) {
                    vm.clubs = clubs;
                });
                loadPlayerGroups();
            }
            else {
                vm.playerGroups = null;
            }
        }

        function onClickNewOrder() {
            var data = {
                orderReference: vm.reference,
                orderProject: vm.project
            };
            SavedCartsApiService.activateSavedCart(data).then(function() {
                $state.reload();
            });
        }

        function onClickViewOrder() {
            $state.go('app.shop.historyView', {id: vm.order.id}, {reload: true});
        }

        function isReferenceProjectUnique() {
            var result = true;
            if (vm.project && vm.reference) {
                _.each(vm.savedCarts, function (savedCart) {
                    result = result && !(savedCart.orderReference.toLowerCase() === vm.reference.toLowerCase() && savedCart.orderProject.toLowerCase() === vm.project.toLowerCase());
                });
            }
            return result;
        }

        function onClickEditStandardTemplate(playerGroup) {
            PlacementsApiService.createQuickTemplateFromTemplate(playerGroup.templateId).then(function (template) {
                StadiumPlacementsApiService.setTemplateOnPlayerGroup(playerGroup.groupId, template.placementId).then(function () {
                    PlacementsApiService.openTemplate(template.placementId).then(function () {
                        $rootScope.$broadcast('$updateNotifications');
                    }).then(function () {
                        $state.go('app.shop.advancedMounting', {id: template.placementId}, 'AdvancedMountingController');
                    });
                });
            });
        }

        function onClickCreateQuickTemplate(playerGroup) {
            TemplateDialogService.showTemplateDialog(playerGroup.colour, playerGroup.garment, null, null, true, false).then(function (template) {
                StadiumPlacementsApiService.setTemplateOnPlayerGroup(playerGroup.groupId, template.placementId).then(function () {
                    PlacementsApiService.openTemplate(template.placementId).then(function () {
                        $rootScope.$broadcast('$updateNotifications');
                    }).then(function () {
                        $state.go('app.shop.advancedMounting', {id: template.placementId}, 'AdvancedMountingController');
                    });
                });
            });
        }

        function onClickEditQuickTemplate(templateId) {
            PlacementsApiService.openTemplate(templateId).then(function () {
                $rootScope.$broadcast('$updateNotifications');
            }).finally(function () {
                $state.go('app.shop.advancedMounting', {id: templateId}, 'AdvancedMountingController');
            });
        }

        function onClickRemoveQuickTemplate(playerGroup) {
            if(user.templateId === playerGroup.templateId) {
                PlacementsApiService.closeTemplate().then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                });
            }
            StadiumPlacementsApiService.setTemplateOnPlayerGroup(playerGroup.groupId, "0").then(function () {
                loadPlayerGroups();
            });
        }

        function onClickCreateTemplate() {
            TemplateDialogService.showTemplateDialog(null, null, null, null, false, true).then(function (template) {
                PlacementsApiService.openTemplate(template.placementId).then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                }).finally(function () {
                    $state.go('app.shop.advancedMounting', {id: template.placementId}, 'AdvancedMountingController');
                });
            });
        }

        function onClickEditTemplate() {
            TemplatePickerDialogService.showDialog().then(function (result) {
                PlacementsApiService.openTemplate(result.template.placementId).then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                }).finally(function () {
                    $state.go('app.shop.advancedMounting', {id: result.template.placementId}, 'AdvancedMountingController');
                });
            });
        }

        function onClickActivateSavedCart() {
            if (vm.savedCart === null) {
                return;
            }

            var data = {
                orderReference: vm.savedCart.orderReference,
                orderProject: vm.savedCart.orderProject
            };
            SavedCartsApiService.activateSavedCart(data).then(function () {
                $state.reload();
            });
        }

        function getSavedCarts() {
            return _.filter(vm.savedCarts, function (savedCart) {
                return savedCart.orderReference !== vm.user.orderReference && savedCart.orderProject !== vm.user.orderProject;
            });
        }

        function removeSavedCart(savedCart) {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default'}, { name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('STADIUM.DELETESAVEDCART1', 'STADIUM.DELETESAVEDCART2', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    SavedCartsApiService.deleteSavedCart(savedCart).then(function() {
                        vm.savedCart = null;
                        vm.savedCarts = _.without(vm.savedCarts, savedCart);
                    }).then(loadSpinnerService.stop());
                }
            });
        }

        function importExcel() {
            vm.importError = false;
            StadiumParserApiService.getParsedPlayers(vm.excelImport).then(function() {
                loadPlayerGroups();
            }, function(error) {
                if (error.status === 400) {
                    vm.importErrors = error.data || [];
                }

                vm.importError = true;
            });
            vm.excelImport = null;
        }

        function addPlayerGroup() {
            PlayerGroupDialogService.showDialog()
                .then(function (value) {
                    CartApiService.addPlayerGroup(value).then(function () {
                        loadPlayerGroups();
                    })
                    .catch(function (error) {
                        if (error) {
                            ValidationManager.handleResponseError(error);
                            throw error;
                        }
                    });
                });
        }

        function onClickSetTemplate(playerGroup) {
            var filterData = {
                garmentName: playerGroup.garment || '',
                garmentColour: playerGroup.colour || ''
            };

            var templateId = '';
            TemplatePickerDialogService.showSuggestionDialog(playerGroup.templateId, findSuggestedTemplateForImport(), filterData).then(function (result) {
                templateId = result.template.placementId;

                PlacementsApiService.validateTemplate(templateId).then(function (errors) {
                    if (errors.length === 0) {
                        StadiumPlacementsApiService.setTemplateOnPlayerGroup(playerGroup.groupId, templateId).then(function () {
                            loadPlayerGroups();
                        });
                    } else {
                        TemplateErrorDialogService.showDialog(templateId);
                    }
                }, function () {
                    TemplateErrorDialogService.showDialog(templateId);
                });
            });
        }

        // TODO: Check if this should be able on start page (button not added in html)
        function onClickSetProductTemplate(playerGroup) {
            var templateId = '';
            StadiumProductTemplatePickerDialogService.showDialog()
                .then(function (template) {
                    templateId = template;

                    PlacementsApiService.validateTemplate(templateId)
                        .then(function (errors) {
                            if (errors.length === 0) {
                                StadiumPlacementsApiService.setTemplateOnPlayerGroup(playerGroup.groupId, templateId)
                                    .then(function () {
                                        loadPlayerGroups();
                                    });
                            } else {
                                TemplateErrorDialogService.showDialog(templateId);
                            }
                        }).catch(function () {
                            TemplateErrorDialogService.showDialog(templateId);
                        });
                });
        }

        function onClickRemovePlayerGroup(playerGroup) {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default'}, { name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('STADIUM.EXCEL.IMPORT.TABLE.REMOVE.TITLE', ' ', buttons).then(function(button) {
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    StadiumPlacementsApiService.removePlayerGroup(playerGroup.groupId).then(function () {
                        if (user.templateId === playerGroup.templateId) {
                            PlacementsApiService.closeTemplate().then(function () {
                                $rootScope.$broadcast('$updateNotifications');
                            });
                        }
                        loadPlayerGroups();
                    }).finally(loadSpinnerService.stop);
                }
            });
        }

        function loadPlayerGroups() {
            CartApiService.getPlayerGroups().then(function (playerGroups) {
                vm.playerGroups = playerGroups;
            });
        }

        function findSuggestedTemplateForImport(){
            var playerGroup = vm.playerGroups.find(function (playerGroup) {
                if(playerGroup.templateId && !playerGroup.quickTemplate) {
                    return playerGroup;
                }
            });

            return playerGroup ? playerGroup.templateId : '';
        }

        function openPlayerDialog(playerListId) {
            PlayerDialogService.showDialog(playerListId).then(function() {
                loadPlayerGroups();
            });
        }

        function orderExcelImport() {
            loadSpinnerService.start();
            vm.isLoading = true;
            var templateOrderEntities = [];
            vm.playerGroups.forEach(function (playerGroup) {
                if (!playerGroup.locked && playerGroup.templateId) {
                    templateOrderEntities.push({playerGroupId: playerGroup.groupId, templateId: playerGroup.templateId, playerListId: playerGroup.playerListId});
                }
            });

            PlacementOrderApiService.addTemplatesToCart(templateOrderEntities).then(function () {
                PlacementsApiService.closeTemplate().then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                    $state.go('app.shop.cart', {}, {reload: true});
                });
            }, function (reason) {
                ValidationManager.handleResponseError(reason);
            }).then(function () {
                loadSpinnerService.stop();
                vm.isLoading = false;
            });
        }

        function isOrderAvailable() {
            if (vm.isLoading) {
                return false;
            }
            if (!vm.playerGroups) {
                return false;
            }
            return !(vm.playerGroups.some(incompleteOrderRow) || vm.playerGroups.every(completedOrderRow));
        }

        function isPlayerGroupReady(playerGroup) {
            return !playerGroup.locked && playerGroup.templateId && playerGroup.playerQuantity > 0;
        }

        function incompleteOrderRow(playerGroup) {
            return !playerGroup.locked && !playerGroup.templateId || playerGroup.playerQuantity === 0 || playerGroup.garmentQuantity === 0;
        }

        function completedOrderRow(playerGroup) {
            return playerGroup.locked && playerGroup.templateId;
        }

        function showOrderTable() {
            return !!(vm.user.orderReference || vm.user.orderProject);
        }
    }

    angular
        .module('stadium.start', [])
        .controller('StadiumStartController', StadiumStartController)
        .config(stateConfig);
})();

(function() {
    'use strict';

    // @ngInject
    stateConfig.$inject = ["$stateProvider"];
    userResolve.$inject = ["AuthService"];
    resolveTemplates.$inject = ["PlacementsApiService"];
    TemplateManagementController.$inject = ["$rootScope", "$state", "$modal", "$window", "$anchorScroll", "$location", "templates", "user", "AuthService", "ClubsApiService", "PlacementsApiService", "StadiumPlacementsApiService", "ConfirmDialogService", "TemplateDialogService"];
    function stateConfig($stateProvider) {
        $stateProvider.state('app.shop.templateManagement', {
            url: '/templateManagement',
            views: {
                'main-content': {
                    templateUrl: 'stadium/templateManagement/templateManagement.tpl.html',
                    controller: 'TemplateManagementController as vm'
                }
            },
            resolve: {
                templates: resolveTemplates,
                user: userResolve
            }
        });
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function resolveTemplates(PlacementsApiService) {
        return PlacementsApiService.getStadiumTemplates(null, null, false);
    }

    // @ngInject
    function TemplateManagementController($rootScope, $state, $modal, $window, $anchorScroll, $location, templates, user, AuthService, ClubsApiService,
                                          PlacementsApiService, StadiumPlacementsApiService, ConfirmDialogService, TemplateDialogService) {
        var vm = this;
        vm.clubs = [];
        vm.user = user;
        vm.templates = templates;
        vm.categories = [];
        vm.selectedClub = null;
        vm.selectedCategory = null;
        vm.selectedTemplate = null;

        vm.addNew = addNew;
        vm.addNewTemplate = addNewTemplate;
        vm.archiveCategory = archiveCategory;
        vm.archiveClub = archiveClub;
        vm.archiveTemplate = archiveTemplate;
        vm.openTemplate = openTemplate;
        vm.onSelectClub = onSelectClub;
        vm.onSelectCategory = onSelectCategory;
        vm.rename = rename;
        vm.setSelectedTemplate = setSelectedTemplate;
        vm.isActiveTemplate = isActiveTemplate;

        init();

        function init(id) {
            ClubsApiService.getClubs().then(function (allClubs){
                vm.clubs = allClubs;

                if(id) {
                    setSelectedClubById(id);
                } else {
                    initialize();
                }
            });
        }

        function initialize(selectedTemplate) {
            var templateId = selectedTemplate;
            if(!templateId) {
                templateId = user.templateId;
            }
            if(templateId) {
                StadiumPlacementsApiService.getPlacement(templateId).then(function (template) {
                    if(template && template.placementId) {
                        vm.selectedClub = _.find(vm.clubs, { 'clubId': template.club });
                        ClubsApiService.getCategories(template.club).then(function(categories) {
                            vm.categories = categories;
                            vm.selectedCategory = _.find(vm.categories, { 'categoryId': template.category });
                        });
                    }
                }).then(function () {
                    setSelectedTemplateById(templateId);
                });
            }
        }

        function onSelectClub(club) {
            ClubsApiService.getCategories(club.clubId).then(function(categories) {
                vm.categories = categories;
                vm.selectedClub = club;
                vm.selectedCategory = null;
                vm.selectedTemplate = null;
            });
        }

        function onSelectCategory(category) {
            vm.selectedCategory = category;
            vm.selectedTemplate = null;
        }

        function archiveClub() {
            if(vm.categories.length > 0) {
                showErrorDialog('CLUB');
            }
            else {
                var buttons = [{ name: 'BUTTON.NO', class: 'btn-default'}, { name: 'BUTTON.YES', class: 'btn-success'}];
                ConfirmDialogService.showDialog('STADIUM.CLUB.DELETETITLE', 'STADIUM.CLUB.DELETEQUESTION', buttons).then(function(button) {
                    if (button.name === 'BUTTON.YES') {
                        ClubsApiService.deleteClub(vm.selectedClub.clubId).then(function () {
                            refreshState('club');
                        });
                    }
                });
            }
        }

        function archiveCategory() {
            if(vm.templates.some(function(template) {
                return template.category === vm.selectedCategory.categoryId;
            })) {
                showErrorDialog('CATEGORY');
            }
            else {
                var buttons = [{ name: 'BUTTON.NO', class: 'btn-default'}, { name: 'BUTTON.YES', class: 'btn-success'}];
                ConfirmDialogService.showDialog('STADIUM.CATEGORY.DELETETITLE', 'STADIUM.CATEGORY.DELETEQUESTION', buttons).then(function(button) {
                    if (button.name === 'BUTTON.YES') {
                        ClubsApiService.deleteCategory(vm.selectedClub.clubId, vm.selectedCategory.categoryId).then(function () {
                            onSelectClub(vm.selectedClub);
                        });
                    }
                });
            }
        }

        function archiveTemplate() {
            var buttons = [{ name: 'BUTTON.NO', class: 'btn-default'}, { name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('STADIUM.TEMPLATE.DELETETITLE', 'STADIUM.TEMPLATE.DELETEQUESTION', buttons).then(function(button) {
                if (button.name === 'BUTTON.YES') {
                    PlacementsApiService.deletePlacement(vm.selectedTemplate.placementId).then(function () {
                        refreshState('template');
                    });
                }
            });
        }

        function setSelectedTemplate(template) {
            vm.selectedTemplate = template;
        }

        function addNew(mode) {
            var templatesDialog = {
                backdrop: 'static',
                controller: 'TemplateManagementDialogController as vm',
                templateUrl: 'stadium/templateManagement/templateManagementDialog.tpl.html',
                resolve: {
                    mode: function() { return mode; },
                    clubId: function() { return vm.selectedClub ? vm.selectedClub.clubId : null; },
                    categoryId: function() { return vm.selectedCategory ? vm.selectedCategory.categoryId : null; },
                    templateId: function() { return vm.selectedTemplate ? vm.selectedTemplate.placementId : null; },
                    oldName: function() { return null; }
                }
            };
            $modal.open(templatesDialog).result.then(function (id) {
                refreshState(mode, id);
            });
        }

        function addNewTemplate() {
            TemplateDialogService.showTemplateDialog(null, null, vm.selectedClub.clubId, vm.selectedCategory.categoryId, false, true)
                .then(function (template) {
                    $rootScope.$broadcast('$updateNotifications');
                    initialize(template.placementId);
                });
        }

        function refreshState (mode, id) {
            switch(mode) {
                case 'club':
                    init(id);
                    break;
                case 'category':
                    setSelectedCategoryById(id);
                    break;
                case 'template':
                    setSelectedTemplateById(id);
                    break;
                default:
                    $window.location.reload();
                    break;
            }
        }

        function setSelectedClubById(id) {
            vm.selectedClub = vm.clubs.find(function(club) {
                if(club.clubId === id) {
                    onSelectClub(club);
                }
            });
        }

        function setSelectedCategoryById(id) {
            ClubsApiService.getCategories(vm.selectedClub.clubId).then(function(categories) {
                vm.categories = categories;

                vm.categories.find(function(category) {
                    if(category.categoryId === id) {
                        onSelectCategory(category);
                    }
                });
            });
        }

        function setSelectedTemplateById(id) {
            PlacementsApiService.getStadiumTemplates(null, null, false).then(function(allPlacements){
                vm.templates = allPlacements;

                vm.selectedTemplate = vm.templates.find(function (tpl) {
                    return tpl.placementId === id;
                });
            }).then(function () {
                if(vm.selectedTemplate) {
                    $location.hash(vm.selectedTemplate.placementId);
                    $anchorScroll();
                }
            });
        }

        function rename(mode) {
            var renameDialog = {
                backdrop: 'static',
                controller: 'TemplateManagementDialogController as vm',
                templateUrl: 'stadium/templateManagement/templateManagementDialog.tpl.html',
                resolve: {
                    mode: function() { return 'rename-' + mode; },
                    clubId: function() { return vm.selectedClub ? vm.selectedClub.clubId : null; },
                    categoryId: function() { return vm.selectedCategory ? vm.selectedCategory.categoryId : null; },
                    templateId: function() { return vm.selectedTemplate ? vm.selectedTemplate.placementId : null; },
                    oldName: function() {
                        switch(mode) {
                            case 'club':
                                return vm.selectedClub.clubName;
                            case 'category':
                                return vm.selectedCategory.categoryName;
                            case 'template':
                                return vm.selectedTemplate.templateName;
                            default:
                                return null;
                        }
                    }
                }
            };
            $modal.open(renameDialog).result.then(function (id) {
                refreshState(mode, id);
            });
        }

        function showErrorDialog(errorMode) {
            var errorDialog = {
                backdrop: 'static',
                controller: 'TemplateManagementDialogController as vm',
                templateUrl: 'stadium/templateManagement/templateManagementDialog.tpl.html',
                resolve: {
                    mode: function() { return 'error-' + errorMode; },
                    clubId: function() { return vm.selectedClub ? vm.selectedClub.clubId : null; },
                    categoryId: function() { return vm.selectedCategory ? vm.selectedCategory.placementId : null; },
                    templateId: function() { return vm.selectedTemplate ? vm.selectedTemplate.placementId : null; },
                    oldName: function() { return null; }
                }
            };
            $modal.open(errorDialog);
        }

        function openTemplate(placementId) {
            PlacementsApiService.openTemplate(placementId).then(function () {
                $state.go('app.shop.advancedMounting', {id: placementId}, 'AdvancedMountingController');
            });
        }

        function isActiveTemplate(templateId) {
            return vm.user.templateId === templateId;
        }
    }

    angular
        .module('stadium.templateManagement', ['templateManagementDialog'])
        .controller('TemplateManagementController', TemplateManagementController)
        .config(stateConfig);
}());

(function() {

    'use strict';

    // @ngInject
    TemplateManagementDialogController.$inject = ["$q", "$modalInstance", "$filter", "$translate", "mode", "clubId", "categoryId", "templateId", "oldName", "ClubsApiService", "PlacementsApiService", "loadSpinnerService"];
    function TemplateManagementDialogController($q, $modalInstance, $filter, $translate, mode, clubId, categoryId, templateId, oldName, ClubsApiService, PlacementsApiService, loadSpinnerService) {
        /* jshint validthis: true */
        var vm = this;
        vm.name = null;
        vm.isErrorDialog = false;
        vm.isRenameDialog = false;
        vm.hasError = false;
        vm.clubId = clubId;
        vm.categoryId = categoryId;
        vm.templateId = templateId;
        vm.categories = [];
        vm.clubs = [];
        vm.templates = [];
        vm.oldName = oldName;
        vm.mode = mode;

        vm.save = save;
        vm.close = close;
        vm.rename = rename;
        vm.isUniqueName = isUniqueName;

        init();

        function init() {
            loadSpinnerService.start();
            switch(mode) {
                case 'club':
                    $translate('STADIUM.CLUB.NEW').then(function (translation) {
                        vm.title = translation;
                    });
                    break;
                case 'category':
                    $translate('STADIUM.CATEGORY.NEW').then(function (translation) {
                        vm.title = translation;
                    });
                    break;
                default:
                    setAlternativeContent();
                    break;
            }

            var calls = [];

            var clubCall = ClubsApiService.getAllClubs().then(function(clubs) {
                vm.clubs = clubs;
            });

            calls.push(clubCall);

            if(clubId) {
                var categoriesCall = ClubsApiService.getAllCategories(clubId).then(function(categories) {
                    vm.categories = categories;
                });

                calls.push(categoriesCall);
            }

            if(templateId) {
                var placementsCall = PlacementsApiService.getStadiumTemplates(null, null, null).then(function(templates) {
                    vm.templates = templates;
                });

                calls.push(placementsCall);
            }

            vm.name = vm.oldName;

            return $q.all(calls).then(loadSpinnerService.stop);
        }

        function setAlternativeContent() {
            if(vm.mode.includes('rename')) {
                vm.isRenameDialog = true;
                var renameMode = vm.mode.split('-');

                switch(renameMode[1]) {
                    case 'club':
                        $translate('STADIUM.CLUB.RENAME').then(function (translation) {
                            vm.title = translation;
                        });
                        break;
                    case 'category':
                        $translate('STADIUM.CATEGORY.RENAME').then(function (translation) {
                            vm.title = translation;
                        });
                        break;
                    case 'template':
                        $translate('STADIUM.TEMPLATE.RENAME').then(function (translation) {
                            vm.title = translation;
                        });
                        break;
                }
            }

            if(vm.mode.includes('error')) {
                vm.isErrorDialog = true;

                var errorMode = vm.mode.split('-');
                $translate('STADIUM.ERROR.DELETE' + errorMode[1]).then(function(translation) {
                    vm.error = translation;
                });

                $translate('STADIUM.ERROR.TITLE').then(function(translation) {
                    vm.title = translation;
                });
            }
        }

        function rename() {
            if(vm.mode.includes('club')) {
                ClubsApiService.renameClub(vm.clubId, vm.name).then(function() {
                    $modalInstance.close(vm.clubId);
                }, function(error) {
                    if(error && error.data) {
                        vm.error = error.data.message;
                        vm.hasError = true;
                    }
                });
            }
            if(vm.mode.includes('category')) {
                ClubsApiService.renameCategory(vm.clubId, vm.categoryId, vm.name).then(function() {
                    $modalInstance.close(vm.categoryId);
                }, function(error) {
                    if(error && error.data) {
                        vm.error = error.data.message;
                        vm.hasError = true;
                    }
                });
            }
            if(vm.mode.includes('template')) {
                PlacementsApiService.getPlacement(vm.templateId).then(function(placement) {
                    var data = {
                        templateName: vm.name,
                        description: placement.description,
                        perspectives: placement.perspectives,
                        garment: placement.garment,
                        colour: placement.colour,
                        playerListId: placement.playerListId,
                        club: placement.club,
                        category: placement.category,
                        stadiumTemplate: placement.stadiumTemplate,
                        articleList: placement.articleList,
                        digitList: placement.digitList,
                        logoList: placement.logoList,
                        stadiumLegacyNotHandled: placement.stadiumLegacyNotHandled
                    };
                    PlacementsApiService.updatePlacement(data, vm.templateId).then(function() {
                        $modalInstance.close(vm.templateId);
                    }, function(error) {
                        if(error && error.data) {
                            vm.error = error.data.message;
                            vm.hasError = true;
                        }
                    });
                }, function(error) {
                    if(error && error.data) {
                        vm.error = error.data.message;
                        vm.hasError = true;
                    }
                });
            }
        }

        function save() {
            if(vm.mode === 'club') {
                ClubsApiService.createClub(vm.name).then(function(club) {
                    $modalInstance.close(club.clubId);
                }, function(error) {
                    if(error && error.data) {
                        vm.error = error.data.message;
                        vm.hasError = true;
                    }
                });
            }

            if(vm.mode === 'category') {
                ClubsApiService.createCategory(vm.clubId, vm.name).then(function(category) {
                    $modalInstance.close(category.categoryId);
                }, function (error) {
                    if(error && error.data) {
                        vm.error = error.data.message;
                        vm.hasError = true;
                    }
                });
            }
        }

        function close() {
            $modalInstance.dismiss();
        }

        function isUniqueName() {
            if(mode.includes('club')) {
                vm.hasError = vm.clubs.some(function (club) {
                    return club.clubName === vm.name;
                });

                if(vm.hasError) {
                    $translate('STADIUM.TEMPLATE.ERROR.CLUB.NAMEEXISTS').then(function(translation) {
                        vm.error = translation;
                    });
                }
            }

            if(mode.includes('category')) {
                vm.hasError = vm.categories.some(function (category) {
                    return category.categoryName === vm.name;
                });

                if(vm.hasError) {
                    $translate('STADIUM.TEMPLATE.ERROR.CATEGORY.NAMEEXISTS').then(function(translation) {
                        vm.error = translation;
                    });
                }
            }

            if(mode.includes('template')) {
                vm.hasError = vm.templates.some(function (template) {
                    return template.templateName === vm.name;
                });

                if(vm.hasError) {
                    $translate('STADIUM.TEMPLATE.ERROR.TEMPLATE.NAMEEXISTS').then(function(translation) {
                        vm.error = translation;
                    });
                }
            }
        }
    }

    angular
        .module('templateManagementDialog', [])
        .controller('TemplateManagementDialogController', TemplateManagementDialogController);
})();

(function() {

    'use strict';

    // @ngInject
    AddToCartButtonController.$inject = ["$scope", "CartApiService", "ValidationManager"];
    function addToCartButton(){
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                article: '=',
                buttonClass: '@',
                disabled:'=ngDisabled'
            },
            templateUrl: 'directives/addToCartButton/addToCartButton.tpl.html',
            controller: 'AddToCartButtonController',
            controllerAs: 'vm'
        };
    }

    // @ngInject
    function AddToCartButtonController($scope, CartApiService, ValidationManager){
        var vm = this;
        vm.article = $scope.article;
        vm.disabled = $scope.disabled;
        vm.buttonClass = $scope.buttonClass;

        vm.addToCart = addToCart;
        vm.isLoading = false;
        vm.isInCart = isInCart;
        vm.cartQty = cartQty;

        function addToCart(article){
            vm.isLoading = true;

            if (article.setManufacturingQuantity) {
                article.manufacturingQuantity = article.quantity;
            }

            CartApiService.newCartRows([{id: article.id, quantity: article.quantity.toString(), draft: article.draft, manufacturingQuantity: article.manufacturingQuantity}])
                .catch(function (error) {
                    if (error) {
                        ValidationManager.handleResponseError(error);
                        throw error;
                    }
                })
                .finally(function(){
                    vm.isLoading = false;
                });
        }

        function isInCart(id){
            return CartApiService.articleInCart(id);
        }

        function cartQty(id){
            var cartRow = CartApiService.getCartRow(id);
            if(cartRow){
                return cartRow.quantity;
            }else{
                return 0;
            }

        }
    }

    angular
        .module( 'addToCartButton', [])
        .directive('addToCartButton', addToCartButton)
        .controller('AddToCartButtonController',AddToCartButtonController);
})();
(function () {

  'use strict';

  AddToTemplateButtonController.$inject = ["$scope", "PlacementsApiService"];
  function addToTemplateButton() {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        buttonClass: '@',
        disabled: '=ngDisabled',
        article: '=',
        digit: '=',
        smallDigit: '=',
        largeDigit: '=',
        template: '=',
      },
      templateUrl: 'directives/addToTemplateButton/addToTemplateButton.tpl.html',
      controller: 'AddToTemplateButtonController',
      controllerAs: 'vm',
    };
  }

  function AddToTemplateButtonController($scope, PlacementsApiService) {
    var vm = this;
    vm.article = $scope.article;
    vm.digit = $scope.digit;
    vm.smallDigit = $scope.smallDigit;
    vm.largeDigit = $scope.largeDigit;
    vm.template = $scope.template;

    vm.disabled = $scope.disabled;
    vm.buttonClass = $scope.buttonClass;
    vm.isLoading = false;
    vm.isOnTemplate = false;

    vm.addToTemplate = addToTemplate;

    isOnTemplate();

    function addToTemplate() {
      vm.isLoading = true;

      vm.digit = vm.smallDigit != null ? vm.smallDigit : vm.digit;
      vm.digit = vm.largeDigit != null ? vm.largeDigit : vm.digit;

      var data = {
        articleList: vm.article != null ? [vm.article] : [],
        digitList: vm.digit != null ? [vm.digit] : []
      };

      PlacementsApiService.addItemsToTemplate(vm.template.placementId, data)
        .finally(function () {
          vm.isOnTemplate = true;
          vm.isLoading = false;
        });
    }

    function isOnTemplate() {
      vm.isOnTemplate = false;

      if (vm.template == null) {
        return;
      }

      if (vm.article != null && vm.template.articleList != null) {
        vm.isOnTemplate = vm.template.articleList.includes(vm.article);
        return;
      }

      vm.digit = vm.smallDigit != null ? vm.smallDigit : vm.digit;
      vm.digit = vm.largeDigit != null ? vm.largeDigit : vm.digit;

      if (vm.digit != null && vm.template.digitList != null) {
        vm.isOnTemplate = vm.template.digitList.includes(vm.digit);
        return;
      }
    }
  }

  angular
    .module('addToTemplateButton', [])
    .directive('addToTemplateButton', addToTemplateButton)
    .controller('AddToTemplateButtonController', AddToTemplateButtonController);
})();
(function() {

    'use strict';

    // @ngInject
    AdminInputController.$inject = ["$scope", "$element", "$attrs", "$timeout"];
    function adminInput() {
        return {
            restrict: 'A',
            scope: {
                item: '='
            },
            templateUrl: 'directives/adminInput/adminInput.tpl.html',
            controller: 'adminInputController',
            controllerAs: 'vm'
        };
    }

    // @ngInject
    function AdminInputController($scope, $element, $attrs, $timeout) {
        var REGEX_VALID_PRICE = /^\d{0,4},?\d{0,2}$/;
        var REGEX_VALID_DISCOUNT = /^\d{0,3}$/;
        var REGEX_WHITESPACE = /\s+/g;

        var vm = this;
        vm.value = null;
        vm.item = $scope.item;
        vm.isPrice = isInputType('price');
        vm.isDiscount = isInputType('discount');
        vm.hasAdminValue = hasAdminValue;
        vm.isInvalid = isInvalid;
        vm.resetAdminValue = resetAdminValue;
        vm.initialised = false;

        initialise();

        function initialise() {
            if (vm.isPrice) {
                vm.value = vm.item.adminPrice || vm.item.unitPrice;
                vm.value = getNormalisedValue(vm.value);
                vm.changedValue = changedPriceValue;
            }
            if (vm.isDiscount) {
                vm.value = vm.item.adminDiscount || vm.item.unitDiscount;
                vm.changedValue = changedDiscountValue;
            }
        }

        function isInputType(inputType) {
            return inputType === $attrs.adminInput;
        }

        function getNormalisedValue(value) {
            return value.replace(REGEX_WHITESPACE, "").replace(".", ",");
        }

        function hasAdminValue() {
            if (vm.isPrice) {
                return vm.item.adminPrice && vm.item.adminPrice.length > 0;
            }
            if (vm.isDiscount) {
                return vm.item.adminDiscount && vm.item.adminDiscount.length > 0;
            }
        }

        function isInvalid() {
            return vm.isPrice && !vm.value;
        }

        function resetAdminValue() {
            if (vm.isPrice) {
                vm.item.adminPrice = "";
            }
            if (vm.isDiscount) {
                vm.item.adminDiscount = "";
            }
            initialise();
        }

        function changedPriceValue() {
            checkForMissingValue();
            if (vm.value === getNormalisedValue(vm.item.unitPrice)) {
                resetAdminValue();
            } else {
                if (REGEX_VALID_PRICE.test(vm.value)) {
                    vm.item.adminPrice = vm.value.replace(",", ".");
                } else {
                    initialise();
                }
            }
        }

        function changedDiscountValue() {
            if (vm.value === vm.item.unitDiscount) {
                resetAdminValue();
            } else {
                if (REGEX_VALID_DISCOUNT.test(vm.value) && parseInt(vm.value) < 101) {
                    vm.item.adminDiscount = parseInt(vm.value) + '';
                } else {
                    initialise();
                }
            }
        }

        function checkForMissingValue() {
            if (!vm.value) {
                $timeout(function(){
                    $element.find('input').triggerHandler('closeTrigger');
                });
            }
        }
    }

    angular
        .module( 'adminInput', [])
        .directive('adminInput', adminInput)
        .controller('adminInputController', AdminInputController);
})();
(function () {

  'use strict';

  // @ngInject
  breadcrumbs.$inject = ["$state"];
  function breadcrumbs($state) {
    return {
      templateUrl: 'directives/breadcrumbs/breadcrumbs.tpl.html',
      restrict: 'EA',
      replace: true,
      scope: {
        links: '=',
      },
      link: function ($scope) {
        $scope.goBack = function goBack(state) {
          var to = state.to;
          var params = state.params || {};
          var options = state.options || {};

          $state.go(to, params, options);
        };
      },
    };
  }

  angular
    .module('breadcrumbs', [])
    .directive('breadcrumbs', breadcrumbs);
})();
(function() {

    'use strict';

    // @ngInject
    CalculatorPriceTableController.$inject = ["$scope"];
    function calculatorPriceTable(){
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                prices: '=',
                currentQty: '='
            },
            templateUrl: 'directives/calculatorPriceTable/calculatorPriceTable.tpl.html',
            controller: 'CalculatorPriceTableController',
            controllerAs: 'vm'
        };
    }

    // @ngInject
    function CalculatorPriceTableController($scope){
        var vm = this;

        vm.priceTable = [];
        vm.isActiveQty = isActiveQty;

        function isActiveQty(count){
            if(!$scope.currentQty) {
                return false;
            }

            var currentQty;

            currentQty = $scope.currentQty;

            var index = _.findIndex(vm.priceTable, { key: count });

            if(currentQty < count){
                return index === 0;
            }

            return !(index + 1 in vm.priceTable && currentQty >= vm.priceTable[index + 1].key);
        }

        function getPriceTable(prices){
            var priceTable = [];
            var priceCounts = Object.keys(prices);

            _.forEach(priceCounts,function(priceCount){
                var newPrice = {key:parseInt(priceCount,10),value:prices[priceCount]};
                priceTable.push(newPrice);
            });

            return priceTable;
        }

        $scope.$watch('prices',function(){
            vm.priceTable = getPriceTable($scope.prices);
        });

    }

    angular
        .module('app')
        .directive('calculatorPriceTable', calculatorPriceTable)
        .controller('CalculatorPriceTableController', CalculatorPriceTableController);
})();
(function() {

    'use strict';

    // @ngInject
    confirmOrderButton.$inject = ["$timeout"];
    function confirmOrderButton($timeout){
        return {
            restrict: 'EA',
            replace: true,
            scope: { text: '@', title: '@', isEnabled: '=', action: '&', showWarningTooltip: '=' },
            template: '<button class="btn btn-success" ng-disabled="!isEnabled" ng-click="action()"><span manualtooltip="{{text}}" manualtooltip-placement="bottom">{{title}}</span></button>',
            link: function(scope, element, attributes) {

                var tooltip = element.find('span');
                var button = element.context;
                var transparent = window.getComputedStyle(button)
                                    .backgroundColor
                                    .replace('(', 'a(')         // Use rgba color for transparency instead of opacity
                                    .replace(')', ', 0.65)');   // 0.65 is the same value used by opacity, resulting in the same color.

                scope.$watch(
                    function() { return scope.showWarningTooltip; },
                    function(newValue, oldValue) {
                        if (oldValue !== newValue) {
                            if (newValue === true) {
                                // Since opacity forces all child elements to be transparent,
                                // a transparent backgroundColor is used keep the original tooltip colors.
                                button.style.opacity = 1;
                                button.style.backgroundColor = transparent;
                                $timeout(function() {
                                    tooltip.triggerHandler('openTrigger');
                                });
                            } else {
                                button.style.backgroundColor = '';
                                $timeout(function() {
                                    tooltip.triggerHandler('closeTrigger');
                                });
                            }
                        }
                    }
                );


            }
        };
    }

    angular
        .module( 'confirmOrderButton', [])
        .directive('confirmOrderButton', confirmOrderButton);
})();

(function() {

    'use strict';

    // @ngInject
    counter.$inject = ["$timeout"];
    function counter($timeout){
        return {
            restrict: 'EA',
            scope: {
                value: '=',
                isSmall:"@",
                min: '=',
                max: '=',
                disabled: '=?'
            },
            template:
                '<div class="input-group counter" ng-class="{\'counter-small\': isSmall}" >'+
                '<div class="input-group-btn">'+
                '<button type="button" class="btn btn-default" ng-class="{\'btn-sm\': isSmall}" ng-click="minus()" ng-disabled="disabled"><i class="fa fa-minus"></i></button>'+
                '</div>'+
                '<input type="text" ng-disabled="disabled" class="form-control counter-field" ng-class="{invalid: !isValid}" manualtooltip="{{\'LABEL.MINIMUMNUMBER\' | translate}} {{$parent.min}}" ng-model="$parent.value" ng-change="changed()">'+
                '<div class="input-group-btn">'+
                '<button type="button" class="btn btn-default" ng-class="{\'btn-sm\': isSmall}" ng-click="plus()" ng-disabled="disabled"><i class="fa fa-plus"></i></button>'+
                '</div>'+
                '</div>',
            link: function( scope , element , attributes ) {


                // Make sure the value attribute is not missing.
                if ( angular.isUndefined(scope.value) ) {
                    throw "Missing the value attribute on the counter directive.";
                }

                var max = angular.isUndefined(attributes.max) ? 999999999999999 : parseInt(attributes.max,10);
                var step = angular.isUndefined(attributes.step) ? 1 : parseInt(attributes.step,10);
                var currentValue;
                var timer;

                scope.disabled = scope.disabled || false;
                scope.isValid = true;
                scope.isSmall = scope.small || false;
                element.addClass('counter-container');

                var setValue = function( val ) {
                    currentValue = val;
                    scope.value = parseInt(val,10);
                    validate();
                };

                var setMin = function( val ) {
                    scope.min = parseInt(val,10);
                    validate();
                };

                // Set the value initially, as an integer
                setValue( scope.value );
                setMin( scope.min );
                validate();

                /**
                 * Decrement the value and make sure we stay within the limits, if defined.
                 */
                scope.minus = function() {

                    var min = parseInt( scope.min, 10);
                    if (0 !== scope.value && !scope.value) {
                        setValue( min );
                        return false;
                    }

                    var value = parseInt( scope.value, 10);
                    if ( min && (value <= min || value - step <= min) || min === 0 && value < 1 ) {
                        setValue( min );
                        return false;
                    }
                    setValue( value - step );
                };

                /**
                 * Increment the value and make sure we stay within the limits, if defined.
                 */
                scope.plus = function() {

                    var min = parseInt( scope.min, 10);
                    if (0 !== scope.value && !scope.value) {
                        setValue( min );
                        return false;
                    }

                    var value = parseInt( scope.value, 10);
                    if ( max && (value + step > max) ) {
                        setValue( max );
                        return false;
                    }

                    if ( min && (value + step < min) ) {
                        setValue( min );
                        return false;
                    }

                    setValue( value + step );
                };

                /**
                 * This is only triggered when the field is manually edited by the user.
                 * Where we can perform some validation and make sure that they enter the
                 * correct values from within the restrictions.
                 */
                scope.changed = function() {
                    // If the user decides to delete the number
                    if ( !scope.value ) { validate(); return; }

                    // Check if what's typed is numeric or if it has any letters.
                    if ( /^[0-9]*$/.test(scope.value) ) {
                        setValue( parseInt( scope.value, 10));
                    }
                    else {
                        setValue(currentValue);
                    }
                };

                function validate(){
                    if (0 !== scope.value && !scope.value) {
                        setValid(false);
                        return;
                    }
                    var value = parseInt(scope.value, 10);
                    var min = parseInt(scope.min, 10);
                    var max = parseInt(scope.max, 10);

                    // If a minimum is set, let's make sure we're within the limit.
                    if (min && (value < min) ) {
                        setValid(false);
                        return;
                    }
                    // If a maximum is set, let's make sure we're within the limit.
                    if (max && (value > max)) {
                        setValue(max);
                        return;
                    }
                    setValid(true);
                }

                function setValid(val){
                    if(val && !scope.isValid){
                        scope.isValid = true;
                        $timeout(function(){
                            element.find('input').triggerHandler('closeTrigger');
                        });
                        $timeout.cancel(timer);
                    }else if(!val && scope.isValid === true){
                        scope.isValid = false;
                        timer = $timeout(function(){
                            element.find('input').triggerHandler('openTrigger');
                        }, 1000);
                    }

                }

                scope.$watch(function() {return scope.min;}, function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        validate();
                    }
                });
                scope.$watch(function() {return scope.max;}, function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        validate();
                    }
                });
                scope.$watch(function() {return scope.value;}, function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        validate();
                    }
                });
            }
        };
    }

    angular
        .module( 'counter', [])
        .directive('counter', counter);
})();

angular.module('filters', ['filters.translationFilter']);


translationFilter.$inject = ["$translate"];angular.module('filters.translationFilter', []).filter('translationFilter', translationFilter);

function translationFilter($translate) {
    function filter(input, searchParam, translationPrefix, property) {
        if (!searchParam) {
            return input;
        }

        var result = [];
        var searchVal = searchParam.toLowerCase();
        angular.forEach(input, function (value) {
            var translated = '';
            if (property) {
                translated = $translate.instant(translationPrefix + value[property]);
            } else {
                translated = $translate.instant(translationPrefix + value);
            }

            if (translated.toLowerCase().indexOf(searchVal) !== -1) {
                result.push(value);
            }
        });

        return result;
    }

    // disable stateful
    filter.$stateful = false;

    return filter;
}

(function() {

    'use strict';

    // @ngInject
    function focus(){
        return {
            restrict: 'EA',
            link: function( $scope , elem ) {
                elem.bind('keydown', function(e) {
                    var code = e.keyCode || e.which;
                    if (code === 13) {
                        e.preventDefault();
                    }
                });
            }
        };
    }

    angular
        .module( 'focus', [])
        .directive('focus', focus);
})();
(function() {

    'use strict';

    // @ngInject
    loadSpinnerService.$inject = ["$rootScope"];
    loadSpinner.$inject = ["usSpinnerService", "$rootScope"];
    function loadSpinnerService($rootScope){
        var service = {
            start: start,
            stop: stop
        };
        return service;

        function start(){
            $rootScope.$emit('loadSpinner-start');
        }

        function stop(){
            $rootScope.$emit('loadSpinner-stop');
        }
    }

    // @ngInject
    function loadSpinner(usSpinnerService,$rootScope){
        return {
            templateUrl: 'directives/loadSpinner/loadSpinner.tpl.html',
            restrict: 'EA',
            replace: true,
            scope: { spinnerName:'@'},
            link: function($scope) {
                $scope.loaders = 0;

                $rootScope.$on('loadSpinner-start', function (event, data) {
                    if($scope.loaders === 0){
                        usSpinnerService.spin($scope.spinnerName);
                        $scope.isLoading = true;
                    }
                    $scope.loaders++;
                });

                $rootScope.$on('loadSpinner-stop', function (event, data) {
                    $scope.loaders--;

                    if($scope.loaders === 0){
                        usSpinnerService.stop($scope.spinnerName);
                        $scope.isLoading = false;
                    }
                });
            }
        };
    }

    angular
        .module( 'loadSpinner', [])
        .service( 'loadSpinnerService', loadSpinnerService)
        .directive('loadSpinner', loadSpinner);
})();
(function() {
    'use strict';

    // @ngInject
    manualtooltip.$inject = ["$tooltip"];
    function manualtooltip($tooltip) {
        return $tooltip('manualtooltip', 'manualtooltip', 'openTrigger');
    }

    // @ngInject
    function manualtooltipPopup() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { title: '@', content: '@', placement: '@', animation: '&', isOpen: '&' },
            templateUrl: 'template/tooltip/tooltip-popup.html',
            link: function($scope, element) {
                var tooltip = element.context;
                var anchor;
                $(window).resize(_.debounce(function() {
                    // HACK: Reposition visible tooltips when screen size changes.
                    if ($scope.isOpen() && tooltip.previousElementSibling) {
                        if (!anchor) {
                            anchor = $(tooltip.previousElementSibling);
                        }
                        anchor.triggerHandler('closeTrigger');
                        anchor.triggerHandler('openTrigger');
                    }
                }, 50));
            }
        };
    }

    angular
        .module( 'manualtooltip', ['ui.bootstrap'])
        .directive('manualtooltipPopup',manualtooltipPopup)
        .directive('manualtooltip', manualtooltip);
})();

(function() {

    'use strict';

    // @ngInject
    modalWindow.$inject = ["$document"];
    function modalWindow($document) {
        return function (scope, element) {
            var startX = 0,
                startY = 0,
                x = 0,
                y = 0;
            element = angular.element(document.getElementsByClassName("modal-dialog"));
            element.on('mousedown', function (event) {
                if (event.target.className === 'modal-title') {
                    startX = event.screenX - x;
                    startY = event.screenY - y;
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                }
            });

            function mousemove(event) {
                y = event.screenY - startY;
                x = event.screenX - startX;
                element.css({
                    top: y + 'px',
                    left: x + 'px'
                });
            }

            function mouseup() {
                $document.unbind('mousemove', mousemove);
                $document.unbind('mouseup', mouseup);
            }
        };
    }

    angular
        .module('modalWindow', [])
        .directive('modalWindow', modalWindow);
})();
(function () {

    'use strict';

    NamePreviewController.$inject = ["$scope", "$translate"];
    function namePreview() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                players: '=',
                font: '=',
                textColour: '=',
                backgroundColour: '=',
                activePlayerListTypes: '=',
                case: '='
            },
            bindToController: true,
            templateUrl: 'directives/namePreview/namePreview.tpl.html',
            controller: 'NamePreviewController as vm'
        };
    }

    // @ngInject
    function NamePreviewController($scope, $translate) {
        var vm = this;
        vm.showPlayerItem = showPlayerItem;
        vm.getBestPlayersToPreview = getBestPlayersToPreview;
        vm.getPreview = getPreview;

        var maxPlayers = 5;
        var relevantPlayerProperties = ['name', 'initials', 'number', 'smallNumber'];
        var caseTypes = {
            SENTENCE_CASE: 'capitalize',
            UPPERCASE: 'uppercase',
            LOWERCASE: 'lowercase',
            AS_WRITTEN: ''
        };

        function getBestPlayersToPreview() {
            return vm.players.reduce(function (selected, player) {
                if (selected.length < maxPlayers) {
                    return selected.concat(player);
                }
                return keepPlayerIfMoreRelevantProperties(player, selected);
            }, []);
        }

        function keepPlayerIfMoreRelevantProperties(player, selected) {
            var indexToReplace = _.findIndex(selected, function (selectedPlayer) {
                return countRelevantProperties(player) > countRelevantProperties(selectedPlayer);
            });

            if (indexToReplace > -1) {
                selected.splice(indexToReplace, 1, player);
            }
            return selected;
        }

        function countRelevantProperties(player) {
            return Object.keys(player)
                .reduce(function (count, prop) {
                    return relevantPlayerProperties.includes(prop) && player[prop] ? ++count : count;
                }, 0);
        }

        function getPreview() {
            return {
                'background-color': vm.backgroundColour[0] ? hex(vm.backgroundColour[0].code) : '',
                'color': vm.textColour[0] ? hex(vm.textColour[0].code) : '',
                'font-family': vm.font[0] ? $translate.instant('NAME.FONTTYPE.' + vm.font[0]) : '',
                'text-transform': vm.case ? caseTypes[vm.case] : ''
            };
        }

        function showPlayerItem(type, item) {
            return _.some(vm.activePlayerListTypes, function (playerListType) {
                return playerListType.name === type && playerListType.active && item !== '';
            });
        }

        function hex(color) {
            return '#' + color;
        }
    }

    angular
        .module('namePreview', [])
        .directive('namePreview', namePreview)
        .controller('NamePreviewController', NamePreviewController);

})();

(function(){

    "use strict";

    // @ngInject
    function onImageLoad(){
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.bind('load', function() {
                    scope.$apply(attrs.onImageLoad)(element.context, true);
                });
                element.bind('error', function(){
                    scope.$apply(attrs.onImageLoad)(element.context, false);
                });
            }
        };
    }

    angular
        .module('onImageLoad', [])
        .directive('onImageLoad', onImageLoad);
})();

(function() {

    'use strict';

    // @ngInject
    PriceTableController.$inject = ["$scope", "PriceApiService"];
    function priceTable(){
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                articleId: '=',
                user: '=',
                currentQty: '='
            },
            templateUrl: 'directives/priceTable/priceTable.tpl.html',
            controller: 'PriceTableController',
            controllerAs: 'vm'
        };
    }

    // @ngInject
    function PriceTableController($scope, PriceApiService){
        var vm = this;

        vm.priceTable = [];
        vm.lastUpdate = null;
        vm.user = $scope.user;
        vm.isActiveQty = isActiveQty;
        vm.onClickUpdate = onClickUpdate;
        getPrice();

        function onClickUpdate() {
            updatePrice();
        }

        function getPrice() {
            PriceApiService.getPrice($scope.articleId).then(function(price) {
                vm.priceTable = getPriceTable(price.prices);
                vm.lastUpdate = price.lastUpdate;
            });
        }

        function updatePrice() {
            PriceApiService.updatePrice($scope.articleId).then(function(price) {
                vm.priceTable = getPriceTable(price.prices);
                vm.lastUpdate = price.lastUpdate;
            });
        }

        function isActiveQty(count){
            if(!$scope.currentQty) {
                return false;
            }

            var currentQty;

            currentQty = $scope.currentQty;

            var index = _.findIndex(vm.priceTable, { key: count });

            if(currentQty < count){
                return index === 0;
            }

            return !(index + 1 in vm.priceTable && currentQty >= vm.priceTable[index + 1].key);
        }

        function getPriceTable(prices){
            var priceTable = [];
            var priceCounts = Object.keys(prices);

            _.forEach(priceCounts,function(priceCount){
                var newPrice = {key:parseInt(priceCount,10),value:prices[priceCount]};
                priceTable.push(newPrice);
            });

            return priceTable;
        }
    }

    angular
        .module('app')
        .directive('priceTable', priceTable)
        .controller('PriceTableController',PriceTableController);
})();
(function(){

    "use strict";

    // @ngInject
    singleClick.$inject = ["$timeout"];
    function singleClick($timeout){
        return {
            restrict: 'A',
            link: function(scope, element, attrs){
                var clicks = 0;
                var delay = 800;
                var timer = null;

                element.on('click', function (event) {
                    clicks = clicks + 1;
                    if(clicks === 1) {
                        scope.$apply(function () {
                            scope.$eval(attrs.singleClick);
                        });
                        timer = $timeout(function() {
                            clicks = 0;
                        }, delay);
                    } else {
                        $timeout.cancel(timer);
                        clicks = 0;
                    }
                });
            }
        };
    }
    angular
        .module('singleClick', [])
        .directive('singleClick', singleClick);
})();
(function() {

    'use strict';

    // @ngInject
    StockTableController.$inject = ["$scope", "StockApiService"];
    function stockTable(){
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                articleId: '='
            },
            templateUrl: 'directives/stockTable/stockTable.tpl.html',
            controller: 'StockTableController',
            controllerAs: 'vm'
        };
    }

    // @ngInject
    function StockTableController($scope, StockApiService) {
        var vm = this;
        vm.onClickUpdate = onClickUpdate;
        vm.isEmpty = false;
        getStock();

        function onClickUpdate() {
            getStock(true);
        }

        function getStock(update) {
            StockApiService.getStock($scope.articleId, update).then(function(stock) {
                vm.stock = stock;
                vm.isEmpty = _.isEmpty(vm.stock.quantityPerLocation);
            });
        }
    }

    angular
        .module('app')
        .directive('stockTable', stockTable)
        .controller('StockTableController', StockTableController);
})();
(function(){

    "use strict";

    // @ngInject
    function uiSelect(){
        return {
            restrict: 'EA',
            require: 'uiSelect',
            link: function($scope, $element, $attributes, ctrl) {
                $scope.$select.getPlaceholder = function(){return $scope.$select.placeholder;};
            }
        };
    }
    angular
        .module('uiSelectExtension', [])
        .directive('uiSelect', uiSelect);
})();
(function() {

    'use strict';

    // @ngInject
    updateCartButton.$inject = ["$timeout"];
    function updateCartButton($timeout){
        return {
            restrict: 'EA',
            replace: true,
            scope: { text: '@', title: '@', isEnabled: '=', action: '&' },
            template: '<button class="btn btn-default" ng-disabled="!isEnabled" ng-click="action()"><span manualtooltip="{{text}}" manualtooltip-placement="bottom">{{title}}</span></button>',
            link: function(scope, element, attributes) {

                var tooltip = element.find('span');

                scope.$watch(
                    function() { return scope.isEnabled; },
                    function(newValue, oldValue) {
                        if (oldValue !== newValue) {
                            if (newValue === true) {
                                $timeout(function() {
                                    tooltip.triggerHandler('openTrigger');
                                });
                            } else {
                                $timeout(function() {
                                    tooltip.triggerHandler('closeTrigger');
                                });
                            }
                        }
                    }
                );
            }
        };
    }

    angular
        .module( 'updateCartButton', [])
        .directive('updateCartButton', updateCartButton);
})();

(function () {

    'use strict';

    // @ngInject
    userBox.$inject = ["$rootScope", "$state", "$translate", "$cookies", "CartApiService", "AuthService", "UsersApiService", "CustomerPickerDialogService", "SavedCartDialogService", "TranslationsApiService", "PlacementsApiService", "ValidationManager"];
    function userBox(
        $rootScope,
        $state,
        $translate,
        $cookies,
        CartApiService,
        AuthService,
        UsersApiService,
        CustomerPickerDialogService,
        SavedCartDialogService,
        TranslationsApiService,
        PlacementsApiService,
        ValidationManager
    ) {
        var scope;
        return {
            templateUrl: 'directives/userBox/userBox.tpl.html',
            restrict: 'EA',
            replace: true,
            scope: true,
            link: function ($scope) {
                scope = $scope;
                $scope.user = {};
                $scope.isAdminOrderEnabled = isAdminOrderEnabled;
                $scope.isCustomerChosen = isCustomerChosen;
                $scope.isIncomingOrderCount = isIncomingOrderCount;
                $scope.isIncomingOrderCountB2B = isIncomingOrderCountB2B;
                $scope.isIncomingOrderCountB2C = isIncomingOrderCountB2C;
                $scope.isShortageCount = isShortageCount;
                $scope.isStadium = isStadium;
                $scope.isStadiumCartSelected = isStadiumCartSelected;
                $scope.logOut = AuthService.logOut;
                $scope.openCustomerPicker = showDialog;
                $scope.openSavedCartDialog = showSavedCartDialog;
                $scope.selectLanguage = selectLanguage;
                $scope.hasTemplateActive = hasTemplateActive;
                $scope.openTemplate = openTemplate;
                $scope.closeTemplate = closeTemplate;
                $scope.closeCart = closeCart;

                TranslationsApiService
                    .getLanguages()
                    .then(function (languages) {
                        $scope.availableLanguages = languages;
                    })
                    .then(getUser)
                    .then(setDefaultLanguage);
                $scope.$on('$updateNotifications', function () {
                    getUser($scope);
                });
                $scope.$on('$updateNotificationsClearOrderRecipient', function () {
                    getUser($scope);
                    $scope.user.orderRecipient = null;
                });

                // Only close language selection menu when 1. user selects a new language or 2. clicks outside.
                $(document).on('click', '.user-menu-language .dropdown-menu', function (event) {
                    event.stopPropagation();
                });

                getUser();
            }
        };

        function closeCart() {
            if (!isStadiumCartSelected()) {
                return;
            }

            CartApiService.closeCart()
                .then(function () {
                    $state.reload();
                });
        }

        function getUser() {
            return UsersApiService
                .getSelf()
                .then(function (user) {
                    scope.user = user;
                });
        }

        function setDefaultLanguage() {
            scope.selectedLanguage = _.find(scope.availableLanguages, {code: scope.user.languageCode});
            if ($cookies['user-language']) {
                var customLanguage = JSON.parse($cookies['user-language']);

                if (customLanguage && customLanguage.code && customLanguage.name) {
                    scope.selectedLanguage = customLanguage;
                }
            }

            if (scope.selectedLanguage) {
                $translate.use(scope.selectedLanguage.code);
            } else {
                $translate.use('en');
            }
        }

        function isCustomerChosen() {
            return scope.user.admin && scope.user.orderRecipient;
        }

        function selectLanguage(language) {
            scope.selectedLanguage = language;
            $translate.use(language.code);
            $cookies['user-language'] = JSON.stringify(language);
        }

        function isAdminOrderEnabled() {
            var result = scope.user.admin && scope.user.adminCarts && scope.user.adminCarts.length > 0;
            if (result && scope.user.adminCarts.length === 1 && scope.user.orderRecipient) {
                var adminCart = scope.user.adminCarts[0];
                var orderRecipient = scope.user.orderRecipient;
                result = result && (adminCart.userId !== orderRecipient.userId || adminCart.customerId !== orderRecipient.customerId);
            }
            return result;
        }

        function showDialog() {
            CustomerPickerDialogService.showDialog().then(function (data) {
                scope.user.orderRecipient = {
                    customerId: data.customer.id,
                    customerName: data.customer.name,
                    userId: data.employee.id,
                    userName: data.employee.name
                };
                UsersApiService.updateSelf(scope.user).then(function (user) {
                    CartApiService.getCartRows();
                    scope.user = user;
                    $state.go('app.shop.customer');
                    $rootScope.$broadcast('$orderRecipientChange');
                });
            });
        }

        function showSavedCartDialog() {
            SavedCartDialogService.showDialog().then(function () {
                UsersApiService.updateSelf(scope.user).then(function (user) {
                    scope.user = user;
                    $state.reload();
                });
            });
        }

        function isStadium() {
            return scope.user && scope.user.stadium && !scope.user.admin;
        }

        function isStadiumCartSelected() {
            return isStadium() && scope.user.orderReference && scope.user.orderProject;
        }

        function isIncomingOrderCount() {
            return isIncomingOrderCountB2B() || isIncomingOrderCountB2C();
        }

        function isIncomingOrderCountB2C() {
            return (scope.user.incomingOrderCountB2C && '0' !== scope.user.incomingOrderCountB2C);
        }

        function isIncomingOrderCountB2B() {
            return (scope.user.incomingOrderCountB2B && '0' !== scope.user.incomingOrderCountB2B);
        }

        function isShortageCount() {
            return scope.user.shortageCount && '0' !== scope.user.shortageCount;
        }

        function hasTemplateActive() {
            return scope.user.templateId != null;
        }

        function openTemplate() {
            $state.go('app.shop.advancedMounting', {id: scope.user.templateId}, 'AdvancedMountingController');
        }

        function closeTemplate() {
            PlacementsApiService.closeTemplate()
                .then(function () {
                    $rootScope.$broadcast('$updateNotifications');
                    if (isStadium()) {
                        return $state.go('app.shop.stadiumStart');
                    } else {
                        return $state.go('app.shop.cart');
                    }
                }, function (error) {
                    ValidationManager.handleResponseError(error);
                });
        }
    }

    angular
        .module('userbox', [])
        .directive('userBox', userBox);
})();

(function(){

    "use strict";

    // @ngInject
    function validateCommaSeparatedNumbers() {
            return {
                require: '?ngModel',
                link: function (scope, element, attrs, ngModelCtrl) {
                    if(!ngModelCtrl){
                        return;
                    }

                    ngModelCtrl.$parsers.push(function(val){
                        var clean = val.replace(/[^\d,]/gm,'');
                        clean = clean.replace(/^,+/m, '');
                        clean = clean.replace(/,{2,}/g, ',');
                        if(val !== clean){
                            ngModelCtrl.$setViewValue(clean);
                            ngModelCtrl.$render();
                        }

                        return clean;
                    });

                    element.bind('keypress', function(event){
                        // Space
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });
                }
            };
    }

    angular
        .module('validators.commaSeparatedNumbers',[])
        .directive('validateCommaSeparatedNumbers', validateCommaSeparatedNumbers);
})();
(function(){

    "use strict";

    // @ngInject
    function validateInteger(){
        var REGEX = /^\-?\d+$/;

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {

                ctrl.$validators.integer = function (modelValue, viewValue) {
                    return !!REGEX.test(viewValue);
                };
            }
        };
    }
    angular
        .module('validators.integer',[])
        .directive('validateInteger', validateInteger);
})();
(function(){

    'use strict';

    angular.module('validators',['validators.integer', 'validators.commaSeparatedNumbers']);
})();
(function() {

    'use strict';

    // @ngInject
    ArticlesApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function ArticlesApiService(DS,DSHttpAdapter,$q) {
        var savedSearch = initialiseSearch();
        return {
            getAll: getAll,
            getById: getById,
            getArticleImageUrl: getArticleImageUrl,
            getArticleAttachmentUrl: getArticleAttachmentUrl,
            updateArticle: updateArticle,
            getProductTypes: getProductTypes,
            getColors: getColors,
            getSavedSearch: getSavedSearch,
            freezeArticle: freezeArticle,
            shareArticle: shareArticle,
            getProductBacksides: getProductBacksides
        };

        function initialiseSearch() {
            return {
                searchField: '',
                stadiumSearch: 'shared',
                page: 1,
                globalSearch: false,
                count: 20,
                sorting: {
                    id: 'asc'
                }
            };
        }

        function getSavedSearch() {
            return savedSearch;
        }

        function getAll(page,sorting,globalSearch,stadiumSearch) {
            var deferred = $q.defer();
            var params = {};

            savedSearch.page = page;
            savedSearch.sorting = sorting;
            savedSearch.globalSearch = globalSearch;
            savedSearch.stadiumSearch = stadiumSearch;

            if (typeof page !== 'undefined' && page > 1) {
                params.page = page;
            }

            if (!_.isEmpty(sorting)) {
                for(var obj in sorting) {
                    var sort = obj;
                    var order = sorting[obj];

                    if(sort !== "id" || order !== "asc"){
                        params.sort = sort;
                        params.order = order;
                    }
                }
            }

            if (!_.isEmpty(savedSearch.searchField)) {
                params.filter = (savedSearch.searchField || '');
                params.filter = params.filter.trim();
            }
            if (globalSearch) {
                params.globalSearch = true;
            }
            if (stadiumSearch) {
                params.stadiumSearch = savedSearch.stadiumSearch;
            }

            DSHttpAdapter.GET(DS.defaults.baseUrl + 'articles', {params:params}).then(function(response) {
                DS.ejectAll('article');
                DS.inject('article', response.data.articles);
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function getById(articleId) {
            return DS.find('article', articleId, { bypassCache: true, cacheResponse: false });
        }

        function getArticleImageUrl(articleNumber){
            return DS.defaults.baseUrl + 'images/' + encodeURIComponent(articleNumber);
        }

        function getArticleAttachmentUrl(articleNumber) {
            return DS.defaults.baseUrl + 'attachments/' + encodeURIComponent(articleNumber);
        }

        function updateArticle(articleNumber,data){
            var deferred = $q.defer();
            DS.update('article', articleNumber, data,{ cacheResponse:false }).then(function(response) {
                var article = DS.get('article', articleNumber);
                article.tags = response.tags;
                deferred.resolve(response);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getColors(articleType){
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'colours/' + articleType).then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getProductTypes(groupType){
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'producttypes/' + groupType).then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getProductBacksides(name){
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'producttypes/backsides/' + name).then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function freezeArticle(articleNumber){
            var deferred = $q.defer();
            DSHttpAdapter.DEL(DS.defaults.baseUrl + 'articles/' + articleNumber).then(function(response) {
                deferred.resolve(response);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function shareArticle(data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'articles/share';
            DSHttpAdapter.PUT(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.articles', [])
        .factory('ArticlesApiService', ArticlesApiService);
})();
(function() {

    'use strict';

    // @ngInject
    CalculatorApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function CalculatorApiService(DS,DSHttpAdapter,$q) {
        return {
            calculatePrice: calculatePrice,
            calculateSize: calculateSize
        };

        function calculatePrice(query) {
            var deferred = $q.defer();
            DSHttpAdapter.POST(DS.defaults.baseUrl + 'calculator', query).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function calculateSize(query) {
            var deferred = $q.defer();
            DSHttpAdapter.POST(DS.defaults.baseUrl + 'calculator/size', query).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.calculator', [])
        .factory('CalculatorApiService', CalculatorApiService);
})();
(function () {

    'use strict';

    // @ngInject
    CartApiService.$inject = ["DS", "DSHttpAdapter", "$q", "$upload", "AuthService"];
    function CartApiService(DS, DSHttpAdapter, $q, $upload, AuthService) {
        return {
            getCartRows: getCartRows,
            newCartRows: newCartRows,
            getPlayerGroups: getPlayerGroups,
            addPlayerGroup: addPlayerGroup,
            updateCart: updateCart,
            deleteCartRow: deleteCartRow,
            newOrder: newOrder,
            getCartMeta: getCartMeta,
            getCartCosts: getCartCosts,
            articleInCart: articleInCart,
            getCartRow: getCartRow,
            getDeliveryAddresses: getDeliveryAddresses,
            getStandardAddress: getStandardAddress,
            getStadiumAddress: getStadiumAddress,
            closeCart: closeCart,
            getCartInfo: getCartInfo,
            addBacksides: addBacksides,
            getNonWorkingDays: getNonWorkingDays,
            deleteAddress: deleteAddress
        };

        function getCartRows() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'cart')
                .then(function (response) {
                    var rows = storeCartRows(response.data);
                    storeCartMeta(response.data);
                    deferred.resolve(rows);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getPlayerGroups() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'cart/playerGroups')
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getNonWorkingDays() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'cart/nonWorkingDays')
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function addPlayerGroup(data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'cart/playerGroup';
            DSHttpAdapter.POST(url, data)
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function newCartRows(data) {
            var deferred = $q.defer();
            DSHttpAdapter.POST(DS.defaults.baseUrl + 'cart', data)
                .then(function (response) {
                    var rows = storeCartRows(response.data);
                    storeCartMeta(response.data);
                    deferred.resolve(rows);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function updateCart(data) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'cart', data)
                .then(function (response) {
                    var rows = storeCartRows(response.data);
                    storeCartMeta(response.data);
                    deferred.resolve(rows);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function addBacksides(data) {
            var deferred = $q.defer();
            DSHttpAdapter.POST(DS.defaults.baseUrl + 'cart/backsides', data)
                .then(function (response) {
                    var rows = storeCartRows(response.data);
                    storeCartMeta(response.data);
                    deferred.resolve(rows);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function deleteCartRow(rowId) {
            var deferred = $q.defer();
            DSHttpAdapter.DEL(DS.defaults.baseUrl + 'cart/' + rowId)
                .then(function (response) {
                    DS.eject('cartRow', rowId);
                    storeCartMeta(response.data);
                    deferred.resolve();
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getAddress(address) {
            var deliveryAddress = {};
            deliveryAddress.id = address.id;
            deliveryAddress.customerId = address.customerId || "";
            deliveryAddress.recipient = address.recipient || "";
            deliveryAddress.line1 = address.line1 || "";
            deliveryAddress.line2 = address.line2 || "";
            deliveryAddress.postCode = address.postCode || "";
            deliveryAddress.city = address.city || "";
            deliveryAddress.countryCode = address.countryCode || "";

            return deliveryAddress;
        }

        function deleteAddress(deliveryAddress) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'addresses';

            var address = getAddress(deliveryAddress);

            DSHttpAdapter.DEL(url, { data: address, headers: {'Content-Type': 'application/json'} }).then(function (response) {
                deferred.resolve(response.data);
            })
            .catch(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function newOrder(order) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'orders';

            var formFields = getForm(order);

            handleFileNames(order);

            $upload.upload({
                url: url,
                method: 'POST',
                fields: formFields,
                file: order.files,
                fileFormDataName: 'file'
            }).then(function () {
                clearCart();
                deferred.resolve();
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function handleFileNames(errand) {
            angular.forEach(errand.files, function(file) {
                Object.defineProperties(file, {
                    'name': {
                        value: encodeURI(file.name),
                        writable: true
                    }
                });
            });
        }

        function getForm(order) {
            var formData = {};
            formData.reference = order.reference;
            formData.stadiumInvoice = order.stadiumInvoice;
            formData.stadiumPayment = order.stadiumPayment;
            formData.instructions = order.instructions;
            formData.deliveryDate = order.deliveryDate;
            formData.ignoreCustomerNotification = order.ignoreCustomerNotification;
            formData.addressType = order.addressType;

            if (order.recipient) {
                formData.recipient = order.recipient;
                formData.line1 = order.line1;
                formData.line2 = order.line2;
                formData.postCode = order.postCode;
                formData.city = order.city;
                formData.countryCode = order.countryCode;
            }
            return formData;
        }

        function getCartMeta() {
            return DS.definitions.cartRow.meta;
        }

        function getCartCosts() {
            return DS.definitions.cartRow.costs;
        }

        function articleInCart(id) {
            return _.some(DS.filter('cartRow'), { 'article': { id: id } });
        }

        function getCartRow(id) {
            return _.find(DS.filter('cartRow'), { 'article': { id: id } });
        }

        function getDeliveryAddresses() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'addresses')
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getStandardAddress() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'addresses/standard')
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getStadiumAddress() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'addresses/stadium')
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function storeCartRows(cart) {
            DS.ejectAll('cartRow');
            var rowList = [];

            angular.forEach(cart.rows, function (row) {
                row.id = row.mounting && row.mounting.placementId ? row.mounting.placementId : row.id;
                var tempRow = DS.createInstance('cartRow', row);
                rowList.push(tempRow);
            });

            DS.inject('cartRow', rowList);
            return rowList;
        }

        function storeCartMeta(cart) {
            var definition = DS.definitions.cartRow;
            definition.costs = cart.costs;
            createCartMeta();
            definition.meta.itemCount = cart.meta.itemCount || 0;
            definition.meta.orderSum = cart.meta.orderSum;
            definition.meta.orderTotal = cart.meta.orderTotal;
            definition.meta.deliveryDate = cart.meta.deliveryDate;
            definition.meta.currencyPrefix = cart.meta.currencyPrefix;
            definition.meta.currencySuffix = cart.meta.currencySuffix;
        }

        function clearCart() {
            createCartMeta();
            DS.ejectAll('cartRow');
            DS.definitions.cartRow.costs = [];
        }

        function createCartMeta() {
            var definition = DS.definitions.cartRow;
            definition.meta = definition.meta || {};
            definition.meta.itemCount = 0;
            definition.meta.orderSum = "";
            definition.meta.orderTotal = "";
            definition.meta.deliveryDate = "";
            definition.meta.currencyPrefix = "";
            definition.meta.currencySuffix = "";
        }

        function closeCart() {
            var deferred = $q.defer();
            DSHttpAdapter.POST(DS.defaults.baseUrl + 'cart/close')
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function getCartInfo() {
            var deferred = $q.defer();

            DSHttpAdapter.GET(DS.defaults.baseUrl + 'cart/info')
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }
    }

    angular
        .module('modules.cart', [])
        .factory('CartApiService', CartApiService);
})();

(function() {

    'use strict';

    // @ngInject
    ClubsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function ClubsApiService(DS,DSHttpAdapter,$q) {
        return {
            getClubs: getClubs,
            getClubsWithCategories: getClubsWithCategories,
            getAllClubs: getAllClubs,
            getAllClubsForStore: getAllClubsForStore,
            getCategories: getCategories,
            getAllCategories: getAllCategories,
            createClub: createClub,
            createCategory: createCategory,
            deleteClub: deleteClub,
            deleteCategory: deleteCategory,
            renameClub: renameClub,
            renameCategory: renameCategory,
            copy: copy
        };

        function getClubs() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'clubs').then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getClubsWithCategories() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'clubs/categories').then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getAllClubs() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'clubs/all').then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getAllClubsForStore(storeId) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'clubs/store/' + storeId).then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getCategories(clubId) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'clubs/' + clubId).then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getAllCategories(clubId) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'clubs/all/' + clubId).then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createClub(clubName) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'clubs';
            var data = {
                name: clubName
            };
            DSHttpAdapter.POST(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createCategory(clubId, categoryName) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'clubs/' + clubId;
            var data = {
                name: categoryName
            };
            DSHttpAdapter.POST(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deleteClub(clubId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'clubs/' + clubId;
            DSHttpAdapter.DEL(url).then(function(response) {
                deferred.resolve(response);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deleteCategory(clubId, categoryId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'clubs/' + clubId + '/' + categoryId;
            DSHttpAdapter.DEL(url).then(function(response) {
                deferred.resolve(response);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function renameClub(clubId, newName) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'clubs/' + clubId;
            DSHttpAdapter.PUT(url, newName).then(function(response) {
                deferred.resolve(response);
            }, function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function renameCategory(clubId, categoryId, newName) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'clubs/' + clubId + '/' + categoryId;
            DSHttpAdapter.PUT(url, newName).then(function(response) {
                deferred.resolve(response);
            }, function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function copy(data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'clubs/copy';
            DSHttpAdapter.PUT(url, data).then(function(response) {
                deferred.resolve(response);
            }, function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.clubs', [])
        .factory('ClubsApiService', ClubsApiService);
})();
(function() {

    'use strict';

    // @ngInject
    CountriesApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function CountriesApiService(DS,DSHttpAdapter,$q) {
        return {
            getCountries: getCountries
        };

        function getCountries() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'countries/').then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.countries', [])
        .factory('CountriesApiService', CountriesApiService);
})();
(function() {

    'use strict';

    // @ngInject
    CustomerDetailsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function CustomerDetailsApiService(DS,DSHttpAdapter,$q) {
        return {
            getCustomerDetails: getCustomerDetails
        };

        function getCustomerDetails(customerId) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'customerdetails/' + customerId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.customerDetails', [])
        .factory('CustomerDetailsApiService', CustomerDetailsApiService);
})();
(function() {

    'use strict';

    // @ngInject
    CustomersApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function CustomersApiService(DS,DSHttpAdapter,$q) {
        return {
            getAll: getAll,
            getById: getById,
            getEmployee : getEmployee
        };

        function getAll() {
            return DS.findAll('customer',null);
        }

        function getById(customerId){
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'customers/' + customerId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getEmployee(customerId, employeeId){
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'customers/' + customerId + '/' + employeeId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.customers', [])
        .factory('CustomersApiService', CustomersApiService);
})();
(function() {

    'use strict';

    // @ngInject
    CustomerSettingsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function CustomerSettingsApiService(DS,DSHttpAdapter,$q) {
        return {
            getCustomerSettings: getCustomerSettings,
            updateCustomerSettings: updateCustomerSettings
        };

        function getCustomerSettings(customerId) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'customersettings/' + customerId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updateCustomerSettings(customerSettings) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'customersettings/', customerSettings).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.customerSettings', [])
        .factory('CustomerSettingsApiService', CustomerSettingsApiService);
})();
(function () {

  'use strict';

  // @ngInject
  DigitsApiService.$inject = ["DS", "DSHttpAdapter"];
  function DigitsApiService(DS, DSHttpAdapter) {
    return {
      getAll: getAll,
      getAllSmall: getAllSmall,
      getAllLarge: getAllLarge,
      getById: getById,
      getSmallById: getSmallById,
      getLargeById: getLargeById,
      getImageUrl: getImageUrl,
    };

    function getAll() {
      return DS.findAll('digit', null, { bypassCache: true });
    }

    function getAllSmall() {
      return DSHttpAdapter.GET(DS.defaults.baseUrl + 'digits/small')
        .then(function (response) {
          return response.data;
        });
    }

    function getAllLarge() {
      return DSHttpAdapter.GET(DS.defaults.baseUrl + 'digits/large')
          .then(function (response) {
            return response.data;
          });
    }

    function getById(digitsId) {
      return DS.find('digit', digitsId, { bypassCache: true });
    }

    function getSmallById(digitsId) {
      return DSHttpAdapter.GET(DS.defaults.baseUrl + 'digits/' + digitsId + '/small')
        .then(function (response) {
          return response.data;
        });
    }

    function getLargeById(digitsId) {
      return DSHttpAdapter.GET(DS.defaults.baseUrl + 'digits/' + digitsId + '/large')
          .then(function (response) {
            return response.data;
          });
    }

    function getImageUrl(digitId) {
      return DS.defaults.baseUrl + 'images/' + encodeURIComponent(digitId);
    }
  }

  angular
    .module('modules.digits', [])
    .factory('DigitsApiService', DigitsApiService);
})();

(function() {

    'use strict';

    // @ngInject
    DiscountsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function DiscountsApiService(DS,DSHttpAdapter,$q) {
        return {
            getDiscounts: getDiscounts,
            updateDiscounts: updateDiscounts
        };

        function getDiscounts() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'discounts').then(function (response) {
                deferred.resolve(DS.inject('discount', response.data));
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updateDiscounts(discounts) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'discounts', discounts).then(function (response) {
                deferred.resolve(DS.inject('discount', response.data));
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.discounts', [])
        .factory('DiscountsApiService', DiscountsApiService);
})();
(function() {

    'use strict';

    // @ngInject
    EmailApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function EmailApiService(DS,DSHttpAdapter,$q) {
        return {
            getErrandTemplates: getErrandTemplates,
            getMountingTemplates: getMountingTemplates,
            createErrandEmail: createErrandEmail,
            createMountingEmail: createMountingEmail,
            updateErrandEmail: updateErrandEmail,
            updateMountingEmail: updateMountingEmail,
            deleteErrandEmail: deleteErrandEmail,
            deleteMountingEmail: deleteMountingEmail
        };

        function getErrandTemplates(errandId) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'errandtemplates/' + errandId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getMountingTemplates(mountingId) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'mountingtemplates/' + mountingId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createErrandEmail(errandId, email) {
            var deferred = $q.defer();
            DSHttpAdapter.POST(DS.defaults.baseUrl + 'errandemail/' + errandId, email).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createMountingEmail(mountingId, email) {
            var deferred = $q.defer();
            DSHttpAdapter.POST(DS.defaults.baseUrl + 'mountingemail/' + mountingId, email).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updateErrandEmail(errandId, emailId, email) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'errandemail/' + errandId + '/' + emailId, email).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updateMountingEmail(mountingId, emailId, email) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'mountingemail/' + mountingId + '/' + emailId, email).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deleteErrandEmail(errandId, emailId) {
            var deferred = $q.defer();
            DSHttpAdapter.DEL(DS.defaults.baseUrl + 'errandemail/' + errandId + '/' + emailId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deleteMountingEmail(mountingId, emailId) {
            var deferred = $q.defer();
            DSHttpAdapter.DEL(DS.defaults.baseUrl + 'mountingemail/' + mountingId + '/' + emailId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.email', [])
        .factory('EmailApiService', EmailApiService);
})();
(function() {

    'use strict';

    // @ngInject
    ErrandsApiService.$inject = ["DS", "DSHttpAdapter", "$q", "$upload", "AuthService"];
    function ErrandsApiService(DS, DSHttpAdapter, $q, $upload, AuthService) {
        var savedSearch = initializeSearch();
        return {
            getErrands: getErrands,
            getErrand: getErrand,
            closeErrand: closeErrand,
            deleteErrand: deleteErrand,
            createErrand: createErrand,
            updateErrand: updateErrand,
            getSavedSearch: getSavedSearch,
            deleteErrandAttachment: deleteErrandAttachment,
            remindErrand: remindErrand,
            markPriceSent: markPriceSent
        };

        function initializeSearch() {
            return {
                errandId: '',
                customerId: '',
                tag: '',
                errandStatus: '',
                resourceId: '',
                errandTypes: [],
                express: false,
                page: 1,
                sorting: {
                    registeredDate: 'desc'
                },
                includeArchived: false
            };
        }

        function getSavedSearch() {
            return savedSearch;
        }

        function getErrands(sorting, pageNumber, filter) {
            var params = {};
            addFilterParams(params, {
                errandId: filter.errandId,
                customerId: filter.customerId,
                tag: filter.tag,
                errandStatus: filter.errandStatus,
                resourceId: filter.resourceId,
                errandTypes: filter.errandTypes,
                express: filter.express,
                unreadEmail: filter.unreadEmail
            });

            if (angular.isDefined(pageNumber) && pageNumber > 1) {
                params.page = pageNumber;
            }

            if (!_.isEmpty(sorting)) {
                for (var obj in sorting) {
                    var sortBy = obj;
                    var sortDirection = sorting[obj];

                    if (sortBy !== "registeredDate" || sortDirection !== "desc") {
                        params.sort = sortBy;
                        params.order = sortDirection;
                    }
                }
            }

            params.includeArchived = !!filter.includeArchived;

            savedSearch = {
                errandId: filter.errandId || '',
                customerId: filter.customerId || '',
                tag: filter.tag || '',
                errandStatus: filter.errandStatus || '',
                resourceId: filter.resourceId || '',
                errandTypes: filter.errandTypes || [],
                express: filter.express || false,
                unreadEmail: filter.unreadEmail || false,
                sorting: sorting,
                page: pageNumber,
                includeArchived: !!filter.includeArchived
            };

            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productionerrands';
            DSHttpAdapter.GET(url, {params: params}).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function addFilterParams(params, filterParams) {
            for (var paramName in filterParams) {
                var paramValue = filterParams[paramName];
                if (paramValue && paramValue.length > 0 || paramValue === true) {
                    params[paramName] = paramValue;
                }
            }
        }

        function getErrand(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productionerrands/' + id;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function remindErrand(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productionerrands/remind/' + id;
            DSHttpAdapter.PUT(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function markPriceSent(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productionerrands/markpricesent/' + id;
            DSHttpAdapter.PUT(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deleteErrand(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productionerrands/' + id;
            DSHttpAdapter.DEL(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function closeErrand(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productionerrands/close/' + id;
            DSHttpAdapter.POST(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createErrand(errand) {
            var deferred = $q.defer();

            var formFields = {
                customerId: errand.customerId || "",
                userId: errand.userId || "",
                information: errand.information || "",
                tags: errand.tags || [],
                resourceId: errand.resourceId || "",
                errandTypes: errand.errandTypes || [],
                express: errand.express || false,
            };

            handleFileNames(errand);

            $upload.upload({
                url: DS.defaults.baseUrl + 'productionerrands',
                method: 'POST',
                fields: formFields,
                file: errand.files,
                fileFormDataName: 'file'
            }).then(function(response) {
                deferred.resolve(response.data);
            }, function(error) {
                deferred.reject(error.data);
            });

            return deferred.promise;
        }

        function handleFileNames(errand) {
            angular.forEach(errand.files, function(file) {
                Object.defineProperties(file, {
                    'name': {
                        value: encodeURI(file.name),
                        writable: true
                    }
                });
            });
        }

        function updateErrand(errand) {
            var deferred = $q.defer();

            var formFields = {
                customerId: errand.customerId || "",
                userId: errand.userId || "",
                information: errand.information || "",
                tags: errand.tags || [],
                resourceId: errand.resourceId || "",
                errandTypes: errand.errandTypes || [],
                express: errand.express,
                lastModified: errand.lastModifiedDate || ""
            };

            handleFileNames(errand);

            $upload.upload({
                url: DS.defaults.baseUrl + 'productionerrands/' + errand.id,
                method: 'PUT',
                fields: formFields,
                file: errand.files,
                fileFormDataName: 'file'
            }).then(function(response) {
                deferred.resolve(response.data);
            }, function(error) {
                deferred.reject(error.data);
            });

            return deferred.promise;
        }

        function deleteErrandAttachment(errandId, attachmentId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productionerrands/' + errandId + '/attachments/' + attachmentId;
            DSHttpAdapter.DEL(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.errands', [])
        .factory('ErrandsApiService', ErrandsApiService);
})();

(function() {

    'use strict';

    // @ngInject
    GarmentsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function GarmentsApiService(DS,DSHttpAdapter,$q) {
        return {
            getGarments: getGarments
        };

        function getGarments() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'garments';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.garments', [])
        .factory('GarmentsApiService', GarmentsApiService);
})();
(function() {

    'use strict';

    // @ngInject
    HistoryApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function HistoryApiService(DS,DSHttpAdapter,$q) {
        var savedSearch = initializeSearch();
        return {
            getAll: getAll,
            getById: getById,
            getSavedSearch : getSavedSearch
        };

        function initializeSearch() {
            return {
                page: 1,
                sorting: {
                    dateOrdered: 'desc'
                }
            };
        }

        function getSavedSearch() {
            return savedSearch;
        }

        function getAll(page, sorting, pageSize) {
            var deferred = $q.defer();
            var params = {};

            savedSearch.page = page;
            savedSearch.sorting = sorting;

            if (typeof page !== 'undefined' && page > 1) {
                params.page = page;
            }
            if (typeof pageSize !== 'undefined' && pageSize > 1) {
                params.pageSize = pageSize;
            }
            if (!_.isEmpty(sorting)) {
                for(var obj in sorting) {
                    var sort = obj;
                    var order = sorting[obj];

                    if(sort !== "dateOrdered" || order !== "desc"){
                        params.sort = sort;
                        params.order = order;
                    }
                }
            }

            DSHttpAdapter.GET(DS.defaults.baseUrl + 'history', {params:params}).then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getById(historyId){
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'history/' + historyId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.history', [])
        .factory('HistoryApiService', HistoryApiService);
})();
(function () {

    'use strict';

    // @ngInject
    LogoImageApiService.$inject = ["DS", "DSHttpAdapter", "$q", "$upload", "AuthService"];
    function LogoImageApiService(DS, DSHttpAdapter, $q, $upload, AuthService) {
        return {
            get: get,
            getAll: getAll,
            getImageUrl: getImageUrl,
            getSourceImage: getSourceImage,
            create: create,
            save: save,
            saveAs: saveAs,
            archive: archive
        };

        function get(id) {
            var defer = $q.defer();
            var url = DS.defaults.baseUrl + 'logoImages/' + id;

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    defer.resolve(response.data);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        }

        function getImageUrl(id) {
            return DS.defaults.baseUrl + 'logoImages/image/' + encodeURIComponent(id);
        }

        function getSourceImage(id) {
            var defer = $q.defer();
            var url = DS.defaults.baseUrl + 'logoImages/source/' + encodeURIComponent(id);

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    defer.resolve(response.data);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        }

        function getAll() {
            var defer = $q.defer();
            var url = DS.defaults.baseUrl + 'logoImages/all';

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    defer.resolve(response.data);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        }

        function create(logoImage) {
            var form = {
                name: logoImage.name,
                logoImageId: '',
                originalId: ''
            };

            var defer = $q.defer();
            $upload.upload({
                url: DS.defaults.baseUrl + 'logoImages',
                method: 'POST',
                fields: form,
                file: logoImage.file,
                fileFormDataName: 'file'
            }).then(function (response) {
                defer.resolve(response.data);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        }

        function save(data) {
            var defer = $q.defer();
            var url = DS.defaults.baseUrl + 'logoImages/save';

            DSHttpAdapter.POST(url, data).then(function (response) {
                defer.resolve(response.data);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        }

        function saveAs(data) {
            var defer = $q.defer();
            var url = DS.defaults.baseUrl + 'logoImages/saveAs';

            DSHttpAdapter.POST(url, data)
                .then(function (response) {
                    defer.resolve(response.data);
                }, function (error) {
                    defer.reject(error);
                });
            return defer.promise;
        }

        function archive(id) {
            var defer = $q.defer();
            var url = DS.defaults.baseUrl + 'logoImages/' + id;

            DSHttpAdapter.DEL(url)
                .then(function (response) {
                    defer.resolve(response.data);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        }
    }

    angular
        .module('modules.logoImages', [])
        .factory('LogoImageApiService', LogoImageApiService);
})();

(function () {

    'use strict';

    // @ngInject
    LogosApiService.$inject = ["DS", "DSHttpAdapter", "$q", "$upload", "AuthService"];
    function LogosApiService(DS, DSHttpAdapter, $q, $upload, AuthService) {
        return {
            newLogo: newLogo,
            getLogo: getLogo,
            getEditableLogo: getEditableLogo,
            updateLogo: updateLogo
        };

        function getLogo(id) {
            return DSHttpAdapter.GET(DS.defaults.baseUrl + 'logo/' + id)
                .then(function (response) {
                    return response.data;
                }, function (error) {
                    return error.data;
                });
        }

        function getEditableLogo(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'logo/edit/' + id;

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error.data);
                });

            return deferred.promise;
        }

        function newLogo(article) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'logo';

            $upload.upload({
                url: url,
                method: 'POST',
                fields: getForm(article),
                file: article.file,
                fileFormDataName: 'file'
            }).then(function () {
                deferred.resolve();
            }, function (error) {
                deferred.reject(error.data);
            });

            return deferred.promise;
        }

        function updateLogo(article, id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'logo/edit/' + id;

            $upload.upload({
                url: url,
                method: 'PUT',
                fields: getForm(article),
                file: article.file,
                fileFormDataName: 'file'
            }).then(function () {
                deferred.resolve();
            }, function (error) {
                deferred.reject(error.data);
            });

            return deferred.promise;
        }

        function getForm(article) {
            return {
                logoId: article.id || '',
                productType: article.productType || '',
                productSubtype: article.productSubtype || '',
                name: article.name || '',
                fixedAspect: article.fixedAspect || '',
                height: article.height || '',
                width: article.width || '',
                information: article.information || '',
                process: article.process || false,
                colours: article.colors || '',
                tags: article.tags || '',
                quantity: article.quantity || '',
                stitches: article.stitches || '',
                edgeType: article.edgeType || '',
                warpType: article.warpType || '',
                foldType: article.foldType || '',
                backside: article.backside || '',
                backsides: article.backsides ? JSON.stringify(article.backsides) : '',
                contact: article.contact || false,

                // Files & Errands
                logoImage: article.logoImage ? article.logoImage.logoImageId : '',
                errandId: article.errand ? article.errand.errandId : '',
                proofFileId: article.errand ? article.errand.fileId : '',

                // Stadium
                share: article.share || false,
                minimumStock: article.minimumStock || '',
                refillQuantity: article.refillQuantity || '',
                manufacturingQuantity: article.manufacturingQuantity || '',

                // Simple mounting
                mountingArticle: article.mountingArticle || '',
                garmentInfo: article.garment || '',
                placementInfo: article.placement || '',

                // Template
                templateId: article.templateId || '',
                register: article.register || false
            };
        }
    }

    angular
        .module('modules.logos', [])
        .factory('LogosApiService', LogosApiService);
})();

(function() {

    'use strict';

    // @ngInject
    ManufacturingApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function ManufacturingApiService(DS,DSHttpAdapter,$q) {
        return {
            postManufacturing: postManufacturing,
            getManufacturingOrders: getManufacturingOrders
        };

        function postManufacturing(manufacturing) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'manufacturing';

            var data = {
                id: manufacturing.id,
                quantity: manufacturing.quantity
            };

            DSHttpAdapter.POST(url, data).then(function(response) {
                deferred.resolve(response.data);
            }, function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getManufacturingOrders(articleId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'manufacturing/' + articleId;

            DSHttpAdapter.GET(url).then(function(response) {
                deferred.resolve(response.data);
            }, function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.manufacturing', [])
        .factory('ManufacturingApiService', ManufacturingApiService);
})();
(function () {

    'use strict';

    angular
        .module('modules', [
            'modules.articles',
            'modules.calculator',
            'modules.cart',
            'modules.clubs',
            'modules.countries',
            'modules.customerDetails',
            'modules.customers',
            'modules.customerSettings',
            'modules.digits',
            'modules.discounts',
            'modules.email',
            'modules.errands',
            'modules.garments',
            'modules.history',
            'modules.logos',
            'modules.logoImages',
            'modules.manufacturing',
            'modules.mountingItems',
            'modules.names',
            'modules.orderProofs',
            'modules.pendingOrders',
            'modules.placementImages',
            'modules.placementOrder',
            'modules.placements',
            'modules.PlayerList',
            'modules.productionTypes',
            'modules.proofs',
            'modules.resources',
            'modules.savedCarts',
            'modules.shortages',
            'modules.stadiumOrder',
            'modules.stadiumHistory',
            'modules.stadiumParser',
            'modules.stadiumPlacements',
            'modules.stadiumStock',
            'modules.stadiumStores',
            'modules.stadiumProducts',
            'modules.stock',
            'modules.tasks',
            'modules.translations',
            'modules.templatePrices',
            'modules.users',
            'modules.price'
        ]);
})();

(function() {

    'use strict';

    // @ngInject
    MountingItemsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function MountingItemsApiService(DS,DSHttpAdapter,$q) {
        return {
            getMountingItems: getMountingItems,
        };

        function getMountingItems() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'mountingitems').then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.mountingItems', [])
        .factory('MountingItemsApiService', MountingItemsApiService);
})();
(function () {

    'use strict';

    // @ngInject
    NamesApiService.$inject = ["DSHttpAdapter", "DS", "$q", "$upload", "AuthService"];
    function NamesApiService(DSHttpAdapter, DS, $q, $upload, AuthService) {
        return {
            postName: postName,
            getName: getName,
            getMetaData: getMetaData,
            getColours: getColours,
            getCustomerFontList: getCustomerFontList
        };

        function postName(name) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'name';
            var method = 'POST';

            if (name.logoId) {
                method = 'PUT';
            }

            var formFields = getNameForm(name);

            $upload.upload({
                url: url,
                method: method,
                fields: formFields,
                file: name.file,
                fileFormDataName: 'file'
            }).then(function () {
                deferred.resolve();
            }, function (error) {
                deferred.reject(error.data);
            });

            return deferred.promise;
        }

        function getName(logoId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'name/' + logoId;

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getMetaData() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'name/metadata';

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getCustomerFontList() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'name/fonts';

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getColours(colourType) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'colours/' + colourType;

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getNameForm(name) {
            return {
                description: name.description || '',
                fontType: name.fontType || '',
                formType: name.formType || '',
                caseType: name.caseType || '',
                playerListTypes: name.playerListTypes || [],
                backgroundColour: name.backgroundColour || '',
                textColour: name.textColour || '',
                tags: name.tags || [],
                width: name.width || '',
                height: name.height || '',
                information: name.information || '',
                playerListId: name.playerListId || '',
                heightRelative: name.heightRelative || false,
                logoId: name.logoId || ''
            };
        }
    }

    angular
        .module('modules.names', [])
        .factory('NamesApiService', NamesApiService);
})();

(function() {

    'use strict';

    // @ngInject
    OrderProofsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function OrderProofsApiService(DS, DSHttpAdapter, $q) {
        return {
            getOrderProofs: getOrderProofs
        };

        function getOrderProofs() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'orderproofs';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.orderProofs', [])
        .factory('OrderProofsApiService', OrderProofsApiService);
})();
(function() {

    'use strict';

    // @ngInject
    PendingOrdersApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function PendingOrdersApiService(DS,DSHttpAdapter,$q) {
        return {
            getOrders: getOrders,
            getOrder: getOrder,
            approveOrder: approveOrder,
            rejectOrder: rejectOrder
        };

        function getOrders() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'pendingorders';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getOrder(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'pendingorders/' + id;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function approveOrder(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'pendingorders/approve/' + id;
            DSHttpAdapter.POST(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function rejectOrder(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'pendingorders/reject/' + id;
            DSHttpAdapter.POST(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.pendingOrders', [])
        .factory('PendingOrdersApiService', PendingOrdersApiService);
})();
(function() {

    'use strict';

    // @ngInject
    PlacementImagesApiService.$inject = ["AuthService", "DS", "DSHttpAdapter", "$q", "$upload"];
    function PlacementImagesApiService(AuthService, DS, DSHttpAdapter, $q, $upload) {
        return {
            getPlacementLogos: getPlacementLogos,
            getPlacementBackgrounds: getPlacementBackgrounds,
            uploadPlacementImage: uploadPlacementImage,
            deletePlacementImage: deletePlacementImage
        };

        function getPlacementLogos() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placementimages';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getPlacementBackgrounds(perspective) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placementimages/' + perspective;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function uploadPlacementImage(placementImage) {
            var deferred = $q.defer();
            var formFields = {
                name: placementImage.name || "",
                perspective: placementImage.perspective || ""
            };
            $upload.upload({
                url: DS.defaults.baseUrl + 'placementimages',
                method: 'POST',
                fields: formFields,
                file: placementImage.file,
                fileFormDataName: 'file'
            }).then(function(response) {
                deferred.resolve(response.data);
            }, function(error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        }

        function deletePlacementImage(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placementimages/' + id;
            DSHttpAdapter.DEL(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.placementImages', [])
        .factory('PlacementImagesApiService', PlacementImagesApiService);
})();
(function() {

    'use strict';

    // @ngInject
    PlacementOrderApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function PlacementOrderApiService(DS,DSHttpAdapter,$q) {
        return {
            getWarnings: getWarnings,
            addPlacementToCart: addPlacementToCart,
            addTemplatesToCart: addTemplatesToCart,
            updatePlacementInCart: updatePlacementInCart
        };

        function getWarnings() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'warnings';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function addPlacementToCart(data) {
            var url = DS.defaults.baseUrl + 'placementorder';
            return DSHttpAdapter.POST(url, data)
                .then(function (response) {
                    return response.data;
                });
        }

        function addTemplatesToCart(data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placementorder/templates';
            DSHttpAdapter.POST(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updatePlacementInCart(data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placementorder';
            DSHttpAdapter.PUT(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.placementOrder', [])
        .factory('PlacementOrderApiService', PlacementOrderApiService);
})();

(function () {

    'use strict';

    // @ngInject
    PlacementsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function PlacementsApiService(DS, DSHttpAdapter, $q) {
        return {
            getPlacement: getPlacement,
            getPrintingWork: getPrintingWork,
            getPlacementItems: getPlacementItems,
            getStadiumTemplates: getStadiumTemplates,
            getTemplateAuditLogs: getTemplateAuditLogs,
            getTemplateType: getTemplateType,
            createQuickTemplateFromTemplate: createQuickTemplateFromTemplate,
            createBlankPlacement: createBlankPlacement,
            createFromExistingPlacement: createFromExistingPlacement,
            updatePlacement: updatePlacement,
            deletePlacement: deletePlacement,
            addItemsToTemplate: addItemsToTemplate,
            copyItemsToTemplate: copyItemsToTemplate,
            removeItemsFromTemplate: removeItemsFromTemplate,
            getColours: getColours,
            openTemplate: openTemplate,
            closeTemplate: closeTemplate,
            setPlayerListOnTemplate: setPlayerListOnTemplate,
            getCartItemsForTemplate: getCartItemsForTemplate,
            validateTemplate: validateTemplate,
            updatePrintingInformation: updatePrintingInformation,
            updatePrintingPrice: updatePrintingPrice,
            clearPrintingInformation: clearPrintingInformation,
            clearPrintingPrice: clearPrintingPrice,
            getTemplateAuditLogsStadiumProduct: getTemplateAuditLogsStadiumProduct
        };

        function getCartItemsForTemplate(templateId) {
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/cart-items';

            return DSHttpAdapter.GET(url)
                .then(function (response) {
                    return response.data;
                });
        }

        function getPlacementItems(placementId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/' + placementId + '/items';

            DSHttpAdapter.GET(url)
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function getPlacement(placementId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/' + placementId;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getStadiumTemplates(club, category, archived) {
            var params = {
                club: club,
                category: category,
                archived: archived
            };
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/stadiumTemplates';
            DSHttpAdapter.GET(url, {params: params}).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function getTemplateAuditLogs(templateId) {
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/templateAuditLogs';

            return DSHttpAdapter.GET(url)
                .then(function (response) {
                    return response.data;
                });
        }

        function getPrintingWork(templateId) {
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/printingWork';

            return DSHttpAdapter.GET(url)
                .then(function (response) {
                    return response.data;
                });
        }

        function getTemplateAuditLogsStadiumProduct(templateId) {
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/templateAuditLogsStadiumProduct';

            return DSHttpAdapter.GET(url)
                .then(function (response) {
                    return response.data;
                });
        }

        function getTemplateType(templateId) {
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/type';

            return DSHttpAdapter.GET(url)
                .then(function (response) {
                    return response.data;
                });
        }

        function createQuickTemplateFromTemplate(placementId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/' + placementId + '/copy';
            DSHttpAdapter.POST(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (reason) {
                deferred.reject(reason);
            });
            return deferred.promise;
        }

        function createBlankPlacement(placement) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements';

            DSHttpAdapter.POST(url, placement).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createFromExistingPlacement(placement, placementId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/' + placementId;

            DSHttpAdapter.POST(url, placement).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updatePlacement(placement, placementId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/' + placementId;
            var data = {
                templateName: placement.templateName || "",
                description: placement.description || "",
                perspectives: placement.perspectives || [],
                playerListId: placement.playerListId || "",
                garment: placement.garment || "",
                colour: placement.colour || "",
                tags: placement.tags || [],
                club: placement.club || "",
                category: placement.category || "",
                stadiumTemplate: placement.stadiumTemplate,
                articleList: placement.articleList || [],
                digitList: placement.digitList || [],
                logoList: placement.logoList || [],
                stadiumLegacyNotHandled: placement.stadiumLegacyNotHandled
            };

            DSHttpAdapter.PUT(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deletePlacement(id) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/' + id;
            DSHttpAdapter.DEL(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function addItemsToTemplate(placementId, items) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/stadiumTemplates/' + placementId + '/addItems';
            var data = {
                articleList: items.articleList || [],
                digitList: items.digitList || [],
                logoList: items.logoList || [],
                addDefaultProducts: items.addDefaultProducts || false
            };

            DSHttpAdapter.PUT(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function copyItemsToTemplate(placementId, fromPlacementId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/stadiumTemplates/' + placementId + '/copyItems/' + fromPlacementId;

            DSHttpAdapter.PUT(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function removeItemsFromTemplate(placementId, items) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/stadiumTemplates/' + placementId + '/removeItems';
            var data = {
                articleList: items.articleList || [],
                digitList: items.digitList || [],
                logoList: items.logoList || []
            };

            DSHttpAdapter.PUT(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getColours() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'colours/garment')
                .then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function openTemplate(placementId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/templates/openTemplate/' + placementId;
            DSHttpAdapter.POST(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        function closeTemplate() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/templates/closeTemplate';
            DSHttpAdapter.POST(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        function setPlayerListOnTemplate(placementId, playerListId) {
            var url = DS.defaults.baseUrl + 'placements/' + placementId + '/playerList';

            return DSHttpAdapter.PUT(url, playerListId)
                .then(function (response) {
                    return response.data;
                });
        }

        function validateTemplate(templateId) {
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/validate';
            return DSHttpAdapter.GET(url)
                .then(function (response) {
                    return response.data;
                });
        }

        function updatePrintingInformation(templateId, data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/printing-information';

            var request = {
                difficulty: data.difficulty || null,
                printCount: data.printCount,
            };

            DSHttpAdapter.PUT(url, request).then(function (response) {
                deferred.resolve(response.data);
            }, function(reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        function updatePrintingPrice(templateId, data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/printing-price';

            var request = {
                price: data.price
            };

            DSHttpAdapter.PUT(url, request).then(function (response) {
                deferred.resolve(response.data);
            }, function(reason) {
                deferred.reject(reason);
            });

            return deferred.promise;
        }


        function clearPrintingInformation(templateId) {
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/clear-printing-information';
            return DSHttpAdapter.PUT(url).then(function (response) {
                return response.data;
            });
        }

        function clearPrintingPrice(templateId) {
            var url = DS.defaults.baseUrl + 'placements/' + templateId + '/clear-printing-price';
            return DSHttpAdapter.PUT(url).then(function (response) {
                return response.data;
            });
        }
    }

    angular
        .module('modules.placements', [])
        .factory('PlacementsApiService', PlacementsApiService);
})();

(function() {

    'use strict';

    // @ngInject
    PlayerListApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function PlayerListApiService(DS, DSHttpAdapter, $q) {
        return {
            getPlayerList: getPlayerList,
            getPlayerLists: getPlayerLists,
            updatePlayerList: updatePlayerList,
            createBlankPlayerList: createBlankPlayerList,
            createQuickPlayerList: createQuickPlayerList,
            createFromExistingPlayerList: createFromExistingPlayerList,
            deletePlayerList: deletePlayerList
        };

        function getPlayerLists() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'playerlist';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getPlayerList(playerListId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'playerlist/' + playerListId;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createBlankPlayerList(data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'playerlist/';
            DSHttpAdapter.POST(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createQuickPlayerList(players) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'playerlist/quick';

            DSHttpAdapter.POST(url, players)
                .then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function createFromExistingPlayerList(data, playerListId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'playerlist/' + playerListId;
            DSHttpAdapter.POST(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updatePlayerList(playerListId, players) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'playerlist/' + playerListId;
            DSHttpAdapter.PUT(url, players).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deletePlayerList(playerListId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'playerlist/' + playerListId;
            DSHttpAdapter.DEL(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.PlayerList', [])
        .factory('PlayerListApiService', PlayerListApiService);
})();
(function() {

    'use strict';

    // @ngInject
    PriceApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function PriceApiService(DS,DSHttpAdapter,$q) {
        return {
            getPrice: getPrice,
            updatePrice: updatePrice
        };

        function getPrice(articleId) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'price/' + articleId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updatePrice(articleId) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'price/' + articleId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.price', [])
        .factory('PriceApiService', PriceApiService);
})();
(function () {

    'use strict';

    // @ngInject
    ProductionTypesApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function ProductionTypesApiService(DS, DSHttpAdapter, $q) {
        return {
            getStatusErrand: getStatusErrand,
            getErrandTypes: getErrandTypes
        };

        function getStatusErrand() {
            return getType('errandstatus');
        }

        function getErrandTypes() {
            return getType('errandtype');
        }

        function getType(type) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productiontypes/' + type;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.productionTypes', [])
        .factory('ProductionTypesApiService', ProductionTypesApiService);
})();

(function () {

    'use strict';

    // @ngInject
    ProofsApiService.$inject = ["DS", "DSHttpAdapter", "$q", "$upload", "AuthService"];
    function ProofsApiService(DS, DSHttpAdapter, $q, $upload, AuthService) {
        return {
            approveErrandProof: approveErrandProof,
            rejectErrandProof: rejectErrandProof,
            undoErrandProof: undoErrandProof,
            createErrandProof: createErrandProof,
            editErrandProof: editErrandProof
        };

        function approveErrandProof(errandId, proofId) {
            return updateProof('productionerrands/approve/', errandId, proofId);
        }

        function rejectErrandProof(errandId, proofId) {
            return updateProof('productionerrands/reject/', errandId, proofId);
        }

        function undoErrandProof(errandId, proofId) {
            return updateProof('productionerrands/undo/', errandId, proofId);
        }

        function createErrandProof(errandId, proof) {
            return createProof('productionerrands/', errandId, proof);
        }

        function editErrandProof(errandId, proofId, data) {
            return editProof('productionerrands/', errandId, proofId, data);
        }

        function updateProof(path, id, proofId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + path + id + '/' + proofId;
            DSHttpAdapter.PUT(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function editProof(path, id, proofId, data) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + path + id + '/' + proofId, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createProof(path, id, proof) {
            var deferred = $q.defer();
            var formFields = {
                information: proof.information || ""
            };
            handleFileNames(proof);
            $upload.upload({
                url: DS.defaults.baseUrl + path + id,
                method: 'POST',
                fields: formFields,
                file: proof.files,
                fileFormDataName: 'file'
            }).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        }
    }

    function handleFileNames(proof) {
        angular.forEach(proof.files, function (file) {
            Object.defineProperties(file, {
                'name': {
                    value: encodeURI(file.name),
                    writable: true
                }
            });
        });
    }

    angular
        .module('modules.proofs', [])
        .factory('ProofsApiService', ProofsApiService);
})();

(function() {

    'use strict';

    // @ngInject
    ResourcesApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function ResourcesApiService(DS, DSHttpAdapter, $q) {
        return {
            getResources: getResources
        };

        function getResources(resourceType) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'productionresources/' + resourceType;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.resources', [])
        .factory('ResourcesApiService', ResourcesApiService);
})();
(function() {

    'use strict';

    // @ngInject
    SavedCartsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function SavedCartsApiService(DS,DSHttpAdapter,$q) {
        return {
            getSavedCarts: getSavedCarts,
            activateSavedCart: activateSavedCart,
            deleteSavedCart: deleteSavedCart
        };

        function getSavedCarts() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'savedcarts').then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function activateSavedCart(savedCart) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'savedcarts';

            var data = {
                orderReference: savedCart.orderReference,
                orderProject: savedCart.orderProject
            };
            DSHttpAdapter.PUT(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deleteSavedCart(savedCart) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'savedcarts';
            var params = {
                orderReference: savedCart.orderReference,
                orderProject: savedCart.orderProject
            };

            DSHttpAdapter.DEL(url, {params:params}).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.savedCarts', [])
        .factory('SavedCartsApiService', SavedCartsApiService);
})();
(function() {

    'use strict';

    // @ngInject
    ShortagesApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function ShortagesApiService(DS,DSHttpAdapter,$q) {
        return {
            getShortages: getShortages
        };

        function getShortages(page, sorting, stadiumSearch) {
            var deferred = $q.defer();
            var params = {};

            if (typeof page !== 'undefined' && page > 1) {
                params.page = page;
            }

            if (!_.isEmpty(sorting)) {
                for(var obj in sorting) {
                    var sort = obj;
                    var order = sorting[obj];

                    if(sort !== "id" || order !== "asc"){
                        params.sort = sort;
                        params.order = order;
                        params.stadiumSearch = stadiumSearch;
                    }
                }
            }

            DSHttpAdapter.GET(DS.defaults.baseUrl + 'shortages', {params:params}).then(function(response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.shortages', [])
        .factory('ShortagesApiService', ShortagesApiService);
})();
(function() {

    'use strict';

    // @ngInject
    StadiumHistoryApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function StadiumHistoryApiService(DS,DSHttpAdapter,$q) {
        return {
            getOrders: getOrders
        };

        function getOrders() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumhistory';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.stadiumHistory', [])
        .factory('StadiumHistoryApiService', StadiumHistoryApiService);
})();
(function() {

    'use strict';

    // @ngInject
    StadiumOrderApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function StadiumOrderApiService(DS,DSHttpAdapter,$q) {
        return {
            getOrderGroups: getOrderGroups,
            getOrders: getOrders,
            consumeOrder: consumeOrder,
            consumeOrders: consumeOrders,
            deleteOrder: deleteOrder,
            updateTemplate: updateTemplate,
            removeTemplate: removeTemplate
        };

        function getOrderGroups(b2c) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumorders?b2c=' + b2c;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getOrders(reference, user, weborder, orderType) {
            var params = {
                reference: reference,
                user: user,
                weborder: weborder,
                orderType: orderType
            };
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumorders/query';
            DSHttpAdapter.GET(url, {params:params}).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function consumeOrder(orderId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumorders/' + orderId;

            DSHttpAdapter.PUT(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function consumeOrders(reference, user, weborder, orderType) {
            var data = {
                reference: reference,
                user: user,
                weborder: weborder,
                orderType: orderType
            };
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumorders/';
            DSHttpAdapter.PUT(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function deleteOrder(orderId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumorders/' + orderId;
            DSHttpAdapter.DEL(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updateTemplate(orderId, templateId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumorders/updateTemplate/' + orderId;
            DSHttpAdapter.PUT(url, templateId).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function removeTemplate(orderId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumorders/removeTemplate/' + orderId;
            DSHttpAdapter.PUT(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.stadiumOrder', [])
        .factory('StadiumOrderApiService', StadiumOrderApiService);
})();
(function() {

    'use strict';

    // @ngInject
    StadiumParserApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function StadiumParserApiService(DS, DSHttpAdapter, $q) {
        return {
            getParsedPlayers: getParsedPlayers
        };

        function getParsedPlayers(data) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumplayerparser';
            DSHttpAdapter.POST(url, {data: data}).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

    }

    angular
        .module('modules.stadiumParser', [])
        .factory('StadiumParserApiService', StadiumParserApiService);
})();
(function() {

    'use strict';

    // @ngInject
    StadiumPlacementsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function StadiumPlacementsApiService(DS, DSHttpAdapter, $q) {
        return {
            getPlacement: getPlacement,
            getColours: getColours,
            setTemplateOnPlayerGroup: setTemplateOnPlayerGroup,
            removePlayerGroup: removePlayerGroup
        };

        function getPlacement(placementId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumplacements/' + placementId;
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function setTemplateOnPlayerGroup(playerGroupId, templateId) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'stadiumplacements/' + playerGroupId + '/' + templateId)
                .then(function(response) {
                    deferred.resolve(response.data);
                }, function(error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function removePlayerGroup(playerGroupId) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'stadiumplacements/remove/' + playerGroupId)
                .then(function(response) {
                    deferred.resolve(response.data);
                }, function(error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function getColours() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'colours/standard')
                .then(function(response) {
                    deferred.resolve(response.data);
                }, function(error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }
    }

    angular
        .module('modules.stadiumPlacements', [])
        .factory('StadiumPlacementsApiService', StadiumPlacementsApiService);
})();

(function () {

    'use strict';

    // @ngInject
    StadiumProductService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function StadiumProductService(DS, DSHttpAdapter, $q) {
        var savedSearch = initialiseSearch(24);
        var savedSearchTemplatePicker = initialiseSearch(12);
        return {
            getProduct: getProduct,
            searchProducts: searchProducts,
            searchProductsTemplatePicker: searchProductsTemplatePicker,
            createMainTemplate: createMainTemplate,
            createTeamTemplate: createTeamTemplate,
            deleteTeamTemplate: deleteTeamTemplate,
            deleteMainTemplate: deleteMainTemplate,
            submitTemplate: submitTemplate,
            updateStadiumProduct: updateStadiumProduct,
            revertTemplateStatus: revertTemplateStatus,
            getClubs: getClubs,
            getSavedSearch: getSavedSearch,
            getSavedSearchTemplatePicker: getSavedSearchTemplatePicker,
            deleteProduct: deleteProduct
        };

        function initialiseSearch(pageSize) {
            return {
                searchText: '',
                selectedClubs: '',
                page: 1,
                pageSize: pageSize,
            };
        }

        function getSavedSearch() {
            return savedSearch;
        }

        function getSavedSearchTemplatePicker() {
            return savedSearchTemplatePicker;
        }

        function getProduct(id) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + id;

            return $q(function (resolve, reject) {
                DSHttpAdapter.GET(url)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function getClubs() {
            var url = DS.defaults.baseUrl + 'stadiumproducts/clubs';

            return DSHttpAdapter.GET(url)
                .then(function (response) {
                    return response.data;
                });
        }

        function searchProductsTemplatePicker(searchText, clubs, page, pageSize) {
            savedSearchTemplatePicker.searchText = searchText;
            savedSearchTemplatePicker.selectedClubs = clubs;
            savedSearchTemplatePicker.page = page;
            savedSearchTemplatePicker.pageSize = pageSize;

            return search(searchText, clubs, page, pageSize, true);
        }

        function searchProducts(searchText, clubs, page, pageSize) {
            savedSearch.searchText = searchText;
            savedSearch.selectedClubs = clubs;
            savedSearch.page = page;
            savedSearch.pageSize = pageSize;

            return search(searchText, clubs, page, pageSize, false);
        }

        function search(searchText, clubs, page, pageSize, readyOnly) {
            var params = {
                searchText: searchText || '',
                clubs: clubs || [],
                page: page,
                pageSize: pageSize,
                readyOnly: readyOnly
            };
            var url = DS.defaults.baseUrl + 'stadiumproducts/_search';

            return DSHttpAdapter.POST(url, params)
                .then(function (response) {
                    return response.data;
                });
        }

        function createMainTemplate(productId) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + productId + '/templates';

            var request = {
                team: null
            };
            return $q(function (resolve, reject) {
                DSHttpAdapter.POST(url, request)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function createTeamTemplate(productId, team) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + productId + '/templates';

            var request = {
                team: team
            };

            return $q(function (resolve, reject) {
                DSHttpAdapter.POST(url, request)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function deleteTeamTemplate(productId, templateId) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + productId + '/templates/' + templateId;

            return $q(function (resolve, reject) {
                DSHttpAdapter.DEL(url)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function deleteMainTemplate(productId) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + productId + '/templates';

            return $q(function (resolve, reject) {
                DSHttpAdapter.DEL(url)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function submitTemplate(productId, templateId) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + productId + '/templates/' + templateId + '/submit';

            return $q(function (resolve, reject) {
                DSHttpAdapter.POST(url)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function revertTemplateStatus(productId, templateId) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + productId + '/templates/' + templateId + '/revert';

            return $q(function (resolve, reject) {
                DSHttpAdapter.POST(url)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function updateStadiumProduct(id, sponsoring) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + id;
            var data = {
                sponsoring: sponsoring
            };

            return $q(function (resolve, reject) {
                DSHttpAdapter.PUT(url, data)
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function deleteProduct(id) {
            var url = DS.defaults.baseUrl + 'stadiumproducts/' + id;
            return DSHttpAdapter.DEL(url)
                .then(function (response) {
                    return response.data;
                });
        }
    }

    angular
        .module('modules.stadiumProducts', [])
        .factory('StadiumProductService', StadiumProductService);
})();

(function() {

    'use strict';

    // @ngInject
    StadiumStockApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function StadiumStockApiService(DS,DSHttpAdapter,$q) {
        return {
            updateStadiumStock: updateStadiumStock,
            getStadiumStock: getStadiumStock,
            setStocked: setStocked
        };

        function getStadiumStock(articleId, update) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumstock/' + articleId;
            var params = update ? {update: true} : {};
            DSHttpAdapter.GET(url, {params:params}).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updateStadiumStock(articleId, stadiumStock) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumstock/' + articleId;
            var data = {
                minimumStock: stadiumStock.minimumStock || "",
                refillVolume: stadiumStock.refillVolume || "",
            };

            DSHttpAdapter.PUT(url, data).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function setStocked(articleId) {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumstock/' + articleId + "/set";
            DSHttpAdapter.PUT(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.stadiumStock', [])
        .factory('StadiumStockApiService', StadiumStockApiService);
})();
(function() {

    'use strict';

    // @ngInject
    StadiumStoresApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function StadiumStoresApiService(DS, DSHttpAdapter, $q) {
        return {
            getStores: getStores
        };

        function getStores() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'stadiumstores';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

    }

    angular
        .module('modules.stadiumStores', [])
        .factory('StadiumStoresApiService', StadiumStoresApiService);
})();
(function() {

    'use strict';

    // @ngInject
    StockApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function StockApiService(DS,DSHttpAdapter,$q) {
        return {
            getStock: getStock
        };

        function getStock(articleId, update) {
            var deferred = $q.defer();
            var stockUrl = DS.defaults.baseUrl + 'stock/' + articleId;
            var params = update ? {update: true} : {};
            DSHttpAdapter.GET(stockUrl, {params:params}).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.stock', [])
        .factory('StockApiService', StockApiService);
})();
(function() {

    'use strict';

    // @ngInject
    TasksApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function TasksApiService(DS,DSHttpAdapter,$q) {
        return {
            getTasks: getTasks,
            changeTaskStatus: changeTaskStatus,
            getSystemStatus: getSystemStatus
        };

        function getTasks() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'jobs').then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function changeTaskStatus(taskName, taskAction) {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'jobs/' + taskName + "/" + taskAction).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getSystemStatus() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'healthcheck').then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.tasks', [])
        .factory('TasksApiService', TasksApiService);
})();
(function() {
    TemplatePriceApiService.$inject = ["DS", "DSHttpAdapter"];
    function TemplatePriceApiService(
        DS,
        DSHttpAdapter
    ) {
        return {
            getTemplatePrice: getTemplatePrice
        };


        function getTemplatePrice(templateId, quantity) {
            var url = DS.defaults.baseUrl + 'template-prices/' + templateId;
            if (quantity) {
                url += '?quantity=' + quantity;
            }
            return DSHttpAdapter.GET(url).then(function(response) {
                    return response.data;
                });
        }
    }

    angular
        .module('modules.templatePrices', [])
        .service('TemplatePriceApiService', TemplatePriceApiService);
})();

(function() {

    'use strict';

    // @ngInject
    TranslationsApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function TranslationsApiService(DS, DSHttpAdapter, $q) {
        return {
            getLanguages: getLanguages
        };

        function getLanguages() {
            var deferred = $q.defer();
            var url = DS.defaults.baseUrl + 'translations/';
            DSHttpAdapter.GET(url).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.translations', [])
        .factory('TranslationsApiService', TranslationsApiService);
})();

(function() {

    'use strict';

    // @ngInject
    UsersApiService.$inject = ["DS", "DSHttpAdapter", "$q"];
    function UsersApiService(DS,DSHttpAdapter,$q) {
        return {
            getSelf: getSelf,
            updateSelf: updateSelf
        };

        function getSelf() {
            var deferred = $q.defer();
            DSHttpAdapter.GET(DS.defaults.baseUrl + 'user').then(function (response) {
                deferred.resolve(DS.inject('user', response.data));
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function updateSelf(user) {
            var deferred = $q.defer();
            DSHttpAdapter.PUT(DS.defaults.baseUrl + 'user', user).then(function (response) {
                deferred.resolve(DS.inject('user', response.data));
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    }

    angular
        .module('modules.users', [])
        .factory('UsersApiService', UsersApiService);
})();
(function () {

    'use strict';

    // @ngInject
    BacksidePickerDialogService.$inject = ["$modal", "ArticlesApiService"];
    userResolve.$inject = ["AuthService"];
    BacksidePickerDialogController.$inject = ["$modalInstance", "ArticlesApiService", "article", "user", "state", "initQuantity"];
    function BacksidePickerDialogService($modal, ArticlesApiService) {
        return {
            showDialog: showDialog
        };

        function showDialog(articleId, initQuantity) {
            var backsidePickerDialog = {
                backdrop: 'static',
                controller: 'BacksidePickerDialogController as vm',
                templateUrl: 'services/backsidePickerDialog/backsidePickerDialog.tpl.html',
                windowClass: 'backside-picker-dialog',
                resolve: {
                    article: function () {
                        return ArticlesApiService.getById(articleId);
                    },
                    user: userResolve,
                    state: function () {
                        return 'default';
                    },
                    initQuantity: function() {
                        return initQuantity;
                    }
                }
            };
            return $modal.open(backsidePickerDialog).result;
        }
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function BacksidePickerDialogController(
        $modalInstance,
        ArticlesApiService,
        article,
        user,
        state,
        initQuantity
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.state = state;
        vm.article = article;
        vm.orderQuantity = 0;
        vm.minQuantity = 0;
        vm.minOrderQuantity = vm.minQuantity;
        vm.quantity = Math.max(vm.minQuantity, parseInt(article.refillVolume));
        vm.close = close;
        vm.isValid = isValid;
        vm.isOrderAvailable = isOrderAvailable;
        vm.continueButton = continueButton;
        vm.availableBacksides = availableBacksides;
        vm.addBackside = addBackside;
        vm.removeBackside = removeBackside;
        vm.submit = submit;
        vm.backsides = [];
        vm.selectedBackside = null;
        vm.selectedBacksides = [];
        vm.productType = null;
        vm.initQuantity = initQuantity;

        activate();

        function activate() {
            loadBacksides()
            .then(function () {
                if (vm.selectedBackside) {
                    // Try to find the currently selected backsides among the new backsides
                    vm.selectedBackside = vm.backsides.find(function (backside) {
                        return backside.id === vm.selectedBackside.id;
                    }) || vm.backside[0];
                } else {
                    vm.selectedBackside = vm.backsides[0];
                }
            });
        }

        function loadBacksides() {
            return ArticlesApiService.getProductBacksides(article.articleType).then(function(response) {
                vm.backsides = response;
            });
        }

        function addBackside() {
            if (!vm.selectedBackside) {
                return;
            }

            vm.selectedBackside.quantity = _.max([vm.initQuantity, vm.selectedBackside.minimumQuantity]);
            vm.selectedBacksides.push(vm.selectedBackside);
            vm.selectedBackside = null;
        }

        function availableBacksides() {
            if (!vm.selectedBacksides || vm.selectedBacksides && vm.selectedBacksides.length === 0) {
                return vm.backsides;
            }
            return _.differenceWith(vm.backsides, vm.selectedBacksides, _.isEqual);
        }

        function removeBackside(backsideToRemove) {
            if (!vm.selectedBacksides) {
                return;
            }
            if (vm.selectedBacksides.length === 1) {
                vm.selectedBacksides = [];
            } else {
                _.remove(vm.selectedBacksides, function (backside) {
                    return backside.id === backsideToRemove.id;
                });
            }
        }

        function continueButton() {
            $modalInstance.close();
        }

        function isValid() {
            return vm.quantity >= vm.minQuantity && vm.orderQuantity >= vm.minOrderQuantity;
        }

        function isOrderAvailable() {
            return vm.user.orderProject !== null && vm.user.orderReference !== null;
        }

        function submit() {
            $modalInstance.close({ selectedBacksides: vm.selectedBacksides, article: vm.article });
        }

        function close() {
            $modalInstance.dismiss();
        }

    }

    angular
        .module('services.backsidePickerDialog', [])
        .service('BacksidePickerDialogService', BacksidePickerDialogService)
        .controller('BacksidePickerDialogController', BacksidePickerDialogController);
})();

(function () {

    'use strict';

    // @ngInject
    ColorPickerDialogService.$inject = ["$modal"];
    ColorPickerDialogController.$inject = ["$modalInstance", "data"];
    function ColorPickerDialogService($modal) {

        return {
            showDialog: showDialog
        };

        function showDialog(data) {
            data = data || {};
            data.colors = data.colors || [];
            data.selectedColors = data.selectedColors || [];
            data.maxColors = data.maxColors || 0;

            var modalDefaults = {
                backdrop: 'static',
                controller: "ColorPickerDialogController as vm",
                templateUrl: "services/colorPickerDialog/colorPickerDialog.tpl.html",
                resolve: {
                    data: function () {
                        return data;
                    }
                }
            };

            return $modal.open(modalDefaults).result;
        }
    }

    // @ngInject
    function ColorPickerDialogController($modalInstance, data) {
        var vm = this;
        vm.validationErrors = [];
        vm.colors = data.colors;
        vm.maxColors = data.maxColors;
        vm.selectedColors = data.selectedColors;
        vm.customColors = data.customColors;
        vm.toggleColor = toggleColor;
        vm.isSelected = isSelected;
        vm.close = close;

        function toggleColor(color) {
            if (vm.maxColors === 1) {
                if (isSelected(color)) {
                    vm.selectedColors = [];
                } else {
                    vm.selectedColors = [color];
                }
            }
            else {
                if (isSelected(color)) {
                    vm.selectedColors = _.filter(vm.selectedColors, function (c) {
                        return !colorsEqual(c, color);
                    });
                } else if (vm.selectedColors.length < vm.maxColors) {
                    vm.selectedColors.push(color);
                }
            }
        }

        function close() {
            $modalInstance.close(vm.selectedColors);
        }

        function isSelected(color) {
            return _.some(vm.selectedColors, function (selectedColor) {
                return colorsEqual(selectedColor, color);
            });
        }

        function colorsEqual(color1, color2) {
            return color1.name === color2.name && color1.code === color2.code;
        }
    }

    angular
        .module('services.colorPickerDialog', [])
        .service('ColorPickerDialogService', ColorPickerDialogService)
        .controller('ColorPickerDialogController', ColorPickerDialogController);
})();
(function () {

    'use strict';
    
    function ColorConverter() {
        function rgbToHex(rgb) {
            if (rgb === null || rgb === '') {
                return rgb;
            }

            var hex = rgb.b | (rgb.g << 8) | (rgb.r << 16);
            return '#' + (0x1000000 + hex).toString(16).slice(1);
        }

        function rgbFromString(rgbString) {
            try {
                var regex = /\d+/g;
                return { r: regex.exec(rgbString)[0], g: regex.exec(rgbString)[0], b: regex.exec(rgbString)[0] };
            }
            catch (error) {
                // Suppress
                return null;
            }
        }

        function hexToRgb(hex) {
            // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        }
        
        function rgbToLab(rgb) {
            var r = rgb.r / 255,
                g = rgb.g / 255,
                b = rgb.b / 255,
                x, y, z;

            r = (r > 0.04045) ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = (g > 0.04045) ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = (b > 0.04045) ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;

            x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
            y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.00000;
            z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;

            x = (x > 0.008856) ? Math.pow(x, 1/3) : (7.787 * x) + 16/116;
            y = (y > 0.008856) ? Math.pow(y, 1/3) : (7.787 * y) + 16/116;
            z = (z > 0.008856) ? Math.pow(z, 1/3) : (7.787 * z) + 16/116;

            return { L: (116 * y) - 16, A: 500 * (x - y), B: 200 * (y - z) };
        }

        return {
            rgbFromString: rgbFromString,
            rgbToHex: rgbToHex,
            hexToRgb: hexToRgb,
            rgbToLab: rgbToLab
        };
    }

    angular.module('color.converter', []).factory('ColorConverter', ColorConverter);

})();
(function () {

    'use strict';

    colorFinder.$inject = ["ColorConverter"];
    function colorFinder(ColorConverter) {
        function findClosest(sourceColor, targetColors) {
            if (sourceColor.code === null || sourceColor.code === '') {
                return null;
            }

            var sourceHex = sourceColor.code.replace(/^#+/g, '');
            var baseColor = {
                name: sourceColor.name,
                code: sourceColor.code,
                hex: '#' + sourceHex,
                rgb: ColorConverter.hexToRgb('#' + sourceHex)
            };
            baseColor.lab = ColorConverter.rgbToLab(baseColor.rgb);

            var resultList = [];
            _.each(targetColors, function (targetColor) {
                var targetHex = targetColor.code.replace(/^#+/g, '');
                var color = {
                    name: targetColor.name,
                    code: targetColor.code,
                    hex: '#' + targetHex,
                    rgb: ColorConverter.hexToRgb('#' + targetHex)
                };
                color.lab = ColorConverter.rgbToLab(color.rgb);
                color.delta = DeltaE.getDeltaE76(baseColor.lab, color.lab);

                resultList.push(color);
            });

            return _.sortBy(resultList, ['delta']);
        }

        return {
            findClosest: findClosest
        };
    }

    angular.module('color.finder', []).factory('ColorFinder', colorFinder);

})();
(function () {

    'use strict';

    angular.module('color.tools', ['color.finder', 'color.converter']);

})();
(function() {
    'use strict';

    // @ngInject
    ConfirmDialogService.$inject = ["$modal"];
    ConfirmDialogController.$inject = ["$modalInstance", "title", "question", "buttons"];
    function ConfirmDialogService($modal) {
        return {
            showDialog: showDialog
        };

        function showDialog(title, question, buttons) {
            var modalDefaults = {
                backdrop: 'static',
                controller: "ConfirmDialogController as vm",
                templateUrl: "services/confirmDialog/confirmDialog.tpl.html",
                resolve: {
                    title: function() {
                        return title || {};
                    },
                    question: function() {
                        return question || {};
                    },
                    buttons: function() {
                        return buttons || [];
                    }
                }
            };

            return $modal.open(modalDefaults).result;
        }
    }

    // @ngInject
    function ConfirmDialogController ($modalInstance, title, question, buttons) {
        var vm = this;
        vm.title = title;
        vm.question = question;
        vm.buttons = buttons;
        vm.onClickButton = onClickButton;
        vm.cancel = cancel;

        function cancel() {
            $modalInstance.dismiss();
        }
        
        function onClickButton(button) {
            $modalInstance.close(button);
        }
    }

    angular
        .module('services.confirmDialog', [])
        .service('ConfirmDialogService', ConfirmDialogService)
        .controller('ConfirmDialogController', ConfirmDialogController);
})();
(function() {

    'use strict';

    CookieConsentDialogController.$inject = ["CookieConsentService"];
    function CookieConsentDialogController(CookieConsentService) {
        var vm = this;
        vm.onClickClose = onClickClose;
        vm.onClickGiveConsent = onClickGiveConsent;
        
        function onClickClose() {
            CookieConsentService.closeDialog(false);
        }

        function onClickGiveConsent() {
            CookieConsentService.closeDialog(true);
        }
    }

    angular
        .module('cookieConsentDialog', [])
        .controller('CookieConsentDialogController', CookieConsentDialogController);
})();

(function() {

    'use strict';

    cookieConsentService.$inject = ["$modal", "$cookieStore", "$cookies", "DSHttpAdapter", "ErrorLogService"];
    function cookieConsentService($modal, $cookieStore, $cookies, DSHttpAdapter, ErrorLogService){
        var _dialog = null;
        var COOKIE_NAME = "tokyo-cookie-consent";

        var service = {
            createCookie: createCookie,
            clearCookie: clearCookie,
            getCookie: getCookie,
            tryShowDialog: tryShowDialog,
            showDialog: showDialog,
            closeDialog: closeDialog,
            doesCookieExist: doesCookieExist,
        };

        return service;

        function tryShowDialog() {
            if (!doesCookieExist()) {
                showDialog();
            }
        }

        function showDialog() {
            var cookieConsentDialog = {
                backdrop: false,
                controller: 'CookieConsentDialogController as vm',
                templateUrl: 'services/cookieConsent/cookieConsentDialog/cookieConsentDialog.tpl.html'
            };
            _dialog = $modal.open(cookieConsentDialog);
        }

        function closeDialog(hasGivenConsent) {
            clearCookie();
            createCookie(hasGivenConsent);
            _dialog.close();
        }

        function clearCookie() {
            // Special for IE
            document.cookie = COOKIE_NAME + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;';
            $cookieStore.remove(COOKIE_NAME);
        }

        function createCookie(hasGivenConsent) {
            var date = new Date();
            var oneDayInSeconds = 24 * 60 * 60;
            var oneYearInSeconds = 24 * 60 * 60 * 365;
            var expireSeconds = hasGivenConsent ? oneYearInSeconds : oneDayInSeconds;
            var expireTime = date.setSeconds(date.getSeconds() + expireSeconds);
            date.setTime(expireTime);
            document.cookie = COOKIE_NAME + '=' + hasGivenConsent + ';expires=' + date.toGMTString() + ';';
        }

        function getCookie() {
            return $cookies[COOKIE_NAME];
        }

        function doesCookieExist() {
            return !!getCookie();
        }
    }

    angular
        .module('services.cookieConsentService', [])
        .factory('CookieConsentService', cookieConsentService);
})();
(function() {

    'use strict';

    // @ngInject
    CustomerPickerDialogService.$inject = ["$modal"];
    CustomerPickerDialogController.$inject = ["CustomersApiService", "$modalInstance", "$timeout", "loadSpinnerService"];
    function CustomerPickerDialogService ($modal) {
        return {
            showDialog: showDialog
        };

        function showDialog(){
            var modalDefaults = {
                backdrop: 'static',
                controller: "CustomerPickerDialogController as vm",
                templateUrl: "services/customerPickerDialog/customerPickerDialog.tpl.html",
            };
            return $modal.open(modalDefaults).result;
        }
    }

    // @ngInject
    function CustomerPickerDialogController (CustomersApiService, $modalInstance, $timeout, loadSpinnerService) {
        var vm = this;
        vm.customers = [];
        vm.employees = [];
        vm.selectedCustomer = null;
        vm.selectedEmployee = {};
        vm.onCustomerSelect = onCustomerSelect;
        vm.onEmployeeSelect = onEmployeeSelect;
        vm.close = close;
        vm.dismiss = dismiss;

        activate();

        function activate() {
            loadSpinnerService.start();
            CustomersApiService.getAll().then(function(customers) {
                vm.customers = customers;
                loadSpinnerService.stop();
                focusSelect('.select-customer');
            });
        }

        function onCustomerSelect(customer) {
            vm.selectedCustomer = customer;
            loadSpinnerService.start();
            return CustomersApiService.getById(customer.id).then(function(employees) {
                vm.employees = employees || [];
                vm.selectedEmployee = vm.employees.length === 0 ? null : vm.employees[0];
                loadSpinnerService.stop();
                focusSelect('.select-employee');
            });
        }

        function onEmployeeSelect(employee) {
            vm.selectedEmployee = employee;
            $timeout(function() {document.querySelector('.choose').focus();});
        }

        function close() {
            if (vm.selectedCustomer && vm.selectedEmployee) {
                $modalInstance.close({customer: vm.selectedCustomer, employee: vm.selectedEmployee});
            } else {
                $modalInstance.dismiss();
            }
        }

        function dismiss() {
            $modalInstance.dismiss();
        }

        function focusSelect(selectClass) {
            var node = document.querySelector(selectClass);
            if (node) {
                var uiSelect = angular.element(node).controller('uiSelect');
                uiSelect.focusser[0].focus();
                uiSelect.activate();
            } else {
                $timeout(function() {focusSelect(selectClass);});
            }
        }
    }

    angular
        .module('services.customerPickerDialog', [])
        .service('CustomerPickerDialogService', CustomerPickerDialogService)
        .controller('CustomerPickerDialogController', CustomerPickerDialogController);
})();
(function() {
    'use strict';

    // @ngInject
    EmailDialogService.$inject = ["$modal", "EmailApiService"];
    EmailDialogController.$inject = ["$modalInstance", "toastr", "loadSpinnerService", "EmailApiService", "ConfirmDialogService", "data", "templates", "mode"];
    function EmailDialogService ($modal, EmailApiService) {
        return {
            showErrandEmailDialog: showErrandEmailDialog,
            showMountingEmailDialog: showMountingEmailDialog
        };

        function showErrandEmailDialog(data) {
            var modalDefaults = {
                backdrop: 'static',
                controller: "EmailDialogController as vm",
                templateUrl: "services/emailDialog/emailDialog.tpl.html",
                resolve: {
                    data: function() {
                        return data;
                    },
                    templates: function() {
                        return EmailApiService.getErrandTemplates(data.errandId);
                    },
                    mode: function() {
                        return 'ERRAND';
                    }
                }
            };
            return $modal.open(modalDefaults).result;
        }

        function showMountingEmailDialog(data) {
            var modalDefaults = {
                backdrop: 'static',
                controller: "EmailDialogController as vm",
                templateUrl: "services/emailDialog/emailDialog.tpl.html",
                resolve: {
                    data: function() {
                        return data;
                    },
                    templates: function() {
                        return EmailApiService.getMountingTemplates(data.mountingId);
                    },
                    mode: function() {
                        return 'MOUNTING';
                    }
                }
            };
            return $modal.open(modalDefaults).result;
        }
    }

    // @ngInject
    function EmailDialogController($modalInstance, toastr, loadSpinnerService, EmailApiService, ConfirmDialogService,
                                   data, templates, mode) {
        var vm = this;
        vm.cancel = cancel;
        vm.save = save;
        vm.reply = reply;
        vm.addRecipient = addRecipient;
        vm.onTemplateSelect = onTemplateSelect;
        vm.isReady = isReady;
        vm.isNew = isNew;
        vm.subject = "";
        vm.body = "";
        vm.recipients = [];
        vm.templates = templates;
        vm.readOnly = false;
        vm.visibility = {};
        vm.replyMode = false;
        vm.replyBody = "";

        activate();

        function activate() {
            if (data.email) {
                vm.subject = data.email.subject;
                vm.body = data.email.body;
                vm.recipients = data.email.recipients;
                vm.readOnly = data.email.status !== 'DRAFT';
                angular.forEach(templates, function (template) {
                    vm.selectedTemplate = (template.name === data.email.template) ? template : vm.selectedTemplate;
                });
                if(data.reply) {
                    vm.replyMode = true;
                    vm.replyBody = vm.body;
                }
            } else {
                vm.recipients = [data.recipient];
                angular.forEach(templates, function (template) {
                    vm.selectedTemplate = (template.name === data.templateName) ? template : vm.selectedTemplate;
                });
                onTemplateSelect();
            }
            vm.visibility = {
                showSkip: 'ERRAND' === data.templateName || 'PROOF' === data.templateName,
                showSaveDraft: !data.email || 'DRAFT' === data.email.status,
                showSend: !data.email || 'DRAFT' === data.email.status,
                showReply: data.email && data.email.status === 'RECEIVED' && data.errandStatus && data.errandStatus !== "CLOSED",
                showClose: 'ERRAND' !== data.templateName && 'PROOF' !== data.templateName,
                showTemplate: !data.email || 'DRAFT' === data.email.status
            };
            vm.body = removeHtmlLineBreaks(vm.body);
        }

        function removeHtmlLineBreaks(text) {
            return text.split("<br/>").join("\r\n");
        }

        function onTemplateSelect() {
            if(vm.replyMode) {
                vm.body = removeHtmlLineBreaks(vm.selectedTemplate.body) + vm.replyBody;
            } else {
                vm.subject = vm.selectedTemplate.subject;
                vm.body = removeHtmlLineBreaks(vm.selectedTemplate.body);
            }
        }

        function addRecipient(tag) {
            if(tag) {
                var recipients = tag.split(',');
                _.forEach(recipients, function (recipient) {
                    if(!vm.recipients.includes(recipient.trim())) {
                        vm.recipients.push(recipient.trim());
                    }
                });
            }
        }

        function cancel() {
            var dirty = false;
            if (data.email && 'DRAFT' === data.email.status) {
                dirty = dirty || data.email.subject !== vm.subject;
                dirty = dirty || removeHtmlLineBreaks(data.email.body) !== vm.body;
                dirty = dirty || !_.isEqual(data.email.recipients.sort(), vm.recipients.sort());
            } else if (!data.email) {
                dirty = dirty || vm.selectedTemplate.subject !== vm.subject;
                dirty = dirty || vm.selectedTemplate.body !== vm.body;
                dirty = dirty || !_.isEqual([data.recipient], vm.recipients);
            }
            if (dirty) {
                var buttons = [{ name: 'BUTTON.NO', class: 'btn-default'}, { name: 'BUTTON.YES', class: 'btn-success'}];
                ConfirmDialogService.showDialog('EMAILPOPUP.WARNTITLE', 'EMAILPOPUP.WARNTEXT', buttons).then(function(button) {
                    if (button.name === 'BUTTON.YES') {
                        $modalInstance.dismiss();
                    }
                });
            } else {
                $modalInstance.dismiss();
            }
        }

        function isReady() {
            return vm.recipients.length > 0 && vm.subject && vm.body;
        }

        function isNew() {
            var result = true;
            if(data.email) {
                result = data.email.status !== 'RECEIVED' && data.email.status !== 'SENT';
            }
            return result;
        }

        function save(status) {
            var email = {
                recipients: vm.recipients,
                subject: vm.subject,
                body: vm.body,
                status: status
            };
            if (vm.selectedTemplate) {
                email.template = vm.selectedTemplate.name;
            }
            loadSpinnerService.start();
            var result = saveEmail(email);
            result.then(function() {
                $modalInstance.close();
            }, function(error) {
                if (error && error.data && error.data.message) {
                    toastr.error(error.data.message);
                }
            }).finally(function() {
                loadSpinnerService.stop();
            });
        }

        function reply() {
            data.reply = true;
            data.email = {
                recipients: vm.recipients,
                subject: "RE: " + vm.subject,
                body: "\n\n\n-------------------------\n\n\n" + vm.body,
                status: "DRAFT"
            };

            activate();
        }

        function saveEmail(email) {
            var result = null;
            if ('ERRAND' === mode) {
                if(data.email && data.email.emailId) {
                    result = EmailApiService.updateErrandEmail(data.errandId, data.email.emailId, email);
                } else {
                    result = EmailApiService.createErrandEmail(data.errandId, email);
                }
            }
            if ('MOUNTING' === mode) {
                if(data.email && data.email.emailId) {
                    result = EmailApiService.updateMountingEmail(data.mountingId, data.email.emailId, email);
                }
                else {
                    result = EmailApiService.createMountingEmail(data.mountingId, email);
                }
            }
            return result;
        }
    }
    angular
        .module('services.emailDialog', [])
        .service('EmailDialogService', EmailDialogService)
        .controller('EmailDialogController', EmailDialogController);
})();
(function() {

    'use strict';

    // @ngInject
    ErrorLogService.$inject = ["$injector"];
    function ErrorLogService($injector){

        var service = {
            init: init,
            logException: logException,
            setUser: setUser
        };

        return service;

        function init(options){
            options = options || {};

            Raygun.init(options.apiKey).attach().withTags(['frontend']);
            Raygun.setVersion(options.version);
        }

        function logException(exception, cause){
            var state = $injector.get('$state');

            Raygun.send(exception, { cause: cause,state: state.current });
        }

        function setUser(user) {
            if(user === null) {
                Raygun.resetAnonymousUser();
            }else{
                Raygun.setUser(user.email,false);
            }

        }
    }

    angular
        .module('errorLog', [])
        .service('ErrorLogService', ErrorLogService);
})();
(function () {

    'use strict';

    GarmentPickerService.$inject = ["$modal"];
    GarmentPickerDialogController.$inject = ["$modalInstance", "garments"];
    function GarmentPickerService($modal) {

        garmentsResolve.$inject = ["GarmentsApiService"];
        return {
            showDialog: showDialog
        };

        function showDialog() {
            return $modal.open({
                controller: 'GarmentPickerDialogController',
                controllerAs: 'vm',
                templateUrl: 'services/garmentPicker/garmentPicker.tpl.html',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    garments: garmentsResolve
                }
            }).result;
        }

        // @ngInject
        function garmentsResolve(GarmentsApiService) {
            return GarmentsApiService.getGarments();
        }
    }

    function GarmentPickerDialogController($modalInstance, garments) {
        var vm = this;
        vm.garments = [];
        vm.select = select;
        vm.close = close;

        initialize();

        function initialize() {
            loadGarments(garments);
        }

        function loadGarments(garments) {
            vm.garments = [];
            angular.forEach(garments, function (value, key) {
                vm.garments.push(key);
            });
        }

        function select(garment) {
            $modalInstance.close(garment);
        }

        function close() {
            $modalInstance.dismiss();
        }
    }

    angular
        .module('services.garmentPicker', [])
        .service('GarmentPickerService', GarmentPickerService)
        .controller('GarmentPickerDialogController', GarmentPickerDialogController);
})();

(function() {

    'use strict';

    function HelperService(){

        this.getChangedData = function(original,edited,values) {
            return this.findDiff(_.pick(original, values), edited);
        };

        this.findDiff = function(original, edited) {
            var diff = {};
            for (var key in original) {
                if (original[key] !== edited[key]){ diff[key] = edited[key];}
            }
            return diff;
        };

        this.createArrayDiffs = function(oldArray, newArray, sameId) {

            var ArrayDiffEntry = (function () {
                function ArrayDiffEntry(position, oldValue, newValue) {
                    this.position = position;
                    this.oldValue = oldValue;
                    this.newValue = newValue;
                }
                ArrayDiffEntry.prototype.changeType = function () {
                    if (angular.isUndefined(this.oldValue))
                    {return 0 /* Addition */;}
                    if (angular.isUndefined(this.newValue))
                    {return 1 /* Removal */;}
                };

                return ArrayDiffEntry;
            })();

            if (angular.isUndefined(sameId)) {
                sameId = angular.equals;
            } else if (_.isString(sameId)) {
                var idFieldName = sameId;
                sameId = function (o1, o2) {
                    return o1[idFieldName] === o2[idFieldName];
                };
            }

            var arrayDiffs = [];

            function arrayIndexOf(array, element, index) {
                for (var i = index; i < array.length; i++) {
                    if (sameId(array[i], element))
                    {return i;}
                }
                return -1;
            }

            var oldArrayCopy = oldArray ? oldArray.slice() : [];

            var index = 0;
            var i;
            for (i = 0; i < newArray.length; i++) {
                var newValue = newArray[i];
                // If we are at end of old array, just add it
                if (oldArrayCopy.length <= index) {
                    arrayDiffs.push(new ArrayDiffEntry(index, undefined, newValue));
                } else {
                    var done;
                    do {
                        done = true;
                        var oldValue = oldArrayCopy[index];
                        if (!sameId(oldValue, newValue)) {
                            // Id mismatch, try to find the old index of the new value
                            var oldIndexOfNewValue = arrayIndexOf(oldArrayCopy, newValue, index);

                            if (oldIndexOfNewValue !== -1) {
                                // We have found an index, lets check if there is a new index for the old value
                                var newIndexOfOldValue = arrayIndexOf(newArray, oldValue, index);

                                if (newIndexOfOldValue === -1) {
                                    // The old value doesn't exist in the new array, delete it
                                    arrayDiffs.push(new ArrayDiffEntry(index, oldValue, undefined));
                                    oldArrayCopy.splice(index, 1);
                                    done = false;
                                } else if (newIndexOfOldValue > oldIndexOfNewValue) {
                                    // The new index for the old value is bigger than the old index of the new value
                                    if (oldArrayCopy.length <= newIndexOfOldValue) {
                                        // Place the old value last
                                        newIndexOfOldValue = oldArrayCopy.length - 1;
                                    }
                                    // Delete the old value
                                    arrayDiffs.push(new ArrayDiffEntry(index, oldValue, undefined));
                                    oldArrayCopy.splice(index, 1);

                                    // Insert the old value at new position
                                    arrayDiffs.push(new ArrayDiffEntry(newIndexOfOldValue, undefined, oldValue));
                                    oldArrayCopy.splice(newIndexOfOldValue, 0, oldValue);
                                    done = false;
                                } else {
                                    // The new index for the old value is not bigger
                                    // Delete the old placement of the new value
                                    arrayDiffs.push(new ArrayDiffEntry(oldIndexOfNewValue, newValue, undefined));
                                    oldArrayCopy.splice(oldIndexOfNewValue, 1);

                                    // Insert the the new value at the current index
                                    arrayDiffs.push(new ArrayDiffEntry(index, undefined, newValue));
                                    oldArrayCopy.splice(index, 0, newValue);
                                }
                            } else {
                                // No index was found, add it at the current index
                                oldArrayCopy.splice(index, 0, newValue);
                                arrayDiffs.push(new ArrayDiffEntry(index, undefined, newValue));
                            }
                        }
                    } while(!done);
                }
                index++;
            }
            for (i = oldArrayCopy.length; i > index;) {
                arrayDiffs.push(new ArrayDiffEntry(--i, oldArrayCopy[i], undefined));
            }

            return arrayDiffs;
        };
    }

    angular
        .module('helper', [])
        .service('HelperService', HelperService);
})();
(function () {

    // @ngInject
    LogoImageDialogService.$inject = ["$modal"];
    userResolve.$inject = ["AuthService"];
    logoImageResolve.$inject = ["LogoImageApiService"];
    logoDialogUploadController.$inject = ["$modalInstance", "$translate", "toastr", "LogoImageApiService", "LogoImageDialogService", "ConfirmDialogService", "user", "logoImages", "colourType"];
    LogoDialogEditController.$inject = ["$modalInstance", "$scope", "$timeout", "$translate", "toastr", "logoImage", "colorType", "LogoImageApiService", "ArticlesApiService", "LogoImageDialogService", "ColorConverter", "ColorFinder", "ColorPickerDialogService"];
    LogoDialogSaveAsController.$inject = ["$modalInstance"];
    function LogoImageDialogService($modal) {
        return {
            showDialog: showDialog,
            showEditDialog: showEditDialog,
            showSaveAsDialog: showSaveAsDialog
        };

        function showDialog(colourType) {
            return $modal.open({
                templateUrl: 'services/logoImageDialog/logoDialog-upload.tpl.html',
                controller: logoDialogUploadController,
                controllerAs: 'vm',
                resolve: {
                    user: userResolve,
                    logoImages: logoImageResolve,
                    colourType: function () {
                        return colourType;
                    }
                },
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            }).result;
        }

        function showEditDialog(logoImage, colorType) {
            return $modal.open({
                templateUrl: 'services/logoImageDialog/logoDialog-edit.tpl.html',
                controller: LogoDialogEditController,
                controllerAs: 'vm',
                resolve: {
                    logoImage: function () {
                        return logoImage;
                    },
                    colorType: function () {
                        return colorType;
                    }
                },
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            }).result;
        }

        function showSaveAsDialog() {
            return $modal.open({
                templateUrl: 'services/logoImageDialog/logoDialog-saveAs.tpl.html',
                controller: LogoDialogSaveAsController,
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false
            }).result;
        }
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function logoImageResolve(LogoImageApiService) {
        return LogoImageApiService.getAll();
    }

    function logoDialogUploadController(
        $modalInstance,
        $translate,
        toastr,
        LogoImageApiService,
        LogoImageDialogService,
        ConfirmDialogService,
        user,
        logoImages,
        colourType
    ) {
        var vm = this;

        vm.acceptableFormats = '.ai, .eps, .ps';

        // Upload
        vm.user = user;
        vm.colourType = colourType;
        vm.uploadImage = null;
        vm.uploadImageName = '';
        vm.logoImageName = '';
        vm.nameError = false;
        vm.fileError = false;

        // Status
        vm.processing = false;
        vm.error = false;
        vm.errorMessages = [];

        // Image selection
        vm.allCustomerImages = logoImages ? logoImages : [];
        vm.filteredImages = [];
        vm.maxSizeImagePage = 8;
        vm.currentImagePage = 1;
        vm.filterText = '';

        vm.onFileSelect = onFileSelect;
        vm.getFilteredImages = getFilteredImages;
        vm.saveImage = saveImage;
        vm.getImageUrl = getImageUrl;
        vm.selectImage = selectImage;
        vm.dismiss = dismiss;
        vm.close = close;
        vm.editImage = editImage;
        vm.removeImage = removeImage;

        function onFileSelect(file) {
            if (file) {
                vm.uploadImageName = file.name;
                if (!vm.logoImageName) {
                    vm.logoImageName = file.name.replace(/\..+$/, '');
                }
                vm.fileError = false;
            }
            return !!file;
        }

        function getFilteredImages(filterText) {
            if (filterText) {
                vm.filteredImages = _.filter(vm.allCustomerImages, function (image) {
                    return image.name.toLowerCase().startsWith(filterText.toLowerCase().trim());
                });
                return vm.filteredImages.slice(((vm.currentImagePage - 1) * vm.maxSizeImagePage), ((vm.currentImagePage) * vm.maxSizeImagePage));
            } else {
                vm.filteredImages = vm.allCustomerImages;
                return vm.allCustomerImages.slice(((vm.currentImagePage - 1) * vm.maxSizeImagePage), ((vm.currentImagePage) * vm.maxSizeImagePage));
            }
        }

        function saveImage() {
            if (!validateForm()) {
                return;
            }

            var logoImage = {
                name: vm.logoImageName,
                file: vm.uploadImage
            };

            vm.error = false;
            vm.errorMessages = [];
            vm.processing = true;
            LogoImageApiService.create(logoImage).then(function (logoImageEntity) {
                LogoImageDialogService.showEditDialog(logoImageEntity, vm.colourType).then(function () {
                    loadLogoImages();
                });
            }).catch(function (errors) {
                vm.error = true;

                if (errors.status < 400 || errors.status >= 500) {
                    throw errors;
                }

                _.each(errors.data, function (error) {
                    if (error.code === 'LOGO_IMAGE_INVALID_FORMAT') {
                        vm.errorMessages.push($translate.instant('ERROR.LOGO_IMAGE_INVALID_FORMAT', {format: error.data}));
                    } else {
                        vm.errorMessages.push($translate.instant('ERROR.' + error.code));
                    }
                });

            }).catch(function (error) {
                vm.errorMessages.push($translate.instant('MESSAGE.SAVEFAIL'));
                throw error;
            }).finally(function () {
                vm.processing = false;

                if (!vm.error) {
                    resetForm();
                }
            });
        }

        function getImageUrl(filename) {
            return LogoImageApiService.getImageUrl(filename);
        }

        function loadLogoImages() {
            LogoImageApiService.getAll().then(function (logoImages) {
                vm.allCustomerImages = logoImages;
            });
        }

        function selectImage(image) {
            $modalInstance.close(image);
        }

        function editImage(image) {
            LogoImageDialogService.showEditDialog(image, vm.colourType).then(function (logoImage) {
                $modalInstance.close(logoImage);
            });
        }

        function removeImage(image) {
            var buttons = [{name: 'BUTTON.NO', class: 'btn-default'}, {name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('LOGO.IMAGE.REMOVE.TITLE', 'LOGO.IMAGE.REMOVE.DESCRIPTION', buttons)
                .then(function (button) {
                    if (button.name === 'BUTTON.YES') {
                        LogoImageApiService.archive(image.logoImageId)
                            .then(function () {
                                loadLogoImages();
                            })
                            .catch(function (errors) {
                                handleValidationErrors(errors);
                            });
                    }
                });

        }

        function dismiss() {
            $modalInstance.dismiss();
        }

        function close() {
            $modalInstance.dismiss();
        }

        // Utility
        function resetForm() {
            vm.uploadImage = null;
            vm.uploadImageName = '';
            vm.logoImageName = '';
            vm.fileError = false;
            vm.nameError = false;
        }

        function validateForm() {
            vm.nameError = !vm.logoImageName;
            if (!vm.uploadImage) {
                vm.fileError = true;
            }
            return !(vm.nameError || vm.fileError);
        }

        function handleValidationErrors(errors) {
            _.each(errors.data, function (error) {
                toastr.error($translate.instant('ERROR.' + error.code));
            });
        }
    }

    function LogoDialogEditController(
        $modalInstance,
        $scope,
        $timeout,
        $translate,
        toastr,
        logoImage,
        colorType,
        LogoImageApiService,
        ArticlesApiService,
        LogoImageDialogService,
        ColorConverter,
        ColorFinder,
        ColorPickerDialogService
    ) {
        var vm = this;
        vm.logoImage = logoImage;
        vm.colourType = colorType;
        vm.selectedColour = null;
        vm.processing = false;
        vm.svgData = '';
        vm.originalHeight = 0;
        vm.originalWidth = 0;
        vm.maxWidth = 400;
        vm.maxHeight = 400;
        vm.allColours = [];
        vm.productColours = [];
        vm.logoColours = [];
        vm.selectedColours = [];
        vm.maxSelectedColours = 1;
        vm.customColour = [];
        vm.acceptableDelta = 0.2;
        vm.logoColoursStates = [];

        vm.addColour = addColour;
        vm.applyColour = applyColour;
        vm.showColourConfiguration = showColourConfiguration;
        vm.validateColours = validateColours;
        vm.openColourPicker = openColourPicker;
        vm.reset = reset;
        vm.undo = undo;
        vm.save = save;
        vm.saveAs = saveAs;
        vm.cancel = cancel;
        vm.close = close;

        loadColours();
        getSvgData();

        function getSvgData() {
            LogoImageApiService.getSourceImage(vm.logoImage.logoImageId).then(function (svg) {
                svg = DOMPurify.sanitize(svg);
                var element = angular.element(document.querySelector('#svg-container'));
                element.html(svg);

                var svgElem = document.querySelector('svg');
                var svgRect = svgElem.getBoundingClientRect();

                vm.originalWidth = svgRect.width;
                vm.originalHeight = svgRect.height;

                setDimensions(svgElem);

                vm.svgData = svg;
                scanImageColours(svgElem);
            }, function (errors) {
                if (errors && errors.data) {
                    _.each(errors.data, function (error) {
                        if (error.code) {
                            toastr.error($translate.instant('ERROR.' + error.code));
                        }
                    });
                } else {
                    throw errors;
                }

                $modalInstance.dismiss();
            });
        }

        function setDimensions(svgElem) {
            var height = 0;
            var width = 0;
            var shouldAdjust = false;
            var multiplier = 0;

            if (parseFloat(vm.originalHeight) > parseFloat(vm.originalWidth)) {
                multiplier = vm.maxHeight / vm.originalHeight;
                if (parseFloat(vm.originalHeight) > parseFloat(vm.maxHeight)) {
                    shouldAdjust = true;
                }
            } else {
                multiplier = vm.maxWidth / vm.originalWidth;
                if (parseFloat(vm.originalWidth) > parseFloat(vm.maxWidth)) {
                    shouldAdjust = true;
                }
            }

            if (shouldAdjust) {
                height = vm.originalHeight * multiplier;
                width = vm.originalWidth * multiplier;
            } else {
                height = vm.originalHeight;
                width = vm.originalWidth;
            }

            svgElem.setAttribute('width', width);
            svgElem.setAttribute('height', height);
            svgElem.preserveAspectRatio = 'XMidYMid meet';
        }

        function loadColours() {
            // Reset all
            vm.allColours = [];
            vm.productColours = [];
            vm.logoColours = [];
            vm.selectedColours = [];

            // Product type colors
            ArticlesApiService.getColors(vm.colourType.toLowerCase()).then(function (productColours) {
                _.each(productColours, function (productColour) {
                    productColour.code = productColour.code.toLowerCase();
                });
                vm.productColours = productColours;
            });
        }

        function applyColour(colour) {
            var _colour = getColour(colour);
            // Find and set
            var logoColour = _.find(vm.logoColours, function (logoColour) {
                if (logoColour.code && logoColour.code === vm.selectedColour.code) {
                    return logoColour;
                }
            });
            logoColour.tokyoColour = _colour;

            // Paint & re-scan
            paintImageColour(document.querySelector('svg'));

            // Reselect colour
            var selectedColour = _.find(vm.logoColours, function (logoColour) {
                if (logoColour.code && logoColour.code === _colour.hex || logoColour.code === _colour.code) {
                    return logoColour;
                }
            });

            if (selectedColour) {
                showColourConfiguration(selectedColour);
            }
        }

        //TODO: This works
        function showColourConfiguration(colour) {
            $timeout(function () {
                vm.selectedColour = colour;
                if (colour.tokyoColour) {
                    vm.selectedColours = [colour.tokyoColour];
                } else {
                    vm.selectedColours = [];
                }

                $scope.$apply();
            });

            $timeout(function () {
                vm.selectedColour = colour;
                if (colour.tokyoColour) {
                    vm.selectedColours = [colour.tokyoColour];
                } else {
                    vm.selectedColours = [];
                }

                $scope.$apply();
            });
        }

        function addColour(colour) {
            if (vm.customColour.length > 0) {
                return false;
            }
            if (colour && colour.trim()) {
                return {name: colour.trim(), customColour: true};
            }
        }

        function getColour(colour) {
            if (colour.customColour) {
                return colour;
            }

            if (colour.code.startsWith('#')) {
                colour.code = colour.code.substring(1, colour.code.length);
            }

            if (!colour.hex && colour.code) {
                colour.hex = '#'.concat('', colour.code);
            }

            return colour;
        }

        function scanImageColours(svg) {
            var colours = [];
            var elements = svg.querySelectorAll('*[style]');

            _.each(elements, function (element) {
                if (element.style.fill && element.style.fill !== 'none') {
                    if (element.style.fill.charAt(0) === '#') {
                        colours.push(element.style.fill);
                    } else {
                        colours.push(ColorConverter.rgbToHex(ColorConverter.rgbFromString(element.style.fill)));
                    }
                }
                if (element.style.stroke && element.style.stroke !== 'none') {
                    if (element.style.stroke.charAt(0) === '#') {
                        colours.push(element.style.stroke);
                    } else {
                        colours.push(ColorConverter.rgbToHex(ColorConverter.rgbFromString(element.style.stroke)));
                    }
                }
            });

            if (colours.length === 0) {
                $translate('LOGO.DIALOG.EDIT.NO_COLOURS_FOUND')
                    .then(function (translation) {
                        toastr.error(translation);
                    });
            }

            // Remove duplicates
            colours = _.uniq(colours);

            // Construct color objects
            var logoColours = [];
            _.each(colours, function (colour) {
                var c = {
                    name: '',
                    code: colour,
                    tokyoColour: null
                };

                // Set already matched colour if exists
                if (vm.logoImage.logoImageColours) {
                    var logoImageColour = _.find(vm.logoImage.logoImageColours, {'imageHexColour': colour});

                    if (logoImageColour && logoImageColour.colourName) {
                        var productColour = _.find(vm.productColours, {'name': logoImageColour.colourName});
                        if (productColour) {
                            c.tokyoColour = productColour;
                        } else {
                            c.tokyoColour = {
                                name: logoImageColour.colourName
                            };
                        }
                    }
                }

                logoColours.push(c);
            });

            // Match colours
            vm.logoColours = matchColours(logoColours);

            // Save to states
            vm.logoColoursStates.push({
                logoColours: _.cloneDeep(vm.logoColours),
                svg: document.querySelector('svg').cloneNode(true)
            });
        }

        function matchColours(logoColours) {
            _.each(logoColours, function (logoColour) {
                var result = ColorFinder.findClosest(logoColour, vm.productColours);
                if (result && result.length > 0) {
                    // If there was a custom (free-text colour) set that info by looking at previous state before painting
                    if (vm.logoColours && vm.logoColours.length > 0) {
                        var previousLogoColour = _.find(vm.logoColours, {'code': logoColour.code});
                        if (previousLogoColour && previousLogoColour.tokyoColour) {
                            var tokyoColour = previousLogoColour.tokyoColour;
                            if (tokyoColour.name && !tokyoColour.code) {
                                logoColour.tokyoColour = tokyoColour;
                            }
                        }
                    }

                    // If first suggestions has a low delta, auto select it
                    var firstSuggestion = result[0];
                    if (!logoColour.tokyoColour && firstSuggestion.delta <= vm.acceptableDelta) {
                        logoColour.tokyoColour = firstSuggestion;
                    }

                    logoColour.suggestions = result;
                }
            });

            return logoColours;
        }

        function paintImageColour(svg) {
            var elements = svg.querySelectorAll('*[style]');
            _.each(elements, function (element) {
                if (element.style.fill && element.style.fill !== 'none') {
                    var fillHex;
                    if (element.style.fill.charAt(0) === '#') {
                        fillHex = element.style.fill;
                    } else {
                        fillHex = ColorConverter.rgbToHex(ColorConverter.rgbFromString(element.style.fill));
                    }

                    var x = _.find(vm.logoColours, {'code': fillHex});
                    if (x && x.tokyoColour && x.tokyoColour.code && x.tokyoColour.code !== fillHex) {
                        element.style.fill = x.tokyoColour.hex;
                    }
                }
                if (element.style.stroke && element.style.stroke !== 'none') {
                    var strokeHex;
                    if (element.style.fill.charAt(0) === '#') {
                        strokeHex = element.style.stroke;
                    } else {
                        strokeHex = ColorConverter.rgbToHex(ColorConverter.rgbFromString(element.style.stroke));
                    }

                    var y = _.find(vm.logoColours, {'code': strokeHex});
                    if (y && y.tokyoColour && y.tokyoColour.code && y.tokyoColour.code !== strokeHex) {
                        element.style.stroke = y.tokyoColour.hex;
                    }
                }
            });

            // Re-scan image
            scanImageColours(document.querySelector('svg'));
        }

        function validateColours() {
            if (vm.logoColours.length === 0) {
                return false;
            }

            var valid = true;
            _.each(vm.logoColours, function (logoColour) {
                if (!logoColour.tokyoColour) {
                    valid = false;
                }
            });

            return valid;
        }

        function save() {
            var data = prepareLogoImageData();

            vm.processing = true;
            LogoImageApiService.save(data).then(function (logoImage) {
                vm.processing = false;
                close(logoImage);
            }, function (errors) {
                if (errors && errors.data) {
                    handleValidationErrors(errors);
                } else {
                    throw errors;
                }
            });
        }

        function saveAs() {
            var data = prepareLogoImageData();
            LogoImageDialogService.showSaveAsDialog().then(function (name) {
                if (name === undefined || name === null || name.trim() === '') {
                    $modalInstance.dismiss();
                }

                data.name = name.trim();

                vm.processing = true;
                LogoImageApiService.saveAs(data).then(function (logoImage) {
                    vm.processing = false;
                    close(logoImage);
                }, function (errors) {
                    vm.processing = false;
                    if (errors && errors.data) {
                        handleValidationErrors(errors);
                    } else {
                        throw errors;
                    }
                });
            }, function (errors) {
                if (!errors) {
                    return;
                }

                if (errors && errors.data) {
                    handleValidationErrors(errors);
                } else {
                    throw errors;
                }
            });
        }

        function prepareLogoImageData() {
            if (!validateColours()) {
                throw new Error("Invalid colours " + JSON.stringify(vm.logoColours));
            }

            var entityColours = [];
            _.each(vm.logoColours, function (logoColour) {
                var entityColour = {
                    imageHexColour: logoColour.code,
                    colourName: logoColour.tokyoColour.name,
                    customColour: false
                };

                if (logoColour.tokyoColour.customColour === true) {
                    entityColour.customColour = true;
                }

                entityColours.push(entityColour);
            });

            // Process image
            var svg = document.querySelector('svg').cloneNode(true);
            svg.setAttribute('width', vm.originalWidth);
            svg.setAttribute('height', vm.originalHeight);
            svg.removeAttribute('preserveAspectRatio');
            var html = svg.outerHTML || new XMLSerializer().serializeToString(svg);

            return {
                name: vm.logoImage.name,
                logoImageId: vm.logoImage.logoImageId,
                originalImageId: vm.logoImage.originalId,
                svgData: html,
                logoImageColours: JSON.stringify(entityColours)
            };
        }

        function reset() {
            if (vm.logoColoursStates && vm.logoColoursStates.length > 0) {
                rollback(1);
            }
        }

        function undo() {
            if (vm.logoColoursStates && vm.logoColoursStates.length > 1) {
                rollback();
            }
        }

        function rollback(stage) {
            vm.selectedColour = null;
            vm.selectedColours = [];

            if (stage && stage === 1) {
                var first = _.head(vm.logoColoursStates);
                if (first) {
                    replaceImage(first.svg);
                    vm.logoColoursStates = [];
                    scanImageColours(document.querySelector('svg'));
                }
            } else {
                vm.logoColoursStates.pop();
                var latest = vm.logoColoursStates.pop();
                if (latest) {
                    replaceImage(latest.svg);
                    vm.logoColours = latest.logoColours;
                    paintImageColour(document.querySelector('svg'));
                }
            }
        }

        function replaceImage(svg) {
            angular.element(document.querySelector('svg')).remove();
            var element = angular.element(document.querySelector('#svg-container'));
            element.html(svg);
        }

        function openColourPicker() {
            var data = {
                colors: vm.productColours.slice(),
                selectedColors: vm.selectedColours.slice(),
                maxColors: vm.maxSelectedColours,
                customColors: countCustomColours()
            };

            ColorPickerDialogService.showDialog(data)
                .then(function (selectedColours) {
                    if (selectedColours && selectedColours.length > 0) {
                        applyColour(_.head(selectedColours));
                    }
                });
        }

        function countCustomColours() {
            return vm.selectedColours.filter(function (colour) {
                return !colour.code;
            }).length;
        }

        function handleValidationErrors(errors) {
            vm.processing = false;

            if (Array.isArray(errors.data)) {
                _.each(errors.data, function (error) {
                    if (error.code) {
                        toastr.error($translate.instant('ERROR.' + error.code));
                    }
                });
            } else {
                toastr.error($translate.instant('MESSAGE.SAVEFAIL'));
            }
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function close(logoImage) {
            $modalInstance.close(logoImage);
        }
    }

    function LogoDialogSaveAsController($modalInstance) {
        var vm = this;
        vm.name = '';
        vm.valid = true;

        vm.save = save;
        vm.dismiss = dismiss;

        function save() {
            if (!validate()) {
                vm.valid = false;
            } else {
                $modalInstance.close(vm.name);
            }
        }

        function dismiss() {
            $modalInstance.dismiss();
        }

        function validate() {
            return vm.name != null && vm.name.trim() !== '';
        }
    }

    angular
        .module('services.logoImageDialog', [])
        .service('LogoImageDialogService', LogoImageDialogService)
        .controller('logoDialogUploadController', logoDialogUploadController)
        .controller('LogoDialogEditController', LogoDialogEditController)
        .controller('LogoDialogSaveAsController', LogoDialogSaveAsController);
})();

(function () {

    'use strict';

    // @ngInject
    ManufacturingDialogService.$inject = ["$modal", "ArticlesApiService", "StadiumStockApiService"];
    userResolve.$inject = ["AuthService"];
    ManufacturingDialogController.$inject = ["$modalInstance", "$scope", "loadSpinnerService", "ManufacturingApiService", "StadiumStockApiService", "StadiumStockDialogService", "ValidationManager", "article", "stock", "user", "cartQuantity"];
    function ManufacturingDialogService($modal, ArticlesApiService, StadiumStockApiService) {
        return {
            showDialog: showDialog,
            showCartDialog: showCartDialog
        };

        function showDialog(articleId, updateStock) {
            var manufacturingDialog = {
                backdrop: 'static',
                keyboard: false,
                controller: 'ManufacturingDialogController as vm',
                templateUrl: 'services/manufacturingDialog/manufacturingDialog.tpl.html',
                windowClass: 'manufacturing-dialog',
                resolve: {
                    article: function () {
                        return ArticlesApiService.getById(articleId);
                    },
                    stock: function () {
                        return StadiumStockApiService.getStadiumStock(articleId, updateStock);
                    },
                    user: userResolve,
                    cartQuantity: function () {
                        return 0;
                    }
                }
            };
            return $modal.open(manufacturingDialog).result;
        }

        function showCartDialog(articleId, orderQuantity) {
            var manufacturingDialog = {
                backdrop: 'static',
                keyboard: false,
                controller: 'ManufacturingDialogController as vm',
                templateUrl: 'services/manufacturingDialog/manufacturingDialog.tpl.html',
                windowClass: 'manufacturing-dialog',
                resolve: {
                    article: function () {
                        return ArticlesApiService.getById(articleId);
                    },
                    stock: function () {
                        return StadiumStockApiService.getStadiumStock(articleId);
                    },
                    user: userResolve,
                    cartQuantity: function () {
                        return orderQuantity;
                    }
                }
            };
            return $modal.open(manufacturingDialog).result;
        }
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function ManufacturingDialogController(
        $modalInstance,
        $scope,
        loadSpinnerService,
        ManufacturingApiService,
        StadiumStockApiService,
        StadiumStockDialogService,
        ValidationManager,
        article,
        stock,
        user,
        cartQuantity
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.contentTemplate = "services/manufacturingDialog/manufacturingDialogDefault.tpl.html";
        vm.article = article;
        vm.stock = stock;
        vm.manufacturingOrders = null;
        vm.cartQuantity = cartQuantity;
        vm.success = false;

        vm.close = close;
        vm.isValid = isValid;
        vm.continueButton = continueButton;
        vm.confirm = confirm;
        vm.onStockUpdate = onStockUpdate;
        vm.openStadiumStockDialog = openStadiumStockDialog;

        activate();

        function activate() {
            if (vm.article.stocked) {
                vm.minQuantity = Math.max(calculateMinQuantity(vm.cartQuantity), parseInt(article.refillVolume) || 0, 25);
                vm.quantity = vm.minQuantity;

                ManufacturingApiService.getManufacturingOrders(vm.article.id).then(function (manufacturingOrders) {
                    vm.manufacturingOrders = manufacturingOrders;
                });
            }
            else {
                vm.minQuantity = Math.max(parseInt(article.refillVolume) || 0, 25);
                vm.quantity = Math.max(vm.cartQuantity, vm.minQuantity);
            }
        }

        function openStadiumStockDialog() {
            StadiumStockDialogService.showDialog(vm.stock, vm.article.id).then(function () {
                StadiumStockApiService.getStadiumStock(vm.article.id).then(function (stadiumStock) {
                    vm.stock = stadiumStock;
                    activate();
                });
            });
        }

        function continueButton() {
            $modalInstance.close();
        }

        function confirm() {
            if (vm.article.stocked) {
                order();
            }
            else {
                updateCart();
            }
        }

        function onStockUpdate() {
            StadiumStockApiService.getStadiumStock(vm.article.id, true).then(function (stadiumStock) {
                vm.stock = stadiumStock;
            });
        }

        function order() {
            loadSpinnerService.start();
            vm.params = {
                id: vm.article.id,
                quantity: vm.quantity
            };
            ManufacturingApiService.postManufacturing(vm.params)
                .then(confirmSuccess, confirmError)
                .finally(loadSpinnerService.stop);
        }

        function updateCart() {
            var manufacturingInformation = {
                quantity: vm.quantity,
            };
            $modalInstance.close(manufacturingInformation);
        }

        function confirmSuccess() {
            vm.success = true;
            vm.contentTemplate = "services/manufacturingDialog/manufacturingDialogSuccess.tpl.html";
        }

        function confirmError(error) {
            ValidationManager.handleResponseError(error);
        }

        function isValid() {
            return vm.quantity >= vm.minQuantity;
        }

        function close() {
            if (vm.success) {
                $modalInstance.close();
            } else {
                $modalInstance.dismiss();
            }
        }

        function calculateMinQuantity(cartQuantity) {
            var minRefill = Math.max(parseInt(vm.stock.refillVolume), 25);

            var current = parseInt(vm.stock.stock) + parseInt(vm.stock.orderIn) - parseInt(vm.stock.orderOut);
            var minStock = parseInt(vm.stock.minimumStock);

            var orderResult = current - cartQuantity;

            if (orderResult > minStock) {
                return minRefill;
            }

            return Math.max(minRefill, Math.abs(orderResult - minStock));
        }
    }

    angular
        .module('services.manufacturingDialog', [])
        .service('ManufacturingDialogService', ManufacturingDialogService)
        .controller('ManufacturingDialogController', ManufacturingDialogController);
})();

(function () {

    'use strict';

    // @ngInject
    PlayerDialogService.$inject = ["$modal", "PlayerListApiService"];
    PlayerDialogController.$inject = ["$filter", "$modalInstance", "$translate", "$scope", "toastr", "loadSpinnerService", "ConfirmDialogService", "PlayerListApiService", "playerList", "playerLists", "readOnly"];
    function PlayerDialogService($modal, PlayerListApiService) {
        return {
            showDialog: showDialog
        };

        function showDialog(playerListId, readOnly) {
            var playerDialog = {
                backdrop: 'static',
                controller: 'PlayerDialogController as vm',
                templateUrl: 'services/playerDialog/playerDialog.tpl.html',
                windowClass: 'players-dialog small',    // Show a small dialog initially to better fit content.
                resolve: {
                    playerList: function () {
                        if (!playerListId) {
                            return null;
                        }
                
                        return PlayerListApiService.getPlayerList(playerListId);
                    },
                    playerLists: PlayerListApiService.getPlayerLists,
                    readOnly: function() {
                        return !!readOnly;
                    }
                }
            };
            return $modal.open(playerDialog).result;
        }
    }

    // @ngInject
    function PlayerDialogController(
        $filter,
        $modalInstance,
        $translate,
        $scope,
        toastr,
        loadSpinnerService,
        ConfirmDialogService,
        PlayerListApiService,
        playerList,
        playerLists,
        readOnly
    ) {
        /* jshint validthis: true */
        var vm = this;
        vm.playerLists = playerLists;
        vm.playerListId = '';
        vm.currentPhase = 1;
        vm.minQuantity = 1;
        vm.players = [];
        vm.recipients = [];
        vm.selectedPlayerList = playerList;
        vm.radioChoice = '';
        vm.name = '';
        vm.description = '';
        vm.dateCreated = null;
        vm.sent = false;
        vm.nameIsUnique = true;
        vm.showSizeSummary = false;
        vm.numberOfRows = '';
        vm.activePlayerIndex = 0;
        vm.quickEdit = false;
        vm.imported = false;
        vm.readOnly = readOnly;

        vm.remove = remove;
        vm.close = close;
        vm.save = save;
        vm.clear = clear;
        vm.copy = copy;
        vm.addIfLastRow = addIfLastRow;
        vm.playerQuantitiesAreValid = playerQuantitiesAreValid;
        vm.onPlayerListSelect = onPlayerListSelect;
        vm.next = next;
        vm.isValid = isValid;
        vm.isReadOnly = isReadOnly;
        vm.checkNameIsUnique = checkNameIsUnique;
        vm.back = back;
        vm.removePlayerList = removePlayerList;
        vm.onClickToggleSummary = onClickToggleSummary;
        vm.summarizeSizes = summarizeSizes;
        vm.getSize = getSize;
        vm.getTotal = getTotal;
        vm.getTotalRow = getTotalRow;
        vm.getSizes = getSizes;
        vm.checkNumber = checkNumber;
        vm.addRecipient = addRecipient;
        vm.updateActivePlayer = updateActivePlayer;
        vm.setActivePlayer = setActivePlayer;
        vm.findNewActivePlayer = findNewActivePlayer;
        vm.send = send;

        activate();

        function activate() {
            if (vm.selectedPlayerList == null) {
                vm.radioChoice = 'radioNewBlank';
            } else {
                vm.radioChoice = 'radioReuse';

                vm.description = vm.selectedPlayerList.playerListDescription;
                vm.dateCreated = $filter('date')(vm.selectedPlayerList.dateCreated, 'yy-MM-dd HH:mm');
                populatePlayers();
                setNumberOfRows();
                vm.quickEdit = true;
                vm.imported = vm.selectedPlayerList.imported;
            }

            vm.watch = $scope.$watch(function () {
                return vm.radioChoice;
            }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    vm.name = '';
                    vm.description = '';
                    vm.selectedPlayerList = null;
                    vm.dateCreated = null;
                    vm.numberOfRows = '';
                }
            });

            if (vm.quickEdit) {
                next();
            }
        }

        function populatePlayers() {
            vm.players = !vm.selectedPlayerList ? null : vm.selectedPlayerList.players;
            if (!vm.players || vm.players.length === 0) {
                vm.players = [];
            }
            if (!isReadOnly()) {
                addNew();
            }
        }

        function addNew() {
            if (vm.players.length === 0 || isNotEmpty(vm.players[vm.players.length - 1])) {
                vm.players.push({
                    name: '',
                    articleId: '',
                    initials: '',
                    number: '',
                    smallNumber: '',
                    size: '',
                    comment: '',
                    quantity: '1'
                });
            }
        }

        function back() {
            PlayerListApiService.getPlayerLists().then(function (playerLists) {
                vm.playerLists = playerLists;
                vm.currentPhase = 1;
                vm.watch();
                decreaseModalSize();
                vm.showSizeSummary = false;
            });
        }

        function isReadOnly() {
            if (vm.readOnly) {
                return true;
            }

            var result = false;
            if (vm.selectedPlayerList !== null) {
                result = !vm.selectedPlayerList.draft;
            }
            return result;
        }

        function isValid() {
            var result = true;
            if (vm.radioChoice === 'radioNewBlank') {
                result = result && vm.name;
            }
            if (vm.radioChoice === 'radioNewExisting') {
                result = result && vm.selectedPlayerList && vm.playerLists.length;
                result = result && vm.name;
            }
            if (vm.radioChoice === 'radioReuse') {
                result = result && vm.selectedPlayerList && vm.playerLists.length;
            }
            return result && vm.nameIsUnique;
        }

        function checkNameIsUnique() {
            vm.nameIsUnique = !_.some(vm.playerLists, function (playerList) {
                return playerList.playerListName === vm.name;
            });
        }

        function next() {
            if (vm.radioChoice === 'radioNewBlank' || vm.radioChoice === 'radioNewExisting') {
                var data = {
                    playerListDescription: vm.description,
                    playerListName: vm.name
                };
                if (vm.radioChoice === 'radioNewBlank') {
                    PlayerListApiService.createBlankPlayerList(data)
                        .then(function (playerList) {
                            vm.currentPhase = 2;
                            increaseModalSize();
                            vm.playerListId = playerList.playerListId;
                            vm.selectedPlayerList = playerList;
                            onPlayerListSelect(playerList);
                        })
                        .catch(function (error) {
                            if (error && error.data) {
                                toastr.error(error.data.message);
                            }
                        });
                }
                if (vm.radioChoice === 'radioNewExisting') {
                    PlayerListApiService.createFromExistingPlayerList(data, vm.selectedPlayerList.playerListId)
                        .then(function (playerList) {
                            vm.currentPhase = 2;
                            increaseModalSize();
                            vm.playerListId = playerList.playerListId;
                            vm.selectedPlayerList = playerList;
                            onPlayerListSelect(playerList);
                        })
                        .catch(function (error) {
                            if (error && error.data) {
                                toastr.error(error.data.message);
                            }
                        });
                }
            }
            if (vm.radioChoice === 'radioReuse') {
                PlayerListApiService.getPlayerList(vm.selectedPlayerList.playerListId).then(function (playerList) {
                    vm.currentPhase = 2;
                    increaseModalSize();
                    vm.playerListId = playerList.playerListId;
                    vm.selectedPlayerList = playerList;
                    onPlayerListSelect(playerList);
                    vm.name = playerList.playerListName;
                });
            }
            // Reset index to stay in range in case the playerList was changed.
            vm.activePlayerIndex = 0;
        }

        function decreaseModalSize() {
            $('.players-dialog').addClass('small');
        }

        function increaseModalSize() {
            $('.players-dialog').removeClass('small');
        }

        function onPlayerListSelect(playerList) {
            vm.description = playerList.playerListDescription;
            vm.dateCreated = $filter('date')(playerList.dateCreated, 'yy-MM-dd HH:mm');
            populatePlayers();
            setNumberOfRows();
        }

        function setNumberOfRows() {
            vm.numberOfRows = _.filter(vm.players, function (player) {
                return isNotEmpty(player);
            }).length;
        }

        function addIfLastRow(index) {
            if (index + 1 === vm.players.length) {
                addNew();
            }
        }

        function isNotEmpty(player) {
            return player.name || player.articleId || player.initials || player.number || player.smallNumber || player.size || player.comment;
        }

        function remove(index) {
            var isLast = (index + 1 === vm.players.length);
            vm.players.splice(index, 1);
            if (isLast) {
                addNew();
            }
        }

        function save() {
            var players = [];
            angular.forEach(vm.players, function (player) {
                if (isNotEmpty(player)) {
                    players.push(player);
                }
            });

            if (players.length === 0) {
                return $translate('ERROR.PLAYER_LIST_PLAYERS_NOT_FOUND').then(function (translation) {
                    toastr.error(translation);
                });
            }

            var data = {
                playerListId: vm.playerListId,
                playerListName: vm.name,
                players: players
            };
            if (vm.isReadOnly()) {
                $modalInstance.close(data);
            } else {
                PlayerListApiService.updatePlayerList(vm.playerListId, players).then(function () {
                    $modalInstance.close(data);
                });
            }
        }

        function playerQuantitiesAreValid() {
            return vm.players.every(function (player, index) {
                return player.quantity !== '' && player.quantity > '0' ||
                    index === vm.players.length - 1;     // The last row is always empty.
            });
        }

        function close() {
            $modalInstance.dismiss();
        }

        function clear() {
            var buttons = [{name: 'BUTTON.NO', class: 'btn-default'}, {name: 'BUTTON.YES', class: 'btn-danger'}];
            ConfirmDialogService.showDialog('MOUNTING.PLAYERDIALOG.CLEARPLAYERSTITLE', 'MOUNTING.PLAYERDIALOG.CLEARPLAYERSTEXT', buttons)
                .then(function (usedButton) {
                    if (usedButton.name === 'BUTTON.YES') {
                        // Delete all player rows except the last one with default data.
                        vm.players = vm.players.slice(vm.players.length - 1, vm.players.length);
                    }
                });
        }

        function removePlayerList(playerList) {
            var buttons = [{name: 'BUTTON.NO', class: 'btn-default'}, {name: 'BUTTON.YES', class: 'btn-success'}];
            ConfirmDialogService.showDialog('MOUNTING.DELETEPLAYERLIST1', 'MOUNTING.DELETEPLAYERLIST2', buttons).then(function (button) {
                if (button.name === 'BUTTON.YES') {
                    loadSpinnerService.start();
                    PlayerListApiService.deletePlayerList(playerList.playerListId).then(function () {
                        vm.playerLists = _.without(vm.playerLists, playerList);
                        vm.selectedPlayerList = null;
                        vm.name = '';
                        vm.description = '';
                        vm.dateCreated = '';
                    }).finally(loadSpinnerService.stop);
                }
            });
        }

        function onClickToggleSummary() {
            summarizeSizes();
            vm.showSizeSummary = !vm.showSizeSummary;
        }

        function summarizeSizes() {
            var summary = {};
            var players = getPlayers();
            for (var index = 0; index < players.length; index++) {
                var size = players[index].size;
                summary[size] = (summary[size] || 0) + Number(players[index].quantity);
            }
            vm.sizes = summary;
        }

        function getPlayers() {
            return isReadOnly() ? vm.players : _.without(vm.players, vm.players[vm.players.length - 1]);
        }

        function getSize(index) {
            return Object.keys(vm.sizes)[index];
        }

        function getTotalRow(index) {
            var sizes = Object.keys(vm.sizes).map(function (size) {
                return vm.sizes[size];
            });
            return sizes[index];
        }

        function getTotal() {
            var players = getPlayers();
            return players.reduce(function (sum, player) {
                return sum + Number(player.quantity);
            }, 0);
        }

        function getSizes() {
            summarizeSizes();
            return vm.sizes;
        }

        function checkNumber(index) {
            var player = vm.players[index];
            if (player.number) {
                if (isNaN(player.number[player.number.length - 1])) {
                    player.number = player.number.slice(0, -1);
                }
            }

            if (player.smallNumber) {
                if (isNaN(player.smallNumber[player.smallNumber.length - 1])) {
                    player.smallNumber = player.smallNumber.slice(0, -1);
                }
            }
        }

        function updateActivePlayer(direction) {
            vm.activePlayerIndex += direction;
            if (vm.activePlayerIndex < 0) {
                vm.activePlayerIndex = 0;
            } else if (vm.activePlayerIndex > vm.players.length - 2) {
                vm.activePlayerIndex = vm.players.length - 2;
            }
        }

        function setActivePlayer(index) {
            vm.activePlayerIndex = index;
        }

        function findNewActivePlayer() {
            // Find suitable player to show when another has been deleted.
            vm.activePlayerIndex = vm.activePlayerIndex > 0 ? vm.activePlayerIndex - 1 : 0;
        }

        function copy(index) {
            var player = vm.players[index];
            vm.players.splice(index, 0, {
                name: player.name,
                articleId: player.articleId,
                initials: player.initials,
                number: player.number,
                smallNumber: player.smallNumber,
                size: player.size,
                comment: player.comment,
                quantity: player.quantity
            });
        }

        function addRecipient(tag) {
            return tag.replace(',', '');
        }

        function send() {
            vm.recipients = [];
            vm.showMail = false;
            vm.sent = true;
        }
    }

    angular
        .module('services.playerDialog', ['ngTouch'])
        .service('PlayerDialogService', PlayerDialogService)
        .controller('PlayerDialogController', PlayerDialogController);
})();

(function () {

    'use strict';

    garmentResolve.$inject = ["GarmentsApiService"];
    colourResolve.$inject = ["ArticlesApiService"];
    PlayerGroupDialogService.$inject = ["$modal"];
    PlayerGroupDialogController.$inject = ["$scope", "$modalInstance", "$translate", "ColorPickerDialogService", "garments", "colours"];
    function PlayerGroupDialogService($modal) {
        return {
            showDialog: showDialog
        };

        function showDialog() {
            var dialog = {
                backdrop: 'static',
                controller: 'PlayerGroupDialogController as vm',
                templateUrl: 'services/playerGroupDialog/playerGroupDialog.tpl.html',
                resolve: {
                    garments: garmentResolve,
                    colours: colourResolve
                }
            };
            return $modal.open(dialog).result;
        }
    }

    // @ngInject
    function garmentResolve(GarmentsApiService) {
        var allGarments = [];
        GarmentsApiService.getGarments().then(function (garments) {
            _.each(garments, function (value, key) {
                allGarments.push({
                    key: key,
                    value: 'GARMENT.TYPE.' + key
                });
            });
        });
        return allGarments;
    }

    //@ngInject
    function colourResolve(ArticlesApiService) {
        return ArticlesApiService.getColors('GARMENT');
    }

    function PlayerGroupDialogController($scope, $modalInstance, $translate, ColorPickerDialogService, garments, colours) {
        var vm = this;
        vm.colours = colours;
        vm.garments = garments;
        vm.maxColours = 1;
        vm.maxGarments = 1;
        vm.selectedColours = [];
        vm.selectedGarments = [];
        vm.validationErrors = [];

        vm.addColour = addColour;
        vm.addGarment = addGarment;
        vm.save = save;
        vm.close = close;

        function addColour(colour) {
            if (colour && colour.trim()) {
                var customColour = colour.trim().toUpperCase();
                if (!_.find(vm.selectedColours, {'name': customColour})) {
                    return {name: customColour};
                }
            }
        }

        function addGarment(garment) {
            if (garment && garment.trim()) {
                return {
                    key: garment,
                    value: garment
                };
            }
        }

        function validate() {
            vm.validationErrors = [];

            // Garment
            if (!vm.selectedGarments || vm.selectedGarments.length !== vm.maxGarments) {
                vm.validationErrors.push({field: 'garment', message: $translate.instant('VALIDATION.GARMENT')});
            }

            // Colours
            if (!vm.selectedColours || vm.selectedColours.length !== vm.maxColours) {
                vm.validationErrors.push(
                    {
                        field: 'colour',
                        message: $translate.instant('CREATEARTICLE.VALIDATION.COLORS', {colorCount: vm.maxColours})
                    });
            }

            return vm.validationErrors.length <= 0;
        }

        function save() {
            if (!validate()) {
                return;
            }

            var playerGroupForm = {
                garment: vm.selectedGarments[0].key,
                colour: vm.selectedColours[0].name.trim()
            };

            $modalInstance.close(playerGroupForm);
        }

        function close() {
            $modalInstance.dismiss();
        }

        $scope.$watchCollection('[vm.garment, vm.selectedColours]', function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            if (vm.garment) {
                _.remove(vm.validationErrors, {'field': 'garment'});
            }
            if (vm.selectedColours && vm.selectedColours.length > 0) {
                _.remove(vm.validationErrors, {'field': 'colour'});
            }
        });
    }

    angular
        .module('services.playerGroupDialog', [])
        .service('PlayerGroupDialogService', PlayerGroupDialogService)
        .controller('PlayerGroupDialogController', PlayerGroupDialogController);
})();
(function() {

    'use strict';

    // @ngInject
    ProofDialogService.$inject = ["$modal"];
    orderProofsResolve.$inject = ["OrderProofsApiService"];
    userResolve.$inject = ["AuthService"];
    resourcesResolve.$inject = ["ResourcesApiService"];
    ProofDialogController.$inject = ["$modalInstance", "DS", "orderProofs", "user", "resources"];
    function ProofDialogService($modal) {
        return {
            showDialog: showDialog
        };

        function showDialog() {
            var proofDialog = {
                backdrop: 'static',
                controller: 'ProofDialogController as vm',
                templateUrl: 'services/proofDialog/proofDialog.tpl.html',
                resolve: {
                    orderProofs: orderProofsResolve,
                    user: userResolve,
                    resources: resourcesResolve
                }
            };
            return $modal.open(proofDialog).result;
        }
    }

    // @ngInject
    function orderProofsResolve(OrderProofsApiService) {
        return OrderProofsApiService.getOrderProofs();
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function resourcesResolve(ResourcesApiService) {
        return ResourcesApiService.getResources('errand');
    }

    // @ngInject
    function ProofDialogController($modalInstance, DS, orderProofs, user, resources) {
        /* jshint validthis: true */
        var vm = this;
        vm.user = user;
        vm.orderProofs = orderProofs;
        vm.resources = resources;
        vm.selectedResource = null;
        vm.availableResources = [];
        vm.close = close;
        vm.getProofLink = getProofLink;
        vm.onClickProof = onClickProof;
        vm.filterProofs = filterProofs;

        activate();

        function activate() {
            var proofResources = [];
            _.forEach(orderProofs, function (orderProof) {
                var resource = _.find(vm.resources, { 'resourceId': orderProof.resourceId });
                if (resource) {
                    proofResources.push(resource);
                }
            });
            vm.availableResources = _.uniq(proofResources);
            vm.selectedResource = _.find(vm.availableResources, { 'resourceEmail': vm.user.userId });
        }

        function getProofLink(proof) {
            return DS.defaults.baseUrl + 'productionerrands/' + proof.errandId + '/proofs/' + proof.proofId + '/' + proof.fileId;
        }

        function onClickProof(orderProof) {
            $modalInstance.close(orderProof);
        }

        function filterProofs(proof) {
            if (!vm.selectedResource) {
                return proof;
            }
            else if (vm.selectedResource.resourceId === proof.resourceId) {
                return proof;
            }
        }

        function close() {
            $modalInstance.dismiss();
        }
    }

    angular
        .module('services.proofDialog', [])
        .service('ProofDialogService', ProofDialogService)
        .controller('ProofDialogController', ProofDialogController);
})();
(function() {
  'use strict';

  // @ngInject
  SavedCartDialogService.$inject = ["$modal", "SavedCartsApiService", "AuthService"];
  SavedCartDialogController.$inject = ["$filter", "$modalInstance", "$scope", "loadSpinnerService", "ConfirmDialogService", "SavedCartsApiService", "savedCarts", "user", "orderNumber", "project"];
  function SavedCartDialogService($modal, SavedCartsApiService, AuthService) {
    return {
      showDialog: showDialog
    };

    function showDialog(orderNumber, project) {
      var savedCartDialog = {
        backdrop: 'static',
        controller: 'SavedCartDialogController as vm',
        templateUrl: 'services/savedCartDialog/savedCartDialog.tpl.html',
        resolve: {
          savedCarts: SavedCartsApiService.getSavedCarts,
          user: AuthService.getUser,
          orderNumber: function() { return orderNumber; },
          project: function() { return project; }
        }
      };
      return $modal.open(savedCartDialog).result;
    }
  }

  // @ngInject
  function SavedCartDialogController(
    $filter,
    $modalInstance,
    $scope,
    loadSpinnerService,
    ConfirmDialogService,
    SavedCartsApiService,
    savedCarts,
    user,
    orderNumber,
    project
  ) {
    /* jshint validthis: true */
    var vm = this;
    vm.orderProject = project || '';
    vm.orderReference = orderNumber || '';
    vm.radioChoice = 'radioNewBlank';
    vm.savedCarts = savedCarts;
    vm.user = user;
    vm.selectedCart = null;
    vm.dateCreated = null;
    vm.close = close;
    vm.create = create;
    vm.isReferenceProjectUnique = isReferenceProjectUnique;
    vm.isValid = isValid;
    vm.removeSavedCart = removeSavedCart;
    vm.onSavedCartSelect = onSavedCartSelect;
    vm.getSavedCarts = getSavedCarts;
    vm.showNoCartsWarning = showNoCartsWarning;
    vm.showOneCartWarning = showOneCartWarning;
    vm.showCartWarning = showCartWarning;

    function getSavedCarts() {
      return vm.radioChoice !== 'radioReuse' ? vm.savedCarts : _.filter(vm.savedCarts, function(savedCart) {
            return (
              savedCart.orderReference !== vm.user.orderReference &&
              savedCart.orderProject !== vm.user.orderProject
            );
          });
    }

    function onSavedCartSelect() {
      angular.forEach(vm.savedCarts, function(cart) {
        if (cart === vm.selectedCart) {
          vm.dateCreated = $filter('date')(cart.dateCreated, 'yy-MM-dd HH:mm');
          if (vm.radioChoice === 'radioReuse') {
            vm.orderReference = cart.orderReference;
            vm.orderProject = cart.orderProject;
          }
        }
      });
    }

    function isReferenceProjectUnique() {
      var result = true;
      if (
        vm.orderProject &&
        vm.orderReference &&
        vm.radioChoice !== 'radioReuse'
      ) {
        _.each(vm.savedCarts, function(savedCart) {
          result =
            result &&
            !(
              savedCart.orderReference.toLowerCase() ===
                vm.orderReference.toLowerCase() &&
              savedCart.orderProject.toLowerCase() ===
                vm.orderProject.toLowerCase()
            );
        });
      }
      return result;
    }

    function close() {
      $modalInstance.dismiss();
    }

    function create() {
      var data = {
        orderReference: vm.orderReference,
        orderProject: vm.orderProject
      };
      SavedCartsApiService.activateSavedCart(data)
        .then(function() {
            $modalInstance.close();
        });
    }

    function showCartWarning() {
      var result = true;
      result = result && vm.radioChoice !== 'radioNewBlank';
      result = result && (showOneCartWarning() || showNoCartsWarning());
      return result;
    }

    function showNoCartsWarning() {
      return !vm.user.orderProject ? vm.radioChoice !== 'radioNewBlank' && vm.savedCarts.length < 1 : false;
    }

    function showOneCartWarning() {
      return vm.user.orderProject ? vm.radioChoice === 'radioReuse' && vm.savedCarts.length <= 1 : false;
    }

    function isValid() {
      if (vm.radioChoice === 'radioNewBlank') {
        return (
          vm.orderReference && vm.orderProject && isReferenceProjectUnique()
        );
      } else {
        return (
          vm.orderReference &&
          vm.orderProject &&
          vm.selectedCart &&
          isReferenceProjectUnique()
        );
      }
    }

    vm.watch = $scope.$watch(
      function() {
        return vm.radioChoice;
      },
      function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.orderReference = '';
          vm.orderProject = '';
          vm.dateCreated = null;
          vm.selectedCart = null;
        }
      }
    );

    function removeSavedCart(savedCart) {
      var buttons = [
        { name: 'BUTTON.NO', class: 'btn-default' },
        { name: 'BUTTON.YES', class: 'btn-success' }
      ];
      ConfirmDialogService.showDialog(
        'STADIUM.DELETESAVEDCART1',
        'STADIUM.DELETESAVEDCART2',
        buttons
      ).then(function(button) {
        if (button.name === 'BUTTON.YES') {
          loadSpinnerService.start();
          SavedCartsApiService.deleteSavedCart(savedCart)
            .then(function() {
              vm.savedCarts = _.without(vm.savedCarts, savedCart);
              vm.orderReference = '';
              vm.orderProject = '';
              vm.dateCreated = null;
              vm.selectedCart = null;
            })
            .finally(loadSpinnerService.stop);
        }
      });
    }
  }

  angular
    .module('services.savedCartDialog', [])
    .service('SavedCartDialogService', SavedCartDialogService)
    .controller('SavedCartDialogController', SavedCartDialogController);
})();

(function() {

    'use strict';

    // @ngInject
    authService.$inject = ["$location", "$state", "$modal", "$q", "$window", "DSHttpAdapter", "DS", "UsersApiService", "ErrorLogService", "CustomersApiService"];
    function authService($location, $state, $modal, $q, $window, DSHttpAdapter, DS,
                         UsersApiService, ErrorLogService, CustomersApiService){
        var _user = null;
        var _loginDialog = null;

        var service = {
            ensureUser: ensureUser,
            isPublicState: isPublicState,
            getUser: getUser,
            showLogin: showLogin,
            logIn: logIn,
            logOut: logOut
        };

        return service;

        function isPublicState(stateName) {
            // These states may be visited without being logged in
            return stateName == 'placement' || stateName == 'login';
        }

        function ensureUser() {
            var userPromise = $q.defer();
            if (_user != null) {
                userPromise.resolve();
            }

            getUser().then(function () {
                userPromise.resolve();
            }).catch(function () {
                userPromise.reject();
            });

            return userPromise.promise;
        }

        function getUser() {
            var userPromise = $q.defer();

            if (angular.isDefined(_user) && _user != null) {
                userPromise.resolve(_user);
                return userPromise.promise;
            }

            UsersApiService.getSelf().then(function (user) {
                _user = user;
                ErrorLogService.setUser(_user);
                preloadCustomers(user);
                userPromise.resolve(_user);
            }).catch(function (error) {
                userPromise.reject(error);
            });

            return userPromise.promise;
        }

        function preloadCustomers(user) {
            if (user && user.admin) {
                CustomersApiService.getAll();
            }
        }

        function authenticate(email, password) {
            var data = {
                'email' : email,
                'password' : password
            };

            return DSHttpAdapter.POST(DS.defaults.baseUrl + 'auth', data);
        }

        function showLogin() {
            if (_loginDialog == null) {
                _loginDialog = $modal.open({
                    templateUrl: 'services/security/loginDialog/loginDialog.tpl.html',
                    controller: "LoginDialogController as vm",
                    size: 'sm',
                    backdrop: 'static',
                    keyboard: false
                });

                _loginDialog.result.then(onCloseLoginSuccess);
            }
        }

        function closeDialog() {
            _loginDialog.close();
            _loginDialog = null;
        }

        function onCloseLoginSuccess() {
            $location.path("/");
        }

        function logIn(email, password) {
            var promise = $q.defer();
            authenticate(email, password).then(function () {
                closeDialog(true);
                promise.resolve();
            }).catch(function (error) {
                promise.reject(error);
            });

            return promise.promise;
        }

        function logOut() {
            if (_user != null) {
                _user = null;
                ErrorLogService.setUser(null);

                DSHttpAdapter.DEL(DS.defaults.baseUrl + 'auth', { ignore401: true }).finally(function () {
                    $window.location.href = '/';
                });
            } else {
                $state.go('login');
            }
        }
    }

    angular
        .module('security.authService', [])
        .factory('AuthService', authService);
})();

(function () {
    'use strict';

    // @ngInject
    LoginDialogController.$inject = ["$scope", "AuthService", "loadSpinnerService"];
    function LoginDialogController($scope, AuthService, loadSpinnerService) {
        /* jshint validthis: true */
        var vm = this;

        vm.email = '';
        vm.password = '';
        vm.showLogin = true;
        vm.authError = null;
        vm.AuthService = AuthService;
        vm.login = login;

        function login() {
            vm.showLogin = false;
            loadSpinnerService.start();
            // Try to log in
            AuthService.logIn(vm.email, vm.password).catch(function (error) {
                if (error) {
                    if (error.status === 0 || error.status === 404) {
                        vm.authError = "No connection";
                    }
                    if (error.data && error.data.message) {
                        vm.authError = error.data.message;
                    }
                }
            }).finally(function () {
                vm.showLogin = true;
                loadSpinnerService.stop();
            });
        }
    }

    angular
        .module('security.loginDialog', ['autofill-directive'])
        .controller('LoginDialogController', LoginDialogController);
})();

(function() {

    'use strict';

    angular
        .module('security', ['security.authService','security.loginDialog']);
})();
(function () {
  'use strict';

  // @ngInject
  StadiumProductTemplatePickerDialogService.$inject = ["$modal"];
  clubsResolve.$inject = ["StadiumProductService"];
  StadiumProductTemplatePickerController.$inject = ["$modalInstance", "DS", "StadiumProductService", "ValidationManager", "loadSpinnerService", "clubs", "includeNonReadyTeamTemplates"];
  function StadiumProductTemplatePickerDialogService($modal) {
    return {
      showDialog: showDialog,
    };

    function showDialog(includeNonReadyTeamTemplates) {
      var modalDefaults = {
        backdrop: 'static',
        controller: 'StadiumProductTemplatePickerController as vm',
        templateUrl: 'services/stadiumProductTemplatePickerDialog/stadiumProductTemplatePickerDialog.tpl.html',
        size: 'lg',
        resolve: {
          clubs: clubsResolve,
          includeNonReadyTeamTemplates: function () {
            return includeNonReadyTeamTemplates;
          }
        },
      };
      return $modal.open(modalDefaults).result;
    }
  }

  // @ngInject
  function clubsResolve(StadiumProductService) {
    return StadiumProductService.getClubs();
  }

  // @ngInject
  function StadiumProductTemplatePickerController(
    $modalInstance,
    DS,
    StadiumProductService,
    ValidationManager,
    loadSpinnerService,
    clubs,
    includeNonReadyTeamTemplates
  ) {
    var vm = this;
    vm.clubs = clubs;
    vm.products = [];
    vm.savedSearch = StadiumProductService.getSavedSearchTemplatePicker();
    vm.searchText = vm.savedSearch.searchText;
    vm.pageSize = vm.savedSearch.pageSize;
    vm.page = vm.savedSearch.page;
    vm.selectedClubs = vm.savedSearch.selectedClubs;
    vm.includeNonReadyTeamTemplates = includeNonReadyTeamTemplates;

    vm.selectedTemplate = null;
    vm.selectedClub = vm.savedSearch.selectedClubs.length > 0 ? vm.savedSearch.selectedClubs[0] : '';
    vm.selectedProduct = null;
    vm.mainTemplate = null;
    vm.teamTemplates = null;
    vm.getImageUrl = getImageUrl;
    vm.onSelectClub = onSelectClub;
    vm.onSearch = onSearch;
    vm.onSelectProduct = onSelectProduct;
    vm.clearSelectedProduct = clearSelectedProduct;
    vm.pageChanged = pageChanged;
    vm.close = close;
    vm.dismiss = dismiss;

    if (isAnyFilterActive()) {
      fetchProducts();
    }


    function getImageUrl(fileName) {
      return (
        DS.defaults.baseUrl +
        'stadiumproducts/image/' +
        fileName +
        '?size=small'
      );
    }

    function onSelectClub() {
      vm.page = 1;
      vm.searchText = '';
      fetchProducts();
    }

    function onSearch(event) {
      vm.searchText = event.target.value;
      vm.page = 1;
      fetchProducts();
    }

    function fetchProducts() {
      if (!isAnyFilterActive()) {
        clearProducts();
        return;
      }

      vm.selectedClubs = [vm.selectedClub];

      loadSpinnerService.start();
      StadiumProductService.searchProductsTemplatePicker(
          vm.searchText,
          vm.selectedClubs,
          vm.page,
          vm.pageSize
      )
        .then(function (result) {
          vm.products = result.searchResults;
          vm.totalItems = result.searchHitCount;
          vm.savedSearch = StadiumProductService.getSavedSearchTemplatePicker();
        })
        .finally(function () {
          loadSpinnerService.stop();
        });
    }

    function isAnyFilterActive() {
      return vm.selectedClub;
    }

    function clearProducts() {
      vm.products = null;
      vm.totalItems = null;
    }

    function pageChanged() {
      fetchProducts();
    }

    function onSelectProduct(productId) {
      StadiumProductService.getProduct(productId)
        .then(function (product) {
          vm.selectedProduct = product;

          vm.selectedProduct.teamTemplates = _.filter(
              vm.selectedProduct.teamTemplates,
              function (template) {
                return vm.includeNonReadyTeamTemplates || template.status === 'READY';
              }
          );
        })
        .catch(function (error) {
          ValidationManager.handleResponseError(error);
          throw error;
        });
    }

    function clearSelectedProduct() {
      vm.selectedProduct = null;
      vm.selectedTemplate = null;
      fetchProducts();
    }

    function close() {
      $modalInstance.close(vm.selectedTemplate);
    }

    function dismiss() {
      $modalInstance.dismiss();
    }
  }

  angular
    .module('services.stadiumProductTemplatePickerDialog', [])
    .service(
      'StadiumProductTemplatePickerDialogService',
      StadiumProductTemplatePickerDialogService
    )
    .controller(
      'StadiumProductTemplatePickerController',
      StadiumProductTemplatePickerController
    );
})();

(function () {

    'use strict';

    StadiumStockDialogController.$inject = ["$modalInstance", "$translate", "toastr", "loadSpinnerService", "StadiumStockApiService", "stadiumStock", "articleId"];
    StadiumStockDialogService.$inject = ["$modal"];
    function StadiumStockDialogService($modal) {

        return {
            showDialog: showDialog
        };

        function showDialog(stadiumStock, articleId) {
            var stadiumStockDialog = {
                backdrop: 'static',
                controller: 'StadiumStockDialogController as vm',
                templateUrl: 'services/stadiumStockDialog/stadiumStockDialog.tpl.html',
                resolve: {
                    stadiumStock: function () {
                        return stadiumStock;
                    }, articleId: function () {
                        return articleId;
                    }
                }
            };
            return $modal.open(stadiumStockDialog).result;
        }
    }

    // @ngInject
    function StadiumStockDialogController($modalInstance, $translate, toastr, loadSpinnerService, StadiumStockApiService,
                                          stadiumStock, articleId) {
        /* jshint validthis: true */
        var vm = this;
        vm.stadiumStock = stadiumStock;
        vm.minimumStock = stadiumStock.minimumStock;
        vm.refillVolume = stadiumStock.refillVolume;
        vm.minQuantity = 0;
        vm.isValid = isValid;
        vm.close = close;
        vm.save = save;

        function close() {
            $modalInstance.dismiss();
        }

        function save() {
            stadiumStock.minimumStock = vm.minimumStock;
            stadiumStock.refillVolume = vm.refillVolume;

            loadSpinnerService.start();
            StadiumStockApiService.updateStadiumStock(articleId, stadiumStock).then(function () {
                $modalInstance.close();
            }, function (error) {
                $translate('MESSAGE.SAVEFAIL').then(function (translation) {
                    if (error && error.message) {
                        toastr.error(error.message, translation);
                    } else {
                        toastr.error(translation);
                    }
                });
            }).finally(loadSpinnerService.stop);
        }

        function isValid() {
            return vm.minimumStock >= vm.minQuantity && vm.refillVolume >= vm.minQuantity;
        }
    }

    angular
        .module('services.stadiumStockDialog', [])
        .service('StadiumStockDialogService', StadiumStockDialogService)
        .controller('StadiumStockDialogController', StadiumStockDialogController);
})();

(function () {

    'use strict';

    // @ngInject
    function TableService() {
        this.generatePagesArray = function (currentPage, totalItems, pageSize) {
            var maxBlocks, maxPage, maxPivotPages, minPage, numPages, pages;
            maxBlocks = 17;
            pages = [];
            numPages = Math.ceil(totalItems / pageSize);
            if (numPages > 1) {
                pages.push({
                    type: 'prev',
                    number: Math.max(1, currentPage - 1),
                    active: currentPage > 1
                });
                pages.push({
                    type: 'first',
                    number: 1,
                    active: currentPage > 1,
                    current: currentPage === 1
                });
                maxPivotPages = Math.round((maxBlocks - 5) / 2);
                minPage = Math.max(2, currentPage - maxPivotPages);
                maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
                minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
                var i = minPage;
                while (i <= maxPage) {
                    if ((i === minPage && i !== 2) || (i === maxPage && i !== numPages - 1)) {
                        pages.push({
                            type: 'more',
                            active: false
                        });
                    } else {
                        pages.push({
                            type: 'page',
                            number: i,
                            active: currentPage !== i,
                            current: currentPage === i
                        });
                    }
                    i++;
                }
                pages.push({
                    type: 'last',
                    number: numPages,
                    active: currentPage !== numPages,
                    current: currentPage === numPages
                });
                pages.push({
                    type: 'next',
                    number: Math.min(numPages, currentPage + 1),
                    active: currentPage < numPages
                });
            }
            return pages;
        };
    }

    angular
        .module('table', [])
        .service('TableService', TableService);
})();
(function() {

    // @ngInject
    TemplateCartDialogService.$inject = ["$modal", "PlacementsApiService"];
    TemplateCartDialogController.$inject = ["$modalInstance", "PlacementsApiService", "templateId", "cartItems"];
    function TemplateCartDialogService($modal, PlacementsApiService) {
        return {
            show: show
        };

        function show(templateId) {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplateCartDialogController as vm',
                templateUrl: 'services/templateCartDialog/templateCartDialog.tpl.html',
                resolve: {
                    templateId: function() {
                        return templateId;
                    },
                    cartItems: function() {
                        return PlacementsApiService.getCartItemsForTemplate(templateId);
                    }
                }
            };
            return $modal.open(modalDefaults).result;
        }
    }

    // @ngInject
    function TemplateCartDialogController($modalInstance, PlacementsApiService, templateId, cartItems) {
        var vm = this;

        vm.templateId = templateId;
        vm.cartItems = cartItems;

        vm.addItem = addItem;
        vm.close = close;

        function addItem(item) {
            item.added = true;
            var request = {};
            if (item.type === 'LOGO') {
                request.logoList = [item.id];
            } else if (item.type === 'ARTICLE') {
                request.articleList = [item.id];
            } else {
                return;
            }
            PlacementsApiService.addItemsToTemplate(vm.templateId, request);
        }

        function close() {
            $modalInstance.close();
        }
    }


    angular
        .module('services.templateCartDialog', [])
        .service('TemplateCartDialogService', TemplateCartDialogService)
        .controller('TemplateCartDialogController', TemplateCartDialogController);
})();

(function () {

    'use strict';

    // @ngInject
    TemplateDialogService.$inject = ["$modal"];
    userResolve.$inject = ["AuthService"];
    garmentResolve.$inject = ["GarmentsApiService"];
    clubResolve.$inject = ["ClubsApiService"];
    coloursResolve.$inject = ["PlacementsApiService"];
    TemplateDialogController.$inject = ["$modalInstance", "$scope", "$filter", "$translate", "$q", "loadSpinnerService", "toastr", "user", "garments", "clubs", "colours", "colour", "garment", "clubId", "categoryId", "template", "quickTemplate", "stadiumTemplate", "PlacementsApiService", "ClubsApiService"];
    function TemplateDialogService($modal) {
        return {
            showStandardDialog: showStandardDialog,
            showStadiumDialog: showStadiumDialog,
            showTemplateDialog: showTemplateDialog
        };

        function showStandardDialog() {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplateDialogController as vm',
                templateUrl: 'services/templateDialog/templateDialog.tpl.html',
                resolve: {
                    user: userResolve,
                    garments: garmentResolve,
                    colours: coloursResolve,
                    clubs: function () { return null; },
                    colour: function () { return ''; },
                    garment: function () { return ''; },
                    clubId: function () { return null; },
                    categoryId: function () { return null; },
                    template: function () { return true; },
                    quickTemplate: function () { return true; },
                    stadiumTemplate: function () { return false; }
                }
            };
            return $modal.open(modalDefaults).result;
        }

        function showStadiumDialog() {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplateDialogController as vm',
                templateUrl: 'services/templateDialog/templateDialog.tpl.html',
                resolve: {
                    user: userResolve,
                    garments: garmentResolve,
                    clubs: clubResolve,
                    colours: coloursResolve,
                    colour: function () { return ''; },
                    garment: function () { return ''; },
                    clubId: function () { return null; },
                    categoryId: function () { return null; },
                    template: function () { return false; },
                    quickTemplate: function () { return false; },
                    stadiumTemplate: function () { return false; }
                }
            };
            return $modal.open(modalDefaults).result;
        }

        function showTemplateDialog(colour, garment, clubId, categoryId, quickTemplate, stadiumTemplate) {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplateDialogController as vm',
                templateUrl: 'services/templateDialog/templateDialog.tpl.html',
                resolve: {
                    user: userResolve,
                    garments: garmentResolve,
                    clubs: clubResolve,
                    colours: coloursResolve,
                    colour: function () { return colour; },
                    garment: function () { return garment; },
                    clubId: function () { return clubId; },
                    categoryId: function () { return categoryId; },
                    template: function () { return true; },
                    quickTemplate: function () { return quickTemplate; },
                    stadiumTemplate: function () { return stadiumTemplate; }
                }
            };
            return $modal.open(modalDefaults).result;
        }
    }

    // @ngInject
    function userResolve(AuthService) {
        return AuthService.getUser();
    }

    // @ngInject
    function garmentResolve(GarmentsApiService) {
        return GarmentsApiService.getGarments();
    }

    // @ngInject
    function clubResolve(ClubsApiService) {
        return ClubsApiService.getClubs();
    }

    // @ngInject
    function coloursResolve(PlacementsApiService) {
        return PlacementsApiService.getColours();
    }

    // @ngInject
    function TemplateDialogController(
        $modalInstance,
        $scope,
        $filter,
        $translate,
        $q,
        loadSpinnerService,
        toastr,
        user,
        garments,
        clubs,
        colours,
        colour,
        garment,
        clubId,
        categoryId,
        template,
        quickTemplate,
        stadiumTemplate,
        PlacementsApiService,
        ClubsApiService
    ) {
        var vm = this;
        vm.user = user;
        vm.isStadium = user.stadium;
        vm.isTemplate = template;
        vm.isQuickTemplate = quickTemplate;
        vm.createStadiumTemplate = stadiumTemplate;
        vm.radioChoice = 'new';

        // Base
        vm.clubs = clubs;
        vm.categories = null;
        vm.placements = null;
        vm.garments = null;
        vm.colours = colours;
        vm.quantity = 1;
        vm.minQuantity = 1;

        // Selections
        vm.selectedClub = null;
        vm.selectedClubId = clubId;
        vm.selectedCategory = null;
        vm.selectedCategoryId = categoryId;
        vm.selectedPlacement = null;
        vm.selectedGarmentName = garment;
        vm.selectedGarment = null;
        vm.selectedColour = colour;
        vm.selectedColours = [];

        // Info
        vm.name = '';
        vm.description = '';
        vm.dateCreated = null;
        vm.nameIsUnique = true;

        // Display
        vm.showClubAndCategory = showClubAndCategory;
        vm.lockClubAndCategory = lockClubAndCategory;
        vm.showPlacement = showPlacement;

        // Validation
        vm.isFormValid = isFormValid;

        // Events
        vm.onNewCustomColour = onNewCustomColour;
        vm.onSelectClub = onSelectClub;
        vm.onSelectPlacement = onSelectPlacement;
        vm.createPlacement = createPlacement;
        vm.dismiss = dismiss;
        vm.close = close;

        activate();

        function activate() {
            loadGarments(garments);
            setColour(colour);

            var calls = [];

            if (vm.selectedClubId) {
                var clubById = _.find(vm.clubs, { clubId: vm.selectedClubId });
                var clubByName = _.find(vm.clubs, { clubName: vm.selectedClubId });

                if (clubById) {
                    vm.selectedClub = clubById;
                }
                else if (clubByName) {
                    vm.selectedClub = clubByName;
                }

                if (vm.selectedClub) {
                    var loadCategories = loadCategoriesForClub(vm.selectedClub.clubId);
                    calls.push(loadCategories);
                }
            }
            if (vm.selectedGarmentName) {
                vm.selectedGarment = _.find(vm.garments, { key: vm.selectedGarmentName.toUpperCase() });
            }
            if (garment) {
                vm.name = garment.trim();
            }

            if(calls.length > 0){
                loadSpinnerService.start();
                return $q.all(calls).then(loadSpinnerService.stop);
            } else {
                return $q.when();
            }
        }

        function loadGarments(garments) {
            vm.garments = [];
            angular.forEach(garments, function (value, key) {
                vm.garments.push({
                    key: key,
                    value: 'GARMENT.TYPE.' + key
                });
            });
        }

        function setColour(colour) {
            var placementColour = colour ? colour.toUpperCase() : '';
            var colourIndex = _.findIndex(vm.colours, function (colour) {
                return colour.name.toUpperCase() === placementColour;
            });
            if (colourIndex !== -1) {
                vm.selectedColours[0] = vm.colours[colourIndex];
            }
            else if (colourIndex === -1 && colour) {
                vm.selectedColours[0] = { name: colour };
            }
        }

        function loadCategoriesForClub(clubId) {
            return ClubsApiService.getCategories(clubId).then(function (categories) {
                vm.categories = categories;
                if (vm.selectedCategoryId) {
                    vm.selectedCategory = _.find(vm.categories, { categoryId: vm.selectedCategoryId });
                } else {
                    vm.selectedCategory = null;
                }
            });
        }

        /* Display */
        function showClubAndCategory() {
            if (vm.isStadium) {
                if (vm.isQuickTemplate) {
                    return vm.radioChoice !== 'new';
                }
                return true;
            }
            return false;
        }

        function lockClubAndCategory() {
            return !!vm.isStadium;
        }

        function showPlacement() {
            return vm.radioChoice !== 'new';
        }

        /* Events */
        function onSelectClub() {
            loadCategoriesForClub(vm.selectedClub.clubId);
        }

        function onSelectPlacement() {
            if (!vm.selectedPlacement) {
                return;
            }
            vm.selectedGarment = _.find(vm.garments, { 'key': vm.selectedPlacement.garment });
            vm.name = vm.selectedPlacement.templateName;
            setColour(vm.selectedPlacement.colour);
            vm.description = vm.selectedPlacement.description;
            vm.dateCreated = $filter('date')(vm.selectedPlacement.dateCreated, 'yy-MM-dd HH:mm');
        }

        function onNewCustomColour(colour) {
            return { name: colour };
        }

        /* Validation */
        function isFormValid() {
            return validateForm();
        }

        function validateForm() {
            if (vm.isStadium && vm.isQuickTemplate) {
                if ((!vm.selectedClub || !vm.selectedCategory) && vm.radioChoice !== 'new') {
                    return false;
                }
            }
            else if (vm.isStadium && !vm.isQuickTemplate) {
                if (!vm.selectedClub || !vm.selectedCategory) {
                    return false;
                }
            }

            if (!vm.selectedGarment) {
                return false;
            }

            if (vm.radioChoice !== 'new') {
                if (!vm.selectedPlacement) {
                    return false;
                }
            }

            vm.nameIsUnique = validateName();

            return !(!vm.name || !vm.nameIsUnique);
        }

        function validateName() {
            if (vm.isQuickTemplate) {
                return true;
            }

            if (vm.createStadiumTemplate) {
                return !_.some(vm.placements, function (placement) {
                    return vm.name.toLowerCase() === placement.templateName.toLowerCase() &&
                        vm.selectedClub.clubId === placement.club &&
                        vm.selectedCategory.categoryId === placement.category;
                });
            }

            return true;
        }

        /* Submit actions */
        function createPlacement() {
            var data = {
                templateName: vm.name || "",
                description: vm.description || "",
                colour: vm.selectedColours[0] ? vm.selectedColours[0].name : "",
                garment: vm.selectedGarment.key || "",
                club: vm.selectedClub ? vm.selectedClub.clubId : "",
                category: vm.selectedCategory ? vm.selectedCategory.categoryId : "",
                template: true,
                stadiumTemplate: vm.createStadiumTemplate
            };

            if (vm.radioChoice === 'new') {
                createNewPlacement(data);
            }
            else if (vm.radioChoice === 'copy') {
                copyPlacement(data);
            }
        }

        function createNewPlacement(data) {
            return PlacementsApiService.createBlankPlacement(data).then(function (placement) {
                $modalInstance.close(placement);
            }, function (error) {
                if (error && error.status === 409) {
                    if (vm.isTemplate) {
                        toastr.error($translate.instant('STADIUM.PLACEMENTTEMPLATE.NAMEWARNING'));
                    } else {
                        toastr.error($translate.instant('MOUNTING.DIALOGWARNING'));
                    }
                }
                else if (error && error.data) {
                    toastr.error(error.data.message);
                }
                else {
                    throw error;
                }
            });
        }

        function copyPlacement(data) {
            return PlacementsApiService.createFromExistingPlacement(data, vm.selectedPlacement.placementId).then(function (placement) {
                $modalInstance.close(placement);
            }, function (error) {
                if (error && error.data) {
                    handleValidationErrors(error);
                }
                else {
                    throw error;
                }
            });
        }

        function handleValidationErrors(error) {
            _.each(error.data, function (error) {
                if (error.code === 'TEMPLATE_IS_INVALID') {
                    $translate('ERROR.TEMPLATE_IS_INVALID', { templateName: error.data })
                        .then(function (errorMessage) {
                            toastr.error(errorMessage);
                        }, function () {
                            toastr.error(error.message);
                        });
                }
            });
        }

        function dismiss() {
            $modalInstance.dismiss();
        }

        function close() {
            $modalInstance.dismiss();
        }

        function loadStadiumPlacements(){
            if(!vm.selectedClub || !vm.selectedCategory){
                vm.placements = null;
                return $q.when();
            }

            loadSpinnerService.start();
            return PlacementsApiService.getStadiumTemplates(vm.selectedClub.clubId, vm.selectedCategory.categoryId, null).then(function (placements){
                vm.placements = placements;
                loadSpinnerService.stop();
            });
        }

        /* Watchers */
        $scope.$watch(
            function () {
                return vm.radioChoice;
            },
            function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    vm.name = '';
                    vm.description = '';
                    vm.selectedColours = [];
                    vm.selectedGarment = null;
                    vm.selectedPlacement = null;
                    vm.nameIsUnique = true;
                    vm.dateCreated = null;
                }
            }
        );

        $scope.$watchGroup(
            [
                function () {
                    return vm.selectedClub ? vm.selectedClub.clubId : null;
                },
                function () {
                    return vm.selectedCategory ? vm.selectedCategory.categoryId : null;
                }
            ],
            function (newValue, oldValue, scope) {
                return newValue !== oldValue ? loadStadiumPlacements() : $q.when();
            });
    }

    angular
        .module('services.templateDialog', [])
        .service('TemplateDialogService', TemplateDialogService)
        .controller('TemplateDialogController', TemplateDialogController);
})();

(function () {

    'use strict';
    
    // @ngInject
    TemplateErrorDialogService.$inject = ["$modal", "StadiumPlacementsApiService"];
    TemplateErrorDialogController.$inject = ["$modalInstance", "$state", "$rootScope", "PlacementsApiService", "template"];
    function TemplateErrorDialogService($modal, StadiumPlacementsApiService) {
        return {
            showDialog: showDialog
        };

        function showDialog(templateId) {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplateErrorDialogController as vm',
                templateUrl: 'services/templateErrorDialog/templateErrorDialog.tpl.html',
                resolve: {
                    template: function () {
                        return StadiumPlacementsApiService.getPlacement(templateId);
                    }
                }
            };
            return $modal.open(modalDefaults).result;
        }
    }

    // @ngInject
    function TemplateErrorDialogController($modalInstance, $state, $rootScope, PlacementsApiService, template) {
        var vm = this;
        vm.template = template;

        vm.goToTemplate = goToTemplate;
        vm.dismiss = dismiss;
        vm.close = close;

        function goToTemplate() {
            PlacementsApiService.openTemplate(template.placementId).then(function () {
                $rootScope.$broadcast('$updateNotifications');
            }).finally(function () {
                $modalInstance.dismiss();
                $state.go('app.shop.advancedMounting', {id: template.placementId}, 'AdvancedMountingController');
            });
        }

        function dismiss() {
            $modalInstance.dismiss();
        }

        function close() {
            $modalInstance.dismiss();
        }
    }

    angular
        .module('services.templateErrorDialog', [])
        .service('TemplateErrorDialogService', TemplateErrorDialogService)
        .controller('TemplateErrorDialogController', TemplateErrorDialogController);
})();
(function () {

    'use strict';

    // @ngInject
    TemplatePickerDialogService.$inject = ["$modal", "StadiumPlacementsApiService"];
    clubsResolve.$inject = ["ClubsApiService"];
    templatesResolve.$inject = ["PlacementsApiService"];
    TemplatePickerDialogController.$inject = ["$modalInstance", "$translate", "currentTemplate", "suggestedTemplate", "filterData", "clubs", "templates", "currentClub"];
    function TemplatePickerDialogService($modal, StadiumPlacementsApiService) {
        return {
            showDialog: showDialog,
            showSuggestionDialog: showSuggestionDialog,
            showSetTemplateDialog: showSetTemplateDialog
        };

        function showDialog() {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplatePickerDialogController as vm',
                templateUrl: 'services/templatePickerDialog/templatePickerDialog.tpl.html',
                resolve: {
                    currentTemplate: function () {
                        return null;
                    },
                    suggestedTemplate: function () {
                        return null;
                    },
                    filterData: function () {
                        return null;
                    },
                    currentClub: function () {
                        return null;
                    },
                    clubs: clubsResolve,
                    templates: templatesResolve
                }
            };
            return $modal.open(modalDefaults).result;
        }

        function showSuggestionDialog(currentTemplate, suggestedTemplate, filterData) {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplatePickerDialogController as vm',
                templateUrl: 'services/templatePickerDialog/templatePickerDialog.tpl.html',
                resolve: {
                    currentTemplate: function () {
                        return currentTemplate ? StadiumPlacementsApiService.getPlacement(currentTemplate) : null;
                    },
                    suggestedTemplate: function () {
                        return suggestedTemplate ? StadiumPlacementsApiService.getPlacement(suggestedTemplate) : null;
                    },
                    filterData: function () {
                        return filterData;
                    },
                    currentClub: function () {
                        return null;
                    },
                    clubs: clubsResolve,
                    templates: templatesResolve
                }
            };
            return $modal.open(modalDefaults).result;
        }

        function showSetTemplateDialog(currentClub, filterData) {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplatePickerDialogController as vm',
                templateUrl: 'services/templatePickerDialog/templatePickerDialog.tpl.html',
                resolve: {
                    currentTemplate: function () {
                        return null;
                    },
                    suggestedTemplate: function () {
                        return null;
                    },
                    filterData: function () {
                        return filterData;
                    },
                    currentClub: function () {
                        return currentClub;
                    },
                    clubs: clubsResolve,
                    templates: templatesResolve
                }
            };
            return $modal.open(modalDefaults).result;
        }
    }

    // @ngInject
    function clubsResolve(ClubsApiService) {
        return ClubsApiService.getClubsWithCategories();
    }

    // @ngInject
    function templatesResolve(PlacementsApiService) {
        return PlacementsApiService.getStadiumTemplates(null, null, false);
    }

    // @ngInject
    function TemplatePickerDialogController(
        $modalInstance,
        $translate,
        currentTemplate,
        suggestedTemplate,
        filterData,
        clubs,
        templates,
        currentClub
    ) {
        var vm = this;
        vm.currentTemplate = currentTemplate;
        vm.suggestedTemplate = suggestedTemplate;
        vm.filterData = filterData;
        vm.clubs = clubs;
        vm.categories = [];
        vm.templates = templates;
        vm.selectedClub = null;
        vm.selectedCategory = null;
        vm.selectedTemplate = null;
        vm.suggestionLimit = 3;
        vm.suggestionList = [];
        vm.currentClubName = currentClub;

        vm.onSelectClub = onSelectClub;
        vm.onSelectCategory = onSelectCategory;
        vm.dismiss = dismiss;
        vm.close = close;
        vm.closeWithSuggestion = closeWithSuggestion;

        initialize();

        function initialize() {
            if(!vm.filterData) {
                return;
            }

            if(vm.currentTemplate) {
                vm.selectedTemplate = vm.currentTemplate;
                setClubAndCategory(vm.currentTemplate);
                findSuggestion(vm.selectedClub, vm.selectedCategory);
            }
            else if(vm.suggestedTemplate) {
                var club = null;
                var category = null;
                if(vm.suggestedTemplate.club) {
                    club = vm.clubs.find(function (club) {
                        return club.clubId === vm.suggestedTemplate.club;
                    });
                }
                if(club && vm.suggestedTemplate.category) {
                    category = club.categories.find(function (category) {
                        return category.categoryId === vm.suggestedTemplate.category;
                    });
                }
                findSuggestion(club, category);
            }

            if(vm.currentClubName) {
                vm.selectedClub = clubs.find(function (club) {
                    return club.clubName === vm.currentClubName;
                });

                if(vm.selectedClub) {
                    vm.onSelectClub();
                }
            }

        }

        function setClubAndCategory(template) {
            vm.selectedClub = vm.clubs.find(function (club) {
                if(club.clubId === template.club) {
                    return club;
                }
            });
            vm.categories = vm.selectedClub.categories;
            vm.selectedCategory = vm.selectedClub.categories.find(function (category) {
                if(category.categoryId === template.category) {
                    return category;
                }
            });
        }

        function findSuggestion(club, category) {
            // get list of available templates from club & category
            var availableTemplates = [];
            if(club && category) {
                availableTemplates = vm.templates.filter(function (template) {
                    if(template.club === club.clubId && template.category === category.categoryId) {
                        return template;
                    }
                });
            }

            if(availableTemplates.length === 0) {
                vm.selectedClub = club;
                return;
            } else {
                vm.selectedClub = club;
                if(club) {
                    vm.categories = club.categories;
                    vm.selectedCategory = category;
                }
            }

            var colourTemplates = [];
            var garmentTemplates = [];
            var suggestionTemplates = [];

            var processTemplates = new Promise(function (resolve) {
                availableTemplates.forEach(function (availableTemplate) {
                    $translate('GARMENT.TYPE.' + availableTemplate.garment).then(function (templateGarment) {
                        var garment = vm.filterData.garmentName ? vm.filterData.garmentName.toUpperCase() : null;
                        var colour = vm.filterData.garmentColour ? vm.filterData.garmentColour.toUpperCase() : null;
                        var templateColour = availableTemplate.colour ? availableTemplate.colour.toUpperCase() : null;

                        if(templateGarment.toUpperCase() === garment && templateColour === colour) {
                            suggestionTemplates.push(availableTemplate);
                        }
                        else {
                            if(templateGarment.toUpperCase() === garment) {
                                garmentTemplates.push(availableTemplate);
                            }
                            if(templateColour === colour) {
                                colourTemplates.push(availableTemplate);
                            }
                        }
                    }).then(function () {
                        resolve();
                    });
                });
            });

            processTemplates.then(function () {
                vm.suggestionList = _.concat(suggestionTemplates, _.concat(garmentTemplates, colourTemplates));
            });
        }

        function onSelectClub() {
            vm.selectedTemplate = null;
            vm.selectedCategory = null;
            vm.categories = vm.selectedClub.categories;
        }

        function onSelectCategory() {
            vm.selectedTemplate = null;

            if(vm.filterData) {
                findSuggestion(vm.selectedClub, vm.selectedCategory);
            }
        }

        function dismiss() {
            $modalInstance.dismiss();
        }

        function close() {
            if (vm.selectedClub && vm.selectedCategory && vm.selectedTemplate) {
                $modalInstance.close({
                    template: vm.selectedTemplate
                });
            } else {
                dismiss();
            }
        }

        function closeWithSuggestion(template) {
            $modalInstance.close({
                template: template
            });
        }
    }

    angular
        .module('services.templatePickerDialog', [])
        .service('TemplatePickerDialogService', TemplatePickerDialogService)
        .controller('TemplatePickerDialogController', TemplatePickerDialogController);
})();

(function() {
    'use strict';

    // @ngInject
    TemplatePriceDialogService.$inject = ["$modal"];
    TemplatePriceDialogController.$inject = ["$modalInstance", "TemplatePriceApiService", "templateId", "quantity", "loadSpinnerService"];
    function TemplatePriceDialogService($modal) {
        return {
            showDialog: showDialog
        };


        function showDialog(templateId, quantity) {
            var modalDefaults = {
                backdrop: 'static',
                controller: 'TemplatePriceDialogController as vm',
                templateUrl: 'services/templatePrices/templatePriceDialog.tpl.html',
                size: 'lg',
                resolve: {
                    templateId: function() {
                        return templateId;
                    },
                    quantity: function() {
                        return quantity;
                    }
                }
            };

            return $modal.open(modalDefaults).result;
        }
    }


    function TemplatePriceDialogController(
        $modalInstance,
        TemplatePriceApiService,
        templateId,
        quantity,
        loadSpinnerService
    ) {
        var vm = this;
        vm.prices = [];
        vm.costs = [];
        vm.total = "";

        vm.close = close;

        activate();

        loadSpinnerService.start();

        function activate() {
            TemplatePriceApiService.getTemplatePrice(templateId, quantity).then(function(response) {
                vm.prices = response.prices;
                vm.costs = response.costs;

                vm.total = response.total;
                vm.garment = {};
                vm.garment.type = _.find(vm.prices, 'garment').garment;
                vm.garment.quantity = quantity || 1;

                loadSpinnerService.stop();
            });
        }

        function close() {
            $modalInstance.close();
        }
    }

    angular
        .module('services.templatePriceDialog', [])
        .service('TemplatePriceDialogService', TemplatePriceDialogService)
        .controller('TemplatePriceDialogController', TemplatePriceDialogController);

})();

(function(){
    'use strict';

    //  @ngInject
    TextAreaDialogService.$inject = ["$modal"];
    TextAreaDialogController.$inject = ["$modalInstance", "title", "text"];
    function TextAreaDialogService($modal) {
        return {
            showDialog: showDialog
        };

        function showDialog(title, text) {
            var dialog = {
                backdrop: 'static',
                controller: 'TextAreaDialogController as vm',
                templateUrl: 'services/textAreaDialog/textAreaDialog.tpl.html',
                resolve: {
                    text: function() {
                        return text;
                    },
                    title: function() {
                        return title;
                    }
                }
            };
            $modal.open(dialog);
        }
    }

    // @ngInject
    function TextAreaDialogController($modalInstance, title, text) {
        var vm = this;
        vm.title = title;
        vm.text = text;

        vm.close = close;

        function close() {
            $modalInstance.close();
        }
    }


    angular.module('services.textAreaDialog', [])
        .service('TextAreaDialogService', TextAreaDialogService)
        .controller('TextAreaDialogController', TextAreaDialogController);
})();

(function () {
    'use strict';

    // @ngInject
    ValidationManager.$inject = ["$translate", "$rootScope", "toastr"];
    function ValidationManager($translate, $rootScope, toastr) {
        return {
            handleResponseError: handleResponseError
        };

        function handleResponseError(error) {
            if (error.status >= 400 && error.status < 500) {
                handleClientError(error);
            }
        }

        function handleClientError(error) {
            if (Array.isArray(error.data)) {
                _.forEach(error.data, handleError);
                return;
            }
            if (error.message) {
                toastr.error(error.message);
            }
        }

        function handleError(error) {
            var translationId = 'ERROR.' +  error.code;
            var message = $translate.instant(translationId, error.data);

            // If no translation is found
            if (message === translationId && error.message) {
                message = error.message;
            }

            toastr.error(message);

            $rootScope.$broadcast("$updateNotifications");
        }
    }

    angular.module('validationManager', ['toastr', 'pascalprecht.translate'])
        .service('ValidationManager', ValidationManager);
})();

angular.module('templates-app', ['admin/controlPanel/controlPanel.tpl.html', 'admin/controlPanel/systemStatusDialog/systemStatusDialog.tpl.html', 'admin/customerDetails/customerDetails.tpl.html', 'admin/discounts/discounts.tpl.html', 'admin/draftOrders/draftOrders.tpl.html', 'admin/pendingOrders/logoDialog/logoDialog.tpl.html', 'admin/pendingOrders/pendingOrderList.tpl.html', 'admin/pendingOrders/pendingOrderView.tpl.html', 'admin/productTypes/productTypes.tpl.html', 'admin/templateCopy/templateCopy.tpl.html', 'productionPlanning/errands/errandProofsDialog/errandProofsDialog.tpl.html', 'productionPlanning/errands/errandsDialog/errandsDialog.tpl.html', 'productionPlanning/errands/errandsList.tpl.html', 'productionPlanning/errands/errandsView.tpl.html', 'productionPlanning/errands/viewErrandProofsDialog/viewErrandProofsDialog.tpl.html', 'shop/articles/articlesList.tpl.html', 'shop/articles/articleView.tpl.html', 'shop/calculator/calculator.tpl.html', 'shop/cart/cart.tpl.html', 'shop/cart/cartRowTextDialog/cartRowTextDialog.tpl.html', 'shop/cart/cartWarningsDialog/cartWarningsDialog.tpl.html', 'shop/cart/checkoutDialog/checkoutDialog.tpl.html', 'shop/cart/checkoutDialog/checkoutDialogConfirmation.tpl.html', 'shop/cart/checkoutDialog/checkoutDialogSuccess.tpl.html', 'shop/create/create.tpl.html', 'shop/digits/digitsList.tpl.html', 'shop/digits/digitView.tpl.html', 'shop/history/historyList.tpl.html', 'shop/history/historyView.tpl.html', 'shop/mounting/advancedMounting.tpl.html', 'shop/mounting/editMountingDialog/editMountingDialog.tpl.html', 'shop/mounting/instructionDialog/instructionDialog.tpl.html', 'shop/mounting/printingInformationDialog/printingInformationDialog.tpl.html', 'shop/mounting/simpleMounting.tpl.html', 'shop/mounting/templateAuditLogsDialog/templateAuditLogsDialog.tpl.html', 'shop/mounting/uploadsDialog/uploadsDialog.tpl.html', 'shop/name/name.tpl.html', 'shop/shop.tpl.html', 'stadium/incomingOrders/incomingOrders.tpl.html', 'stadium/incomingOrders/incomingOrdersDialog/incomingOrdersDialog.tpl.html', 'stadium/logo/stadiumLogo.tpl.html', 'stadium/shortages/shortages.tpl.html', 'stadium/stadiumProduct/stadiumProduct.tpl.html', 'stadium/stadiumProduct/stadiumProducts.tpl.html', 'stadium/start/start.tpl.html', 'stadium/templateManagement/templateManagement.tpl.html', 'stadium/templateManagement/templateManagementDialog.tpl.html', '../common/directives/addToCartButton/addToCartButton.tpl.html', '../common/directives/addToTemplateButton/addToTemplateButton.tpl.html', '../common/directives/adminInput/adminInput.tpl.html', '../common/directives/breadcrumbs/breadcrumbs.tpl.html', '../common/directives/calculatorPriceTable/calculatorPriceTable.tpl.html', '../common/directives/loadSpinner/loadSpinner.tpl.html', '../common/directives/namePreview/namePreview.tpl.html', '../common/directives/priceTable/priceTable.tpl.html', '../common/directives/stockTable/stockTable.tpl.html', '../common/directives/userBox/userBox.tpl.html', '../common/services/backsidePickerDialog/backsidePickerDialog.tpl.html', '../common/services/colorPickerDialog/colorPickerDialog.tpl.html', '../common/services/confirmDialog/confirmDialog.tpl.html', '../common/services/cookieConsent/cookieConsentDialog/cookieConsentDialog.tpl.html', '../common/services/customerPickerDialog/customerPickerDialog.tpl.html', '../common/services/emailDialog/emailDialog.tpl.html', '../common/services/garmentPicker/garmentPicker.tpl.html', '../common/services/logoImageDialog/logoDialog-edit.tpl.html', '../common/services/logoImageDialog/logoDialog-saveAs.tpl.html', '../common/services/logoImageDialog/logoDialog-upload.tpl.html', '../common/services/manufacturingDialog/manufacturingDialog.tpl.html', '../common/services/manufacturingDialog/manufacturingDialogDefault.tpl.html', '../common/services/manufacturingDialog/manufacturingDialogSuccess.tpl.html', '../common/services/playerDialog/playerDialog.tpl.html', '../common/services/playerGroupDialog/playerGroupDialog.tpl.html', '../common/services/proofDialog/proofDialog.tpl.html', '../common/services/savedCartDialog/savedCartDialog.tpl.html', '../common/services/security/loginDialog/loginDialog.tpl.html', '../common/services/stadiumProductTemplatePickerDialog/stadiumProductTemplatePickerDialog.tpl.html', '../common/services/stadiumStockDialog/stadiumStockDialog.tpl.html', '../common/services/templateCartDialog/templateCartDialog.tpl.html', '../common/services/templateDialog/templateDialog.tpl.html', '../common/services/templateErrorDialog/templateErrorDialog.tpl.html', '../common/services/templatePickerDialog/templatePickerDialog.tpl.html', '../common/services/templatePrices/templatePriceDialog.tpl.html', '../common/services/textAreaDialog/textAreaDialog.tpl.html']);

angular.module("admin/controlPanel/controlPanel.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/controlPanel/controlPanel.tpl.html",
    "<div class=\"tasks col-md-offset-1 col-md-10\" ng-if=\"vm.user.admin\">\n" +
    "    <h2>\n" +
    "        {{'CONTROLPANEL.TITLE1' | translate}}\n" +
    "    </h2>\n" +
    "    <p>\n" +
    "        {{'CONTROLPANEL.SUBTITLE1' | translate}}\n" +
    "    </p>\n" +
    "    <button class=\"btn btn-success\" ng-click=\"vm.onClickSystemStatus()\">\n" +
    "        {{'CONTROLPANEL.SYSTEMSTATUS' | translate}}\n" +
    "    </button>\n" +
    "    <h2>\n" +
    "        {{'CONTROLPANEL.TITLE2' | translate}}\n" +
    "    </h2>\n" +
    "    <p>\n" +
    "        {{'CONTROLPANEL.SUBTITLE2' | translate}}\n" +
    "    </p>\n" +
    "    <table class=\"table\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'CONTROLPANEL.TASKNAME' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'CONTROLPANEL.SCHEDULE' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'CONTROLPANEL.LATEST' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'CONTROLPANEL.NEXT' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'CONTROLPANEL.STATUS' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                </th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"task in vm.tasks\">\n" +
    "                <td>\n" +
    "                    {{task.jobName}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{task.cronExpression}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{!task.previousFireTime ? \"None\" : task.previousFireTime | date : 'yy-MM-dd HH:mm'}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{task.nextFireTime | date : 'yy-MM-dd HH:mm'}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{'CONTROLPANEL.' + task.status | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <button class=\"btn btn-default btn-sm fa fa-play\" title=\"{{'TOOLTIP.PLAY' | translate}}\" ng-if=\"task.status === 'NONE'\" ng-click=\"vm.onClickTask(task, 'trigger')\">\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default btn-sm fa fa-pause\" title=\"{{'TOOLTIP.PAUSE' | translate}}\" ng-if=\"task.status === 'RUNNING'\" ng-click=\"vm.onClickTask(task, 'pause')\">\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default btn-sm fa fa-play\" title=\"{{'TOOLTIP.RESUME' | translate}}\" ng-if=\"task.status === 'PAUSED'\" ng-click=\"vm.onClickTask(task, 'resume')\">\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default btn-sm fa fa-stop\" title=\"{{'TOOLTIP.STOP' | translate}}\" ng-if=\"task.status === 'RUNNING'\" ng-click=\"vm.onClickTask(task, 'interrupt')\">\n" +
    "                    </button>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>");
}]);

angular.module("admin/controlPanel/systemStatusDialog/systemStatusDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/controlPanel/systemStatusDialog/systemStatusDialog.tpl.html",
    "<div class=\"system-status\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'SYSTEMSTATUS.TITLE' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div load-spinner spinner-name=\"dialog-spinner\"></div>\n" +
    "        <div class=\"loading\" ng-if=\"!vm.systemStatus\">\n" +
    "            <h2>\n" +
    "                {{'SYSTEMSTATUS.CHECKING' | translate}}\n" +
    "            </h2>\n" +
    "        </div>\n" +
    "        <div class=\"loaded\" ng-if=\"vm.systemStatus\">\n" +
    "            <table class=\"table\">\n" +
    "                <thead>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'SYSTEMSTATUS.MODULENAME' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'SYSTEMSTATUS.MODULESTATUS' | translate}}\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                </thead>\n" +
    "                <tbody>\n" +
    "                    <tr ng-repeat=\"(moduleName, moduleStatus) in vm.systemStatus\" ng-class=\"{error: moduleStatus !== 'OK'}\">\n" +
    "                        <td>\n" +
    "                            {{moduleName}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            {{(moduleStatus === 'OK' ? 'SYSTEMSTATUS.MODULEOK' : 'SYSTEMSTATUS.MODULEERROR') | translate}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\" ng-if=\"vm.systemStatus\">\n" +
    "        <p ng-if=\"vm.isSystemNormal()\">\n" +
    "            {{'SYSTEMSTATUS.NORMAL' | translate}}\n" +
    "        </p>\n" +
    "        <p ng-if=\"!vm.isSystemNormal()\">\n" +
    "            {{'SYSTEMSTATUS.PROBLEM' | translate}}\n" +
    "        </p>\n" +
    "        <button type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">{{'BUTTON.CLOSE' | translate}}</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("admin/customerDetails/customerDetails.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/customerDetails/customerDetails.tpl.html",
    "<div \n" +
    "    class=\"customer-details col-md-offset-1 col-md-10\" \n" +
    "    ng-if=\"vm.user.admin\"\n" +
    ">\n" +
    "    <div class=\"row\">\n" +
    "        <h2>\n" +
    "            {{vm.customerDetails.customerName}}\n" +
    "        </h2>\n" +
    "        <div class=\"pull-right\">\n" +
    "            <label translate>\n" +
    "                {{::'CUSTOMERDETAILS.NEEDSAPPROVAL'}}\n" +
    "            </label>\n" +
    "            <button \n" +
    "                type=\"button\" \n" +
    "                class=\"btn-approval\" \n" +
    "                ng-class=\"vm.customerSettings.noApproval ? 'fa fa-toggle-off' : 'fa fa-toggle-on'\" \n" +
    "                ng-click=\"vm.onClickToggle()\"\n" +
    "            >\n" +
    "            </button>\n" +
    "            <label \n" +
    "                ng-if=\"!vm.customerSettings.noApproval\"\n" +
    "                translate\n" +
    "            >\n" +
    "                {{::'CUSTOMER_DETAILS.AUTO_REJECT'}}\n" +
    "            </label>\n" +
    "            <input\n" +
    "                type=\"checkbox\"\n" +
    "                ng-if=\"!vm.customerSettings.noApproval\"\n" +
    "                ng-model=\"vm.customerSettings.autoReject\"\n" +
    "                ng-click=\"vm.onClickToggleAutoReject()\"\n" +
    "            />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <accordion close-others=\"true\">\n" +
    "            <accordion-group \n" +
    "                heading=\"{{'CUSTOMERDETAILS.CODESTEXTS' | translate}}\" \n" +
    "                is-open=\"true\"\n" +
    "            >\n" +
    "                <table \n" +
    "                    class=\"table\" \n" +
    "                    ng-repeat=\"list in vm.lists\"\n" +
    "                >\n" +
    "                    <tbody>\n" +
    "                    <tr ng-repeat=\"item in list.values\">\n" +
    "                        <th>\n" +
    "                            {{'CUSTOMERDETAILS.' + list.field | uppercase | translate}} {{item.index}}\n" +
    "                        </th>\n" +
    "                        <td>\n" +
    "                            {{item.value}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </accordion-group>\n" +
    "            <accordion-group \n" +
    "                heading=\"{{'CUSTOMERDETAILS.' + group.title | uppercase | translate}}\" \n" +
    "                ng-repeat=\"group in vm.fieldGroups\"\n" +
    "            >\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                    <tr ng-repeat=\"field in group.fields\">\n" +
    "                        <th>\n" +
    "                            {{'CUSTOMERDETAILS.' + field | uppercase | translate}}\n" +
    "                        </th>\n" +
    "                        <td>\n" +
    "                            {{vm.customerDetails[field]}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </accordion-group>\n" +
    "        </accordion>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("admin/discounts/discounts.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/discounts/discounts.tpl.html",
    "<div class=\"discounts col-md-offset-1 col-md-10\" ng-if=\"vm.user.admin\">\n" +
    "    <div class=\"row\">\n" +
    "        <h2>\n" +
    "            {{'DISCOUNT.TITLE' | translate}}\n" +
    "        </h2>\n" +
    "        <p>\n" +
    "            {{'DISCOUNT.BREADTEXT' | translate}}\n" +
    "        </p>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-offset-2 col-md-8\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                        <tr ng-repeat=\"discount in vm.discounts\">\n" +
    "                            <td class=\"\">\n" +
    "                                {{discount.articleGroupId}} - {{discount.articleGroupName}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                <input tabindex=\"{{discount.articleGroupId}}\" type=\"text\" class=\"form-control\" ng-class=\"{'invalid' : !vm.checkDiscount(discount)}\" ng-model=\"discount.discount\" ng-change=\"vm.changedDiscount(discount)\">\n" +
    "                                <button class=\"btn-remove\" ng-if=\"vm.hasDiscount(discount)\" ng-click=\"vm.removeDiscount(discount)\">\n" +
    "                                    <i class=\"fa fa-remove\"></i>\n" +
    "                                </button>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td colspan=\"2\" class=\"text-right\">\n" +
    "                                <button update-cart-button=\"\" text=\"{{'DISCOUNT.UPDATEMESSAGE' | translate}}\" title=\"{{'BUTTON.UPDATE' | translate}}\" is-enabled=\"vm.isDirty && vm.isValid\" action=\"vm.updateDiscounts()\"></button>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("admin/draftOrders/draftOrders.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/draftOrders/draftOrders.tpl.html",
    "<div class=\"draft-orders col-md-offset-1 col-md-10\" ng-if=\"vm.user.admin\">\n" +
    "    <h2>\n" +
    "        {{'DRAFTORDERS.TITLE' | translate}}\n" +
    "    </h2>\n" +
    "    <p ng-if=\"vm.hasAdminCarts()\">\n" +
    "        {{'DRAFTORDERS.SUBTITLE' | translate}}\n" +
    "    </p>\n" +
    "    <p ng-if=\"!vm.hasAdminCarts()\">\n" +
    "        {{'DRAFTORDERS.EMPTY' | translate}}\n" +
    "    </p>\n" +
    "    <table class=\"table table-hover\" ng-if=\"vm.hasAdminCarts()\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'DRAFTORDERS.CUSTOMER' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'DRAFTORDERS.EMPLOYEE' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'DRAFTORDERS.ITEMS' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'DRAFTORDERS.LASTMODIFIED' | translate}}\n" +
    "                </th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"adminCart in vm.user.adminCarts\" class=\"clickable\" ng-click=\"vm.selectAdminCart(adminCart)\">\n" +
    "                <td>\n" +
    "                    {{adminCart.customerName}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{adminCart.userName}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{adminCart.rowCount}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{adminCart.lastModified | date : 'yy-MM-dd HH:mm'}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>\n" +
    "");
}]);

angular.module("admin/pendingOrders/logoDialog/logoDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/pendingOrders/logoDialog/logoDialog.tpl.html",
    "<div class=\"logo-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'LOGODIALOG.VIEWDETAILS' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div ng-if=\"!vm.logo\" class=\"text-center\">\n" +
    "            {{'LOGODIALOG.LOGONOTAVAILABLE' | translate}}\n" +
    "        </div>\n" +
    "        <table class=\"table\" ng-if=\"vm.logo\">\n" +
    "            <tbody>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.PRODUCTGROUP' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{'PRODUCT.GROUP.' + vm.logo.productGroup | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.PRODUCTTYPE' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{'PRODUCT.TYPE.' + vm.logo.productType | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-if=\"vm.logo.productSubtype\">\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.PRODUCTSUBTYPE' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{'PRODUCT.SUBTYPE.' + vm.logo.productSubtype | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.LOGONAME' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{vm.logo.logoName}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.TEMPLATEID' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{vm.logo.templateId}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.LOGOHEIGHT' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{vm.logo.logoHeight}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.LOGOWIDTH' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{vm.logo.logoWidth}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-if=\"vm.logo.stitchCount\">\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.STITCHCOUNT' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{vm.logo.stitchCount}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-if=\"vm.logo.LogoInformation\">\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.LOGOINFORMATION' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{vm.logo.LogoInformation}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-if=\"vm.logo.mountingArticle\">\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.MOUNTINGARTICLE' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{vm.logo.mountingArticle}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.STANDARDCOLOURS' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <p ng-repeat=\"colour in vm.logo.standardColours\">\n" +
    "                        {{colour}}\n" +
    "                    </p>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.SPECIALCOLOURS' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <p ng-repeat=\"colour in vm.logo.specialColours\">\n" +
    "                        {{colour}}\n" +
    "                    </p>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-if=\"vm.logo.tags\">\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.TAGS' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <p ng-repeat=\"tag in vm.logo.tags\">\n" +
    "                        {{tag}}\n" +
    "                    </p>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.PROCESS' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{('BOOLEAN.' + vm.logo.process).toUpperCase() | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.CONTACT' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{('BOOLEAN.' + vm.logo.contact).toUpperCase() | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-if=\"vm.logo.edgeType\">\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.EDGETYPE' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{'PRODUCT.EDGE.' + vm.logo.edgeType | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-if=\"vm.logo.foldType\">\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.FOLDTYPE' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{'PRODUCT.FOLD.' + vm.logo.foldType | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-if=\"vm.logo.warpType\">\n" +
    "                <td>\n" +
    "                    {{'LOGODIALOG.WARPTYPE' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{'PRODUCT.WARP.' + vm.logo.warpType | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <a class=\"btn btn-default\"\n" +
    "           href=\"{{vm.attachmentUrl}}\"\n" +
    "           target=\"_blank\"\n" +
    "           title=\"{{'TOOLTIP.DOWNLOADIMAGE' | translate}}\"\n" +
    "           type=\"button\"\n" +
    "           ng-disabled=\"!vm.logo\">\n" +
    "            <span>\n" +
    "                <i aria-hidden=\"true\" class=\"fa fa-download\"></i>\n" +
    "            </span>\n" +
    "        </a>\n" +
    "        <a class=\"btn btn-default\"\n" +
    "           href=\"{{vm.originalAttachmenUrl}}\"\n" +
    "           ng-if=\"vm.originalAttachmenUrl\"\n" +
    "           target=\"_blank\"\n" +
    "           title=\"{{'TOOLTIP.DOWNLOADIMAGE' | translate}}\"\n" +
    "           type=\"button\">\n" +
    "            <span>\n" +
    "                <i aria-hidden=\"true\" class=\"fa fa-download\"></i>\n" +
    "                {{'LABEL.FILE.ORIGINAL' | translate}}\n" +
    "            </span>\n" +
    "        </a>\n" +
    "        <button class=\"btn btn-default\" name=\"cancel\" ng-click=\"vm.close()\" type=\"button\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("admin/pendingOrders/pendingOrderList.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/pendingOrders/pendingOrderList.tpl.html",
    "<div breadcrumbs links=\"vm.links\"></div>\n" +
    "<div class=\"pending-orders col-md-offset-1 col-md-10\" ng-if=\"vm.user.admin\">\n" +
    "    <h2>\n" +
    "        {{'PENDINGORDERS.TITLE' | translate}}\n" +
    "    </h2>\n" +
    "    <p ng-if=\"vm.pendingOrders.length !== 0\">\n" +
    "        {{'PENDINGORDERS.SUBTITLE' | translate}}\n" +
    "    </p>\n" +
    "    <p ng-if=\"vm.pendingOrders.length === 0\">\n" +
    "        {{'PENDINGORDERS.EMPTY' | translate}}\n" +
    "    </p>\n" +
    "    <table class=\"table table-hover\" ng-if=\"vm.pendingOrders.length !== 0\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.CUSTOMERNUMBER' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.CUSTOMERNAME' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.USER' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.ROWCOUNT' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.INTERNALREFERENCE' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.EXTERNALREFERENCE' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.CREATED' | translate}}\n" +
    "                </th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"pendingOrder in vm.pendingOrders\" class=\"clickable\" ng-click=\"vm.selectOrder(pendingOrder)\">\n" +
    "                <td>\n" +
    "                    {{pendingOrder.customerId}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{pendingOrder.customerName}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{pendingOrder.userName}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{pendingOrder.orderRowCount}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{pendingOrder.internalReference}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{pendingOrder.externalReference}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{pendingOrder.dateCreated | date : 'yy-MM-dd HH:mm'}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>\n" +
    "");
}]);

angular.module("admin/pendingOrders/pendingOrderView.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/pendingOrders/pendingOrderView.tpl.html",
    "<div class=\"pending-order\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <h2>\n" +
    "        {{'PENDINGORDERS.ORDERDETAILS' | translate}}\n" +
    "    </h2>\n" +
    "    <div class=\"col-md-5\">\n" +
    "        <table class=\"table\">\n" +
    "            <tbody>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PENDINGORDERS.DATECREATED' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.pendingOrder.dateCreated | date : 'yy-MM-dd HH:mm'}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PENDINGORDERS.CUSTOMERID' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.pendingOrder.orderRecord.customerId}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PENDINGORDERS.USERNAME' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.pendingOrder.orderRecord.userName}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PENDINGORDERS.USEREMAIL' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.pendingOrder.orderRecord.userEmail}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PENDINGORDERS.INSTRUCTION' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.pendingOrder.orderRecord.instruction}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PENDINGORDERS.EXTERNALREFERENCE' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.pendingOrder.orderRecord.externalReference}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PENDINGORDERS.INTERNALREFERENCE' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.pendingOrder.orderRecord.internalReference}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PENDINGORDERS.MOUNTINGREQUIRED' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{('BOOLEAN.' + vm.pendingOrder.orderRecord.mountingRequired).toUpperCase() | translate}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-3 pull-right pending-order-panel\">\n" +
    "        <button ng-if=\"vm.isOrderPending()\" class=\"btn btn-success\" title=\"{{'TOOLTIP.APPROVE' | translate}}\" ng-click=\"vm.approveOrder()\">\n" +
    "            <i class=\"fa fa-thumbs-up\" aria-hidden=\"true\"></i>\n" +
    "        </button>\n" +
    "        <button ng-if=\"vm.isOrderPending()\" class=\"btn btn-danger\" title=\"{{'TOOLTIP.REJECT' | translate}}\" ng-click=\"vm.rejectOrder()\">\n" +
    "            <i class=\"fa fa-thumbs-down\" aria-hidden=\"true\"></i>\n" +
    "        </button>\n" +
    "        <div ng-if=\"vm.pendingOrder.orderRecord.addressRecipient\" class=\"panel panel-default info-panel\">\n" +
    "            <div class=\"panel-heading\">\n" +
    "                {{'PENDINGORDERS.DELIVERYADDRESS' | translate}}\n" +
    "            </div>\n" +
    "            <div class=\"price-table\">\n" +
    "                <p>\n" +
    "                    {{vm.pendingOrder.orderRecord.addressRecipient}}\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    {{vm.pendingOrder.orderRecord.addressLine1}}\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    {{vm.pendingOrder.orderRecord.addressLine2}}\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    {{vm.pendingOrder.orderRecord.addressCity}}\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    {{vm.pendingOrder.orderRecord.addressPostCode}}\n" +
    "                </p>\n" +
    "                <p>\n" +
    "                    {{vm.pendingOrder.orderRecord.addressCountryCode}}\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <table class=\"table pending-rows\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.ARTICLENUMBER' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.TEMPLATEID' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"text-right\">\n" +
    "                    {{'PENDINGORDERS.QUANTITY' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.INSTRUCTION' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"text-right\">\n" +
    "                    {{'PENDINGORDERS.DISCOUNT' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"text-right\">\n" +
    "                    {{'PENDINGORDERS.ITEMPRICE' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"text-right\">\n" +
    "                    {{'PENDINGORDERS.NETPRICE' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"text-right\">\n" +
    "                    {{'PENDINGORDERS.TOTALPRICE' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.EXPRESS' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PENDINGORDERS.COSTTYPE' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    &nbsp;\n" +
    "                </th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"row in vm.pendingOrder.orderRecord.orderRows\">\n" +
    "                <td>\n" +
    "                    {{row.articleId}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{row.templateId}}\n" +
    "                </td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    {{row.quantity}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-attr-title=\"{{row.instruction}}\">\n" +
    "                        {{row.instruction | limitTo: 25}}{{row.instruction.length > 25 ? '&hellip;' : ''}}\n" +
    "                        <button class=\"btn btn-sm btn-default\" ng-if=\"row.instruction\" ng-click=\"vm.showInstructions(row.instruction)\">\n" +
    "                            <i class=\"fa fa-comments\"></i>\n" +
    "                        </button>\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    {{row.discount}}\n" +
    "                </td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    {{row.itemPrice}}\n" +
    "                </td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    {{row.netPrice}}\n" +
    "                </td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    {{row.totalPrice}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{('BOOLEAN.' + row.express).toUpperCase() | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-if=\"row.costType\">\n" +
    "                        {{('COST.' + row.costType) | translate}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <button ng-if=\"row.logoId\" type=\"button\" class=\"btn btn-sm btn-default\" title=\"{{'TOOLTIP.VIEWLOGO' | translate}}\" ng-click=\"vm.openLogoDialog(row.logoId)\">\n" +
    "                        <i class=\"fa fa-clone\" aria-hidden=\"true\"></i>\n" +
    "                    </button>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>\n" +
    "");
}]);

angular.module("admin/productTypes/productTypes.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/productTypes/productTypes.tpl.html",
    "<div class=\"product-types row\" ng-if=\"vm.user.admin\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <h2>\n" +
    "            {{'PRODUCTTYPES.TITLE' | translate}}\n" +
    "        </h2>\n" +
    "        <p>\n" +
    "            {{'PRODUCTTYPES.SUBTITLE' | translate}}\n" +
    "        </p>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-3\">\n" +
    "        <button class=\"btn\" ng-class=\"{'btn-default': productType !== vm.productType, 'btn-success': productType == vm.productType}\"\n" +
    "                ng-repeat=\"productType in vm.productTypes\" ng-click=\"vm.onClickProductType(productType)\">\n" +
    "            {{'PRODUCT.TYPE.' + productType.name | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-6\" ng-if=\"vm.productType\">\n" +
    "        <h3>\n" +
    "            {{'PRODUCTTYPES.SECTION1' | translate}}\n" +
    "        </h3>\n" +
    "        <table class=\"table table-type\">\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.NAME' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{(vm.productType.name ? 'PRODUCT.TYPE.' + vm.productType.name : 'PRODUCTTYPES.NOTSPECIFIED') | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.PRODUCTTYPE' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.groupType || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.ARTICLEGROUP' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.articleGroup || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.COLOURTYPE' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.colourType || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.MINIMUMCOLOURS' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.minColourCount || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.MAXIMUMCOLOURS' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.maxColourCount || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.MINORDERQUANTITY' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.quantitySettings.minOrderQuantity}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.MINPRODUCTIONQUANTITY' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.quantitySettings.minProductionQuantity}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.REFILLQUANTITY' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.quantitySettings.minRefillQuantity}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.THRESHOLD' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{vm.productType.startCostThreshold || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.SPECIALCOLOURS' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{('PRODUCTTYPES.BOOLEAN.' + vm.productType.debitSpecialColours).toUpperCase() | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.EDGETYPES' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    <span ng-if=\"vm.productType.edgeTypes.length == 0\">\n" +
    "                        {{'PRODUCTTYPES.NONE' | translate}}\n" +
    "                    </span>\n" +
    "                    <span ng-repeat=\"edgeType in vm.productType.edgeTypes\">\n" +
    "                        {{'PRODUCT.EDGE.' + edgeType | translate}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.WARPTYPES' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    <span ng-if=\"vm.productType.warpTypes.length == 0\">\n" +
    "                        {{'PRODUCTTYPES.NONE' | translate}}\n" +
    "                    </span>\n" +
    "                    <span ng-repeat=\"warpType in vm.productType.warpTypes\">\n" +
    "                        {{'PRODUCT.WARP.' + warpType | translate}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.FOLDTYPES' | translate}}:\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    <span ng-if=\"vm.productType.foldTypes.length == 0\">\n" +
    "                        {{'PRODUCTTYPES.NONE' | translate}}\n" +
    "                    </span>\n" +
    "                    <span ng-repeat=\"foldType in vm.productType.foldTypes\">\n" +
    "                        {{'PRODUCT.FOLD.' + foldType | translate}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'CREATEARTICLE.BACKSIDES' | translate}}\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                     <span ng-if=\"!vm.productType.backsides || vm.productType.backsides.length == 0\">\n" +
    "                        {{'PRODUCTTYPES.NONE' | translate}}\n" +
    "                    </span>\n" +
    "                    <span ng-repeat=\"foldType in vm.productType.backsides\">\n" +
    "                        {{foldType}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.ALLOWLOGOUPLOAD' | translate}}\n" +
    "                </th>\n" +
    "                <td>\n" +
    "                    {{('PRODUCTTYPES.BOOLEAN.' + vm.productType.allowLogoUpload).toUpperCase() | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "        <h3 ng-if=\"vm.productType\">\n" +
    "            {{'PRODUCTTYPES.SECTION2' | translate}}\n" +
    "        </h3>\n" +
    "        <table ng-if=\"vm.productType\" class=\"table table-subtype\">\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.NAME' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.PREFIX' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.STARTCOST' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.PROCESSPREFIX' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.PROCESSSTARTCOST' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.EXACTCOLOURCOUNT' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTTYPES.PRODUCTIONCUSTOMERNUMBER' | translate}}\n" +
    "                </th>\n" +
    "            </tr>\n" +
    "            <tr ng-repeat=\"productSubtype in vm.productType.productSubtypes\">\n" +
    "                <td>\n" +
    "                    {{(productSubtype.name ? 'PRODUCT.SUBTYPE.' + productSubtype.name : 'PRODUCTTYPES.NOTSPECIFIED') | translate}}\n" +
    "                    {{productSubtype.customerId ? '(' + productSubtype.customerId + ')' : ''}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{productSubtype.prefix || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{productSubtype.startCost || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{productSubtype.processPrefix || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{productSubtype.processStartCost || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{productSubtype.exactColourCount || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{productSubtype.productionCustomerNumber || 'PRODUCTTYPES.NOTSPECIFIED' | translate}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-3\" ng-if=\"vm.productType.exampleImage\">\n" +
    "        <h3 class=\"h3-center\">\n" +
    "            {{'LABEL.EXAMPLE' | translate}}\n" +
    "        </h3>\n" +
    "        <img class=\"example-image\" ng-src=\"./assets/images/{{vm.getExampleImage()}}\">\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("admin/templateCopy/templateCopy.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("admin/templateCopy/templateCopy.tpl.html",
    "<div class=\"template-copy\">\n" +
    "    <div load-spinner spinner-name=\"copy-spinner\"></div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h2>\n" +
    "                {{'ADMIN.COPYTEMPLATE' | translate}}\n" +
    "            </h2>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-6\">\n" +
    "            <table class=\"table table-responsive\">\n" +
    "                <tbody>\n" +
    "                <tr>\n" +
    "                    <td colspan=\"2\">{{'ADMIN.COPYTEMPLATE.FROM' | translate}}</td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\" translate>{{'ADMIN.COPYTEMPLATE.STORE'}}</td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <div>\n" +
    "                            <ui-select ng-model=\"vm.selectedSource\" on-select=\"vm.onSelectSource()\">\n" +
    "                                <ui-select-match placeholder=\"{{ 'ADMIN.COPYTEMPLATE.PLACEHOLDERSTORE' | translate }}\">\n" +
    "                                    {{ $select.selected.storeId }} - {{ $select.selected.storeName }}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"store in vm.stores | orderBy: 'storeId' | filter: $select.search\">\n" +
    "                                    <span class=\"item-name\">{{ store.storeId }} - {{ store.storeName }}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CLUB'}}</td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <div>\n" +
    "                            <ui-select ng-model=\"vm.selectedClub\" on-select=\"vm.onSelectClub()\">\n" +
    "                                <ui-select-match allow-clear=\"true\" placeholder=\"{{ 'ADMIN.COPYTEMPLATE.ALLCLUBS' | translate }}\">\n" +
    "                                    {{ $select.selected.clubName }}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"club in vm.clubs | orderBy: 'clubName' | filter: $select.search\">\n" +
    "                                    <span class=\"item-name\">{{ club.clubName }}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-6\">\n" +
    "            <table class=\"table table-responsive\">\n" +
    "                <tbody>\n" +
    "                <tr>\n" +
    "                    <td colspan=\"2\">{{'ADMIN.COPYTEMPLATE.TO' | translate}}</td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\" translate>{{'ADMIN.COPYTEMPLATE.STORE'}}</td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <div>\n" +
    "                            <ui-select ng-model=\"vm.selectedDestination\">\n" +
    "                                <ui-select-match placeholder=\"{{ 'ADMIN.COPYTEMPLATE.PLACEHOLDERSTORE' | translate }}\">\n" +
    "                                    {{ $select.selected.storeId }} - {{ $select.selected.storeName }}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"store in vm.stores | orderBy: 'storeId' | filter: $select.search\">\n" +
    "                                    <span class=\"item-name\">{{ store.storeId }} - {{ store.storeName }}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"pull-right\">\n" +
    "                <button class=\"btn btn-success\" ng-click=\"vm.copy()\">{{'BUTTON.COPY' | translate}}</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("productionPlanning/errands/errandProofsDialog/errandProofsDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("productionPlanning/errands/errandProofsDialog/errandProofsDialog.tpl.html",
    "<div class=\"errand\">\n" +
    "    <div modalWindow/>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'PRODUCTIONPLANNING.CREATEPROOF'| translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <table class=\"table\">\n" +
    "            <tbody>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width top-align\">\n" +
    "                        {{'PRODUCTIONPLANNING.INFORMATION'| translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <textarea placeholder=\"{{vm.getInfoPlaceholder()}}\" class=\"form-control\" ng-model=\"vm.information\" tabindex=\"1\"></textarea>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"file\">\n" +
    "                        {{'PRODUCTIONPLANNING.FILE'| translate}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <button class=\"fileButton btn-default pull-left\" ng-click=\"$event.preventDefault()\" ng-file-select=\"\" ng-accept=\"vm.onFileSelect($file)\" ng-model=\"vm.file\" ng-multiple=\"true\" tabindex=\"6\">\n" +
    "                            {{'BUTTON.SELECTFILES' | translate}}\n" +
    "                        </button>\n" +
    "                        <ul class=\"file-list\">\n" +
    "                            <li ng-repeat=\"fileIndex in vm.getFileButtonRange()\">\n" +
    "                                <button class=\"btn-delete\" ng-click=\"vm.removeFile(fileIndex)\" ng-if-start=\"vm.files[fileIndex].name\">\n" +
    "                                    <i class=\"fa fa-remove\"></i>\n" +
    "                                </button>\n" +
    "                                <span class=\"file-name\" ng-if-end>\n" +
    "                                    {{vm.files[fileIndex].name}}\n" +
    "                                </span>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CANCEL' | translate}}\n" +
    "        </button>\n" +
    "        <button type=\"button\" tabindex=\"4\" ng-click=\"vm.save()\" class=\"btn btn-success\" ng-disabled=\"!vm.isValid()\">\n" +
    "            {{'BUTTON.SUBMIT' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("productionPlanning/errands/errandsDialog/errandsDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("productionPlanning/errands/errandsDialog/errandsDialog.tpl.html",
    "<div class=\"errandsDialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div ng-if=\"vm.isEditing\" class=\"modal-title\">\n" +
    "            {{'PRODUCTIONPLANNING.EDITERRAND' | translate}}\n" +
    "        </div>\n" +
    "        <div ng-if=\"!vm.isEditing\" class=\"modal-title\">\n" +
    "            {{'PRODUCTIONPLANNING.CREATEERRAND' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body errand\">\n" +
    "        <div ng-if=\"vm.errorMessage\" class=\"alert alert-danger\">\n" +
    "            {{vm.errorMessage}}\n" +
    "        </div>\n" +
    "        <div ng-if=\"vm.isSelectedEmployeeBlocked()\" class=\"alert alert-danger\">\n" +
    "            {{'NAVIGATION.SELECTEDUSERBLOCKED' | translate}}\n" +
    "        </div>\n" +
    "        <table class=\"table customer-picker\">\n" +
    "            <tbody>\n" +
    "                <tr ng-if=\"!vm.errand.customerId\">\n" +
    "                    <td>\n" +
    "                        {{'PRODUCTIONPLANNING.CUSTOMER'| translate}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <ui-select tabindex=\"1\" ng-model=\"vm.selectedCustomer\" on-select=\"vm.onCustomerSelect($item)\" class=\"select-customer\">\n" +
    "                            <ui-select-match placeholder=\"{{'LABEL.ENTERCUSTOMER' | translate}}\">\n" +
    "                                {{$select.selected.id}} - {{$select.selected.name}}\n" +
    "                            </ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"customer in vm.customers | filter:{search:$select.search} | limitTo:50\">\n" +
    "                                <span>{{customer.id}} - {{customer.name}}</span>\n" +
    "                            </ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-if=\"!vm.errand.userId\">\n" +
    "                    <td>\n" +
    "                        {{'PRODUCTIONPLANNING.USER'| translate}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <ui-select tabindex=\"2\" ng-model=\"vm.selectedEmployee\" on-select=\"vm.onEmployeeSelect($item)\" ng-disabled=\"!vm.selectedCustomer.id\" class=\"select-employee\">\n" +
    "                            <ui-select-match placeholder=\"{{'LABEL.ENTEREMPLOYEE' | translate}}\">\n" +
    "                                {{$select.selected.name}}\n" +
    "                            </ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"employee in vm.employees | filter:{name:$select.search}\">\n" +
    "                                <span>{{employee.name}}</span>\n" +
    "                            </ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PRODUCTIONPLANNING.ERRANDTYPES'| translate}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <span ng-repeat=\"errandType in vm.errandTypes\">\n" +
    "                            <input type=\"checkbox\" ng-checked=\"vm.isSelected(errandType)\" ng-click=\"vm.toggleErrandTypes(errandType)\"/>\n" +
    "                                <span>\n" +
    "                                    {{'PRODUCTIONPLANNING.ERRANDTYPE.' + errandType | translate}}\n" +
    "                                </span>\n" +
    "                        </span>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PRODUCTIONPLANNING.EXPRESS'| translate}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <input type=\"checkbox\" ng-model=\"vm.express\"/>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width top-align\">\n" +
    "                        {{'PRODUCTIONPLANNING.INFORMATION'| translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <textarea class=\"form-control select-information\" ng-model=\"vm.information\" tabindex=\"3\"></textarea>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PRODUCTIONPLANNING.TAGS'| translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width tags\">\n" +
    "                        <ui-select tabindex=\"4\" reset-search-input=\"true\" multiple search-enabled=\"false\" tagging=\"vm.newTag\" tagging-label=\"false\" tagging-tokens=\"ENTER\" ng-model=\"vm.tags\" title=\"\" theme=\"bootstrap\">\n" +
    "                            <ui-select-match placeholder=\"\">{{$item}}</ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'PRODUCTIONPLANNING.RESOURCE'| translate}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <ui-select tabindex=\"5\" ng-model=\"vm.selectedResource\" class=\"select-resource\">\n" +
    "                            <ui-select-match placeholder=\"{{'PRODUCTIONPLANNING.ENTERRESOURCE' | translate}}\">\n" +
    "                                {{$select.selected.resourceName}}\n" +
    "                            </ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"resource in vm.resources | filter:$select.search | limitTo:50\">\n" +
    "                                <span>{{resource.resourceName}}</span>\n" +
    "                            </ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                        <button class=\"btn btn-default trash pull-right\" title=\"{{'TOOLTIP.CLEAR' | translate}}\" ng-click=\"vm.onClickClear()\">\n" +
    "                            <i class=\"fa fa-trash\" title=\"{{'PRODUCTIONITEMS.TOOLTIP.CLEAR' | translate}}\">\n" +
    "                            </i>\n" +
    "                        </button>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"file\">\n" +
    "                        {{'PRODUCTIONPLANNING.FILE'| translate}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <button class=\"fileButton btn-default pull-left\" ng-click=\"$event.preventDefault()\" ng-file-select=\"\" ng-accept=\"vm.onFileSelect($file)\" ng-model=\"vm.file\" ng-multiple=\"true\" tabindex=\"6\">\n" +
    "                            {{'BUTTON.SELECTFILES' | translate}}\n" +
    "                        </button>\n" +
    "                        <ul class=\"file-list\">\n" +
    "                            <li ng-repeat=\"fileIndex in vm.getFileButtonRange()\">\n" +
    "                                <button class=\"btn-delete\" ng-click=\"vm.removeFile(fileIndex)\" ng-if-start=\"vm.files[fileIndex].name\">\n" +
    "                                    <i class=\"fa fa-remove\"></i>\n" +
    "                                </button>\n" +
    "                                <span class=\"file-name\" ng-if-end>\n" +
    "                                    {{vm.files[fileIndex].name}}\n" +
    "                                </span>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button tabindex=\"7\" name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\" translate>\n" +
    "            {{'BUTTON.CANCEL'}}\n" +
    "        </button>\n" +
    "        <button tabindex=\"8\" type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-success\" ng-disabled=\"!vm.isValid()\" ng-if=\"!vm.errorMessage\" translate>\n" +
    "            {{'BUTTON.SUBMIT'}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("productionPlanning/errands/errandsList.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("productionPlanning/errands/errandsList.tpl.html",
    "<div breadcrumbs links=\"vm.links\"></div>\n" +
    "<div class=\"errand\" ng-if=\"vm.user.admin\">\n" +
    "    <div class=\"filter\">\n" +
    "        <div class=\"row filter-row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <div class=\"col-md-2\">\n" +
    "                    <label>\n" +
    "                        {{'PRODUCTIONPLANNING.ERRANDID' | translate}}\n" +
    "                    </label>\n" +
    "                    <input type=\"text\" class=\"form-control input-sm\" ng-model=\"vm.filter.errandId\" ng-model-options=\"{ debounce: 400 }\"/>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2\">\n" +
    "                    <label>\n" +
    "                        {{'PRODUCTIONPLANNING.CUSTOMER' | translate}}\n" +
    "                    </label>\n" +
    "                    <input type=\"text\" class=\"form-control input-sm\" ng-model=\"vm.filter.customerId\" ng-model-options=\"{ debounce: 400 }\"/>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2\">\n" +
    "                    <label>\n" +
    "                        {{'PRODUCTIONPLANNING.TAG' | translate}}\n" +
    "                    </label>\n" +
    "                    <input type=\"text\" class=\"form-control input-sm\" ng-model=\"vm.filter.tag\" ng-model-options=\"{ debounce: 400 }\"/>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2\">\n" +
    "                    <label>\n" +
    "                        {{'PRODUCTIONPLANNING.ERRANDSTATUS' | translate}}\n" +
    "                    </label>\n" +
    "                    <ui-select ng-model=\"vm.filter.errandStatus\">\n" +
    "                        <ui-select-match placeholder=\"{{'PRODUCTIONPLANNING.SELECTSTATUS' | translate}}\">\n" +
    "                            {{'PRODUCTIONPLANNING.ERRANDSTATUS.' + $select.selected | translate}}\n" +
    "                        </ui-select-match>\n" +
    "                        <ui-select-choices repeat=\"status in vm.errandStatusTypes | translationFilter: $select.search : 'PRODUCTIONPLANNING.ERRANDSTATUS.'\">\n" +
    "                            <span>\n" +
    "                                {{'PRODUCTIONPLANNING.ERRANDSTATUS.' + status | translate}}\n" +
    "                            </span>\n" +
    "                        </ui-select-choices>\n" +
    "                    </ui-select>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2\">\n" +
    "                    <label>\n" +
    "                        {{'PRODUCTIONPLANNING.RESOURCE' | translate}}\n" +
    "                    </label>\n" +
    "                    <ui-select ng-model=\"vm.selectedResource\" on-select=\"vm.onResourceSelect($item)\">\n" +
    "                        <ui-select-match placeholder=\"{{'PRODUCTIONPLANNING.SELECTRESOURCE' | translate}}\">\n" +
    "                            {{vm.selectedResource.resourceName}}\n" +
    "                        </ui-select-match>\n" +
    "                        <ui-select-choices repeat=\"resource in vm.resources | filter:$select.search\">\n" +
    "                            <span>\n" +
    "                                {{resource.resourceName}}\n" +
    "                            </span>\n" +
    "                        </ui-select-choices>\n" +
    "                    </ui-select>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-1\">\n" +
    "                    <label>\n" +
    "                        &nbsp;\n" +
    "                    </label>\n" +
    "                    <button class=\"btn btn-default btn-sm button-trash\" ng-click=\"vm.onClickClear()\">\n" +
    "                        <i class=\"fa fa-trash\" title=\"{{'TOOLTIP.CLEAR' | translate}}\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2 pull-right\">\n" +
    "                    <label>\n" +
    "                        &nbsp;\n" +
    "                    </label>\n" +
    "                    <span class=\"icon-buttons pull-right\">\n" +
    "                        <button title=\"{{'TOOLTIP.FILTERICON.' + type | translate}}\" class=\"btn btn-default btn-xs\" ng-class=\"{ 'btn-default' : !vm.isSelected(type), 'btn-success' : vm.isSelected(type) }\" ng-repeat=\"type in vm.errandTypes\" ng-click=\"vm.toggleTodo(type)\">\n" +
    "                            <i class=\"fa fa-{{('FONTAWESOME.' + type) | translate}}\" aria-hidden=\"true\">\n" +
    "                            </i>\n" +
    "                        </button>\n" +
    "                    </span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"pull-right\">\n" +
    "            <input type=\"checkbox\" id=\"includeArchived\" ng-model=\"vm.filter.includeArchived\"/>\n" +
    "            <label for=\"includeArchived\" class=\"checkboxLabel\" title=\"{{'PRODUCTIONPLANNING.ERRANDS.INCLUDEARCHIVED.TOOLTIP' | translate}}\" translate>\n" +
    "                {{'PRODUCTIONPLANNING.ERRANDS.INCLUDEARCHIVED'}}\n" +
    "            </label>\n" +
    "            <input type=\"checkbox\" id=\"unreadEmail\" ng-model=\"vm.filter.unreadEmail\"/>\n" +
    "            <label for=\"unreadEmail\" class=\"checkboxLabel\">\n" +
    "                {{'PRODUCTIONPLANNING.ERRANDS.UNREADMAIL' | translate}}\n" +
    "            </label>\n" +
    "            <input type=\"checkbox\" id=\"express\" ng-model=\"vm.filter.express\"/>\n" +
    "            <label for=\"express\" class=\"checkboxLabel\">\n" +
    "                {{'PRODUCTIONPLANNING.EXPRESSITEMS' | translate}}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-3 pull-right text-right plus\">\n" +
    "            <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.openErrandDialog()\" title=\"{{'TOOLTIP.NEWERRAND' | translate}}\">\n" +
    "                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "        <h2>\n" +
    "            {{'PRODUCTIONPLANNING.ERRANDS' | translate}}\n" +
    "        </h2>\n" +
    "        <div class=\"articles-list\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <div class=\"table-responsive\">\n" +
    "                        <table ng-table=\"vm.tableParams\" class=\"table table-hover\">\n" +
    "                            <tbody>\n" +
    "                                <tr ng-repeat=\"errand in $data\" class=\"clickable {{vm.getRemindUsersClass(errand)}}\" ng-click=\"vm.selectErrand(errand)\">\n" +
    "                                    <td data-title=\"'PRODUCTIONPLANNING.ERRANDID' | translate\" sortable=\"'id'\">\n" +
    "                                        <i class=\"fa fa-envelope\" aria-hidden=\"true\" ng-class=\"{transparent: !errand.unreadEmail}\"></i>\n" +
    "                                        <span class=\"mail-column\">{{::errand.id}}</span>\n" +
    "                                    </td>\n" +
    "                                    <td data-title=\"'PRODUCTIONPLANNING.CUSTOMER' | translate\" sortable=\"'customerId'\">\n" +
    "                                        <span ng-if=\"errand.customerId\" ng-attr-title=\"{{errand.customerId + ' - ' + errand.customerName}}\">\n" +
    "                                            {{vm.getCustomerTitle(errand) | limitTo: 15}}{{vm.getCustomerTitle(errand).length > 15 ? '&hellip;' : ''}}\n" +
    "                                        </span>\n" +
    "                                    </td>\n" +
    "                                    <td data-title=\"'PRODUCTIONPLANNING.DATEREGISTERED' | translate\" sortable=\"'registeredDate'\">\n" +
    "                                        {{::errand.registeredDate | date : 'yy-MM-dd HH:mm'}}\n" +
    "                                    </td>\n" +
    "                                    <td data-title=\"'PRODUCTIONPLANNING.LATESTMAIL' | translate\" sortable=\"'lastEmailDate'\">\n" +
    "                                        {{::errand.lastEmailDate | date : 'yy-MM-dd HH:mm'}}\n" +
    "                                    </td>\n" +
    "                                    <td data-title=\"'PRODUCTIONPLANNING.RESOURCE' | translate\" sortable=\"'resourceId'\">\n" +
    "                                        {{vm.getResourceName(errand.resourceId) | limitTo: 15}}{{vm.getResourceName(errand.resourceId).length > 15 ? '&hellip;' : ''}}\n" +
    "                                    </td>\n" +
    "                                    <td data-title=\"'PRODUCTIONPLANNING.TAGS' | translate\">\n" +
    "                                        <span ng-attr-title=\"{{::errand.tags.join(', ')}}\">\n" +
    "                                            {{::errand.tags.join(\", \") | limitTo: 15}}{{errand.tags.join(\", \").length > 15 ? '&hellip;' : ''}}\n" +
    "                                        </span>\n" +
    "                                    </td>\n" +
    "                                    <td data-title=\"'PRODUCTIONPLANNING.STATUS' | translate\">\n" +
    "                                        <span class=\"{{vm.getStatusClass(errand)}}\">\n" +
    "                                            {{'PRODUCTIONPLANNING.ERRANDSTATUS.' + errand.status | translate}}\n" +
    "                                        </span>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"text-center\">\n" +
    "                                        <i class=\"fa fa-exclamation-circle express\" aria-hidden=\"true\" ng-if=\"errand.express\"></i>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"icons text-right\">\n" +
    "                                        <i ng-repeat=\"type in vm.errandTypes\" class=\"fa fa-{{('FONTAWESOME.' + type) | translate}} {{vm.getIconClass(errand, type)}}\" aria-hidden=\"true\" title=\"{{vm.getIconTitle(errand, type)}}\">\n" +
    "                                        </i>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                            </tbody>\n" +
    "                        </table>\n" +
    "                        <div ng-show=\"vm.tableParams.total() === 0 && vm.initialized\" class=\"alert alert-info text-center\">\n" +
    "                            <h4>\n" +
    "                                {{'PRODUCTIONPLANNING.ERRANDLIST.NOITEMS' | translate}}\n" +
    "                            </h4>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("productionPlanning/errands/errandsView.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("productionPlanning/errands/errandsView.tpl.html",
    "<div class=\"errand\" ng-if=\"vm.user.admin\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <div class=\"row errand-section\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div ng-if=\"vm.isCustomerBlocked\" class=\"alert alert-danger\">\n" +
    "                {{'NAVIGATION.SELECTEDUSERBLOCKED' | translate}}\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.alerts.length == 1\" class=\"alert alert-warning\">\n" +
    "                {{vm.alerts[0] | translate}}\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.alerts.length == 4\" class=\"alert alert-warning\">\n" +
    "                {{vm.alerts[0] | translate}}\n" +
    "                <a href=\"\" ng-click=\"vm.alerts[1]()\" class=\"whiteBold\">\n" +
    "                    {{vm.alerts[2] | translate}}\n" +
    "                </a>\n" +
    "                {{vm.alerts[3] | translate}}\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.alerts.length == 8\" class=\"alert alert-warning\">\n" +
    "                {{vm.alerts[0] | translate}}\n" +
    "                <a href=\"\" ng-click=\"vm.alerts[1]()\" class=\"whiteBold\">\n" +
    "                    {{vm.alerts[2] | translate}}\n" +
    "                </a>\n" +
    "                {{vm.alerts[3] | translate}}\n" +
    "                {{vm.alerts[4] | translate}}\n" +
    "                <a href=\"\" ng-click=\"vm.alerts[6]()\" class=\"whiteBold\">\n" +
    "                    {{vm.alerts[5] | translate}}\n" +
    "                </a>\n" +
    "                {{vm.alerts[7] | translate}}\n" +
    "            </div>\n" +
    "            <h2>\n" +
    "                {{'PRODUCTIONPLANNING.ERRANDDETAILS' | translate}}\n" +
    "            </h2>\n" +
    "            <div class=\"col-md-5\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.ID' | translate}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{vm.errand.id}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.STATUS' | translate}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'PRODUCTIONPLANNING.STATUS' | translate\">\n" +
    "                                <span class=\"{{vm.getStatusClass(vm.errand.status)}}\">\n" +
    "                                    {{'PRODUCTIONPLANNING.ERRANDSTATUS.' + vm.errand.status | translate}}\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.errand.tags && vm.errand.tags.length > 0\">\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.TAGS' | translate}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{vm.errand.tags.join(\", \")}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.DATEREGISTERED' | translate}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{vm.errand.registeredDate | date : 'yy-MM-dd HH:mm'}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.CREATEDBY' | translate}}\n" +
    "                            </td>\n" +
    "                            <td ng-if=\"vm.errand.creatorId && vm.errand.creatorId.length > 0\">\n" +
    "                                {{vm.getResourceName(vm.errand.creatorId)}}\n" +
    "                            </td>\n" +
    "                            <td ng-if=\"vm.errand.creatorId === null || vm.errand.creatorId.length <= 0\">\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.errand.closedDate\">\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.DATECLOSED' | translate}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{vm.errand.closedDate | date : 'yy-MM-dd HH:mm'}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.RESOURCE' | translate}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{vm.errand.autoGenerated ? 'GENERATED AUTOMATICALLY' :\n" +
    "                                vm.getResourceName(vm.errand.resourceId)}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.CUSTOMER' | translate}}\n" +
    "                            </td>\n" +
    "                            <td ng-if=\"vm.errand.customerId\">\n" +
    "                                {{vm.errand.customerId}} - {{vm.errand.customerName}}\n" +
    "                            </td>\n" +
    "                            <td ng-if=\"!errand.customerId\">\n" +
    "\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.CONTACTPERSON' | translate}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{vm.errand.userName}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.EXPRESS' | translate}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                <input type=\"checkbox\" ng-checked=\"vm.errand.express\" ng-disabled=\"true\" />\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-5 pull-right errand-right\">\n" +
    "                <div class=\"pull-right\">\n" +
    "                    <button class=\"{{vm.getRemindUsersClass()}}\" ng-click=\"vm.remindUser()\"\n" +
    "                        ng-disabled=\"vm.isErrandClosed()\" title=\"{{'TOOLTIP.REMINDERRAND' | translate}}\">\n" +
    "                        <i class=\"fa fa-bell-o\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"vm.editErrand()\" ng-disabled=\"vm.isErrandClosed()\"\n" +
    "                        title=\"{{'TOOLTIP.EDITERRAND' | translate}}\">\n" +
    "                        <i class=\"fa fa-pencil\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"vm.openEmailDialog()\" ng-disabled=\"vm.isErrandClosed()\"\n" +
    "                        title=\"{{'TOOLTIP.EMAILERRAND' | translate}}\">\n" +
    "                        <i class=\"fa fa-envelope\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-success\" ng-click=\"vm.closeErrand()\" ng-disabled=\"vm.isErrandClosed()\"\n" +
    "                        title=\"{{'TOOLTIP.CLOSEERRAND' | translate}}\">\n" +
    "                        <i class=\"fa fa-archive\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-danger\" ng-click=\"vm.deleteErrand()\"\n" +
    "                        title=\"{{'TOOLTIP.DELETEERRAND' | translate}}\">\n" +
    "                        <i class=\"fa fa-remove\" aria-hidden=\"true\"></i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.errand.information\" class=\"panel panel-default info-panel\">\n" +
    "                    <div class=\"panel-heading ng-binding\">\n" +
    "                        {{'LABEL.INFORMATION' | translate}}\n" +
    "                    </div>\n" +
    "                    <div class=\"price-table\">\n" +
    "                        <div class=\"errand-information\">\n" +
    "                            <div class=\"pre\">{{vm.errand.information}}</div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.errand.pendingOrder\" class=\"panel panel-default info-panel\">\n" +
    "                    <div class=\"panel-heading ng-binding\">\n" +
    "                        {{'PRODUCTIONPLANNING.PENDINGORDER' | translate}}\n" +
    "                    </div>\n" +
    "                    <div class=\"price-table\">\n" +
    "                        <ul class=\"file-list\">\n" +
    "                            <li>\n" +
    "                                <button class=\"btn btn-link\"\n" +
    "                                    ng-click=\"vm.goToPendingOrder()\">{{'PRODUCTIONPLANNING.PENDINGORDER.VIEW' |\n" +
    "                                    translate}}</button>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.hasFiles()\" class=\"panel panel-default info-panel\">\n" +
    "                    <div class=\"panel-heading ng-binding\">\n" +
    "                        {{'PRODUCTIONPLANNING.ATTACHMENTS' | translate}}\n" +
    "                    </div>\n" +
    "                    <div class=\"price-table\">\n" +
    "                        <ul class=\"file-list\">\n" +
    "                            <li ng-repeat=\"file in vm.files\">\n" +
    "                                <div class=\"rowContainer\">\n" +
    "                                    <div class=\"iconContainer\">\n" +
    "                                        <i class=\"fa fa-file\"></i>\n" +
    "                                    </div>\n" +
    "                                    <div class=\"contentContainer\">\n" +
    "                                        <span>{{file.date | date : 'yy-MM-dd HH:mm'}}</span>\n" +
    "                                        <div class=\"fileContainer\">\n" +
    "                                            <a href=\"{{vm.getAttachmentLink(file.id)}}\" target=\"_blank\">\n" +
    "                                                {{file.name}}\n" +
    "                                            </a>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                    <div class=\"closeContainer\">\n" +
    "                                        <button class=\"btn-delete\" ng-click=\"vm.removeFile(file)\"\n" +
    "                                            ng-if=\"!vm.isErrandClosed()\">\n" +
    "                                            <i class=\"fa fa-remove\"></i>\n" +
    "                                        </button>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row errand-section\" ng-if=\"vm.hasErrandType('PROOF')\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h2 class=\"proof-title\">\n" +
    "                {{'PRODUCTIONPLANNING.PROOF' | translate}}\n" +
    "            </h2>\n" +
    "            <div class=\"alert alert-info text-center no-items\"\n" +
    "                ng-if=\"!vm.errand.proofs || vm.errand.proofs.length === 0\">\n" +
    "                <h4>\n" +
    "                    {{'PRODUCTIONPLANNING.PROOFLIST.NOITEMS' | translate}}\n" +
    "                </h4>\n" +
    "                <button type=\"button\" class=\"btn btn-xs btn-default pull-right add-first-proof\" ng-click=\"vm.addProof()\"\n" +
    "                    ng-disabled=\"!vm.canAddProof()\" title=\"{{'TOOLTIP.NEWPROOF' | translate}}\">\n" +
    "                    <i class=\"fa fa-plus\" aria-hidden=\"true\">\n" +
    "                    </i>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <table class=\"table errand-rows\" ng-if=\"vm.errand.proofs && vm.errand.proofs.length > 0\">\n" +
    "                <thead>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            #\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'PRODUCTIONPLANNING.DATEREGISTERED' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'PRODUCTIONPLANNING.INFORMATION' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'PRODUCTIONPLANNING.STATUS' | translate}}\n" +
    "                        </th>\n" +
    "                        <th class=\"text-right\">\n" +
    "                            <button type=\"button\" class=\"btn btn-xs btn-default\" ng-click=\"vm.addProof()\"\n" +
    "                                ng-disabled=\"!vm.canAddProof()\" title=\"{{'TOOLTIP.NEWPROOF' | translate}}\">\n" +
    "                                <i class=\"fa fa-plus\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                </thead>\n" +
    "                <tbody>\n" +
    "                    <tr ng-repeat=\"row in vm.errand.proofs\">\n" +
    "                        <td>\n" +
    "                            {{vm.errand.proofs.indexOf(row) + 1}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            {{row.registeredDate | date : 'yy-MM-dd HH:mm'}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <span ng-attr-title=\"{{row.information}}\">\n" +
    "                                {{row.information | limitTo: 25}}{{row.information.length > 25 ? '&hellip;' : ''}}\n" +
    "                            </span>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <span class=\"{{vm.getStatusClass(row.approvalType)}}\">\n" +
    "                                {{'PRODUCTIONPLANNING.PROOFSTATUS.' + row.approvalType | translate}}\n" +
    "                            </span>\n" +
    "                        </td>\n" +
    "                        <td class=\"text-right\">\n" +
    "                            <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.undoProof(row.id)\"\n" +
    "                                ng-if=\"vm.canUndo(row)\" title=\"{{'TOOLTIP.UNDOPROOF' | translate}}\">\n" +
    "                                <i class=\"fa fa-undo\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                            <button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"vm.approveProof(row.id)\"\n" +
    "                                ng-if=\"vm.canChangeProofStatus(row)\" title=\"{{'TOOLTIP.APPROVEPROOF' | translate}}\">\n" +
    "                                <i class=\"fa fa-thumbs-up\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                            <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.rejectProof(row.id)\"\n" +
    "                                ng-if=\"vm.canChangeProofStatus(row)\" title=\"{{'TOOLTIP.REJECTPROOF' | translate}}\">\n" +
    "                                <i class=\"fa fa-thumbs-down\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                            <button type=\"button\" class=\"btn btn-xs btn-default\" ng-click=\"vm.viewProof(row)\"\n" +
    "                                title=\"{{'TOOLTIP.VIEWPROOF' | translate}}\">\n" +
    "                                <i class=\"fa fa-clone\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row errand-section\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h2 class=\"customer-correspondence-title\">\n" +
    "                {{'PRODUCTIONPLANNING.CUSTOMERCORRESPONDENCE' | translate}}\n" +
    "            </h2>\n" +
    "            <div class=\"alert alert-info text-center no-items\" ng-if=\"!vm.hasEmails()\">\n" +
    "                <h4>\n" +
    "                    {{'PRODUCTIONPLANNING.EMAILLIST.NOITEMS' | translate}}\n" +
    "                </h4>\n" +
    "            </div>\n" +
    "            <table ts-wrapper class=\"table email errand-rows\" ng-if=\"vm.hasEmails()\">\n" +
    "                <thead>\n" +
    "                    <tr>\n" +
    "                        <th ts-default=\"descending\" ts-criteria=\"sentReceivedDate\">\n" +
    "                            {{'PRODUCTIONPLANNING.SENTRECEIVED' | translate}}\n" +
    "                        </th>\n" +
    "                        <th ts-criteria=\"subject\">\n" +
    "                            {{'PRODUCTIONPLANNING.SUBJECT' | translate}}\n" +
    "                        </th>\n" +
    "                        <th ts-criteria=\"recipients\">\n" +
    "                            {{'PRODUCTIONPLANNING.RECIPIENTS' | translate}}\n" +
    "                        </th>\n" +
    "                        <th ts-criteria=\"status\">\n" +
    "                            {{'PRODUCTIONPLANNING.STATUS' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            &nbsp;\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                </thead>\n" +
    "                <tbody>\n" +
    "                    <tr ts-repeat ng-repeat=\"email in vm.errand.emails\" ng-if=\"!email.archived\">\n" +
    "                        <td>\n" +
    "                            {{email.sentReceivedDate | date : 'yy-MM-dd HH:mm'}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <span ng-attr-title=\"{{email.subject}}\">\n" +
    "                                {{email.subject | limitTo: 50}}{{email.subject.length > 50 ? '&hellip;' : ''}}\n" +
    "                            </span>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <span ng-attr-title=\"{{email.recipients.join(', ')}}\">\n" +
    "                                {{email.recipients.join(\", \") | limitTo: 30}}{{email.recipients.join(\", \").length > 30 ?\n" +
    "                                '&hellip;' : ''}}\n" +
    "                            </span>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <span class=\"{{vm.getStatusClass(email.status)}}\">\n" +
    "                                {{'PRODUCTIONPLANNING.EMAILSTATUS.' + email.status | translate}}\n" +
    "                            </span>\n" +
    "                        </td>\n" +
    "                        <td class=\"text-right\">\n" +
    "                            <button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.markRead(email)\"\n" +
    "                                title=\"{{'TOOLTIP.MARKREAD' | translate}}\"\n" +
    "                                ng-if=\"'RECEIVED' === email.status && !email.read\">\n" +
    "                                <i class=\"fa fa-envelope-open-o\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                            <button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"vm.deleteDraft(email)\"\n" +
    "                                title=\"{{'TOOLTIP.DELETEDRAFT' | translate}}\" ng-if=\"'DRAFT' === email.status\">\n" +
    "                                <i class=\"fa fa-remove\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                            <button type=\"button\" class=\"btn btn-xs btn-default\" ng-click=\"vm.viewEmail(email)\"\n" +
    "                                title=\"{{'TOOLTIP.VIEWEMAIL' | translate}}\">\n" +
    "                                <i class=\"fa fa-clone\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("productionPlanning/errands/viewErrandProofsDialog/viewErrandProofsDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("productionPlanning/errands/viewErrandProofsDialog/viewErrandProofsDialog.tpl.html",
    "<div class=\"errand\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'PRODUCTIONPLANNING.PROOFDETAILS'| translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <table class=\"table\">\n" +
    "            <thead>\n" +
    "                <tr>\n" +
    "                    <th>\n" +
    "                        {{'PRODUCTIONPLANNING.FILE'| translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'PRODUCTIONPLANNING.ARTICLEID'| translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                    </th>\n" +
    "                </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "            <tr ng-repeat=\"attachment in vm.proof.attachments\">\n" +
    "                <td>\n" +
    "                    <span class=\"file-name\">\n" +
    "                        {{attachment.filename}}.{{attachment.fileExtension}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <div ng-if=\"attachment.articleId\">\n" +
    "                        {{attachment.articleId}}\n" +
    "                    </div>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <a href=\"{{vm.getProofLink(vm.proof.id, attachment.fileId)}}\" target=\"_blank\">\n" +
    "                        <button type=\"button\" title=\"{{'TOOLTIP.DOWNLOADIMAGE' | translate}}\" class=\"btn btn-sm btn-default pull-right text-right\">\n" +
    "                            <i class=\"fa fa-download\"></i>\n" +
    "                        </button>\n" +
    "                    </a>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "        <table class=\"table\">\n" +
    "            <thead>\n" +
    "                <th>\n" +
    "                    {{'PRODUCTIONPLANNING.INFORMATION'| translate}}\n" +
    "                </th>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "            <tr>\n" +
    "                <td>\n" +
    "                    <textarea class=\"form-control\" ng-model=\"vm.information\" tabindex=\"1\"></textarea>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button tabindex=\"3\" type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-success\" ng-disabled=\"!vm.information\">\n" +
    "            {{'BUTTON.SUBMIT' | translate}}\n" +
    "        </button>\n" +
    "        <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/articles/articlesList.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/articles/articlesList.tpl.html",
    "<div class=\"articles-list\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"search-status\">\n" +
    "                <span>\n" +
    "                    {{'ARTICLELIST.PAGE' | translate}} {{vm.searchStatus.page}} {{'ARTICLELIST.OF' | translate}} {{vm.searchStatus.pages}}\n" +
    "                </span>\n" +
    "                <span ng-if=\"vm.searchStatus.active\">\n" +
    "                    {{'ARTICLELIST.FOR' | translate}}: \"{{vm.searchStatus.query}}\"\n" +
    "                </span>\n" +
    "                <button class=\"btn btn-default btn-xs\" ng-if=\"vm.searchStatus.active\" ng-click=\"vm.resetSearch()\">\n" +
    "                    {{'ARTICLELIST.RESET' | translate}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"search-box stadium-search\">\n" +
    "                <div class=\"input-group\" ng-if=\"vm.user.stadium && !vm.user.admin\">\n" +
    "                    <input type=\"radio\"\n" +
    "                           id=\"stadiumSharedLogos\"\n" +
    "                           value=\"shared\"\n" +
    "                           name=\"radioStadiumSearch\"\n" +
    "                           ng-model=\"vm.stadiumSearch\">\n" +
    "                    <label for=\"stadiumSharedLogos\" class=\"checkboxLabel\">\n" +
    "                        {{'ARTICLELIST.SEARCH.STADIUMLOGOS' | translate}}\n" +
    "                    </label>\n" +
    "                    <input type=\"radio\"\n" +
    "                           id=\"stadiumAllLogos\"\n" +
    "                           value=\"all\"\n" +
    "                           name=\"radioStadiumSearch\"\n" +
    "                           ng-model=\"vm.stadiumSearch\">\n" +
    "                    <label for=\"stadiumAllLogos\" class=\"checkboxLabel\">\n" +
    "                        {{'ARTICLELIST.SEARCH.ALLSTORES' | translate}}\n" +
    "                    </label>\n" +
    "                    <input type=\"radio\"\n" +
    "                           id=\"stadiumOwnLogos\"\n" +
    "                           value=\"own\"\n" +
    "                           name=\"radioStadiumSearch\"\n" +
    "                           ng-model=\"vm.stadiumSearch\">\n" +
    "                    <label for=\"stadiumOwnLogos\" class=\"checkboxLabel\">\n" +
    "                        {{'ARTICLELIST.SEARCH.OWNSTORE' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"search-box pull-right\" ng-if=\"!vm.user.stadium\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-12\">\n" +
    "                        <div class=\"input-group\" ng-if=\"vm.user.admin\">\n" +
    "                            <input type=\"checkbox\" id=\"globalSearch\" ng-model=\"vm.globalSearch\"/>\n" +
    "                            <label for=\"globalSearch\" class=\"checkboxLabel\">\n" +
    "                                {{'ARTICLELIST.SEARCHENTIRECATALOGUE' | translate}}\n" +
    "                            </label>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table ng-table=\"vm.tableParams\" class=\"table table-hover\">\n" +
    "                    <tbody>\n" +
    "                    <tr ng-repeat=\"article in $data\" class=\"clickable\" ng-click=\"vm.selectArticle(article)\">\n" +
    "                        <td data-title=\"'ARTICLE.NUMBER' | translate\" sortable=\"'id'\">\n" +
    "                            {{::article.id}}\n" +
    "                        </td>\n" +
    "                        <td data-title=\"'ARTICLE.NAME' | translate\" sortable=\"'name'\">\n" +
    "                            <span ng-attr-title=\"{{::article.name}}\">\n" +
    "                                {{::article.name | limitTo: 25}}{{::article.name.length > 25 ? '&hellip;' : ''}}\n" +
    "                            </span>\n" +
    "                        </td>\n" +
    "                        <td data-title=\"'LABEL.SIZE' | translate\"\n" +
    "                            class=\"hidden-xs hidden-sm\"\n" +
    "                            header-class=\"hidden-xs hidden-sm\">\n" +
    "                            <span ng-attr-title=\"{{::article.size}}\">\n" +
    "                                {{::article.size | limitTo: 25}}{{::article.size.length > 25 ? '&hellip;' : ''}}\n" +
    "                            </span>\n" +
    "                        </td>\n" +
    "                        <td data-title=\"'LABEL.COLOR' | translate\"\n" +
    "                            class=\"hidden-xs hidden-sm\"\n" +
    "                            header-class=\"hidden-xs hidden-sm\">\n" +
    "                            <span ng-attr-title=\"{{::article.colour}}\">\n" +
    "                                {{::article.colour | limitTo: 25}}{{::article.colour.length > 25 ? '&hellip;' : ''}}\n" +
    "                            </span>\n" +
    "                        </td>\n" +
    "                        <td data-title=\"'STADIUM.LAST_MANUFACTURING_DATE' | translate\" sortable=\"'lastManufacturingDate'\"\n" +
    "                            class=\"hidden-xs hidden-sm\"\n" +
    "                            header-class=\"hidden-xs hidden-sm\"\n" +
    "                            ng-show=\"vm.user.stadium && !vm.isTemplateMode()\">\n" +
    "                            {{::article.lastManufacturingDate | date : 'yy-MM-dd'}}\n" +
    "                        </td>\n" +
    "                        <td data-title=\"'STADIUM.STOCK' | translate\" sortable=\"'stock'\"\n" +
    "                            class=\"hidden-xs hidden-sm\"\n" +
    "                            header-class=\"hidden-xs hidden-sm\"\n" +
    "                            ng-style=\"{'width': '90px'}\"\n" +
    "                            ng-show=\"vm.user.stadium && !vm.isTemplateMode()\">\n" +
    "                            {{::article.stock}}\n" +
    "                        </td>\n" +
    "                        <td data-title=\"'LABEL.QUANTITY' | translate\"\n" +
    "                            header-class=\"quantity\"\n" +
    "                            ng-show=\"vm.isOrderButtonVisible()\">\n" +
    "                            <div counter=\"\"\n" +
    "                                 is-small=\"true\"\n" +
    "                                 value=\"article.quantity\"\n" +
    "                                 min=\"article.minimumQuantity\"\n" +
    "                                 ng-click=\"$event.stopPropagation();\">\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td class=\"buttons\">\n" +
    "                            <button add-to-cart-button=\"\"\n" +
    "                                    min-qty=\"vm.minOrder\"\n" +
    "                                    button-class=\"btn-sm\"\n" +
    "                                    article=\"article\"\n" +
    "                                    ng-click=\"$event.stopPropagation();\"\n" +
    "                                    ng-disabled=\"!vm.user.admin && !article.canBuy\"\n" +
    "                                    ng-if=\"vm.isOrderButtonVisible()\">\n" +
    "                            </button>\n" +
    "                            <add-to-template-button\n" +
    "                                    template=\"vm.template\"\n" +
    "                                    article=\"article.id\"\n" +
    "                                    button-class=\"btn-sm\"\n" +
    "                                    ng-click=\"$event.stopPropagation();\"\n" +
    "                                    ng-if=\"vm.isTemplateMode()\"\n" +
    "                            >\n" +
    "                            </add-to-template-button>\n" +
    "                        </td>\n" +
    "                        <td class=\"text-right col-md-1\" ng-show=\"vm.user.stadium && !vm.isTemplateMode()\">\n" +
    "                            <button class=\"btn btn-default btn-sm\"\n" +
    "                                    title=\"{{'STADIUM.ADDITIONALMANUFACTURING' | translate}}\"\n" +
    "                                    ng-click=\"vm.openManufacturingDialog(article);$event.stopPropagation();\"\n" +
    "                                    ng-disabled=\"!vm.user.admin && !article.canOrderManufacturing\"\n" +
    "                                    ng-if=\"article.stocked\">\n" +
    "                                <i class=\"fa fa-industry\" aria-hidden=\"true\">\n" +
    "                                </i>\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "                <div ng-show=\"vm.tableParams.total() === 0 && vm.initialized\" class=\"alert alert-info text-center\">\n" +
    "                    <h4>\n" +
    "                        {{'ARTICLELIST.NOITEMS' | translate}}\n" +
    "                    </h4>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/articles/articleView.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/articles/articleView.tpl.html",
    "<div class=\"article-view\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-3 col-xs-12 image-holder\">\n" +
    "            <img class=\"img-responsive\"\n" +
    "                 ng-class=\"{ transparent: vm.article.isArticleImageTransparent }\"\n" +
    "                 ng-src=\"{{::vm.imageUrl}}\">\n" +
    "            <a ng-if=\"vm.article.hasAttachment\"\n" +
    "               class=\"btn btn-default\"\n" +
    "               ng-href=\"{{::vm.attachmentUrl}}\"\n" +
    "               target=\"_blank\"\n" +
    "               rel=\"noopener noreferrer\">\n" +
    "                {{'CREATEARTICLE.SHOW_ORIGINAL' | translate}}\n" +
    "            </a>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-6 col-xs-12\">\n" +
    "            <h2 class=\"article-title\">{{::vm.article.name}}</h2>\n" +
    "            <div><span ng-if=\"vm.article.frozen\" class=\"status status-deleted\">{{'TOOLTIP.DELETED' | translate}}</span>\n" +
    "            </div>\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">{{'ARTICLE.NUMBER' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">{{::vm.article.id}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">{{'ARTICLE.NAME' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">{{::vm.article.name}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.article.articleType\">\n" +
    "                        <td class=\"dynamic-width\">{{'CREATEARTICLE.SUBTYPE' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">{{'PRODUCT.TYPE.' + vm.article.articleType | translate}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">{{'LABEL.SIZE' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">{{::vm.article.size}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">{{'LABEL.COLOR' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                                <span ng-repeat=\"colour in vm.article.colours track by $index\">\n" +
    "                                    {{colour}}\n" +
    "                                    <br>\n" +
    "                                </span>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.article.edge\">\n" +
    "                        <td class=\"dynamic-width\">{{'CREATEARTICLE.EDGE' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">{{'PRODUCT.EDGE.' + vm.article.edge | translate}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.article.warp\">\n" +
    "                        <td class=\"dynamic-width\">{{'CREATEARTICLE.WARP' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">{{'PRODUCT.WARP.' + vm.article.warp | translate}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.article.fold\">\n" +
    "                        <td class=\"dynamic-width\">{{'CREATEARTICLE.FOLD' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">{{'PRODUCT.FOLD.' + vm.article.fold | translate}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.article.owner && vm.user.stadium\">\n" +
    "                        <td class=\"dynamic-width\">{{'CREATEARTICLE.OWNER' | translate}}:</td>\n" +
    "                        <td class=\"full-width\">{{vm.article.owner.customerId}} - {{vm.article.owner.name}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.user.stadium && vm.article.owner != null\">\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            {{'STADIUM.SHARED' | translate}}:\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-xs-4\">\n" +
    "                                        <span class=\"{{vm.getStatusClass(vm.article.shared)}}\">\n" +
    "                                            {{vm.getStatusName(vm.article.shared) | translate}}\n" +
    "                                        </span>\n" +
    "                                </div>\n" +
    "                                <div class=\"col-xs-8\">\n" +
    "                                    <button type=\"button\"\n" +
    "                                            class=\"btn-approval pull-right\"\n" +
    "                                            ng-class=\"vm.article.shared ? 'fa fa-toggle-on' : 'fa fa-toggle-off'\"\n" +
    "                                            ng-click=\"vm.shareArticle()\"\n" +
    "                                            ng-if=\"vm.isShareButtonVisible()\">\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">{{'LABEL.TAGS' | translate}}:</td>\n" +
    "                        <td class=\"full-width tags\">\n" +
    "                            <ui-select reset-search-input=\"true\"\n" +
    "                                       multiple\n" +
    "                                       search-enabled=\"false\"\n" +
    "                                       tagging=\"vm.newTag\"\n" +
    "                                       tagging-label=\"false\"\n" +
    "                                       tagging-tokens=\"ENTER|TAB\"\n" +
    "                                       ng-model=\"vm.tags\"\n" +
    "                                       title=\"{{'ARTICLE.ADDATAG' | translate}}\"\n" +
    "                                       theme=\"bootstrap\">\n" +
    "                                <ui-select-match placeholder=\"{{'ARTICLE.ADDATAGPLACEHOLDER' | translate}}\">\n" +
    "                                    {{$item}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"!vm.article.frozen && vm.isOrderButtonVisible()\">\n" +
    "                        <td colspan=\"2\">\n" +
    "                            <div counter=\"\"\n" +
    "                                 class=\"btn-group-vertical\"\n" +
    "                                 value=\"vm.article.quantity\"\n" +
    "                                 min=\"vm.article.minimumQuantity\"></div>\n" +
    "                            <button add-to-cart-button\n" +
    "                                    min-qty=\"vm.minOrder\"\n" +
    "                                    article=\"vm.article\"\n" +
    "                                    ng-disabled=\"!vm.user.admin && !vm.article.canBuy\">\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"!vm.article.frozen && vm.isTemplateMode()\">\n" +
    "                        <td>\n" +
    "                            <add-to-template-button\n" +
    "                                template=\"vm.template\" \n" +
    "                                article=\"vm.article.id\"\n" +
    "                                button-class=\"btn-sm\"\n" +
    "                                ng-click=\"$event.stopPropagation();\"\n" +
    "                                ng-if=\"vm.isTemplateMode()\"\n" +
    "                            >\n" +
    "                            </add-to-template-button>\n" +
    "                            <button\n" +
    "                                class=\"btn btn-sm btn-success\"\n" +
    "                                type=\"button\"\n" +
    "                                ng-click=\"vm.navigateToTemplate()\">\n" +
    "                                    {{'TOOLTIP.GOTOTEMPLATE' | translate}}\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"visible-xs-block clearfix\"></div>\n" +
    "        <div class=\"col-md-3 col-sm-12\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"buttons pull-right\" ng-if=\"vm.user.stadium && !vm.article.frozen\">\n" +
    "                    <button class=\"btn btn-default\"\n" +
    "                            title=\"{{'STADIUM.ADDITIONALMANUFACTURING' | translate}}\"\n" +
    "                            ng-click=\"vm.openManufacturingDialog()\"\n" +
    "                            ng-if=\"vm.article.stocked\"\n" +
    "                            ng-disabled=\"!vm.user.admin && !vm.article.canOrderManufacturing\">\n" +
    "                        <i class=\"fa fa-industry\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default\" \n" +
    "                            ng-if=\"!vm.article.stocked && vm.user.stadiumMaster\"\n" +
    "                            ng-click=\"vm.setStocked()\">\n" +
    "                            {{'STADIUM.SETSTOCKED' | translate}}\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-danger\"\n" +
    "                            title=\"{{'ARTICLE.DELETE' | translate}}\"\n" +
    "                            ng-click=\"vm.freezeArticle()\"\n" +
    "                            ng-disabled=\"!vm.user.admin && !vm.article.canAdjust\">\n" +
    "                        <i class=\"fa fa-remove\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "\n" +
    "                <div price-table\n" +
    "                     class=\"col-md-12\"\n" +
    "                     ng-class=\"vm.getPanelSize()\"\n" +
    "                     ng-if=\"!vm.user.stadium\"\n" +
    "                     article-id=\"vm.article.id\"\n" +
    "                     user=\"vm.user\"\n" +
    "                     current-qty=\"vm.article.quantity\">\n" +
    "                </div>\n" +
    "                <div stock-table\n" +
    "                     class=\"col-md-12\"\n" +
    "                     ng-class=\"vm.getPanelSize()\"\n" +
    "                     ng-if=\"vm.isAdmin && !vm.user.stadium\"\n" +
    "                     article-id=\"vm.article.id\">\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"col-md-12\" ng-class=\"vm.getPanelSize()\"\n" +
    "                     ng-if=\"vm.article.orderIds && vm.article.orderIds.length > 0\">\n" +
    "                    <div class=\"panel panel-default article-panel\">\n" +
    "                        <div class=\"panel-heading ng-binding\">\n" +
    "                            {{'ARTICLE.PREVIOUSORDERS' | translate}}\n" +
    "                        </div>\n" +
    "                        <div class=\"price-table scroll\">\n" +
    "                            <ul>\n" +
    "                                <li ng-repeat=\"orderId in vm.article.orderIds\">\n" +
    "                                    <a href=\"\" ng-click=\"go('/history/' + orderId)\">\n" +
    "                                        {{orderId}}\n" +
    "                                    </a>\n" +
    "                                </li>\n" +
    "                            </ul>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"col-md-12 panel panel-default info-panel stadium-stock\"\n" +
    "                     ng-if=\"vm.user.stadium && vm.article.stocked\">\n" +
    "                    <div class=\"panel-heading\">\n" +
    "                        {{'STADIUM.STADIUMSTOCK' | translate}}\n" +
    "                        <button class=\"btn btn-sm btn-default pull-right\"\n" +
    "                                title=\"{{'TOOLTIP.EDIT' | translate}}\"\n" +
    "                                ng-click=\"vm.openStadiumStockDialog()\"\n" +
    "                                ng-disabled=\"!vm.user.admin && !vm.article.canAdjust\">\n" +
    "                            <i class=\"fa fa-pencil\" aria-hidden=\"true\">\n" +
    "                            </i>\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-sm btn-default pull-right\"\n" +
    "                                title=\"{{'STOCK.UPDATE' | translate}}\"\n" +
    "                                style=\"margin-right: 5px;\"\n" +
    "                                ng-click=\"vm.onStockUpdate()\">\n" +
    "                            <i class=\"fa fa-refresh\" aria-hidden=\"true\">\n" +
    "                            </i>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div class=\"price-table\">\n" +
    "                        <table class=\"table borderless\">\n" +
    "                            <tr>\n" +
    "                                <th>{{'STADIUM.STOCK' | translate}}:</th>\n" +
    "                                <td>\n" +
    "                                    {{vm.stadiumStock.stock}}\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <th>{{'STADIUM.PRODUCTION' | translate}}:</th>\n" +
    "                                <td>\n" +
    "                                    {{vm.stadiumStock.orderIn}}\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <th>{{'STADIUM.ORDERED' | translate}}:</th>\n" +
    "                                <td>\n" +
    "                                    {{vm.stadiumStock.orderOut}}\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <th>{{'STADIUM.MINIMUMSTOCK' | translate}}:</th>\n" +
    "                                <td>\n" +
    "                                    {{vm.stadiumStock.minimumStock}}\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <th>{{'STADIUM.REFILLVOLUME' | translate}}:</th>\n" +
    "                                <td>\n" +
    "                                    {{vm.stadiumStock.refillVolume}}\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </table>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-12\" ng-if=\"vm.user.stadium && vm.manufacturingOrders\">\n" +
    "                    <div class=\"panel panel-default article-panel\">\n" +
    "                        <div class=\"panel-heading ng-binding\">\n" +
    "                            {{'STADIUM.MANUFACTURINGORDERS' | translate}}\n" +
    "                        </div>\n" +
    "                        <div class=\"price-table scroll\">\n" +
    "                            <div class=\"panel panel-default inner-manufacturing-panel\">\n" +
    "                                <table class=\"table borderless\">\n" +
    "                                    <tbody>\n" +
    "                                    <tr class=\"panel-heading\">\n" +
    "                                        <th>\n" +
    "                                            {{'STADIUM.DATE' | translate}}\n" +
    "                                        </th>\n" +
    "                                        <th>\n" +
    "                                            {{'STADIUM.QUANTITY' | translate}}\n" +
    "                                        </th>\n" +
    "                                    </tr>\n" +
    "                                    <tr ng-repeat=\"order in vm.manufacturingOrders\">\n" +
    "                                        <td>\n" +
    "                                            {{order.date | date : 'yy-MM-dd'}}\n" +
    "                                        </td>\n" +
    "                                        <td>\n" +
    "                                            {{order.quantity}}\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                    </tbody>\n" +
    "                                </table>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/calculator/calculator.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/calculator/calculator.tpl.html",
    "<div class=\"article-create\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"col-md-3\">\n" +
    "                <div class=\"calculator-price-table calculator-cost-table\" ng-if=\"vm.productType && vm.productType.exampleImage\">\n" +
    "                    <div class=\"panel panel-default info-panel\">\n" +
    "                        <div class=\"panel-heading\">{{'LABEL.EXAMPLE' | translate}}</div>\n" +
    "                        <div class=\"price-table\">\n" +
    "                            <table class=\"table borderless\">\n" +
    "                                <tr>\n" +
    "                                    <td class=\"fill\"></td>\n" +
    "                                    <td>\n" +
    "                                        <img class=\"example-image\" ng-src=\"./assets/images/{{vm.getExampleImage()}}\">\n" +
    "                                    </td>\n" +
    "                                    <td class=\"fill\"></td>\n" +
    "                                </tr>\n" +
    "                            </table>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6\" >\n" +
    "                <div class=\"alert alert-warning\" ng-if=\"vm.errorMessage\">\n" +
    "                    {{vm.errorMessage}}\n" +
    "                </div>\n" +
    "                <h2 class=\"article-title\">\n" +
    "                    {{'CALCULATOR.TITLE' | translate}}\n" +
    "                </h2>\n" +
    "                <p ng-if=\"vm.isLocked()\">\n" +
    "                    {{'CALCULATOR.BREADTEXTLOCKED' | translate}}\n" +
    "                </p>\n" +
    "                <form ng-if=\"!vm.isLocked()\">\n" +
    "                    <p>\n" +
    "                        {{'CALCULATOR.BREADTEXT' | translate}}\n" +
    "                    </p>\n" +
    "                    <div class=\"table-responsive\">\n" +
    "                        <table class=\"table table-calculator\">\n" +
    "                            <tbody>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.GROUP' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <ui-select on-select=\"vm.onProductGroupSelect($item)\" ng-model=\"vm.groupType\" tabindex=\"1\">\n" +
    "                                        <ui-select-match placeholder=\"{{'CALCULATOR.SELECTGROUP' | translate}}\">\n" +
    "                                            {{'PRODUCT.GROUP.' + $select.selected.name | translate}}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"groupType in vm.groupTypes | translationFilter: $select.search : 'PRODUCT.GROUP.' : 'name' \">\n" +
    "                                            <span>{{'PRODUCT.GROUP.' + groupType.name | translate}}</span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.TYPE' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <ui-select on-select=\"vm.onProductTypeSelect($item)\" ng-model=\"vm.productType\" tabindex=\"1\">\n" +
    "                                        <ui-select-match placeholder=\"{{'CALCULATOR.SELECTTYPE' | translate}}\">\n" +
    "                                            {{'PRODUCT.TYPE.' + $select.selected.name | translate}}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"productType in vm.productTypes | translationFilter: $select.search : 'PRODUCT.TYPE.' : 'name' \">\n" +
    "                                            <span>{{'PRODUCT.TYPE.' + productType.name | translate}}</span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.productType.productSubtypes.length > 1\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.SUBTYPE' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <ui-select on-select=\"vm.onProductSubtypeSelect($item)\" ng-model=\"vm.productSubtype\" tabindex=\"2\">\n" +
    "                                        <ui-select-match placeholder=\"{{'CALCULATOR.SELECTSUBTYPE' | translate}}\">\n" +
    "                                            {{'PRODUCT.SUBTYPE.' + $select.selected.name | translate}}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"productSubtype in vm.productType.productSubtypes | translationFilter: $select.search : 'PRODUCT.SUBTYPE.' : 'name'\">\n" +
    "                                            <span>{{'PRODUCT.SUBTYPE.' + productSubtype.name | translate}}</span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"!vm.isStitches()\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.WIDTH' | translate}} (mm):\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input ng-model-options=\"{ debounce: 400 }\"\n" +
    "                                           type=\"text\"\n" +
    "                                           name=\"width\"\n" +
    "                                           class=\"form-control\"\n" +
    "                                           tabindex=\"5\"\n" +
    "                                           ng-model=\"vm.width\"\n" +
    "                                           ng-change=\"vm.calculatePrice()\"\n" +
    "                                           required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"!vm.isStitches()\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.HEIGHT' | translate}} (mm):\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input ng-model-options=\"{ debounce: 400 }\"\n" +
    "                                           type=\"text\"\n" +
    "                                           name=\"height\"\n" +
    "                                           class=\"form-control\"\n" +
    "                                           tabindex=\"6\"\n" +
    "                                           ng-model=\"vm.height\"\n" +
    "                                           ng-change=\"vm.calculatePrice()\"\n" +
    "                                           required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.isStitches()\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.STITCHCOUNT' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input ng-model-options=\"{ debounce: 400 }\"\n" +
    "                                           type=\"text\"\n" +
    "                                           name=\"stitchCount\"\n" +
    "                                           class=\"form-control\"\n" +
    "                                           tabindex=\"6\"\n" +
    "                                           ng-model=\"vm.stitchCount\"\n" +
    "                                           ng-change=\"vm.calculatePrice()\"\n" +
    "                                           required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.hasProcess()\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.PROCESS' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"checkbox\"\n" +
    "                                           name=\"process\"\n" +
    "                                           id=\"process\"\n" +
    "                                           ng-model=\"vm.process\"\n" +
    "                                           ng-click=\"vm.clearColors()\"\n" +
    "                                           tabindex=\"7\"\n" +
    "                                           ng-change=\"vm.calculatePrice()\"/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.isNumberOfColoursVisible() && !vm.process\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.TOTALCOLOURS' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <div ng-if=\"!vm.process\">\n" +
    "                                        <ui-select on-select=\"vm.onTotalColoursSelect()\" ng-model=\"vm.numberOfColours\" tabindex=\"2\">\n" +
    "                                            <ui-select-match placeholder=\"{{'CALCULATOR.SELECTNUMBEROFCOLOURS' | translate}}\">\n" +
    "                                                {{$select.selected}}\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices repeat=\"number in vm.numbersDropdown\">\n" +
    "                                                <span>{{number}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.isNumberOfSpecialColoursVisible() && !vm.process\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.SPECIALCOLOURS' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <div ng-if=\"!vm.process\" ng-disabled=\"!vm.numberOfColours\">\n" +
    "                                        <ui-select on-select=\"vm.calculatePrice()\" ng-model=\"vm.numberOfSpecialColours\" tabindex=\"2\" ng-disabled=\"!vm.numberOfColours\">\n" +
    "                                            <ui-select-match placeholder=\"{{'CALCULATOR.SELECTNUMBEROFSPECIALCOLOURS' | translate}}\">\n" +
    "                                                {{$select.selected}}\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices repeat=\"number in vm.specialNumbersDropdown\">\n" +
    "                                                <span>{{number}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CALCULATOR.EXPRESS' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"express\" ng-click=\"vm.onExpress()\">\n" +
    "                                    <input type=\"checkbox\" ng-model=\"vm.express\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            </tbody>\n" +
    "                        </table>\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-3\">\n" +
    "                <div ng-if=\"vm.prices\">\n" +
    "                    <div class=\"calculator-price-table\" calculator-price-table prices=\"vm.prices\"></div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.isCostsVisible()\">\n" +
    "                    <div class=\"calculator-cost-table\">\n" +
    "                        <div class=\"panel panel-default info-panel\">\n" +
    "                            <div class=\"panel-heading\">{{'CALCULATOR.COSTS' | translate}}</div>\n" +
    "                            <div class=\"price-table\">\n" +
    "                                <table class=\"table borderless\">\n" +
    "                                    <tr ng-if=\"vm.startCost\">\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                        <td class=\"price-title\">{{'CALCULATOR.STARTCOST' | translate}}</td>\n" +
    "                                        <td class=\"price-separator\">:</td>\n" +
    "                                        <td class=\"price-number\">{{vm.startCost}}</td>\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                    </tr>\n" +
    "                                    <tr ng-if=\"vm.colourCost\">\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                        <td class=\"price-title\">{{'CALCULATOR.SPECIALCOLOURSCOST' | translate}}</td>\n" +
    "                                        <td class=\"price-separator\">:</td>\n" +
    "                                        <td class=\"price-number\">{{vm.colourCost}}</td>\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                    </tr>\n" +
    "                                    <tr ng-if=\"vm.expressCost\">\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                        <td class=\"price-title\">{{'CALCULATOR.EXPRESSCOST' | translate}}</td>\n" +
    "                                        <td class=\"price-separator\">:</td>\n" +
    "                                        <td class=\"price-number\">{{vm.expressCost}}</td>\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                    </tr>\n" +
    "                                </table>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/cart/cart.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/cart/cart.tpl.html",
    "<div class=\"cart\">\n" +
    "    <a ng-if=\"vm.hasWarnings\" href=\"\" ng-click=\"vm.openCartWarningsModal()\">\n" +
    "        <div ng-if=\"vm.hasWarnings\" class=\"alert alert-warning clickable\">\n" +
    "            {{'CARTWARNING.MESSAGE3' | translate}}\n" +
    "            {{'CARTWARNING.CLICK' | translate}}\n" +
    "            {{'CARTWARNING.HERE' | translate}}\n" +
    "            {{'CARTWARNING.SEEMISSING' | translate}}\n" +
    "        </div>\n" +
    "    </a>\n" +
    "    <div ng-if=\"vm.hasShortages\" class=\"alert alert-warning\">\n" +
    "        {{'CARTWARNING.STOCKSHORTAGE' | translate}}\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.hasMinimumShortages\" class=\"alert alert-warning\">\n" +
    "        {{'CARTWARNING.MINIMUMSTOCKSHORTAGE' | translate}}\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.hasNameProblems\" class=\"alert alert-warning\">\n" +
    "        {{'CARTWARNING.NAMESHORTAGE' | translate}}\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.frozenArticles.length > 0\" class=\"alert alert-warning\">\n" +
    "        {{ 'CARTWARNING.FROZENARTICLES' | translate }}\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.backsideArticles.length > 0\" class=\"alert alert-warning\">\n" +
    "        {{ 'CARTWARNING.BACKSIDEARTICLES' | translate }}\n" +
    "        <div class=\"articleListContainer\">\n" +
    "            <button ng-repeat=\"articleId in vm.backsideArticles\" ng-click=\"vm.openBacksidePickerDialogWithArticleId(articleId)\" class=\"btn btn-link fa fa-warning\">{{ 'CARTWARNING.CHOOSEBACKSIDE' | translate }} {{ articleId }}</button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <table ng-if=\"vm.cart.meta.itemCount > 0\" class=\"table cart-table hidden-sm hidden-xs\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'ARTICLE.NUMBER' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"name\">\n" +
    "                    {{'ARTICLE.NAME' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'LABEL.SIZECOLOUR' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"quantity\">\n" +
    "                    {{'LABEL.QUANTITY' | translate}}\n" +
    "                </th>\n" +
    "                <th ng-if=\"!vm.user.stadium\">\n" +
    "                    {{'ARTICLE.UNITPRICE' | translate}}\n" +
    "                </th>\n" +
    "                <th ng-if=\"vm.isAdmin\">\n" +
    "                    %\n" +
    "                </th>\n" +
    "                <th ng-if=\"!vm.user.stadium\">\n" +
    "                    {{'ARTICLE.TOTALPRICE' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'CART.EXPRESS' | translate}}\n" +
    "                </th>\n" +
    "                <th></th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"row in vm.getSortedCartRows()\">\n" +
    "                <td>\n" +
    "                    <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\" ng-if=\"vm.isProblem(row.id)\">\n" +
    "                    </i>\n" +
    "                    <a href=\"\" ng-click=\"vm.selectArticle(row.article.id)\" ng-if=\"!row.mounting\">\n" +
    "                        {{row.article.id}}\n" +
    "                    </a>\n" +
    "                    <span ng-if=\"row.mounting\">\n" +
    "                        {{row.article.id}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td ng-if=\"!row.mounting\">\n" +
    "                    <span ng-if=\"row.playerListScopeType\" class=\"name-width\">\n" +
    "                        {{('NAME.PLAYERLISTTYPE.' + row.playerListScopeType) | translate}}\n" +
    "                        <br/>\n" +
    "                    </span>\n" +
    "                    <span ng-if=\"row.article.type && !row.playerListScopeType\">\n" +
    "                        {{'PRODUCT.TYPE.' + row.article.type | translate}}\n" +
    "                        <br/>\n" +
    "                    </span>\n" +
    "                    <span ng-attr-title=\"{{row.article.name}}\" class=\"name-width\">\n" +
    "                        {{row.article.name}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td ng-if=\"row.mounting && !row.mounting.placementId\" class=\"name-width\">\n" +
    "                    {{('PRODUCT.TYPE.' + row.mounting.productType) | translate}} - {{('PRODUCT.SUBTYPE.' + row.mounting.productSubtype) | translate}}\n" +
    "                    <br/>\n" +
    "                    {{row.mounting.mountingArticleName}}\n" +
    "                </td>\n" +
    "                <td ng-if=\"row.mounting && row.mounting.placementId\" class=\"name-width\">\n" +
    "                    <span ng-attr-title=\"{{row.article.name}}\">\n" +
    "                       {{row.article.name}}\n" +
    "                    </span>\n" +
    "                    <br/>\n" +
    "                    <span ng-if=\"row.mounting.garmentType\">\n" +
    "                        {{'GARMENT.TYPE.' + row.mounting.garmentType | translate}} -\n" +
    "                    </span>\n" +
    "                    {{row.mounting.templateName}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-if=\"row.article.size\" ng-attr-title=\"{{row.article.size}}\">\n" +
    "                        {{row.article.size | limitTo: 25}}{{row.article.size.length > 20 ? '&hellip;' : ''}}\n" +
    "                    </span>\n" +
    "                    <br ng-if=\"row.article.size && row.article.colour\" />\n" +
    "                    <span ng-if=\"row.article.colour\" ng-attr-title=\"{{row.article.colour}}\">\n" +
    "                        {{row.article.colour | limitTo: 25}}{{row.article.colour.length > 20 ? '&hellip;' : ''}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-if=\"(!row.mounting || !row.mounting.placementId) && !row.playerListScopeType && !row.manufacturingQuantity\">\n" +
    "                        <div counter=\"\" value=\"row.quantity\" min=\"row.article.minimumQuantity\" is-small=\"true\"></div>\n" +
    "                    </span>\n" +
    "                    <table ng-if=\"row.playerListScopeType\" class=\"placement-quantity\">\n" +
    "                        <tr>\n" +
    "                            <td class=\"text-bold\">{{'CART.ITEMS' | translate}}:</td>\n" +
    "                            <td>{{row.quantity}}</td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                    <table ng-if=\"row.mounting && row.mounting.placementId\" class=\"placement-quantity\">\n" +
    "                        <tr>\n" +
    "                            <td class=\"text-bold\">{{'CART.GARMENTS' | translate}}:</td>\n" +
    "                            <td>{{row.mounting.placementQuantity}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"!vm.user.stadium\">\n" +
    "                            <td class=\"text-bold\">{{'CART.TRANSFERS' | translate}}:</td>\n" +
    "                            <td>{{row.quantity}}</td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                    <table ng-if=\"row.manufacturingQuantity\" class=\"placement-quantity\">\n" +
    "                        <tr>\n" +
    "                            <td class=\"text-bold\">{{'CART.MANUFACTURING' | translate}}:</td>\n" +
    "                            <td>{{row.manufacturingQuantity}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"text-bold\">{{'CART.QUANTITY' | translate}}:</td>\n" +
    "                            <td>{{row.quantity}}</td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                </td>\n" +
    "                <td ng-if=\"!vm.user.stadium\">\n" +
    "                    <span ng-if=\"!vm.isAdmin\">\n" +
    "                        {{vm.formatCurrency(row.unitPrice)}}\n" +
    "                    </span>\n" +
    "                    <div admin-input=\"price\" item=\"row\" ng-if=\"vm.isAdmin\" class=\"counter-container\">\n" +
    "                    </div>\n" +
    "                </td>\n" +
    "                <td ng-if=\"vm.isAdmin\">\n" +
    "                    <div admin-input=\"discount\" item=\"row\" ng-if=\"vm.isAdmin\" class=\"counter-container thin\">\n" +
    "                    </div>\n" +
    "                </td>\n" +
    "                <td class=\"text-right\" ng-if=\"!vm.user.stadium\">\n" +
    "                    {{vm.formatCurrency(row.rowPrice)}}\n" +
    "                </td>\n" +
    "                <td class=\"express\" ng-click=\"row.express = !row.express\">\n" +
    "                    <input type=\"checkbox\" ng-click=\"$event.stopPropagation();\" ng-model=\"row.express\">\n" +
    "                </td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    <button class=\"btn btn-sm btn-default\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-if=\"!vm.user.admin && vm.isManufacturingAvailable(row)\"\n" +
    "                            ng-disabled=\"vm.isOrderManufacturingDisabled(row)\"\n" +
    "                            ng-click=\"vm.openManufacturingDialog(row)\"\n" +
    "                            title=\"{{'STADIUM.ADDITIONALMANUFACTURING' | translate}}\">\n" +
    "                        <i class=\"fa fa-industry\" aria-hidden=\"true\"></i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm btn-default\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-if=\"vm.isArticleWithBackside(row.id)\"\n" +
    "                            ng-click=\"vm.openBacksidePickerDialog(row)\"\n" +
    "                            title=\"{{'CART.ADD_BACKSIDE' | translate}}\">\n" +
    "                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm btn-default\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-if=\"row.mounting && row.mounting.placementId\"\n" +
    "                            ng-click=\"vm.editMounting(row.mounting.placementId)\"\n" +
    "                            title=\"{{'TOOLTIP.EDIT' | translate}}\">\n" +
    "                        <i class=\"fa fa-pencil\"></i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm btn-default\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-if=\"row.mounting && row.mounting.playerListId\"\n" +
    "                            ng-click=\"vm.openPlayerListDialog(row.mounting)\"\n" +
    "                            title=\"{{'TOOLTIP.EDIT' | translate}}\">\n" +
    "                        <i class=\"fa fa-th-list\"></i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm btn-default\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-if=\"vm.isStadium && row.playerListId\"\n" +
    "                            ng-click=\"vm.viewPlayerList(row.playerListId)\"\n" +
    "                            title=\"{{'CART.VIEW_PLAYERLIST' | translate}}\">\n" +
    "                            <i class=\"fa fa-th-list\"></i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm btn-default\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-if=\"row.newLogo\"\n" +
    "                            ng-click=\"vm.editNewLogo(row)\"\n" +
    "                            title=\"{{'TOOLTIP.EDIT' | translate}}\">\n" +
    "                        <i class=\"fa fa-pencil\"></i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-class=\"{'btn-success': vm.hasRowText(row), 'btn-default': !vm.hasRowText(row)}\"\n" +
    "                            ng-disabled=\"vm.isDirty\"\n" +
    "                            ng-click=\"vm.openRowText(row)\"\n" +
    "                            title=\"{{'TOOLTIP.COMMENT' | translate}}\">\n" +
    "                        <i class=\"fa fa-comments\"></i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm btn-danger\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-disabled=\"!vm.canDeleteRow(row)\"\n" +
    "                            ng-click=\"vm.deleteRow(row)\"\n" +
    "                            title=\"{{'TOOLTIP.DELETE' | translate}}\">\n" +
    "                        <i class=\"fa fa-remove\"></i>\n" +
    "                    </button>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "    <p class=\"visible-sm visible-xs alert alert-info text-center\" ng-if=\"vm.cart.meta.itemCount > 0\">\n" +
    "        {{ 'CART.SELECTROW' | translate }}\n" +
    "    </p>\n" +
    "    <table ng-if=\"vm.cart.meta.itemCount > 0\" class=\"table cart-table hidden-lg hidden-md visible-sm-table\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'ARTICLE.NUMBER' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"name\">\n" +
    "                    {{'ARTICLE.NAME' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"quantity\">\n" +
    "                    {{'LABEL.QUANTITY' | translate}}\n" +
    "                </th>\n" +
    "                <th ng-if=\"!vm.user.stadium\">\n" +
    "                    {{'ARTICLE.TOTALPRICE' | translate}}\n" +
    "                </th>\n" +
    "                <th class=\"hidden-xs\">\n" +
    "                    {{'CART.EXPRESS' | translate}}\n" +
    "                </th>\n" +
    "                <th></th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat-start=\"row in vm.getSortedCartRows()\" ng-click=\"vm.setActiveRow(row.id)\" ng-class=\"{ 'active': row.id === vm.activeRowId }\">\n" +
    "                <td>\n" +
    "                    {{row.article.id}}\n" +
    "                </td>\n" +
    "                <td ng-if=\"!row.mounting\">\n" +
    "                    <span ng-if=\"row.playerListScopeType\">\n" +
    "                        {{('NAME.PLAYERLISTTYPE.' + row.playerListScopeType) | translate}}\n" +
    "                        <br/>\n" +
    "                    </span>\n" +
    "                    <span ng-attr-title=\"{{row.article.name}}\">\n" +
    "                        {{row.article.name | limitTo: 20}}{{row.article.name.length > 20 ? '&hellip;' : ''}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td ng-if=\"row.mounting && !row.mounting.placementId\">\n" +
    "                    {{('PRODUCT.TYPE.' + row.mounting.productType) | translate}} - {{('PRODUCT.SUBTYPE.' + row.mounting.productSubtype) | translate}}\n" +
    "                    <br/>\n" +
    "                    {{row.mounting.mountingArticleName}}\n" +
    "                </td>\n" +
    "                <td ng-if=\"row.mounting && row.mounting.placementId\">\n" +
    "                    <span ng-attr-title=\"{{row.article.name}}\">\n" +
    "                        {{row.article.name | limitTo: 20}}{{row.article.name.length > 20 ? '&hellip;' : ''}}\n" +
    "                    </span>\n" +
    "                    <br/>\n" +
    "                    <span ng-if=\"row.mounting.garmentType\">\n" +
    "                        {{'GARMENT.TYPE.' + row.mounting.garmentType | translate}} -\n" +
    "                    </span>\n" +
    "                    {{row.mounting.templateName}}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-if=\"(!row.mounting || !row.mounting.placementId) && !row.playerListScopeType\" class=\"hidden-xs\" ng-click=\"$event.stopPropagation()\">\n" +
    "                        <div counter=\"\" value=\"row.quantity\" min=\"row.article.minimumQuantity\" is-small=\"true\"></div>\n" +
    "                    </span>\n" +
    "                    <span class=\"visible-xs-block\" ng-if=\"(!row.mounting || !row.mounting.placementId) && !row.playerListScopeType\" style=\"text-align: right;\">\n" +
    "                        {{ row.quantity }}\n" +
    "                    </span>\n" +
    "                    <table ng-if=\"row.playerListScopeType\" class=\"placement-quantity\">\n" +
    "                        <tr>\n" +
    "                            <td class=\"text-bold\">{{'CART.ITEMS' | translate}}:</td>\n" +
    "                            <td>{{row.quantity}}</td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                    <table ng-if=\"row.mounting && row.mounting.placementId\" class=\"placement-quantity\">\n" +
    "                        <tr>\n" +
    "                            <td class=\"text-bold\">{{'CART.GARMENTS' | translate}}:</td>\n" +
    "                            <td>{{row.mounting.placementQuantity}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"!vm.user.stadium\">\n" +
    "                            <td class=\"text-bold\">{{'CART.TRANSFERS' | translate}}:</td>\n" +
    "                            <td>{{row.quantity}}</td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                </td>\n" +
    "                <td ng-if=\"!vm.user.stadium\" class=\"text-right\">\n" +
    "                    {{vm.formatCurrency(row.rowPrice)}}\n" +
    "                </td>\n" +
    "                <td class=\"express hidden-xs\" ng-click=\"row.express = !row.express\">\n" +
    "                    <input type=\"checkbox\" ng-click=\"$event.stopPropagation();\" ng-model=\"row.express\">\n" +
    "                </td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    <button \n" +
    "                        class=\"btn btn-default btn-sm\" \n" +
    "                        ng-if=\"!vm.user.admin && vm.isManufacturingAvailable(row)\" \n" +
    "                        ng-disabled=\"vm.isOrderManufacturingDisabled(row)\"\n" +
    "                        ng-click=\"vm.openManufacturingDialog(row)\" \n" +
    "                        title=\"{{'STADIUM.ADDITIONALMANUFACTURING' | translate}}\"\n" +
    "                    >\n" +
    "                        <i class=\"fa fa-industry\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"row.mounting && row.mounting.placementId\" ng-click=\"vm.editMounting(row.mounting.placementId)\" title=\"{{'TOOLTIP.EDIT' | translate}}\">\n" +
    "                        <i class=\"fa fa-pencil\"></i>\n" +
    "                    </button>\n" +
    "                    <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"row.newLogo\" ng-click=\"vm.editNewLogo(row)\"\n" +
    "                        title=\"{{'TOOLTIP.EDIT' | translate}}\">\n" +
    "                        <i class=\"fa fa-pencil\"></i>\n" +
    "                    </button>\n" +
    "                    <button type=\"button\" class=\"btn btn-sm\" ng-disabled=\"vm.isDirty\" ng-class=\"{'btn-success': vm.hasRowText(row), 'btn-default': !vm.hasRowText(row)}\" ng-click=\"vm.openRowText(row)\" title=\"{{'TOOLTIP.COMMENT' | translate}}\">\n" +
    "                        <i class=\"fa fa-comments\"></i>\n" +
    "                    </button>\n" +
    "                    <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vm.deleteRow(row)\" ng-disabled=\"!vm.canDeleteRow(row)\" title=\"{{'TOOLTIP.DELETE' | translate}}\">\n" +
    "                        <i class=\"fa fa-remove\"></i>\n" +
    "                    </button>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-repeat-end ng-show=\"row.id === vm.activeRowId\">\n" +
    "                <td colspan=\"42\">\n" +
    "                    <table class=\"table row-details\">\n" +
    "                        <tbody>\n" +
    "                            <tr>\n" +
    "                                <td>{{'LABEL.SIZECOLOUR' | translate}}</td>\n" +
    "                                <td>\n" +
    "                                        <span ng-if=\"row.article.size\" ng-attr-title=\"{{row.article.size}}\">\n" +
    "                                            {{row.article.size | limitTo: 25}}{{row.article.size.length > 20 ? '&hellip;' : ''}}\n" +
    "                                        </span>\n" +
    "                                    <br ng-if=\"row.article.size && row.article.colour\" />\n" +
    "                                    <span ng-if=\"row.article.colour\" ng-attr-title=\"{{row.article.colour}}\">\n" +
    "                                            {{row.article.colour | limitTo: 25}}{{row.article.colour.length > 20 ? '&hellip;' : ''}}\n" +
    "                                        </span>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>{{'ARTICLE.UNITPRICE' | translate}}</td>\n" +
    "                                <td>\n" +
    "                                    <span ng-if=\"!vm.isAdmin\">\n" +
    "                                        {{vm.formatCurrency(row.unitPrice)}}\n" +
    "                                    </span>\n" +
    "                                    <div admin-input=\"price\" item=\"row\" ng-if=\"vm.isAdmin\" class=\"counter-container\"></div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.isAdmin\">\n" +
    "                                <td>%</td>\n" +
    "                                <td>\n" +
    "                                    <div admin-input=\"discount\" item=\"row\" class=\"counter-container\"></div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr class=\"hidden-sm visible-xs-table-cell\">\n" +
    "                                <td>{{'CART.EXPRESS' | translate}}</td>\n" +
    "                                <td class=\"express\" ng-click=\"row.express = !row.express\">\n" +
    "                                    <input type=\"checkbox\" ng-click=\"$event.stopPropagation()\" ng-model=\"row.express\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "    <table ng-if=\"vm.cart.meta.itemCount > 0\" class=\"cost-table pull-right\" ng-show=\"!vm.user.stadium\">\n" +
    "        <tr>\n" +
    "            <td class=\"text-right\">\n" +
    "                {{'COST.SUM' | translate}} :\n" +
    "            </td>\n" +
    "            <td ng-if=\"vm.isAdmin\">\n" +
    "            </td>\n" +
    "            <td ng-if=\"vm.isAdmin\">\n" +
    "            </td>\n" +
    "            <td class=\"text-right\">\n" +
    "                {{vm.formatCurrency(vm.cart.meta.orderSum)}}\n" +
    "            </td>\n" +
    "        </tr>\n" +
    "        <tr ng-repeat=\"cost in vm.cart.costs\" ng-if=\"vm.showCost(cost)\">\n" +
    "            <td class=\"text-right\">\n" +
    "                {{'COST.' + cost.type | translate}} :\n" +
    "            </td>\n" +
    "            <td ng-if=\"vm.isAdmin\">\n" +
    "                <div admin-input=\"price\" item=\"cost\" class=\"counter-container\">\n" +
    "                </div>\n" +
    "            </td>\n" +
    "            <td ng-if=\"vm.isAdmin\">\n" +
    "                <div admin-input=\"discount\" item=\"cost\" class=\"counter-container thin\">\n" +
    "                </div>\n" +
    "            </td>\n" +
    "            <td class=\"text-right\">\n" +
    "                {{vm.formatCurrency(cost.rowPrice)}}\n" +
    "            </td>\n" +
    "        </tr>\n" +
    "        <tr>\n" +
    "            <td class=\"text-bold text-right\">\n" +
    "                {{'COST.TOTAL' | translate}} :\n" +
    "            </td>\n" +
    "            <td ng-if=\"vm.isAdmin\">\n" +
    "            </td>\n" +
    "            <td ng-if=\"vm.isAdmin\">\n" +
    "            </td>\n" +
    "            <td class=\"text-bold text-right\">\n" +
    "                {{vm.formatCurrency(vm.cart.meta.orderTotal)}}\n" +
    "            </td>\n" +
    "        </tr>\n" +
    "    </table>\n" +
    "    <div ng-if=\"vm.cart.meta.itemCount > 0\" class=\"alert alert-info cart-info\">\n" +
    "        <div class=\"pull-left\">\n" +
    "            <div class=\"cart-delivery-date\" ng-if=\"vm.cart.info.showDeliveryDate && vm.cart.meta.deliveryDate\">\n" +
    "                {{'CART.DELIVERYDATE' | translate}}: {{vm.cart.meta.deliveryDate | date : 'yy-MM-dd'}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"text-right\">\n" +
    "            <button update-cart-button=\"\" text=\"{{'CART.UPDATEMESSAGE' | translate}}\" title=\"{{'BUTTON.UPDATE' | translate}}\" is-enabled=\"vm.isDirty && vm.isValid\" action=\"vm.updateCart()\"></button>\n" +
    "            <button confirm-order-button=\"\"\n" +
    "                    text=\"Review warnings to continue\"\n" +
    "                    title=\"{{'BUTTON.CONFIRM' | translate}}\"\n" +
    "                    is-enabled=\"!vm.isDirty && !vm.needsAttention() && vm.isValid\"\n" +
    "                    show-warning-tooltip=\"!vm.isDirty && vm.needsAttention()\"\n" +
    "                    action=\"vm.confirm()\">\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.cart.meta.itemCount < 1\" class=\"alert alert-info text-center\">\n" +
    "        <h4>\n" +
    "            {{'CART.NOITEMS' | translate}}\n" +
    "        </h4>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/cart/cartRowTextDialog/cartRowTextDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/cart/cartRowTextDialog/cartRowTextDialog.tpl.html",
    "<div class=\"dialog order-confirmation\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.cancel()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'ROWTEXT.MAIN' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"table\">\n" +
    "            <span class=\"confirmation-message\">\n" +
    "                {{'ROWTEXT.TITLE' | translate}}\n" +
    "            </span>\n" +
    "            <span>\n" +
    "                {{'ROWTEXT.SUBTITLE' | translate}}\n" +
    "            </span>\n" +
    "            <table>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{'ARTICLE.NUMBER' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        {{vm.row.article.id}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width top-align\">\n" +
    "                        {{'ARTICLE.NAME' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        {{vm.row.article.name}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width top-align\">\n" +
    "                        {{'ROWTEXT.INSTRUCTION' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <textarea ng-model=\"vm.instruction\" class=\"form-control\"></textarea>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.clear()\" class=\"btn btn-default\">{{'BUTTON.CLEAR' | translate}}</button>\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-default\">{{'BUTTON.CANCEL' | translate}}</button>\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-success\">{{'BUTTON.SAVE' | translate}}</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("shop/cart/cartWarningsDialog/cartWarningsDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/cart/cartWarningsDialog/cartWarningsDialog.tpl.html",
    "<div class=\"dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\" translate>\n" +
    "            {{'CARTWARNING.TITLE'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"warning-message\">\n" +
    "            <p>\n" +
    "                {{'CARTWARNING.MESSAGE1' | translate}}\n" +
    "            </p>\n" +
    "            <p>\n" +
    "                {{'CARTWARNING.MESSAGE2' | translate}}\n" +
    "            </p>\n" +
    "        </div>\n" +
    "        <table class=\"table\">\n" +
    "            <thead>\n" +
    "                <tr>\n" +
    "                    <th>\n" +
    "                        {{'CARTWARNING.ID' | translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'CARTWARNING.NAME' | translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'CARTWARNING.COLOUR' | translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'CARTWARNING.SIZE' | translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'CARTWARNING.QUANTITY' | translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'CARTWARNING.REQUIRED' | translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                    </th>\n" +
    "                </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "                <tr ng-repeat=\"warning in vm.warnings\">\n" +
    "                    <td>\n" +
    "                        <span ng-if=\"!warning.draft\">\n" +
    "                            {{warning.id}}\n" +
    "                        </span>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{warning.name | limitTo: 10}}{{warning.name.length > 10 ? '&hellip;' : ''}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{warning.colour | limitTo: 10}}{{warning.colour.length > 10 ? '&hellip;' : ''}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{warning.size | limitTo: 10}}{{warning.size.length > 10 ? '&hellip;' : ''}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{warning.currentQuantity }}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{warning.requiredQuantity }}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <div counter=\"\" value=\"warning.quantity\" min=\"warning.quantity\" is-small=\"true\"></div>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <button add-to-cart-button button-class=\"btn-sm\" article=\"warning\" ng-click=\"$event.stopPropagation()\"></button>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"close\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/cart/checkoutDialog/checkoutDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/cart/checkoutDialog/checkoutDialog.tpl.html",
    "<div class=\"order-confirmation\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.cancel()\">×</a>\n" +
    "        <div class=\"modal-title\">{{ 'CHECKOUT.CONFIRMORDER' | translate }}</div>\n" +
    "    </div>\n" +
    "    <div ng-include=\"vm.contentTemplate\"></div>\n" +
    "</div>");
}]);

angular.module("shop/cart/checkoutDialog/checkoutDialogConfirmation.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/cart/checkoutDialog/checkoutDialogConfirmation.tpl.html",
    "<div class=\"modal-body\">\n" +
    "    <div class=\"alert alert-danger\" ng-show=\"vm.confirmError\">\n" +
    "        {{vm.confirmError}}\n" +
    "    </div>\n" +
    "    <div class=\"alert alert-warning\" ng-if=\"vm.showErrors\">\n" +
    "        <div ng-if=\"vm.isNoAddressSelected()\">\n" +
    "            <div>{{'CHECKOUT.ADDRESSREQUIRED' | translate}}</div>\n" +
    "        </div>\n" +
    "        <div ng-messages=\"vm.form.recipient.$error\">\n" +
    "            <div ng-message=\"required\">{{'CHECKOUT.RECIPIENTREQUIRED' | translate}}</div>\n" +
    "        </div>\n" +
    "        <div ng-messages=\"vm.form.line1.$error\">\n" +
    "            <div ng-message=\"required\">{{'CHECKOUT.LINE1REQUIRED' | translate}}</div>\n" +
    "        </div>\n" +
    "        <div ng-messages=\"vm.form.postCode.$error\">\n" +
    "            <div ng-message=\"required\">{{'CHECKOUT.POSTCODEREQUIRED' | translate}}</div>\n" +
    "        </div>\n" +
    "        <div ng-messages=\"vm.form.city.$error\">\n" +
    "            <div ng-message=\"required\">{{'CHECKOUT.CITYREQUIRED' | translate}}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <span class=\"confirmation-message\">\n" +
    "        {{'CHECKOUT.CONFIRM' | translate}}\n" +
    "    </span>\n" +
    "    <span ng-if=\"vm.currentPhase === 1\">\n" +
    "        {{'CHECKOUT.DELIVERYDATE' | translate}}\n" +
    "    </span>\n" +
    "    <span ng-if=\"vm.currentPhase === 2\">\n" +
    "        {{'CHECKOUT.DELIVERYADDRESS' | translate}}\n" +
    "    </span>\n" +
    "    <span ng-if=\"vm.currentPhase === 3\">\n" +
    "        {{'CHECKOUT.ADDITIONALDETAILS' | translate}}\n" +
    "    </span>\n" +
    "    <div class=\"table-responsive\">\n" +
    "        <div class=\"delivery-date\" ng-if=\"vm.currentPhase === 1\">\n" +
    "            <datepicker class=\"date-picker\" ng-model=\"vm.deliveryDate.chosenDate\" min-date=\"vm.deliveryDate.minDate\" starting-day=\"1\" max-mode=\"day\" show-weeks=\"true\" date-disabled=\"vm.isDateDisabled(date)\"></datepicker>\n" +
    "        </div>\n" +
    "        <div class=\"table\" ng-if=\"vm.currentPhase === 2\">\n" +
    "            <form name=\"vm.form\" novalidate>\n" +
    "                <table class=\"delivery-address\">\n" +
    "                    <tr>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"radio\" ng-if=\"vm.user.stadium\" ng-click=\"vm.resetForm();\" ng-model=\"vm.radioAddress\" value=\"radioAddressStadium\" id=\"radioAddressStadium\"/>\n" +
    "                            <label ng-if=\"vm.user.stadium\" for=\"radioAddressStadium\">\n" +
    "                                {{'CHECKOUT.ADDRESSSTADIUM' | translate}}\n" +
    "                            </label>\n" +
    "                            <br ng-if=\"vm.user.stadium\" />\n" +
    "                            <input type=\"radio\" ng-click=\"vm.resetForm();\" ng-model=\"vm.radioAddress\" value=\"radioAddressStandard\" id=\"radioAddressStandard\"/>\n" +
    "                            <label for=\"radioAddressStandard\">\n" +
    "                                {{'CHECKOUT.ADDRESSSTANDARD' | translate}}\n" +
    "                            </label>\n" +
    "                            <br/>\n" +
    "                            <input type=\"radio\" ng-click=\"vm.resetForm();\" ng-model=\"vm.radioAddress\" value=\"radioAddressSaved\" id=\"radioAddressSaved\"/>\n" +
    "                            <label for=\"radioAddressSaved\">\n" +
    "                                {{'CHECKOUT.ADDRESSSAVED' | translate}}\n" +
    "                            </label>\n" +
    "                            <br/>\n" +
    "                            <input type=\"radio\" ng-click=\"vm.resetForm();\" ng-model=\"vm.radioAddress\" value=\"radioAddressNew\" id=\"radioAddressNew\"/>\n" +
    "                            <label for=\"radioAddressNew\">\n" +
    "                                {{'CHECKOUT.ADDRESSNEW' | translate}}\n" +
    "                            </label>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressSaved'\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <ui-select on-select=\"vm.onSelectSavedAddress($item)\" ng-model=\"vm.selectedAddress\" ng-if=\"vm.savedAddresses.length > 0\">\n" +
    "                                <ui-select-match placeholder=\"{{'CHECKOUT.SELECTADDRESS' | translate}}\">\n" +
    "                                    {{$select.selected.displayName}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"address in vm.savedAddresses | filter:{recipient:$select.search} track by $index\">\n" +
    "                                    <span>{{address.displayName}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressSaved' && vm.selectedAddress && !vm.user.stadium\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" name=\"line1\" ng-model=\"vm.params.line1\" maxlength=\"30\" placeholder=\"{{'CHECKOUT.ATTENTION' | translate}}\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressSaved' && vm.selectedAddress\"> \n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"recipient\" ng-model=\"vm.params.recipient\" maxlength=\"30\" placeholder=\"{{'CHECKOUT.RECIPIENT' | translate}}\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressSaved' && vm.selectedAddress && vm.user.stadium\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"line1\" ng-model=\"vm.params.line1\" maxlength=\"30\" placeholder=\"{{'CHECKOUT.LINE1' | translate}}\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressSaved' && vm.selectedAddress\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" ng-model=\"vm.params.line2\" maxlength=\"30\" placeholder=\"{{'CHECKOUT.LINE2' | translate}}\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressSaved' && vm.selectedAddress\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"postCode\" ng-model=\"vm.params.postCode\" maxlength=\"5\" placeholder=\"{{'CHECKOUT.POSTCODE' | translate}}\" class=\"form-control address address-short\"/>\n" +
    "                            <input type=\"text\" required name=\"city\" ng-model=\"vm.params.city\" maxlength=\"25\" placeholder=\"{{'CHECKOUT.CITY' | translate}}\" class=\"form-control address address-medium\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressSaved' && vm.selectedAddress\">\n" +
    "                        <td class=\"full-width country-cell\">\n" +
    "                            <ui-select ng-model=\"vm.selectedCountry\" on-select=\"vm.onCountrySelect($item)\" class=\"select-country\">\n" +
    "                                <ui-select-match placeholder=\"{{'CHECKOUT.SELECTCOUNTRY' | translate}}\">\n" +
    "                                    {{$select.selected.name}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"country in vm.countries | filter:{name:$select.search} track by $index\">\n" +
    "                                    <span>{{country.name}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressSaved' && vm.selectedAddress\">\n" +
    "                        <td class=\"text-right\">\n" +
    "                            <button class=\"btn btn-sm btn-danger\"\n" +
    "                                ng-click=\"vm.removeAddress(vm.selectedAddress)\"\n" +
    "                                type=\"button\"\n" +
    "                                title=\"{{'TOOLTIP.DELETE' | translate}}\"\n" +
    "                                ng-disabled=\"vm.isSelectedAddressChanged()\">\n" +
    "                                <i class=\"fa fa-remove\"></i>\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressNew' && !vm.user.stadium\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" name=\"line1\" ng-model=\"vm.params.line1\" maxlength=\"30\" placeholder=\"{{'CHECKOUT.LINE1' | translate}}\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressNew'\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"recipient\" ng-model=\"vm.params.recipient\" maxlength=\"30\" placeholder=\"{{'CHECKOUT.RECIPIENT' | translate}}\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressNew' && vm.user.stadium\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"line1\" ng-model=\"vm.params.line1\" maxlength=\"30\" placeholder=\"{{'CHECKOUT.LINE1' | translate}}\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressNew'\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" ng-model=\"vm.params.line2\" maxlength=\"30\" placeholder=\"{{'CHECKOUT.LINE2' | translate}}\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressNew'\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"postCode\" ng-model=\"vm.params.postCode\" maxlength=\"5\" placeholder=\"{{'CHECKOUT.POSTCODE' | translate}}\" class=\"form-control address address-short\"/>\n" +
    "                            <input type=\"text\" required name=\"city\" ng-model=\"vm.params.city\" maxlength=\"25\" placeholder=\"{{'CHECKOUT.CITY' | translate}}\" class=\"form-control address address-medium\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressNew'\">\n" +
    "                        <td class=\"full-width country-cell\">\n" +
    "                            <ui-select ng-model=\"vm.selectedCountry\" on-select=\"vm.onCountrySelect($item)\" class=\"select-country\">\n" +
    "                                <ui-select-match placeholder=\"{{'CHECKOUT.SELECTCOUNTRY' | translate}}\">\n" +
    "                                    {{$select.selected.name}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"country in vm.countries | filter:{name:$select.search} track by $index\">\n" +
    "                                    <span>{{country.name}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStandard' && !vm.user.stadium\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" name=\"line1\" ng-model=\"vm.params.line1\" class=\"address form-control\" placeholder=\"{{'CHECKOUT.ATTENTION' | translate}}\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStandard' && vm.standardAddress.recipient\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" name=\"recipient\" ng-model=\"vm.standardAddress.recipient\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStandard' && vm.user.stadium && vm.standardAddress.line1\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" name=\"line1\" ng-model=\"vm.standardAddress.line1\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStandard' && vm.standardAddress.line2\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" ng-model=\"vm.standardAddress.line2\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStandard'\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input ng-if=\"vm.standardAddress.postCode\" type=\"text\" name=\"postCode\" ng-model=\"vm.standardAddress.postCode\" disabled=\"disabled\" class=\"form-control address address-short\"/>\n" +
    "                            <input ng-if=\"vm.standardAddress.city\" type=\"text\" name=\"city\" ng-model=\"vm.standardAddress.city\" disabled=\"disabled\" class=\"form-control address address-medium\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStandard' && vm.standardAddress.countryCode\">\n" +
    "                        <td class=\"full-width country-cell\">\n" +
    "                            <input type=\"text\" name=\"country\" ng-model=\"vm.standardAddress.countryName\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStadium' && vm.stadiumAddress.recipient\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"recipient\" ng-model=\"vm.stadiumAddress.recipient\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStadium' && vm.stadiumAddress.line1\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"line1\" ng-model=\"vm.stadiumAddress.line1\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStadium' && vm.stadiumAddress.line2\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" ng-model=\"vm.stadiumAddress.line2\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStadium' && vm.stadiumAddress.city\">\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input type=\"text\" required name=\"city\" ng-model=\"vm.stadiumAddress.city\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-if=\"vm.radioAddress === 'radioAddressStadium' && vm.stadiumAddress.countryCode\">\n" +
    "                        <td class=\"full-width country-cell\">\n" +
    "                            <input type=\"text\" required name=\"country\" ng-model=\"vm.stadiumAddress.countryName\" disabled=\"disabled\" class=\"address form-control\"/>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "        <div ng-if=\"vm.currentPhase === 3\">\n" +
    "            <table class=\"table\">\n" +
    "                <tr ng-if=\"vm.user.stadium\">\n" +
    "                    <td class=\"dynamic-width top-align\">\n" +
    "                        {{ 'CHECKOUT.STADIUM.INVOICE_CUSTOMER' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <input type=\"radio\" ng-model=\"vm.stadiumInvoice\" value=\"radioStadiumInvoiceStore\" id=\"radioStadiumInvoiceStore\"/>\n" +
    "                        <label for=\"radioStadiumInvoiceStore\">\n" +
    "                            {{'CHECKOUT.STADIUM.INVOICE_CUSTOMER.STORE' | translate}}\n" +
    "                        </label>\n" +
    "                        <br/>\n" +
    "                        <input type=\"radio\" ng-model=\"vm.stadiumInvoice\" value=\"radioStadiumInvoiceSolutions\" id=\"radioStadiumInvoiceSolutions\"/>\n" +
    "                        <label for=\"radioStadiumInvoiceSolutions\">\n" +
    "                            {{'CHECKOUT.STADIUM.INVOICE_CUSTOMER.SOLUTIONS' | translate}}\n" +
    "                        </label>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-if=\"vm.user.stadium\">\n" +
    "                    <td class=\"dynamic-width top-align\">\n" +
    "                        {{ 'CHECKOUT.STADIUM.PAYMENT' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <input type=\"radio\" ng-model=\"vm.stadiumPayment\" value=\"radioStadiumPaymentStore\" id=\"radioStadiumPaymentStore\"/>\n" +
    "                        <label for=\"radioStadiumPaymentStore\">\n" +
    "                            {{'CHECKOUT.STADIUM.PAYMENT.STORE' | translate}}\n" +
    "                        </label>\n" +
    "                        <br/>\n" +
    "                        <input type=\"radio\" ng-model=\"vm.stadiumPayment\" value=\"radioStadiumPaymentTeamSales\" id=\"radioStadiumPaymentTeamSales\"/>\n" +
    "                        <label for=\"radioStadiumPaymentTeamSales\">\n" +
    "                            {{'CHECKOUT.STADIUM.PAYMENT.TEAM_SALES' | translate}}\n" +
    "                        </label>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{'CHECKOUT.CUSTOMERREFERENCE' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <input type=\"text\" ng-model=\"vm.params.reference\" class=\"form-control\"/>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width top-align\">\n" +
    "                        {{'CHECKOUT.CUSTOMERINSTRUCTIONS' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <textarea ng-model=\"vm.params.instructions\" class=\"form-control\"></textarea>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"file\">\n" +
    "                        {{'CHECKOUT.ATTACHFILES'| translate}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <button class=\"fileButton btn-default pull-left\" ng-click=\"$event.preventDefault()\" ng-file-select=\"\" ng-accept=\"vm.onFileSelect($file)\" ng-model=\"vm.file\" ng-multiple=\"true\" tabindex=\"6\">\n" +
    "                            {{'BUTTON.SELECTFILES' | translate}}\n" +
    "                        </button>\n" +
    "                        <ul class=\"file-list\">\n" +
    "                            <li ng-repeat=\"fileIndex in vm.getFileButtonRange()\">\n" +
    "                                <button class=\"btn-delete\" ng-click=\"vm.removeFile(fileIndex)\" ng-if-start=\"vm.files[fileIndex].name\">\n" +
    "                                    <i class=\"fa fa-remove\"></i>\n" +
    "                                </button>\n" +
    "                                <span class=\"file-name\" ng-if-end>\n" +
    "                                    {{vm.files[fileIndex].name}}\n" +
    "                                </span>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-if=\"vm.isAdmin()\">\n" +
    "                    <td class=\"dynamic-width\" colspan=\"2\">\n" +
    "                        <div class=\"order-confirmation-container\">\n" +
    "                            <input id=\"customerConfirmCheckbox\" type=\"checkbox\" ng-model=\"vm.sendCustomerConfirmation\">\n" +
    "                            <label for=\"customerConfirmCheckbox\" translate>{{'CHECKOUT.CUSTOMER.NOTIFICATION'}}</label>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"alert alert-warning address-none\" ng-if=\"vm.radioAddress === 'radioAddressSaved' && vm.savedAddresses.length === 0\">\n" +
    "    {{'CHECKOUT.NOADDRESSES' | translate}}\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <a ng-if=\"vm.isFirstPhase()\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">{{'BUTTON.CANCEL' | translate}}</a>\n" +
    "    <a ng-if=\"!vm.isFirstPhase()\" class=\"btn btn-default\" ng-click=\"vm.changePhase(-1)\">&laquo; {{'BUTTON.BACK' | translate}}</a>\n" +
    "    <a ng-if=\"!vm.isLastPhase()\" class=\"btn btn-success\" tabindex=\"1\" ng-click=\"vm.changePhase(1)\">{{'BUTTON.NEXT' | translate}} &raquo;</a>\n" +
    "    <a ng-if=\"vm.isLastPhase()\" class=\"btn btn-success\" tabindex=\"1\" ng-click=\"vm.confirm()\">{{'BUTTON.CONFIRM' | translate}}</a>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "");
}]);

angular.module("shop/cart/checkoutDialog/checkoutDialogSuccess.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/cart/checkoutDialog/checkoutDialogSuccess.tpl.html",
    "<div class=\"modal-body\">\n" +
    "    <div class=\"success-contents\">\n" +
    "        <span class=\"success-message\"><i class=\"fa fa-check\"></i> {{'CHECKOUT.ORDERCONFIRMEDMESSAGE' | translate}}</span>\n" +
    "        <span>{{'CHECKOUT.ORDERCONTACTMESSAGE' | translate}}</span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <a class=\"btn btn-block btn-info\" ng-click=\"vm.continueButton()\">{{'BUTTON.CONTINUE' | translate}}</a>\n" +
    "</div>");
}]);

angular.module("shop/create/create.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/create/create.tpl.html",
    "<div class=\"article-create\">\n" +
    "    <div class=\"title-container row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <h2 class=\"article-title center-title\" ng-if=\"!vm.isEditState\">\n" +
    "                {{'CREATEARTICLE.TITLE.' + $stateParams.articleGroup.toUpperCase() | translate}}\n" +
    "            </h2>\n" +
    "            <h2 class=\"article-title center-title\" ng-if=\"vm.isEditState\">\n" +
    "                {{'EDITARTICLE.TITLE.' + $stateParams.articleGroup.toUpperCase() | translate}}\n" +
    "            </h2>\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <p class=\"center-title\">\n" +
    "                {{'CREATEARTICLE.BREADTEXT.' + $stateParams.articleGroup.toUpperCase() | translate}}\n" +
    "            </p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"col-xs-3\">\n" +
    "                <div class=\"logo-container row\" ng-if=\"vm.productType && vm.productType.allowLogoUpload\">\n" +
    "                    <div class=\"logo-title col-xs-12\">\n" +
    "                        <p translate>{{'LOGO.IMAGE.PREVIEW.TITLE'}}</p>\n" +
    "                    </div>\n" +
    "                    <div class=\"logo-image col-xs-12\" ng-if=\"vm.article.logoImage\">\n" +
    "                        <img ng-src=\"{{vm.getLogoImageUrl()}}\" on-image-load=\"vm.onLogoLoad\">\n" +
    "                    </div>\n" +
    "                    <div class=\"logo-controls col-xs-12\">\n" +
    "                        <div class=\"btn-group\" role=\"group\">\n" +
    "                            <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.selectLogoImage()\"\n" +
    "                                ng-disabled=\"!vm.showLogoImage()\" translate>\n" +
    "                                {{!vm.article.logoImage ? 'BUTTON.SELECT' : 'BUTTON.REPLACE'}}\n" +
    "                            </button>\n" +
    "                            <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.editLogoImage()\"\n" +
    "                                ng-if=\"vm.article.logoImage\" translate>\n" +
    "                                {{'BUTTON.EDIT'}}\n" +
    "                            </button>\n" +
    "                            <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.clearLogoImage()\"\n" +
    "                                ng-if=\"vm.article.logoImage\">\n" +
    "                                <i class=\"fa fa-trash\"></i>\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"logo-container row\" ng-if=\"vm.productType && vm.productType.exampleImage\">\n" +
    "                    <div class=\"logo-title col-xs-12\">\n" +
    "                        <p translate>{{'LABEL.EXAMPLE'}}</p>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-xs-12\">\n" +
    "                        <img class=\"example-image\" ng-src=\"./assets/images/{{vm.getExampleImageUrl()}}\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-6\">\n" +
    "                <form name=\"vm.form\" ng-submit=\"vm.submit()\" novalidate>\n" +
    "                    <div class=\"alert alert-warning\"\n" +
    "                        ng-if=\"vm.form.$invalid && vm.form.$submitted || vm.validationErrors.length > 0\">\n" +
    "                        <div ng-messages=\"vm.form.$error\" class=\"error-messages\">\n" +
    "                            <div ng-messages=\"vm.form.name.$error\">\n" +
    "                                <div ng-message=\"required\">{{'CREATEARTICLE.NAMEREQUIRED' | translate}}</div>\n" +
    "                            </div>\n" +
    "                            <div ng-messages=\"vm.form.width.$error\">\n" +
    "                                <div ng-message=\"required\">{{'CREATEARTICLE.WIDTHREQUIRED' | translate}}</div>\n" +
    "                                <div ng-message=\"min\">{{'CREATEARTICLE.VALIDATION.MIN.WIDTH' | translate}}</div>\n" +
    "                                <div ng-message=\"number\">{{'CREATEARTICLE.WIDTHINVALID' | translate}}</div>\n" +
    "                            </div>\n" +
    "                            <div ng-messages=\"vm.form.height.$error\">\n" +
    "                                <div ng-message=\"required\">{{'CREATEARTICLE.HEIGHTREQUIRED' | translate}}</div>\n" +
    "                                <div ng-message=\"min\">{{'CREATEARTICLE.VALIDATION.MIN.HEIGHT' | translate}}</div>\n" +
    "                                <div ng-message=\"number\">{{'CREATEARTICLE.HEIGHTINVALID' | translate}}</div>\n" +
    "                            </div>\n" +
    "                            <div ng-messages=\"vm.form.stitches.$error\">\n" +
    "                                <div ng-message=\"required\">{{'CREATEARTICLE.STITCHESREQUIRED' | translate}}</div>\n" +
    "                                <div ng-message=\"min\">{{'CREATEARTICLE.VALIDATION.MIN.STITCHES' | translate}}</div>\n" +
    "                                <div ng-message=\"number\">{{'CREATEARTICLE.STITCHESINVALID' | translate}}</div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div ng-repeat=\"error in vm.validationErrors\">\n" +
    "                            {{error.message}}\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"table-responsive form-table\">\n" +
    "                        <table class=\"table\">\n" +
    "                            <tbody>\n" +
    "                                <tr ng-if=\"vm.productTypes && vm.productTypes.length > 1\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'CREATEARTICLE.TYPE' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <ui-select on-select=\"vm.onProductTypeSelect($item)\" ng-model=\"vm.productType\"\n" +
    "                                            tabindex=\"1\" append-to-body=\"true\">\n" +
    "                                            <ui-select-match placeholder=\"{{'CREATEARTICLE.SELECTTYPE' | translate}}\">\n" +
    "                                                {{'PRODUCT.TYPE.' + $select.selected.name | translate}}\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices\n" +
    "                                                repeat=\"productType in vm.productTypes | translationFilter: $select.search : 'PRODUCT.TYPE.' : 'name'\">\n" +
    "                                                <span>{{'PRODUCT.TYPE.' + productType.name | translate}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.showSubProducts()\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'CREATEARTICLE.SUBTYPE' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <span ng-if=\"vm.isLeatheretteBrand()\">*{{'ARTICLE.LEATHERETTE_TEXT' |\n" +
    "                                            translate}}</span>\n" +
    "                                        <ui-select on-select=\"vm.clearSelectedColours()\" ng-model=\"vm.productSubtype\"\n" +
    "                                            tabindex=\"2\" append-to-body=\"true\">\n" +
    "                                            <ui-select-match\n" +
    "                                                placeholder=\"{{'CREATEARTICLE.SELECTSUBTYPE' | translate}}\">\n" +
    "                                                {{'PRODUCT.SUBTYPE.' + $select.selected.name | translate}}\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices\n" +
    "                                                repeat=\"subtype in vm.productType.productSubtypes | translationFilter: $select.search : 'PRODUCT.SUBTYPE.' : 'name'\">\n" +
    "                                                <span>{{'PRODUCT.SUBTYPE.' + subtype.name | translate}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'ARTICLE.NAME' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.article.name\"\n" +
    "                                            tabindex=\"3\" required focus />\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr class=\"no-border-bottom\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'LABEL.WIDTH' | translate}} (mm)</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <input type=\"number\" name=\"width\" class=\"form-control\" tabindex=\"4\"\n" +
    "                                            ng-model=\"vm.article.width\" min=\"1\" required focus />\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"!!vm.article.logoImage\" class=\"small slim-height no-border-bottom\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                    </td>\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <input type=\"checkbox\" id=\"fixedAspectRatio\" tabindex=\"5\"\n" +
    "                                            ng-model=\"vm.article.fixedAspect\" />\n" +
    "                                        <label class=\"form-label\">{{'LABEL.FIXED_ASPECT' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'LABEL.HEIGHT' | translate}} (mm)</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <input type=\"number\" name=\"height\" class=\"form-control\" tabindex=\"6\"\n" +
    "                                            ng-model=\"vm.article.height\" ng-disabled=\"vm.article.fixedAspect !== false && !!vm.article.logoImage\"\n" +
    "                                            min=\"1\" required focus />\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.productType && vm.productType.countStitches\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'LABEL.STITCHES' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <input type=\"number\" name=\"stitches\" class=\"form-control\" tabindex=\"7\"\n" +
    "                                            ng-model=\"vm.article.stitches\" min=\"1\" required focus />\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.maxColourCount()\">\n" +
    "                                    <td class=\"dynamic-width top-align\">\n" +
    "                                        <label class=\"form-label\">{{'LABEL.COLORS' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <div class=\"process-contbainer\" ng-if=\"vm.showProcess()\">\n" +
    "                                            <input type=\"checkbox\" id=\"process\" ng-model=\"vm.article.process\"\n" +
    "                                                ng-click=\"vm.onProcessSelect()\" tabindex=\"8\" />\n" +
    "                                            <label for=\"process\">{{'LABEL.PROCESS' | translate}}</label>\n" +
    "                                        </div>\n" +
    "                                        <div class=\"color-picker\" ng-if=\"!vm.article.process\"\n" +
    "                                            ng-class=\"{'full': vm.maxColourCount() === vm.selectedColours.length, 'input-group': vm.productType.colourType !== 'NONE'}\">\n" +
    "                                            <ui-select multiple limit=\"{{vm.maxColourCount()}}\"\n" +
    "                                                ng-model=\"vm.selectedColours\" tagging=\"vm.addColour\"\n" +
    "                                                tagging-label=\"false\" tagging-tokens=\"ENTER|TAB\" tabindex=\"9\"\n" +
    "                                                append-to-body=\"true\">\n" +
    "                                                <ui-select-match\n" +
    "                                                    placeholder=\"{{'LABEL.ENTERCOLOR' | translate | stringular : (vm.maxColourCount() - vm.selectedColours.length) + '' }}\">\n" +
    "                                                    <div ng-if=\"!$item.imageName\" class=\"color-box\"\n" +
    "                                                        ng-style=\"{'background-color': '#' + $item.code}\">\n" +
    "                                                        <span ng-if=\"!$item.code\">PMS</span>\n" +
    "                                                    </div>\n" +
    "                                                    <div ng-if=\"$item.imageName\" class=\"color-box\" ng-style=\"{'background-image':'url(./assets/images/colours/{{$item.imageName}})'}\"></div>\n" +
    "                                                    <span class=\"item-name\">{{$item.name}}</span>\n" +
    "                                                    <span class=\"sort\" ng-if=\"vm.selectedColours.length > 1\">\n" +
    "                                                        <button type=\"button\" ng-if=\"!vm.isFirst($item)\"\n" +
    "                                                            ng-click=\"vm.moveColour($item, -1)\">\n" +
    "                                                            <i class=\"fa fa-chevron-circle-up\"></i>\n" +
    "                                                        </button>\n" +
    "                                                        <button type=\"button\" ng-if=\"!vm.isLast($item)\"\n" +
    "                                                            ng-click=\"vm.moveColour($item, 1)\">\n" +
    "                                                            <i class=\"fa fa-chevron-circle-down\"></i>\n" +
    "                                                        </button>\n" +
    "                                                    </span>\n" +
    "                                                </ui-select-match>\n" +
    "                                                <ui-select-choices\n" +
    "                                                    repeat=\"colour in vm.colours | filter:{name:$select.search}\"\n" +
    "                                                    ng-model=\"vm.colours\">\n" +
    "                                                    <div ng-if=\"colour.code\" class=\"color-box\"\n" +
    "                                                        ng-style=\"{'background-color': '#' + colour.code}\"></div>\n" +
    "                                                    <div ng-if=\"colour.imageName\" class=\"color-box\" ng-style=\"{'background-image':'url(./assets/images/colours/{{colour.imageName}})'}\"></div>\n" +
    "                                                    <span class=\"item-name\">{{colour.name}}</span>\n" +
    "                                                </ui-select-choices>\n" +
    "                                            </ui-select>\n" +
    "                                            <div class=\"input-group-btn top-align\"\n" +
    "                                                ng-if=\"vm.productType.colourType !== 'NONE'\">\n" +
    "                                                <button type=\"button\" ng-click=\"vm.openColourPicker()\"\n" +
    "                                                    ng-disabled=\"!vm.showColourPicker()\" class=\"btn btn-default\"\n" +
    "                                                    tabindex=\"10\" title=\"{{'TOOLTIP.COLOURPICKER' | translate}}\">\n" +
    "                                                    <i class=\"fa fa-th\"></i>\n" +
    "                                                </button>\n" +
    "                                            </div>\n" +
    "                                        </div>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.productType && vm.productType.edgeTypes.length > 0\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'CREATEARTICLE.EDGE' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <ui-select ng-model=\"vm.article.edgeType\" tabindex=\"11\" append-to-body=\"true\">\n" +
    "                                            <ui-select-match placeholder=\"{{'CREATEARTICLE.SELECTEDGE' | translate}}\">\n" +
    "                                                {{'PRODUCT.EDGE.' + $select.selected | translate}}\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices\n" +
    "                                                repeat=\"edgeType in vm.productType.edgeTypes | translationFilter: $select.search : 'PRODUCT.EDGE.'\">\n" +
    "                                                <span>{{'PRODUCT.EDGE.' + edgeType | translate}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.isAdmin && vm.productType && vm.productType.warpTypes.length > 0\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'CREATEARTICLE.WARP' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <ui-select ng-model=\"vm.article.warpType\" tabindex=\"12\" append-to-body=\"true\">\n" +
    "                                            <ui-select-match placeholder=\"{{'CREATEARTICLE.SELECTWARP' | translate}}\">\n" +
    "                                                {{'PRODUCT.WARP.' + $select.selected | translate}}\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices\n" +
    "                                                repeat=\"warpType in vm.productType.warpTypes | translationFilter: $select.search : 'PRODUCT.WARP.'\">\n" +
    "                                                <span>{{'PRODUCT.WARP.' + warpType | translate}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.productType && vm.productType.foldTypes.length > 0\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'CREATEARTICLE.FOLD' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <ui-select ng-model=\"vm.article.foldType\" tabindex=\"13\" append-to-body=\"true\">\n" +
    "                                            <ui-select-match placeholder=\"{{'CREATEARTICLE.SELECTFOLD' | translate}}\">\n" +
    "                                                {{'PRODUCT.FOLD.' + $select.selected | translate}}\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices\n" +
    "                                                repeat=\"foldType in vm.productType.foldTypes | translationFilter: $select.search : 'PRODUCT.FOLD.'\">\n" +
    "                                                <span>{{'PRODUCT.FOLD.' + foldType | translate}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td class=\"dynamic-width top-align\">\n" +
    "                                        <label class=\"form-label\">{{'LABEL.TAGS' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width tags\">\n" +
    "                                        <ui-select multiple ng-model=\"vm.article.tags\" tagging=\"vm.addTag\"\n" +
    "                                            tagging-label=\"false\" tagging-tokens=\"ENTER|TAB\" append-to-body=\"true\"\n" +
    "                                            tabindex=\"14\">\n" +
    "                                            <ui-select-match placeholder=\"\">{{$item}}</ui-select-match>\n" +
    "                                            <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td class=\"dynamic-width top-align\">\n" +
    "                                        <label class=\"form-label\">{{'LABEL.INFORMATION' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <textarea class=\"form-control\" ng-model=\"vm.article.information\"\n" +
    "                                            tabindex=\"15\"></textarea>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"!vm.isTemplateMode() && vm.minQuantity > 0\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'LABEL.QUANTITY' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\" tabindex=\"16\">\n" +
    "                                        <div counter=\"\" class=\"btn-group-vertical\" value=\"vm.article.quantity\"\n" +
    "                                            min=\"vm.minQuantity\"></div>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.showBacksidePicker()\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'CREATEARTICLE.BACKSIDES' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width\">\n" +
    "                                        <div ng-class=\"{'backside-picker': !vm.isTemplateMode() }\">\n" +
    "                                            <ui-select ng-model=\"vm.selectedBackside\" append-to-body=\"true\">\n" +
    "                                                <ui-select-match\n" +
    "                                                    placeholder=\"{{'CREATEARTICLE.BACKSIDES.PLACEHOLDER' | translate}}\">\n" +
    "                                                    {{ 'ARTICLE.BACKSIDE.' + $select.selected.id | translate }}\n" +
    "                                                </ui-select-match>\n" +
    "                                                <ui-select-choices\n" +
    "                                                    repeat=\"backside in vm.availableBacksides(vm.backsides) | filter: $select.search\">\n" +
    "                                                    <span>{{'ARTICLE.BACKSIDE.' + backside.id | translate}}</span>\n" +
    "                                                </ui-select-choices>\n" +
    "                                            </ui-select>\n" +
    "                                        </div>\n" +
    "                                        <div class=\"input-group-btn top-align\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                                            <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.addBackside()\"\n" +
    "                                                ng-disabled=\"!vm.selectedBackside\">\n" +
    "                                                {{'BUTTON.ADD' | translate}}\n" +
    "                                            </button>\n" +
    "                                        </div>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-repeat=\"backside in vm.selectedBacksides\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                                    <td class=\"full-width\" colspan=\"2\">\n" +
    "                                        <div class=\"backside-row col-xs-12\">\n" +
    "                                            <div class=\"backside-name-col col-xs-12\">\n" +
    "                                                {{'ARTICLE.BACKSIDE.' + backside.id | translate}}\n" +
    "                                            </div>\n" +
    "                                            <div class=\"backside-counter-col\">\n" +
    "                                                <div counter=\"\" class=\"btn-group-vertical\" value=\"backside.quantity\"\n" +
    "                                                    min=\"backside.minimumQuantity\"></div>\n" +
    "                                            </div>\n" +
    "                                            <div class=\"backside-action-col\">\n" +
    "                                                <button class=\"btn btn-default\" type=\"button\"\n" +
    "                                                    ng-click=\"vm.removeBackside(backside)\">\n" +
    "                                                    <i class=\"fa fa-trash\"></i>\n" +
    "                                                </button>\n" +
    "                                            </div>\n" +
    "                                        </div>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.showProof()\">\n" +
    "                                    <td class=\"dynamic-width top-align\">\n" +
    "                                        <label class=\"form-label\">{{'PRODUCTIONPLANNING.PROOF' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width errand\">\n" +
    "                                        <div class=\"input-group\">\n" +
    "                                            <input class=\"form-control\" ng-class=\"{ pointer: vm.article.errand }\"\n" +
    "                                                ng-model=\"vm.article.errand.fileName\" ng-click=\"vm.getProofFile()\"\n" +
    "                                                ng-disabled=\"!vm.article.errand\" title=\"{{vm.article.errand.fileName}}\"\n" +
    "                                                type=\"text\" readonly=\"readonly\" tabindex=\"17\" />\n" +
    "                                            <span class=\"input-group-btn\">\n" +
    "                                                <button class=\"btn btn-default\" type=\"button\"\n" +
    "                                                    ng-click=\"vm.openProofDialog()\">\n" +
    "                                                    <i class=\"fa fa-file-image-o\"></i>\n" +
    "                                                </button>\n" +
    "                                                <button class=\"btn btn-default\" type=\"button\"\n" +
    "                                                    ng-click=\"vm.clearProof()\">\n" +
    "                                                    <i class=\"fa fa-trash\"></i>\n" +
    "                                                </button>\n" +
    "                                            </span>\n" +
    "                                        </div>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr ng-if=\"vm.showFile()\">\n" +
    "                                    <td class=\"dynamic-width\">\n" +
    "                                        <label class=\"form-label\">{{'LABEL.FILE' | translate}}</label>\n" +
    "                                    </td>\n" +
    "                                    <td class=\"full-width errand\">\n" +
    "                                        <div class=\"input-group\">\n" +
    "                                            <input class=\"form-control\" ng-class=\"{ pointer: vm.files.length > 0 }\"\n" +
    "                                                ng-model=\"vm.files[0].name\" ng-click=\"vm.getFile()\"\n" +
    "                                                ng-disabled=\"vm.files.length === 0\" title=\"{{vm.files[0].name}}\"\n" +
    "                                                type=\"text\" readonly=\"readonly\" />\n" +
    "                                            <span class=\"input-group-btn\">\n" +
    "                                                <button class=\"btn btn-default\" ng-click=\"$event.preventDefault()\"\n" +
    "                                                    ng-file-select=\"\" ng-accept=\"vm.onFileSelect($file)\"\n" +
    "                                                    ng-multiple=\"false\">\n" +
    "                                                    {{vm.files.length > 0 ? 'BUTTON.REPLACEFILE' : 'BUTTON.SELECTFILE' |\n" +
    "                                                    translate}}\n" +
    "                                                </button>\n" +
    "                                                <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.clearFile()\">\n" +
    "                                                    <i class=\"fa fa-trash\"></i>\n" +
    "                                                </button>\n" +
    "                                            </span>\n" +
    "                                        </div>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td></td>\n" +
    "                                    <td>\n" +
    "                                        <div class=\"contact-container\">\n" +
    "                                            <input class=\"checkbox\" type=\"checkbox\" id=\"contact\"\n" +
    "                                                ng-model=\"vm.article.contact\"\n" +
    "                                                ng-disabled=\"vm.customerSettings.autoReject\" />\n" +
    "                                            <label class=\"checkbox-label\" for=\"contact\" translate>\n" +
    "                                                {{::'CREATEARTICLE.CONTACT'}}\n" +
    "                                            </label>\n" +
    "                                        </div>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td></td>\n" +
    "                                    <td>\n" +
    "                                        <div class=\"pull-right\"> \n" +
    "                                            <button type=\"submit\" ng-disabled=\"vm.minQuantity === 0\" ng-if=\"!vm.isTemplateMode()\" class=\"btn btn-success\" tabindex=\"18\">\n" +
    "                                                {{vm.isEditState ? 'BUTTON.UPDATE' : 'BUTTON.ADDTOCART' | translate}}\n" +
    "                                            </button>\n" +
    "                                            <button class=\"btn btn-success\" ng-if=\"vm.isTemplateMode()\" type=\"submit\">\n" +
    "                                                {{vm.isEditState ? 'BUTTON.UPDATE' :\n" +
    "                                                    'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATE' | translate}}\n" +
    "                                            </button>\n" +
    "                                            <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-default\"\n" +
    "                                                tabindex=\"19\" ng-if=\"vm.isEditState\">\n" +
    "                                                {{'BUTTON.CANCEL' | translate}}\n" +
    "                                            </button>\n" +
    "                                        </div>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                            </tbody>\n" +
    "                        </table>\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-3\">\n" +
    "                <button class=\"btn btn-sm\" ng-class=\"{'btn-success': vm.showPrices, 'btn-default': !vm.showPrices}\"\n" +
    "                    ng-click=\"vm.togglePrices()\">\n" +
    "                    <i class=\"fa fa-dollar\"></i>\n" +
    "                </button>\n" +
    "                <div ng-if=\"vm.showPrices && vm.prices\">\n" +
    "                    <div class=\"calculator-cost-table\">\n" +
    "                        <div class=\"panel panel-default info-panel\">\n" +
    "                            <div class=\"panel-heading panel-heading-first\">{{'COST.SUM' | translate}}</div>\n" +
    "                            <div class=\"price-table\">\n" +
    "                                <table class=\"table borderless\">\n" +
    "                                    <tr ng-if=\"vm.startCost\">\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                        <td class=\"price-title\">{{'CALCULATOR.STARTCOST' | translate}}</td>\n" +
    "                                        <td class=\"price-separator\">:</td>\n" +
    "                                        <td class=\"price-number\">{{vm.startCost}}</td>\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                    </tr>\n" +
    "                                    <tr ng-if=\"vm.colourCost\">\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                        <td class=\"price-title\">{{'CALCULATOR.SPECIALCOLOURSCOST' | translate}}</td>\n" +
    "                                        <td class=\"price-separator\">:</td>\n" +
    "                                        <td class=\"price-number\">{{vm.colourCost}}</td>\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                    </tr>\n" +
    "                                    <tr ng-if=\"vm.expressCost\">\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                        <td class=\"price-title\">{{'CALCULATOR.EXPRESSCOST' | translate}}</td>\n" +
    "                                        <td class=\"price-separator\">:</td>\n" +
    "                                        <td class=\"price-number\">{{vm.expressCost}}</td>\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                    </tr>\n" +
    "                                    <tr ng-if=\"!vm.isTemplateMode() && vm.totalPrice\">\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                        <td class=\"price-title\">{{'ARTICLE.TOTALPRICE' | translate}}</td>\n" +
    "                                        <td class=\"price-separator\">:</td>\n" +
    "                                        <td class=\"price-number\">{{vm.totalPrice}}</td>\n" +
    "                                        <td class=\"fill\"></td>\n" +
    "                                    </tr>\n" +
    "                                </table>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"calculator-cost-table\" calculator-price-table prices=\"vm.prices\"\n" +
    "                        current-qty=\"vm.isTemplateMode() ? undefined : vm.article.quantity\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("shop/digits/digitsList.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/digits/digitsList.tpl.html",
    "<div class=\"digits-list\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"digit-box col-lg-2 col-md-3 col-sm-4 col-xs-6\" ng-repeat=\"digit in vm.digits\" ng-click=\"vm.selectDigit(digit)\">\n" +
    "            <div class=\"striped\">\n" +
    "                <img ng-src=\"{{ ::vm.imageUrl(digit.id) }}\">\n" +
    "            </div>\n" +
    "            <div class=\"caption\">\n" +
    "                <p class=\"title\">{{ ::digit.style }}</p>\n" +
    "                <p>{{ ::digit.colour }}</p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/digits/digitView.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/digits/digitView.tpl.html",
    "<div class=\"digit-view\">\n" +
    "    <div breadcrumbs links=\"vm.links\">\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-3 col-sm-4\">\n" +
    "            <div class=\"digit-info-box\">\n" +
    "                <div class=\"striped\">\n" +
    "                    <img class=\"img-responsive\" ng-src=\"{{::vm.imageUrl(vm.digit.id)}}\">\n" +
    "                </div>\n" +
    "                <div class=\"digit-info\">\n" +
    "                    <h3>\n" +
    "                        {{::vm.digit.style}}\n" +
    "                    </h3>\n" +
    "                    <p class=\"color-info\">\n" +
    "                        {{::vm.digit.colour}}\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"dropdown-box\" ng-if=\"!vm.isStadium() || !vm.isTemplateMode()\">\n" +
    "                <span class=\"title\" translate>\n" +
    "                    {{::'LABEL.SIZE'}}\n" +
    "                </span>\n" +
    "                <ui-select ng-model=\"vm.selectedSize\" on-select=\"vm.setCurrentSize($item, $model)\" theme=\"bootstrap\">\n" +
    "                    <ui-select-match placeholder=\"Select a size..\">\n" +
    "                        {{$select.selected.size}}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"size in vm.digit.sizes | filter:{size:$select.search}\">\n" +
    "                        <span>\n" +
    "                            {{size.size}}\n" +
    "                        </span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-7\" ng-if=\"vm.isStadium() && vm.isTemplateMode() && vm.digit.sizes.length > 0\">\n" +
    "            <table class=\"table\">\n" +
    "                <thead>\n" +
    "                <tr>\n" +
    "                    <th translate>\n" +
    "                        {{::'ARTICLE.NUMBER'}}\n" +
    "                    </th>\n" +
    "                    <th translate>\n" +
    "                        {{::'LABEL.SIZE'}}\n" +
    "                    </th>\n" +
    "                    <th></th>\n" +
    "                </tr>\n" +
    "                </thead>\n" +
    "                <tbody>\n" +
    "                <tr ng-repeat=\"size in vm.digit.sizes\">\n" +
    "                    <td>\n" +
    "                        {{::size.articles[1].id}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{::size.size}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <div class=\"pull-right\">\n" +
    "                            <add-to-template-button\n" +
    "                                    button-class=\"btn-sm\"\n" +
    "                                    digit=\"size.articles[1].id\"\n" +
    "                                    ng-click=\"$event.stopPropagation();\"\n" +
    "                                    ng-if=\"$state.current.name === 'app.shop.digits.view'\"\n" +
    "                                    template=\"vm.template\"\n" +
    "                            >\n" +
    "                            </add-to-template-button>\n" +
    "                            <add-to-template-button\n" +
    "                                    button-class=\"btn-sm\"\n" +
    "                                    large-digit=\"size.articles[1].id\"\n" +
    "                                    ng-click=\"$event.stopPropagation();\"\n" +
    "                                    ng-if=\"$state.current.name === 'app.shop.large-digits.view'\"\n" +
    "                                    template=\"vm.template\"\n" +
    "                            >\n" +
    "                            </add-to-template-button>\n" +
    "                            <add-to-template-button\n" +
    "                                    button-class=\"btn-sm\"\n" +
    "                                    ng-click=\"$event.stopPropagation();\"\n" +
    "                                    ng-if=\"$state.current.name === 'app.shop.small-digits.view'\"\n" +
    "                                    small-digit=\"size.articles[1].id\"\n" +
    "                                    template=\"vm.template\"\n" +
    "                            >\n" +
    "                            </add-to-template-button>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "            <div class=\"template-button-row\">\n" +
    "                <button\n" +
    "                        class=\"btn btn-sm btn-success\"\n" +
    "                        ng-click=\"vm.navigateToTemplate()\"\n" +
    "                        translate\n" +
    "                        type=\"button\"\n" +
    "                >\n" +
    "                    {{::'TOOLTIP.GOTOTEMPLATE'}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-7\" ng-if=\"vm.digit.sizes.length === 0\">\n" +
    "            <h4 class=\"information-text-center\" translate>\n" +
    "                {{'DIGIT.VIEW.NO_SIZES'}}\n" +
    "            </h4>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-6 col-sm-8\" ng-if=\"!vm.isStadium() || !vm.isTemplateMode()\">\n" +
    "            <table class=\"table\">\n" +
    "                <thead>\n" +
    "                <tr>\n" +
    "                    <th>\n" +
    "                    </th>\n" +
    "                    <th translate>\n" +
    "                        {{::'ARTICLE.NUMBER'}}\n" +
    "                    </th>\n" +
    "                    <th ng-if=\"!vm.isTemplateMode() && vm.isOrderButtonVisible()\" translate>\n" +
    "                        {{::'LABEL.QUANTITY'}}\n" +
    "                    </th>\n" +
    "                    <th ng-if=\"!vm.isTemplateMode() && vm.user.stadiumMaster && vm.isAnyStock()\" translate>\n" +
    "                        {{::'STADIUM.STOCK'}}\n" +
    "                    </th>\n" +
    "                    <th class=\"buttons\">\n" +
    "                        <button class=\"btn btn-sm btn-success\"\n" +
    "                                data-style=\"slide-left\"\n" +
    "                                ladda=\"vm.addAllIsLoading\"\n" +
    "                                ng-click=\"vm.addAllToCart()\"\n" +
    "                                ng-if=\"vm.isOrderButtonVisible()\">\n" +
    "                                <span translate>\n" +
    "                                   {{::'CART.ADDALLTOCART'}}\n" +
    "                                </span>\n" +
    "                        </button>\n" +
    "                    </th>\n" +
    "                </tr>\n" +
    "                </thead>\n" +
    "                <tbody>\n" +
    "                <tr ng-if=\"vm.isVisible(article)\" ng-repeat=\"article in vm.currentSize.articles\">\n" +
    "                    <td class=\"images striped\">\n" +
    "                        <img class=\"img-responsive\" ng-src=\"{{::vm.imageUrl(article.id)}}\">\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{article.id}}\n" +
    "                    </td>\n" +
    "                    <td ng-if=\"!vm.isTemplateMode() && vm.isOrderButtonVisible()\">\n" +
    "                        <div counter=\"\"\n" +
    "                             is-small=\"true\"\n" +
    "                             min=\"article.minimumQuantity\"\n" +
    "                             ng-click=\"$event.stopPropagation();\"\n" +
    "                             value=\"article.quantity\">\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                    <td ng-if=\"!vm.isTemplateMode() && vm.user.stadiumMaster && vm.isAnyStock()\">\n" +
    "                        {{article.stock}}\n" +
    "                    </td>\n" +
    "                    <td class=\"buttons\">\n" +
    "                        <button add-to-cart-button=\"\"\n" +
    "                                article=\"article\"\n" +
    "                                button-class=\"btn-sm\"\n" +
    "                                ng-click=\"$event.stopPropagation();\"\n" +
    "                                ng-if=\"vm.isOrderButtonVisible()\">\n" +
    "                        </button>\n" +
    "                        <add-to-template-button\n" +
    "                                article=\"article.id\"\n" +
    "                                button-class=\"btn-sm\"\n" +
    "                                ng-if=\"vm.isTemplateMode()\"\n" +
    "                                template=\"vm.template\"\n" +
    "                        >\n" +
    "                        </add-to-template-button>\n" +
    "                        <button\n" +
    "                                class=\"btn-sm btn-default\"\n" +
    "                                title=\"{{'STADIUM.ADDITIONALMANUFACTURING' | translate}}\"\n" +
    "                                ng-if=\"!vm.isTemplateMode() && article.manufacturing && vm.user.stadiumMaster\"\n" +
    "                                ng-click=\"vm.openManufacturingDialog(article.id)\">\n" +
    "                            <i class=\"fa fa-industry\" aria-hidden=\"true\">\n" +
    "                            </i>\n" +
    "                        </button>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "            <div class=\"alert alert-info text-center\" ng-show=\"vm.isNoneVisible()\">\n" +
    "                <h4 translate>\n" +
    "                    {{::'DIGIT.NOITEMS'}}\n" +
    "                </h4>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-3 col-sm-12 panels\" ng-if=\"!vm.isTemplateMode() && vm.isOrderButtonVisible()\">\n" +
    "            <div class=\"col-md-12 col-sm-4 col-xs-8 col-xs-offset-2 col-sm-offset-0 digit-panel\"\n" +
    "                 ng-if=\"!vm.user.stadium\">\n" +
    "                <div calculator-price-table prices=\"vm.currentSize.prices\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"panel panel-default info-panel digit-panel col-md-12 col-sm-4 col-xs-8 col-xs-offset-2 col-sm-offset-0\"\n" +
    "                ng-if=\"vm.isStadium()\"\n" +
    "            >\n" +
    "                <div class=\"panel-heading\" translate>\n" +
    "                    {{::'DIGIT.NAMELIST'}}\n" +
    "                    <button class=\"btn btn-sm btn-default pull-right\"\n" +
    "                            ng-click=\"vm.onClickClearPlayerList()\"\n" +
    "                            ng-disabled=\"!vm.selectedPlayerList\">\n" +
    "                        <i class=\"fa fa-trash\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <div class=\"price-table\">\n" +
    "                    <p translate>\n" +
    "                        {{::'DIGIT.SELECTNAMELIST'}}\n" +
    "                    </p>\n" +
    "                    <div class=\"player-list\">\n" +
    "                        <input class=\"form-control\"\n" +
    "                               ng-model=\"vm.selectedPlayerList.playerListName\"\n" +
    "                               readonly=\"readonly\"\n" +
    "                               type=\"text\">\n" +
    "                        <button class=\"btn btn-default\"\n" +
    "                                ng-click=\"vm.openPlayerDialog()\"\n" +
    "                                title=\"{{'TOOLTIP.PLAYERS' | translate}}\"\n" +
    "                                type=\"button\">\n" +
    "                            <i class=\"fa fa-th-list\">\n" +
    "                            </i>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"panel panel-default info-panel digit-panel col-md-12 col-sm-4 col-xs-8 col-xs-offset-2 col-sm-offset-0\">\n" +
    "                <div class=\"panel-heading\" translate>\n" +
    "                    {{'DIGIT.NUMBERSERIES'}}\n" +
    "                    <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"vm.resetNumberSeries()\">\n" +
    "                        <i class=\"fa fa-trash\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <div class=\"price-table\">\n" +
    "                    <p translate>\n" +
    "                        {{::'DIGIT.NUMBERSERIESINSTRUCTION'}}\n" +
    "                    </p>\n" +
    "                    <div class=\"digit-white-panel\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <span translate>\n" +
    "                                {{::'DIGIT.FROM'}}:\n" +
    "                            </span>\n" +
    "                            <div counter=\"\"\n" +
    "                                 is-small=\"true\"\n" +
    "                                 max=\"vm.numberSeriesTo\"\n" +
    "                                 min=\"vm.numberSeriesMinimumQuantity\"\n" +
    "                                 ng-click=\"$event.stopPropagation();\"\n" +
    "                                 value=\"vm.numberSeriesFrom\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <span translate>\n" +
    "                                {{::'DIGIT.TO'}}:\n" +
    "                            </span>\n" +
    "                            <div counter=\"\"\n" +
    "                                 is-small=\"true\"\n" +
    "                                 min=\"vm.numberSeriesFrom\"\n" +
    "                                 ng-click=\"$event.stopPropagation();\"\n" +
    "                                 value=\"vm.numberSeriesTo\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"panel panel-default info-panel digit-panel col-md-12 col-sm-4 col-xs-8 col-xs-offset-2 col-sm-offset-0\"\n" +
    "                ng-if=\"vm.isStadium()\"\n" +
    "            >\n" +
    "                <div class=\"panel-heading\" translate>\n" +
    "                    {{::'DIGIT.FREETEXT'}}\n" +
    "                    <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"vm.resetFreeTextNumbers()\">\n" +
    "                        <i class=\"fa fa-trash\"></i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <div class=\"price-table\">\n" +
    "                    <p translate>\n" +
    "                        {{::'DIGIT.FREETEXTINSTRUCTION'}}\n" +
    "                    </p>\n" +
    "                    <div class=\"digit-white-panel-grid\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-xs-12\">\n" +
    "                                <input class=\"form-control\"\n" +
    "                                       ng-model=\"vm.freeTextNumbers\"\n" +
    "                                       title=\"FreeText\"\n" +
    "                                       type=\"text\"\n" +
    "                                       validate-comma-separated-numbers>\n" +
    "                                <button class=\"btn btn-sm btn-default pull-right apply-button\"\n" +
    "                                        ng-click=\"vm.applyFreeTextNumbers()\">\n" +
    "                                    <span>{{'BUTTON.APPLY' | translate}}</span>\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/history/historyList.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/history/historyList.tpl.html",
    "<div class=\"history-list\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"search-status\">\n" +
    "                {{'HISTORYLIST.PAGE' | translate}} {{vm.searchStatus.page}} {{'HISTORYLIST.OF' | translate}} {{vm.searchStatus.pages}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table ng-table=\"vm.tableParams\" class=\"table table-hover\">\n" +
    "                    <tbody>\n" +
    "                        <tr ng-repeat=\"order in $data\" class=\"clickable\" ng-click=\"vm.selectOrder(order)\">\n" +
    "                            <td data-title=\"'HISTORYLIST.ORDERNO' | translate\" sortable=\"'id'\">\n" +
    "                                {{::order.id}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'HISTORYLIST.DATE' | translate\" sortable=\"'dateOrdered'\">\n" +
    "                                {{::order.dateOrdered}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'HISTORYLIST.YOURREF' | translate\" sortable=\"'yourReference'\">\n" +
    "                                {{::order.yourReference}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'HISTORYLIST.TYPE' | translate\" sortable=\"'orderType'\">\n" +
    "                                {{::order.orderType}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'HISTORYLIST.STATUS' | translate\" sortable=\"'deliveryStatus'\">\n" +
    "                                {{::order.deliveryStatus}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'HISTORYLIST.DELIVERYDATE' | translate\" sortable=\"'dateDelivery'\">\n" +
    "                                {{::order.dateDelivery}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'HISTORYLIST.SUM' | translate\" class=\"text-right\" ng-show=\"!vm.user.stadium\">\n" +
    "                                {{::order.orderSum}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "                <div ng-show=\"vm.tableParams.total() === 0 && vm.initialized\" class=\"alert alert-info text-center\">\n" +
    "                    <h4>\n" +
    "                        {{'HISTORYLIST.NOITEMS' | translate}}\n" +
    "                    </h4>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("shop/history/historyView.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/history/historyView.tpl.html",
    "<div class=\"history-order\" ng-if=\"vm.history.id\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h2>\n" +
    "                {{'HISTORYDETAILS.ORDERDETAILS' | translate}}\n" +
    "            </h2>\n" +
    "            <hr>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\" ng-if=\"vm.history.flowUrl\">\n" +
    "            <a ng-if=\"vm.history.flowUrl\"\n" +
    "               ng-href=\"{{vm.history.flowUrl}}\"\n" +
    "               target=\"_blank\"\n" +
    "               rel=\"noopener noreferrer\"\n" +
    "               type=\"button\"\n" +
    "               class=\"btn btn-default flow-button\">\n" +
    "                <span class=\"fa fa-external-link\"></span>\n" +
    "            </a>\n" +
    "            <iframe ng-src=\"{{vm.history.safeFlowUrl}}\"></iframe>\n" +
    "            <hr>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-5\">\n" +
    "            <table class=\"table\">\n" +
    "                <tbody>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.ORDERNUMBER' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.id}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-if=\"(vm.history.text2 || '').indexOf('#') > -1\">\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.STADIUMREFERENCE' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <span>\n" +
    "                            {{vm.history.text2.substring(0, vm.history.text2.indexOf('#'))}}\n" +
    "                        </span>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-if=\"(vm.history.text2 || '').indexOf('#') > -1\">\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.STADIUMPROJECT' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.text2.substring(vm.history.text2.indexOf('#') + 1)}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.YOURREFERENCE' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.yourReference}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.OURREFERENCE' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.ourReference}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.TEXT1' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.text1}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-if=\"(vm.history.text2 || '').indexOf('#') === -1\">\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.TEXT2' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.text2}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.GOODSMARKING' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.goodsMarking}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.DATEORDERED' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.dateOrdered}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.DELIVERYDATE' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{vm.history.dateDelivery}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.ORDERTYPE' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYFLAG.ORDERTYPE.' + vm.history.orderType | translate}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYDETAILS.DELIVERYSTATUS' | translate}}:\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{'HISTORYFLAG.DELIVERYSTATUS.' + vm.history.deliveryStatus | translate}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-3 col-md-offset-4\">\n" +
    "            <div class=\"panel panel-default info-panel\">\n" +
    "                <div class=\"panel-heading\">\n" +
    "                    {{'HISTORYDETAILS.DELIVERYADDRESS' | translate}}\n" +
    "                </div>\n" +
    "                <div class=\"price-table\">\n" +
    "                    <p ng-repeat=\"row in vm.history.address track by $index\">\n" +
    "                        {{row}}\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <table class=\"table\">\n" +
    "                <thead>\n" +
    "                <tr>\n" +
    "                    <th>\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'HISTORYDETAILS.ARTICLENUMBER' | translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'HISTORYDETAILS.NAME' | translate}}\n" +
    "                    </th>\n" +
    "                    <th>\n" +
    "                        {{'HISTORYDETAILS.DELIVERYDATE' | translate}}\n" +
    "                    </th>\n" +
    "                    <th class=\"text-right\">\n" +
    "                        {{'HISTORYDETAILS.ORDERED' | translate}}\n" +
    "                    </th>\n" +
    "                    <th class=\"text-right\">\n" +
    "                        {{'HISTORYDETAILS.DELIVERED' | translate}}\n" +
    "                    </th>\n" +
    "                    <th class=\"text-right\" ng-show=\"!vm.user.stadium\">\n" +
    "                        {{'HISTORYDETAILS.PRICE' | translate}}\n" +
    "                    </th>\n" +
    "                    <th class=\"text-right\" ng-show=\"!vm.user.stadium\">\n" +
    "                        {{'HISTORYDETAILS.DISCOUNT' | translate}}\n" +
    "                    </th>\n" +
    "                    <th class=\"text-right\" ng-show=\"!vm.user.stadium\">\n" +
    "                        {{'HISTORYDETAILS.TOTAL' | translate}}\n" +
    "                    </th>\n" +
    "                </tr>\n" +
    "                </thead>\n" +
    "                <tbody>\n" +
    "                <tr ng-repeat=\"row in vm.history.rows\">\n" +
    "                    <td>\n" +
    "                        {{row.rowNumber}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{row.articleId}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{row.articleName}}\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        {{row.dateDelivery}}\n" +
    "                    </td>\n" +
    "                    <td class=\"text-right\">\n" +
    "                        {{row.quantityOrdered}}\n" +
    "                    </td>\n" +
    "                    <td class=\"text-right\">\n" +
    "                        {{row.quantityDelivered}}\n" +
    "                    </td>\n" +
    "                    <td class=\"text-right\" ng-show=\"!vm.user.stadium\">\n" +
    "                        {{row.unitPrice}}\n" +
    "                    </td>\n" +
    "                    <td class=\"text-right\" ng-show=\"!vm.user.stadium\">\n" +
    "                        {{row.unitDiscount}}\n" +
    "                    </td>\n" +
    "                    <td class=\"text-right\" ng-show=\"!vm.user.stadium\">\n" +
    "                        {{row.totalPrice}}\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                </tbody>\n" +
    "                <tfoot ng-show=\"!vm.user.stadium\">\n" +
    "                <tr>\n" +
    "                    <th class=\"text-right\" colspan=\"8\">\n" +
    "                        {{'HISTORYDETAILS.SUM' | translate}}:\n" +
    "                    </th>\n" +
    "                    <th class=\"text-right\">\n" +
    "                        {{vm.history.orderSum}}\n" +
    "                    </th>\n" +
    "                </tr>\n" +
    "                </tfoot>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/mounting/advancedMounting.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/mounting/advancedMounting.tpl.html",
    "<div class=\"alert alert-warning\" ng-if=\"vm.errors.length > 0\">\n" +
    "    <div ng-repeat=\"error in vm.errors\">\n" +
    "        {{'ERROR.' + error.code | translate: error.data}}\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"placement\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-9\">\n" +
    "            <div class=\"design-panel-border\">\n" +
    "                <div class=\"alert alert-info\">\n" +
    "                    <h4 class=\"pull-left\" title=\"{{vm.placement.templateName}}\">\n" +
    "                        {{vm.placement.templateName | limitTo: 40}}{{vm.placement.templateName.length > 40 ? '...' :\n" +
    "                        ''}}\n" +
    "                        <span ng-if=\"vm.placement.garment\"> - {{'GARMENT.TYPE.' + vm.placement.garment |\n" +
    "                            translate}}</span>\n" +
    "                    </h4>\n" +
    "                    <div class=\"button-row\">\n" +
    "                        <button ng-if=\"vm.user.stadiumMaster\" class=\"btn btn-sm btn-default\"\n" +
    "                            ng-click=\"vm.openPrintingInformationDialog()\"\n" +
    "                            title=\"{{'TOOLTIP.EDIT.PRINTINGINFO' | translate}}\">\n" +
    "                            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n" +
    "                        </button>\n" +
    "                        <button ng-if=\"vm.user.stadium\" class=\"btn btn-sm btn-default\"\n" +
    "                            ng-click=\"vm.openTemplateAuditLogsDialog()\" title=\"{{'TOOLTIP.VIEW.LOGS' | translate}}\">\n" +
    "                            <i aria-hidden=\"true\" class=\"fa fa-list\"></i>\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-default btn-sm\" data-spinner-size=\"12\" data-style=\"slide-right\"\n" +
    "                            ladda=\"vm.buttonLocked\" ng-disabled=\"vm.buttonLocked\" single-click=\"vm.onClickDownloadPdf()\"\n" +
    "                            title=\"{{'TOOLTIP.DOWNLOADASPDF' | translate}}\">\n" +
    "                            <i aria-hidden=\"true\" class=\"fa fa-file-pdf-o\"></i>\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-sm btn-default\" ng-click=\"vm.setHandledLegacyTemplate()\"\n" +
    "                            ng-if=\"vm.placement.stadiumLegacyNotHandled\"\n" +
    "                            title=\"{{'TOOLTIP.SETHANDLEDLEGACYTEMPLATE' | translate}}\">\n" +
    "                            <i aria-hidden=\"true\" class=\"fa fa-exclamation-triangle\"></i>\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-sm btn-default\" ng-click=\"vm.openEditMountingDialog()\"\n" +
    "                            ng-if=\"vm.placement.type !== 'STADIUM_PRODUCT_TEMPLATE'\"\n" +
    "                            title=\"{{'TOOLTIP.EDIT' | translate}}\">\n" +
    "                            <i aria-hidden=\"true\" class=\"fa fa-pencil\"></i>\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-sm btn-default btn-with-text\" ng-click=\"vm.openGarmentPicker()\"\n" +
    "                            ng-if=\"vm.placement.type !== 'STADIUM_PRODUCT_TEMPLATE'\"\n" +
    "                            title=\"{{'LABEL.SELECTGARMENT' | translate}}\">\n" +
    "                            <span><i aria-hidden=\"true\" class=\"fa fa-th\"></i>{{'LABEL.GARMENT' | translate}}</span>\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-sm btn-default\" ng-click=\"vm.openUploadBackground()\"\n" +
    "                            title=\"{{'TOOLTIP.UPLOADGARMENT' | translate}}\">\n" +
    "                            <i aria-hidden=\"true\" class=\"fa fa-picture-o\">\n" +
    "                            </i>\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-sm btn-danger\" ng-if=\"vm.placement.type !== 'STADIUM_PRODUCT_TEMPLATE'\" ng-click=\"vm.resetActiveViewpoint()\"\n" +
    "                            title=\"{{'TOOLTIP.DELETE' | translate}}\">\n" +
    "                            <i aria-hidden=\"true\" class=\"fa fa-trash\"></i>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <design-placer config=\"vm.designPlacerConfig\" init=\"vm.init(controller)\" />\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-xs-12\">\n" +
    "                    <p class=\"text-center\">\n" +
    "                        {{'MOUNTING.INFORMATION' | translate}}\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-3 right-col\">\n" +
    "            <div class=\"panel panel-default\">\n" +
    "                <div class=\"panel-heading\">\n" +
    "                    {{'MOUNTING.CHOOSEITEM' | translate}}\n" +
    "                    <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"vm.openUploadLogo()\"\n" +
    "                        title=\"{{'TOOLTIP.UPLOADITEM' | translate}}\">\n" +
    "                        <i aria-hidden=\"true\" class=\"fa fa-clone\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <div class=\"panel-body top\">\n" +
    "                    <div class=\"text-center\">\n" +
    "                        <a class=\"btn btn-sm btn-success templateButton\" translate ui-sref=\"app.shop.articlesList\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.ARTICLES'}}\n" +
    "                        </a>\n" +
    "                        <a class=\"btn btn-sm btn-success templateButton\" ng-if=\"!vm.isStadium()\" translate\n" +
    "                            ui-sref=\"app.shop.digits.list\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.DIGITS'}}\n" +
    "                        </a>\n" +
    "                        <a class=\"btn btn-sm btn-success templateButton\" ng-if=\"vm.isStadium()\"\n" +
    "                            ng-disabled=\"vm.specialDigitsOnTemplate()\" translate ui-sref=\"app.shop.large-digits.list\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.LARGE_DIGITS'}}\n" +
    "                        </a>\n" +
    "                        <a class=\"btn btn-sm btn-success templateButton\" ng-if=\"vm.isStadium()\"\n" +
    "                            ng-disabled=\"vm.specialDigitsOnTemplate()\" translate ui-sref=\"app.shop.small-digits.list\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.SMALL_DIGITS'}}\n" +
    "                        </a>\n" +
    "                        <a class=\"btn btn-sm btn-success templateButton\" ng-if=\"vm.isStadium()\" translate\n" +
    "                            ui-sref=\"app.shop.name\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.NAME'}}\n" +
    "                        </a>\n" +
    "                        <a class=\"btn btn-sm btn-success templateButton\" ng-if=\"vm.isStadium()\" translate\n" +
    "                            ui-sref=\"app.shop.initial\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.INITIAL'}}\n" +
    "                        </a>\n" +
    "                        <a class=\"btn btn-sm btn-success templateButton\" ng-if=\"vm.isStadium()\"\n" +
    "                            ng-disabled=\"vm.digitsOnTemplate()\" translate ui-sref=\"app.shop.digit\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.SPECIAL_DIGIT'}}\n" +
    "                        </a>\n" +
    "                        <a class=\"btn btn-sm btn-success templateButton\" ng-if=\"vm.isStadium()\" translate\n" +
    "                            ui-sref=\"app.shop.stadiumLogo\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.DETAIL'}}\n" +
    "                        </a>\n" +
    "                        <button class=\"btn btn-sm btn-success templateButton\" ng-if=\"vm.isStadium()\" translate\n" +
    "                            ng-click=\"vm.addToTemplate()\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDDEFAULTPRODUCTS'}}\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-sm btn-success templateButton\" ng-if=\"vm.isStadium()\" translate\n" +
    "                                ng-click=\"vm.copyFromTemplate()\">\n" +
    "                            {{::'STADIUM.PLACEMENTTEMPLATE.ITEMS.COPYFROMTEMPLATE'}}\n" +
    "                        </button>\n" +
    "                        <div class=\"dropdown dropdown-template\">\n" +
    "                            <a aria-expanded=\"true\" aria-haspopup=\"true\"\n" +
    "                                class=\"btn btn-sm btn-success dropdown-toggle dropdownTemplateButton\"\n" +
    "                                data-toggle=\"dropdown\" ng-if=\"!vm.isStadium()\" type=\"button\">\n" +
    "                                <span translate>\n" +
    "                                    {{::'STADIUM.PLACEMENTTEMPLATE.ORDER.DETAIL'}}\n" +
    "                                </span>\n" +
    "                                <span class=\"caret\"></span>\n" +
    "                            </a>\n" +
    "                            <ul class=\"dropdown-menu dropdown-menu-right dropdown-menu-wide template-dropdown-menu\">\n" +
    "                                <li class=\"template-dropdown-button\" title=\"{{'NAVIGATION.NEWTRANSFER' | translate}}\">\n" +
    "                                    <a translate ui-sref=\"app.shop.create({ articleGroup: 'transfer'})\">\n" +
    "                                        {{::'NAVIGATION.NEWTRANSFER'}}\n" +
    "                                    </a>\n" +
    "                                </li>\n" +
    "                                <li class=\"template-dropdown-button\" title=\"{{'NAVIGATION.NEWPROFILE' | translate}}\">\n" +
    "                                    <a translate ui-sref=\"app.shop.create({ articleGroup: 'profile'})\">\n" +
    "                                        {{::'NAVIGATION.NEWPROFILE'}}\n" +
    "                                    </a>\n" +
    "                                </li>\n" +
    "                                <li class=\"template-dropdown-button\" title=\"{{'NAVIGATION.NEWCONCEPT' | translate}}\">\n" +
    "                                    <a translate ui-sref=\"app.shop.create({ articleGroup: 'concept'})\">\n" +
    "                                        {{::'NAVIGATION.NEWCONCEPT'}}\n" +
    "                                    </a>\n" +
    "                                </li>\n" +
    "                            </ul>\n" +
    "                        </div>\n" +
    "                        <button class=\"btn btn-sm btn-success templateButton\" ng-click=\"vm.addProductFromCart()\"\n" +
    "                            ng-if=\"vm.showAddFromCart()\" translate>\n" +
    "                            {{::'MOUNTING.ADD_FROM_CART'}}\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <table ng-click=\"vm.onClickTemplateItem(item)\"\n" +
    "                        ng-repeat=\"item in vm.placementItems track by item.id+item.type\">\n" +
    "                        <tr>\n" +
    "                            <th class=\"striped-light\">\n" +
    "                                <img class=\"img-responsive\" ng-src=\"{{vm.getImageUrl(item)}}\" />\n" +
    "                            </th>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"panel-item-description\">\n" +
    "                                {{item.name}}\n" +
    "                                <span translate>\n" +
    "                                    {{vm.getPlacementItemDescription(item)}}\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-9\">\n" +
    "\n" +
    "            <!-- Item list -->\n" +
    "            <table class=\"table table-striped table-border article-table\"\n" +
    "                ng-if=\"vm.placementItems && vm.placementItems.length > 0\" ng-model=\"vm.placement.perspectives\">\n" +
    "                <thead>\n" +
    "                    <tr>\n" +
    "                        <th>{{'STADIUM.PLACEMENTTEMPLATE.ITEMS.NAME' | translate}}</th>\n" +
    "                        <th>{{'NAME.LABEL.TYPE' | translate}}</th>\n" +
    "                        <th>{{'ARTICLE.NUMBER' | translate}}</th>\n" +
    "                        <th>{{'STADIUM.PLACEMENTTEMPLATE.ITEMS.PLACED' | translate}}</th>\n" +
    "                        <th>{{'STADIUM.PLACEMENTTEMPLATE.ITEMS.QUANTITY' | translate}}</th>\n" +
    "                        <th ng-if=\"!vm.isStadium()\">{{'LABEL.SIZE' | translate}}</th>\n" +
    "                        <th></th>\n" +
    "                    </tr>\n" +
    "                </thead>\n" +
    "                <tbody>\n" +
    "\n" +
    "                    <tr\n" +
    "                        ng-repeat=\"item in vm.placementItems | filter: vm.placementItemFilter track by item.id+item.type\">\n" +
    "                        <td class=\"name-col\" ng-if=\"item.name !== 'REMOVED ITEM'\" title=\"{{item.name}}\">\n" +
    "                            {{item.name}}\n" +
    "                        </td>\n" +
    "                        <td class=\"name-col\" ng-if=\"item.name === 'REMOVED ITEM'\">\n" +
    "                            <span><i class=\"fa fa-exclamation-triangle\"\n" +
    "                                    tooltip=\"{{'STADIUM.TEMPLATE.ITEMS.ARTICLE.WARNING.EXIST' | translate}}\"></i></span>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            {{vm.getPlacementItemType(item) | translate}}\n" +
    "                        </td>\n" +
    "                        <td ng-if=\"vm.isArticleId(item)\">\n" +
    "                            <a href=\"\"\n" +
    "                                ng-click=\"vm.selectArticle(vm.getPlacementItemArtNr(item))\">{{vm.getPlacementItemArtNr(item)}}</a>\n" +
    "                        </td>\n" +
    "                        <td ng-if=\"!vm.isArticleId(item)\">\n" +
    "                            {{vm.getPlacementItemArtNr(item) | translate}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            {{vm.isItemPlaced(item) ? ('BOOLEAN.TRUE' | translate) : ('BOOLEAN.FALSE' | translate)}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            {{vm.countPlacements(item)}}\n" +
    "                        </td>\n" +
    "                        <td ng-if=!vm.isStadium()>\n" +
    "                            {{vm.getItemDisplaySize(item)}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <button class=\"btn btn-sm btn-default\" ng-click=\"vm.onClickEditPlacementItem(item)\"\n" +
    "                                ng-if=\"vm.showPlacementItemEdit(item)\">\n" +
    "                                <i class=\"fa fa-pencil\"></i>\n" +
    "                            </button>\n" +
    "                            <button class=\"btn btn-sm btn-danger\" ng-click=\"vm.onClickRemovePlacementItem(item)\"\n" +
    "                                ng-if=\"!vm.isItemPlaced(item)\"\n" +
    "                                title=\"{{'STADIUM.TEMPLATE.PLACEMENT.ITEMS.REMOVE' | translate}}\">\n" +
    "                                <i class=\"fa fa-trash\"></i>\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-3 col-centered\" ng-if=\"vm.isStadium()\">\n" +
    "            <div class=\"row\" ng-if=\"vm.placement.type === 'STADIUM_PRODUCT_TEMPLATE'\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <div class=\"panel panel-default printing-information-panel\">\n" +
    "                        <div class=\"panel-heading\">\n" +
    "                            <div translate>\n" +
    "                                {{::'STADIUM.PRODUCT_PRINTING_INFORMATION'}}\n" +
    "                            </div>\n" +
    "                            <button class=\"btn btn-xs btn-danger clear-button\" type=\"button\"\n" +
    "                                ng-click=\"vm.clearPrintingPrice()\"\n" +
    "                                title=\"{{::'STADIUM.PRODUCT_PRINTING_PRICE.CLEAR' | translate}}\">\n" +
    "                                <span class=\"fa fa-trash\"></span>\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                        <div class=\"panel-body top\">\n" +
    "                            <div class=\"col-xs-12 col-centered\">\n" +
    "                                <label translate>\n" +
    "                                    {{::'STADIUM.PRODUCT_PRINTING_PRICE'}}\n" +
    "                                </label>\n" +
    "                                <input class=\"form-control panel-input\" min=\"0\" ng-model=\"vm.printingPrice\" step=\"1\"\n" +
    "                                    type=\"number\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-12 col-centered\"\n" +
    "                ng-if=\"!vm.isQuickTemplateMode() && vm.placement.type !== 'STADIUM_PRODUCT_TEMPLATE'\">\n" +
    "                <button class=\"btn btn-success\" ng-click=\"vm.onClickCreateTemplate()\" translate>\n" +
    "                    {{'STADIUM.PLACEMENTTEMPLATE.CREATENEW'}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-12 col-centered\">\n" +
    "                <button class=\"btn btn-warning\" ng-click=\"vm.closeTemplateMode()\" translate>\n" +
    "                    {{'STADIUM.TEMPLATE.MODE.CLOSE'}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("shop/mounting/editMountingDialog/editMountingDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/mounting/editMountingDialog/editMountingDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\" ng-if=\"vm.user.stadium\" translate>\n" +
    "            {{vm.isTemplateMode ? 'STADIUM.TEMPLATE.DIALOG.TITLE.EDIT' : 'MOUNTING.EDIT'}}\n" +
    "        </div>\n" +
    "        <div class=\"modal-title\" ng-if=\"!vm.user.stadium\" translate>\n" +
    "            {{'PLACEMENT.PROOF.EDIT'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body row\">\n" +
    "        <div class=\"col-md-offset-1 col-md-10\">\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"!vm.nameIsUnique\" translate>\n" +
    "                {{vm.isTemplateMode ? 'STADIUM.TEMPLATE.DIALOG.NAME.WARNING' : 'MOUNTING.DIALOGWARNING'}}\n" +
    "            </div>\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"vm.clubRequired\" translate>\n" +
    "                {{'STADIUM.TEMPLATE.DIALOG.CLUB.WARNING'}}\n" +
    "            </div>\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"vm.categoryRequired\" translate>\n" +
    "                {{'STADIUM.TEMPLATE.DIALOG.CATEGORY.WARNING'}}\n" +
    "            </div>\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\" translate>\n" +
    "                                {{'MOUNTING.NAME'}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input type=\"text\" name=\"templateName\" class=\"form-control\" ng-model=\"vm.templateName\" ng-change=\"vm.checkNameIsUnique()\">\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\" translate>\n" +
    "                                {{'MOUNTING.GARMENT'}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <ui-select ng-model=\"vm.garment\" on-select=\"vm.resetImageUrls()\">\n" +
    "                                    <ui-select-match placeholder=\"Select garment\">\n" +
    "                                        {{$select.selected.value}}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"garment in vm.garments | translationFilter: $select.search : '' : 'value' | orderBy : 'value'\">\n" +
    "                                        <span>\n" +
    "                                            {{garment.value | translate}}\n" +
    "                                        </span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{ 'MOUNTING.COLOUR' | translate }}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <div class=\"color-picker\" ng-class=\"{ 'full': (vm.selectedColours.length > 0) }\">\n" +
    "                                    <ui-select multiple=\"\" limit=\"1\" ng-model=\"vm.selectedColours\" tagging=\"vm.onNewCustomColour\" tagging-label=\"false\" append-to-body=\"true\">\n" +
    "                                        <ui-select-match placeholder=\"{{ 'NAME.PLACEHOLDER.TEXTCOLOUR' | translate }}\">\n" +
    "                                            <div class=\"color-box\" ng-style=\"{'background-color': '#' + $item.code}\"></div>\n" +
    "                                            <span class=\"color-name\">\n" +
    "                                                    {{$item.name}}\n" +
    "                                            </span>\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"color in vm.colours | filter:{ name: $select.search }\">\n" +
    "                                            <div class=\"color-box\" ng-style=\"{'background-color': '#' + color.code}\"></div>\n" +
    "                                            <span class=\"color-name\">\n" +
    "                                                    {{color.name}}\n" +
    "                                            </span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{'PRODUCTIONPLANNING.TAGS'| translate}}\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width tags\">\n" +
    "                                <ui-select tabindex=\"4\" reset-search-input=\"true\" multiple search-enabled=\"false\" tagging=\"vm.newTag\" tagging-label=\"false\" tagging-tokens=\"ENTER\" ng-model=\"vm.tags\" title=\"\" theme=\"bootstrap\">\n" +
    "                                    <ui-select-match placeholder=\"\">{{$item}}</ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.user.stadium\">\n" +
    "                            <td class=\"dynamic-width top-align\">\n" +
    "                                {{ 'MOUNTING.CLUB' | translate }}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <div ng-class=\"{ 'full': vm.selectedClub }\">\n" +
    "                                    <ui-select ng-model=\"vm.selectedClub\" on-select=\"vm.onSelectClub()\">\n" +
    "                                        <ui-select-match placeholder=\"{{ 'MOUNTING.PLACEHOLDERCLUB' | translate }}\">\n" +
    "                                            {{ $select.selected.clubName }}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"club in vm.clubs | orderBy: 'clubName' | filter: $select.search\">\n" +
    "                                                <span class=\"item-name\">\n" +
    "                                                    {{ club.clubName }}\n" +
    "                                                </span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.user.stadium\">\n" +
    "                            <td class=\"dynamic-width top-align\">\n" +
    "                                {{ 'MOUNTING.CATEGORY' | translate }}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <div ng-class=\"{ 'full': vm.selectedCategory }\">\n" +
    "                                    <ui-select ng-model=\"vm.selectedCategory\" ng-disabled=\"!vm.selectedClub\">\n" +
    "                                        <ui-select-match placeholder=\"{{ 'MOUNTING.PLACEHOLDERCATEGORY' | translate }}\">\n" +
    "                                            {{ $select.selected.categoryName }}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"category in vm.categories | orderBy: 'categoryName' |filter: $select.search\">\n" +
    "                                                <span class=\"item-name\">\n" +
    "                                                    {{ category.categoryName }}\n" +
    "                                                </span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.DESCRIPTION' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <textarea class=\"form-control\" ng-model=\"vm.description\"></textarea>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CANCEL' | translate}}\n" +
    "        </button>\n" +
    "        <button name=\"save\" type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\">\n" +
    "            {{'BUTTON.SAVE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/mounting/instructionDialog/instructionDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/mounting/instructionDialog/instructionDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'MOUNTING.ENTERINSTRUCTION' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body row\">\n" +
    "        <div class=\"group\">\n" +
    "            <div class=\"player-dialog-title\">\n" +
    "                {{'MOUNTING.INSTRUCTIONDIALOGTITLE' | translate}}\n" +
    "\n" +
    "            </div>\n" +
    "            <div class=\"player-dialog-text\">\n" +
    "                {{'MOUNTING.INSTRUCTIONDIALOGTEXT' | translate}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <textarea ng-model=\"vm.instruction\" class=\"form-control\">\n" +
    "        </textarea>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"clear\" tabindex=\"3\" type=\"button\" ng-click=\"vm.clear()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CLEAR' | translate}}\n" +
    "        </button>\n" +
    "        <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CANCEL' | translate}}\n" +
    "        </button>\n" +
    "        <button name=\"save\" tabindex=\"3\" type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-success\">\n" +
    "            {{'BUTTON.SAVE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("shop/mounting/printingInformationDialog/printingInformationDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/mounting/printingInformationDialog/printingInformationDialog.tpl.html",
    "<div class=\"printing-work-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\" translate>\n" +
    "            {{'STADIUM.PRODUCT_PRINTING_INFORMATION'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "<div class=\"panel-body top\">\n" +
    "<div class=\"col-xs-12 col-centered\">\n" +
    "    <label translate>\n" +
    "        {{::'LABEL.PRINTS'}}\n" +
    "    </label>\n" +
    "    <input\n" +
    "            class=\"form-control panel-input\"\n" +
    "            min=\"0\"\n" +
    "            ng-model=\"vm.printingWork.printCount\"\n" +
    "            step=\"1\"\n" +
    "            type=\"number\"\n" +
    "    >\n" +
    "</div>\n" +
    "<div class=\"col-xs-12 col-centered\">\n" +
    "    <label translate>\n" +
    "        {{::'LABEL.DIFFICULTY'}}\n" +
    "    </label>\n" +
    "    <ui-select id=\"printDifficulty\" ng-model=\"vm.printingWork.difficulty\">\n" +
    "        <ui-select-match placeholder=\"{{'LABEL.DIFFICULTY' | translate}}\">\n" +
    "            {{'LABEL.DIFFICULTY.' + $select.selected | translate}}\n" +
    "        </ui-select-match>\n" +
    "        <ui-select-choices repeat=\"difficulty in vm.printingWorkDifficulties\">\n" +
    "            {{'LABEL.DIFFICULTY.' + difficulty | translate}}\n" +
    "        </ui-select-choices>\n" +
    "    </ui-select>\n" +
    "</div>\n" +
    "</div>\n" +
    "</div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button\n" +
    "        class=\"btn btn-xs btn-danger clear-button\"\n" +
    "        type=\"button\"\n" +
    "        ng-click=\"vm.clearPrintingInformation()\"\n" +
    "        title=\"{{::'STADIUM.PRODUCT_PRINTING_INFORMATION.CLEAR' | translate}}\"\n" +
    "    >\n" +
    "        <span class=\"fa fa-trash\"></span>\n" +
    "    </button>\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "        <button ng-disabled=\"vm.missingValues()\" name=\"save\" type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-success\">\n" +
    "            {{'BUTTON.SAVE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/mounting/simpleMounting.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/mounting/simpleMounting.tpl.html",
    "<div class=\"article-create\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-offset-3 col-md-6\">\n" +
    "            <form name=\"vm.form\" ng-submit=\"vm.save()\" novalidate>\n" +
    "                <h2 class=\"article-title\">\n" +
    "                    {{'CREATEARTICLE.TITLE.' + vm.productType.name.toUpperCase() | translate}}\n" +
    "                </h2>\n" +
    "                <p>\n" +
    "                    {{'MOUNTING.PLACEMENTINFO' | translate}}\n" +
    "                </p>\n" +
    "                <div class=\"alert alert-warning\" ng-if=\"(!vm.mountingItems || vm.mountingItems.length === 0) && !vm.externalItem\">\n" +
    "                    {{'MOUNTING.NOITEMS' | translate}}\n" +
    "                </div>\n" +
    "                <div class=\"alert alert-warning\" ng-if=\"vm.form.$invalid && vm.form.$submitted || vm.validationErrors.length > 0\">\n" +
    "                    <div ng-messages='vm.form.$error' class='error-messages'>\n" +
    "                        <div ng-messages=\"vm.form.width.$error\">\n" +
    "                            <div ng-message=\"required\">{{'CREATEARTICLE.WIDTHREQUIRED' | translate}}</div>\n" +
    "                            <div ng-message=\"integer\">{{'CREATEARTICLE.WIDTHINVALID' | translate}}</div>\n" +
    "                        </div>\n" +
    "                        <div ng-messages=\"vm.form.height.$error\">\n" +
    "                            <div ng-message=\"required\">{{'CREATEARTICLE.HEIGHTREQUIRED' | translate}}</div>\n" +
    "                            <div ng-message=\"integer\">{{'CREATEARTICLE.HEIGHTINVALID' | translate}}</div>\n" +
    "                        </div>\n" +
    "                        <div ng-messages=\"vm.form.garment.$error\">\n" +
    "                            <div ng-message=\"required\">{{'MOUNTING.GARMENTREQUIRED' | translate}}</div>\n" +
    "                        </div>\n" +
    "                        <div ng-messages=\"vm.form.placement.$error\">\n" +
    "                            <div ng-message=\"required\">{{'MOUNTING.PLACEMENTREQUIRED' | translate}}</div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"table-responsive\">\n" +
    "                    <table class=\"table\">\n" +
    "                        <tbody>\n" +
    "                            <tr ng-if=\"vm.productType && vm.productType.productSubtypes.length > 1\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CREATEARTICLE.SUBTYPE' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <ui-select on-select=\"vm.clearColors()\" ng-model=\"vm.productSubtype\" tabindex=\"2\">\n" +
    "                                        <ui-select-match placeholder=\"{{'CREATEARTICLE.SELECTSUBTYPE' | translate}}\">\n" +
    "                                            {{'PRODUCT.SUBTYPE.' + $select.selected.name | translate}}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"productSubtype in vm.productType.productSubtypes | translationFilter: $select.search : 'PRODUCT.SUBTYPE.' : 'name'\">\n" +
    "                                            <span>{{'PRODUCT.SUBTYPE.' + productSubtype.name | translate}}</span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'CREATEARTICLE.ITEM' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input type=\"checkbox\" id=\"mounting\" ng-model=\"vm.externalItem\" ng-click=\"vm.clearMountingArticle()\"/>\n" +
    "                                    <label for=\"mounting\">\n" +
    "                                        {{'MOUNTING.CHECKBOX' | translate}}\n" +
    "                                    </label>\n" +
    "                                    <ui-select ng-model=\"vm.mountingArticle\" tabindex=\"3\" ng-disabled=\"vm.externalItem\">\n" +
    "                                        <ui-select-match placeholder=\"{{'CREATEARTICLE.SELECTMOUNTING' | translate}}\" title=\"{{$select.selected.name}}\">\n" +
    "                                            <div class=\"simple-mounting-dropdown\">{{$select.selected.name}}</div>\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"mountingItem in vm.mountingItems | filter: $select.search\">\n" +
    "                                            <div class=\"simple-mounting-dropdown\" title=\"{{mountingItem.name}}\">{{mountingItem.name}}</div>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productSubtype.doNotSkipArea\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'LABEL.WIDTH' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input type=\"text\" validate-integer name=\"width\" class=\"form-control\" tabindex=\"5\" ng-model=\"vm.article.width\" focus required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productSubtype.doNotSkipArea\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'LABEL.HEIGHT' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input type=\"text\" validate-integer name=\"height\" class=\"form-control\" tabindex=\"6\" ng-model=\"vm.article.height\" focus required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width top-align\">\n" +
    "                                    {{'MOUNTING.GARMENTSIZES' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <textarea ng-if=\"vm.productType\" type=\"text\" name=\"garment\" class=\"form-control\" ng-model=\"vm.article.garment\" tabindex=\"4\" required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'MOUNTING.PLACEMENT' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input ng-if=\"vm.productType\" type=\"text\" name=\"placement\" class=\"form-control\" tabindex=\"5\" ng-model=\"vm.article.placement\" focus required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width top-align\">\n" +
    "                                    {{'LABEL.TAGS' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width tags\">\n" +
    "                                    <ui-select reset-search-input=\"true\" multiple search-enabled=\"false\" tagging=\"vm.newTag\" tagging-label=\"false\" tagging-tokens=\"ENTER\" ng-model=\"vm.article.tags\" title=\"\" tabindex=\"14\" theme=\"bootstrap\">\n" +
    "                                        <ui-select-match placeholder=\"\">{{$item}}</ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width top-align\">\n" +
    "                                    {{'LABEL.INFORMATION' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <textarea placeholder=\"{{vm.getInfoPlaceholder()}}\" class=\"form-control\" ng-model=\"vm.article.information\" tabindex=\"15\" ></textarea>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.minQuantity > 0\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'LABEL.QUANTITY' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\" tabindex=\"16\">\n" +
    "                                    <div counter=\"\" class=\"btn-group-vertical\" value=\"vm.article.quantity\" min=\"vm.minQuantity\"></div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"!vm.article.errand\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'MOUNTING.TEMPLATE' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <button class=\"btn-default\" ng-click=\"$event.preventDefault()\" ng-file-select=\"\" ng-accept=\"vm.onFileSelect($file)\" ng-model=\"vm.files\" ng-multiple=\"false\" tabindex=\"18\">\n" +
    "                                        {{'BUTTON.SELECTFILE' | translate}}\n" +
    "                                    </button>\n" +
    "                                    <span class=\"file-name\">\n" +
    "                                        {{vm.files[0].name}}\n" +
    "                                    </span>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td></td>\n" +
    "                                <td class=\"contact\">\n" +
    "                                    <div class=\"pull-left\">\n" +
    "                                        <input \n" +
    "                                            type=\"checkbox\" \n" +
    "                                            name=\"contact\" \n" +
    "                                            id=\"contact\" \n" +
    "                                            ng-model=\"vm.article.contact\" \n" +
    "                                            ng-disabled=\"vm.customerSettings.autoReject\"\n" +
    "                                        />\n" +
    "                                        <label \n" +
    "                                            for=\"contact\"\n" +
    "                                            translate    \n" +
    "                                        >\n" +
    "                                            {{::'CREATEARTICLE.CONTACT'}}\n" +
    "                                        </label>\n" +
    "                                    </div>\n" +
    "                                    <div class=\"pull-right\">\n" +
    "                                        <button \n" +
    "                                            ng-disabled=\"!vm.isValid()\" \n" +
    "                                            class=\"btn btn-success\" \n" +
    "                                            translate\n" +
    "                                        >\n" +
    "                                            {{::'BUTTON.SAVE'}}\n" +
    "                                        </button>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/mounting/templateAuditLogsDialog/templateAuditLogsDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/mounting/templateAuditLogsDialog/templateAuditLogsDialog.tpl.html",
    "<div class=\"template-audit-logs-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\" translate>\n" +
    "            {{'TEMPLATE.LOGS'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "<div class=\"modal-body row\">\n" +
    "    <div class=\"col-md-offset-1 col-md-10\">\n" +
    "        <div ng-repeat=\"templateAuditLog in vm.templateAuditLogs\" class=\"logs\">\n" +
    "            <p class=\"log-header\">{{ 'TEMPLATE.LOGS' | translate }}: {{templateAuditLog.templateId}}</p>\n" +
    "            <table class=\"table table-responsive table-striped table-hover table-condensed\" ng-repeat=\"log in templateAuditLog.templateLogs\">\n" +
    "                <tr><th>{{$index+1}} {{log.username}} ({{log.createdAt | date : 'yy-MM-dd HH:mm'}})</th></tr>\n" +
    "                <tr ng-repeat=\"action in log.actions\">\n" +
    "                    <td>{{ action.type | translate: { item: action.item } }}</td>\n" +
    "                </tr>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "</div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/mounting/uploadsDialog/uploadsDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/mounting/uploadsDialog/uploadsDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog placement-images\" ng-show=\"!vm.hidden\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\" ng-if=\"vm.perspective\">\n" +
    "            {{'MOUNTING.USEOWNGARMENTIMAGE' | translate}}\n" +
    "        </div>\n" +
    "        <div class=\"modal-title\" ng-if=\"!vm.perspective\">\n" +
    "            {{'MOUNTING.USEOWNLOGOIMAGE' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body row\">\n" +
    "        <div class=\"alert alert-warning\" ng-if=\"!vm.perspective\">\n" +
    "            {{'MOUNTING.USEOWNLOGOIMAGEWARNING' | translate}}\n" +
    "        </div>\n" +
    "        <div class=\"col-md-offset-1 col-md-10 radio-panel\">\n" +
    "            <div class=\"group\">\n" +
    "                <span class=\"title\">\n" +
    "                    {{'MOUNTING.UPLOADOPTIONS' | translate}}:\n" +
    "                </span>\n" +
    "            </div>\n" +
    "            <div class=\"group\">\n" +
    "                <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioNew\" id=\"radioNew\"/>\n" +
    "                <label for=\"radioNew\">\n" +
    "                    {{'MOUNTING.UPLOADNEWIMAGE' | translate}}\n" +
    "                </label>\n" +
    "                <br/>\n" +
    "                <input type=\"radio\" checked=\"checked\" ng-model=\"vm.radioChoice\" value=\"radioReuse\" id=\"radioReuse\"/>\n" +
    "                <label for=\"radioReuse\">\n" +
    "                    {{'MOUNTING.UPLOADREUSE' | translate}}\n" +
    "                </label>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-offset-1 col-md-10\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                        <tr ng-if=\"vm.radioChoice === 'radioNew'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.FILE' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <button class=\"btn-default\" ng-click=\"$event.preventDefault()\" ng-file-select=\"\" ng-accept=\"vm.onFileSelect($file)\" ng-model=\"vm.files\" ng-multiple=\"false\" tabindex=\"18\">\n" +
    "                                    {{'BUTTON.SELECTFILE' | translate}}\n" +
    "                                </button>\n" +
    "                                <button class=\"btn-delete\" ng-click=\"vm.removeFile(fileIndex)\" ng-if-start=\"vm.files.length > 0\">\n" +
    "                                    <i class=\"fa fa-remove\"></i>\n" +
    "                                </button>\n" +
    "                                <span class=\"file-name\" ng-if-end>\n" +
    "                                    {{vm.files[0].name}}\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.radioChoice === 'radioNew'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.NAME' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.name\"/>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-12 upload-panel\" ng-if=\"vm.radioChoice === 'radioReuse' && vm.originalPlacementImages.length > 0\">\n" +
    "            <div class=\"col-md-offset-1\">\n" +
    "                <div class=\"row upload-content-title\">\n" +
    "                    <div class=\"col-md-8\">\n" +
    "                        <span class=\"title\">\n" +
    "                            {{'MOUNTING.SELECTIMAGE' | translate}}:\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-md-4\">\n" +
    "                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.search\" ng-model-options=\"{ debounce: 400 }\" ng-change=\"vm.filter()\" placeholder=\"{{'FIELD.SEARCH' | translate}}\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row upload-content\">\n" +
    "                <div class=\"col-xs-3 upload-item\" ng-repeat=\"placementImage in vm.placementImages\">\n" +
    "                    <button class=\"btn btn-xs btn-danger\" ng-click=\"vm.deletePlacementImage(placementImage)\" title=\"{{'TOOLTIP.DELETEERRAND' | translate}}\">\n" +
    "                        <i class=\"fa fa-remove\" aria-hidden=\"true\"></i>\n" +
    "                    </button>\n" +
    "                    <table ng-class=\"{active: vm.selectedImage == placementImage}\" ng-click=\"vm.onClickImage(placementImage)\">\n" +
    "                        <tr>\n" +
    "                            <th class=\"striped-light\">\n" +
    "                                <img class=\"img-responsive\" ng-src=\"{{vm.imageUrl(placementImage)}}\"/>\n" +
    "                            </th>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                {{::placementImage.name | limitTo: 30}}{{::placementImage.name.length > 30 ? '&hellip;' : ''}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-12\" ng-if=\"vm.radioChoice === 'radioReuse' && vm.originalPlacementImages.length === 0\">\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"vm.perspective\">\n" +
    "                {{'MOUNTING.UPLOADWARNING1PART1' | translate}} {{'PERSPECTIVE.TYPE.' + vm.perspective | translate}}. {{'MOUNTING.UPLOADWARNING1PART2' | translate}}\n" +
    "            </div>\n" +
    "            <div class=\"alert alert-warning \" ng-if=\"!vm.perspective\">\n" +
    "                {{'MOUNTING.UPLOADWARNING2' | translate}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"alert alert-warning no-placements\" ng-if=\"!vm.isValidFile && vm.files.length > 0\">\n" +
    "        {{'MOUNTING.IMAGEFORMATWARNING' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <span ng-if=\"vm.perspective\">\n" +
    "            {{'MOUNTING.GARMENT' | translate}}: {{'PERSPECTIVE.TYPE.' + vm.perspective | translate}}\n" +
    "        </span>\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CANCEL' | translate}}\n" +
    "        </button>\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.upload()\" class=\"btn btn-success\" ng-disabled=\"vm.files.length == 0 || !vm.name || !vm.isValidFile\" ng-if=\"vm.radioChoice === 'radioNew'\">\n" +
    "            {{'MOUNTING.UPLOAD' | translate}}\n" +
    "        </button>\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.use()\" class=\"btn btn-success\" ng-disabled=\"!vm.selectedImage\" ng-if=\"vm.radioChoice !== 'radioNew'\">\n" +
    "            {{'MOUNTING.USE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("shop/name/name.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/name/name.tpl.html",
    "<div class=\"name\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-offset-3 col-sm-6\">\n" +
    "            <h2>\n" +
    "                {{vm.getTitle() | translate}}\n" +
    "            </h2>\n" +
    "            <p>\n" +
    "                {{vm.getBreadText() | translate}}\n" +
    "            </p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-offset-3 col-sm-6\">\n" +
    "            <form name=\"vm.form\" novalidate>\n" +
    "                <div class=\"alert alert-warning\"\n" +
    "                     id=\"warnings\"\n" +
    "                     ng-if=\"vm.form.$invalid && vm.form.$submitted || vm.hasErrors\">\n" +
    "                    <div ng-if=\"vm.validationErrors.playerListId\">\n" +
    "                        {{ 'NAME.VALIDATION.PLAYERLIST' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.playerListTypes\">\n" +
    "                        {{ 'NAME.VALIDATION.PLAYERLISTTYPE' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.fontType\">\n" +
    "                        {{ 'NAME.VALIDATION.FONT' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.formType\">\n" +
    "                        {{ 'NAME.VALIDATION.FORM' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.caseType\">\n" +
    "                        {{ 'NAME.VALIDATION.CASE' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.textColour\">\n" +
    "                        {{ 'NAME.VALIDATION.TEXTCOLOUR' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.backgroundColour\">\n" +
    "                        {{ 'NAME.VALIDATION.BACKGROUNDCOLOUR' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.description\">\n" +
    "                        {{ 'NAME.VALIDATION.DESCRIPTION' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.width\">\n" +
    "                        {{ 'NAME.VALIDATION.WIDTH' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.stadiumInitialWidth\">\n" +
    "                        {{ 'NAME.VALIDATION.STADIUMINITIALWIDTH' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.height\">\n" +
    "                        {{ 'NAME.VALIDATION.HEIGHT' | translate }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.quantity\">\n" +
    "                        {{ 'NAME.VALIDATION.QUANTITY' | translate:{ minimumQuantity: vm.minQuantity } }}\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.validationErrors.stadiumPlayerListNoMatchingPlayers\">\n" +
    "                        {{vm.getNoMatchingPlayersError()}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"table-responsive\">\n" +
    "                    <table class=\"table\">\n" +
    "                        <tbody>\n" +
    "                        <!-- Scope type -->\n" +
    "                        <tr ng-if=\"vm.isTemplateMode() && !vm.isStadium()\">\n" +
    "                            <td></td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <div class=\"player-list-types\">\n" +
    "                                    <span ng-repeat=\"scopeType in vm.playerListTypes\">\n" +
    "                                        <input type=\"checkbox\"\n" +
    "                                               id=\"{{scopeType.name}}\"\n" +
    "                                               name=\"{{scopeType.name}}\"\n" +
    "                                               ng-model=\"scopeType.active\"\n" +
    "                                               ng-disabled=\"vm.isEditMode()\">\n" +
    "                                        <label class=\"form-label\" for=\"{{scopeType.name}}\">\n" +
    "                                            {{ ('NAME.PLAYERLISTTYPE.' + scopeType.name) | translate }}\n" +
    "                                        </label>\n" +
    "                                    </span>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Player list -->\n" +
    "                        <tr ng-if=\"!vm.isTemplateMode()\">\n" +
    "                            <td class=\"dynamic-width top-align\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.PLAYERLIST' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <span class=\"input-group player-list\">\n" +
    "                                    <input class=\"form-control\"\n" +
    "                                           type=\"text\"\n" +
    "                                           readonly=\"readonly\"\n" +
    "                                           ng-model=\"vm.playerListName\"\n" +
    "                                           ng-disabled=\"vm.names\">\n" +
    "                                    <span class=\"button-group-justified input-group-btn\">\n" +
    "                                        <button class=\"btn btn-default\"\n" +
    "                                                type=\"button\"\n" +
    "                                                ng-click=\"vm.openPlayerListDialog()\"\n" +
    "                                                ng-disabled=\"vm.names\"\n" +
    "                                                title=\"{{'TOOLTIP.PLAYERS' | translate}}\">\n" +
    "                                            <i class=\"fa fa-th-list\"></i>\n" +
    "                                        </button>\n" +
    "                                        <button class=\"btn btn-default\"\n" +
    "                                                type=\"button\"\n" +
    "                                                ng-click=\"vm.clearPlayerLists()\"\n" +
    "                                                ng-disabled=\"vm.names\"\n" +
    "                                                title=\"{{'TOOLTIP.CLEAR' | translate}}\">\n" +
    "                                            <i class=\"fa fa-trash\"></i>\n" +
    "                                        </button>\n" +
    "                                    </span>\n" +
    "                                </span>\n" +
    "                                <div class=\"player-list-types\" ng-if=\"vm.name.playerListId && !vm.isStadium()\">\n" +
    "                                    <span ng-repeat=\"type in vm.playerListTypes\">\n" +
    "                                        <input type=\"checkbox\"\n" +
    "                                               id=\"{{type.name}}\"\n" +
    "                                               name=\"{{type.name}}\"\n" +
    "                                               ng-model=\"type.active\"\n" +
    "                                               ng-disabled=\"!type.enabled\">\n" +
    "                                        <label class=\"form-label\" for=\"{{type.name}}\">\n" +
    "                                            {{ ('NAME.PLAYERLISTTYPE.' + type.name) | translate }}\n" +
    "                                        </label>\n" +
    "                                    </span>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Quick player list -->\n" +
    "                        <tr ng-if=\"!vm.isTemplateMode()\">\n" +
    "                            <td class=\"dynamic-width free-text-title\">\n" +
    "                                <div class=\"row\">\n" +
    "                                    <label class=\"form-label col-xs-12\">\n" +
    "                                        {{'NAME.LABEL.PLAYERLIST' | translate}} - {{'NAME.FREETEXT.FREETEXT' | translate}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                                <div class=\"row\">\n" +
    "                                    <label class=\"form-label col-xs-12\" for=\"freeTextPlayerList\">\n" +
    "                                        {{'MOUNTING.PLAYERS' | translate}}:\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width free-text-box\">\n" +
    "                                <textarea class=\"form-control\"\n" +
    "                                          id=\"freeTextPlayerList\"\n" +
    "                                          ng-model=\"vm.names\"\n" +
    "                                          ng-disabled=\"vm.name.playerListId\"\n" +
    "                                          ng-blur=\"vm.setNamePreviewPlayers()\"\n" +
    "                                          cols=\"50\">\n" +
    "                                </textarea>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Font type -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.FONT' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <div class=\"font-picker\" ng-class=\"{ 'full': vm.selectedFont.length === 1 }\">\n" +
    "                                    <ui-select multiple\n" +
    "                                               limit=\"1\"\n" +
    "                                               ng-model=\"vm.selectedFont\"\n" +
    "                                               tagging\n" +
    "                                               tagging-label=\"false\"\n" +
    "                                               append-to-body=\"true\">\n" +
    "                                        <ui-select-match placeholder=\"{{ 'NAME.PLACEHOLDER.FONT' | translate }}\">\n" +
    "                                            {{ vm.getSelectedFontName($select.selected[0]) | translate }}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"type in vm.metaData.fontTypes | translationFilter: $select.search : 'NAME.FONTTYPE.'\">\n" +
    "                                            <span class=\"item-name\">\n" +
    "                                                {{ 'NAME.FONTTYPE.' + type | translate }}\n" +
    "                                            </span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Form type -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.FORM' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <ui-select ng-model=\"vm.name.formType\" append-to-body=\"true\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'NAME.PLACEHOLDER.FORM' | translate }}\">\n" +
    "                                        {{ 'NAME.FORMTYPE.' + $select.selected | translate }}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"item in vm.metaData.formTypes | translationFilter: $select.search : 'NAME.FORMTYPE.'\">\n" +
    "                                        <span>{{ 'NAME.FORMTYPE.' + item | translate }}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Case type -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.CASE' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <ui-select ng-model=\"vm.name.caseType\" append-to-body=\"true\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'NAME.PLACEHOLDER.CASE' | translate }}\">\n" +
    "                                        {{ 'NAME.CASETYPE.' + $select.selected | translate }}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"item in vm.metaData.caseTypes | translationFilter: $select.search : 'NAME.CASETYPE.'\">\n" +
    "                                        <span>{{ 'NAME.CASETYPE.' + item | translate }}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Text colour -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.TEXTCOLOUR' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <div class=\"color-picker input-group\"\n" +
    "                                     ng-class=\"{ 'full': (vm.maxColourCount === vm.selectedColours.text.length) }\">\n" +
    "                                    <ui-select multiple\n" +
    "                                               limit=\"{{ vm.maxColourCount }}\"\n" +
    "                                               ng-model=\"vm.selectedColours.text\"\n" +
    "                                               tagging=\"vm.newCustomColour\"\n" +
    "                                               tagging-label=\"false\"\n" +
    "                                               append-to-body=\"true\">\n" +
    "                                        <ui-select-match placeholder=\"{{ 'NAME.PLACEHOLDER.TEXTCOLOUR' | translate }}\">\n" +
    "                                            <div class=\"color-box\"\n" +
    "                                                 ng-style=\"{'background-color': '#' + $item.code}\">\n" +
    "                                            </div>\n" +
    "                                            <span class=\"color-name\">\n" +
    "                                                {{$item.name}}\n" +
    "                                            </span>\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"colour in vm.colours | filter:{ name: $select.search }\">\n" +
    "                                            <div class=\"color-box\"\n" +
    "                                                 ng-style=\"{'background-color': '#' + colour.code}\">\n" +
    "                                            </div>\n" +
    "                                            <span class=\"color-name\">\n" +
    "                                                {{colour.name}}\n" +
    "                                            </span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                    <div class=\"input-group-btn top-align\">\n" +
    "                                        <button class=\"btn btn-default\"\n" +
    "                                                type=\"button\"\n" +
    "                                                ng-click=\"vm.openColourPicker('text')\"\n" +
    "                                                title=\"{{ 'TOOLTIP.COLOURPICKER' | translate }}\">\n" +
    "                                            <i class=\"fa fa-th\"></i>\n" +
    "                                        </button>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Background colour -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.BACKGROUNDCOLOUR' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <div class=\"color-picker input-group\"\n" +
    "                                     ng-class=\"{ 'full': (vm.maxColourCount === vm.selectedColours.background.length) }\">\n" +
    "                                    <ui-select multiple\n" +
    "                                               limit=\"{{ vm.maxColourCount }}\"\n" +
    "                                               ng-model=\"vm.selectedColours.background\"\n" +
    "                                               tagging=\"vm.newCustomColour\"\n" +
    "                                               tagging-label=\"false\"\n" +
    "                                               append-to-body=\"true\">\n" +
    "                                        <ui-select-match placeholder=\"{{ 'NAME.PLACEHOLDER.BACKGROUNDCOLOUR' | translate }}\">\n" +
    "                                            <div class=\"color-box\"\n" +
    "                                                 ng-style=\"{'background-color': '#' + $item.code}\">\n" +
    "                                            </div>\n" +
    "                                            <span class=\"color-name\">\n" +
    "                                                {{$item.name}}\n" +
    "                                            </span>\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"color in vm.colours | filter:{ name: $select.search }\">\n" +
    "                                            <div class=\"color-box\"\n" +
    "                                                 ng-style=\"{'background-color': '#' + color.code}\">\n" +
    "                                            </div>\n" +
    "                                            <span class=\"color-name\">\n" +
    "                                                {{color.name}}\n" +
    "                                            </span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                    <div class=\"input-group-btn top-align\">\n" +
    "                                        <button class=\"btn btn-default\"\n" +
    "                                                type=\"button\"\n" +
    "                                                ng-click=\"vm.openColourPicker('background')\"\n" +
    "                                                title=\"{{ 'TOOLTIP.COLOURPICKER' | translate }}\">\n" +
    "                                            <i class=\"fa fa-th\"></i>\n" +
    "                                        </button>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Description -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.DESCRIPTION' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input class=\"form-control\"\n" +
    "                                       type=\"text\"\n" +
    "                                       name=\"description\"\n" +
    "                                       ng-model=\"vm.name.description\"\n" +
    "                                       focus>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Information -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width top-align\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.INFORMATION' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <textarea class=\"form-control\" ng-model=\"vm.name.information\"></textarea>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Width -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.WIDTH' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input class=\"form-control\" type=\"text\" name=\"width\" ng-model=\"vm.name.width\" focus>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Height -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width top-align\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{ 'NAME.LABEL.HEIGHT' | translate }}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input class=\"form-control\"\n" +
    "                                       type=\"text\"\n" +
    "                                       name=\"height\"\n" +
    "                                       ng-model=\"vm.name.height\"\n" +
    "                                       ng-disabled=\"vm.name.heightRelative\"\n" +
    "                                       focus>\n" +
    "                                <div class=\"height-relative\" ng-if=\"!vm.isDigit()\">\n" +
    "                                    <input type=\"checkbox\"\n" +
    "                                           id=\"heightRelative\"\n" +
    "                                           name=\"heightRelative\"\n" +
    "                                           ng-model=\"vm.name.heightRelative\"\n" +
    "                                           ng-change=\"vm.onHeightTypeChange()\">\n" +
    "                                    <label for=\"heightRelative\">\n" +
    "                                        {{ 'NAME.LABEL.VARIABLEHEIGHT' | translate }}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Tags -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width top-align\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{'NAME.LABEL.TAG' | translate}}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width tags\">\n" +
    "                                <ui-select multiple\n" +
    "                                           tagging\n" +
    "                                           tagging-label=\"false\"\n" +
    "                                           tagging-tokens=\"ENTER\"\n" +
    "                                           reset-search-input=\"true\"\n" +
    "                                           search-enabled=\"false\"\n" +
    "                                           ng-model=\"vm.name.tags\"\n" +
    "                                           theme=\"bootstrap\"\n" +
    "                                           append-to-body=\"true\">\n" +
    "                                    <ui-select-match placeholder=\"\">{{$item}}</ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Quantity -->\n" +
    "                        <tr ng-if=\"vm.names\">\n" +
    "                            <td class=\"dynamic-width top-align\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{'NAME.LABEL.QUANTITY' | translate}}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"col-md-1\">\n" +
    "                                <div counter class=\"btn-group-vertical\" value=\"vm.freeTextQuantity\" min=\"1\"></div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Attachment -->\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                <label class=\"form-label\">\n" +
    "                                    {{'NAME.LABEL.FILE' | translate}}:\n" +
    "                                </label>\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <div class=\"input-group\">\n" +
    "                                    <input class=\"form-control\"\n" +
    "                                           ng-class=\"{ pointer: vm.files.length > 0 && !vm.files[0].size }\"\n" +
    "                                           ng-value=\"vm.files[0].name | translate\"\n" +
    "                                           ng-click=\"vm.getFile()\"\n" +
    "                                           ng-disabled=\"vm.files.length === 0\"\n" +
    "                                           ng-readonly=\"vm.files.length > 0\"\n" +
    "                                           title=\"{{vm.files[0].name | translate}}\"\n" +
    "                                           type=\"text\"/>\n" +
    "                                    <span class=\"input-group-btn\">\n" +
    "                                        <button class=\"btn btn-default\"\n" +
    "                                                ng-click=\"$event.preventDefault()\"\n" +
    "                                                ng-file-select=\"\"\n" +
    "                                                ng-accept=\"vm.onFileSelect($file)\"\n" +
    "                                                ng-multiple=\"false\">\n" +
    "                                            {{vm.files.length > 0\n" +
    "                                                ? 'BUTTON.REPLACEFILE'\n" +
    "                                                : 'BUTTON.SELECTFILE'\n" +
    "                                                | translate}}\n" +
    "                                        </button>\n" +
    "                                    </span>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <!-- Submit -->\n" +
    "                        <tr>\n" +
    "                            <td colspan=\"2\">\n" +
    "                                <div class=\"pull-right save-buttons\" ng-if=\"!vm.isEditMode()\">\n" +
    "                                    <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.submit()\">\n" +
    "                                        {{vm.isTemplateMode()\n" +
    "                                            ? 'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATE'\n" +
    "                                            : 'BUTTON.SAVE'\n" +
    "                                            | translate}}\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.submit('new')\">\n" +
    "                                        {{vm.isTemplateMode()\n" +
    "                                            ? 'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATECREATENEW'\n" +
    "                                            : 'BUTTON.SAVEANDADDNEWNAME'\n" +
    "                                            | translate}}\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                                <div class=\"pull-right save-buttons\" ng-if=\"vm.isEditMode()\">\n" +
    "                                    <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.submit()\">\n" +
    "                                        {{'BUTTON.UPDATE' | translate}}\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-3\" ng-show=\"vm.showNamePreview()\">\n" +
    "            <div name-preview\n" +
    "                 players=\"vm.players\"\n" +
    "                 font=\"vm.selectedFont\"\n" +
    "                 case=\"vm.name.caseType\"\n" +
    "                 text-colour=\"vm.selectedColours.text\"\n" +
    "                 background-colour=\"vm.selectedColours.background\"\n" +
    "                 active-player-list-types=\"vm.playerListTypes\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shop/shop.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shop/shop.tpl.html",
    "<div class=\"container-fluid shop\" ng-class=\"{stadium: vm.user.stadium}\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 text-center\">\n" +
    "            <img ng-if=\"vm.isStagingOrDevelopment\" ng-repeat=\"i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]\" src=\"./assets/images/demo.png\"/>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"header\">\n" +
    "                <div class=\"logo\">\n" +
    "                    <img src=\"./assets/images/bamatex.png\"/>\n" +
    "                </div>\n" +
    "                <div user-box></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div ng-if=\"vm.isCurrentUserBlocked()\" class=\"alert alert-danger\">\n" +
    "                {{'NAVIGATION.CURRENTUSERBLOCKED' | translate}}\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.isSelectedUserBlocked()\" class=\"alert alert-danger\">\n" +
    "                {{'NAVIGATION.SELECTEDUSERBLOCKED' | translate}}\n" +
    "            </div>\n" +
    "            <nav ng-if=\"!vm.loading && !vm.isCurrentUserBlocked() && !vm.isSelectedUserBlocked()\" class=\"navbar navbar-default\" role=\"navigation\">\n" +
    "                <ul class=\"nav navbar-nav\" ng-class=\"{ 'small-menu-hidden': !vm.isMenuOpen }\">\n" +
    "                    <li class=\"main-menu-toggle visible-xs-block\">\n" +
    "                        <a href=\"\" ng-click=\"vm.toggleMenu()\">\n" +
    "                            {{ 'NAVIGATION.' + (vm.isMenuOpen ? 'HIDE' : 'SHOW') | translate }}\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.calculator') }\">\n" +
    "                        <a ng-if=\"!vm.user.stadium\" href=\"\" ng-click=\"go('/')\">\n" +
    "                            <i class=\"fa fa-calculator\" title=\"{{'TOOLTIP.CALCULATOR' | translate}}\"></i>\n" +
    "                        </a>\n" +
    "                        <a ng-if=\"vm.user.stadium\" href=\"\" ng-click=\"go('/stadium')\">\n" +
    "                            <i class=\"fa fa-home\" title=\"{{'TOOLTIP.CALCULATOR' | translate}}\"></i>\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.articlesList') || $state.includes('app.shop.articleView'), locked: vm.isLocked('articles') }\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked('articles') || go('/articles')\">{{'NAVIGATION.ARTICLES' | translate}}</a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.digitsList') || $state.includes('app.shop.digitView'), locked: vm.isLocked('digits') }\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked('digits') || go('/digits/list')\">{{'NAVIGATION.DIGITS' | translate}}</a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.name'), locked: vm.isLocked() }\" ng-if=\"vm.user.stadium\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked() || vm.navigateToName()\">{{'NAVIGATION.NAME' | translate}}</a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.initial'), locked: vm.isLocked() }\" ng-if=\"vm.user.stadium\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked() || vm.navigateToInitial()\">{{'NAVIGATION.INITIAL' | translate}}</a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.digit'), locked: vm.isLocked() }\" ng-if=\"vm.user.stadium\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked() || vm.navigateToDigit()\">{{'NAVIGATION.DIGIT' | translate}}</a>\n" +
    "                    </li>\n" +
    "                    <li class=\"dropdown\" ng-class=\"vm.getNewItemClasses($stateParams.articleGroup)\" ng-if=\"!vm.user.stadium\">\n" +
    "                        <a href=\"\" type=\"button\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n" +
    "                            {{ 'NAVIGATION.NEWITEM' | translate }}\n" +
    "                        </a>\n" +
    "                        <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                            <li ng-class=\"{ 'locked': vm.isLocked() }\">\n" +
    "                                <a href=\"\" ng-click=\"vm.isLocked() || go('/create/transfer')\">{{'NAVIGATION.NEWTRANSFER' | translate}}</a>\n" +
    "                            </li>\n" +
    "                            <li ng-class=\"{ 'locked': vm.isLocked() }\">\n" +
    "                                <a href=\"\" ng-click=\"vm.isLocked() || go('/create/profile')\">{{'NAVIGATION.NEWPROFILE' | translate}}</a>\n" +
    "                            </li>\n" +
    "                            <li ng-class=\"{ 'locked': vm.isLocked() }\">\n" +
    "                                <a href=\"\" ng-click=\"vm.isLocked() || go('/create/concept')\">{{'NAVIGATION.NEWCONCEPT' | translate}}</a>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.create'), locked: vm.isLocked('create') }\" ng-if=\"vm.user.stadium\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked('create') || go('/stadiumlogo')\">{{'NAVIGATION.NEWITEM' | translate}}</a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.stadiumproducts') }\" ng-if=\"vm.showStadiumProducts && vm.user.stadium\">\n" +
    "                        <a href=\"\" ng-click=\"go('/stadiumproducts')\">{{'STADIUM.PRODUCTS' | translate}}</a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.mounting'), locked: vm.isLocked() }\" ng-if=\"!vm.user.stadium && !vm.isTemplateMode()\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked() || go('/mounting')\" translate>{{'NAVIGATION.MOUNTING'}}</a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.advancedMounting'), locked: vm.isLocked() }\"\n" +
    "                        ng-if=\"(vm.isStadiumUser() && vm.isTemplateMode())\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked() || vm.navigateToMounting()\" translate>\n" +
    "                            {{'STADIUM.USERBOX.TEMPLATE'}}\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ active: $state.includes('app.shop.advancedMounting'), locked: vm.isLocked() }\"\n" +
    "                        ng-if=\"!vm.isStadiumUser()\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked() || vm.navigateToMounting()\" translate>\n" +
    "                            {{'PLACEMENT.PROOF'}}\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "                <ul class=\"nav navbar-nav navbar-right\" ng-class=\"{ 'locked': vm.isLocked() }\">\n" +
    "                    <li class=\"search\">\n" +
    "                        <span class=\"visible-xs-inline\">\n" +
    "                            <input class=\"form-control\" type=\"text\" ng-disabled=\"vm.isLocked('search')\" ng-keypress=\"vm.onClickSearch($event)\"\n" +
    "                                   ng-model=\"vm.searchField\" placeholder=\"{{'FIELD.SEARCH' | translate}}\"/>\n" +
    "                        </span>\n" +
    "                        <input class=\"form-control hidden-sm hidden-xs\" type=\"text\" ng-disabled=\"vm.isLocked('search')\"\n" +
    "                               ng-keypress=\"vm.onClickSearch($event)\" ng-model=\"vm.searchField\" placeholder=\"{{'FIELD.SEARCH' | translate}}\"/>\n" +
    "                        <button class=\"btn btn-default hidden-sm\" ng-disabled=\"vm.isLocked('search')\" ng-click=\"vm.onClickSearch()\"><i class=\"fa fa-search\"></i></button>\n" +
    "                        <span class=\"cart visible-xs-inline\">\n" +
    "                            <a href=\"\" ng-click=\"vm.isLocked() || go('/cart')\">\n" +
    "                                <i class=\"fa fa-shopping-cart\" title=\"{{'TOOLTIP.CART' | translate}}\"></i>\n" +
    "                                <span>{{vm.cartMeta.itemCount}}</span>\n" +
    "                            </a>\n" +
    "                        </span>\n" +
    "\n" +
    "                        <span class=\"dropdown hidden-lg hidden-md hidden-xs\">\n" +
    "                            <button class=\"btn btn-default dropdown-toggle\" ng-show=\"!vm.searchField.length\"\n" +
    "                                    ng-disabled=\"vm.isLocked('search')\" ng-click=\"vm.delayedFocus('#small-search')\">\n" +
    "                                <i class=\"fa fa-search\"></i>\n" +
    "                            </button>\n" +
    "                            <button class=\"btn btn-default dropdown-toggle\" ng-show=\"vm.searchField.length\"\n" +
    "                                    ng-disabled=\"vm.isLocked('search')\" ng-click=\"vm.onClickSearch()\">\n" +
    "                                <i class=\"fa fa-search\"></i>\n" +
    "                            </button>\n" +
    "                            <ul class=\"dropdown-menu\">\n" +
    "                                <li>\n" +
    "                                    <input class=\"form-control\" type=\"text\" id=\"small-search\" ng-disabled=\"vm.isLocked('search')\"\n" +
    "                                           ng-keypress=\"vm.onClickSearch($event)\" ng-model=\"vm.searchField\" placeholder=\"Search\"/>\n" +
    "                                </li>\n" +
    "                            </ul>\n" +
    "                        </span>\n" +
    "                    </li>\n" +
    "                    <li class=\"cart hidden-xs\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                        <a href=\"\" ng-click=\"vm.isLocked() || go('/cart')\">\n" +
    "                            <i class=\"fa fa-shopping-cart\" title=\"{{'TOOLTIP.CART' | translate}}\"></i>\n" +
    "                            <span>&nbsp;{{vm.cartMeta.itemCount}}</span>\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </nav>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div ui-view=\"main-content\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"pusher\"></div>\n" +
    "</div>\n" +
    "<footer class=\"container-fluid shop-footer\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <span>Copyright © Bamatex AB</span>\n" +
    "            <span><a href=\"http://bamatex.se/\" target=\"_blank\">Bamatex.se</a></span>\n" +
    "            <span><i class=\"fa fa-envelope\"></i> order@bamatex.se</span>\n" +
    "            <span><i class=\"fa fa-phone\"></i> Tel. +46 33-180 11 80</span>\n" +
    "            <span>\n" +
    "                <a href=\"\" ng-click=\"vm.openPrivacyPolicy()\">\n" +
    "                    {{'PRIVACY.TITLE' | translate}}\n" +
    "                </a>\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</footer>\n" +
    "");
}]);

angular.module("stadium/incomingOrders/incomingOrders.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/incomingOrders/incomingOrders.tpl.html",
    "<div class=\"incoming-orders\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <h2>\n" +
    "            {{'INCOMINGORDERS.TITLE' | translate}} {{vm.orderType}}\n" +
    "        </h2>\n" +
    "        <div class=\"search-box search\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <input \n" +
    "                    type=\"radio\"\n" +
    "                    id=\"orderTypeB2B\"\n" +
    "                    value=\"B2B\"\n" +
    "                    name=\"orderType\"\n" +
    "                    ng-model=\"vm.orderType\"\n" +
    "                    ng-change=\"vm.changeOrderType()\"\n" +
    "                >\n" +
    "                <label for=\"orderTypeB2B\" class=\"checkboxLabel\">\n" +
    "                    B2B\n" +
    "                </label>\n" +
    "                <input \n" +
    "                    type=\"radio\"\n" +
    "                    id=\"orderTypeB2C\"\n" +
    "                    value=\"B2C\"\n" +
    "                    name=\"orderType\"\n" +
    "                    ng-model=\"vm.orderType\"\n" +
    "                    ng-change=\"vm.changeOrderType()\"\n" +
    "                >\n" +
    "                <label for=\"orderTypeB2C\" class=\"checkboxLabel\">\n" +
    "                    B2C\n" +
    "                </label>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <table class=\"table\" ng-if=\"vm.groups.length !== 0\">\n" +
    "            <thead>\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                    {{'INCOMINGORDERS.RECEIVED' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'INCOMINGORDERS.CLUB' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'INCOMINGORDERS.CUSTOMERREFERENCE' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'INCOMINGORDERS.SALESPERSON' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'INCOMINGORDERS.WEBID' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                    {{'INCOMINGORDERS.ITEMS' | translate}}\n" +
    "                </th>\n" +
    "                <th>\n" +
    "                </th>\n" +
    "            </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "            <tr ng-repeat=\"group in vm.groups\">\n" +
    "                <td>\n" +
    "                    <span ng-attre-title=\"{{::group.received}}\">\n" +
    "                        {{::group.received | date: 'yy-MM-dd HH:mm'}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-attr-title=\"{{::group.club}}\">\n" +
    "                        {{::group.club | limitTo: 25}}{{::group.club.length > 25 ? '&hellip;' : ''}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-attr-title=\"{{::group.reference}}\">\n" +
    "                        {{::group.reference | limitTo: 25}}{{::group.reference.length > 25 ? '&hellip;' : ''}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-attr-title=\"{{::group.user}}\">\n" +
    "                        {{::group.user | limitTo: 25}}{{::group.user.length > 25 ? '&hellip;' : ''}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <span ng-attr-title=\"{{::group.weborder}}\">\n" +
    "                        {{::group.weborder | limitTo: 25}}{{::group.weborder.length > 25 ? '&hellip;' : ''}}\n" +
    "                    </span>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    {{group.itemCount}}\n" +
    "                </td>\n" +
    "                <td class=\"text-right col-md-1\">\n" +
    "                    <button \n" +
    "                        class=\"btn btn-default btn-sm\" \n" +
    "                        title=\"{{'TOOLTIP.SHOWDETAILS' | translate}}\" \n" +
    "                        ng-click=\"vm.openIncomingOrdersDialog(group)\"\n" +
    "                    >\n" +
    "                        <i class=\"fa fa-clone\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button\n" +
    "                        class=\"btn btn-success btn-sm\"\n" +
    "                        title=\"{{'TOOLTIP.CREATE_NEW_ORDER' | translate}}\"\n" +
    "                        ng-click=\"vm.createOrder(group)\"\n" +
    "                        ng-if=\"!vm.isOrderActive()\"\n" +
    "                        translate\n" +
    "                    >\n" +
    "                        {{::'BUTTON.CREATE_ORDER'}}\n" +
    "                    </button>\n" +
    "                    <button \n" +
    "                        class=\"btn btn-success btn-sm\" \n" +
    "                        title=\"{{'TOOLTIP.ADDTOCART' | translate}}\" \n" +
    "                        ng-disabled=\"!vm.isOrderActive() || !group.valid\" \n" +
    "                        ng-click=\"vm.consumeOrders(group)\"\n" +
    "                        translate\n" +
    "                    >\n" +
    "                        {{::'BUTTON.ADDTOCART'}}\n" +
    "                    </button>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "        <div \n" +
    "            ng-show=\"vm.groups.length === 0\" \n" +
    "            class=\"alert alert-info text-center\"\n" +
    "        >\n" +
    "            <h4>{{'INCOMINGORDERS.NOITEMS' | translate}}</h4>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("stadium/incomingOrders/incomingOrdersDialog/incomingOrdersDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/incomingOrders/incomingOrdersDialog/incomingOrdersDialog.tpl.html",
    "<div class=\"incoming-order-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\" ng-disabled=\"vm.processing\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'INCOMINGORDERS.TITLE' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <table class=\"table table-summary\">\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'INCOMINGORDERS.CLUB' | translate}}:\n" +
    "                        </th>\n" +
    "                        <td>\n" +
    "                            {{vm.group.club}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'INCOMINGORDERS.CUSTOMERREFERENCE' | translate}}:\n" +
    "                        </th>\n" +
    "                        <td>\n" +
    "                            {{vm.group.reference}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'INCOMINGORDERS.SALESPERSON' | translate}}:\n" +
    "                        </th>\n" +
    "                        <td>\n" +
    "                            {{vm.group.user}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'INCOMINGORDERS.WEBID' | translate}}:\n" +
    "                        </th>\n" +
    "                        <td>\n" +
    "                            {{vm.group.weborder}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <table class=\"table\">\n" +
    "                    <thead>\n" +
    "                        <tr>\n" +
    "                            <th>\n" +
    "                                {{'INCOMINGORDERS.RECEIVED' | translate}}\n" +
    "                            </th>\n" +
    "                            <th>\n" +
    "                                {{'INCOMINGORDERS.GARMENT' | translate}}\n" +
    "                            </th>\n" +
    "                            <th>\n" +
    "                                {{'INCOMINGORDERS.COLOUR' | translate}}\n" +
    "                            </th>\n" +
    "                            <th>\n" +
    "                                {{'INCOMINGORDERS.ROWS' | translate}}\n" +
    "                            </th>\n" +
    "                            <th>\n" +
    "                                {{'INCOMINGORDERS.TEMPLATE' | translate}}\n" +
    "                            </th>\n" +
    "                            <th>\n" +
    "                                &nbsp;\n" +
    "                            </th>\n" +
    "                        </tr>\n" +
    "                    </thead>\n" +
    "                    <tbody>\n" +
    "                        <tr ng-repeat=\"order in vm.orders\">\n" +
    "                            <td>\n" +
    "                                {{order.received | date : 'yy-MM-dd HH:mm'}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{order.garment}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{order.colour}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{order.orderRows.length}}\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                <a \n" +
    "                                    href=\"\" \n" +
    "                                    ng-click=\"vm.openTemplate(order.template)\" \n" +
    "                                    class=\"template-label\" \n" +
    "                                    ng-if=\"order.valid && !order.productTemplate\" \n" +
    "                                    title=\"{{order.templateName}}\"\n" +
    "                                >\n" +
    "                                    {{order.templateName | limitTo: 20}}{{order.templateName.length > 20 ? '...' : ''}}\n" +
    "                                    <i \n" +
    "                                        class=\"fa fa-exclamation-triangle\" \n" +
    "                                        title=\"{{'TOOLTIP.NOTHANDLEDLEGACYTEMPLATE' | translate}}\" \n" +
    "                                        ng-if=\"order.legacyTemplateNotHandled\"\n" +
    "                                    >\n" +
    "                                    </i>\n" +
    "                                </a>\n" +
    "                                <div\n" +
    "                                    ng-if=\"order.productTemplate\"    \n" +
    "                                >\n" +
    "                                    {{order.templateName | limitTo: 20}}{{order.templateName.length > 20 ? '...' : ''}}\n" +
    "                                </div>\n" +
    "\n" +
    "                            </td>\n" +
    "                            <td class=\"pull-right\">\n" +
    "                                <div class=\"btn-group template-buttons dropdown\" ng-if=\"!playerGroup.locked\">\n" +
    "                                    <button \n" +
    "                                        type=\"button\" \n" +
    "                                        class=\"btn btn-sm btn-warning\"\n" +
    "                                        ng-click=\"vm.onClickEditStandardTemplate(order)\"\n" +
    "                                        ng-if=\"!order.quickTemplate && order.template && !order.productTemplate\"\n" +
    "                                        title=\"{{'STADIUM.EXCEL.IMPORT.TABLE.EDITTEMPLATE' | translate}}\"\n" +
    "                                    >\n" +
    "                                        <span class=\"fa fa-pencil\"></span>\n" +
    "                                    </button>\n" +
    "                                    <button \n" +
    "                                        type=\"button\" \n" +
    "                                        class=\"btn btn-sm btn-success\"\n" +
    "                                        ng-if=\"!order.quickTemplate && !order.template\"\n" +
    "                                        ng-click=\"vm.onClickSetTemplate(order)\"\n" +
    "                                        translate\n" +
    "                                    >\n" +
    "                                        {{'STADIUM.EXCEL.IMPORT.TABLE.TEMPLATE'}}\n" +
    "                                    </button>\n" +
    "                                    <button \n" +
    "                                        type=\"button\" \n" +
    "                                        class=\"btn btn-sm btn-warning\"\n" +
    "                                        ng-if=\"order.quickTemplate && order.template && !order.productTemplate\"\n" +
    "                                        ng-click=\"vm.onClickEditQuickTemplate(order)\"\n" +
    "                                        translate\n" +
    "                                    >\n" +
    "                                        {{'STADIUM.EXCEL.IMPORT.TABLE.EDITTEMPLATE'}}\n" +
    "                                    </button>\n" +
    "                                    <button \n" +
    "                                        type=\"button\" \n" +
    "                                        class=\"btn btn-sm btn-warning\"\n" +
    "                                        ng-if=\"!order.quickTemplate && order.template\"\n" +
    "                                        ng-click=\"vm.onClickRemoveTemplate(order)\"\n" +
    "                                        translate\n" +
    "                                    >\n" +
    "                                        {{'STADIUM.EXCEL.IMPORT.TABLE.REMOVETEMPLATE'}}\n" +
    "                                    </button>\n" +
    "                                    <button \n" +
    "                                        type=\"button\" \n" +
    "                                        class=\"btn btn-sm btn-success dropdown-toggle\" \n" +
    "                                        ng-class=\"!order.template ? 'btn-success' : 'btn-warning'\"\n" +
    "                                        ng-if=\"order.quickTemplate && order.template || !order.quickTemplate && !order.template\" \n" +
    "                                    >\n" +
    "                                        <span class=\"caret\"></span>\n" +
    "                                    </button>\n" +
    "                                    <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                                        <li ng-if=\"!order.template && !order.quickTemplate\">\n" +
    "                                            <a \n" +
    "                                                type=\"button\" \n" +
    "                                                href=\"\" \n" +
    "                                                ng-click=\"vm.onClickCreateQuickTemplate(order)\" \n" +
    "                                                translate\n" +
    "                                            >\n" +
    "                                                {{::'STADIUM.EXCEL.IMPORT.TABLE.QUICKTEMPLATE'}}\n" +
    "                                            </a>\n" +
    "                                        </li>\n" +
    "                                        <li ng-if=\"!order.template && !order.quickTemplate && vm.validStadiumCustomer()\">\n" +
    "                                            <a \n" +
    "                                                type=\"button\" \n" +
    "                                                href=\"\" \n" +
    "                                                ng-click=\"vm.onClickSetProductTemplate(order)\"\n" +
    "                                                translate\n" +
    "                                            >\n" +
    "                                                {{::'BUTTON.STADIUM.PRODUCT_TEMPLATE'}}\n" +
    "                                            </a>\n" +
    "                                        </li>\n" +
    "                                        <li ng-if=\"order.template && order.quickTemplate\">\n" +
    "                                            <a \n" +
    "                                                type=\"button\" \n" +
    "                                                href=\"\" \n" +
    "                                                ng-click=\"vm.onClickRemoveTemplate(order)\" \n" +
    "                                                translate\n" +
    "                                            >\n" +
    "                                                {{::'STADIUM.EXCEL.IMPORT.TABLE.REMOVETEMPLATE'}}\n" +
    "                                            </a>\n" +
    "                                        </li>\n" +
    "                                    </ul>\n" +
    "                                </div>\n" +
    "                                <button \n" +
    "                                    class=\"btn btn-success btn-sm\" \n" +
    "                                    ng-click=\"vm.consumeOrder(order)\" \n" +
    "                                    title=\"{{'TOOLTIP.ADDTOCART' | translate}}\" \n" +
    "                                    ng-disabled=\"!vm.isCartActive() || !order.valid\"\n" +
    "                                    translate\n" +
    "                                >\n" +
    "                                    {{::'BUTTON.ADDTOCART'}}\n" +
    "                                </button>\n" +
    "                                <button \n" +
    "                                    class=\"btn btn-danger btn-sm\" \n" +
    "                                    ng-click=\"vm.deleteOrder(order)\" \n" +
    "                                    title=\"{{'TOOLTIP.CLEAR' | translate}}\"\n" +
    "                                >\n" +
    "                                    <i class=\"fa fa-remove\" aria-hidden=\"true\"></i>\n" +
    "                                </button>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button \n" +
    "            type=\"button\" \n" +
    "            ng-click=\"vm.close()\" \n" +
    "            class=\"btn btn-default\"\n" +
    "            ng-disabled=\"vm.processing\"\n" +
    "            translate\n" +
    "        >\n" +
    "            {{::'BUTTON.CLOSE'}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("stadium/logo/stadiumLogo.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/logo/stadiumLogo.tpl.html",
    "<div class=\"article-create\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-offset-3 col-xs-6\">\n" +
    "            <h2>\n" +
    "                {{vm.isEditMode() ? 'CREATEARTICLE.TITLE.STADIUM.EDIT' : 'CREATEARTICLE.TITLE.STADIUM' | translate}}\n" +
    "            </h2>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12 col-md-12\">\n" +
    "            <div class=\"col-md-3 col-sm-2\">\n" +
    "                <div class=\"logo-container row\" ng-if=\"vm.productType && vm.productType.allowLogoUpload\">\n" +
    "                    <div class=\"logo-title col-xs-12\">\n" +
    "                        <p translate>{{'LOGO.IMAGE.PREVIEW.TITLE'}}</p>\n" +
    "                    </div>\n" +
    "                    <div class=\"logo-image col-xs-12\" ng-if=\"vm.logoImage\">\n" +
    "                        <img ng-src=\"{{vm.getLogoImageUrl()}}\">\n" +
    "                    </div>\n" +
    "                    <div class=\"logo-controls col-xs-12\">\n" +
    "                        <div class=\"btn-group\" role=\"group\">\n" +
    "                            <button \n" +
    "                                class=\"btn btn-default\" \n" +
    "                                type=\"button\" \n" +
    "                                ng-click=\"vm.selectLogoImage()\"    \n" +
    "                                ng-disabled=\"!vm.showLogoImage() && !vm.isAttachmentAvailable('logoImage')\" \n" +
    "                                translate\n" +
    "                            >\n" +
    "                                {{!vm.logoImage ? 'BUTTON.SELECT' : 'BUTTON.REPLACE'}}\n" +
    "                            </button>\n" +
    "                            <button \n" +
    "                                class=\"btn btn-warning\" \n" +
    "                                type=\"button\" \n" +
    "                                ng-click=\"vm.editLogoImage()\"\n" +
    "                                ng-if=\"vm.logoImage\" \n" +
    "                                translate\n" +
    "                            >\n" +
    "                                {{'BUTTON.EDIT'}}\n" +
    "                            </button>\n" +
    "                            <button \n" +
    "                                class=\"btn btn-danger\" \n" +
    "                                type=\"button\" \n" +
    "                                ng-click=\"vm.clearAttachments()\"\n" +
    "                                ng-if=\"vm.logoImage\"\n" +
    "                            >\n" +
    "                                <i class=\"fa fa-trash\"></i>\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6 col-sm-8\">\n" +
    "                <form name=\"vm.form\" ng-submit=\"vm.save()\" novalidate>\n" +
    "                    <div class=\"alert alert-warning\"\n" +
    "                        ng-if=\"vm.form.$invalid && vm.form.$submitted || vm.validationErrors.length > 0\">\n" +
    "                        <div ng-messages=\"vm.form.$error\" class=\"error-messages\">\n" +
    "                            <div ng-messages=\"vm.form.name.$error\">\n" +
    "                                <div ng-message=\"required\">\n" +
    "                                    {{'CREATEARTICLE.NAMEREQUIRED' | translate}}\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div ng-messages=\"vm.form.width.$error\">\n" +
    "                                <div ng-message=\"required\">\n" +
    "                                    {{'CREATEARTICLE.WIDTHREQUIRED' | translate}}\n" +
    "                                </div>\n" +
    "                                <div ng-message=\"min\">\n" +
    "                                    {{'CREATEARTICLE.VALIDATION.MIN.WIDTH' | translate}}\n" +
    "                                </div>\n" +
    "                                <div ng-message=\"number\">\n" +
    "                                    {{'CREATEARTICLE.WIDTHINVALID' | translate}}\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div ng-messages=\"vm.form.height.$error\">\n" +
    "                                <div ng-message=\"required\">\n" +
    "                                    {{'CREATEARTICLE.HEIGHTREQUIRED' | translate}}\n" +
    "                                </div>\n" +
    "                                <div ng-message=\"min\">\n" +
    "                                    {{'CREATEARTICLE.VALIDATION.MIN.HEIGHT' | translate}}\n" +
    "                                </div>\n" +
    "                                <div ng-message=\"number\">\n" +
    "                                    {{'CREATEARTICLE.HEIGHTINVALID' | translate}}\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div ng-messages=\"vm.form.stitches.$error\">\n" +
    "                                <div ng-message=\"required\">\n" +
    "                                    {{'CREATEARTICLE.STITCHESREQUIRED' | translate}}\n" +
    "                                </div>\n" +
    "                                <div ng-message=\"integer\">\n" +
    "                                    {{'CREATEARTICLE.STITCHESINVALID' | translate}}\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div ng-repeat=\"error in vm.validationErrors\">\n" +
    "                            {{error.message | translate}}\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"table-responsive\">\n" +
    "                        <table class=\"table\">\n" +
    "                            <tbody>\n" +
    "                            <tr ng-if=\"vm.productTypes && vm.productTypes.length > 1\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'CREATEARTICLE.TYPE' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <ui-select on-select=\"vm.onProductTypeSelect($item)\" ng-model=\"vm.productType\"\n" +
    "                                            append-to-body=\"true\">\n" +
    "                                        <ui-select-match placeholder=\"{{'CREATEARTICLE.SELECTTYPE' | translate}}\">\n" +
    "                                            {{'PRODUCT.TYPE.' + $select.selected.name | translate}}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices\n" +
    "                                                repeat=\"productType in vm.productTypes | translationFilter: $select.search : 'PRODUCT.TYPE.' : 'name'\">\n" +
    "                                                <span>\n" +
    "                                                    {{'PRODUCT.TYPE.' + productType.name | translate}}\n" +
    "                                                </span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.productType.productSubtypes.length > 1\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'CREATEARTICLE.SUBTYPE' | translate}}</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <span ng-if=\"vm.isLeatheretteBrand()\">*{{'ARTICLE.LEATHERETTE_TEXT' | translate}}</span>\n" +
    "                                    <ui-select ng-model=\"vm.productSubtype\"\n" +
    "                                            tabindex=\"2\"\n" +
    "                                            append-to-body=\"true\">\n" +
    "                                        <ui-select-match placeholder=\"{{'CREATEARTICLE.SELECTSUBTYPE' | translate}}\">\n" +
    "                                            {{'PRODUCT.SUBTYPE.' + $select.selected.name | translate}}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices\n" +
    "                                                repeat=\"subtype in vm.productType.productSubtypes | translationFilter: $select.search : 'PRODUCT.SUBTYPE.' : 'name'\">\n" +
    "                                            <span>{{'PRODUCT.SUBTYPE.' + subtype.name | translate}}</span>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'ARTICLE.NAME' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.name\"\n" +
    "                                        required focus>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'LABEL.WIDTH' | translate}} (mm):</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input class=\"form-control\"\n" +
    "                                        type=\"number\"\n" +
    "                                        name=\"width\"\n" +
    "                                        ng-model=\"vm.width\"\n" +
    "                                        min=\"1\"\n" +
    "                                        required\n" +
    "                                        focus\n" +
    "                                    />\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'LABEL.HEIGHT' | translate}} (mm):</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input class=\"form-control\"\n" +
    "                                        type=\"number\"\n" +
    "                                        name=\"height\"\n" +
    "                                        ng-model=\"vm.height\"\n" +
    "                                        min=\"1\"\n" +
    "                                        required\n" +
    "                                        focus\n" +
    "                                    />\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.maxColourCount() > 0\">\n" +
    "                                <td class=\"dynamic-width top-align\">\n" +
    "                                    <label class=\"form-label\">{{'LABEL.COLORS' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <div class=\"process-container\" ng-if=\"vm.showProcess()\">\n" +
    "                                        <input \n" +
    "                                            type=\"checkbox\" \n" +
    "                                            id=\"process\" \n" +
    "                                            ng-model=\"vm.process\"\n" +
    "                                            ng-disabled=\"vm.logoImage !== null\"\n" +
    "                                            ng-click=\"vm.clearSelectedColours()\"\n" +
    "                                        />\n" +
    "                                        <label for=\"process\">{{'LABEL.PROCESS' | translate}}</label>\n" +
    "                                    </div>\n" +
    "                                    <div class=\"color-picker\" ng-if=\"!vm.process\"\n" +
    "                                        ng-class=\"{'full': vm.maxColourCount() === vm.selectedColours.length, 'input-group': vm.productType.colourType !== 'NONE'}\">\n" +
    "                                        <ui-select multiple limit=\"{{vm.maxColourCount()}}\" ng-model=\"vm.selectedColours\"\n" +
    "                                                tagging=\"vm.addColour\"\n" +
    "                                                tagging-label=\"false\" tagging-tokens=\"ENTER|TAB\"\n" +
    "                                                append-to-body=\"true\">\n" +
    "                                            <ui-select-match\n" +
    "                                                    placeholder=\"{{'LABEL.ENTERCOLOR' | translate | stringular : (vm.maxColourCount() - vm.selectedColours.length) + '' }}\">\n" +
    "                                                <div ng-if=\"!$item.imageName\" class=\"color-box\"\n" +
    "                                                    ng-style=\"{'background-color': '#' + $item.code}\">\n" +
    "                                                    <span ng-if=\"!$item.code\">PMS</span>\n" +
    "                                                </div>\n" +
    "                                                <div ng-if=\"$item.imageName\" class=\"color-box\" ng-style=\"{'background-image':'url(./assets/images/colours/{{$item.imageName}})'}\"></div>\n" +
    "                                                <span class=\"item-name\">{{$item.name}}</span>\n" +
    "                                                <span class=\"sort\" ng-if=\"vm.selectedColours.length > 1\">\n" +
    "                                                            <button type=\"button\" ng-if=\"!vm.isFirst($item)\"\n" +
    "                                                                    ng-click=\"vm.moveColour($item, -1)\">\n" +
    "                                                                <i class=\"fa fa-chevron-circle-up\"></i>\n" +
    "                                                            </button>\n" +
    "                                                            <button type=\"button\" ng-if=\"!vm.isLast($item)\"\n" +
    "                                                                    ng-click=\"vm.moveColour($item, 1)\">\n" +
    "                                                                <i class=\"fa fa-chevron-circle-down\"></i>\n" +
    "                                                            </button>\n" +
    "                                                        </span>\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices repeat=\"colour in vm.colours | filter:{name:$select.search}\"\n" +
    "                                                            ng-model=\"vm.colours\">\n" +
    "                                                    <div ng-if=\"colour.code\" class=\"color-box\"\n" +
    "                                                            ng-style=\"{'background-color': '#' + colour.code}\"></div>\n" +
    "                                                        <div ng-if=\"colour.imageName\" class=\"color-box\" ng-style=\"{'background-image':'url(./assets/images/colours/{{colour.imageName}})'}\"></div>\n" +
    "                                                        <span class=\"item-name\">{{colour.name}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                        <div class=\"input-group-btn top-align\" ng-if=\"vm.productType.colourType !== 'NONE'\">\n" +
    "                                            <button type=\"button\" ng-click=\"vm.openColourPicker()\"\n" +
    "                                                    ng-disabled=\"!vm.showColourPicker()\"\n" +
    "                                                    class=\"btn btn-default\"\n" +
    "                                                    title=\"{{'TOOLTIP.COLOURPICKER' | translate}}\">\n" +
    "                                                <i class=\"fa fa-th\"></i>\n" +
    "                                            </button>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.productType.allowTags\">\n" +
    "                                <td class=\"dynamic-width top-align\">\n" +
    "                                    <label class=\"form-label\">{{'LABEL.TAGS' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width tags\">\n" +
    "                                    <ui-select reset-search-input=\"true\" multiple search-enabled=\"false\" tagging=\"vm.newTag\"\n" +
    "                                            tagging-label=\"false\" tagging-tokens=\"ENTER|TAB\" ng-model=\"vm.tags\" title=\"\"\n" +
    "                                            theme=\"bootstrap\" append-to-body=\"true\">\n" +
    "                                        <ui-select-match placeholder=\"\">{{$item}}</ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td class=\"dynamic-width top-align\">\n" +
    "                                    <label class=\"form-label\">{{'LABEL.INFORMATION' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                        <textarea class=\"form-control\" ng-model=\"vm.information\">\n" +
    "                                        </textarea>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.showBacksidePicker()\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'CREATEARTICLE.BACKSIDES' | translate}}</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <div ng-class=\"{'backside-picker': !vm.isTemplateMode() }\">\n" +
    "                                        <ui-select ng-model=\"vm.selectedBackside\"\n" +
    "                                                append-to-body=\"true\">\n" +
    "                                            <ui-select-match\n" +
    "                                                    placeholder=\"{{'CREATEARTICLE.BACKSIDES.PLACEHOLDER' | translate}}\">\n" +
    "                                                {{$select.selected.name}}\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices\n" +
    "                                                    repeat=\"backside in vm.availableBacksides(vm.backsides) | filter: $select.search\">\n" +
    "                                                    <span>{{'ARTICLE.BACKSIDE.' + backside.id | translate}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                    </div>\n" +
    "                                    <div class=\"input-group-btn top-align\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                                        <button class=\"btn btn-success\"\n" +
    "                                                type=\"button\"\n" +
    "                                                ng-click=\"vm.addBackside()\"\n" +
    "                                                ng-disabled=\"!vm.selectedBackside\">\n" +
    "                                            {{'BUTTON.ADD' | translate}}\n" +
    "                                        </button>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-repeat=\"backside in vm.selectedBacksides\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                                <td class=\"full-width\" colspan=\"2\">\n" +
    "                                    <div class=\"backside-row col-xs-12\">\n" +
    "                                        <div class=\"backside-name-col col-xs-12\">\n" +
    "                                            {{backside.name}}\n" +
    "                                        </div>\n" +
    "                                        <div class=\"backside-counter-col\">\n" +
    "                                            <div counter=\"\" class=\"btn-group-vertical\" value=\"backside.quantity\"\n" +
    "                                                min=\"backside.minimumQuantity\"></div>\n" +
    "                                        </div>\n" +
    "                                        <div class=\"backside-action-col\">\n" +
    "                                            <button class=\"btn btn-default\"\n" +
    "                                                    type=\"button\"\n" +
    "                                                    ng-click=\"vm.removeBackside(backside)\">\n" +
    "                                                <i class=\"fa fa-trash\"></i>\n" +
    "                                            </button>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.productType.allowOnlyRegistration && !vm.isTemplateMode() && !vm.isEditMode()\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'STADIUMPRODUCT.REGISTER' | translate }}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input type=\"checkbox\"\n" +
    "                                        ng-model=\"vm.register\"\n" +
    "                                        ng-disabled=\"!vm.isOrderActive()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.productType.allowSharingProduct && !vm.isTemplateMode()\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'STADIUMPRODUCT.SHAREPRODUCT' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input type=\"checkbox\" name=\"share\" id=\"share\" ng-model=\"vm.share\" focus>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.productType.allowInventory && !vm.isTemplateMode()\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'STADIUMPRODUCT.STOREINVENTORY' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input type=\"checkbox\" name=\"inventory\" id=\"inventory\" ng-model=\"vm.inventory\"\n" +
    "                                        ng-change=\"vm.onSelectInventory()\" focus>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && !vm.inventory && !vm.isTemplateMode() && !vm.register\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'LABEL.QUANTITY' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <counter\n" +
    "                                        class=\"btn-group-vertical\"\n" +
    "                                        value=\"vm.quantity\"\n" +
    "                                        min=\"vm.minQuantity\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.inventory\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'STADIUMPRODUCT.MINIMUMSTOCK' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <counter\n" +
    "                                        class=\"btn-group-vertical\"\n" +
    "                                        value=\"vm.minimumStock\"\n" +
    "                                        min=\"0\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.inventory\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'STADIUMPRODUCT.REFILLQUANTITY' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <counter\n" +
    "                                        class=\"btn-group-vertical\"\n" +
    "                                        value=\"vm.refillQuantity\"\n" +
    "                                        min=\"vm.minRefillQuantity\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.productType && vm.inventory && !vm.register\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'STADIUM.LOGO.MANUFACTURING_QUANTITY' | translate}}:</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <counter\n" +
    "                                        class=\"btn-group-vertical\"\n" +
    "                                        value=\"vm.manufacturingQuantity\"\n" +
    "                                        min=\"vm.minManufacturingQuantity\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"!vm.errand\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    <label class=\"form-label\">{{'LABEL.FILE' | translate}}</label>\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width errand\">\n" +
    "                                    <span class=\"stadium-proof\">\n" +
    "                                        {{'STADIUM.LOGO.UPLOAD_PROOF1' | translate}}\n" +
    "                                        <b>{{'STADIUM.LOGO.UPLOAD_PROOF2' | translate}}</b>\n" +
    "                                        {{'STADIUM.LOGO.UPLOAD_PROOF3' | translate}}\n" +
    "                                    </span>\n" +
    "                                    <div class=\"input-group file-control\">\n" +
    "                                        <input \n" +
    "                                            class=\"form-control\" \n" +
    "                                            ng-class=\"{ pointer: vm.files.length > 0 && !vm.files[0].size }\"\n" +
    "                                            ng-value=\"vm.files[0].name | translate\" \n" +
    "                                            ng-click=\"vm.getFile()\"\n" +
    "                                            ng-disabled=\"true\"\n" +
    "                                            title=\"{{vm.files[0].name | translate}}\" \n" +
    "                                            type=\"text\"\n" +
    "                                            ng-readonly=\"vm.files.length > 0\"\n" +
    "                                        />\n" +
    "                                        <span class=\"input-group-btn\">\n" +
    "                                            <button \n" +
    "                                                class=\"btn btn-default\" \n" +
    "                                                ng-click=\"$event.preventDefault()\" \n" +
    "                                                ng-file-select=\"\"    \n" +
    "                                                ng-accept=\"vm.onFileSelect($file)\" \n" +
    "                                                ng-multiple=\"false\"\n" +
    "                                            >\n" +
    "                                                {{vm.files.length > 0 ? 'BUTTON.REPLACEFILE' : 'BUTTON.SELECTFILE' | translate}}\n" +
    "                                            </button>\n" +
    "                                            <button\n" +
    "                                                class=\"btn btn-default\"\n" +
    "                                                type=\"button\"\n" +
    "                                                ng-click=\"vm.clearAttachments()\"\n" +
    "                                            >\n" +
    "                                                <span>\n" +
    "                                                    <i class=\"fa fa-trash\"></i>\n" +
    "                                                </span>\n" +
    "                                            </button>\n" +
    "                                        </span>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td colspan=\"2\">\n" +
    "                                    <div class=\"pull-right\" ng-if=\"!vm.isEditMode()\">\n" +
    "                                        <button class=\"btn btn-success\" type=\"submit\">\n" +
    "                                            {{vm.isTemplateMode() ?\n" +
    "                                            'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATE' :\n" +
    "                                            'BUTTON.SAVE' | translate}}\n" +
    "                                        </button>\n" +
    "                                        <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.saveAndAddNew()\">\n" +
    "                                            {{vm.isTemplateMode() ?\n" +
    "                                            'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATECREATENEW' :\n" +
    "                                            'BUTTON.SAVEANDADDNEW' | translate}}\n" +
    "                                        </button>\n" +
    "                                    </div>\n" +
    "                                    <div class=\"pull-right\" ng-if=\"vm.isEditMode()\">\n" +
    "                                        <button class=\"btn btn-success\" type=\"submit\">\n" +
    "                                            {{'BUTTON.UPDATE' | translate}}\n" +
    "                                        </button>\n" +
    "                                    </div>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            </tbody>\n" +
    "                        </table>\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("stadium/shortages/shortages.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/shortages/shortages.tpl.html",
    "<div class=\"articles-list\">\n" +
    "    <div breadcrumbs links=\"vm.links\"></div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h2>\n" +
    "                {{'STADIUM.SHORTAGES.TITLE' | translate}}\n" +
    "            </h2>\n" +
    "            <div class=\"search-box stadium-search\">\n" +
    "                <div class=\"input-group\" ng-if=\"vm.user.stadiumMaster\">\n" +
    "                        <input type=\"radio\" id=\"stadiumSharedLogos\" value=\"shared\" name=\"radioStadiumSearch\" ng-model=\"vm.stadiumSearch\">\n" +
    "                        <label for=\"stadiumSharedLogos\" class=\"checkboxLabel\">\n" +
    "                            {{'ARTICLELIST.SEARCH.STADIUMLOGOS' | translate}}\n" +
    "                        </label>\n" +
    "                        <input type=\"radio\" id=\"stadiumAllLogos\" value=\"all\" name=\"radioStadiumSearch\" ng-model=\"vm.stadiumSearch\">\n" +
    "                        <label for=\"stadiumAllLogos\" class=\"checkboxLabel\">\n" +
    "                            {{'ARTICLELIST.SEARCH.ALLSTORES' | translate}}\n" +
    "                        </label>\n" +
    "                        <input type=\"radio\" id=\"stadiumOwnLogos\" value=\"own\" name=\"radioStadiumSearch\" ng-model=\"vm.stadiumSearch\">\n" +
    "                        <label for=\"stadiumOwnLogos\" class=\"checkboxLabel\">\n" +
    "                            {{'ARTICLELIST.SEARCH.OWNSTORE' | translate}}\n" +
    "                        </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table ng-table=\"vm.tableParams\" class=\"table table-shortages\" ng-show=\"vm.tableParams.total() > 0\">\n" +
    "                    <tbody>\n" +
    "                        <tr ng-repeat=\"shortage in $data\">\n" +
    "                            <td data-title=\"'SHORTAGE.ID' | translate\" sortable=\"'articleId'\">\n" +
    "                                <a href=\"\" ng-click=\"vm.selectArticle(shortage.articleId)\">\n" +
    "                                    {{::shortage.articleId}}\n" +
    "                                </a>\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.NAME' | translate\" sortable=\"'articleName'\">\n" +
    "                                <span ng-attr-title=\"{{::shortage.articleName}}\">\n" +
    "                                    {{::shortage.articleName | limitTo: 15}}{{::shortage.articleName.length > 15 ? '&hellip;' : ''}}\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.COLOR' | translate\" sortable=\"'colour'\">\n" +
    "                                <span ng-attr-title=\"{{::shortage.colour}}\">\n" +
    "                                    {{::shortage.colour | limitTo: 15}}{{::shortage.colour.length > 15 ? '&hellip;' : ''}}\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.SIZE' | translate\" sortable=\"'size'\">\n" +
    "                                <span ng-attr-title=\"{{::shortage.size}}\">\n" +
    "                                    {{::shortage.size | limitTo: 15}}{{::shortage.size.length > 15 ? '&hellip;' : ''}}\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.OWNER' | translate\" sortable=\"'owner'\" class=\"text-right\">\n" +
    "                                {{::shortage.owner}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.STOCK' | translate\" sortable=\"'stock'\" class=\"text-right\">\n" +
    "                                {{::shortage.stock}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.ORDERIN' | translate\" sortable=\"'orderIn'\" class=\"text-right\">\n" +
    "                                {{::shortage.orderIn}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.ORDEROUT' | translate\" sortable=\"'orderOut'\" class=\"text-right\">\n" +
    "                                {{::shortage.orderOut}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.MINIMUMSTOCK' | translate\" sortable=\"'minimumStock'\" class=\"text-right\">\n" +
    "                                {{::shortage.minimumStock}}\n" +
    "                            </td>\n" +
    "                            <td data-title=\"'SHORTAGE.REFILLVOLUME' | translate\" sortable=\"'refillVolume'\" class=\"text-right\">\n" +
    "                                {{::shortage.refillVolume}}\n" +
    "                            </td>\n" +
    "                            <td class=\"text-right col-md-1\">\n" +
    "                                <button class=\"btn btn-default btn-sm\" ng-click=\"vm.openManufacturingDialog(shortage);$event.stopPropagation();\" title=\"{{'STADIUM.ADDITIONALMANUFACTURING' | translate}}\">\n" +
    "                                    <i class=\"fa fa-industry\" aria-hidden=\"true\">\n" +
    "                                    </i>\n" +
    "                                </button>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "                <div ng-show=\"vm.tableParams.total() === 0 && vm.initialized\" class=\"alert alert-info text-center\"><h4>{{'ARTICLELIST.NOITEMS' | translate}}</h4></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("stadium/stadiumProduct/stadiumProduct.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/stadiumProduct/stadiumProduct.tpl.html",
    "<div class=\"stadium-products\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div breadcrumbs links=\"vm.links\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12 col-md-5\">\n" +
    "            <div class=\"panel\">\n" +
    "                <div class=\"panel-heading\">\n" +
    "                    <button\n" +
    "                        class=\"btn btn-danger delete-product-button\"\n" +
    "                        title=\"{{'STADIUM.PRODUCT_DELETE' | translate}}\"\n" +
    "                        ng-click=\"vm.deleteProduct()\"\n" +
    "                    >\n" +
    "                        <i class=\"fa fa-trash\"></i>\n" +
    "                    </button>\n" +
    "                    <div>\n" +
    "                        {{'LABEL.INFORMATION' | translate}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\">\n" +
    "                    <div class=\"col-xs-12 stadium-product-image-container\" ng-if=\"vm.product.image\">\n" +
    "                        <img class=\"img-responsive\" ng-src=\"{{vm.getImageUrl(vm.product.image)}}\"/>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-xs-12\">\n" +
    "                            <table class=\"information-table\">\n" +
    "                                <tbody>\n" +
    "                                <tr>\n" +
    "                                    <td class=\"col-xs-4\">\n" +
    "                                        {{'STADIUM.PRODUCT_ARTICLE_ID' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td class=\"col-xs-8\">\n" +
    "                                        {{vm.product.articleId}}\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td>\n" +
    "                                        {{'STADIUM.PRODUCT_ARTICLE_NAME' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td>\n" +
    "                                        {{vm.product.articleName}}\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td>\n" +
    "                                        {{'STADIUM.PRODUCT_VARIANT_NAME' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td>\n" +
    "                                        {{vm.product.variantName}}\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td>\n" +
    "                                        {{'STADIUM.PRODUCT_EXTERNAL_CLUB_ID' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td>\n" +
    "                                        {{vm.product.externalClubId}}\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td>\n" +
    "                                        {{'STADIUM.PRODUCT_CLUB_NAME' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td>\n" +
    "                                        {{vm.product.clubName}}\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td>\n" +
    "                                        {{'STADIUM.PRODUCT_SPONSORING' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td>\n" +
    "                                        <input type=\"checkbox\" ng-model=\"vm.product.sponsoring\" ng-click=\"vm.updateProduct()\">\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td>\n" +
    "                                        {{'STADIUM.PRODUCT_CHANNELS' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td>\n" +
    "                                        <ul class=\"channels-list\">\n" +
    "                                            <li class=\"col-xs-12\" ng-repeat=\"channel in vm.product.channels\">\n" +
    "                                                {{channel}}\n" +
    "                                            </li>\n" +
    "                                        </ul>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr>\n" +
    "                                    <td>\n" +
    "                                        {{'STADIUM.PRODUCT_CHANNELS_ONLY_B2B' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td>\n" +
    "                                        {{vm.isB2bOnly() | translate}}\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                <tr class=\"main-template-row\">\n" +
    "                                    <td>\n" +
    "                                        {{'STADIUM.PRODUCT_MAIN_TEMPLATE' | translate}}\n" +
    "                                    </td>\n" +
    "                                    <td>\n" +
    "                                        <span class=\"template-status\" title=\"{{vm.getMainTemplateStatus()}}\">\n" +
    "                                            <span>\n" +
    "                                                <i ng-class=\"vm.getMainTemplateClass()\" class=\"fa\"></i>\n" +
    "                                            </span>\n" +
    "                                        </span>\n" +
    "                                        <span class=\"pull-right\">\n" +
    "                                            <button class=\"btn btn-xs btn-default\"\n" +
    "                                                    title=\"{{'TOOLTIP.ADD' | translate}}\"\n" +
    "                                                    ng-if=\"!vm.product.mainTemplate\"\n" +
    "                                                    ng-click=\"vm.createMainTemplate()\">\n" +
    "                                                <i class=\"fa fa-plus\"></i>\n" +
    "                                            </button>\n" +
    "                                            <button class=\"btn btn-sm btn-default\"\n" +
    "                                                    ng-click=\"vm.openTemplateAuditLogsDialog()\"\n" +
    "                                                    title=\"{{'TOOLTIP.VIEW.LOGS' | translate}}\">\n" +
    "                                                    <i aria-hidden=\"true\" class=\"fa fa-list\"></i>\n" +
    "                                            </button>\n" +
    "                                            <button class=\"btn btn-xs btn-default\"\n" +
    "                                                    title=\"{{'TOOLTIP.EDIT' | translate}}\"\n" +
    "                                                    ng-if=\"vm.product.mainTemplate\"\n" +
    "                                                    ng-click=\"vm.editMainTemplate()\">\n" +
    "                                                <i class=\"fa fa-pencil\"></i>\n" +
    "                                            </button>\n" +
    "                                            <button class=\"btn btn-xs btn-default\"\n" +
    "                                                    title=\"{{'BUTTON.SUBMIT' | translate}}\"\n" +
    "                                                    ng-if=\"vm.product.mainTemplate && vm.product.mainTemplate.status !== 'READY'\"\n" +
    "                                                    ng-click=\"vm.submitTemplate(vm.product.mainTemplate.templateId)\">\n" +
    "                                                <i class=\"fa fa-share\"></i>\n" +
    "                                            </button>\n" +
    "                                            <button class=\"btn btn-xs btn-default\"\n" +
    "                                                    title=\"{{'BUTTON.UNDO' | translate}}\"\n" +
    "                                                    ng-if=\"vm.product.mainTemplate && vm.product.mainTemplate.status === 'READY'\"\n" +
    "                                                    ng-click=\"vm.revertTemplateStatus(vm.product.mainTemplate.templateId)\">\n" +
    "                                                <i class=\"fa fa-undo\"></i>\n" +
    "                                            </button>\n" +
    "                                            <button class=\"btn btn-xs btn-default\"\n" +
    "                                                    title=\"{{'TOOLTIP.DELETE' | translate}}\"\n" +
    "                                                    ng-if=\"vm.product.mainTemplate\"\n" +
    "                                                    ng-click=\"vm.deleteMainTemplate()\">\n" +
    "                                                <i class=\"fa fa-trash\"></i>\n" +
    "                                            </button>\n" +
    "                                        </span>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                                </tbody>\n" +
    "                            </table>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-12 col-md-7\">\n" +
    "            <div class=\"panel\">\n" +
    "                <div class=\"panel-heading\">{{'LABEL.TEMPLATES' | translate}}</div>\n" +
    "                <div class=\"panel-body\">\n" +
    "                    <table class=\"stadium-product-table\">\n" +
    "                    <thead>\n" +
    "                        <tr>\n" +
    "                            <th>\n" +
    "                                {{'LABEL.TEAM'| translate}}\n" +
    "                            </th>\n" +
    "                            <th>\n" +
    "                                {{'LABEL.STATUS' | translate}}\n" +
    "                            </th>\n" +
    "                            <th></th>\n" +
    "                        </tr>\n" +
    "                    </thead>\n" +
    "                    <tbody>\n" +
    "                        <tr ng-repeat=\"template in vm.product.teamTemplates\">\n" +
    "                            <td>\n" +
    "                                <div>{{template.team | limitTo: 50}}</div>\n" +
    "                                <div>\n" +
    "                                    <small class=\"team-template-id\">{{template.templateId}}</small>\n" +
    "                                </div>\n" +
    "                            </td>\n" +
    "                            <td class=\"template-status\" title=\"{{vm.getTemplateStatus(template)}}\">\n" +
    "                                <span>\n" +
    "                                    <i ng-class=\"vm.getTemplateClass(template)\" class=\"fa\"></i>\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                <span class=\"pull-right\">\n" +
    "                                    <button class=\"btn btn-xs btn-default\"\n" +
    "                                            title=\"{{'TOOLTIP.EDIT' | translate}}\"\n" +
    "                                            ng-click=\"vm.editTeamTemplate(template.templateId)\">\n" +
    "                                        <i class=\"fa fa-pencil\"></i>\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-xs btn-default\"\n" +
    "                                            title=\"{{'BUTTON.SUBMIT' | translate}}\"\n" +
    "                                            ng-if=\"template.status !== 'READY' && !vm.product.sponsoring\"\n" +
    "                                            ng-click=\"vm.submitTemplate(template.templateId)\">\n" +
    "                                        <i class=\"fa fa-share\"></i>\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-xs btn-default\"\n" +
    "                                            title=\"{{'BUTTON.UNDO' | translate}}\"\n" +
    "                                            ng-if=\"template.status === 'READY'\"\n" +
    "                                            ng-click=\"vm.revertTemplateStatus(template.templateId)\">\n" +
    "                                                <i class=\"fa fa-undo\"></i>\n" +
    "                                            </button>\n" +
    "                                    <button\n" +
    "                                        class=\"btn btn-xs btn-default\"\n" +
    "                                        title=\"{{'TOOLTIP.DELETE' | translate}}\"\n" +
    "                                        ng-click=\"vm.deleteTeamTemplate(template.templateId)\">\n" +
    "                                        <i class=\"fa fa-trash\"></i>\n" +
    "                                    </button>\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "                <div class=\"panel-footer\">\n" +
    "                    <div class=\"input-group\">\n" +
    "                        <input\n" +
    "                            class=\"form-control add-team-input\"\n" +
    "                            type=\"text\"\n" +
    "                            ng-model=\"vm.teamTemplateName\"\n" +
    "                            ng-disabled=\"!vm.product.mainTemplate\"\n" +
    "                            maxlength=\"50\"\n" +
    "                            placeholder=\"{{'LABEL.TEAM' | translate}}\">\n" +
    "\n" +
    "                        <span class=\"input-group-btn add-team-btn\">\n" +
    "                            <button\n" +
    "                                class=\"btn btn-success\"\n" +
    "                                type=\"button\"\n" +
    "                                tooltip=\"{{'TOOLTIP.ADD' | translate\"\n" +
    "                                ng-disabled=\"!vm.product.mainTemplate || !vm.teamTemplateName\"\n" +
    "                                ng-click=\"vm.createTeamTemplate(vm.teamTemplateName)\">\n" +
    "                                    <i class=\"fa fa-plus\"></i>\n" +
    "                            </button>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("stadium/stadiumProduct/stadiumProducts.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/stadiumProduct/stadiumProducts.tpl.html",
    "<div class=\"stadium-products\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div breadcrumbs links=\"vm.links\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-4\">\n" +
    "            <ui-select multiple ng-model=\"vm.selectedClubs\" append-to-body=\"true\" ng-change=\"vm.clubChanged()\">\n" +
    "                <ui-select-match placeholder=\"{{'STADIUM.PRODUCT_CLUB' | translate}}\">\n" +
    "                   {{$item | limitTo: 45}}{{$item.length > 45 ? '...' :''}}\n" +
    "                </ui-select-match>\n" +
    "                <ui-select-choices repeat=\"club in vm.clubs | filter:$select.search | limitTo: 100\">\n" +
    "                    <span>{{::club | limitTo: 45}}{{club.length > 45 ? '...' :''}}</span>\n" +
    "                </ui-select-choices>\n" +
    "            </ui-select>\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-12 col-md-4\">\n" +
    "            <input class=\"form-control input-with-icon\"\n" +
    "                    ng-keyup=\"$event.keyCode == 13 && vm.search($event)\"\n" +
    "                    placeholder=\"&#xF002; {{'LOGO.DIALOG.UPLOAD.SELECT.SEARCH' | translate}}\"\n" +
    "                    ng-value=\"vm.searchText\"\n" +
    "                    type=\"text\">\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-12 col-md-4\">\n" +
    "            <div class=\"col-xs-9\">\n" +
    "                <div class=\"valign\">\n" +
    "                {{'STADIUM.PRODUCTS.PRODUCTS_PER_PAGE' | translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        <div class=\"col-xs-3\">\n" +
    "            <ui-select ng-model=\"vm.pageSize\" on-select=\"vm.pageSizeChanged($select.selected)\" search-enabled=\"false\">\n" +
    "                <ui-select-match>\n" +
    "                    {{$select.selected}}\n" +
    "                </ui-select-match>\n" +
    "                <ui-select-choices class=\"dropdown\"\n" +
    "                    repeat=\"pageSize in vm.pageSizeSelect\">\n" +
    "                    <span>{{pageSize}}</span>\n" +
    "                </ui-select-choices>\n" +
    "            </ui-select>\n" +
    "        </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"vm.isAnyFilterActive()\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <pagination\n" +
    "                    class=\"pagination\"\n" +
    "                    total-items=\"vm.totalItems\"\n" +
    "                    items-per-page=\"vm.pageSize\"\n" +
    "                    ng-model=\"vm.page\"\n" +
    "                    ng-if=\"vm.totalItems\"\n" +
    "                    ng-change=\"vm.pageChanged()\">\n" +
    "            </pagination>\n" +
    "            <p>{{ 'STADIUM.PRODUCTS.NUMBER_OF_PRODUCTS_DISPLAYED' | translate:{ number: vm.totalItems } }}</p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-2\" ng-repeat=\"product in vm.products\">\n" +
    "            <div class=\"panel panel-default\">\n" +
    "                <div class=\"panel-heading\" title=\"{{product.articleId}}\">\n" +
    "                    {{product.articleId}}\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\">\n" +
    "                    <div class=\"stadium-product-thumbnail-container\" ng-if=\"product.image\">\n" +
    "                        <img class=\"img-responsive\" ng-src=\"{{vm.getImageUrl(product.image)}}\"/>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-xs-12\">\n" +
    "                            <div class=\"product-title\" title=\"{{product.articleName}} - {{product.variantName}}\">\n" +
    "                                {{product.articleName}}\n" +
    "                            </div>\n" +
    "                            <div class=\"product-club\" title=\"{{product.clubName}}\">\n" +
    "                                {{product.clubName}}\n" +
    "                            </div>\n" +
    "                            <div class=\"text-center template-status\" title=\"{{vm.getTemplateStatus(product)}}\">\n" +
    "                                <i class=\"fa\" ng-class=\"vm.getTemplateStatusClass(product)\"></i>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-xs-12\">\n" +
    "                            <a  ui-sref=\"app.shop.stadiumproduct({id: product.id})\"\n" +
    "                                class=\"btn btn-sm btn-default product-details-button\">\n" +
    "                                {{'LABEL.DETAILS' | translate}}\n" +
    "                            </a>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"!vm.isAnyFilterActive()\">\n" +
    "        <div class=\"col-xs-12 stadium-products-placeholder-text\">\n" +
    "            {{'STADIUM.PRODUCTS.NO_FILTER_PLACEHOLDER' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"vm.isAnyFilterActive()\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <pagination\n" +
    "                    class=\"pagination\"\n" +
    "                    total-items=\"vm.totalItems\"\n" +
    "                    items-per-page=\"vm.pageSize\"\n" +
    "                    ng-model=\"vm.page\"\n" +
    "                    ng-if=\"vm.totalItems\"\n" +
    "                    ng-change=\"vm.pageChanged()\">\n" +
    "            </pagination>\n" +
    "            <p>{{ 'STADIUM.PRODUCTS.NUMBER_OF_PRODUCTS_DISPLAYED' | translate:{ number: vm.totalItems } }}</p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("stadium/start/start.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/start/start.tpl.html",
    "<div class=\"stadium-start\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <div class=\"col-md-8 start-left\">\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"!vm.isReferenceProjectUnique()\">\n" +
    "                {{'STADIUM.SAVEDCARTSCOMBINATIONNOTUNIQUE' | translate}}\n" +
    "            </div>\n" +
    "            <table class=\"table\">\n" +
    "                <tbody>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{'STADIUM.ACTIVATENEWCART' | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <input type=\"text\" name=\"reference\" class=\"form-control input-small\" ng-model=\"vm.reference\"\n" +
    "                               placeholder=\"{{'STADIUMUSER.ORDERREF' | translate}}\">\n" +
    "                        <input type=\"text\" name=\"project\" class=\"form-control input-small\" ng-model=\"vm.project\"\n" +
    "                               placeholder=\"{{'STADIUMUSER.ORDERPROJECT' | translate}}\">\n" +
    "                        <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.onClickNewOrder()\"\n" +
    "                                ng-disabled=\"!vm.reference || !vm.project || !vm.isReferenceProjectUnique()\">\n" +
    "                            {{'BUTTON.CREATE' | translate}}\n" +
    "                        </button>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{'STADIUM.ACTIVATE_SAVED_ORDER' | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <ui-select ng-model=\"vm.savedCart\" append-to-body=\"true\">\n" +
    "                            <ui-select-match placeholder=\"{{'STADIUM.SELECTCART' | translate}}\">\n" +
    "                                <span>{{$select.selected.orderReference}} - {{$select.selected.orderProject}}</span>\n" +
    "                            </ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"savedCart in vm.getSavedCarts() | filter:$select.search:strict\">\n" +
    "                                <span>{{savedCart.orderReference}} - {{savedCart.orderProject}}</span>\n" +
    "                                <button class=\"btn-delete pull-right\" ng-click=\"vm.removeSavedCart(savedCart)\">\n" +
    "                                    <i class=\"fa fa-remove\"></i>\n" +
    "                                </button>\n" +
    "                            </ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                        <button class=\"btn btn-success\" type=\"button\" ng-disabled=\"!vm.savedCart\" ng-click=\"vm.onClickActivateSavedCart()\">\n" +
    "                            {{'BUTTON.ACTIVATE' | translate}}\n" +
    "                        </button>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{'STADIUM.SEARCHORDERHISTORY' | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <ui-select ng-model=\"vm.order\" append-to-body=\"true\">\n" +
    "                            <ui-select-match placeholder=\"{{'STADIUM.SELECTCART' | translate}}\">\n" +
    "                                {{$select.selected.description}}\n" +
    "                            </ui-select-match>\n" +
    "                            <ui-select-choices\n" +
    "                                    repeat=\"order in vm.orders | filter:{articles:$select.search} | limitTo: 50 track by order.id\">\n" +
    "                                    <span>\n" +
    "                                        {{order.description}}\n" +
    "                                    </span>\n" +
    "                            </ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                        <button type=\"button\" class=\"btn btn-success\" ng-disabled=\"!vm.order\"\n" +
    "                                ng-click=\"vm.onClickViewOrder()\">\n" +
    "                            {{'BUTTON.SHOW' | translate}}\n" +
    "                        </button>\n" +
    "                    </td>\n" +
    "\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\" translate>\n" +
    "                        {{'STADIUM.TEMPLATE.MANAGE'}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.onClickCreateTemplate()\" translate>\n" +
    "                            {{'BUTTON.CREATE'}}\n" +
    "                        </button>\n" +
    "                        <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.onClickEditTemplate()\" translate>\n" +
    "                            {{'BUTTON.EDIT'}}\n" +
    "                        </button>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "\n" +
    "            <div class=\"row\" ng-if=\"vm.user.orderReference && vm.user.orderProject\">\n" +
    "                <div class=\"col-xs-12\">\n" +
    "                    <div class=\"panel panel-default import-panel\">\n" +
    "                        <div class=\"panel-heading\">\n" +
    "                            <p class=\"panel-title\" translate>\n" +
    "                                {{'STADIUM.EXCEL.IMPORT.TITLE'}}\n" +
    "                            </p>\n" +
    "                        </div>\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"col-xs-12\">\n" +
    "                                <div class=\"alert alert-warning\" ng-if=\"vm.importErrors.length\">\n" +
    "                                    <ul>\n" +
    "                                        <li ng-repeat=\"error in vm.importErrors\">\n" +
    "                                            {{ 'ERROR.' + error.code | translate: error.data}}\n" +
    "                                        </li>\n" +
    "                                    </ul>\n" +
    "                                </div>\n" +
    "                                <div class=\"alert alert-warning\" ng-if=\"vm.importError && !vm.importErrors.length\" translate>\n" +
    "                                    {{'STADIUM.EXCEL.IMPORT.ERROR'}}\n" +
    "                                </div>\n" +
    "                                <p translate>\n" +
    "                                    {{'STADIUM.EXCEL.IMPORT.DESCRIPTION'}}\n" +
    "                                </p>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-xs-12\">\n" +
    "                                <div class=\"form-group\">\n" +
    "                                    <textarea class=\"form-control import-textarea\" rows=\"5\" ng-model=\"vm.excelImport\"\n" +
    "                                              title=\"\"></textarea>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-xs-12\">\n" +
    "                                <a type=\"button\" class=\"btn btn-success btn-icon btn-sm\"\n" +
    "                                   href=\"/assets/stadium/stadium.xls?cache=20220919\"\n" +
    "                                   tooltip=\"{{'STADIUM.EXCEL.IMPORT.TOOLTIP.DOWNLOAD' | translate}}\">\n" +
    "                                    <span><i class=\"fa fa-lg\" aria-hidden=\"true\">&#xf1c3;</i></span>\n" +
    "                                </a>\n" +
    "                                <button class=\"btn btn-success btn-sm pull-right\" ng-click=\"vm.importExcel()\" translate>\n" +
    "                                    {{'BUTTON.IMPORT'}}\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-4\">\n" +
    "            <div class=\"panel panel-default\">\n" +
    "                <div class=\"panel-heading\">\n" +
    "                    {{'STADIUM.LEGEND' | translate}}\n" +
    "                </div>\n" +
    "                <div class=\"panel-body start-symbols\">\n" +
    "                    <dl>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-comment-o\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'STADIUM.CHANGELANGUAGE' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-tasks\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'STADIUM.YOURLISTS' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-comments\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'STADIUM.ADDCOMMENTS' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-pencil\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'TOOLTIP.EDIT' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-exclamation-triangle\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'STADIUM.SHORTAGEWARNING' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-picture-o\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'STADIUM.UPLOADIMAGE' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-th-list\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'DIGIT.NAMELIST' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-clone\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'STADIUM.UPLOADLOGO' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-industry\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'STADIUM.STARTMANUFACTURING' | translate}}\n" +
    "                        </dd>\n" +
    "                        <dt>\n" +
    "                            <i class=\"fa fa-list\"></i>\n" +
    "                        </dt>\n" +
    "                        <dd>\n" +
    "                            {{'TEMPLATE.LOGS' | translate}}\n" +
    "                        </dd>\n" +
    "                    </dl>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-12\" ng-if=\"vm.showOrderTable()\">\n" +
    "        <table class=\"table table-striped\">\n" +
    "            <thead>\n" +
    "            <tr>\n" +
    "                <th translate>{{'STADIUM.EXCEL.IMPORT.TABLE.GARMENT'}}</th>\n" +
    "                <th translate>{{'STADIUM.EXCEL.IMPORT.TABLE.COLOUR'}}</th>\n" +
    "                <th translate>{{'STADIUM.EXCEL.IMPORT.TABLE.QUANTITY.PLAYERS'}}</th>\n" +
    "                <th translate>{{'STADIUM.EXCEL.IMPORT.TABLE.QUANTITY'}}</th>\n" +
    "                <th translate>{{'STADIUM.EXCEL.IMPORT.TABLE.TEMPLATE'}}</th>\n" +
    "                <th translate>{{'STADIUM.EXCEL.IMPORT.TABLE.STATE'}}</th>\n" +
    "                <th></th>\n" +
    "            </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "            <tr ng-repeat=\"playerGroup in vm.playerGroups\">\n" +
    "                <td>{{playerGroup.garment}}</td>\n" +
    "                <td>{{playerGroup.colour}}</td>\n" +
    "                <td>{{playerGroup.playerQuantity}}</td>\n" +
    "                <td>{{playerGroup.garmentQuantity}}</td>\n" +
    "                <td title=\"{{playerGroup.templateName}}\">\n" +
    "                    {{playerGroup.templateName | limitTo: 25}}{{playerGroup.templateName.length > 25 ? '...' : ''}}\n" +
    "                    <i class=\"fa fa-exclamation-triangle\" title=\"{{'TOOLTIP.NOTHANDLEDLEGACYTEMPLATE' | translate}}\"\n" +
    "                       ng-if=\"playerGroup.legacyTemplateNotHandled\"></i>\n" +
    "                </td>\n" +
    "                <td translate>\n" +
    "                    <div class=\"text-danger\" ng-if=\"!vm.isPlayerGroupReady(playerGroup) && !playerGroup.locked\" translate>\n" +
    "                        {{'STADIUM.EXCEL.IMPORT.TABLE.STATE.NOTREADY'}}\n" +
    "                    </div>\n" +
    "                    <div class=\"text-success\" ng-if=\"vm.isPlayerGroupReady(playerGroup)\" translate>\n" +
    "                        {{'STADIUM.EXCEL.IMPORT.TABLE.STATE.READY'}}\n" +
    "                    </div>\n" +
    "                    <div class=\"text-info\" ng-if=\"playerGroup.locked\" translate>\n" +
    "                        {{'STADIUM.EXCEL.IMPORT.TABLE.STATE.LOCKED'}}\n" +
    "                    </div>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <div class=\"pull-right\">\n" +
    "                        <div class=\"btn-group template-buttons dropdown\" ng-if=\"!playerGroup.locked\">\n" +
    "                            <button \n" +
    "                                type=\"button\" \n" +
    "                                class=\"btn btn-sm btn-warning\"\n" +
    "                                ng-if=\"playerGroup.templateId && !playerGroup.quickTemplate\"\n" +
    "                                ng-click=\"vm.onClickEditStandardTemplate(playerGroup)\"\n" +
    "                                tooltip=\"{{'STADIUM.EXCEL.IMPORT.TABLE.EDITTEMPLATE' | translate}}\"\n" +
    "                            >\n" +
    "                                <span class=\"fa fa-pencil\"></span>\n" +
    "                            </button>\n" +
    "                            <button \n" +
    "                                type=\"button\" \n" +
    "                                class=\"btn btn-sm btn-success\"\n" +
    "                                ng-if=\"!playerGroup.templateId && !playerGroup.quickTemplate\"\n" +
    "                                ng-click=\"vm.onClickSetTemplate(playerGroup)\" \n" +
    "                                translate\n" +
    "                            >\n" +
    "                                {{'STADIUM.EXCEL.IMPORT.TABLE.TEMPLATE'}}\n" +
    "                            </button>\n" +
    "                            <button \n" +
    "                                type=\"button\" \n" +
    "                                class=\"btn btn-sm btn-warning\" \n" +
    "                                ng-if=\"playerGroup.quickTemplate\"\n" +
    "                                ng-click=\"vm.onClickEditQuickTemplate(playerGroup.templateId)\" \n" +
    "                                translate\n" +
    "                            >\n" +
    "                                {{'STADIUM.EXCEL.IMPORT.TABLE.EDITTEMPLATE'}}\n" +
    "                            </button>\n" +
    "                            <button \n" +
    "                                type=\"button\" \n" +
    "                                class=\"btn btn-sm btn-warning\"\n" +
    "                                ng-if=\"playerGroup.templateId && !playerGroup.quickTemplate\"\n" +
    "                                ng-click=\"vm.onClickRemoveQuickTemplate(playerGroup)\" \n" +
    "                                translate\n" +
    "                            >\n" +
    "                                {{'STADIUM.EXCEL.IMPORT.TABLE.REMOVETEMPLATE'}}\n" +
    "                            </button>\n" +
    "                            <button \n" +
    "                                type=\"button\" \n" +
    "                                class=\"btn btn-sm btn-success dropdown-toggle\"\n" +
    "                                ng-class=\"!playerGroup.templateId ? 'btn-success' : 'btn-warning'\"\n" +
    "                                ng-if=\"playerGroup.templateId && playerGroup.quickTemplate || !playerGroup.templateId && !playerGroup.quickTemplate\"\n" +
    "                            >\n" +
    "                                <span class=\"caret\"></span>\n" +
    "                            </button>\n" +
    "                            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                                <li ng-if=\"!playerGroup.templateId && !playerGroup.quickTemplate\">\n" +
    "                                    <a \n" +
    "                                        type=\"button\" \n" +
    "                                        href=\"\" \n" +
    "                                        ng-click=\"vm.onClickCreateQuickTemplate(playerGroup)\"\n" +
    "                                        translate\n" +
    "                                    >\n" +
    "                                        {{::'STADIUM.EXCEL.IMPORT.TABLE.QUICKTEMPLATE'}}\n" +
    "                                    </a>\n" +
    "                                </li>\n" +
    "                                <li ng-if=\"playerGroup.templateId && playerGroup.quickTemplate\">\n" +
    "                                    <a \n" +
    "                                        type=\"button\" \n" +
    "                                        href=\"\" \n" +
    "                                        ng-click=\"vm.onClickRemoveQuickTemplate(playerGroup)\"\n" +
    "                                        translate\n" +
    "                                    >\n" +
    "                                        {{::'STADIUM.EXCEL.IMPORT.TABLE.REMOVETEMPLATE'}}\n" +
    "                                    </a>\n" +
    "                                </li>\n" +
    "                            </ul>\n" +
    "                        </div>\n" +
    "                        <button class=\"btn btn-sm btn-default\" ng-click=\"vm.openPlayerDialog(playerGroup.playerListId)\"\n" +
    "                                ng-if=\"!playerGroup.locked\" tooltip=\"{{'TOOLTIP.PLAYERS' | translate}}\">\n" +
    "                            <i class=\"fa fa-th-list\" aria-hidden=\"true\"></i>\n" +
    "                        </button>\n" +
    "                        <button class=\"btn btn-sm btn-danger\" ng-click=\"vm.onClickRemovePlayerGroup(playerGroup)\"\n" +
    "                                ng-if=\"!playerGroup.locked\"\n" +
    "                                tooltip=\"{{'STADIUM.EXCEL.IMPORT.TOOLTIP.REMOVE' | translate}}\">\n" +
    "                            <span><i class=\"fa fa-trash\"></i></span>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-12 order-row\" ng-if=\"vm.showOrderTable()\">\n" +
    "        <button class=\"btn btn-sm btn-success\" ng-click=\"vm.orderExcelImport()\" ng-disabled=\"!vm.isOrderAvailable()\">\n" +
    "            {{'BUTTON.ADDTOCART' | translate}}\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"vm.addPlayerGroup()\">\n" +
    "            {{'STADIUM.EXCEL.IMPORT.ADD.ROW' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("stadium/templateManagement/templateManagement.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/templateManagement/templateManagement.tpl.html",
    "<div class=\"template-management row\">\n" +
    "    <div class=\"col-sm-4\">\n" +
    "        <div class=\"list-group-item list-group-item-info\">\n" +
    "            <span translate>{{'STADIUM.CLUB.CLUBS'}}</span>\n" +
    "            <span class=\"pull-right\">\n" +
    "                    <a href=\"\" ng-click=\"vm.addNew('club')\">\n" +
    "                        <i class=\"fa fa-plus fa-lg\" title=\"{{'TOOLTIP.ADD' | translate}}\"></i>\n" +
    "                    </a>\n" +
    "            </span>\n" +
    "        </div>\n" +
    "        <div class=\"list-group scrollable\">\n" +
    "            <ul>\n" +
    "                <li ng-repeat=\"club in vm.clubs | orderBy: 'clubName'\" id=\"{{club.clubId}}\" class=\"list-group-item col-sm-12\"\n" +
    "                    ng-class=\"{'active': vm.selectedClub.clubId === club.clubId}\"  ng-click=\"vm.onSelectClub(club)\">\n" +
    "                    <span ng-bind=\"club.clubName\" class=\"col-sm-10 no-horizontal-padding word-break\"\n" +
    "                          ng-class=\"{'col-sm-10': vm.selectedClub.clubId === club.clubId, 'col-sm-12' : vm.selectedClub.clubId !== club.clubId }\"></span>\n" +
    "                    <span class=\"col-sm-2 no-horizontal-padding\" ng-if=\"vm.selectedClub === club\">\n" +
    "                        <span class=\"pull-right\">\n" +
    "                            <button type=\"button\" class=\"btn btn-sm transparent\" ng-click=\"vm.rename('club')\" >\n" +
    "                                <i class=\"fa fa-pencil\" title=\"{{'TOOLTIP.RENAME' | translate}}\"></i>\n" +
    "                            </button>\n" +
    "                            <button type=\"button\" class=\"btn btn-sm transparent\" ng-click=\"vm.archiveClub()\">\n" +
    "                                <i class=\"fa fa-trash\" title=\"{{'TOOLTIP.DELETE' | translate}}\"></i>\n" +
    "                            </button>\n" +
    "                        </span>\n" +
    "                        \n" +
    "                    </span>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-sm-4\">\n" +
    "        <div class=\"list-group-item list-group-item-info\">\n" +
    "            <span translate>{{'STADIUM.CATEGORY.CATEGORIES'}}</span>\n" +
    "            <span class=\"pull-right\" ng-if=\"vm.selectedClub\">\n" +
    "                <a href=\"\" ng-click=\"vm.addNew('category')\">\n" +
    "                    <i class=\"fa fa-plus fa-lg\" title=\"{{'TOOLTIP.ADD' | translate}}\"></i>\n" +
    "                </a>\n" +
    "            </span>\n" +
    "        </div>        \n" +
    "        <div class=\"list-group scrollable\">\n" +
    "            <ul>\n" +
    "                <li ng-repeat=\"category in vm.categories | orderBy: 'categoryName'\" id=\"{{category.categoryId}}\" class=\"list-group-item col-sm-12\"\n" +
    "                    ng-class=\"{'active': vm.selectedCategory.categoryId === category.categoryId}\" ng-click=\"vm.onSelectCategory(category)\">\n" +
    "                    <span ng-bind=\"category.categoryName\" class=\"no-horizontal-padding word-break\"\n" +
    "                          ng-class=\"{'col-sm-10': vm.selectedCategory.categoryId === category.categoryId, 'col-sm-12' : vm.selectedCategory.categoryId !== category.categoryId }\"></span>\n" +
    "                    <span class=\"col-sm-2 no-horizontal-padding\" ng-if=\"vm.selectedCategory === category\">\n" +
    "                        <span class=\"pull-right\">\n" +
    "                                <button type=\"button\" class=\"btn btn-sm transparent\" ng-click=\"vm.rename('category')\" >\n" +
    "                                    <i class=\"fa fa-pencil\" title=\"{{'TOOLTIP.RENAME' | translate}}\"></i>\n" +
    "                                </button>\n" +
    "                                <button type=\"button\" class=\"btn btn-sm transparent\" ng-click=\"vm.archiveCategory()\">\n" +
    "                                    <i class=\"fa fa-trash\" title=\"{{'TOOLTIP.DELETE' | translate}}\"></i>\n" +
    "                                </button>\n" +
    "                        </span>\n" +
    "                    </span>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-sm-4\">\n" +
    "        <div class=\"list-group-item list-group-item-info\">\n" +
    "            <span translate>{{'STADIUM.TEMPLATE.TEMPLATES'}}</span>\n" +
    "            <span class=\"pull-right\" ng-if=\"vm.selectedCategory\">\n" +
    "                <a href=\"\" ng-click=\"vm.addNewTemplate()\">\n" +
    "                    <i class=\"fa fa-plus fa-lg\" title=\"{{'TOOLTIP.ADD' | translate}}\"></i>\n" +
    "                </a>\n" +
    "            </span>\n" +
    "        </div>\n" +
    "        <div class=\"list-group scrollable\" ng-if=\"vm.selectedClub && vm.selectedCategory\">\n" +
    "            <ul>\n" +
    "                <li ng-repeat=\"template in vm.templates | filter: {category:vm.selectedCategory.categoryId} | orderBy: 'templateName'\" \n" +
    "                    id=\"{{template.placementId}}\" class=\"list-group-item col-sm-12\"\n" +
    "                    ng-class=\"{'active': vm.selectedTemplate.placementId === template.placementId, 'active-template' : vm.isActiveTemplate(template.placementId)}\"\n" +
    "                    ng-click=\"vm.setSelectedTemplate(template)\">\n" +
    "                    <span ng-if=\"template.stadiumLegacyNotHandled\" class=\"no-horizontal-padding\"><i class=\"fa fa-exclamation-triangle\" title=\"{{'TOOLTIP.NOTHANDLEDLEGACYTEMPLATE' | translate}}\"></i></span>\n" +
    "                    <span ng-bind=\"template.templateName\"\n" +
    "                          class=\"no-horizontal-padding word-break\"\n" +
    "                          ng-class=\"{\n" +
    "                          'col-sm-8': vm.selectedTemplate.placementId === template.placementId && template.stadiumLegacyNotHandled,\n" +
    "                          'col-sm-11': vm.selectedTemplate.placementId !== template.placementId && template.stadiumLegacyNotHandled,\n" +
    "                          'col-sm-9': vm.selectedTemplate.placementId === template.placementId && !template.stadiumLegacyNotHandled,\n" +
    "                          'col-sm-12': vm.selectedTemplate.placementId !== template.placementId && !template.stadiumLegacyNotHandled\n" +
    "                           }\"></span>\n" +
    "                    <span class=\"col-sm-3 no-horizontal-padding\" ng-if=\"vm.selectedTemplate === template\">\n" +
    "                        <span class=\"pull-right\">\n" +
    "                            <button type=\"button\" class=\"btn btn-sm transparent\" ng-click=\"vm.rename('template')\">\n" +
    "                                <i class=\"fa fa-pencil\" title=\"{{'TOOLTIP.RENAME' | translate}}\"></i>\n" +
    "                            </button>\n" +
    "                            <button type=\"button\" class=\"btn btn-sm transparent\" ng-click=\"vm.archiveTemplate()\" ng-if=\"!vm.isActiveTemplate(template.placementId)\">\n" +
    "                                <i class=\"fa fa-trash\" title=\"{{'TOOLTIP.DELETE' | translate}}\"></i>\n" +
    "                            </button>\n" +
    "                            <button type=\"button\" class=\"btn btn-sm transparent\" ng-click=\"vm.openTemplate(template.placementId)\">\n" +
    "                                <i class=\"fa fa-chevron-circle-right\" title=\"{{'TOOLTIP.GOTOTEMPLATE' | translate}}\"></i>\n" +
    "                            </button>\n" +
    "                        </span>\n" +
    "                    </span>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("stadium/templateManagement/templateManagementDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("stadium/templateManagement/templateManagementDialog.tpl.html",
    "<div class=\"club-management\">\n" +
    "    <div modalWindow/>\n" +
    "    <div class=\"modal-header alert alert-danger\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{vm.title}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\" ng-if=\"!vm.isErrorDialog\">\n" +
    "        <div class=\"alert alert-warning\" ng-if=\"vm.hasError\">\n" +
    "            {{vm.error}}\n" +
    "        </div>\n" +
    "        <div class=\"row margin-bottom\">\n" +
    "            <div class=\"col-sm-2 col-sm-offset-1 vertical-center no-horizontal-padding\" translate>\n" +
    "                {{'STADIUM.NAME'}}\n" +
    "            </div>\n" +
    "            <div class=\"col-sm-7\">\n" +
    "                <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.name\" ng-change=\"vm.isUniqueName()\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\" ng-if=\"vm.isErrorDialog\">\n" +
    "        <p>\n" +
    "            <span class=\"confirmation-message\">\n" +
    "                {{vm.error}}\n" +
    "            </span>\n" +
    "        </p>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.close()\" ng-if=\"!vm.isErrorDialog\" translate>\n" +
    "            {{'BUTTON.CANCEL'}}\n" +
    "        </button>\n" +
    "        <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"!vm.isErrorDialog && !vm.isRenameDialog\" ng-disabled=\"!vm.name\" translate>\n" +
    "            {{'BUTTON.SAVE'}}\n" +
    "        </button>\n" +
    "        <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.rename()\" ng-if=\"vm.isRenameDialog\" ng-disabled=\"!vm.name\" translate>\n" +
    "            {{'BUTTON.RENAME'}}\n" +
    "        </button>\n" +
    "        <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.close()\" ng-if=\"vm.isErrorDialog\" translate>\n" +
    "            {{'BUTTON.CLOSE'}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/directives/addToCartButton/addToCartButton.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/addToCartButton/addToCartButton.tpl.html",
    "<div class=\"btn-group \" role=\"group\" aria-label=\"...\">\n" +
    "    <button class=\"btn btn-success {{vm.buttonClass}}\" ng-disabled=\"vm.article.quantity < vm.article.minimumQuantity || vm.disabled\" href=\"\" ladda=\"vm.isLoading\" data-style=\"slide-left\" single-click=\"vm.addToCart(vm.article)\" translate>CART.ADDTOCART</button>\n" +
    "    <button type=\"button\" ng-if=\"vm.isInCart(vm.article.id)\" class=\"btn {{vm.buttonClass}} btn-success disabled\"><i class=\"fa fa-shopping-cart\"></i> {{vm.cartQty(vm.article.id)}}</button>\n" +
    "</div>");
}]);

angular.module("../common/directives/addToTemplateButton/addToTemplateButton.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/addToTemplateButton/addToTemplateButton.tpl.html",
    "<div aria-label=\"...\" class=\"btn-group \" role=\"group\">\n" +
    "    <button\n" +
    "            class=\"btn btn-success {{vm.buttonClass}}\"\n" +
    "            data-style=\"slide-left\"\n" +
    "            href=\"\"\n" +
    "            ladda=\"vm.isLoading\"\n" +
    "            ng-disabled=\"vm.disabled || vm.isOnTemplate\"\n" +
    "            single-click=\"vm.addToTemplate()\"\n" +
    "            translate\n" +
    "    >\n" +
    "        {{'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATE'}}\n" +
    "    </button>\n" +
    "    <button\n" +
    "            class=\"btn {{vm.buttonClass}} btn-success disabled\"\n" +
    "            ng-if=\"vm.isOnTemplate\"\n" +
    "            type=\"button\"\n" +
    "    >\n" +
    "        <i class=\"fa fa-chain\"></i>\n" +
    "    </button>\n" +
    "</div>");
}]);

angular.module("../common/directives/adminInput/adminInput.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/adminInput/adminInput.tpl.html",
    "<div class=\"input-group input-admin counter counter-small\">\n" +
    "    <button ng-if=\"vm.hasAdminValue() || vm.isInvalid()\" ng-click=\"vm.resetAdminValue()\">\n" +
    "        <i class=\"fa fa-remove\"></i>\n" +
    "    </button>\n" +
    "    <input type=\"text\" ng-class=\"{'active': vm.hasAdminValue(), 'invalid': vm.isInvalid()}\" class=\"form-control counter-field\" value=\"{{vm.value}}\" ng-model=\"vm.value\" ng-change=\"vm.changedValue();\" ng-trim=\"false\"/>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/directives/breadcrumbs/breadcrumbs.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/breadcrumbs/breadcrumbs.tpl.html",
    "<div class=\"breadcrumbs\">\n" +
    "    <div class=\"row\">\n" +
    "        <ol class=\"breadcrumb\">\n" +
    "            <li ng-repeat=\"link in links\">\n" +
    "                <a\n" +
    "                        href\n" +
    "                        ng-click=\"goBack(link.state)\"\n" +
    "                        ng-if=\"link.state\"\n" +
    "                        translate\n" +
    "                >\n" +
    "                    {{::link.displayName}}\n" +
    "                </a>\n" +
    "                <span\n" +
    "                        ng-if=\"!link.state\"\n" +
    "                        translate\n" +
    "                >\n" +
    "                    {{::link.displayName}}\n" +
    "                </span>\n" +
    "            </li>\n" +
    "        </ol>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/directives/calculatorPriceTable/calculatorPriceTable.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/calculatorPriceTable/calculatorPriceTable.tpl.html",
    "<div class=\"panel panel-default info-panel\">\n" +
    "    <div class=\"panel-heading\">{{'LABEL.PRICE' | translate}}</div>\n" +
    "    <div class=\"price-table\">\n" +
    "        <table class=\"table borderless\">\n" +
    "            <tr ng-repeat=\"price in vm.priceTable\"\n" +
    "                ng-class=\"{'active': vm.isActiveQty(price.key)}\">\n" +
    "                <td class=\"fill\"></td>\n" +
    "                <td class=\"price-title\">{{price.key}}</td>\n" +
    "                <td class=\"price-separator\">:</td>\n" +
    "                <td class=\"price-number\">{{price.value}}</td>\n" +
    "                <td class=\"fill\"></td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/directives/loadSpinner/loadSpinner.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/loadSpinner/loadSpinner.tpl.html",
    "<div class=\"load-spinner\" ng-class=\"{'loading': isLoading}\">\n" +
    "    <span us-spinner=\"{speed:2,trail:20,corners:1,radius:15, width:5, length: 10,lines:15}\" spinner-key=\"{{spinnerName}}\"></span>\n" +
    "</div>");
}]);

angular.module("../common/directives/namePreview/namePreview.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/namePreview/namePreview.tpl.html",
    "<div class=\"panel panel-default info-panel\">\n" +
    "    <div class=\"panel-heading\">{{'NAME.PREVIEW.TITLE' | translate}}</div>\n" +
    "    <div class=\"name-preview\">\n" +
    "        <table class=\"table borderless\">\n" +
    "            <tr ng-repeat=\"player in vm.getBestPlayersToPreview()\">\n" +
    "                <td ng-if=\"vm.showPlayerItem('NAME', player.name)\n" +
    "                           || vm.showPlayerItem('INITIAL', player.initials)\n" +
    "                           || vm.showPlayerItem('DIGIT', player.number)\n" +
    "                           || vm.showPlayerItem('DIGIT', player.smallNumber)\">\n" +
    "                    <div class=\"preview\" ng-style=\"vm.getPreview()\">\n" +
    "                        <span class=\"player-name\" ng-if=\"vm.showPlayerItem('NAME', player.name)\">\n" +
    "                            {{ player.name }}\n" +
    "                        </span>\n" +
    "                        <div ng-class=\"{ 'second-row': vm.showPlayerItem('NAME', player.name) }\"\n" +
    "                             ng-if=\"vm.showPlayerItem('INITIAL', player.initials) || vm.showPlayerItem('DIGIT', player.number) || vm.showPlayerItem('DIGIT', player.smallNumber)\">\n" +
    "                            <span class=\"player-initials\" ng-if=\"vm.showPlayerItem('INITIAL', player.initials)\">\n" +
    "                                {{ player.initials }}\n" +
    "                            </span>\n" +
    "                            <span class=\"player-number\" ng-if=\"vm.showPlayerItem('DIGIT', player.number)\">\n" +
    "                                {{ player.number }}\n" +
    "                            </span>\n" +
    "                            <span class=\"player-small-number\" ng-if=\"vm.showPlayerItem('DIGIT', player.smallNumber)\">\n" +
    "                                {{ player.smallNumber }}\n" +
    "                            </span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/directives/priceTable/priceTable.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/priceTable/priceTable.tpl.html",
    "<div class=\"panel panel-default info-panel\">\n" +
    "    <div class=\"panel-heading\">{{'LABEL.PRICE' | translate}}</div>\n" +
    "    <div class=\"price-table\">\n" +
    "        <table class=\"table borderless\">\n" +
    "            <tr ng-repeat=\"price in vm.priceTable\"\n" +
    "                ng-class=\"{'active': vm.isActiveQty(price.key)}\">\n" +
    "                <td class=\"fill\"></td>\n" +
    "                <td class=\"price-title\">{{price.key}}</td>\n" +
    "                <td class=\"price-separator\">:</td>\n" +
    "                <td class=\"price-number\">{{price.value}}</td>\n" +
    "                <td class=\"fill\"></td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "        <div class=\"price-update\" ng-if=\"vm.user.admin\">\n" +
    "            <button class=\"btn btn-default\" ng-click=\"vm.onClickUpdate()\">\n" +
    "                {{'STOCK.UPDATE' | translate}}\n" +
    "            </button>\n" +
    "            <label>\n" +
    "                {{'STOCK.UPDATED' | translate}}: {{vm.lastUpdate | date : 'yy-MM-dd HH:mm'}}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/directives/stockTable/stockTable.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/stockTable/stockTable.tpl.html",
    "<div class=\"panel panel-default article-panel stock-panel\">\n" +
    "    <div class=\"panel-heading\">\n" +
    "        {{'STOCK.TITLE' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"stock-table\">\n" +
    "        <p ng-if=\"vm.isEmpty\">\n" +
    "            {{'STOCK.NONE' | translate}}\n" +
    "        </p>\n" +
    "        <table class=\"table borderless\" ng-if=\"!vm.isEmpty\">\n" +
    "            <tbody>\n" +
    "                <tr ng-repeat=\"(key, value) in vm.stock.quantityPerLocation\">\n" +
    "                    <td class=\"fill\"></td>\n" +
    "                    <td class=\"stock-title ng-binding\">{{key}}</td>\n" +
    "                    <td class=\"stock-separator\">:</td>\n" +
    "                    <td class=\"stock-number ng-binding\">{{value}}</td>\n" +
    "                    <td class=\"fill\"></td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "        <div class=\"stock-update\">\n" +
    "            <button class=\"btn btn-default\" ng-click=\"vm.onClickUpdate()\">\n" +
    "                {{'STOCK.UPDATE' | translate}}\n" +
    "            </button>\n" +
    "            <label>\n" +
    "                {{'STOCK.UPDATED' | translate}}: {{vm.stock.lastUpdate | date : 'yy-MM-dd HH:mm'}}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/directives/userBox/userBox.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/directives/userBox/userBox.tpl.html",
    "<div class=\"userbox\">\n" +
    "    <span class=\"admin\" ng-click=\"openCustomerPicker()\" ng-if=\"user.admin && !isStadium()\">\n" +
    "        <span ng-if=\"user.orderRecipient\" class=\"active\">\n" +
    "            {{user.orderRecipient.userName + ', ' + user.orderRecipient.customerName}}\n" +
    "        </span>\n" +
    "        <span ng-if=\"!user.orderRecipient\" class=\"inactive\">\n" +
    "            {{'NAVIGATION.NOCUSTOMERACTIVE' | translate}}\n" +
    "        </span>\n" +
    "    </span>\n" +
    "    <span class=\"admin\" ng-click=\"openSavedCartDialog()\" ng-if=\"isStadium()\">\n" +
    "        <span ng-if=\"isStadiumCartSelected()\" class=\"active\">\n" +
    "            <span class=\"text-bold\">\n" +
    "                {{'STADIUMUSER.ORDERREF' | translate}}:\n" +
    "            </span>\n" +
    "            {{user.orderReference | limitTo: 15}}{{user.orderReference.length > 15 ? '&hellip;' : ''}}\n" +
    "            <span class=\"text-bold\">\n" +
    "                {{'STADIUMUSER.ORDERPROJECT' | translate}}:\n" +
    "            </span>\n" +
    "            {{user.orderProject | limitTo: 15}}{{user.orderProject.length > 15 ? '&hellip;' : ''}}\n" +
    "        </span>\n" +
    "        <span ng-if=\"!isStadiumCartSelected()\" class=\"inactive\">\n" +
    "            {{'STADIUMUSER.NOORDERACTIVE' | translate}}\n" +
    "        </span>\n" +
    "    </span>\n" +
    "    <span\n" +
    "        class=\"admin\"\n" +
    "        tooltip=\"{{'STADIUM.CLOSE_ACTIVE_ORDER' | translate}}\"\n" +
    "        ng-if=\"isStadiumCartSelected()\"\n" +
    "        ng-click=\"closeCart()\">\n" +
    "        <i class=\"fa fa-times\"></i>\n" +
    "    </span>\n" +
    "    <span\n" +
    "        class=\"admin\"\n" +
    "        ng-if=\"hasTemplateActive()\"\n" +
    "        ng-click=\"openTemplate()\"\n" +
    "        title=\"{{user.templateName}}\">\n" +
    "            <span class=\"text-bold\">\n" +
    "                {{user.stadium ? 'STADIUM.USERBOX.TEMPLATE' : 'PLACEMENT.PROOF' | translate}}:\n" +
    "            </span>\n" +
    "            {{user.templateName | limitTo: 10}}{{user.templateName.length > 10 ? '...' : ''}}\n" +
    "    </span>\n" +
    "    <span\n" +
    "        class=\"admin\"\n" +
    "        tooltip=\"{{'STADIUM.TEMPLATE.MODE.CLOSE' | translate}}\"\n" +
    "        ng-click=\"closeTemplate()\"\n" +
    "        ng-if=\"hasTemplateActive()\">\n" +
    "            <i class=\"fa fa-times\"></i>\n" +
    "        </span>\n" +
    "    <span class=\"user\">\n" +
    "        <span class=\"user-name\">\n" +
    "            {{user.userName}}\n" +
    "        </span>\n" +
    "    </span>\n" +
    "    <ul class=\"navigation nav\">\n" +
    "        <li class=\"user-menu user-menu-language\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-comment-o\" title=\"{{ 'TOOLTIP.LANGUAGESELECTION' | translate }}\"></i>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li ng-repeat=\"language in availableLanguages track by language.code\" ng-class=\"{ 'disabled': selectedLanguage.name === language.name }\">\n" +
    "                    <a ng-click=\"selectLanguage(language)\" ng-disabled=\"selectedLanguage.name === language.name\" ng-class=\"{ 'selected-language': selectedLanguage.name === language.name }\" class=\"language\">\n" +
    "                        {{ language.name }} ({{ language.code }})\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"!user.admin\" class=\"user-menu user-menu-customer\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-user\"></i>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/history')\" href=\"\">\n" +
    "                        {{'NAVIGATION.ORDERHISTORY' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"logOut()\" href=\"\">\n" +
    "                        {{'NAVIGATION.SIGNOUT' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"user.admin\" class=\"user-menu user-menu-customer\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-user\" title=\"{{'TOOLTIP.CUSTOMERS' | translate}}\"></i>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"openCustomerPicker()\" href=\"\">\n" +
    "                        {{'NAVIGATION.SELECTCUSTOMER' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li ng-class=\"{disabled: !isCustomerChosen()}\">\n" +
    "                    <a ng-click=\"!isCustomerChosen() || go('/customer')\" href=\"\">\n" +
    "                        {{'NAVIGATION.CUSTOMERDETAILS' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li ng-class=\"{disabled: !isCustomerChosen()}\">\n" +
    "                    <a ng-click=\"!isCustomerChosen() || go('/discounts')\" href=\"\">\n" +
    "                        {{'NAVIGATION.DISCOUNTS' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li ng-class=\"{disabled: !isCustomerChosen()}\">\n" +
    "                    <a ng-click=\"!isCustomerChosen() || go('/history')\" href=\"\">\n" +
    "                        {{'NAVIGATION.ORDERHISTORY' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"user.admin\" class=\"user-menu user-menu-admin\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-file-text-o\" title=\"{{'TOOLTIP.PRODUCTIONPLANNING' | translate}}\">\n" +
    "                </i>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/errands')\" href=\"\">\n" +
    "                        {{'NAVIGATION.ERRANDS' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"user.admin\" class=\"user-menu user-menu-admin\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-tasks\" title=\"{{'TOOLTIP.ADMINMENU' | translate}}\">\n" +
    "                </i>\n" +
    "                <span class=\"user-orders\" ng-if=\"isAdminOrderEnabled() || user.pendingOrderCount !== '0'\">\n" +
    "                    <i class=\"fa fa-exclamation\" aria-hidden=\"true\">\n" +
    "                    </i>\n" +
    "                </span>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/pendingorders')\" href=\"\">\n" +
    "                        {{'NAVIGATION.PENDINGORDERS' | translate}}\n" +
    "                        <span class=\"user-orders\" ng-if=\"user.pendingOrderCount !== '0'\">\n" +
    "                            {{user.pendingOrderCount}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/draftorders')\" href=\"\">\n" +
    "                        {{'NAVIGATION.DRAFTORDERS' | translate}}\n" +
    "                        <span class=\"user-orders\" ng-if=\"isAdminOrderEnabled()\">\n" +
    "                            {{user.adminCarts.length}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/controlpanel')\" href=\"\">\n" +
    "                        {{'NAVIGATION.CONTROLPANEL' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/producttypes')\" href=\"\">\n" +
    "                        {{'NAVIGATION.PRODUCTTYPES' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/templatecopy')\" href=\"\">\n" +
    "                        {{'NAVIGATION.COPYTEMPLATES' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"logOut()\" href=\"\">\n" +
    "                        {{'NAVIGATION.SIGNOUT' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"user.stadium\" class=\"user-menu user-menu-admin\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-tasks\" title=\"{{'TOOLTIP.STADIUMMENU' | translate}}\">\n" +
    "                </i>\n" +
    "                <span class=\"user-orders\" ng-if=\"isIncomingOrderCount() || isShortageCount()\">\n" +
    "                    <i class=\"fa fa-exclamation\" aria-hidden=\"true\">\n" +
    "                    </i>\n" +
    "                </span>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/incomingorders/b2c')\" href=\"\">\n" +
    "                        {{'NAVIGATION.INCOMINGORDERS' | translate}} B2C\n" +
    "                        <span class=\"user-orders\" ng-if=\"isIncomingOrderCountB2C()\">\n" +
    "                            {{user.incomingOrderCountB2C}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                    <a ng-click=\"go('/incomingorders')\" href=\"\">\n" +
    "                        {{'NAVIGATION.INCOMINGORDERS' | translate}} B2B\n" +
    "                        <span class=\"user-orders\" ng-if=\"isIncomingOrderCountB2B()\">\n" +
    "                            {{user.incomingOrderCountB2B}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/shortages')\" href=\"\">\n" +
    "                        {{'NAVIGATION.SHORTAGES' | translate}}\n" +
    "                        <span class=\"user-orders\" ng-if=\"isShortageCount()\">\n" +
    "                            {{user.shortageCount}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/templateManagement')\" href=\"\" translate>\n" +
    "                        {{'STADIUM.TEMPLATE.MANAGEMENT'}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/backsidePickerDialog/backsidePickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/backsidePickerDialog/backsidePickerDialog.tpl.html",
    "<div class=\"article-create\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">{{'CREATEARTICLE.BACKSIDES' | translate}} {{'GENERAL.FOR' | translate}} {{ vm.article.id }}</div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "    \n" +
    "    \n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"table-responsive form-table\">\n" +
    "            <table class=\"table\">\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        <label class=\"form-label\">{{'CREATEARTICLE.BACKSIDES' | translate}}</label>\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <div ng-class=\"{'backside-picker': !vm.isTemplateMode() }\">\n" +
    "                            <ui-select ng-model=\"vm.selectedBackside\"\n" +
    "                                    append-to-body=\"true\">\n" +
    "                                <ui-select-match\n" +
    "                                        placeholder=\"{{'CREATEARTICLE.BACKSIDES.PLACEHOLDER' | translate}}\">\n" +
    "                                    {{$select.selected.name}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices\n" +
    "                                        repeat=\"backside in vm.availableBacksides(vm.backsides) | filter: $select.search\">\n" +
    "                                    <span>{{'ARTICLE.BACKSIDE.' + backside.id | translate}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </div>\n" +
    "                        <div class=\"input-group-btn top-align\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                            <button class=\"btn btn-success\"\n" +
    "                                    type=\"button\"\n" +
    "                                    ng-click=\"vm.addBackside()\"\n" +
    "                                    ng-disabled=\"!vm.selectedBackside\">\n" +
    "                                {{'BUTTON.ADD' | translate}}\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-repeat=\"backside in vm.selectedBacksides\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                    <td class=\"full-width\" colspan=\"2\">\n" +
    "                        <div class=\"backside-row col-xs-12\">\n" +
    "                            <div class=\"backside-name-col col-xs-12\">\n" +
    "                                {{backside.name}}\n" +
    "                            </div>\n" +
    "                            <div class=\"backside-counter-col\">\n" +
    "                                <div counter=\"\" class=\"btn-group-vertical\" value=\"backside.quantity\"\n" +
    "                                    min=\"1\"></div>\n" +
    "                            </div>\n" +
    "                            <div class=\"backside-action-col\">\n" +
    "                                <button class=\"btn btn-default\"\n" +
    "                                        type=\"button\"\n" +
    "                                        ng-click=\"vm.removeBackside(backside)\">\n" +
    "                                    <i class=\"fa fa-trash\"></i>\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td></td>\n" +
    "                    <td>\n" +
    "                        <div class=\"text-right\">\n" +
    "                            <button confirm-order-button=\"\"\n" +
    "                                title=\"{{'CART.ADDTOCART' | translate}}\"\n" +
    "                                is-enabled=\"!vm.isDirty && !vm.needsAttention() && vm.isValid\"\n" +
    "                                show-warning-tooltip=\"!vm.isDirty && vm.needsAttention()\"\n" +
    "                                action=\"vm.submit()\">\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "</div>");
}]);

angular.module("../common/services/colorPickerDialog/colorPickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/colorPickerDialog/colorPickerDialog.tpl.html",
    "<div class=\"dialog color-picker\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{ 'COLOURPICKER.SELECTCOLOURS' | translate }}\n" +
    "            <p ng-if=\"vm.customColors\">\n" +
    "                {{ vm.customColors }} {{ 'COLOURPICKER.CUSTOMCOLORS' | translate | lowercase }}\n" +
    "            </p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"color-cell col-md-3 col-sm-4 col-xs-4\" ng-class=\"{ 'active': vm.isSelected(color) }\" ng-repeat=\"color in vm.colors\" ng-click=\"vm.toggleColor(color)\" ng-if=\"color.code || color.imageName\">\n" +
    "                <div ng-if=\"color.code\" class=\"color-header\" ng-style=\"{'background-color': '#' + color.code}\">\n" +
    "                </div>\n" +
    "                <div ng-if=\"color.imageName\" class=\"color-header\" ng-style=\"{'background-image':'url(./assets/images/colours/{{color.imageName}})'}\"></div>\n" +
    "                <span class=\"color-text\">\n" +
    "                    <i class=\"fa fa-check-square\" ng-if=\"vm.isSelected(color)\"></i>\n" +
    "                    {{color.name}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">{{'BUTTON.CLOSE' | translate}}</button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/confirmDialog/confirmDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/confirmDialog/confirmDialog.tpl.html",
    "<div class=\"dialog order-confirmation\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.cancel()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{vm.title | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p>\n" +
    "            <span class=\"confirmation-message\">\n" +
    "                {{vm.question | translate}}\n" +
    "            </span>\n" +
    "        </p>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "         <button ng-repeat=\"button in vm.buttons\" type=\"button\" class=\"btn {{button.class}}\" ng-click=\"vm.onClickButton(button)\">\n" +
    "            {{button.name | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/cookieConsent/cookieConsentDialog/cookieConsentDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/cookieConsent/cookieConsentDialog/cookieConsentDialog.tpl.html",
    "<div class=\"modal-header\">\n" +
    "    <a class=\"close\" ng-click=\"vm.onClickClose()\">×</a>\n" +
    "    <div class=\"modal-title\">\n" +
    "        {{'COOKIECONSENT.TITLE' | translate }}\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"cookies-consent-container\">\n" +
    "    <div class=\"section\">\n" +
    "        {{'COOKIECONSENT.FIRSTSECTION' | translate }}\n" +
    "    </div>\n" +
    "    <div class=\"section\">\n" +
    "        {{'COOKIECONSENT.SECONDSECTION' | translate }}\n" +
    "    </div>\n" +
    "    <div class=\"section\">\n" +
    "        <p><a target=\"_blank\" href=\"{{'COOKIECONSENT.LINK' | translate}}\">\n" +
    "                {{'COOKIECONSENT.LINKTITLE' | translate }}\n" +
    "            </a></p>\n" +
    "    </div>\n" +
    "    <div class=\"btnContainer\">\n" +
    "        <button class=\"btn btn-success\" ng-click=\"vm.onClickGiveConsent()\">\n" +
    "            {{'COOKIECONSENT.APPROVE' | translate }}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/services/customerPickerDialog/customerPickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/customerPickerDialog/customerPickerDialog.tpl.html",
    "<div class=\"dialog customer-picker\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'CUSTOMERPICKER.SELECTCUSTOMER' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div>\n" +
    "            <div class=\"dropdown-box\">\n" +
    "                <span class=\"title\">{{'CUSTOMERPICKER.CUSTOMER' | translate}}</span>\n" +
    "                <ui-select ng-model=\"vm.selectedCustomer\" on-select=\"vm.onCustomerSelect($item)\" class=\"select-customer\">\n" +
    "                    <ui-select-match placeholder=\"{{'LABEL.ENTERCUSTOMER' | translate}}\">\n" +
    "                        {{$select.selected.id}} - {{$select.selected.name}}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"customer in vm.customers | filter:{search:$select.search} | limitTo:50\">\n" +
    "                        <span>{{customer.id}} - {{customer.name}}</span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "            <div class=\"dropdown-box\">\n" +
    "                <span class=\"title\">{{'CUSTOMERPICKER.EMPLOYEE' | translate}}</span>\n" +
    "                <ui-select ng-model=\"vm.selectedEmployee\" on-select=\"vm.onEmployeeSelect($item)\" ng-disabled=\"!vm.selectedCustomer.id\" class=\"select-employee\">\n" +
    "                    <ui-select-match placeholder=\"{{'LABEL.ENTEREMPLOYEE' | translate}}\">\n" +
    "                        {{$select.selected.name}}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"employee in vm.employees | filter:{name:$select.search}\">\n" +
    "                        <span>{{employee.name}}</span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"choose\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default choose\">Choose</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/services/emailDialog/emailDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/emailDialog/emailDialog.tpl.html",
    "<div class=\"dialog email-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.cancel()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{\"EMAILPOPUP.TITLE\" | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p class=\"breadtext\" ng-if=\"vm.isNew()\">\n" +
    "            {{\"EMAILPOPUP.BREADTEXT\" | translate}}\n" +
    "        </p>\n" +
    "        <div class=\"table-responsive\">\n" +
    "            <table class=\"table\">\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{\"EMAILPOPUP.TO\" | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width tags\">\n" +
    "                        <ui-select reset-search-input=\"true\" multiple search-enabled=\"false\" tagging=\"vm.addRecipient\" tagging-label=\"false\"\n" +
    "                                   tagging-tokens=\"ENTER\" ng-model=\"vm.recipients\" ng-if=\"!vm.readOnly\" title=\"\" theme=\"bootstrap\">\n" +
    "                            <ui-select-match placeholder=\"\">{{$item}}</ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                        <div ng-if=\"vm.readOnly\" class=\"ui-select-container ui-select-multiple ui-select-bootstrap\">\n" +
    "                            <span ng-repeat=\"recipient in vm.recipients\" class=\"ui-select-match-item btn btn-default btn-xs recipient-readonly\">\n" +
    "                                {{recipient}}\n" +
    "                            </span>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-if=\"vm.visibility.showTemplate\">\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{\"EMAILPOPUP.TEMPLATE\" | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <ui-select ng-model=\"vm.selectedTemplate\" on-select=\"vm.onTemplateSelect()\" ng-disabled=\"vm.readOnly\">\n" +
    "                            <ui-select-match placeholder=\"{{'LABEL.SELECTTEMPLATE' | translate}}\">\n" +
    "                                <span>{{\"EMAILTEMPLATE.\" + $select.selected.name | translate}}</span>\n" +
    "                            </ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"template in vm.templates | translationFilter: $select.search : 'EMAILTEMPLATE.' : 'name'\">\n" +
    "                                <span>{{\"EMAILTEMPLATE.\" + template.name | translate}}</span>\n" +
    "                            </ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{\"EMAILPOPUP.SUBJECT\" | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"vm.subject\" ng-disabled=\"vm.readOnly\"/>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"full-width\" colspan=\"2\">\n" +
    "                        <textarea name=\"body\" ng-model=\"vm.body\" class=\"form-control email-body\" ng-disabled=\"vm.readOnly\"></textarea>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"reply\" class=\"btn btn-success\" type=\"button\" ng-click=\"vm.reply()\"  ng-if=\"vm.visibility.showReply\">{{'BUTTON.REPLY' | translate}}</button>\n" +
    "        <button name=\"skip\" type=\"button\" ng-if=\"vm.visibility.showSkip\" ng-click=\"vm.cancel()\" class=\"btn btn-default\">{{'BUTTON.SKIP' | translate}}</button>\n" +
    "        <button name=\"saveDraft\" type=\"button\" ng-disabled=\"!vm.isReady()\" ng-if=\"vm.visibility.showSaveDraft\" ng-click=\"vm.save('DRAFT')\" class=\"btn btn-default\">{{'BUTTON.SAVEDRAFT' | translate}}</button>\n" +
    "        <button name=\"send\" type=\"button\" ng-disabled=\"!vm.isReady()\" ng-if=\"vm.visibility.showSend\" ng-click=\"vm.save('SENT')\" class=\"btn btn-success\">{{'BUTTON.SEND' | translate}}</button>\n" +
    "        <button name=\"close\" type=\"button\" ng-if=\"vm.visibility.showClose\" ng-click=\"vm.cancel()\" class=\"btn btn-default\">{{'BUTTON.CLOSE' | translate}}</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/services/garmentPicker/garmentPicker.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/garmentPicker/garmentPicker.tpl.html",
    "<div class=\"garment-picker-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'LABEL.SELECTGARMENT' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div ng-repeat=\"garment in vm.garments\">\n" +
    "                <div class=\"col-xs-3\">\n" +
    "                    <div class=\"garment-container\">\n" +
    "                        <img ng-src=\"{{'./assets/products/' + garment + '-FRONT.png'}}\" alt=\"Image\">\n" +
    "                        <div class=\"middle\">\n" +
    "                            <div class=\"btn-group\" role=\"group\">\n" +
    "                                <button class=\"btn btn-success\"\n" +
    "                                        type=\"button\"\n" +
    "                                        ng-click=\"vm.select(garment)\">\n" +
    "                                    {{'BUTTON.SELECT' | translate}}\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"garment-container-text-box\">\n" +
    "                            <p>{{('GARMENT.TYPE.' + garment) | translate}}</p>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-default\" ng-click=\"vm.close()\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/logoImageDialog/logoDialog-edit.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/logoImageDialog/logoDialog-edit.tpl.html",
    "<div class=\"process-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.cancel()\">×</a>\n" +
    "        <div class=\"modal-title\" translate>\n" +
    "            {{'LOGO.DIALOG.EDIT.TITLE'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body edit-panel\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-offset-2 col-xs-8 image-background\" id=\"svg-container\">\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-2\">\n" +
    "                <button class=\"btn btn-sm btn-default float-right\" type=\"button\" ng-click=\"vm.reset()\" title=\"{{'BUTTON.RESET' | translate}}\">\n" +
    "                    <i class=\"fa fa-undo\"></i>\n" +
    "                </button>\n" +
    "                <button class=\"btn btn-sm btn-default float-right\" type=\"button\" ng-click=\"vm.undo()\" title=\"{{'BUTTON.UNDO' | translate}}\">\n" +
    "                    <i class=\"fa fa-arrow-left\"></i>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <p class=\"text-center\">\n" +
    "                    {{'LOGO.DIALOG.COLOR.PROOF.INFORMATION' | translate}}\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row last-row\" ng-if=\"!vm.processing\">\n" +
    "            <div class=\"col-xs-4 colour-col\">\n" +
    "                <div class=\"tokyo-panel\">\n" +
    "                    <div class=\"tokyo-panel-header\">\n" +
    "                        <p>{{'LOGO.DIALOG.EDIT.LOGO.COLOURS.TITLE' | translate}}</p>\n" +
    "                    </div>\n" +
    "                    <div class=\"tokyo-panel-body\">\n" +
    "                        <div class=\"col-xs-12 colour-row\" ng-repeat=\"colour in vm.logoColours\" ng-class=\"{'selected-colour-row': vm.selectedColour.code === colour.code}\">\n" +
    "\n" +
    "                            <!-- Colour box -->\n" +
    "                            <div class=\"colour-preview\" ng-style=\"{'background-color': '{{ colour.code }}'}\"></div>\n" +
    "\n" +
    "                            <!-- Colour name / match -->\n" +
    "                            <div class=\"colour-name\" ng-class=\"{'italic': !colour.tokyoColour}\">\n" +
    "                                {{colour.tokyoColour ? colour.tokyoColour.name : 'LOGO.DIALOG.EDIT.SELECT.COLOUR' | translate}}\n" +
    "                            </div>\n" +
    "\n" +
    "                            <!-- Edit and warning -->\n" +
    "                            <div class=\"float-right\">\n" +
    "                                <i class=\"fa fa-warning logo-dialog-warning-icon\"\n" +
    "                                   ng-if=\"!colour.tokyoColour && vm.selectedColour !== colour\"\n" +
    "                                   aria-hidden=\"true\"\n" +
    "                                   title=\"{{'LOGO.DIALOG.EDIT.SELECT.COLOUR.WARNING' | translate}}\">\n" +
    "                                </i>\n" +
    "                                <div class=\"btn-group colour-btn-group\">\n" +
    "                                    <button class=\"btn btn-sm btn-default\"\n" +
    "                                            title=\"{{'LOGO.DIALOG.EDIT.SHOW.COLOUR.CONFIG' | translate}}\"\n" +
    "                                            ng-if=\"!vm.selectedColour || vm.selectedColour !== colour\"\n" +
    "                                            ng-click=\"vm.showColourConfiguration(colour)\">\n" +
    "                                        <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-xs-8 config-col\" ng-if=\"vm.selectedColour\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-xs-12\">\n" +
    "                        <div class=\"tokyo-panel inner-panel\">\n" +
    "                            <div class=\"tokyo-panel-header\">\n" +
    "                                <p>{{'LOGO.DIALOG.EDIT.SUGGESTED.TITLE' | translate}}</p>\n" +
    "                            </div>\n" +
    "                            <div class=\"tokyo-panel-body\">\n" +
    "                                <p class=\"tokyo-panel-information\">\n" +
    "                                    {{'LOGO.DIALOG.EDIT.SUGGESTED.INFORMATION' | translate}}\n" +
    "                                </p>\n" +
    "                                <div class=\"colour-row-suggestions\">\n" +
    "                                    <div class=\"colour-preview-box\"\n" +
    "                                         ng-repeat=\"colour in vm.selectedColour.suggestions | limitTo: 5\"\n" +
    "                                         ng-style=\"{'background-color': '{{ colour.hex }}'}\"\n" +
    "                                         ng-class=\"{'selected-box': vm.selectedColours[0].code === colour.code}\"\n" +
    "                                         tooltip=\"{{colour.name}}\"\n" +
    "                                         ng-click=\"vm.applyColour(colour)\">\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-xs-12\">\n" +
    "                        <div class=\"tokyo-panel inner-panel\">\n" +
    "                            <div class=\"tokyo-panel-header\">\n" +
    "                                <p>{{'LOGO.DIALOG.EDIT.FREE' | translate}}</p>\n" +
    "                            </div>\n" +
    "                            <div class=\"tokyo-panel-body colour-picker-panel\">\n" +
    "                                <div class=\"col-xs-12\">\n" +
    "                                    <div class=\"color-picker input-group\" ng-class=\"{ 'full': vm.maxSelectedColours === vm.selectedColours.length }\">\n" +
    "                                        <ui-select multiple\n" +
    "                                                   limit=\"{{vm.maxSelectedColours}}\"\n" +
    "                                                   ng-model=\"::vm.selectedColours\"\n" +
    "                                                   on-select=\"vm.applyColour($item)\"\n" +
    "                                                   tagging=\"vm.addColour\"\n" +
    "                                                   tagging-label=\"false\"\n" +
    "                                                   tagging-tokens=\"ENTER|TAB\"\n" +
    "                                                   append-to-body=\"true\">\n" +
    "                                            <ui-select-match placeholder=\"{{'LABEL.ENTERCOLOR' | translate | stringular : (vm.maxSelectedColours - vm.selectedColours.length) + '' }}\">\n" +
    "                                                <div class=\"color-box\" ng-style=\"{'background-color': '#' + $item.code}\">\n" +
    "                                                    <span ng-if=\"!$item.code\">PMS</span>\n" +
    "                                                </div>\n" +
    "                                                <span class=\"item-name\">{{$item.name}}</span>\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices repeat=\"colour in vm.productColours | filter:{name:$select.search}\" ng-model=\"::vm.productColours\">\n" +
    "                                                <div class=\"color-box\" ng-style=\"{'background-color': '#' + colour.code}\"></div>\n" +
    "                                                <span class=\"item-name\">{{colour.name}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                        <div class=\"input-group-btn top-align\" ng-if=\"vm.productType.colourType !== 'NONE'\">\n" +
    "                                            <button type=\"button\" ng-click=\"vm.openColourPicker()\"\n" +
    "                                                    class=\"btn btn-default\" tabindex=\"9\" title=\"{{'TOOLTIP.COLOURPICKER' | translate}}\">\n" +
    "                                                <i class=\"fa fa-th\"></i>\n" +
    "                                            </button>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row last-row\" ng-if=\"vm.processing\">\n" +
    "            <div class=\"col-xs-12\" >\n" +
    "                <div class=\"progress progress-striped active\">\n" +
    "                    <div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <p class=\"progress-text\">{{'LOGO.DIALOG.CONVERTING.MESSAGE' | translate}}</p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <div class=\"row\" ng-if=\"!vm.processing\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"float-right\">\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.saveAs()\" ng-disabled=\"vm.processing || !vm.validateColours()\">\n" +
    "                        {{'BUTTON.SAVEAS' | translate}}\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"vm.processing || !vm.validateColours()\">\n" +
    "                        {{'BUTTON.SAVE' | translate}}\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">\n" +
    "                        {{'BUTTON.CANCEL' | translate}}\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/logoImageDialog/logoDialog-saveAs.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/logoImageDialog/logoDialog-saveAs.tpl.html",
    "<div class=\"modal-header\">\n" +
    "    <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "    <div class=\"modal-title\" translate>\n" +
    "        {{'LOGO.DIALOG.SAVEAS.TITLE'}}\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-body save-as\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"alert alert-warning\" ng-show=\"!vm.valid\">\n" +
    "            <span>{{'CREATEARTICLE.NAMEREQUIRED' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <label for=\"logoImageName\" class=\"col-xs-2 control-label\">\n" +
    "            {{'ARTICLE.NAME' | translate}}\n" +
    "        </label>\n" +
    "        <div class=\"col-xs-10\">\n" +
    "            <input type=\"text\" class=\"form-control\" ng-model=\"vm.name\" id=\"logoImageName\" required=\"\" ng-change=\"vm.valid = true\"/>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"float-right\">\n" +
    "                <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.save()\">\n" +
    "                    {{'BUTTON.SAVE' | translate}}\n" +
    "                </button>\n" +
    "                <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.dismiss()\">\n" +
    "                    {{'BUTTON.CANCEL' | translate}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/services/logoImageDialog/logoDialog-upload.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/logoImageDialog/logoDialog-upload.tpl.html",
    "<div class=\"modal-header\">\n" +
    "    <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "    <div class=\"modal-title\" translate>\n" +
    "        {{'LOGO.DIALOG.UPLOAD.TITLE'}}\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <!-- Upload -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"panel upload-panel\">\n" +
    "                <div class=\"panel-heading\" translate>\n" +
    "                    {{'LOGO.DIALOG.UPLOAD.ADD.TITLE'}}\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\" ng-if=\"vm.processing\">\n" +
    "                    <div class=\"progress progress-striped active\">\n" +
    "                        <div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <p class=\"progress-text\">\n" +
    "                        {{'LOGO.DIALOG.CONVERTING.MESSAGE' | translate}}\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\" ng-if=\"!vm.processing\">\n" +
    "                    <div class=\"alert alert-warning\" ng-if=\"vm.nameError\" translate>\n" +
    "                        {{'LOGO.DIALOG.UPLOAD.ERROR.NAME'}}\n" +
    "                    </div>\n" +
    "                    <div class=\"alert alert-warning\" ng-if=\"vm.fileError\" translate>\n" +
    "                        {{'LOGO.DIALOG.UPLOAD.ERROR.FILE'}}\n" +
    "                    </div>\n" +
    "                    <form class=\"form-horizontal\">\n" +
    "                        <div class=\"alert alert-warning col-xs-12\" ng-if=\"vm.error\">\n" +
    "                            <div ng-repeat=\"errorMessage in vm.errorMessages\" class=\"col-xs-12\">\n" +
    "                                {{errorMessage}}\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"form-group\">\n" +
    "                            <label for=\"logoImageName\" class=\"col-xs-2 control-label\" translate>\n" +
    "                                {{'LOGO.DIALOG.UPLOAD.ADD.NAME'}}\n" +
    "                            </label>\n" +
    "                            <div class=\"col-xs-10\">\n" +
    "                                <input type=\"text\" class=\"form-control upload-textfield\" id=\"logoImageName\" placeholder=\"{{'LOGO.DIALOG.UPLOAD.ADD.PLACEHOLDER' | translate}}\" ng-model=\"vm.logoImageName\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"form-group bottom-form-group\">\n" +
    "                            <div class=\"col-xs-offset-2 col-xs-8\">\n" +
    "                                <button ng-file-select class=\"btn btn-default btn-with-icon upload-button\" ng-model=\"vm.uploadImage\" ng-accept=\"vm.onFileSelect($file)\" accept=\"{{vm.acceptableFormats}}\"\n" +
    "                                        ng-multiple=\"false\" ng-click=\"$event.preventDefault()\" title=\"{{vm.uploadImageName}}\">\n" +
    "                                    <span ng-if=\"!vm.uploadImage\"><i class=\"fa fa-image\"></i>{{'LOGO.DIALOG.UPLOAD.ADD.BUTTON' | translate}}</span>\n" +
    "                                    <span ng-if=\"vm.uploadImage\"><i class=\"fa fa-cloud-upload\"></i>{{vm.uploadImageName}}</span>\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-xs-2\">\n" +
    "                                <button type=\"button\" class=\"btn btn-success float-right\" ng-click=\"vm.saveImage()\" translate>{{'BUTTON.SAVE'}}</button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </form>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Selection -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"panel upload-panel bottom-upload-panel\">\n" +
    "                <div class=\"panel-heading col-xs-12\">\n" +
    "                    <div class=\"col-xs-offset-4 col-xs-4 panel-heading-title\">\n" +
    "                        <p translate>{{'LOGO.DIALOG.UPLOAD.SELECT.TITLE'}}</p>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-xs-4 panel-search-box\">\n" +
    "                       <input class=\"form-control input-with-icon\" ng-model=\"vm.filterText\" placeholder=\"&#xF002; {{'LOGO.DIALOG.UPLOAD.SELECT.SEARCH' | translate}}\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\">\n" +
    "                    <div ng-repeat=\"image in vm.getFilteredImages(vm.filterText)\">\n" +
    "                        <div class=\"col-xs-3 image-container\">\n" +
    "                            <img class=\"center-cropped image image-background\" ng-src=\"{{vm.getImageUrl(image.logoImageId)}}\" alt=\"Image\">\n" +
    "                            <div class=\"middle\">\n" +
    "                                <p class=\"middle-title\" title=\"{{image.name}}\">{{image.name}}</p>\n" +
    "                                <div class=\"btn-group\" role=\"group\">\n" +
    "                                    <button class=\"btn btn-sm btn-success\" type=\"button\" ng-click=\"vm.selectImage(image)\"\n" +
    "                                            ng-disabled=\"vm.processing\">\n" +
    "                                        {{'BUTTON.SELECT' | translate}}\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-sm btn-warning\" type=\"button\" ng-click=\"vm.editImage(image)\"\n" +
    "                                            ng-disabled=\"vm.processing\">\n" +
    "                                        <i class=\"fa fa-pencil\"></i>\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-sm btn-danger\" type=\"button\" ng-click=\"vm.removeImage(image)\"\n" +
    "                                            ng-disabled=\"vm.processing\">\n" +
    "                                        <i class=\"fa fa-trash\"></i>\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <pagination class=\"pagination\" total-items=\"vm.filteredImages.length\" items-per-page=\"vm.maxSizeImagePage\" ng-model=\"vm.currentImagePage\"></pagination>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <button class=\"btn btn-default float-right\" type=\"button\" ng-click=\"vm.close()\" ng-disabled=\"vm.processing\">\n" +
    "                {{'BUTTON.CLOSE' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/services/manufacturingDialog/manufacturingDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/manufacturingDialog/manufacturingDialog.tpl.html",
    "<div class=\"manufacturing-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">{{ 'STADIUM.ADDITIONALMANUFACTURING' | translate }}</div>\n" +
    "    </div>\n" +
    "    <div ng-include=\"vm.contentTemplate\"></div>\n" +
    "</div>");
}]);

angular.module("../common/services/manufacturingDialog/manufacturingDialogDefault.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/manufacturingDialog/manufacturingDialogDefault.tpl.html",
    "<div class=\"modal-body\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-6\">\n" +
    "            <table class=\"table\">\n" +
    "                <tbody>\n" +
    "                    <tr>\n" +
    "                        <td class=\"col-xs-6\" translate>\n" +
    "                            {{::'STADIUM.ARTNR'}}\n" +
    "                        </td>\n" +
    "                        <td class=\"col-xs-6\">\n" +
    "                            {{vm.article.id}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"col-xs-6\" translate>\n" +
    "                            {{::'STADIUM.NAME'}}\n" +
    "                        </td>\n" +
    "                        <td class=\"col-xs-6 name-cell\">\n" +
    "                            {{vm.article.name}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td ng-if=\"vm.article.stocked\" class=\"col-xs-6\" translate>\n" +
    "                            {{::'STADIUM.LOGO.MANUFACTURING_QUANTITY'}}\n" +
    "                        </td>\n" +
    "                        <td ng-if=\"!vm.article.stocked\" class=\"col-xs-6\" translate>\n" +
    "                            {{::'STADIUM.LOGO.ORDER_QUANTITY'}}\n" +
    "                        </td>\n" +
    "                        <td class=\"col-xs-6\">\n" +
    "                            <div \n" +
    "                                counter=\"\" \n" +
    "                                is-small=\"true\" \n" +
    "                                class=\"btn-group-vertical\"\n" +
    "                                value=\"vm.quantity\"\n" +
    "                                min=\"vm.minQuantity\"\n" +
    "                            >\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-6\" ng-if=\"vm.article.stocked\">\n" +
    "            <div class=\"panel panel-default info-panel stadium-stock\">\n" +
    "                <div class=\"panel-heading\">{{'STADIUM.STADIUMSTOCK' | translate}}:\n" +
    "                    <button class=\"btn btn-sm btn-default pull-right\"\n" +
    "                            title=\"{{'TOOLTIP.EDIT' | translate}}\"\n" +
    "                            ng-click=\"vm.openStadiumStockDialog()\"\n" +
    "                            ng-disabled=\"!vm.user.admin && !vm.article.canAdjust\">\n" +
    "                        <i class=\"fa fa-pencil\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm btn-default pull-right\"\n" +
    "                            title=\"{{'STOCK.UPDATE' | translate}}\"\n" +
    "                            style=\"margin-right: 5px;\"\n" +
    "                            ng-click=\"vm.onStockUpdate()\">\n" +
    "                        <i class=\"fa fa-refresh\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <div class=\"price-table\">\n" +
    "                    <table class=\"table borderless\">\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.STOCK'}}</th>\n" +
    "                            <td>{{vm.stock.stock}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.PRODUCTION'}}</th>\n" +
    "                            <td>{{vm.stock.orderIn}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.ORDERED'}}</th>\n" +
    "                            <td>{{vm.stock.orderOut}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.MINIMUMSTOCK'}}</th>\n" +
    "                            <td>{{vm.stock.minimumStock}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.REFILLVOLUME'}}</th>\n" +
    "                            <td>{{vm.stock.refillVolume}}</td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.user.stadium && vm.manufacturingOrders\">\n" +
    "                <div class=\"panel panel-default info-panel stadium-stock\">\n" +
    "                    <div class=\"manufacturing-panel\">\n" +
    "                        <div class=\"panel-heading ng-binding\">\n" +
    "                            {{'STADIUM.MANUFACTURINGORDERS' | translate}}\n" +
    "                        </div>\n" +
    "                        <div class=\"price-table scroll\">\n" +
    "                            <div class=\"panel panel-default inner-manufacturing-panel\">\n" +
    "                                <table class=\"table borderless\">\n" +
    "                                    <tbody>\n" +
    "                                    <tr class=\"panel-heading\">\n" +
    "                                        <th>\n" +
    "                                            {{'STADIUM.DATE' | translate}}\n" +
    "                                        </th>\n" +
    "                                        <th>\n" +
    "                                            {{'STADIUM.QUANTITY' | translate}}\n" +
    "                                        </th>\n" +
    "                                    </tr>\n" +
    "                                    <tr ng-repeat=\"order in vm.manufacturingOrders\">\n" +
    "                                        <td>\n" +
    "                                            {{order.date | date : 'yy-MM-dd'}}\n" +
    "                                        </td>\n" +
    "                                        <td>\n" +
    "                                            {{order.quantity}}\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                    </tbody>\n" +
    "                                </table>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button \n" +
    "        name=\"cancel\" \n" +
    "        tabindex=\"3\"\n" +
    "        type=\"button\" \n" +
    "        ng-click=\"vm.close()\" \n" +
    "        class=\"btn btn-default\"\n" +
    "        translate\n" +
    "    >\n" +
    "        {{::'BUTTON.CANCEL'}}\n" +
    "    </button>\n" +
    "    <button \n" +
    "        class=\"btn btn-success\" \n" +
    "        type=\"button\"\n" +
    "        ng-if=\"!vm.article.stocked\"\n" +
    "        ng-disabled=\"!vm.isValid()\"\n" +
    "        ng-click=\"vm.confirm()\"\n" +
    "        translate\n" +
    "    >\n" +
    "        {{::'BUTTON.ADDTOCART'}}\n" +
    "    </button>\n" +
    "    <button \n" +
    "        name=\"submit\" \n" +
    "        type=\"button\"\n" +
    "        ng-if=\"vm.article.stocked\"\n" +
    "        ng-click=\"vm.confirm()\"\n" +
    "        ng-disabled=\"!vm.isValid()\" \n" +
    "        class=\"btn btn-success\"\n" +
    "        translate\n" +
    "    >\n" +
    "        {{::'BUTTON.SUBMIT'}}\n" +
    "    </button>\n" +
    "</div>");
}]);

angular.module("../common/services/manufacturingDialog/manufacturingDialogSuccess.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/manufacturingDialog/manufacturingDialogSuccess.tpl.html",
    "<div class=\"modal-body\">\n" +
    "    <div class=\"success-contents\">\n" +
    "        <span class=\"success-message\"><i class=\"fa fa-check\"></i> {{'CHECKOUT.ORDERCONFIRMEDMESSAGE' | translate}}</span>\n" +
    "        <span>{{'CHECKOUT.ORDERCONTACTMESSAGE' | translate}}</span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <a class=\"btn btn-block btn-info\" ng-click=\"vm.continueButton()\">{{'BUTTON.CONTINUE' | translate}}</a>\n" +
    "</div>");
}]);

angular.module("../common/services/playerDialog/playerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/playerDialog/playerDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog\">\n" +
    "    <div class=\"player-dialog\">\n" +
    "        <div class=\"modal-header\">\n" +
    "            <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "                ×\n" +
    "            </a>\n" +
    "            <div class=\"modal-title\">\n" +
    "                {{'MOUNTING.PLAYERS' | translate}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body row\" ng-if=\"vm.currentPhase === 1\">\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"!vm.nameIsUnique\">\n" +
    "                {{'MOUNTING.PLAYERDIALOG.CHOOSENEWUNIQUENAME' | translate}}\n" +
    "            </div>\n" +
    "            <div class=\"col-md-offset-1 col-md-10 radio-panel\">\n" +
    "                <div class=\"group\">\n" +
    "                <span class=\"title\">\n" +
    "                    {{'MOUNTING.SELECTOPTIONS' | translate}}\n" +
    "                </span>\n" +
    "                </div>\n" +
    "                <div class=\"group\">\n" +
    "                    <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioNewBlank\" id=\"radioNewBlank\">\n" +
    "                    <label for=\"radioNewBlank\">\n" +
    "                        {{'MOUNTING.CREATENEWPLAYERLIST' | translate}}\n" +
    "                    </label>\n" +
    "                    <br>\n" +
    "                    <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioNewExisting\" id=\"radioNewExisting\">\n" +
    "                    <label for=\"radioNewExisting\">\n" +
    "                        {{'MOUNTING.CREATEEXISTINGPLAYERLIST' | translate}}\n" +
    "                    </label>\n" +
    "                    <br>\n" +
    "                    <input type=\"radio\" checked=\"checked\" ng-model=\"vm.radioChoice\" value=\"radioReuse\" id=\"radioReuse\">\n" +
    "                    <label for=\"radioReuse\">\n" +
    "                        {{'MOUNTING.REUSEEXISTINGPLAYERLIST' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-offset-1 col-md-10\" ng-hide=\"vm.playerLists.length === 0 && vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                <p ng-if=\"vm.radioChoice === 'radioNewBlank'\">\n" +
    "                    {{'MOUNTING.NEWPLAYERLIST' | translate}}:\n" +
    "                </p>\n" +
    "                <p ng-if=\"vm.radioChoice === 'radioNewExisting'\">\n" +
    "                    {{'MOUNTING.SELECTEXISTINGPLAYERLIST' | translate}}:\n" +
    "                </p>\n" +
    "                <p ng-if=\"vm.radioChoice === 'radioReuse'\">\n" +
    "                    {{'MOUNTING.SELECTREUSEEXISTINGPLAYERLIST' | translate}}:\n" +
    "                </p>\n" +
    "                <div class=\"table-responsive\">\n" +
    "                    <table class=\"table\">\n" +
    "                        <tbody>\n" +
    "                        <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'PRODUCTIONPLANNING.PLAYERLIST' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <ui-select on-select=\"vm.onPlayerListSelect($item)\" ng-model=\"vm.selectedPlayerList\">\n" +
    "                                    <ui-select-match placeholder=\"{{'MOUNTING.SELECTPLAYERLIST' | translate}}\">\n" +
    "                                        {{$select.selected.playerListName}}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"playerList in vm.playerLists | filter:$select.search | filter:{imported:false} | orderBy : 'value'\">\n" +
    "                                        <span>{{playerList.playerListName}}</span>\n" +
    "                                        <button class=\"btn-delete pull-right\" ng-click=\"vm.removePlayerList(playerList)\">\n" +
    "                                            <i class=\"fa fa-remove\"></i>\n" +
    "                                        </button>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.radioChoice !== 'radioReuse'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.NAME' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.name\" ng-change=\"vm.checkNameIsUnique()\">\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.DESCRIPTION' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <textarea class=\"form-control\" ng-model=\"vm.description\" ng-disabled=\"vm.radioChoice === 'radioReuse'\"></textarea>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.NUMBEROFROWS' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input type=\"text\" class=\"form-control\" ng-model=\"vm.numberOfRows\" readonly=\"readonly\"/>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.DATECREATED' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.dateCreated\" readonly=\"readonly\">\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"alert alert-warning no-playerlist\" ng-if=\"vm.playerLists.length === 0 && vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                {{'MOUNTING.PLAYERDIALOG.NOPLAYERLISTS' | translate}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body row\" ng-if=\"vm.currentPhase === 2\">\n" +
    "            <div class=\"alert alert-success\" ng-if=\"vm.sent\">\n" +
    "                An email has been sent\n" +
    "            </div>\n" +
    "            <div class=\"alert alert-danger\" ng-show=\"vm.importError\">\n" +
    "                {{'PLAYERLIST.EXCELERROR' | translate}}\n" +
    "            </div>\n" +
    "            <div class=\"group\">\n" +
    "                <div class=\"player-dialog-title\">\n" +
    "                    {{'MOUNTING.PLAYERDIALOGTITLE' | translate}}\n" +
    "                </div>\n" +
    "                <div class=\"player-dialog-text\">\n" +
    "                    {{'MOUNTING.PLAYERDIALOGTEXT' | translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"visible-lg-block visible-md-block\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <table class=\"table\">\n" +
    "                        <tdead>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.ARTICLE' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.SIZE' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.NAME' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.INITIALS' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.LARGE_NUMBER' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.SMALL_NUMBER' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.COMMENT' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.QUANTITY' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    &nbsp;\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tdead>\n" +
    "                        <tbody>\n" +
    "                            <tr ng-repeat=\"player in vm.players\">\n" +
    "                                <td class=\"col-md-2\">\n" +
    "                                    <input ng-readonly=\"vm.isReadOnly()\" type=\"text\" name=\"articleId\" class=\"form-control\" ng-model=\"player.articleId\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <input type=\"text\" name=\"size\" class=\"form-control\" ng-model=\"player.size\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-2\">\n" +
    "                                    <input type=\"text\" name=\"player-name\" class=\"form-control\" ng-model=\"player.name\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <input type=\"text\" name=\"initials\" class=\"form-control\" ng-model=\"player.initials\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <input type=\"text\" name=\"number\" class=\"form-control\" ng-model=\"player.number\" ng-change=\"vm.addIfLastRow($index); vm.checkNumber($index);\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <input type=\"text\" name=\"smallNumber\" class=\"form-control\" ng-model=\"player.smallNumber\" ng-change=\"vm.addIfLastRow($index); vm.checkNumber($index);\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-3\">\n" +
    "                                    <input type=\"text\" name=\"comment\" class=\"form-control\" ng-model=\"player.comment\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\" ng-if=\"!vm.isReadOnly()\">\n" +
    "                                    <div counter=\"\" class=\"btn-group-vertical\" value=\"player.quantity\" min=\"vm.minQuantity\"></div>\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\" ng-if=\"vm.isReadOnly()\">\n" +
    "                                    <input type=\"text\" class=\"form-control text-right\" ng-model=\"player.quantity\" ng-disabled=\"true\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <button class=\"btn btn-default\" ng-click=\"vm.copy($index)\" title=\"{{'TOOLTIP.COPY' | translate}}\" ng-disabled=\"vm.isReadOnly()\">\n" +
    "                                        <i class=\"fa fa-copy\" aria-hidden=\"true\"></i>\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-default\" ng-click=\"vm.remove($index)\" title=\"{{'TOOLTIP.CLEAR' | translate}}\" ng-disabled=\"vm.isReadOnly()\">\n" +
    "                                        <i class=\"fa fa-trash\" aria-hidden=\"true\"></i>\n" +
    "                                    </button>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"hidden-lg hidden-md\">\n" +
    "                <div class=\"col-md-12 col-sm-8 col-sm-offset-2 col-xs-12\">\n" +
    "                    <table class=\"table\" ng-repeat=\"player in vm.players\" ng-show=\"$index === vm.activePlayerIndex\" ng-swipe-right=\"vm.updateActivePlayer(-1)\" ng-swipe-left=\"vm.updateActivePlayer(1)\">\n" +
    "                        <tbody>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.ARTICLE' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input ng-readonly=\"vm.isReadOnly()\" type=\"text\" name=\"articleId\" class=\"form-control\" ng-model=\"player.articleId\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.SIZE' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"size\" class=\"form-control\" ng-model=\"player.size\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.NAME' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"player-name\" class=\"form-control\" ng-model=\"player.name\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.INITIALS' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"initials\" class=\"form-control\" ng-model=\"player.initials\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.LARGE_NUMBER' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"number\" class=\"form-control\" ng-model=\"player.number\" ng-change=\"vm.addIfLastRow($index); vm.checkNumber($index);\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.SMALL_NUMBER' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"smallNumber\" class=\"form-control\" ng-model=\"player.smallNumber\" ng-change=\"vm.addIfLastRow($index); vm.checkNumber($index);\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.COMMENT' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"comment\" class=\"form-control\" ng-model=\"player.comment\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.QUANTITY' | translate}}\n" +
    "                                </td>\n" +
    "                                <td ng-if=\"!vm.isReadOnly()\">\n" +
    "                                    <div counter=\"\" class=\"btn-group-vertical\" value=\"player.quantity\" min=\"vm.minQuantity\"></div>\n" +
    "                                </td>\n" +
    "                                <td ng-if=\"vm.isReadOnly()\">\n" +
    "                                    <input type=\"text\" class=\"form-control text-right\" ng-model=\"player.quantity\" ng-disabled=\"true\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    &nbsp;\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <button class=\"btn btn-default delete-player\" ng-click=\"vm.remove($index); vm.findNewActivePlayer()\" title=\"{{'TOOLTIP.CLEAR' | translate}}\" ng-disabled=\"vm.isReadOnly()\">\n" +
    "                                        <i class=\"fa fa-trash\" aria-hidden=\"true\"></i>\n" +
    "                                    </button>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                    <div class=\"pagination\">\n" +
    "                        <a href=\"\" ng-click=\"vm.activePlayerIndex > 0 && vm.updateActivePlayer(-1)\" ng-disabled=\"vm.activePlayerIndex === 0\">&laquo;</a>\n" +
    "                        <!-- TODO: show first, `...` (if needed), three around current, `...` (if needed) and last page if there are too many -->\n" +
    "                        <a href=\"\" ng-if=\"$index < vm.players.length - 1 || vm.players.length === 1\" ng-repeat=\"player in vm.players\" ng-click=\"vm.setActivePlayer($index)\" ng-class=\"{ 'active': vm.activePlayerIndex === $index }\">{{ $index + 1 }}</a>\n" +
    "                        <a href=\"\" class=\"new-player\" ng-show=\"vm.players.length > 1\" ng-click=\"vm.setActivePlayer(vm.players.length - 1)\" ng-class=\"{ 'active': vm.activePlayerIndex === vm.players.length - 1 }\">\n" +
    "                            <i class=\"fa fa-plus\"></i>\n" +
    "                        </a>\n" +
    "                        <a href=\"\" ng-click=\"vm.activePlayerIndex < vm.players.length - 2 && vm.updateActivePlayer(1)\" ng-disabled=\"vm.activePlayerIndex >= vm.players.length - 2\">&raquo;</a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"playerlist-panel-outer\" ng-if=\"vm.showSizeSummary\">\n" +
    "                <div class=\"playerlist-panel-header\">\n" +
    "                    <h4>\n" +
    "                        {{'PLAYERLIST.SUMMARY' | translate}}\n" +
    "                    </h4>\n" +
    "                </div>\n" +
    "                <div class=\"playerlist-panel-body playerlist-panel-summary\">\n" +
    "                    <table class=\"table\">\n" +
    "                        <thead>\n" +
    "                        <tr>\n" +
    "                            <th>\n" +
    "                                {{'MOUNTING.SIZE' | translate}}\n" +
    "                            </th>\n" +
    "                            <th>\n" +
    "                                {{'MOUNTING.TOTAL' | translate}}\n" +
    "                            </th>\n" +
    "                        </tr>\n" +
    "                        </thead>\n" +
    "                        <tbody>\n" +
    "                        <tr ng-repeat=\"size in vm.getSizes()\">\n" +
    "                            <td class=\"col-md-2\">\n" +
    "                                {{vm.getSize($index)}}\n" +
    "\n" +
    "                            </td>\n" +
    "                            <td class=\"col-md-1\">\n" +
    "                                {{vm.getTotalRow($index)}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"player-total\">\n" +
    "                                {{'MOUNTING.TOTAL' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{vm.getTotal()}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\" ng-if=\"vm.currentPhase === 1\">\n" +
    "            <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.CANCEL' | translate}}\">\n" +
    "                {{'BUTTON.CANCEL' | translate}}\n" +
    "            </button>\n" +
    "            <button name=\"save\" tabindex=\"3\" type=\"button\" ng-click=\"vm.next()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\" title=\"{{'TOOLTIP.NEXT' | translate}}\">\n" +
    "                {{'BUTTON.NEXT' | translate}} &raquo;\n" +
    "            </button>\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\" ng-if=\"vm.currentPhase === 2\">\n" +
    "            <div class=\"pull-left\">\n" +
    "                <button type=\"button\" class=\"btn\" ng-click=\"vm.onClickToggleSummary()\" ng-class=\"vm.showSizeSummary ? 'btn-success' : 'btn-default'\" title=\"{{'TOOLTIP.SHOWSIZESUMMARY' | translate}}\">\n" +
    "                    <i class=\"fa fa-calculator\" aria-hidden=\"true\"></i>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"pull-right\">\n" +
    "                <button name=\"back\" type=\"button\" ng-if=\"!vm.imported && !vm.readOnly\" ng-click=\"vm.back()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.BACK' | translate}}\">\n" +
    "                    &laquo; {{'BUTTON.BACK' | translate}}\n" +
    "                </button>\n" +
    "                <button name=\"clear\" type=\"button\" ng-if=\"!vm.isReadOnly()\" ng-click=\"vm.clear()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.CLEAR' | translate}}\">\n" +
    "                    {{'BUTTON.CLEAR' | translate}}\n" +
    "                </button>\n" +
    "                <button name=\"cancel\" type=\"button\" ng-if=\"!vm.isReadOnly()\" ng-click=\"vm.close()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.CANCEL' | translate}}\">\n" +
    "                    {{'BUTTON.CANCEL' | translate}}\n" +
    "                </button>\n" +
    "                <button name=\"save\" type=\"button\" ng-if=\"!vm.isReadOnly()\" ng-click=\"vm.save()\" ng-disabled=\"!vm.playerQuantitiesAreValid()\" class=\"btn btn-success\" title=\"{{'TOOLTIP.SAVE' | translate}}\">\n" +
    "                    {{'BUTTON.SAVE' | translate}}\n" +
    "                </button>\n" +
    "                <button name=\"close\" type=\"button\" ng-if=\"vm.isReadOnly()\" ng-click=\"vm.save()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.CLOSE' | translate}}\">\n" +
    "                    {{'BUTTON.CLOSE' | translate}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/playerGroupDialog/playerGroupDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/playerGroupDialog/playerGroupDialog.tpl.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'PLAYERGROUP.DIALOG.TITLE' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"alert alert-warning\" ng-if=\"vm.validationErrors.length > 0\">\n" +
    "                    <div ng-repeat=\"error in vm.validationErrors\">\n" +
    "                        {{error.message}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <table class=\"table table-responsive dialog-table\">\n" +
    "                    <tr class=\"borderless\">\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"vertical-align-middle\">\n" +
    "                                {{'LABEL.GARMENT' | translate}}\n" +
    "                            </label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div class=\"garment-picker input-group\"\n" +
    "                                 ng-class=\"{'full': vm.maxGarments === vm.selectedGarments.length}\">\n" +
    "                                <ui-select multiple\n" +
    "                                           limit=\"vm.maxGarments\"\n" +
    "                                           tagging=\"vm.addGarment\"\n" +
    "                                           tagging-label=\"false\"\n" +
    "                                           ng-model=\"vm.selectedGarments\"\n" +
    "                                           append-to-body=\"true\">\n" +
    "                                    <ui-select-match placeholder=\"{{'LABEL.SELECTGARMENT' | translate}}\">\n" +
    "                                        <span>{{$select.selected[0].value | translate}}</span>\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"garment in vm.garments | translationFilter: $select.search : '' : 'value' | orderBy: 'value'\">\n" +
    "                                        <span>{{garment.value | translate}}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"borderless\">\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"vertical-align-middle\">\n" +
    "                                {{'LABEL.COLOR' | translate}}\n" +
    "                            </label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div class=\"color-picker input-group\" style=\"width: 100%;\"\n" +
    "                                 ng-class=\"{'full': vm.maxColours === vm.selectedColours.length}\">\n" +
    "                                <ui-select multiple\n" +
    "                                           limit=\"{{vm.maxColours}}\"\n" +
    "                                           tagging=\"vm.addColour\"\n" +
    "                                           tagging-label=\"false\"\n" +
    "                                           ng-model=\"vm.selectedColours\"\n" +
    "                                           append-to-body=\"true\">\n" +
    "                                    <ui-select-match\n" +
    "                                            placeholder=\"{{'NAME.PLACEHOLDER.TEXTCOLOUR' | translate}}\">\n" +
    "                                        <div class=\"color-box\" ng-style=\"{'background-color': '#' + $item.code}\">\n" +
    "                                        </div>\n" +
    "                                        <span class=\"item-name\">{{$item.name}}</span>\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"colour in vm.colours | filter:{name: $select.search}\"\n" +
    "                                                       ng-model=\"vm.colours\">\n" +
    "                                        <div class=\"color-box\" ng-style=\"{'background-color': '#' + colour.code}\"></div>\n" +
    "                                        <span class=\"item-name\">{{colour.name}}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.save()\">\n" +
    "                    {{'BUTTON.ADD' | translate}}\n" +
    "                </button>\n" +
    "                <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">\n" +
    "                    {{'BUTTON.CLOSE' | translate}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/services/proofDialog/proofDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/proofDialog/proofDialog.tpl.html",
    "<div class=\"errand\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'PRODUCTIONPLANNING.SELECTFILE'| translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row filter-row\">\n" +
    "            <div class=\"col-xs-3 filter-row-title\">\n" +
    "                <p>{{'PRODUCTIONPLANNING.RESOURCE' | translate}}</p>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-9\">\n" +
    "                <ui-select ng-model=\"vm.selectedResource\">\n" +
    "                    <ui-select-match placeholder=\"{{'LABEL.ALL' | translate}}\" allow-clear=\"true\">\n" +
    "                        {{$select.selected.resourceName}}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"resource in vm.availableResources\" ng-model=\"vm.availableResources\">\n" +
    "                        <span>{{resource.resourceName}}</span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <table class=\"table table-hover\">\n" +
    "                    <thead>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'PRODUCTIONPLANNING.ERRANDID'| translate}}\n" +
    "                        </th>\n" +
    "                        <th colspan=\"2\">\n" +
    "                            {{'PRODUCTIONPLANNING.FILE'| translate}}\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                    </thead>\n" +
    "                    <tbody>\n" +
    "                    <tr class=\"clickable\" ng-repeat=\"orderProof in vm.orderProofs | filter: vm.filterProofs\" ng-click=\"vm.onClickProof(orderProof)\">\n" +
    "                        <td>\n" +
    "                            {{orderProof.errandId}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            {{orderProof.fileName}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <a href=\"{{vm.getProofLink(orderProof)}}\" target=\"_blank\" title=\"{{'TOOLTIP.DOWNLOADIMAGE' | translate}}\">\n" +
    "                                <button type=\"button\" class=\"btn btn-sm btn-default pull-right text-right\">\n" +
    "                                    <i class=\"fa fa-download\"></i>\n" +
    "                                </button>\n" +
    "                            </a>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CANCEL' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/services/savedCartDialog/savedCartDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/savedCartDialog/savedCartDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog\">\n" +
    "    <div class=\"player-dialog\">\n" +
    "        <div class=\"modal-header\">\n" +
    "            <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "                ×\n" +
    "            </a>\n" +
    "            <div class=\"modal-title\">\n" +
    "                {{'STADIUM.CHOOSECART' | translate}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body row\">\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"!vm.isReferenceProjectUnique()\">\n" +
    "                {{'STADIUM.SAVEDCARTSCOMBINATIONNOTUNIQUE' | translate}}\n" +
    "            </div>\n" +
    "            <div class=\"col-md-offset-1 col-md-10 radio-panel\">\n" +
    "                <div class=\"group\">\n" +
    "                <span class=\"title\">\n" +
    "                    {{'STADIUM.SELECTOPTIONS' | translate}}\n" +
    "                </span>\n" +
    "                </div>\n" +
    "                <div class=\"group\">\n" +
    "                    <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioNewBlank\" id=\"radioNewBlank\">\n" +
    "                    <label for=\"radioNewBlank\">\n" +
    "                        {{'STADIUM.CREATENEWCART' | translate}}\n" +
    "                    </label>\n" +
    "                    <br>\n" +
    "                    <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioReuse\" id=\"radioReuse\">\n" +
    "                    <label for=\"radioReuse\">\n" +
    "                        {{'STADIUM.ACTIVATEALREADYSTARTEDCART' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"!vm.showCartWarning()\">\n" +
    "                <div class=\"col-md-offset-1 col-md-10\">\n" +
    "                    <p ng-if=\"vm.radioChoice === 'radioNewBlank'\">\n" +
    "                        {{'STADIUM.NEWCART' | translate}}:\n" +
    "                    </p>\n" +
    "                    <p ng-if=\"vm.radioChoice === 'radioReuse'\">\n" +
    "                        {{'STADIUM.SELECTCARTTOACTIVATE' | translate}}:\n" +
    "                    </p>\n" +
    "                    <div class=\"table-responsive\">\n" +
    "                        <table class=\"table\">\n" +
    "                            <tbody>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.CART' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <ui-select on-select=\"vm.onSavedCartSelect()\" ng-model=\"vm.selectedCart\">\n" +
    "                                        <ui-select-match placeholder=\"{{'STADIUM.SELECTCART' | translate}}\">\n" +
    "                                            {{$select.selected.orderReference}} - {{$select.selected.orderProject}}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"savedCart in vm.getSavedCarts() | filter:$select.search | orderBy : 'orderReference'\">\n" +
    "                                            <span>{{savedCart.orderReference}} - {{savedCart.orderProject}}</span>\n" +
    "                                            <button class=\"btn-delete pull-right\" ng-click=\"vm.removeSavedCart(savedCart)\">\n" +
    "                                                <i class=\"fa fa-remove\"></i>\n" +
    "                                            </button>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioReuse'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.REFERENCE' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input name=\"name\" class=\"form-control\" ng-model=\"vm.orderReference\" required>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioReuse'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.PROJECT' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input class=\"form-control\" ng-model=\"vm.orderProject\" required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.ROWS' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input class=\"form-control\" ng-model=\"vm.selectedCart.rows\" readonly=\"true\"/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.DATECREATED' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input name=\"name\" class=\"form-control\" ng-model=\"vm.dateCreated\" readonly=\"true\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            </tbody>\n" +
    "                        </table>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-12\" ng-if=\"vm.showNoCartsWarning()\">\n" +
    "                <div class=\"alert alert-warning\">\n" +
    "                    {{'STADIUM.NOCARTSWARNING' | translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-12\" ng-if=\"vm.showOneCartWarning()\">\n" +
    "                <div class=\"alert alert-warning\">\n" +
    "                    {{'STADIUM.ONECARTWARNING' | translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "                {{'BUTTON.CANCEL' | translate}}\n" +
    "            </button>\n" +
    "            <button name=\"create\" tabindex=\"3\" type=\"button\" ng-click=\"vm.create()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\" ng-if=\"vm.radioChoice !== 'radioReuse'\">\n" +
    "                {{'BUTTON.CREATE' | translate}}\n" +
    "            </button>\n" +
    "            <button name=\"activate\" tabindex=\"3\" type=\"button\" ng-click=\"vm.create()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\" ng-if=\"vm.radioChoice === 'radioReuse'\">\n" +
    "                {{'BUTTON.ACTIVATE' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/security/loginDialog/loginDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/security/loginDialog/loginDialog.tpl.html",
    "<div class=\"login-box\">\n" +
    "    <div class=\"header\">{{'LABEL.SIGNIN' | translate}}</div>\n" +
    "    <form autofill-submit=\"vm.login()\">\n" +
    "        <div class=\"body\">\n" +
    "            <div class=\"alert alert-danger\" ng-show=\"vm.authError\">\n" +
    "                {{vm.authError}}\n" +
    "            </div>\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"email\">{{'LABEL.EMAIL' | translate}}:</label>\n" +
    "                <input type=\"text\" id=\"email\" name=\"email\" class=\"form-control\" autofill ng-model=\"vm.email\" placeholder=\"Email\"/>\n" +
    "            </div>\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"email\">{{'LABEL.PASSWORD' | translate}}:</label>\n" +
    "                <input type=\"password\" id=\"password\" name=\"password\" class=\"form-control\" autofill ng-model=\"vm.password\" placeholder=\"Password\"/>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"footer\">\n" +
    "            <input value=\"{{'LABEL.SIGNIN' | translate}}\" type=\"submit\" ng-enabled=\"vm.showLogin\" class=\"btn btn-block btn-success\" />\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-12 registration-link\">\n" +
    "                    <a href=\"http://bamatex.se/bli-kund\" target=\"_blank\">Är du ny kund? Registrera dig här</a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>");
}]);

angular.module("../common/services/stadiumProductTemplatePickerDialog/stadiumProductTemplatePickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/stadiumProductTemplatePickerDialog/stadiumProductTemplatePickerDialog.tpl.html",
    "<div class=\"dialog stadium-template-picker-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a \n" +
    "            class=\"close\" \n" +
    "            ng-click=\"vm.dismiss()\"\n" +
    "        >\n" +
    "                ×\n" +
    "        </a>\n" +
    "        <div \n" +
    "            class=\"modal-title\" \n" +
    "            translate\n" +
    "        >\n" +
    "            {{::'STADIUM.PRODUCT_TEMPLATE.PICKER.TITLE'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-offset-2 col-xs-8 col-xs-offset-2 \">\n" +
    "                <ui-select ng-model=\"vm.selectedClub\" on-select=\"vm.onSelectClub()\">\n" +
    "                    <ui-select-match placeholder=\"{{ 'MOUNTING.PLACEHOLDERCLUB' | translate }}\">\n" +
    "                        {{ $select.selected }}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"club in vm.clubs | filter: $select.search | limitTo: 100 track by club\">\n" +
    "                        <span class=\"item-name\">{{ ::club }}</span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-offset-2 col-xs-8 col-xs-offset-2\">\n" +
    "                <input \n" +
    "                    class=\"form-control input-with-icon input-margin\"\n" +
    "                    ng-keyup=\"$event.keyCode == 13 && vm.onSearch($event)\"\n" +
    "                    placeholder=\"&#xF002; {{'LOGO.DIALOG.UPLOAD.SELECT.SEARCH' | translate}}\"\n" +
    "                    ng-model=\"vm.searchText\"\n" +
    "                    type=\"text\"\n" +
    "                >\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- View products -->\n" +
    "        <div \n" +
    "            class=\"row\"\n" +
    "            ng-if=\"!vm.selectedProduct\"\n" +
    "        >\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"col-xs-3\" ng-repeat=\"product in vm.products\">\n" +
    "                    <div class=\"panel panel-default\">\n" +
    "                        <div class=\"panel-heading\" title=\"{{product.articleId}}\">\n" +
    "                            {{product.articleId}}\n" +
    "                        </div>\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"stadium-product-thumbnail-container\" ng-if=\"product.image\">\n" +
    "                                <img class=\"img-responsive\" ng-src=\"{{vm.getImageUrl(product.image)}}\"/>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-xs-12\">\n" +
    "                                    <div class=\"product-title\" title=\"{{product.articleName}} - {{product.variantName}}\">\n" +
    "                                        {{product.articleName}}\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-xs-12\">\n" +
    "                                    <button\n" +
    "                                        type=\"button\"\n" +
    "                                        class=\"btn btn-sm btn-default product-details-button\"\n" +
    "                                        ng-click=\"vm.onSelectProduct(product.id)\"\n" +
    "                                        translate\n" +
    "                                    >\n" +
    "                                        {{::'BUTTON.SELECT'}}\n" +
    "                                </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-12\">\n" +
    "                    <pagination\n" +
    "                        class=\"pagination-sm\"\n" +
    "                        total-items=\"vm.totalItems\"\n" +
    "                        items-per-page=\"vm.pageSize\"\n" +
    "                        ng-model=\"vm.page\"\n" +
    "                        ng-change=\"vm.pageChanged()\"\n" +
    "                        ng-if=\"vm.totalItems\"\n" +
    "                    >\n" +
    "                    </pagination>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Select template -->\n" +
    "        <div \n" +
    "            class=\"row\" \n" +
    "            ng-if=\"vm.selectedProduct\"\n" +
    "        >\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"col-xs-6\">\n" +
    "                    <div class=\"panel panel-default\">\n" +
    "                        <div class=\"panel-heading\" title=\"{{vm.selectedProduct.articleId}}\">\n" +
    "                            {{vm.selectedProduct.articleId}}\n" +
    "                        </div>\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"stadium-product-thumbnail-container\" ng-if=\"vm.selectedProduct.image\">\n" +
    "                                <img class=\"img-responsive\" ng-src=\"{{vm.getImageUrl(vm.selectedProduct.image)}}\"/>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-xs-12\">\n" +
    "                                    <table class=\"information-table\">\n" +
    "                                        <tbody>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_ARTICLE_NAME' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                {{vm.selectedProduct.articleName}}\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_VARIANT_NAME' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                {{vm.selectedProduct.variantName}}\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_EXTERNAL_CLUB_ID' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                {{vm.selectedProduct.externalClubId}}\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_CLUB_NAME' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                {{vm.selectedProduct.clubName}}\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_SPONSORING' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                <input \n" +
    "                                                    type=\"checkbox\" \n" +
    "                                                    ng-model=\"vm.selectedProduct.sponsoring\" \n" +
    "                                                    disabled\n" +
    "                                                >\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_CHANNELS' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                <ul class=\"channels-list\">\n" +
    "                                                    <li \n" +
    "                                                        class=\"col-xs-12\" \n" +
    "                                                        ng-repeat=\"channel in vm.selectedProduct.channels\"\n" +
    "                                                    >\n" +
    "                                                        {{channel}}\n" +
    "                                                    </li>\n" +
    "                                                </ul>\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_CHANNELS_ONLY_B2B' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                <input \n" +
    "                                                    type=\"checkbox\" \n" +
    "                                                    ng-model=\"vm.selectedProduct.onlyB2BSharing\"\n" +
    "                                                    disabled\n" +
    "                                                >\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        </tbody>\n" +
    "                                    </table>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-6\">\n" +
    "                    <div class=\"panel panel-default\">\n" +
    "                        <div \n" +
    "                            class=\"panel-heading\"\n" +
    "                            translate\n" +
    "                        >\n" +
    "                            {{::'LABEL.SELECTTEMPLATE'}}\n" +
    "                        </div>\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"col-xs-12 main-template\">\n" +
    "                                <label \n" +
    "                                    class=\"title\"\n" +
    "                                    translate\n" +
    "                                >\n" +
    "                                    {{::'STADIUM.PRODUCT_MAIN_TEMPLATE'}}\n" +
    "                                </label>\n" +
    "                                <div ng-if=\"vm.selectedProduct.mainTemplate\">\n" +
    "                                    <input\n" +
    "                                            type=\"radio\"\n" +
    "                                            id=\"mainTemplate\"\n" +
    "                                            value=\"{{vm.selectedProduct.mainTemplate.templateId}}\"\n" +
    "                                            name=\"template\"\n" +
    "                                            ng-model=\"vm.selectedTemplate\"\n" +
    "                                    >\n" +
    "                                    <label\n" +
    "                                            class=\"template-name\"\n" +
    "                                            for=\"mainTemplate\"\n" +
    "                                            translate\n" +
    "                                    >\n" +
    "                                        {{::'STADIUM.PRODUCT_MAIN_TEMPLATE'}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-xs-12 team-templates\">\n" +
    "                                <label \n" +
    "                                    class=\"title\"\n" +
    "                                    translate\n" +
    "                                >\n" +
    "                                    {{::'LABEL.TEAM'}}\n" +
    "                                </label>\n" +
    "                                <div \n" +
    "                                    ng-repeat=\"teamTemplate in vm.selectedProduct.teamTemplates\"\n" +
    "                                >\n" +
    "                                    <input \n" +
    "                                        type=\"radio\" \n" +
    "                                        id=\"{{teamTemplate.templateId}}\" \n" +
    "                                        value=\"{{teamTemplate.templateId}}\" \n" +
    "                                        name=\"template\"\n" +
    "                                        ng-model=\"vm.selectedTemplate\"\n" +
    "                                    >\n" +
    "                                    <label \n" +
    "                                        class=\"template-name\" \n" +
    "                                        for=\"{{teamTemplate.templateId}}\"\n" +
    "                                    >\n" +
    "                                        {{teamTemplate.team}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button\n" +
    "            type=\"button\"\n" +
    "            class=\"btn btn-default pull-left\"\n" +
    "            ng-if=\"vm.selectedProduct\"\n" +
    "            ng-click=\"vm.clearSelectedProduct()\"\n" +
    "            translate\n" +
    "        >\n" +
    "            {{::'BUTTON.BACK'}}\n" +
    "        </button>\n" +
    "        <button \n" +
    "            type=\"button\" \n" +
    "            ng-click=\"vm.close()\" \n" +
    "            ng-disabled=\"!vm.selectedTemplate\" \n" +
    "            class=\"btn choose\"\n" +
    "            ng-class=\"{ 'btn-success': vm.selectedTemplate, 'btn-default': !vm.selectedTemplate }\" \n" +
    "            translate\n" +
    "        >\n" +
    "            {{::'BUTTON.APPLY'}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/stadiumStockDialog/stadiumStockDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/stadiumStockDialog/stadiumStockDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'STADIUM.EDITSTOCK' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body row\">\n" +
    "        <div class=\"col-md-offset-1 col-md-10\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            {{'STADIUM.MINIMUMSTOCK' | translate}}\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div counter=\"\" class=\"btn-group-vertical\" value=\"vm.minimumStock\" min=\"vm.minQuantity\"></div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            {{'STADIUM.REFILLVOLUME' | translate}}\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div counter=\"\" class=\"btn-group-vertical\" value=\"vm.refillVolume\" min=\"vm.minQuantity\"></div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CANCEL' | translate}}\n" +
    "        </button>\n" +
    "        <button name=\"save\" type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\">\n" +
    "            {{'BUTTON.SAVE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/templateCartDialog/templateCartDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/templateCartDialog/templateCartDialog.tpl.html",
    "<div class=\"dialog template-dialog\" tabindex=\"-1\">\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <table class=\"table\">\n" +
    "                <tbody>\n" +
    "                    <tr ng-repeat=\"item in vm.cartItems\">\n" +
    "                        <td>\n" +
    "                            <span ng-if=\"item.productType\">\n" +
    "                                {{'PRODUCT.TYPE.' + item.productType | translate}}\n" +
    "                            </span>\n" +
    "                            <span ng-if=\"!item.productType\">\n" +
    "                                {{item.id}}\n" +
    "                            </span>\n" +
    "                            <br>\n" +
    "                            {{item.name}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <button ng-disabled=\"item.added\"\n" +
    "                                    ng-click=\"vm.addItem(item)\"\n" +
    "                                    class=\"btn btn-sm btn-success\">\n" +
    "                                    {{'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATE' | translate}}\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <!-- Buttons -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"button-input\">\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"vm.close()\" translate>\n" +
    "                        {{'BUTTON.CLOSE'}}\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/templateDialog/templateDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/templateDialog/templateDialog.tpl.html",
    "<div class=\"dialog template-dialog\" tabindex=\"-1\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "        <div class=\"modal-title\" ng-if=\"!vm.isTemplate\" translate>\n" +
    "            {{'MOUNTING.ADVANCEDMOUNTING'}}\n" +
    "        </div>\n" +
    "        <div class=\"modal-title\" ng-if=\"vm.isTemplate && !vm.isQuickTemplate\" translate>\n" +
    "            {{'STADIUM.TEMPLATE.DIALOG.CREATE.TITLE'}}\n" +
    "        </div>\n" +
    "        <div class=\"modal-title\" ng-if=\"vm.isQuickTemplate && vm.isStadium\" translate>\n" +
    "            {{'STADIUM.TEMPLATE.DIALOG.QUICKTEMPLATE.TITLE'}}\n" +
    "        </div>\n" +
    "        <div class=\"modal-title\" ng-if=\"vm.isQuickTemplate && !vm.isStadium\" translate>\n" +
    "            {{'PLACEMENT.PROOF'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <!-- Warnings -->\n" +
    "        <div class=\"alert alert-warning\" ng-if=\"!vm.nameIsUnique\" translate>\n" +
    "            {{vm.isTemplate ? 'STADIUM.PLACEMENTTEMPLATE.NAMEWARNING' : 'MOUNTING.DIALOGWARNING'}}\n" +
    "        </div>\n" +
    "        <!-- Title -->\n" +
    "        <div class=\"row\" ng-if=\"vm.isStadium\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <span class=\"title\" translate>\n" +
    "                    {{'MOUNTING.SELECTOPTIONS'}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Options -->\n" +
    "        <div class=\"row\" ng-if=\"vm.isStadium\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"radio-group\">\n" +
    "                    <div class=\"radio-row\">\n" +
    "                        <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"new\" id=\"radioNewBlank\"/>\n" +
    "                        <label for=\"radioNewBlank\" translate>\n" +
    "                            {{vm.isTemplate ? 'STADIUM.PLACEMENTTEMPLATE.CREATENEW' : 'MOUNTING.CREATENEWPLACEMENT'}}\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                    <div class=\"radio-row\">\n" +
    "                        <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"copy\" id=\"radioNewExisting\"/>\n" +
    "                        <label for=\"radioNewExisting\" translate>\n" +
    "                            {{vm.isTemplate ? 'STADIUM.PLACEMENTTEMPLATE.COPY' : 'MOUNTING.CREATEEXISTINGPLACEMENT'}}\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Selection -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                    <!-- Club -->\n" +
    "                    <tr ng-if=\"vm.showClubAndCategory()\">\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CLUB'}}</label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <ui-select ng-model=\"vm.selectedClub\" on-select=\"vm.onSelectClub()\" ng-disabled=\"!vm.lockClubAndCategory()\">\n" +
    "                                <ui-select-match placeholder=\"{{'MOUNTING.PLACEHOLDERCLUB' | translate}}\">\n" +
    "                                    {{$select.selected.clubName}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"club in vm.clubs | orderBy: 'clubName' | filter: $select.search\">\n" +
    "                                    <span>{{club.clubName}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Category -->\n" +
    "                    <tr ng-if=\"vm.showClubAndCategory()\">\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CATEGORY'}}</label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <ui-select ng-model=\"vm.selectedCategory\" ng-disabled=\"!vm.selectedClub\">\n" +
    "                                <ui-select-match placeholder=\"{{'MOUNTING.PLACEHOLDERCATEGORY' | translate}}\">\n" +
    "                                    {{$select.selected.categoryName}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"category in vm.categories | orderBy: 'categoryName' | filter: $select.search\">\n" +
    "                                    <span>{{category.categoryName}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Placement -->\n" +
    "                    <tr ng-if=\"vm.showPlacement()\">\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>\n" +
    "                                {{vm.isTemplate ? 'STADIUM.PLACEMENTTEMPLATE.TEMPLATE' : 'MOUNTING.PLACEMENT'}}\n" +
    "                            </label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <ui-select ng-model=\"vm.selectedPlacement\" ng-disabled=\"vm.isTemplate && !vm.selectedCategory\" on-select=\"vm.onSelectPlacement()\">\n" +
    "                                <ui-select-match placeholder=\"{{vm.isTemplate ? ('LABEL.SELECTTEMPLATE' | translate) : ('LABEL.SELECTPLACEMENT' | translate)}}\">\n" +
    "                                    {{$select.selected.templateName | limitTo: 25}}{{$select.selected.templateName.length > 25 ? '...' : ''}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"placement in vm.placements | filter:{templateName:$select.search, archived:false, club:vm.selectedClub.clubId, category:vm.selectedCategory.categoryId} | orderBy: 'templateName'\">\n" +
    "                                    <span>{{placement.templateName}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Garment -->\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.GARMENT'}}</label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <ui-select ng-model=\"vm.selectedGarment\" ng-disabled=\"!vm.selectedPlacement && vm.showPlacement()\">\n" +
    "                                <ui-select-match placeholder=\"{{'LABEL.SELECTGARMENT' | translate}}\">\n" +
    "                                    <span translate>{{$select.selected.value}}</span>\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"garment in vm.garments | translationFilter: $select.search : '' : 'value' | orderBy : 'value'\">\n" +
    "                                    <span translate>{{garment.value}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Name -->\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.NAME'}}</label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input class=\"form-control\" type=\"text\" ng-model=\"vm.name\" title=\"name\">\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Colour -->\n" +
    "                    <tr>\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.COLOUR'}}</label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <div class=\"color-picker\" ng-class=\"{ 'full': (vm.selectedColours.length > 0) }\">\n" +
    "                                <ui-select multiple=\"\" limit=\"1\" ng-model=\"vm.selectedColours\" tagging=\"vm.onNewCustomColour\" tagging-label=\"false\" append-to-body=\"true\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'NAME.PLACEHOLDER.TEXTCOLOUR' | translate }}\">\n" +
    "                                        <div class=\"color-box\" ng-style=\"{'background-color': '#' + $item.code}\"></div>\n" +
    "                                        <span class=\"color-name\">\n" +
    "                                            {{$item.name}}\n" +
    "                                        </span>\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"color in vm.colours | filter:{ name: $select.search }\">\n" +
    "                                        <div class=\"color-box\" ng-style=\"{'background-color': '#' + color.code}\"></div>\n" +
    "                                        <span class=\"color-name\">\n" +
    "                                            {{color.name}}\n" +
    "                                        </span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Description -->\n" +
    "                    <tr ng-if=\"!vm.isQuickTemplate\">\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.DESCRIPTION'}}</label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <textarea class=\"form-control\" ng-model=\"vm.description\" title=\"description\"></textarea>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Created date -->\n" +
    "                    <tr ng-if=\"vm.selectedPlacement !== null\">\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.DATECREATED'}}</label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input class=\"form-control\" type=\"text\" ng-model=\"vm.dateCreated\" title=\"date created\" disabled>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <!-- Buttons -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"button-input\">\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"vm.close()\" translate>\n" +
    "                        {{'BUTTON.CANCEL'}}\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-success\" ng-disabled=\"!vm.isFormValid()\" ng-click=\"vm.createPlacement()\" translate>\n" +
    "                        {{'BUTTON.CREATE'}}\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/templateErrorDialog/templateErrorDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/templateErrorDialog/templateErrorDialog.tpl.html",
    "<div class=\"dialog stadium-template-error\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\" translate>{{'STADIUM.TEMPLATE.WARNING.ERRORS'}}</div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12 name\">\n" +
    "                <strong>{{vm.template.templateName}}</strong>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\" style=\"padding-bottom: 25px\" translate>\n" +
    "                {{'STADIUM.TEMPLATE.WARNING.ERRORS.DESCRIPTION'}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"pull-right\">\n" +
    "                    <button class=\"btn btn-warning\" ng-click=\"vm.goToTemplate()\" translate>{{'INCOMINGORDERS.GOTOTEMPLATE1'}}</button>\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"vm.close()\" translate>{{'BUTTON.CLOSE'}}</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("../common/services/templatePickerDialog/templatePickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/templatePickerDialog/templatePickerDialog.tpl.html",
    "<div class=\"dialog stadium-template-picker\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "        <div class=\"modal-title\" translate>\n" +
    "            {{'STADIUM.TEMPLATE.PICKER.TITLE'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <table class=\"table table-responsive\">\n" +
    "                    <tbody>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CLUB'}}</td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div>\n" +
    "                                <ui-select ng-model=\"vm.selectedClub\" on-select=\"vm.onSelectClub()\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'MOUNTING.PLACEHOLDERCLUB' | translate }}\">\n" +
    "                                        {{ $select.selected.clubName }}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"club in vm.clubs | filter: $select.search\">\n" +
    "                                        <span class=\"item-name\">{{ club.clubName }}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CATEGORY'}}</td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div>\n" +
    "                                <ui-select ng-model=\"vm.selectedCategory\" on-select=\"vm.onSelectCategory()\" ng-disabled=\"vm.selectedClub === null\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'MOUNTING.PLACEHOLDERCATEGORY' | translate }}\">\n" +
    "                                        {{ $select.selected.categoryName }}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"category in vm.categories | filter: $select.search\">\n" +
    "                                        <span class=\"item-name\">{{ category.categoryName }}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\" translate>{{'STADIUM.PLACEMENTTEMPLATE.TEMPLATE'}}</td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div>\n" +
    "                                <ui-select ng-model=\"vm.selectedTemplate\" ng-disabled=\"vm.selectedClub === null || vm.selectedCategory === null\" title=\"{{$select.selected.templateName}}\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'STADIUM.PLACEMENTTEMPLATE.TEMPLATEPLACEHOLDER' | translate }}\" allow-clear=\"true\">\n" +
    "                                        {{$select.selected.templateName | limitTo: 40}}{{$select.selected.templateName.length > 40 ? '...' : ''}}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"template in vm.templates | orderBy: 'templateName' | filter:{templateName:$select.search} | filter:{club:vm.selectedClub.clubId} | filter:{category:vm.selectedCategory.categoryId}\">\n" +
    "                                        <span class=\"item-name\">{{ template.templateName }}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "                <div ng-show=\"vm.selectedTemplate\">\n" +
    "                    <div class=\"panel picker-panel\">\n" +
    "                        <div class=\"panel-body picker-panel-body\">\n" +
    "                            <h4 class=\"text-center\" title=\"{{vm.selectedTemplate.templateName}}\">\n" +
    "                                {{vm.selectedTemplate.templateName | limitTo: 40}}{{vm.selectedTemplate.templateName.length > 40 ? '...' : ''}}\n" +
    "                            </h4>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"panel\">\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <p class=\"col-xs-6\"><strong>{{'MOUNTING.GARMENT' | translate}}: </strong>{{'GARMENT.TYPE.' + vm.selectedTemplate.garment | translate}}</p>\n" +
    "                                <p class=\"col-xs-6\"><strong>{{'MOUNTING.COLOUR' | translate}}: </strong>{{vm.selectedTemplate.colour}}</p>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <p class=\"col-xs-12\"><strong>{{'MOUNTING.DESCRIPTION' | translate}}: </strong>{{vm.selectedTemplate.description}}</p>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-show=\"!vm.selectedTemplate && vm.suggestionList.length > 0\">\n" +
    "                    <div class=\"panel picker-panel\">\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <h4 class=\"text-center\" translate>{{'STADIUM.TEMPLATE.PICKER.SUGGESTION.TITLE'}}</h4>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"panel\" ng-repeat=\"suggestion in vm.suggestionList.slice(0, vm.suggestionLimit)\">\n" +
    "                        <div class=\"panel-body picker-panel-body\">\n" +
    "                            <div class=\"col-xs-12\">\n" +
    "                                <div class=\"row\">\n" +
    "                                    <h5 class=\"col-xs-12\" title=\"{{suggestion.templateName}}\">\n" +
    "                                        {{suggestion.templateName | limitTo: 50}}{{suggestion.templateName.length > 50 ? '...' : ''}}\n" +
    "                                    </h5>\n" +
    "                                </div>\n" +
    "                                <div class=\"row\">\n" +
    "                                    <p class=\"col-xs-6\"><strong>{{'MOUNTING.GARMENT' | translate}}: </strong>{{'GARMENT.TYPE.' + suggestion.garment | translate}}</p>\n" +
    "                                    <p class=\"col-xs-6\"><strong>{{'MOUNTING.COLOUR' | translate}}: </strong>{{suggestion.colour}}</p>\n" +
    "                                </div>\n" +
    "                                <div class=\"row\">\n" +
    "                                    <p class=\"col-xs-9\"><strong>{{'MOUNTING.DESCRIPTION' | translate}}: </strong>{{suggestion.description}}</p>\n" +
    "                                    <button class=\"btn btn-primary btn-success pull-right picker-button\" ng-click=\"vm.closeWithSuggestion(suggestion)\" translate>{{'BUTTON.APPLY'}}</button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"choose\" type=\"button\" ng-click=\"vm.close()\" ng-disabled=\"!vm.selectedTemplate\" class=\"btn choose\"\n" +
    "                ng-class=\"{ 'btn-success': vm.selectedTemplate, 'btn-default': !vm.selectedTemplate }\" translate>\n" +
    "            {{vm.filterData ? 'BUTTON.APPLY' : 'TOOLTIP.EDIT'}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/templatePrices/templatePriceDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/templatePrices/templatePriceDialog.tpl.html",
    "<div class=\"dialog template-dialog\" tabindex=\"-1\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">{{'MOUNTING.PRICEDIALOG' | translate}}</div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"table-responsive\">\n" +
    "            <table class=\"table\">\n" +
    "                <thead>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'ARTICLE.NUMBER' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'ARTICLE.NAME' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'LABEL.QUANTITY' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'ARTICLE.UNITPRICE' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'ARTICLE.TOTALPRICE' | translate}}\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                </thead>\n" +
    "                <tbody ng-if=\"vm.garment.type\">\n" +
    "                    <tr ng-repeat=\"price in vm.prices\">\n" +
    "                        <td>\n" +
    "                            {{price.articleNumber}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <span ng-if=\"price.scopeType\">\n" +
    "                                {{'NAME.PLAYERLISTTYPE.' + price.scopeType | translate}}\n" +
    "                                <br />\n" +
    "                            </span>\n" +
    "                            <span ng-if=\"price.articleType && !price.scopeType && !price.garment\">\n" +
    "                                {{'PRODUCT.TYPE.' + price.articleType | translate}}\n" +
    "                                <br />\n" +
    "                            </span>\n" +
    "                            {{price.name}}\n" +
    "                        </td>\n" +
    "                        <td>{{price.quantity}}</td>\n" +
    "                        <td>{{price.unitPrice}}</td>\n" +
    "                        <td>{{price.totalPrice}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td></td>\n" +
    "                        <td>\n" +
    "                            {{'LABEL.GARMENT' | translate}}<br />\n" +
    "                            {{'GARMENT.TYPE.' + vm.garment.type | translate}}\n" +
    "                        </td>\n" +
    "                        <td>{{vm.garment.quantity}}</td>\n" +
    "                        <td>-</td>\n" +
    "                        <td>-</td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        <hr>\n" +
    "        <div ng-repeat=\"cost in vm.costs\">\n" +
    "            <b>{{'COST.' + cost.type | translate}}:</b> {{cost.price}}\n" +
    "        </div>\n" +
    "        <hr>\n" +
    "        <div>\n" +
    "            <b>{{'COST.TOTAL' | translate}}:</b> {{vm.total}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-default\" ng-click=\"vm.close()\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../common/services/textAreaDialog/textAreaDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("../common/services/textAreaDialog/textAreaDialog.tpl.html",
    "<div class=\"textarea-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">x</a>\n" +
    "\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{ vm.title }}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-body\">\n" +
    "        <textarea ng-model=\"vm.text\" disabled></textarea>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <button class=\"btn btn-default\" ng-click=\"vm.close()\">{{'BUTTON.CLOSE' | translate}}</button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module('templates-common', ['directives/addToCartButton/addToCartButton.tpl.html', 'directives/addToTemplateButton/addToTemplateButton.tpl.html', 'directives/adminInput/adminInput.tpl.html', 'directives/breadcrumbs/breadcrumbs.tpl.html', 'directives/calculatorPriceTable/calculatorPriceTable.tpl.html', 'directives/loadSpinner/loadSpinner.tpl.html', 'directives/namePreview/namePreview.tpl.html', 'directives/priceTable/priceTable.tpl.html', 'directives/stockTable/stockTable.tpl.html', 'directives/userBox/userBox.tpl.html', 'services/backsidePickerDialog/backsidePickerDialog.tpl.html', 'services/colorPickerDialog/colorPickerDialog.tpl.html', 'services/confirmDialog/confirmDialog.tpl.html', 'services/cookieConsent/cookieConsentDialog/cookieConsentDialog.tpl.html', 'services/customerPickerDialog/customerPickerDialog.tpl.html', 'services/emailDialog/emailDialog.tpl.html', 'services/garmentPicker/garmentPicker.tpl.html', 'services/logoImageDialog/logoDialog-edit.tpl.html', 'services/logoImageDialog/logoDialog-saveAs.tpl.html', 'services/logoImageDialog/logoDialog-upload.tpl.html', 'services/manufacturingDialog/manufacturingDialog.tpl.html', 'services/manufacturingDialog/manufacturingDialogDefault.tpl.html', 'services/manufacturingDialog/manufacturingDialogSuccess.tpl.html', 'services/playerDialog/playerDialog.tpl.html', 'services/playerGroupDialog/playerGroupDialog.tpl.html', 'services/proofDialog/proofDialog.tpl.html', 'services/savedCartDialog/savedCartDialog.tpl.html', 'services/security/loginDialog/loginDialog.tpl.html', 'services/stadiumProductTemplatePickerDialog/stadiumProductTemplatePickerDialog.tpl.html', 'services/stadiumStockDialog/stadiumStockDialog.tpl.html', 'services/templateCartDialog/templateCartDialog.tpl.html', 'services/templateDialog/templateDialog.tpl.html', 'services/templateErrorDialog/templateErrorDialog.tpl.html', 'services/templatePickerDialog/templatePickerDialog.tpl.html', 'services/templatePrices/templatePriceDialog.tpl.html', 'services/textAreaDialog/textAreaDialog.tpl.html']);

angular.module("directives/addToCartButton/addToCartButton.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/addToCartButton/addToCartButton.tpl.html",
    "<div class=\"btn-group \" role=\"group\" aria-label=\"...\">\n" +
    "    <button class=\"btn btn-success {{vm.buttonClass}}\" ng-disabled=\"vm.article.quantity < vm.article.minimumQuantity || vm.disabled\" href=\"\" ladda=\"vm.isLoading\" data-style=\"slide-left\" single-click=\"vm.addToCart(vm.article)\" translate>CART.ADDTOCART</button>\n" +
    "    <button type=\"button\" ng-if=\"vm.isInCart(vm.article.id)\" class=\"btn {{vm.buttonClass}} btn-success disabled\"><i class=\"fa fa-shopping-cart\"></i> {{vm.cartQty(vm.article.id)}}</button>\n" +
    "</div>");
}]);

angular.module("directives/addToTemplateButton/addToTemplateButton.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/addToTemplateButton/addToTemplateButton.tpl.html",
    "<div aria-label=\"...\" class=\"btn-group \" role=\"group\">\n" +
    "    <button\n" +
    "            class=\"btn btn-success {{vm.buttonClass}}\"\n" +
    "            data-style=\"slide-left\"\n" +
    "            href=\"\"\n" +
    "            ladda=\"vm.isLoading\"\n" +
    "            ng-disabled=\"vm.disabled || vm.isOnTemplate\"\n" +
    "            single-click=\"vm.addToTemplate()\"\n" +
    "            translate\n" +
    "    >\n" +
    "        {{'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATE'}}\n" +
    "    </button>\n" +
    "    <button\n" +
    "            class=\"btn {{vm.buttonClass}} btn-success disabled\"\n" +
    "            ng-if=\"vm.isOnTemplate\"\n" +
    "            type=\"button\"\n" +
    "    >\n" +
    "        <i class=\"fa fa-chain\"></i>\n" +
    "    </button>\n" +
    "</div>");
}]);

angular.module("directives/adminInput/adminInput.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/adminInput/adminInput.tpl.html",
    "<div class=\"input-group input-admin counter counter-small\">\n" +
    "    <button ng-if=\"vm.hasAdminValue() || vm.isInvalid()\" ng-click=\"vm.resetAdminValue()\">\n" +
    "        <i class=\"fa fa-remove\"></i>\n" +
    "    </button>\n" +
    "    <input type=\"text\" ng-class=\"{'active': vm.hasAdminValue(), 'invalid': vm.isInvalid()}\" class=\"form-control counter-field\" value=\"{{vm.value}}\" ng-model=\"vm.value\" ng-change=\"vm.changedValue();\" ng-trim=\"false\"/>\n" +
    "</div>\n" +
    "");
}]);

angular.module("directives/breadcrumbs/breadcrumbs.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/breadcrumbs/breadcrumbs.tpl.html",
    "<div class=\"breadcrumbs\">\n" +
    "    <div class=\"row\">\n" +
    "        <ol class=\"breadcrumb\">\n" +
    "            <li ng-repeat=\"link in links\">\n" +
    "                <a\n" +
    "                        href\n" +
    "                        ng-click=\"goBack(link.state)\"\n" +
    "                        ng-if=\"link.state\"\n" +
    "                        translate\n" +
    "                >\n" +
    "                    {{::link.displayName}}\n" +
    "                </a>\n" +
    "                <span\n" +
    "                        ng-if=\"!link.state\"\n" +
    "                        translate\n" +
    "                >\n" +
    "                    {{::link.displayName}}\n" +
    "                </span>\n" +
    "            </li>\n" +
    "        </ol>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("directives/calculatorPriceTable/calculatorPriceTable.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/calculatorPriceTable/calculatorPriceTable.tpl.html",
    "<div class=\"panel panel-default info-panel\">\n" +
    "    <div class=\"panel-heading\">{{'LABEL.PRICE' | translate}}</div>\n" +
    "    <div class=\"price-table\">\n" +
    "        <table class=\"table borderless\">\n" +
    "            <tr ng-repeat=\"price in vm.priceTable\"\n" +
    "                ng-class=\"{'active': vm.isActiveQty(price.key)}\">\n" +
    "                <td class=\"fill\"></td>\n" +
    "                <td class=\"price-title\">{{price.key}}</td>\n" +
    "                <td class=\"price-separator\">:</td>\n" +
    "                <td class=\"price-number\">{{price.value}}</td>\n" +
    "                <td class=\"fill\"></td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("directives/loadSpinner/loadSpinner.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/loadSpinner/loadSpinner.tpl.html",
    "<div class=\"load-spinner\" ng-class=\"{'loading': isLoading}\">\n" +
    "    <span us-spinner=\"{speed:2,trail:20,corners:1,radius:15, width:5, length: 10,lines:15}\" spinner-key=\"{{spinnerName}}\"></span>\n" +
    "</div>");
}]);

angular.module("directives/namePreview/namePreview.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/namePreview/namePreview.tpl.html",
    "<div class=\"panel panel-default info-panel\">\n" +
    "    <div class=\"panel-heading\">{{'NAME.PREVIEW.TITLE' | translate}}</div>\n" +
    "    <div class=\"name-preview\">\n" +
    "        <table class=\"table borderless\">\n" +
    "            <tr ng-repeat=\"player in vm.getBestPlayersToPreview()\">\n" +
    "                <td ng-if=\"vm.showPlayerItem('NAME', player.name)\n" +
    "                           || vm.showPlayerItem('INITIAL', player.initials)\n" +
    "                           || vm.showPlayerItem('DIGIT', player.number)\n" +
    "                           || vm.showPlayerItem('DIGIT', player.smallNumber)\">\n" +
    "                    <div class=\"preview\" ng-style=\"vm.getPreview()\">\n" +
    "                        <span class=\"player-name\" ng-if=\"vm.showPlayerItem('NAME', player.name)\">\n" +
    "                            {{ player.name }}\n" +
    "                        </span>\n" +
    "                        <div ng-class=\"{ 'second-row': vm.showPlayerItem('NAME', player.name) }\"\n" +
    "                             ng-if=\"vm.showPlayerItem('INITIAL', player.initials) || vm.showPlayerItem('DIGIT', player.number) || vm.showPlayerItem('DIGIT', player.smallNumber)\">\n" +
    "                            <span class=\"player-initials\" ng-if=\"vm.showPlayerItem('INITIAL', player.initials)\">\n" +
    "                                {{ player.initials }}\n" +
    "                            </span>\n" +
    "                            <span class=\"player-number\" ng-if=\"vm.showPlayerItem('DIGIT', player.number)\">\n" +
    "                                {{ player.number }}\n" +
    "                            </span>\n" +
    "                            <span class=\"player-small-number\" ng-if=\"vm.showPlayerItem('DIGIT', player.smallNumber)\">\n" +
    "                                {{ player.smallNumber }}\n" +
    "                            </span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("directives/priceTable/priceTable.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/priceTable/priceTable.tpl.html",
    "<div class=\"panel panel-default info-panel\">\n" +
    "    <div class=\"panel-heading\">{{'LABEL.PRICE' | translate}}</div>\n" +
    "    <div class=\"price-table\">\n" +
    "        <table class=\"table borderless\">\n" +
    "            <tr ng-repeat=\"price in vm.priceTable\"\n" +
    "                ng-class=\"{'active': vm.isActiveQty(price.key)}\">\n" +
    "                <td class=\"fill\"></td>\n" +
    "                <td class=\"price-title\">{{price.key}}</td>\n" +
    "                <td class=\"price-separator\">:</td>\n" +
    "                <td class=\"price-number\">{{price.value}}</td>\n" +
    "                <td class=\"fill\"></td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "        <div class=\"price-update\" ng-if=\"vm.user.admin\">\n" +
    "            <button class=\"btn btn-default\" ng-click=\"vm.onClickUpdate()\">\n" +
    "                {{'STOCK.UPDATE' | translate}}\n" +
    "            </button>\n" +
    "            <label>\n" +
    "                {{'STOCK.UPDATED' | translate}}: {{vm.lastUpdate | date : 'yy-MM-dd HH:mm'}}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("directives/stockTable/stockTable.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/stockTable/stockTable.tpl.html",
    "<div class=\"panel panel-default article-panel stock-panel\">\n" +
    "    <div class=\"panel-heading\">\n" +
    "        {{'STOCK.TITLE' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"stock-table\">\n" +
    "        <p ng-if=\"vm.isEmpty\">\n" +
    "            {{'STOCK.NONE' | translate}}\n" +
    "        </p>\n" +
    "        <table class=\"table borderless\" ng-if=\"!vm.isEmpty\">\n" +
    "            <tbody>\n" +
    "                <tr ng-repeat=\"(key, value) in vm.stock.quantityPerLocation\">\n" +
    "                    <td class=\"fill\"></td>\n" +
    "                    <td class=\"stock-title ng-binding\">{{key}}</td>\n" +
    "                    <td class=\"stock-separator\">:</td>\n" +
    "                    <td class=\"stock-number ng-binding\">{{value}}</td>\n" +
    "                    <td class=\"fill\"></td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "        <div class=\"stock-update\">\n" +
    "            <button class=\"btn btn-default\" ng-click=\"vm.onClickUpdate()\">\n" +
    "                {{'STOCK.UPDATE' | translate}}\n" +
    "            </button>\n" +
    "            <label>\n" +
    "                {{'STOCK.UPDATED' | translate}}: {{vm.stock.lastUpdate | date : 'yy-MM-dd HH:mm'}}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("directives/userBox/userBox.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/userBox/userBox.tpl.html",
    "<div class=\"userbox\">\n" +
    "    <span class=\"admin\" ng-click=\"openCustomerPicker()\" ng-if=\"user.admin && !isStadium()\">\n" +
    "        <span ng-if=\"user.orderRecipient\" class=\"active\">\n" +
    "            {{user.orderRecipient.userName + ', ' + user.orderRecipient.customerName}}\n" +
    "        </span>\n" +
    "        <span ng-if=\"!user.orderRecipient\" class=\"inactive\">\n" +
    "            {{'NAVIGATION.NOCUSTOMERACTIVE' | translate}}\n" +
    "        </span>\n" +
    "    </span>\n" +
    "    <span class=\"admin\" ng-click=\"openSavedCartDialog()\" ng-if=\"isStadium()\">\n" +
    "        <span ng-if=\"isStadiumCartSelected()\" class=\"active\">\n" +
    "            <span class=\"text-bold\">\n" +
    "                {{'STADIUMUSER.ORDERREF' | translate}}:\n" +
    "            </span>\n" +
    "            {{user.orderReference | limitTo: 15}}{{user.orderReference.length > 15 ? '&hellip;' : ''}}\n" +
    "            <span class=\"text-bold\">\n" +
    "                {{'STADIUMUSER.ORDERPROJECT' | translate}}:\n" +
    "            </span>\n" +
    "            {{user.orderProject | limitTo: 15}}{{user.orderProject.length > 15 ? '&hellip;' : ''}}\n" +
    "        </span>\n" +
    "        <span ng-if=\"!isStadiumCartSelected()\" class=\"inactive\">\n" +
    "            {{'STADIUMUSER.NOORDERACTIVE' | translate}}\n" +
    "        </span>\n" +
    "    </span>\n" +
    "    <span\n" +
    "        class=\"admin\"\n" +
    "        tooltip=\"{{'STADIUM.CLOSE_ACTIVE_ORDER' | translate}}\"\n" +
    "        ng-if=\"isStadiumCartSelected()\"\n" +
    "        ng-click=\"closeCart()\">\n" +
    "        <i class=\"fa fa-times\"></i>\n" +
    "    </span>\n" +
    "    <span\n" +
    "        class=\"admin\"\n" +
    "        ng-if=\"hasTemplateActive()\"\n" +
    "        ng-click=\"openTemplate()\"\n" +
    "        title=\"{{user.templateName}}\">\n" +
    "            <span class=\"text-bold\">\n" +
    "                {{user.stadium ? 'STADIUM.USERBOX.TEMPLATE' : 'PLACEMENT.PROOF' | translate}}:\n" +
    "            </span>\n" +
    "            {{user.templateName | limitTo: 10}}{{user.templateName.length > 10 ? '...' : ''}}\n" +
    "    </span>\n" +
    "    <span\n" +
    "        class=\"admin\"\n" +
    "        tooltip=\"{{'STADIUM.TEMPLATE.MODE.CLOSE' | translate}}\"\n" +
    "        ng-click=\"closeTemplate()\"\n" +
    "        ng-if=\"hasTemplateActive()\">\n" +
    "            <i class=\"fa fa-times\"></i>\n" +
    "        </span>\n" +
    "    <span class=\"user\">\n" +
    "        <span class=\"user-name\">\n" +
    "            {{user.userName}}\n" +
    "        </span>\n" +
    "    </span>\n" +
    "    <ul class=\"navigation nav\">\n" +
    "        <li class=\"user-menu user-menu-language\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-comment-o\" title=\"{{ 'TOOLTIP.LANGUAGESELECTION' | translate }}\"></i>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li ng-repeat=\"language in availableLanguages track by language.code\" ng-class=\"{ 'disabled': selectedLanguage.name === language.name }\">\n" +
    "                    <a ng-click=\"selectLanguage(language)\" ng-disabled=\"selectedLanguage.name === language.name\" ng-class=\"{ 'selected-language': selectedLanguage.name === language.name }\" class=\"language\">\n" +
    "                        {{ language.name }} ({{ language.code }})\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"!user.admin\" class=\"user-menu user-menu-customer\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-user\"></i>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/history')\" href=\"\">\n" +
    "                        {{'NAVIGATION.ORDERHISTORY' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"logOut()\" href=\"\">\n" +
    "                        {{'NAVIGATION.SIGNOUT' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"user.admin\" class=\"user-menu user-menu-customer\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-user\" title=\"{{'TOOLTIP.CUSTOMERS' | translate}}\"></i>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"openCustomerPicker()\" href=\"\">\n" +
    "                        {{'NAVIGATION.SELECTCUSTOMER' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li ng-class=\"{disabled: !isCustomerChosen()}\">\n" +
    "                    <a ng-click=\"!isCustomerChosen() || go('/customer')\" href=\"\">\n" +
    "                        {{'NAVIGATION.CUSTOMERDETAILS' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li ng-class=\"{disabled: !isCustomerChosen()}\">\n" +
    "                    <a ng-click=\"!isCustomerChosen() || go('/discounts')\" href=\"\">\n" +
    "                        {{'NAVIGATION.DISCOUNTS' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li ng-class=\"{disabled: !isCustomerChosen()}\">\n" +
    "                    <a ng-click=\"!isCustomerChosen() || go('/history')\" href=\"\">\n" +
    "                        {{'NAVIGATION.ORDERHISTORY' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"user.admin\" class=\"user-menu user-menu-admin\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-file-text-o\" title=\"{{'TOOLTIP.PRODUCTIONPLANNING' | translate}}\">\n" +
    "                </i>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/errands')\" href=\"\">\n" +
    "                        {{'NAVIGATION.ERRANDS' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"user.admin\" class=\"user-menu user-menu-admin\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-tasks\" title=\"{{'TOOLTIP.ADMINMENU' | translate}}\">\n" +
    "                </i>\n" +
    "                <span class=\"user-orders\" ng-if=\"isAdminOrderEnabled() || user.pendingOrderCount !== '0'\">\n" +
    "                    <i class=\"fa fa-exclamation\" aria-hidden=\"true\">\n" +
    "                    </i>\n" +
    "                </span>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/pendingorders')\" href=\"\">\n" +
    "                        {{'NAVIGATION.PENDINGORDERS' | translate}}\n" +
    "                        <span class=\"user-orders\" ng-if=\"user.pendingOrderCount !== '0'\">\n" +
    "                            {{user.pendingOrderCount}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/draftorders')\" href=\"\">\n" +
    "                        {{'NAVIGATION.DRAFTORDERS' | translate}}\n" +
    "                        <span class=\"user-orders\" ng-if=\"isAdminOrderEnabled()\">\n" +
    "                            {{user.adminCarts.length}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/controlpanel')\" href=\"\">\n" +
    "                        {{'NAVIGATION.CONTROLPANEL' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/producttypes')\" href=\"\">\n" +
    "                        {{'NAVIGATION.PRODUCTTYPES' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/templatecopy')\" href=\"\">\n" +
    "                        {{'NAVIGATION.COPYTEMPLATES' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"logOut()\" href=\"\">\n" +
    "                        {{'NAVIGATION.SIGNOUT' | translate}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "        <li ng-if=\"user.stadium\" class=\"user-menu user-menu-admin\" dropdown>\n" +
    "            <a href=\"#\" class=\"dropdown-toggle\">\n" +
    "                <i class=\"fa fa-tasks\" title=\"{{'TOOLTIP.STADIUMMENU' | translate}}\">\n" +
    "                </i>\n" +
    "                <span class=\"user-orders\" ng-if=\"isIncomingOrderCount() || isShortageCount()\">\n" +
    "                    <i class=\"fa fa-exclamation\" aria-hidden=\"true\">\n" +
    "                    </i>\n" +
    "                </span>\n" +
    "            </a>\n" +
    "            <ul class=\"dropdown-menu\" role=\"menu\">\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/incomingorders/b2c')\" href=\"\">\n" +
    "                        {{'NAVIGATION.INCOMINGORDERS' | translate}} B2C\n" +
    "                        <span class=\"user-orders\" ng-if=\"isIncomingOrderCountB2C()\">\n" +
    "                            {{user.incomingOrderCountB2C}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                    <a ng-click=\"go('/incomingorders')\" href=\"\">\n" +
    "                        {{'NAVIGATION.INCOMINGORDERS' | translate}} B2B\n" +
    "                        <span class=\"user-orders\" ng-if=\"isIncomingOrderCountB2B()\">\n" +
    "                            {{user.incomingOrderCountB2B}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/shortages')\" href=\"\">\n" +
    "                        {{'NAVIGATION.SHORTAGES' | translate}}\n" +
    "                        <span class=\"user-orders\" ng-if=\"isShortageCount()\">\n" +
    "                            {{user.shortageCount}}\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <a ng-click=\"go('/templateManagement')\" href=\"\" translate>\n" +
    "                        {{'STADIUM.TEMPLATE.MANAGEMENT'}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/backsidePickerDialog/backsidePickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/backsidePickerDialog/backsidePickerDialog.tpl.html",
    "<div class=\"article-create\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">{{'CREATEARTICLE.BACKSIDES' | translate}} {{'GENERAL.FOR' | translate}} {{ vm.article.id }}</div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "    \n" +
    "    \n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"table-responsive form-table\">\n" +
    "            <table class=\"table\">\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        <label class=\"form-label\">{{'CREATEARTICLE.BACKSIDES' | translate}}</label>\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <div ng-class=\"{'backside-picker': !vm.isTemplateMode() }\">\n" +
    "                            <ui-select ng-model=\"vm.selectedBackside\"\n" +
    "                                    append-to-body=\"true\">\n" +
    "                                <ui-select-match\n" +
    "                                        placeholder=\"{{'CREATEARTICLE.BACKSIDES.PLACEHOLDER' | translate}}\">\n" +
    "                                    {{$select.selected.name}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices\n" +
    "                                        repeat=\"backside in vm.availableBacksides(vm.backsides) | filter: $select.search\">\n" +
    "                                    <span>{{'ARTICLE.BACKSIDE.' + backside.id | translate}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </div>\n" +
    "                        <div class=\"input-group-btn top-align\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                            <button class=\"btn btn-success\"\n" +
    "                                    type=\"button\"\n" +
    "                                    ng-click=\"vm.addBackside()\"\n" +
    "                                    ng-disabled=\"!vm.selectedBackside\">\n" +
    "                                {{'BUTTON.ADD' | translate}}\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-repeat=\"backside in vm.selectedBacksides\" ng-if=\"!vm.isTemplateMode()\">\n" +
    "                    <td class=\"full-width\" colspan=\"2\">\n" +
    "                        <div class=\"backside-row col-xs-12\">\n" +
    "                            <div class=\"backside-name-col col-xs-12\">\n" +
    "                                {{backside.name}}\n" +
    "                            </div>\n" +
    "                            <div class=\"backside-counter-col\">\n" +
    "                                <div counter=\"\" class=\"btn-group-vertical\" value=\"backside.quantity\"\n" +
    "                                    min=\"1\"></div>\n" +
    "                            </div>\n" +
    "                            <div class=\"backside-action-col\">\n" +
    "                                <button class=\"btn btn-default\"\n" +
    "                                        type=\"button\"\n" +
    "                                        ng-click=\"vm.removeBackside(backside)\">\n" +
    "                                    <i class=\"fa fa-trash\"></i>\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td></td>\n" +
    "                    <td>\n" +
    "                        <div class=\"text-right\">\n" +
    "                            <button confirm-order-button=\"\"\n" +
    "                                title=\"{{'CART.ADDTOCART' | translate}}\"\n" +
    "                                is-enabled=\"!vm.isDirty && !vm.needsAttention() && vm.isValid\"\n" +
    "                                show-warning-tooltip=\"!vm.isDirty && vm.needsAttention()\"\n" +
    "                                action=\"vm.submit()\">\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "</div>");
}]);

angular.module("services/colorPickerDialog/colorPickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/colorPickerDialog/colorPickerDialog.tpl.html",
    "<div class=\"dialog color-picker\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{ 'COLOURPICKER.SELECTCOLOURS' | translate }}\n" +
    "            <p ng-if=\"vm.customColors\">\n" +
    "                {{ vm.customColors }} {{ 'COLOURPICKER.CUSTOMCOLORS' | translate | lowercase }}\n" +
    "            </p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"color-cell col-md-3 col-sm-4 col-xs-4\" ng-class=\"{ 'active': vm.isSelected(color) }\" ng-repeat=\"color in vm.colors\" ng-click=\"vm.toggleColor(color)\" ng-if=\"color.code || color.imageName\">\n" +
    "                <div ng-if=\"color.code\" class=\"color-header\" ng-style=\"{'background-color': '#' + color.code}\">\n" +
    "                </div>\n" +
    "                <div ng-if=\"color.imageName\" class=\"color-header\" ng-style=\"{'background-image':'url(./assets/images/colours/{{color.imageName}})'}\"></div>\n" +
    "                <span class=\"color-text\">\n" +
    "                    <i class=\"fa fa-check-square\" ng-if=\"vm.isSelected(color)\"></i>\n" +
    "                    {{color.name}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">{{'BUTTON.CLOSE' | translate}}</button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/confirmDialog/confirmDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/confirmDialog/confirmDialog.tpl.html",
    "<div class=\"dialog order-confirmation\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.cancel()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{vm.title | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p>\n" +
    "            <span class=\"confirmation-message\">\n" +
    "                {{vm.question | translate}}\n" +
    "            </span>\n" +
    "        </p>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "         <button ng-repeat=\"button in vm.buttons\" type=\"button\" class=\"btn {{button.class}}\" ng-click=\"vm.onClickButton(button)\">\n" +
    "            {{button.name | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/cookieConsent/cookieConsentDialog/cookieConsentDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/cookieConsent/cookieConsentDialog/cookieConsentDialog.tpl.html",
    "<div class=\"modal-header\">\n" +
    "    <a class=\"close\" ng-click=\"vm.onClickClose()\">×</a>\n" +
    "    <div class=\"modal-title\">\n" +
    "        {{'COOKIECONSENT.TITLE' | translate }}\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"cookies-consent-container\">\n" +
    "    <div class=\"section\">\n" +
    "        {{'COOKIECONSENT.FIRSTSECTION' | translate }}\n" +
    "    </div>\n" +
    "    <div class=\"section\">\n" +
    "        {{'COOKIECONSENT.SECONDSECTION' | translate }}\n" +
    "    </div>\n" +
    "    <div class=\"section\">\n" +
    "        <p><a target=\"_blank\" href=\"{{'COOKIECONSENT.LINK' | translate}}\">\n" +
    "                {{'COOKIECONSENT.LINKTITLE' | translate }}\n" +
    "            </a></p>\n" +
    "    </div>\n" +
    "    <div class=\"btnContainer\">\n" +
    "        <button class=\"btn btn-success\" ng-click=\"vm.onClickGiveConsent()\">\n" +
    "            {{'COOKIECONSENT.APPROVE' | translate }}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("services/customerPickerDialog/customerPickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/customerPickerDialog/customerPickerDialog.tpl.html",
    "<div class=\"dialog customer-picker\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'CUSTOMERPICKER.SELECTCUSTOMER' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div>\n" +
    "            <div class=\"dropdown-box\">\n" +
    "                <span class=\"title\">{{'CUSTOMERPICKER.CUSTOMER' | translate}}</span>\n" +
    "                <ui-select ng-model=\"vm.selectedCustomer\" on-select=\"vm.onCustomerSelect($item)\" class=\"select-customer\">\n" +
    "                    <ui-select-match placeholder=\"{{'LABEL.ENTERCUSTOMER' | translate}}\">\n" +
    "                        {{$select.selected.id}} - {{$select.selected.name}}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"customer in vm.customers | filter:{search:$select.search} | limitTo:50\">\n" +
    "                        <span>{{customer.id}} - {{customer.name}}</span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "            <div class=\"dropdown-box\">\n" +
    "                <span class=\"title\">{{'CUSTOMERPICKER.EMPLOYEE' | translate}}</span>\n" +
    "                <ui-select ng-model=\"vm.selectedEmployee\" on-select=\"vm.onEmployeeSelect($item)\" ng-disabled=\"!vm.selectedCustomer.id\" class=\"select-employee\">\n" +
    "                    <ui-select-match placeholder=\"{{'LABEL.ENTEREMPLOYEE' | translate}}\">\n" +
    "                        {{$select.selected.name}}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"employee in vm.employees | filter:{name:$select.search}\">\n" +
    "                        <span>{{employee.name}}</span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"choose\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default choose\">Choose</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("services/emailDialog/emailDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/emailDialog/emailDialog.tpl.html",
    "<div class=\"dialog email-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.cancel()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{\"EMAILPOPUP.TITLE\" | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p class=\"breadtext\" ng-if=\"vm.isNew()\">\n" +
    "            {{\"EMAILPOPUP.BREADTEXT\" | translate}}\n" +
    "        </p>\n" +
    "        <div class=\"table-responsive\">\n" +
    "            <table class=\"table\">\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{\"EMAILPOPUP.TO\" | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width tags\">\n" +
    "                        <ui-select reset-search-input=\"true\" multiple search-enabled=\"false\" tagging=\"vm.addRecipient\" tagging-label=\"false\"\n" +
    "                                   tagging-tokens=\"ENTER\" ng-model=\"vm.recipients\" ng-if=\"!vm.readOnly\" title=\"\" theme=\"bootstrap\">\n" +
    "                            <ui-select-match placeholder=\"\">{{$item}}</ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"item in []\"></ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                        <div ng-if=\"vm.readOnly\" class=\"ui-select-container ui-select-multiple ui-select-bootstrap\">\n" +
    "                            <span ng-repeat=\"recipient in vm.recipients\" class=\"ui-select-match-item btn btn-default btn-xs recipient-readonly\">\n" +
    "                                {{recipient}}\n" +
    "                            </span>\n" +
    "                        </div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr ng-if=\"vm.visibility.showTemplate\">\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{\"EMAILPOPUP.TEMPLATE\" | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <ui-select ng-model=\"vm.selectedTemplate\" on-select=\"vm.onTemplateSelect()\" ng-disabled=\"vm.readOnly\">\n" +
    "                            <ui-select-match placeholder=\"{{'LABEL.SELECTTEMPLATE' | translate}}\">\n" +
    "                                <span>{{\"EMAILTEMPLATE.\" + $select.selected.name | translate}}</span>\n" +
    "                            </ui-select-match>\n" +
    "                            <ui-select-choices repeat=\"template in vm.templates | translationFilter: $select.search : 'EMAILTEMPLATE.' : 'name'\">\n" +
    "                                <span>{{\"EMAILTEMPLATE.\" + template.name | translate}}</span>\n" +
    "                            </ui-select-choices>\n" +
    "                        </ui-select>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"dynamic-width\">\n" +
    "                        {{\"EMAILPOPUP.SUBJECT\" | translate}}\n" +
    "                    </td>\n" +
    "                    <td class=\"full-width\">\n" +
    "                        <input type=\"text\" name=\"subject\" class=\"form-control\" ng-model=\"vm.subject\" ng-disabled=\"vm.readOnly\"/>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <td class=\"full-width\" colspan=\"2\">\n" +
    "                        <textarea name=\"body\" ng-model=\"vm.body\" class=\"form-control email-body\" ng-disabled=\"vm.readOnly\"></textarea>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"reply\" class=\"btn btn-success\" type=\"button\" ng-click=\"vm.reply()\"  ng-if=\"vm.visibility.showReply\">{{'BUTTON.REPLY' | translate}}</button>\n" +
    "        <button name=\"skip\" type=\"button\" ng-if=\"vm.visibility.showSkip\" ng-click=\"vm.cancel()\" class=\"btn btn-default\">{{'BUTTON.SKIP' | translate}}</button>\n" +
    "        <button name=\"saveDraft\" type=\"button\" ng-disabled=\"!vm.isReady()\" ng-if=\"vm.visibility.showSaveDraft\" ng-click=\"vm.save('DRAFT')\" class=\"btn btn-default\">{{'BUTTON.SAVEDRAFT' | translate}}</button>\n" +
    "        <button name=\"send\" type=\"button\" ng-disabled=\"!vm.isReady()\" ng-if=\"vm.visibility.showSend\" ng-click=\"vm.save('SENT')\" class=\"btn btn-success\">{{'BUTTON.SEND' | translate}}</button>\n" +
    "        <button name=\"close\" type=\"button\" ng-if=\"vm.visibility.showClose\" ng-click=\"vm.cancel()\" class=\"btn btn-default\">{{'BUTTON.CLOSE' | translate}}</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("services/garmentPicker/garmentPicker.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/garmentPicker/garmentPicker.tpl.html",
    "<div class=\"garment-picker-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'LABEL.SELECTGARMENT' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div ng-repeat=\"garment in vm.garments\">\n" +
    "                <div class=\"col-xs-3\">\n" +
    "                    <div class=\"garment-container\">\n" +
    "                        <img ng-src=\"{{'./assets/products/' + garment + '-FRONT.png'}}\" alt=\"Image\">\n" +
    "                        <div class=\"middle\">\n" +
    "                            <div class=\"btn-group\" role=\"group\">\n" +
    "                                <button class=\"btn btn-success\"\n" +
    "                                        type=\"button\"\n" +
    "                                        ng-click=\"vm.select(garment)\">\n" +
    "                                    {{'BUTTON.SELECT' | translate}}\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"garment-container-text-box\">\n" +
    "                            <p>{{('GARMENT.TYPE.' + garment) | translate}}</p>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-default\" ng-click=\"vm.close()\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/logoImageDialog/logoDialog-edit.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/logoImageDialog/logoDialog-edit.tpl.html",
    "<div class=\"process-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.cancel()\">×</a>\n" +
    "        <div class=\"modal-title\" translate>\n" +
    "            {{'LOGO.DIALOG.EDIT.TITLE'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body edit-panel\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-offset-2 col-xs-8 image-background\" id=\"svg-container\">\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-2\">\n" +
    "                <button class=\"btn btn-sm btn-default float-right\" type=\"button\" ng-click=\"vm.reset()\" title=\"{{'BUTTON.RESET' | translate}}\">\n" +
    "                    <i class=\"fa fa-undo\"></i>\n" +
    "                </button>\n" +
    "                <button class=\"btn btn-sm btn-default float-right\" type=\"button\" ng-click=\"vm.undo()\" title=\"{{'BUTTON.UNDO' | translate}}\">\n" +
    "                    <i class=\"fa fa-arrow-left\"></i>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <p class=\"text-center\">\n" +
    "                    {{'LOGO.DIALOG.COLOR.PROOF.INFORMATION' | translate}}\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row last-row\" ng-if=\"!vm.processing\">\n" +
    "            <div class=\"col-xs-4 colour-col\">\n" +
    "                <div class=\"tokyo-panel\">\n" +
    "                    <div class=\"tokyo-panel-header\">\n" +
    "                        <p>{{'LOGO.DIALOG.EDIT.LOGO.COLOURS.TITLE' | translate}}</p>\n" +
    "                    </div>\n" +
    "                    <div class=\"tokyo-panel-body\">\n" +
    "                        <div class=\"col-xs-12 colour-row\" ng-repeat=\"colour in vm.logoColours\" ng-class=\"{'selected-colour-row': vm.selectedColour.code === colour.code}\">\n" +
    "\n" +
    "                            <!-- Colour box -->\n" +
    "                            <div class=\"colour-preview\" ng-style=\"{'background-color': '{{ colour.code }}'}\"></div>\n" +
    "\n" +
    "                            <!-- Colour name / match -->\n" +
    "                            <div class=\"colour-name\" ng-class=\"{'italic': !colour.tokyoColour}\">\n" +
    "                                {{colour.tokyoColour ? colour.tokyoColour.name : 'LOGO.DIALOG.EDIT.SELECT.COLOUR' | translate}}\n" +
    "                            </div>\n" +
    "\n" +
    "                            <!-- Edit and warning -->\n" +
    "                            <div class=\"float-right\">\n" +
    "                                <i class=\"fa fa-warning logo-dialog-warning-icon\"\n" +
    "                                   ng-if=\"!colour.tokyoColour && vm.selectedColour !== colour\"\n" +
    "                                   aria-hidden=\"true\"\n" +
    "                                   title=\"{{'LOGO.DIALOG.EDIT.SELECT.COLOUR.WARNING' | translate}}\">\n" +
    "                                </i>\n" +
    "                                <div class=\"btn-group colour-btn-group\">\n" +
    "                                    <button class=\"btn btn-sm btn-default\"\n" +
    "                                            title=\"{{'LOGO.DIALOG.EDIT.SHOW.COLOUR.CONFIG' | translate}}\"\n" +
    "                                            ng-if=\"!vm.selectedColour || vm.selectedColour !== colour\"\n" +
    "                                            ng-click=\"vm.showColourConfiguration(colour)\">\n" +
    "                                        <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-xs-8 config-col\" ng-if=\"vm.selectedColour\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-xs-12\">\n" +
    "                        <div class=\"tokyo-panel inner-panel\">\n" +
    "                            <div class=\"tokyo-panel-header\">\n" +
    "                                <p>{{'LOGO.DIALOG.EDIT.SUGGESTED.TITLE' | translate}}</p>\n" +
    "                            </div>\n" +
    "                            <div class=\"tokyo-panel-body\">\n" +
    "                                <p class=\"tokyo-panel-information\">\n" +
    "                                    {{'LOGO.DIALOG.EDIT.SUGGESTED.INFORMATION' | translate}}\n" +
    "                                </p>\n" +
    "                                <div class=\"colour-row-suggestions\">\n" +
    "                                    <div class=\"colour-preview-box\"\n" +
    "                                         ng-repeat=\"colour in vm.selectedColour.suggestions | limitTo: 5\"\n" +
    "                                         ng-style=\"{'background-color': '{{ colour.hex }}'}\"\n" +
    "                                         ng-class=\"{'selected-box': vm.selectedColours[0].code === colour.code}\"\n" +
    "                                         tooltip=\"{{colour.name}}\"\n" +
    "                                         ng-click=\"vm.applyColour(colour)\">\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-xs-12\">\n" +
    "                        <div class=\"tokyo-panel inner-panel\">\n" +
    "                            <div class=\"tokyo-panel-header\">\n" +
    "                                <p>{{'LOGO.DIALOG.EDIT.FREE' | translate}}</p>\n" +
    "                            </div>\n" +
    "                            <div class=\"tokyo-panel-body colour-picker-panel\">\n" +
    "                                <div class=\"col-xs-12\">\n" +
    "                                    <div class=\"color-picker input-group\" ng-class=\"{ 'full': vm.maxSelectedColours === vm.selectedColours.length }\">\n" +
    "                                        <ui-select multiple\n" +
    "                                                   limit=\"{{vm.maxSelectedColours}}\"\n" +
    "                                                   ng-model=\"::vm.selectedColours\"\n" +
    "                                                   on-select=\"vm.applyColour($item)\"\n" +
    "                                                   tagging=\"vm.addColour\"\n" +
    "                                                   tagging-label=\"false\"\n" +
    "                                                   tagging-tokens=\"ENTER|TAB\"\n" +
    "                                                   append-to-body=\"true\">\n" +
    "                                            <ui-select-match placeholder=\"{{'LABEL.ENTERCOLOR' | translate | stringular : (vm.maxSelectedColours - vm.selectedColours.length) + '' }}\">\n" +
    "                                                <div class=\"color-box\" ng-style=\"{'background-color': '#' + $item.code}\">\n" +
    "                                                    <span ng-if=\"!$item.code\">PMS</span>\n" +
    "                                                </div>\n" +
    "                                                <span class=\"item-name\">{{$item.name}}</span>\n" +
    "                                            </ui-select-match>\n" +
    "                                            <ui-select-choices repeat=\"colour in vm.productColours | filter:{name:$select.search}\" ng-model=\"::vm.productColours\">\n" +
    "                                                <div class=\"color-box\" ng-style=\"{'background-color': '#' + colour.code}\"></div>\n" +
    "                                                <span class=\"item-name\">{{colour.name}}</span>\n" +
    "                                            </ui-select-choices>\n" +
    "                                        </ui-select>\n" +
    "                                        <div class=\"input-group-btn top-align\" ng-if=\"vm.productType.colourType !== 'NONE'\">\n" +
    "                                            <button type=\"button\" ng-click=\"vm.openColourPicker()\"\n" +
    "                                                    class=\"btn btn-default\" tabindex=\"9\" title=\"{{'TOOLTIP.COLOURPICKER' | translate}}\">\n" +
    "                                                <i class=\"fa fa-th\"></i>\n" +
    "                                            </button>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row last-row\" ng-if=\"vm.processing\">\n" +
    "            <div class=\"col-xs-12\" >\n" +
    "                <div class=\"progress progress-striped active\">\n" +
    "                    <div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <p class=\"progress-text\">{{'LOGO.DIALOG.CONVERTING.MESSAGE' | translate}}</p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <div class=\"row\" ng-if=\"!vm.processing\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"float-right\">\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.saveAs()\" ng-disabled=\"vm.processing || !vm.validateColours()\">\n" +
    "                        {{'BUTTON.SAVEAS' | translate}}\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"vm.processing || !vm.validateColours()\">\n" +
    "                        {{'BUTTON.SAVE' | translate}}\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">\n" +
    "                        {{'BUTTON.CANCEL' | translate}}\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/logoImageDialog/logoDialog-saveAs.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/logoImageDialog/logoDialog-saveAs.tpl.html",
    "<div class=\"modal-header\">\n" +
    "    <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "    <div class=\"modal-title\" translate>\n" +
    "        {{'LOGO.DIALOG.SAVEAS.TITLE'}}\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-body save-as\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"alert alert-warning\" ng-show=\"!vm.valid\">\n" +
    "            <span>{{'CREATEARTICLE.NAMEREQUIRED' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <label for=\"logoImageName\" class=\"col-xs-2 control-label\">\n" +
    "            {{'ARTICLE.NAME' | translate}}\n" +
    "        </label>\n" +
    "        <div class=\"col-xs-10\">\n" +
    "            <input type=\"text\" class=\"form-control\" ng-model=\"vm.name\" id=\"logoImageName\" required=\"\" ng-change=\"vm.valid = true\"/>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"float-right\">\n" +
    "                <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.save()\">\n" +
    "                    {{'BUTTON.SAVE' | translate}}\n" +
    "                </button>\n" +
    "                <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.dismiss()\">\n" +
    "                    {{'BUTTON.CANCEL' | translate}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("services/logoImageDialog/logoDialog-upload.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/logoImageDialog/logoDialog-upload.tpl.html",
    "<div class=\"modal-header\">\n" +
    "    <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "    <div class=\"modal-title\" translate>\n" +
    "        {{'LOGO.DIALOG.UPLOAD.TITLE'}}\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <!-- Upload -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"panel upload-panel\">\n" +
    "                <div class=\"panel-heading\" translate>\n" +
    "                    {{'LOGO.DIALOG.UPLOAD.ADD.TITLE'}}\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\" ng-if=\"vm.processing\">\n" +
    "                    <div class=\"progress progress-striped active\">\n" +
    "                        <div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <p class=\"progress-text\">\n" +
    "                        {{'LOGO.DIALOG.CONVERTING.MESSAGE' | translate}}\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\" ng-if=\"!vm.processing\">\n" +
    "                    <div class=\"alert alert-warning\" ng-if=\"vm.nameError\" translate>\n" +
    "                        {{'LOGO.DIALOG.UPLOAD.ERROR.NAME'}}\n" +
    "                    </div>\n" +
    "                    <div class=\"alert alert-warning\" ng-if=\"vm.fileError\" translate>\n" +
    "                        {{'LOGO.DIALOG.UPLOAD.ERROR.FILE'}}\n" +
    "                    </div>\n" +
    "                    <form class=\"form-horizontal\">\n" +
    "                        <div class=\"alert alert-warning col-xs-12\" ng-if=\"vm.error\">\n" +
    "                            <div ng-repeat=\"errorMessage in vm.errorMessages\" class=\"col-xs-12\">\n" +
    "                                {{errorMessage}}\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"form-group\">\n" +
    "                            <label for=\"logoImageName\" class=\"col-xs-2 control-label\" translate>\n" +
    "                                {{'LOGO.DIALOG.UPLOAD.ADD.NAME'}}\n" +
    "                            </label>\n" +
    "                            <div class=\"col-xs-10\">\n" +
    "                                <input type=\"text\" class=\"form-control upload-textfield\" id=\"logoImageName\" placeholder=\"{{'LOGO.DIALOG.UPLOAD.ADD.PLACEHOLDER' | translate}}\" ng-model=\"vm.logoImageName\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"form-group bottom-form-group\">\n" +
    "                            <div class=\"col-xs-offset-2 col-xs-8\">\n" +
    "                                <button ng-file-select class=\"btn btn-default btn-with-icon upload-button\" ng-model=\"vm.uploadImage\" ng-accept=\"vm.onFileSelect($file)\" accept=\"{{vm.acceptableFormats}}\"\n" +
    "                                        ng-multiple=\"false\" ng-click=\"$event.preventDefault()\" title=\"{{vm.uploadImageName}}\">\n" +
    "                                    <span ng-if=\"!vm.uploadImage\"><i class=\"fa fa-image\"></i>{{'LOGO.DIALOG.UPLOAD.ADD.BUTTON' | translate}}</span>\n" +
    "                                    <span ng-if=\"vm.uploadImage\"><i class=\"fa fa-cloud-upload\"></i>{{vm.uploadImageName}}</span>\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-xs-2\">\n" +
    "                                <button type=\"button\" class=\"btn btn-success float-right\" ng-click=\"vm.saveImage()\" translate>{{'BUTTON.SAVE'}}</button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </form>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Selection -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"panel upload-panel bottom-upload-panel\">\n" +
    "                <div class=\"panel-heading col-xs-12\">\n" +
    "                    <div class=\"col-xs-offset-4 col-xs-4 panel-heading-title\">\n" +
    "                        <p translate>{{'LOGO.DIALOG.UPLOAD.SELECT.TITLE'}}</p>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-xs-4 panel-search-box\">\n" +
    "                       <input class=\"form-control input-with-icon\" ng-model=\"vm.filterText\" placeholder=\"&#xF002; {{'LOGO.DIALOG.UPLOAD.SELECT.SEARCH' | translate}}\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\">\n" +
    "                    <div ng-repeat=\"image in vm.getFilteredImages(vm.filterText)\">\n" +
    "                        <div class=\"col-xs-3 image-container\">\n" +
    "                            <img class=\"center-cropped image image-background\" ng-src=\"{{vm.getImageUrl(image.logoImageId)}}\" alt=\"Image\">\n" +
    "                            <div class=\"middle\">\n" +
    "                                <p class=\"middle-title\" title=\"{{image.name}}\">{{image.name}}</p>\n" +
    "                                <div class=\"btn-group\" role=\"group\">\n" +
    "                                    <button class=\"btn btn-sm btn-success\" type=\"button\" ng-click=\"vm.selectImage(image)\"\n" +
    "                                            ng-disabled=\"vm.processing\">\n" +
    "                                        {{'BUTTON.SELECT' | translate}}\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-sm btn-warning\" type=\"button\" ng-click=\"vm.editImage(image)\"\n" +
    "                                            ng-disabled=\"vm.processing\">\n" +
    "                                        <i class=\"fa fa-pencil\"></i>\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-sm btn-danger\" type=\"button\" ng-click=\"vm.removeImage(image)\"\n" +
    "                                            ng-disabled=\"vm.processing\">\n" +
    "                                        <i class=\"fa fa-trash\"></i>\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <pagination class=\"pagination\" total-items=\"vm.filteredImages.length\" items-per-page=\"vm.maxSizeImagePage\" ng-model=\"vm.currentImagePage\"></pagination>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <button class=\"btn btn-default float-right\" type=\"button\" ng-click=\"vm.close()\" ng-disabled=\"vm.processing\">\n" +
    "                {{'BUTTON.CLOSE' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("services/manufacturingDialog/manufacturingDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/manufacturingDialog/manufacturingDialog.tpl.html",
    "<div class=\"manufacturing-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">{{ 'STADIUM.ADDITIONALMANUFACTURING' | translate }}</div>\n" +
    "    </div>\n" +
    "    <div ng-include=\"vm.contentTemplate\"></div>\n" +
    "</div>");
}]);

angular.module("services/manufacturingDialog/manufacturingDialogDefault.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/manufacturingDialog/manufacturingDialogDefault.tpl.html",
    "<div class=\"modal-body\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-6\">\n" +
    "            <table class=\"table\">\n" +
    "                <tbody>\n" +
    "                    <tr>\n" +
    "                        <td class=\"col-xs-6\" translate>\n" +
    "                            {{::'STADIUM.ARTNR'}}\n" +
    "                        </td>\n" +
    "                        <td class=\"col-xs-6\">\n" +
    "                            {{vm.article.id}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"col-xs-6\" translate>\n" +
    "                            {{::'STADIUM.NAME'}}\n" +
    "                        </td>\n" +
    "                        <td class=\"col-xs-6 name-cell\">\n" +
    "                            {{vm.article.name}}\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td ng-if=\"vm.article.stocked\" class=\"col-xs-6\" translate>\n" +
    "                            {{::'STADIUM.LOGO.MANUFACTURING_QUANTITY'}}\n" +
    "                        </td>\n" +
    "                        <td ng-if=\"!vm.article.stocked\" class=\"col-xs-6\" translate>\n" +
    "                            {{::'STADIUM.LOGO.ORDER_QUANTITY'}}\n" +
    "                        </td>\n" +
    "                        <td class=\"col-xs-6\">\n" +
    "                            <div \n" +
    "                                counter=\"\" \n" +
    "                                is-small=\"true\" \n" +
    "                                class=\"btn-group-vertical\"\n" +
    "                                value=\"vm.quantity\"\n" +
    "                                min=\"vm.minQuantity\"\n" +
    "                            >\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-6\" ng-if=\"vm.article.stocked\">\n" +
    "            <div class=\"panel panel-default info-panel stadium-stock\">\n" +
    "                <div class=\"panel-heading\">{{'STADIUM.STADIUMSTOCK' | translate}}:\n" +
    "                    <button class=\"btn btn-sm btn-default pull-right\"\n" +
    "                            title=\"{{'TOOLTIP.EDIT' | translate}}\"\n" +
    "                            ng-click=\"vm.openStadiumStockDialog()\"\n" +
    "                            ng-disabled=\"!vm.user.admin && !vm.article.canAdjust\">\n" +
    "                        <i class=\"fa fa-pencil\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-sm btn-default pull-right\"\n" +
    "                            title=\"{{'STOCK.UPDATE' | translate}}\"\n" +
    "                            style=\"margin-right: 5px;\"\n" +
    "                            ng-click=\"vm.onStockUpdate()\">\n" +
    "                        <i class=\"fa fa-refresh\" aria-hidden=\"true\">\n" +
    "                        </i>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "                <div class=\"price-table\">\n" +
    "                    <table class=\"table borderless\">\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.STOCK'}}</th>\n" +
    "                            <td>{{vm.stock.stock}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.PRODUCTION'}}</th>\n" +
    "                            <td>{{vm.stock.orderIn}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.ORDERED'}}</th>\n" +
    "                            <td>{{vm.stock.orderOut}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.MINIMUMSTOCK'}}</th>\n" +
    "                            <td>{{vm.stock.minimumStock}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <th translate>{{::'STADIUM.REFILLVOLUME'}}</th>\n" +
    "                            <td>{{vm.stock.refillVolume}}</td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.user.stadium && vm.manufacturingOrders\">\n" +
    "                <div class=\"panel panel-default info-panel stadium-stock\">\n" +
    "                    <div class=\"manufacturing-panel\">\n" +
    "                        <div class=\"panel-heading ng-binding\">\n" +
    "                            {{'STADIUM.MANUFACTURINGORDERS' | translate}}\n" +
    "                        </div>\n" +
    "                        <div class=\"price-table scroll\">\n" +
    "                            <div class=\"panel panel-default inner-manufacturing-panel\">\n" +
    "                                <table class=\"table borderless\">\n" +
    "                                    <tbody>\n" +
    "                                    <tr class=\"panel-heading\">\n" +
    "                                        <th>\n" +
    "                                            {{'STADIUM.DATE' | translate}}\n" +
    "                                        </th>\n" +
    "                                        <th>\n" +
    "                                            {{'STADIUM.QUANTITY' | translate}}\n" +
    "                                        </th>\n" +
    "                                    </tr>\n" +
    "                                    <tr ng-repeat=\"order in vm.manufacturingOrders\">\n" +
    "                                        <td>\n" +
    "                                            {{order.date | date : 'yy-MM-dd'}}\n" +
    "                                        </td>\n" +
    "                                        <td>\n" +
    "                                            {{order.quantity}}\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                    </tbody>\n" +
    "                                </table>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button \n" +
    "        name=\"cancel\" \n" +
    "        tabindex=\"3\"\n" +
    "        type=\"button\" \n" +
    "        ng-click=\"vm.close()\" \n" +
    "        class=\"btn btn-default\"\n" +
    "        translate\n" +
    "    >\n" +
    "        {{::'BUTTON.CANCEL'}}\n" +
    "    </button>\n" +
    "    <button \n" +
    "        class=\"btn btn-success\" \n" +
    "        type=\"button\"\n" +
    "        ng-if=\"!vm.article.stocked\"\n" +
    "        ng-disabled=\"!vm.isValid()\"\n" +
    "        ng-click=\"vm.confirm()\"\n" +
    "        translate\n" +
    "    >\n" +
    "        {{::'BUTTON.ADDTOCART'}}\n" +
    "    </button>\n" +
    "    <button \n" +
    "        name=\"submit\" \n" +
    "        type=\"button\"\n" +
    "        ng-if=\"vm.article.stocked\"\n" +
    "        ng-click=\"vm.confirm()\"\n" +
    "        ng-disabled=\"!vm.isValid()\" \n" +
    "        class=\"btn btn-success\"\n" +
    "        translate\n" +
    "    >\n" +
    "        {{::'BUTTON.SUBMIT'}}\n" +
    "    </button>\n" +
    "</div>");
}]);

angular.module("services/manufacturingDialog/manufacturingDialogSuccess.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/manufacturingDialog/manufacturingDialogSuccess.tpl.html",
    "<div class=\"modal-body\">\n" +
    "    <div class=\"success-contents\">\n" +
    "        <span class=\"success-message\"><i class=\"fa fa-check\"></i> {{'CHECKOUT.ORDERCONFIRMEDMESSAGE' | translate}}</span>\n" +
    "        <span>{{'CHECKOUT.ORDERCONTACTMESSAGE' | translate}}</span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <a class=\"btn btn-block btn-info\" ng-click=\"vm.continueButton()\">{{'BUTTON.CONTINUE' | translate}}</a>\n" +
    "</div>");
}]);

angular.module("services/playerDialog/playerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/playerDialog/playerDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog\">\n" +
    "    <div class=\"player-dialog\">\n" +
    "        <div class=\"modal-header\">\n" +
    "            <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "                ×\n" +
    "            </a>\n" +
    "            <div class=\"modal-title\">\n" +
    "                {{'MOUNTING.PLAYERS' | translate}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body row\" ng-if=\"vm.currentPhase === 1\">\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"!vm.nameIsUnique\">\n" +
    "                {{'MOUNTING.PLAYERDIALOG.CHOOSENEWUNIQUENAME' | translate}}\n" +
    "            </div>\n" +
    "            <div class=\"col-md-offset-1 col-md-10 radio-panel\">\n" +
    "                <div class=\"group\">\n" +
    "                <span class=\"title\">\n" +
    "                    {{'MOUNTING.SELECTOPTIONS' | translate}}\n" +
    "                </span>\n" +
    "                </div>\n" +
    "                <div class=\"group\">\n" +
    "                    <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioNewBlank\" id=\"radioNewBlank\">\n" +
    "                    <label for=\"radioNewBlank\">\n" +
    "                        {{'MOUNTING.CREATENEWPLAYERLIST' | translate}}\n" +
    "                    </label>\n" +
    "                    <br>\n" +
    "                    <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioNewExisting\" id=\"radioNewExisting\">\n" +
    "                    <label for=\"radioNewExisting\">\n" +
    "                        {{'MOUNTING.CREATEEXISTINGPLAYERLIST' | translate}}\n" +
    "                    </label>\n" +
    "                    <br>\n" +
    "                    <input type=\"radio\" checked=\"checked\" ng-model=\"vm.radioChoice\" value=\"radioReuse\" id=\"radioReuse\">\n" +
    "                    <label for=\"radioReuse\">\n" +
    "                        {{'MOUNTING.REUSEEXISTINGPLAYERLIST' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-offset-1 col-md-10\" ng-hide=\"vm.playerLists.length === 0 && vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                <p ng-if=\"vm.radioChoice === 'radioNewBlank'\">\n" +
    "                    {{'MOUNTING.NEWPLAYERLIST' | translate}}:\n" +
    "                </p>\n" +
    "                <p ng-if=\"vm.radioChoice === 'radioNewExisting'\">\n" +
    "                    {{'MOUNTING.SELECTEXISTINGPLAYERLIST' | translate}}:\n" +
    "                </p>\n" +
    "                <p ng-if=\"vm.radioChoice === 'radioReuse'\">\n" +
    "                    {{'MOUNTING.SELECTREUSEEXISTINGPLAYERLIST' | translate}}:\n" +
    "                </p>\n" +
    "                <div class=\"table-responsive\">\n" +
    "                    <table class=\"table\">\n" +
    "                        <tbody>\n" +
    "                        <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'PRODUCTIONPLANNING.PLAYERLIST' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <ui-select on-select=\"vm.onPlayerListSelect($item)\" ng-model=\"vm.selectedPlayerList\">\n" +
    "                                    <ui-select-match placeholder=\"{{'MOUNTING.SELECTPLAYERLIST' | translate}}\">\n" +
    "                                        {{$select.selected.playerListName}}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"playerList in vm.playerLists | filter:$select.search | filter:{imported:false} | orderBy : 'value'\">\n" +
    "                                        <span>{{playerList.playerListName}}</span>\n" +
    "                                        <button class=\"btn-delete pull-right\" ng-click=\"vm.removePlayerList(playerList)\">\n" +
    "                                            <i class=\"fa fa-remove\"></i>\n" +
    "                                        </button>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.radioChoice !== 'radioReuse'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.NAME' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.name\" ng-change=\"vm.checkNameIsUnique()\">\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.DESCRIPTION' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <textarea class=\"form-control\" ng-model=\"vm.description\" ng-disabled=\"vm.radioChoice === 'radioReuse'\"></textarea>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.NUMBEROFROWS' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input type=\"text\" class=\"form-control\" ng-model=\"vm.numberOfRows\" readonly=\"readonly\"/>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                            <td class=\"dynamic-width\">\n" +
    "                                {{'MOUNTING.DATECREATED' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td class=\"full-width\">\n" +
    "                                <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.dateCreated\" readonly=\"readonly\">\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"alert alert-warning no-playerlist\" ng-if=\"vm.playerLists.length === 0 && vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                {{'MOUNTING.PLAYERDIALOG.NOPLAYERLISTS' | translate}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body row\" ng-if=\"vm.currentPhase === 2\">\n" +
    "            <div class=\"alert alert-success\" ng-if=\"vm.sent\">\n" +
    "                An email has been sent\n" +
    "            </div>\n" +
    "            <div class=\"alert alert-danger\" ng-show=\"vm.importError\">\n" +
    "                {{'PLAYERLIST.EXCELERROR' | translate}}\n" +
    "            </div>\n" +
    "            <div class=\"group\">\n" +
    "                <div class=\"player-dialog-title\">\n" +
    "                    {{'MOUNTING.PLAYERDIALOGTITLE' | translate}}\n" +
    "                </div>\n" +
    "                <div class=\"player-dialog-text\">\n" +
    "                    {{'MOUNTING.PLAYERDIALOGTEXT' | translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"visible-lg-block visible-md-block\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <table class=\"table\">\n" +
    "                        <tdead>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.ARTICLE' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.SIZE' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.NAME' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.INITIALS' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.LARGE_NUMBER' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.SMALL_NUMBER' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.COMMENT' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.QUANTITY' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    &nbsp;\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tdead>\n" +
    "                        <tbody>\n" +
    "                            <tr ng-repeat=\"player in vm.players\">\n" +
    "                                <td class=\"col-md-2\">\n" +
    "                                    <input ng-readonly=\"vm.isReadOnly()\" type=\"text\" name=\"articleId\" class=\"form-control\" ng-model=\"player.articleId\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <input type=\"text\" name=\"size\" class=\"form-control\" ng-model=\"player.size\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-2\">\n" +
    "                                    <input type=\"text\" name=\"player-name\" class=\"form-control\" ng-model=\"player.name\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <input type=\"text\" name=\"initials\" class=\"form-control\" ng-model=\"player.initials\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <input type=\"text\" name=\"number\" class=\"form-control\" ng-model=\"player.number\" ng-change=\"vm.addIfLastRow($index); vm.checkNumber($index);\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <input type=\"text\" name=\"smallNumber\" class=\"form-control\" ng-model=\"player.smallNumber\" ng-change=\"vm.addIfLastRow($index); vm.checkNumber($index);\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-3\">\n" +
    "                                    <input type=\"text\" name=\"comment\" class=\"form-control\" ng-model=\"player.comment\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\" ng-if=\"!vm.isReadOnly()\">\n" +
    "                                    <div counter=\"\" class=\"btn-group-vertical\" value=\"player.quantity\" min=\"vm.minQuantity\"></div>\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\" ng-if=\"vm.isReadOnly()\">\n" +
    "                                    <input type=\"text\" class=\"form-control text-right\" ng-model=\"player.quantity\" ng-disabled=\"true\">\n" +
    "                                </td>\n" +
    "                                <td class=\"col-md-1\">\n" +
    "                                    <button class=\"btn btn-default\" ng-click=\"vm.copy($index)\" title=\"{{'TOOLTIP.COPY' | translate}}\" ng-disabled=\"vm.isReadOnly()\">\n" +
    "                                        <i class=\"fa fa-copy\" aria-hidden=\"true\"></i>\n" +
    "                                    </button>\n" +
    "                                    <button class=\"btn btn-default\" ng-click=\"vm.remove($index)\" title=\"{{'TOOLTIP.CLEAR' | translate}}\" ng-disabled=\"vm.isReadOnly()\">\n" +
    "                                        <i class=\"fa fa-trash\" aria-hidden=\"true\"></i>\n" +
    "                                    </button>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"hidden-lg hidden-md\">\n" +
    "                <div class=\"col-md-12 col-sm-8 col-sm-offset-2 col-xs-12\">\n" +
    "                    <table class=\"table\" ng-repeat=\"player in vm.players\" ng-show=\"$index === vm.activePlayerIndex\" ng-swipe-right=\"vm.updateActivePlayer(-1)\" ng-swipe-left=\"vm.updateActivePlayer(1)\">\n" +
    "                        <tbody>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.ARTICLE' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input ng-readonly=\"vm.isReadOnly()\" type=\"text\" name=\"articleId\" class=\"form-control\" ng-model=\"player.articleId\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.SIZE' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"size\" class=\"form-control\" ng-model=\"player.size\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.NAME' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"player-name\" class=\"form-control\" ng-model=\"player.name\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.INITIALS' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"initials\" class=\"form-control\" ng-model=\"player.initials\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.LARGE_NUMBER' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"number\" class=\"form-control\" ng-model=\"player.number\" ng-change=\"vm.addIfLastRow($index); vm.checkNumber($index);\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.SMALL_NUMBER' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"smallNumber\" class=\"form-control\" ng-model=\"player.smallNumber\" ng-change=\"vm.addIfLastRow($index); vm.checkNumber($index);\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.COMMENT' | translate}}\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <input type=\"text\" name=\"comment\" class=\"form-control\" ng-model=\"player.comment\" ng-change=\"vm.addIfLastRow($index)\" ng-readonly=\"vm.isReadOnly()\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    {{'MOUNTING.QUANTITY' | translate}}\n" +
    "                                </td>\n" +
    "                                <td ng-if=\"!vm.isReadOnly()\">\n" +
    "                                    <div counter=\"\" class=\"btn-group-vertical\" value=\"player.quantity\" min=\"vm.minQuantity\"></div>\n" +
    "                                </td>\n" +
    "                                <td ng-if=\"vm.isReadOnly()\">\n" +
    "                                    <input type=\"text\" class=\"form-control text-right\" ng-model=\"player.quantity\" ng-disabled=\"true\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr>\n" +
    "                                <td>\n" +
    "                                    &nbsp;\n" +
    "                                </td>\n" +
    "                                <td>\n" +
    "                                    <button class=\"btn btn-default delete-player\" ng-click=\"vm.remove($index); vm.findNewActivePlayer()\" title=\"{{'TOOLTIP.CLEAR' | translate}}\" ng-disabled=\"vm.isReadOnly()\">\n" +
    "                                        <i class=\"fa fa-trash\" aria-hidden=\"true\"></i>\n" +
    "                                    </button>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                    <div class=\"pagination\">\n" +
    "                        <a href=\"\" ng-click=\"vm.activePlayerIndex > 0 && vm.updateActivePlayer(-1)\" ng-disabled=\"vm.activePlayerIndex === 0\">&laquo;</a>\n" +
    "                        <!-- TODO: show first, `...` (if needed), three around current, `...` (if needed) and last page if there are too many -->\n" +
    "                        <a href=\"\" ng-if=\"$index < vm.players.length - 1 || vm.players.length === 1\" ng-repeat=\"player in vm.players\" ng-click=\"vm.setActivePlayer($index)\" ng-class=\"{ 'active': vm.activePlayerIndex === $index }\">{{ $index + 1 }}</a>\n" +
    "                        <a href=\"\" class=\"new-player\" ng-show=\"vm.players.length > 1\" ng-click=\"vm.setActivePlayer(vm.players.length - 1)\" ng-class=\"{ 'active': vm.activePlayerIndex === vm.players.length - 1 }\">\n" +
    "                            <i class=\"fa fa-plus\"></i>\n" +
    "                        </a>\n" +
    "                        <a href=\"\" ng-click=\"vm.activePlayerIndex < vm.players.length - 2 && vm.updateActivePlayer(1)\" ng-disabled=\"vm.activePlayerIndex >= vm.players.length - 2\">&raquo;</a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"playerlist-panel-outer\" ng-if=\"vm.showSizeSummary\">\n" +
    "                <div class=\"playerlist-panel-header\">\n" +
    "                    <h4>\n" +
    "                        {{'PLAYERLIST.SUMMARY' | translate}}\n" +
    "                    </h4>\n" +
    "                </div>\n" +
    "                <div class=\"playerlist-panel-body playerlist-panel-summary\">\n" +
    "                    <table class=\"table\">\n" +
    "                        <thead>\n" +
    "                        <tr>\n" +
    "                            <th>\n" +
    "                                {{'MOUNTING.SIZE' | translate}}\n" +
    "                            </th>\n" +
    "                            <th>\n" +
    "                                {{'MOUNTING.TOTAL' | translate}}\n" +
    "                            </th>\n" +
    "                        </tr>\n" +
    "                        </thead>\n" +
    "                        <tbody>\n" +
    "                        <tr ng-repeat=\"size in vm.getSizes()\">\n" +
    "                            <td class=\"col-md-2\">\n" +
    "                                {{vm.getSize($index)}}\n" +
    "\n" +
    "                            </td>\n" +
    "                            <td class=\"col-md-1\">\n" +
    "                                {{vm.getTotalRow($index)}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        <tr>\n" +
    "                            <td class=\"player-total\">\n" +
    "                                {{'MOUNTING.TOTAL' | translate}}:\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                {{vm.getTotal()}}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                        </tbody>\n" +
    "                    </table>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\" ng-if=\"vm.currentPhase === 1\">\n" +
    "            <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.CANCEL' | translate}}\">\n" +
    "                {{'BUTTON.CANCEL' | translate}}\n" +
    "            </button>\n" +
    "            <button name=\"save\" tabindex=\"3\" type=\"button\" ng-click=\"vm.next()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\" title=\"{{'TOOLTIP.NEXT' | translate}}\">\n" +
    "                {{'BUTTON.NEXT' | translate}} &raquo;\n" +
    "            </button>\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\" ng-if=\"vm.currentPhase === 2\">\n" +
    "            <div class=\"pull-left\">\n" +
    "                <button type=\"button\" class=\"btn\" ng-click=\"vm.onClickToggleSummary()\" ng-class=\"vm.showSizeSummary ? 'btn-success' : 'btn-default'\" title=\"{{'TOOLTIP.SHOWSIZESUMMARY' | translate}}\">\n" +
    "                    <i class=\"fa fa-calculator\" aria-hidden=\"true\"></i>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"pull-right\">\n" +
    "                <button name=\"back\" type=\"button\" ng-if=\"!vm.imported && !vm.readOnly\" ng-click=\"vm.back()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.BACK' | translate}}\">\n" +
    "                    &laquo; {{'BUTTON.BACK' | translate}}\n" +
    "                </button>\n" +
    "                <button name=\"clear\" type=\"button\" ng-if=\"!vm.isReadOnly()\" ng-click=\"vm.clear()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.CLEAR' | translate}}\">\n" +
    "                    {{'BUTTON.CLEAR' | translate}}\n" +
    "                </button>\n" +
    "                <button name=\"cancel\" type=\"button\" ng-if=\"!vm.isReadOnly()\" ng-click=\"vm.close()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.CANCEL' | translate}}\">\n" +
    "                    {{'BUTTON.CANCEL' | translate}}\n" +
    "                </button>\n" +
    "                <button name=\"save\" type=\"button\" ng-if=\"!vm.isReadOnly()\" ng-click=\"vm.save()\" ng-disabled=\"!vm.playerQuantitiesAreValid()\" class=\"btn btn-success\" title=\"{{'TOOLTIP.SAVE' | translate}}\">\n" +
    "                    {{'BUTTON.SAVE' | translate}}\n" +
    "                </button>\n" +
    "                <button name=\"close\" type=\"button\" ng-if=\"vm.isReadOnly()\" ng-click=\"vm.save()\" class=\"btn btn-default\" title=\"{{'TOOLTIP.CLOSE' | translate}}\">\n" +
    "                    {{'BUTTON.CLOSE' | translate}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/playerGroupDialog/playerGroupDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/playerGroupDialog/playerGroupDialog.tpl.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'PLAYERGROUP.DIALOG.TITLE' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"alert alert-warning\" ng-if=\"vm.validationErrors.length > 0\">\n" +
    "                    <div ng-repeat=\"error in vm.validationErrors\">\n" +
    "                        {{error.message}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <table class=\"table table-responsive dialog-table\">\n" +
    "                    <tr class=\"borderless\">\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"vertical-align-middle\">\n" +
    "                                {{'LABEL.GARMENT' | translate}}\n" +
    "                            </label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div class=\"garment-picker input-group\"\n" +
    "                                 ng-class=\"{'full': vm.maxGarments === vm.selectedGarments.length}\">\n" +
    "                                <ui-select multiple\n" +
    "                                           limit=\"vm.maxGarments\"\n" +
    "                                           tagging=\"vm.addGarment\"\n" +
    "                                           tagging-label=\"false\"\n" +
    "                                           ng-model=\"vm.selectedGarments\"\n" +
    "                                           append-to-body=\"true\">\n" +
    "                                    <ui-select-match placeholder=\"{{'LABEL.SELECTGARMENT' | translate}}\">\n" +
    "                                        <span>{{$select.selected[0].value | translate}}</span>\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"garment in vm.garments | translationFilter: $select.search : '' : 'value' | orderBy: 'value'\">\n" +
    "                                        <span>{{garment.value | translate}}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"borderless\">\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"vertical-align-middle\">\n" +
    "                                {{'LABEL.COLOR' | translate}}\n" +
    "                            </label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div class=\"color-picker input-group\" style=\"width: 100%;\"\n" +
    "                                 ng-class=\"{'full': vm.maxColours === vm.selectedColours.length}\">\n" +
    "                                <ui-select multiple\n" +
    "                                           limit=\"{{vm.maxColours}}\"\n" +
    "                                           tagging=\"vm.addColour\"\n" +
    "                                           tagging-label=\"false\"\n" +
    "                                           ng-model=\"vm.selectedColours\"\n" +
    "                                           append-to-body=\"true\">\n" +
    "                                    <ui-select-match\n" +
    "                                            placeholder=\"{{'NAME.PLACEHOLDER.TEXTCOLOUR' | translate}}\">\n" +
    "                                        <div class=\"color-box\" ng-style=\"{'background-color': '#' + $item.code}\">\n" +
    "                                        </div>\n" +
    "                                        <span class=\"item-name\">{{$item.name}}</span>\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"colour in vm.colours | filter:{name: $select.search}\"\n" +
    "                                                       ng-model=\"vm.colours\">\n" +
    "                                        <div class=\"color-box\" ng-style=\"{'background-color': '#' + colour.code}\"></div>\n" +
    "                                        <span class=\"item-name\">{{colour.name}}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.save()\">\n" +
    "                    {{'BUTTON.ADD' | translate}}\n" +
    "                </button>\n" +
    "                <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">\n" +
    "                    {{'BUTTON.CLOSE' | translate}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("services/proofDialog/proofDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/proofDialog/proofDialog.tpl.html",
    "<div class=\"errand\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'PRODUCTIONPLANNING.SELECTFILE'| translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row filter-row\">\n" +
    "            <div class=\"col-xs-3 filter-row-title\">\n" +
    "                <p>{{'PRODUCTIONPLANNING.RESOURCE' | translate}}</p>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-9\">\n" +
    "                <ui-select ng-model=\"vm.selectedResource\">\n" +
    "                    <ui-select-match placeholder=\"{{'LABEL.ALL' | translate}}\" allow-clear=\"true\">\n" +
    "                        {{$select.selected.resourceName}}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"resource in vm.availableResources\" ng-model=\"vm.availableResources\">\n" +
    "                        <span>{{resource.resourceName}}</span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <table class=\"table table-hover\">\n" +
    "                    <thead>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'PRODUCTIONPLANNING.ERRANDID'| translate}}\n" +
    "                        </th>\n" +
    "                        <th colspan=\"2\">\n" +
    "                            {{'PRODUCTIONPLANNING.FILE'| translate}}\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                    </thead>\n" +
    "                    <tbody>\n" +
    "                    <tr class=\"clickable\" ng-repeat=\"orderProof in vm.orderProofs | filter: vm.filterProofs\" ng-click=\"vm.onClickProof(orderProof)\">\n" +
    "                        <td>\n" +
    "                            {{orderProof.errandId}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            {{orderProof.fileName}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <a href=\"{{vm.getProofLink(orderProof)}}\" target=\"_blank\" title=\"{{'TOOLTIP.DOWNLOADIMAGE' | translate}}\">\n" +
    "                                <button type=\"button\" class=\"btn btn-sm btn-default pull-right text-right\">\n" +
    "                                    <i class=\"fa fa-download\"></i>\n" +
    "                                </button>\n" +
    "                            </a>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CANCEL' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("services/savedCartDialog/savedCartDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/savedCartDialog/savedCartDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog\">\n" +
    "    <div class=\"player-dialog\">\n" +
    "        <div class=\"modal-header\">\n" +
    "            <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "                ×\n" +
    "            </a>\n" +
    "            <div class=\"modal-title\">\n" +
    "                {{'STADIUM.CHOOSECART' | translate}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body row\">\n" +
    "            <div class=\"alert alert-warning\" ng-if=\"!vm.isReferenceProjectUnique()\">\n" +
    "                {{'STADIUM.SAVEDCARTSCOMBINATIONNOTUNIQUE' | translate}}\n" +
    "            </div>\n" +
    "            <div class=\"col-md-offset-1 col-md-10 radio-panel\">\n" +
    "                <div class=\"group\">\n" +
    "                <span class=\"title\">\n" +
    "                    {{'STADIUM.SELECTOPTIONS' | translate}}\n" +
    "                </span>\n" +
    "                </div>\n" +
    "                <div class=\"group\">\n" +
    "                    <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioNewBlank\" id=\"radioNewBlank\">\n" +
    "                    <label for=\"radioNewBlank\">\n" +
    "                        {{'STADIUM.CREATENEWCART' | translate}}\n" +
    "                    </label>\n" +
    "                    <br>\n" +
    "                    <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"radioReuse\" id=\"radioReuse\">\n" +
    "                    <label for=\"radioReuse\">\n" +
    "                        {{'STADIUM.ACTIVATEALREADYSTARTEDCART' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"!vm.showCartWarning()\">\n" +
    "                <div class=\"col-md-offset-1 col-md-10\">\n" +
    "                    <p ng-if=\"vm.radioChoice === 'radioNewBlank'\">\n" +
    "                        {{'STADIUM.NEWCART' | translate}}:\n" +
    "                    </p>\n" +
    "                    <p ng-if=\"vm.radioChoice === 'radioReuse'\">\n" +
    "                        {{'STADIUM.SELECTCARTTOACTIVATE' | translate}}:\n" +
    "                    </p>\n" +
    "                    <div class=\"table-responsive\">\n" +
    "                        <table class=\"table\">\n" +
    "                            <tbody>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.CART' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <ui-select on-select=\"vm.onSavedCartSelect()\" ng-model=\"vm.selectedCart\">\n" +
    "                                        <ui-select-match placeholder=\"{{'STADIUM.SELECTCART' | translate}}\">\n" +
    "                                            {{$select.selected.orderReference}} - {{$select.selected.orderProject}}\n" +
    "                                        </ui-select-match>\n" +
    "                                        <ui-select-choices repeat=\"savedCart in vm.getSavedCarts() | filter:$select.search | orderBy : 'orderReference'\">\n" +
    "                                            <span>{{savedCart.orderReference}} - {{savedCart.orderProject}}</span>\n" +
    "                                            <button class=\"btn-delete pull-right\" ng-click=\"vm.removeSavedCart(savedCart)\">\n" +
    "                                                <i class=\"fa fa-remove\"></i>\n" +
    "                                            </button>\n" +
    "                                        </ui-select-choices>\n" +
    "                                    </ui-select>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioReuse'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.REFERENCE' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input name=\"name\" class=\"form-control\" ng-model=\"vm.orderReference\" required>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioReuse'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.PROJECT' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input class=\"form-control\" ng-model=\"vm.orderProject\" required/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.ROWS' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input class=\"form-control\" ng-model=\"vm.selectedCart.rows\" readonly=\"true\"/>\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            <tr ng-if=\"vm.radioChoice !== 'radioNewBlank'\">\n" +
    "                                <td class=\"dynamic-width\">\n" +
    "                                    {{'STADIUM.DATECREATED' | translate}}:\n" +
    "                                </td>\n" +
    "                                <td class=\"full-width\">\n" +
    "                                    <input name=\"name\" class=\"form-control\" ng-model=\"vm.dateCreated\" readonly=\"true\">\n" +
    "                                </td>\n" +
    "                            </tr>\n" +
    "                            </tbody>\n" +
    "                        </table>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-12\" ng-if=\"vm.showNoCartsWarning()\">\n" +
    "                <div class=\"alert alert-warning\">\n" +
    "                    {{'STADIUM.NOCARTSWARNING' | translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-12\" ng-if=\"vm.showOneCartWarning()\">\n" +
    "                <div class=\"alert alert-warning\">\n" +
    "                    {{'STADIUM.ONECARTWARNING' | translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button name=\"cancel\" tabindex=\"3\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "                {{'BUTTON.CANCEL' | translate}}\n" +
    "            </button>\n" +
    "            <button name=\"create\" tabindex=\"3\" type=\"button\" ng-click=\"vm.create()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\" ng-if=\"vm.radioChoice !== 'radioReuse'\">\n" +
    "                {{'BUTTON.CREATE' | translate}}\n" +
    "            </button>\n" +
    "            <button name=\"activate\" tabindex=\"3\" type=\"button\" ng-click=\"vm.create()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\" ng-if=\"vm.radioChoice === 'radioReuse'\">\n" +
    "                {{'BUTTON.ACTIVATE' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/security/loginDialog/loginDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/security/loginDialog/loginDialog.tpl.html",
    "<div class=\"login-box\">\n" +
    "    <div class=\"header\">{{'LABEL.SIGNIN' | translate}}</div>\n" +
    "    <form autofill-submit=\"vm.login()\">\n" +
    "        <div class=\"body\">\n" +
    "            <div class=\"alert alert-danger\" ng-show=\"vm.authError\">\n" +
    "                {{vm.authError}}\n" +
    "            </div>\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"email\">{{'LABEL.EMAIL' | translate}}:</label>\n" +
    "                <input type=\"text\" id=\"email\" name=\"email\" class=\"form-control\" autofill ng-model=\"vm.email\" placeholder=\"Email\"/>\n" +
    "            </div>\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"email\">{{'LABEL.PASSWORD' | translate}}:</label>\n" +
    "                <input type=\"password\" id=\"password\" name=\"password\" class=\"form-control\" autofill ng-model=\"vm.password\" placeholder=\"Password\"/>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"footer\">\n" +
    "            <input value=\"{{'LABEL.SIGNIN' | translate}}\" type=\"submit\" ng-enabled=\"vm.showLogin\" class=\"btn btn-block btn-success\" />\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-12 registration-link\">\n" +
    "                    <a href=\"http://bamatex.se/bli-kund\" target=\"_blank\">Är du ny kund? Registrera dig här</a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>");
}]);

angular.module("services/stadiumProductTemplatePickerDialog/stadiumProductTemplatePickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/stadiumProductTemplatePickerDialog/stadiumProductTemplatePickerDialog.tpl.html",
    "<div class=\"dialog stadium-template-picker-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a \n" +
    "            class=\"close\" \n" +
    "            ng-click=\"vm.dismiss()\"\n" +
    "        >\n" +
    "                ×\n" +
    "        </a>\n" +
    "        <div \n" +
    "            class=\"modal-title\" \n" +
    "            translate\n" +
    "        >\n" +
    "            {{::'STADIUM.PRODUCT_TEMPLATE.PICKER.TITLE'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-offset-2 col-xs-8 col-xs-offset-2 \">\n" +
    "                <ui-select ng-model=\"vm.selectedClub\" on-select=\"vm.onSelectClub()\">\n" +
    "                    <ui-select-match placeholder=\"{{ 'MOUNTING.PLACEHOLDERCLUB' | translate }}\">\n" +
    "                        {{ $select.selected }}\n" +
    "                    </ui-select-match>\n" +
    "                    <ui-select-choices repeat=\"club in vm.clubs | filter: $select.search | limitTo: 100 track by club\">\n" +
    "                        <span class=\"item-name\">{{ ::club }}</span>\n" +
    "                    </ui-select-choices>\n" +
    "                </ui-select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-offset-2 col-xs-8 col-xs-offset-2\">\n" +
    "                <input \n" +
    "                    class=\"form-control input-with-icon input-margin\"\n" +
    "                    ng-keyup=\"$event.keyCode == 13 && vm.onSearch($event)\"\n" +
    "                    placeholder=\"&#xF002; {{'LOGO.DIALOG.UPLOAD.SELECT.SEARCH' | translate}}\"\n" +
    "                    ng-model=\"vm.searchText\"\n" +
    "                    type=\"text\"\n" +
    "                >\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- View products -->\n" +
    "        <div \n" +
    "            class=\"row\"\n" +
    "            ng-if=\"!vm.selectedProduct\"\n" +
    "        >\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"col-xs-3\" ng-repeat=\"product in vm.products\">\n" +
    "                    <div class=\"panel panel-default\">\n" +
    "                        <div class=\"panel-heading\" title=\"{{product.articleId}}\">\n" +
    "                            {{product.articleId}}\n" +
    "                        </div>\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"stadium-product-thumbnail-container\" ng-if=\"product.image\">\n" +
    "                                <img class=\"img-responsive\" ng-src=\"{{vm.getImageUrl(product.image)}}\"/>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-xs-12\">\n" +
    "                                    <div class=\"product-title\" title=\"{{product.articleName}} - {{product.variantName}}\">\n" +
    "                                        {{product.articleName}}\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-xs-12\">\n" +
    "                                    <button\n" +
    "                                        type=\"button\"\n" +
    "                                        class=\"btn btn-sm btn-default product-details-button\"\n" +
    "                                        ng-click=\"vm.onSelectProduct(product.id)\"\n" +
    "                                        translate\n" +
    "                                    >\n" +
    "                                        {{::'BUTTON.SELECT'}}\n" +
    "                                </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-12\">\n" +
    "                    <pagination\n" +
    "                        class=\"pagination-sm\"\n" +
    "                        total-items=\"vm.totalItems\"\n" +
    "                        items-per-page=\"vm.pageSize\"\n" +
    "                        ng-model=\"vm.page\"\n" +
    "                        ng-change=\"vm.pageChanged()\"\n" +
    "                        ng-if=\"vm.totalItems\"\n" +
    "                    >\n" +
    "                    </pagination>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Select template -->\n" +
    "        <div \n" +
    "            class=\"row\" \n" +
    "            ng-if=\"vm.selectedProduct\"\n" +
    "        >\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"col-xs-6\">\n" +
    "                    <div class=\"panel panel-default\">\n" +
    "                        <div class=\"panel-heading\" title=\"{{vm.selectedProduct.articleId}}\">\n" +
    "                            {{vm.selectedProduct.articleId}}\n" +
    "                        </div>\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"stadium-product-thumbnail-container\" ng-if=\"vm.selectedProduct.image\">\n" +
    "                                <img class=\"img-responsive\" ng-src=\"{{vm.getImageUrl(vm.selectedProduct.image)}}\"/>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-xs-12\">\n" +
    "                                    <table class=\"information-table\">\n" +
    "                                        <tbody>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_ARTICLE_NAME' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                {{vm.selectedProduct.articleName}}\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_VARIANT_NAME' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                {{vm.selectedProduct.variantName}}\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_EXTERNAL_CLUB_ID' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                {{vm.selectedProduct.externalClubId}}\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_CLUB_NAME' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                {{vm.selectedProduct.clubName}}\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_SPONSORING' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                <input \n" +
    "                                                    type=\"checkbox\" \n" +
    "                                                    ng-model=\"vm.selectedProduct.sponsoring\" \n" +
    "                                                    disabled\n" +
    "                                                >\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_CHANNELS' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                <ul class=\"channels-list\">\n" +
    "                                                    <li \n" +
    "                                                        class=\"col-xs-12\" \n" +
    "                                                        ng-repeat=\"channel in vm.selectedProduct.channels\"\n" +
    "                                                    >\n" +
    "                                                        {{channel}}\n" +
    "                                                    </li>\n" +
    "                                                </ul>\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        <tr>\n" +
    "                                            <td>\n" +
    "                                                {{'STADIUM.PRODUCT_CHANNELS_ONLY_B2B' | translate}}\n" +
    "                                            </td>\n" +
    "                                            <td>\n" +
    "                                                <input \n" +
    "                                                    type=\"checkbox\" \n" +
    "                                                    ng-model=\"vm.selectedProduct.onlyB2BSharing\"\n" +
    "                                                    disabled\n" +
    "                                                >\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "                                        </tbody>\n" +
    "                                    </table>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-6\">\n" +
    "                    <div class=\"panel panel-default\">\n" +
    "                        <div \n" +
    "                            class=\"panel-heading\"\n" +
    "                            translate\n" +
    "                        >\n" +
    "                            {{::'LABEL.SELECTTEMPLATE'}}\n" +
    "                        </div>\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"col-xs-12 main-template\">\n" +
    "                                <label \n" +
    "                                    class=\"title\"\n" +
    "                                    translate\n" +
    "                                >\n" +
    "                                    {{::'STADIUM.PRODUCT_MAIN_TEMPLATE'}}\n" +
    "                                </label>\n" +
    "                                <div ng-if=\"vm.selectedProduct.mainTemplate\">\n" +
    "                                    <input\n" +
    "                                            type=\"radio\"\n" +
    "                                            id=\"mainTemplate\"\n" +
    "                                            value=\"{{vm.selectedProduct.mainTemplate.templateId}}\"\n" +
    "                                            name=\"template\"\n" +
    "                                            ng-model=\"vm.selectedTemplate\"\n" +
    "                                    >\n" +
    "                                    <label\n" +
    "                                            class=\"template-name\"\n" +
    "                                            for=\"mainTemplate\"\n" +
    "                                            translate\n" +
    "                                    >\n" +
    "                                        {{::'STADIUM.PRODUCT_MAIN_TEMPLATE'}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-xs-12 team-templates\">\n" +
    "                                <label \n" +
    "                                    class=\"title\"\n" +
    "                                    translate\n" +
    "                                >\n" +
    "                                    {{::'LABEL.TEAM'}}\n" +
    "                                </label>\n" +
    "                                <div \n" +
    "                                    ng-repeat=\"teamTemplate in vm.selectedProduct.teamTemplates\"\n" +
    "                                >\n" +
    "                                    <input \n" +
    "                                        type=\"radio\" \n" +
    "                                        id=\"{{teamTemplate.templateId}}\" \n" +
    "                                        value=\"{{teamTemplate.templateId}}\" \n" +
    "                                        name=\"template\"\n" +
    "                                        ng-model=\"vm.selectedTemplate\"\n" +
    "                                    >\n" +
    "                                    <label \n" +
    "                                        class=\"template-name\" \n" +
    "                                        for=\"{{teamTemplate.templateId}}\"\n" +
    "                                    >\n" +
    "                                        {{teamTemplate.team}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button\n" +
    "            type=\"button\"\n" +
    "            class=\"btn btn-default pull-left\"\n" +
    "            ng-if=\"vm.selectedProduct\"\n" +
    "            ng-click=\"vm.clearSelectedProduct()\"\n" +
    "            translate\n" +
    "        >\n" +
    "            {{::'BUTTON.BACK'}}\n" +
    "        </button>\n" +
    "        <button \n" +
    "            type=\"button\" \n" +
    "            ng-click=\"vm.close()\" \n" +
    "            ng-disabled=\"!vm.selectedTemplate\" \n" +
    "            class=\"btn choose\"\n" +
    "            ng-class=\"{ 'btn-success': vm.selectedTemplate, 'btn-default': !vm.selectedTemplate }\" \n" +
    "            translate\n" +
    "        >\n" +
    "            {{::'BUTTON.APPLY'}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/stadiumStockDialog/stadiumStockDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/stadiumStockDialog/stadiumStockDialog.tpl.html",
    "<div class=\"advanced-mounting-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{'STADIUM.EDITSTOCK' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body row\">\n" +
    "        <div class=\"col-md-offset-1 col-md-10\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            {{'STADIUM.MINIMUMSTOCK' | translate}}\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div counter=\"\" class=\"btn-group-vertical\" value=\"vm.minimumStock\" min=\"vm.minQuantity\"></div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            {{'STADIUM.REFILLVOLUME' | translate}}\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div counter=\"\" class=\"btn-group-vertical\" value=\"vm.refillVolume\" min=\"vm.minQuantity\"></div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"cancel\" type=\"button\" ng-click=\"vm.close()\" class=\"btn btn-default\">\n" +
    "            {{'BUTTON.CANCEL' | translate}}\n" +
    "        </button>\n" +
    "        <button name=\"save\" type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"!vm.isValid()\" class=\"btn btn-success\">\n" +
    "            {{'BUTTON.SAVE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/templateCartDialog/templateCartDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/templateCartDialog/templateCartDialog.tpl.html",
    "<div class=\"dialog template-dialog\" tabindex=\"-1\">\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <table class=\"table\">\n" +
    "                <tbody>\n" +
    "                    <tr ng-repeat=\"item in vm.cartItems\">\n" +
    "                        <td>\n" +
    "                            <span ng-if=\"item.productType\">\n" +
    "                                {{'PRODUCT.TYPE.' + item.productType | translate}}\n" +
    "                            </span>\n" +
    "                            <span ng-if=\"!item.productType\">\n" +
    "                                {{item.id}}\n" +
    "                            </span>\n" +
    "                            <br>\n" +
    "                            {{item.name}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <button ng-disabled=\"item.added\"\n" +
    "                                    ng-click=\"vm.addItem(item)\"\n" +
    "                                    class=\"btn btn-sm btn-success\">\n" +
    "                                    {{'STADIUM.PLACEMENTTEMPLATE.ITEMS.ADDTOTEMPLATE' | translate}}\n" +
    "                            </button>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <!-- Buttons -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"button-input\">\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"vm.close()\" translate>\n" +
    "                        {{'BUTTON.CLOSE'}}\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/templateDialog/templateDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/templateDialog/templateDialog.tpl.html",
    "<div class=\"dialog template-dialog\" tabindex=\"-1\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "        <div class=\"modal-title\" ng-if=\"!vm.isTemplate\" translate>\n" +
    "            {{'MOUNTING.ADVANCEDMOUNTING'}}\n" +
    "        </div>\n" +
    "        <div class=\"modal-title\" ng-if=\"vm.isTemplate && !vm.isQuickTemplate\" translate>\n" +
    "            {{'STADIUM.TEMPLATE.DIALOG.CREATE.TITLE'}}\n" +
    "        </div>\n" +
    "        <div class=\"modal-title\" ng-if=\"vm.isQuickTemplate && vm.isStadium\" translate>\n" +
    "            {{'STADIUM.TEMPLATE.DIALOG.QUICKTEMPLATE.TITLE'}}\n" +
    "        </div>\n" +
    "        <div class=\"modal-title\" ng-if=\"vm.isQuickTemplate && !vm.isStadium\" translate>\n" +
    "            {{'PLACEMENT.PROOF'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <!-- Warnings -->\n" +
    "        <div class=\"alert alert-warning\" ng-if=\"!vm.nameIsUnique\" translate>\n" +
    "            {{vm.isTemplate ? 'STADIUM.PLACEMENTTEMPLATE.NAMEWARNING' : 'MOUNTING.DIALOGWARNING'}}\n" +
    "        </div>\n" +
    "        <!-- Title -->\n" +
    "        <div class=\"row\" ng-if=\"vm.isStadium\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <span class=\"title\" translate>\n" +
    "                    {{'MOUNTING.SELECTOPTIONS'}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Options -->\n" +
    "        <div class=\"row\" ng-if=\"vm.isStadium\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"radio-group\">\n" +
    "                    <div class=\"radio-row\">\n" +
    "                        <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"new\" id=\"radioNewBlank\"/>\n" +
    "                        <label for=\"radioNewBlank\" translate>\n" +
    "                            {{vm.isTemplate ? 'STADIUM.PLACEMENTTEMPLATE.CREATENEW' : 'MOUNTING.CREATENEWPLACEMENT'}}\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                    <div class=\"radio-row\">\n" +
    "                        <input type=\"radio\" ng-model=\"vm.radioChoice\" value=\"copy\" id=\"radioNewExisting\"/>\n" +
    "                        <label for=\"radioNewExisting\" translate>\n" +
    "                            {{vm.isTemplate ? 'STADIUM.PLACEMENTTEMPLATE.COPY' : 'MOUNTING.CREATEEXISTINGPLACEMENT'}}\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Selection -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"table-responsive\">\n" +
    "                <table class=\"table\">\n" +
    "                    <tbody>\n" +
    "                    <!-- Club -->\n" +
    "                    <tr ng-if=\"vm.showClubAndCategory()\">\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CLUB'}}</label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <ui-select ng-model=\"vm.selectedClub\" on-select=\"vm.onSelectClub()\" ng-disabled=\"!vm.lockClubAndCategory()\">\n" +
    "                                <ui-select-match placeholder=\"{{'MOUNTING.PLACEHOLDERCLUB' | translate}}\">\n" +
    "                                    {{$select.selected.clubName}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"club in vm.clubs | orderBy: 'clubName' | filter: $select.search\">\n" +
    "                                    <span>{{club.clubName}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Category -->\n" +
    "                    <tr ng-if=\"vm.showClubAndCategory()\">\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CATEGORY'}}</label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <ui-select ng-model=\"vm.selectedCategory\" ng-disabled=\"!vm.selectedClub\">\n" +
    "                                <ui-select-match placeholder=\"{{'MOUNTING.PLACEHOLDERCATEGORY' | translate}}\">\n" +
    "                                    {{$select.selected.categoryName}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"category in vm.categories | orderBy: 'categoryName' | filter: $select.search\">\n" +
    "                                    <span>{{category.categoryName}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Placement -->\n" +
    "                    <tr ng-if=\"vm.showPlacement()\">\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>\n" +
    "                                {{vm.isTemplate ? 'STADIUM.PLACEMENTTEMPLATE.TEMPLATE' : 'MOUNTING.PLACEMENT'}}\n" +
    "                            </label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <ui-select ng-model=\"vm.selectedPlacement\" ng-disabled=\"vm.isTemplate && !vm.selectedCategory\" on-select=\"vm.onSelectPlacement()\">\n" +
    "                                <ui-select-match placeholder=\"{{vm.isTemplate ? ('LABEL.SELECTTEMPLATE' | translate) : ('LABEL.SELECTPLACEMENT' | translate)}}\">\n" +
    "                                    {{$select.selected.templateName | limitTo: 25}}{{$select.selected.templateName.length > 25 ? '...' : ''}}\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"placement in vm.placements | filter:{templateName:$select.search, archived:false, club:vm.selectedClub.clubId, category:vm.selectedCategory.categoryId} | orderBy: 'templateName'\">\n" +
    "                                    <span>{{placement.templateName}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Garment -->\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.GARMENT'}}</label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <ui-select ng-model=\"vm.selectedGarment\" ng-disabled=\"!vm.selectedPlacement && vm.showPlacement()\">\n" +
    "                                <ui-select-match placeholder=\"{{'LABEL.SELECTGARMENT' | translate}}\">\n" +
    "                                    <span translate>{{$select.selected.value}}</span>\n" +
    "                                </ui-select-match>\n" +
    "                                <ui-select-choices repeat=\"garment in vm.garments | translationFilter: $select.search : '' : 'value' | orderBy : 'value'\">\n" +
    "                                    <span translate>{{garment.value}}</span>\n" +
    "                                </ui-select-choices>\n" +
    "                            </ui-select>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Name -->\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.NAME'}}</label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input class=\"form-control\" type=\"text\" ng-model=\"vm.name\" title=\"name\">\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Colour -->\n" +
    "                    <tr>\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.COLOUR'}}</label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <div class=\"color-picker\" ng-class=\"{ 'full': (vm.selectedColours.length > 0) }\">\n" +
    "                                <ui-select multiple=\"\" limit=\"1\" ng-model=\"vm.selectedColours\" tagging=\"vm.onNewCustomColour\" tagging-label=\"false\" append-to-body=\"true\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'NAME.PLACEHOLDER.TEXTCOLOUR' | translate }}\">\n" +
    "                                        <div class=\"color-box\" ng-style=\"{'background-color': '#' + $item.code}\"></div>\n" +
    "                                        <span class=\"color-name\">\n" +
    "                                            {{$item.name}}\n" +
    "                                        </span>\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"color in vm.colours | filter:{ name: $select.search }\">\n" +
    "                                        <div class=\"color-box\" ng-style=\"{'background-color': '#' + color.code}\"></div>\n" +
    "                                        <span class=\"color-name\">\n" +
    "                                            {{color.name}}\n" +
    "                                        </span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Description -->\n" +
    "                    <tr ng-if=\"!vm.isQuickTemplate\">\n" +
    "                        <td>\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.DESCRIPTION'}}</label>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <textarea class=\"form-control\" ng-model=\"vm.description\" title=\"description\"></textarea>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <!-- Created date -->\n" +
    "                    <tr ng-if=\"vm.selectedPlacement !== null\">\n" +
    "                        <td class=\"dynamic-width\">\n" +
    "                            <label class=\"control-label\" translate>{{'MOUNTING.DATECREATED'}}</label>\n" +
    "                        </td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <input class=\"form-control\" type=\"text\" ng-model=\"vm.dateCreated\" title=\"date created\" disabled>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <!-- Buttons -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"button-input\">\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"vm.close()\" translate>\n" +
    "                        {{'BUTTON.CANCEL'}}\n" +
    "                    </button>\n" +
    "                    <button class=\"btn btn-success\" ng-disabled=\"!vm.isFormValid()\" ng-click=\"vm.createPlacement()\" translate>\n" +
    "                        {{'BUTTON.CREATE'}}\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/templateErrorDialog/templateErrorDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/templateErrorDialog/templateErrorDialog.tpl.html",
    "<div class=\"dialog stadium-template-error\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">\n" +
    "            ×\n" +
    "        </a>\n" +
    "        <div class=\"modal-title\" translate>{{'STADIUM.TEMPLATE.WARNING.ERRORS'}}</div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12 name\">\n" +
    "                <strong>{{vm.template.templateName}}</strong>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\" style=\"padding-bottom: 25px\" translate>\n" +
    "                {{'STADIUM.TEMPLATE.WARNING.ERRORS.DESCRIPTION'}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"pull-right\">\n" +
    "                    <button class=\"btn btn-warning\" ng-click=\"vm.goToTemplate()\" translate>{{'INCOMINGORDERS.GOTOTEMPLATE1'}}</button>\n" +
    "                    <button class=\"btn btn-default\" ng-click=\"vm.close()\" translate>{{'BUTTON.CLOSE'}}</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("services/templatePickerDialog/templatePickerDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/templatePickerDialog/templatePickerDialog.tpl.html",
    "<div class=\"dialog stadium-template-picker\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.dismiss()\">×</a>\n" +
    "        <div class=\"modal-title\" translate>\n" +
    "            {{'STADIUM.TEMPLATE.PICKER.TITLE'}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <table class=\"table table-responsive\">\n" +
    "                    <tbody>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CLUB'}}</td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div>\n" +
    "                                <ui-select ng-model=\"vm.selectedClub\" on-select=\"vm.onSelectClub()\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'MOUNTING.PLACEHOLDERCLUB' | translate }}\">\n" +
    "                                        {{ $select.selected.clubName }}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"club in vm.clubs | filter: $select.search\">\n" +
    "                                        <span class=\"item-name\">{{ club.clubName }}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\" translate>{{'STADIUM.PLACEMENTTEMPLATE.CATEGORY'}}</td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div>\n" +
    "                                <ui-select ng-model=\"vm.selectedCategory\" on-select=\"vm.onSelectCategory()\" ng-disabled=\"vm.selectedClub === null\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'MOUNTING.PLACEHOLDERCATEGORY' | translate }}\">\n" +
    "                                        {{ $select.selected.categoryName }}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"category in vm.categories | filter: $select.search\">\n" +
    "                                        <span class=\"item-name\">{{ category.categoryName }}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td class=\"dynamic-width\" translate>{{'STADIUM.PLACEMENTTEMPLATE.TEMPLATE'}}</td>\n" +
    "                        <td class=\"full-width\">\n" +
    "                            <div>\n" +
    "                                <ui-select ng-model=\"vm.selectedTemplate\" ng-disabled=\"vm.selectedClub === null || vm.selectedCategory === null\" title=\"{{$select.selected.templateName}}\">\n" +
    "                                    <ui-select-match placeholder=\"{{ 'STADIUM.PLACEMENTTEMPLATE.TEMPLATEPLACEHOLDER' | translate }}\" allow-clear=\"true\">\n" +
    "                                        {{$select.selected.templateName | limitTo: 40}}{{$select.selected.templateName.length > 40 ? '...' : ''}}\n" +
    "                                    </ui-select-match>\n" +
    "                                    <ui-select-choices repeat=\"template in vm.templates | orderBy: 'templateName' | filter:{templateName:$select.search} | filter:{club:vm.selectedClub.clubId} | filter:{category:vm.selectedCategory.categoryId}\">\n" +
    "                                        <span class=\"item-name\">{{ template.templateName }}</span>\n" +
    "                                    </ui-select-choices>\n" +
    "                                </ui-select>\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "                <div ng-show=\"vm.selectedTemplate\">\n" +
    "                    <div class=\"panel picker-panel\">\n" +
    "                        <div class=\"panel-body picker-panel-body\">\n" +
    "                            <h4 class=\"text-center\" title=\"{{vm.selectedTemplate.templateName}}\">\n" +
    "                                {{vm.selectedTemplate.templateName | limitTo: 40}}{{vm.selectedTemplate.templateName.length > 40 ? '...' : ''}}\n" +
    "                            </h4>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"panel\">\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <p class=\"col-xs-6\"><strong>{{'MOUNTING.GARMENT' | translate}}: </strong>{{'GARMENT.TYPE.' + vm.selectedTemplate.garment | translate}}</p>\n" +
    "                                <p class=\"col-xs-6\"><strong>{{'MOUNTING.COLOUR' | translate}}: </strong>{{vm.selectedTemplate.colour}}</p>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <p class=\"col-xs-12\"><strong>{{'MOUNTING.DESCRIPTION' | translate}}: </strong>{{vm.selectedTemplate.description}}</p>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-show=\"!vm.selectedTemplate && vm.suggestionList.length > 0\">\n" +
    "                    <div class=\"panel picker-panel\">\n" +
    "                        <div class=\"panel-body\">\n" +
    "                            <h4 class=\"text-center\" translate>{{'STADIUM.TEMPLATE.PICKER.SUGGESTION.TITLE'}}</h4>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"panel\" ng-repeat=\"suggestion in vm.suggestionList.slice(0, vm.suggestionLimit)\">\n" +
    "                        <div class=\"panel-body picker-panel-body\">\n" +
    "                            <div class=\"col-xs-12\">\n" +
    "                                <div class=\"row\">\n" +
    "                                    <h5 class=\"col-xs-12\" title=\"{{suggestion.templateName}}\">\n" +
    "                                        {{suggestion.templateName | limitTo: 50}}{{suggestion.templateName.length > 50 ? '...' : ''}}\n" +
    "                                    </h5>\n" +
    "                                </div>\n" +
    "                                <div class=\"row\">\n" +
    "                                    <p class=\"col-xs-6\"><strong>{{'MOUNTING.GARMENT' | translate}}: </strong>{{'GARMENT.TYPE.' + suggestion.garment | translate}}</p>\n" +
    "                                    <p class=\"col-xs-6\"><strong>{{'MOUNTING.COLOUR' | translate}}: </strong>{{suggestion.colour}}</p>\n" +
    "                                </div>\n" +
    "                                <div class=\"row\">\n" +
    "                                    <p class=\"col-xs-9\"><strong>{{'MOUNTING.DESCRIPTION' | translate}}: </strong>{{suggestion.description}}</p>\n" +
    "                                    <button class=\"btn btn-primary btn-success pull-right picker-button\" ng-click=\"vm.closeWithSuggestion(suggestion)\" translate>{{'BUTTON.APPLY'}}</button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button name=\"choose\" type=\"button\" ng-click=\"vm.close()\" ng-disabled=\"!vm.selectedTemplate\" class=\"btn choose\"\n" +
    "                ng-class=\"{ 'btn-success': vm.selectedTemplate, 'btn-default': !vm.selectedTemplate }\" translate>\n" +
    "            {{vm.filterData ? 'BUTTON.APPLY' : 'TOOLTIP.EDIT'}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/templatePrices/templatePriceDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/templatePrices/templatePriceDialog.tpl.html",
    "<div class=\"dialog template-dialog\" tabindex=\"-1\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">×</a>\n" +
    "        <div class=\"modal-title\">{{'MOUNTING.PRICEDIALOG' | translate}}</div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"table-responsive\">\n" +
    "            <table class=\"table\">\n" +
    "                <thead>\n" +
    "                    <tr>\n" +
    "                        <th>\n" +
    "                            {{'ARTICLE.NUMBER' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'ARTICLE.NAME' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'LABEL.QUANTITY' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'ARTICLE.UNITPRICE' | translate}}\n" +
    "                        </th>\n" +
    "                        <th>\n" +
    "                            {{'ARTICLE.TOTALPRICE' | translate}}\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                </thead>\n" +
    "                <tbody ng-if=\"vm.garment.type\">\n" +
    "                    <tr ng-repeat=\"price in vm.prices\">\n" +
    "                        <td>\n" +
    "                            {{price.articleNumber}}\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <span ng-if=\"price.scopeType\">\n" +
    "                                {{'NAME.PLAYERLISTTYPE.' + price.scopeType | translate}}\n" +
    "                                <br />\n" +
    "                            </span>\n" +
    "                            <span ng-if=\"price.articleType && !price.scopeType && !price.garment\">\n" +
    "                                {{'PRODUCT.TYPE.' + price.articleType | translate}}\n" +
    "                                <br />\n" +
    "                            </span>\n" +
    "                            {{price.name}}\n" +
    "                        </td>\n" +
    "                        <td>{{price.quantity}}</td>\n" +
    "                        <td>{{price.unitPrice}}</td>\n" +
    "                        <td>{{price.totalPrice}}</td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td></td>\n" +
    "                        <td>\n" +
    "                            {{'LABEL.GARMENT' | translate}}<br />\n" +
    "                            {{'GARMENT.TYPE.' + vm.garment.type | translate}}\n" +
    "                        </td>\n" +
    "                        <td>{{vm.garment.quantity}}</td>\n" +
    "                        <td>-</td>\n" +
    "                        <td>-</td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "        <hr>\n" +
    "        <div ng-repeat=\"cost in vm.costs\">\n" +
    "            <b>{{'COST.' + cost.type | translate}}:</b> {{cost.price}}\n" +
    "        </div>\n" +
    "        <hr>\n" +
    "        <div>\n" +
    "            <b>{{'COST.TOTAL' | translate}}:</b> {{vm.total}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-default\" ng-click=\"vm.close()\">\n" +
    "            {{'BUTTON.CLOSE' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("services/textAreaDialog/textAreaDialog.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("services/textAreaDialog/textAreaDialog.tpl.html",
    "<div class=\"textarea-dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <a class=\"close\" ng-click=\"vm.close()\">x</a>\n" +
    "\n" +
    "        <div class=\"modal-title\">\n" +
    "            {{ vm.title }}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-body\">\n" +
    "        <textarea ng-model=\"vm.text\" disabled></textarea>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <button class=\"btn btn-default\" ng-click=\"vm.close()\">{{'BUTTON.CLOSE' | translate}}</button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);
